
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6604"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6604"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = "function" === typeof Symbol && Symbol.for, $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$n ? Symbol.for("react.element") : 60103, $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$n ? Symbol.for("react.portal") : 60106, $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$n ? Symbol.for("react.fragment") : 60107, $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$n ? Symbol.for("react.strict_mode") : 60108, $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$n ? Symbol.for("react.profiler") : 60114, $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$n ? Symbol.for("react.provider") : 60109, $1c29a66706a62afd$var$w = $1c29a66706a62afd$var$n ? Symbol.for("react.context") : 60110, $1c29a66706a62afd$var$x = $1c29a66706a62afd$var$n ? Symbol.for("react.forward_ref") : 60112, $1c29a66706a62afd$var$y = $1c29a66706a62afd$var$n ? Symbol.for("react.suspense") : 60113, $1c29a66706a62afd$var$z = $1c29a66706a62afd$var$n ? Symbol.for("react.memo") : 60115, $1c29a66706a62afd$var$A = $1c29a66706a62afd$var$n ? Symbol.for("react.lazy") : 60116, $1c29a66706a62afd$var$B = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$E = {};
function $1c29a66706a62afd$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
$1c29a66706a62afd$var$F.prototype.isReactComponent = {};
$1c29a66706a62afd$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$G() {}
$1c29a66706a62afd$var$G.prototype = $1c29a66706a62afd$var$F.prototype;
function $1c29a66706a62afd$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
var $1c29a66706a62afd$var$I = $1c29a66706a62afd$var$H.prototype = new $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$I.constructor = $1c29a66706a62afd$var$H;
$8coUR($1c29a66706a62afd$var$I, $1c29a66706a62afd$var$F.prototype);
$1c29a66706a62afd$var$I.isPureReactComponent = !0;
var $1c29a66706a62afd$var$J = {
    current: null
}, $1c29a66706a62afd$var$K = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$1c29a66706a62afd$var$K.call(b, e) && !$1c29a66706a62afd$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $1c29a66706a62afd$var$J.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$p;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g, $1c29a66706a62afd$var$Q = [];
function $1c29a66706a62afd$var$R(a, b, c, e) {
    if ($1c29a66706a62afd$var$Q.length) {
        var d = $1c29a66706a62afd$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $1c29a66706a62afd$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $1c29a66706a62afd$var$Q.length && $1c29a66706a62afd$var$Q.push(a);
}
function $1c29a66706a62afd$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$p:
                case $1c29a66706a62afd$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $1c29a66706a62afd$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $1c29a66706a62afd$var$U(d, k);
        g += $1c29a66706a62afd$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $1c29a66706a62afd$var$B && a[$1c29a66706a62afd$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $1c29a66706a62afd$var$U(d, k++), g += $1c29a66706a62afd$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($1c29a66706a62afd$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $1c29a66706a62afd$var$V(a, b, c) {
    return null == a ? 0 : $1c29a66706a62afd$var$T(a, "", b, c);
}
function $1c29a66706a62afd$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape(a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $1c29a66706a62afd$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $1c29a66706a62afd$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($1c29a66706a62afd$var$O(a) && (a = $1c29a66706a62afd$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + c)), e.push(a));
}
function $1c29a66706a62afd$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($1c29a66706a62afd$var$P, "$&/") + "/");
    b = $1c29a66706a62afd$var$R(b, g, e, d);
    $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$aa, b);
    $1c29a66706a62afd$var$S(b);
}
var $1c29a66706a62afd$var$Y = {
    current: null
};
function $1c29a66706a62afd$var$Z() {
    var a = $1c29a66706a62afd$var$Y.current;
    if (null === a) throw Error($1c29a66706a62afd$var$C(321));
    return a;
}
var $1c29a66706a62afd$var$ba = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $1c29a66706a62afd$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $1c29a66706a62afd$var$R(null, null, b, c);
        $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$W, b);
        $1c29a66706a62afd$var$S(b);
    },
    count: function(a) {
        return $1c29a66706a62afd$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $1c29a66706a62afd$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error($1c29a66706a62afd$var$C(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$F;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$u;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$H;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$t;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$y;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$ba;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$C(267, a));
    var e = $8coUR({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $1c29a66706a62afd$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$1c29a66706a62afd$var$K.call(b, h) && !$1c29a66706a62afd$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$Z().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$Z().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$Z().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $fO90s.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$8coUR(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $8coUR(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $8coUR({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $8coUR({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $fO90s.unstable_runWithPriority, Jf = $fO90s.unstable_scheduleCallback, Kf = $fO90s.unstable_cancelCallback, Lf = $fO90s.unstable_requestPaint, Mf = $fO90s.unstable_now, Nf = $fO90s.unstable_getCurrentPriorityLevel, Of = $fO90s.unstable_ImmediatePriority, Pf = $fO90s.unstable_UserBlockingPriority, Qf = $fO90s.unstable_NormalPriority, Rf = $fO90s.unstable_LowPriority, Sf = $fO90s.unstable_IdlePriority, Tf = {}, Uf = $fO90s.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $8coUR({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $acw62.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $8coUR({}, f, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $8coUR({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($8coUR({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k, $bcb017604639e9d7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$p = null, $bcb017604639e9d7$var$q = null, $bcb017604639e9d7$var$t = function() {
        if (null !== $bcb017604639e9d7$var$p) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$p(!0, a);
            $bcb017604639e9d7$var$p = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$t, 0), b;
        }
    }, $bcb017604639e9d7$var$u = Date.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return Date.now() - $bcb017604639e9d7$var$u;
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$p ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$p = a, setTimeout($bcb017604639e9d7$var$t, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$q = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$q);
    };
    $bcb017604639e9d7$var$k = function() {
        return !1;
    };
    $bcb017604639e9d7$var$l = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$w = window.performance, $bcb017604639e9d7$var$x = window.Date, $bcb017604639e9d7$var$y = window.setTimeout, $bcb017604639e9d7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcb017604639e9d7$var$w && "function" === typeof $bcb017604639e9d7$var$w.now) $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$w.now();
    };
    else {
        var $bcb017604639e9d7$var$B = $bcb017604639e9d7$var$x.now();
        $bcb017604639e9d7$export$c4744153514ff05d = function() {
            return $bcb017604639e9d7$var$x.now() - $bcb017604639e9d7$var$B;
        };
    }
    var $bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null, $bcb017604639e9d7$var$E = -1, $bcb017604639e9d7$var$F = 5, $bcb017604639e9d7$var$G = 0;
    $bcb017604639e9d7$var$k = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$G;
    };
    $bcb017604639e9d7$var$l = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcb017604639e9d7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$H = new MessageChannel, $bcb017604639e9d7$var$I = $bcb017604639e9d7$var$H.port2;
    $bcb017604639e9d7$var$H.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$D) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$G = a + $bcb017604639e9d7$var$F;
            try {
                $bcb017604639e9d7$var$D(!0, a) ? $bcb017604639e9d7$var$I.postMessage(null) : ($bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$I.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$C = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$D = a;
        $bcb017604639e9d7$var$C || ($bcb017604639e9d7$var$C = !0, $bcb017604639e9d7$var$I.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$E = $bcb017604639e9d7$var$y(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$z($bcb017604639e9d7$var$E);
        $bcb017604639e9d7$var$E = -1;
    };
}
function $bcb017604639e9d7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$K(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$N = [], $bcb017604639e9d7$var$O = [], $bcb017604639e9d7$var$P = 1, $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = 3, $bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$T = !1, $bcb017604639e9d7$var$U = !1;
function $bcb017604639e9d7$var$V(a) {
    for(var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O);
        else if (b.startTime <= a) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, b);
        else break;
        b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
    }
}
function $bcb017604639e9d7$var$W(a) {
    $bcb017604639e9d7$var$U = !1;
    $bcb017604639e9d7$var$V(a);
    if (!$bcb017604639e9d7$var$T) {
        if (null !== $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N)) $bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X);
        else {
            var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$X(a, b) {
    $bcb017604639e9d7$var$T = !1;
    $bcb017604639e9d7$var$U && ($bcb017604639e9d7$var$U = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$S = !0;
    var c = $bcb017604639e9d7$var$R;
    try {
        $bcb017604639e9d7$var$V(b);
        for($bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N); null !== $bcb017604639e9d7$var$Q && (!($bcb017604639e9d7$var$Q.expirationTime > b) || a && !$bcb017604639e9d7$var$k());){
            var d = $bcb017604639e9d7$var$Q.callback;
            if (null !== d) {
                $bcb017604639e9d7$var$Q.callback = null;
                $bcb017604639e9d7$var$R = $bcb017604639e9d7$var$Q.priorityLevel;
                var e = d($bcb017604639e9d7$var$Q.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$Q.callback = e : $bcb017604639e9d7$var$Q === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
                $bcb017604639e9d7$var$V(b);
            } else $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
            $bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
        }
        if (null !== $bcb017604639e9d7$var$Q) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = c, $bcb017604639e9d7$var$S = !1;
    }
}
function $bcb017604639e9d7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcb017604639e9d7$var$Z = $bcb017604639e9d7$var$l;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$R;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$R;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$Z;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcb017604639e9d7$var$Y(a);
    } else c = $bcb017604639e9d7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcb017604639e9d7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$O, a), null === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && a === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O) && ($bcb017604639e9d7$var$U ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$U = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, e - d))) : (a.sortIndex = c, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, a), $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = function() {
    var a = $bcb017604639e9d7$export$c4744153514ff05d();
    $bcb017604639e9d7$var$V(a);
    var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
    return b !== $bcb017604639e9d7$var$Q && null !== $bcb017604639e9d7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcb017604639e9d7$var$Q.expirationTime || $bcb017604639e9d7$var$k();
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$R;
    return function() {
        var c = $bcb017604639e9d7$var$R;
        $bcb017604639e9d7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$R = c;
        }
    };
};

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("jTyJM", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("go3dK"));

});
parcelRegister("9a4Ve", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return fetch(bundle).then(function(res) {
        return res.text();
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2k0Ea", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("3bLr3"));

});

parcelRegister("3QaWb", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("hl39L"));

});

parcelRegister("2uW6Q", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("7hqiT"));

});

parcelRegister("i8ZFc", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("lVt0F"));

});

parcelRegister("4pJ3W", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("6f4A7"));

});

parcelRegister("bH5M0", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("6DZme"));

});

parcelRegister("eHzNx", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("k7LJj"));

});

parcelRegister("6jFfq", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("kWWYN"));

});

parcelRegister("6IsRp", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("cqX2s"));

});

parcelRegister("axXW0", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("3yf6w"));

});

parcelRegister("7Dct0", function(module, exports) {

module.exports = (parcelRequire("9a4Ve"))(import.meta.resolve("6gjSm"));

});

parcelRegister("3v7ey", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("6Z7su", function(module, exports) {
/* global window */ 
var $1qzDT = parcelRequire("1qzDT");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $1qzDT.default)(root);
var $515e39ad6749f3aa$export$2e2bcd8739ae039 = result;

});
parcelRegister("1qzDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3ddfbb4e508ab$export$2e2bcd8739ae039);
function $10a3ddfbb4e508ab$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("lDMx5", function(module, exports) {
module.exports = import("4f5x1").then(()=>parcelRequire('lz3IE'));

});

parcelRegister("aomWg", function(module, exports) {
module.exports = import("7Vz0d").then(()=>parcelRequire('ct26U'));

});

parcelRegister("hMDjA", function(module, exports) {
module.exports = import("9XiGB").then(()=>parcelRequire('8dB9q'));

});

parcelRegister("2Hiyr", function(module, exports) {
module.exports = import("hFjS0").then(()=>parcelRequire('2cQPc'));

});

parcelRegister("4iiq5", function(module, exports) {
module.exports = import("lkOkz").then(()=>parcelRequire('eJWmT'));

});

parcelRegister("bfr93", function(module, exports) {
module.exports = import("iUOnL").then(()=>parcelRequire('3OS8t'));

});

parcelRegister("g38qb", function(module, exports) {
module.exports = import("clp8H").then(()=>parcelRequire('kHgxW'));

});

parcelRegister("gIRbv", function(module, exports) {
module.exports = import("aubsY").then(()=>parcelRequire('jUWlB'));

});

parcelRegister("bvWpg", function(module, exports) {
module.exports = import("eCnRv").then(()=>parcelRequire('8Jfcj'));

});

parcelRegister("lXJRU", function(module, exports) {
module.exports = import("7jF5o").then(()=>parcelRequire('7wx4U'));

});

parcelRegister("lKvWu", function(module, exports) {
module.exports = import("9s6gK").then(()=>parcelRequire('ga4Bf'));

});

parcelRegister("7lvqF", function(module, exports) {
module.exports = import("6t1rC").then(()=>parcelRequire('eH362'));

});

parcelRegister("gwS4i", function(module, exports) {
module.exports = import("6nSjA").then(()=>parcelRequire('d32Rn'));

});

parcelRegister("l4Foc", function(module, exports) {
module.exports = import("cV4OK").then(()=>parcelRequire('5NhDQ'));

});

parcelRegister("2mtiv", function(module, exports) {
module.exports = import("7lCIw").then(()=>parcelRequire('cQMRa'));

});

parcelRegister("dxDer", function(module, exports) {
module.exports = import("dQ201").then(()=>parcelRequire('iHVaG'));

});

parcelRegister("aKMJr", function(module, exports) {
module.exports = import("58RwH").then(()=>parcelRequire('9Exo8'));

});

parcelRegister("sK9Fu", function(module, exports) {
module.exports = import("aSrga").then(()=>parcelRequire('gm5On'));

});

parcelRegister("4tx5w", function(module, exports) {
module.exports = import("huV9E").then(()=>parcelRequire('k5YsQ'));

});

parcelRegister("jEOdQ", function(module, exports) {
module.exports = import("lrKfQ").then(()=>parcelRequire('2PURQ'));

});

parcelRegister("3zvpK", function(module, exports) {
module.exports = import("el1EF").then(()=>parcelRequire('iecYs'));

});

parcelRegister("1hXIw", function(module, exports) {
module.exports = import("j9uMz").then(()=>parcelRequire('gEqqg'));

});

parcelRegister("893KM", function(module, exports) {
module.exports = import("cdNpt").then(()=>parcelRequire('hzdde'));

});

parcelRegister("7Rq0e", function(module, exports) {
module.exports = import("hldMX").then(()=>parcelRequire('0424b'));

});

parcelRegister("7RStm", function(module, exports) {
module.exports = import("gUuPE").then(()=>parcelRequire('a4Hkv'));

});

parcelRegister("eA3Fe", function(module, exports) {
module.exports = import("ExYWR").then(()=>parcelRequire('eajPr'));

});

parcelRegister("1UWDV", function(module, exports) {
module.exports = import("4NB3h").then(()=>parcelRequire('gaRPm'));

});

parcelRegister("av2rP", function(module, exports) {
module.exports = import("hf3RT").then(()=>parcelRequire('bbqE0'));

});

parcelRegister("gaHbE", function(module, exports) {
module.exports = import("bIXH6").then(()=>parcelRequire('4oSUk'));

});

parcelRegister("7x782", function(module, exports) {
module.exports = import("e7C6K").then(()=>parcelRequire('5jv8j'));

});

parcelRegister("iF2Nm", function(module, exports) {
module.exports = import("1BlYO").then(()=>parcelRequire('lJ0UZ'));

});

parcelRegister("1HAk0", function(module, exports) {
module.exports = import("32ZUA").then(()=>parcelRequire('dMU1F'));

});

parcelRegister("6yVp9", function(module, exports) {
module.exports = import("1XO1o").then(()=>parcelRequire('5GDOG'));

});

parcelRegister("aKKkr", function(module, exports) {
module.exports = import("itH4H").then(()=>parcelRequire('ljO1t'));

});

parcelRegister("34nyo", function(module, exports) {
module.exports = import("3djYS").then(()=>parcelRequire('d8Veg'));

});

parcelRegister("8qava", function(module, exports) {
module.exports = import("7J9lL").then(()=>parcelRequire('l1zYt'));

});

parcelRegister("g7KJJ", function(module, exports) {
module.exports = import("uvdgR").then(()=>parcelRequire('36bu9'));

});

parcelRegister("1kPzM", function(module, exports) {
module.exports = import("gYU5Q").then(()=>parcelRequire('dCid2'));

});

parcelRegister("jBSim", function(module, exports) {
module.exports = import("938fP").then(()=>parcelRequire('aDFRr'));

});

parcelRegister("6UkSI", function(module, exports) {
module.exports = import("gUavz").then(()=>parcelRequire('5yWwg'));

});

parcelRegister("bOBxi", function(module, exports) {
module.exports = import("bwwoO").then(()=>parcelRequire('c4g4i'));

});

parcelRegister("VRwTE", function(module, exports) {
module.exports = import("9p9DU").then(()=>parcelRequire('fiPtG'));

});

parcelRegister("iZpJl", function(module, exports) {
module.exports = import("b0Djm").then(()=>parcelRequire('lXZ2f'));

});

parcelRegister("7Il5I", function(module, exports) {
module.exports = import("loUHL").then(()=>parcelRequire('7YecD'));

});

parcelRegister("6CCah", function(module, exports) {
module.exports = import("9q11r").then(()=>parcelRequire('eZ4F9'));

});

parcelRegister("jmbqU", function(module, exports) {
module.exports = import("1doqw").then(()=>parcelRequire('2go5D'));

});

parcelRegister("8jsDo", function(module, exports) {
module.exports = import("9G0fp").then(()=>parcelRequire('gmAJn'));

});

parcelRegister("cZAQu", function(module, exports) {
module.exports = import("cGUbI").then(()=>parcelRequire('bn9pB'));

});

parcelRegister("4jEze", function(module, exports) {
module.exports = import("3PuTh").then(()=>parcelRequire('4nxfQ'));

});

parcelRegister("38E8E", function(module, exports) {
module.exports = import("9tbnV").then(()=>parcelRequire('5D0r5'));

});

parcelRegister("2BUQH", function(module, exports) {
module.exports = import("9W0FV").then(()=>parcelRequire('4z7b6'));

});

parcelRegister("36jau", function(module, exports) {
module.exports = import("gThWY").then(()=>parcelRequire('1oOCK'));

});

parcelRegister("ebdry", function(module, exports) {
module.exports = import("1RNvq").then(()=>parcelRequire('7u239'));

});

parcelRegister("hP22W", function(module, exports) {
module.exports = import("8Mkd9").then(()=>parcelRequire('7mv79'));

});

parcelRegister("ckH97", function(module, exports) {
module.exports = import("98R4r").then(()=>parcelRequire('703O9'));

});

parcelRegister("j8CYa", function(module, exports) {
module.exports = import("f5P1b").then(()=>parcelRequire('2iv9e'));

});

parcelRegister("aMtwO", function(module, exports) {
module.exports = import("dtDBv").then(()=>parcelRequire('2juOS'));

});

parcelRegister("3DOwE", function(module, exports) {
module.exports = import("09HHS").then(()=>parcelRequire('hh5Zh'));

});

parcelRegister("dTBj8", function(module, exports) {
module.exports = import("3TxHS").then(()=>parcelRequire('fnL39'));

});

parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "useField", () => useField);

var $cCVp3 = parcelRequire("cCVp3");

var $3rtvu = parcelRequire("3rtvu");

var $chB0Q = parcelRequire("chB0Q");

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $9RYKL = parcelRequire("9RYKL");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9ORqK = parcelRequire("9ORqK");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $acw62.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $acw62.useRef)({
        values: (0, $chB0Q.default)(props.initialValues),
        errors: (0, $chB0Q.default)(props.initialErrors) || emptyErrors,
        touched: (0, $chB0Q.default)(props.initialTouched) || emptyTouched,
        status: (0, $chB0Q.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $acw62.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cCVp3.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cCVp3.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cCVp3.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $9RYKL.default)(false);
    var fieldHelpers = (0, $acw62.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false);
            return (0, $acw62.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false);
        !!(component && render) && (0, $9RYKL.default)(false);
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cCVp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93158fb633685272$export$2e2bcd8739ae039);
var $93158fb633685272$var$isMergeableObject = function isMergeableObject(value) {
    return $93158fb633685272$var$isNonNullObject(value) && !$93158fb633685272$var$isSpecial(value);
};
function $93158fb633685272$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $93158fb633685272$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $93158fb633685272$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $93158fb633685272$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $93158fb633685272$var$REACT_ELEMENT_TYPE = $93158fb633685272$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $93158fb633685272$var$isReactElement(value) {
    return value.$$typeof === $93158fb633685272$var$REACT_ELEMENT_TYPE;
}
function $93158fb633685272$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $93158fb633685272$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $93158fb633685272$var$deepmerge($93158fb633685272$var$emptyTarget(value), value, options) : value;
}
function $93158fb633685272$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $93158fb633685272$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $93158fb633685272$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $93158fb633685272$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $93158fb633685272$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $93158fb633685272$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $93158fb633685272$var$mergeObject(target, source, options);
}
$93158fb633685272$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $93158fb633685272$var$deepmerge(prev, next, options);
    }, {});
};
var $93158fb633685272$var$deepmerge_1 = $93158fb633685272$var$deepmerge;
var $93158fb633685272$export$2e2bcd8739ae039 = $93158fb633685272$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = '[object Arguments]', $bc81bf84e8d65dab$var$arrayTag = '[object Array]', $bc81bf84e8d65dab$var$boolTag = '[object Boolean]', $bc81bf84e8d65dab$var$dateTag = '[object Date]', $bc81bf84e8d65dab$var$errorTag = '[object Error]', $bc81bf84e8d65dab$var$funcTag = '[object Function]', $bc81bf84e8d65dab$var$genTag = '[object GeneratorFunction]', $bc81bf84e8d65dab$var$mapTag = '[object Map]', $bc81bf84e8d65dab$var$numberTag = '[object Number]', $bc81bf84e8d65dab$var$objectTag = '[object Object]', $bc81bf84e8d65dab$var$regexpTag = '[object RegExp]', $bc81bf84e8d65dab$var$setTag = '[object Set]', $bc81bf84e8d65dab$var$stringTag = '[object String]', $bc81bf84e8d65dab$var$symbolTag = '[object Symbol]', $bc81bf84e8d65dab$var$weakMapTag = '[object WeakMap]';
var $bc81bf84e8d65dab$var$arrayBufferTag = '[object ArrayBuffer]', $bc81bf84e8d65dab$var$dataViewTag = '[object DataView]', $bc81bf84e8d65dab$var$float32Tag = '[object Float32Array]', $bc81bf84e8d65dab$var$float64Tag = '[object Float64Array]', $bc81bf84e8d65dab$var$int8Tag = '[object Int8Array]', $bc81bf84e8d65dab$var$int16Tag = '[object Int16Array]', $bc81bf84e8d65dab$var$int32Tag = '[object Int32Array]', $bc81bf84e8d65dab$var$uint8Tag = '[object Uint8Array]', $bc81bf84e8d65dab$var$uint8ClampedTag = '[object Uint8ClampedArray]', $bc81bf84e8d65dab$var$uint16Tag = '[object Uint16Array]', $bc81bf84e8d65dab$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype['delete'] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype['delete'] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), 'Map');
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp('^' + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = '[object AsyncFunction]', $397b12740d7995ef$var$funcTag = '[object Function]', $397b12740d7995ef$var$genTag = '[object GeneratorFunction]', $397b12740d7995ef$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)['__core-js_shared__'];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype['delete'] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $lSo3Y.default),
        'map': new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        'string': new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype['delete'] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, 'create');
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, 'callee') && !$44fca59879666c41$var$propertyIsEnumerable.call(value, 'callee');
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = '[object Arguments]', $a51ff94e4fd33486$var$arrayTag = '[object Array]', $a51ff94e4fd33486$var$boolTag = '[object Boolean]', $a51ff94e4fd33486$var$dateTag = '[object Date]', $a51ff94e4fd33486$var$errorTag = '[object Error]', $a51ff94e4fd33486$var$funcTag = '[object Function]', $a51ff94e4fd33486$var$mapTag = '[object Map]', $a51ff94e4fd33486$var$numberTag = '[object Number]', $a51ff94e4fd33486$var$objectTag = '[object Object]', $a51ff94e4fd33486$var$regexpTag = '[object RegExp]', $a51ff94e4fd33486$var$setTag = '[object Set]', $a51ff94e4fd33486$var$stringTag = '[object String]', $a51ff94e4fd33486$var$weakMapTag = '[object WeakMap]';
var $a51ff94e4fd33486$var$arrayBufferTag = '[object ArrayBuffer]', $a51ff94e4fd33486$var$dataViewTag = '[object DataView]', $a51ff94e4fd33486$var$float32Tag = '[object Float32Array]', $a51ff94e4fd33486$var$float64Tag = '[object Float64Array]', $a51ff94e4fd33486$var$int8Tag = '[object Int8Array]', $a51ff94e4fd33486$var$int16Tag = '[object Int16Array]', $a51ff94e4fd33486$var$int32Tag = '[object Int32Array]', $a51ff94e4fd33486$var$uint8Tag = '[object Uint8Array]', $a51ff94e4fd33486$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a51ff94e4fd33486$var$uint16Tag = '[object Uint16Array]', $a51ff94e4fd33486$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = '[object Map]', $34aa59a61c7ccccb$var$objectTag = '[object Object]', $34aa59a61c7ccccb$var$promiseTag = '[object Promise]', $34aa59a61c7ccccb$var$setTag = '[object Set]', $34aa59a61c7ccccb$var$weakMapTag = '[object WeakMap]';
var $34aa59a61c7ccccb$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), 'DataView');
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), 'Promise');
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), 'Set');
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), 'WeakMap');
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7103088c29fc4f0b$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = '[object Boolean]', $d8c6c80dd3650253$var$dateTag = '[object Date]', $d8c6c80dd3650253$var$mapTag = '[object Map]', $d8c6c80dd3650253$var$numberTag = '[object Number]', $d8c6c80dd3650253$var$regexpTag = '[object RegExp]', $d8c6c80dd3650253$var$setTag = '[object Set]', $d8c6c80dd3650253$var$stringTag = '[object String]', $d8c6c80dd3650253$var$symbolTag = '[object Symbol]';
var $d8c6c80dd3650253$var$arrayBufferTag = '[object ArrayBuffer]', $d8c6c80dd3650253$var$dataViewTag = '[object DataView]', $d8c6c80dd3650253$var$float32Tag = '[object Float32Array]', $d8c6c80dd3650253$var$float64Tag = '[object Float64Array]', $d8c6c80dd3650253$var$int8Tag = '[object Int8Array]', $d8c6c80dd3650253$var$int16Tag = '[object Int16Array]', $d8c6c80dd3650253$var$int32Tag = '[object Int32Array]', $d8c6c80dd3650253$var$uint8Tag = '[object Uint8Array]', $d8c6c80dd3650253$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d8c6c80dd3650253$var$uint16Tag = '[object Uint16Array]', $d8c6c80dd3650253$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("ai2Pb", function(module, exports) {
'use strict';
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== 'undefined';
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});

parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == 'string' || (0, $1WN0o.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? '-0' : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? '' : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + '';
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? '-0' : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


// Keep the following in sync with packages/rum-slim/src/entries/main.ts
/* eslint-disable local-rules/disallow-side-effects */ /**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */ var $429fd8a62f4aa1b2$export$d37676e8a94e6b40 = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error'
};
var $429fd8a62f4aa1b2$export$d07b2d1b8b601164 = console;
var $429fd8a62f4aa1b2$export$77c4ce905194557b = {};
Object.keys($429fd8a62f4aa1b2$export$d37676e8a94e6b40).forEach(function(name) {
    $429fd8a62f4aa1b2$export$77c4ce905194557b[name] = $429fd8a62f4aa1b2$export$d07b2d1b8b601164[name];
});
var $429fd8a62f4aa1b2$var$PREFIX = 'Datadog Browser SDK:';
var $429fd8a62f4aa1b2$export$79693fdaa4661ff2 = {
    debug: $429fd8a62f4aa1b2$export$77c4ce905194557b.debug.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    log: $429fd8a62f4aa1b2$export$77c4ce905194557b.log.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    info: $429fd8a62f4aa1b2$export$77c4ce905194557b.info.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    warn: $429fd8a62f4aa1b2$export$77c4ce905194557b.warn.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX),
    error: $429fd8a62f4aa1b2$export$77c4ce905194557b.error.bind($429fd8a62f4aa1b2$export$d07b2d1b8b601164, $429fd8a62f4aa1b2$var$PREFIX)
};
var $429fd8a62f4aa1b2$export$61b69f86bb46c85e = 'https://docs.datadoghq.com';
var $429fd8a62f4aa1b2$export$f3bbdb3cea20e78e = "".concat($429fd8a62f4aa1b2$export$61b69f86bb46c85e, "/real_user_monitoring/browser/troubleshooting");
var $429fd8a62f4aa1b2$export$69ce01f6d41ea86c = 'More details:';


function $1227ac9fbf79b35b$export$a7d71543eda007d0(fn, errorMsg) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            return fn.apply(void 0, args);
        } catch (err) {
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error(errorMsg, err);
        }
    };
}



var $1d6ff96621fb36bb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1d6ff96621fb36bb$var$onMonitorErrorCollected;
var $1d6ff96621fb36bb$var$debugMode = false;
function $1d6ff96621fb36bb$export$2fa3dec4f40a39a2(newOnMonitorErrorCollected) {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function $1d6ff96621fb36bb$export$2be227cb6aa211be(newDebugMode) {
    $1d6ff96621fb36bb$var$debugMode = newDebugMode;
}
function $1d6ff96621fb36bb$export$6c5b5d0667b12cfc() {
    $1d6ff96621fb36bb$var$onMonitorErrorCollected = undefined;
    $1d6ff96621fb36bb$var$debugMode = false;
}
function $1d6ff96621fb36bb$export$efef192ceb8f8a31(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var decorated = $1d6ff96621fb36bb$var$onMonitorErrorCollected ? $1d6ff96621fb36bb$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function $1d6ff96621fb36bb$export$ec5b303098bc4b7f(fn) {
    return function() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, this, arguments);
    }; // consider output type has input type
}
function $1d6ff96621fb36bb$export$b69eb0f8afebfb6d(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    } catch (e) {
        $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
        if ($1d6ff96621fb36bb$var$onMonitorErrorCollected) try {
            $1d6ff96621fb36bb$var$onMonitorErrorCollected(e);
        } catch (e) {
            $1d6ff96621fb36bb$export$54b26de4de044ec5(e);
        }
    }
}
function $1d6ff96621fb36bb$export$54b26de4de044ec5() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if ($1d6ff96621fb36bb$var$debugMode) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error.apply((0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2), $1d6ff96621fb36bb$var$__spreadArray([
        '[MONITOR]'
    ], args, false));
}


function $b287859a2cd2eacd$export$ee2e0f811dca1807(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function $b287859a2cd2eacd$export$b1a47efd00197c76(arrayLike) {
    if (Array.from) return Array.from(arrayLike);
    var array = [];
    if (arrayLike instanceof Set) arrayLike.forEach(function(item) {
        return array.push(item);
    });
    else for(var i = 0; i < arrayLike.length; i++)array.push(arrayLike[i]);
    return array;
}
function $b287859a2cd2eacd$export$71aa6c912b956294(array, predicate) {
    for(var i = 0; i < array.length; i += 1){
        var item = array[i];
        if (predicate(item, i)) return item;
    }
    return undefined;
}
function $b287859a2cd2eacd$export$296de88ccac4bedb(array, predicate) {
    for(var i = array.length - 1; i >= 0; i -= 1){
        var item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $b287859a2cd2eacd$export$4b80e395e36b5a56(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function $b287859a2cd2eacd$export$ad1854f4a08c15f8(object) {
    return Object.keys(object).map(function(key) {
        return object[key];
    });
}
function $b287859a2cd2eacd$export$6a29ade99f81ec8a(object) {
    return Object.keys(object).map(function(key) {
        return [
            key,
            object[key]
        ];
    });
}
function $b287859a2cd2eacd$export$68326237475e9a7d(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function $b287859a2cd2eacd$export$10fdab3683b55b22(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function $b287859a2cd2eacd$export$e6e34fd1f2686227(target) {
    var toAssign = [];
    for(var _i = 1; _i < arguments.length; _i++)toAssign[_i - 1] = arguments[_i];
    toAssign.forEach(function(source) {
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
}



function $a940c8408eeade74$export$119e7fe763fbc1d1(stub) {
    var publicApi = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        version: "5.35.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function(callback) {
            callback();
        }
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function() {
            return 0, $1d6ff96621fb36bb$export$2be227cb6aa211be;
        },
        enumerable: false
    });
    return publicApi;
}
function $a940c8408eeade74$export$884b45263866f2b7(global, name, api) {
    var existingGlobalVariable = global[name];
    if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach(function(fn) {
        return (0, $1227ac9fbf79b35b$export$a7d71543eda007d0)(fn, 'onReady callback threw an error:')();
    });
}

/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */ function $5d1c89bab7298e4d$export$256479dc0cea61c4() {
    if (typeof globalThis === 'object') return globalThis;
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function() {
            return this;
        },
        configurable: true
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') globalObject = self;
        else if (typeof window === 'object') globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}




var $5baf81a8b4674c85$export$756c3d65870c899e = 1024;
var $5baf81a8b4674c85$export$377b1474fc07c10f = 1024 * $5baf81a8b4674c85$export$756c3d65870c899e;
// eslint-disable-next-line no-control-regex
var $5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function $5baf81a8b4674c85$export$36cba7c53d8f13a2(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!$5baf81a8b4674c85$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
    if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
    return new Blob([
        candidate
    ]).size;
}
function $5baf81a8b4674c85$export$28e250f55413be00(buffers) {
    var length = buffers.reduce(function(total, buffer) {
        return total + buffer.length;
    }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for(var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++){
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}



function $3f8b4cfb9b188c27$export$610f486206760177(target, name) {
    var browserWindow = (0, $5d1c89bab7298e4d$export$256479dc0cea61c4)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}




function $02784b622c768a70$export$831dc9f2ab0a617b(callback, delay) {
    return (0, $3f8b4cfb9b188c27$export$610f486206760177)((0, $5d1c89bab7298e4d$export$256479dc0cea61c4)(), 'setTimeout')((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(callback), delay);
}
function $02784b622c768a70$export$4e6a25ba7ce9d78e(timeoutId) {
    (0, $3f8b4cfb9b188c27$export$610f486206760177)((0, $5d1c89bab7298e4d$export$256479dc0cea61c4)(), 'clearTimeout')(timeoutId);
}
function $02784b622c768a70$export$cda6c73645970615(callback, delay) {
    return (0, $3f8b4cfb9b188c27$export$610f486206760177)((0, $5d1c89bab7298e4d$export$256479dc0cea61c4)(), 'setInterval')((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(callback), delay);
}
function $02784b622c768a70$export$5c0dc72231454d02(timeoutId) {
    (0, $3f8b4cfb9b188c27$export$610f486206760177)((0, $5d1c89bab7298e4d$export$256479dc0cea61c4)(), 'clearInterval')(timeoutId);
}


function $772566d0dfa3645c$export$de363e709c412c8a(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function() {
            var parameters = [];
            for(var _i = 0; _i < arguments.length; _i++)parameters[_i] = arguments[_i];
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) fn.apply(void 0, parameters);
            else pendingExecutionWithParameters = parameters;
            inWaitPeriod = true;
            pendingTimeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                if (needTrailingExecution && pendingExecutionWithParameters) fn.apply(void 0, pendingExecutionWithParameters);
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function() {
            (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        }
    };
}
function $772566d0dfa3645c$export$8793edee2d425525() {}


function $169208b8dc904506$export$1f8609334739c2b6(value, replacer, space) {
    if (typeof value !== 'object' || value === null) return JSON.stringify(value);
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.prototype);
    var restoreArrayPrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Array.prototype);
    var restoreValuePrototypeToJson = $169208b8dc904506$export$f6ec9d87b663748(Object.getPrototypeOf(value));
    var restoreValueToJson = $169208b8dc904506$export$f6ec9d87b663748(value);
    try {
        return JSON.stringify(value, replacer, space);
    } catch (_a) {
        return '<error: unable to serialize object>';
    } finally{
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function $169208b8dc904506$export$f6ec9d87b663748(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function() {
            object.toJSON = objectToJson;
        };
    }
    return 0, $772566d0dfa3645c$export$8793edee2d425525;
}


// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var $15a562dd6816cf15$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * (0, $5baf81a8b4674c85$export$756c3d65870c899e);
// Symbol for the root element of the JSONPath used for visited objects
var $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var $15a562dd6816cf15$var$KEY_DECORATION_LENGTH = 3;
function $15a562dd6816cf15$export$83d2e9e3e4ee39ed(source, maxCharacterCount) {
    if (maxCharacterCount === void 0) maxCharacterCount = $15a562dd6816cf15$var$SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0, $169208b8dc904506$export$f6ec9d87b663748)(Object.prototype);
    var restoreArrayPrototypeToJson = (0, $169208b8dc904506$export$f6ec9d87b663748)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = $15a562dd6816cf15$var$sanitizeProcessor(source, $15a562dd6816cf15$var$JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var serializedSanitizedData = JSON.stringify(sanitizedData);
    var accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while(containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount){
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) for(var key = 0; key < containerToProcess.source.length; key++){
            var targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
            if (targetData !== undefined) accumulatedCharacterCount += JSON.stringify(targetData).length;
            else // When an element of an Array (targetData) is undefined, it is serialized as null:
            // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
            accumulatedCharacterCount += 4;
            accumulatedCharacterCount += separatorLength;
            separatorLength = 1;
            if (accumulatedCharacterCount > maxCharacterCount) {
                $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                break;
            }
            containerToProcess.target[key] = targetData;
        }
        else {
            for(var key in containerToProcess.source)if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                var targetData = $15a562dd6816cf15$var$sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                // When a property of an object has an undefined value, it will be dropped during serialization:
                // JSON.stringify({a:undefined}) => '{}'
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + $15a562dd6816cf15$var$KEY_DECORATION_LENGTH;
                    separatorLength = 1;
                }
                if (accumulatedCharacterCount > maxCharacterCount) {
                    $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                containerToProcess.target[key] = targetData;
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */ function $15a562dd6816cf15$var$sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = $15a562dd6816cf15$var$tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') return $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(sourceToSanitize);
    var sanitizedSource = $15a562dd6816cf15$var$sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') return sanitizedSource;
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({
        source: sourceToSanitize,
        target: target,
        path: currentPath
    });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */ function $15a562dd6816cf15$var$sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') return "[BigInt] ".concat(value.toString());
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') return "[Function] ".concat(value.name || 'unknown');
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') return "[Symbol] ".concat(value.description || value.toString());
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */ function $15a562dd6816cf15$var$sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) return {
            isTrusted: value.isTrusted
        };
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) return "[".concat(match[1], "]");
    } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */ function $15a562dd6816cf15$var$tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') try {
        return object.toJSON();
    } catch (_a) {
    // If toJSON fails, we continue by trying to serialize the value manually
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */ function $15a562dd6816cf15$var$warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}



/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */ 
var $24e0e8626c2d0274$var$UNKNOWN_FUNCTION = '?';
function $24e0e8626c2d0274$export$81296eded4f2ac09(ex) {
    var stack = [];
    var stackProperty = $24e0e8626c2d0274$var$tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0, $b287859a2cd2eacd$export$68326237475e9a7d)(stackProperty, exString)) stackProperty = stackProperty.slice(exString.length);
    if (stackProperty) stackProperty.split('\n').forEach(function(line) {
        var stackFrame = $24e0e8626c2d0274$var$parseChromeLine(line) || $24e0e8626c2d0274$var$parseChromeAnonymousLine(line) || $24e0e8626c2d0274$var$parseWinLine(line) || $24e0e8626c2d0274$var$parseGeckoLine(line);
        if (stackFrame) {
            if (!stackFrame.func && stackFrame.line) stackFrame.func = $24e0e8626c2d0274$var$UNKNOWN_FUNCTION;
            stack.push(stackFrame);
        }
    });
    return {
        message: $24e0e8626c2d0274$var$tryToGetString(ex, 'message'),
        name: $24e0e8626c2d0274$var$tryToGetString(ex, 'name'),
        stack: stack
    };
}
var $24e0e8626c2d0274$var$fileUrl = '((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var $24e0e8626c2d0274$var$filePosition = '(?::(\\d+))';
var $24e0e8626c2d0274$var$CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat($24e0e8626c2d0274$var$fileUrl).concat($24e0e8626c2d0274$var$filePosition, "?").concat($24e0e8626c2d0274$var$filePosition, "?\\)?\\s*$"), 'i');
var $24e0e8626c2d0274$var$CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat($24e0e8626c2d0274$var$filePosition).concat($24e0e8626c2d0274$var$filePosition, "\\)"));
function $24e0e8626c2d0274$var$parseChromeLine(line) {
    var parts = $24e0e8626c2d0274$var$CHROME_LINE_RE.exec(line);
    if (!parts) return;
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = $24e0e8626c2d0274$var$CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [
            parts[2]
        ] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined
    };
}
var $24e0e8626c2d0274$var$CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat($24e0e8626c2d0274$var$fileUrl).concat($24e0e8626c2d0274$var$filePosition, "?").concat($24e0e8626c2d0274$var$filePosition, "??\\s*$"), 'i');
function $24e0e8626c2d0274$var$parseChromeAnonymousLine(line) {
    var parts = $24e0e8626c2d0274$var$CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1]
    };
}
var $24e0e8626c2d0274$var$WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function $24e0e8626c2d0274$var$parseWinLine(line) {
    var parts = $24e0e8626c2d0274$var$WINJS_LINE_RE.exec(line);
    if (!parts) return;
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2]
    };
}
var $24e0e8626c2d0274$var$GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var $24e0e8626c2d0274$var$GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function $24e0e8626c2d0274$var$parseGeckoLine(line) {
    var parts = $24e0e8626c2d0274$var$GECKO_LINE_RE.exec(line);
    if (!parts) return;
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = $24e0e8626c2d0274$var$GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || $24e0e8626c2d0274$var$UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3]
    };
}
function $24e0e8626c2d0274$var$tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) return undefined;
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function $24e0e8626c2d0274$export$e8e53f0e2ff18afa(messageObj, url, line, column) {
    var stack = [
        {
            url: url,
            column: column,
            line: line
        }
    ];
    var _a = $24e0e8626c2d0274$var$tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var $24e0e8626c2d0274$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function $24e0e8626c2d0274$var$tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if (({}).toString.call(messageObj) === '[object String]') _a = $24e0e8626c2d0274$var$ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    return {
        name: name,
        message: message
    };
}





function $4ac782ea9e4e9601$export$46c2cbbc853cd95b() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */ var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) try {
        throw error;
    } catch (_a) {
        (0, $772566d0dfa3645c$export$8793edee2d425525)();
    }
    (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(function() {
        var stackTrace = (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = $4ac782ea9e4e9601$export$36ad41d7075a6f2b(stackTrace);
    });
    return formattedStack;
}
function $4ac782ea9e4e9601$export$36ad41d7075a6f2b(stack) {
    var result = $4ac782ea9e4e9601$export$5201d50a34753d71(stack);
    stack.stack.forEach(function(frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function $4ac782ea9e4e9601$export$5201d50a34753d71(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}


var $35957bb00d7299b7$export$25ad0fcc62fe3571 = 'No stack, consider using an instance of Error';
function $35957bb00d7299b7$export$b8dc46b79c72ee26(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = $35957bb00d7299b7$export$e6127cc7fe7395c3(originalError);
    var message = $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = $35957bb00d7299b7$var$hasUsableStack(isErrorInstance, stackTrace) ? (0, $4ac782ea9e4e9601$export$36ad41d7075a6f2b)(stackTrace) : $35957bb00d7299b7$export$25ad0fcc62fe3571;
    var causes = isErrorInstance ? $35957bb00d7299b7$export$bf9a979d43c83a9(originalError, source) : undefined;
    var type = stackTrace ? stackTrace.name : undefined;
    var fingerprint = $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint
    };
}
function $35957bb00d7299b7$var$computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat((0, $169208b8dc904506$export$1f8609334739c2b6)((0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(originalError))) : 'Empty message';
}
function $35957bb00d7299b7$var$hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) return false;
    if (isErrorInstance) return true;
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function $35957bb00d7299b7$export$1c18937f21a7f1f7(originalError) {
    return $35957bb00d7299b7$export$e6127cc7fe7395c3(originalError) && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function $35957bb00d7299b7$export$edc1986890374033(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function $35957bb00d7299b7$export$e6127cc7fe7395c3(error) {
    return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
}
function $35957bb00d7299b7$export$bf9a979d43c83a9(error, parentSource) {
    var currentError = error;
    var causes = [];
    while($35957bb00d7299b7$export$e6127cc7fe7395c3(currentError === null || currentError === void 0 ? void 0 : currentError.cause) && causes.length < 10){
        var stackTrace = (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && (0, $4ac782ea9e4e9601$export$36ad41d7075a6f2b)(stackTrace)
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}



/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */ // We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag

function $66d1b7fd2da44c06$export$370e8311c3cdebd9(object) {
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, object);
}
function $66d1b7fd2da44c06$export$783ef1184b4cd483(object, value) {
    return Object.keys(object).some(function(key) {
        return object[key] === value;
    });
}
function $66d1b7fd2da44c06$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $66d1b7fd2da44c06$export$825e789796ab7275(object, fn) {
    var newObject = {};
    for(var _i = 0, _a = Object.keys(object); _i < _a.length; _i++){
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}


var $e967aa36fccc7e29$export$8c1a7666d5772525;
(function(ExperimentalFeature) {
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
    ExperimentalFeature["LONG_ANIMATION_FRAME"] = "long_animation_frame";
    ExperimentalFeature["ANONYMOUS_USER_TRACKING"] = "anonymous_user_tracking";
    ExperimentalFeature["ACTION_NAME_MASKING"] = "action_name_masking";
    ExperimentalFeature["CONSISTENT_TRACE_SAMPLING"] = "consistent_trace_sampling";
    ExperimentalFeature["DELAY_VIEWPORT_COLLECTION"] = "delay_viewport_collection";
})($e967aa36fccc7e29$export$8c1a7666d5772525 || ($e967aa36fccc7e29$export$8c1a7666d5772525 = {}));
var $e967aa36fccc7e29$var$enabledExperimentalFeatures = new Set();
function $e967aa36fccc7e29$export$f9d0db67c92b2ab2(enableExperimentalFeatures) {
    if (Array.isArray(enableExperimentalFeatures)) $e967aa36fccc7e29$export$6d36e587aa761763(enableExperimentalFeatures.filter(function(flag) {
        return (0, $66d1b7fd2da44c06$export$783ef1184b4cd483)($e967aa36fccc7e29$export$8c1a7666d5772525, flag);
    }));
}
function $e967aa36fccc7e29$export$6d36e587aa761763(enabledFeatures) {
    enabledFeatures.forEach(function(flag) {
        $e967aa36fccc7e29$var$enabledExperimentalFeatures.add(flag);
    });
}
function $e967aa36fccc7e29$export$ada3eaf101ef7eb6(featureName) {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures.has(featureName);
}
function $e967aa36fccc7e29$export$4248398637d8b60d() {
    $e967aa36fccc7e29$var$enabledExperimentalFeatures.clear();
}
function $e967aa36fccc7e29$export$45a70c97bd86e1c8() {
    return $e967aa36fccc7e29$var$enabledExperimentalFeatures;
}


var $77d3907623da03fc$export$a204b9d5a62f1e2c = 'datad0g.com';
var $77d3907623da03fc$export$62cc10d94d5ff7fd = 'dd0g-gov.com';
var $77d3907623da03fc$export$6b79fd7dd2f5fb9a = 'datadoghq.com';
var $77d3907623da03fc$export$7452d85ec570d2ea = 'datadoghq.eu';
var $77d3907623da03fc$export$241ba7106e833c7b = 'ddog-gov.com';
var $77d3907623da03fc$export$e02f42b31d885a8c = 'pci.browser-intake-datadoghq.com';
var $77d3907623da03fc$export$e36b5f83de28fc8a = [
    'ddsource',
    'ddtags'
];


// eslint-disable-next-line no-restricted-syntax
var $34a3791423ee474f$export$77cea355fa80b5f4 = /** @class */ function() {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function(f) {
        var _this = this;
        this.observers.push(f);
        if (this.observers.length === 1 && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        return {
            unsubscribe: function() {
                _this.observers = _this.observers.filter(function(other) {
                    return f !== other;
                });
                if (!_this.observers.length && _this.onLastUnsubscribe) _this.onLastUnsubscribe();
            }
        };
    };
    Observable.prototype.notify = function(data) {
        this.observers.forEach(function(observer) {
            return observer(data);
        });
    };
    return Observable;
}();
function $34a3791423ee474f$export$ca54b410f15f44fe() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return new $34a3791423ee474f$export$77cea355fa80b5f4(function(globalObservable) {
        var subscriptions = observables.map(function(observable) {
            return observable.subscribe(function(data) {
                return globalObservable.notify(data);
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.unsubscribe();
            });
        };
    });
}


/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */ function $89f5cd41be2839b1$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $89f5cd41be2839b1$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $89f5cd41be2839b1$export$d86432a85610ea90(value) {
    return $89f5cd41be2839b1$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $89f5cd41be2839b1$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}


var $fafd178883cb17fc$export$32c0454ceff7f92d = 1000;
var $fafd178883cb17fc$export$35acaebf644db34e = 60 * $fafd178883cb17fc$export$32c0454ceff7f92d;
var $fafd178883cb17fc$export$82541edf19e5e3b0 = 60 * $fafd178883cb17fc$export$35acaebf644db34e;
var $fafd178883cb17fc$export$a97a1358cbb650ab = 24 * $fafd178883cb17fc$export$82541edf19e5e3b0;
var $fafd178883cb17fc$export$99cafda57477293d = 365 * $fafd178883cb17fc$export$a97a1358cbb650ab;
function $fafd178883cb17fc$export$6d554362ef4543f2(relative) {
    return {
        relative: relative,
        timeStamp: $fafd178883cb17fc$var$getCorrectedTimeStamp(relative)
    };
}
function $fafd178883cb17fc$export$1208e92a226eb540(timeStamp) {
    return {
        relative: $fafd178883cb17fc$export$493c11ff22f45a24(timeStamp),
        timeStamp: timeStamp
    };
}
function $fafd178883cb17fc$var$getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = $fafd178883cb17fc$export$ceae11818251d43c() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > $fafd178883cb17fc$var$getNavigationStart()) return Math.round($fafd178883cb17fc$export$c0c581816dedfc70(correctedOrigin, relativeTime));
    return $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime);
}
function $fafd178883cb17fc$export$5dcf4148298ed557() {
    return Math.round($fafd178883cb17fc$export$ceae11818251d43c() - $fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), performance.now()));
}
function $fafd178883cb17fc$export$cc7917ebd320fa93(duration) {
    if (!(0, $89f5cd41be2839b1$export$7e4aa119212bc614)(duration)) return duration;
    return (0, $89f5cd41be2839b1$export$2077e0241d6afd3c)(duration * 1e6, 0);
}
function $fafd178883cb17fc$export$ceae11818251d43c() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function $fafd178883cb17fc$export$71f52cdbbf629086() {
    return $fafd178883cb17fc$export$ceae11818251d43c();
}
function $fafd178883cb17fc$export$53cb631b087d9e92() {
    return performance.now();
}
function $fafd178883cb17fc$export$67898643147706d3() {
    return {
        relative: $fafd178883cb17fc$export$53cb631b087d9e92(),
        timeStamp: $fafd178883cb17fc$export$71f52cdbbf629086()
    };
}
function $fafd178883cb17fc$export$d8b428538156d05f() {
    return {
        relative: 0,
        timeStamp: $fafd178883cb17fc$var$getNavigationStart()
    };
}
function $fafd178883cb17fc$export$e04aa69d28450d55(start, end) {
    return end - start;
}
function $fafd178883cb17fc$export$c0c581816dedfc70(a, b) {
    return a + b;
}
function $fafd178883cb17fc$export$493c11ff22f45a24(timestamp) {
    return timestamp - $fafd178883cb17fc$var$getNavigationStart();
}
function $fafd178883cb17fc$export$3eddb21a9c389dec(relativeTime) {
    return Math.round($fafd178883cb17fc$export$c0c581816dedfc70($fafd178883cb17fc$var$getNavigationStart(), relativeTime));
}
function $fafd178883cb17fc$export$dc53cd187b19c9f8(time) {
    return time < $fafd178883cb17fc$export$99cafda57477293d;
}
/**
 * Navigation start slightly change on some rare cases
 */ var $fafd178883cb17fc$var$navigationStart;
function $fafd178883cb17fc$var$getNavigationStart() {
    if ($fafd178883cb17fc$var$navigationStart === undefined) $fafd178883cb17fc$var$navigationStart = performance.timing.navigationStart;
    return $fafd178883cb17fc$var$navigationStart;
}



function $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) callback({
        type: type,
        payload: payload
    });
}





/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */ function $41afd9a0399e7c82$export$e2b5c5db9e2009fd(value) {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    return typeof value;
}


function $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) circularReferenceChecker = $df0d4cb06c424d45$var$createCircularReferenceChecker();
    // ignore the source if it is undefined
    if (source === undefined) return destination;
    if (typeof source !== 'object' || source === null) // primitive values - just return source
    return source;
    else if (source instanceof Date) return new Date(source.getTime());
    else if (source instanceof RegExp) {
        var flags = source.flags || // old browsers compatibility
        [
            source.global ? 'g' : '',
            source.ignoreCase ? 'i' : '',
            source.multiline ? 'm' : '',
            source.sticky ? 'y' : '',
            source.unicode ? 'u' : ''
        ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) // remove circular references
    return undefined;
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for(var i = 0; i < source.length; ++i)merged_1[i] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged_1[i], source[i], circularReferenceChecker);
        return merged_1;
    }
    var merged = (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(destination) === 'object' ? destination : {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) merged[key] = $df0d4cb06c424d45$export$f00f2bc10b5384e6(merged[key], source[key], circularReferenceChecker);
    return merged;
}
function $df0d4cb06c424d45$export$b7d58db314e0ac27(value) {
    return $df0d4cb06c424d45$export$f00f2bc10b5384e6(undefined, value);
}
function $df0d4cb06c424d45$export$1be1fc439b849fdf() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var destination;
    for(var _a = 0, sources_1 = sources; _a < sources_1.length; _a++){
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $df0d4cb06c424d45$export$f00f2bc10b5384e6(destination, source);
    }
    return destination;
}
function $df0d4cb06c424d45$var$createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function(value) {
                var has = set_1.has(value);
                if (!has) set_1.add(value);
                return has;
            }
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function(value) {
            var has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}



function $5db5d5af84f5318f$export$5c86d3b16901f3ce() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [
            navigator.connection.type
        ] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
    };
}



function $fcd525cace9de4ff$export$2e2262a44ac61957(array) {
    var set = new Set();
    array.forEach(function(item) {
        return set.add(item);
    });
    return (0, $b287859a2cd2eacd$export$b1a47efd00197c76)(set);
}
function $fcd525cace9de4ff$export$fe2d9b4e03920b4c(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}


var $f330f38d49d59161$var$BUFFER_LIMIT = 500;
function $f330f38d49d59161$export$9724f168e999472b() {
    var buffer = [];
    var add = function(callback) {
        var length = buffer.push(callback);
        if (length > $f330f38d49d59161$var$BUFFER_LIMIT) buffer.splice(0, 1);
    };
    var remove = function(callback) {
        (0, $fcd525cace9de4ff$export$fe2d9b4e03920b4c)(buffer, callback);
    };
    var drain = function(arg) {
        buffer.forEach(function(callback) {
            return callback(arg);
        });
        buffer.length = 0;
    };
    return {
        add: add,
        remove: remove,
        drain: drain
    };
}


var $15bc0061a7f329ff$export$8c1a12d9d019b209 = {
    log: 'log',
    configuration: 'configuration',
    usage: 'usage'
};


var $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>'
];
var $b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES = [
    (0, $77d3907623da03fc$export$241ba7106e833c7b)
];
// eslint-disable-next-line local-rules/disallow-side-effects
var $b20e9e3ee3028089$var$preStartTelemetryBuffer = (0, $f330f38d49d59161$export$9724f168e999472b)();
var $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(event) {
    $b20e9e3ee3028089$var$preStartTelemetryBuffer.add(function() {
        return $b20e9e3ee3028089$var$onRawTelemetryEventCollected(event);
    });
};
function $b20e9e3ee3028089$export$a1198c4bba5d5e18(telemetryService, configuration) {
    var _a;
    var contextProvider;
    var observable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var alreadySentEvents = new Set();
    var telemetryEnabled = !(0, $b287859a2cd2eacd$export$ee2e0f811dca1807)($b20e9e3ee3028089$var$TELEMETRY_EXCLUDED_SITES, configuration.site) && (0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.telemetrySampleRate);
    var telemetryEnabledPerType = (_a = {}, _a[(0, $15bc0061a7f329ff$export$8c1a12d9d019b209).log] = telemetryEnabled, _a[(0, $15bc0061a7f329ff$export$8c1a12d9d019b209).configuration] = telemetryEnabled && (0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.telemetryConfigurationSampleRate), _a[(0, $15bc0061a7f329ff$export$8c1a12d9d019b209).usage] = telemetryEnabled && (0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.telemetryUsageSampleRate), _a);
    var runtimeEnvInfo = $b20e9e3ee3028089$var$getRuntimeEnvInfo();
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(rawEvent) {
        var stringifiedEvent = (0, $169208b8dc904506$export$1f8609334739c2b6)(rawEvent);
        if (telemetryEnabledPerType[rawEvent.type] && alreadySentEvents.size < configuration.maxTelemetryEventsPerPage && !alreadySentEvents.has(stringifiedEvent)) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0, $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b)('telemetry', event_1);
            alreadySentEvents.add(stringifiedEvent);
        }
    };
    (0, $1d6ff96621fb36bb$export$2fa3dec4f40a39a2)($b20e9e3ee3028089$export$2e825f93958b0e6a);
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)({
            type: 'telemetry',
            date: (0, $fafd178883cb17fc$export$71f52cdbbf629086)(),
            service: telemetryService,
            version: "5.35.1",
            source: 'browser',
            _dd: {
                format_version: 2
            },
            telemetry: (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0, $5db5d5af84f5318f$export$5c86d3b16901f3ce)(),
                sdk_setup: "npm"
            }),
            experimental_features: (0, $b287859a2cd2eacd$export$b1a47efd00197c76)((0, $e967aa36fccc7e29$export$45a70c97bd86e1c8)())
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function(provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryEnabled
    };
}
function $b20e9e3ee3028089$var$getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self
    };
}
function $b20e9e3ee3028089$export$fa01c94923483298() {
    var events = [];
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(event) {
        events.push(event);
    };
    return events;
}
function $b20e9e3ee3028089$export$848bed2c00d8bca2() {
    $b20e9e3ee3028089$var$preStartTelemetryBuffer.drain();
}
function $b20e9e3ee3028089$export$bcc442d9456bda5() {
    $b20e9e3ee3028089$var$preStartTelemetryBuffer = (0, $f330f38d49d59161$export$9724f168e999472b)();
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected = function(event) {
        $b20e9e3ee3028089$var$preStartTelemetryBuffer.add(function() {
            return $b20e9e3ee3028089$var$onRawTelemetryEventCollected(event);
        });
    };
}
function $b20e9e3ee3028089$export$2b39c4ac778572fb(configuration) {
    return configuration.site === (0, $77d3907623da03fc$export$a204b9d5a62f1e2c);
}
function $b20e9e3ee3028089$export$d922954195a17683(message, context) {
    (0, $1d6ff96621fb36bb$export$54b26de4de044ec5)((0, $429fd8a62f4aa1b2$export$d37676e8a94e6b40).debug, message, context);
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected((0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        type: (0, $15bc0061a7f329ff$export$8c1a12d9d019b209).log,
        message: message,
        status: "debug" /* StatusType.debug */ 
    }, context));
}
function $b20e9e3ee3028089$export$2e825f93958b0e6a(e, context) {
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected((0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        type: (0, $15bc0061a7f329ff$export$8c1a12d9d019b209).log,
        status: "error" /* StatusType.error */ 
    }, $b20e9e3ee3028089$export$7b5b869ee98c16ab(e), context));
}
function $b20e9e3ee3028089$export$d546dcbd09bc447f(configuration) {
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected({
        type: (0, $15bc0061a7f329ff$export$8c1a12d9d019b209).configuration,
        configuration: configuration
    });
}
function $b20e9e3ee3028089$export$1241dad04919e70b(usage) {
    $b20e9e3ee3028089$var$onRawTelemetryEventCollected({
        type: (0, $15bc0061a7f329ff$export$8c1a12d9d019b209).usage,
        usage: usage
    });
}
function $b20e9e3ee3028089$export$7b5b869ee98c16ab(e) {
    if ((0, $35957bb00d7299b7$export$e6127cc7fe7395c3)(e)) {
        var stackTrace = (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $4ac782ea9e4e9601$export$36ad41d7075a6f2b)($b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace))
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: (0, $35957bb00d7299b7$export$25ad0fcc62fe3571)
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */ , " ").concat((0, $169208b8dc904506$export$1f8609334739c2b6)(e))
    };
}
function $b20e9e3ee3028089$export$cb9c82b4610a83c3(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function(frame) {
        return !frame.url || $b20e9e3ee3028089$var$ALLOWED_FRAME_URLS.some(function(allowedFrameUrl) {
            return (0, $b287859a2cd2eacd$export$68326237475e9a7d)(frame.url, allowedFrameUrl);
        });
    });
    return stackTrace;
}




function $c75d7197f8114000$export$cb88b31dcf3267e1(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, newUser);
    var keys = [
        'id',
        'name',
        'email'
    ];
    keys.forEach(function(key) {
        if (key in user) /* eslint-disable @typescript-eslint/no-base-to-string */ user[key] = String(user[key]);
    });
    return user;
}
function $c75d7197f8114000$export$77a0cf2b32e9e53d(newUser) {
    var isValid = (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(newUser) === 'object';
    if (!isValid) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Unsupported user:', newUser);
    return isValid;
}
function $c75d7197f8114000$export$e8675f0f57a60e5b() {
    return Math.floor(Math.random() * Math.pow(2, 53)).toString(36);
}





function $a708ac9bed8d6582$export$fe3149b78a43e1ad(customerDataTracker) {
    var context = {};
    var changeObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var contextManager = {
        getContext: function() {
            return (0, $df0d4cb06c424d45$export$b7d58db314e0ac27)(context);
        },
        setContext: function(newContext) {
            if ((0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(newContext) === 'object') {
                context = (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(newContext);
                customerDataTracker === null || customerDataTracker === void 0 || customerDataTracker.updateCustomerData(context);
            } else contextManager.clearContext();
            changeObservable.notify();
        },
        setContextProperty: function(key, property) {
            context[key] = (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(property);
            customerDataTracker === null || customerDataTracker === void 0 || customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function(key) {
            delete context[key];
            customerDataTracker === null || customerDataTracker === void 0 || customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function() {
            context = {};
            customerDataTracker === null || customerDataTracker === void 0 || customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable
    };
    return contextManager;
}






var $6a0cdc23e79adf0f$export$856a8907751d74c7 = 3 * (0, $5baf81a8b4674c85$export$756c3d65870c899e);
var $6a0cdc23e79adf0f$export$c5b99750d2340cdd = 16 * (0, $5baf81a8b4674c85$export$756c3d65870c899e);
var $6a0cdc23e79adf0f$export$e4441139afa265bd = 200;
function $6a0cdc23e79adf0f$export$91e74adeb321d399(compressionStatus) {
    if (compressionStatus === void 0) compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */ ;
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) initialBytesCount = 0;
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) return;
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */  ? $6a0cdc23e79adf0f$export$856a8907751d74c7 : $6a0cdc23e79adf0f$export$c5b99750d2340cdd;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function(tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            $6a0cdc23e79adf0f$var$displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */ createDetachedTracker: function() {
            var tracker = $6a0cdc23e79adf0f$export$1cff91322f949d75(function() {
                return checkCustomerDataLimit(tracker.getBytesCount());
            });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */ getOrCreateTracker: function(type) {
            if (!customerDataTrackers.has(type)) customerDataTrackers.set(type, $6a0cdc23e79adf0f$export$1cff91322f949d75(checkCustomerDataLimit));
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function(newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */ ) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function() {
            return compressionStatus;
        },
        stop: function() {
            customerDataTrackers.forEach(function(tracker) {
                return tracker.stop();
            });
            customerDataTrackers.clear();
        }
    };
}
function $6a0cdc23e79adf0f$export$1cff91322f949d75(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function(context) {
        bytesCountCache = (0, $5baf81a8b4674c85$export$36cba7c53d8f13a2)((0, $169208b8dc904506$export$1f8609334739c2b6)(context));
        checkCustomerDataLimit();
    }, $6a0cdc23e79adf0f$export$e4441139afa265bd), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function() {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function(context) {
            if ((0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(context)) resetBytesCount();
            else computeBytesCountThrottled(context);
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function() {
            return bytesCountCache;
        },
        stop: function() {
            cancelComputeBytesCount();
        }
    };
}
function $6a0cdc23e79adf0f$var$displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("Customer data exceeds the recommended ".concat(bytesCountLimit / (0, $5baf81a8b4674c85$export$756c3d65870c899e), "KiB threshold. ").concat((0, $429fd8a62f4aa1b2$export$69ce01f6d41ea86c), " ").concat((0, $429fd8a62f4aa1b2$export$f3bbdb3cea20e78e), "/#customer-data-exceeds-the-recommended-threshold-warning"));
}


function $ff11a0928c846f93$export$b5341466c7007825() {
    var output = '';
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty () {
            return !output;
        },
        write: function(data, callback) {
            var additionalEncodedBytesCount = (0, $5baf81a8b4674c85$export$36cba7c53d8f13a2)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) callback(additionalEncodedBytesCount);
        },
        finish: function(callback) {
            callback(this.finishSync());
        },
        finishSync: function() {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: ''
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function(data) {
            return data.length;
        }
    };
}


var $69f3116f372ada5b$export$52745dd8ee2d32b2 = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted'
};
function $69f3116f372ada5b$export$6a999af43d888e18(currentConsent) {
    var observable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    return {
        tryToInit: function(trackingConsent) {
            if (!currentConsent) currentConsent = trackingConsent;
        },
        update: function(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function() {
            return currentConsent === $69f3116f372ada5b$export$52745dd8ee2d32b2.GRANTED;
        },
        observable: observable
    };
}


function $c014cf41d8e6d87d$export$b25c854130ebaef9(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(sdkName, " is already initialized."));
}



function $d12554daef4f5e60$export$3f65cefe8380dbea(configuration, eventTarget, eventName, listener, options) {
    return $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, [
        eventName
    ], listener, options);
}
function $d12554daef4f5e60$export$40a4ed63e5cb7043(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) return;
        if (once) stop();
        listener(event);
    });
    var options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    // Use the window.EventTarget.prototype when possible to avoid wrong overrides (e.g: https://github.com/salesforce/lwc/issues/1824)
    var listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
    var add = (0, $3f8b4cfb9b188c27$export$610f486206760177)(listenerTarget, 'addEventListener');
    eventNames.forEach(function(eventName) {
        return add.call(eventTarget, eventName, listenerWithMonitor, options);
    });
    function stop() {
        var remove = (0, $3f8b4cfb9b188c27$export$610f486206760177)(listenerTarget, 'removeEventListener');
        eventNames.forEach(function(eventName) {
            return remove.call(eventTarget, eventName, listenerWithMonitor, options);
        });
    }
    return {
        stop: stop
    };
}



var $77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var $77176f4fd68bc5cf$var$storageListeners = [];
function $77176f4fd68bc5cf$export$a658cbc041b124d0(configuration, contextManager, productKey, customerDataType) {
    var storageKey = $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType);
    $77176f4fd68bc5cf$var$storageListeners.push((0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "storage" /* DOM_EVENT.STORAGE */ , function(_a) {
        var key = _a.key;
        if (storageKey === key) synchronizeWithStorage();
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext((0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function $77176f4fd68bc5cf$export$c2d6dd7271dc8ae0(productKey, customerDataType) {
    return "".concat($77176f4fd68bc5cf$var$CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function $77176f4fd68bc5cf$export$c82fd872f963a6c() {
    $77176f4fd68bc5cf$var$storageListeners.map(function(listener) {
        return listener.stop();
    });
}


function $af152d066fd4f661$export$ef57df7b19d2c9ab(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined
    };
}


/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */ function $01b8047924249a5c$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, $01b8047924249a5c$export$e73c8bd0f20705a);
}
var $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function $01b8047924249a5c$export$fe87bb5193f3e70(rawString, name) {
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) return match[2];
        } else break;
    }
}
function $01b8047924249a5c$export$58032b923d63748e(rawString) {
    var result = new Map();
    $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var match = $01b8047924249a5c$var$COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) result.set(match[1], match[2]);
        else break;
    }
    return result;
}
function $01b8047924249a5c$export$b26462d2f74496cd(candidate, length, suffix) {
    if (suffix === void 0) suffix = '';
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}


function $7eb1818b147a2865$export$10f357105ec5707a() {
    var vitalsByName = new Map();
    var vitalsByReference = new WeakMap();
    return {
        vitalsByName: vitalsByName,
        vitalsByReference: vitalsByReference
    };
}
function $7eb1818b147a2865$export$1f5a51a997c60d35(lifeCycle, pageStateHistory, customVitalsState) {
    function isValid(vital) {
        return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , vital.startClocks.relative, vital.duration);
    }
    function addDurationVital(vital) {
        if (isValid(vital)) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $7eb1818b147a2865$var$processVital(vital, true));
    }
    return {
        addDurationVital: addDurationVital,
        startDurationVital: function(name, options) {
            if (options === void 0) options = {};
            return $7eb1818b147a2865$export$861e77a28cc19266(customVitalsState, name, options);
        },
        stopDurationVital: function(nameOrRef, options) {
            if (options === void 0) options = {};
            $7eb1818b147a2865$export$ccd4fac39ed3f334(addDurationVital, customVitalsState, nameOrRef, options);
        }
    };
}
function $7eb1818b147a2865$export$861e77a28cc19266(_a, name, options) {
    var vitalsByName = _a.vitalsByName, vitalsByReference = _a.vitalsByReference;
    if (options === void 0) options = {};
    var vital = {
        name: name,
        startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)(),
        context: options.context,
        description: options.description
    };
    // To avoid leaking implementation details of the vital, we return a reference to it.
    var reference = {
        __dd_vital_reference: true
    };
    vitalsByName.set(name, vital);
    // To avoid memory leaks caused by the creation of numerous references (e.g., from improper useEffect implementations), we use a WeakMap.
    vitalsByReference.set(reference, vital);
    return reference;
}
function $7eb1818b147a2865$export$ccd4fac39ed3f334(stopCallback, _a, nameOrRef, options) {
    var vitalsByName = _a.vitalsByName, vitalsByReference = _a.vitalsByReference;
    if (options === void 0) options = {};
    var vitalStart = typeof nameOrRef === 'string' ? vitalsByName.get(nameOrRef) : vitalsByReference.get(nameOrRef);
    if (!vitalStart) return;
    stopCallback($7eb1818b147a2865$var$buildDurationVital(vitalStart, vitalStart.startClocks, options, (0, $fafd178883cb17fc$export$67898643147706d3)()));
    if (typeof nameOrRef === 'string') vitalsByName.delete(nameOrRef);
    else vitalsByReference.delete(nameOrRef);
}
function $7eb1818b147a2865$var$buildDurationVital(vitalStart, startClocks, stopOptions, stopClocks) {
    var _a;
    return {
        name: vitalStart.name,
        type: "duration" /* VitalType.DURATION */ ,
        startClocks: startClocks,
        duration: (0, $fafd178883cb17fc$export$e04aa69d28450d55)(startClocks.timeStamp, stopClocks.timeStamp),
        context: (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(vitalStart.context, stopOptions.context),
        description: (_a = stopOptions.description) !== null && _a !== void 0 ? _a : vitalStart.description
    };
}
function $7eb1818b147a2865$var$processVital(vital, valueComputedBySdk) {
    var rawRumEvent = {
        date: vital.startClocks.timeStamp,
        vital: {
            id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
            type: vital.type,
            name: vital.name,
            duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(vital.duration),
            description: vital.description
        },
        type: "vital" /* RumEventType.VITAL */ 
    };
    if (valueComputedBySdk) rawRumEvent._dd = {
        vital: {
            computed_value: true
        }
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: vital.startClocks.relative,
        customerContext: vital.context,
        domainContext: {}
    };
}




function $f0aff45a57046ce0$export$86c8e1e7efd0dfc1() {
    var eventBridgeGlobal = $f0aff45a57046ce0$var$getEventBridgeGlobal();
    if (!eventBridgeGlobal) return;
    return {
        getCapabilities: function() {
            var _a;
            return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
        },
        getPrivacyLevel: function() {
            var _a;
            return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
        },
        getAllowedWebViewHosts: function() {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function(eventType, event, viewId) {
            var view = viewId ? {
                id: viewId
            } : undefined;
            eventBridgeGlobal.send(JSON.stringify({
                eventType: eventType,
                event: event,
                view: view
            }));
        }
    };
}
function $f0aff45a57046ce0$export$c3d8d1f8445a3630(capability) {
    var bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(bridge.getCapabilities(), capability);
}
function $f0aff45a57046ce0$export$a8ab916fee43a31b(currentHost) {
    var _a;
    if (currentHost === void 0) currentHost = (_a = (0, $5d1c89bab7298e4d$export$256479dc0cea61c4)().location) === null || _a === void 0 ? void 0 : _a.hostname;
    var bridge = $f0aff45a57046ce0$export$86c8e1e7efd0dfc1();
    return !!bridge && bridge.getAllowedWebViewHosts().some(function(allowedHost) {
        return currentHost === allowedHost || (0, $b287859a2cd2eacd$export$10fdab3683b55b22)(currentHost, ".".concat(allowedHost));
    });
}
function $f0aff45a57046ce0$var$getEventBridgeGlobal() {
    return (0, $5d1c89bab7298e4d$export$256479dc0cea61c4)().DatadogEventBridge;
}






function $23e9a88fc9385609$export$f00f71a511cb3cac(targetPrototype, method, onPreCall, _a) {
    var _b = _a === void 0 ? {} : _a, computeHandlingStack = _b.computeHandlingStack;
    var original = targetPrototype[method];
    if (typeof original !== 'function') {
        if (method in targetPrototype && (0, $b287859a2cd2eacd$export$68326237475e9a7d)(method, 'on')) original = (0, $772566d0dfa3645c$export$8793edee2d425525);
        else return {
            stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
        };
    }
    var stopped = false;
    var instrumentation = function() {
        if (stopped) // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return original.apply(this, arguments);
        var parameters = (0, $b287859a2cd2eacd$export$b1a47efd00197c76)(arguments);
        var postCallCallback;
        (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function(callback) {
                    postCallCallback = callback;
                },
                handlingStack: computeHandlingStack ? (0, $4ac782ea9e4e9601$export$46c2cbbc853cd95b)() : undefined
            }
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        var result = original.apply(this, parameters);
        if (postCallCallback) (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(postCallCallback, null, [
            result
        ]);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
    targetPrototype[method] = instrumentation;
    return {
        stop: function() {
            stopped = true;
            // If the instrumentation has been removed by a third party, keep the last one
            if (targetPrototype[method] === instrumentation) targetPrototype[method] = original;
        }
    };
}
function $23e9a88fc9385609$export$2a2b9a3e88aa9011(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) return {
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var stoppedInstrumentation = (0, $772566d0dfa3645c$export$8793edee2d425525);
    var instrumentation = function(target, value) {
        // put hooked setter into event loop to avoid of set latency
        (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
            if (instrumentation !== stoppedInstrumentation) after(target, value);
        }, 0);
    };
    var instrumentationWrapper = function(value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper
    });
    return {
        stop: function() {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
            instrumentation = stoppedInstrumentation;
        }
    };
}







function $8af9b5626c1bb968$export$6535eb414fa2c8b6(url) {
    return $8af9b5626c1bb968$export$b5cd97dee32de81d(url, location.href).href;
}
function $8af9b5626c1bb968$export$bef94a5618bf18bf(url) {
    try {
        return !!$8af9b5626c1bb968$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $8af9b5626c1bb968$export$ba1b94ff70383687(url) {
    var pathname = $8af9b5626c1bb968$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function $8af9b5626c1bb968$export$b5cd97dee32de81d(url, base) {
    var supportedURL = $8af9b5626c1bb968$var$getSupportedUrl();
    if (supportedURL) try {
        return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
        throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0, $169208b8dc904506$export$1f8609334739c2b6)({
            url: url,
            base: base
        })));
    }
    if (base === undefined && !/:/.test(url)) throw new Error("Invalid URL: '".concat(url, "'"));
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var $8af9b5626c1bb968$var$originalURL = URL;
var $8af9b5626c1bb968$var$isURLSupported;
function $8af9b5626c1bb968$var$getSupportedUrl() {
    if ($8af9b5626c1bb968$var$isURLSupported === undefined) try {
        var url = new $8af9b5626c1bb968$var$originalURL('http://test/path');
        $8af9b5626c1bb968$var$isURLSupported = url.href === 'http://test/path';
    } catch (_a) {
        $8af9b5626c1bb968$var$isURLSupported = false;
    }
    return $8af9b5626c1bb968$var$isURLSupported ? $8af9b5626c1bb968$var$originalURL : undefined;
}


var $fc27ff42b956d16d$var$fetchObservable;
function $fc27ff42b956d16d$export$68d940e9b7f5282c() {
    if (!$fc27ff42b956d16d$var$fetchObservable) $fc27ff42b956d16d$var$fetchObservable = $fc27ff42b956d16d$var$createFetchObservable();
    return $fc27ff42b956d16d$var$fetchObservable;
}
function $fc27ff42b956d16d$export$81ee928f11655c0c() {
    $fc27ff42b956d16d$var$fetchObservable = undefined;
}
function $fc27ff42b956d16d$var$createFetchObservable() {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        if (!window.fetch) return;
        var stop = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(window, 'fetch', function(call) {
            return $fc27ff42b956d16d$var$beforeSend(call, observable);
        }, {
            computeHandlingStack: true
        }).stop;
        return stop;
    });
}
function $fc27ff42b956d16d$var$beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall, handlingStack = _a.handlingStack;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) methodFromParams = input.method;
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    var url = input instanceof Request ? input.url : (0, $8af9b5626c1bb968$export$6535eb414fa2c8b6)(String(input));
    var startClocks = (0, $fafd178883cb17fc$export$67898643147706d3)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
        handlingStack: handlingStack
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function(responsePromise) {
        return $fc27ff42b956d16d$var$afterSend(observable, responsePromise, context);
    });
}
function $fc27ff42b956d16d$var$afterSend(observable, responsePromise, startContext) {
    var context = startContext;
    function reportFetch(partialContext) {
        context.state = 'resolve';
        (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(context, partialContext);
        observable.notify(context);
    }
    responsePromise.then((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(response) {
        reportFetch({
            response: response,
            responseType: response.type,
            status: response.status,
            isAborted: false
        });
    }), (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(error) {
        var _a, _b;
        reportFetch({
            status: 0,
            isAborted: ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || error instanceof DOMException && error.code === DOMException.ABORT_ERR,
            error: error
        });
    }));
}




function $31fa799c5ed9e680$export$110700823644f4a6(name, value, expireDelay, options) {
    if (expireDelay === void 0) expireDelay = 0;
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    var partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function $31fa799c5ed9e680$export$4be65e66cfa2648a(name) {
    return (0, $01b8047924249a5c$export$fe87bb5193f3e70)(document.cookie, name);
}
var $31fa799c5ed9e680$var$initCookieParsed;
function $31fa799c5ed9e680$export$379e6c34a14280ba(name) {
    if (!$31fa799c5ed9e680$var$initCookieParsed) $31fa799c5ed9e680$var$initCookieParsed = (0, $01b8047924249a5c$export$58032b923d63748e)(document.cookie);
    return $31fa799c5ed9e680$var$initCookieParsed.get(name);
}
function $31fa799c5ed9e680$export$c97a852288b43516() {
    $31fa799c5ed9e680$var$initCookieParsed = undefined;
}
function $31fa799c5ed9e680$export$b43e45590305ffaa(name, options) {
    $31fa799c5ed9e680$export$110700823644f4a6(name, '', 0, options);
}
function $31fa799c5ed9e680$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, $01b8047924249a5c$export$e73c8bd0f20705a)());
        var testCookieValue = 'test';
        $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $fafd178883cb17fc$export$35acaebf644db34e), options);
        var isCookieCorrectlySet = $31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
        $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, options);
        return isCookieCorrectlySet;
    } catch (error) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ var $31fa799c5ed9e680$var$getCurrentSiteCache;
function $31fa799c5ed9e680$export$8d7fb5ac3c42095() {
    if ($31fa799c5ed9e680$var$getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, $01b8047924249a5c$export$e73c8bd0f20705a)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while(domainLevels.length && !$31fa799c5ed9e680$export$4be65e66cfa2648a(testCookieName)){
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            $31fa799c5ed9e680$export$110700823644f4a6(testCookieName, testCookieValue, (0, $fafd178883cb17fc$export$32c0454ceff7f92d), {
                domain: candidateDomain
            });
        }
        $31fa799c5ed9e680$export$b43e45590305ffaa(testCookieName, {
            domain: candidateDomain
        });
        $31fa799c5ed9e680$var$getCurrentSiteCache = candidateDomain;
    }
    return $31fa799c5ed9e680$var$getCurrentSiteCache;
}


var $a9d5c9dbe5afd19a$export$ef391ea72457ea48 = 'datadog-synthetics-public-id';
var $a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9 = 'datadog-synthetics-result-id';
var $a9d5c9dbe5afd19a$export$c8a0c5680e097130 = 'datadog-synthetics-injects-rum';
function $a9d5c9dbe5afd19a$export$749ed8af36cd25e0() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($a9d5c9dbe5afd19a$export$c8a0c5680e097130));
}
function $a9d5c9dbe5afd19a$export$8ea5b4a47d6660d5() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($a9d5c9dbe5afd19a$export$ef391ea72457ea48);
    return typeof value === 'string' ? value : undefined;
}
function $a9d5c9dbe5afd19a$export$75da4270a596d87b() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($a9d5c9dbe5afd19a$export$a2c8b6e1d6d69dc9);
    return typeof value === 'string' ? value : undefined;
}
















function $3d758b2023765aca$export$7e7b1a9668aaed8() {
    return $3d758b2023765aca$var$detectBrowserCached() === 0 /* Browser.IE */ ;
}
function $3d758b2023765aca$export$dd401a4677e99039() {
    return $3d758b2023765aca$var$detectBrowserCached() === 1 /* Browser.CHROMIUM */ ;
}
function $3d758b2023765aca$export$95df08bae54cb4df() {
    return $3d758b2023765aca$var$detectBrowserCached() === 2 /* Browser.SAFARI */ ;
}
var $3d758b2023765aca$var$browserCache;
function $3d758b2023765aca$var$detectBrowserCached() {
    return $3d758b2023765aca$var$browserCache !== null && $3d758b2023765aca$var$browserCache !== void 0 ? $3d758b2023765aca$var$browserCache : $3d758b2023765aca$var$browserCache = $3d758b2023765aca$export$2d31490a0c05f094();
}
function $3d758b2023765aca$export$2d31490a0c05f094(browserWindow) {
    var _a;
    if (browserWindow === void 0) browserWindow = window;
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) return 1 /* Browser.CHROMIUM */ ;
    if (// navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) return 2 /* Browser.SAFARI */ ;
    if (browserWindow.document.documentMode) return 0 /* Browser.IE */ ;
    return 3 /* Browser.OTHER */ ;
}





var $b8836af4b2ff7971$export$dce9f2ddeb0efe71 = '_dd_s';








var $407be9496e601c3b$export$324def7afe89d7e8 = 4 * (0, $fafd178883cb17fc$export$82541edf19e5e3b0);
var $407be9496e601c3b$export$481fdd126dba0912 = 15 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
var $407be9496e601c3b$export$39360b0e14efae23 = (0, $fafd178883cb17fc$export$99cafda57477293d);
var $407be9496e601c3b$export$6b08240aba869f7e = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'local-storage'
};


var $ed47376b15a39472$export$d79faf935ae6abec = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var $ed47376b15a39472$export$92d973d0376798f5 = '&';
function $ed47376b15a39472$export$1a6351cc7f3c5cc8(sessionString) {
    return !!sessionString && (sessionString.indexOf($ed47376b15a39472$export$92d973d0376798f5) !== -1 || $ed47376b15a39472$export$d79faf935ae6abec.test(sessionString));
}


var $3dc0019fbfe25134$export$4fdc68be9dc4d6b5 = '1';
function $3dc0019fbfe25134$export$551e7155381c0fd(previousSessionState) {
    var expiredSessionState = {
        isExpired: $3dc0019fbfe25134$export$4fdc68be9dc4d6b5
    };
    if ((0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).ANONYMOUS_USER_TRACKING)) {
        if (previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId) expiredSessionState.anonymousId = previousSessionState === null || previousSessionState === void 0 ? void 0 : previousSessionState.anonymousId;
        else expiredSessionState.anonymousId = (0, $c75d7197f8114000$export$e8675f0f57a60e5b)();
    }
    return expiredSessionState;
}
function $3dc0019fbfe25134$export$5ad8724e83865c4(session) {
    return (0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(session);
}
function $3dc0019fbfe25134$export$9fbe93df7546a09b(session) {
    return !$3dc0019fbfe25134$export$5ad8724e83865c4(session);
}
function $3dc0019fbfe25134$export$7b5aaa833707368f(session) {
    return session.isExpired !== undefined || !$3dc0019fbfe25134$var$isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function $3dc0019fbfe25134$var$isActiveSession(sessionState) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return (sessionState.created === undefined || (0, $fafd178883cb17fc$export$ceae11818251d43c)() - Number(sessionState.created) < (0, $407be9496e601c3b$export$324def7afe89d7e8)) && (sessionState.expire === undefined || (0, $fafd178883cb17fc$export$ceae11818251d43c)() < Number(sessionState.expire));
}
function $3dc0019fbfe25134$export$112e1a1467f7ca28(session) {
    session.expire = String((0, $fafd178883cb17fc$export$ceae11818251d43c)() + (0, $407be9496e601c3b$export$481fdd126dba0912));
}
function $3dc0019fbfe25134$export$df489f56daf61eef(session) {
    return (0, $b287859a2cd2eacd$export$6a29ade99f81ec8a)(session)// we use `aid` as a key for anonymousId
    .map(function(_a) {
        var key = _a[0], value = _a[1];
        return key === 'anonymousId' ? "aid=".concat(value) : "".concat(key, "=").concat(value);
    }).join((0, $ed47376b15a39472$export$92d973d0376798f5));
}
function $3dc0019fbfe25134$export$fa3c08092be8a0e4(sessionString) {
    var session = {};
    if ((0, $ed47376b15a39472$export$1a6351cc7f3c5cc8)(sessionString)) sessionString.split((0, $ed47376b15a39472$export$92d973d0376798f5)).forEach(function(entry) {
        var matches = (0, $ed47376b15a39472$export$d79faf935ae6abec).exec(entry);
        if (matches !== null) {
            var key = matches[1], value = matches[2];
            if (key === 'aid') // we use `aid` as a key for anonymousId
            session.anonymousId = value;
            else session[key] = value;
        }
    });
    return session;
}


var $35fd447a749f50ce$export$9b0bbb4e1ef88c6d = '_dd';
var $35fd447a749f50ce$export$4231281e64250ad5 = '_dd_r';
var $35fd447a749f50ce$export$381d62e3ee200c01 = '_dd_l';
var $35fd447a749f50ce$export$50ae25e0cd1ada34 = 'rum';
var $35fd447a749f50ce$export$c47fdbea9837fd34 = 'logs';
function $35fd447a749f50ce$export$308239c26bbf40d4(cookieStoreStrategy) {
    var sessionString = (0, $31fa799c5ed9e680$export$379e6c34a14280ba)((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71));
    if (!sessionString) {
        var oldSessionId = (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($35fd447a749f50ce$export$9b0bbb4e1ef88c6d);
        var oldRumType = (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($35fd447a749f50ce$export$4231281e64250ad5);
        var oldLogsType = (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($35fd447a749f50ce$export$381d62e3ee200c01);
        var session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$35fd447a749f50ce$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$35fd447a749f50ce$export$50ae25e0cd1ada34] = oldRumType;
        if ((0, $3dc0019fbfe25134$export$9fbe93df7546a09b)(session)) {
            (0, $3dc0019fbfe25134$export$112e1a1467f7ca28)(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}





function $d814349331ade12d$export$88fc2ec23ae4ccfd(initConfiguration) {
    var cookieOptions = $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration);
    return (0, $31fa799c5ed9e680$export$29b13dee24cadcda)(cookieOptions) ? {
        type: (0, $407be9496e601c3b$export$6b08240aba869f7e).COOKIE,
        cookieOptions: cookieOptions
    } : undefined;
}
function $d814349331ade12d$export$96a0082cb9ded337(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */ isLockEnabled: (0, $3d758b2023765aca$export$dd401a4677e99039)(),
        persistSession: $d814349331ade12d$var$persistSessionCookie(cookieOptions),
        retrieveSession: $d814349331ade12d$var$retrieveSessionCookie,
        expireSession: function(sessionState) {
            return $d814349331ade12d$var$expireSessionCookie(cookieOptions, sessionState);
        }
    };
    (0, $35fd447a749f50ce$export$308239c26bbf40d4)(cookieStore);
    return cookieStore;
}
function $d814349331ade12d$var$persistSessionCookie(options) {
    return function(session) {
        (0, $31fa799c5ed9e680$export$110700823644f4a6)((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71), (0, $3dc0019fbfe25134$export$df489f56daf61eef)(session), (0, $407be9496e601c3b$export$481fdd126dba0912), options);
    };
}
function $d814349331ade12d$var$expireSessionCookie(options, sessionState) {
    var expiredSessionState = (0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionState);
    (0, $31fa799c5ed9e680$export$110700823644f4a6)((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71), (0, $3dc0019fbfe25134$export$df489f56daf61eef)(expiredSessionState), (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).ANONYMOUS_USER_TRACKING) ? (0, $407be9496e601c3b$export$39360b0e14efae23) : (0, $407be9496e601c3b$export$324def7afe89d7e8), options);
}
function $d814349331ade12d$var$retrieveSessionCookie() {
    var sessionString = (0, $31fa799c5ed9e680$export$4be65e66cfa2648a)((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71));
    var sessionState = (0, $3dc0019fbfe25134$export$fa3c08092be8a0e4)(sessionString);
    return sessionState;
}
function $d814349331ade12d$export$d037e740f60b1dc5(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) cookieOptions.domain = (0, $31fa799c5ed9e680$export$8d7fb5ac3c42095)();
    return cookieOptions;
}







var $1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function $1832aa7f8f61a7ea$export$4d20c6f83e85c567() {
    try {
        var id = (0, $01b8047924249a5c$export$e73c8bd0f20705a)();
        var testKey = "".concat($1832aa7f8f61a7ea$var$LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? {
            type: (0, $407be9496e601c3b$export$6b08240aba869f7e).LOCAL_STORAGE
        } : undefined;
    } catch (_a) {
        return undefined;
    }
}
function $1832aa7f8f61a7ea$export$f96a432ca80663c2() {
    return {
        isLockEnabled: false,
        persistSession: $1832aa7f8f61a7ea$var$persistInLocalStorage,
        retrieveSession: $1832aa7f8f61a7ea$var$retrieveSessionFromLocalStorage,
        expireSession: $1832aa7f8f61a7ea$var$expireSessionFromLocalStorage
    };
}
function $1832aa7f8f61a7ea$var$persistInLocalStorage(sessionState) {
    localStorage.setItem((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71), (0, $3dc0019fbfe25134$export$df489f56daf61eef)(sessionState));
}
function $1832aa7f8f61a7ea$var$retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem((0, $b8836af4b2ff7971$export$dce9f2ddeb0efe71));
    return (0, $3dc0019fbfe25134$export$fa3c08092be8a0e4)(sessionString);
}
function $1832aa7f8f61a7ea$var$expireSessionFromLocalStorage(previousSessionState) {
    $1832aa7f8f61a7ea$var$persistInLocalStorage((0, $3dc0019fbfe25134$export$551e7155381c0fd)(previousSessionState));
}






var $02d7be7ae3d08a12$export$af5f677cffbf8829 = 10;
var $02d7be7ae3d08a12$export$63e0e5fbdb17b26 = 100;
var $02d7be7ae3d08a12$var$bufferedOperations = [];
var $02d7be7ae3d08a12$var$ongoingOperations;
function $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) numberOfRetries = 0;
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, persistSession = sessionStoreStrategy.persistSession, expireSession = sessionStoreStrategy.expireSession;
    var persistWithLock = function(session) {
        return persistSession((0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, session, {
            lock: currentLock
        }));
    };
    var retrieveStore = function() {
        var session = sessionStoreStrategy.retrieveSession();
        var lock = session.lock;
        if (session.lock) delete session.lock;
        return {
            session: session,
            lock: lock
        };
    };
    if (!$02d7be7ae3d08a12$var$ongoingOperations) $02d7be7ae3d08a12$var$ongoingOperations = operations;
    if (operations !== $02d7be7ae3d08a12$var$ongoingOperations) {
        $02d7be7ae3d08a12$var$bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= $02d7be7ae3d08a12$export$63e0e5fbdb17b26) {
        $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentStore = retrieveStore();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentStore.lock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0, $01b8047924249a5c$export$e73c8bd0f20705a)();
        persistWithLock(currentStore.session);
        // if lock is not acquired, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentStore.session);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentStore = retrieveStore();
        if (currentStore.lock !== currentLock) {
            $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if ((0, $3dc0019fbfe25134$export$7b5aaa833707368f)(processedSession)) expireSession(processedSession);
        else {
            (0, $3dc0019fbfe25134$export$112e1a1467f7ca28)(processedSession);
            if (isLockEnabled) persistWithLock(processedSession);
            else persistSession(processedSession);
        }
    }
    if (isLockEnabled) // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    {
        if (!(processedSession && (0, $3dc0019fbfe25134$export$7b5aaa833707368f)(processedSession))) {
            // if lock corrupted after persist, retry later
            currentStore = retrieveStore();
            if (currentStore.lock !== currentLock) {
                $02d7be7ae3d08a12$var$retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            persistSession(currentStore.session);
            processedSession = currentStore.session;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 || _a.call(operations, processedSession || currentStore.session);
    $02d7be7ae3d08a12$var$next(sessionStoreStrategy);
}
function $02d7be7ae3d08a12$var$retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
        $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(operations, sessionStore, currentNumberOfRetries + 1);
    }, $02d7be7ae3d08a12$export$af5f677cffbf8829);
}
function $02d7be7ae3d08a12$var$next(sessionStore) {
    $02d7be7ae3d08a12$var$ongoingOperations = undefined;
    var nextOperations = $02d7be7ae3d08a12$var$bufferedOperations.shift();
    if (nextOperations) $02d7be7ae3d08a12$export$5efeffeb1c7b84cb(nextOperations, sessionStore);
}



var $70fa419824414645$export$97790393ff416f6c = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $70fa419824414645$export$2ae22598cc9269e0(initConfiguration) {
    switch(initConfiguration.sessionPersistence){
        case (0, $407be9496e601c3b$export$6b08240aba869f7e).COOKIE:
            return (0, $d814349331ade12d$export$88fc2ec23ae4ccfd)(initConfiguration);
        case (0, $407be9496e601c3b$export$6b08240aba869f7e).LOCAL_STORAGE:
            return (0, $1832aa7f8f61a7ea$export$4d20c6f83e85c567)();
        case undefined:
            var sessionStoreStrategyType = (0, $d814349331ade12d$export$88fc2ec23ae4ccfd)(initConfiguration);
            if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) sessionStoreStrategyType = (0, $1832aa7f8f61a7ea$export$4d20c6f83e85c567)();
            return sessionStoreStrategyType;
        default:
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("Invalid session persistence '".concat(String(initConfiguration.sessionPersistence), "'"));
    }
}
function $70fa419824414645$export$99eabf0f32a21670(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var expireObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var sessionStateUpdateObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var sessionStoreStrategy = sessionStoreStrategyType.type === (0, $407be9496e601c3b$export$6b08240aba869f7e).COOKIE ? (0, $d814349331ade12d$export$96a0082cb9ded337)(sessionStoreStrategyType.cookieOptions) : (0, $1832aa7f8f61a7ea$export$f96a432ca80663c2)();
    var expireSession = sessionStoreStrategy.expireSession;
    var watchSessionTimeoutId = (0, $02784b622c768a70$export$cda6c73645970615)(watchSession, $70fa419824414645$export$97790393ff416f6c);
    var sessionCache;
    startSession();
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function() {
        (0, $02d7be7ae3d08a12$export$5efeffeb1c7b84cb)({
            process: function(sessionState) {
                if ((0, $3dc0019fbfe25134$export$5ad8724e83865c4)(sessionState)) return;
                var synchronizedSession = synchronizeSession(sessionState);
                expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function(sessionState) {
                if ((0, $3dc0019fbfe25134$export$9fbe93df7546a09b)(sessionState) && !hasSessionInCache()) renewSessionInCache(sessionState);
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }, $70fa419824414645$export$97790393ff416f6c), throttledExpandOrRenewSession = _a.throttled, cancelExpandOrRenewSession = _a.cancel;
    function expandSession() {
        (0, $02d7be7ae3d08a12$export$5efeffeb1c7b84cb)({
            process: function(sessionState) {
                return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
            }
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */ function watchSession() {
        (0, $02d7be7ae3d08a12$export$5efeffeb1c7b84cb)({
            process: function(sessionState) {
                return (0, $3dc0019fbfe25134$export$7b5aaa833707368f)(sessionState) ? (0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionState) : undefined;
            },
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if ((0, $3dc0019fbfe25134$export$7b5aaa833707368f)(sessionState)) sessionState = (0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionState);
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) expireSessionInCache();
            else {
                sessionStateUpdateObservable.notify({
                    previousState: sessionCache,
                    newState: sessionState
                });
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function startSession() {
        (0, $02d7be7ae3d08a12$export$5efeffeb1c7b84cb)({
            process: function(sessionState) {
                if ((0, $3dc0019fbfe25134$export$5ad8724e83865c4)(sessionState)) return (0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionState);
            },
            after: function(sessionState) {
                sessionCache = sessionState;
            }
        }, sessionStoreStrategy);
    }
    function expandOrRenewSessionState(sessionState) {
        if ((0, $3dc0019fbfe25134$export$5ad8724e83865c4)(sessionState)) return false;
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        delete sessionState.isExpired;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0, $01b8047924249a5c$export$e73c8bd0f20705a)();
            sessionState.created = String((0, $fafd178883cb17fc$export$ceae11818251d43c)());
        }
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = (0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionCache);
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function updateSessionState(partialSessionState) {
        (0, $02d7be7ae3d08a12$export$5efeffeb1c7b84cb)({
            process: function(sessionState) {
                return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, sessionState, partialSessionState);
            },
            after: synchronizeSession
        }, sessionStoreStrategy);
    }
    return {
        expandOrRenewSession: throttledExpandOrRenewSession,
        expandSession: expandSession,
        getSession: function() {
            return sessionCache;
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStateUpdateObservable,
        restartSession: startSession,
        expire: function() {
            cancelExpandOrRenewSession();
            expireSession(sessionCache);
            synchronizeSession((0, $3dc0019fbfe25134$export$551e7155381c0fd)(sessionCache));
        },
        stop: function() {
            (0, $02784b622c768a70$export$5c0dc72231454d02)(watchSessionTimeoutId);
        },
        updateSessionState: updateSessionState
    };
}








function $f9b945dd035d2e49$export$b84621d9b3dd3f17(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function(api, payload) {
            var parameters = $f9b945dd035d2e49$var$buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        trackType: trackType
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */ function $f9b945dd035d2e49$var$createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        var normalizedProxyUrl_1 = (0, $8af9b5626c1bb968$export$6535eb414fa2c8b6)(proxy);
        return function(parameters) {
            return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
        };
    }
    if (typeof proxy === 'function') return function(parameters) {
        return proxy({
            path: path,
            parameters: parameters
        });
    };
    var host = $f9b945dd035d2e49$var$buildEndpointHost(trackType, initConfiguration);
    return function(parameters) {
        return "https://".concat(host).concat(path, "?").concat(parameters);
    };
}
function $f9b945dd035d2e49$var$buildEndpointHost(trackType, initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? (0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a) : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (trackType === 'logs' && initConfiguration.usePciIntake && site === (0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a)) return 0, $77d3907623da03fc$export$e02f42b31d885a8c;
    if (internalAnalyticsSubdomain && site === (0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a)) return "".concat(internalAnalyticsSubdomain, ".").concat((0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a));
    if (site === (0, $77d3907623da03fc$export$62cc10d94d5ff7fd)) return "http-intake.logs.".concat(site);
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */ function $f9b945dd035d2e49$var$buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, encoding = _b.encoding;
    var tags = [
        "sdk_version:".concat("5.35.1"),
        "api:".concat(api)
    ].concat(configurationTags);
    if (retry) tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.35.1")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0, $01b8047924249a5c$export$e73c8bd0f20705a)())
    ];
    if (encoding) parameters.push("dd-evp-encoding=".concat(encoding));
    if (trackType === 'rum') parameters.push("batch_time=".concat((0, $fafd178883cb17fc$export$71f52cdbbf629086)()));
    if (internalAnalyticsSubdomain) parameters.reverse();
    return parameters.join('&');
}



var $3f7cfdc5e4c726ca$export$4f41fac0b8471c73 = 200;
function $3f7cfdc5e4c726ca$export$ebabee42db672bb6(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2('env', env));
    if (service) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2('service', service));
    if (version) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2('version', version));
    if (datacenter) tags.push($3f7cfdc5e4c726ca$export$4478cda40be33ba2('datacenter', datacenter));
    return tags;
}
function $3f7cfdc5e4c726ca$export$4478cda40be33ba2(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = $3f7cfdc5e4c726ca$export$4f41fac0b8471c73 - key.length - 1;
    if (rawValue.length > valueSizeLimit || $3f7cfdc5e4c726ca$var$hasForbiddenCharacters(rawValue)) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. ").concat((0, $429fd8a62f4aa1b2$export$69ce01f6d41ea86c), " ").concat((0, $429fd8a62f4aa1b2$export$61b69f86bb46c85e), "/getting_started/tagging/#defining-tags"));
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
function $3f7cfdc5e4c726ca$var$hasForbiddenCharacters(rawValue) {
    // Unicode property escapes is not supported in all browsers, so we use a try/catch.
    // Todo: Remove the try/catch when dropping IE11.
    if (!$3f7cfdc5e4c726ca$export$a8efa6d27d175125()) return false;
    // We use the Unicode property escapes to match any character that is a letter including other languages like Chinese, Japanese, etc.
    // p{Ll} matches a lowercase letter.
    // p{Lo} matches a letter that is neither uppercase nor lowercase (ex: Japanese characters).
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape#unicode_property_escapes_vs._character_classes
    return new RegExp('[^\\p{Ll}\\p{Lo}0-9_:./-]', 'u').test(rawValue);
}
function $3f7cfdc5e4c726ca$export$a8efa6d27d175125() {
    try {
        new RegExp('[\\p{Ll}]', 'u');
        return true;
    } catch (_a) {
        return false;
    }
}



function $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6(initConfiguration) {
    var site = initConfiguration.site || (0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a);
    var tags = (0, $3f7cfdc5e4c726ca$export$ebabee42db672bb6)(initConfiguration);
    var endpointBuilders = $57fc5f00ec8e4fc6$var$computeEndpointBuilders(initConfiguration, tags);
    var replicaConfiguration = $57fc5f00ec8e4fc6$var$computeReplicaConfiguration(initConfiguration, tags);
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        replica: replicaConfiguration,
        site: site
    }, endpointBuilders);
}
function $57fc5f00ec8e4fc6$var$computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, $f9b945dd035d2e49$export$b84621d9b3dd3f17)(initConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, $f9b945dd035d2e49$export$b84621d9b3dd3f17)(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: (0, $f9b945dd035d2e49$export$b84621d9b3dd3f17)(initConfiguration, 'replay', tags)
    };
}
function $57fc5f00ec8e4fc6$var$computeReplicaConfiguration(initConfiguration, tags) {
    if (!initConfiguration.replica) return;
    var replicaConfiguration = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, initConfiguration, {
        site: (0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a),
        clientToken: initConfiguration.replica.clientToken
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, $f9b945dd035d2e49$export$b84621d9b3dd3f17)(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, $f9b945dd035d2e49$export$b84621d9b3dd3f17)(replicaConfiguration, 'rum', tags)
    };
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        applicationId: initConfiguration.replica.applicationId
    }, replicaEndpointBuilders);
}
function $57fc5f00ec8e4fc6$export$8f53a704ec1860b3(url) {
    // check if tags is present in the query string
    return (0, $77d3907623da03fc$export$e36b5f83de28fc8a).every(function(param) {
        return (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(url, param);
    });
}


var $54fbdcf742061e48$export$e8c12a778f5ad67c = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input'
};
var $54fbdcf742061e48$export$d060b603b6f9a5d5 = {
    ALL: 'all',
    SAMPLED: 'sampled'
};
function $54fbdcf742061e48$var$isString(tag, tagName) {
    if (tag !== undefined && tag !== null && typeof tag !== 'string') {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(tagName, " must be defined as a string"));
        return false;
    }
    return true;
}
function $54fbdcf742061e48$var$isDatadogSite(site) {
    if (site && typeof site === 'string' && !/(datadog|ddog|datad0g|dd0g)/.test(site)) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("Site should be a valid Datadog site. ".concat((0, $429fd8a62f4aa1b2$export$69ce01f6d41ea86c), " ").concat((0, $429fd8a62f4aa1b2$export$61b69f86bb46c85e), "/getting_started/site/."));
        return false;
    }
    return true;
}
function $54fbdcf742061e48$export$341d55b7c3150b7f(sampleRate, name) {
    if (sampleRate !== undefined && !(0, $89f5cd41be2839b1$export$d86432a85610ea90)(sampleRate)) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(name, " Sample Rate should be a number between 0 and 100"));
        return false;
    }
    return true;
}
function $54fbdcf742061e48$export$bb3dd6b9741fea90(initConfiguration) {
    var _a, _b, _c, _d, _e;
    if (!initConfiguration || !initConfiguration.clientToken) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (!$54fbdcf742061e48$var$isDatadogSite(initConfiguration.site) || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.sessionSampleRate, 'Session') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetrySampleRate, 'Telemetry') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetryConfigurationSampleRate, 'Telemetry Configuration') || !$54fbdcf742061e48$export$341d55b7c3150b7f(initConfiguration.telemetryUsageSampleRate, 'Telemetry Usage') || !$54fbdcf742061e48$var$isString(initConfiguration.version, 'Version') || !$54fbdcf742061e48$var$isString(initConfiguration.env, 'Env') || !$54fbdcf742061e48$var$isString(initConfiguration.service, 'Service')) return;
    if (initConfiguration.trackingConsent !== undefined && !(0, $66d1b7fd2da44c06$export$783ef1184b4cd483)((0, $69f3116f372ada5b$export$52745dd8ee2d32b2), initConfiguration.trackingConsent)) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        beforeSend: initConfiguration.beforeSend && (0, $1227ac9fbf79b35b$export$a7d71543eda007d0)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0, $70fa419824414645$export$2ae22598cc9269e0)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
        service: initConfiguration.service || undefined,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : (0, $69f3116f372ada5b$export$52745dd8ee2d32b2).GRANTED,
        storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */ batchBytesLimit: 16 * (0, $5baf81a8b4674c85$export$756c3d65870c899e),
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */ flushTimeout: 30 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d),
        /**
         * Logs intake limit
         */ batchMessagesLimit: 50,
        messageBytesLimit: 256 * (0, $5baf81a8b4674c85$export$756c3d65870c899e)
    }, (0, $57fc5f00ec8e4fc6$export$2cf2d9e8f31925e6)(initConfiguration));
}
function $54fbdcf742061e48$export$948cb0730656da11(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        session_persistence: initConfiguration.sessionPersistence,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
        tracking_consent: initConfiguration.trackingConsent
    };
}




function $b56eba7faf105c60$export$b620f5b550eaf484(item) {
    var itemType = (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
function $b56eba7faf105c60$export$eb5a30555469227(list, value, useStartsWith) {
    if (useStartsWith === void 0) useStartsWith = false;
    return list.some(function(item) {
        try {
            if (typeof item === 'function') return item(value);
            else if (item instanceof RegExp) return item.test(value);
            else if (typeof item === 'string') return useStartsWith ? (0, $b287859a2cd2eacd$export$68326237475e9a7d)(value, item) : item === value;
        } catch (e) {
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error(e);
        }
        return false;
    });
}



function $2ed496ab9f146a4c$export$e003cc239f955cb6() {
    // TODO: remove msCrypto when IE11 support is dropped
    return window.crypto || window.msCrypto;
}




function $5c7a0ca9cf77c393$export$d0df1a1c84fa9037() {
    return $5c7a0ca9cf77c393$var$createIdentifier(64);
}
function $5c7a0ca9cf77c393$export$42e322be3a41cf8f() {
    return $5c7a0ca9cf77c393$var$createIdentifier(63);
}
var $5c7a0ca9cf77c393$var$createIdentifierImplementationCache;
function $5c7a0ca9cf77c393$var$createIdentifier(bits) {
    if (!$5c7a0ca9cf77c393$var$createIdentifierImplementationCache) $5c7a0ca9cf77c393$var$createIdentifierImplementationCache = (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).CONSISTENT_TRACE_SAMPLING) && $5c7a0ca9cf77c393$export$bc7a8099f680bf3e() ? $5c7a0ca9cf77c393$var$createIdentifierUsingBigInt : $5c7a0ca9cf77c393$var$createIdentifierUsingUint32Array;
    return $5c7a0ca9cf77c393$var$createIdentifierImplementationCache(bits);
}
function $5c7a0ca9cf77c393$export$bc7a8099f680bf3e() {
    try {
        crypto.getRandomValues(new BigUint64Array(1));
        return true;
    } catch (_a) {
        return false;
    }
}
function $5c7a0ca9cf77c393$var$createIdentifierUsingBigInt(bits) {
    var id = crypto.getRandomValues(new BigUint64Array(1))[0];
    if (bits === 63) // eslint-disable-next-line no-bitwise
    id >>= BigInt('1');
    return id;
}
// TODO: remove this when all browser we support have BigInt support
function $5c7a0ca9cf77c393$var$createIdentifierUsingUint32Array(bits) {
    var buffer = (0, $2ed496ab9f146a4c$export$e003cc239f955cb6)().getRandomValues(new Uint32Array(2));
    if (bits === 63) // eslint-disable-next-line no-bitwise
    buffer[buffer.length - 1] >>>= 1; // force 63-bit
    return {
        toString: function(radix) {
            if (radix === void 0) radix = 10;
            var high = buffer[1];
            var low = buffer[0];
            var str = '';
            do {
                var mod = high % radix * 4294967296 + low;
                high = Math.floor(high / radix);
                low = Math.floor(mod / radix);
                str = (mod % radix).toString(radix) + str;
            }while (high || low);
            return str;
        }
    };
}
function $5c7a0ca9cf77c393$export$8c28a7bcd86c533(id) {
    var traceId = id.toString(16);
    // TODO: replace with String.prototype.padStart when we drop IE11 support
    return Array(17 - traceId.length).join('0') + traceId;
}



function $37b08f7b1ffa2704$export$4c45cc742ba6a286(identifier, sampleRate) {
    // Shortcuts for common cases. This is not strictly necessary, but it makes the code faster for
    // customers willing to ingest all traces.
    if (sampleRate === 100) return true;
    if (sampleRate === 0) return false;
    // For simplicity, we don't use consistent sampling for browser that don't support BigInt
    // TODO: remove this when all browser we support have BigInt support
    if (typeof identifier !== 'bigint') return (0, $89f5cd41be2839b1$export$72c7afebfef3b500)(sampleRate);
    // Offer consistent sampling for the same trace id across different environments. The rule is:
    //
    //   (identifier * knuthFactor) % 2^64 < sampleRate * 2^64
    //
    // Because JavaScript numbers are 64-bit floats, we can't represent 64-bit integers, and the
    // modulo would be incorrect. Thus, we are using BigInts here.
    //
    // Implementation in other languages:
    // * Go     https://github.com/DataDog/dd-trace-go/blob/ec6fbb1f2d517b7b8e69961052adf7136f3af773/ddtrace/tracer/sampler.go#L86-L91
    // * Python https://github.com/DataDog/dd-trace-py/blob/0cee2f066fb6e79aa15947c1514c0f406dea47c5/ddtrace/sampling_rule.py#L197
    // * Ruby   https://github.com/DataDog/dd-trace-rb/blob/1a6e255cdcb7e7e22235ea5955f90f6dfa91045d/lib/datadog/tracing/sampling/rate_sampler.rb#L42
    // * C++    https://github.com/DataDog/dd-trace-cpp/blob/159629edc438ae45f2bb318eb7bd51abd05e94b5/src/datadog/trace_sampler.cpp#L58
    // * Java   https://github.com/DataDog/dd-trace-java/blob/896dd6b380533216e0bdee59614606c8272d313e/dd-trace-core/src/main/java/datadog/trace/common/sampling/DeterministicSampler.java#L48
    //
    // Note: All implementations have slight variations. Some of them use '<=' instead of '<', and
    // use `sampleRate * 2^64 - 1` instead of `sampleRate * 2^64`. The following implementation
    // should adhere to the spec and is a bit simpler than using a 2^64-1 limit as there are less
    // BigInt arithmetic to write. In practice this does not matter, as we are using floating point
    // numbers in the end, and Number(2n**64n-1n) === Number(2n**64n).
    var knuthFactor = BigInt('1111111111111111111');
    var twoPow64 = BigInt('0x10000000000000000'); // 2n ** 64n
    var hash = identifier * knuthFactor % twoPow64;
    return Number(hash) <= sampleRate / 100 * Number(twoPow64);
}


function $2b3f7c5bb3826872$export$5980e9370742a9f1(item) {
    var expectedItem = item;
    return (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(expectedItem) === 'object' && (0, $b56eba7faf105c60$export$b620f5b550eaf484)(expectedItem.match) && Array.isArray(expectedItem.propagatorTypes);
}
function $2b3f7c5bb3826872$export$5fcd137715d2568d(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function $2b3f7c5bb3826872$export$faa83af43a19aa4b(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: $2b3f7c5bb3826872$export$5fcd137715d2568d,
        traceFetch: function(context) {
            return $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, function(tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function(key) {
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                } else {
                    context.init = (0, $66d1b7fd2da44c06$export$370e8311c3cdebd9)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) context.init.headers.forEach(function(value, key) {
                        headers_1.push([
                            key,
                            value
                        ]);
                    });
                    else if (Array.isArray(context.init.headers)) context.init.headers.forEach(function(header) {
                        headers_1.push(header);
                    });
                    else if (context.init.headers) Object.keys(context.init.headers).forEach(function(key) {
                        headers_1.push([
                            key,
                            context.init.headers[key]
                        ]);
                    });
                    context.init.headers = headers_1.concat((0, $b287859a2cd2eacd$export$6a29ade99f81ec8a)(tracingHeaders));
                }
            });
        },
        traceXhr: function(context, xhr) {
            return $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, function(tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function(name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        }
    };
}
function $2b3f7c5bb3826872$var$injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!$2b3f7c5bb3826872$export$fccc3aa05073f942() || !sessionManager.findTrackedSession()) return;
    var tracingOption = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(configuration.allowedTracingUrls, function(tracingOption) {
        return (0, $b56eba7faf105c60$export$eb5a30555469227)([
            tracingOption.match
        ], context.url, true);
    });
    if (!tracingOption) return;
    var traceId = (0, $5c7a0ca9cf77c393$export$d0df1a1c84fa9037)();
    context.traceSampled = (0, $37b08f7b1ffa2704$export$4c45cc742ba6a286)(traceId, configuration.traceSampleRate);
    var shouldInjectHeaders = context.traceSampled || configuration.traceContextInjection === (0, $54fbdcf742061e48$export$d060b603b6f9a5d5).ALL;
    if (!shouldInjectHeaders) return;
    context.traceId = traceId;
    context.spanId = (0, $5c7a0ca9cf77c393$export$42e322be3a41cf8f)();
    inject($2b3f7c5bb3826872$var$makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function $2b3f7c5bb3826872$export$fccc3aa05073f942() {
    return (0, $2ed496ab9f146a4c$export$e003cc239f955cb6)() !== undefined;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */ function $2b3f7c5bb3826872$var$makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function(propagatorType) {
        switch(propagatorType){
            case 'datadog':
                (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toString()
                });
                break;
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext':
                (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat((0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(traceId), "-").concat((0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(spanId), "-0").concat(traceSampled ? '1' : '0')
                });
                break;
            // https://github.com/openzipkin/b3-propagation
            case 'b3':
                (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(tracingHeaders, {
                    b3: "".concat((0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(traceId), "-").concat((0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(spanId), "-").concat(traceSampled ? '1' : '0')
                });
                break;
            case 'b3multi':
                (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(tracingHeaders, {
                    'X-B3-TraceId': (0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(traceId),
                    'X-B3-SpanId': (0, $5c7a0ca9cf77c393$export$8c28a7bcd86c533)(spanId),
                    'X-B3-Sampled': traceSampled ? '1' : '0'
                });
                break;
        }
    });
    return tracingHeaders;
}


var $a285eb8854056411$export$6fcd8876d4ab74f5 = [
    'tracecontext',
    'datadog'
];
function $a285eb8854056411$export$4f016a753eca1880(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration.applicationId) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (!(0, $54fbdcf742061e48$export$341d55b7c3150b7f)(initConfiguration.sessionReplaySampleRate, 'Session Replay') || !(0, $54fbdcf742061e48$export$341d55b7c3150b7f)(initConfiguration.traceSampleRate, 'Trace')) return;
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = $a285eb8854056411$var$validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) return;
    var baseConfiguration = (0, $54fbdcf742061e48$export$bb3dd6b9741fea90)(initConfiguration);
    if (!baseConfiguration) return;
    var sessionReplaySampleRate = (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0;
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version || undefined,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: sessionReplaySampleRate,
        startSessionReplayRecordingManually: initConfiguration.startSessionReplayRecordingManually !== undefined ? !!initConfiguration.startSessionReplayRecordingManually : sessionReplaySampleRate === 0,
        traceSampleRate: (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : 100,
        rulePsr: (0, $89f5cd41be2839b1$export$7e4aa119212bc614)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : undefined,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_c = initConfiguration.excludedActivityUrls) !== null && _c !== void 0 ? _c : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!initConfiguration.trackUserInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!initConfiguration.trackResources,
        trackLongTasks: !!initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0, $66d1b7fd2da44c06$export$783ef1184b4cd483)((0, $54fbdcf742061e48$export$e8c12a778f5ad67c), initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : (0, $54fbdcf742061e48$export$e8c12a778f5ad67c).MASK,
        enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
        customerDataTelemetrySampleRate: 1,
        traceContextInjection: (0, $66d1b7fd2da44c06$export$783ef1184b4cd483)((0, $54fbdcf742061e48$export$d060b603b6f9a5d5), initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : (0, $54fbdcf742061e48$export$d060b603b6f9a5d5).ALL,
        plugins: initConfiguration.plugins || []
    }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */ function $a285eb8854056411$var$validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls === undefined) return [];
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Allowed Tracing URLs should be an array');
        return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Service needs to be configured when tracing is enabled');
        return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    var tracingOptions = [];
    initConfiguration.allowedTracingUrls.forEach(function(option) {
        if ((0, $b56eba7faf105c60$export$b620f5b550eaf484)(option)) tracingOptions.push({
            match: option,
            propagatorTypes: $a285eb8854056411$export$6fcd8876d4ab74f5
        });
        else if ((0, $2b3f7c5bb3826872$export$5980e9370742a9f1)(option)) tracingOptions.push(option);
        else (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
    });
    return tracingOptions;
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */ function $a285eb8854056411$var$getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) configuration.allowedTracingUrls.forEach(function(option) {
        if ((0, $b56eba7faf105c60$export$b620f5b550eaf484)(option)) $a285eb8854056411$export$6fcd8876d4ab74f5.forEach(function(propagatorType) {
            return usedTracingPropagators.add(propagatorType);
        });
        else if ((0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(option) === 'object' && Array.isArray(option.propagatorTypes)) // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
        option.propagatorTypes.forEach(function(propagatorType) {
            return usedTracingPropagators.add(propagatorType);
        });
    });
    return (0, $b287859a2cd2eacd$export$b1a47efd00197c76)(usedTracingPropagators);
}
function $a285eb8854056411$export$937b8b43e93f9c22(configuration) {
    var _a;
    var baseSerializedConfiguration = (0, $54fbdcf742061e48$export$948cb0730656da11)(configuration);
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        trace_context_injection: configuration.traceContextInjection,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: $a285eb8854056411$var$getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
        plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map(function(plugin) {
            var _a;
            return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
                name: plugin.name
            }, (_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin));
        })
    }, baseSerializedConfiguration);
}



var $02c65ea76566f8d8$export$cf04c7629d25d5bd = 'https://d3uc069fcn7uxw.cloudfront.net/configuration';
function $02c65ea76566f8d8$export$cfd957a7abf0b7b5(initConfiguration, callback) {
    $02c65ea76566f8d8$export$4e57f2d70ec375f7(initConfiguration, function(remoteInitConfiguration) {
        callback($02c65ea76566f8d8$export$8fe2215bb479e811(initConfiguration, remoteInitConfiguration));
    });
}
function $02c65ea76566f8d8$export$8fe2215bb479e811(initConfiguration, remoteInitConfiguration) {
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, initConfiguration, remoteInitConfiguration);
}
function $02c65ea76566f8d8$export$4e57f2d70ec375f7(configuration, callback) {
    var xhr = new XMLHttpRequest();
    (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, xhr, 'load', function() {
        if (xhr.status === 200) callback(JSON.parse(xhr.responseText));
        else $02c65ea76566f8d8$var$displayRemoteConfigurationFetchingError();
    });
    (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, xhr, 'error', function() {
        $02c65ea76566f8d8$var$displayRemoteConfigurationFetchingError();
    });
    xhr.open('GET', "".concat($02c65ea76566f8d8$export$cf04c7629d25d5bd, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json"));
    xhr.send();
}
function $02c65ea76566f8d8$var$displayRemoteConfigurationFetchingError() {
    (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Error fetching the remote configuration.');
}





function $af030ac9e0faa3f9$export$165b46b876b53122(plugins, methodName, parameter) {
    if (!plugins) return;
    for(var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++){
        var plugin = plugins_1[_i];
        var method = plugin[methodName];
        if (method) method(parameter);
    }
}


function $a4b70066dfc326ec$export$8f7002373dcc6602(_a, getCommonContext, trackingConsentState, customVitalsState, doStartRum) {
    var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum, startDeflateWorker = _a.startDeflateWorker;
    var bufferApiCalls = (0, $f330f38d49d59161$export$9724f168e999472b)();
    var firstStartViewCall;
    var deflateWorker;
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) return;
        trackingConsentStateSubscription.unsubscribe();
        var initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) return;
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        var startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    function doInit(initConfiguration) {
        var eventBridgeAvailable = (0, $f0aff45a57046ce0$export$a8ab916fee43a31b)();
        if (eventBridgeAvailable) initConfiguration = $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration);
        // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
        cachedInitConfiguration = initConfiguration;
        (0, $b20e9e3ee3028089$export$d546dcbd09bc447f)((0, $a285eb8854056411$export$937b8b43e93f9c22)(initConfiguration));
        if (cachedConfiguration) {
            (0, $c014cf41d8e6d87d$export$b25c854130ebaef9)('DD_RUM', initConfiguration);
            return;
        }
        var configuration = (0, $a285eb8854056411$export$4f016a753eca1880)(initConfiguration);
        if (!configuration) return;
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn('No storage available for session. We will not send any data.');
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            (0, $772566d0dfa3645c$export$8793edee2d425525));
            if (!deflateWorker) // `startDeflateWorker` should have logged an error message explaining the issue
            return;
        }
        cachedConfiguration = configuration;
        // Instrumuent fetch to track network requests
        // This is needed in case the consent is not granted and some cutsomer
        // library (Apollo Client) is storing uninstrumented fetch to be used later
        // The subscrption is needed so that the instrumentation process is completed
        (0, $fc27ff42b956d16d$export$68d940e9b7f5282c)().subscribe((0, $772566d0dfa3645c$export$8793edee2d425525));
        trackingConsentState.tryToInit(configuration.trackingConsent);
        tryStartRum();
    }
    var addDurationVital = function(vital) {
        bufferApiCalls.add(function(startRumResult) {
            return startRumResult.addDurationVital(vital);
        });
    };
    return {
        init: function(initConfiguration, publicApi) {
            if (!initConfiguration) {
                (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error('Missing configuration');
                return;
            }
            // Set the experimental feature flags as early as possible, so we can use them in most places
            (0, $e967aa36fccc7e29$export$f9d0db67c92b2ab2)(initConfiguration.enableExperimentalFeatures);
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && (0, $a9d5c9dbe5afd19a$export$749ed8af36cd25e0)()) return;
            (0, $af030ac9e0faa3f9$export$165b46b876b53122)(initConfiguration.plugins, 'onInit', {
                initConfiguration: initConfiguration,
                publicApi: publicApi
            });
            if (initConfiguration.remoteConfigurationId && (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).REMOTE_CONFIGURATION)) (0, $02c65ea76566f8d8$export$cfd957a7abf0b7b5)(initConfiguration, doInit);
            else doInit(initConfiguration);
        },
        get initConfiguration () {
            return cachedInitConfiguration;
        },
        getInternalContext: (0, $772566d0dfa3645c$export$8793edee2d425525),
        stopSession: (0, $772566d0dfa3645c$export$8793edee2d425525),
        addTiming: function(name, time) {
            if (time === void 0) time = (0, $fafd178883cb17fc$export$71f52cdbbf629086)();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addTiming(name, time);
            });
        },
        startView: function(options, startClocks) {
            if (startClocks === void 0) startClocks = (0, $fafd178883cb17fc$export$67898643147706d3)();
            var callback = function(startRumResult) {
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = {
                    options: options,
                    callback: callback
                };
                tryStartRum();
            }
        },
        setViewName: function(name) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.setViewName(name);
            });
        },
        setViewContext: function(context) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.setViewContext(context);
            });
        },
        setViewContextProperty: function(key, value) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.setViewContextProperty(key, value);
            });
        },
        addAction: function(action, commonContext) {
            if (commonContext === void 0) commonContext = getCommonContext();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addAction(action, commonContext);
            });
        },
        addError: function(providedError, commonContext) {
            if (commonContext === void 0) commonContext = getCommonContext();
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addError(providedError, commonContext);
            });
        },
        addFeatureFlagEvaluation: function(key, value) {
            bufferApiCalls.add(function(startRumResult) {
                return startRumResult.addFeatureFlagEvaluation(key, value);
            });
        },
        startDurationVital: function(name, options) {
            return (0, $7eb1818b147a2865$export$861e77a28cc19266)(customVitalsState, name, options);
        },
        stopDurationVital: function(name, options) {
            (0, $7eb1818b147a2865$export$ccd4fac39ed3f334)(addDurationVital, customVitalsState, name, options);
        },
        addDurationVital: addDurationVital
    };
}
function $a4b70066dfc326ec$var$overrideInitConfigurationForBridge(initConfiguration) {
    var _a, _b;
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, initConfiguration, {
        applicationId: '00000000-aaaa-0000-aaaa-000000000000',
        clientToken: 'empty',
        sessionSampleRate: 100,
        defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = (0, $f0aff45a57046ce0$export$86c8e1e7efd0dfc1)()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
    });
}


var $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY = 'rum';
function $c7e3cb8a60bc2b2b$export$27595a139f6e6837(startRumImpl, recorderApi, options) {
    if (options === void 0) options = {};
    var customerDataTrackerManager = (0, $6a0cdc23e79adf0f$export$91e74adeb321d399)(0 /* CustomerDataCompressionStatus.Unknown */ );
    var globalContextManager = (0, $a708ac9bed8d6582$export$fe3149b78a43e1ad)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ));
    var userContextManager = (0, $a708ac9bed8d6582$export$fe3149b78a43e1ad)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ));
    var trackingConsentState = (0, $69f3116f372ada5b$export$6a999af43d888e18)();
    var customVitalsState = (0, $7eb1818b147a2865$export$10f357105ec5707a)();
    function getCommonContext() {
        return (0, $af152d066fd4f661$export$ef57df7b19d2c9ab)(globalContextManager, userContextManager, recorderApi);
    }
    var strategy = (0, $a4b70066dfc326ec$export$8f7002373dcc6602)(options, getCommonContext, trackingConsentState, customVitalsState, function(configuration, deflateWorker, initialViewOptions) {
        if (configuration.storeContextsAcrossPages) {
            (0, $77176f4fd68bc5cf$export$a658cbc041b124d0)(configuration, globalContextManager, $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */ );
            (0, $77176f4fd68bc5cf$export$a658cbc041b124d0)(configuration, userContextManager, $c7e3cb8a60bc2b2b$var$RUM_STORAGE_KEY, 1 /* CustomerDataType.User */ );
        }
        customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */  : 2 /* CustomerDataCompressionStatus.Disabled */ );
        var startRumResult = startRumImpl(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder ? function(streamId) {
            return options.createDeflateEncoder(configuration, deflateWorker, streamId);
        } : (0, $ff11a0928c846f93$export$b5341466c7007825), trackingConsentState, customVitalsState);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewHistory, deflateWorker);
        strategy = $c7e3cb8a60bc2b2b$var$createPostStartStrategy(strategy, startRumResult);
        return startRumResult;
    });
    var startView = (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(options) {
        var sanitizedOptions = typeof options === 'object' ? options : {
            name: options
        };
        if (sanitizedOptions.context) customerDataTrackerManager.getOrCreateTracker(3 /* CustomerDataType.View */ ).updateCustomerData(sanitizedOptions.context);
        strategy.startView(sanitizedOptions);
        (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
            feature: 'start-view'
        });
    });
    var rumPublicApi = (0, $a940c8408eeade74$export$119e7fe763fbc1d1)({
        init: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(initConfiguration) {
            strategy.init(initConfiguration, rumPublicApi);
        }),
        setTrackingConsent: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(trackingConsent) {
            trackingConsentState.update(trackingConsent);
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'set-tracking-consent',
                tracking_consent: trackingConsent
            });
        }),
        setViewName: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(name) {
            strategy.setViewName(name);
        }),
        setViewContext: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(context) {
            strategy.setViewContext(context);
        }),
        setViewContextProperty: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key, value) {
            strategy.setViewContextProperty(key, value);
        }),
        setGlobalContext: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(context) {
            globalContextManager.setContext(context);
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'set-global-context'
            });
        }),
        getGlobalContext: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return globalContextManager.getContext();
        }),
        setGlobalContextProperty: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key, value) {
            globalContextManager.setContextProperty(key, value);
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'set-global-context'
            });
        }),
        removeGlobalContextProperty: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key) {
            return globalContextManager.removeContextProperty(key);
        }),
        clearGlobalContext: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return globalContextManager.clearContext();
        }),
        getInternalContext: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(startTime) {
            return strategy.getInternalContext(startTime);
        }),
        getInitConfiguration: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return (0, $df0d4cb06c424d45$export$b7d58db314e0ac27)(strategy.initConfiguration);
        }),
        addAction: function(name, context) {
            var handlingStack = (0, $4ac782ea9e4e9601$export$46c2cbbc853cd95b)();
            (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(function() {
                strategy.addAction({
                    name: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(name),
                    context: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(context),
                    startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)(),
                    type: "custom" /* ActionType.CUSTOM */ ,
                    handlingStack: handlingStack
                });
                (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                    feature: 'add-action'
                });
            });
        },
        addError: function(error, context) {
            var handlingStack = (0, $4ac782ea9e4e9601$export$46c2cbbc853cd95b)();
            (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(function() {
                strategy.addError({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(context),
                    startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)()
                });
                (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                    feature: 'add-error'
                });
            });
        },
        addTiming: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(name, time) {
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(name), time);
        }),
        setUser: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(newUser) {
            if ((0, $c75d7197f8114000$export$77a0cf2b32e9e53d)(newUser)) userContextManager.setContext((0, $c75d7197f8114000$export$cb88b31dcf3267e1)(newUser));
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'set-user'
            });
        }),
        getUser: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return userContextManager.getContext();
        }),
        setUserProperty: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key, property) {
            var _a;
            var sanitizedProperty = (0, $c75d7197f8114000$export$cb88b31dcf3267e1)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'set-user'
            });
        }),
        removeUserProperty: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key) {
            return userContextManager.removeContextProperty(key);
        }),
        clearUser: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return userContextManager.clearContext();
        }),
        startView: startView,
        stopSession: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            strategy.stopSession();
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'stop-session'
            });
        }),
        addFeatureFlagEvaluation: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(key, value) {
            strategy.addFeatureFlagEvaluation((0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(key), (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(value));
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'add-feature-flag-evaluation'
            });
        }),
        getSessionReplayLink: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return recorderApi.getSessionReplayLink();
        }),
        startSessionReplayRecording: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(options) {
            recorderApi.start(options);
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'start-session-replay-recording',
                force: options && options.force
            });
        }),
        stopSessionReplayRecording: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return recorderApi.stop();
        }),
        addDurationVital: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(name, options) {
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'add-duration-vital'
            });
            strategy.addDurationVital({
                name: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(name),
                type: "duration" /* VitalType.DURATION */ ,
                startClocks: (0, $fafd178883cb17fc$export$1208e92a226eb540)(options.startTime),
                duration: options.duration,
                context: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.context),
                description: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.description)
            });
        }),
        startDurationVital: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(name, options) {
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'start-duration-vital'
            });
            return strategy.startDurationVital((0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(name), {
                context: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.context),
                description: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.description)
            });
        }),
        stopDurationVital: (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(nameOrRef, options) {
            (0, $b20e9e3ee3028089$export$1241dad04919e70b)({
                feature: 'stop-duration-vital'
            });
            strategy.stopDurationVital(typeof nameOrRef === 'string' ? (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(nameOrRef) : nameOrRef, {
                context: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.context),
                description: (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(options && options.description)
            });
        })
    });
    return rumPublicApi;
}
function $c7e3cb8a60bc2b2b$var$createPostStartStrategy(preStartStrategy, startRumResult) {
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        init: function(initConfiguration) {
            (0, $c014cf41d8e6d87d$export$b25c854130ebaef9)('DD_RUM', initConfiguration);
        },
        initConfiguration: preStartStrategy.initConfiguration
    }, startRumResult);
}





var $0ebb46f2959d2690$export$69c8658089134213 = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen'
};
function $0ebb46f2959d2690$export$ff7f79b1ae5ce683(configuration) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var stopListeners = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
            "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
            "freeze" /* DOM_EVENT.FREEZE */ 
        ], function(event) {
            if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */  && document.visibilityState === 'hidden') /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */ observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.HIDDEN
            });
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */ observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.FROZEN
            });
        }, {
            capture: true
        }).stop;
        var stopBeforeUnloadListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */ , function() {
            observable.notify({
                reason: $0ebb46f2959d2690$export$69c8658089134213.UNLOADING
            });
        }).stop;
        return function() {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function $0ebb46f2959d2690$export$cbb6b5cdbd0f2b60(reason) {
    return (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)((0, $b287859a2cd2eacd$export$ad1854f4a08c15f8)($0ebb46f2959d2690$export$69c8658089134213), reason);
}



function $1e55a02d0fb92a5e$export$e0f9a2ab04194dff() {
    var MutationObserver = $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982();
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        if (!MutationObserver) return;
        var observer = new MutationObserver((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return observable.notify();
        }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return function() {
            return observer.disconnect();
        };
    });
}
function $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, $3f8b4cfb9b188c27$export$610f486206760177)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver((0, $772566d0dfa3645c$export$8793edee2d425525));
            var originalInstance = (0, $3f8b4cfb9b188c27$export$610f486206760177)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}



function $54f177b32de8aa24$export$7c27c71faac0cc07() {
    var observable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var stop = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(window, 'open', function() {
        return observable.notify();
    }).stop;
    return {
        observable: observable,
        stop: stop
    };
}




var $125d036ad0d2a2af$export$4f7d2dba9330699b = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report'
};


function $7adb00cfa5352eff$export$eafcd5d914e17d69(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function() {
            if (eventCount === 0) (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                eventCount = 0;
            }, (0, $fafd178883cb17fc$export$35acaebf644db34e));
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).AGENT,
                        startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)()
                    });
                } finally{
                    allowNextEvent = false;
                }
            }
            return true;
        }
    };
}



function $a3ecaf80187f9bbd$export$f36825a638794cc1() {
    var testId = (0, $a9d5c9dbe5afd19a$export$8ea5b4a47d6660d5)();
    var resultId = (0, $a9d5c9dbe5afd19a$export$75da4270a596d87b)();
    if (testId && resultId) return {
        test_id: testId,
        result_id: resultId,
        injected: (0, $a9d5c9dbe5afd19a$export$749ed8af36cd25e0)()
    };
}



function $d39841a7da10ef40$export$a1733aa00dfb01(object, modifiableFieldPaths, modifier) {
    var clone = (0, $df0d4cb06c424d45$export$b7d58db314e0ac27)(object);
    var result = modifier(clone);
    (0, $b287859a2cd2eacd$export$6a29ade99f81ec8a)(modifiableFieldPaths).forEach(function(_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = $d39841a7da10ef40$var$get(clone, fieldPath);
        var newType = (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(newValue);
        if (newType === fieldType) $d39841a7da10ef40$var$set(object, fieldPath, (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(newValue));
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) $d39841a7da10ef40$var$set(object, fieldPath, {});
    });
    return result;
}
function $d39841a7da10ef40$var$get(object, path) {
    var current = object;
    for(var _i = 0, _a = path.split('.'); _i < _a.length; _i++){
        var field = _a[_i];
        if (!$d39841a7da10ef40$var$isValidObjectContaining(current, field)) return;
        current = current[field];
    }
    return current;
}
function $d39841a7da10ef40$var$set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for(var i = 0; i < fields.length; i += 1){
        var field = fields[i];
        if (!$d39841a7da10ef40$var$isValidObject(current)) return;
        if (i !== fields.length - 1) current = current[field];
        else current[field] = value;
    }
}
function $d39841a7da10ef40$var$isValidObject(object) {
    return (0, $41afd9a0399e7c82$export$e2b5c5db9e2009fd)(object) === 'object';
}
function $d39841a7da10ef40$var$isValidObjectContaining(object, field) {
    return $d39841a7da10ef40$var$isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}


var $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string'
};
var $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object'
};
var $66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS = {
    service: 'string',
    version: 'string'
};
var $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent;
function $66722fe8d7cbabe1$export$1a0bc162690d6539(configuration, lifeCycle, sessionManager, viewHistory, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
    var _a, _b;
    $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent = (_a = {}, _a["view" /* RumEventType.VIEW */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["error" /* RumEventType.ERROR */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        'error.message': 'string',
        'error.stack': 'string',
        'error.resource.url': 'string',
        'error.fingerprint': 'string'
    }, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS), _a["resource" /* RumEventType.RESOURCE */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        'resource.url': 'string'
    }, (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).WRITABLE_RESOURCE_GRAPHQL) ? {
        'resource.graphql': 'object'
    } : {}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS), _a["action" /* RumEventType.ACTION */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        'action.target.name': 'string'
    }, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$ROOT_MODIFIABLE_FIELD_PATHS), _a["long_task" /* RumEventType.LONG_TASK */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a["vital" /* RumEventType.VITAL */ ] = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, $66722fe8d7cbabe1$var$USER_CUSTOMIZABLE_FIELD_PATHS, $66722fe8d7cbabe1$var$VIEW_MODIFIABLE_FIELD_PATHS), _a);
    var eventRateLimiters = (_b = {}, _b["error" /* RumEventType.ERROR */ ] = (0, $7adb00cfa5352eff$export$eafcd5d914e17d69)("error" /* RumEventType.ERROR */ , configuration.eventRateLimiterThreshold, reportError), _b["action" /* RumEventType.ACTION */ ] = (0, $7adb00cfa5352eff$export$eafcd5d914e17d69)("action" /* RumEventType.ACTION */ , configuration.eventRateLimiterThreshold, reportError), _b["vital" /* RumEventType.VITAL */ ] = (0, $7adb00cfa5352eff$export$eafcd5d914e17d69)("vital" /* RumEventType.VITAL */ , configuration.eventRateLimiterThreshold, reportError), _b);
    var syntheticsContext = (0, $a3ecaf80187f9bbd$export$f36825a638794cc1)();
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , function(_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewHistoryEntry = viewHistory.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewHistoryEntry && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0, $fafd178883cb17fc$export$5dcf4148298ed557)(),
                    configuration: {
                        session_sample_rate: (0, $89f5cd41be2839b1$export$2077e0241d6afd3c)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0, $89f5cd41be2839b1$export$2077e0241d6afd3c)(configuration.sessionReplaySampleRate, 3)
                    },
                    browser_sdk_version: (0, $f0aff45a57046ce0$export$a8ab916fee43a31b)() ? "5.35.1" : undefined
                },
                application: {
                    id: configuration.applicationId
                },
                date: (0, $fafd178883cb17fc$export$71f52cdbbf629086)(),
                service: viewHistoryEntry.service || configuration.service,
                version: viewHistoryEntry.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */  : ciVisibilityContext.get() ? "ci_test" /* SessionType.CI_TEST */  : "user" /* SessionType.USER */ 
                },
                view: {
                    id: viewHistoryEntry.id,
                    name: viewHistoryEntry.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer
                },
                action: $66722fe8d7cbabe1$var$needToAssembleWithAction(rawRumEvent) && actionId ? {
                    id: actionId
                } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciVisibilityContext.get(),
                display: displayContext.get(),
                connectivity: (0, $5db5d5af84f5318f$export$5c86d3b16901f3ce)()
            };
            var serverRumEvent = (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(rumContext, rawRumEvent);
            serverRumEvent.context = (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(commonContext.context, viewHistoryEntry.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) serverRumEvent.session.has_replay = commonContext.hasReplay;
            if (serverRumEvent.type === 'view') serverRumEvent.session.sampled_for_replay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */ ;
            if (// TODO: remove ff and should always add anonymous user id
            (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).ANONYMOUS_USER_TRACKING) && !commonContext.user.anonymous_id) commonContext.user.anonymous_id = session.anonymousId;
            if (!(0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(commonContext.user)) serverRumEvent.usr = commonContext.user;
            if ($66722fe8d7cbabe1$var$shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(serverRumEvent.context)) delete serverRumEvent.context;
                lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , serverRumEvent);
            }
        }
    });
}
function $66722fe8d7cbabe1$var$shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = (0, $d39841a7da10ef40$export$a1733aa00dfb01)(event, $66722fe8d7cbabe1$var$modifiableFieldPathsByEvent[event.type], function(event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */ ) return false;
        if (result === false) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("Can't dismiss view events using beforeSend!");
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function $66722fe8d7cbabe1$var$needToAssembleWithAction(event) {
    return [
        "error" /* RumEventType.ERROR */ ,
        "resource" /* RumEventType.RESOURCE */ ,
        "long_task" /* RumEventType.LONG_TASK */ 
    ].indexOf(event.type) !== -1;
}


/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */ function $af3ad9afe3848d81$export$ee941cf091e8459(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
    return {
        get: function(startTime) {
            var viewContext = viewHistory.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? {
                        id: actionId
                    } : undefined,
                    view: {
                        id: viewContext.id,
                        name: viewContext.name,
                        referrer: urlContext.referrer,
                        url: urlContext.url
                    }
                };
            }
        }
    };
}


// eslint-disable-next-line no-restricted-syntax
var $b012f5cc0ca286d9$export$cf0c49d09be0ebd8 = /** @class */ function() {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function(eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach(function(callback) {
            return callback(data);
        });
    };
    AbstractLifeCycle.prototype.subscribe = function(eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function() {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function(other) {
                    return callback !== other;
                });
            }
        };
    };
    return AbstractLifeCycle;
}();


var $3b152250b13a0137$export$6af70476896cbaec = (0, $b012f5cc0ca286d9$export$cf0c49d09be0ebd8);





var $5d3fa3f7dfe2dca0$var$END_OF_TIMES = Infinity;
var $5d3fa3f7dfe2dca0$export$7cf440d5901bea64 = (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $5d3fa3f7dfe2dca0$export$74da638c6075b86(_a) {
    var expireDelay = _a.expireDelay, maxEntries = _a.maxEntries;
    var entries = [];
    var clearOldValuesInterval = (0, $02784b622c768a70$export$cda6c73645970615)(function() {
        return clearOldValues();
    }, $5d3fa3f7dfe2dca0$export$7cf440d5901bea64);
    function clearOldValues() {
        var oldTimeThreshold = (0, $fafd178883cb17fc$export$53cb631b087d9e92)() - expireDelay;
        while(entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold)entries.pop();
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */ function add(value, startTime) {
        var entry = {
            value: value,
            startTime: startTime,
            endTime: $5d3fa3f7dfe2dca0$var$END_OF_TIMES,
            remove: function() {
                (0, $fcd525cace9de4ff$export$fe2d9b4e03920b4c)(entries, entry);
            },
            close: function(endTime) {
                entry.endTime = endTime;
            }
        };
        if (maxEntries && entries.length >= maxEntries) entries.pop();
        entries.unshift(entry);
        return entry;
    }
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     *
     * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
     */ function find(startTime, options) {
        if (startTime === void 0) startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES;
        if (options === void 0) options = {
            returnInactive: false
        };
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.startTime <= startTime) {
                if (options.returnInactive || startTime <= entry.endTime) return entry.value;
                break;
            }
        }
    }
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */ function closeActive(endTime) {
        var latestEntry = entries[0];
        if (latestEntry && latestEntry.endTime === $5d3fa3f7dfe2dca0$var$END_OF_TIMES) latestEntry.close(endTime);
    }
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */ function findAll(startTime, duration) {
        if (startTime === void 0) startTime = $5d3fa3f7dfe2dca0$var$END_OF_TIMES;
        if (duration === void 0) duration = 0;
        var endTime = (0, $fafd178883cb17fc$export$c0c581816dedfc70)(startTime, duration);
        return entries.filter(function(entry) {
            return entry.startTime <= endTime && startTime <= entry.endTime;
        }).map(function(entry) {
            return entry.value;
        });
    }
    /**
     * Remove all entries from this collection.
     */ function reset() {
        entries = [];
    }
    /**
     * Stop internal garbage collection of past entries.
     */ function stop() {
        (0, $02784b622c768a70$export$5c0dc72231454d02)(clearOldValuesInterval);
    }
    return {
        add: add,
        find: find,
        closeActive: closeActive,
        findAll: findAll,
        reset: reset,
        stop: stop
    };
}


var $7d11beaaee8c1142$export$f12c747a768c817c = (0, $407be9496e601c3b$export$324def7afe89d7e8);
function $7d11beaaee8c1142$export$268034a9c98ba695(lifeCycle) {
    var viewValueHistory = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $7d11beaaee8c1142$export$f12c747a768c817c
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(view) {
        viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        viewValueHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , function(viewUpdate) {
        var currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
        if (currentView && viewUpdate.name) currentView.name = viewUpdate.name;
        if (currentView && viewUpdate.context) currentView.context = viewUpdate.context;
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        viewValueHistory.reset();
    });
    function buildViewHistoryEntry(view) {
        return {
            service: view.service,
            version: view.version,
            context: view.context,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks
        };
    }
    return {
        findView: function(startTime) {
            return viewValueHistory.find(startTime);
        },
        stop: function() {
            viewValueHistory.stop();
        }
    };
}








var $a2867d5cdff4f776$var$xhrObservable;
var $a2867d5cdff4f776$var$xhrContexts = new WeakMap();
function $a2867d5cdff4f776$export$1b29a115c614eaec(configuration) {
    if (!$a2867d5cdff4f776$var$xhrObservable) $a2867d5cdff4f776$var$xhrObservable = $a2867d5cdff4f776$var$createXhrObservable(configuration);
    return $a2867d5cdff4f776$var$xhrObservable;
}
function $a2867d5cdff4f776$var$createXhrObservable(configuration) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var stopInstrumentingStart = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(XMLHttpRequest.prototype, 'open', $a2867d5cdff4f776$var$openXhr).stop;
        var stopInstrumentingSend = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(XMLHttpRequest.prototype, 'send', function(call) {
            $a2867d5cdff4f776$var$sendXhr(call, configuration, observable);
        }, {
            computeHandlingStack: true
        }).stop;
        var stopInstrumentingAbort = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(XMLHttpRequest.prototype, 'abort', $a2867d5cdff4f776$var$abortXhr).stop;
        return function() {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function $a2867d5cdff4f776$var$openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    $a2867d5cdff4f776$var$xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: (0, $8af9b5626c1bb968$export$6535eb414fa2c8b6)(String(url))
    });
}
function $a2867d5cdff4f776$var$sendXhr(_a, configuration, observable) {
    var xhr = _a.target, handlingStack = _a.handlingStack;
    var context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (!context) return;
    var startContext = context;
    startContext.state = 'start';
    startContext.startClocks = (0, $fafd178883cb17fc$export$67898643147706d3)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    startContext.handlingStack = handlingStack;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(xhr, 'onreadystatechange', function() {
        if (xhr.readyState === XMLHttpRequest.DONE) // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
    }).stop;
    var onEnd = function() {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) return;
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(startContext.startClocks.timeStamp, (0, $fafd178883cb17fc$export$71f52cdbbf629086)());
        completeContext.status = xhr.status;
        observable.notify((0, $66d1b7fd2da44c06$export$370e8311c3cdebd9)(completeContext));
    };
    var unsubscribeLoadEndListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, xhr, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function $a2867d5cdff4f776$var$abortXhr(_a) {
    var xhr = _a.target;
    var context = $a2867d5cdff4f776$var$xhrContexts.get(xhr);
    if (context) context.isAborted = true;
}



function $3205c6e66a2d76d7$export$ecd154de096317dd(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) chunks.push(result.value);
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) onDone();
            else readMore();
        }), (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(error) {
            return callback(error);
        }));
    }
    function onDone() {
        reader.cancel().catch(// we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        (0, $772566d0dfa3645c$export$8793edee2d425525));
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
            // use it directly.
            completeBuffer_1 = chunks[0];
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function(chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}

function $63b619b5581ec78b$export$a7cbe72d7c4012af(status) {
    return status >= 500;
}
function $63b619b5581ec78b$export$8a0df03d5faeada4(response) {
    try {
        return response.clone();
    } catch (_a) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}



var $b22ed8845addf22a$export$dc5d43db6d9a2bce = 'initial_document';
var $b22ed8845addf22a$var$RESOURCE_TYPES = [
    [
        "document" /* ResourceType.DOCUMENT */ ,
        function(initiatorType) {
            return $b22ed8845addf22a$export$dc5d43db6d9a2bce === initiatorType;
        }
    ],
    [
        "xhr" /* ResourceType.XHR */ ,
        function(initiatorType) {
            return 'xmlhttprequest' === initiatorType;
        }
    ],
    [
        "fetch" /* ResourceType.FETCH */ ,
        function(initiatorType) {
            return 'fetch' === initiatorType;
        }
    ],
    [
        "beacon" /* ResourceType.BEACON */ ,
        function(initiatorType) {
            return 'beacon' === initiatorType;
        }
    ],
    [
        "css" /* ResourceType.CSS */ ,
        function(_, path) {
            return /\.css$/i.test(path);
        }
    ],
    [
        "js" /* ResourceType.JS */ ,
        function(_, path) {
            return /\.js$/i.test(path);
        }
    ],
    [
        "image" /* ResourceType.IMAGE */ ,
        function(initiatorType, path) {
            return (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)([
                'image',
                'img',
                'icon'
            ], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        }
    ],
    [
        "font" /* ResourceType.FONT */ ,
        function(_, path) {
            return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
        }
    ],
    [
        "media" /* ResourceType.MEDIA */ ,
        function(initiatorType, path) {
            return (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)([
                'audio',
                'video'
            ], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        }
    ]
];
function $b22ed8845addf22a$export$874b6cde352e515a(entry) {
    var url = entry.name;
    if (!(0, $8af9b5626c1bb968$export$bef94a5618bf18bf)(url)) {
        (0, $b20e9e3ee3028089$export$d922954195a17683)("Failed to construct URL for \"".concat(entry.name, "\""));
        return "other" /* ResourceType.OTHER */ ;
    }
    var path = (0, $8af9b5626c1bb968$export$ba1b94ff70383687)(url);
    for(var _i = 0, RESOURCE_TYPES_1 = $b22ed8845addf22a$var$RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++){
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(entry.initiatorType, path)) return type;
    }
    return "other" /* ResourceType.OTHER */ ;
}
function $b22ed8845addf22a$var$areInOrder() {
    var numbers = [];
    for(var _i = 0; _i < arguments.length; _i++)numbers[_i] = arguments[_i];
    for(var i = 1; i < numbers.length; i += 1){
        if (numbers[i - 1] > numbers[i]) return false;
    }
    return true;
}
function $b22ed8845addf22a$export$a5878f59e3ee2e9f(entry) {
    return entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch';
}
function $b22ed8845addf22a$export$e10d69e2d9b371b6(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) return (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((0, $fafd178883cb17fc$export$e04aa69d28450d55)(startTime, responseEnd));
    return (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(duration);
}
function $b22ed8845addf22a$export$a8cdd6a8741b9542(entry) {
    if (!$b22ed8845addf22a$export$c07d151c23cfeb06(entry)) return undefined;
    var startTime = entry.startTime, fetchStart = entry.fetchStart, workerStart = entry.workerStart, redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd, domainLookupStart = entry.domainLookupStart, domainLookupEnd = entry.domainLookupEnd, connectStart = entry.connectStart, secureConnectionStart = entry.secureConnectionStart, connectEnd = entry.connectEnd, requestStart = entry.requestStart, responseStart = entry.responseStart, responseEnd = entry.responseEnd;
    var details = {
        download: $b22ed8845addf22a$var$formatTiming(startTime, responseStart, responseEnd),
        first_byte: $b22ed8845addf22a$var$formatTiming(startTime, requestStart, responseStart)
    };
    // Make sure a worker processing time is recorded
    if (0 < workerStart && workerStart < fetchStart) details.worker = $b22ed8845addf22a$var$formatTiming(startTime, workerStart, fetchStart);
    // Make sure a connection occurred
    if (fetchStart < connectEnd) {
        details.connect = $b22ed8845addf22a$var$formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) details.ssl = $b22ed8845addf22a$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    // Make sure a domain lookup occurred
    if (fetchStart < domainLookupEnd) details.dns = $b22ed8845addf22a$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    // Make sure a redirection occurred
    if (startTime < redirectEnd) details.redirect = $b22ed8845addf22a$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
function $b22ed8845addf22a$export$bb48f5f5ee2d8ac6(entry) {
    return entry.duration >= 0;
}
function $b22ed8845addf22a$export$c07d151c23cfeb06(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    var areCommonTimingsInOrder = $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
    var areRedirectionTimingsInOrder = $b22ed8845addf22a$var$hasRedirection(entry) ? $b22ed8845addf22a$var$areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
    return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function $b22ed8845addf22a$var$hasRedirection(entry) {
    return entry.redirectEnd > entry.startTime;
}
function $b22ed8845addf22a$var$formatTiming(origin, start, end) {
    if (origin <= start && start <= end) return {
        duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((0, $fafd178883cb17fc$export$e04aa69d28450d55)(start, end)),
        start: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((0, $fafd178883cb17fc$export$e04aa69d28450d55)(origin, start))
    };
}
function $b22ed8845addf22a$export$628529093947cac8(entry) {
    return entry.nextHopProtocol === '' ? undefined : entry.nextHopProtocol;
}
function $b22ed8845addf22a$export$f83ec67aa945dcf6(entry) {
    return entry.deliveryType === '' ? 'other' : entry.deliveryType;
}
function $b22ed8845addf22a$export$9207ac338b648dd5(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        var encodedBodySize = entry.encodedBodySize, decodedBodySize = entry.decodedBodySize, transferSize = entry.transferSize;
        return {
            size: decodedBodySize,
            encoded_body_size: encodedBodySize,
            decoded_body_size: decodedBodySize,
            transfer_size: transferSize
        };
    }
    return {
        size: undefined,
        encoded_body_size: undefined,
        decoded_body_size: undefined,
        transfer_size: undefined
    };
}
function $b22ed8845addf22a$export$c298da523d6ed600(url) {
    return url && !(0, $57fc5f00ec8e4fc6$export$8f53a704ec1860b3)(url);
}
var $b22ed8845addf22a$var$DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
var $b22ed8845addf22a$export$60afd1bdd3673cde = 24000;
function $b22ed8845addf22a$export$4731ef4a2d5817b7(url) {
    if (url.length <= $b22ed8845addf22a$export$60afd1bdd3673cde) return false;
    else if (url.substring(0, 5) === 'data:') {
        // Avoid String.match RangeError: Maximum call stack size exceeded
        url = url.substring(0, $b22ed8845addf22a$export$60afd1bdd3673cde);
        return true;
    }
    return false;
}
function $b22ed8845addf22a$export$7e3e020b0533decd(url) {
    return "".concat(url.match($b22ed8845addf22a$var$DATA_URL_REGEX)[0], "[...]");
}



var $c4313f4d150a5ffa$var$nextRequestIndex = 1;
function $c4313f4d150a5ffa$export$254c90b445eb4949(lifeCycle, configuration, sessionManager) {
    var tracer = (0, $2b3f7c5bb3826872$export$faa83af43a19aa4b)(configuration, sessionManager);
    $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer);
    $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, tracer);
}
function $c4313f4d150a5ffa$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer) {
    var subscription = (0, $a2867d5cdff4f776$export$1b29a115c614eaec)(configuration).subscribe(function(rawContext) {
        var context = rawContext;
        if (!(0, $b22ed8845addf22a$export$c298da523d6ed600)(context.url)) return;
        switch(context.state){
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */ ,
                    url: context.url,
                    xhr: context.xhr,
                    isAborted: context.isAborted,
                    handlingStack: context.handlingStack
                });
                break;
        }
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $c4313f4d150a5ffa$export$2862eaaabb376c8d(lifeCycle, tracer) {
    var subscription = (0, $fc27ff42b956d16d$export$68d940e9b7f5282c)().subscribe(function(rawContext) {
        var context = rawContext;
        if (!(0, $b22ed8845addf22a$export$c298da523d6ed600)(context.url)) return;
        switch(context.state){
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = $c4313f4d150a5ffa$var$getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */ , {
                    requestIndex: context.requestIndex,
                    url: context.url
                });
                break;
            case 'resolve':
                $c4313f4d150a5ffa$var$waitForResponseToComplete(context, function(duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */ ,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                        isAborted: context.isAborted,
                        handlingStack: context.handlingStack
                    });
                });
                break;
        }
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $c4313f4d150a5ffa$var$getNextRequestIndex() {
    var result = $c4313f4d150a5ffa$var$nextRequestIndex;
    $c4313f4d150a5ffa$var$nextRequestIndex += 1;
    return result;
}
function $c4313f4d150a5ffa$var$waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0, $63b619b5581ec78b$export$8a0df03d5faeada4)(context.response);
    if (!clonedResponse || !clonedResponse.body) // do not try to wait for the response if the clone failed, fetch error or null body
    callback((0, $fafd178883cb17fc$export$e04aa69d28450d55)(context.startClocks.timeStamp, (0, $fafd178883cb17fc$export$71f52cdbbf629086)()));
    else (0, $3205c6e66a2d76d7$export$ecd154de096317dd)(clonedResponse.body, function() {
        callback((0, $fafd178883cb17fc$export$e04aa69d28450d55)(context.startClocks.timeStamp, (0, $fafd178883cb17fc$export$71f52cdbbf629086)()));
    }, {
        bytesLimit: Number.POSITIVE_INFINITY,
        collectStreamBody: false
    });
}




function $fc3b94d36e42b5cc$export$e8fc7a7e81732139(duration) {
    return (0, $89f5cd41be2839b1$export$7e4aa119212bc614)(duration) && duration < 0 ? undefined : duration;
}




function $0b00b19bfaa2355c$export$a50549f6fbbed49b(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? (0, $772566d0dfa3645c$export$8793edee2d425525) : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0
    };
    var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        var _a;
        if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) return;
        switch(event.type){
            case "error" /* RumEventType.ERROR */ :
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */ :
                eventCounts.actionCount += 1;
                if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */ :
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */ :
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts
    };
}






function $2b21719c0559c4ac$export$2c9064660d4f1caa(configuration, callback) {
    var startTimeStamp = (0, $fafd178883cb17fc$export$ceae11818251d43c)();
    var timingSent = false;
    var removeEventListeners = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "mousedown" /* DOM_EVENT.MOUSE_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ 
    ], function(evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) return;
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: (0, $fafd178883cb17fc$export$53cb631b087d9e92)(),
            processingEnd: (0, $fafd178883cb17fc$export$53cb631b087d9e92)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: '',
            cancelable: false,
            target: null,
            toJSON: function() {
                return {};
            }
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ) sendTimingIfPointerIsNotCancelled(configuration, timing);
        else sendTiming(timing);
    }, {
        passive: true,
        capture: true
    }).stop;
    return {
        stop: removeEventListeners
    };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */ function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
            "pointerup" /* DOM_EVENT.POINTER_UP */ ,
            "pointercancel" /* DOM_EVENT.POINTER_CANCEL */ 
        ], function(event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */ ) sendTiming(timing);
        }, {
            once: true
        });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, $fafd178883cb17fc$export$ceae11818251d43c)() - startTimeStamp) callback(timing);
        }
    }
}


var $a45e320ac0fe2c4f$export$5241bfb054a2a291;
(function(RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})($a45e320ac0fe2c4f$export$5241bfb054a2a291 || ($a45e320ac0fe2c4f$export$5241bfb054a2a291 = {}));
function $a45e320ac0fe2c4f$export$f3f6554c84596077(configuration, options) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        if (!window.PerformanceObserver) return;
        var handlePerformanceEntries = function(entries) {
            var rumPerformanceEntries = $a45e320ac0fe2c4f$var$filterRumPerformanceEntries(entries);
            if (rumPerformanceEntries.length > 0) observable.notify(rumPerformanceEntries);
        };
        var timeoutId;
        var isObserverInitializing = true;
        var observer = new PerformanceObserver((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(entries) {
            // In Safari the performance observer callback is synchronous.
            // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
            if (isObserverInitializing) timeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                return handlePerformanceEntries(entries.getEntries());
            });
            else handlePerformanceEntries(entries.getEntries());
        }));
        try {
            observer.observe(options);
        } catch (_a) {
            // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
            // TODO: remove this fallback in the next major version
            var fallbackSupportedEntryTypes = [
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.RESOURCE,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.NAVIGATION,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.LONG_TASK,
                $a45e320ac0fe2c4f$export$5241bfb054a2a291.PAINT
            ];
            if ((0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(fallbackSupportedEntryTypes, options.type)) {
                if (options.buffered) timeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                    return handlePerformanceEntries(performance.getEntriesByType(options.type));
                });
                try {
                    observer.observe({
                        entryTypes: [
                            options.type
                        ]
                    });
                } catch (_b) {
                    // Old versions of Safari are throwing "entryTypes contained only unsupported types"
                    // errors when observing only unsupported entry types.
                    //
                    // We could use `supportPerformanceTimingEvent` to make sure we don't invoke
                    // `observer.observe` with an unsupported entry type, but Safari 11 and 12 don't support
                    // `Performance.supportedEntryTypes`, so doing so would lose support for these versions
                    // even if they do support the entry type.
                    return;
                }
            }
        }
        isObserverInitializing = false;
        $a45e320ac0fe2c4f$var$manageResourceTimingBufferFull(configuration);
        var stopFirstInputTiming;
        if (!$a45e320ac0fe2c4f$export$c6967607cdac15e8($a45e320ac0fe2c4f$export$5241bfb054a2a291.FIRST_INPUT) && options.type === $a45e320ac0fe2c4f$export$5241bfb054a2a291.FIRST_INPUT) stopFirstInputTiming = (0, $2b21719c0559c4ac$export$2c9064660d4f1caa)(configuration, function(timing) {
            handlePerformanceEntries([
                timing
            ]);
        }).stop;
        return function() {
            observer.disconnect();
            if (stopFirstInputTiming) stopFirstInputTiming();
            (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(timeoutId);
        };
    });
}
var $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener;
function $a45e320ac0fe2c4f$var$manageResourceTimingBufferFull(configuration) {
    if (!$a45e320ac0fe2c4f$var$resourceTimingBufferFullListener && $a45e320ac0fe2c4f$var$supportPerformanceObject() && 'addEventListener' in performance) // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, performance, 'resourcetimingbufferfull', function() {
        performance.clearResourceTimings();
    });
    return function() {
        $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener === null || $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener === void 0 || $a45e320ac0fe2c4f$var$resourceTimingBufferFullListener.stop();
    };
}
function $a45e320ac0fe2c4f$var$supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function $a45e320ac0fe2c4f$export$c6967607cdac15e8(entryType) {
    return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $a45e320ac0fe2c4f$var$filterRumPerformanceEntries(entries) {
    return entries.filter(function(entry) {
        return !$a45e320ac0fe2c4f$var$isForbiddenResource(entry);
    });
}
function $a45e320ac0fe2c4f$var$isForbiddenResource(entry) {
    return entry.entryType === $a45e320ac0fe2c4f$export$5241bfb054a2a291.RESOURCE && (!(0, $b22ed8845addf22a$export$c298da523d6ed600)(entry.name) || !(0, $b22ed8845addf22a$export$bb48f5f5ee2d8ac6)(entry));
}


var $56392c0d6d718cf0$export$a59477b089b98865 = 100;
var $56392c0d6d718cf0$export$daa5d178ead00ab = 100;
function $56392c0d6d718cf0$export$4a886e0e421b0302(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = $56392c0d6d718cf0$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
    return $56392c0d6d718cf0$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function $56392c0d6d718cf0$export$580daaeb5ddf2e92(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
        return complete({
            hadActivity: false
        });
    }), $56392c0d6d718cf0$export$a59477b089b98865);
    var maxDurationTimeoutId = maxDuration !== undefined ? (0, $02784b622c768a70$export$831dc9f2ab0a617b)((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
        return complete({
            hadActivity: true,
            end: (0, $fafd178883cb17fc$export$71f52cdbbf629086)()
        });
    }), maxDuration) : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function(_a) {
        var isBusy = _a.isBusy;
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(validationTimeoutId);
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(pageActivityEndTimeoutId);
        var lastChangeTime = (0, $fafd178883cb17fc$export$71f52cdbbf629086)();
        if (!isBusy) pageActivityEndTimeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            return complete({
                hadActivity: true,
                end: lastChangeTime
            });
        }), $56392c0d6d718cf0$export$daa5d178ead00ab);
    });
    var stop = function() {
        hasCompleted = true;
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(validationTimeoutId);
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(pageActivityEndTimeoutId);
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) return;
        stop();
        pageActivityEndCallback(event);
    }
    return {
        stop: stop
    };
}
function $56392c0d6d718cf0$export$48867124286069d5(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), windowOpenObservable.subscribe(notifyPageActivity), (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
            type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).RESOURCE
        }).subscribe(function(entries) {
            if (entries.some(function(entry) {
                return !$56392c0d6d718cf0$var$isExcludedUrl(configuration, entry.name);
            })) notifyPageActivity();
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */ , function(startEvent) {
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, startEvent.url)) return;
            if (firstRequestIndex === undefined) firstRequestIndex = startEvent.requestIndex;
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , function(request) {
            if ($56392c0d6d718cf0$var$isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined || // If the request started before the tracking start, ignore it
            request.requestIndex < firstRequestIndex) return;
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        return function() {
            subscriptions.forEach(function(s) {
                return s.unsubscribe();
            });
        };
        function notifyPageActivity() {
            observable.notify({
                isBusy: pendingRequestsCount > 0
            });
        }
    });
}
function $56392c0d6d718cf0$var$isExcludedUrl(configuration, requestUrl) {
    return (0, $b56eba7faf105c60$export$eb5a30555469227)(configuration.excludedActivityUrls, requestUrl);
}


// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function $d84da87a5bdc7a20$export$a5d1f61e0bd5c403(str) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(str);
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') return '\uFFFD';
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function $d84da87a5bdc7a20$export$c33a404b21a1fad3(element, selector) {
    if (element.matches) return element.matches(selector);
    // IE11 support
    if (element.msMatchesSelector) return element.msMatchesSelector(selector);
    return false;
}
function $d84da87a5bdc7a20$export$169e5491001d3ed6(node) {
    if (node.parentElement) return node.parentElement;
    while(node.parentNode){
        if (node.parentNode.nodeType === Node.ELEMENT_NODE) return node.parentNode;
        node = node.parentNode;
    }
    return null;
}
function $d84da87a5bdc7a20$export$4b3def1d4726a17a(element) {
    if (element.classList) return element.classList;
    var classes = (element.getAttribute('class') || '').trim();
    return classes ? classes.split(/\s+/) : [];
}
// ie11 supports WeakMap but not WeakSet
var $d84da87a5bdc7a20$var$PLACEHOLDER = 1;
// eslint-disable-next-line no-restricted-syntax
var $d84da87a5bdc7a20$export$c0627e557a270ad = /** @class */ function() {
    function WeakSet(initialValues) {
        var _this = this;
        this.map = new WeakMap();
        if (initialValues) initialValues.forEach(function(value) {
            return _this.map.set(value, $d84da87a5bdc7a20$var$PLACEHOLDER);
        });
    }
    WeakSet.prototype.add = function(value) {
        this.map.set(value, $d84da87a5bdc7a20$var$PLACEHOLDER);
        return this;
    };
    WeakSet.prototype.delete = function(value) {
        return this.map.delete(value);
    };
    WeakSet.prototype.has = function(value) {
        return this.map.has(value);
    };
    return WeakSet;
}();





function $390d7e44cf00bd59$export$ccbedd67ef6e9417(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $390d7e44cf00bd59$export$575485136eb1b1f(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function $390d7e44cf00bd59$export$95fe5d3c5526a812(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $390d7e44cf00bd59$export$1fde2ba54cd81850(node) {
    return $390d7e44cf00bd59$export$95fe5d3c5526a812(node) && Boolean(node.shadowRoot);
}
function $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && $390d7e44cf00bd59$export$95fe5d3c5526a812(shadowRoot.host);
}
function $390d7e44cf00bd59$export$13782f450ac5e09a(node) {
    return node.childNodes.length > 0 || $390d7e44cf00bd59$export$1fde2ba54cd81850(node);
}
function $390d7e44cf00bd59$export$522badb50a8fb0b(node, callback) {
    var child = node.firstChild;
    while(child){
        callback(child);
        child = child.nextSibling;
    }
    if ($390d7e44cf00bd59$export$1fde2ba54cd81850(node)) callback(node.shadowRoot);
}
function $390d7e44cf00bd59$export$4e12058fc4d51d56(node) {
    return $390d7e44cf00bd59$export$3a98bd54c2ced0bf(node) ? node.host : node.parentNode;
}



var $096eed2d25f26114$export$92940eb5f25d0fc5 = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: (0, $54fbdcf742061e48$export$e8c12a778f5ad67c).ALLOW,
    MASK: (0, $54fbdcf742061e48$export$e8c12a778f5ad67c).MASK,
    MASK_USER_INPUT: (0, $54fbdcf742061e48$export$e8c12a778f5ad67c).MASK_USER_INPUT
};
var $096eed2d25f26114$export$ff33c64c78e35b2b = 'data-dd-privacy';
var $096eed2d25f26114$export$a5095f6ae8c6493c = 'allow';
var $096eed2d25f26114$export$faf6990c986cc1eb = 'mask';
var $096eed2d25f26114$export$b06f6b91aa78d012 = 'mask-user-input';
var $096eed2d25f26114$export$e41cc9b2bd72efb8 = 'hidden';
var $096eed2d25f26114$export$bee0efbfde2065b1 = 'dd-privacy-';
var $096eed2d25f26114$export$76054905c0914783 = '***';
var $096eed2d25f26114$export$4ab830af01a1bf7e = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var $096eed2d25f26114$export$b6dba6f930ee071f = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true
};
var $096eed2d25f26114$var$TEXT_MASKING_CHAR = 'x';
function $096eed2d25f26114$export$da439d4b145972be(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) return cache.get(node);
    var parentNode = (0, $390d7e44cf00bd59$export$4e12058fc4d51d56)(node);
    var parentNodePrivacyLevel = parentNode ? $096eed2d25f26114$export$da439d4b145972be(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = $096eed2d25f26114$export$c417e854a5c24a6f(node);
    var nodePrivacyLevel = $096eed2d25f26114$export$3e5e4c23b3787dea(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) cache.set(node, nodePrivacyLevel);
    return nodePrivacyLevel;
}
function $096eed2d25f26114$export$3e5e4c23b3787dea(childPrivacyLevel, parentNodePrivacyLevel) {
    switch(parentNodePrivacyLevel){
        // These values cannot be overridden
        case $096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch(childPrivacyLevel){
        case $096eed2d25f26114$export$92940eb5f25d0fc5.ALLOW:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.MASK:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.MASK_USER_INPUT:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
function $096eed2d25f26114$export$c417e854a5c24a6f(node) {
    // Only Element types can have a privacy level set
    if (!(0, $390d7e44cf00bd59$export$95fe5d3c5526a812)(node)) return;
    // Overrules for replay purpose
    if (node.tagName === 'BASE') return $096eed2d25f26114$export$92940eb5f25d0fc5.ALLOW;
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') return $096eed2d25f26114$export$92940eb5f25d0fc5.MASK;
        if (inputElement.type === 'hidden') return $096eed2d25f26114$export$92940eb5f25d0fc5.MASK;
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year/new-password/current-password]
        if (autocomplete && (autocomplete.startsWith('cc-') || autocomplete.endsWith('-password'))) return $096eed2d25f26114$export$92940eb5f25d0fc5.MASK;
    }
    // Check HTML privacy attributes and classes
    if ((0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(node, $096eed2d25f26114$export$8af88c85d388edd6($096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN))) return $096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN;
    if ((0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(node, $096eed2d25f26114$export$8af88c85d388edd6($096eed2d25f26114$export$92940eb5f25d0fc5.MASK))) return $096eed2d25f26114$export$92940eb5f25d0fc5.MASK;
    if ((0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(node, $096eed2d25f26114$export$8af88c85d388edd6($096eed2d25f26114$export$92940eb5f25d0fc5.MASK_USER_INPUT))) return $096eed2d25f26114$export$92940eb5f25d0fc5.MASK_USER_INPUT;
    if ((0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(node, $096eed2d25f26114$export$8af88c85d388edd6($096eed2d25f26114$export$92940eb5f25d0fc5.ALLOW))) return $096eed2d25f26114$export$92940eb5f25d0fc5.ALLOW;
    if ($096eed2d25f26114$export$15d4213dc9444b1(node)) return $096eed2d25f26114$export$92940eb5f25d0fc5.IGNORE;
}
function $096eed2d25f26114$export$f97c617afddc1089(node, privacyLevel) {
    switch(privacyLevel){
        case $096eed2d25f26114$export$92940eb5f25d0fc5.MASK:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN:
        case $096eed2d25f26114$export$92940eb5f25d0fc5.IGNORE:
            return true;
        case $096eed2d25f26114$export$92940eb5f25d0fc5.MASK_USER_INPUT:
            return (0, $390d7e44cf00bd59$export$ccbedd67ef6e9417)(node) ? $096eed2d25f26114$var$isFormElement(node.parentNode) : $096eed2d25f26114$var$isFormElement(node);
        default:
            return false;
    }
}
function $096eed2d25f26114$var$isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
    var element = node;
    if (element.tagName === 'INPUT') switch(element.type){
        case 'button':
        case 'color':
        case 'reset':
        case 'submit':
            return false;
    }
    return !!$096eed2d25f26114$export$b6dba6f930ee071f[element.tagName];
}
var $096eed2d25f26114$export$7aa14ef9d0a56a45 = function(text) {
    return text.replace(/\S/g, $096eed2d25f26114$var$TEXT_MASKING_CHAR);
};
function $096eed2d25f26114$export$132e79e4118a78e0(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) return;
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) // For perf reasons, we don't record script (heuristic)
    textContent = $096eed2d25f26114$export$76054905c0914783;
    else if (nodePrivacyLevel === $096eed2d25f26114$export$92940eb5f25d0fc5.HIDDEN) // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = $096eed2d25f26114$export$76054905c0914783;
    else if ($096eed2d25f26114$export$f97c617afddc1089(textNode, nodePrivacyLevel)) {
        if (// Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) return;
        } else if (parentTagName === 'OPTION') // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
        textContent = $096eed2d25f26114$export$76054905c0914783;
        else textContent = $096eed2d25f26114$export$7aa14ef9d0a56a45(textContent);
    }
    return textContent;
}
function $096eed2d25f26114$export$15d4213dc9444b1(element) {
    if (element.nodeName === 'SCRIPT') return true;
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return(// Link as script - Ignore only when rel=preload, modulepreload or prefetch
        /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script' || // Favicons
        relAttribute === 'shortcut icon' || relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return(// Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' || // Description
        nameAttribute === 'keywords' || nameAttribute === 'description' || // Social
        /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' || // Robots
        nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
        // X-Translated-By
        element.hasAttribute('http-equiv') || // Authorship
        nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || // Verification
        nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
function $096eed2d25f26114$export$8af88c85d388edd6(privacyLevel) {
    return "[".concat($096eed2d25f26114$export$ff33c64c78e35b2b, "=\"").concat(privacyLevel, "\"], .").concat($096eed2d25f26114$export$bee0efbfde2065b1).concat(privacyLevel);
}


var $19d85f6358de8c0d$export$e3a045a56698d3f9 = 'data-dd-action-name';
var $19d85f6358de8c0d$export$23b90ecb4143a9ad = 'Masked Element';
function $19d85f6358de8c0d$export$9c46f8d96b9f088f(element, _a, nodePrivacyLevel) {
    var enablePrivacyForActionName = _a.enablePrivacyForActionName, userProgrammaticAttribute = _a.actionNameAttribute;
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, if privacy is set to mask, return a placeholder for the undefined.
    // * if privacy is not set to mask, use strategies that are known to return good results.
    //   Those strategies will be used on the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    var defaultActionName = $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, $19d85f6358de8c0d$export$e3a045a56698d3f9) || userProgrammaticAttribute && $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
    if (defaultActionName) return {
        name: defaultActionName,
        nameSource: "custom_attribute" /* ActionNameSource.CUSTOM_ATTRIBUTE */ 
    };
    else if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).MASK) return {
        name: $19d85f6358de8c0d$export$23b90ecb4143a9ad,
        nameSource: "mask_placeholder" /* ActionNameSource.MASK_PLACEHOLDER */ 
    };
    return $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, userProgrammaticAttribute, $19d85f6358de8c0d$var$priorityStrategies, enablePrivacyForActionName) || $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(element, userProgrammaticAttribute, $19d85f6358de8c0d$var$fallbackStrategies, enablePrivacyForActionName) || {
        name: '',
        nameSource: "blank" /* ActionNameSource.BLANK */ 
    };
}
function $19d85f6358de8c0d$var$getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if ($19d85f6358de8c0d$var$supportsElementClosest()) elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    else {
        var element = targetElement;
        while(element){
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = (0, $d84da87a5bdc7a20$export$169e5491001d3ed6)(element);
        }
    }
    if (!elementWithAttribute) return;
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(name.trim()));
}
var $19d85f6358de8c0d$var$priorityStrategies = [
    // associated LABEL text
    function(element, userProgrammaticAttribute, privacy) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if ($19d85f6358de8c0d$var$supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element.labels[0], userProgrammaticAttribute);
        } else if (element.id) {
            var label = element.ownerDocument && (0, $b287859a2cd2eacd$export$71aa6c912b956294)(element.ownerDocument.querySelectorAll('label'), function(label) {
                return label.htmlFor === element.id;
            });
            return label && $19d85f6358de8c0d$var$getActionNameFromTextualContent(label, userProgrammaticAttribute, privacy);
        }
    },
    // INPUT button (and associated) value
    function(element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') return {
                name: input.value,
                nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
            };
        }
    },
    // BUTTON, LABEL or button-like element text
    function(element, userProgrammaticAttribute, privacyEnabledActionName) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    },
    function(element) {
        return $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'aria-label');
    },
    // associated element text designated by the aria-labelledby attribute
    function(element, userProgrammaticAttribute, privacyEnabledActionName) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) return {
            name: labelledByAttribute.split(/\s+/).map(function(id) {
                return $19d85f6358de8c0d$var$getElementById(element, id);
            }).filter(function(label) {
                return Boolean(label);
            }).map(function(element) {
                return $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
            }).join(' '),
            nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
        };
    },
    function(element) {
        return $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'alt');
    },
    function(element) {
        return $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'name');
    },
    function(element) {
        return $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'title');
    },
    function(element) {
        return $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, 'placeholder');
    },
    // SELECT first OPTION text
    function(element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element.options[0], userProgrammaticAttribute);
    }
];
var $19d85f6358de8c0d$var$fallbackStrategies = [
    function(element, userProgrammaticAttribute, privacyEnabledActionName) {
        return $19d85f6358de8c0d$var$getActionNameFromTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    }
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */ var $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER = 10;
function $19d85f6358de8c0d$var$getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies, privacyEnabledActionName) {
    var element = targetElement;
    var recursionCounter = 0;
    while(recursionCounter <= $19d85f6358de8c0d$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD'){
        for(var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++){
            var strategy = strategies_1[_i];
            var actionName = strategy(element, userProgrammaticAttribute, privacyEnabledActionName);
            if (actionName) {
                var name_1 = actionName.name, nameSource = actionName.nameSource;
                var trimmedName = name_1 && name_1.trim();
                if (trimmedName) return {
                    name: $19d85f6358de8c0d$var$truncate($19d85f6358de8c0d$var$normalizeWhitespace(trimmedName)),
                    nameSource: nameSource
                };
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') break;
        element = (0, $d84da87a5bdc7a20$export$169e5491001d3ed6)(element);
        recursionCounter += 1;
    }
}
function $19d85f6358de8c0d$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function $19d85f6358de8c0d$var$truncate(s) {
    return s.length > 100 ? "".concat((0, $01b8047924249a5c$export$b26462d2f74496cd)(s, 100), " [...]") : s;
}
function $19d85f6358de8c0d$var$getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $19d85f6358de8c0d$var$getActionNameFromStandardAttribute(element, attribute) {
    return {
        name: element.getAttribute(attribute) || '',
        nameSource: "standard_attribute" /* ActionNameSource.STANDARD_ATTRIBUTE */ 
    };
}
function $19d85f6358de8c0d$var$getActionNameFromTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
    return {
        name: $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) || '',
        nameSource: "text_content" /* ActionNameSource.TEXT_CONTENT */ 
    };
}
function $19d85f6358de8c0d$var$getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
    if (element.isContentEditable) return;
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function(query) {
            var list = element.querySelectorAll(query);
            for(var index = 0; index < list.length; index += 1){
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) text_1 = text_1.replace(textToReplace, '');
                }
            }
        };
        if (!$19d85f6358de8c0d$var$supportsInnerTextScriptAndStyleRemoval()) // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
        // be relatively fast and work in most cases.
        removeTextFromElements('script, style');
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat($19d85f6358de8c0d$export$e3a045a56698d3f9, "]"));
        if (userProgrammaticAttribute) removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        if (privacyEnabledActionName) // remove the text of elements with privacy override
        removeTextFromElements("".concat((0, $096eed2d25f26114$export$8af88c85d388edd6)((0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN), ", ").concat((0, $096eed2d25f26114$export$8af88c85d388edd6)((0, $096eed2d25f26114$export$92940eb5f25d0fc5).MASK)));
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */ function $19d85f6358de8c0d$var$supportsInnerTextScriptAndStyleRemoval() {
    return !(0, $3d758b2023765aca$export$7e7b1a9668aaed8)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $19d85f6358de8c0d$var$supportsLabelPropertyResult;
function $19d85f6358de8c0d$var$supportsLabelProperty() {
    if ($19d85f6358de8c0d$var$supportsLabelPropertyResult === undefined) $19d85f6358de8c0d$var$supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    return $19d85f6358de8c0d$var$supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $19d85f6358de8c0d$var$supportsElementClosestResult;
function $19d85f6358de8c0d$var$supportsElementClosest() {
    if ($19d85f6358de8c0d$var$supportsElementClosestResult === undefined) $19d85f6358de8c0d$var$supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    return $19d85f6358de8c0d$var$supportsElementClosestResult;
}


var $f53c969915647662$export$4ab9e1b4853d6dd7 = [
    (0, $19d85f6358de8c0d$export$e3a045a56698d3f9),
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file'
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$var$getIDSelector
];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    $f53c969915647662$var$getStableAttributeSelector,
    $f53c969915647662$var$getClassSelector,
    $f53c969915647662$var$getTagNameSelector
];
function $f53c969915647662$export$2a298c6a007e5e40(targetElement, actionNameAttribute) {
    if (!$f53c969915647662$var$isConnected(targetElement)) // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
    var targetElementSelector;
    var currentElement = targetElement;
    while(currentElement && currentElement.nodeName !== 'HTML'){
        var globallyUniqueSelector = $f53c969915647662$var$findSelector(currentElement, $f53c969915647662$var$GLOBALLY_UNIQUE_SELECTOR_GETTERS, $f53c969915647662$var$isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) return globallyUniqueSelector;
        var uniqueSelectorAmongChildren = $f53c969915647662$var$findSelector(currentElement, $f53c969915647662$var$UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, $f53c969915647662$export$feed9c87b437f926, actionNameAttribute, targetElementSelector);
        targetElementSelector = uniqueSelectorAmongChildren || $f53c969915647662$var$combineSelector($f53c969915647662$var$getPositionSelector(currentElement), targetElementSelector);
        currentElement = (0, $d84da87a5bdc7a20$export$169e5491001d3ed6)(currentElement);
    }
    return targetElementSelector;
}
function $f53c969915647662$var$isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time.
    return /[0-9]/.test(value);
}
function $f53c969915647662$var$getIDSelector(element) {
    if (element.id && !$f53c969915647662$var$isGeneratedValue(element.id)) return "#".concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.id));
}
function $f53c969915647662$var$getClassSelector(element) {
    if (element.tagName === 'BODY') return;
    var classList = (0, $d84da87a5bdc7a20$export$4b3def1d4726a17a)(element);
    for(var i = 0; i < classList.length; i += 1){
        var className = classList[i];
        if ($f53c969915647662$var$isGeneratedValue(className)) continue;
        return "".concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.tagName), ".").concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(className));
    }
}
function $f53c969915647662$var$getTagNameSelector(element) {
    return (0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.tagName);
}
function $f53c969915647662$var$getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) return selector;
    }
    for(var _i = 0, STABLE_ATTRIBUTES_1 = $f53c969915647662$export$4ab9e1b4853d6dd7; _i < STABLE_ATTRIBUTES_1.length; _i++){
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) return selector;
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) return "".concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.tagName), "[").concat(attributeName, "=\"").concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.getAttribute(attributeName)), "\"]");
    }
}
function $f53c969915647662$var$getPositionSelector(element) {
    var sibling = (0, $d84da87a5bdc7a20$export$169e5491001d3ed6)(element).firstElementChild;
    var elementIndex = 1;
    while(sibling && sibling !== element){
        if (sibling.tagName === element.tagName) elementIndex += 1;
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function $f53c969915647662$var$findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for(var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++){
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) continue;
        if (predicate(element, elementSelector, childSelector)) return $f53c969915647662$var$combineSelector(elementSelector, childSelector);
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */ function $f53c969915647662$var$isSelectorUniqueGlobally(element, elementSelector, childSelector) {
    return element.ownerDocument.querySelectorAll($f53c969915647662$var$combineSelector(elementSelector, childSelector)).length === 1;
}
function $f53c969915647662$export$feed9c87b437f926(currentElement, currentElementSelector, childSelector) {
    var isSiblingMatching;
    if (childSelector === undefined) // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = function(sibling) {
        return (0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(sibling, currentElementSelector);
    };
    else {
        var scopedSelector_1 = $f53c969915647662$export$619938c02511e63c() ? $f53c969915647662$var$combineSelector("".concat(currentElementSelector, ":scope"), childSelector) : $f53c969915647662$var$combineSelector(currentElementSelector, childSelector);
        isSiblingMatching = function(sibling) {
            return sibling.querySelector(scopedSelector_1) !== null;
        };
    }
    var parent = (0, $d84da87a5bdc7a20$export$169e5491001d3ed6)(currentElement);
    var sibling = parent.firstElementChild;
    while(sibling){
        if (sibling !== currentElement && isSiblingMatching(sibling)) return false;
        sibling = sibling.nextElementSibling;
    }
    return true;
}
function $f53c969915647662$var$combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var $f53c969915647662$var$supportScopeSelectorCache;
function $f53c969915647662$export$619938c02511e63c() {
    if ($f53c969915647662$var$supportScopeSelectorCache === undefined) try {
        document.querySelector(':scope');
        $f53c969915647662$var$supportScopeSelectorCache = true;
    } catch (_a) {
        $f53c969915647662$var$supportScopeSelectorCache = false;
    }
    return $f53c969915647662$var$supportScopeSelectorCache;
}
/**
 * Polyfill-utility for the `isConnected` property not supported in IE11
 */ function $f53c969915647662$var$isConnected(element) {
    if ('isConnected' in // cast is to make sure `element` is not inferred as `never` after the check
    element) return element.isConnected;
    return element.ownerDocument.documentElement.contains(element);
}




var $951b8e01832faf5b$export$1505b1def7b874c6 = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $951b8e01832faf5b$export$30c5966f4862d434 = 100;
function $951b8e01832faf5b$export$864c62f6b0bc947(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */ ;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(dontAcceptMoreClick, $951b8e01832faf5b$export$1505b1def7b874c6);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */  && bufferedClicks.every(function(click) {
            return click.isStopped();
        })) {
            status = 2 /* ClickChainStatus.Finalized */ ;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */ ) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */ ;
            tryFinalize();
        }
    }
    return {
        tryAppend: function(click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */ ) return false;
            if (bufferedClicks.length > 0 && !$951b8e01832faf5b$var$areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function() {
            dontAcceptMoreClick();
        }
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */ function $951b8e01832faf5b$var$areEventsSimilar(first, second) {
    return first.target === second.target && $951b8e01832faf5b$var$mouseEventDistance(first, second) <= $951b8e01832faf5b$export$30c5966f4862d434 && first.timeStamp - second.timeStamp <= $951b8e01832faf5b$export$1505b1def7b874c6;
}
function $951b8e01832faf5b$var$mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}




function $b9826997efb4807d$export$8c9c528e477216a0(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
        scroll: false
    };
    var clickContext;
    var listeners = [
        (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */ , function(event) {
            if ($b9826997efb4807d$var$isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = $b9826997efb4807d$var$isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                    scroll: false
                };
                clickContext = onPointerDown(event);
            }
        }, {
            capture: true
        }),
        (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */ , function() {
            if (!selectionEmptyAtPointerDown || !$b9826997efb4807d$var$isSelectionEmpty()) userActivity.selection = true;
        }, {
            capture: true
        }),
        (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , function() {
            userActivity.scroll = true;
        }, {
            capture: true,
            passive: true
        }),
        (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */ , function(event) {
            if ($b9826997efb4807d$var$isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function() {
                    return localUserActivity_1;
                });
                clickContext = undefined;
            }
        }, {
            capture: true
        }),
        (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "input" /* DOM_EVENT.INPUT */ , function() {
            userActivity.input = true;
        }, {
            capture: true
        })
    ];
    return {
        stop: function() {
            listeners.forEach(function(listener) {
                return listener.stop();
            });
        }
    };
}
function $b9826997efb4807d$var$isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function $b9826997efb4807d$var$isValidPointerEvent(event) {
    return event.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
    // the future.
    event.isPrimary !== false;
}




var $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c(clicks, rageClick) {
    if ($adc75fc4cdc76a78$export$225704fb2a185e45(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */ );
        if (clicks.some($adc75fc4cdc76a78$export$e4a368a4d2e950a3)) rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */ );
        if (rageClick.hasError) rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */ );
        return {
            isRage: true
        };
    }
    var hasSelectionChanged = clicks.some(function(click) {
        return click.getUserActivity().selection;
    });
    clicks.forEach(function(click) {
        if (click.hasError) click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */ );
        if ($adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
        !hasSelectionChanged) click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */ );
    });
    return {
        isRage: false
    };
}
function $adc75fc4cdc76a78$export$225704fb2a185e45(clicks) {
    if (clicks.some(function(click) {
        return click.getUserActivity().selection || click.getUserActivity().scroll;
    })) return false;
    for(var i = 0; i < clicks.length - ($adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1){
        if (clicks[i + $adc75fc4cdc76a78$var$MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= (0, $fafd178883cb17fc$export$32c0454ceff7f92d)) return true;
    }
    return false;
}
var $adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR = // inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *';
function $adc75fc4cdc76a78$export$e4a368a4d2e950a3(click) {
    if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
    return !(0, $d84da87a5bdc7a20$export$c33a404b21a1fad3)(click.event.target, $adc75fc4cdc76a78$var$DEAD_CLICK_EXCLUDE_SELECTOR);
}



var $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3 = 10 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $20a93a7c6e2d8a89$export$921921d3d73df8fe = new Map();
function $20a93a7c6e2d8a89$export$54553eb1afcc5093(relativeTimestamp) {
    var selector = $20a93a7c6e2d8a89$export$921921d3d73df8fe.get(relativeTimestamp);
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.delete(relativeTimestamp);
    return selector;
}
function $20a93a7c6e2d8a89$export$49ad699d303b84c(relativeTimestamp, selector) {
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.set(relativeTimestamp, selector);
    $20a93a7c6e2d8a89$export$921921d3d73df8fe.forEach(function(_, relativeTimestamp) {
        if ((0, $fafd178883cb17fc$export$e04aa69d28450d55)(relativeTimestamp, (0, $fafd178883cb17fc$export$53cb631b087d9e92)()) > $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3) $20a93a7c6e2d8a89$export$921921d3d73df8fe.delete(relativeTimestamp);
    });
}


var $4ebccf53af8f3992$export$403157e9fa778fb6 = 5 * (0, $fafd178883cb17fc$export$35acaebf644db34e); // arbitrary
function $4ebccf53af8f3992$export$ce3e012cf7d342e2(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
    var history = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $4ebccf53af8f3992$export$403157e9fa778fb6
    });
    var stopObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var currentClickChain;
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        history.reset();
    });
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , stopClickChain);
    var stopActionEventsListener = (0, $b9826997efb4807d$export$8c9c528e477216a0)(configuration, {
        onPointerDown: function(pointerDownEvent) {
            return $4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable);
        },
        onPointerUp: function(_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        }
    }).stop;
    var actionContexts = {
        findActionId: function(startTime) {
            return history.findAll(startTime);
        }
    };
    return {
        stop: function() {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = (0, $951b8e01832faf5b$export$864c62f6b0bc947)(click, function(clicks) {
                $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) currentClickChain.stop();
    }
}
function $4ebccf53af8f3992$var$processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
    var nodePrivacyLevel = configuration.enablePrivacyForActionName ? (0, $096eed2d25f26114$export$da439d4b145972be)(pointerDownEvent.target, configuration.defaultPrivacyLevel) : (0, $096eed2d25f26114$export$92940eb5f25d0fc5).ALLOW;
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN) return undefined;
    var clickActionBase = $4ebccf53af8f3992$var$computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
    var hadActivityOnPointerDown = false;
    (0, $56392c0d6d718cf0$export$4a886e0e421b0302)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, function(pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    (0, $56392c0d6d718cf0$export$a59477b089b98865));
    return {
        clickActionBase: clickActionBase,
        hadActivityOnPointerDown: function() {
            return hadActivityOnPointerDown;
        }
    };
}
function $4ebccf53af8f3992$var$startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var _a;
    var click = $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    var selector = (_a = clickActionBase === null || clickActionBase === void 0 ? void 0 : clickActionBase.target) === null || _a === void 0 ? void 0 : _a.selector;
    if (selector) (0, $20a93a7c6e2d8a89$export$49ad699d303b84c)(startEvent.timeStamp, selector);
    var stopWaitPageActivityEnd = (0, $56392c0d6d718cf0$export$4a886e0e421b0302)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, function(pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) // If the clock is looking weird, just discard the click
        click.discard();
        else {
            if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
            else if (hadActivityOnPointerDown()) click.stop(// using the click start as activity end, so the click will have some activity but its
            // duration will be 0 (as the activity started before the click start)
            click.startClocks.timeStamp);
            else click.stop();
        }
    }, (0, $20a93a7c6e2d8a89$export$9ecdfc5cb82b78f3)).stop;
    var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function() {
        click.stop();
    });
    click.stopObservable.subscribe(function() {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function $4ebccf53af8f3992$var$computeClickActionBase(event, nodePrivacyLevel, configuration) {
    var rect = event.target.getBoundingClientRect();
    var selector = (0, $f53c969915647662$export$2a298c6a007e5e40)(event.target, configuration.actionNameAttribute);
    if (selector) (0, $20a93a7c6e2d8a89$export$49ad699d303b84c)(event.timeStamp, selector);
    var actionName = (0, $19d85f6358de8c0d$export$9c46f8d96b9f088f)(event.target, configuration, nodePrivacyLevel);
    return {
        type: "click" /* ActionType.CLICK */ ,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: selector
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top)
        },
        name: actionName.name,
        nameSource: actionName.nameSource
    };
}
function $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0, $01b8047924249a5c$export$e73c8bd0f20705a)();
    var startClocks = (0, $fafd178883cb17fc$export$67898643147706d3)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = (0, $0b00b19bfaa2355c$export$a50549f6fbbed49b)({
        lifeCycle: lifeCycle,
        isChildEvent: function(event) {
            return event.action !== undefined && (Array.isArray(event.action.id) ? (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(event.action.id, id) : event.action.id === id);
        }
    });
    var status = 0 /* ClickStatus.ONGOING */ ;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */ ) return;
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */ ;
        if (activityEndTime) historyEntry.close((0, $fafd178883cb17fc$export$493c11ff22f45a24)(activityEndTime));
        else historyEntry.remove();
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError () {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity () {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function(frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function() {
            return status === 1 /* ClickStatus.STOPPED */  || status === 2 /* ClickStatus.FINALIZED */ ;
        },
        clone: function() {
            return $4ebccf53af8f3992$var$newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
        },
        validate: function(domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */ ) return;
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
                type: "click" /* ActionType.CLICK */ ,
                duration: activityEndTime && (0, $fafd178883cb17fc$export$e04aa69d28450d55)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [
                    startEvent
                ],
                event: startEvent
            }, clickActionBase);
            lifeCycle.notify(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , clickAction);
            status = 2 /* ClickStatus.FINALIZED */ ;
        },
        discard: function() {
            stop();
            status = 2 /* ClickStatus.FINALIZED */ ;
        }
    };
}
function $4ebccf53af8f3992$export$4e2c2102bb4a32e4(clicks, rageClick) {
    var isRage = (0, $adc75fc4cdc76a78$export$bd2d8b95c6d3b36c)(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function(click) {
            return click.discard();
        });
        rageClick.stop((0, $fafd178883cb17fc$export$71f52cdbbf629086)());
        rageClick.validate(clicks.map(function(click) {
            return click.event;
        }));
    } else {
        rageClick.discard();
        clicks.forEach(function(click) {
            return click.validate();
        });
    }
}


function $8258e1e2c7bf35c9$export$195095f773513078(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageStateHistory) {
    var _a;
    lifeCycle.subscribe(0 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */ , function(action) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory));
    });
    var actionContexts = {
        findActionId: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var stop = (0, $772566d0dfa3645c$export$8793edee2d425525);
    if (configuration.trackUserInteractions) _a = (0, $4ebccf53af8f3992$export$ce3e012cf7d342e2)(lifeCycle, domMutationObservable, windowOpenObservable, configuration), actionContexts = _a.actionContexts, stop = _a.stop;
    return {
        addAction: function(action, savedCommonContext) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
                savedCommonContext: savedCommonContext
            }, $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
        stop: stop
    };
}
function $8258e1e2c7bf35c9$var$processAction(action, pageStateHistory) {
    var autoActionProperties = $8258e1e2c7bf35c9$var$isAutoAction(action) ? {
        action: {
            id: action.id,
            loading_time: (0, $fc3b94d36e42b5cc$export$e8fc7a7e81732139)((0, $fafd178883cb17fc$export$cc7917ebd320fa93)(action.duration)),
            frustration: {
                type: action.frustrationTypes
            },
            error: {
                count: action.counts.errorCount
            },
            long_task: {
                count: action.counts.longTaskCount
            },
            resource: {
                count: action.counts.resourceCount
            }
        },
        _dd: {
            action: {
                target: action.target,
                position: action.position,
                name_source: (0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).ACTION_NAME_MASKING) ? action.nameSource : undefined
            }
        }
    } : undefined;
    var customerContext = !$8258e1e2c7bf35c9$var$isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)({
        action: {
            id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
            target: {
                name: action.name
            },
            type: action.type
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */ ,
        view: {
            in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */ , action.startClocks.relative)
        }
    }, autoActionProperties);
    var domainContext = $8258e1e2c7bf35c9$var$isAutoAction(action) ? {
        events: action.events
    } : {};
    if (!$8258e1e2c7bf35c9$var$isAutoAction(action) && action.handlingStack) domainContext.handlingStack = action.handlingStack;
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: domainContext
    };
}
function $8258e1e2c7bf35c9$var$isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */ ;
}







function $0b12bee99c6c13be$export$5f76c2084a9e04d(errorObservable) {
    var handleRuntimeError = function(stackTrace, originalError) {
        var rawError = (0, $35957bb00d7299b7$export$b8dc46b79c72ee26)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */ ,
            source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = $0b12bee99c6c13be$export$f636584f9e54fd1(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = $0b12bee99c6c13be$export$fac10d06c5b5cb33(handleRuntimeError).stop;
    return {
        stop: function() {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        }
    };
}
function $0b12bee99c6c13be$export$f636584f9e54fd1(callback) {
    return (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(window, 'onerror', function(_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if ((0, $35957bb00d7299b7$export$e6127cc7fe7395c3)(errorObj)) stackTrace = (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(errorObj);
        else stackTrace = (0, $24e0e8626c2d0274$export$e8e53f0e2ff18afa)(messageObj, url, line, column);
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function $0b12bee99c6c13be$export$fac10d06c5b5cb33(callback) {
    return (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(window, 'onunhandledrejection', function(_a) {
        var e = _a.parameters[0];
        var reason = e.reason || 'Empty reason';
        var stack = (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(reason);
        callback(stack, reason);
    });
}













var $90f50905b5952746$var$consoleObservablesByApi = {};
function $90f50905b5952746$export$688fb0189cfcddd4(apis) {
    var consoleObservables = apis.map(function(api) {
        if (!$90f50905b5952746$var$consoleObservablesByApi[api]) $90f50905b5952746$var$consoleObservablesByApi[api] = $90f50905b5952746$var$createConsoleObservable(api); // we are sure that the observable created for this api will yield the expected ConsoleLog type
        return $90f50905b5952746$var$consoleObservablesByApi[api];
    });
    return (0, $34a3791423ee474f$export$ca54b410f15f44fe).apply(void 0, consoleObservables);
}
function $90f50905b5952746$export$1356159d86f98c58() {
    $90f50905b5952746$var$consoleObservablesByApi = {};
}
function $90f50905b5952746$var$createConsoleObservable(api) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var originalConsoleApi = (0, $429fd8a62f4aa1b2$export$d07b2d1b8b601164)[api];
        (0, $429fd8a62f4aa1b2$export$d07b2d1b8b601164)[api] = function() {
            var params = [];
            for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, $4ac782ea9e4e9601$export$46c2cbbc853cd95b)();
            (0, $1d6ff96621fb36bb$export$b69eb0f8afebfb6d)(function() {
                observable.notify($90f50905b5952746$var$buildConsoleLog(params, api, handlingStack));
            });
        };
        return function() {
            (0, $429fd8a62f4aa1b2$export$d07b2d1b8b601164)[api] = originalConsoleApi;
        };
    });
}
function $90f50905b5952746$var$buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function(param) {
        return $90f50905b5952746$var$formatConsoleParameters(param);
    }).join(' ');
    var error;
    if (api === (0, $429fd8a62f4aa1b2$export$d37676e8a94e6b40).error) {
        var firstErrorParam = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(params, (0, $35957bb00d7299b7$export$e6127cc7fe7395c3));
        error = {
            stack: firstErrorParam ? (0, $4ac782ea9e4e9601$export$36ad41d7075a6f2b)((0, $24e0e8626c2d0274$export$81296eded4f2ac09)(firstErrorParam)) : undefined,
            fingerprint: (0, $35957bb00d7299b7$export$1c18937f21a7f1f7)(firstErrorParam),
            causes: firstErrorParam ? (0, $35957bb00d7299b7$export$bf9a979d43c83a9)(firstErrorParam, 'console') : undefined,
            startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)(),
            message: message,
            source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */ ,
            handlingStack: handlingStack
        };
    }
    return {
        api: api,
        message: message,
        error: error,
        handlingStack: handlingStack
    };
}
function $90f50905b5952746$var$formatConsoleParameters(param) {
    if (typeof param === 'string') return (0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(param);
    if ((0, $35957bb00d7299b7$export$e6127cc7fe7395c3)(param)) return (0, $4ac782ea9e4e9601$export$5201d50a34753d71)((0, $24e0e8626c2d0274$export$81296eded4f2ac09)(param));
    return (0, $169208b8dc904506$export$1f8609334739c2b6)((0, $15a562dd6816cf15$export$83d2e9e3e4ee39ed)(param), undefined, 2);
}


function $eeb45063442903a5$export$fe4ab68ea26fba82(errorObservable) {
    var subscription = (0, $90f50905b5952746$export$688fb0189cfcddd4)([
        (0, $429fd8a62f4aa1b2$export$d37676e8a94e6b40).error
    ]).subscribe(function(consoleLog) {
        return errorObservable.notify(consoleLog.error);
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        }
    };
}










var $2bdce5556b3f551d$export$1bd494ac7adbb6ce = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation'
};
function $2bdce5556b3f551d$export$645a986d81bb5490(configuration, apis) {
    var observables = [];
    if ((0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(apis, $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation)) observables.push($2bdce5556b3f551d$var$createCspViolationReportObservable(configuration));
    var reportTypes = apis.filter(function(api) {
        return api !== $2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation;
    });
    if (reportTypes.length) observables.push($2bdce5556b3f551d$var$createReportObservable(reportTypes));
    return (0, $34a3791423ee474f$export$ca54b410f15f44fe).apply(void 0, observables);
}
function $2bdce5556b3f551d$var$createReportObservable(reportTypes) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        if (!window.ReportingObserver) return;
        var handleReports = (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(reports, _) {
            return reports.forEach(function(report) {
                return observable.notify($2bdce5556b3f551d$var$buildRawReportErrorFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true
        });
        observer.observe();
        return function() {
            observer.disconnect();
        };
    });
}
function $2bdce5556b3f551d$var$createCspViolationReportObservable(configuration) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var stop = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */ , function(event) {
            observable.notify($2bdce5556b3f551d$var$buildRawReportErrorFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function $2bdce5556b3f551d$var$buildRawReportErrorFromReport(report) {
    var type = report.type, body = report.body;
    return $2bdce5556b3f551d$var$buildRawReportError({
        type: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalError: report,
        stack: $2bdce5556b3f551d$var$buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
    });
}
function $2bdce5556b3f551d$var$buildRawReportErrorFromCspViolation(event) {
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return $2bdce5556b3f551d$var$buildRawReportError({
        type: event.effectiveDirective,
        message: "".concat($2bdce5556b3f551d$export$1bd494ac7adbb6ce.cspViolation, ": ").concat(message),
        originalError: event,
        csp: {
            disposition: event.disposition
        },
        stack: $2bdce5556b3f551d$var$buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, " of the policy \"").concat((0, $01b8047924249a5c$export$b26462d2f74496cd)(event.originalPolicy, 100, '...'), "\"") : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber)
    });
}
function $2bdce5556b3f551d$var$buildRawReportError(partial) {
    return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)(),
        source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).REPORT,
        handling: "unhandled" /* ErrorHandling.UNHANDLED */ 
    }, partial);
}
function $2bdce5556b3f551d$var$buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile ? (0, $4ac782ea9e4e9601$export$36ad41d7075a6f2b)({
        name: name,
        message: message,
        stack: [
            {
                func: '?',
                url: sourceFile,
                line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
            }
        ]
    }) : undefined;
}


function $f87c07eca9e767df$export$532a6c6a36756d07(configuration, errorObservable) {
    var subscription = (0, $2bdce5556b3f551d$export$645a986d81bb5490)(configuration, [
        (0, $2bdce5556b3f551d$export$1bd494ac7adbb6ce).cspViolation,
        (0, $2bdce5556b3f551d$export$1bd494ac7adbb6ce).intervention
    ]).subscribe(function(rawError) {
        return errorObservable.notify(rawError);
    });
    return {
        stop: function() {
            subscription.unsubscribe();
        }
    };
}


function $f95b485e6c21537b$export$243c2bf7ff6b9330(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    (0, $eeb45063442903a5$export$fe4ab68ea26fba82)(errorObservable);
    (0, $0b12bee99c6c13be$export$5f76c2084a9e04d)(errorObservable);
    (0, $f87c07eca9e767df$export$532a6c6a36756d07)(configuration, errorObservable);
    errorObservable.subscribe(function(error) {
        return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
    });
    return $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle, pageStateHistory, featureFlagContexts);
}
function $f95b485e6c21537b$export$87a10e29a48f580b(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , function(_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext
        }, $f95b485e6c21537b$var$processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function(_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = (0, $35957bb00d7299b7$export$e6127cc7fe7395c3)(error) ? (0, $24e0e8626c2d0274$export$81296eded4f2ac09)(error) : undefined;
            var rawError = (0, $35957bb00d7299b7$export$b8dc46b79c72ee26)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */ ,
                source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */ 
            });
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError
            });
        }
    };
}
function $f95b485e6c21537b$var$processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
            csp: error.csp
        },
        type: "error" /* RumEventType.ERROR */ ,
        view: {
            in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */ , error.startClocks.relative)
        }
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(featureFlagContext)) rawRumEvent.feature_flags = featureFlagContext;
    var domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: domainContext
    };
}




function $ffa26d5dc219f735$export$52c09388c428dadc(lifeCycle, configuration) {
    var performanceLongTaskSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LONG_TASK,
        buffered: true
    }).subscribe(function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.entryType !== (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LONG_TASK) break;
            if (!configuration.trackLongTasks) break;
            var startClocks = (0, $fafd178883cb17fc$export$6d554362ef4543f2)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
                    entry_type: "long-task" /* RumLongTaskEntryType.LONG_TASK */ ,
                    duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.duration)
                },
                type: "long_task" /* RumEventType.LONG_TASK */ ,
                _dd: {
                    discarded: false
                }
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: {
                    performanceEntry: entry
                }
            });
        }
    });
    return {
        stop: function() {
            performanceLongTaskSubscription.unsubscribe();
        }
    };
}






function $d205e1c6fda43570$export$9288a5d956b3efbe(callback, opts) {
    // Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(callback), opts);
        return function() {
            return window.cancelIdleCallback(id_1);
        };
    }
    return $d205e1c6fda43570$export$fc768205f0931253(callback);
}
var $d205e1c6fda43570$export$37cda3af96f93c33 = 50;
function $d205e1c6fda43570$export$fc768205f0931253(callback) {
    var start = (0, $fafd178883cb17fc$export$ceae11818251d43c)();
    var timeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
        callback({
            didTimeout: false,
            timeRemaining: function() {
                return Math.max(0, $d205e1c6fda43570$export$37cda3af96f93c33 - ((0, $fafd178883cb17fc$export$ceae11818251d43c)() - start));
            }
        });
    }, 0);
    return function() {
        return (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(timeoutId);
    };
}


/**
 * Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
 * before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
 * the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
 * performance.
 */ var $5c3b6dadc4a2654c$var$IDLE_CALLBACK_TIMEOUT = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $5c3b6dadc4a2654c$export$85114d25709d11dc = 30;
function $5c3b6dadc4a2654c$export$e1c4294b917c2b7b() {
    var pendingTasks = [];
    function run(deadline) {
        var executionTimeRemaining;
        if (deadline.didTimeout) {
            var start_1 = performance.now();
            executionTimeRemaining = function() {
                return $5c3b6dadc4a2654c$export$85114d25709d11dc - (performance.now() - start_1);
            };
        } else executionTimeRemaining = deadline.timeRemaining.bind(deadline);
        while(executionTimeRemaining() > 0 && pendingTasks.length)pendingTasks.shift()();
        if (pendingTasks.length) scheduleNextRun();
    }
    function scheduleNextRun() {
        (0, $d205e1c6fda43570$export$9288a5d956b3efbe)(run, {
            timeout: $5c3b6dadc4a2654c$var$IDLE_CALLBACK_TIMEOUT
        });
    }
    return {
        push: function(task) {
            if (pendingTasks.push(task) === 1) scheduleNextRun();
        }
    };
}







var $cb156ef466274200$var$alreadyMatchedEntries = new (0, $d84da87a5bdc7a20$export$c0627e557a270ad)();
function $cb156ef466274200$export$daf52a30543584f(request) {
    if (!performance || !('getEntriesByName' in performance)) return;
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) return;
    var candidates = sameNameEntries.filter(function(entry) {
        return !$cb156ef466274200$var$alreadyMatchedEntries.has(entry);
    }).filter(function(entry) {
        return (0, $b22ed8845addf22a$export$bb48f5f5ee2d8ac6)(entry) && (0, $b22ed8845addf22a$export$c07d151c23cfeb06)(entry);
    }).filter(function(entry) {
        return $cb156ef466274200$var$isBetween(entry, request.startClocks.relative, $cb156ef466274200$var$endTime({
            startTime: request.startClocks.relative,
            duration: request.duration
        }));
    });
    if (candidates.length === 1) {
        $cb156ef466274200$var$alreadyMatchedEntries.add(candidates[0]);
        return candidates[0].toJSON();
    }
    return;
}
function $cb156ef466274200$var$endTime(timing) {
    return (0, $fafd178883cb17fc$export$c0c581816dedfc70)(timing.startTime, timing.duration);
}
function $cb156ef466274200$var$isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && $cb156ef466274200$var$endTime(timing) <= (0, $fafd178883cb17fc$export$c0c581816dedfc70)(end, errorMargin);
}





function $6c090d2d29937490$export$12cb733fc911e4f7(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
        return {
            stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
        };
    }
    var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */  : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */ ;
    return (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, eventName, callback, {
        once: true
    });
}





var $9546088253798c5a$export$f1b0e1c95ecb6961 = 2 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $9546088253798c5a$export$9600d3c1068ac02c(document) {
    var data = $9546088253798c5a$export$cabe353a895a405f(document) || $9546088253798c5a$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= (0, $fafd178883cb17fc$export$ceae11818251d43c)() - $9546088253798c5a$export$f1b0e1c95ecb6961) return undefined;
    return data.traceId;
}
function $9546088253798c5a$export$cabe353a895a405f(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return $9546088253798c5a$export$10b75f215ee15e0e(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function $9546088253798c5a$export$70f194456d3a8998(document) {
    var comment = $9546088253798c5a$export$4d376e42fa08c24d(document);
    if (!comment) return undefined;
    return $9546088253798c5a$export$10b75f215ee15e0e((0, $01b8047924249a5c$export$fe87bb5193f3e70)(comment, 'trace-id'), (0, $01b8047924249a5c$export$fe87bb5193f3e70)(comment, 'trace-time'));
}
function $9546088253798c5a$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return undefined;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $9546088253798c5a$export$4d376e42fa08c24d(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for(var i = 0; i < document.childNodes.length; i += 1){
        var comment = $9546088253798c5a$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) for(var i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        var node = document.body.childNodes[i];
        var comment = $9546088253798c5a$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!(0, $390d7e44cf00bd59$export$ccbedd67ef6e9417)(node)) break;
    }
}
function $9546088253798c5a$var$getTraceCommentFromNode(node) {
    if (node && (0, $390d7e44cf00bd59$export$575485136eb1b1f)(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) return match[1];
    }
}




function $31e2242c7dc25f3b$export$6431553786c94949() {
    if ((0, $a45e320ac0fe2c4f$export$c6967607cdac15e8)((0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).NAVIGATION)) {
        var navigationEntry = performance.getEntriesByType((0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).NAVIGATION)[0];
        if (navigationEntry) return navigationEntry;
    }
    var timings = $31e2242c7dc25f3b$export$feb5c3ed98a58355();
    var entry = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        entryType: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).NAVIGATION,
        initiatorType: 'navigation',
        name: window.location.href,
        startTime: 0,
        duration: timings.responseEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: function() {
            return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, entry, {
                toJSON: undefined
            });
        }
    }, timings);
    return entry;
}
function $31e2242c7dc25f3b$export$feb5c3ed98a58355() {
    var result = {};
    var timing = performance.timing;
    for(var key in timing)if ((0, $89f5cd41be2839b1$export$7e4aa119212bc614)(timing[key])) {
        var numberKey = key;
        var timingElement = timing[numberKey];
        result[numberKey] = timingElement === 0 ? 0 : (0, $fafd178883cb17fc$export$493c11ff22f45a24)(timingElement);
    }
    return result;
}



function $cc7f465fe0e06d73$export$7eb7526e9416e27a(configuration, callback) {
    (0, $6c090d2d29937490$export$12cb733fc911e4f7)(configuration, 'interactive', function() {
        var entry = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)((0, $31e2242c7dc25f3b$export$6431553786c94949)().toJSON(), {
            entryType: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).RESOURCE,
            initiatorType: (0, $b22ed8845addf22a$export$dc5d43db6d9a2bce),
            traceId: (0, $9546088253798c5a$export$9600d3c1068ac02c)(document),
            toJSON: function() {
                return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, entry, {
                    toJSON: undefined
                });
            }
        });
        callback(entry);
    });
}


function $372bb1efffad81cc$export$7a0c7e0d79d84977(lifeCycle, configuration, pageStateHistory, taskQueue, retrieveInitialDocumentResourceTimingImpl) {
    if (taskQueue === void 0) taskQueue = (0, $5c3b6dadc4a2654c$export$e1c4294b917c2b7b)();
    if (retrieveInitialDocumentResourceTimingImpl === void 0) retrieveInitialDocumentResourceTimingImpl = (0, $cc7f465fe0e06d73$export$7eb7526e9416e27a);
    lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */ , function(request) {
        handleResource(function() {
            return $372bb1efffad81cc$var$processRequest(request, configuration, pageStateHistory);
        });
    });
    var performanceResourceSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).RESOURCE,
        buffered: true
    }).subscribe(function(entries) {
        var _loop_1 = function(entry) {
            if (!(0, $b22ed8845addf22a$export$a5878f59e3ee2e9f)(entry)) handleResource(function() {
                return $372bb1efffad81cc$var$processResourceEntry(entry, configuration);
            });
        };
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            _loop_1(entry);
        }
    });
    retrieveInitialDocumentResourceTimingImpl(configuration, function(timing) {
        handleResource(function() {
            return $372bb1efffad81cc$var$processResourceEntry(timing, configuration);
        });
    });
    function handleResource(computeRawEvent) {
        taskQueue.push(function() {
            var rawEvent = computeRawEvent();
            if (rawEvent) lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , rawEvent);
        });
    }
    return {
        stop: function() {
            performanceResourceSubscription.unsubscribe();
        }
    };
}
function $372bb1efffad81cc$var$processRequest(request, configuration, pageStateHistory) {
    var matchingTiming = (0, $cb156ef466274200$export$daf52a30543584f)(request);
    var startClocks = matchingTiming ? (0, $fafd178883cb17fc$export$6d554362ef4543f2)(matchingTiming.startTime) : request.startClocks;
    var tracingInfo = $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration);
    if (!configuration.trackResources && !tracingInfo) return;
    var type = request.type === "xhr" /* RequestType.XHR */  ? "xhr" /* ResourceType.XHR */  : "fetch" /* ResourceType.FETCH */ ;
    var correspondingTimingOverrides = matchingTiming ? $372bb1efffad81cc$var$computeResourceEntryMetrics(matchingTiming) : undefined;
    var duration = $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var resourceEvent = (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            protocol: matchingTiming && (0, $b22ed8845addf22a$export$628529093947cac8)(matchingTiming),
            url: (0, $b22ed8845addf22a$export$4731ef4a2d5817b7)(request.url) ? (0, $b22ed8845addf22a$export$7e3e020b0533decd)(request.url) : request.url,
            delivery_type: matchingTiming && (0, $b22ed8845addf22a$export$f83ec67aa945dcf6)(matchingTiming)
        },
        type: "resource" /* RumEventType.RESOURCE */ ,
        _dd: {
            discarded: !configuration.trackResources
        }
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming,
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
            isAborted: request.isAborted,
            handlingStack: request.handlingStack
        }
    };
}
function $372bb1efffad81cc$var$processResourceEntry(entry, configuration) {
    var startClocks = (0, $fafd178883cb17fc$export$6d554362ef4543f2)(entry.startTime);
    var tracingInfo = $372bb1efffad81cc$var$computeResourceEntryTracingInfo(entry, configuration);
    if (!configuration.trackResources && !tracingInfo) return;
    var type = (0, $b22ed8845addf22a$export$874b6cde352e515a)(entry);
    var entryMetrics = $372bb1efffad81cc$var$computeResourceEntryMetrics(entry);
    var resourceEvent = (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
            type: type,
            url: entry.name,
            status_code: $372bb1efffad81cc$var$discardZeroStatus(entry.responseStatus),
            protocol: (0, $b22ed8845addf22a$export$628529093947cac8)(entry),
            delivery_type: (0, $b22ed8845addf22a$export$f83ec67aa945dcf6)(entry)
        },
        type: "resource" /* RumEventType.RESOURCE */ ,
        _dd: {
            discarded: !configuration.trackResources
        }
    }, tracingInfo, entryMetrics);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: entry
        }
    };
}
function $372bb1efffad81cc$var$computeResourceEntryMetrics(entry) {
    var renderBlockingStatus = entry.renderBlockingStatus;
    return {
        resource: (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
            duration: (0, $b22ed8845addf22a$export$e10d69e2d9b371b6)(entry),
            render_blocking_status: renderBlockingStatus
        }, (0, $b22ed8845addf22a$export$9207ac338b648dd5)(entry), (0, $b22ed8845addf22a$export$a8cdd6a8741b9542)(entry))
    };
}
function $372bb1efffad81cc$var$computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            span_id: request.spanId.toString(),
            trace_id: request.traceId.toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $372bb1efffad81cc$var$computeResourceEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            trace_id: entry.traceId,
            span_id: (0, $5c7a0ca9cf77c393$export$42e322be3a41cf8f)().toString(),
            rule_psr: configuration.rulePsr
        }
    };
}
function $372bb1efffad81cc$var$computeRequestDuration(pageStateHistory, startClocks, duration) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */ , startClocks.relative, duration) ? (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(duration) : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */ function $372bb1efffad81cc$var$discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}






function $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b(lifeCycle, viewId, onChange) {
    var _a = (0, $0b00b19bfaa2355c$export$a50549f6fbbed49b)({
        lifeCycle: lifeCycle,
        isChildEvent: function(event) {
            return event.view.id === viewId;
        },
        onChange: onChange
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts
    };
}




var $9f3f4e1acb2d1077$export$2f95fa37b4a92d63 = 10 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $9f3f4e1acb2d1077$export$a43e15ae3a012adf(configuration, firstHidden, callback) {
    var performanceSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).PAINT,
        buffered: true
    }).subscribe(function(entries) {
        var fcpEntry = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(entries, function(entry) {
            return entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < $9f3f4e1acb2d1077$export$2f95fa37b4a92d63;
        });
        if (fcpEntry) callback(fcpEntry.startTime);
    });
    return {
        stop: performanceSubscription.unsubscribe
    };
}






function $17078abdd4b8eaf3$export$1de7804f73e53e9a(configuration, firstHidden, callback) {
    var performanceFirstInputSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).FIRST_INPUT,
        buffered: true
    }).subscribe(function(entries) {
        var firstInputEntry = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(entries, function(entry) {
            return entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if (firstInputEntry.target && (0, $390d7e44cf00bd59$export$95fe5d3c5526a812)(firstInputEntry.target)) firstInputTargetSelector = (0, $f53c969915647662$export$2a298c6a007e5e40)(firstInputEntry.target, configuration.actionNameAttribute);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector
            });
        }
    });
    return {
        stop: function() {
            performanceFirstInputSubscription.unsubscribe();
        }
    };
}




function $50116aa6c1259cb4$export$8e38110c52840b40(configuration, callback, getNavigationEntryImpl) {
    if (getNavigationEntryImpl === void 0) getNavigationEntryImpl = (0, $31e2242c7dc25f3b$export$6431553786c94949);
    return $50116aa6c1259cb4$var$waitAfterLoadEvent(configuration, function() {
        var entry = getNavigationEntryImpl();
        if (!$50116aa6c1259cb4$var$isIncompleteNavigation(entry)) callback($50116aa6c1259cb4$var$processNavigationEntry(entry));
    });
}
function $50116aa6c1259cb4$var$processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, $fafd178883cb17fc$export$53cb631b087d9e92)() ? entry.responseStart : undefined
    };
}
function $50116aa6c1259cb4$var$isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function $50116aa6c1259cb4$var$waitAfterLoadEvent(configuration, callback) {
    var timeoutId;
    var stopOnReadyState = (0, $6c090d2d29937490$export$12cb733fc911e4f7)(configuration, 'complete', function() {
        // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
            return callback();
        });
    }).stop;
    return {
        stop: function() {
            stopOnReadyState();
            (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(timeoutId);
        }
    };
}





var $dbdd38f12feaea8d$export$5486837c6e61d9ac = 10 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $dbdd38f12feaea8d$export$e39d61369fabf03f(configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, eventTarget, [
        "pointerdown" /* DOM_EVENT.POINTER_DOWN */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ 
    ], function(event) {
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    }).stop;
    var biggestLcpSize = 0;
    var performanceLcpSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LARGEST_CONTENTFUL_PAINT,
        buffered: true
    }).subscribe(function(entries) {
        var lcpEntry = (0, $b287859a2cd2eacd$export$296de88ccac4bedb)(entries, function(entry) {
            return entry.entryType === (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < $dbdd38f12feaea8d$export$5486837c6e61d9ac && // Ensure to get the LCP entry with the biggest size, see
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
            entry.size > biggestLcpSize;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if (lcpEntry.element) lcpTargetSelector = (0, $f53c969915647662$export$2a298c6a007e5e40)(lcpEntry.element, configuration.actionNameAttribute);
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector
            });
            biggestLcpSize = lcpEntry.size;
        }
    });
    return {
        stop: function() {
            stopEventListener();
            performanceLcpSubscription.unsubscribe();
        }
    };
}



function $5b0bb36cbb3dba14$export$42b1d249aa2dee14(configuration, eventTarget) {
    if (eventTarget === void 0) eventTarget = window;
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') timeStamp = 0;
    else {
        timeStamp = Infinity;
        stopListeners = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, eventTarget, [
            "pagehide" /* DOM_EVENT.PAGE_HIDE */ ,
            "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ 
        ], function(event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */  || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, {
            capture: true
        }).stop;
    }
    return {
        get timeStamp () {
            return timeStamp;
        },
        stop: function() {
            stopListeners === null || stopListeners === void 0 || stopListeners();
        }
    };
}


function $a69e47b74eda2325$export$e0159acaad53a4f8(configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = (0, $50116aa6c1259cb4$export$8e38110c52840b40)(configuration, function(navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = (0, $5b0bb36cbb3dba14$export$42b1d249aa2dee14)(configuration);
    var stopFCPTracking = (0, $9f3f4e1acb2d1077$export$a43e15ae3a012adf)(configuration, firstHidden, function(firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = (0, $dbdd38f12feaea8d$export$e39d61369fabf03f)(configuration, firstHidden, window, function(largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = (0, $17078abdd4b8eaf3$export$1de7804f73e53e9a)(configuration, firstHidden, function(firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics
    };
}






function $80859c8865436c7c$export$da6e6ed807ae3512(configuration, viewStart, callback) {
    if (!$80859c8865436c7c$export$fc2cd0a8db29c298()) return {
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var maxClsValue = 0;
    var maxClsTarget;
    var maxClsStartTime;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0
    });
    var window1 = $80859c8865436c7c$var$slidingSessionWindow();
    var performanceSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LAYOUT_SHIFT,
        buffered: true
    }).subscribe(function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.hadRecentInput || entry.startTime < viewStart) continue;
            var _a = window1.update(entry), cumulatedValue = _a.cumulatedValue, isMaxValue = _a.isMaxValue;
            if (isMaxValue) {
                var target = $80859c8865436c7c$var$getTargetFromSource(entry.sources);
                maxClsTarget = target ? new WeakRef(target) : undefined;
                maxClsStartTime = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(viewStart, entry.startTime);
            }
            if (cumulatedValue > maxClsValue) {
                maxClsValue = cumulatedValue;
                var target = maxClsTarget === null || maxClsTarget === void 0 ? void 0 : maxClsTarget.deref();
                callback({
                    value: (0, $89f5cd41be2839b1$export$2077e0241d6afd3c)(maxClsValue, 4),
                    targetSelector: target && (0, $f53c969915647662$export$2a298c6a007e5e40)(target, configuration.actionNameAttribute),
                    time: maxClsStartTime
                });
            }
        }
    });
    return {
        stop: function() {
            performanceSubscription.unsubscribe();
        }
    };
}
function $80859c8865436c7c$var$getTargetFromSource(sources) {
    var _a;
    if (!sources) return;
    return (_a = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(sources, function(source) {
        return !!source.node && (0, $390d7e44cf00bd59$export$95fe5d3c5526a812)(source.node);
    })) === null || _a === void 0 ? void 0 : _a.node;
}
var $80859c8865436c7c$export$d03c32743ed6c027 = 5 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $80859c8865436c7c$var$MAX_UPDATE_GAP = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $80859c8865436c7c$var$slidingSessionWindow() {
    var cumulatedValue = 0;
    var startTime;
    var endTime;
    var maxValue = 0;
    return {
        update: function(entry) {
            var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= $80859c8865436c7c$var$MAX_UPDATE_GAP || entry.startTime - startTime >= $80859c8865436c7c$export$d03c32743ed6c027;
            var isMaxValue;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                maxValue = cumulatedValue = entry.value;
                isMaxValue = true;
            } else {
                cumulatedValue += entry.value;
                endTime = entry.startTime;
                isMaxValue = entry.value > maxValue;
                if (isMaxValue) maxValue = entry.value;
            }
            return {
                cumulatedValue: cumulatedValue,
                isMaxValue: isMaxValue
            };
        }
    };
}
function $80859c8865436c7c$export$fc2cd0a8db29c298() {
    return (0, $a45e320ac0fe2c4f$export$c6967607cdac15e8)((0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LAYOUT_SHIFT) && 'WeakRef' in window;
}







/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */ 
var $d750dc04d0ff821b$var$observer;
var $d750dc04d0ff821b$var$interactionCountEstimate = 0;
var $d750dc04d0ff821b$var$minKnownInteractionId = Infinity;
var $d750dc04d0ff821b$var$maxKnownInteractionId = 0;
function $d750dc04d0ff821b$export$67d90cda6b78a2eb() {
    if ('interactionCount' in performance || $d750dc04d0ff821b$var$observer) return;
    $d750dc04d0ff821b$var$observer = new window.PerformanceObserver((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(entries) {
        entries.getEntries().forEach(function(e) {
            var entry = e;
            if (entry.interactionId) {
                $d750dc04d0ff821b$var$minKnownInteractionId = Math.min($d750dc04d0ff821b$var$minKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$maxKnownInteractionId = Math.max($d750dc04d0ff821b$var$maxKnownInteractionId, entry.interactionId);
                $d750dc04d0ff821b$var$interactionCountEstimate = ($d750dc04d0ff821b$var$maxKnownInteractionId - $d750dc04d0ff821b$var$minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    $d750dc04d0ff821b$var$observer.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
}
var $d750dc04d0ff821b$export$8a962f2683a476d1 = function() {
    return $d750dc04d0ff821b$var$observer ? $d750dc04d0ff821b$var$interactionCountEstimate : window.performance.interactionCount || 0;
};


// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES = 10;
var $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad = 1 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9(configuration, viewStart, viewLoadingType) {
    if (!$a7bb5b6dbe4d2a3a$export$8abc245381a65a8f()) return {
        getInteractionToNextPaint: function() {
            return undefined;
        },
        setViewEnd: (0, $772566d0dfa3645c$export$8793edee2d425525),
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var _a = $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType), getViewInteractionCount = _a.getViewInteractionCount, stopViewInteractionCount = _a.stopViewInteractionCount;
    var viewEnd = Infinity;
    var longestInteractions = $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var interactionToNextPaintStartTime;
    function handleEntries(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            if (entry.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
            entry.startTime >= viewStart && entry.startTime <= viewEnd) longestInteractions.process(entry);
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
            interactionToNextPaint = newInteraction.duration;
            interactionToNextPaintStartTime = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(viewStart, newInteraction.startTime);
            interactionToNextPaintTargetSelector = (0, $20a93a7c6e2d8a89$export$54553eb1afcc5093)(newInteraction.startTime);
            if (!interactionToNextPaintTargetSelector && newInteraction.target && (0, $390d7e44cf00bd59$export$95fe5d3c5526a812)(newInteraction.target)) interactionToNextPaintTargetSelector = (0, $f53c969915647662$export$2a298c6a007e5e40)(newInteraction.target, configuration.actionNameAttribute);
        }
    }
    var firstInputSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).FIRST_INPUT,
        buffered: true
    }).subscribe(handleEntries);
    var eventSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).EVENT,
        // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
        // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
        durationThreshold: 40,
        buffered: true
    }).subscribe(handleEntries);
    return {
        getInteractionToNextPaint: function() {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) return {
                value: Math.min(interactionToNextPaint, $a7bb5b6dbe4d2a3a$export$7cc919a034f18bad),
                targetSelector: interactionToNextPaintTargetSelector,
                time: interactionToNextPaintStartTime
            };
            else if (getViewInteractionCount()) return {
                value: 0
            };
        },
        setViewEnd: function(viewEndTime) {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: function() {
            eventSubscription.unsubscribe();
            firstInputSubscription.unsubscribe();
        }
    };
}
function $a7bb5b6dbe4d2a3a$var$trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function(a, b) {
            return b.duration - a.duration;
        }).splice($a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */ process: function(entry) {
            var interactionIndex = longestInteractions.findIndex(function(interaction) {
                return entry.interactionId === interaction.interactionId;
            });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            } else if (longestInteractions.length < $a7bb5b6dbe4d2a3a$var$MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */ estimateP98Interaction: function() {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$cd95581cdbd15637(viewLoadingType) {
    (0, $d750dc04d0ff821b$export$67d90cda6b78a2eb)();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */  ? 0 : (0, $d750dc04d0ff821b$export$8a962f2683a476d1)();
    var state = {
        stopped: false
    };
    function computeViewInteractionCount() {
        return (0, $d750dc04d0ff821b$export$8a962f2683a476d1)() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: function() {
            if (state.stopped) return state.interactionCount;
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: function() {
            state = {
                stopped: true,
                interactionCount: computeViewInteractionCount()
            };
        }
    };
}
function $a7bb5b6dbe4d2a3a$export$8abc245381a65a8f() {
    return (0, $a45e320ac0fe2c4f$export$c6967607cdac15e8)((0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).EVENT) && window.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype;
}





function $6575c4fa5823a893$export$58b2b8bfa724cb6f(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    var firstHidden = (0, $5b0bb36cbb3dba14$export$42b1d249aa2dee14)(configuration);
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            var loadingTime = Math.max.apply(Math, loadingTimeCandidates);
            if (loadingTime < firstHidden.timeStamp) callback(loadingTime);
        }
    }
    var stop = (0, $56392c0d6d718cf0$export$4a886e0e421b0302)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, function(event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) loadingTimeCandidates.push((0, $fafd178883cb17fc$export$e04aa69d28450d55)(viewStart.timeStamp, event.end));
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: function() {
            stop();
            firstHidden.stop();
        },
        setLoadEvent: function(loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}



function $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
    else if (window.scrollX !== undefined) scrollX = window.scrollX;
    else scrollX = window.pageXOffset || 0;
    return Math.round(scrollX);
}
function $b49dd51dc1e7c0f8$export$91aaad5752ba6e7() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) scrollY = visual.pageTop - visual.offsetTop;
    else if (window.scrollY !== undefined) scrollY = window.scrollY;
    else scrollY = window.pageYOffset || 0;
    return Math.round(scrollY);
}



var $ed872b54a9ace364$var$viewportObservable;
function $ed872b54a9ace364$export$2c24cc613e51a50f(configuration) {
    if (!$ed872b54a9ace364$var$viewportObservable) $ed872b54a9ace364$var$viewportObservable = $ed872b54a9ace364$export$36388875a0cf8990(configuration);
    return $ed872b54a9ace364$var$viewportObservable;
}
function $ed872b54a9ace364$export$36388875a0cf8990(configuration) {
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var updateDimension = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function() {
            observable.notify($ed872b54a9ace364$export$e79021d67c61dfbd());
        }, 200).throttled;
        return (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "resize" /* DOM_EVENT.RESIZE */ , updateDimension, {
            capture: true,
            passive: true
        }).stop;
    });
}
function $ed872b54a9ace364$export$e79021d67c61dfbd() {
    var visual = window.visualViewport;
    if (visual) return {
        width: Number(visual.width * visual.scale),
        height: Number(visual.height * visual.scale)
    };
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0)
    };
}


var $b0ffb3bb8ad90457$export$f01db56fd078c3a8 = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $b0ffb3bb8ad90457$export$eeec767135e98c85(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) scrollValues = $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration);
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function(_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0, $fafd178883cb17fc$export$53cb631b087d9e92)();
            maxScrollHeightTime = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) callback({
            maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
            maxDepthScrollTop: scrollTop,
            maxScrollHeight: maxScrollHeight,
            maxScrollHeightTime: maxScrollHeightTime
        });
    });
    return {
        stop: function() {
            return subscription.unsubscribe();
        }
    };
}
function $b0ffb3bb8ad90457$export$7819cf13be3ef65c() {
    var scrollTop = (0, $b49dd51dc1e7c0f8$export$91aaad5752ba6e7)();
    var height = (0, $ed872b54a9ace364$export$e79021d67c61dfbd)().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop
    };
}
function $b0ffb3bb8ad90457$export$68a7c526e4759c01(configuration, throttleDuration) {
    if (throttleDuration === void 0) throttleDuration = $b0ffb3bb8ad90457$export$f01db56fd078c3a8;
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        function notify() {
            observable.notify($b0ffb3bb8ad90457$export$7819cf13be3ef65c());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0, $772566d0dfa3645c$export$de363e709c412c8a)(notify, throttleDuration, {
                leading: false,
                trailing: true
            });
            var observerTarget = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(throttledNotify_1.throttled));
            if (observerTarget) resizeObserver_1.observe(observerTarget);
            var eventListener_1 = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */ , throttledNotify_1.throttled, {
                passive: true
            });
            return function() {
                throttledNotify_1.cancel();
                resizeObserver_1.disconnect();
                eventListener_1.stop();
            };
        }
    });
}


function $62018fc84db9011a$export$b84f637a03e61a8d(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = (0, $6575c4fa5823a893$export$58b2b8bfa724cb6f)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, function(newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = (0, $b0ffb3bb8ad90457$export$eeec767135e98c85)(configuration, viewStart, function(newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = (0, $80859c8865436c7c$export$da6e6ed807ae3512)(configuration, viewStart.relative, function(cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = (0, $a7bb5b6dbe4d2a3a$export$21a417d4761d0ac9)(configuration, viewStart.relative, loadingType), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint, setViewEnd = _b.setViewEnd;
    return {
        stop: function() {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: function() {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        }
    };
}


var $9ea3e5f0d6b2c477$export$547e59d66cff6939 = 3000;
var $9ea3e5f0d6b2c477$export$466344df8256a878 = 5 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
var $9ea3e5f0d6b2c477$export$41ad004d27ab927 = 5 * (0, $fafd178883cb17fc$export$35acaebf644db34e);
function $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf(location, lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */ , (0, $fafd178883cb17fc$export$d8b428538156d05f)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function() {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ , undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
                context: currentView.contextManager.getContext()
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , function() {
            currentView.end({
                sessionIsActive: false
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
            if (pageExitEvent.reason === (0, $0ebb46f2959d2690$export$69c8658089134213).UNLOADING) currentView.end();
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function(_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if ($9ea3e5f0d6b2c477$var$areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ );
            }
        });
    }
    return {
        addTiming: function(name, time) {
            if (time === void 0) time = (0, $fafd178883cb17fc$export$71f52cdbbf629086)();
            currentView.addTiming(name, time);
        },
        startView: function(options, startClocks) {
            currentView.end({
                endClocks: startClocks
            });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */ , startClocks, options);
        },
        setViewContext: function(context) {
            currentView.contextManager.setContext(context);
        },
        setViewContextProperty: function(key, value) {
            currentView.contextManager.setContextProperty(key, value);
        },
        setViewName: function(name) {
            currentView.setViewName(name);
        },
        stop: function() {
            if (locationChangeSubscription) locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function(view) {
                return view.stop();
            });
        }
    };
}
function $9ea3e5f0d6b2c477$var$newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) startClocks = (0, $fafd178883cb17fc$export$67898643147706d3)();
    // Setup initial values
    var id = (0, $01b8047924249a5c$export$e73c8bd0f20705a)();
    var stopObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0, $66d1b7fd2da44c06$export$370e8311c3cdebd9)(initialLocation);
    var contextManager = (0, $a708ac9bed8d6582$export$fe3149b78a43e1ad)();
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    var context;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service || undefined;
        version = viewOptions.version || undefined;
        if (viewOptions.context) {
            context = viewOptions.context;
            // use ContextManager to update the context so we always sanitize it
            contextManager.setContext(context);
        }
    }
    var viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
        context: context
    };
    lifeCycle.notify(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , viewCreatedEvent);
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */ , viewCreatedEvent);
    // Update the view every time the measures are changing
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$547e59d66cff6939, {
        leading: false
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = (0, $62018fc84db9011a$export$b84f637a03e61a8d)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, setViewEnd = _b.setViewEnd, stopCommonViewMetricsTracking = _b.stop, stopINPTracking = _b.stopINPTracking, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */  ? (0, $a69e47b74eda2325$export$e0159acaad53a4f8)(configuration, setLoadEvent, scheduleViewUpdate) : {
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525),
        initialViewMetrics: {}
    }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = (0, $d84a7b6bfd07f92f$export$fcb8a99c2bff4a6b)(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0, $02784b622c768a70$export$cda6c73645970615)(triggerViewUpdate, $9ea3e5f0d6b2c477$export$466344df8256a878);
    // Initial view update
    triggerViewUpdate();
    // View context update should always be throttled
    contextManager.changeObservable.subscribe(function() {
        lifeCycle.notify(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */ , {
            id: id,
            name: name,
            context: contextManager.getContext(),
            startClocks: startClocks
        });
        scheduleViewUpdate();
    });
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0, $fafd178883cb17fc$export$71f52cdbbf629086)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */ , {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            context: contextManager.getContext(),
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0, $fafd178883cb17fc$export$e04aa69d28450d55)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts
        });
    }
    return {
        get name () {
            return name;
        },
        service: service,
        version: version,
        contextManager: contextManager,
        stopObservable: stopObservable,
        end: function(options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) options = {};
            if (endClocks) // view already ended
            return;
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0, $fafd178883cb17fc$export$67898643147706d3)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */ , {
                endClocks: endClocks
            });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , {
                endClocks: endClocks
            });
            (0, $02784b622c768a70$export$5c0dc72231454d02)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                _this.stop();
            }, $9ea3e5f0d6b2c477$export$41ad004d27ab927);
        },
        stop: function() {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming: function(name, time) {
            if (endClocks) return;
            var relativeTime = (0, $fafd178883cb17fc$export$dc53cd187b19c9f8)(time) ? time : (0, $fafd178883cb17fc$export$e04aa69d28450d55)(startClocks.timeStamp, time);
            customTimings[$9ea3e5f0d6b2c477$var$sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
        setViewName: function(updatedName) {
            name = updatedName;
            triggerViewUpdate();
        }
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */ function $9ea3e5f0d6b2c477$var$sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    return sanitized;
}
function $9ea3e5f0d6b2c477$var$areDifferentLocation(currentLocation, otherLocation) {
    return currentLocation.pathname !== otherLocation.pathname || !$9ea3e5f0d6b2c477$var$isHashAnAnchor(otherLocation.hash) && $9ea3e5f0d6b2c477$var$getPathFromHash(otherLocation.hash) !== $9ea3e5f0d6b2c477$var$getPathFromHash(currentLocation.hash);
}
function $9ea3e5f0d6b2c477$var$isHashAnAnchor(hash) {
    var correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function $9ea3e5f0d6b2c477$var$getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}


function $2b007b506741de80$export$794a32d201ece359(lifeCycle, configuration, location, domMutationObservable, pageOpenObserable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */ , function(view) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , $2b007b506741de80$var$processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return (0, $9ea3e5f0d6b2c477$export$a9e93bc2fdba42cf)(location, lifeCycle, domMutationObservable, pageOpenObserable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function $2b007b506741de80$var$processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStates,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
            }
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */ ,
        view: {
            action: {
                count: view.eventCounts.actionCount
            },
            frustration: {
                count: view.eventCounts.frustrationCount
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.time),
            cumulative_layout_shift_target_selector: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.targetSelector,
            first_byte: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.firstByte),
            dom_complete: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domComplete),
            dom_content_loaded: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domContentLoaded),
            dom_interactive: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            first_contentful_paint: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.delay),
            first_input_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.time),
            first_input_target_selector: (_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.targetSelector,
            interaction_to_next_paint: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.value),
            interaction_to_next_paint_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_m = view.commonViewMetrics.interactionToNextPaint) === null || _m === void 0 ? void 0 : _m.time),
            interaction_to_next_paint_target_selector: (_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_p = view.initialViewMetrics.largestContentfulPaint) === null || _p === void 0 ? void 0 : _p.value),
            largest_contentful_paint_target_selector: (_q = view.initialViewMetrics.largestContentfulPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
            load_event: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)((_r = view.initialViewMetrics.navigationTimings) === null || _r === void 0 ? void 0 : _r.loadEvent),
            loading_time: (0, $fc3b94d36e42b5cc$export$e8fc7a7e81732139)((0, $fafd178883cb17fc$export$cc7917ebd320fa93)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount
            },
            resource: {
                count: view.eventCounts.resourceCount
            },
            time_spent: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(view.duration)
        },
        feature_flags: featureFlagContext && !(0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll ? {
            scroll: {
                max_depth: view.commonViewMetrics.scroll.maxDepth,
                max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                max_scroll_height_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(view.commonViewMetrics.scroll.maxScrollHeightTime)
            }
        } : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel
        }
    };
    if (!(0, $66d1b7fd2da44c06$export$83b788b1a3698c03)(view.customTimings)) viewEvent.view.custom_timings = (0, $66d1b7fd2da44c06$export$825e789796ab7275)(view.customTimings, (0, $fafd178883cb17fc$export$cc7917ebd320fa93));
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location
        }
    };
}









var $1089e830cf773e23$export$3d1fb0c94cce8478 = (0, $fafd178883cb17fc$export$35acaebf644db34e);
var $1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY = (0, $407be9496e601c3b$export$324def7afe89d7e8);
var $1089e830cf773e23$var$stopCallbacks = [];
function $1089e830cf773e23$export$3b6b9a4f35a367c5(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    var expireObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0, $70fa419824414645$export$99eabf0f32a21670)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        return sessionStore.stop();
    });
    var sessionContextHistory = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $1089e830cf773e23$var$SESSION_CONTEXT_TIMEOUT_DELAY
    });
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        return sessionContextHistory.stop();
    });
    sessionStore.renewObservable.subscribe(function() {
        sessionContextHistory.add(buildSessionContext(), (0, $fafd178883cb17fc$export$53cb631b087d9e92)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function() {
        expireObservable.notify();
        sessionContextHistory.closeActive((0, $fafd178883cb17fc$export$53cb631b087d9e92)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, $fafd178883cb17fc$export$d8b428538156d05f)().relative);
    trackingConsentState.observable.subscribe(function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
        else sessionStore.expire();
    });
    $1089e830cf773e23$var$trackActivity(configuration, function() {
        if (trackingConsentState.isGranted()) sessionStore.expandOrRenewSession();
    });
    $1089e830cf773e23$var$trackVisibility(configuration, function() {
        return sessionStore.expandSession();
    });
    $1089e830cf773e23$var$trackResume(configuration, function() {
        return sessionStore.restartSession();
    });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
            isReplayForced: !!sessionStore.getSession().forcedReplay,
            anonymousId: sessionStore.getSession().anonymousId
        };
    }
    return {
        findSession: function(startTime, options) {
            return sessionContextHistory.find(startTime, options);
        },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
        expire: sessionStore.expire,
        updateSessionState: sessionStore.updateSessionState
    };
}
function $1089e830cf773e23$export$c08596f6814fce4f() {
    $1089e830cf773e23$var$stopCallbacks.forEach(function(e) {
        return e();
    });
    $1089e830cf773e23$var$stopCallbacks = [];
}
function $1089e830cf773e23$var$trackActivity(configuration, expandOrRenewSession) {
    var stop = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
        "click" /* DOM_EVENT.CLICK */ ,
        "touchstart" /* DOM_EVENT.TOUCH_START */ ,
        "keydown" /* DOM_EVENT.KEY_DOWN */ ,
        "scroll" /* DOM_EVENT.SCROLL */ 
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    }).stop;
    $1089e830cf773e23$var$stopCallbacks.push(stop);
}
function $1089e830cf773e23$var$trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function() {
        if (document.visibilityState === 'visible') expandSession();
    };
    var stop = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ , expandSessionWhenVisible).stop;
    $1089e830cf773e23$var$stopCallbacks.push(stop);
    var visibilityCheckInterval = (0, $02784b622c768a70$export$cda6c73645970615)(expandSessionWhenVisible, $1089e830cf773e23$export$3d1fb0c94cce8478);
    $1089e830cf773e23$var$stopCallbacks.push(function() {
        (0, $02784b622c768a70$export$5c0dc72231454d02)(visibilityCheckInterval);
    });
}
function $1089e830cf773e23$var$trackResume(configuration, cb) {
    var stop = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "resume" /* DOM_EVENT.RESUME */ , cb, {
        capture: true
    }).stop;
    $1089e830cf773e23$var$stopCallbacks.push(stop);
}


var $a7da4f9da803eca2$export$50ae25e0cd1ada34 = 'rum';
function $a7da4f9da803eca2$export$8d80e7032209d4ab(configuration, lifeCycle, trackingConsentState) {
    var sessionManager = (0, $1089e830cf773e23$export$3b6b9a4f35a367c5)(configuration, $a7da4f9da803eca2$export$50ae25e0cd1ada34, function(rawTrackingType) {
        return $a7da4f9da803eca2$var$computeSessionState(configuration, rawTrackingType);
    }, trackingConsentState);
    sessionManager.expireObservable.subscribe(function() {
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */ );
    });
    sessionManager.renewObservable.subscribe(function() {
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */ );
    });
    sessionManager.sessionStateUpdateObservable.subscribe(function(_a) {
        var previousState = _a.previousState, newState = _a.newState;
        if (!previousState.forcedReplay && newState.forcedReplay) {
            var sessionEntity = sessionManager.findSession();
            if (sessionEntity) sessionEntity.isReplayForced = true;
        }
    });
    return {
        findTrackedSession: function(startTime) {
            var session = sessionManager.findSession(startTime);
            if (!session || !$a7da4f9da803eca2$var$isTypeTracked(session.trackingType)) return;
            return {
                id: session.id,
                sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  ? 1 /* SessionReplayState.SAMPLED */  : session.isReplayForced ? 2 /* SessionReplayState.FORCED */  : 0 /* SessionReplayState.OFF */ ,
                anonymousId: session.anonymousId
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
        setForcedReplay: function() {
            return sessionManager.updateSessionState({
                forcedReplay: '1'
            });
        }
    };
}
function $a7da4f9da803eca2$export$d66a130e714b81c0() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplay: (0, $f0aff45a57046ce0$export$c3d8d1f8445a3630)("records" /* BridgeCapability.RECORDS */ ) ? 1 /* SessionReplayState.SAMPLED */  : 0 /* SessionReplayState.OFF */ 
    };
    return {
        findTrackedSession: function() {
            return session;
        },
        expire: (0, $772566d0dfa3645c$export$8793edee2d425525),
        expireObservable: new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(),
        setForcedReplay: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
}
function $a7da4f9da803eca2$var$computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if ($a7da4f9da803eca2$var$hasValidRumSession(rawTrackingType)) trackingType = rawTrackingType;
    else if (!(0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.sessionSampleRate)) trackingType = "0" /* RumTrackingType.NOT_TRACKED */ ;
    else if (!(0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.sessionReplaySampleRate)) trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
    else trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
    return {
        trackingType: trackingType,
        isTracked: $a7da4f9da803eca2$var$isTypeTracked(trackingType)
    };
}
function $a7da4f9da803eca2$var$hasValidRumSession(trackingType) {
    return trackingType === "0" /* RumTrackingType.NOT_TRACKED */  || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */  || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ;
}
function $a7da4f9da803eca2$var$isTypeTracked(rumSessionType) {
    return rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */  || rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ;
}







function $8d62f5e28b135c89$export$71e68e90ba624b44(_a) {
    var encoder = _a.encoder, request = _a.request, flushController = _a.flushController, messageBytesLimit = _a.messageBytesLimit;
    var upsertBuffer = {};
    var flushSubscription = flushController.flushObservable.subscribe(function(event) {
        return flush(event);
    });
    function push(serializedMessage, estimatedMessageBytesCount, key) {
        flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            upsertBuffer[key] = serializedMessage;
            flushController.notifyAfterAddMessage();
        } else encoder.write(encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function(realMessageBytesCount) {
            flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
        });
    }
    function hasMessageFor(key) {
        return key !== undefined && upsertBuffer[key] !== undefined;
    }
    function remove(key) {
        var removedMessage = upsertBuffer[key];
        delete upsertBuffer[key];
        var messageBytesCount = encoder.estimateEncodedBytesCount(removedMessage);
        flushController.notifyAfterRemoveMessage(messageBytesCount);
    }
    function addOrUpdate(message, key) {
        var serializedMessage = (0, $169208b8dc904506$export$1f8609334739c2b6)(message);
        var estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= messageBytesLimit) {
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(messageBytesLimit, "KB. ").concat((0, $429fd8a62f4aa1b2$export$69ce01f6d41ea86c), " ").concat((0, $429fd8a62f4aa1b2$export$f3bbdb3cea20e78e), "/#technical-limitations"));
            return;
        }
        if (hasMessageFor(key)) remove(key);
        push(serializedMessage, estimatedMessageBytesCount, key);
    }
    function flush(event) {
        var upsertMessages = (0, $b287859a2cd2eacd$export$ad1854f4a08c15f8)(upsertBuffer).join('\n');
        upsertBuffer = {};
        var isPageExit = (0, $0ebb46f2959d2690$export$cbb6b5cdbd0f2b60)(event.reason);
        var send = isPageExit ? request.sendOnExit : request.send;
        if (isPageExit && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
        // if the encoder is async we need to send two requests in some cases (one for encoded data
        // and the other for non-encoded data). But if it's not async, we don't have to worry about
        // it and always send a single request.
        encoder.isAsync) {
            var encoderResult = encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult));
            // Send messages that are not yet encoded at this point
            var pendingMessages = [
                encoderResult.pendingData,
                upsertMessages
            ].filter(Boolean).join('\n');
            if (pendingMessages) send({
                data: pendingMessages,
                bytesCount: (0, $5baf81a8b4674c85$export$36cba7c53d8f13a2)(pendingMessages)
            });
        } else {
            if (upsertMessages) encoder.write(encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            encoder.finish(function(encoderResult) {
                send($8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult));
            });
        }
    }
    return {
        flushController: flushController,
        add: addOrUpdate,
        upsert: addOrUpdate,
        stop: flushSubscription.unsubscribe
    };
}
function $8d62f5e28b135c89$var$formatPayloadFromEncoder(encoderResult) {
    var data;
    if (typeof encoderResult.output === 'string') data = encoderResult.output;
    else data = new Blob([
        encoderResult.output
    ], {
        // This will set the 'Content-Type: text/plain' header. Reasoning:
        // * The intake rejects the request if there is no content type.
        // * The browser will issue CORS preflight requests if we set it to 'application/json', which
        // could induce higher intake load (and maybe has other impacts).
        // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
        // new lines.
        type: 'text/plain'
    });
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding
    };
}










var $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 = 80 * (0, $5baf81a8b4674c85$export$756c3d65870c899e);
var $399621d7cfb3f6e5$export$86ca45574dbc49bd = 32;
var $399621d7cfb3f6e5$export$5557f582a01f898f = 3 * (0, $5baf81a8b4674c85$export$377b1474fc07c10f);
var $399621d7cfb3f6e5$export$ba196f7860333423 = (0, $fafd178883cb17fc$export$35acaebf644db34e);
var $399621d7cfb3f6e5$export$c3914d5086178577 = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $399621d7cfb3f6e5$export$96c9f5ab1844e401(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */  && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, {
        onSuccess: function() {
            return $399621d7cfb3f6e5$var$retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */ , state, sendStrategy, trackType, reportError);
        },
        onFailure: function() {
            state.queuedPayloads.enqueue(payload);
            $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError);
        }
    });
    else state.queuedPayloads.enqueue(payload);
}
function $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */ ) return;
    (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
        var payload = state.queuedPayloads.first();
        $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, {
            onSuccess: function() {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = $399621d7cfb3f6e5$export$c3914d5086178577;
                $399621d7cfb3f6e5$var$retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */ , state, sendStrategy, trackType, reportError);
            },
            onFailure: function() {
                state.currentBackoffTime = Math.min($399621d7cfb3f6e5$export$ba196f7860333423, state.currentBackoffTime * 2);
                $399621d7cfb3f6e5$var$scheduleRetry(state, sendStrategy, trackType, reportError);
            }
        });
    }, state.currentBackoffTime);
}
function $399621d7cfb3f6e5$var$send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function(response) {
        state.bandwidthMonitor.remove(payload);
        if (!$399621d7cfb3f6e5$var$shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */ ;
            onSuccess();
        } else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */  : 2 /* TransportStatus.DOWN */ ;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status
            };
            onFailure();
        }
    });
}
function $399621d7cfb3f6e5$var$retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */  && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat($399621d7cfb3f6e5$export$5557f582a01f898f / (0, $5baf81a8b4674c85$export$377b1474fc07c10f), "MiB"),
            source: (0, $125d036ad0d2a2af$export$4f7d2dba9330699b).AGENT,
            startClocks: (0, $fafd178883cb17fc$export$67898643147706d3)()
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = $399621d7cfb3f6e5$var$newPayloadQueue();
    while(previousQueue.size() > 0)$399621d7cfb3f6e5$export$96c9f5ab1844e401(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
}
function $399621d7cfb3f6e5$var$shouldRetryRequest(response) {
    return response.type !== 'opaque' && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0, $63b619b5581ec78b$export$a7cbe72d7c4012af)(response.status));
}
function $399621d7cfb3f6e5$export$1663dd4904e17e74() {
    return {
        transportStatus: 0 /* TransportStatus.UP */ ,
        currentBackoffTime: $399621d7cfb3f6e5$export$c3914d5086178577,
        bandwidthMonitor: $399621d7cfb3f6e5$var$newBandwidthMonitor(),
        queuedPayloads: $399621d7cfb3f6e5$var$newPayloadQueue(),
        queueFullReported: false
    };
}
function $399621d7cfb3f6e5$var$newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function(payload) {
            if (this.isFull()) return;
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function() {
            return queue[0];
        },
        dequeue: function() {
            var payload = queue.shift();
            if (payload) this.bytesCount -= payload.bytesCount;
            return payload;
        },
        size: function() {
            return queue.length;
        },
        isFull: function() {
            return this.bytesCount >= $399621d7cfb3f6e5$export$5557f582a01f898f;
        }
    };
}
function $399621d7cfb3f6e5$var$newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function(payload) {
            return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= $399621d7cfb3f6e5$export$b0eb5f34be1e4aa5 && this.ongoingRequestCount < $399621d7cfb3f6e5$export$86ca45574dbc49bd;
        },
        add: function(payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function(payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        }
    };
}


function $27e3ab8a1341cab4$export$58d47321b4325073(endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, $399621d7cfb3f6e5$export$1663dd4904e17e74)();
    var sendStrategyForRetry = function(payload, onResponse) {
        return $27e3ab8a1341cab4$export$4d5d13cecdd8b94d(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function(payload) {
            (0, $399621d7cfb3f6e5$export$96c9f5ab1844e401)(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */ sendOnExit: function(payload) {
            $27e3ab8a1341cab4$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        }
    };
}
function $27e3ab8a1341cab4$var$sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) try {
        var beaconUrl = endpointBuilder.build('beacon', payload);
        var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
        if (isQueued) return;
    } catch (e) {
        $27e3ab8a1341cab4$var$reportBeaconError(e);
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    $27e3ab8a1341cab4$export$998d51f5856d10f5(xhrUrl, payload.data);
}
var $27e3ab8a1341cab4$var$hasReportedBeaconError = false;
function $27e3ab8a1341cab4$var$reportBeaconError(e) {
    if (!$27e3ab8a1341cab4$var$hasReportedBeaconError) {
        $27e3ab8a1341cab4$var$hasReportedBeaconError = true;
        (0, $b20e9e3ee3028089$export$2e825f93958b0e6a)(e);
    }
}
function $27e3ab8a1341cab4$export$4d5d13cecdd8b94d(endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = $27e3ab8a1341cab4$var$isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, {
            method: 'POST',
            body: payload.data,
            keepalive: true,
            mode: 'cors'
        }).then((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function(response) {
            return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
                status: response.status,
                type: response.type
            });
        }), (0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(function() {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            $27e3ab8a1341cab4$export$998d51f5856d10f5(xhrUrl, payload.data, onResponse);
        }));
    } else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        $27e3ab8a1341cab4$export$998d51f5856d10f5(xhrUrl, payload.data, onResponse);
    }
}
function $27e3ab8a1341cab4$var$isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    } catch (_a) {
        return false;
    }
}
function $27e3ab8a1341cab4$export$998d51f5856d10f5(url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    if (data instanceof Blob) // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader('Content-Type', data.type);
    (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(// allow untrusted event to acount for synthetic event dispatched by third party xhr wrapper
    {
        allowUntrustedEvents: true
    }, request, 'loadend', function() {
        onResponse === null || onResponse === void 0 || onResponse({
            status: request.status
        });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true
    });
    request.send(data);
}




function $937417c8633ccd25$export$afc20ff9bd852d2b(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function(event) {
        return flush(event.reason);
    });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function() {
        return flush('session_expire');
    });
    var flushObservable = new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function() {
        return function() {
            pageExitSubscription.unsubscribe();
            sessionExpireSubscription.unsubscribe();
        };
    });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) return;
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) durationLimitTimeoutId = (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
            flush('duration_limit');
        }, durationLimit);
    }
    function cancelDurationLimitTimeout() {
        (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount () {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */ notifyBeforeAddMessage: function(estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) flush('bytes_limit');
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */ notifyAfterAddMessage: function(messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) messageBytesCountDiff = 0;
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) flush('messages_limit');
            else if (currentBytesCount >= bytesLimit) flush('bytes_limit');
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */ notifyAfterRemoveMessage: function(messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) cancelDurationLimitTimeout();
        }
    };
}


function $75e0494d360c41c9$export$b8ccdd9bc4dcc76e(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable, batchFactoryImp) {
    if (batchFactoryImp === void 0) batchFactoryImp = (0, $8d62f5e28b135c89$export$71e68e90ba624b44);
    var primaryBatch = createBatchFromConfig(configuration, primary);
    var replicaBatch = replica && createBatchFromConfig(configuration, replica);
    function createBatchFromConfig(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return batchFactoryImp({
            encoder: encoder,
            request: (0, $27e3ab8a1341cab4$export$58d47321b4325073)(endpoint, configuration.batchBytesLimit, reportError),
            flushController: (0, $937417c8633ccd25$export$afc20ff9bd852d2b)({
                messagesLimit: configuration.batchMessagesLimit,
                bytesLimit: configuration.batchBytesLimit,
                durationLimit: configuration.flushTimeout,
                pageExitObservable: pageExitObservable,
                sessionExpireObservable: sessionExpireObservable
            }),
            messageBytesLimit: configuration.messageBytesLimit
        });
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function(message, replicated) {
            if (replicated === void 0) replicated = true;
            primaryBatch.add(message);
            if (replicaBatch && replicated) replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
        },
        upsert: function(message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
        },
        stop: function() {
            primaryBatch.stop();
            if (replicaBatch) replicaBatch.stop();
        }
    };
}


function $027c47a5a8d86b5f$export$33e6a2986ce7483(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
    var replica = configuration.replica;
    var batch = (0, $75e0494d360c41c9$export$b8ccdd9bc4dcc76e)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */ )
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function(message) {
            return (0, $df0d4cb06c424d45$export$1be1fc439b849fdf)(message, {
                application: {
                    id: replica.applicationId
                }
            });
        },
        encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */ )
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */ ) batch.upsert(serverRumEvent, serverRumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    telemetryEventObservable.subscribe(function(event) {
        return batch.add(event, (0, $b20e9e3ee3028089$export$2b39c4ac778572fb)(configuration));
    });
    return batch;
}



function $7abde8201394e230$export$38cafc1b8954ea9d(lifeCycle) {
    var bridge = (0, $f0aff45a57046ce0$export$86c8e1e7efd0dfc1)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}



var $f43017d046384f22$export$e5d2b82a8e642e14 = (0, $407be9496e601c3b$export$324def7afe89d7e8);
function $f43017d046384f22$export$a9a4d4dde99a99fd(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $f43017d046384f22$export$e5d2b82a8e642e14
    });
    var previousViewUrl;
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function(_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0, $fafd178883cb17fc$export$53cb631b087d9e92)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer
        };
    }
    return {
        findUrl: function(startTime) {
            return urlContextHistory.find(startTime);
        },
        stop: function() {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        }
    };
}



function $2c80a16a9ac8d387$export$c2da1b41b3b918ce(configuration, location) {
    var currentLocation = (0, $66d1b7fd2da44c06$export$370e8311c3cdebd9)(location);
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        var stopHistoryTracking = $2c80a16a9ac8d387$var$trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = $2c80a16a9ac8d387$var$trackHash(configuration, onLocationChange).stop;
        function onLocationChange() {
            if (currentLocation.href === location.href) return;
            var newLocation = (0, $66d1b7fd2da44c06$export$370e8311c3cdebd9)(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation
            });
            currentLocation = newLocation;
        }
        return function() {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function $2c80a16a9ac8d387$var$trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)($2c80a16a9ac8d387$var$getHistoryInstrumentationTarget('pushState'), 'pushState', function(_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var stopInstrumentingReplaceState = (0, $23e9a88fc9385609$export$f00f71a511cb3cac)($2c80a16a9ac8d387$var$getHistoryInstrumentationTarget('replaceState'), 'replaceState', function(_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var removeListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */ , onHistoryChange).stop;
    return {
        stop: function() {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        }
    };
}
function $2c80a16a9ac8d387$var$trackHash(configuration, onHashChange) {
    return (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */ , onHashChange);
}
function $2c80a16a9ac8d387$var$getHistoryInstrumentationTarget(methodName) {
    // Ideally we should always instument the method on the prototype, however some frameworks (e.g [Next.js](https://github.com/vercel/next.js/blob/d3f5532065f3e3bb84fb54bd2dfd1a16d0f03a21/packages/next/src/client/components/app-router.tsx#L429))
    // are wrapping the instance method. In that case we should also wrap the instance method.
    return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}



var $54d4fafd542dd21e$export$205c45090af638e0 = (0, $407be9496e601c3b$export$324def7afe89d7e8);
var $54d4fafd542dd21e$export$e4441139afa265bd = 200;
function $54d4fafd542dd21e$export$9125b974ef9cfd53(lifeCycle, customerDataTracker) {
    var featureFlagContexts = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $54d4fafd542dd21e$export$205c45090af638e0
    });
    lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */ , function(_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        customerDataTracker.resetCustomerData();
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */ , function(_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    return {
        findFeatureFlagEvaluations: function(startTime) {
            return featureFlagContexts.find(startTime);
        },
        addFeatureFlagEvaluation: function(key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                customerDataTracker.updateCustomerData(currentContext);
            }
        },
        stop: function() {
            return customerDataTracker.stop();
        }
    };
}



var $ff14a02fd6cd1ddd$export$e9b7b62aafe04389 = 10 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $ff14a02fd6cd1ddd$var$currentPeriodMeasures;
var $ff14a02fd6cd1ddd$var$currentBatchMeasures;
var $ff14a02fd6cd1ddd$var$batchHasRumEvent;
function $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0, $89f5cd41be2839b1$export$72c7afebfef3b500)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) return;
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
    $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        $ff14a02fd6cd1ddd$var$batchHasRumEvent = true;
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */ ).getBytesCount());
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */ ).getBytesCount());
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentBatchMeasures.featureFlagBytes, (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)([
            "view" /* RumEventType.VIEW */ ,
            "error" /* RumEventType.ERROR */ 
        ], event.type) ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */ ).getBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function(_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!$ff14a02fd6cd1ddd$var$batchHasRumEvent) return;
        $ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount += 1;
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchBytesCount, bytesCount);
        $ff14a02fd6cd1ddd$var$updateMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchMessagesCount, messagesCount);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.globalContextBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.globalContextBytes);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.userContextBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.userContextBytes);
        $ff14a02fd6cd1ddd$var$mergeMeasure($ff14a02fd6cd1ddd$var$currentPeriodMeasures.featureFlagBytes, $ff14a02fd6cd1ddd$var$currentBatchMeasures.featureFlagBytes);
        $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures();
    });
    (0, $02784b622c768a70$export$cda6c73645970615)($ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures, $ff14a02fd6cd1ddd$export$e9b7b62aafe04389);
}
function $ff14a02fd6cd1ddd$var$sendCurrentPeriodMeasures() {
    if ($ff14a02fd6cd1ddd$var$currentPeriodMeasures.batchCount === 0) return;
    (0, $b20e9e3ee3028089$export$d922954195a17683)('Customer data measures', $ff14a02fd6cd1ddd$var$currentPeriodMeasures);
    $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures();
}
function $ff14a02fd6cd1ddd$var$createMeasure() {
    return {
        min: Infinity,
        max: 0,
        sum: 0
    };
}
function $ff14a02fd6cd1ddd$var$updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function $ff14a02fd6cd1ddd$var$mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function $ff14a02fd6cd1ddd$var$initCurrentPeriodMeasures() {
    $ff14a02fd6cd1ddd$var$currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: $ff14a02fd6cd1ddd$var$createMeasure(),
        batchMessagesCount: $ff14a02fd6cd1ddd$var$createMeasure(),
        globalContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        userContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        featureFlagBytes: $ff14a02fd6cd1ddd$var$createMeasure()
    };
}
function $ff14a02fd6cd1ddd$var$initCurrentBatchMeasures() {
    $ff14a02fd6cd1ddd$var$batchHasRumEvent = false;
    $ff14a02fd6cd1ddd$var$currentBatchMeasures = {
        globalContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        userContextBytes: $ff14a02fd6cd1ddd$var$createMeasure(),
        featureFlagBytes: $ff14a02fd6cd1ddd$var$createMeasure()
    };
}



var $aea218dde2c0f936$export$491f01a0e9b8b208 = 4000;
var $aea218dde2c0f936$export$b92c7553d298d075 = 500;
var $aea218dde2c0f936$export$20f880bb2b8d10f6 = (0, $407be9496e601c3b$export$324def7afe89d7e8);
function $aea218dde2c0f936$export$7f01c272948a14b1(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) maxPageStateEntriesSelectable = $aea218dde2c0f936$export$b92c7553d298d075;
    var pageStateEntryHistory = (0, $5d3fa3f7dfe2dca0$export$74da638c6075b86)({
        expireDelay: $aea218dde2c0f936$export$20f880bb2b8d10f6,
        maxEntries: $aea218dde2c0f936$export$491f01a0e9b8b208
    });
    var currentPageState;
    addPageState($aea218dde2c0f936$var$getPageState(), (0, $fafd178883cb17fc$export$53cb631b087d9e92)());
    var stopEventListeners = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */ ,
        "focus" /* DOM_EVENT.FOCUS */ ,
        "blur" /* DOM_EVENT.BLUR */ ,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ ,
        "resume" /* DOM_EVENT.RESUME */ ,
        "freeze" /* DOM_EVENT.FREEZE */ ,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */ 
    ], function(event) {
        addPageState($aea218dde2c0f936$var$computePageState(event), event.timeStamp);
    }, {
        capture: true
    }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) startTime = (0, $fafd178883cb17fc$export$53cb631b087d9e92)();
        if (nextPageState === currentPageState) return;
        currentPageState = nextPageState;
        pageStateEntryHistory.closeActive(startTime);
        pageStateEntryHistory.add({
            state: currentPageState,
            startTime: startTime
        }, startTime);
    }
    var pageStateHistory = {
        findAll: function(eventStartTime, duration) {
            var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) return;
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for(var index = pageStateEntries.length - 1; index >= limit; index--){
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0, $fafd178883cb17fc$export$e04aa69d28450d55)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(relativeStartTime)
                });
            }
            return pageStateServerEntries;
        },
        wasInPageStateAt: function(state, startTime) {
            return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
        },
        wasInPageStateDuringPeriod: function(state, startTime, duration) {
            return pageStateEntryHistory.findAll(startTime, duration).some(function(pageState) {
                return pageState.state === state;
            });
        },
        addPageState: addPageState,
        stop: function() {
            stopEventListeners();
            pageStateEntryHistory.stop();
        }
    };
    return pageStateHistory;
}
function $aea218dde2c0f936$var$computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */ ) return "frozen" /* PageState.FROZEN */ ;
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ ) return event.persisted ? "frozen" /* PageState.FROZEN */  : "terminated" /* PageState.TERMINATED */ ;
    return $aea218dde2c0f936$var$getPageState();
}
function $aea218dde2c0f936$var$getPageState() {
    if (document.visibilityState === 'hidden') return "hidden" /* PageState.HIDDEN */ ;
    if (document.hasFocus()) return "active" /* PageState.ACTIVE */ ;
    return "passive" /* PageState.PASSIVE */ ;
}




function $85a81d4aa7a689fa$export$9b255c0d165a033f(configuration) {
    var viewport;
    var animationFrameId;
    if ((0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).DELAY_VIEWPORT_COLLECTION)) // Use requestAnimationFrame to delay the calculation of viewport dimensions until after SDK initialization, preventing long tasks.
    animationFrameId = requestAnimationFrame(function() {
        viewport = (0, $ed872b54a9ace364$export$e79021d67c61dfbd)();
    });
    else viewport = (0, $ed872b54a9ace364$export$e79021d67c61dfbd)();
    var unsubscribeViewport = (0, $ed872b54a9ace364$export$2c24cc613e51a50f)(configuration).subscribe(function(viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function() {
            return viewport ? {
                viewport: viewport
            } : undefined;
        },
        stop: function() {
            unsubscribeViewport();
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        }
    };
}





function $4bdc5815cbedd0b5$export$346054de39969c66(configuration, cookieName) {
    var detectCookieChangeStrategy = window.cookieStore ? $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) : $4bdc5815cbedd0b5$var$watchCookieFallback;
    return new (0, $34a3791423ee474f$export$77cea355fa80b5f4)(function(observable) {
        return detectCookieChangeStrategy(cookieName, function(event) {
            return observable.notify(event);
        });
    });
}
function $4bdc5815cbedd0b5$var$listenToCookieStoreChange(configuration) {
    return function(cookieName, callback) {
        var listener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, window.cookieStore, "change" /* DOM_EVENT.CHANGE */ , function(event) {
            // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
            // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
            var changeEvent = (0, $b287859a2cd2eacd$export$71aa6c912b956294)(event.changed, function(event) {
                return event.name === cookieName;
            }) || (0, $b287859a2cd2eacd$export$71aa6c912b956294)(event.deleted, function(event) {
                return event.name === cookieName;
            });
            if (changeEvent) callback(changeEvent.value);
        });
        return listener.stop;
    };
}
var $4bdc5815cbedd0b5$export$541bea9a14448c32 = (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $4bdc5815cbedd0b5$var$watchCookieFallback(cookieName, callback) {
    var previousCookieValue = (0, $01b8047924249a5c$export$fe87bb5193f3e70)(document.cookie, cookieName);
    var watchCookieIntervalId = (0, $02784b622c768a70$export$cda6c73645970615)(function() {
        var cookieValue = (0, $01b8047924249a5c$export$fe87bb5193f3e70)(document.cookie, cookieName);
        if (cookieValue !== previousCookieValue) callback(cookieValue);
    }, $4bdc5815cbedd0b5$export$541bea9a14448c32);
    return function() {
        (0, $02784b622c768a70$export$5c0dc72231454d02)(watchCookieIntervalId);
    };
}


var $420c7617b51dc43d$export$f848217ffff2b290 = 'datadog-ci-visibility-test-execution-id';
function $420c7617b51dc43d$export$121aef6278f2cce8(configuration, cookieObservable) {
    var _a;
    if (cookieObservable === void 0) cookieObservable = (0, $4bdc5815cbedd0b5$export$346054de39969c66)(configuration, $420c7617b51dc43d$export$f848217ffff2b290);
    var testExecutionId = (0, $31fa799c5ed9e680$export$379e6c34a14280ba)($420c7617b51dc43d$export$f848217ffff2b290) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
    var cookieObservableSubscription = cookieObservable.subscribe(function(value) {
        testExecutionId = value;
    });
    return {
        get: function() {
            if (typeof testExecutionId === 'string') return {
                test_execution_id: testExecutionId
            };
        },
        stop: function() {
            return cookieObservableSubscription.unsubscribe();
        }
    };
}




function $2f95f92e3d780ccf$export$10045bd26bff7f31(lifeCycle, configuration) {
    var performanceResourceSubscription = (0, $a45e320ac0fe2c4f$export$f3f6554c84596077)(configuration, {
        type: (0, $a45e320ac0fe2c4f$export$5241bfb054a2a291).LONG_ANIMATION_FRAME,
        buffered: true
    }).subscribe(function(entries) {
        for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
            var entry = entries_1[_i];
            var startClocks = (0, $fafd178883cb17fc$export$6d554362ef4543f2)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0, $01b8047924249a5c$export$e73c8bd0f20705a)(),
                    entry_type: "long-animation-frame" /* RumLongTaskEntryType.LONG_ANIMATION_FRAME */ ,
                    duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.duration),
                    blocking_duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.blockingDuration),
                    first_ui_event_timestamp: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.firstUIEventTimestamp),
                    render_start: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.renderStart),
                    style_and_layout_start: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.styleAndLayoutStart),
                    start_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(entry.startTime),
                    scripts: entry.scripts.map(function(script) {
                        return {
                            duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(script.duration),
                            pause_duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(script.pauseDuration),
                            forced_style_and_layout_duration: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(script.forcedStyleAndLayoutDuration),
                            start_time: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(script.startTime),
                            execution_start: (0, $fafd178883cb17fc$export$cc7917ebd320fa93)(script.executionStart),
                            source_url: script.sourceURL,
                            source_function_name: script.sourceFunctionName,
                            source_char_position: script.sourceCharPosition,
                            invoker: script.invoker,
                            invoker_type: script.invokerType,
                            window_attribution: script.windowAttribution
                        };
                    })
                },
                type: "long_task" /* RumEventType.LONG_TASK */ ,
                _dd: {
                    discarded: false
                }
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: {
                    performanceEntry: entry
                }
            });
        }
    });
    return {
        stop: function() {
            return performanceResourceSubscription.unsubscribe();
        }
    };
}


function $1c2ed706f8c64922$export$3215a7cbec5ac3e0(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder, // `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, customVitalsState) {
    var cleanupTasks = [];
    var lifeCycle = new (0, $3b152250b13a0137$export$6af70476896cbaec)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */ , function(event) {
        return (0, $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b)('rum', event);
    });
    var telemetry = $1c2ed706f8c64922$var$startRumTelemetry(configuration);
    telemetry.setContextProvider(function() {
        var _a, _b;
        return {
            application: {
                id: configuration.applicationId
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
            },
            view: {
                id: (_b = viewHistory.findView()) === null || _b === void 0 ? void 0 : _b.id
            },
            action: {
                id: actionContexts.findActionId()
            }
        };
    });
    var reportError = function(error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        (0, $b20e9e3ee3028089$export$d922954195a17683)('Error reported to customer', {
            'error.message': error.message
        });
    };
    var featureFlagContexts = (0, $54d4fafd542dd21e$export$9125b974ef9cfd53)(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */ ));
    var pageExitObservable = (0, $0ebb46f2959d2690$export$ff7f79b1ae5ce683)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function(event) {
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */ , event);
    });
    cleanupTasks.push(function() {
        return pageExitSubscription.unsubscribe();
    });
    var session = !(0, $f0aff45a57046ce0$export$a8ab916fee43a31b)() ? (0, $a7da4f9da803eca2$export$8d80e7032209d4ab)(configuration, lifeCycle, trackingConsentState) : (0, $a7da4f9da803eca2$export$d66a130e714b81c0)();
    if (!(0, $f0aff45a57046ce0$export$a8ab916fee43a31b)()) {
        var batch_1 = (0, $027c47a5a8d86b5f$export$33e6a2986ce7483)(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(function() {
            return batch_1.stop();
        });
        (0, $ff14a02fd6cd1ddd$export$7cc15698fd3ea8d2)(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
    } else (0, $7abde8201394e230$export$38cafc1b8954ea9d)(lifeCycle);
    var domMutationObservable = (0, $1e55a02d0fb92a5e$export$e0f9a2ab04194dff)();
    var locationChangeObservable = (0, $2c80a16a9ac8d387$export$c2da1b41b3b918ce)(configuration, location);
    var pageStateHistory = (0, $aea218dde2c0f936$export$7f01c272948a14b1)(configuration);
    var _a = (0, $54f177b32de8aa24$export$7c27c71faac0cc07)(), windowOpenObservable = _a.observable, stopWindowOpen = _a.stop;
    cleanupTasks.push(stopWindowOpen);
    var _b = $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, configuration, location, session, pageStateHistory, locationChangeObservable, domMutationObservable, windowOpenObservable, getCommonContext, reportError), viewHistory = _b.viewHistory, urlContexts = _b.urlContexts, actionContexts = _b.actionContexts, addAction = _b.addAction, stopRumEventCollection = _b.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0, $b20e9e3ee3028089$export$848bed2c00d8bca2)();
    var _c = (0, $2b007b506741de80$export$794a32d201ece359)(lifeCycle, configuration, location, domMutationObservable, windowOpenObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _c.addTiming, startView = _c.startView, setViewName = _c.setViewName, setViewContext = _c.setViewContext, setViewContextProperty = _c.setViewContextProperty, stopViewCollection = _c.stop;
    cleanupTasks.push(stopViewCollection);
    var stopResourceCollection = (0, $372bb1efffad81cc$export$7a0c7e0d79d84977)(lifeCycle, configuration, pageStateHistory).stop;
    cleanupTasks.push(stopResourceCollection);
    if ((0, $e967aa36fccc7e29$export$ada3eaf101ef7eb6)((0, $e967aa36fccc7e29$export$8c1a7666d5772525).LONG_ANIMATION_FRAME)) {
        if (configuration.trackLongTasks) {
            var stopLongAnimationFrameCollection = (0, $2f95f92e3d780ccf$export$10045bd26bff7f31)(lifeCycle, configuration).stop;
            cleanupTasks.push(stopLongAnimationFrameCollection);
        }
    } else (0, $ffa26d5dc219f735$export$52c09388c428dadc)(lifeCycle, configuration);
    var addError = (0, $f95b485e6c21537b$export$243c2bf7ff6b9330)(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    (0, $c4313f4d150a5ffa$export$254c90b445eb4949)(lifeCycle, configuration, session);
    var vitalCollection = (0, $7eb1818b147a2865$export$1f5a51a997c60d35)(lifeCycle, pageStateHistory, customVitalsState);
    var internalContext = (0, $af3ad9afe3848d81$export$ee941cf091e8459)(configuration.applicationId, session, viewHistory, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        setViewContext: setViewContext,
        setViewContextProperty: setViewContextProperty,
        setViewName: setViewName,
        lifeCycle: lifeCycle,
        viewHistory: viewHistory,
        session: session,
        stopSession: function() {
            return session.expire();
        },
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        addDurationVital: vitalCollection.addDurationVital,
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}
function $1c2ed706f8c64922$var$startRumTelemetry(configuration) {
    var telemetry = (0, $b20e9e3ee3028089$export$a1198c4bba5d5e18)("browser-rum-sdk" /* TelemetryService.RUM */ , configuration);
    if ((0, $f0aff45a57046ce0$export$a8ab916fee43a31b)()) {
        var bridge_1 = (0, $f0aff45a57046ce0$export$86c8e1e7efd0dfc1)();
        telemetry.observable.subscribe(function(event) {
            return bridge_1.send('internal_telemetry', event);
        });
    }
    return telemetry;
}
function $1c2ed706f8c64922$export$cd2ea6643dad23e3(lifeCycle, configuration, location1, sessionManager, pageStateHistory, locationChangeObservable, domMutationObservable, windowOpenObservable, getCommonContext, reportError) {
    var viewHistory = (0, $7d11beaaee8c1142$export$268034a9c98ba695)(lifeCycle);
    var urlContexts = (0, $f43017d046384f22$export$a9a4d4dde99a99fd)(lifeCycle, locationChangeObservable, location1);
    var actionCollection = (0, $8258e1e2c7bf35c9$export$195095f773513078)(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageStateHistory);
    var displayContext = (0, $85a81d4aa7a689fa$export$9b255c0d165a033f)(configuration);
    var ciVisibilityContext = (0, $420c7617b51dc43d$export$121aef6278f2cce8)(configuration);
    (0, $66722fe8d7cbabe1$export$1a0bc162690d6539)(configuration, lifeCycle, sessionManager, viewHistory, urlContexts, actionCollection.actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
    return {
        viewHistory: viewHistory,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: actionCollection.addAction,
        actionContexts: actionCollection.actionContexts,
        stop: function() {
            actionCollection.stop();
            ciVisibilityContext.stop();
            displayContext.stop();
            urlContexts.stop();
            viewHistory.stop();
            pageStateHistory.stop();
        }
    };
}












function $a0227eab1dbc844e$export$58d09b88d0d4cf52(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) parameters.push("error-type=".concat(errorType));
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = $a0227eab1dbc844e$export$63276db6097e2435(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function $a0227eab1dbc844e$export$63276db6097e2435(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || $a0227eab1dbc844e$var$getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function $a0227eab1dbc844e$var$getSiteDefaultSubdomain(configuration) {
    switch(configuration.site){
        case 0, $77d3907623da03fc$export$6b79fd7dd2f5fb9a:
        case 0, $77d3907623da03fc$export$7452d85ec570d2ea:
            return 'app';
        case 0, $77d3907623da03fc$export$a204b9d5a62f1e2c:
            return 'dd';
        default:
            return undefined;
    }
}








var $de188ba0cd76f643$export$f10444a7271b7f1e = 10;
var $de188ba0cd76f643$var$statsPerView;
function $de188ba0cd76f643$export$4223f4e280561ccd(viewId) {
    return $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count;
}
function $de188ba0cd76f643$export$1c43f9ac826b6462(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_count += 1;
}
function $de188ba0cd76f643$export$ab0ab92b3cb31c66(viewId) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).records_count += 1;
}
function $de188ba0cd76f643$export$ae4fdff69a4959e9(viewId, additionalBytesCount) {
    $de188ba0cd76f643$var$getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function $de188ba0cd76f643$export$92ac42d7bd545b2a(viewId) {
    return $de188ba0cd76f643$var$statsPerView === null || $de188ba0cd76f643$var$statsPerView === void 0 ? void 0 : $de188ba0cd76f643$var$statsPerView.get(viewId);
}
function $de188ba0cd76f643$export$f6629d8f23dffc10() {
    $de188ba0cd76f643$var$statsPerView = undefined;
}
function $de188ba0cd76f643$var$getOrCreateReplayStats(viewId) {
    if (!$de188ba0cd76f643$var$statsPerView) $de188ba0cd76f643$var$statsPerView = new Map();
    var replayStats;
    if ($de188ba0cd76f643$var$statsPerView.has(viewId)) replayStats = $de188ba0cd76f643$var$statsPerView.get(viewId);
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0
        };
        $de188ba0cd76f643$var$statsPerView.set(viewId, replayStats);
        if ($de188ba0cd76f643$var$statsPerView.size > $de188ba0cd76f643$export$f10444a7271b7f1e) $de188ba0cd76f643$var$deleteOldestStats();
    }
    return replayStats;
}
function $de188ba0cd76f643$var$deleteOldestStats() {
    if (!$de188ba0cd76f643$var$statsPerView) return;
    if ($de188ba0cd76f643$var$statsPerView.keys) {
        var toDelete = $de188ba0cd76f643$var$statsPerView.keys().next().value;
        if (toDelete) $de188ba0cd76f643$var$statsPerView.delete(toDelete);
    } else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        $de188ba0cd76f643$var$statsPerView.forEach(function(_value, key) {
            if (isFirst_1) {
                $de188ba0cd76f643$var$statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}





var $66c5816c46f245bb$var$serializedNodeIds = new WeakMap();
function $66c5816c46f245bb$export$baab016255f94f54(node) {
    return $66c5816c46f245bb$var$serializedNodeIds.has(node);
}
function $66c5816c46f245bb$export$267b85776945782d(node) {
    var current = node;
    while(current){
        if (!$66c5816c46f245bb$export$baab016255f94f54(current) && !(0, $390d7e44cf00bd59$export$3a98bd54c2ced0bf)(current)) return false;
        current = (0, $390d7e44cf00bd59$export$4e12058fc4d51d56)(current);
    }
    return true;
}
function $66c5816c46f245bb$export$1cdf184f338e4a7b(node) {
    return $66c5816c46f245bb$var$serializedNodeIds.get(node);
}
function $66c5816c46f245bb$export$8fed415004211d23(node, serializeNodeId) {
    $66c5816c46f245bb$var$serializedNodeIds.set(node, serializeNodeId);
}
function $66c5816c46f245bb$export$9a014d2606da64f5(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */ var tagName = element.tagName;
    var value = element.value;
    if ((0, $096eed2d25f26114$export$f97c617afddc1089)(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) // Overrule `MASK` privacy level for button-like element values, as they are used during replay
        // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
        return value;
        else if (!value || tagName === 'OPTION') // <Option> value provides no benefit
        return;
        return 0, $096eed2d25f26114$export$76054905c0914783;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') return element.value;
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') return;
    return value;
}
var $66c5816c46f245bb$export$ba314c99542e79a7 = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var $66c5816c46f245bb$export$23a92ed48cea5444 = /^[A-Za-z]+:|^\/\//;
var $66c5816c46f245bb$export$dbafa72958753fce = /^data:.*,/i;
function $66c5816c46f245bb$export$f7bc20cfc5b360e4(cssText, cssHref) {
    return cssText.replace($66c5816c46f245bb$export$ba314c99542e79a7, function(matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || $66c5816c46f245bb$export$23a92ed48cea5444.test(url) || $66c5816c46f245bb$export$dbafa72958753fce.test(url)) return matchingSubstring;
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat($66c5816c46f245bb$export$d702eb1cee1bdbbc(url, cssHref)).concat(quote, ")");
    });
}
function $66c5816c46f245bb$export$d702eb1cee1bdbbc(url, baseUrl) {
    try {
        return (0, $8af9b5626c1bb968$export$b5cd97dee32de81d)(url, baseUrl).href;
    } catch (_a) {
        return url;
    }
}
var $66c5816c46f245bb$var$TAG_NAME_REGEX = /[^a-z1-6-_]/;
function $66c5816c46f245bb$export$b3a58098b2e64dd6(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if ($66c5816c46f245bb$var$TAG_NAME_REGEX.test(processedTagName)) // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return 'div';
    return processedTagName;
}
function $66c5816c46f245bb$export$370a3fb2c1e85509(width, height) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}




/* eslint-disable */ /**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */ 

var $f4022f9fa1e52f9f$export$2edcab8dd1869daa = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9
};
var $f4022f9fa1e52f9f$export$f06e977173f1857c = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11
};
var $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1 = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8
};
var $f4022f9fa1e52f9f$export$4e7964972bb3e05e = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9
};
var $f4022f9fa1e52f9f$export$df4c88b305317825 = {
    Play: 0,
    Pause: 1
};





function $4c864dec2d0fc266$export$5426777f4276f7bf(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) return undefined;
    return cssStyleSheets.map(function(cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function(cssRule) {
            return cssRule.cssText;
        });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
        };
        return styleSheet;
    });
}








function $14acb1a5b2223964$export$d36a50b4e4d32f1a(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN) // dup condition for direct access case
    return null;
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).MASK && attributeName !== (0, $096eed2d25f26114$export$ff33c64c78e35b2b) && !(0, $f53c969915647662$export$4ab9e1b4853d6dd7).includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch(attributeName){
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return 0, $096eed2d25f26114$export$76054905c0914783;
        }
        // mask image URLs
        if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            var image = element;
            if (image.naturalWidth > 0) return (0, $66c5816c46f245bb$export$370a3fb2c1e85509)(image.naturalWidth, image.naturalHeight);
            var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (width > 0 || height > 0) return (0, $66c5816c46f245bb$export$370a3fb2c1e85509)(width, height);
            // if we can't get the image size, fallback to the censored image
            return 0, $096eed2d25f26114$export$4ab830af01a1bf7e;
        }
        // mask source URLs
        if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) return 0, $096eed2d25f26114$export$4ab830af01a1bf7e;
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') return 0, $096eed2d25f26114$export$76054905c0914783;
        // mask data-* attributes
        if (attributeValue && (0, $b287859a2cd2eacd$export$68326237475e9a7d)(attributeName, 'data-')) // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
        return 0, $096eed2d25f26114$export$76054905c0914783;
        // mask iframe srcdoc
        if (tagName === 'IFRAME' && attributeName === 'srcdoc') return 0, $096eed2d25f26114$export$76054905c0914783;
    }
    if (!attributeValue || typeof attributeValue !== 'string') return attributeValue;
    // Minimum Fix for customer.
    if ((0, $b22ed8845addf22a$export$4731ef4a2d5817b7)(attributeValue)) return (0, $b22ed8845addf22a$export$7e3e020b0533decd)(attributeValue);
    return attributeValue;
}


function $5312144f41e7d226$export$4954cae66e755861(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN) return {};
    var safeAttrs = {};
    var tagName = (0, $66c5816c46f245bb$export$b3a58098b2e64dd6)(element.tagName);
    var doc = element.ownerDocument;
    for(var i = 0; i < element.attributes.length; i += 1){
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = (0, $14acb1a5b2223964$export$d36a50b4e4d32f1a)(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) safeAttrs[attributeName] = attributeValue;
    }
    if (element.value && (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = (0, $66c5816c46f245bb$export$9a014d2606da64f5)(element, nodePrivacyLevel);
        if (formValue !== undefined) safeAttrs.value = formValue;
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */ if (tagName === 'option' && nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) safeAttrs.selected = optionElement.selected;
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function(s) {
            return s.href === element.href;
        });
        var cssText = $5312144f41e7d226$export$ef1cc196b0353a30(stylesheet);
        if (cssText && stylesheet) safeAttrs._cssText = cssText;
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = $5312144f41e7d226$export$ef1cc196b0353a30(element.sheet);
        if (cssText) safeAttrs._cssText = cssText;
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */ var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).ALLOW) safeAttrs.checked = !!inputElement.checked;
        else if ((0, $096eed2d25f26114$export$f97c617afddc1089)(inputElement, nodePrivacyLevel)) delete safeAttrs.checked;
    }
    /**
     * Serialize the media playback state
     */ if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */ var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch(serializationContext.status){
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ :
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) serializationContext.elementsScrollPositions.set(element, {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
            });
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ :
            if (serializationContext.elementsScrollPositions.has(element)) _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
            break;
    }
    if (scrollLeft) safeAttrs.rr_scrollLeft = scrollLeft;
    if (scrollTop) safeAttrs.rr_scrollTop = scrollTop;
    return safeAttrs;
}
function $5312144f41e7d226$export$ef1cc196b0353a30(cssStyleSheet) {
    if (!cssStyleSheet) return null;
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) return null;
    var styleSheetCssText = Array.from(rules, (0, $3d758b2023765aca$export$95df08bae54cb4df)() ? $5312144f41e7d226$var$getCssRuleStringForSafari : $5312144f41e7d226$var$getCssRuleString).join('');
    return (0, $66c5816c46f245bb$export$f7bc20cfc5b360e4)(styleSheetCssText, cssStyleSheet.href);
}
function $5312144f41e7d226$var$getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if ($5312144f41e7d226$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return $5312144f41e7d226$var$getCssRuleString(rule);
}
function $5312144f41e7d226$var$getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return $5312144f41e7d226$var$isCSSImportRule(rule) && $5312144f41e7d226$export$ef1cc196b0353a30(rule.styleSheet) || rule.cssText;
}
function $5312144f41e7d226$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $5312144f41e7d226$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}


function $5247effe67b1adb1$export$27792c824d895cd4(node, options) {
    var serializedNode = $5247effe67b1adb1$var$serializeNode(node, options);
    if (!serializedNode) return null;
    // Try to reuse the previous id
    var id = (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(node) || $5247effe67b1adb1$export$8ce4034bbb89f82a();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    (0, $66c5816c46f245bb$export$8fed415004211d23)(node, id);
    if (options.serializedNodeIds) options.serializedNodeIds.add(id);
    return serializedNodeWithId;
}
var $5247effe67b1adb1$var$_nextId = 1;
function $5247effe67b1adb1$export$8ce4034bbb89f82a() {
    return $5247effe67b1adb1$var$_nextId++;
}
function $5247effe67b1adb1$export$6cba1c3abeb370b2(node, options) {
    var result = [];
    (0, $390d7e44cf00bd59$export$522badb50a8fb0b)(node, function(childNode) {
        var serializedChildNode = $5247effe67b1adb1$export$27792c824d895cd4(childNode, options);
        if (serializedChildNode) result.push(serializedChildNode);
    });
    return result;
}
function $5247effe67b1adb1$var$serializeNode(node, options) {
    switch(node.nodeType){
        case node.DOCUMENT_NODE:
            return $5247effe67b1adb1$export$91525d3a437a6c5c(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return $5247effe67b1adb1$var$serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return $5247effe67b1adb1$var$serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return $5247effe67b1adb1$var$serializeElementNode(node, options);
        case node.TEXT_NODE:
            return $5247effe67b1adb1$var$serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return $5247effe67b1adb1$var$serializeCDataNode();
    }
}
function $5247effe67b1adb1$export$91525d3a437a6c5c(document, options) {
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).Document,
        childNodes: $5247effe67b1adb1$export$6cba1c3abeb370b2(document, options),
        adoptedStyleSheets: (0, $4c864dec2d0fc266$export$5426777f4276f7bf)(document.adoptedStyleSheets)
    };
}
function $5247effe67b1adb1$var$serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = (0, $390d7e44cf00bd59$export$3a98bd54c2ced0bf)(element);
    if (isShadowRoot) options.serializationContext.shadowRootsController.addShadowRoot(element);
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).DocumentFragment,
        childNodes: $5247effe67b1adb1$export$6cba1c3abeb370b2(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? (0, $4c864dec2d0fc266$export$5426777f4276f7bf)(element.adoptedStyleSheets) : undefined
    };
}
function $5247effe67b1adb1$var$serializeDocumentTypeNode(documentType) {
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */ function $5247effe67b1adb1$var$serializeElementNode(element, options) {
    var _a;
    var tagName = (0, $66c5816c46f245bb$export$b3a58098b2e64dd6)(element.tagName);
    var isSVG = $5247effe67b1adb1$var$isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = (0, $096eed2d25f26114$export$3e5e4c23b3787dea)((0, $096eed2d25f26114$export$c417e854a5c24a6f)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).Element,
            tagName: tagName,
            attributes: (_a = {
                rr_width: "".concat(width, "px"),
                rr_height: "".concat(height, "px")
            }, _a[0, $096eed2d25f26114$export$ff33c64c78e35b2b] = (0, $096eed2d25f26114$export$e41cc9b2bd72efb8), _a),
            childNodes: [],
            isSVG: isSVG
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).IGNORE) return;
    var attributes = (0, $5312144f41e7d226$export$4954cae66e755861)(element, nodePrivacyLevel, options);
    var childNodes = [];
    if ((0, $390d7e44cf00bd59$export$13782f450ac5e09a)(element) && // Do not serialize style children as the css rules are already in the _cssText attribute
    tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) childNodesSerializationOptions = options;
        else childNodesSerializationOptions = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({}, options, {
            parentNodePrivacyLevel: nodePrivacyLevel,
            ignoreWhiteSpace: tagName === 'head'
        });
        childNodes = $5247effe67b1adb1$export$6cba1c3abeb370b2(element, childNodesSerializationOptions);
    }
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG
    };
}
function $5247effe67b1adb1$var$isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */ function $5247effe67b1adb1$var$serializeTextNode(textNode, options) {
    var textContent = (0, $096eed2d25f26114$export$132e79e4118a78e0)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) return;
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).Text,
        textContent: textContent
    };
}
function $5247effe67b1adb1$var$serializeCDataNode() {
    return {
        type: (0, $f4022f9fa1e52f9f$export$f06e977173f1857c).CDATA,
        textContent: ''
    };
}


function $67c71d4896ac3366$export$6c4b5890a966884d(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return (0, $5247effe67b1adb1$export$27792c824d895cd4)(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration
    });
}








function $9f8a7fd13e5b98bd$export$c4dfce035d43d1e0(event) {
    return Boolean(event.changedTouches);
}
function $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29(event) {
    if (event.composed === true && (0, $390d7e44cf00bd59$export$1fde2ba54cd81850)(event.target)) return event.composedPath()[0];
    return event.target;
}


/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */ // Scrollbar widths vary across properties on different devices and browsers
var $ba566a704a25e63f$var$TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */ function $ba566a704a25e63f$var$isVisualViewportFactoredIn(visualViewport) {
    return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > $ba566a704a25e63f$var$TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > $ba566a704a25e63f$var$TOLERANCE;
}
var $ba566a704a25e63f$export$eb47450612326c2 = function(clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY
    };
    if (!visualViewport) // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
    else if ($ba566a704a25e63f$var$isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    } else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var $ba566a704a25e63f$export$27974520bd71cbc4 = function(visualViewport) {
    return {
        scale: visualViewport.scale,
        offsetLeft: visualViewport.offsetLeft,
        offsetTop: visualViewport.offsetTop,
        pageLeft: visualViewport.pageLeft,
        pageTop: visualViewport.pageTop,
        height: visualViewport.height,
        width: visualViewport.width
    };
};




function $0821a75a0910c99f$export$8c66addc1bcc799e(source, data) {
    return {
        data: (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
            source: source
        }, data),
        type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).IncrementalSnapshot,
        timestamp: (0, $fafd178883cb17fc$export$71f52cdbbf629086)()
    };
}


var $9b8f90bfb8392fee$var$MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function $9b8f90bfb8392fee$export$9dc14b2d5956f1cb(configuration, moveCb) {
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function(event) {
        var target = (0, $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29)(event);
        if ((0, $66c5816c46f245bb$export$baab016255f94f54)(target)) {
            var coordinates = $9b8f90bfb8392fee$export$3267b4eb1312c189(event);
            if (!coordinates) return;
            var position = {
                id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y
            };
            moveCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $9f8a7fd13e5b98bd$export$c4dfce035d43d1e0)(event) ? (0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).TouchMove : (0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).MouseMove, {
                positions: [
                    position
                ]
            }));
        }
    }, $9b8f90bfb8392fee$var$MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false
    }), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, document, [
        "mousemove" /* DOM_EVENT.MOUSE_MOVE */ ,
        "touchmove" /* DOM_EVENT.TOUCH_MOVE */ 
    ], updatePosition, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}
function $9b8f90bfb8392fee$export$3267b4eb1312c189(event) {
    var _a = (0, $9f8a7fd13e5b98bd$export$c4dfce035d43d1e0)(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = (0, $ba566a704a25e63f$export$eb47450612326c2)(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) (0, $b20e9e3ee3028089$export$d922954195a17683)('mouse/touch event without x/y');
        return undefined;
    }
    return {
        x: x,
        y: y
    };
}









var $5f6f41b3e34579af$var$_a;
var $5f6f41b3e34579af$var$eventTypeToMouseInteraction = ($5f6f41b3e34579af$var$_a = {}, // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
$5f6f41b3e34579af$var$_a["pointerup" /* DOM_EVENT.POINTER_UP */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).MouseUp, $5f6f41b3e34579af$var$_a["mousedown" /* DOM_EVENT.MOUSE_DOWN */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).MouseDown, $5f6f41b3e34579af$var$_a["click" /* DOM_EVENT.CLICK */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).Click, $5f6f41b3e34579af$var$_a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).ContextMenu, $5f6f41b3e34579af$var$_a["dblclick" /* DOM_EVENT.DBL_CLICK */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).DblClick, $5f6f41b3e34579af$var$_a["focus" /* DOM_EVENT.FOCUS */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).Focus, $5f6f41b3e34579af$var$_a["blur" /* DOM_EVENT.BLUR */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).Blur, $5f6f41b3e34579af$var$_a["touchstart" /* DOM_EVENT.TOUCH_START */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).TouchStart, $5f6f41b3e34579af$var$_a["touchend" /* DOM_EVENT.TOUCH_END */ ] = (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).TouchEnd, $5f6f41b3e34579af$var$_a);
function $5f6f41b3e34579af$export$9b708d0caac77d2e(configuration, mouseInteractionCb, recordIds) {
    var handler = function(event) {
        var target = (0, $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29)(event);
        if ((0, $096eed2d25f26114$export$da439d4b145972be)(target, configuration.defaultPrivacyLevel) === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN || !(0, $66c5816c46f245bb$export$baab016255f94f54)(target)) return;
        var id = (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(target);
        var type = $5f6f41b3e34579af$var$eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).Blur && type !== (0, $f4022f9fa1e52f9f$export$4e7964972bb3e05e).Focus) {
            var coordinates = (0, $9b8f90bfb8392fee$export$3267b4eb1312c189)(event);
            if (!coordinates) return;
            interaction = {
                id: id,
                type: type,
                x: coordinates.x,
                y: coordinates.y
            };
        } else interaction = {
            id: id,
            type: type
        };
        var record = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
            id: recordIds.getIdForEvent(event)
        }, (0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).MouseInteraction, interaction));
        mouseInteractionCb(record);
    };
    return (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, document, Object.keys($5f6f41b3e34579af$var$eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true
    });
}








var $a474615d6eec2277$var$SCROLL_OBSERVER_THRESHOLD = 100;
function $a474615d6eec2277$export$de1563ff5a1bae99(configuration, scrollCb, elementsScrollPositions, target) {
    if (target === void 0) target = document;
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function(event) {
        var target = (0, $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29)(event);
        if (!target || (0, $096eed2d25f26114$export$da439d4b145972be)(target, configuration.defaultPrivacyLevel) === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN || !(0, $66c5816c46f245bb$export$baab016255f94f54)(target)) return;
        var id = (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(target);
        var scrollPositions = target === document ? {
            scrollTop: (0, $b49dd51dc1e7c0f8$export$91aaad5752ba6e7)(),
            scrollLeft: (0, $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2)()
        } : {
            scrollTop: Math.round(target.scrollTop),
            scrollLeft: Math.round(target.scrollLeft)
        };
        elementsScrollPositions.set(target, scrollPositions);
        scrollCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).Scroll, {
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop
        }));
    }, $a474615d6eec2277$var$SCROLL_OBSERVER_THRESHOLD), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, target, "scroll" /* DOM_EVENT.SCROLL */ , updatePosition, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}







var $a06ca5797aa60810$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function $a06ca5797aa60810$export$1b4a6a8302e2d23f(configuration, viewportResizeCb) {
    var viewportResizeSubscription = (0, $ed872b54a9ace364$export$2c24cc613e51a50f)(configuration).subscribe(function(data) {
        viewportResizeCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).ViewportResize, data));
    });
    return {
        stop: function() {
            viewportResizeSubscription.unsubscribe();
        }
    };
}
function $a06ca5797aa60810$export$23d8cfde1cc94c6f(configuration, visualViewportResizeCb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) return {
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(function() {
        visualViewportResizeCb({
            data: (0, $ba566a704a25e63f$export$27974520bd71cbc4)(visualViewport),
            type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).VisualViewport,
            timestamp: (0, $fafd178883cb17fc$export$71f52cdbbf629086)()
        });
    }, $a06ca5797aa60810$var$VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, visualViewport, [
        "resize" /* DOM_EVENT.RESIZE */ ,
        "scroll" /* DOM_EVENT.SCROLL */ 
    ], updateDimension, {
        capture: true,
        passive: true
    }).stop;
    return {
        stop: function() {
            removeListener();
            cancelThrottle();
        }
    };
}








function $ef9262233214376a$export$400dbd5b48537196(configuration, mediaInteractionCb) {
    return (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, document, [
        "play" /* DOM_EVENT.PLAY */ ,
        "pause" /* DOM_EVENT.PAUSE */ 
    ], function(event) {
        var target = (0, $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29)(event);
        if (!target || (0, $096eed2d25f26114$export$da439d4b145972be)(target, configuration.defaultPrivacyLevel) === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN || !(0, $66c5816c46f245bb$export$baab016255f94f54)(target)) return;
        mediaInteractionCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).MediaInteraction, {
            id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */  ? (0, $f4022f9fa1e52f9f$export$df4c88b305317825).Play : (0, $f4022f9fa1e52f9f$export$df4c88b305317825).Pause
        }));
    }, {
        capture: true,
        passive: true
    });
}






function $6a4b8351f494fda2$export$162cc50ed858c13d(styleSheetCb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && (0, $66c5816c46f245bb$export$baab016255f94f54)(styleSheet.ownerNode)) callback((0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(styleSheet.ownerNode));
    }
    var instrumentationStoppers = [
        (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(CSSStyleSheet.prototype, 'insertRule', function(_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet, function(id) {
                return styleSheetCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).StyleSheetRule, {
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: index
                        }
                    ]
                }));
            });
        }),
        (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(CSSStyleSheet.prototype, 'deleteRule', function(_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet, function(id) {
                return styleSheetCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).StyleSheetRule, {
                    id: id,
                    removes: [
                        {
                            index: index
                        }
                    ]
                }));
            });
        })
    ];
    if (typeof CSSGroupingRule !== 'undefined') instrumentGroupingCSSRuleClass(CSSGroupingRule);
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0, $23e9a88fc9385609$export$f00f71a511cb3cac)(cls.prototype, 'insertRule', function(_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function(id) {
                var path = $6a4b8351f494fda2$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index || 0);
                    styleSheetCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).StyleSheetRule, {
                        id: id,
                        adds: [
                            {
                                rule: rule,
                                index: path
                            }
                        ]
                    }));
                }
            });
        }), (0, $23e9a88fc9385609$export$f00f71a511cb3cac)(cls.prototype, 'deleteRule', function(_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function(id) {
                var path = $6a4b8351f494fda2$export$5d7dd7838ad576e9(styleSheet);
                if (path) {
                    path.push(index);
                    styleSheetCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).StyleSheetRule, {
                        id: id,
                        removes: [
                            {
                                index: path
                            }
                        ]
                    }));
                }
            });
        }));
    }
    return {
        stop: function() {
            instrumentationStoppers.forEach(function(stopper) {
                return stopper.stop();
            });
        }
    };
}
function $6a4b8351f494fda2$export$5d7dd7838ad576e9(rule) {
    var path = [];
    var currentRule = rule;
    while(currentRule.parentRule){
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) return;
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}




function $6f79c4fa77b2feb6$export$7d4f94d31d887582(configuration, focusCb) {
    return (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, window, [
        "focus" /* DOM_EVENT.FOCUS */ ,
        "blur" /* DOM_EVENT.BLUR */ 
    ], function() {
        focusCb({
            data: {
                has_focus: document.hasFocus()
            },
            type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).Focus,
            timestamp: (0, $fafd178883cb17fc$export$71f52cdbbf629086)()
        });
    });
}



function $bd4ed0952a0033c5$export$c3a8b90296cd71cc(lifeCycle, frustrationCb, recordIds) {
    var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */ , function(data) {
        var _a, _b;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */  && data.rawRumEvent.action.type === "click" /* ActionType.CLICK */  && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && 'events' in data.domainContext && data.domainContext.events && data.domainContext.events.length) frustrationCb({
            timestamp: data.rawRumEvent.date,
            type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).FrustrationRecord,
            data: {
                frustrationTypes: data.rawRumEvent.action.frustration.type,
                recordIds: data.domainContext.events.map(function(e) {
                    return recordIds.getIdForEvent(e);
                })
            }
        });
    });
    return {
        stop: function() {
            frustrationSubscription.unsubscribe();
        }
    };
}




function $2a271ef7d0ccae0b$export$83ef897ea1b996ba(lifeCycle, viewEndCb) {
    var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */ , function() {
        viewEndCb({
            timestamp: (0, $fafd178883cb17fc$export$71f52cdbbf629086)(),
            type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).ViewEnd
        });
    });
    return {
        stop: function() {
            viewEndSubscription.unsubscribe();
        }
    };
}








function $b6425153af858c5d$export$7ffba948d89b71d6(configuration, inputCb, target) {
    if (target === void 0) target = document;
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0, $d12554daef4f5e60$export$40a4ed63e5cb7043)(configuration, target, // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? [
        "change" /* DOM_EVENT.CHANGE */ 
    ] : [
        "input" /* DOM_EVENT.INPUT */ ,
        "change" /* DOM_EVENT.CHANGE */ 
    ], function(event) {
        var target = (0, $9f8a7fd13e5b98bd$export$e58f029f0fbfdb29)(event);
        if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) onElementChange(target);
    }, {
        capture: true,
        passive: true
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0, $23e9a88fc9385609$export$2a2b9a3e88aa9011)(HTMLInputElement.prototype, 'value', onElementChange),
            (0, $23e9a88fc9385609$export$2a2b9a3e88aa9011)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0, $23e9a88fc9385609$export$2a2b9a3e88aa9011)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0, $23e9a88fc9385609$export$2a2b9a3e88aa9011)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0, $23e9a88fc9385609$export$2a2b9a3e88aa9011)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange)
        ];
        stopPropertySetterInstrumentation = function() {
            instrumentationStoppers_1.forEach(function(stopper) {
                return stopper.stop();
            });
        };
    } else stopPropertySetterInstrumentation = (0, $772566d0dfa3645c$export$8793edee2d425525);
    return {
        stop: function() {
            stopPropertySetterInstrumentation();
            stopEventListeners();
        }
    };
    function onElementChange(target) {
        var nodePrivacyLevel = (0, $096eed2d25f26114$export$da439d4b145972be)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN) return;
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if ((0, $096eed2d25f26114$export$f97c617afddc1089)(target, nodePrivacyLevel)) return;
            inputState = {
                isChecked: target.checked
            };
        } else {
            var value = (0, $66c5816c46f245bb$export$9a014d2606da64f5)(target, nodePrivacyLevel);
            if (value === undefined) return;
            inputState = {
                text: value
            };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) (0, $b287859a2cd2eacd$export$4b80e395e36b5a56)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat((0, $d84da87a5bdc7a20$export$a5d1f61e0bd5c403)(name), "\"]")), function(el) {
            if (el !== target) // TODO: Consider the privacy implications for various differing input privacy levels
            cbWithDedup(el, {
                isChecked: false
            });
        });
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */ function cbWithDedup(target, inputState) {
        if (!(0, $66c5816c46f245bb$export$baab016255f94f54)(target)) return;
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            inputCb((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).Input, (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
                id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(target)
            }, inputState)));
        }
    }
}







/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */ var $720672434d5f1bfe$var$MUTATION_PROCESS_MAX_DELAY = 100;
var $720672434d5f1bfe$export$3bd49c5ee28656ba = 16;
function $720672434d5f1bfe$export$b2ea3e1c9a968529(processMutationBatch) {
    var cancelScheduledFlush = (0, $772566d0dfa3645c$export$8793edee2d425525);
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    var _a = (0, $772566d0dfa3645c$export$de363e709c412c8a)(flush, $720672434d5f1bfe$export$3bd49c5ee28656ba, {
        leading: false
    }), throttledFlush = _a.throttled, cancelThrottle = _a.cancel;
    return {
        addMutations: function(mutations) {
            if (pendingMutations.length === 0) cancelScheduledFlush = (0, $d205e1c6fda43570$export$9288a5d956b3efbe)(throttledFlush, {
                timeout: $720672434d5f1bfe$var$MUTATION_PROCESS_MAX_DELAY
            });
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function() {
            cancelScheduledFlush();
            cancelThrottle();
        }
    };
}



function $49f6acf317c92d20$export$24d76f013ec44d4c(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = (0, $1e55a02d0fb92a5e$export$e4f8ebbdf64ea982)();
    if (!MutationObserver) return {
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525),
        flush: (0, $772566d0dfa3645c$export$8793edee2d425525)
    };
    var mutationBatch = (0, $720672434d5f1bfe$export$b2ea3e1c9a968529)(function(mutations) {
        $49f6acf317c92d20$var$processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0, $1d6ff96621fb36bb$export$ec5b303098bc4b7f)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return {
        stop: function() {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function() {
            mutationBatch.flush();
        }
    };
}
function $49f6acf317c92d20$var$processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    var nodePrivacyLevelCache = new Map();
    mutations.filter(function(mutation) {
        return mutation.type === 'childList';
    }).forEach(function(mutation) {
        mutation.removedNodes.forEach(function(removedNode) {
            $49f6acf317c92d20$var$traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function(mutation) {
        return mutation.target.isConnected && (0, $66c5816c46f245bb$export$267b85776945782d)(mutation.target) && (0, $096eed2d25f26114$export$da439d4b145972be)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN;
    });
    var _a = $49f6acf317c92d20$var$processChildListMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === 'childList';
    }), configuration, shadowRootsController, nodePrivacyLevelCache), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = $49f6acf317c92d20$var$processCharacterDataMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    var attributes = $49f6acf317c92d20$var$processAttributesMutations(filteredMutations.filter(function(mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) return;
    mutationCallback((0, $0821a75a0910c99f$export$8c66addc1bcc799e)((0, $f4022f9fa1e52f9f$export$24bb3ebc067ff5e1).Mutation, {
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes
    }));
}
function $49f6acf317c92d20$var$processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function(node) {
            if (!addedAndMovedNodes.has(node)) removedNodes.set(node, mutation.target);
            addedAndMovedNodes.delete(node);
        });
    };
    for(var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++){
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    $49f6acf317c92d20$export$3060629b5781df1e(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for(var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++){
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) continue;
        var parentNodePrivacyLevel = (0, $096eed2d25f26114$export$da439d4b145972be)(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN || parentNodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).IGNORE) continue;
        var serializedNode = (0, $5247effe67b1adb1$export$27792c824d895cd4)(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: {
                status: 2 /* SerializationContextStatus.MUTATION */ ,
                shadowRootsController: shadowRootsController
            },
            configuration: configuration
        });
        if (!serializedNode) continue;
        var parentNode = (0, $390d7e44cf00bd59$export$4e12058fc4d51d56)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(parentNode),
            node: serializedNode
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function(parent, node) {
        if ((0, $66c5816c46f245bb$export$baab016255f94f54)(node)) removedNodeMutations.push({
            parentId: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(parent),
            id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(node)
        });
    });
    return {
        adds: addedNodeMutations,
        removes: removedNodeMutations,
        hasBeenSerialized: hasBeenSerialized
    };
    function hasBeenSerialized(node) {
        return (0, $66c5816c46f245bb$export$baab016255f94f54)(node) && serializedNodeIds.has((0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while(nextSibling){
            if ((0, $66c5816c46f245bb$export$baab016255f94f54)(nextSibling)) return (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(nextSibling);
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function $49f6acf317c92d20$var$processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function(mutation) {
        if (handledNodes.has(mutation.target)) return false;
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for(var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++){
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) continue;
        var parentNodePrivacyLevel = (0, $096eed2d25f26114$export$da439d4b145972be)((0, $390d7e44cf00bd59$export$4e12058fc4d51d56)(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).HIDDEN || parentNodePrivacyLevel === (0, $096eed2d25f26114$export$92940eb5f25d0fc5).IGNORE) continue;
        textMutations.push({
            id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0, $096eed2d25f26114$export$132e79e4118a78e0)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
        });
    }
    return textMutations;
}
function $49f6acf317c92d20$var$processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function(mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes && handledAttributes.has(mutation.attributeName)) return false;
        if (!handledAttributes) handledElements.set(mutation.target, new Set([
            mutation.attributeName
        ]));
        else handledAttributes.add(mutation.attributeName);
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for(var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++){
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) continue;
        var privacyLevel = (0, $096eed2d25f26114$export$da439d4b145972be)(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        var attributeValue = (0, $14acb1a5b2223964$export$d36a50b4e4d32f1a)(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = (0, $66c5816c46f245bb$export$9a014d2606da64f5)(mutation.target, privacyLevel);
            if (inputValue === undefined) continue;
            transformedValue = inputValue;
        } else if (typeof attributeValue === 'string') transformedValue = attributeValue;
        else transformedValue = null;
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: (0, $66c5816c46f245bb$export$1cdf184f338e4a7b)(mutation.target),
                attributes: {}
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function $49f6acf317c92d20$export$3060629b5781df1e(nodes) {
    nodes.sort(function(a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */ if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) return -1;
        /* eslint-enable no-bitwise */ return 0;
    });
}
function $49f6acf317c92d20$var$traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0, $390d7e44cf00bd59$export$1fde2ba54cd81850)(removedNode)) shadowDomRemovedCallback(removedNode.shadowRoot);
    (0, $390d7e44cf00bd59$export$522badb50a8fb0b)(removedNode, function(childNode) {
        return $49f6acf317c92d20$var$traverseRemovedShadowDom(childNode, shadowDomRemovedCallback);
    });
}




function $bc09c6c4b264fe70$export$e1169a2914f55ec7() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function(element, scrollPositions) {
            if (element === document && !document.scrollingElement) // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
            // in some cases scrolling elements can not be defined, we don't support those for now
            return;
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function(element) {
            return scrollPositionsByElement.get(element);
        },
        has: function(element) {
            return scrollPositionsByElement.has(element);
        }
    };
}



var $f1e8ae18fd501662$export$436c949d161d53cc = function(configuration, callback, elementsScrollPositions) {
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function(shadowRoot) {
            if (controllerByShadowRoot.has(shadowRoot)) return;
            var mutationTracker = (0, $49f6acf317c92d20$export$24d76f013ec44d4c)(callback, configuration, shadowRootsController, shadowRoot);
            // The change event does not bubble up across the shadow root, we have to listen on the shadow root
            var inputTracker = (0, $b6425153af858c5d$export$7ffba948d89b71d6)(configuration, callback, shadowRoot);
            // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
            var scrollTracker = (0, $a474615d6eec2277$export$de1563ff5a1bae99)(configuration, callback, elementsScrollPositions, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: function() {
                    return mutationTracker.flush();
                },
                stop: function() {
                    mutationTracker.stop();
                    inputTracker.stop();
                    scrollTracker.stop();
                }
            });
        },
        removeShadowRoot: function(shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
            return;
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function() {
            controllerByShadowRoot.forEach(function(_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function() {
            controllerByShadowRoot.forEach(function(_a) {
                var flush = _a.flush;
                return flush();
            });
        }
    };
    return shadowRootsController;
};







function $f4f6b32442ffef0e$export$4955b6cdd7723991(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
    var takeFullSnapshot = function(timestamp, serializationContext) {
        if (timestamp === void 0) timestamp = (0, $fafd178883cb17fc$export$71f52cdbbf629086)();
        if (serializationContext === void 0) serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */ ,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController
        };
        var _a = (0, $ed872b54a9ace364$export$e79021d67c61dfbd)(), width = _a.width, height = _a.height;
        var records = [
            {
                data: {
                    height: height,
                    href: window.location.href,
                    width: width
                },
                type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).Meta,
                timestamp: timestamp
            },
            {
                data: {
                    has_focus: document.hasFocus()
                },
                type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).Focus,
                timestamp: timestamp
            },
            {
                data: {
                    node: (0, $67c71d4896ac3366$export$6c4b5890a966884d)(document, configuration, serializationContext),
                    initialOffset: {
                        left: (0, $b49dd51dc1e7c0f8$export$1a2bd001e684a8d2)(),
                        top: (0, $b49dd51dc1e7c0f8$export$91aaad5752ba6e7)()
                    }
                },
                type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).FullSnapshot,
                timestamp: timestamp
            }
        ];
        if (window.visualViewport) records.push({
            data: (0, $ba566a704a25e63f$export$27974520bd71cbc4)(window.visualViewport),
            type: (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).VisualViewport,
            timestamp: timestamp
        });
        return records;
    };
    fullSnapshotCallback(takeFullSnapshot());
    var unsubscribe = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */ , function(view) {
        flushMutations();
        fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
            shadowRootsController: shadowRootsController,
            status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */ ,
            elementsScrollPositions: elementsScrollPositions
        }));
    }).unsubscribe;
    return {
        stop: unsubscribe
    };
}


function $1d5cf29b7dc064ad$export$9a1e4d732092db82() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function(event) {
            if (!recordIds.has(event)) recordIds.set(event, nextId++);
            return recordIds.get(event);
        }
    };
}


function $e80fa3a4d7a561db$export$e5185e241753e543(options) {
    var emit = options.emit, configuration = options.configuration, lifeCycle = options.lifeCycle;
    // runtime checks for user options
    if (!emit) throw new Error('emit function is required');
    var emitAndComputeStats = function(record) {
        emit(record);
        (0, $8eb7b09bdabb3e6f$export$528ac5c14fe2fa6b)('record', {
            record: record
        });
        var view = options.viewHistory.findView();
        $de188ba0cd76f643$export$ab0ab92b3cb31c66(view.id);
    };
    var elementsScrollPositions = (0, $bc09c6c4b264fe70$export$e1169a2914f55ec7)();
    var shadowRootsController = (0, $f1e8ae18fd501662$export$436c949d161d53cc)(configuration, emitAndComputeStats, elementsScrollPositions);
    var stopFullSnapshots = (0, $f4f6b32442ffef0e$export$4955b6cdd7723991)(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function(records) {
        return records.forEach(function(record) {
            return emitAndComputeStats(record);
        });
    }).stop;
    function flushMutations() {
        shadowRootsController.flush();
        mutationTracker.flush();
    }
    var recordIds = (0, $1d5cf29b7dc064ad$export$9a1e4d732092db82)();
    var mutationTracker = (0, $49f6acf317c92d20$export$24d76f013ec44d4c)(emitAndComputeStats, configuration, shadowRootsController, document);
    var trackers = [
        mutationTracker,
        (0, $9b8f90bfb8392fee$export$9dc14b2d5956f1cb)(configuration, emitAndComputeStats),
        (0, $5f6f41b3e34579af$export$9b708d0caac77d2e)(configuration, emitAndComputeStats, recordIds),
        (0, $a474615d6eec2277$export$de1563ff5a1bae99)(configuration, emitAndComputeStats, elementsScrollPositions, document),
        (0, $a06ca5797aa60810$export$1b4a6a8302e2d23f)(configuration, emitAndComputeStats),
        (0, $b6425153af858c5d$export$7ffba948d89b71d6)(configuration, emitAndComputeStats),
        (0, $ef9262233214376a$export$400dbd5b48537196)(configuration, emitAndComputeStats),
        (0, $6a4b8351f494fda2$export$162cc50ed858c13d)(emitAndComputeStats),
        (0, $6f79c4fa77b2feb6$export$7d4f94d31d887582)(configuration, emitAndComputeStats),
        (0, $a06ca5797aa60810$export$23d8cfde1cc94c6f)(configuration, emitAndComputeStats),
        (0, $bd4ed0952a0033c5$export$c3a8b90296cd71cc)(lifeCycle, emitAndComputeStats, recordIds),
        (0, $2a271ef7d0ccae0b$export$83ef897ea1b996ba)(lifeCycle, function(viewEndRecord) {
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        })
    ];
    return {
        stop: function() {
            shadowRootsController.stop();
            trackers.forEach(function(tracker) {
                return tracker.stop();
            });
            stopFullSnapshots();
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController
    };
}








function $9fbab539f7a5d513$export$b74fe9b7c5190a03(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([
        data
    ], {
        type: 'application/octet-stream'
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([
        serializedMetadataAndSegmentSizes
    ], {
        type: 'application/json'
    }));
    return {
        data: formData,
        bytesCount: data.byteLength
    };
}





function $d2bcd6486e08f4b9$export$a3c3648560d43a8(_a) {
    var context = _a.context, creationReason = _a.creationReason, encoder = _a.encoder;
    var encodedBytesCount = 0;
    var viewId = context.view.id;
    var metadata = (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)({
        start: Infinity,
        end: -Infinity,
        creation_reason: creationReason,
        records_count: 0,
        has_full_snapshot: false,
        index_in_view: $de188ba0cd76f643$export$4223f4e280561ccd(viewId),
        source: 'browser'
    }, context);
    $de188ba0cd76f643$export$1c43f9ac826b6462(viewId);
    function addRecord(record, callback) {
        metadata.start = Math.min(metadata.start, record.timestamp);
        metadata.end = Math.max(metadata.end, record.timestamp);
        metadata.records_count += 1;
        metadata.has_full_snapshot || (metadata.has_full_snapshot = record.type === (0, $f4022f9fa1e52f9f$export$2edcab8dd1869daa).FullSnapshot);
        var prefix = encoder.isEmpty ? '{"records":[' : ',';
        encoder.write(prefix + JSON.stringify(record), function(additionalEncodedBytesCount) {
            encodedBytesCount += additionalEncodedBytesCount;
            callback(encodedBytesCount);
        });
    }
    function flush(callback) {
        if (encoder.isEmpty) throw new Error('Empty segment flushed');
        encoder.write("],".concat(JSON.stringify(metadata).slice(1), "\n"));
        encoder.finish(function(encoderResult) {
            $de188ba0cd76f643$export$ae4fdff69a4959e9(metadata.view.id, encoderResult.rawBytesCount);
            callback(metadata, encoderResult);
        });
    }
    return {
        addRecord: addRecord,
        flush: flush
    };
}


var $5c9fc380af7b5cde$export$b31f220778239113 = 5 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
var $5c9fc380af7b5cde$export$498b4a5e1a0c6ede = 60000;
function $5c9fc380af7b5cde$export$4fa4acf70ad1cce9(lifeCycle, configuration, sessionManager, viewHistory, httpRequest, encoder) {
    return $5c9fc380af7b5cde$export$a72587c29e6a171e(lifeCycle, function() {
        return $5c9fc380af7b5cde$export$ffabacd17e6fd35a(configuration.applicationId, sessionManager, viewHistory);
    }, httpRequest, encoder);
}
function $5c9fc380af7b5cde$export$a72587c29e6a171e(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
        nextSegmentCreationReason: 'init'
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */ , function() {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */ ) {
            state.segment.flush(function(metadata, encoderResult) {
                var payload = (0, $9fbab539f7a5d513$export$b74fe9b7c5190a03)(encoderResult.output, metadata, encoderResult.rawBytesCount);
                if ((0, $0ebb46f2959d2690$export$cbb6b5cdbd0f2b60)(flushReason)) httpRequest.sendOnExit(payload);
                else httpRequest.send(payload);
            });
            (0, $02784b622c768a70$export$4e6a25ba7ce9d78e)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') state = {
            status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ,
            nextSegmentCreationReason: flushReason
        };
        else state = {
            status: 2 /* SegmentCollectionStatus.Stopped */ 
        };
    }
    return {
        addRecord: function(record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */ ) return;
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */ ) {
                var context = getSegmentContext();
                if (!context) return;
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */ ,
                    segment: (0, $d2bcd6486e08f4b9$export$a3c3648560d43a8)({
                        encoder: encoder,
                        context: context,
                        creationReason: state.nextSegmentCreationReason
                    }),
                    expirationTimeoutId: (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
                        flushSegment('segment_duration_limit');
                    }, $5c9fc380af7b5cde$export$b31f220778239113)
                };
            }
            state.segment.addRecord(record, function(encodedBytesCount) {
                if (encodedBytesCount > $5c9fc380af7b5cde$export$498b4a5e1a0c6ede) flushSegment('segment_bytes_limit');
            });
        },
        stop: function() {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        }
    };
}
function $5c9fc380af7b5cde$export$ffabacd17e6fd35a(applicationId, sessionManager, viewHistory) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewHistory.findView();
    if (!session || !viewContext) return undefined;
    return {
        application: {
            id: applicationId
        },
        session: {
            id: session.id
        },
        view: {
            id: viewContext.id
        }
    };
}
function $5c9fc380af7b5cde$export$fabe14a3439e20b(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) newSegmentBytesLimit = 60000;
    $5c9fc380af7b5cde$export$498b4a5e1a0c6ede = newSegmentBytesLimit;
}





function $36e7aacddb9ca9fe$export$f4759b712f6b3c83(viewHistory) {
    var bridge = (0, $f0aff45a57046ce0$export$86c8e1e7efd0dfc1)();
    return {
        addRecord: function(record) {
            // Get the current active view, not at the time of the record, aligning with the segment logic.
            // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
            // However the risk is minimal. We could address the issue when potential negative impact are identified.
            var view = viewHistory.findView();
            bridge.send('record', record, view.id);
        }
    };
}


function $e59c1dc0ff977688$export$9be9afda50c84681(lifeCycle, configuration, sessionManager, viewHistory, encoder, httpRequest) {
    var cleanupTasks = [];
    var reportError = function(error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */ , {
            error: error
        });
        (0, $b20e9e3ee3028089$export$d922954195a17683)('Error reported to customer', {
            'error.message': error.message
        });
    };
    var replayRequest = httpRequest || (0, $27e3ab8a1341cab4$export$58d47321b4325073)(configuration.sessionReplayEndpointBuilder, (0, $5c9fc380af7b5cde$export$498b4a5e1a0c6ede), reportError);
    var addRecord;
    if (!(0, $f0aff45a57046ce0$export$a8ab916fee43a31b)()) {
        var segmentCollection = (0, $5c9fc380af7b5cde$export$4fa4acf70ad1cce9)(lifeCycle, configuration, sessionManager, viewHistory, replayRequest, encoder);
        addRecord = segmentCollection.addRecord;
        cleanupTasks.push(segmentCollection.stop);
    } else addRecord = (0, $36e7aacddb9ca9fe$export$f4759b712f6b3c83)(viewHistory).addRecord;
    var stopRecording = (0, $e80fa3a4d7a561db$export$e5185e241753e543)({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
        viewHistory: viewHistory
    }).stop;
    cleanupTasks.push(stopRecording);
    return {
        stop: function() {
            cleanupTasks.forEach(function(task) {
                return task();
            });
        }
    };
}





function $275c53661b5d2fb2$export$1b838d3ae89a44b8(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, worker, 'message', function(_a) {
        var workerResponse = _a.data;
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) return;
        rawBytesCount += workerResponse.additionalBytesCount;
        compressedData.push(workerResponse.result);
        compressedDataTrailer = workerResponse.trailer;
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
            if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
            else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
        } else {
            removeMessageListener();
            (0, $b20e9e3ee3028089$export$d922954195a17683)('Worker responses received out of order.');
        }
    }).stop;
    function consumeResult() {
        var output = compressedData.length === 0 ? new Uint8Array(0) : (0, $5baf81a8b4674c85$export$28e250f55413be00)(compressedData.concat(compressedDataTrailer));
        var result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate'
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (nextWriteActionId > 0) {
            worker.postMessage({
                action: 'reset',
                streamId: streamId
            });
            nextWriteActionId = 0;
        }
    }
    return {
        isAsync: true,
        get isEmpty () {
            return nextWriteActionId === 0;
        },
        write: function(data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data
            });
            nextWriteActionId += 1;
        },
        finish: function(callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) callback(consumeResult());
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach(function(pendingWriteAction) {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function() {
                    return callback(consumeResult());
                };
            }
        },
        finishSync: function() {
            sendResetIfNeeded();
            var pendingData = pendingWriteActions.map(function(pendingWriteAction) {
                // Make sure we do not call any write or finish callback
                delete pendingWriteAction.writeCallback;
                delete pendingWriteAction.finishCallback;
                return pendingWriteAction.data;
            }).join('');
            return (0, $b287859a2cd2eacd$export$e6e34fd1f2686227)(consumeResult(), {
                pendingData: pendingData
            });
        },
        estimateEncodedBytesCount: function(data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop: function() {
            removeMessageListener();
        }
    };
}



var $b455450598273b03$export$da9b966004898f5b = 30 * (0, $fafd178883cb17fc$export$32c0454ceff7f92d);
function $b455450598273b03$var$createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob([
        "!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),h=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),l=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),_=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},U=function(t,e,a){var n,r,s=new Array(16),h=0;for(n=1;n<=i;n++)s[n]=h=h+a[n-1]<<1;for(r=0;r<=e;r++){var l=t[2*r+1];0!==l&&(t[2*r]=A(s[l]++,l))}},I=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},B=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},E=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},S=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&E(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!E(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},C=function(t,e,n){var r,i,l,_,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(l=f[i],x(t,l+a+1,e),0!==(_=s[l])&&(i-=c[l],z(t,i,_)),r--,l=y(r),x(t,l,n),0!==(_=h[l])&&(r-=v[l],z(t,r,_)))}while(o<t.last_lit);x(t,256,e)},D=function(t,e){var a,n,r,s=e.dyn_tree,h=e.stat_desc.static_tree,l=e.stat_desc.has_stree,_=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<_;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,l&&(t.static_len-=h[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)S(t,s,a);r=_;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],S(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,S(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,h,l,_=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(_[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=_[2*_[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),_[2*n+1]=s,n>o||(t.bl_count[s]++,h=0,n>=c&&(h=f[n-c]),l=_[2*n],t.opt_len+=l*(s+h),u&&(t.static_len+=l*(d[2*n+1]+h)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(_[2*r+1]!==s&&(t.opt_len+=(s-_[2*r+1])*_[2*r],_[2*r+1]=s),n--)}}(t,e),U(s,o,t.bl_count)},j=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},M=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{x(t,r,t.bl_tree)}while(0!=--h);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),h--),x(t,16,t.bl_tree),z(t,h-3,2)):h<=10?(x(t,17,t.bl_tree),z(t,h-3,3)):(x(t,18,t.bl_tree),z(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},L=!1,T=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){B(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},H=function(t,e,n,r){var i,s,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),D(t,t.l_desc),D(t,t.d_desc),h=function(t){var e;for(j(t,t.dyn_ltree,t.l_desc.max_code),j(t,t.dyn_dtree,t.d_desc.max_code),D(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*_[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?T(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),C(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*_[r]+1],3);M(t,t.dyn_ltree,e-1),M(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),C(t,t.dyn_ltree,t.dyn_dtree)),I(t),r&&B(t)},R={_tr_init:function(t){L||(!function(){var t,e,a,_,m,y=new Array(16);for(a=0,_=0;_<28;_++)for(c[_]=a,t=0;t<1<<s[_];t++)f[a++]=_;for(f[a-1]=_,m=0,_=0;_<16;_++)for(v[_]=m,t=0;t<1<<h[_];t++)u[m++]=_;for(m>>=7;_<r;_++)for(v[_]=m<<7,t=0;t<1<<h[_]-7;t++)u[256+m++]=_;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(U(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,h,0,r,i),w=new b(new Array(0),l,0,19,7)}(),L=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,I(t)},_tr_stored_block:T,_tr_flush_block:H,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},K=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},N=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),O=function(t,e,a,n){var r=N,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return~t},q={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},F=0,G=2,J=3,P=4,Q=0,V=1,W=-1,X=0,Y=8,Z=R._tr_init,$=R._tr_stored_block,tt=R._tr_flush_block,et=R._tr_tally,at=R._tr_align,nt=F,rt=1,it=J,st=P,ht=5,lt=Q,_t=V,ot=-2,dt=-3,ut=-5,ft=W,ct=1,pt=2,gt=3,wt=4,vt=X,bt=2,mt=Y,yt=258,kt=262,zt=103,xt=113,At=666,Ut=function(t,e){return t.msg=q[e],e},It=function(t){return(t<<1)-(t>4?9:0)},Bt=function(t){for(var e=t.length;--e>=0;)t[e]=0},Et=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},St=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Ct=function(t,e){tt(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,St(t.strm)},Dt=function(t,e){t.pending_buf[t.pending++]=e},jt=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Mt=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-kt?t.strstart-(t.w_size-kt):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+yt,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=yt-(u-i),i=u-yt,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!=--r);return s<=t.lookahead?s:t.lookahead},Lt=function(t){var e,a,n,r,i,s,h,l,_,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-kt)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,h=t.window,l=t.strstart+t.lookahead,_=r,o=void 0,(o=s.avail_in)>_&&(o=_),a=0===o?0:(s.avail_in-=o,h.set(s.input.subarray(s.next_in,s.next_in+o),l),1===s.state.wrap?s.adler=K(s.adler,h,o,l):2===s.state.wrap&&(s.adler=O(s.adler,h,o,l)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=Et(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=Et(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<kt&&0!==t.strm.avail_in)},Tt=function(t,e){for(var a,n;;){if(t.lookahead<kt){if(Lt(t),t.lookahead<kt&&e===nt)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=Et(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-kt&&(t.match_length=Mt(t,a)),t.match_length>=3)if(n=et(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=Et(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=Et(t,t.ins_h,t.window[t.strstart+1]);else n=et(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Ct(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===st?(Ct(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ct(t,!1),0===t.strm.avail_out)?1:2},Ht=function(t,e){for(var a,n,r;;){if(t.lookahead<kt){if(Lt(t),t.lookahead<kt&&e===nt)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=Et(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-kt&&(t.match_length=Mt(t,a),t.match_length<=5&&(t.strategy===ct||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=et(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=Et(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Ct(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=et(t,0,t.window[t.strstart-1]))&&Ct(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=et(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===st?(Ct(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ct(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Kt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Lt(t),0===t.lookahead&&e===nt)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Ct(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-kt&&(Ct(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===st?(Ct(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Ct(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Tt),new Rt(4,5,16,8,Tt),new Rt(4,6,32,32,Tt),new Rt(4,4,16,16,Ht),new Rt(8,16,32,32,Ht),new Rt(8,16,128,128,Ht),new Rt(8,32,128,256,Ht),new Rt(32,128,258,1024,Ht),new Rt(32,258,258,4096,Ht)];function Nt(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=mt,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),Bt(this.dyn_ltree),Bt(this.dyn_dtree),Bt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),Bt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),Bt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Ot=function(t){if(!t||!t.state)return Ut(t,ot);t.total_in=t.total_out=0,t.data_type=bt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:xt,t.adler=2===e.wrap?0:1,e.last_flush=nt,Z(e),lt},qt=function(t){var e,a=Ot(t);return a===lt&&((e=t.state).window_size=2*e.w_size,Bt(e.head),e.max_lazy_match=Kt[e.level].max_lazy,e.good_match=Kt[e.level].good_length,e.nice_match=Kt[e.level].nice_length,e.max_chain_length=Kt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Ft=function(t,e,a,n,r,i){if(!t)return ot;var s=1;if(e===ft&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==mt||n<8||n>15||e<0||e>9||i<0||i>wt)return Ut(t,ot);8===n&&(n=9);var h=new Nt;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,qt(t)},Gt={deflateInit:function(t,e){return Ft(t,e,mt,15,8,vt)},deflateInit2:Ft,deflateReset:qt,deflateResetKeep:Ot,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?ot:(t.state.gzhead=e,lt):ot},deflate:function(t,e){var a,n;if(!t||!t.state||e>ht||e<0)return t?Ut(t,ot):ot;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===At&&e!==st)return Ut(t,0===t.avail_out?ut:ot);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Dt(r,31),Dt(r,139),Dt(r,8),r.gzhead?(Dt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Dt(r,255&r.gzhead.time),Dt(r,r.gzhead.time>>8&255),Dt(r,r.gzhead.time>>16&255),Dt(r,r.gzhead.time>>24&255),Dt(r,9===r.level?2:r.strategy>=pt||r.level<2?4:0),Dt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Dt(r,255&r.gzhead.extra.length),Dt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=O(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Dt(r,0),Dt(r,0),Dt(r,0),Dt(r,0),Dt(r,0),Dt(r,9===r.level?2:r.strategy>=pt||r.level<2?4:0),Dt(r,3),r.status=xt);else{var s=mt+(r.w_bits-8<<4)<<8;s|=(r.strategy>=pt||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=xt,jt(r,s),0!==r.strstart&&(jt(r,t.adler>>>16),jt(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),St(t),a=r.pending,r.pending!==r.pending_buf_size));)Dt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),St(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Dt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),St(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Dt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=zt)}else r.status=zt;if(r.status===zt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&St(t),r.pending+2<=r.pending_buf_size&&(Dt(r,255&t.adler),Dt(r,t.adler>>8&255),t.adler=0,r.status=xt)):r.status=xt),0!==r.pending){if(St(t),0===t.avail_out)return r.last_flush=-1,lt}else if(0===t.avail_in&&It(e)<=It(i)&&e!==st)return Ut(t,ut);if(r.status===At&&0!==t.avail_in)return Ut(t,ut);if(0!==t.avail_in||0!==r.lookahead||e!==nt&&r.status!==At){var h=r.strategy===pt?function(t,e){for(var a;;){if(0===t.lookahead&&(Lt(t),0===t.lookahead)){if(e===nt)return 1;break}if(t.match_length=0,a=et(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Ct(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===st?(Ct(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ct(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===gt?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=yt){if(Lt(t),t.lookahead<=yt&&e===nt)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+yt;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=yt-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=et(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=et(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Ct(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===st?(Ct(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ct(t,!1),0===t.strm.avail_out)?1:2}(r,e):Kt[r.level].func(r,e);if(3!==h&&4!==h||(r.status=At),1===h||3===h)return 0===t.avail_out&&(r.last_flush=-1),lt;if(2===h&&(e===rt?at(r):e!==ht&&($(r,0,0,!1),e===it&&(Bt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),St(t),0===t.avail_out))return r.last_flush=-1,lt}return e!==st?lt:r.wrap<=0?_t:(2===r.wrap?(Dt(r,255&t.adler),Dt(r,t.adler>>8&255),Dt(r,t.adler>>16&255),Dt(r,t.adler>>24&255),Dt(r,255&t.total_in),Dt(r,t.total_in>>8&255),Dt(r,t.total_in>>16&255),Dt(r,t.total_in>>24&255)):(jt(r,t.adler>>>16),jt(r,65535&t.adler)),St(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?lt:_t)},deflateEnd:function(t){if(!t||!t.state)return ot;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==zt&&e!==xt&&e!==At?Ut(t,ot):(t.state=null,e===xt?Ut(t,dt):lt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return ot;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return ot;if(1===r&&(t.adler=K(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(Bt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Lt(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=Et(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,Lt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,lt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Jt=new Uint8Array(256),Pt=0;Pt<256;Pt++)Jt[Pt]=Pt>=252?6:Pt>=248?5:Pt>=240?4:Pt>=224?3:Pt>=192?2:1;Jt[254]=Jt[254]=1;var Qt=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Vt=Object.prototype.toString,Wt=F,Xt=G,Yt=J,Zt=P,$t=Q,te=V,ee=W,ae=X,ne=Y;function re(){this.options={level:ee,method:ne,chunkSize:16384,windowBits:15,memLevel:8,strategy:ae};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Qt,this.strm.avail_out=0;var e=Gt.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==$t)throw new Error(q[e]);if(t.header&&Gt.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Vt.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Gt.deflateSetDictionary(this.strm,a))!==$t)throw new Error(q[e]);this._dict_set=!0}}function ie(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function se(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}re.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Zt:Wt,\"[object ArrayBuffer]\"===Vt.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Xt||n===Yt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Gt.deflate(r,n))===te)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Gt.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===$t;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},re.prototype.onData=function(t){this.chunks.push(t)},re.prototype.onEnd=function(t){t===$t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.35.1\"};case\"write\":var n=e.get(a.streamId);n||(n=new re,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,h=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),h+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(h),i=0,r=0;i<h;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,G),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:se(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){ie(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){ie(e,t)}}()}();"
    ])));
}
var $b455450598273b03$var$state = {
    status: 0 /* DeflateWorkerStatus.Nil */ 
};
function $b455450598273b03$export$8ad05986c983585a(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) createDeflateWorkerImpl = $b455450598273b03$var$createDeflateWorker;
    if ($b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) // doStartDeflateWorker updates the state to "loading" or "error"
    $b455450598273b03$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl);
    switch($b455450598273b03$var$state.status){
        case 1 /* DeflateWorkerStatus.Loading */ :
            $b455450598273b03$var$state.initializationFailureCallbacks.push(onInitializationFailure);
            return $b455450598273b03$var$state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */ :
            return $b455450598273b03$var$state.worker;
    }
}
function $b455450598273b03$export$1c93a34ce7f0a4fd() {
    if ($b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  || $b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.stop();
    $b455450598273b03$var$state = {
        status: 0 /* DeflateWorkerStatus.Nil */ 
    };
}
function $b455450598273b03$export$c2a4b833556ae71() {
    return $b455450598273b03$var$state.status;
}
function $b455450598273b03$export$ae2ae5e796988f9a(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) createDeflateWorkerImpl = $b455450598273b03$var$createDeflateWorker;
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, worker, 'error', function(error) {
            $b455450598273b03$var$onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0, $d12554daef4f5e60$export$3f65cefe8380dbea)(configuration, worker, 'message', function(_a) {
            var data = _a.data;
            if (data.type === 'errored') $b455450598273b03$var$onError(configuration, source, data.error, data.streamId);
            else if (data.type === 'initialized') $b455450598273b03$var$onInitialized(data.version);
        }).stop;
        worker.postMessage({
            action: 'init'
        });
        (0, $02784b622c768a70$export$831dc9f2ab0a617b)(function() {
            return $b455450598273b03$var$onTimeout(source);
        }, $b455450598273b03$export$da9b966004898f5b);
        var stop_1 = function() {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        $b455450598273b03$var$state = {
            status: 1 /* DeflateWorkerStatus.Loading */ ,
            worker: worker,
            stop: stop_1,
            initializationFailureCallbacks: []
        };
    } catch (error) {
        $b455450598273b03$var$onError(configuration, source, error);
    }
}
function $b455450598273b03$var$onTimeout(source) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        $b455450598273b03$var$state.initializationFailureCallbacks.forEach(function(callback) {
            return callback();
        });
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    }
}
function $b455450598273b03$var$onInitialized(version) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state = {
        status: 3 /* DeflateWorkerStatus.Initialized */ ,
        worker: $b455450598273b03$var$state.worker,
        stop: $b455450598273b03$var$state.stop,
        version: version
    };
}
function $b455450598273b03$var$onError(configuration, source, error, streamId) {
    if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */  || $b455450598273b03$var$state.status === 0 /* DeflateWorkerStatus.Nil */ ) {
        (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || error instanceof Error && $b455450598273b03$var$isMessageCspRelated(error.message)) {
            var baseMessage = void 0;
            if (configuration.workerUrl) baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            else baseMessage = 'Please make sure CSP is correctly configured.';
            (0, $429fd8a62f4aa1b2$export$79693fdaa4661ff2).error("".concat(baseMessage, " See documentation at ").concat((0, $429fd8a62f4aa1b2$export$61b69f86bb46c85e), "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        } else (0, $b20e9e3ee3028089$export$2e825f93958b0e6a)(error);
        if ($b455450598273b03$var$state.status === 1 /* DeflateWorkerStatus.Loading */ ) $b455450598273b03$var$state.initializationFailureCallbacks.forEach(function(callback) {
            return callback();
        });
        $b455450598273b03$var$state = {
            status: 2 /* DeflateWorkerStatus.Error */ 
        };
    } else (0, $b20e9e3ee3028089$export$2e825f93958b0e6a)(error, {
        worker_version: $b455450598273b03$var$state.status === 3 /* DeflateWorkerStatus.Initialized */  && $b455450598273b03$var$state.version,
        stream_id: streamId
    });
}
function $b455450598273b03$var$isMessageCspRelated(message) {
    return (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(message, 'Content Security Policy') || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
    (0, $b287859a2cd2eacd$export$ee2e0f811dca1807)(message, "requires 'TrustedScriptURL'");
}




/**
 * Test for Browser features used while recording
 */ function $92cd453a3fca38f8$export$3fe402ec04821f17() {
    return(// Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && typeof URL.createObjectURL === 'function' && 'forEach' in NodeList.prototype);
}





function $c99aae6d4d014aa5$export$5070ba0fc541c84(configuration, sessionManager, viewHistory, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted);
    var viewContext = viewHistory.findView();
    return (0, $a0227eab1dbc844e$export$58d09b88d0d4cf52)(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session
    });
}
function $c99aae6d4d014aa5$var$getErrorType(session, isRecordingStarted) {
    if (!(0, $92cd453a3fca38f8$export$3fe402ec04821f17)()) return 'browser-not-supported';
    if (!session) // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return 'rum-not-tracked';
    if (session.sessionReplay === 0 /* SessionReplayState.OFF */ ) // possibilities
    // - replay sampled out
    return 'incorrect-session-plan';
    if (!isRecordingStarted) return 'replay-not-started';
}


function $6dd097e009e9d65f$export$eedb6b2f1f53c8e(configuration, lifeCycle, sessionManager, viewHistory, startRecordingImpl, getOrCreateDeflateEncoder) {
    var status = 0 /* RecorderStatus.Stopped */ ;
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */ , function() {
        if (status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ) {
            stop();
            status = 1 /* RecorderStatus.IntentToStart */ ;
        }
    });
    // Stop the recorder on page unload to avoid sending records after the page is ended.
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */ , function(pageExitEvent) {
        if (pageExitEvent.reason === (0, $0ebb46f2959d2690$export$69c8658089134213).UNLOADING) stop();
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */ , function() {
        if (status === 1 /* RecorderStatus.IntentToStart */ ) start();
    });
    function start(options) {
        var session = sessionManager.findTrackedSession();
        if ($6dd097e009e9d65f$var$canStartRecording(session, options)) {
            status = 1 /* RecorderStatus.IntentToStart */ ;
            return;
        }
        if ($6dd097e009e9d65f$var$isRecordingInProgress(status)) return;
        status = 2 /* RecorderStatus.Starting */ ;
        (0, $6c090d2d29937490$export$12cb733fc911e4f7)(configuration, 'interactive', function() {
            if (status !== 2 /* RecorderStatus.Starting */ ) return;
            var deflateEncoder = getOrCreateDeflateEncoder();
            if (!deflateEncoder) {
                status = 0 /* RecorderStatus.Stopped */ ;
                return;
            }
            stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder).stop;
            status = 3 /* RecorderStatus.Started */ ;
        });
        if ($6dd097e009e9d65f$var$shouldForceReplay(session, options)) sessionManager.setForcedReplay();
    }
    function stop() {
        if (status !== 0 /* RecorderStatus.Stopped */  && status === 3 /* RecorderStatus.Started */ ) stopRecording === null || stopRecording === void 0 || stopRecording();
        status = 0 /* RecorderStatus.Stopped */ ;
    }
    var stopRecording;
    return {
        start: start,
        stop: stop,
        getSessionReplayLink: function() {
            return (0, $c99aae6d4d014aa5$export$5070ba0fc541c84)(configuration, sessionManager, viewHistory, status !== 0 /* RecorderStatus.Stopped */ );
        },
        isRecording: function() {
            return status === 3 /* RecorderStatus.Started */ ;
        }
    };
}
function $6dd097e009e9d65f$var$canStartRecording(session, options) {
    return !session || session.sessionReplay === 0 /* SessionReplayState.OFF */  && (!options || !options.force);
}
function $6dd097e009e9d65f$var$isRecordingInProgress(status) {
    return status === 2 /* RecorderStatus.Starting */  || status === 3 /* RecorderStatus.Started */ ;
}
function $6dd097e009e9d65f$var$shouldForceReplay(session, options) {
    return options && options.force && session.sessionReplay === 0 /* SessionReplayState.OFF */ ;
}



function $f15b3c4f990eacd1$export$8f7002373dcc6602() {
    var status = 0 /* PreStartRecorderStatus.None */ ;
    return {
        strategy: {
            start: function() {
                status = 1 /* PreStartRecorderStatus.HadManualStart */ ;
            },
            stop: function() {
                status = 2 /* PreStartRecorderStatus.HadManualStop */ ;
            },
            isRecording: function() {
                return false;
            },
            getSessionReplayLink: (0, $772566d0dfa3645c$export$8793edee2d425525)
        },
        shouldStartImmediately: function(configuration) {
            return status === 1 /* PreStartRecorderStatus.HadManualStart */  || status === 0 /* PreStartRecorderStatus.None */  && !configuration.startSessionReplayRecordingManually;
        }
    };
}


function $2dcd1b6060126fce$export$e9b5b20eb46e0952(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0, $f0aff45a57046ce0$export$a8ab916fee43a31b)() && !(0, $f0aff45a57046ce0$export$c3d8d1f8445a3630)("records" /* BridgeCapability.RECORDS */ ) || !(0, $92cd453a3fca38f8$export$3fe402ec04821f17)()) return {
        start: (0, $772566d0dfa3645c$export$8793edee2d425525),
        stop: (0, $772566d0dfa3645c$export$8793edee2d425525),
        getReplayStats: function() {
            return undefined;
        },
        onRumStart: (0, $772566d0dfa3645c$export$8793edee2d425525),
        isRecording: function() {
            return false;
        },
        getSessionReplayLink: function() {
            return undefined;
        }
    };
    // eslint-disable-next-line prefer-const
    var _a = (0, $f15b3c4f990eacd1$export$8f7002373dcc6602)(), strategy = _a.strategy, shouldStartImmediately = _a.shouldStartImmediately;
    return {
        start: function(options) {
            return strategy.start(options);
        },
        stop: function() {
            return strategy.stop();
        },
        getSessionReplayLink: function() {
            return strategy.getSessionReplayLink();
        },
        onRumStart: onRumStart,
        isRecording: function() {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return (0, $b455450598273b03$export$c2a4b833556ae71)() === 3 /* DeflateWorkerStatus.Initialized */  && strategy.isRecording();
        },
        getReplayStats: function(viewId) {
            return (0, $b455450598273b03$export$c2a4b833556ae71)() === 3 /* DeflateWorkerStatus.Initialized */  ? (0, $de188ba0cd76f643$export$92ac42d7bd545b2a)(viewId) : undefined;
        }
    };
    function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker) {
        var cachedDeflateEncoder;
        function getOrCreateDeflateEncoder() {
            if (!cachedDeflateEncoder) {
                worker !== null && worker !== void 0 ? worker : worker = (0, $b455450598273b03$export$8ad05986c983585a)(configuration, 'Datadog Session Replay', function() {
                    strategy.stop();
                }, createDeflateWorkerImpl);
                if (worker) cachedDeflateEncoder = (0, $275c53661b5d2fb2$export$1b838d3ae89a44b8)(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */ );
            }
            return cachedDeflateEncoder;
        }
        strategy = (0, $6dd097e009e9d65f$export$eedb6b2f1f53c8e)(configuration, lifeCycle, sessionManager, viewHistory, startRecordingImpl, getOrCreateDeflateEncoder);
        if (shouldStartImmediately(configuration)) strategy.start();
    }
}



var $95032d6edbc0e5a2$var$recorderApi = (0, $2dcd1b6060126fce$export$e9b5b20eb46e0952)((0, $e59c1dc0ff977688$export$9be9afda50c84681));
var $95032d6edbc0e5a2$export$65cc181beb0d2632 = (0, $c7e3cb8a60bc2b2b$export$27595a139f6e6837)((0, $1c2ed706f8c64922$export$3215a7cbec5ac3e0), $95032d6edbc0e5a2$var$recorderApi, {
    startDeflateWorker: (0, $b455450598273b03$export$8ad05986c983585a),
    createDeflateEncoder: (0, $275c53661b5d2fb2$export$1b838d3ae89a44b8)
});
(0, $a940c8408eeade74$export$884b45263866f2b7)((0, $5d1c89bab7298e4d$export$256479dc0cea61c4)(), 'DD_RUM', $95032d6edbc0e5a2$export$65cc181beb0d2632);


const $8c8fbd96eb0536fb$var$env = "prod";
(0, $95032d6edbc0e5a2$export$65cc181beb0d2632).init({
    applicationId: "6f760f5a-de82-485c-a286-9da6bac5c567",
    clientToken: "pubc9636512f65a3adfec63fa394f14eb50",
    site: "datadoghq.eu",
    env: $8c8fbd96eb0536fb$var$env,
    version: "a188f1a74fff642712fb98bcf453fec4a7a88fdb",
    service: "plabu-phx-marketplace-user-service",
    sessionSampleRate: $8c8fbd96eb0536fb$var$env === "prod" ? 100 : 0,
    sessionReplaySampleRate: $8c8fbd96eb0536fb$var$env === "prod" ? 100 : 0,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    useCrossSiteSessionCookie: true,
    allowFallbackToLocalStorage: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow"
});



var $69607e38bd2400f2$exports = {};
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
$69607e38bd2400f2$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign($69607e38bd2400f2$exports, (parcelRequire("acw62")));


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a0acfd416da73b8a$var$extendStatics = function(d, b) {
    $a0acfd416da73b8a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a0acfd416da73b8a$var$extendStatics(d, b);
};
function $a0acfd416da73b8a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a0acfd416da73b8a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a0acfd416da73b8a$export$18ce0697a983be9b = function() {
    $a0acfd416da73b8a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0acfd416da73b8a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a0acfd416da73b8a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a0acfd416da73b8a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a0acfd416da73b8a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a0acfd416da73b8a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a0acfd416da73b8a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a0acfd416da73b8a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a0acfd416da73b8a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a0acfd416da73b8a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a0acfd416da73b8a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a0acfd416da73b8a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a0acfd416da73b8a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a0acfd416da73b8a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a0acfd416da73b8a$export$45d3717a4c69092e(o, m, p);
}
function $a0acfd416da73b8a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a0acfd416da73b8a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a0acfd416da73b8a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a0acfd416da73b8a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a0acfd416da73b8a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a0acfd416da73b8a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a0acfd416da73b8a$export$10c90e4f7922046c(v) {
    return this instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? (this.v = v, this) : new $a0acfd416da73b8a$export$10c90e4f7922046c(v);
}
function $a0acfd416da73b8a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a0acfd416da73b8a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a0acfd416da73b8a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a0acfd416da73b8a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a0acfd416da73b8a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a0acfd416da73b8a$export$19a8beecd37a4c45 === "function" ? $a0acfd416da73b8a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a0acfd416da73b8a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a0acfd416da73b8a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a0acfd416da73b8a$var$ownKeys = function(o) {
    $a0acfd416da73b8a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a0acfd416da73b8a$var$ownKeys(o);
};
function $a0acfd416da73b8a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a0acfd416da73b8a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a0acfd416da73b8a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a0acfd416da73b8a$var$__setModuleDefault(result, mod);
    return result;
}
function $a0acfd416da73b8a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a0acfd416da73b8a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a0acfd416da73b8a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a0acfd416da73b8a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a0acfd416da73b8a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a0acfd416da73b8a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a0acfd416da73b8a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a0acfd416da73b8a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a0acfd416da73b8a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a0acfd416da73b8a$export$2e2bcd8739ae039 = {
    __extends: $a0acfd416da73b8a$export$a8ba968b8961cb8a,
    __assign: $a0acfd416da73b8a$export$18ce0697a983be9b,
    __rest: $a0acfd416da73b8a$export$3c9a16f847548506,
    __decorate: $a0acfd416da73b8a$export$29e00dfd3077644b,
    __param: $a0acfd416da73b8a$export$d5ad3fd78186038f,
    __esDecorate: $a0acfd416da73b8a$export$3a84e1ae4e97e9b0,
    __runInitializers: $a0acfd416da73b8a$export$d831c04e792af3d,
    __propKey: $a0acfd416da73b8a$export$6a2a36740a146cb8,
    __setFunctionName: $a0acfd416da73b8a$export$d1a06452d3489bc7,
    __metadata: $a0acfd416da73b8a$export$f1db080c865becb9,
    __awaiter: $a0acfd416da73b8a$export$1050f835b63b671e,
    __generator: $a0acfd416da73b8a$export$67ebef60e6f28a6,
    __createBinding: $a0acfd416da73b8a$export$45d3717a4c69092e,
    __exportStar: $a0acfd416da73b8a$export$f33643c0debef087,
    __values: $a0acfd416da73b8a$export$19a8beecd37a4c45,
    __read: $a0acfd416da73b8a$export$8d051b38c9118094,
    __spread: $a0acfd416da73b8a$export$afc72e2116322959,
    __spreadArrays: $a0acfd416da73b8a$export$6388937ca91ccae8,
    __spreadArray: $a0acfd416da73b8a$export$1216008129fb82ed,
    __await: $a0acfd416da73b8a$export$10c90e4f7922046c,
    __asyncGenerator: $a0acfd416da73b8a$export$e427f37a30a4de9b,
    __asyncDelegator: $a0acfd416da73b8a$export$bbd80228419bb833,
    __asyncValues: $a0acfd416da73b8a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a0acfd416da73b8a$export$4fb47efe1390b86f,
    __importStar: $a0acfd416da73b8a$export$c21735bcef00d192,
    __importDefault: $a0acfd416da73b8a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a0acfd416da73b8a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a0acfd416da73b8a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a0acfd416da73b8a$export$81fdc39f203e4e04,
    __addDisposableResource: $a0acfd416da73b8a$export$88ac25d8e944e405,
    __disposeResources: $a0acfd416da73b8a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a0acfd416da73b8a$export$889dfb5d17574b0b
};


var $7c30baa29d2eb832$var$genericMessage = "Invariant Violation";
var $7c30baa29d2eb832$var$_a = Object.setPrototypeOf, $7c30baa29d2eb832$var$setPrototypeOf = $7c30baa29d2eb832$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $7c30baa29d2eb832$var$_a;
var $7c30baa29d2eb832$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $7c30baa29d2eb832$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $7c30baa29d2eb832$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $7c30baa29d2eb832$var$genericMessage;
        $7c30baa29d2eb832$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $7c30baa29d2eb832$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $7c30baa29d2eb832$export$cea12affaee22fe8(message);
}
var $7c30baa29d2eb832$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $7c30baa29d2eb832$var$verbosityLevel = $7c30baa29d2eb832$var$verbosityLevels.indexOf("log");
function $7c30baa29d2eb832$var$wrapConsoleMethod(name) {
    return function() {
        if ($7c30baa29d2eb832$var$verbosityLevels.indexOf(name) >= $7c30baa29d2eb832$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $7c30baa29d2eb832$var$wrapConsoleMethod("debug");
    invariant.log = $7c30baa29d2eb832$var$wrapConsoleMethod("log");
    invariant.warn = $7c30baa29d2eb832$var$wrapConsoleMethod("warn");
    invariant.error = $7c30baa29d2eb832$var$wrapConsoleMethod("error");
})($7c30baa29d2eb832$export$f5708dca728d7177 || ($7c30baa29d2eb832$export$f5708dca728d7177 = {}));
function $7c30baa29d2eb832$export$a80e09f2cd325fb8(level) {
    var old = $7c30baa29d2eb832$var$verbosityLevels[$7c30baa29d2eb832$var$verbosityLevel];
    $7c30baa29d2eb832$var$verbosityLevel = Math.max(0, $7c30baa29d2eb832$var$verbosityLevels.indexOf(level));
    return old;
}
var $7c30baa29d2eb832$export$2e2bcd8739ae039 = $7c30baa29d2eb832$export$f5708dca728d7177;


var $fb2c94d2c044c7c5$export$83d89fbfd8236492 = "3.13.9";


function $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $d461b0c33b06d27f$export$2e2bcd8739ae039 = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $14071c0503b706b7$var$prefixCounts = new Map();
function $14071c0503b706b7$export$d0c8ec0fe1b18b70(prefix) {
    var count = $14071c0503b706b7$var$prefixCounts.get(prefix) || 1;
    $14071c0503b706b7$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $29a424226342d3ac$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $28d90d877eb1e517$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $28d90d877eb1e517$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $28d90d877eb1e517$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $28d90d877eb1e517$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $7c30baa29d2eb832$export$f5708dca728d7177)(condition, $28d90d877eb1e517$var$getHandledErrorMsg(message, args) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, args));
}, {
    debug: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).debug),
    log: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).log),
    warn: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).warn),
    error: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $28d90d877eb1e517$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $7c30baa29d2eb832$export$cea12affaee22fe8)($28d90d877eb1e517$var$getHandledErrorMsg(message, optionalParams) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, optionalParams));
}
var $28d90d877eb1e517$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492));
function $28d90d877eb1e517$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $29a424226342d3ac$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $28d90d877eb1e517$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3] && (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3](message, messageArgs.map($28d90d877eb1e517$var$stringify));
}
function $28d90d877eb1e517$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($28d90d877eb1e517$var$stringify)
    })));
}




var $bd560f7419fc8fee$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;




var $5d0a073f980bb2a3$var$isReactNative = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $5d0a073f980bb2a3$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($5d0a073f980bb2a3$var$isReactNative && !$parcel$global.HermesInternal);
var $5d0a073f980bb2a3$export$7293b8a0b474028d = typeof WeakSet === "function";
var $5d0a073f980bb2a3$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $5d0a073f980bb2a3$export$c34f882e9f1c1637 = $5d0a073f980bb2a3$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $5d0a073f980bb2a3$export$71594e8a50f746f4 = typeof (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $5d0a073f980bb2a3$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $5d0a073f980bb2a3$export$4001f6cd4a62405b = ($5d0a073f980bb2a3$export$71594e8a50f746f4 || $5d0a073f980bb2a3$var$isReactNative) && !$5d0a073f980bb2a3$var$usingJSDOM;


var $4653928bf51922ba$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $4653928bf51922ba$var$uSESKey = "useSyncExternalStore";
var $4653928bf51922ba$var$realHook = $69607e38bd2400f2$exports[$4653928bf51922ba$var$uSESKey];
var $4653928bf51922ba$export$306c0aa65ff9ec16 = $4653928bf51922ba$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$4653928bf51922ba$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $4653928bf51922ba$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(68);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $69607e38bd2400f2$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $5d0a073f980bb2a3$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $69607e38bd2400f2$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $69607e38bd2400f2$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
};
function $4653928bf51922ba$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}


function $550d697bbc914bec$export$b10e3d92c03f6472(rv) {
    return (0, $4653928bf51922ba$export$306c0aa65ff9ec16)($69607e38bd2400f2$exports.useCallback(function(update) {
        // By reusing the same onNext function in the nested call to
        // rv.onNextChange(onNext), we can keep using the initial clean-up function
        // returned by rv.onNextChange(function onNext(v){...}), without having to
        // register the new clean-up function (returned by the nested
        // rv.onNextChange(onNext)) with yet another callback.
        return rv.onNextChange(function onNext() {
            update();
            rv.onNextChange(onNext);
        });
    }, [
        rv
    ]), rv, rv);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $9abc92afe9cf7102$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $98d2cb8d1858bbba$export$2e2bcd8739ae039 = {
    raw: ".hcr-main-wrapper-16-4-0{background:var(--hcr-bg-primary-color);margin-top:0;min-height:100%;padding-bottom:0;position:relative}.hcr-main-wrapper--full-16-4-0{min-height:100vh}.hcr-main-wrapper--secondary-16-4-0{background:var(--hcr-bg-secondary-color)}",
    map: {
        "hcr-main-wrapper": "hcr-main-wrapper-16-4-0",
        "hcr-main-wrapper--full": "hcr-main-wrapper--full-16-4-0",
        "hcr-main-wrapper--secondary": "hcr-main-wrapper--secondary-16-4-0"
    }
};


class $4ada79c183cfad4b$export$2e2bcd8739ae039 {
    constructor(blockName, module, prefix = "hcr-"){
        this.convertModifiersToClassNames = function mapModifiersObj(mods, base) {
            return Object.keys(mods).reduce((a, c)=>mods[c] ? `${a} ${base}--${c}` : a, '').trim();
        };
        this.block = `${prefix}${blockName}`;
        this.module = module;
    }
    b(mods, mixes) {
        const classArr = [
            this.block
        ];
        // populating array with mods and mixes class strings
        mods && classArr.push(this.m(mods, this.block));
        mixes && classArr.push(this.mix(mixes));
        // concatenating after removing empty strings
        // and passing to this convert to map against css mapping, if any
        return this.convert(classArr.filter((current)=>current).join(' '));
    }
    e(children, mods, mixes) {
        const e = typeof children === 'string' ? `${this.block}__${children}` : `${this.block}${children.reduce((acc, cur)=>`__${acc}__${cur}`)}`;
        const classArr = [
            e
        ];
        // populating array with mods and mixes class strings
        mods && classArr.push(this.m(mods, e));
        mixes && classArr.push(this.mix(mixes));
        // concatenating after removing empty strings
        // and passing to this convert to map against css mapping, if any
        return this.convert(classArr.filter((current)=>current).join(' '));
    }
    m(mods, baseOverride) {
        const base = baseOverride || this.block;
        if (typeof mods === 'string') // if modifier is a string chain it with base
        return `${base}--${mods}`.trim();
        if (mods instanceof Object && !Array.isArray(mods)) // if object of modifiers given pass them all to the mapping/chaining function
        return this.convertModifiersToClassNames(mods, base).trim();
        if (Array.isArray(mods)) {
            // remove null, false and empty array
            const cleanMods = mods.filter((mod)=>mod && (typeof mod === 'string' || mod instanceof Object));
            // map mod (either string or Object)
            const m = cleanMods.map((mod)=>{
                if (mod instanceof Object) return this.convertModifiersToClassNames(mod, base);
                return `${base}--${mod}`;
            }).join(' '); // join modifier sets for every array item into one modifier string
            return m.trim();
        }
        return '';
    }
    mix(mix) {
        if (typeof mix === 'string') // if string provided, pass it through
        return mix.trim();
        if (Array.isArray(mix)) // if array given, flatten all objects inside and concatenate resulting classes
        return mix.map((mixItem)=>{
            if (mixItem instanceof Object) return this.convertMixesToClassNames(mixItem);
            return mixItem;
        }).join(' ').trim();
        if (mix instanceof Object) // in case we have object, flatten keys depending of the value
        return this.convertMixesToClassNames(mix).trim();
        return '';
    }
    convert(selectors) {
        if (this.module) return selectors.padEnd(1).split(' ').map((a)=>{
            var _a;
            return ((_a = this.module) === null || _a === void 0 ? void 0 : _a.map[a]) ? this.module.map[a] : a;
        }).join(' ');
        return selectors;
    }
    convertMixesToClassNames(mixObj) {
        return Object.keys(mixObj).filter((current)=>mixObj[current]).join(' ');
    }
}




const $0f9f8154b7893dcf$export$5c27252b0362172 = [
    'primary',
    'secondary'
];



var $acw62 = parcelRequire("acw62");
var $c7187b397d0fd9d2$export$2e2bcd8739ae039 = {
    raw: "*{box-sizing:border-box}[class^=hcr-]{margin:0;padding:0}[class^=hcr-]:after,[class^=hcr-]:before{box-sizing:border-box}"
};


var $db51929b491f44e5$export$83d89fbfd8236492 = "16.4.0";
var $db51929b491f44e5$export$2e2bcd8739ae039 = {
    version: $db51929b491f44e5$export$83d89fbfd8236492
};


const $f5d0d8e5a6972273$export$5dc5db8b895b3c69 = (0, $db51929b491f44e5$export$2e2bcd8739ae039).version.replace(/\./g, '-');
const $f5d0d8e5a6972273$export$36b7d774d231bf3c = '__honeycomb-react_css_component';
const $f5d0d8e5a6972273$export$e44ffb50cc242ec5 = Boolean(typeof window !== 'undefined' && typeof document !== 'undefined' && document.head);


const $8004033f3b6e4cea$var$CLIENT_CLASSNAME_NAMESPACE = 'honeycomb-react-css-tag';
const $8004033f3b6e4cea$var$baseStylesId = `base-styles${(0, $f5d0d8e5a6972273$export$36b7d774d231bf3c)}`;
const $8004033f3b6e4cea$var$CLIENT_ID_CACHE = {};
/**
 * Generates style tag and appends to head with given id and css as textNode.
 *
 * Inserts right after a previous sibling is found, if none is found,
 * insert at the beginning of head.
 */ const $8004033f3b6e4cea$export$c9fb2b964712e20e = (id, css, forceRerender = false)=>{
    var _a;
    if ((0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5) && (forceRerender || !document.getElementById(id))) {
        const node = document.createElement('style');
        node.textContent = css;
        node.className = $8004033f3b6e4cea$var$CLIENT_CLASSNAME_NAMESPACE;
        node.setAttribute('type', 'text/css');
        node.id = id;
        const siblings = document.querySelectorAll(`.${$8004033f3b6e4cea$var$CLIENT_CLASSNAME_NAMESPACE}`);
        if (siblings.length) {
            const child = siblings[siblings.length - 1];
            (_a = child === null || child === void 0 ? void 0 : child.parentNode) === null || _a === void 0 || _a.insertBefore(node, child.nextSibling);
        } else {
            const { firstChild: firstChild } = document.head;
            document.head.insertBefore(node, firstChild);
        }
        return true;
    }
    return false;
};
/**
 * Helper to generate inline style tags and cache css.
 *
 * Puts all the HC-React component styles as a concatenated string into "context.styles",
 *
 * Puts individual style nodes into "context.styleNodes" returns null when no context is provided.
 */ const $8004033f3b6e4cea$export$fb348d80caab4249 = (cache, styles, id)=>{
    if (cache && !cache[id]) {
        cache[id] = true;
        if (!cache.styles) cache.styles = '';
        // creating style node tag with the provided styles
        const node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
            id: id,
            className: $8004033f3b6e4cea$var$CLIENT_CLASSNAME_NAMESPACE,
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: styles
            }
        });
        cache.styleNodes = !cache.styleNodes ? [] : cache.styleNodes;
        if (id !== $8004033f3b6e4cea$var$baseStylesId) {
            cache.styleNodes.push(node);
            cache.styles += styles;
        } else // pushing base styles to the beginning of the array
        cache.styleNodes.unshift(node);
    }
    return null;
};
/** Context for server side rendering */ const $8004033f3b6e4cea$export$b293f36bde7e07ad = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
// decorator factory
const $8004033f3b6e4cea$export$59edeac1b7126870 = (WrappedComp, styles)=>{
    // create the component
    function EnhancedComp(props) {
        // using displayName and namespace string as unique ID for caching,
        // this ensures every honeycomb component has unique cache ID
        const componentID = WrappedComp.displayName + (0, $f5d0d8e5a6972273$export$36b7d774d231bf3c) + (0, $f5d0d8e5a6972273$export$5dc5db8b895b3c69);
        // if no css or empty object return component
        if (typeof styles === 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComp, Object.assign({}, props));
        // Add base styles, once
        if (!$8004033f3b6e4cea$var$CLIENT_ID_CACHE[$8004033f3b6e4cea$var$baseStylesId] && (0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5)) {
            $8004033f3b6e4cea$export$c9fb2b964712e20e($8004033f3b6e4cea$var$baseStylesId, (0, $c7187b397d0fd9d2$export$2e2bcd8739ae039).raw);
            $8004033f3b6e4cea$var$CLIENT_ID_CACHE[$8004033f3b6e4cea$var$baseStylesId] = true;
        }
        // append cache to head if client and not cached
        if (!$8004033f3b6e4cea$var$CLIENT_ID_CACHE[componentID] && (0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5)) {
            if ($8004033f3b6e4cea$export$c9fb2b964712e20e(componentID, styles.raw)) // set to true if styles were appended successfully
            $8004033f3b6e4cea$var$CLIENT_ID_CACHE[componentID] = true;
        }
        // server rendered component
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComp, Object.assign({}, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8004033f3b6e4cea$export$b293f36bde7e07ad.Consumer, null, (value)=>{
            $8004033f3b6e4cea$export$fb348d80caab4249(value, styles.raw, componentID);
            $8004033f3b6e4cea$export$fb348d80caab4249(value, (0, $c7187b397d0fd9d2$export$2e2bcd8739ae039).raw, $8004033f3b6e4cea$var$baseStylesId);
            return null;
        }));
    }
    // assign it a name
    EnhancedComp.displayName = `Injecss(${WrappedComp.displayName})`;
    // ship it
    return EnhancedComp;
};


const $aeb73c5367733af6$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('main-wrapper', (0, $98d2cb8d1858bbba$export$2e2bcd8739ae039));
function $aeb73c5367733af6$export$6661021c36f0a701(_a) {
    var { children: children, extraClasses: extraClasses = '', full: full = false, bgColor: bgColor = 'primary' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "full",
        "bgColor"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: $aeb73c5367733af6$var$bem.b({
            full: full,
            [bgColor]: bgColor !== 'primary'
        }, extraClasses)
    }, rest), children);
}
$aeb73c5367733af6$export$6661021c36f0a701.displayName = 'MainWrapper';
$aeb73c5367733af6$export$6661021c36f0a701.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    full: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    bgColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $0f9f8154b7893dcf$export$5c27252b0362172))
};
var $aeb73c5367733af6$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($aeb73c5367733af6$export$6661021c36f0a701, (0, $98d2cb8d1858bbba$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

const $4196d28d09da17fc$export$e3e0d00dc2ac092f = 'hcr-';
const $4196d28d09da17fc$export$2e2bcd8739ae039 = {
    honeycombThemePrefix: `${$4196d28d09da17fc$export$e3e0d00dc2ac092f}theme-`,
    honeycombThemes: [
        'flix',
        'kamil',
        'neptune',
        'high-contrast'
    ],
    honeycombThemeModes: {
        dark: 'dark',
        tvm: 'tvm'
    }
};





/** Returns a list of prefixed and versioned theme class names and modes if any. */ function $c17472ef7c4fc97d$export$d3f9b90ef6e44107(themeName, modes = []) {
    const themeClass = `${(0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemePrefix}${themeName}-${(0, $f5d0d8e5a6972273$export$5dc5db8b895b3c69)}`;
    const modesClasses = modes.filter((mode)=>mode && mode !== 'base') // base mode does not generate specific class
    .map((mode)=>`${(0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemePrefix}${mode}-${0, $f5d0d8e5a6972273$export$5dc5db8b895b3c69}`);
    return [
        themeClass,
        ...modesClasses
    ];
}
/** Returns the class names formatted to be used as class selector for stylesheets. */ function $c17472ef7c4fc97d$export$15d48e8cf06e66cf(themeName, modes = []) {
    const classNames = $c17472ef7c4fc97d$export$d3f9b90ef6e44107(themeName, modes);
    return `.${classNames.join('.')}`;
}



/** @see `@flixbus/honeycomb/dist/scss/common/utils/_cssvars.scss`: `cssvars` mixin. */ function $860c94979a493900$export$620cef8821a1f27f(variables) {
    return Object.entries(variables).map(([key, value])=>`--${0, $4196d28d09da17fc$export$e3e0d00dc2ac092f}${key}: ${value};`).join(' ').trim();
}
/** @see `@flixbus/honeycomb/dist/scss/common/utils/_cssvars.scss`: `cssvar` mixin. */ function $860c94979a493900$export$c192b34d45ad82f3(name) {
    return `var(--${0, $4196d28d09da17fc$export$e3e0d00dc2ac092f}${name})`;
}



/**
 * The output is a CSS string with all the design tokens and theme flix styles.
 * @see `@flixbus/honeycomb/dist/scss/themes/_utils.scss`: `create-theme` mixin.
 */ function $cf3436e2a6166b95$export$1ff374bf9cc63ea6(themes) {
    const modeTokens = themes.flatMap(({ theme: theme, tokens: tokens })=>{
        return Object.entries(tokens).map(([mode, modeTokens])=>{
            return `${(0, $c17472ef7c4fc97d$export$15d48e8cf06e66cf)(theme, [
                mode
            ])} { ${(0, $860c94979a493900$export$620cef8821a1f27f)(modeTokens)} }`;
        });
    });
    const cssString = `
${modeTokens.join('\n')}
${$cf3436e2a6166b95$var$baseStyles(themes.map(({ theme: theme })=>theme))}
`;
    return {
        raw: cssString,
        map: {}
    };
}
/** @see `@flixbus/honeycomb/dist/scss/themes/_utils.scss`: `%base-styles%` */ function $cf3436e2a6166b95$var$baseStyles(themes) {
    const themeSelectors = themes.map((themeName)=>`${(0, $c17472ef7c4fc97d$export$15d48e8cf06e66cf)(themeName, [])}`).join(', ');
    return `
${themeSelectors} {
  color: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('content-primary-color')};
  font-family: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('font-family-primary')};
  font-size: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('font-size-base')};
  font-weight: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('font-weight-normal')};
  line-height: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('line-height-primary')};
  color-scheme: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('color-scheme')};
  @media only screen and (-webkit-min-device-pixel-ratio: 2) and (pointer: coarse) {
    font: -apple-system-body;
    font-family: ${(0, $860c94979a493900$export$c192b34d45ad82f3)('font-family-primary')};
  }
}`;
}


var $eb22b6d771bf6fc6$export$2e2bcd8739ae039 = {
    "ai-color": "#e100e1",
    "ai-dark-color": "#8f008f",
    "bg-primary-color": "#ffffff",
    "bg-primary-transparent-color": "rgba(255, 255, 255, 0.88)",
    "bg-secondary-color": "#f7f7f7",
    "border-radius-1": "6px",
    "border-radius-2": "12px",
    "border-radius-half": "3px",
    "box-bg-color": "#ffffff",
    "box-shadow-color": "rgba(0, 0, 0, 0.18)",
    "box-shadow-subtle-color": "rgba(0, 0, 0, 0.06)",
    "brand-primary-color": "#97d700",
    "button-label-color": "#353535",
    "button-primary-color": "#97d700",
    "color-scheme": "normal",
    "content-primary-color": "#353535",
    "content-secondary-color": "#646464",
    "danger-color": "#dd2828",
    "danger-dark-color": "#b31414",
    "disabled-element-opacity": 0.5,
    "focus-outline-color": "#016ae7",
    "font-family-primary": "Roboto, Arial, sans-serif",
    "font-size-base": "1rem",
    "font-size-fineprint": ".75rem",
    "font-size-h1": "1.7rem",
    "font-size-h2": "1.3rem",
    "font-size-h3": "1.1rem",
    "font-size-h4": "1rem",
    "font-size-primary": "1rem",
    "font-size-small": ".875rem",
    "font-weight-bold": "700",
    "font-weight-normal": "400",
    "font-weight-semibold": "500",
    "grayscale-0-color": "#ffffff",
    "grayscale-10-color": "#f7f7f7",
    "grayscale-100-color": "#353535",
    "grayscale-30-color": "#e1e1e1",
    "grayscale-50-color": "#c8c8c8",
    "grayscale-70-color": "#646464",
    "grayscale-90-color": "#444444",
    "grid-gutter-2": "12px",
    "grid-gutter-4": "24px",
    "header-bg-color": "#97d700",
    "header-color": "#353535",
    "header-nav-bg-color-tablet": "#5cc500",
    "heading-font-color": "#353535",
    "highlight-color": "#e5f9c0",
    "hover-layer-color": "linear-gradient(rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06))",
    "icon-background-color": "#353535",
    "icon-primary-color": "#848484",
    "icon-secondary-color": "#97d700",
    "input-border-color": "#848484",
    "input-height-desktop": "36px",
    "input-height-mobile": "44px",
    "line-height-fineprint": ".938rem",
    "line-height-h1": "2rem",
    "line-height-h2": "1.7rem",
    "line-height-h3": "1.5rem",
    "line-height-h4": "1.5rem",
    "line-height-primary": "1.5rem",
    "line-height-small": "1.125rem",
    "line-primary-color": "#c8c8c8",
    "link-color": "#0047de",
    "neutral-color": "#016ae7",
    "neutral-dark-color": "#0047de",
    "overlay-bg-color": "rgba(0, 0, 0, 0.5)",
    "page-max-width": "1200px",
    "page-min-width": "320px",
    "pressed-layer-color": "linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12))",
    "primary-box-shadow": "0px 6px 12px rgba(0, 0, 0, .06), 0px 3px 18px rgba(0, 0, 0, .06), 0px 3px 6px rgba(0, 0, 0, .18)",
    "spacing-1": "6px",
    "spacing-10": "60px",
    "spacing-11": "66px",
    "spacing-12": "72px",
    "spacing-2": "12px",
    "spacing-3": "18px",
    "spacing-4": "24px",
    "spacing-5": "30px",
    "spacing-6": "36px",
    "spacing-7": "42px",
    "spacing-8": "48px",
    "spacing-9": "54px",
    "spacing-half": "3px",
    "success-color": "#228f00",
    "success-dark-color": "#136b00",
    "ui-primary-color": "#31a100",
    "ui-primary-dark-color": "#187d00",
    "ui-primary-light-color": "#5cc500",
    "warning-color": "#ff5704",
    "warning-dark-color": "#c42d00"
};


var $911138d15e4072d1$export$2e2bcd8739ae039 = {
    "ai-color": "#e759e7",
    "ai-dark-color": "#ff84ff",
    "bg-primary-color": "#151515",
    "bg-primary-transparent-color": "rgba(53, 53, 53, 0.88)",
    "bg-secondary-color": "#121212",
    "box-bg-color": "#252525",
    "button-label-color": "#252525",
    "color-scheme": "dark",
    "content-primary-color": "#ffffff",
    "content-secondary-color": "#c8c8c8",
    "danger-color": "#fd5a5a",
    "danger-dark-color": "#ffc9ce",
    "grayscale-0-color": "#151515",
    "grayscale-10-color": "#252525",
    "grayscale-100-color": "#ffffff",
    "grayscale-30-color": "#444444",
    "grayscale-50-color": "#646464",
    "grayscale-70-color": "#8b8b8b",
    "grayscale-90-color": "#c8c8c8",
    "header-bg-color": "#252525",
    "header-color": "#ffffff",
    "header-nav-bg-color-tablet": "#202020",
    "heading-font-color": "#ffffff",
    "highlight-color": "#0a3c00",
    "hover-layer-color": "linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12))",
    "icon-primary-color": "#ffffff",
    "input-border-color": "#c8c8c8",
    "line-primary-color": "#646464",
    "link-color": "#3bd0de",
    "neutral-color": "#039fd5",
    "neutral-dark-color": "#3bd0de",
    "pressed-layer-color": "linear-gradient(rgba(0, 0, 0, 0.24), rgba(0, 0, 0, 0.24))",
    "success-color": "#44b300",
    "success-dark-color": "#cef38d",
    "ui-primary-color": "#97d700",
    "ui-primary-dark-color": "#cef38d",
    "ui-primary-light-color": "#44b300",
    "warning-color": "#ff8206",
    "warning-dark-color": "#ffe393"
};


var $b8094b91870daaf8$export$2e2bcd8739ae039 = {
    "border-radius-1": "12px",
    "border-radius-2": "18px",
    "border-radius-half": "6px",
    "font-size-base": "1.5rem",
    "grid-gutter-2": "24px",
    "grid-gutter-4": "36px",
    "input-height-desktop": "60px",
    "input-height-mobile": "60px",
    "line-height-primary": "1.5rem",
    "page-max-width": "1200px",
    "page-min-width": "320px",
    "spacing-1": "12px",
    "spacing-10": "108px",
    "spacing-11": "120px",
    "spacing-12": "132px",
    "spacing-2": "18px",
    "spacing-3": "24px",
    "spacing-4": "36px",
    "spacing-5": "48px",
    "spacing-6": "60px",
    "spacing-7": "72px",
    "spacing-8": "84px",
    "spacing-9": "96px",
    "spacing-half": "6px"
};


const $a76b87f35dfdea6f$export$93868ddbf8db212 = {
    theme: 'flix',
    tokens: {
        base: $eb22b6d771bf6fc6$export$2e2bcd8739ae039,
        dark: $911138d15e4072d1$export$2e2bcd8739ae039,
        tvm: $b8094b91870daaf8$export$2e2bcd8739ae039
    }
};



var $acw62 = parcelRequire("acw62");
/**
 * A custom React hook that returns the current `window` and `document` objects if they are
 * available. Returns `null` if not in a browser environment.
 *
 * @since 8.8.0
 */ function $a2044d38a0bc3f8e$export$f0dc76b03756ac7e() {
    const [win, setWin] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [doc, setDoc] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window !== 'undefined') setWin(window);
        if (typeof document !== 'undefined') setDoc(document);
    }, []);
    return [
        win,
        doc
    ];
}



function $aa9bfcb1867fae64$export$cf6495336e7980c8(_a) {
    var _b;
    var { children: children, theme: theme = 'flix', dark: dark = false, tvm: tvm = false, themes: themes = [
        (0, $a76b87f35dfdea6f$export$93868ddbf8db212)
    ], applyToRoot: applyToRoot = false, onUserPreferenceDarkModeChange: onUserPreferenceDarkModeChange } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "theme",
        "dark",
        "tvm",
        "themes",
        "applyToRoot",
        "onUserPreferenceDarkModeChange"
    ]);
    const [win] = (0, $a2044d38a0bc3f8e$export$f0dc76b03756ac7e)();
    const matchMediaPrefersDarkScheme = (_b = win === null || win === void 0 ? void 0 : win.matchMedia) === null || _b === void 0 ? void 0 : _b.call(win, '(prefers-color-scheme: dark)');
    const [userPrefersDark, setUserPrefersDark] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(Boolean(matchMediaPrefersDarkScheme === null || matchMediaPrefersDarkScheme === void 0 ? void 0 : matchMediaPrefersDarkScheme.matches));
    const isDark = dark === 'user-preference' ? userPrefersDark : dark;
    const modes = [
        isDark && (0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemeModes.dark,
        tvm && (0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemeModes.tvm
    ].filter((m)=>m);
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $c17472ef7c4fc97d$export$d3f9b90ef6e44107)(theme, modes), [
        theme,
        modes
    ]);
    // Listen to changes in user preference for dark mode
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const matchMediaChangeHandler = (event)=>{
            // only act on media query change if dark="user-preference"
            if (dark === 'user-preference') {
                setUserPrefersDark(event.matches);
                onUserPreferenceDarkModeChange === null || onUserPreferenceDarkModeChange === void 0 || onUserPreferenceDarkModeChange(event.matches);
            }
        };
        // Initialize state if dark="user-preference" mode is enabled
        if (dark === 'user-preference') {
            setUserPrefersDark(Boolean(matchMediaPrefersDarkScheme === null || matchMediaPrefersDarkScheme === void 0 ? void 0 : matchMediaPrefersDarkScheme.matches));
            // run the callback function to notify consumers about the "actual" mode that is applied
            onUserPreferenceDarkModeChange === null || onUserPreferenceDarkModeChange === void 0 || onUserPreferenceDarkModeChange(Boolean(matchMediaPrefersDarkScheme === null || matchMediaPrefersDarkScheme === void 0 ? void 0 : matchMediaPrefersDarkScheme.matches));
        }
        matchMediaPrefersDarkScheme === null || matchMediaPrefersDarkScheme === void 0 || matchMediaPrefersDarkScheme.addEventListener('change', matchMediaChangeHandler);
        return function cleanup() {
            matchMediaPrefersDarkScheme === null || matchMediaPrefersDarkScheme === void 0 || matchMediaPrefersDarkScheme.removeEventListener('change', matchMediaChangeHandler);
        };
    }, [
        matchMediaPrefersDarkScheme,
        dark,
        onUserPreferenceDarkModeChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // only control root class name in the browser
        if ((0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5) && applyToRoot === true) document.documentElement.classList.add(...classNames);
        return ()=>{
            if ((0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5) && applyToRoot === true) document.documentElement.classList.remove(...classNames);
        };
    }, [
        applyToRoot,
        classNames
    ]);
    const InjecssContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $8004033f3b6e4cea$export$b293f36bde7e07ad));
    if (themes) {
        const styles = (0, $cf3436e2a6166b95$export$1ff374bf9cc63ea6)(themes);
        // adding themes to style element ID so multiple ThemeWrapper components in on one page with
        // different themes setup are possible.
        const themeNamesArray = themes.map(({ theme: theme })=>theme);
        const componentID = `ThemeWrapper__${themeNamesArray.join('-')}${(0, $f5d0d8e5a6972273$export$36b7d774d231bf3c)}${(0, $f5d0d8e5a6972273$export$5dc5db8b895b3c69)}`;
        // only add styles to context in an SSR environment
        if (!(0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5)) (0, $8004033f3b6e4cea$export$fb348d80caab4249)(InjecssContextValue, styles.raw, componentID);
        (0, $8004033f3b6e4cea$export$c9fb2b964712e20e)(componentID, styles.raw);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: applyToRoot ? undefined : classNames.join(' ')
    }, rest), children);
}
$aa9bfcb1867fae64$export$cf6495336e7980c8.displayName = 'ThemeWrapper';
$aa9bfcb1867fae64$export$cf6495336e7980c8.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemes),
    themes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $4196d28d09da17fc$export$2e2bcd8739ae039).honeycombThemes).isRequired,
        tokens: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            base: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
            tvm: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
        }).isRequired
    })),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        true,
        false,
        'user-preference'
    ]),
    tvm: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    applyToRoot: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onUserPrefersDarkSchemeChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};


// Styles
const $63c2c06b53ba964b$var$dangerColor = "var(--hcr-danger-color)";
const $63c2c06b53ba964b$var$primaryBgColor = "var(--hcr-bg-primary-color)";
const $63c2c06b53ba964b$var$primaryContentColor = "var(--hcr-content-primary-color)";
const $63c2c06b53ba964b$var$highlightColor = "var(--hcr-highlight-color)";
const $63c2c06b53ba964b$var$secondaryContentColor = "var(--hcr-content-secondary-color)";
const $63c2c06b53ba964b$var$borderRadius = "var(--hcr-border-radius-1)";
const $63c2c06b53ba964b$var$inputHeightDesktop = "var(--hcr-input-height-desktop)";
const $63c2c06b53ba964b$var$inputHeightMobile = "var(--hcr-input-height-mobile)";
const $63c2c06b53ba964b$var$hoverLayerColor = "var(--hcr-hover-layer-color)";
const $63c2c06b53ba964b$var$inputBorderColor = "var(--hcr-input-border-color)";
const $63c2c06b53ba964b$var$inputHeightWithoutBorderDesktop = "34px";
const $63c2c06b53ba964b$var$spacingHalf = "var(--hcr-spacing-half)";
const $63c2c06b53ba964b$var$uiPrimaryColor = "var(--hcr-ui-primary-color)";
const $63c2c06b53ba964b$var$boxShadow = "var(--hcr-primary-box-shadow)";
const $63c2c06b53ba964b$var$iconPrimaryColor = "var(--hcr-icon-primary-color)";
const $63c2c06b53ba964b$var$getControlBorderColor = (hasError)=>{
    if (hasError) return $63c2c06b53ba964b$var$dangerColor;
    return $63c2c06b53ba964b$var$inputBorderColor;
};
const $63c2c06b53ba964b$var$autocompleteStyles = (withError, isSelect = false, isDropUp = false, isClearable = false, hasLabel = false)=>({
        container: (provided, state)=>({
                ...provided,
                opacity: state.isDisabled ? 0.5 : 1,
                top: hasLabel && "3px",
                "@media only screen and (max-width: 1199px)": {
                    ...provided["@media only screen and (max-width: 1199px)"],
                    top: hasLabel && "0px"
                },
                cursor: isSelect ? "pointer" : "text"
            }),
        placeholder: (provided)=>({
                ...provided,
                color: $63c2c06b53ba964b$var$secondaryContentColor,
                fontStyle: "italic"
            }),
        control: (provided, state)=>({
                ...provided,
                backgroundColor: $63c2c06b53ba964b$var$primaryBgColor,
                borderColor: $63c2c06b53ba964b$var$getControlBorderColor(withError),
                boxShadow: "none",
                outline: "none",
                overflow: "hidden",
                borderRadius: $63c2c06b53ba964b$var$borderRadius,
                borderBottomRightRadius: state.menuIsOpen && !isDropUp ? "0px" : $63c2c06b53ba964b$var$borderRadius,
                borderBottomLeftRadius: state.menuIsOpen && !isDropUp ? "0px" : $63c2c06b53ba964b$var$borderRadius,
                borderTopRightRadius: state.menuIsOpen && isDropUp ? "0px" : $63c2c06b53ba964b$var$borderRadius,
                borderTopLeftRadius: state.menuIsOpen && isDropUp ? "0px" : $63c2c06b53ba964b$var$borderRadius,
                height: $63c2c06b53ba964b$var$inputHeightDesktop,
                minHeight: $63c2c06b53ba964b$var$inputHeightDesktop,
                "@media only screen and (max-width: 1199px)": {
                    ...provided["@media only screen and (max-width: 1199px)"],
                    height: $63c2c06b53ba964b$var$inputHeightMobile,
                    minHeight: $63c2c06b53ba964b$var$inputHeightMobile
                }
            }),
        input: (provided)=>({
                ...provided,
                color: $63c2c06b53ba964b$var$primaryContentColor
            }),
        option: (provided, state)=>({
                ...provided,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                backgroundColor: state.isSelected ? $63c2c06b53ba964b$var$highlightColor : state.isFocused ? $63c2c06b53ba964b$var$hoverLayerColor : "none",
                "&:hover": {
                    backgroundImage: $63c2c06b53ba964b$var$hoverLayerColor
                },
                color: "inherit",
                cursor: "pointer",
                display: state.isDisabled ? "none" : undefined,
                padding: state.isSelected ? "4px 12px 4px 9px" : "4px 12px",
                margin: "4px 0px",
                borderLeft: state.isSelected ? `${$63c2c06b53ba964b$var$spacingHalf} solid ${$63c2c06b53ba964b$var$uiPrimaryColor}` : "unset"
            }),
        menu: (provided)=>({
                ...provided,
                marginTop: 0,
                marginBottom: 0,
                zIndex: 100,
                backgroundColor: "unset"
            }),
        menuList: (provided)=>({
                ...provided,
                paddingTop: 0,
                paddingBottom: 0,
                backgroundColor: $63c2c06b53ba964b$var$primaryBgColor,
                maxHeight: isSelect ? "200px" : provided.maxHeight,
                overflow: isSelect ? "scroll" : provided.overflow,
                borderBottomLeftRadius: $63c2c06b53ba964b$var$borderRadius,
                borderBottomRightRadius: $63c2c06b53ba964b$var$borderRadius,
                boxShadow: $63c2c06b53ba964b$var$boxShadow
            }),
        valueContainer: (provided)=>({
                ...provided,
                backgroundColor: $63c2c06b53ba964b$var$primaryBgColor,
                position: "unset",
                height: $63c2c06b53ba964b$var$inputHeightWithoutBorderDesktop,
                "@media only screen and (max-width: 1199px)": {
                    ...provided["@media only screen and (max-width: 1199px)"],
                    height: $63c2c06b53ba964b$var$inputHeightMobile
                },
                cursor: isSelect ? "pointer" : "text"
            }),
        singleValue: (provided)=>({
                ...provided,
                color: $63c2c06b53ba964b$var$primaryContentColor,
                width: "100%",
                maxWidth: isClearable ? "calc(100% - 85px)" : "calc(100% - 55px)",
                position: "absolute"
            }),
        indicatorsContainer: (provided)=>({
                ...provided,
                backgroundColor: $63c2c06b53ba964b$var$primaryBgColor,
                height: $63c2c06b53ba964b$var$inputHeightWithoutBorderDesktop,
                "@media only screen and (max-width: 1199px)": {
                    ...provided["@media only screen and (max-width: 1199px)"],
                    height: $63c2c06b53ba964b$var$inputHeightMobile
                }
            }),
        clearIndicator: (provided)=>({
                ...provided,
                paddingRight: "12px",
                cursor: "pointer"
            }),
        dropdownIndicator: (provided)=>({
                ...provided,
                cursor: "pointer",
                color: $63c2c06b53ba964b$var$iconPrimaryColor
            })
    });
var $63c2c06b53ba964b$export$2e2bcd8739ae039 = $63c2c06b53ba964b$var$autocompleteStyles;


const $949a2a3b3edb254a$var$contentPrimaryColor = "var(--hcr-content-primary-color)";
const $949a2a3b3edb254a$var$multiSelectStyles = ()=>({
        multiValue: (provided)=>({
                ...provided,
                backgroundColor: "var(--hcr-grayscale-0-color)",
                border: "1px solid var(--hcr-grayscale-50-color)",
                height: "28px",
                borderRadius: "28px",
                lineHeight: "22px",
                alignItems: "center",
                padding: "3px 12px",
                maxWidth: "145px",
                div: {
                    color: $949a2a3b3edb254a$var$contentPrimaryColor
                }
            }),
        multiValueLabel: (provided)=>({
                ...provided,
                fontSize: "var(--hcr-font-size-primary)",
                fontWeight: "400",
                paddingLeft: "0",
                paddingRight: "0"
            }),
        multiValueRemove: (provided)=>({
                ...provided,
                paddingLeft: "6px",
                paddingRight: "0",
                "&:hover": {
                    backgroundColor: "var(--hcr-grayscale-0-color)"
                }
            })
    });
var $949a2a3b3edb254a$export$2e2bcd8739ae039 = $949a2a3b3edb254a$var$multiSelectStyles;


const $b243b3906bce7237$var$uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var $b243b3906bce7237$export$2e2bcd8739ae039 = $b243b3906bce7237$var$uuidRegex;


//! @version @js-joda/core - 5.7.0
//! @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
//! @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
//! @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$createErrorType(name, init, superErrorClass) {
    if (superErrorClass === void 0) superErrorClass = Error;
    function JsJodaException(message) {
        if (!Error.captureStackTrace) this.stack = new Error().stack;
        else Error.captureStackTrace(this, this.constructor);
        this.message = message;
        init && init.apply(this, arguments);
        this.toString = function() {
            return this.name + ": " + this.message;
        };
    }
    JsJodaException.prototype = Object.create(superErrorClass.prototype);
    JsJodaException.prototype.name = name;
    JsJodaException.prototype.constructor = JsJodaException;
    return JsJodaException;
}
var $2e6f1e48aadbcba7$export$6058f27c7f907fb = $2e6f1e48aadbcba7$var$createErrorType('DateTimeException', $2e6f1e48aadbcba7$var$messageWithCause);
var $2e6f1e48aadbcba7$export$ce8a206818942248 = $2e6f1e48aadbcba7$var$createErrorType('DateTimeParseException', $2e6f1e48aadbcba7$var$messageForDateTimeParseException);
var $2e6f1e48aadbcba7$export$8fe6dec993229f58 = $2e6f1e48aadbcba7$var$createErrorType('UnsupportedTemporalTypeException', null, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
var $2e6f1e48aadbcba7$export$5891bcae38b5fd67 = $2e6f1e48aadbcba7$var$createErrorType('ArithmeticException');
var $2e6f1e48aadbcba7$export$86eb44ed3377dd8f = $2e6f1e48aadbcba7$var$createErrorType('IllegalArgumentException');
var $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e = $2e6f1e48aadbcba7$var$createErrorType('IllegalStateException');
var $2e6f1e48aadbcba7$export$b6ad7a1de4697efd = $2e6f1e48aadbcba7$var$createErrorType('NullPointerException');
function $2e6f1e48aadbcba7$var$messageWithCause(message, cause) {
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
}
function $2e6f1e48aadbcba7$var$messageForDateTimeParseException(message, text, index, cause) {
    if (text === void 0) text = '';
    if (index === void 0) index = 0;
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    msg += ": " + text + ", at index: " + index;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
    this.parsedString = function() {
        return text;
    };
    this.errorIndex = function() {
        return index;
    };
}
function $2e6f1e48aadbcba7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2e6f1e48aadbcba7$var$_setPrototypeOf(subClass, superClass);
}
function $2e6f1e48aadbcba7$var$_setPrototypeOf(o, p) {
    $2e6f1e48aadbcba7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2e6f1e48aadbcba7$var$_setPrototypeOf(o, p);
}
function $2e6f1e48aadbcba7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$assert(assertion, msg, error) {
    if (!assertion) {
        if (error) throw new error(msg);
        else throw new Error(msg);
    }
}
function $2e6f1e48aadbcba7$var$requireNonNull(value, parameterName) {
    if (value == null) throw new $2e6f1e48aadbcba7$export$b6ad7a1de4697efd(parameterName + " must not be null");
    return value;
}
function $2e6f1e48aadbcba7$var$requireInstance(value, _class, parameterName) {
    if (!(value instanceof _class)) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f(parameterName + " must be an instance of " + (_class.name ? _class.name : _class) + (value && value.constructor && value.constructor.name ? ", but is " + value.constructor.name : ''));
    return value;
}
function $2e6f1e48aadbcba7$var$abstractMethodFail(methodName) {
    throw new TypeError("abstract method \"" + methodName + "\" is not implemented");
}
var $2e6f1e48aadbcba7$var$assert$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    abstractMethodFail: $2e6f1e48aadbcba7$var$abstractMethodFail,
    assert: $2e6f1e48aadbcba7$var$assert,
    requireInstance: $2e6f1e48aadbcba7$var$requireInstance,
    requireNonNull: $2e6f1e48aadbcba7$var$requireNonNull
});
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER = 9007199254740991;
var $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER = -9007199254740991;
var $2e6f1e48aadbcba7$var$MathUtil = function() {
    function MathUtil() {}
    MathUtil.intDiv = function intDiv(x, y) {
        var r = x / y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.intMod = function intMod(x, y) {
        var r = x - MathUtil.intDiv(x, y) * y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.roundDown = function roundDown(r) {
        if (r < 0) return Math.ceil(r);
        else return Math.floor(r);
    };
    MathUtil.floorDiv = function floorDiv(x, y) {
        var r = Math.floor(x / y);
        return MathUtil.safeZero(r);
    };
    MathUtil.floorMod = function floorMod(x, y) {
        var r = x - MathUtil.floorDiv(x, y) * y;
        return MathUtil.safeZero(r);
    };
    MathUtil.safeAdd = function safeAdd(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0) return MathUtil.safeZero(y);
        if (y === 0) return MathUtil.safeZero(x);
        var r = MathUtil.safeToInt(x + y);
        if (r === x || r === y) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67('Invalid addition beyond MAX_SAFE_INTEGER!');
        return r;
    };
    MathUtil.safeSubtract = function safeSubtract(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0 && y === 0) return 0;
        else if (x === 0) return MathUtil.safeZero(-1 * y);
        else if (y === 0) return MathUtil.safeZero(x);
        return MathUtil.safeToInt(x - y);
    };
    MathUtil.safeMultiply = function safeMultiply(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 1) return MathUtil.safeZero(y);
        if (y === 1) return MathUtil.safeZero(x);
        if (x === 0 || y === 0) return 0;
        var r = MathUtil.safeToInt(x * y);
        if (r / y !== x || x === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER && y === -1 || y === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER && x === -1) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Multiplication overflows: " + x + " * " + y);
        return r;
    };
    MathUtil.parseInt = function(_parseInt) {
        function parseInt1(_x) {
            return _parseInt.apply(this, arguments);
        }
        parseInt1.toString = function() {
            return _parseInt.toString();
        };
        return parseInt1;
    }(function(value) {
        var r = parseInt(value);
        return MathUtil.safeToInt(r);
    });
    MathUtil.safeToInt = function safeToInt(value) {
        MathUtil.verifyInt(value);
        return MathUtil.safeZero(value);
    };
    MathUtil.verifyInt = function verifyInt(value) {
        if (value == null) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid value: '" + value + "', using null or undefined as argument");
        if (isNaN(value)) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67('Invalid int value, using NaN as argument');
        if (Number.isInteger) {
            if (!Number.isInteger(Number(value))) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid value: '" + value + "' is a float");
        } else if (value % 1 !== 0) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid value: '" + value + "' is a float");
        if (value > $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER || value < $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Calculation overflows an int: " + value);
    };
    MathUtil.safeZero = function safeZero(value) {
        return value === 0 ? 0 : +value;
    };
    MathUtil.compareNumbers = function compareNumbers(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    };
    MathUtil.smi = function smi(int) {
        return int >>> 1 & 0x40000000 | int & 0xBFFFFFFF;
    };
    MathUtil.hash = function hash(number) {
        if (number !== number || number === Infinity) return 0;
        var result = number;
        while(number > 0xFFFFFFFF){
            number /= 0xFFFFFFFF;
            result ^= number;
        }
        return MathUtil.smi(result);
    };
    MathUtil.hashCode = function hashCode() {
        var result = 17;
        for(var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++)numbers[_key] = arguments[_key];
        for(var _i = 0, _numbers = numbers; _i < _numbers.length; _i++){
            var n = _numbers[_i];
            result = (result << 5) - result + MathUtil.hash(n);
        }
        return MathUtil.hash(result);
    };
    return MathUtil;
}();
$2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER = $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER;
$2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER = $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$Enum = function() {
    function Enum(name) {
        this._name = name;
    }
    var _proto = Enum.prototype;
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Enum;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff = function() {
    function TemporalAmount() {}
    var _proto = TemporalAmount.prototype;
    _proto.get = function get(unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('get');
    };
    _proto.units = function units() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('units');
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('addTo');
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('subtractFrom');
    };
    return TemporalAmount;
}();
if (typeof Symbol !== 'undefined' && Symbol.toPrimitive) $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff.prototype[Symbol.toPrimitive] = function(hint) {
    if (hint !== 'number') return this.toString();
    throw new TypeError("A conversion from TemporalAmount to a number is not allowed. To compare use the methods .equals(), .compareTo(), .isBefore() or one that is more suitable to your use case.");
};
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$5d412a4bb789788e = function() {
    function TemporalUnit() {}
    var _proto = TemporalUnit.prototype;
    _proto.duration = function duration() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('duration');
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isDurationEstimated');
    };
    _proto.isDateBased = function isDateBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isDateBased');
    };
    _proto.isTimeBased = function isTimeBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isTimeBased');
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isSupportedBy');
    };
    _proto.addTo = function addTo(dateTime, periodToAdd) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('addTo');
    };
    _proto.between = function between(temporal1, temporal2) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('between');
    };
    return TemporalUnit;
}();
var $2e6f1e48aadbcba7$export$3b11bc38611c5941 = function(_TemporalAmount) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Duration, _TemporalAmount);
    function Duration(seconds, nanos) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        _this._seconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(seconds);
        _this._nanos = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanos);
        return _this;
    }
    Duration.ofDays = function ofDays(days) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(days, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    Duration.ofHours = function ofHours(hours) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    Duration.ofMinutes = function ofMinutes(minutes) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    Duration.ofSeconds = function ofSeconds(seconds, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(seconds, $2e6f1e48aadbcba7$var$MathUtil.floorDiv(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
        var nos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration._create(secs, nos);
    };
    Duration.ofMillis = function ofMillis(millis) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(millis, 1000);
        var mos = $2e6f1e48aadbcba7$var$MathUtil.intMod(millis, 1000);
        if (mos < 0) {
            mos += 1000;
            secs--;
        }
        return Duration._create(secs, mos * 1000000);
    };
    Duration.ofNanos = function ofNanos(nanos) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        if (nos < 0) {
            nos += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            secs--;
        }
        return this._create(secs, nos);
    };
    Duration.of = function of(amount, unit) {
        return Duration.ZERO.plus(amount, unit);
    };
    Duration.from = function from(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, 'amount');
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
        var duration = Duration.ZERO;
        amount.units().forEach(function(unit) {
            duration = duration.plus(amount.get(unit), unit);
        });
        return duration;
    };
    Duration.between = function between(startInclusive, endExclusive) {
        $2e6f1e48aadbcba7$var$requireNonNull(startInclusive, 'startInclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        var secs = startInclusive.until(endExclusive, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        var nanos = 0;
        if (startInclusive.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND) && endExclusive.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) try {
            var startNos = startInclusive.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            nanos = endExclusive.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND) - startNos;
            if (secs > 0 && nanos < 0) nanos += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs < 0 && nanos > 0) nanos -= $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs === 0 && nanos !== 0) {
                var adjustedEnd = endExclusive.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, startNos);
                secs = startInclusive.until(adjustedEnd, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
            }
        } catch (e) {}
        return this.ofSeconds(secs, nanos);
    };
    Duration.parse = function parse(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        var PATTERN = new RegExp('([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?', 'i');
        var matches = PATTERN.exec(text);
        if (matches !== null) {
            if ('T' === matches[3] === false) {
                var negate = '-' === matches[1];
                var dayMatch = matches[2];
                var hourMatch = matches[4];
                var minuteMatch = matches[5];
                var secondMatch = matches[6];
                var fractionMatch = matches[7];
                if (dayMatch != null || hourMatch != null || minuteMatch != null || secondMatch != null) {
                    var daysAsSecs = Duration._parseNumber(text, dayMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY, 'days');
                    var hoursAsSecs = Duration._parseNumber(text, hourMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR, 'hours');
                    var minsAsSecs = Duration._parseNumber(text, minuteMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE, 'minutes');
                    var seconds = Duration._parseNumber(text, secondMatch, 1, 'seconds');
                    var negativeSecs = secondMatch != null && secondMatch.charAt(0) === '-';
                    var nanos = Duration._parseFraction(text, fractionMatch, negativeSecs ? -1 : 1);
                    try {
                        return Duration._create(negate, daysAsSecs, hoursAsSecs, minsAsSecs, seconds, nanos);
                    } catch (ex) {
                        throw new $2e6f1e48aadbcba7$export$ce8a206818942248('Text cannot be parsed to a Duration: overflow', text, 0, ex);
                    }
                }
            }
        }
        throw new $2e6f1e48aadbcba7$export$ce8a206818942248('Text cannot be parsed to a Duration', text, 0);
    };
    Duration._parseNumber = function _parseNumber(text, parsed, multiplier, errorText) {
        if (parsed == null) return 0;
        try {
            if (parsed[0] === '+') parsed = parsed.substring(1);
            return $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(parseFloat(parsed), multiplier);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Duration: " + errorText, text, 0, ex);
        }
    };
    Duration._parseFraction = function _parseFraction(text, parsed, negate) {
        if (parsed == null || parsed.length === 0) return 0;
        parsed = (parsed + "000000000").substring(0, 9);
        return parseFloat(parsed) * negate;
    };
    Duration._create = function _create() {
        if (arguments.length <= 2) return Duration._createSecondsNanos(arguments[0], arguments[1]);
        else return Duration._createNegateDaysHoursMinutesSecondsNanos(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    };
    Duration._createNegateDaysHoursMinutesSecondsNanos = function _createNegateDaysHoursMinutesSecondsNanos(negate, daysAsSecs, hoursAsSecs, minsAsSecs, secs, nanos) {
        var seconds = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(daysAsSecs, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(hoursAsSecs, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(minsAsSecs, secs)));
        if (negate) return Duration.ofSeconds(seconds, nanos).negated();
        return Duration.ofSeconds(seconds, nanos);
    };
    Duration._createSecondsNanos = function _createSecondsNanos(seconds, nanoAdjustment) {
        if (seconds === void 0) seconds = 0;
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        if (seconds === 0 && nanoAdjustment === 0) return Duration.ZERO;
        return new Duration(seconds, nanoAdjustment);
    };
    var _proto = Duration.prototype;
    _proto.get = function get(unit) {
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS) return this._seconds;
        else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this._nanos;
        else throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.units = function units() {
        return [
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS
        ];
    };
    _proto.isZero = function isZero() {
        return this._seconds === 0 && this._nanos === 0;
    };
    _proto.isNegative = function isNegative() {
        return this._seconds < 0;
    };
    _proto.seconds = function seconds() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto.withSeconds = function withSeconds(seconds) {
        return Duration._create(seconds, this._nanos);
    };
    _proto.withNanos = function withNanos(nanoOfSecond) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nanoOfSecond);
        return Duration._create(this._seconds, nanoOfSecond);
    };
    _proto.plusDuration = function plusDuration(duration) {
        $2e6f1e48aadbcba7$var$requireNonNull(duration, 'duration');
        return this.plus(duration.seconds(), duration.nano());
    };
    _proto.plus = function plus(durationOrNumber, unitOrNumber) {
        if (arguments.length === 1) return this.plusDuration(durationOrNumber);
        else if (arguments.length === 2 && unitOrNumber instanceof $2e6f1e48aadbcba7$export$5d412a4bb789788e) return this.plusAmountUnit(durationOrNumber, unitOrNumber);
        else return this.plusSecondsNanos(durationOrNumber, unitOrNumber);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, 'amountToAdd');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
        if (unit.isDurationEstimated()) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unit must not have an estimated duration');
        if (amountToAdd === 0) return this;
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, 1000000000) * 1000, $2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 1000000000) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
            }
            return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(unit.duration().seconds(), amountToAdd), 0);
        }
        var duration = unit.duration().multipliedBy(amountToAdd);
        return this.plusSecondsNanos(duration.seconds(), duration.nano());
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(daysToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(hoursToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(minutesToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this.plusSecondsNanos(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.intDiv(millisToAdd, 1000), $2e6f1e48aadbcba7$var$MathUtil.intMod(millisToAdd, 1000) * 1000000);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this.plusSecondsNanos(0, nanosToAdd);
    };
    _proto.plusSecondsNanos = function plusSecondsNanos(secondsToAdd, nanosToAdd) {
        $2e6f1e48aadbcba7$var$requireNonNull(secondsToAdd, 'secondsToAdd');
        $2e6f1e48aadbcba7$var$requireNonNull(nanosToAdd, 'nanosToAdd');
        if (secondsToAdd === 0 && nanosToAdd === 0) return this;
        var epochSec = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._seconds, secondsToAdd);
        epochSec = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(epochSec, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
        nanosToAdd = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._nanos, nanosToAdd);
        return Duration.ofSeconds(epochSec, nanoAdjustment);
    };
    _proto.minus = function minus(durationOrNumber, unit) {
        if (arguments.length === 1) return this.minusDuration(durationOrNumber);
        else return this.minusAmountUnit(durationOrNumber, unit);
    };
    _proto.minusDuration = function minusDuration(duration) {
        $2e6f1e48aadbcba7$var$requireNonNull(duration, 'duration');
        var secsToSubtract = duration.seconds();
        var nanosToSubtract = duration.nano();
        if (secsToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER) return this.plus($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER, -nanosToSubtract);
        return this.plus(-secsToSubtract, -nanosToSubtract);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, 'amountToSubtract');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        return amountToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusAmountUnit($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER, unit) : this.plusAmountUnit(-amountToSubtract, unit);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return daysToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusDays($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusDays(-daysToSubtract);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return hoursToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusHours($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusHours(-hoursToSubtract);
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return minutesToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusMinutes($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusMinutes(-minutesToSubtract);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return secondsToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusSeconds($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusSeconds(-secondsToSubtract);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return millisToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusMillis($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusMillis(-millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return nanosToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusNanos($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusNanos(-nanosToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(multiplicand) {
        if (multiplicand === 0) return Duration.ZERO;
        if (multiplicand === 1) return this;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, multiplicand);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._nanos, multiplicand);
        secs = secs + $2e6f1e48aadbcba7$var$MathUtil.intDiv(nos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        nos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration.ofSeconds(secs, nos);
    };
    _proto.dividedBy = function dividedBy(divisor) {
        if (divisor === 0) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67('Cannot divide by zero');
        if (divisor === 1) return this;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, divisor);
        var secsMod = $2e6f1e48aadbcba7$var$MathUtil.roundDown((this._seconds / divisor - secs) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, divisor);
        nos = secsMod + nos;
        return Duration.ofSeconds(secs, nos);
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.abs = function abs() {
        return this.isNegative() ? this.negated() : this;
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (this._seconds !== 0) temporal = temporal.plus(this._seconds, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.plus(this._nanos, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (this._seconds !== 0) temporal = temporal.minus(this._seconds, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.minus(this._nanos, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.toDays = function toDays() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
    };
    _proto.toHours = function toHours() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
    };
    _proto.toMinutes = function toMinutes() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
    };
    _proto.toMillis = function toMillis() {
        var millis = Math.round($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, 1000));
        millis = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(millis, $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, 1000000));
        return millis;
    };
    _proto.toNanos = function toNanos() {
        var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, this._nanos);
        return totalNanos;
    };
    _proto.toHoursPart = function toHoursPart() {
        return $2e6f1e48aadbcba7$var$MathUtil.intMod(this.toHours(), $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY);
    };
    _proto.toMinutesPart = function toMinutesPart() {
        return $2e6f1e48aadbcba7$var$MathUtil.intMod(this.toMinutes(), $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR);
    };
    _proto.toSecondsPart = function toSecondsPart() {
        return $2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
    };
    _proto.toMillisPart = function toMillisPart() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, 1000000);
    };
    _proto.compareTo = function compareTo(otherDuration) {
        $2e6f1e48aadbcba7$var$requireNonNull(otherDuration, 'otherDuration');
        $2e6f1e48aadbcba7$var$requireInstance(otherDuration, Duration, 'otherDuration');
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._seconds, otherDuration.seconds());
        if (cmp !== 0) return cmp;
        return this._nanos - otherDuration.nano();
    };
    _proto.equals = function equals(otherDuration) {
        if (this === otherDuration) return true;
        if (otherDuration instanceof Duration) return this.seconds() === otherDuration.seconds() && this.nano() === otherDuration.nano();
        return false;
    };
    _proto.toString = function toString() {
        if (this === Duration.ZERO) return 'PT0S';
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv($2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var rval = 'PT';
        if (hours !== 0) rval += hours + "H";
        if (minutes !== 0) rval += minutes + "M";
        if (secs === 0 && this._nanos === 0 && rval.length > 2) return rval;
        if (secs < 0 && this._nanos > 0) {
            if (secs === -1) rval += '-0';
            else rval += secs + 1;
        } else rval += secs;
        if (this._nanos > 0) {
            rval += '.';
            var nanoString;
            if (secs < 0) nanoString = "" + (2 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND - this._nanos);
            else nanoString = "" + ($2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos);
            nanoString = nanoString.slice(1, nanoString.length);
            rval += nanoString;
            while(rval.charAt(rval.length - 1) === '0')rval = rval.slice(0, rval.length - 1);
        }
        rval += 'S';
        return rval;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Duration;
}($2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
function $2e6f1e48aadbcba7$var$_init$n() {
    $2e6f1e48aadbcba7$export$3b11bc38611c5941.ZERO = new $2e6f1e48aadbcba7$export$3b11bc38611c5941(0, 0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE.md in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$c04b60057299af61 = function YearConstants() {};
function $2e6f1e48aadbcba7$var$_init$m() {
    $2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE = -999999;
    $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE = 999999;
}
var $2e6f1e48aadbcba7$export$e61e212a4109fb8a = function(_TemporalUnit) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoUnit, _TemporalUnit);
    function ChronoUnit(name, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto = ChronoUnit.prototype;
    _proto.duration = function duration() {
        return this._duration;
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        return this.isDateBased() || this === ChronoUnit.FOREVER;
    };
    _proto.isDateBased = function isDateBased() {
        return this.compareTo(ChronoUnit.DAYS) >= 0 && this !== ChronoUnit.FOREVER;
    };
    _proto.isTimeBased = function isTimeBased() {
        return this.compareTo(ChronoUnit.DAYS) < 0;
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        if (this === ChronoUnit.FOREVER) return false;
        try {
            temporal.plus(1, this);
            return true;
        } catch (e) {
            try {
                temporal.plus(-1, this);
                return true;
            } catch (e2) {
                return false;
            }
        }
    };
    _proto.addTo = function addTo(temporal, amount) {
        return temporal.plus(amount, this);
    };
    _proto.between = function between(temporal1, temporal2) {
        return temporal1.until(temporal2, this);
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        return this.duration().compareTo(other.duration());
    };
    return ChronoUnit;
}($2e6f1e48aadbcba7$export$5d412a4bb789788e);
function $2e6f1e48aadbcba7$var$_init$l() {
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Nanos', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Micros', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Millis', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1000000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Seconds', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(1));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Minutes', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(60));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Hours', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(3600));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('HalfDays', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(43200));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Days', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(86400));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Weeks', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(604800));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Months', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(2629746));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Years', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Decades', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(315569520));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Centuries', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(3155695200));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Millennia', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Eras', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952 * ($2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE + 1)));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a('Forever', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER, 999999999));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9 = function() {
    function TemporalField() {}
    var _proto = TemporalField.prototype;
    _proto.isDateBased = function isDateBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isDateBased');
    };
    _proto.isTimeBased = function isTimeBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isTimeBased');
    };
    _proto.baseUnit = function baseUnit() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('baseUnit');
    };
    _proto.rangeUnit = function rangeUnit() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('rangeUnit');
    };
    _proto.range = function range() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('range');
    };
    _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('rangeRefinedBy');
    };
    _proto.getFrom = function getFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('getFrom');
    };
    _proto.adjustInto = function adjustInto(temporal, newValue) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('adjustInto');
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isSupportedBy');
    };
    _proto.displayName = function displayName() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('displayName');
    };
    _proto.equals = function equals(other) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('equals');
    };
    _proto.name = function name() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('name');
    };
    return TemporalField;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$177e5e64bab4dec5 = function() {
    function ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
        $2e6f1e48aadbcba7$var$assert(!(minSmallest > minLargest), "Smallest minimum value '" + minSmallest + "' must be less than largest minimum value '" + minLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        $2e6f1e48aadbcba7$var$assert(!(maxSmallest > maxLargest), "Smallest maximum value '" + maxSmallest + "' must be less than largest maximum value '" + maxLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        $2e6f1e48aadbcba7$var$assert(!(minLargest > maxLargest), "Minimum value '" + minLargest + "' must be less than maximum value '" + maxLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        this._minSmallest = minSmallest;
        this._minLargest = minLargest;
        this._maxLargest = maxLargest;
        this._maxSmallest = maxSmallest;
    }
    var _proto = ValueRange.prototype;
    _proto.isFixed = function isFixed() {
        return this._minSmallest === this._minLargest && this._maxSmallest === this._maxLargest;
    };
    _proto.minimum = function minimum() {
        return this._minSmallest;
    };
    _proto.largestMinimum = function largestMinimum() {
        return this._minLargest;
    };
    _proto.maximum = function maximum() {
        return this._maxLargest;
    };
    _proto.smallestMaximum = function smallestMaximum() {
        return this._maxSmallest;
    };
    _proto.isValidValue = function isValidValue(value) {
        return this.minimum() <= value && value <= this.maximum();
    };
    _proto.checkValidValue = function checkValidValue(value, field) {
        var msg;
        if (!this.isValidValue(value)) {
            if (field != null) msg = "Invalid value for " + field + " (valid values " + this.toString() + "): " + value;
            else msg = "Invalid value (valid values " + this.toString() + "): " + value;
            return $2e6f1e48aadbcba7$var$assert(false, msg, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        }
        return value;
    };
    _proto.checkValidIntValue = function checkValidIntValue(value, field) {
        if (this.isValidIntValue(value) === false) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid int value for " + field + ": " + value);
        return value;
    };
    _proto.isValidIntValue = function isValidIntValue(value) {
        return this.isIntValue() && this.isValidValue(value);
    };
    _proto.isIntValue = function isIntValue() {
        return this.minimum() >= $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER && this.maximum() <= $2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER;
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ValueRange) return this._minSmallest === other._minSmallest && this._minLargest === other._minLargest && this._maxSmallest === other._maxSmallest && this._maxLargest === other._maxLargest;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._minSmallest, this._minLargest, this._maxSmallest, this._maxLargest);
    };
    _proto.toString = function toString() {
        var str = this.minimum() + (this.minimum() !== this.largestMinimum() ? "/" + this.largestMinimum() : '');
        str += ' - ';
        str += this.smallestMaximum() + (this.smallestMaximum() !== this.maximum() ? "/" + this.maximum() : '');
        return str;
    };
    ValueRange.of = function of() {
        if (arguments.length === 2) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[1]);
        else if (arguments.length === 3) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[2]);
        else if (arguments.length === 4) return new ValueRange(arguments[0], arguments[1], arguments[2], arguments[3]);
        else return $2e6f1e48aadbcba7$var$assert(false, "Invalid number of arguments " + arguments.length, $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
    };
    return ValueRange;
}();
var $2e6f1e48aadbcba7$export$7f55a40756153c3e = function(_TemporalField) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoField, _TemporalField);
    ChronoField.byName = function byName(fieldName) {
        for(var prop in ChronoField)if (ChronoField[prop]) {
            if (ChronoField[prop] instanceof ChronoField && ChronoField[prop].name() === fieldName) return ChronoField[prop];
        }
    };
    function ChronoField(name, baseUnit, rangeUnit, range) {
        var _this;
        _this = _TemporalField.call(this) || this;
        _this._name = name;
        _this._baseUnit = baseUnit;
        _this._rangeUnit = rangeUnit;
        _this._range = range;
        return _this;
    }
    var _proto = ChronoField.prototype;
    _proto.name = function name() {
        return this._name;
    };
    _proto.baseUnit = function baseUnit() {
        return this._baseUnit;
    };
    _proto.rangeUnit = function rangeUnit() {
        return this._rangeUnit;
    };
    _proto.range = function range() {
        return this._range;
    };
    _proto.displayName = function displayName() {
        return this.toString();
    };
    _proto.checkValidValue = function checkValidValue(value) {
        return this.range().checkValidValue(value, this);
    };
    _proto.checkValidIntValue = function checkValidIntValue(value) {
        return this.range().checkValidIntValue(value, this);
    };
    _proto.isDateBased = function isDateBased() {
        var dateBased = this === ChronoField.DAY_OF_WEEK || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR || this === ChronoField.DAY_OF_MONTH || this === ChronoField.DAY_OF_YEAR || this === ChronoField.EPOCH_DAY || this === ChronoField.ALIGNED_WEEK_OF_MONTH || this === ChronoField.ALIGNED_WEEK_OF_YEAR || this === ChronoField.MONTH_OF_YEAR || this === ChronoField.PROLEPTIC_MONTH || this === ChronoField.YEAR_OF_ERA || this === ChronoField.YEAR || this === ChronoField.ERA;
        return dateBased;
    };
    _proto.isTimeBased = function isTimeBased() {
        var timeBased = this === ChronoField.NANO_OF_SECOND || this === ChronoField.NANO_OF_DAY || this === ChronoField.MICRO_OF_SECOND || this === ChronoField.MICRO_OF_DAY || this === ChronoField.MILLI_OF_SECOND || this === ChronoField.MILLI_OF_DAY || this === ChronoField.SECOND_OF_MINUTE || this === ChronoField.SECOND_OF_DAY || this === ChronoField.MINUTE_OF_HOUR || this === ChronoField.MINUTE_OF_DAY || this === ChronoField.HOUR_OF_AMPM || this === ChronoField.CLOCK_HOUR_OF_AMPM || this === ChronoField.HOUR_OF_DAY || this === ChronoField.CLOCK_HOUR_OF_DAY || this === ChronoField.AMPM_OF_DAY;
        return timeBased;
    };
    _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return temporal.range(this);
    };
    _proto.getFrom = function getFrom(temporal) {
        return temporal.getLong(this);
    };
    _proto.toString = function toString() {
        return this.name();
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.adjustInto = function adjustInto(temporal, newValue) {
        return temporal.with(this, newValue);
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported(this);
    };
    return ChronoField;
}($2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9);
function $2e6f1e48aadbcba7$var$_init$k() {
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('NanoOfSecond', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('NanoOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MicroOfSecond', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MicroOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MilliOfSecond', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MilliOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('SecondOfMinute', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 59));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('SecondOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MinuteOfHour', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 59));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MinuteOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1439));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('HourOfAmPm', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 11));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('ClockHourOfAmPm', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 12));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('HourOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 23));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('ClockHourOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 24));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('AmPmOfDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('DayOfWeek', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('AlignedDayOfWeekInMonth', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('AlignedDayOfWeekInYear', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('DayOfMonth', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 28, 31), 'day');
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('DayOfYear', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 365, 366));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('EpochDay', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(-365961662, 364522971));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('AlignedWeekOfMonth', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 4, 5));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('AlignedWeekOfYear', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 53));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('MonthOfYear', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 12), 'month');
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('ProlepticMonth', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE * 12, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE * 12 + 11));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('YearOfEra', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE + 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('Year', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE), 'year');
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('Era', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('InstantSeconds', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER, $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS = new $2e6f1e48aadbcba7$export$7f55a40756153c3e('OffsetSeconds', $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(-64800, 64800));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$d6cc568434dfd9dc = function() {
    function TemporalQueries() {}
    TemporalQueries.zoneId = function zoneId() {
        return TemporalQueries.ZONE_ID;
    };
    TemporalQueries.chronology = function chronology() {
        return TemporalQueries.CHRONO;
    };
    TemporalQueries.precision = function precision() {
        return TemporalQueries.PRECISION;
    };
    TemporalQueries.zone = function zone() {
        return TemporalQueries.ZONE;
    };
    TemporalQueries.offset = function offset() {
        return TemporalQueries.OFFSET;
    };
    TemporalQueries.localDate = function localDate() {
        return TemporalQueries.LOCAL_DATE;
    };
    TemporalQueries.localTime = function localTime() {
        return TemporalQueries.LOCAL_TIME;
    };
    return TemporalQueries;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$e5100310ee9cc158 = function() {
    function TemporalAccessor() {}
    var _proto = TemporalAccessor.prototype;
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('getLong');
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (this.isSupported(field)) return field.range();
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.isSupported = function isSupported(field) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isSupported');
    };
    return TemporalAccessor;
}();
var $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(TemporalQuery, _Enum);
    function TemporalQuery() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TemporalQuery.prototype;
    _proto.queryFrom = function queryFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('queryFrom');
    };
    return TemporalQuery;
}($2e6f1e48aadbcba7$var$Enum);
function $2e6f1e48aadbcba7$var$createTemporalQuery(name, queryFromFunction) {
    var ExtendedTemporalQuery = function(_TemporalQuery) {
        $2e6f1e48aadbcba7$var$_inheritsLoose(ExtendedTemporalQuery, _TemporalQuery);
        function ExtendedTemporalQuery() {
            return _TemporalQuery.apply(this, arguments) || this;
        }
        return ExtendedTemporalQuery;
    }($2e6f1e48aadbcba7$export$3164c6c8dc6c80ff);
    ExtendedTemporalQuery.prototype.queryFrom = queryFromFunction;
    return new ExtendedTemporalQuery(name);
}
var $2e6f1e48aadbcba7$export$7ed5ca4f8b987938 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DayOfWeek, _TemporalAccessor);
    function DayOfWeek(ordinal, name) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._ordinal = ordinal;
        _this._name = name;
        return _this;
    }
    var _proto = DayOfWeek.prototype;
    _proto.ordinal = function ordinal() {
        return this._ordinal;
    };
    _proto.name = function name() {
        return this._name;
    };
    DayOfWeek.values = function values() {
        return $2e6f1e48aadbcba7$var$ENUMS.slice();
    };
    DayOfWeek.valueOf = function valueOf(name) {
        var ordinal = 0;
        for(ordinal; ordinal < $2e6f1e48aadbcba7$var$ENUMS.length; ordinal++){
            if ($2e6f1e48aadbcba7$var$ENUMS[ordinal].name() === name) break;
        }
        return DayOfWeek.of(ordinal + 1);
    };
    DayOfWeek.of = function of(dayOfWeek) {
        if (dayOfWeek < 1 || dayOfWeek > 7) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid value for DayOfWeek: " + dayOfWeek);
        return $2e6f1e48aadbcba7$var$ENUMS[dayOfWeek - 1];
    };
    DayOfWeek.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$assert(temporal != null, 'temporal', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (temporal instanceof DayOfWeek) return temporal;
        try {
            return DayOfWeek.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK));
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain DayOfWeek from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''), ex);
            else throw ex;
        }
    };
    _proto.value = function value() {
        return this._ordinal + 1;
    };
    _proto.displayName = function displayName(style, locale) {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented yet!');
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return field.range();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(days) {
        var amount = $2e6f1e48aadbcba7$var$MathUtil.floorMod(days, 7);
        return $2e6f1e48aadbcba7$var$ENUMS[$2e6f1e48aadbcba7$var$MathUtil.floorMod(this._ordinal + (amount + 7), 7)];
    };
    _proto.minus = function minus(days) {
        return this.plus(-1 * $2e6f1e48aadbcba7$var$MathUtil.floorMod(days, 7));
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        $2e6f1e48aadbcba7$var$assert(_query != null, 'query', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, this.value());
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, DayOfWeek, 'other');
        return this._ordinal - other._ordinal;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return DayOfWeek;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$ENUMS;
function $2e6f1e48aadbcba7$var$_init$j() {
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.MONDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(0, 'MONDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.TUESDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(1, 'TUESDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(2, 'WEDNESDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(3, 'THURSDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FRIDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(4, 'FRIDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SATURDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(5, 'SATURDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SUNDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(6, 'SUNDAY');
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('DayOfWeek.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.from(temporal);
    });
    $2e6f1e48aadbcba7$var$ENUMS = [
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.MONDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.TUESDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FRIDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SATURDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SUNDAY
    ];
}
var $2e6f1e48aadbcba7$export$951c8378cdfec6e6 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Month, _TemporalAccessor);
    function Month(value, name) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._value = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(value);
        _this._name = name;
        return _this;
    }
    var _proto = Month.prototype;
    _proto.value = function value() {
        return this._value;
    };
    _proto.ordinal = function ordinal() {
        return this._value - 1;
    };
    _proto.name = function name() {
        return this._name;
    };
    _proto.displayName = function displayName(style, locale) {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented yet!');
    };
    _proto.isSupported = function isSupported(field) {
        if (null === field) return false;
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR;
        return field != null && field.isSupportedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(months) {
        var amount = $2e6f1e48aadbcba7$var$MathUtil.intMod(months, 12) + 12;
        var newMonthVal = $2e6f1e48aadbcba7$var$MathUtil.intMod(this.value() + amount, 12);
        newMonthVal = newMonthVal === 0 ? 12 : newMonthVal;
        return Month.of(newMonthVal);
    };
    _proto.minus = function minus(months) {
        return this.plus(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(months, 12));
    };
    _proto.length = function length(leapYear) {
        switch(this){
            case Month.FEBRUARY:
                return leapYear ? 29 : 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.minLength = function minLength() {
        switch(this){
            case Month.FEBRUARY:
                return 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.maxLength = function maxLength() {
        switch(this){
            case Month.FEBRUARY:
                return 29;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.firstDayOfYear = function firstDayOfYear(leapYear) {
        var leap = leapYear ? 1 : 0;
        switch(this){
            case Month.JANUARY:
                return 1;
            case Month.FEBRUARY:
                return 32;
            case Month.MARCH:
                return 60 + leap;
            case Month.APRIL:
                return 91 + leap;
            case Month.MAY:
                return 121 + leap;
            case Month.JUNE:
                return 152 + leap;
            case Month.JULY:
                return 182 + leap;
            case Month.AUGUST:
                return 213 + leap;
            case Month.SEPTEMBER:
                return 244 + leap;
            case Month.OCTOBER:
                return 274 + leap;
            case Month.NOVEMBER:
                return 305 + leap;
            case Month.DECEMBER:
            default:
                return 335 + leap;
        }
    };
    _proto.firstMonthOfQuarter = function firstMonthOfQuarter() {
        switch(this){
            case Month.JANUARY:
            case Month.FEBRUARY:
            case Month.MARCH:
                return Month.JANUARY;
            case Month.APRIL:
            case Month.MAY:
            case Month.JUNE:
                return Month.APRIL;
            case Month.JULY:
            case Month.AUGUST:
            case Month.SEPTEMBER:
                return Month.JULY;
            case Month.OCTOBER:
            case Month.NOVEMBER:
            case Month.DECEMBER:
            default:
                return Month.OCTOBER;
        }
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$assert(_query != null, 'query() parameter must not be null', $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.toString = function toString() {
        switch(this){
            case Month.JANUARY:
                return 'JANUARY';
            case Month.FEBRUARY:
                return 'FEBRUARY';
            case Month.MARCH:
                return 'MARCH';
            case Month.APRIL:
                return 'APRIL';
            case Month.MAY:
                return 'MAY';
            case Month.JUNE:
                return 'JUNE';
            case Month.JULY:
                return 'JULY';
            case Month.AUGUST:
                return 'AUGUST';
            case Month.SEPTEMBER:
                return 'SEPTEMBER';
            case Month.OCTOBER:
                return 'OCTOBER';
            case Month.NOVEMBER:
                return 'NOVEMBER';
            case Month.DECEMBER:
                return 'DECEMBER';
            default:
                return "unknown Month, value: " + this.value();
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, this.value());
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, Month, 'other');
        return this._value - other._value;
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    Month.valueOf = function valueOf(name) {
        var ordinal = 0;
        for(ordinal; ordinal < $2e6f1e48aadbcba7$var$MONTHS.length; ordinal++){
            if ($2e6f1e48aadbcba7$var$MONTHS[ordinal].name() === name) break;
        }
        return Month.of(ordinal + 1);
    };
    Month.values = function values() {
        return $2e6f1e48aadbcba7$var$MONTHS.slice();
    };
    Month.of = function of(month) {
        if (month < 1 || month > 12) $2e6f1e48aadbcba7$var$assert(false, "Invalid value for MonthOfYear: " + month, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        return $2e6f1e48aadbcba7$var$MONTHS[month - 1];
    };
    Month.from = function from(temporal) {
        if (temporal instanceof Month) return temporal;
        try {
            return Month.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Month from TemporalAccessor: " + temporal + " of type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''), ex);
        }
    };
    return Month;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$MONTHS;
function $2e6f1e48aadbcba7$var$_init$i() {
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JANUARY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(1, 'JANUARY');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(2, 'FEBRUARY');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MARCH = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(3, 'MARCH');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.APRIL = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(4, 'APRIL');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MAY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(5, 'MAY');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JUNE = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(6, 'JUNE');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JULY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(7, 'JULY');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.AUGUST = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(8, 'AUGUST');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.SEPTEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(9, 'SEPTEMBER');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.OCTOBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(10, 'OCTOBER');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.NOVEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(11, 'NOVEMBER');
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.DECEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(12, 'DECEMBER');
    $2e6f1e48aadbcba7$var$MONTHS = [
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JANUARY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MARCH,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.APRIL,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MAY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JUNE,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JULY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.AUGUST,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.SEPTEMBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.OCTOBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.NOVEMBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.DECEMBER
    ];
}
var $2e6f1e48aadbcba7$var$PATTERN = /([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?/;
var $2e6f1e48aadbcba7$export$67186dcd8fa4f92f = function(_TemporalAmount) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Period, _TemporalAmount);
    function Period(years, months, days) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        var _years = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(years);
        var _months = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(months);
        var _days = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(days);
        if (_years === 0 && _months === 0 && _days === 0) {
            if (!Period.ZERO) {
                _this._years = _years;
                _this._months = _months;
                _this._days = _days;
                Period.ZERO = $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
            }
            return Period.ZERO || $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        }
        _this._years = _years;
        _this._months = _months;
        _this._days = _days;
        return _this;
    }
    Period.ofYears = function ofYears(years) {
        return Period.create(years, 0, 0);
    };
    Period.ofMonths = function ofMonths(months) {
        return Period.create(0, months, 0);
    };
    Period.ofWeeks = function ofWeeks(weeks) {
        return Period.create(0, 0, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeks, 7));
    };
    Period.ofDays = function ofDays(days) {
        return Period.create(0, 0, days);
    };
    Period.of = function of(years, months, days) {
        return Period.create(years, months, days);
    };
    Period.from = function from(amount) {
        if (amount instanceof Period) return amount;
        $2e6f1e48aadbcba7$var$requireNonNull(amount, 'amount');
        var years = 0;
        var months = 0;
        var days = 0;
        var units = amount.units();
        for(var i = 0; i < units.length; i++){
            var unit = units[i];
            var unitAmount = amount.get(unit);
            if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS) years = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS) months = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) days = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit must be Years, Months or Days, but was " + unit);
        }
        return Period.create(years, months, days);
    };
    Period.between = function between(startDate, endDate) {
        $2e6f1e48aadbcba7$var$requireNonNull(startDate, 'startDate');
        $2e6f1e48aadbcba7$var$requireNonNull(endDate, 'endDate');
        $2e6f1e48aadbcba7$var$requireInstance(startDate, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, 'startDate');
        $2e6f1e48aadbcba7$var$requireInstance(endDate, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, 'endDate');
        return startDate.until(endDate);
    };
    Period.parse = function parse(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        try {
            return Period._parse(text);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$5891bcae38b5fd67) throw new $2e6f1e48aadbcba7$export$ce8a206818942248('Text cannot be parsed to a Period', text, 0, ex);
            else throw ex;
        }
    };
    Period._parse = function _parse(text) {
        var matches = $2e6f1e48aadbcba7$var$PATTERN.exec(text);
        if (matches != null) {
            var negate = '-' === matches[1] ? -1 : 1;
            var yearMatch = matches[2];
            var monthMatch = matches[3];
            var weekMatch = matches[4];
            var dayMatch = matches[5];
            if (yearMatch != null || monthMatch != null || weekMatch != null || dayMatch != null) {
                var years = Period._parseNumber(text, yearMatch, negate);
                var months = Period._parseNumber(text, monthMatch, negate);
                var weeks = Period._parseNumber(text, weekMatch, negate);
                var days = Period._parseNumber(text, dayMatch, negate);
                days = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(days, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeks, 7));
                return Period.create(years, months, days);
            }
        }
        throw new $2e6f1e48aadbcba7$export$ce8a206818942248('Text cannot be parsed to a Period', text, 0);
    };
    Period._parseNumber = function _parseNumber(text, str, negate) {
        if (str == null) return 0;
        var val = $2e6f1e48aadbcba7$var$MathUtil.parseInt(str);
        return $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(val, negate);
    };
    Period.create = function create(years, months, days) {
        return new Period(years, months, days);
    };
    var _proto = Period.prototype;
    _proto.units = function units() {
        return [
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS
        ];
    };
    _proto.chronology = function chronology() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.get = function get(unit) {
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS) return this._years;
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS) return this._months;
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) return this._days;
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.isZero = function isZero() {
        return this === Period.ZERO;
    };
    _proto.isNegative = function isNegative() {
        return this._years < 0 || this._months < 0 || this._days < 0;
    };
    _proto.years = function years() {
        return this._years;
    };
    _proto.months = function months() {
        return this._months;
    };
    _proto.days = function days() {
        return this._days;
    };
    _proto.withYears = function withYears(years) {
        if (years === this._years) return this;
        return Period.create(years, this._months, this._days);
    };
    _proto.withMonths = function withMonths(months) {
        if (months === this._months) return this;
        return Period.create(this._years, months, this._days);
    };
    _proto.withDays = function withDays(days) {
        if (days === this._days) return this;
        return Period.create(this._years, this._months, days);
    };
    _proto.plus = function plus(amountToAdd) {
        var amount = Period.from(amountToAdd);
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._years, amount._years), $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._months, amount._months), $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._days, amount._days));
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._years, yearsToAdd)), this._months, this._days);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        return Period.create(this._years, $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._months, monthsToAdd)), this._days);
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        return Period.create(this._years, this._months, $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._days, daysToAdd)));
    };
    _proto.minus = function minus(amountToSubtract) {
        var amount = Period.from(amountToSubtract);
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._years, amount._years), $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._months, amount._months), $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._days, amount._days));
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(-1 * yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(-1 * monthsToSubtract);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(-1 * daysToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(scalar) {
        if (this === Period.ZERO || scalar === 1) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._years, scalar), $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._months, scalar), $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._days, scalar));
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.normalized = function normalized() {
        var totalMonths = this.toTotalMonths();
        var splitYears = $2e6f1e48aadbcba7$var$MathUtil.intDiv(totalMonths, 12);
        var splitMonths = $2e6f1e48aadbcba7$var$MathUtil.intMod(totalMonths, 12);
        if (splitYears === this._years && splitMonths === this._months) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeToInt(splitYears), splitMonths, this._days);
    };
    _proto.toTotalMonths = function toTotalMonths() {
        return this._years * 12 + this._months;
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.plus(this.toTotalMonths(), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.plus(this._years, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.plus(this._months, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.plus(this._days, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.minus(this.toTotalMonths(), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.minus(this._years, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.minus(this._months, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.minus(this._days, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof Period) {
            var other = obj;
            return this._years === other._years && this._months === other._months && this._days === other._days;
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._years, this._months, this._days);
    };
    _proto.toString = function toString() {
        if (this === Period.ZERO) return 'P0D';
        else {
            var buf = 'P';
            if (this._years !== 0) buf += this._years + "Y";
            if (this._months !== 0) buf += this._months + "M";
            if (this._days !== 0) buf += this._days + "D";
            return buf;
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Period;
}($2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
function $2e6f1e48aadbcba7$var$_init$h() {
    $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$56251aea61478734 = function() {
    function ParsePosition(index) {
        this._index = index;
        this._errorIndex = -1;
    }
    var _proto = ParsePosition.prototype;
    _proto.getIndex = function getIndex() {
        return this._index;
    };
    _proto.setIndex = function setIndex(index) {
        this._index = index;
    };
    _proto.getErrorIndex = function getErrorIndex() {
        return this._errorIndex;
    };
    _proto.setErrorIndex = function setErrorIndex(errorIndex) {
        this._errorIndex = errorIndex;
    };
    return ParsePosition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$EnumMap = function() {
    function EnumMap() {
        this._map = {};
    }
    var _proto = EnumMap.prototype;
    _proto.putAll = function putAll(otherMap) {
        for(var key in otherMap._map)this._map[key] = otherMap._map[key];
        return this;
    };
    _proto.containsKey = function containsKey(key) {
        return this._map.hasOwnProperty(key.name()) && this.get(key) !== undefined;
    };
    _proto.get = function get(key) {
        return this._map[key.name()];
    };
    _proto.put = function put(key, val) {
        return this.set(key, val);
    };
    _proto.set = function set(key, val) {
        this._map[key.name()] = val;
        return this;
    };
    _proto.retainAll = function retainAll(keyList) {
        var map = {};
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i].name();
            map[key] = this._map[key];
        }
        this._map = map;
        return this;
    };
    _proto.remove = function remove(key) {
        var keyName = key.name();
        var val = this._map[keyName];
        this._map[keyName] = undefined;
        return val;
    };
    _proto.keySet = function keySet() {
        return this._map;
    };
    _proto.clear = function clear() {
        this._map = {};
    };
    return EnumMap;
}();
var $2e6f1e48aadbcba7$export$2a833e4d13229d66 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ResolverStyle, _Enum);
    function ResolverStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    return ResolverStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT = new $2e6f1e48aadbcba7$export$2a833e4d13229d66('STRICT');
$2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART = new $2e6f1e48aadbcba7$export$2a833e4d13229d66('SMART');
$2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT = new $2e6f1e48aadbcba7$export$2a833e4d13229d66('LENIENT');
var $2e6f1e48aadbcba7$export$336849d529cb05e5 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Temporal, _TemporalAccessor);
    function Temporal() {
        return _TemporalAccessor.apply(this, arguments) || this;
    }
    var _proto = Temporal.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('isSupported');
    };
    _proto.minus = function minus(amount, unit) {
        if (arguments.length < 2) return this._minusAmount(amount);
        else return this._minusUnit(amount, unit);
    };
    _proto._minusAmount = function _minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, 'amount');
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, 'amount');
        return amount.subtractFrom(this);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, 'amountToSubtract');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, 'unit');
        return this._plusUnit(-amountToSubtract, unit);
    };
    _proto.plus = function plus(amount, unit) {
        if (arguments.length < 2) return this._plusAmount(amount);
        else return this._plusUnit(amount, unit);
    };
    _proto._plusAmount = function _plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, 'amount');
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, 'amount');
        return amount.addTo(this);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('_plusUnit');
    };
    _proto.until = function until(endTemporal, unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('until');
    };
    _proto.with = function _with(adjusterOrField, newValue) {
        if (arguments.length < 2) return this._withAdjuster(adjusterOrField);
        else return this._withField(adjusterOrField, newValue);
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, 'adjuster');
        $2e6f1e48aadbcba7$var$assert(typeof adjuster.adjustInto === 'function', 'adjuster must be a TemporalAdjuster', $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('_withField');
    };
    return Temporal;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
if (typeof Symbol !== 'undefined' && Symbol.toPrimitive) $2e6f1e48aadbcba7$export$336849d529cb05e5.prototype[Symbol.toPrimitive] = function(hint) {
    if (hint !== 'number') return this.toString();
    throw new TypeError("A conversion from Temporal to a number is not allowed. To compare use the methods .equals(), .compareTo(), .isBefore() or one that is more suitable to your use case.");
};
var $2e6f1e48aadbcba7$export$2a07e3472bc98879 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoLocalDate, _Temporal);
    function ChronoLocalDate() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDate.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toEpochDay());
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return formatter.format(this);
    };
    return ChronoLocalDate;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringUtil = function() {
    function StringUtil() {}
    StringUtil.startsWith = function startsWith(text, pattern) {
        return text.indexOf(pattern) === 0;
    };
    StringUtil.hashCode = function hashCode(text) {
        var len = text.length;
        if (len === 0) return 0;
        var hash = 0;
        for(var i = 0; i < len; i++){
            var chr = text.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return $2e6f1e48aadbcba7$var$MathUtil.smi(hash);
    };
    return StringUtil;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$a514a0be1f00ef62 = function() {
    function ZoneId() {}
    ZoneId.systemDefault = function systemDefault() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('not supported operation');
    };
    ZoneId.getAvailableZoneIds = function getAvailableZoneIds() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('not supported operation');
    };
    ZoneId.of = function of(zoneId) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + zoneId);
    };
    ZoneId.ofOffset = function ofOffset(prefix, offset) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + prefix + offset);
    };
    ZoneId.from = function from(temporal) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + temporal);
    };
    var _proto = ZoneId.prototype;
    _proto.id = function id() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneId.id');
    };
    _proto.rules = function rules() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneId.rules');
    };
    _proto.normalized = function normalized() {
        var rules = this.rules();
        if (rules.isFixedOffset()) return rules.offset($2e6f1e48aadbcba7$export$fecec53969739358.EPOCH);
        return this;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZoneId) return this.id() === other.id();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$StringUtil.hashCode(this.id());
    };
    _proto.toString = function toString() {
        return this.id();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneId;
}();
var $2e6f1e48aadbcba7$export$cbd9bcf3fad97817 = function() {
    function ZoneRules() {}
    ZoneRules.of = function of(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        return new $2e6f1e48aadbcba7$var$Fixed(offset);
    };
    var _proto = ZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.isFixedOffset');
    };
    _proto.offset = function offset(instantOrLocalDateTime) {
        if (instantOrLocalDateTime instanceof $2e6f1e48aadbcba7$export$fecec53969739358) return this.offsetOfInstant(instantOrLocalDateTime);
        else return this.offsetOfLocalDateTime(instantOrLocalDateTime);
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.offsetInstant');
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.offsetOfEpochMilli');
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.offsetLocalDateTime');
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.validOffsets');
    };
    _proto.transition = function transition(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.transition');
    };
    _proto.standardOffset = function standardOffset(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.standardOffset');
    };
    _proto.daylightSavings = function daylightSavings(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.daylightSavings');
    };
    _proto.isDaylightSavings = function isDaylightSavings(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.isDaylightSavings');
    };
    _proto.isValidOffset = function isValidOffset(localDateTime, offset) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.isValidOffset');
    };
    _proto.nextTransition = function nextTransition(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.nextTransition');
    };
    _proto.previousTransition = function previousTransition(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.previousTransition');
    };
    _proto.transitions = function transitions() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.transitions');
    };
    _proto.transitionRules = function transitionRules() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.transitionRules');
    };
    _proto.toString = function toString() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('ZoneRules.toString');
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneRules;
}();
var $2e6f1e48aadbcba7$var$Fixed = function(_ZoneRules) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Fixed, _ZoneRules);
    function Fixed(offset) {
        var _this;
        _this = _ZoneRules.call(this) || this;
        _this._offset = offset;
        return _this;
    }
    var _proto2 = Fixed.prototype;
    _proto2.isFixedOffset = function isFixedOffset() {
        return true;
    };
    _proto2.offsetOfInstant = function offsetOfInstant() {
        return this._offset;
    };
    _proto2.offsetOfEpochMilli = function offsetOfEpochMilli() {
        return this._offset;
    };
    _proto2.offsetOfLocalDateTime = function offsetOfLocalDateTime() {
        return this._offset;
    };
    _proto2.validOffsets = function validOffsets() {
        return [
            this._offset
        ];
    };
    _proto2.transition = function transition() {
        return null;
    };
    _proto2.standardOffset = function standardOffset() {
        return this._offset;
    };
    _proto2.daylightSavings = function daylightSavings() {
        return $2e6f1e48aadbcba7$export$3b11bc38611c5941.ZERO;
    };
    _proto2.isDaylightSavings = function isDaylightSavings() {
        return false;
    };
    _proto2.isValidOffset = function isValidOffset(localDateTime, offset) {
        return this._offset.equals(offset);
    };
    _proto2.nextTransition = function nextTransition() {
        return null;
    };
    _proto2.previousTransition = function previousTransition() {
        return null;
    };
    _proto2.transitions = function transitions() {
        return [];
    };
    _proto2.transitionRules = function transitionRules() {
        return [];
    };
    _proto2.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Fixed) return this._offset.equals(other._offset);
        return false;
    };
    _proto2.toString = function toString() {
        return "FixedRules:" + this._offset.toString();
    };
    return Fixed;
}($2e6f1e48aadbcba7$export$cbd9bcf3fad97817);
var $2e6f1e48aadbcba7$var$SECONDS_CACHE = {};
var $2e6f1e48aadbcba7$var$ID_CACHE = {};
var $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZoneOffset, _ZoneId);
    function ZoneOffset(totalSeconds) {
        var _this;
        _this = _ZoneId.call(this) || this;
        ZoneOffset._validateTotalSeconds(totalSeconds);
        _this._totalSeconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(totalSeconds);
        _this._rules = $2e6f1e48aadbcba7$export$cbd9bcf3fad97817.of($2e6f1e48aadbcba7$var$_assertThisInitialized(_this));
        _this._id = ZoneOffset._buildId(totalSeconds);
        return _this;
    }
    var _proto = ZoneOffset.prototype;
    _proto.totalSeconds = function totalSeconds() {
        return this._totalSeconds;
    };
    _proto.id = function id() {
        return this._id;
    };
    ZoneOffset._buildId = function _buildId(totalSeconds) {
        if (totalSeconds === 0) return 'Z';
        else {
            var absTotalSeconds = Math.abs(totalSeconds);
            var absHours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
            var absMinutes = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR);
            var buf = "" + (totalSeconds < 0 ? '-' : '+') + (absHours < 10 ? '0' : '') + absHours + (absMinutes < 10 ? ':0' : ':') + absMinutes;
            var absSeconds = $2e6f1e48aadbcba7$var$MathUtil.intMod(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
            if (absSeconds !== 0) buf += (absSeconds < 10 ? ':0' : ':') + absSeconds;
            return buf;
        }
    };
    ZoneOffset._validateTotalSeconds = function _validateTotalSeconds(totalSeconds) {
        if (Math.abs(totalSeconds) > ZoneOffset.MAX_SECONDS) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Zone offset not in valid range: -18:00 to +18:00');
    };
    ZoneOffset._validate = function _validate(hours, minutes, seconds) {
        if (hours < -18 || hours > 18) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset hours not in valid range: value " + hours + " is not in the range -18 to 18");
        if (hours > 0) {
            if (minutes < 0 || seconds < 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Zone offset minutes and seconds must be positive because hours is positive');
        } else if (hours < 0) {
            if (minutes > 0 || seconds > 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Zone offset minutes and seconds must be negative because hours is negative');
        } else if (minutes > 0 && seconds < 0 || minutes < 0 && seconds > 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Zone offset minutes and seconds must have the same sign');
        if (Math.abs(minutes) > 59) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset minutes not in valid range: abs(value) " + Math.abs(minutes) + " is not in the range 0 to 59");
        if (Math.abs(seconds) > 59) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset seconds not in valid range: abs(value) " + Math.abs(seconds) + " is not in the range 0 to 59");
        if (Math.abs(hours) === 18 && (Math.abs(minutes) > 0 || Math.abs(seconds) > 0)) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Zone offset not in valid range: -18:00 to +18:00');
    };
    ZoneOffset.of = function of(offsetId) {
        $2e6f1e48aadbcba7$var$requireNonNull(offsetId, 'offsetId');
        var offset = $2e6f1e48aadbcba7$var$ID_CACHE[offsetId];
        if (offset != null) return offset;
        var hours, minutes, seconds;
        switch(offsetId.length){
            case 2:
                offsetId = offsetId[0] + "0" + offsetId[1];
            case 3:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = 0;
                seconds = 0;
                break;
            case 5:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = 0;
                break;
            case 6:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = 0;
                break;
            case 7:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = ZoneOffset._parseNumber(offsetId, 5, false);
                break;
            case 9:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = ZoneOffset._parseNumber(offsetId, 7, true);
                break;
            default:
                throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, invalid format: " + offsetId);
        }
        var first = offsetId[0];
        if (first !== '+' && first !== '-') throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, plus/minus not found when expected: " + offsetId);
        if (first === '-') return ZoneOffset.ofHoursMinutesSeconds(-hours, -minutes, -seconds);
        else return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, seconds);
    };
    ZoneOffset._parseNumber = function _parseNumber(offsetId, pos, precededByColon) {
        if (precededByColon && offsetId[pos - 1] !== ':') throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId);
        var ch1 = offsetId[pos];
        var ch2 = offsetId[pos + 1];
        if (ch1 < '0' || ch1 > '9' || ch2 < '0' || ch2 > '9') throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId);
        return (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
    };
    ZoneOffset.ofHours = function ofHours(hours) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, 0, 0);
    };
    ZoneOffset.ofHoursMinutes = function ofHoursMinutes(hours, minutes) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, 0);
    };
    ZoneOffset.ofHoursMinutesSeconds = function ofHoursMinutesSeconds(hours, minutes, seconds) {
        ZoneOffset._validate(hours, minutes, seconds);
        var totalSeconds = hours * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR + minutes * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE + seconds;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalMinutes = function ofTotalMinutes(totalMinutes) {
        var totalSeconds = totalMinutes * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalSeconds = function ofTotalSeconds(totalSeconds) {
        if (totalSeconds % (15 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE) === 0) {
            var totalSecs = totalSeconds;
            var result = $2e6f1e48aadbcba7$var$SECONDS_CACHE[totalSecs];
            if (result == null) {
                result = new ZoneOffset(totalSeconds);
                $2e6f1e48aadbcba7$var$SECONDS_CACHE[totalSecs] = result;
                $2e6f1e48aadbcba7$var$ID_CACHE[result.id()] = result;
            }
            return result;
        } else return new ZoneOffset(totalSeconds);
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._totalSeconds;
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this._totalSeconds);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return other._totalSeconds - this._totalSeconds;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof ZoneOffset) return this._totalSeconds === obj._totalSeconds;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._totalSeconds;
    };
    _proto.toString = function toString() {
        return this._id;
    };
    return ZoneOffset;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
function $2e6f1e48aadbcba7$var$_init$g() {
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS = 18 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR;
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(-$2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS);
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS);
}
var $2e6f1e48aadbcba7$var$DateTimeBuilder = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DateTimeBuilder, _TemporalAccessor);
    DateTimeBuilder.create = function create(field, value) {
        var dtb = new DateTimeBuilder();
        dtb._addFieldValue(field, value);
        return dtb;
    };
    function DateTimeBuilder() {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this.fieldValues = new $2e6f1e48aadbcba7$var$EnumMap();
        _this.chrono = null;
        _this.zone = null;
        _this.date = null;
        _this.time = null;
        _this.leapSecond = false;
        _this.excessDays = null;
        return _this;
    }
    var _proto = DateTimeBuilder.prototype;
    _proto.getFieldValue0 = function getFieldValue0(field) {
        return this.fieldValues.get(field);
    };
    _proto._addFieldValue = function _addFieldValue(field, value) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        var old = this.getFieldValue0(field);
        if (old != null && old !== value) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Conflict found: " + field + " " + old + " differs from " + field + " " + value + ": " + this);
        return this._putFieldValue0(field, value);
    };
    _proto._putFieldValue0 = function _putFieldValue0(field, value) {
        this.fieldValues.put(field, value);
        return this;
    };
    _proto.resolve = function resolve(resolverStyle, resolverFields) {
        if (resolverFields != null) this.fieldValues.retainAll(resolverFields);
        this._mergeDate(resolverStyle);
        this._mergeTime(resolverStyle);
        this._resolveTimeInferZeroes(resolverStyle);
        if (this.excessDays != null && this.excessDays.isZero() === false && this.date != null && this.time != null) {
            this.date = this.date.plus(this.excessDays);
            this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ZERO;
        }
        this._resolveInstant();
        return this;
    };
    _proto._mergeDate = function _mergeDate(resolverStyle) {
        this._checkDate($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE.resolveDate(this.fieldValues, resolverStyle));
    };
    _proto._checkDate = function _checkDate(date) {
        if (date != null) {
            this._addObject(date);
            for(var fieldName in this.fieldValues.keySet()){
                var field = $2e6f1e48aadbcba7$export$7f55a40756153c3e.byName(fieldName);
                if (field) {
                    if (this.fieldValues.get(field) !== undefined) {
                        if (field.isDateBased()) {
                            var val1 = void 0;
                            try {
                                val1 = date.getLong(field);
                            } catch (ex) {
                                if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb) continue;
                                else throw ex;
                            }
                            var val2 = this.fieldValues.get(field);
                            if (val1 !== val2) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Conflict found: Field " + field + " " + val1 + " differs from " + field + " " + val2 + " derived from " + date);
                        }
                    }
                }
            }
        }
    };
    _proto._mergeTime = function _mergeTime(resolverStyle) {
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY)) {
            var ch = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && ch === 0) ;
                else $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY.checkValidValue(ch);
            }
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, ch === 24 ? 0 : ch);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM)) {
            var _ch = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && _ch === 0) ;
                else $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM.checkValidValue(_ch);
            }
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM, _ch === 12 ? 0 : _ch);
        }
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY));
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM)) {
            var ap = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY);
            var hap = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, ap * 12 + hap);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY)) {
            var nod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, 1000000000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(nod, 1000000000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY)) {
            var cod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY.checkValidValue(cod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(cod, 1000000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(cod, 1000000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY)) {
            var lod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY.checkValidValue(lod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(lod, 1000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(lod, 1000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY)) {
            var sod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(sod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(sod, 3600));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(sod, 60), 60));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, $2e6f1e48aadbcba7$var$MathUtil.intMod(sod, 60));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY)) {
            var mod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY.checkValidValue(mod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(mod, 60));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, $2e6f1e48aadbcba7$var$MathUtil.intMod(mod, 60));
        }
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND));
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var los = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
            var cos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, los * 1000 + $2e6f1e48aadbcba7$var$MathUtil.intMod(cos, 1000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nos, 1000));
            this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var _nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intDiv(_nos, 1000000));
            this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var _cos = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, _cos * 1000);
        } else if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND)) {
            var _los = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, _los * 1000000);
        }
    };
    _proto._resolveTimeInferZeroes = function _resolveTimeInferZeroes(resolverStyle) {
        var hod = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        var moh = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var som = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (hod == null) return;
        if (moh == null && (som != null || nos != null)) return;
        if (moh != null && som == null && nos != null) return;
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (hod != null) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && hod === 24 && (moh == null || moh === 0) && (som == null || som === 0) && (nos == null || nos === 0)) {
                    hod = 0;
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(1);
                }
                var hodVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidIntValue(hod);
                if (moh != null) {
                    var mohVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidIntValue(moh);
                    if (som != null) {
                        var somVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidIntValue(som);
                        if (nos != null) {
                            var nosVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nos);
                            this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal, somVal, nosVal));
                        } else this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal, somVal));
                    } else if (nos == null) this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal));
                } else if (som == null && nos == null) this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, 0));
            }
        } else if (hod != null) {
            var _hodVal = hod;
            if (moh != null) {
                if (som != null) {
                    if (nos == null) nos = 0;
                    var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(_hodVal, 3600000000000);
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(moh, 60000000000));
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(som, 1000000000));
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, nos);
                    var excessDays = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totalNanos, 86400000000000);
                    var nod = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totalNanos, 86400000000000);
                    this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(nod));
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(excessDays);
                } else {
                    var totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(_hodVal, 3600);
                    totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalSecs, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(moh, 60));
                    var _excessDays = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totalSecs, 86400);
                    var sod = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totalSecs, 86400);
                    this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(sod));
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(_excessDays);
                }
            } else {
                var _excessDays2 = $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.floorDiv(_hodVal, 24));
                _hodVal = $2e6f1e48aadbcba7$var$MathUtil.floorMod(_hodVal, 24);
                this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(_hodVal, 0));
                this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(_excessDays2);
            }
        }
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
    };
    _proto._addObject = function _addObject(dateOrTime) {
        if (dateOrTime instanceof $2e6f1e48aadbcba7$export$2a07e3472bc98879) this.date = dateOrTime;
        else if (dateOrTime instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) this.time = dateOrTime;
    };
    _proto._resolveInstant = function _resolveInstant() {
        if (this.date != null && this.time != null) {
            var offsetSecs = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
            if (offsetSecs != null) {
                var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
                var instant = this.date.atTime(this.time).atZone(offset).getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, instant);
            } else if (this.zone != null) {
                var _instant = this.date.atTime(this.time).atZone(this.zone).getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, _instant);
            }
        }
    };
    _proto.build = function build(type) {
        return type.queryFrom(this);
    };
    _proto.isSupported = function isSupported(field) {
        if (field == null) return false;
        return this.fieldValues.containsKey(field) && this.fieldValues.get(field) !== undefined || this.date != null && this.date.isSupported(field) || this.time != null && this.time.isSupported(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        var value = this.getFieldValue0(field);
        if (value == null) {
            if (this.date != null && this.date.isSupported(field)) return this.date.getLong(field);
            if (this.time != null && this.time.isSupported(field)) return this.time.getLong(field);
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field not found: " + field);
        }
        return value;
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return this.zone;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.date != null ? $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(this.date) : null;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.time;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return _query.queryFrom(this);
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    return DateTimeBuilder;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$DateTimeParseContext = function() {
    function DateTimeParseContext() {
        if (arguments.length === 1) {
            if (arguments[0] instanceof DateTimeParseContext) {
                this._constructorSelf.apply(this, arguments);
                return;
            } else this._constructorFormatter.apply(this, arguments);
        } else this._constructorParam.apply(this, arguments);
        this._caseSensitive = true;
        this._strict = true;
        this._parsed = [
            new $2e6f1e48aadbcba7$var$Parsed(this)
        ];
    }
    var _proto = DateTimeParseContext.prototype;
    _proto._constructorParam = function _constructorParam(locale, symbols, chronology) {
        this._locale = locale;
        this._symbols = symbols;
        this._overrideChronology = chronology;
    };
    _proto._constructorFormatter = function _constructorFormatter(formatter) {
        this._locale = formatter.locale();
        this._symbols = formatter.decimalStyle();
        this._overrideChronology = formatter.chronology();
    };
    _proto._constructorSelf = function _constructorSelf(other) {
        this._locale = other._locale;
        this._symbols = other._symbols;
        this._overrideChronology = other._overrideChronology;
        this._overrideZone = other._overrideZone;
        this._caseSensitive = other._caseSensitive;
        this._strict = other._strict;
        this._parsed = [
            new $2e6f1e48aadbcba7$var$Parsed(this)
        ];
    };
    _proto.copy = function copy() {
        return new DateTimeParseContext(this);
    };
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.isStrict = function isStrict() {
        return this._strict;
    };
    _proto.setStrict = function setStrict(strict) {
        this._strict = strict;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    _proto.startOptional = function startOptional() {
        this._parsed.push(this.currentParsed().copy());
    };
    _proto.endOptional = function endOptional(successful) {
        if (successful) this._parsed.splice(this._parsed.length - 2, 1);
        else this._parsed.splice(this._parsed.length - 1, 1);
    };
    _proto.isCaseSensitive = function isCaseSensitive() {
        return this._caseSensitive;
    };
    _proto.setCaseSensitive = function setCaseSensitive(caseSensitive) {
        this._caseSensitive = caseSensitive;
    };
    _proto.subSequenceEquals = function subSequenceEquals(cs1, offset1, cs2, offset2, length) {
        if (offset1 + length > cs1.length || offset2 + length > cs2.length) return false;
        if (!this.isCaseSensitive()) {
            cs1 = cs1.toLowerCase();
            cs2 = cs2.toLowerCase();
        }
        for(var i = 0; i < length; i++){
            var ch1 = cs1[offset1 + i];
            var ch2 = cs2[offset2 + i];
            if (ch1 !== ch2) return false;
        }
        return true;
    };
    _proto.charEquals = function charEquals(ch1, ch2) {
        if (this.isCaseSensitive()) return ch1 === ch2;
        return this.charEqualsIgnoreCase(ch1, ch2);
    };
    _proto.charEqualsIgnoreCase = function charEqualsIgnoreCase(c1, c2) {
        return c1 === c2 || c1.toLowerCase() === c2.toLowerCase();
    };
    _proto.setParsedField = function setParsedField(field, value, errorPos, successPos) {
        var currentParsedFieldValues = this.currentParsed().fieldValues;
        var old = currentParsedFieldValues.get(field);
        currentParsedFieldValues.set(field, value);
        return old != null && old !== value ? ~errorPos : successPos;
    };
    _proto.setParsedZone = function setParsedZone(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        this.currentParsed().zone = zone;
    };
    _proto.getParsed = function getParsed(field) {
        return this.currentParsed().fieldValues.get(field);
    };
    _proto.toParsed = function toParsed() {
        return this.currentParsed();
    };
    _proto.currentParsed = function currentParsed() {
        return this._parsed[this._parsed.length - 1];
    };
    _proto.setParsedLeapSecond = function setParsedLeapSecond() {
        this.currentParsed().leapSecond = true;
    };
    _proto.getEffectiveChronology = function getEffectiveChronology() {
        var chrono = this.currentParsed().chrono;
        if (chrono == null) {
            chrono = this._overrideChronology;
            if (chrono == null) chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        }
        return chrono;
    };
    return DateTimeParseContext;
}();
var $2e6f1e48aadbcba7$var$Parsed = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Parsed, _Temporal);
    function Parsed(dateTimeParseContext) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this.chrono = null;
        _this.zone = null;
        _this.fieldValues = new $2e6f1e48aadbcba7$var$EnumMap();
        _this.leapSecond = false;
        _this.dateTimeParseContext = dateTimeParseContext;
        return _this;
    }
    var _proto2 = Parsed.prototype;
    _proto2.copy = function copy() {
        var cloned = new Parsed();
        cloned.chrono = this.chrono;
        cloned.zone = this.zone;
        cloned.fieldValues.putAll(this.fieldValues);
        cloned.leapSecond = this.leapSecond;
        cloned.dateTimeParseContext = this.dateTimeParseContext;
        return cloned;
    };
    _proto2.toString = function toString() {
        return this.fieldValues + ", " + this.chrono + ", " + this.zone;
    };
    _proto2.isSupported = function isSupported(field) {
        return this.fieldValues.containsKey(field);
    };
    _proto2.get = function get(field) {
        var val = this.fieldValues.get(field);
        $2e6f1e48aadbcba7$var$assert(val != null);
        return val;
    };
    _proto2.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.zone;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto2.toBuilder = function toBuilder() {
        var builder = new $2e6f1e48aadbcba7$var$DateTimeBuilder();
        builder.fieldValues.putAll(this.fieldValues);
        builder.chrono = this.dateTimeParseContext.getEffectiveChronology();
        if (this.zone != null) builder.zone = this.zone;
        else builder.zone = this.overrideZone;
        builder.leapSecond = this.leapSecond;
        builder.excessDays = this.excessDays;
        return builder;
    };
    return Parsed;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$DateTimePrintContext = function() {
    function DateTimePrintContext(temporal, localeOrFormatter, symbols) {
        if (arguments.length === 2 && arguments[1] instanceof $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c) {
            this._temporal = DateTimePrintContext.adjust(temporal, localeOrFormatter);
            this._locale = localeOrFormatter.locale();
            this._symbols = localeOrFormatter.decimalStyle();
        } else {
            this._temporal = temporal;
            this._locale = localeOrFormatter;
            this._symbols = symbols;
        }
        this._optional = 0;
    }
    DateTimePrintContext.adjust = function adjust(temporal, formatter) {
        return temporal;
    };
    var _proto = DateTimePrintContext.prototype;
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.startOptional = function startOptional() {
        this._optional++;
    };
    _proto.endOptional = function endOptional() {
        this._optional--;
    };
    _proto.getValueQuery = function getValueQuery(query) {
        var result = this._temporal.query(query);
        if (result == null && this._optional === 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to extract value: " + this._temporal);
        return result;
    };
    _proto.getValue = function getValue(field) {
        try {
            return this._temporal.getLong(field);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb && this._optional > 0) return null;
            throw ex;
        }
    };
    _proto.temporal = function temporal() {
        return this._temporal;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setDateTime = function setDateTime(temporal) {
        this._temporal = temporal;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    return DateTimePrintContext;
}();
var $2e6f1e48aadbcba7$export$2091a0730eb3b2d2 = {};
var $2e6f1e48aadbcba7$var$QUARTER_DAYS = [
    0,
    90,
    181,
    273,
    0,
    91,
    182,
    274
];
var $2e6f1e48aadbcba7$var$Field = function(_TemporalField) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Field, _TemporalField);
    function Field() {
        return _TemporalField.apply(this, arguments) || this;
    }
    var _proto = Field.prototype;
    _proto.isDateBased = function isDateBased() {
        return true;
    };
    _proto.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto._isIso = function _isIso() {
        return true;
    };
    Field._getWeekRangeByLocalDate = function _getWeekRangeByLocalDate(date) {
        var wby = Field._getWeekBasedYear(date);
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, Field._getWeekRangeByYear(wby));
    };
    Field._getWeekRangeByYear = function _getWeekRangeByYear(wby) {
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 1);
        if (date.dayOfWeek() === $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY || date.dayOfWeek() === $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY && date.isLeapYear()) return 53;
        return 52;
    };
    Field._getWeek = function _getWeek(date) {
        var dow0 = date.dayOfWeek().ordinal();
        var doy0 = date.dayOfYear() - 1;
        var doyThu0 = doy0 + (3 - dow0);
        var alignedWeek = $2e6f1e48aadbcba7$var$MathUtil.intDiv(doyThu0, 7);
        var firstThuDoy0 = doyThu0 - alignedWeek * 7;
        var firstMonDoy0 = firstThuDoy0 - 3;
        if (firstMonDoy0 < -3) firstMonDoy0 += 7;
        if (doy0 < firstMonDoy0) return Field._getWeekRangeByLocalDate(date.withDayOfYear(180).minusYears(1)).maximum();
        var week = $2e6f1e48aadbcba7$var$MathUtil.intDiv(doy0 - firstMonDoy0, 7) + 1;
        if (week === 53) {
            if ((firstMonDoy0 === -3 || firstMonDoy0 === -2 && date.isLeapYear()) === false) week = 1;
        }
        return week;
    };
    Field._getWeekBasedYear = function _getWeekBasedYear(date) {
        var year = date.year();
        var doy = date.dayOfYear();
        if (doy <= 3) {
            var dow = date.dayOfWeek().ordinal();
            if (doy - dow < -2) year--;
        } else if (doy >= 363) {
            var _dow = date.dayOfWeek().ordinal();
            doy = doy - 363 - (date.isLeapYear() ? 1 : 0);
            if (doy - _dow >= 0) year++;
        }
        return year;
    };
    _proto.displayName = function displayName() {
        return this.toString();
    };
    _proto.resolve = function resolve() {
        return null;
    };
    _proto.name = function name() {
        return this.toString();
    };
    return Field;
}($2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9);
var $2e6f1e48aadbcba7$var$DAY_OF_QUARTER_FIELD = function(_Field) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DAY_OF_QUARTER_FIELD, _Field);
    function DAY_OF_QUARTER_FIELD() {
        return _Field.apply(this, arguments) || this;
    }
    var _proto2 = DAY_OF_QUARTER_FIELD.prototype;
    _proto2.toString = function toString() {
        return 'DayOfQuarter';
    };
    _proto2.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
    };
    _proto2.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    };
    _proto2.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 90, 92);
    };
    _proto2.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR) && temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) && temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) && this._isIso(temporal);
    };
    _proto2.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: DayOfQuarter');
        var qoy = temporal.getLong($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        if (qoy === 1) {
            var year = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
            return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 91) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 90);
        } else if (qoy === 2) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 91);
        else if (qoy === 3 || qoy === 4) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 92);
        return this.range();
    };
    _proto2.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: DayOfQuarter');
        var doy = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR);
        var moy = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var year = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        return doy - $2e6f1e48aadbcba7$var$QUARTER_DAYS[$2e6f1e48aadbcba7$var$MathUtil.intDiv(moy - 1, 3) + ($2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 4 : 0)];
    };
    _proto2.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR) + (newValue - curValue));
    };
    _proto2.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var yearLong = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        var qoyLong = fieldValues.get($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        if (yearLong == null || qoyLong == null) return null;
        var y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(yearLong);
        var doq = fieldValues.get($2e6f1e48aadbcba7$var$DAY_OF_QUARTER);
        var date;
        if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            var qoy = qoyLong;
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, 1, 1);
            date = date.plusMonths($2e6f1e48aadbcba7$var$MathUtil.safeMultiply($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(qoy, 1), 3));
            date = date.plusDays($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(doq, 1));
        } else {
            var _qoy = $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR.range().checkValidIntValue(qoyLong, $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
            if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                var max = 92;
                if (_qoy === 1) max = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(y) ? 91 : 90;
                else if (_qoy === 2) max = 91;
                $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, max).checkValidValue(doq, this);
            } else this.range().checkValidValue(doq, this);
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, (_qoy - 1) * 3 + 1, 1).plusDays(doq - 1);
        }
        fieldValues.remove(this);
        fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        fieldValues.remove($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        return date;
    };
    return DAY_OF_QUARTER_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR_FIELD = function(_Field2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(QUARTER_OF_YEAR_FIELD, _Field2);
    function QUARTER_OF_YEAR_FIELD() {
        return _Field2.apply(this, arguments) || this;
    }
    var _proto3 = QUARTER_OF_YEAR_FIELD.prototype;
    _proto3.toString = function toString() {
        return 'QuarterOfYear';
    };
    _proto3.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    };
    _proto3.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS;
    };
    _proto3.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 4);
    };
    _proto3.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) && this._isIso(temporal);
    };
    _proto3.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return this.range();
    };
    _proto3.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: QuarterOfYear');
        var moy = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(moy + 2, 3);
    };
    _proto3.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) + (newValue - curValue) * 3);
    };
    return QUARTER_OF_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR_FIELD = function(_Field3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(WEEK_OF_WEEK_BASED_YEAR_FIELD, _Field3);
    function WEEK_OF_WEEK_BASED_YEAR_FIELD() {
        return _Field3.apply(this, arguments) || this;
    }
    var _proto4 = WEEK_OF_WEEK_BASED_YEAR_FIELD.prototype;
    _proto4.toString = function toString() {
        return 'WeekOfWeekBasedYear';
    };
    _proto4.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS;
    };
    _proto4.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    };
    _proto4.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 52, 53);
    };
    _proto4.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto4.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: WeekOfWeekBasedYear');
        return $2e6f1e48aadbcba7$var$Field._getWeekRangeByLocalDate($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: WeekOfWeekBasedYear');
        return $2e6f1e48aadbcba7$var$Field._getWeek($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.adjustInto = function adjustInto(temporal, newValue) {
        this.range().checkValidValue(newValue, this);
        return temporal.plus($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(newValue, this.getFrom(temporal)), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS);
    };
    _proto4.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var wbyLong = fieldValues.get($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var dowLong = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (wbyLong == null || dowLong == null) return null;
        var wby = $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR.range().checkValidIntValue(wbyLong, $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var wowby = fieldValues.get($2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR);
        var date;
        if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            var dow = dowLong;
            var weeks = 0;
            if (dow > 7) {
                weeks = $2e6f1e48aadbcba7$var$MathUtil.intDiv(dow - 1, 7);
                dow = $2e6f1e48aadbcba7$var$MathUtil.intMod(dow - 1, 7) + 1;
            } else if (dow < 1) {
                weeks = $2e6f1e48aadbcba7$var$MathUtil.intDiv(dow, 7) - 1;
                dow = $2e6f1e48aadbcba7$var$MathUtil.intMod(dow, 7) + 7;
            }
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).plusWeeks(weeks).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, dow);
        } else {
            var _dow2 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(dowLong);
            if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                var temp = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4);
                var range = $2e6f1e48aadbcba7$var$Field._getWeekRangeByLocalDate(temp);
                range.checkValidValue(wowby, this);
            } else this.range().checkValidValue(wowby, this);
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, _dow2);
        }
        fieldValues.remove(this);
        fieldValues.remove($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        return date;
    };
    _proto4.displayName = function displayName() {
        return 'Week';
    };
    return WEEK_OF_WEEK_BASED_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR_FIELD = function(_Field4) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(WEEK_BASED_YEAR_FIELD, _Field4);
    function WEEK_BASED_YEAR_FIELD() {
        return _Field4.apply(this, arguments) || this;
    }
    var _proto5 = WEEK_BASED_YEAR_FIELD.prototype;
    _proto5.toString = function toString() {
        return 'WeekBasedYear';
    };
    _proto5.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    };
    _proto5.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER;
    };
    _proto5.range = function range() {
        return $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto5.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: WeekBasedYear');
        return $2e6f1e48aadbcba7$var$Field._getWeekBasedYear($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto5.adjustInto = function adjustInto(temporal, newValue) {
        if (this.isSupportedBy(temporal) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58('Unsupported field: WeekBasedYear');
        var newWby = this.range().checkValidIntValue(newValue, $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
        var dow = date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        var week = $2e6f1e48aadbcba7$var$Field._getWeek(date);
        if (week === 53 && $2e6f1e48aadbcba7$var$Field._getWeekRangeByYear(newWby) === 52) week = 52;
        var resolved = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(newWby, 1, 4);
        var days = dow - resolved.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) + (week - 1) * 7;
        resolved = resolved.plusDays(days);
        return temporal.with(resolved);
    };
    return WEEK_BASED_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$Unit = function(_TemporalUnit) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Unit, _TemporalUnit);
    function Unit(name, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto6 = Unit.prototype;
    _proto6.duration = function duration() {
        return this._duration;
    };
    _proto6.isDurationEstimated = function isDurationEstimated() {
        return true;
    };
    _proto6.isDateBased = function isDateBased() {
        return true;
    };
    _proto6.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto6.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY);
    };
    _proto6.addTo = function addTo(temporal, periodToAdd) {
        switch(this){
            case $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS:
                var added = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(temporal.get($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR), periodToAdd);
                return temporal.with($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR, added);
            case $2e6f1e48aadbcba7$var$QUARTER_YEARS:
                return temporal.plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(periodToAdd, 256), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS).plus($2e6f1e48aadbcba7$var$MathUtil.intMod(periodToAdd, 256) * 3, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            default:
                throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e('Unreachable');
        }
    };
    _proto6.between = function between(temporal1, temporal2) {
        switch(this){
            case $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS:
                return $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(temporal2.getLong($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR), temporal1.getLong($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR));
            case $2e6f1e48aadbcba7$var$QUARTER_YEARS:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(temporal1.until(temporal2, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS), 3);
            default:
                throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e('Unreachable');
        }
    };
    _proto6.toString = function toString() {
        return this._name;
    };
    return Unit;
}($2e6f1e48aadbcba7$export$5d412a4bb789788e);
var $2e6f1e48aadbcba7$var$DAY_OF_QUARTER = null;
var $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS = null;
var $2e6f1e48aadbcba7$var$QUARTER_YEARS = null;
function $2e6f1e48aadbcba7$var$_init$f() {
    $2e6f1e48aadbcba7$var$DAY_OF_QUARTER = new $2e6f1e48aadbcba7$var$DAY_OF_QUARTER_FIELD();
    $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR = new $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR = new $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR = new $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS = new $2e6f1e48aadbcba7$var$Unit('WeekBasedYears', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952));
    $2e6f1e48aadbcba7$var$QUARTER_YEARS = new $2e6f1e48aadbcba7$var$Unit('QuarterYears', $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(7889238));
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.DAY_OF_QUARTER = $2e6f1e48aadbcba7$var$DAY_OF_QUARTER;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR = $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR = $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEAR = $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEARS = $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_YEARS = $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.prototype.isoWeekOfWeekyear = function() {
        return this.get($2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR);
    };
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.prototype.isoWeekyear = function() {
        return this.get($2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEAR);
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$c1929c59b9e7d355 = function() {
    function DecimalStyle(zeroChar, positiveSignChar, negativeSignChar, decimalPointChar) {
        this._zeroDigit = zeroChar;
        this._zeroDigitCharCode = zeroChar.charCodeAt(0);
        this._positiveSign = positiveSignChar;
        this._negativeSign = negativeSignChar;
        this._decimalSeparator = decimalPointChar;
    }
    var _proto = DecimalStyle.prototype;
    _proto.positiveSign = function positiveSign() {
        return this._positiveSign;
    };
    _proto.withPositiveSign = function withPositiveSign(positiveSign) {
        if (positiveSign === this._positiveSign) return this;
        return new DecimalStyle(this._zeroDigit, positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.negativeSign = function negativeSign() {
        return this._negativeSign;
    };
    _proto.withNegativeSign = function withNegativeSign(negativeSign) {
        if (negativeSign === this._negativeSign) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, negativeSign, this._decimalSeparator);
    };
    _proto.zeroDigit = function zeroDigit() {
        return this._zeroDigit;
    };
    _proto.withZeroDigit = function withZeroDigit(zeroDigit) {
        if (zeroDigit === this._zeroDigit) return this;
        return new DecimalStyle(zeroDigit, this._positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.decimalSeparator = function decimalSeparator() {
        return this._decimalSeparator;
    };
    _proto.withDecimalSeparator = function withDecimalSeparator(decimalSeparator) {
        if (decimalSeparator === this._decimalSeparator) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, this._negativeSign, decimalSeparator);
    };
    _proto.convertToDigit = function convertToDigit(char) {
        var val = char.charCodeAt(0) - this._zeroDigitCharCode;
        return val >= 0 && val <= 9 ? val : -1;
    };
    _proto.convertNumberToI18N = function convertNumberToI18N(numericText) {
        if (this._zeroDigit === '0') return numericText;
        var diff = this._zeroDigitCharCode - '0'.charCodeAt(0);
        var convertedText = '';
        for(var i = 0; i < numericText.length; i++)convertedText += String.fromCharCode(numericText.charCodeAt(i) + diff);
        return convertedText;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof DecimalStyle) return this._zeroDigit === other._zeroDigit && this._positiveSign === other._positiveSign && this._negativeSign === other._negativeSign && this._decimalSeparator === other._decimalSeparator;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator;
    };
    _proto.toString = function toString() {
        return "DecimalStyle[" + this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator + "]";
    };
    DecimalStyle.of = function of() {
        throw new Error('not yet supported');
    };
    DecimalStyle.availableLocales = function availableLocales() {
        throw new Error('not yet supported');
    };
    return DecimalStyle;
}();
$2e6f1e48aadbcba7$export$c1929c59b9e7d355.STANDARD = new $2e6f1e48aadbcba7$export$c1929c59b9e7d355('0', '+', '-', '.');
var $2e6f1e48aadbcba7$export$b2e3a42c433c0b35 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SignStyle, _Enum);
    function SignStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SignStyle.prototype;
    _proto.parse = function parse(positive, strict, fixedWidth) {
        switch(this){
            case SignStyle.NORMAL:
                return !positive || !strict;
            case SignStyle.ALWAYS:
            case SignStyle.EXCEEDS_PAD:
                return true;
            default:
                return !strict && !fixedWidth;
        }
    };
    return SignStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35('NORMAL');
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NEVER = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35('NEVER');
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35('ALWAYS');
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35('EXCEEDS_PAD');
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35('NOT_NEGATIVE');
var $2e6f1e48aadbcba7$export$1df879243bf2e42d = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(TextStyle, _Enum);
    function TextStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TextStyle.prototype;
    _proto.isStandalone = function isStandalone() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
            case TextStyle.SHORT_STANDALONE:
            case TextStyle.NARROW_STANDALONE:
                return true;
            default:
                return false;
        }
    };
    _proto.asStandalone = function asStandalone() {
        switch(this){
            case TextStyle.FULL:
                return TextStyle.FULL_STANDALONE;
            case TextStyle.SHORT:
                return TextStyle.SHORT_STANDALONE;
            case TextStyle.NARROW:
                return TextStyle.NARROW_STANDALONE;
            default:
                return this;
        }
    };
    _proto.asNormal = function asNormal() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
                return TextStyle.FULL;
            case TextStyle.SHORT_STANDALONE:
                return TextStyle.SHORT;
            case TextStyle.NARROW_STANDALONE:
                return TextStyle.NARROW;
            default:
                return this;
        }
    };
    return TextStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('FULL');
$2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('FULL_STANDALONE');
$2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('SHORT');
$2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('SHORT_STANDALONE');
$2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('NARROW');
$2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d('NARROW_STANDALONE');
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$CharLiteralPrinterParser = function() {
    function CharLiteralPrinterParser(literal) {
        if (literal.length > 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("invalid literal, too long: \"" + literal + "\"");
        this._literal = literal;
    }
    var _proto = CharLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        var ch = text.charAt(position);
        if (context.charEquals(this._literal, ch) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        if (this._literal === '\'') return "''";
        return "'" + this._literal + "'";
    };
    return CharLiteralPrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$CompositePrinterParser = function() {
    function CompositePrinterParser(printerParsers, optional) {
        this._printerParsers = printerParsers;
        this._optional = optional;
    }
    var _proto = CompositePrinterParser.prototype;
    _proto.withOptional = function withOptional(optional) {
        if (optional === this._optional) return this;
        return new CompositePrinterParser(this._printerParsers, optional);
    };
    _proto.print = function print(context, buf) {
        var length = buf.length();
        if (this._optional) context.startOptional();
        try {
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                if (pp.print(context, buf) === false) {
                    buf.setLength(length);
                    return true;
                }
            }
        } finally{
            if (this._optional) context.endOptional();
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        if (this._optional) {
            context.startOptional();
            var pos = position;
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                pos = pp.parse(context, text, pos);
                if (pos < 0) {
                    context.endOptional(false);
                    return position;
                }
            }
            context.endOptional(true);
            return pos;
        } else {
            for(var _i = 0; _i < this._printerParsers.length; _i++){
                var _pp = this._printerParsers[_i];
                position = _pp.parse(context, text, position);
                if (position < 0) break;
            }
            return position;
        }
    };
    _proto.toString = function toString() {
        var buf = '';
        if (this._printerParsers != null) {
            buf += this._optional ? '[' : '(';
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                buf += pp.toString();
            }
            buf += this._optional ? ']' : ')';
        }
        return buf;
    };
    return CompositePrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$FractionPrinterParser = function() {
    function FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field.range().isFixed() === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Field must have a fixed set of values: " + field);
        if (minWidth < 0 || minWidth > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Minimum width must be from 0 to 9 inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Maximum width must be from 1 to 9 inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        this.field = field;
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
        this.decimalPoint = decimalPoint;
    }
    var _proto = FractionPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var value = context.getValue(this.field);
        if (value === null) return false;
        var symbols = context.symbols();
        if (value === 0) {
            if (this.minWidth > 0) {
                if (this.decimalPoint) buf.append(symbols.decimalSeparator());
                for(var i = 0; i < this.minWidth; i++)buf.append(symbols.zeroDigit());
            }
        } else {
            var fraction = this.convertToFraction(value, symbols.zeroDigit());
            var outputScale = Math.min(Math.max(fraction.length, this.minWidth), this.maxWidth);
            fraction = fraction.substr(0, outputScale);
            if (fraction * 1 > 0) while(fraction.length > this.minWidth && fraction[fraction.length - 1] === '0')fraction = fraction.substr(0, fraction.length - 1);
            var str = fraction;
            str = symbols.convertNumberToI18N(str);
            if (this.decimalPoint) buf.append(symbols.decimalSeparator());
            buf.append(str);
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var effectiveMin = context.isStrict() ? this.minWidth : 0;
        var effectiveMax = context.isStrict() ? this.maxWidth : 9;
        var length = text.length;
        if (position === length) return effectiveMin > 0 ? ~position : position;
        if (this.decimalPoint) {
            if (text[position] !== context.symbols().decimalSeparator()) return effectiveMin > 0 ? ~position : position;
            position++;
        }
        var minEndPos = position + effectiveMin;
        if (minEndPos > length) return ~position;
        var maxEndPos = Math.min(position + effectiveMax, length);
        var total = 0;
        var pos = position;
        while(pos < maxEndPos){
            var ch = text.charAt(pos++);
            var digit = context.symbols().convertToDigit(ch);
            if (digit < 0) {
                if (pos < minEndPos) return ~position;
                pos--;
                break;
            }
            total = total * 10 + digit;
        }
        var moveLeft = pos - position;
        var scale = Math.pow(10, moveLeft);
        var value = this.convertFromFraction(total, scale);
        return context.setParsedField(this.field, value, position, pos);
    };
    _proto.convertToFraction = function convertToFraction(value, zeroDigit) {
        var range = this.field.range();
        range.checkValidValue(value, this.field);
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = value - _min;
        var _scaled = $2e6f1e48aadbcba7$var$MathUtil.intDiv(_value * 1000000000, _range);
        var fraction = "" + _scaled;
        while(fraction.length < 9)fraction = zeroDigit + fraction;
        return fraction;
    };
    _proto.convertFromFraction = function convertFromFraction(total, scale) {
        var range = this.field.range();
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = $2e6f1e48aadbcba7$var$MathUtil.intDiv(total * _range, scale);
        return _value;
    };
    _proto.toString = function toString() {
        var decimal = this.decimalPoint ? ',DecimalPoint' : '';
        return "Fraction(" + this.field + "," + this.minWidth + "," + this.maxWidth + decimal + ")";
    };
    return FractionPrinterParser;
}();
var $2e6f1e48aadbcba7$var$MAX_WIDTH$1 = 15;
var $2e6f1e48aadbcba7$var$EXCEED_POINTS = [
    0,
    10,
    100,
    1000,
    10000,
    100000,
    1000000,
    10000000,
    100000000,
    1000000000
];
var $2e6f1e48aadbcba7$var$NumberPrinterParser = function() {
    function NumberPrinterParser(field, minWidth, maxWidth, signStyle, subsequentWidth) {
        if (subsequentWidth === void 0) subsequentWidth = 0;
        this._field = field;
        this._minWidth = minWidth;
        this._maxWidth = maxWidth;
        this._signStyle = signStyle;
        this._subsequentWidth = subsequentWidth;
    }
    var _proto = NumberPrinterParser.prototype;
    _proto.field = function field() {
        return this._field;
    };
    _proto.minWidth = function minWidth() {
        return this._minWidth;
    };
    _proto.maxWidth = function maxWidth() {
        return this._maxWidth;
    };
    _proto.signStyle = function signStyle() {
        return this._signStyle;
    };
    _proto.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, -1);
    };
    _proto.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, this._subsequentWidth + subsequentWidth);
    };
    _proto._isFixedWidth = function _isFixedWidth() {
        return this._subsequentWidth === -1 || this._subsequentWidth > 0 && this._minWidth === this._maxWidth && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE;
    };
    _proto.print = function print(context, buf) {
        var contextValue = context.getValue(this._field);
        if (contextValue == null) return false;
        var value = this._getValue(context, contextValue);
        var symbols = context.symbols();
        var str = "" + Math.abs(value);
        if (str.length > this._maxWidth) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " exceeds the maximum print width of " + this._maxWidth);
        str = symbols.convertNumberToI18N(str);
        if (value >= 0) switch(this._signStyle){
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD:
                if (this._minWidth < $2e6f1e48aadbcba7$var$MAX_WIDTH$1 && value >= $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth]) buf.append(symbols.positiveSign());
                break;
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.positiveSign());
                break;
        }
        else switch(this._signStyle){
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL:
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD:
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.negativeSign());
                break;
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE:
                throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " cannot be negative according to the SignStyle");
        }
        for(var i = 0; i < this._minWidth - str.length; i++)buf.append(symbols.zeroDigit());
        buf.append(str);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        $2e6f1e48aadbcba7$var$assert(position >= 0 && position < length);
        var sign = text.charAt(position);
        var negative = false;
        var positive = false;
        if (sign === context.symbols().positiveSign()) {
            if (this._signStyle.parse(true, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            positive = true;
            position++;
        } else if (sign === context.symbols().negativeSign()) {
            if (this._signStyle.parse(false, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            negative = true;
            position++;
        } else {
            if (this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS && context.isStrict()) return ~position;
        }
        var effMinWidth = context.isStrict() || this._isFixedWidth() ? this._minWidth : 1;
        var minEndPos = position + effMinWidth;
        if (minEndPos > length) return ~position;
        var effMaxWidth = (context.isStrict() || this._isFixedWidth() ? this._maxWidth : 9) + Math.max(this._subsequentWidth, 0);
        var total = 0;
        var pos = position;
        for(var pass = 0; pass < 2; pass++){
            var maxEndPos = Math.min(pos + effMaxWidth, length);
            while(pos < maxEndPos){
                var ch = text.charAt(pos++);
                var digit = context.symbols().convertToDigit(ch);
                if (digit < 0) {
                    pos--;
                    if (pos < minEndPos) return ~position;
                    break;
                }
                if (pos - position > $2e6f1e48aadbcba7$var$MAX_WIDTH$1) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67('number text exceeds length');
                else total = total * 10 + digit;
            }
            if (this._subsequentWidth > 0 && pass === 0) {
                var parseLen = pos - position;
                effMaxWidth = Math.max(effMinWidth, parseLen - this._subsequentWidth);
                pos = position;
                total = 0;
            } else break;
        }
        if (negative) {
            if (total === 0 && context.isStrict()) return ~(position - 1);
            if (total !== 0) total = -total;
        } else if (this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD && context.isStrict()) {
            var _parseLen = pos - position;
            if (positive) {
                if (_parseLen <= this._minWidth) return ~(position - 1);
            } else {
                if (_parseLen > this._minWidth) return ~position;
            }
        }
        return this._setValue(context, total, position, pos);
    };
    _proto._getValue = function _getValue(context, value) {
        return value;
    };
    _proto._setValue = function _setValue(context, value, errorPos, successPos) {
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto.toString = function toString() {
        if (this._minWidth === 1 && this._maxWidth === $2e6f1e48aadbcba7$var$MAX_WIDTH$1 && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL) return "Value(" + this._field + ")";
        if (this._minWidth === this._maxWidth && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) return "Value(" + this._field + "," + this._minWidth + ")";
        return "Value(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + this._signStyle + ")";
    };
    return NumberPrinterParser;
}();
var $2e6f1e48aadbcba7$var$ReducedPrinterParser = function(_NumberPrinterParser) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ReducedPrinterParser, _NumberPrinterParser);
    function ReducedPrinterParser(field, width, maxWidth, baseValue, baseDate) {
        var _this;
        _this = _NumberPrinterParser.call(this, field, width, maxWidth, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) || this;
        if (width < 1 || width > 10) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The width must be from 1 to 10 inclusive but was " + width);
        if (maxWidth < 1 || maxWidth > 10) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The maxWidth must be from 1 to 10 inclusive but was " + maxWidth);
        if (maxWidth < width) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('The maxWidth must be greater than the width');
        if (baseDate === null) {
            if (field.range().isValidValue(baseValue) === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('The base value must be within the range of the field');
            if (baseValue + $2e6f1e48aadbcba7$var$EXCEED_POINTS[width] > $2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Unable to add printer-parser as the range exceeds the capacity of an int');
        }
        _this._baseValue = baseValue;
        _this._baseDate = baseDate;
        return _this;
    }
    var _proto2 = ReducedPrinterParser.prototype;
    _proto2._getValue = function _getValue(context, value) {
        var absValue = Math.abs(value);
        var baseValue = this._baseValue;
        if (this._baseDate !== null) {
            context.temporal();
            var chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        if (value >= baseValue && value < baseValue + $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth]) return absValue % $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth];
        return absValue % $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._maxWidth];
    };
    _proto2._setValue = function _setValue(context, value, errorPos, successPos) {
        var baseValue = this._baseValue;
        if (this._baseDate != null) {
            var chrono = context.getEffectiveChronology();
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        var parseLen = successPos - errorPos;
        if (parseLen === this._minWidth && value >= 0) {
            var range = $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth];
            var lastPart = baseValue % range;
            var basePart = baseValue - lastPart;
            if (baseValue > 0) value = basePart + value;
            else value = basePart - value;
            if (value < baseValue) value += range;
        }
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto2.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate);
    };
    _proto2.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, this._subsequentWidth + subsequentWidth);
    };
    _proto2.isFixedWidth = function isFixedWidth(context) {
        if (context.isStrict() === false) return false;
        return _NumberPrinterParser.prototype.isFixedWidth.call(this, context);
    };
    _proto2.toString = function toString() {
        return "ReducedValue(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + (this._baseDate != null ? this._baseDate : this._baseValue) + ")";
    };
    return ReducedPrinterParser;
}($2e6f1e48aadbcba7$var$NumberPrinterParser);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$PATTERNS = [
    '+HH',
    '+HHmm',
    '+HH:mm',
    '+HHMM',
    '+HH:MM',
    '+HHMMss',
    '+HH:MM:ss',
    '+HHMMSS',
    '+HH:MM:SS'
];
var $2e6f1e48aadbcba7$var$OffsetIdPrinterParser = function() {
    function OffsetIdPrinterParser(noOffsetText, pattern) {
        $2e6f1e48aadbcba7$var$requireNonNull(noOffsetText, 'noOffsetText');
        $2e6f1e48aadbcba7$var$requireNonNull(pattern, 'pattern');
        this.noOffsetText = noOffsetText;
        this.type = this._checkPattern(pattern);
    }
    var _proto = OffsetIdPrinterParser.prototype;
    _proto._checkPattern = function _checkPattern(pattern) {
        for(var i = 0; i < $2e6f1e48aadbcba7$var$PATTERNS.length; i++){
            if ($2e6f1e48aadbcba7$var$PATTERNS[i] === pattern) return i;
        }
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid zone offset pattern: " + pattern);
    };
    _proto.print = function print(context, buf) {
        var offsetSecs = context.getValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
        if (offsetSecs == null) return false;
        var totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(offsetSecs);
        if (totalSecs === 0) buf.append(this.noOffsetText);
        else {
            var absHours = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(totalSecs, 3600), 100));
            var absMinutes = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(totalSecs, 60), 60));
            var absSeconds = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod(totalSecs, 60));
            var bufPos = buf.length();
            var output = absHours;
            buf.append(totalSecs < 0 ? '-' : '+').appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absHours, 10) + "0").appendChar($2e6f1e48aadbcba7$var$MathUtil.intMod(absHours, 10) + "0");
            if (this.type >= 3 || this.type >= 1 && absMinutes > 0) {
                buf.append(this.type % 2 === 0 ? ':' : '').appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absMinutes, 10) + "0").appendChar(absMinutes % 10 + "0");
                output += absMinutes;
                if (this.type >= 7 || this.type >= 5 && absSeconds > 0) {
                    buf.append(this.type % 2 === 0 ? ':' : '').appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absSeconds, 10) + "0").appendChar(absSeconds % 10 + "0");
                    output += absSeconds;
                }
            }
            if (output === 0) {
                buf.setLength(bufPos);
                buf.append(this.noOffsetText);
            }
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        var noOffsetLen = this.noOffsetText.length;
        if (noOffsetLen === 0) {
            if (position === length) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position);
        } else {
            if (position === length) return ~position;
            if (context.subSequenceEquals(text, position, this.noOffsetText, 0, noOffsetLen)) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        }
        var sign = text[position];
        if (sign === '+' || sign === '-') {
            var negative = sign === '-' ? -1 : 1;
            var array = [
                0,
                0,
                0,
                0
            ];
            array[0] = position + 1;
            if ((this._parseNumber(array, 1, text, true) || this._parseNumber(array, 2, text, this.type >= 3) || this._parseNumber(array, 3, text, false)) === false) {
                var offsetSecs = $2e6f1e48aadbcba7$var$MathUtil.safeZero(negative * (array[1] * 3600 + array[2] * 60 + array[3]));
                return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, offsetSecs, position, array[0]);
            }
        }
        if (noOffsetLen === 0) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        return ~position;
    };
    _proto._parseNumber = function _parseNumber(array, arrayIndex, parseText, required) {
        if ((this.type + 3) / 2 < arrayIndex) return false;
        var pos = array[0];
        if (this.type % 2 === 0 && arrayIndex > 1) {
            if (pos + 1 > parseText.length || parseText[pos] !== ':') return required;
            pos++;
        }
        if (pos + 2 > parseText.length) return required;
        var ch1 = parseText[pos++];
        var ch2 = parseText[pos++];
        if (ch1 < '0' || ch1 > '9' || ch2 < '0' || ch2 > '9') return required;
        var value = (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
        if (value < 0 || value > 59) return required;
        array[arrayIndex] = value;
        array[0] = pos;
        return false;
    };
    _proto.toString = function toString() {
        var converted = this.noOffsetText.replace('\'', '\'\'');
        return "Offset(" + $2e6f1e48aadbcba7$var$PATTERNS[this.type] + ",'" + converted + "')";
    };
    return OffsetIdPrinterParser;
}();
$2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID = new $2e6f1e48aadbcba7$var$OffsetIdPrinterParser('Z', '+HH:MM:ss');
$2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS = $2e6f1e48aadbcba7$var$PATTERNS;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$PadPrinterParserDecorator = function() {
    function PadPrinterParserDecorator(printerParser, padWidth, padChar) {
        this._printerParser = printerParser;
        this._padWidth = padWidth;
        this._padChar = padChar;
    }
    var _proto = PadPrinterParserDecorator.prototype;
    _proto.print = function print(context, buf) {
        var preLen = buf.length();
        if (this._printerParser.print(context, buf) === false) return false;
        var len = buf.length() - preLen;
        if (len > this._padWidth) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Cannot print as output of " + len + " characters exceeds pad width of " + this._padWidth);
        for(var i = 0; i < this._padWidth - len; i++)buf.insert(preLen, this._padChar);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var strict = context.isStrict();
        var caseSensitive = context.isCaseSensitive();
        $2e6f1e48aadbcba7$var$assert(!(position > text.length));
        $2e6f1e48aadbcba7$var$assert(position >= 0);
        if (position === text.length) return ~position;
        var endPos = position + this._padWidth;
        if (endPos > text.length) {
            if (strict) return ~position;
            endPos = text.length;
        }
        var pos = position;
        while(pos < endPos && (caseSensitive ? text[pos] === this._padChar : context.charEquals(text[pos], this._padChar)))pos++;
        text = text.substring(0, endPos);
        var resultPos = this._printerParser.parse(context, text, pos);
        if (resultPos !== endPos && strict) return ~(position + pos);
        return resultPos;
    };
    _proto.toString = function toString() {
        return "Pad(" + this._printerParser + "," + this._padWidth + (this._padChar === ' ' ? ')' : ",'" + this._padChar + "')");
    };
    return PadPrinterParserDecorator;
}();
var $2e6f1e48aadbcba7$var$SettingsParser = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SettingsParser, _Enum);
    function SettingsParser() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SettingsParser.prototype;
    _proto.print = function print() {
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        switch(this){
            case SettingsParser.SENSITIVE:
                context.setCaseSensitive(true);
                break;
            case SettingsParser.INSENSITIVE:
                context.setCaseSensitive(false);
                break;
            case SettingsParser.STRICT:
                context.setStrict(true);
                break;
            case SettingsParser.LENIENT:
                context.setStrict(false);
                break;
        }
        return position;
    };
    _proto.toString = function toString() {
        switch(this){
            case SettingsParser.SENSITIVE:
                return 'ParseCaseSensitive(true)';
            case SettingsParser.INSENSITIVE:
                return 'ParseCaseSensitive(false)';
            case SettingsParser.STRICT:
                return 'ParseStrict(true)';
            case SettingsParser.LENIENT:
                return 'ParseStrict(false)';
        }
    };
    return SettingsParser;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$var$SettingsParser.SENSITIVE = new $2e6f1e48aadbcba7$var$SettingsParser('SENSITIVE');
$2e6f1e48aadbcba7$var$SettingsParser.INSENSITIVE = new $2e6f1e48aadbcba7$var$SettingsParser('INSENSITIVE');
$2e6f1e48aadbcba7$var$SettingsParser.STRICT = new $2e6f1e48aadbcba7$var$SettingsParser('STRICT');
$2e6f1e48aadbcba7$var$SettingsParser.LENIENT = new $2e6f1e48aadbcba7$var$SettingsParser('LENIENT');
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringLiteralPrinterParser = function() {
    function StringLiteralPrinterParser(literal) {
        this._literal = literal;
    }
    var _proto = StringLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        $2e6f1e48aadbcba7$var$assert(!(position > length || position < 0));
        if (context.subSequenceEquals(text, position, this._literal, 0, this._literal.length) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        var converted = this._literal.replace("'", "''");
        return "'" + converted + "'";
    };
    return StringLiteralPrinterParser;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter, Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$79d73e02cd645302 = function() {
    function ZoneRulesProvider() {}
    ZoneRulesProvider.getRules = function getRules(_zoneId) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('@js-joda/timezone not imported');
    };
    ZoneRulesProvider.getAvailableZoneIds = function getAvailableZoneIds() {
        return [];
    };
    return ZoneRulesProvider;
}();
var $2e6f1e48aadbcba7$export$9caa52e4e516e67d = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZoneRegion, _ZoneId);
    ZoneRegion.ofId = function ofId(zoneId) {
        var rules = $2e6f1e48aadbcba7$export$79d73e02cd645302.getRules(zoneId);
        return new ZoneRegion(zoneId, rules);
    };
    function ZoneRegion(id, rules) {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._id = id;
        _this._rules = rules;
        return _this;
    }
    var _proto = ZoneRegion.prototype;
    _proto.id = function id() {
        return this._id;
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    return ZoneRegion;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ZoneIdPrinterParser = function() {
    function ZoneIdPrinterParser(query, description) {
        this.query = query;
        this.description = description;
    }
    var _proto = ZoneIdPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var zone = context.getValueQuery(this.query);
        if (zone == null) return false;
        buf.append(zone.id());
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position > length) return ~position;
        if (position === length) return ~position;
        var nextChar = text.charAt(position);
        if (nextChar === '+' || nextChar === '-') {
            var newContext = context.copy();
            var endPos = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
            if (endPos < 0) return endPos;
            var offset = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
            var zone = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offset);
            context.setParsedZone(zone);
            return endPos;
        } else if (length >= position + 2) {
            var nextNextChar = text.charAt(position + 1);
            if (context.charEquals(nextChar, 'U') && context.charEquals(nextNextChar, 'T')) {
                if (length >= position + 3 && context.charEquals(text.charAt(position + 2), 'C')) return this._parsePrefixedOffset(context, text, position, position + 3);
                return this._parsePrefixedOffset(context, text, position, position + 2);
            } else if (context.charEquals(nextChar, 'G') && length >= position + 3 && context.charEquals(nextNextChar, 'M') && context.charEquals(text.charAt(position + 2), 'T')) return this._parsePrefixedOffset(context, text, position, position + 3);
        }
        if (text.substr(position, 6) === 'SYSTEM') {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault());
            return position + 6;
        }
        if (context.charEquals(nextChar, 'Z')) {
            context.setParsedZone($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            return position + 1;
        }
        var availableZoneIds = $2e6f1e48aadbcba7$export$79d73e02cd645302.getAvailableZoneIds();
        if ($2e6f1e48aadbcba7$var$zoneIdTree.size !== availableZoneIds.length) $2e6f1e48aadbcba7$var$zoneIdTree = $2e6f1e48aadbcba7$var$ZoneIdTree.createTreeMap(availableZoneIds);
        var maxParseLength = length - position;
        var treeMap = $2e6f1e48aadbcba7$var$zoneIdTree.treeMap;
        var parsedZoneId = null;
        var parseLength = 0;
        while(treeMap != null){
            var parsedSubZoneId = text.substr(position, Math.min(treeMap.length, maxParseLength));
            treeMap = treeMap.get(parsedSubZoneId);
            if (treeMap != null && treeMap.isLeaf) {
                parsedZoneId = parsedSubZoneId;
                parseLength = treeMap.length;
            }
        }
        if (parsedZoneId != null) {
            context.setParsedZone($2e6f1e48aadbcba7$export$9caa52e4e516e67d.ofId(parsedZoneId));
            return position + parseLength;
        }
        return ~position;
    };
    _proto._parsePrefixedOffset = function _parsePrefixedOffset(context, text, prefixPos, position) {
        var prefix = text.substring(prefixPos, position).toUpperCase();
        var newContext = context.copy();
        if (position < text.length && context.charEquals(text.charAt(position), 'Z')) {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var endPos = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
        if (endPos < 0) {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var offsetSecs = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
        var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
        context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, offset));
        return endPos;
    };
    _proto.toString = function toString() {
        return this.description;
    };
    return ZoneIdPrinterParser;
}();
var $2e6f1e48aadbcba7$var$ZoneIdTree = function() {
    ZoneIdTree.createTreeMap = function createTreeMap(availableZoneIds) {
        var sortedZoneIds = availableZoneIds.sort(function(a, b) {
            return a.length - b.length;
        });
        var treeMap = new $2e6f1e48aadbcba7$var$ZoneIdTreeMap(sortedZoneIds[0].length, false);
        for(var i = 0; i < sortedZoneIds.length; i++)treeMap.add(sortedZoneIds[i]);
        return new ZoneIdTree(sortedZoneIds.length, treeMap);
    };
    function ZoneIdTree(size, treeMap) {
        this.size = size;
        this.treeMap = treeMap;
    }
    return ZoneIdTree;
}();
var $2e6f1e48aadbcba7$var$ZoneIdTreeMap = function() {
    function ZoneIdTreeMap(length, isLeaf) {
        if (length === void 0) length = 0;
        if (isLeaf === void 0) isLeaf = false;
        this.length = length;
        this.isLeaf = isLeaf;
        this._treeMap = {};
    }
    var _proto2 = ZoneIdTreeMap.prototype;
    _proto2.add = function add(zoneId) {
        var idLength = zoneId.length;
        if (idLength === this.length) this._treeMap[zoneId] = new ZoneIdTreeMap(idLength, true);
        else if (idLength > this.length) {
            var subZoneId = zoneId.substr(0, this.length);
            var subTreeMap = this._treeMap[subZoneId];
            if (subTreeMap == null) {
                subTreeMap = new ZoneIdTreeMap(idLength, false);
                this._treeMap[subZoneId] = subTreeMap;
            }
            subTreeMap.add(zoneId);
        }
    };
    _proto2.get = function get(zoneId) {
        return this._treeMap[zoneId];
    };
    return ZoneIdTreeMap;
}();
var $2e6f1e48aadbcba7$var$zoneIdTree = new $2e6f1e48aadbcba7$var$ZoneIdTree([]);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$MAX_WIDTH = 15;
var $2e6f1e48aadbcba7$export$81529fd372517959 = function() {
    function DateTimeFormatterBuilder() {
        this._active = this;
        this._parent = null;
        this._printerParsers = [];
        this._optional = false;
        this._padNextWidth = 0;
        this._padNextChar = null;
        this._valueParserIndex = -1;
    }
    DateTimeFormatterBuilder._of = function _of(parent, optional) {
        $2e6f1e48aadbcba7$var$requireNonNull(parent, 'parent');
        $2e6f1e48aadbcba7$var$requireNonNull(optional, 'optional');
        var dtFormatterBuilder = new DateTimeFormatterBuilder();
        dtFormatterBuilder._parent = parent;
        dtFormatterBuilder._optional = optional;
        return dtFormatterBuilder;
    };
    var _proto = DateTimeFormatterBuilder.prototype;
    _proto.parseCaseSensitive = function parseCaseSensitive() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.SENSITIVE);
        return this;
    };
    _proto.parseCaseInsensitive = function parseCaseInsensitive() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.INSENSITIVE);
        return this;
    };
    _proto.parseStrict = function parseStrict() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.STRICT);
        return this;
    };
    _proto.parseLenient = function parseLenient() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.LENIENT);
        return this;
    };
    _proto.parseDefaulting = function parseDefaulting(field, value) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        this._appendInternal(new $2e6f1e48aadbcba7$var$DefaultingParser(field, value));
        return this;
    };
    _proto.appendValue = function appendValue() {
        if (arguments.length === 1) return this._appendValue1.apply(this, arguments);
        else if (arguments.length === 2) return this._appendValue2.apply(this, arguments);
        else return this._appendValue4.apply(this, arguments);
    };
    _proto._appendValue1 = function _appendValue1(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        this._appendValuePrinterParser(new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, 1, $2e6f1e48aadbcba7$var$MAX_WIDTH, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL));
        return this;
    };
    _proto._appendValue2 = function _appendValue2(field, width) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        if (width < 1 || width > $2e6f1e48aadbcba7$var$MAX_WIDTH) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH + " inclusive but was " + width);
        var pp = new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, width, width, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValue4 = function _appendValue4(field, minWidth, maxWidth, signStyle) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        $2e6f1e48aadbcba7$var$requireNonNull(signStyle);
        if (minWidth === maxWidth && signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) return this._appendValue2(field, maxWidth);
        if (minWidth < 1 || minWidth > $2e6f1e48aadbcba7$var$MAX_WIDTH) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH + " inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > $2e6f1e48aadbcba7$var$MAX_WIDTH) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH + " inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        var pp = new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, minWidth, maxWidth, signStyle);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto.appendValueReduced = function appendValueReduced() {
        if (arguments.length === 4 && arguments[3] instanceof $2e6f1e48aadbcba7$export$2a07e3472bc98879) return this._appendValueReducedFieldWidthMaxWidthBaseDate.apply(this, arguments);
        else return this._appendValueReducedFieldWidthMaxWidthBaseValue.apply(this, arguments);
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseValue = function _appendValueReducedFieldWidthMaxWidthBaseValue(field, width, maxWidth, baseValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        var pp = new $2e6f1e48aadbcba7$var$ReducedPrinterParser(field, width, maxWidth, baseValue, null);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseDate = function _appendValueReducedFieldWidthMaxWidthBaseDate(field, width, maxWidth, baseDate) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireNonNull(baseDate, 'baseDate');
        $2e6f1e48aadbcba7$var$requireInstance(baseDate, $2e6f1e48aadbcba7$export$2a07e3472bc98879, 'baseDate');
        var pp = new $2e6f1e48aadbcba7$var$ReducedPrinterParser(field, width, maxWidth, 0, baseDate);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValuePrinterParser = function _appendValuePrinterParser(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._valueParserIndex >= 0 && this._active._printerParsers[this._active._valueParserIndex] instanceof $2e6f1e48aadbcba7$var$NumberPrinterParser) {
            var activeValueParser = this._active._valueParserIndex;
            var basePP = this._active._printerParsers[activeValueParser];
            if (pp.minWidth() === pp.maxWidth() && pp.signStyle() === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) {
                basePP = basePP.withSubsequentWidth(pp.maxWidth());
                this._appendInternal(pp.withFixedWidth());
                this._active._valueParserIndex = activeValueParser;
            } else {
                basePP = basePP.withFixedWidth();
                this._active._valueParserIndex = this._appendInternal(pp);
            }
            this._active._printerParsers[activeValueParser] = basePP;
        } else this._active._valueParserIndex = this._appendInternal(pp);
        return this;
    };
    _proto.appendFraction = function appendFraction(field, minWidth, maxWidth, decimalPoint) {
        this._appendInternal(new $2e6f1e48aadbcba7$var$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
        return this;
    };
    _proto.appendInstant = function appendInstant(fractionalDigits) {
        if (fractionalDigits === void 0) fractionalDigits = -2;
        if (fractionalDigits < -2 || fractionalDigits > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid fractional digits: " + fractionalDigits);
        this._appendInternal(new $2e6f1e48aadbcba7$var$InstantPrinterParser(fractionalDigits));
        return this;
    };
    _proto.appendOffsetId = function appendOffsetId() {
        this._appendInternal($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID);
        return this;
    };
    _proto.appendOffset = function appendOffset(pattern, noOffsetText) {
        this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$OffsetIdPrinterParser(noOffsetText, pattern));
        return this;
    };
    _proto.appendZoneId = function appendZoneId() {
        this._appendInternal(new $2e6f1e48aadbcba7$var$ZoneIdPrinterParser($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId(), 'ZoneId()'));
        return this;
    };
    _proto.appendPattern = function appendPattern(pattern) {
        $2e6f1e48aadbcba7$var$requireNonNull(pattern, 'pattern');
        this._parsePattern(pattern);
        return this;
    };
    _proto.appendZoneText = function appendZoneText() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
    };
    _proto.appendText = function appendText() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
    };
    _proto.appendLocalizedOffset = function appendLocalizedOffset() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
    };
    _proto.appendWeekField = function appendWeekField() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern using (localized) text not implemented, use @js-joda/locale plugin!');
    };
    _proto._parsePattern = function _parsePattern(pattern) {
        var FIELD_MAP = {
            'G': $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA,
            'y': $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA,
            'u': $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR,
            'Q': $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            'q': $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            'M': $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR,
            'L': $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR,
            'D': $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR,
            'd': $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH,
            'F': $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH,
            'E': $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            'c': $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            'e': $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            'a': $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY,
            'H': $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY,
            'k': $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY,
            'K': $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM,
            'h': $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM,
            'm': $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR,
            's': $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE,
            'S': $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND,
            'A': $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY,
            'n': $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND,
            'N': $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY
        };
        for(var pos = 0; pos < pattern.length; pos++){
            var cur = pattern.charAt(pos);
            if (cur >= 'A' && cur <= 'Z' || cur >= 'a' && cur <= 'z') {
                var start = pos++;
                for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                var count = pos - start;
                if (cur === 'p') {
                    var pad = 0;
                    if (pos < pattern.length) {
                        cur = pattern.charAt(pos);
                        if (cur >= 'A' && cur <= 'Z' || cur >= 'a' && cur <= 'z') {
                            pad = count;
                            start = pos++;
                            for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                            count = pos - start;
                        }
                    }
                    if (pad === 0) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pad letter 'p' must be followed by valid pad pattern: " + pattern);
                    this.padNext(pad);
                }
                var field = FIELD_MAP[cur];
                if (field != null) this._parseField(cur, count, field);
                else if (cur === 'z') {
                    if (count > 4) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    else if (count === 4) this.appendZoneText($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else this.appendZoneText($2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                } else if (cur === 'V') {
                    if (count !== 2) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern letter count must be 2: " + cur);
                    this.appendZoneId();
                } else if (cur === 'Z') {
                    if (count < 4) this.appendOffset('+HHMM', '+0000');
                    else if (count === 4) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else if (count === 5) this.appendOffset('+HH:MM:ss', 'Z');
                    else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                } else if (cur === 'O') {
                    if (count === 1) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                    else if (count === 4) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern letter count must be 1 or 4: " + cur);
                } else if (cur === 'X') {
                    if (count > 5) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendOffset($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], 'Z');
                } else if (cur === 'x') {
                    if (count > 5) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    var zero = count === 1 ? '+00' : count % 2 === 0 ? '+0000' : '+00:00';
                    this.appendOffset($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], zero);
                } else if (cur === 'W') {
                    if (count > 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField('W', count);
                } else if (cur === 'w') {
                    if (count > 2) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField('w', count);
                } else if (cur === 'Y') this.appendWeekField('Y', count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Unknown pattern letter: " + cur);
                pos--;
            } else if (cur === '\'') {
                var _start = pos++;
                for(; pos < pattern.length; pos++)if (pattern.charAt(pos) === '\'') {
                    if (pos + 1 < pattern.length && pattern.charAt(pos + 1) === '\'') pos++;
                    else break;
                }
                if (pos >= pattern.length) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern ends with an incomplete string literal: " + pattern);
                var str = pattern.substring(_start + 1, pos);
                if (str.length === 0) this.appendLiteral('\'');
                else this.appendLiteral(str.replace('\'\'', '\''));
            } else if (cur === '[') this.optionalStart();
            else if (cur === ']') {
                if (this._active._parent === null) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Pattern invalid as it contains ] without previous [');
                this.optionalEnd();
            } else if (cur === '{' || cur === '}' || cur === '#') throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern includes reserved character: '" + cur + "'");
            else this.appendLiteral(cur);
        }
    };
    _proto._parseField = function _parseField(cur, count, field) {
        switch(cur){
            case 'u':
            case 'y':
                if (count === 2) this.appendValueReduced(field, 2, 2, $2e6f1e48aadbcba7$var$ReducedPrinterParser.BASE_DATE);
                else if (count < 4) this.appendValue(field, count, $2e6f1e48aadbcba7$var$MAX_WIDTH, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL);
                else this.appendValue(field, count, $2e6f1e48aadbcba7$var$MAX_WIDTH, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD);
                break;
            case 'M':
            case 'Q':
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case 'L':
            case 'q':
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case 'e':
                switch(count){
                    case 1:
                    case 2:
                        this.appendWeekField('e', count);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case 'c':
                switch(count){
                    case 1:
                        this.appendWeekField('c', count);
                        break;
                    case 2:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid number of pattern letters: " + cur);
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case 'a':
                if (count === 1) this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case 'E':
            case 'G':
                switch(count){
                    case 1:
                    case 2:
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case 'S':
                this.appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, count, count, false);
                break;
            case 'F':
                if (count === 1) this.appendValue(field);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case 'd':
            case 'h':
            case 'H':
            case 'k':
            case 'K':
            case 'm':
            case 's':
                if (count === 1) this.appendValue(field);
                else if (count === 2) this.appendValue(field, count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case 'D':
                if (count === 1) this.appendValue(field);
                else if (count <= 3) this.appendValue(field, count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            default:
                if (count === 1) this.appendValue(field);
                else this.appendValue(field, count);
                break;
        }
    };
    _proto.padNext = function padNext() {
        if (arguments.length === 1) return this._padNext1.apply(this, arguments);
        else return this._padNext2.apply(this, arguments);
    };
    _proto._padNext1 = function _padNext1(padWidth) {
        return this._padNext2(padWidth, ' ');
    };
    _proto._padNext2 = function _padNext2(padWidth, padChar) {
        if (padWidth < 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The pad width must be at least one but was " + padWidth);
        this._active._padNextWidth = padWidth;
        this._active._padNextChar = padChar;
        this._active._valueParserIndex = -1;
        return this;
    };
    _proto.optionalStart = function optionalStart() {
        this._active._valueParserIndex = -1;
        this._active = DateTimeFormatterBuilder._of(this._active, true);
        return this;
    };
    _proto.optionalEnd = function optionalEnd() {
        if (this._active._parent == null) throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e('Cannot call optionalEnd() as there was no previous call to optionalStart()');
        if (this._active._printerParsers.length > 0) {
            var cpp = new $2e6f1e48aadbcba7$var$CompositePrinterParser(this._active._printerParsers, this._active._optional);
            this._active = this._active._parent;
            this._appendInternal(cpp);
        } else this._active = this._active._parent;
        return this;
    };
    _proto._appendInternal = function _appendInternal(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $2e6f1e48aadbcba7$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.appendLiteral = function appendLiteral(literal) {
        $2e6f1e48aadbcba7$var$assert(literal != null);
        if (literal.length > 0) {
            if (literal.length === 1) this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$CharLiteralPrinterParser(literal.charAt(0)));
            else this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$StringLiteralPrinterParser(literal));
        }
        return this;
    };
    _proto._appendInternalPrinterParser = function _appendInternalPrinterParser(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $2e6f1e48aadbcba7$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.append = function append(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        this._appendInternal(formatter._toPrinterParser(false));
        return this;
    };
    _proto.toFormatter = function toFormatter(resolverStyle) {
        if (resolverStyle === void 0) resolverStyle = $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART;
        while(this._active._parent != null)this.optionalEnd();
        var pp = new $2e6f1e48aadbcba7$var$CompositePrinterParser(this._printerParsers, false);
        return new $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c(pp, null, $2e6f1e48aadbcba7$export$c1929c59b9e7d355.STANDARD, resolverStyle, null, null, null);
    };
    return DateTimeFormatterBuilder;
}();
var $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS = 315569520000;
var $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970 = 62167219200;
var $2e6f1e48aadbcba7$var$InstantPrinterParser = function() {
    function InstantPrinterParser(fractionalDigits) {
        this.fractionalDigits = fractionalDigits;
    }
    var _proto2 = InstantPrinterParser.prototype;
    _proto2.print = function print(context, buf) {
        var inSecs = context.getValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
        var inNanos = 0;
        if (context.temporal().isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) inNanos = context.temporal().getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (inSecs == null) return false;
        var inSec = inSecs;
        var inNano = $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(inNanos);
        if (inSec >= -$2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970) {
            var zeroSecs = inSec - $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS + $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970;
            var hi = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS) + 1;
            var lo = $2e6f1e48aadbcba7$var$MathUtil.floorMod(zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(lo - $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            if (hi > 0) buf.append('+').append(hi);
            buf.append(ldt.toString());
            if (ldt.second() === 0) buf.append(':00');
        } else {
            var _zeroSecs = inSec + $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970;
            var _hi = $2e6f1e48aadbcba7$var$MathUtil.intDiv(_zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var _lo = $2e6f1e48aadbcba7$var$MathUtil.intMod(_zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var _ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(_lo - $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            var pos = buf.length();
            buf.append(_ldt.toString());
            if (_ldt.second() === 0) buf.append(':00');
            if (_hi < 0) {
                if (_ldt.year() === -10000) buf.replace(pos, pos + 2, "" + (_hi - 1));
                else if (_lo === 0) buf.insert(pos, _hi);
                else buf.insert(pos + 1, Math.abs(_hi));
            }
        }
        if (this.fractionalDigits === -2) {
            if (inNano !== 0) {
                buf.append('.');
                if ($2e6f1e48aadbcba7$var$MathUtil.intMod(inNano, 1000000) === 0) buf.append(("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, 1000000) + 1000)).substring(1));
                else if ($2e6f1e48aadbcba7$var$MathUtil.intMod(inNano, 1000) === 0) buf.append(("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, 1000) + 1000000)).substring(1));
                else buf.append(("" + (inNano + 1000000000)).substring(1));
            }
        } else if (this.fractionalDigits > 0 || this.fractionalDigits === -1 && inNano > 0) {
            buf.append('.');
            var div = 100000000;
            for(var i = 0; this.fractionalDigits === -1 && inNano > 0 || i < this.fractionalDigits; i++){
                var digit = $2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, div);
                buf.append(digit);
                inNano = inNano - digit * div;
                div = $2e6f1e48aadbcba7$var$MathUtil.intDiv(div, 10);
            }
        }
        buf.append('Z');
        return true;
    };
    _proto2.parse = function parse(context, text, position) {
        var newContext = context.copy();
        var minDigits = this.fractionalDigits < 0 ? 0 : this.fractionalDigits;
        var maxDigits = this.fractionalDigits < 0 ? 9 : this.fractionalDigits;
        var parser = new $2e6f1e48aadbcba7$export$81529fd372517959().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral('T').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(':').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).appendLiteral(':').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, minDigits, maxDigits, true).appendLiteral('Z').toFormatter()._toPrinterParser(false);
        var pos = parser.parse(newContext, text, position);
        if (pos < 0) return pos;
        var yearParsed = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        var month = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var day = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH);
        var hour = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        var min = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var secVal = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nanoVal = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        var sec = secVal != null ? secVal : 0;
        var nano = nanoVal != null ? nanoVal : 0;
        var year = $2e6f1e48aadbcba7$var$MathUtil.intMod(yearParsed, 10000);
        var days = 0;
        if (hour === 24 && min === 0 && sec === 0 && nano === 0) {
            hour = 0;
            days = 1;
        } else if (hour === 23 && min === 59 && sec === 60) {
            context.setParsedLeapSecond();
            sec = 59;
        }
        var instantSecs;
        try {
            var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, day, hour, min, sec, 0).plusDays(days);
            instantSecs = ldt.toEpochSecond($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            instantSecs += $2e6f1e48aadbcba7$var$MathUtil.safeMultiply($2e6f1e48aadbcba7$var$MathUtil.intDiv(yearParsed, 10000), $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
        } catch (ex) {
            return ~position;
        }
        var successPos = pos;
        successPos = context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, instantSecs, position, successPos);
        return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, nano, position, successPos);
    };
    _proto2.toString = function toString() {
        return 'Instant()';
    };
    return InstantPrinterParser;
}();
var $2e6f1e48aadbcba7$var$DefaultingParser = function() {
    function DefaultingParser(field, value) {
        this._field = field;
        this._value = value;
    }
    var _proto3 = DefaultingParser.prototype;
    _proto3.print = function print() {
        return true;
    };
    _proto3.parse = function parse(context, text, position) {
        if (context.getParsed(this._field) == null) context.setParsedField(this._field, this._value, position, position);
        return position;
    };
    return DefaultingParser;
}();
function $2e6f1e48aadbcba7$var$_init$e() {
    $2e6f1e48aadbcba7$var$ReducedPrinterParser.BASE_DATE = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(2000, 1, 1);
    $2e6f1e48aadbcba7$export$81529fd372517959.CompositePrinterParser = $2e6f1e48aadbcba7$var$CompositePrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.PadPrinterParserDecorator = $2e6f1e48aadbcba7$var$PadPrinterParserDecorator;
    $2e6f1e48aadbcba7$export$81529fd372517959.SettingsParser = $2e6f1e48aadbcba7$var$SettingsParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.CharLiteralPrinterParser = $2e6f1e48aadbcba7$var$StringLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.StringLiteralPrinterParser = $2e6f1e48aadbcba7$var$StringLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.CharLiteralPrinterParser = $2e6f1e48aadbcba7$var$CharLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.NumberPrinterParser = $2e6f1e48aadbcba7$var$NumberPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.ReducedPrinterParser = $2e6f1e48aadbcba7$var$ReducedPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.FractionPrinterParser = $2e6f1e48aadbcba7$var$FractionPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.OffsetIdPrinterParser = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.ZoneIdPrinterParser = $2e6f1e48aadbcba7$var$ZoneIdPrinterParser;
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringBuilder = function() {
    function StringBuilder() {
        this._str = '';
    }
    var _proto = StringBuilder.prototype;
    _proto.append = function append(str) {
        this._str += str;
        return this;
    };
    _proto.appendChar = function appendChar(str) {
        this._str += str[0];
        return this;
    };
    _proto.insert = function insert(offset, str) {
        this._str = this._str.slice(0, offset) + str + this._str.slice(offset);
        return this;
    };
    _proto.replace = function replace(start, end, str) {
        this._str = this._str.slice(0, start) + str + this._str.slice(end);
        return this;
    };
    _proto.length = function length() {
        return this._str.length;
    };
    _proto.setLength = function setLength(length) {
        this._str = this._str.slice(0, length);
        return this;
    };
    _proto.toString = function toString() {
        return this._str;
    };
    return StringBuilder;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c = function() {
    DateTimeFormatter.parsedExcessDays = function parsedExcessDays() {
        return DateTimeFormatter.PARSED_EXCESS_DAYS;
    };
    DateTimeFormatter.parsedLeapSecond = function parsedLeapSecond() {
        return DateTimeFormatter.PARSED_LEAP_SECOND;
    };
    DateTimeFormatter.ofPattern = function ofPattern(pattern) {
        return new $2e6f1e48aadbcba7$export$81529fd372517959().appendPattern(pattern).toFormatter();
    };
    function DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
        if (chrono === void 0) chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        $2e6f1e48aadbcba7$var$assert(printerParser != null);
        $2e6f1e48aadbcba7$var$assert(decimalStyle != null);
        $2e6f1e48aadbcba7$var$assert(resolverStyle != null);
        this._printerParser = printerParser;
        this._locale = locale;
        this._decimalStyle = decimalStyle;
        this._resolverStyle = resolverStyle;
        this._resolverFields = resolverFields;
        this._chrono = chrono;
        this._zone = zone;
    }
    var _proto = DateTimeFormatter.prototype;
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.decimalStyle = function decimalStyle() {
        return this._decimalStyle;
    };
    _proto.chronology = function chronology() {
        return this._chrono;
    };
    _proto.withChronology = function withChronology(chrono) {
        if (this._chrono != null && this._chrono.equals(chrono)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, this._resolverStyle, this._resolverFields, chrono, this._zone);
    };
    _proto.withLocale = function withLocale() {
        return this;
    };
    _proto.withResolverStyle = function withResolverStyle(resolverStyle) {
        $2e6f1e48aadbcba7$var$requireNonNull(resolverStyle, 'resolverStyle');
        if (resolverStyle.equals(this._resolverStyle)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, resolverStyle, this._resolverFields, this._chrono, this._zone);
    };
    _proto.format = function format(temporal) {
        var buf = new $2e6f1e48aadbcba7$var$StringBuilder(32);
        this._formatTo(temporal, buf);
        return buf.toString();
    };
    _proto._formatTo = function _formatTo(temporal, appendable) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        $2e6f1e48aadbcba7$var$requireNonNull(appendable, 'appendable');
        var context = new $2e6f1e48aadbcba7$var$DateTimePrintContext(temporal, this);
        this._printerParser.print(context, appendable);
    };
    _proto.parse = function parse(text, type) {
        if (arguments.length === 1) return this.parse1(text);
        else return this.parse2(text, type);
    };
    _proto.parse1 = function parse1(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        try {
            return this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto.parse2 = function parse2(text, type) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        $2e6f1e48aadbcba7$var$requireNonNull(type, 'type');
        try {
            var builder = this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
            return builder.build(type);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto._createError = function _createError(text, ex) {
        var abbr = '';
        if (text.length > 64) abbr = text.substring(0, 64) + "...";
        else abbr = text;
        return new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed: " + ex.message, text, 0, ex);
    };
    _proto._parseToBuilder = function _parseToBuilder(text, position) {
        var pos = position != null ? position : new $2e6f1e48aadbcba7$export$56251aea61478734(0);
        var result = this._parseUnresolved0(text, pos);
        if (result == null || pos.getErrorIndex() >= 0 || position == null && pos.getIndex() < text.length) {
            var abbr = '';
            if (text.length > 64) abbr = text.substr(0, 64).toString() + "...";
            else abbr = text;
            if (pos.getErrorIndex() >= 0) throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed at index " + pos.getErrorIndex(), text, pos.getErrorIndex());
            else throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed, unparsed text found at index " + pos.getIndex(), text, pos.getIndex());
        }
        return result.toBuilder();
    };
    _proto.parseUnresolved = function parseUnresolved(text, position) {
        return this._parseUnresolved0(text, position);
    };
    _proto._parseUnresolved0 = function _parseUnresolved0(text, position) {
        $2e6f1e48aadbcba7$var$assert(text != null, 'text', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        $2e6f1e48aadbcba7$var$assert(position != null, 'position', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        var context = new $2e6f1e48aadbcba7$var$DateTimeParseContext(this);
        var pos = position.getIndex();
        pos = this._printerParser.parse(context, text, pos);
        if (pos < 0) {
            position.setErrorIndex(~pos);
            return null;
        }
        position.setIndex(pos);
        return context.toParsed();
    };
    _proto._toPrinterParser = function _toPrinterParser(optional) {
        return this._printerParser.withOptional(optional);
    };
    _proto.toString = function toString() {
        var pattern = this._printerParser.toString();
        return pattern.indexOf('[') === 0 ? pattern : pattern.substring(1, pattern.length - 1);
    };
    return DateTimeFormatter;
}();
function $2e6f1e48aadbcba7$var$_init$d() {
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(':').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).optionalStart().appendLiteral(':').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).optionalStart().appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, 0, 9, true).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral('T').append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().appendInstant().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME).optionalStart().appendLiteral('[').parseCaseSensitive().appendZoneId().appendLiteral(']').toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.BASIC_ISO_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ORDINAL_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_WEEK_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral('-W').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).optionalStart().appendOffsetId().optionalEnd().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).optionalStart().appendOffsetId().optionalEnd().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME).optionalStart().appendOffsetId().optionalEnd().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.PARSED_EXCESS_DAYS = $2e6f1e48aadbcba7$var$createTemporalQuery('PARSED_EXCESS_DAYS', function(temporal) {
        if (temporal instanceof $2e6f1e48aadbcba7$var$DateTimeBuilder) return temporal.excessDays;
        else return $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ZERO;
    });
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.PARSED_LEAP_SECOND = $2e6f1e48aadbcba7$var$createTemporalQuery('PARSED_LEAP_SECOND', function(temporal) {
        if (temporal instanceof $2e6f1e48aadbcba7$var$DateTimeBuilder) return temporal.leapSecond;
        else return false;
    });
}
var $2e6f1e48aadbcba7$export$30964d9b15071608 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(MonthDay, _TemporalAccessor);
    MonthDay.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return MonthDay.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return MonthDay.nowZoneId(zoneIdOrClock);
        else return MonthDay.nowClock(zoneIdOrClock);
    };
    MonthDay.now0 = function now0() {
        return this.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    MonthDay.nowZoneId = function nowZoneId(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        return this.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    MonthDay.nowClock = function nowClock(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, 'clock');
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return MonthDay.of(now.month(), now.dayOfMonth());
    };
    MonthDay.of = function of(monthOrNumber, number) {
        if (arguments.length === 2 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return MonthDay.ofMonthNumber(monthOrNumber, number);
        else return MonthDay.ofNumberNumber(monthOrNumber, number);
    };
    MonthDay.ofMonthNumber = function ofMonthNumber(month, dayOfMonth) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > month.maxLength()) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Illegal value for DayOfMonth field, value " + dayOfMonth + " is not valid for month " + month.toString());
        return new MonthDay(month.value(), dayOfMonth);
    };
    MonthDay.ofNumberNumber = function ofNumberNumber(month, dayOfMonth) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfMonth, 'dayOfMonth');
        return MonthDay.of($2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(month), dayOfMonth);
    };
    MonthDay.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$e5100310ee9cc158, 'temporal');
        if (temporal instanceof MonthDay) return temporal;
        try {
            return MonthDay.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR), temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain MonthDay from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    MonthDay.parse = function parse(text, formatter) {
        if (arguments.length === 1) return MonthDay.parseString(text);
        else return MonthDay.parseStringFormatter(text, formatter);
    };
    MonthDay.parseString = function parseString(text) {
        return MonthDay.parseStringFormatter(text, $2e6f1e48aadbcba7$var$PARSER$2);
    };
    MonthDay.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return formatter.parse(text, MonthDay.FROM);
    };
    function MonthDay(month, dayOfMonth) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        _this._day = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(dayOfMonth);
        return _this;
    }
    var _proto = MonthDay.prototype;
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return field.range();
        else if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.month().minLength(), this.month().maxLength());
        return _TemporalAccessor.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this._day;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isValidYear = function isValidYear(year) {
        return (this._day === 29 && this._month === 2 && $2e6f1e48aadbcba7$export$6ce2f08d515512.isLeap(year) === false) === false;
    };
    _proto.withMonth = function withMonth(month) {
        return this.with($2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(month));
    };
    _proto.with = function _with(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        if (month.value() === this._month) return this;
        var day = Math.min(this._day, month.maxLength());
        return new MonthDay(month.value(), day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (dayOfMonth === this._day) return this;
        return MonthDay.of(this._month, dayOfMonth);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        temporal = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, this._month);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, Math.min(temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum(), this._day));
    };
    _proto.atYear = function atYear(year) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(year, this._month, this.isValidYear(year) ? this._day : 28);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, 'other');
        var cmp = this._month - other.monthValue();
        if (cmp === 0) cmp = this._day - other.dayOfMonth();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, 'other');
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, 'other');
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof MonthDay) {
            var other = obj;
            return this.monthValue() === other.monthValue() && this.dayOfMonth() === other.dayOfMonth();
        }
        return false;
    };
    _proto.toString = function toString() {
        return "--" + (this._month < 10 ? '0' : '') + this._month + (this._day < 10 ? '-0' : '-') + this._day;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return formatter.format(this);
    };
    return MonthDay;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$PARSER$2;
function $2e6f1e48aadbcba7$var$_init$c() {
    $2e6f1e48aadbcba7$var$PARSER$2 = new $2e6f1e48aadbcba7$export$81529fd372517959().appendLiteral('--').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter();
    $2e6f1e48aadbcba7$export$30964d9b15071608.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('MonthDay.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$30964d9b15071608.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$b707805e12671f51 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(YearMonth, _Temporal);
    YearMonth.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return YearMonth.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return YearMonth.nowZoneId(zoneIdOrClock);
        else return YearMonth.nowClock(zoneIdOrClock);
    };
    YearMonth.now0 = function now0() {
        return YearMonth.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    YearMonth.nowZoneId = function nowZoneId(zone) {
        return YearMonth.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    YearMonth.nowClock = function nowClock(clock) {
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return YearMonth.of(now.year(), now.month());
    };
    YearMonth.of = function of(year, monthOrNumber) {
        if (arguments.length === 2 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return YearMonth.ofNumberMonth(year, monthOrNumber);
        else return YearMonth.ofNumberNumber(year, monthOrNumber);
    };
    YearMonth.ofNumberMonth = function ofNumberMonth(year, month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$var$requireInstance(month, $2e6f1e48aadbcba7$export$951c8378cdfec6e6, 'month');
        return YearMonth.ofNumberNumber(year, month.value());
    };
    YearMonth.ofNumberNumber = function ofNumberNumber(year, month) {
        $2e6f1e48aadbcba7$var$requireNonNull(year, 'year');
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return new YearMonth(year, month);
    };
    YearMonth.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (temporal instanceof YearMonth) return temporal;
        try {
            return YearMonth.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR), temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain YearMonth from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    YearMonth.parse = function parse(text, formatter) {
        if (arguments.length === 1) return YearMonth.parseString(text);
        else return YearMonth.parseStringFormatter(text, formatter);
    };
    YearMonth.parseString = function parseString(text) {
        return YearMonth.parseStringFormatter(text, $2e6f1e48aadbcba7$var$PARSER$1);
    };
    YearMonth.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, YearMonth.FROM);
    };
    function YearMonth(year, month) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(year);
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        return _this;
    }
    var _proto = YearMonth.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA) return this.year() <= 0 ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE + 1) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, 'field');
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this._getProlepticMonth();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto._getProlepticMonth = function _getProlepticMonth() {
        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._year, 12), this._month - 1);
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.isValidDay = function isValidDay(dayOfMonth) {
        return dayOfMonth >= 1 && dayOfMonth <= this.lengthOfMonth();
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        return this.month().length(this.isLeapYear());
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto.with = function _with(adjusterOrField, value) {
        if (arguments.length === 1) return this._withAdjuster(adjusterOrField);
        else return this._withField(adjusterOrField, value);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year < 1 ? 1 - newValue : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return new YearMonth(year, this._month);
    };
    _proto.withMonth = function withMonth(month) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return new YearMonth(this._year, month);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, 'unit');
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return this.withYear(newYear);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $2e6f1e48aadbcba7$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return new YearMonth(newYear, newMonth);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return monthsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusMonths(Math.MAX_SAFE_INTEGER).plusMonths(1) : this.plusMonths(-monthsToSubtract);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$336849d529cb05e5, 'temporal');
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH, this._getProlepticMonth());
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        $2e6f1e48aadbcba7$var$requireInstance(endExclusive, $2e6f1e48aadbcba7$export$336849d529cb05e5, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, 'unit');
        var end = YearMonth.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var monthsUntil = end._getProlepticMonth() - this._getProlepticMonth();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return monthsUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(monthsUntil, 12);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(monthsUntil, 120);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(monthsUntil, 1200);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(monthsUntil, 12000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDay = function atDay(dayOfMonth) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfMonth, 'dayOfMonth');
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(this._year, this._month, dayOfMonth);
    };
    _proto.atEndOfMonth = function atEndOfMonth() {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(this._year, this._month, this.lengthOfMonth());
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, YearMonth, 'other');
        var cmp = this._year - other.year();
        if (cmp === 0) cmp = this._month - other.monthValue();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof YearMonth) {
            var other = obj;
            return this.year() === other.year() && this.monthValue() === other.monthValue();
        }
        return false;
    };
    _proto.toString = function toString() {
        return $2e6f1e48aadbcba7$var$PARSER$1.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this);
    };
    return YearMonth;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$var$PARSER$1;
function $2e6f1e48aadbcba7$var$_init$b() {
    $2e6f1e48aadbcba7$var$PARSER$1 = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral('-').appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).toFormatter();
    $2e6f1e48aadbcba7$export$b707805e12671f51.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('YearMonth.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$b707805e12671f51.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$6ce2f08d515512 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Year, _Temporal);
    function Year(value) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(value);
        return _this;
    }
    var _proto = Year.prototype;
    _proto.value = function value() {
        return this._year;
    };
    Year.now = function now(zoneIdOrClock) {
        if (zoneIdOrClock === void 0) zoneIdOrClock = undefined;
        if (zoneIdOrClock === undefined) return Year.now0();
        else if (zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return Year.nowZoneId(zoneIdOrClock);
        else return Year.nowClock(zoneIdOrClock);
    };
    Year.now0 = function now0() {
        return Year.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    Year.nowZoneId = function nowZoneId(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        $2e6f1e48aadbcba7$var$requireInstance(zone, $2e6f1e48aadbcba7$export$a514a0be1f00ef62, 'zone');
        return Year.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    Year.nowClock = function nowClock(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, 'clock');
        $2e6f1e48aadbcba7$var$requireInstance(clock, $2e6f1e48aadbcba7$export$9735c82c4bae3302, 'clock');
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return Year.of(now.year());
    };
    Year.of = function of(isoYear) {
        $2e6f1e48aadbcba7$var$requireNonNull(isoYear, 'isoYear');
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(isoYear);
        return new Year(isoYear);
    };
    Year.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$e5100310ee9cc158, 'temporal');
        if (temporal instanceof Year) return temporal;
        try {
            return Year.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Year from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    Year.parse = function parse(text, formatter) {
        if (arguments.length <= 1) return Year.parseText(text);
        else return Year.parseTextFormatter(text, formatter);
    };
    Year.parseText = function parseText(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        return Year.parse(text, $2e6f1e48aadbcba7$var$PARSER);
    };
    Year.parseTextFormatter = function parseTextFormatter(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$var$PARSER;
        $2e6f1e48aadbcba7$var$requireNonNull(text, 'text');
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return formatter.parse(text, Year.FROM);
    };
    Year.isLeap = function isLeap(year) {
        return $2e6f1e48aadbcba7$var$MathUtil.intMod(year, 4) === 0 && ($2e6f1e48aadbcba7$var$MathUtil.intMod(year, 100) !== 0 || $2e6f1e48aadbcba7$var$MathUtil.intMod(year, 400) === 0);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (this.isSupported(field)) return field.range();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isLeap = function isLeap() {
        return Year.isLeap(this._year);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return Year.of(this._year < 1 ? 1 - newValue : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return Year.of(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : Year.of(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, 'amountToAdd');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, 'unit');
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Year.of($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._year, yearsToAdd)));
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, this._year);
    };
    _proto.isValidMonthDay = function isValidMonthDay(monthDay) {
        return monthDay != null && monthDay.isValidYear(this._year);
    };
    _proto.length = function length() {
        return this.isLeap() ? 366 : 365;
    };
    _proto.atDay = function atDay(dayOfYear) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(this._year, dayOfYear);
    };
    _proto.atMonth = function atMonth(monthOrNumber) {
        if (arguments.length === 1 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return this.atMonthMonth(monthOrNumber);
        else return this.atMonthNumber(monthOrNumber);
    };
    _proto.atMonthMonth = function atMonthMonth(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$var$requireInstance(month, $2e6f1e48aadbcba7$export$951c8378cdfec6e6, 'month');
        return $2e6f1e48aadbcba7$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthNumber = function atMonthNumber(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        return $2e6f1e48aadbcba7$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthDay = function atMonthDay(monthDay) {
        $2e6f1e48aadbcba7$var$requireNonNull(monthDay, 'monthDay');
        $2e6f1e48aadbcba7$var$requireInstance(monthDay, $2e6f1e48aadbcba7$export$30964d9b15071608, 'monthDay');
        return monthDay.atYear(this._year);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query()');
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, 'query()');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, 'other');
        return this._year - other._year;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, 'other');
        return this._year > other._year;
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, 'other');
        return this._year < other._year;
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return formatter.format(this);
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Year) return this.value() === other.value();
        return false;
    };
    _proto.toString = function toString() {
        return "" + this._year;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.until = function until(endExclusive, unit) {
        var end = Year.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var yearsUntil = end.value() - this.value();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return yearsUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 10);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 100);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    return Year;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$var$PARSER;
function $2e6f1e48aadbcba7$var$_init$a() {
    $2e6f1e48aadbcba7$export$6ce2f08d515512.MIN_VALUE = $2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE;
    $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE = $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE;
    $2e6f1e48aadbcba7$var$PARSER = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).toFormatter();
    $2e6f1e48aadbcba7$export$6ce2f08d515512.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('Year.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$6ce2f08d515512.from(temporal);
    });
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$841f8bd48996924f = function() {
    function TemporalAdjuster() {}
    var _proto = TemporalAdjuster.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail('adjustInto');
    };
    return TemporalAdjuster;
}();
var $2e6f1e48aadbcba7$export$d922854d56f8a965 = function() {
    function TemporalAdjusters() {}
    TemporalAdjusters.firstDayOfMonth = function firstDayOfMonth() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_MONTH;
    };
    TemporalAdjusters.lastDayOfMonth = function lastDayOfMonth() {
        return $2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_MONTH;
    };
    TemporalAdjusters.firstDayOfNextMonth = function firstDayOfNextMonth() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_MONTH;
    };
    TemporalAdjusters.firstDayOfYear = function firstDayOfYear() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_YEAR;
    };
    TemporalAdjusters.lastDayOfYear = function lastDayOfYear() {
        return $2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_YEAR;
    };
    TemporalAdjusters.firstDayOfNextYear = function firstDayOfNextYear() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_YEAR;
    };
    TemporalAdjusters.firstInMonth = function firstInMonth(dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, 'dayOfWeek');
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(1, dayOfWeek);
    };
    TemporalAdjusters.lastInMonth = function lastInMonth(dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, 'dayOfWeek');
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(-1, dayOfWeek);
    };
    TemporalAdjusters.dayOfWeekInMonth = function dayOfWeekInMonth(ordinal, dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, 'dayOfWeek');
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(ordinal, dayOfWeek);
    };
    TemporalAdjusters.next = function next(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(2, dayOfWeek);
    };
    TemporalAdjusters.nextOrSame = function nextOrSame(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(0, dayOfWeek);
    };
    TemporalAdjusters.previous = function previous(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(3, dayOfWeek);
    };
    TemporalAdjusters.previousOrSame = function previousOrSame(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(1, dayOfWeek);
    };
    return TemporalAdjusters;
}();
var $2e6f1e48aadbcba7$var$Impl = function(_TemporalAdjuster) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Impl, _TemporalAdjuster);
    function Impl(ordinal) {
        var _this;
        _this = _TemporalAdjuster.call(this) || this;
        _this._ordinal = ordinal;
        return _this;
    }
    var _proto = Impl.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        switch(this._ordinal){
            case 0:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            case 1:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            case 2:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1).plus(1, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            case 3:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, 1);
            case 4:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR).maximum());
            case 5:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, 1).plus(1, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        }
        throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e('Unreachable');
    };
    return Impl;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_MONTH = new $2e6f1e48aadbcba7$var$Impl(0);
$2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_MONTH = new $2e6f1e48aadbcba7$var$Impl(1);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_MONTH = new $2e6f1e48aadbcba7$var$Impl(2);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_YEAR = new $2e6f1e48aadbcba7$var$Impl(3);
$2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_YEAR = new $2e6f1e48aadbcba7$var$Impl(4);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_YEAR = new $2e6f1e48aadbcba7$var$Impl(5);
var $2e6f1e48aadbcba7$var$DayOfWeekInMonth = function(_TemporalAdjuster2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DayOfWeekInMonth, _TemporalAdjuster2);
    function DayOfWeekInMonth(ordinal, dow) {
        var _this2;
        _this2 = _TemporalAdjuster2.call(this) || this;
        _this2._ordinal = ordinal;
        _this2._dowValue = dow.value();
        return _this2;
    }
    var _proto2 = DayOfWeekInMonth.prototype;
    _proto2.adjustInto = function adjustInto(temporal) {
        if (this._ordinal >= 0) {
            var temp = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            var curDow = temp.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
            var dowDiff = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._dowValue - curDow + 7, 7);
            dowDiff += (this._ordinal - 1) * 7;
            return temp.plus(dowDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        } else {
            var _temp = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            var _curDow = _temp.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
            var daysDiff = this._dowValue - _curDow;
            daysDiff = daysDiff === 0 ? 0 : daysDiff > 0 ? daysDiff - 7 : daysDiff;
            daysDiff -= (-this._ordinal - 1) * 7;
            return _temp.plus(daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        }
    };
    return DayOfWeekInMonth;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
var $2e6f1e48aadbcba7$var$RelativeDayOfWeek = function(_TemporalAdjuster3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(RelativeDayOfWeek, _TemporalAdjuster3);
    function RelativeDayOfWeek(relative, dayOfWeek) {
        var _this3;
        _this3 = _TemporalAdjuster3.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, 'dayOfWeek');
        _this3._relative = relative;
        _this3._dowValue = dayOfWeek.value();
        return _this3;
    }
    var _proto3 = RelativeDayOfWeek.prototype;
    _proto3.adjustInto = function adjustInto(temporal) {
        var calDow = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (this._relative < 2 && calDow === this._dowValue) return temporal;
        if ((this._relative & 1) === 0) {
            var daysDiff = calDow - this._dowValue;
            return temporal.plus(daysDiff >= 0 ? 7 - daysDiff : -daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        } else {
            var _daysDiff = this._dowValue - calDow;
            return temporal.minus(_daysDiff >= 0 ? 7 - _daysDiff : -_daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        }
    };
    return RelativeDayOfWeek;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
var $2e6f1e48aadbcba7$export$f47ae290cf4e4958 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(IsoChronology, _Enum);
    function IsoChronology() {
        return _Enum.apply(this, arguments) || this;
    }
    IsoChronology.isLeapYear = function isLeapYear(prolepticYear) {
        return (prolepticYear & 3) === 0 && (prolepticYear % 100 !== 0 || prolepticYear % 400 === 0);
    };
    var _proto = IsoChronology.prototype;
    _proto._updateResolveMap = function _updateResolveMap(fieldValues, field, value) {
        $2e6f1e48aadbcba7$var$requireNonNull(fieldValues, 'fieldValues');
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        var current = fieldValues.get(field);
        if (current != null && current !== value) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid state, field: " + field + " " + current + " conflicts with " + field + " " + value);
        fieldValues.put(field, value);
    };
    _proto.resolveDate = function resolveDate(fieldValues, resolverStyle) {
        if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY)) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY));
        var prolepticMonth = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH);
        if (prolepticMonth != null) {
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH.checkValidValue(prolepticMonth);
            this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, $2e6f1e48aadbcba7$var$MathUtil.floorMod(prolepticMonth, 12) + 1);
            this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, $2e6f1e48aadbcba7$var$MathUtil.floorDiv(prolepticMonth, 12));
        }
        var yoeLong = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA);
        if (yoeLong != null) {
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA.checkValidValue(yoeLong);
            var era = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            if (era == null) {
                var year = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                    if (year != null) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, year > 0 ? yoeLong : $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
                    else fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA, yoeLong);
                } else this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, year == null || year > 0 ? yoeLong : $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
            } else if (era === 1) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, yoeLong);
            else if (era === 0) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
            else throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid value for era: " + era);
        } else if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA.checkValidValue(fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA));
        if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR)) {
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR)) {
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH)) {
                    var y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    var moy = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
                    var dom = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH);
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var months = moy - 1;
                        var days = dom - 1;
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, 1, 1).plusMonths(months).plusDays(days);
                    } else if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART) {
                        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dom);
                        if (moy === 4 || moy === 6 || moy === 9 || moy === 11) dom = Math.min(dom, 30);
                        else if (moy === 2) dom = Math.min(dom, $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY.length($2e6f1e48aadbcba7$export$6ce2f08d515512.isLeap(y)));
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, moy, dom);
                    } else return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, moy, dom);
                }
            }
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR)) {
                var _y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                    var _days = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR), 1);
                    return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(_y, 1).plusDays(_days);
                }
                var doy = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR));
                return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(_y, doy);
            }
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR)) {
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR)) {
                    var _y2 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var weeks = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days2 = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR), 1);
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusWeeks(weeks).plusDays(_days2);
                    }
                    var aw = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var ad = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                    var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusDays((aw - 1) * 7 + (ad - 1));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT && date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) !== _y2) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Strict mode rejected date parsed to a different year');
                    return date;
                }
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK)) {
                    var _y3 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var _weeks = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days3 = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK), 1);
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_weeks).plusDays(_days3);
                    }
                    var _aw = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var dow = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK));
                    var _date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_aw - 1).with($2e6f1e48aadbcba7$export$d922854d56f8a965.nextOrSame($2e6f1e48aadbcba7$export$7ed5ca4f8b987938.of(dow)));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT && _date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) !== _y3) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Strict mode rejected date parsed to a different month');
                    return _date;
                }
            }
        }
        return null;
    };
    _proto.date = function date(temporal) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
    };
    return IsoChronology;
}($2e6f1e48aadbcba7$var$Enum);
function $2e6f1e48aadbcba7$var$_init$9() {
    $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE = new $2e6f1e48aadbcba7$export$f47ae290cf4e4958('IsoChronology');
}
var $2e6f1e48aadbcba7$export$a362394fcc906a80 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetTime, _Temporal);
    OffsetTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (temporal instanceof OffsetTime) return temporal;
        else if (temporal instanceof $2e6f1e48aadbcba7$export$f351e12f7a164fb5) return temporal.toOffsetTime();
        try {
            var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from(temporal);
            return new OffsetTime(time, offset);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain OffsetTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    OffsetTime.now = function now(clockOrZone) {
        if (arguments.length === 0) return OffsetTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return OffsetTime._now(clockOrZone);
        else return OffsetTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    OffsetTime._now = function _now(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, 'clock');
        var now = clock.instant();
        return OffsetTime.ofInstant(now, clock.zone().rules().offset(now));
    };
    OffsetTime.of = function of() {
        if (arguments.length <= 2) return OffsetTime.ofTimeAndOffset.apply(this, arguments);
        else return OffsetTime.ofNumbers.apply(this, arguments);
    };
    OffsetTime.ofNumbers = function ofNumbers(hour, minute, second, nanoOfSecond, offset) {
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond);
        return new OffsetTime(time, offset);
    };
    OffsetTime.ofTimeAndOffset = function ofTimeAndOffset(time, offset) {
        return new OffsetTime(time, offset);
    };
    OffsetTime.ofInstant = function ofInstant(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, 'instant');
        $2e6f1e48aadbcba7$var$requireInstance(instant, $2e6f1e48aadbcba7$export$fecec53969739358, 'instant');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        $2e6f1e48aadbcba7$var$requireInstance(zone, $2e6f1e48aadbcba7$export$a514a0be1f00ef62, 'zone');
        var rules = zone.rules();
        var offset = rules.offset(instant);
        var secsOfDay = instant.epochSecond() % $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        secsOfDay = (secsOfDay + offset.totalSeconds()) % $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        if (secsOfDay < 0) secsOfDay += $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, instant.nano());
        return new OffsetTime(time, offset);
    };
    OffsetTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, OffsetTime.FROM);
    };
    function OffsetTime(time, offset) {
        var _this;
        _this = _Temporal.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(time, 'time');
        $2e6f1e48aadbcba7$var$requireInstance(time, $2e6f1e48aadbcba7$export$bf1071e344bea1d, 'time');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, 'offset');
        _this._time = time;
        _this._offset = offset;
        return _this;
    }
    var _proto = OffsetTime.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this._time.toNanoOfDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this.offset().totalSeconds());
    };
    _proto.atDate = function atDate(date) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(date, this._time, this._offset);
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this, OffsetTime.FROM);
    };
    _proto.get = function get(field) {
        return _Temporal.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._offset.totalSeconds();
            return this._time.getLong(field);
        }
        return field.getFrom(this);
    };
    _proto.hour = function hour() {
        return this._time.hour();
    };
    _proto.minute = function minute() {
        return this._time.minute();
    };
    _proto.second = function second() {
        return this._time.second();
    };
    _proto.nano = function nano() {
        return this._time.nano();
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return this._toEpochNano() > other._toEpochNano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return this._toEpochNano() < other._toEpochNano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return this._toEpochNano() === other._toEpochNano();
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isTimeBased() || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS;
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._withLocalTimeOffset(this._time.minusHours(hours), this._offset);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._withLocalTimeOffset(this._time.minusMinutes(minutes), this._offset);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._withLocalTimeOffset(this._time.minusSeconds(seconds), this._offset);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._withLocalTimeOffset(this._time.minusNanos(nanos), this._offset);
    };
    _proto._minusAmount = function _minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.subtractFrom(this);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        return this.plus(-1 * amountToSubtract, unit);
    };
    _proto._plusAmount = function _plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.addTo(this);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return this._withLocalTimeOffset(this._time.plus(amountToAdd, unit), this._offset);
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._withLocalTimeOffset(this._time.plusHours(hours), this._offset);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._withLocalTimeOffset(this._time.plusMinutes(minutes), this._offset);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._withLocalTimeOffset(this._time.plusSeconds(seconds), this._offset);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._withLocalTimeOffset(this._time.plusNanos(nanos), this._offset);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this._time;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._time.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._time;
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withLocalTimeOffset(this._time.truncatedTo(unit), this._offset);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        var end = OffsetTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var nanosUntil = end._toEpochNano() - this._toEpochNano();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return nanosUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 12 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.withHour = function withHour(hour) {
        return this._withLocalTimeOffset(this._time.withHour(hour), this._offset);
    };
    _proto.withMinute = function withMinute(minute) {
        return this._withLocalTimeOffset(this._time.withMinute(minute), this._offset);
    };
    _proto.withSecond = function withSecond(second) {
        return this._withLocalTimeOffset(this._time.withSecond(second), this._offset);
    };
    _proto.withNano = function withNano(nano) {
        return this._withLocalTimeOffset(this._time.withNano(nano), this._offset);
    };
    _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        if (offset.equals(this._offset)) return this;
        var difference = offset.totalSeconds() - this._offset.totalSeconds();
        var adjusted = this._time.plusSeconds(difference);
        return new OffsetTime(adjusted, offset);
    };
    _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
        return offset != null && offset.equals(this._offset) ? this : new OffsetTime(this._time, offset);
    };
    _proto._toEpochNano = function _toEpochNano() {
        var nod = this._time.toNanoOfDay();
        var offsetNanos = this._offset.totalSeconds() * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
        return nod - offsetNanos;
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, 'adjuster');
        if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._withLocalTimeOffset(adjuster, this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._withLocalTimeOffset(this._time, adjuster);
        else if (adjuster instanceof OffsetTime) return adjuster;
        return adjuster.adjustInto(this);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._withLocalTimeOffset(this._time, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(field.checkValidIntValue(newValue)));
            return this._withLocalTimeOffset(this._time.with(field, newValue), this._offset);
        }
        return field.adjustInto(this, newValue);
    };
    _proto._withLocalTimeOffset = function _withLocalTimeOffset(time, offset) {
        if (this._time === time && this._offset.equals(offset)) return this;
        return new OffsetTime(time, offset);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, OffsetTime, 'other');
        if (this._offset.equals(other._offset)) return this._time.compareTo(other._time);
        var compare = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._toEpochNano(), other._toEpochNano());
        if (compare === 0) return this._time.compareTo(other._time);
        return compare;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof OffsetTime) return this._time.equals(other._time) && this._offset.equals(other._offset);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._time.hashCode() ^ this._offset.hashCode();
    };
    _proto.toString = function toString() {
        return this._time.toString() + this._offset.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return OffsetTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$8() {
    $2e6f1e48aadbcba7$export$a362394fcc906a80.MIN = $2e6f1e48aadbcba7$export$a362394fcc906a80.ofNumbers(0, 0, 0, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX);
    $2e6f1e48aadbcba7$export$a362394fcc906a80.MAX = $2e6f1e48aadbcba7$export$a362394fcc906a80.ofNumbers(23, 59, 59, 999999999, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN);
    $2e6f1e48aadbcba7$export$a362394fcc906a80.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('OffsetTime.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$a362394fcc906a80.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$e69f60c5a83f5572 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoZonedDateTime, _Temporal);
    function ChronoZonedDateTime() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoZonedDateTime.prototype;
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.zone();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.toLocalDate().chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this);
    };
    _proto.toInstant = function toInstant() {
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond() {
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= this.offset().totalSeconds();
        return secs;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
        if (cmp === 0) {
            cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
            if (cmp === 0) {
                cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
                if (cmp === 0) cmp = $2e6f1e48aadbcba7$var$strcmp(this.zone().id(), other.zone().id());
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ChronoZonedDateTime) return this.compareTo(other) === 0;
        return false;
    };
    return ChronoZonedDateTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
var $2e6f1e48aadbcba7$export$d3b7288e7994edea = function(_ChronoZonedDateTime) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZonedDateTime, _ChronoZonedDateTime);
    ZonedDateTime.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone == null ? $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone() : clockOrZone;
        return ZonedDateTime.ofInstant(clock.instant(), clock.zone());
    };
    ZonedDateTime.of = function of() {
        if (arguments.length <= 2) return ZonedDateTime.of2.apply(this, arguments);
        else if (arguments.length === 3 && arguments[0] instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return ZonedDateTime.of3.apply(this, arguments);
        else return ZonedDateTime.of8.apply(this, arguments);
    };
    ZonedDateTime.of3 = function of3(date, time, zone) {
        return ZonedDateTime.of2($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, time), zone);
    };
    ZonedDateTime.of2 = function of2(localDateTime, zone) {
        return ZonedDateTime.ofLocal(localDateTime, zone, null);
    };
    ZonedDateTime.of8 = function of8(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, zone) {
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
        return ZonedDateTime.ofLocal(dt, zone, null);
    };
    ZonedDateTime.ofLocal = function ofLocal(localDateTime, zone, preferredOffset) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, 'localDateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return new ZonedDateTime(localDateTime, zone, zone);
        var offset = null;
        var rules = zone.rules();
        var validOffsets = rules.validOffsets(localDateTime);
        if (validOffsets.length === 1) offset = validOffsets[0];
        else if (validOffsets.length === 0) {
            var trans = rules.transition(localDateTime);
            localDateTime = localDateTime.plusSeconds(trans.duration().seconds());
            offset = trans.offsetAfter();
        } else if (preferredOffset != null && validOffsets.some(function(validOffset) {
            return validOffset.equals(preferredOffset);
        })) offset = preferredOffset;
        else offset = $2e6f1e48aadbcba7$var$requireNonNull(validOffsets[0], 'offset');
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofInstant = function ofInstant() {
        if (arguments.length === 2) return ZonedDateTime.ofInstant2.apply(this, arguments);
        else return ZonedDateTime.ofInstant3.apply(this, arguments);
    };
    ZonedDateTime.ofInstant2 = function ofInstant2(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, 'instant');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        return ZonedDateTime._create(instant.epochSecond(), instant.nano(), zone);
    };
    ZonedDateTime.ofInstant3 = function ofInstant3(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, 'localDateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        return ZonedDateTime._create(localDateTime.toEpochSecond(offset), localDateTime.nano(), zone);
    };
    ZonedDateTime._create = function _create(epochSecond, nanoOfSecond, zone) {
        var rules = zone.rules();
        var instant = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(epochSecond, nanoOfSecond);
        var offset = rules.offset(instant);
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(epochSecond, nanoOfSecond, offset);
        return new ZonedDateTime(ldt, offset, zone);
    };
    ZonedDateTime.ofStrict = function ofStrict(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, 'localDateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        var rules = zone.rules();
        if (rules.isValidOffset(localDateTime, offset) === false) {
            var trans = rules.transition(localDateTime);
            if (trans != null && trans.isGap()) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("LocalDateTime " + localDateTime + " does not exist in zone " + zone + " due to a gap in the local time-line, typically caused by daylight savings");
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("ZoneOffset \"" + offset + "\" is not valid for LocalDateTime \"" + localDateTime + "\" in zone \"" + zone + "\"");
        }
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofLenient = function ofLenient(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, 'localDateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 && offset.equals(zone) === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('ZoneId must match ZoneOffset');
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (temporal instanceof ZonedDateTime) return temporal;
        var zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.from(temporal);
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS)) {
            var zdt = ZonedDateTime._from(temporal, zone);
            if (zdt != null) return zdt;
        }
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
        return ZonedDateTime.of2(ldt, zone);
    };
    ZonedDateTime._from = function _from(temporal, zone) {
        try {
            return ZonedDateTime.__from(temporal, zone);
        } catch (ex) {
            if (!(ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb)) throw ex;
        }
    };
    ZonedDateTime.__from = function __from(temporal, zone) {
        var epochSecond = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
        var nanoOfSecond = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        return ZonedDateTime._create(epochSecond, nanoOfSecond, zone);
    };
    ZonedDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, ZonedDateTime.FROM);
    };
    function ZonedDateTime(dateTime, offset, zone) {
        var _this;
        $2e6f1e48aadbcba7$var$requireNonNull(dateTime, 'dateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        _this = _ChronoZonedDateTime.call(this) || this;
        _this._dateTime = dateTime;
        _this._offset = offset;
        _this._zone = zone;
        return _this;
    }
    var _proto = ZonedDateTime.prototype;
    _proto._resolveLocal = function _resolveLocal(newDateTime) {
        $2e6f1e48aadbcba7$var$requireNonNull(newDateTime, 'newDateTime');
        return ZonedDateTime.ofLocal(newDateTime, this._zone, this._offset);
    };
    _proto._resolveInstant = function _resolveInstant(newDateTime) {
        return ZonedDateTime.ofInstant3(newDateTime, this._offset, this._zone);
    };
    _proto._resolveOffset = function _resolveOffset(offset) {
        if (offset.equals(this._offset) === false && this._zone.rules().isValidOffset(this._dateTime, offset)) return new ZonedDateTime(this._dateTime, offset, this._zone);
        return this;
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return true;
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._dateTime.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this.toEpochSecond();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this._offset.totalSeconds();
            }
            return this._dateTime.getLong(field);
        }
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        return field.getFrom(this);
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.withEarlierOffsetAtOverlap = function withEarlierOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this._dateTime);
        if (trans != null && trans.isOverlap()) {
            var earlierOffset = trans.offsetBefore();
            if (earlierOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, earlierOffset, this._zone);
        }
        return this;
    };
    _proto.withLaterOffsetAtOverlap = function withLaterOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this.toLocalDateTime());
        if (trans != null) {
            var laterOffset = trans.offsetAfter();
            if (laterOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, laterOffset, this._zone);
        }
        return this;
    };
    _proto.zone = function zone() {
        return this._zone;
    };
    _proto.withZoneSameLocal = function withZoneSameLocal(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        return this._zone.equals(zone) ? this : ZonedDateTime.ofLocal(this._dateTime, zone, this._offset);
    };
    _proto.withZoneSameInstant = function withZoneSameInstant(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        return this._zone.equals(zone) ? this : ZonedDateTime._create(this._dateTime.toEpochSecond(this._offset), this._dateTime.nano(), zone);
    };
    _proto.withFixedOffsetZone = function withFixedOffsetZone() {
        return this._zone.equals(this._offset) ? this : new ZonedDateTime(this._dateTime, this._offset, this._offset);
    };
    _proto.year = function year() {
        return this._dateTime.year();
    };
    _proto.monthValue = function monthValue() {
        return this._dateTime.monthValue();
    };
    _proto.month = function month() {
        return this._dateTime.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._dateTime.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._dateTime.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._dateTime.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._dateTime.hour();
    };
    _proto.minute = function minute() {
        return this._dateTime.minute();
    };
    _proto.second = function second() {
        return this._dateTime.second();
    };
    _proto.nano = function nano() {
        return this._dateTime.nano();
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return this._resolveLocal($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(adjuster, this._dateTime.toLocalTime()));
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._resolveLocal($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this._dateTime.toLocalDate(), adjuster));
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) return this._resolveLocal(adjuster);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$fecec53969739358) {
            var instant = adjuster;
            return ZonedDateTime._create(instant.epochSecond(), instant.nano(), this._zone);
        } else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._resolveOffset(adjuster);
        return _ChronoZonedDateTime.prototype._withAdjuster.call(this, adjuster);
    };
    _proto._withField = function _withField(field, newValue) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return ZonedDateTime._create(newValue, this.nano(), this._zone);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(field.checkValidIntValue(newValue));
                    return this._resolveOffset(offset);
            }
            return this._resolveLocal(this._dateTime.with(field, newValue));
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._resolveLocal(this._dateTime.withYear(year));
    };
    _proto.withMonth = function withMonth(month) {
        return this._resolveLocal(this._dateTime.withMonth(month));
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._resolveLocal(this._dateTime.withDayOfMonth(dayOfMonth));
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._resolveLocal(this._dateTime.withDayOfYear(dayOfYear));
    };
    _proto.withHour = function withHour(hour) {
        return this._resolveLocal(this._dateTime.withHour(hour));
    };
    _proto.withMinute = function withMinute(minute) {
        return this._resolveLocal(this._dateTime.withMinute(minute));
    };
    _proto.withSecond = function withSecond(second) {
        return this._resolveLocal(this._dateTime.withSecond(second));
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        return this._resolveLocal(this._dateTime.withNano(nanoOfSecond));
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._resolveLocal(this._dateTime.truncatedTo(unit));
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            if (unit.isDateBased()) return this._resolveLocal(this._dateTime.plus(amountToAdd, unit));
            else return this._resolveInstant(this._dateTime.plus(amountToAdd, unit));
        }
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        return this._resolveLocal(this._dateTime.plusYears(years));
    };
    _proto.plusMonths = function plusMonths(months) {
        return this._resolveLocal(this._dateTime.plusMonths(months));
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        return this._resolveLocal(this._dateTime.plusWeeks(weeks));
    };
    _proto.plusDays = function plusDays(days) {
        return this._resolveLocal(this._dateTime.plusDays(days));
    };
    _proto.plusHours = function plusHours(hours) {
        return this._resolveInstant(this._dateTime.plusHours(hours));
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._resolveInstant(this._dateTime.plusMinutes(minutes));
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._resolveInstant(this._dateTime.plusSeconds(seconds));
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._resolveInstant(this._dateTime.plusNanos(nanos));
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        return this._plusUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this.plusHours(-1 * hours);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this.plusMinutes(-1 * minutes);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this.plusSeconds(-1 * seconds);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this.plusNanos(-1 * nanos);
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        return _ChronoZonedDateTime.prototype.query.call(this, _query);
    };
    _proto.until = function until(endExclusive, unit) {
        var end = ZonedDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            end = end.withZoneSameInstant(this._zone);
            if (unit.isDateBased()) return this._dateTime.until(end._dateTime, unit);
            else {
                var difference = this._offset.totalSeconds() - end._offset.totalSeconds();
                var adjustedEnd = end._dateTime.plusSeconds(difference);
                return this._dateTime.until(adjustedEnd, unit);
            }
        }
        return unit.between(this, end);
    };
    _proto.toLocalDateTime = function toLocalDateTime() {
        return this._dateTime;
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._dateTime.toLocalDate();
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._dateTime.toLocalTime();
    };
    _proto.toOffsetDateTime = function toOffsetDateTime() {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(this._dateTime, this._offset);
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZonedDateTime) return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset) && this._zone.equals(other._zone);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._dateTime.hashCode(), this._offset.hashCode(), this._zone.hashCode());
    };
    _proto.toString = function toString() {
        var str = this._dateTime.toString() + this._offset.toString();
        if (this._offset !== this._zone) str += "[" + this._zone.toString() + "]";
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        return _ChronoZonedDateTime.prototype.format.call(this, formatter);
    };
    return ZonedDateTime;
}($2e6f1e48aadbcba7$export$e69f60c5a83f5572);
function $2e6f1e48aadbcba7$var$_init$7() {
    $2e6f1e48aadbcba7$export$d3b7288e7994edea.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('ZonedDateTime.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$f351e12f7a164fb5 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetDateTime, _Temporal);
    OffsetDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (temporal instanceof OffsetDateTime) return temporal;
        try {
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from(temporal);
            try {
                var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
                return OffsetDateTime.of(ldt, offset);
            } catch (_) {
                var instant = $2e6f1e48aadbcba7$export$fecec53969739358.from(temporal);
                return OffsetDateTime.ofInstant(instant, offset);
            }
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain OffsetDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    OffsetDateTime.now = function now(clockOrZone) {
        if (arguments.length === 0) return OffsetDateTime.now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else {
            $2e6f1e48aadbcba7$var$requireNonNull(clockOrZone, 'clockOrZone');
            if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return OffsetDateTime.now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
            else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) {
                var now = clockOrZone.instant();
                return OffsetDateTime.ofInstant(now, clockOrZone.zone().rules().offset(now));
            } else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('clockOrZone must be an instance of ZoneId or Clock');
        }
    };
    OffsetDateTime.of = function of() {
        if (arguments.length <= 2) return OffsetDateTime.ofDateTime.apply(this, arguments);
        else if (arguments.length === 3) return OffsetDateTime.ofDateAndTime.apply(this, arguments);
        else return OffsetDateTime.ofNumbers.apply(this, arguments);
    };
    OffsetDateTime.ofDateTime = function ofDateTime(dateTime, offset) {
        return new OffsetDateTime(dateTime, offset);
    };
    OffsetDateTime.ofDateAndTime = function ofDateAndTime(date, time, offset) {
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, time);
        return new OffsetDateTime(dt, offset);
    };
    OffsetDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, offset) {
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
        return new OffsetDateTime(dt, offset);
    };
    OffsetDateTime.ofInstant = function ofInstant(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, 'instant');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        var rules = zone.rules();
        var offset = rules.offset(instant);
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
        return new OffsetDateTime(ldt, offset);
    };
    OffsetDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, OffsetDateTime.FROM);
    };
    function OffsetDateTime(dateTime, offset) {
        var _this;
        _this = _Temporal.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(dateTime, 'dateTime');
        $2e6f1e48aadbcba7$var$requireInstance(dateTime, $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff, 'dateTime');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, 'offset');
        _this._dateTime = dateTime;
        _this._offset = offset;
        return _this;
    }
    var _proto = OffsetDateTime.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toLocalDate().toEpochDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this.toLocalTime().toNanoOfDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this.offset().totalSeconds());
    };
    _proto.until = function until(endExclusive, unit) {
        var end = OffsetDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            end = end.withOffsetSameInstant(this._offset);
            return this._dateTime.until(end._dateTime, unit);
        }
        return unit.between(this, end);
    };
    _proto.atZoneSameInstant = function atZoneSameInstant(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofInstant(this._dateTime, this._offset, zone);
    };
    _proto.atZoneSimilarLocal = function atZoneSimilarLocal(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofLocal(this._dateTime, zone, this._offset);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.get = function get(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field too large for an int: " + field);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this.offset().totalSeconds();
            }
            return this._dateTime.get(field);
        }
        return _Temporal.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this.toEpochSecond();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this.offset().totalSeconds();
            }
            return this._dateTime.getLong(field);
        }
        return field.getFrom(this);
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.year = function year() {
        return this._dateTime.year();
    };
    _proto.monthValue = function monthValue() {
        return this._dateTime.monthValue();
    };
    _proto.month = function month() {
        return this._dateTime.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._dateTime.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._dateTime.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._dateTime.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._dateTime.hour();
    };
    _proto.minute = function minute() {
        return this._dateTime.minute();
    };
    _proto.second = function second() {
        return this._dateTime.second();
    };
    _proto.nano = function nano() {
        return this._dateTime.nano();
    };
    _proto.toLocalDateTime = function toLocalDateTime() {
        return this._dateTime;
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._dateTime.toLocalDate();
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._dateTime.toLocalTime();
    };
    _proto.toOffsetTime = function toOffsetTime() {
        return $2e6f1e48aadbcba7$export$a362394fcc906a80.of(this._dateTime.toLocalTime(), this._offset);
    };
    _proto.toZonedDateTime = function toZonedDateTime() {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(this._dateTime, this._offset);
    };
    _proto.toInstant = function toInstant() {
        return this._dateTime.toInstant(this._offset);
    };
    _proto.toEpochSecond = function toEpochSecond() {
        return this._dateTime.toEpochSecond(this._offset);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._dateTime.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster);
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6 || adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d || adjuster instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) return this._withDateTimeOffset(this._dateTime.with(adjuster), this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$fecec53969739358) return OffsetDateTime.ofInstant(adjuster, this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._withDateTimeOffset(this._dateTime, adjuster);
        else if (adjuster instanceof OffsetDateTime) return adjuster;
        return adjuster.adjustInto(this);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return OffsetDateTime.ofInstant($2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(newValue, this.nano()), this._offset);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this._withDateTimeOffset(this._dateTime, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(f.checkValidIntValue(newValue)));
            }
            return this._withDateTimeOffset(this._dateTime.with(field, newValue), this._offset);
        }
        return field.adjustInto(this, newValue);
    };
    _proto._withDateTimeOffset = function _withDateTimeOffset(dateTime, offset) {
        if (this._dateTime === dateTime && this._offset.equals(offset)) return this;
        return new OffsetDateTime(dateTime, offset);
    };
    _proto.withYear = function withYear(year) {
        return this._withDateTimeOffset(this._dateTime.withYear(year), this._offset);
    };
    _proto.withMonth = function withMonth(month) {
        return this._withDateTimeOffset(this._dateTime.withMonth(month), this._offset);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._withDateTimeOffset(this._dateTime.withDayOfMonth(dayOfMonth), this._offset);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._withDateTimeOffset(this._dateTime.withDayOfYear(dayOfYear), this._offset);
    };
    _proto.withHour = function withHour(hour) {
        return this._withDateTimeOffset(this._dateTime.withHour(hour), this._offset);
    };
    _proto.withMinute = function withMinute(minute) {
        return this._withDateTimeOffset(this._dateTime.withMinute(minute), this._offset);
    };
    _proto.withSecond = function withSecond(second) {
        return this._withDateTimeOffset(this._dateTime.withSecond(second), this._offset);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        return this._withDateTimeOffset(this._dateTime.withNano(nanoOfSecond), this._offset);
    };
    _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        return this._withDateTimeOffset(this._dateTime, offset);
    };
    _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        if (offset.equals(this._offset)) return this;
        var difference = offset.totalSeconds() - this._offset.totalSeconds();
        var adjusted = this._dateTime.plusSeconds(difference);
        return new OffsetDateTime(adjusted, offset);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withDateTimeOffset(this._dateTime.truncatedTo(unit), this._offset);
    };
    _proto._plusAmount = function _plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, 'amount');
        return amount.addTo(this);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return this._withDateTimeOffset(this._dateTime.plus(amountToAdd, unit), this._offset);
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        return this._withDateTimeOffset(this._dateTime.plusYears(years), this._offset);
    };
    _proto.plusMonths = function plusMonths(months) {
        return this._withDateTimeOffset(this._dateTime.plusMonths(months), this._offset);
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        return this._withDateTimeOffset(this._dateTime.plusWeeks(weeks), this._offset);
    };
    _proto.plusDays = function plusDays(days) {
        return this._withDateTimeOffset(this._dateTime.plusDays(days), this._offset);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._withDateTimeOffset(this._dateTime.plusHours(hours), this._offset);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._withDateTimeOffset(this._dateTime.plusMinutes(minutes), this._offset);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._withDateTimeOffset(this._dateTime.plusSeconds(seconds), this._offset);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._withDateTimeOffset(this._dateTime.plusNanos(nanos), this._offset);
    };
    _proto._minusAmount = function _minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.subtractFrom(this);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        return this.plus(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this._withDateTimeOffset(this._dateTime.minusYears(years), this._offset);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this._withDateTimeOffset(this._dateTime.minusMonths(months), this._offset);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this._withDateTimeOffset(this._dateTime.minusWeeks(weeks), this._offset);
    };
    _proto.minusDays = function minusDays(days) {
        return this._withDateTimeOffset(this._dateTime.minusDays(days), this._offset);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._withDateTimeOffset(this._dateTime.minusHours(hours), this._offset);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._withDateTimeOffset(this._dateTime.minusMinutes(minutes), this._offset);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._withDateTimeOffset(this._dateTime.minusSeconds(seconds), this._offset);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._withDateTimeOffset(this._dateTime.minusNanos(nanos), this._offset);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, OffsetDateTime, 'other');
        if (this.offset().equals(other.offset())) return this.toLocalDateTime().compareTo(other.toLocalDateTime());
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
        if (cmp === 0) {
            cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
            if (cmp === 0) cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof OffsetDateTime) return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._dateTime.hashCode() ^ this._offset.hashCode();
    };
    _proto.toString = function toString() {
        return this._dateTime.toString() + this._offset.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this);
    };
    return OffsetDateTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$6() {
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.MIN = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MIN.atOffset($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX);
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.MAX = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MAX.atOffset($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN);
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('OffsetDateTime.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.from(temporal);
    });
}
var $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE = 146097;
var $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970 = $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE * 5 - 10957;
var $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6 = function(_ChronoLocalDate) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalDate, _ChronoLocalDate);
    LocalDate.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone == null) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone();
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone;
        return LocalDate.ofInstant(clock.instant(), clock.zone());
    };
    LocalDate.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        $2e6f1e48aadbcba7$var$requireNonNull(instant, 'instant');
        var offset = zone.rules().offset(instant);
        var epochSec = instant.epochSecond() + offset.totalSeconds();
        var epochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochSec, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        return LocalDate.ofEpochDay(epochDay);
    };
    LocalDate.of = function of(year, month, dayOfMonth) {
        return new LocalDate(year, month, dayOfMonth);
    };
    LocalDate.ofYearDay = function ofYearDay(year, dayOfYear) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        var leap = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year);
        if (dayOfYear === 366 && leap === false) $2e6f1e48aadbcba7$var$assert(false, "Invalid date 'DayOfYear 366' as '" + year + "' is not a leap year", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        var moy = $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(Math.floor((dayOfYear - 1) / 31 + 1));
        var monthEnd = moy.firstDayOfYear(leap) + moy.length(leap) - 1;
        if (dayOfYear > monthEnd) moy = moy.plus(1);
        var dom = dayOfYear - moy.firstDayOfYear(leap) + 1;
        return new LocalDate(year, moy.value(), dom);
    };
    LocalDate.ofEpochDay = function ofEpochDay(epochDay) {
        if (epochDay === void 0) epochDay = 0;
        var adjust, adjustCycles, doyEst, yearEst, zeroDay;
        zeroDay = epochDay + $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970;
        zeroDay -= 60;
        adjust = 0;
        if (zeroDay < 0) {
            adjustCycles = $2e6f1e48aadbcba7$var$MathUtil.intDiv(zeroDay + 1, $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE) - 1;
            adjust = adjustCycles * 400;
            zeroDay += -adjustCycles * $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE;
        }
        yearEst = $2e6f1e48aadbcba7$var$MathUtil.intDiv(400 * zeroDay + 591, $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE);
        doyEst = zeroDay - (365 * yearEst + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 400));
        if (doyEst < 0) {
            yearEst--;
            doyEst = zeroDay - (365 * yearEst + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 400));
        }
        yearEst += adjust;
        var marchDoy0 = doyEst;
        var marchMonth0 = $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchDoy0 * 5 + 2, 153);
        var month = (marchMonth0 + 2) % 12 + 1;
        var dom = marchDoy0 - $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchMonth0 * 306 + 5, 10) + 1;
        yearEst += $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchMonth0, 10);
        var year = yearEst;
        return new LocalDate(year, month, dom);
    };
    LocalDate.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        var date = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate());
        if (date == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalDate from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        return date;
    };
    LocalDate.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE;
        $2e6f1e48aadbcba7$var$assert(formatter != null, 'formatter', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        return formatter.parse(text, LocalDate.FROM);
    };
    LocalDate._resolvePreviousValid = function _resolvePreviousValid(year, month, day) {
        switch(month){
            case 2:
                day = Math.min(day, $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28);
                break;
            case 4:
            case 6:
            case 9:
            case 11:
                day = Math.min(day, 30);
                break;
        }
        return LocalDate.of(year, month, day);
    };
    function LocalDate(year, month, dayOfMonth) {
        var _this;
        _this = _ChronoLocalDate.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(year, 'year');
        $2e6f1e48aadbcba7$var$requireNonNull(month, 'month');
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfMonth, 'dayOfMonth');
        if (month instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) month = month.value();
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(year);
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        _this._day = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(dayOfMonth);
        LocalDate._validate(_this._year, _this._month, _this._day);
        return _this;
    }
    LocalDate._validate = function _validate(year, month, dayOfMonth) {
        var dom;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > 28) {
            dom = 31;
            switch(month){
                case 2:
                    dom = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28;
                    break;
                case 4:
                case 6:
                case 9:
                case 11:
                    dom = 30;
            }
            if (dayOfMonth > dom) {
                if (dayOfMonth === 29) $2e6f1e48aadbcba7$var$assert(false, "Invalid date 'February 29' as '" + year + "' is not a leap year", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
                else $2e6f1e48aadbcba7$var$assert(false, "Invalid date '" + year + "' '" + month + "' '" + dayOfMonth + "'", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
            }
        }
    };
    var _proto = LocalDate.prototype;
    _proto.isSupported = function isSupported(field) {
        return _ChronoLocalDate.prototype.isSupported.call(this, field);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field.isDateBased()) {
                switch(field){
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.lengthOfMonth());
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.lengthOfYear());
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.month() === $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY && this.isLeapYear() === false ? 4 : 5);
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                        return this._year <= 0 ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE + 1) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE);
                }
                return field.range();
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$assert(field != null, '', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK:
                return this.dayOfWeek().value();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this._day - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this.dayOfYear() - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                return this._day;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                return this.dayOfYear();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY:
                return this.toEpochDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._day - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.dayOfYear() - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                return this._month;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                return this._prolepticMonth();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                return this._year >= 1 ? this._year : 1 - this._year;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                return this._year;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                return this._year >= 1 ? 1 : 0;
        }
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto._prolepticMonth = function _prolepticMonth() {
        return this._year * 12 + (this._month - 1);
    };
    _proto.chronology = function chronology() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.dayOfYear = function dayOfYear() {
        return this.month().firstDayOfYear(this.isLeapYear()) + this._day - 1;
    };
    _proto.dayOfWeek = function dayOfWeek() {
        var dow0 = $2e6f1e48aadbcba7$var$MathUtil.floorMod(this.toEpochDay() + 3, 7);
        return $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.of(dow0 + 1);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        switch(this._month){
            case 2:
                return this.isLeapYear() ? 29 : 28;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            default:
                return 31;
        }
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, 'adjuster');
        if (adjuster instanceof LocalDate) return adjuster;
        return _ChronoLocalDate.prototype._withAdjuster.call(this, adjuster);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$assert(field != null, 'field', $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK:
                    return this.plusDays(newValue - this.dayOfWeek().value());
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                    return this.plusDays(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                    return this.plusDays(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this.withDayOfMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                    return this.withDayOfYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY:
                    return LocalDate.ofEpochDay(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                    return this.plusWeeks(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                    return this.plusWeeks(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year >= 1 ? newValue : 1 - newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        if (this._year === year) return this;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return LocalDate._resolvePreviousValid(year, this._month, this._day);
    };
    _proto.withMonth = function withMonth(month) {
        var m = month instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6 ? month.value() : month;
        if (this._month === m) return this;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(m);
        return LocalDate._resolvePreviousValid(this._year, m, this._day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (this._day === dayOfMonth) return this;
        return LocalDate.of(this._year, this._month, dayOfMonth);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        if (this.dayOfYear() === dayOfYear) return this;
        return LocalDate.ofYearDay(this._year, dayOfYear);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, 'amountToAdd');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.plusDays(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS:
                    return this.plusWeeks(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return LocalDate._resolvePreviousValid(newYear, this._month, this._day);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $2e6f1e48aadbcba7$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return LocalDate._resolvePreviousValid(newYear, newMonth, this._day);
    };
    _proto.plusWeeks = function plusWeeks(weeksToAdd) {
        return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeksToAdd, 7));
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        var mjDay = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.toEpochDay(), daysToAdd);
        return LocalDate.ofEpochDay(mjDay);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, 'amountToSubtract');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        return this._plusUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(yearsToSubtract * -1);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(monthsToSubtract * -1);
    };
    _proto.minusWeeks = function minusWeeks(weeksToSubtract) {
        return this.plusWeeks(weeksToSubtract * -1);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(daysToSubtract * -1);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this;
        return _ChronoLocalDate.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDate.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(p1, p2) {
        if (arguments.length < 2) return this.until1(p1);
        else return this.until2(p1, p2);
    };
    _proto.until2 = function until2(endExclusive, unit) {
        var end = LocalDate.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.daysUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.daysUntil(end), 7);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this._monthsUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 12);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 120);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 1200);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 12000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.daysUntil = function daysUntil(end) {
        return end.toEpochDay() - this.toEpochDay();
    };
    _proto._monthsUntil = function _monthsUntil(end) {
        var packed1 = this._prolepticMonth() * 32 + this.dayOfMonth();
        var packed2 = end._prolepticMonth() * 32 + end.dayOfMonth();
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(packed2 - packed1, 32);
    };
    _proto.until1 = function until1(endDate) {
        var end = LocalDate.from(endDate);
        var totalMonths = end._prolepticMonth() - this._prolepticMonth();
        var days = end._day - this._day;
        if (totalMonths > 0 && days < 0) {
            totalMonths--;
            var calcDate = this.plusMonths(totalMonths);
            days = end.toEpochDay() - calcDate.toEpochDay();
        } else if (totalMonths < 0 && days > 0) {
            totalMonths++;
            days -= end.lengthOfMonth();
        }
        var years = $2e6f1e48aadbcba7$var$MathUtil.intDiv(totalMonths, 12);
        var months = $2e6f1e48aadbcba7$var$MathUtil.intMod(totalMonths, 12);
        return $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.of(years, months, days);
    };
    _proto.atTime = function atTime() {
        if (arguments.length === 1) return this.atTime1.apply(this, arguments);
        else return this.atTime4.apply(this, arguments);
    };
    _proto.atTime1 = function atTime1(time) {
        $2e6f1e48aadbcba7$var$requireNonNull(time, 'time');
        if (time instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, time);
        else if (time instanceof $2e6f1e48aadbcba7$export$a362394fcc906a80) return this._atTimeOffsetTime(time);
        else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("time must be an instance of LocalTime or OffsetTime" + (time && time.constructor && time.constructor.name ? ", but is " + time.constructor.name : ''));
    };
    _proto.atTime4 = function atTime4(hour, minute, second, nanoOfSecond) {
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        return this.atTime1($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond));
    };
    _proto._atTimeOffsetTime = function _atTimeOffsetTime(time) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, time.toLocalTime()), time.offset());
    };
    _proto.atStartOfDay = function atStartOfDay(zone) {
        if (zone != null) return this._atStartOfDayWithZone(zone);
        else return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT);
    };
    _proto._atStartOfDayWithZone = function _atStartOfDayWithZone(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        var ldt = this.atTime($2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT);
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 === false) {
            var trans = zone.rules().transition(ldt);
            if (trans != null && trans.isGap()) ldt = trans.dateTimeAfter();
        }
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(ldt, zone);
    };
    _proto.toEpochDay = function toEpochDay() {
        var y = this._year;
        var m = this._month;
        var total = 0;
        total += 365 * y;
        if (y >= 0) total += $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 3, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 99, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 399, 400);
        else total -= $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -400);
        total += $2e6f1e48aadbcba7$var$MathUtil.intDiv(367 * m - 362, 12);
        total += this.dayOfMonth() - 1;
        if (m > 2) {
            total--;
            if (!$2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(y)) total--;
        }
        return total - $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalDate, 'other');
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(otherDate) {
        var cmp = this._year - otherDate._year;
        if (cmp === 0) {
            cmp = this._month - otherDate._month;
            if (cmp === 0) cmp = this._day - otherDate._day;
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDate) return this._compareTo0(other) === 0;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        return $2e6f1e48aadbcba7$var$MathUtil.hash(yearValue & 0xFFFFF800 ^ (yearValue << 11) + (monthValue << 6) + dayValue);
    };
    _proto.toString = function toString() {
        var dayString, monthString, yearString;
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        var absYear = Math.abs(yearValue);
        if (absYear < 1000) {
            if (yearValue < 0) yearString = "-" + ("" + (yearValue - 10000)).slice(-4);
            else yearString = ("" + (yearValue + 10000)).slice(-4);
        } else if (yearValue > 9999) yearString = "+" + yearValue;
        else yearString = "" + yearValue;
        if (monthValue < 10) monthString = "-0" + monthValue;
        else monthString = "-" + monthValue;
        if (dayValue < 10) dayString = "-0" + dayValue;
        else dayString = "-" + dayValue;
        return yearString + monthString + dayString;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, 'formatter');
        return _ChronoLocalDate.prototype.format.call(this, formatter);
    };
    return LocalDate;
}($2e6f1e48aadbcba7$export$2a07e3472bc98879);
function $2e6f1e48aadbcba7$var$_init$5() {
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MIN = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE, 1, 1);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MAX = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of($2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE, 12, 31);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.EPOCH_0 = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(0);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('LocalDate.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$94e985176fb19d17 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoLocalDateTime, _Temporal);
    function ChronoLocalDateTime() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDateTime.prototype;
    _proto.chronology = function chronology() {
        return this.toLocalDate().chronology();
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toLocalDate().toEpochDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this.toLocalTime().toNanoOfDay());
    };
    _proto.toInstant = function toInstant(offset) {
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, 'zoneId');
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(offset), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= offset.totalSeconds();
        return $2e6f1e48aadbcba7$var$MathUtil.safeToInt(secs);
    };
    return ChronoLocalDateTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff = function(_ChronoLocalDateTime) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalDateTime, _ChronoLocalDateTime);
    LocalDateTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalDateTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return LocalDateTime._now(clockOrZone);
        else return LocalDateTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalDateTime._now = function _now(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, 'clock');
        return LocalDateTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalDateTime._ofEpochMillis = function _ofEpochMillis(epochMilli, offset) {
        var localSecond = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochMilli, 1000) + offset.totalSeconds();
        var localEpochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.floorMod(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var nanoOfSecond = $2e6f1e48aadbcba7$var$MathUtil.floorMod(epochMilli, 1000) * 1000000;
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.of = function of() {
        if (arguments.length <= 2) return LocalDateTime.ofDateAndTime.apply(this, arguments);
        else return LocalDateTime.ofNumbers.apply(this, arguments);
    };
    LocalDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(year, month, dayOfMonth);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofDateAndTime = function ofDateAndTime(date, time) {
        $2e6f1e48aadbcba7$var$requireNonNull(date, 'date');
        $2e6f1e48aadbcba7$var$requireNonNull(time, 'time');
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        $2e6f1e48aadbcba7$var$requireNonNull(instant, 'instant');
        $2e6f1e48aadbcba7$var$requireInstance(instant, $2e6f1e48aadbcba7$export$fecec53969739358, 'instant');
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        var offset = zone.rules().offset(instant);
        return LocalDateTime.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
    };
    LocalDateTime.ofEpochSecond = function ofEpochSecond(epochSecond, nanoOfSecond, offset) {
        if (epochSecond === void 0) epochSecond = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (arguments.length === 2 && nanoOfSecond instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) {
            offset = nanoOfSecond;
            nanoOfSecond = 0;
        }
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        var localSecond = epochSecond + offset.totalSeconds();
        var localEpochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.floorMod(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        if (temporal instanceof LocalDateTime) return temporal;
        else if (temporal instanceof $2e6f1e48aadbcba7$export$d3b7288e7994edea) return temporal.toLocalDateTime();
        try {
            var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
            var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
            return new LocalDateTime(date, time);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        }
    };
    LocalDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, LocalDateTime.FROM);
    };
    function LocalDateTime(date, time) {
        var _this;
        _this = _ChronoLocalDateTime.call(this) || this;
        $2e6f1e48aadbcba7$var$requireInstance(date, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, 'date');
        $2e6f1e48aadbcba7$var$requireInstance(time, $2e6f1e48aadbcba7$export$bf1071e344bea1d, 'time');
        _this._date = date;
        _this._time = time;
        return _this;
    }
    var _proto = LocalDateTime.prototype;
    _proto._withDateTime = function _withDateTime(newDate, newTime) {
        if (this._date.equals(newDate) && this._time.equals(newTime)) return this;
        return new LocalDateTime(newDate, newTime);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.range(field) : this._date.range(field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.get(field) : this._date.get(field);
        return _ChronoLocalDateTime.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.getLong(field) : this._date.getLong(field);
        return field.getFrom(this);
    };
    _proto.year = function year() {
        return this._date.year();
    };
    _proto.monthValue = function monthValue() {
        return this._date.monthValue();
    };
    _proto.month = function month() {
        return this._date.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._date.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._date.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._date.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._time.hour();
    };
    _proto.minute = function minute() {
        return this._time.minute();
    };
    _proto.second = function second() {
        return this._time.second();
    };
    _proto.nano = function nano() {
        return this._time.nano();
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, 'adjuster');
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return this._withDateTime(adjuster, this._time);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._withDateTime(this._date, adjuster);
        else if (adjuster instanceof LocalDateTime) return adjuster;
        return _ChronoLocalDateTime.prototype._withAdjuster.call(this, adjuster);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field.isTimeBased()) return this._withDateTime(this._date, this._time.with(field, newValue));
            else return this._withDateTime(this._date.with(field, newValue), this._time);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._withDateTime(this._date.withYear(year), this._time);
    };
    _proto.withMonth = function withMonth(month) {
        return this._withDateTime(this._date.withMonth(month), this._time);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._withDateTime(this._date.withDayOfMonth(dayOfMonth), this._time);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._withDateTime(this._date.withDayOfYear(dayOfYear), this._time);
    };
    _proto.withHour = function withHour(hour) {
        var newTime = this._time.withHour(hour);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withMinute = function withMinute(minute) {
        var newTime = this._time.withMinute(minute);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withSecond = function withSecond(second) {
        var newTime = this._time.withSecond(second);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        var newTime = this._time.withNano(nanoOfSecond);
        return this._withDateTime(this._date, newTime);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withDateTime(this._date, this._time.truncatedTo(unit));
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY)).plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY)).plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY) * 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, 256)).plusHours($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 256) * 12);
            }
            return this._withDateTime(this._date.plus(amountToAdd, unit), this._time);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        var newDate = this._date.plusYears(years);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusMonths = function plusMonths(months) {
        var newDate = this._date.plusMonths(months);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        var newDate = this._date.plusWeeks(weeks);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusDays = function plusDays(days) {
        var newDate = this._date.plusDays(days);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, 1);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, 1);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, 1);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, 1);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        return this._plusUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, -1);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, -1);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, -1);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, -1);
    };
    _proto._plusWithOverflow = function _plusWithOverflow(newDate, hours, minutes, seconds, nanos, sign) {
        if (hours === 0 && minutes === 0 && seconds === 0 && nanos === 0) return this._withDateTime(newDate, this._time);
        var totDays = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY);
        totDays *= sign;
        var totNanos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intMod(seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + $2e6f1e48aadbcba7$var$MathUtil.intMod(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE + $2e6f1e48aadbcba7$var$MathUtil.intMod(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR;
        var curNoD = this._time.toNanoOfDay();
        totNanos = totNanos * sign + curNoD;
        totDays += $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totNanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newNoD = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totNanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newTime = newNoD === curNoD ? this._time : $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(newNoD);
        return this._withDateTime(newDate.plusDays(totDays), newTime);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        return _ChronoLocalDateTime.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDateTime.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        var end = LocalDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            if (unit.isTimeBased()) {
                var daysUntil = this._date.daysUntil(end._date);
                var timeUntil = end._time.toNanoOfDay() - this._time.toNanoOfDay();
                if (daysUntil > 0 && timeUntil < 0) {
                    daysUntil--;
                    timeUntil += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY;
                } else if (daysUntil < 0 && timeUntil > 0) {
                    daysUntil++;
                    timeUntil -= $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY;
                }
                var amount = daysUntil;
                switch(unit){
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, timeUntil);
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, 1000));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, 1000000));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, 2);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR * 12));
                }
                throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
            }
            var endDate = end._date;
            var endTime = end._time;
            if (endDate.isAfter(this._date) && endTime.isBefore(this._time)) endDate = endDate.minusDays(1);
            else if (endDate.isBefore(this._date) && endTime.isAfter(this._time)) endDate = endDate.plusDays(1);
            return this._date.until(endDate, unit);
        }
        return unit.between(this, end);
    };
    _proto.atOffset = function atOffset(offset) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(this, offset);
    };
    _proto.atZone = function atZone(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(this, zone);
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._date;
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._time;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalDateTime, 'other');
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(other) {
        var cmp = this._date.compareTo(other.toLocalDate());
        if (cmp === 0) cmp = this._time.compareTo(other.toLocalTime());
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDateTime) return this._date.equals(other._date) && this._time.equals(other._time);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._date.hashCode() ^ this._time.hashCode();
    };
    _proto.toString = function toString() {
        return this._date.toString() + "T" + this._time.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this);
    };
    return LocalDateTime;
}($2e6f1e48aadbcba7$export$94e985176fb19d17);
function $2e6f1e48aadbcba7$var$_init$4() {
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MIN = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MIN, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIN);
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MAX = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MAX, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MAX);
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('LocalDateTime.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$bf1071e344bea1d = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalTime, _Temporal);
    LocalTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return LocalTime._now(clockOrZone);
        else return LocalTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalTime._now = function _now(clock) {
        if (clock === void 0) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone();
        $2e6f1e48aadbcba7$var$requireNonNull(clock, 'clock');
        return LocalTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        var offset = zone.rules().offset(instant);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.intMod(instant.epochSecond(), LocalTime.SECONDS_PER_DAY);
        secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.intMod(secsOfDay + offset.totalSeconds(), LocalTime.SECONDS_PER_DAY);
        if (secsOfDay < 0) secsOfDay += LocalTime.SECONDS_PER_DAY;
        return LocalTime.ofSecondOfDay(secsOfDay, instant.nano());
    };
    LocalTime.of = function of(hour, minute, second, nanoOfSecond) {
        return new LocalTime(hour, minute, second, nanoOfSecond);
    };
    LocalTime.ofSecondOfDay = function ofSecondOfDay(secondOfDay, nanoOfSecond) {
        if (secondOfDay === void 0) secondOfDay = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(secondOfDay);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_HOUR);
        secondOfDay -= hours * LocalTime.SECONDS_PER_HOUR;
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_MINUTE);
        secondOfDay -= minutes * LocalTime.SECONDS_PER_MINUTE;
        return new LocalTime(hours, minutes, secondOfDay, nanoOfSecond);
    };
    LocalTime.ofNanoOfDay = function ofNanoOfDay(nanoOfDay) {
        if (nanoOfDay === void 0) nanoOfDay = 0;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nanoOfDay);
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_HOUR);
        nanoOfDay -= hours * LocalTime.NANOS_PER_HOUR;
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_MINUTE);
        nanoOfDay -= minutes * LocalTime.NANOS_PER_MINUTE;
        var seconds = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_SECOND);
        nanoOfDay -= seconds * LocalTime.NANOS_PER_SECOND;
        return new LocalTime(hours, minutes, seconds, nanoOfDay);
    };
    LocalTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        var time = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime());
        if (time == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        return time;
    };
    LocalTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.parse(text, LocalTime.FROM);
    };
    function LocalTime(hour, minute, second, nanoOfSecond) {
        var _this;
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        _this = _Temporal.call(this) || this;
        var _hour = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(hour);
        var _minute = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(minute);
        var _second = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(second);
        var _nanoOfSecond = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanoOfSecond);
        LocalTime._validate(_hour, _minute, _second, _nanoOfSecond);
        if (_minute === 0 && _second === 0 && _nanoOfSecond === 0) {
            if (!LocalTime.HOURS[_hour]) {
                _this._hour = _hour;
                _this._minute = _minute;
                _this._second = _second;
                _this._nano = _nanoOfSecond;
                LocalTime.HOURS[_hour] = $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
            }
            return LocalTime.HOURS[_hour] || $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        }
        _this._hour = _hour;
        _this._minute = _minute;
        _this._second = _second;
        _this._nano = _nanoOfSecond;
        return _this;
    }
    LocalTime._validate = function _validate(hour, minute, second, nanoOfSecond) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidValue(hour);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidValue(minute);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidValue(second);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
    };
    var _proto = LocalTime.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                return this._nano;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY:
                return this.toNanoOfDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nano, 1000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.toNanoOfDay(), 1000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nano, 1000000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.toNanoOfDay(), 1000000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                return this._second;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY:
                return this.toSecondOfDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                return this._minute;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY:
                return this._hour * 60 + this._minute;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                var ham = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12);
                return ham % 12 === 0 ? 12 : ham;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY:
                return this._hour;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                return this._hour === 0 ? 24 : this._hour;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._hour, 12);
        }
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto.hour = function hour() {
        return this._hour;
    };
    _proto.minute = function minute() {
        return this._minute;
    };
    _proto.second = function second() {
        return this._second;
    };
    _proto.nano = function nano() {
        return this._nano;
    };
    _proto._withAdjuster = function _withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, 'adjuster');
        if (adjuster instanceof LocalTime) return adjuster;
        return _Temporal.prototype._withAdjuster.call(this, adjuster);
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this.withNano(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return this.withNano(newValue * 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return this.withNano(newValue * 1000000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                    return this.withSecond(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY:
                    return this.plusSeconds(newValue - this.toSecondOfDay());
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                    return this.withMinute(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY:
                    return this.plusMinutes(newValue - (this._hour * 60 + this._minute));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM:
                    return this.plusHours(newValue - $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                    return this.plusHours((newValue === 12 ? 0 : newValue) - $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY:
                    return this.withHour(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                    return this.withHour(newValue === 24 ? 0 : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY:
                    return this.plusHours((newValue - $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._hour, 12)) * 12);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withHour = function withHour(hour) {
        if (hour === void 0) hour = 0;
        if (this._hour === hour) return this;
        return new LocalTime(hour, this._minute, this._second, this._nano);
    };
    _proto.withMinute = function withMinute(minute) {
        if (minute === void 0) minute = 0;
        if (this._minute === minute) return this;
        return new LocalTime(this._hour, minute, this._second, this._nano);
    };
    _proto.withSecond = function withSecond(second) {
        if (second === void 0) second = 0;
        if (this._second === second) return this;
        return new LocalTime(this._hour, this._minute, second, this._nano);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (this._nano === nanoOfSecond) return this;
        return new LocalTime(this._hour, this._minute, this._second, nanoOfSecond);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > LocalTime.SECONDS_PER_DAY) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Unit is too large to be used for truncation');
        var dur = unitDur.toNanos();
        if ($2e6f1e48aadbcba7$var$MathUtil.intMod(LocalTime.NANOS_PER_DAY, dur) !== 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Unit must divide into a standard day without remainder');
        var nod = this.toNanoOfDay();
        return LocalTime.ofNanoOfDay($2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, dur) * dur);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, LocalTime.MICROS_PER_DAY) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, LocalTime.MILLIS_PER_DAY) * 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusHours($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 2) * 12);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        if (hoursToAdd === 0) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(hoursToAdd, LocalTime.HOURS_PER_DAY) + this._hour + LocalTime.HOURS_PER_DAY, LocalTime.HOURS_PER_DAY);
        return new LocalTime(newHour, this._minute, this._second, this._nano);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        if (minutesToAdd === 0) return this;
        var mofd = this._hour * LocalTime.MINUTES_PER_HOUR + this._minute;
        var newMofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(minutesToAdd, LocalTime.MINUTES_PER_DAY) + mofd + LocalTime.MINUTES_PER_DAY, LocalTime.MINUTES_PER_DAY);
        if (mofd === newMofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newMofd, LocalTime.MINUTES_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod(newMofd, LocalTime.MINUTES_PER_HOUR);
        return new LocalTime(newHour, newMinute, this._second, this._nano);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        if (secondsToAdd === 0) return this;
        var sofd = this._hour * LocalTime.SECONDS_PER_HOUR + this._minute * LocalTime.SECONDS_PER_MINUTE + this._second;
        var newSofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(secondsToAdd, LocalTime.SECONDS_PER_DAY) + sofd + LocalTime.SECONDS_PER_DAY, LocalTime.SECONDS_PER_DAY);
        if (sofd === newSofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $2e6f1e48aadbcba7$var$MathUtil.intMod(newSofd, LocalTime.SECONDS_PER_MINUTE);
        return new LocalTime(newHour, newMinute, newSecond, this._nano);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        if (nanosToAdd === 0) return this;
        var nofd = this.toNanoOfDay();
        var newNofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToAdd, LocalTime.NANOS_PER_DAY) + nofd + LocalTime.NANOS_PER_DAY, LocalTime.NANOS_PER_DAY);
        if (nofd === newNofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_SECOND), LocalTime.SECONDS_PER_MINUTE);
        var newNano = $2e6f1e48aadbcba7$var$MathUtil.intMod(newNofd, LocalTime.NANOS_PER_SECOND);
        return new LocalTime(newHour, newMinute, newSecond, newNano);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        return this._plusUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return this.plusHours(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(hoursToSubtract, LocalTime.HOURS_PER_DAY));
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return this.plusMinutes(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(minutesToSubtract, LocalTime.MINUTES_PER_DAY));
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(secondsToSubtract, LocalTime.SECONDS_PER_DAY));
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToSubtract, LocalTime.NANOS_PER_DAY));
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with(LocalTime.NANO_OF_DAY, this.toNanoOfDay());
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        var end = LocalTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var nanosUntil = end.toNanoOfDay() - this.toNanoOfDay();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return nanosUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_SECOND);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 12 * LocalTime.NANOS_PER_HOUR);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDate = function atDate(date) {
        return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, this);
    };
    _proto.atOffset = function atOffset(offset) {
        return $2e6f1e48aadbcba7$export$a362394fcc906a80.of(this, offset);
    };
    _proto.toSecondOfDay = function toSecondOfDay() {
        var total = this._hour * LocalTime.SECONDS_PER_HOUR;
        total += this._minute * LocalTime.SECONDS_PER_MINUTE;
        total += this._second;
        return total;
    };
    _proto.toNanoOfDay = function toNanoOfDay() {
        var total = this._hour * LocalTime.NANOS_PER_HOUR;
        total += this._minute * LocalTime.NANOS_PER_MINUTE;
        total += this._second * LocalTime.NANOS_PER_SECOND;
        total += this._nano;
        return total;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, 'other');
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalTime, 'other');
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._hour, other._hour);
        if (cmp === 0) {
            cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._minute, other._minute);
            if (cmp === 0) {
                cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._second, other._second);
                if (cmp === 0) cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._nano, other._nano);
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalTime) return this._hour === other._hour && this._minute === other._minute && this._second === other._second && this._nano === other._nano;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var nod = this.toNanoOfDay();
        return $2e6f1e48aadbcba7$var$MathUtil.hash(nod);
    };
    _proto.toString = function toString() {
        var buf = '';
        var hourValue = this._hour;
        var minuteValue = this._minute;
        var secondValue = this._second;
        var nanoValue = this._nano;
        buf += hourValue < 10 ? '0' : '';
        buf += hourValue;
        buf += minuteValue < 10 ? ':0' : ':';
        buf += minuteValue;
        if (secondValue > 0 || nanoValue > 0) {
            buf += secondValue < 10 ? ':0' : ':';
            buf += secondValue;
            if (nanoValue > 0) {
                buf += '.';
                if ($2e6f1e48aadbcba7$var$MathUtil.intMod(nanoValue, 1000000) === 0) buf += ("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoValue, 1000000) + 1000)).substring(1);
                else if ($2e6f1e48aadbcba7$var$MathUtil.intMod(nanoValue, 1000) === 0) buf += ("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoValue, 1000) + 1000000)).substring(1);
                else buf += ("" + (nanoValue + 1000000000)).substring(1);
            }
        }
        return buf;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, 'formatter');
        return formatter.format(this);
    };
    return LocalTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$3() {
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS = [];
    for(var hour = 0; hour < 24; hour++)$2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, 0, 0, 0);
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIN = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[0];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MAX = new $2e6f1e48aadbcba7$export$bf1071e344bea1d(23, 59, 59, 999999999);
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[0];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.NOON = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[12];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('LocalTime.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
    });
}
$2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY = 24;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR = 60;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE = 60;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE * $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND = 1000000000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE * $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
var $2e6f1e48aadbcba7$var$NANOS_PER_MILLI = 1000000;
var $2e6f1e48aadbcba7$export$fecec53969739358 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Instant, _Temporal);
    Instant.now = function now(clock) {
        if (clock === void 0) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemUTC();
        return clock.instant();
    };
    Instant.ofEpochSecond = function ofEpochSecond(epochSecond, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = epochSecond + $2e6f1e48aadbcba7$var$MathUtil.floorDiv(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Instant._create(secs, nos);
    };
    Instant.ofEpochMilli = function ofEpochMilli(epochMilli) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochMilli, 1000);
        var mos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(epochMilli, 1000);
        return Instant._create(secs, mos * 1000000);
    };
    Instant.ofEpochMicro = function ofEpochMicro(epochMicro) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochMicro, 1000000);
        var mos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(epochMicro, 1000000);
        return Instant._create(secs, mos * 1000);
    };
    Instant.from = function from(temporal) {
        try {
            var instantSecs = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
            var nanoOfSecond = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            return Instant.ofEpochSecond(instantSecs, nanoOfSecond);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Instant from TemporalAccessor: " + temporal + ", type " + typeof temporal, ex);
        }
    };
    Instant.parse = function parse(text) {
        return $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT.parse(text, Instant.FROM);
    };
    Instant._create = function _create(seconds, nanoOfSecond) {
        if (seconds === 0 && nanoOfSecond === 0) return Instant.EPOCH;
        return new Instant(seconds, nanoOfSecond);
    };
    Instant._validate = function _validate(seconds, nanoOfSecond) {
        if (seconds < Instant.MIN_SECONDS || seconds > Instant.MAX_SECONDS) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Instant exceeds minimum or maximum instant');
        if (nanoOfSecond < 0 || nanoOfSecond > $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Instant exceeds minimum or maximum instant');
    };
    function Instant(seconds, nanoOfSecond) {
        var _this;
        _this = _Temporal.call(this) || this;
        Instant._validate(seconds, nanoOfSecond);
        _this._seconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(seconds);
        _this._nanos = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanoOfSecond);
        return _this;
    }
    var _proto = Instant.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND;
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased() || fieldOrUnit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this._nanos;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this._seconds;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.epochSecond = function epochSecond() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto._withField = function _withField(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, 'field');
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    var nval = newValue * $2e6f1e48aadbcba7$var$NANOS_PER_MILLI;
                    return nval !== this._nanos ? Instant._create(this._seconds, nval) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    var _nval = newValue * 1000;
                    return _nval !== this._nanos ? Instant._create(this._seconds, _nval) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return newValue !== this._nanos ? Instant._create(this._seconds, newValue) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return newValue !== this._seconds ? Instant._create(newValue, this._nanos) : this;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Unit is too large to be used for truncation');
        var dur = unitDur.toNanos();
        if ($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY, dur) !== 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('Unit must divide into a standard day without remainder');
        var nod = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos;
        var result = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, dur) * dur;
        return this.plusNanos(result - nod);
    };
    _proto._plusUnit = function _plusUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, 'amountToAdd');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusMicros(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY / 2));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this._plus(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this._plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(millisToAdd, 1000), $2e6f1e48aadbcba7$var$MathUtil.intMod(millisToAdd, 1000) * $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this._plus(0, nanosToAdd);
    };
    _proto.plusMicros = function plusMicros(microsToAdd) {
        return this._plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(microsToAdd, 1000000), $2e6f1e48aadbcba7$var$MathUtil.intMod(microsToAdd, 1000000) * 1000);
    };
    _proto._plus = function _plus(secondsToAdd, nanosToAdd) {
        if (secondsToAdd === 0 && nanosToAdd === 0) return this;
        var epochSec = this._seconds + secondsToAdd;
        epochSec = epochSec + $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = this._nanos + nanosToAdd % $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
        return Instant.ofEpochSecond(epochSec, nanoAdjustment);
    };
    _proto._minusUnit = function _minusUnit(amountToSubtract, unit) {
        return this._plusUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(secondsToSubtract * -1);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return this.plusMillis(-1 * millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * nanosToSubtract);
    };
    _proto.minusMicros = function minusMicros(microsToSubtract) {
        return this.plusMicros(-1 * microsToSubtract);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, 'query');
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, this._seconds).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, this._nanos);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, 'endExclusive');
        $2e6f1e48aadbcba7$var$requireNonNull(unit, 'unit');
        var end = Instant.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this._nanosUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this._microsUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.toEpochMilli(), this.toEpochMilli());
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this._secondsUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), 12 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto._microsUntil = function _microsUntil(end) {
        var secsDiff = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var totalMicros = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(secsDiff, 1000000);
        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalMicros, $2e6f1e48aadbcba7$var$MathUtil.intDiv(end.nano() - this.nano(), 1000));
    };
    _proto._nanosUntil = function _nanosUntil(end) {
        var secsDiff = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(secsDiff, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, end.nano() - this.nano());
    };
    _proto._secondsUntil = function _secondsUntil(end) {
        var secsDiff = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var nanosDiff = end.nano() - this.nano();
        if (secsDiff > 0 && nanosDiff < 0) secsDiff--;
        else if (secsDiff < 0 && nanosDiff > 0) secsDiff++;
        return secsDiff;
    };
    _proto.atOffset = function atOffset(offset) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.ofInstant(this, offset);
    };
    _proto.atZone = function atZone(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofInstant(this, zone);
    };
    _proto.toEpochMilli = function toEpochMilli() {
        var millis = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, 1000);
        return millis + $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
    };
    _proto.compareTo = function compareTo(otherInstant) {
        $2e6f1e48aadbcba7$var$requireNonNull(otherInstant, 'otherInstant');
        $2e6f1e48aadbcba7$var$requireInstance(otherInstant, Instant, 'otherInstant');
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._seconds, otherInstant._seconds);
        if (cmp !== 0) return cmp;
        return this._nanos - otherInstant._nanos;
    };
    _proto.isAfter = function isAfter(otherInstant) {
        return this.compareTo(otherInstant) > 0;
    };
    _proto.isBefore = function isBefore(otherInstant) {
        return this.compareTo(otherInstant) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Instant) return this.epochSecond() === other.epochSecond() && this.nano() === other.nano();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._seconds, this._nanos);
    };
    _proto.toString = function toString() {
        return $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Instant;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$2() {
    $2e6f1e48aadbcba7$export$fecec53969739358.MIN_SECONDS = -31619119219200;
    $2e6f1e48aadbcba7$export$fecec53969739358.MAX_SECONDS = 31494816403199;
    $2e6f1e48aadbcba7$export$fecec53969739358.EPOCH = new $2e6f1e48aadbcba7$export$fecec53969739358(0, 0);
    $2e6f1e48aadbcba7$export$fecec53969739358.MIN = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond($2e6f1e48aadbcba7$export$fecec53969739358.MIN_SECONDS, 0);
    $2e6f1e48aadbcba7$export$fecec53969739358.MAX = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond($2e6f1e48aadbcba7$export$fecec53969739358.MAX_SECONDS, 999999999);
    $2e6f1e48aadbcba7$export$fecec53969739358.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery('Instant.FROM', function(temporal) {
        return $2e6f1e48aadbcba7$export$fecec53969739358.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$9735c82c4bae3302 = function() {
    function Clock() {}
    Clock.systemUTC = function systemUTC() {
        return new $2e6f1e48aadbcba7$var$SystemClock($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
    };
    Clock.systemDefaultZone = function systemDefaultZone() {
        return new $2e6f1e48aadbcba7$var$SystemClock($2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault());
    };
    Clock.system = function system(zone) {
        return new $2e6f1e48aadbcba7$var$SystemClock(zone);
    };
    Clock.fixed = function fixed(fixedInstant, zoneId) {
        return new $2e6f1e48aadbcba7$var$FixedClock(fixedInstant, zoneId);
    };
    Clock.offset = function offset(baseClock, duration) {
        return new $2e6f1e48aadbcba7$var$OffsetClock(baseClock, duration);
    };
    var _proto = Clock.prototype;
    _proto.millis = function millis() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('Clock.millis');
    };
    _proto.instant = function instant() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('Clock.instant');
    };
    _proto.zone = function zone() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('Clock.zone');
    };
    _proto.withZone = function withZone() {
        $2e6f1e48aadbcba7$var$abstractMethodFail('Clock.withZone');
    };
    return Clock;
}();
var $2e6f1e48aadbcba7$var$SystemClock = function(_Clock) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemClock, _Clock);
    function SystemClock(zone) {
        var _this;
        $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
        _this = _Clock.call(this) || this;
        _this._zone = zone;
        return _this;
    }
    var _proto2 = SystemClock.prototype;
    _proto2.zone = function zone() {
        return this._zone;
    };
    _proto2.millis = function millis() {
        return new Date().getTime();
    };
    _proto2.instant = function instant() {
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(this.millis());
    };
    _proto2.equals = function equals(obj) {
        if (obj instanceof SystemClock) return this._zone.equals(obj._zone);
        return false;
    };
    _proto2.withZone = function withZone(zone) {
        if (zone.equals(this._zone)) return this;
        return new SystemClock(zone);
    };
    _proto2.toString = function toString() {
        return "SystemClock[" + this._zone.toString() + "]";
    };
    return SystemClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
var $2e6f1e48aadbcba7$var$FixedClock = function(_Clock2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(FixedClock, _Clock2);
    function FixedClock(fixedInstant, zoneId) {
        var _this2;
        _this2 = _Clock2.call(this) || this;
        _this2._instant = fixedInstant;
        _this2._zoneId = zoneId;
        return _this2;
    }
    var _proto3 = FixedClock.prototype;
    _proto3.instant = function instant() {
        return this._instant;
    };
    _proto3.millis = function millis() {
        return this._instant.toEpochMilli();
    };
    _proto3.zone = function zone() {
        return this._zoneId;
    };
    _proto3.toString = function toString() {
        return 'FixedClock[]';
    };
    _proto3.equals = function equals(obj) {
        if (obj instanceof FixedClock) return this._instant.equals(obj._instant) && this._zoneId.equals(obj._zoneId);
        return false;
    };
    _proto3.withZone = function withZone(zone) {
        if (zone.equals(this._zoneId)) return this;
        return new FixedClock(this._instant, zone);
    };
    return FixedClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
var $2e6f1e48aadbcba7$var$OffsetClock = function(_Clock3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetClock, _Clock3);
    function OffsetClock(baseClock, offset) {
        var _this3;
        _this3 = _Clock3.call(this) || this;
        _this3._baseClock = baseClock;
        _this3._offset = offset;
        return _this3;
    }
    var _proto4 = OffsetClock.prototype;
    _proto4.zone = function zone() {
        return this._baseClock.zone();
    };
    _proto4.withZone = function withZone(zone) {
        if (zone.equals(this._baseClock.zone())) return this;
        return new OffsetClock(this._baseClock.withZone(zone), this._offset);
    };
    _proto4.millis = function millis() {
        return this._baseClock.millis() + this._offset.toMillis();
    };
    _proto4.instant = function instant() {
        return this._baseClock.instant().plus(this._offset);
    };
    _proto4.equals = function equals(obj) {
        if (obj instanceof OffsetClock) return this._baseClock.equals(obj._baseClock) && this._offset.equals(obj._offset);
        return false;
    };
    _proto4.toString = function toString() {
        return "OffsetClock[" + this._baseClock + "," + this._offset + "]";
    };
    return OffsetClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$993d982a5ca9c76d = function() {
    ZoneOffsetTransition.of = function of(transition, offsetBefore, offsetAfter) {
        return new ZoneOffsetTransition(transition, offsetBefore, offsetAfter);
    };
    function ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
        $2e6f1e48aadbcba7$var$requireNonNull(transition, 'transition');
        $2e6f1e48aadbcba7$var$requireNonNull(offsetBefore, 'offsetBefore');
        $2e6f1e48aadbcba7$var$requireNonNull(offsetAfter, 'offsetAfter');
        if (offsetBefore.equals(offsetAfter)) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Offsets must not be equal');
        if (transition.nano() !== 0) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('Nano-of-second must be zero');
        if (transition instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) this._transition = transition;
        else this._transition = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(transition, 0, offsetBefore);
        this._offsetBefore = offsetBefore;
        this._offsetAfter = offsetAfter;
    }
    var _proto = ZoneOffsetTransition.prototype;
    _proto.instant = function instant() {
        return this._transition.toInstant(this._offsetBefore);
    };
    _proto.toEpochSecond = function toEpochSecond() {
        return this._transition.toEpochSecond(this._offsetBefore);
    };
    _proto.dateTimeBefore = function dateTimeBefore() {
        return this._transition;
    };
    _proto.dateTimeAfter = function dateTimeAfter() {
        return this._transition.plusSeconds(this.durationSeconds());
    };
    _proto.offsetBefore = function offsetBefore() {
        return this._offsetBefore;
    };
    _proto.offsetAfter = function offsetAfter() {
        return this._offsetAfter;
    };
    _proto.duration = function duration() {
        return $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(this.durationSeconds());
    };
    _proto.durationSeconds = function durationSeconds() {
        return this._offsetAfter.totalSeconds() - this._offsetBefore.totalSeconds();
    };
    _proto.isGap = function isGap() {
        return this._offsetAfter.totalSeconds() > this._offsetBefore.totalSeconds();
    };
    _proto.isOverlap = function isOverlap() {
        return this._offsetAfter.totalSeconds() < this._offsetBefore.totalSeconds();
    };
    _proto.isValidOffset = function isValidOffset(offset) {
        return this.isGap() ? false : this._offsetBefore.equals(offset) || this._offsetAfter.equals(offset);
    };
    _proto.validOffsets = function validOffsets() {
        if (this.isGap()) return [];
        else return [
            this._offsetBefore,
            this._offsetAfter
        ];
    };
    _proto.compareTo = function compareTo(transition) {
        return this.instant().compareTo(transition.instant());
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ZoneOffsetTransition) {
            var d = other;
            return this._transition.equals(d._transition) && this._offsetBefore.equals(d.offsetBefore()) && this._offsetAfter.equals(d.offsetAfter());
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._transition.hashCode() ^ this._offsetBefore.hashCode() ^ this._offsetAfter.hashCode() >>> 16;
    };
    _proto.toString = function toString() {
        return "Transition[" + (this.isGap() ? 'Gap' : 'Overlap') + " at " + this._transition.toString() + this._offsetBefore.toString() + " to " + this._offsetAfter + "]";
    };
    return ZoneOffsetTransition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$_init$1() {
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID = $2e6f1e48aadbcba7$var$createTemporalQuery('ZONE_ID', function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.CHRONO = $2e6f1e48aadbcba7$var$createTemporalQuery('CHRONO', function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.CHRONO);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.PRECISION = $2e6f1e48aadbcba7$var$createTemporalQuery('PRECISION', function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.PRECISION);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.OFFSET = $2e6f1e48aadbcba7$var$createTemporalQuery('OFFSET', function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS)) return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS));
        return null;
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE = $2e6f1e48aadbcba7$var$createTemporalQuery('ZONE', function(temporal) {
        var zone = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID);
        return zone != null ? zone : temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.OFFSET);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.LOCAL_DATE = $2e6f1e48aadbcba7$var$createTemporalQuery('LOCAL_DATE', function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY)) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY));
        return null;
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.LOCAL_TIME = $2e6f1e48aadbcba7$var$createTemporalQuery('LOCAL_TIME', function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY)) return $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY));
        return null;
    });
}
var $2e6f1e48aadbcba7$var$SystemDefaultZoneRules = function(_ZoneRules) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemDefaultZoneRules, _ZoneRules);
    function SystemDefaultZoneRules() {
        return _ZoneRules.apply(this, arguments) || this;
    }
    var _proto = SystemDefaultZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        return false;
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        var offsetInMinutes = new Date(instant.toEpochMilli()).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        var offsetInMinutes = new Date(epochMilli).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        var epochMilli = localDateTime.toEpochSecond($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC) * 1000;
        var offsetInMinutesBeforePossibleTransition = new Date(epochMilli).getTimezoneOffset();
        var epochMilliSystemZone = epochMilli + offsetInMinutesBeforePossibleTransition * 60000;
        var offsetInMinutesAfterPossibleTransition = new Date(epochMilliSystemZone).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutesAfterPossibleTransition * -1);
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        return [
            this.offsetOfLocalDateTime(localDateTime)
        ];
    };
    _proto.transition = function transition() {
        return null;
    };
    _proto.standardOffset = function standardOffset(instant) {
        return this.offsetOfInstant(instant);
    };
    _proto.daylightSavings = function daylightSavings() {
        this._throwNotSupported();
    };
    _proto.isDaylightSavings = function isDaylightSavings() {
        this._throwNotSupported();
    };
    _proto.isValidOffset = function isValidOffset(dateTime, offset) {
        return this.offsetOfLocalDateTime(dateTime).equals(offset);
    };
    _proto.nextTransition = function nextTransition() {
        this._throwNotSupported();
    };
    _proto.previousTransition = function previousTransition() {
        this._throwNotSupported();
    };
    _proto.transitions = function transitions() {
        this._throwNotSupported();
    };
    _proto.transitionRules = function transitionRules() {
        this._throwNotSupported();
    };
    _proto._throwNotSupported = function _throwNotSupported() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('not supported operation');
    };
    _proto.equals = function equals(other) {
        if (this === other || other instanceof SystemDefaultZoneRules) return true;
        else return false;
    };
    _proto.toString = function toString() {
        return 'SYSTEM';
    };
    return SystemDefaultZoneRules;
}($2e6f1e48aadbcba7$export$cbd9bcf3fad97817);
var $2e6f1e48aadbcba7$var$SystemDefaultZoneId = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemDefaultZoneId, _ZoneId);
    function SystemDefaultZoneId() {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._rules = new $2e6f1e48aadbcba7$var$SystemDefaultZoneRules();
        return _this;
    }
    var _proto = SystemDefaultZoneId.prototype;
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        return false;
    };
    _proto.id = function id() {
        return 'SYSTEM';
    };
    return SystemDefaultZoneId;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ZoneIdFactory = function() {
    function ZoneIdFactory() {}
    ZoneIdFactory.systemDefault = function systemDefault() {
        return $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    };
    ZoneIdFactory.getAvailableZoneIds = function getAvailableZoneIds() {
        return $2e6f1e48aadbcba7$export$79d73e02cd645302.getAvailableZoneIds();
    };
    ZoneIdFactory.of = function of(zoneId) {
        $2e6f1e48aadbcba7$var$requireNonNull(zoneId, 'zoneId');
        if (zoneId === 'Z') return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC;
        if (zoneId.length === 1) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid zone: " + zoneId);
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, '+') || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, '-')) return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId);
        if (zoneId === 'UTC' || zoneId === 'GMT' || zoneId === 'GMT0' || zoneId === 'UT') return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC.rules());
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'UTC+') || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'GMT+') || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'UTC-') || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'GMT-')) {
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId.substring(3));
            if (offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId.substring(0, 3), offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId.substring(0, 3) + offset.id(), offset.rules());
        }
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'UT+') || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, 'UT-')) {
            var _offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId.substring(2));
            if (_offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d('UT', _offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d("UT" + _offset.id(), _offset.rules());
        }
        if (zoneId === 'SYSTEM') return $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        return $2e6f1e48aadbcba7$export$9caa52e4e516e67d.ofId(zoneId);
    };
    ZoneIdFactory.ofOffset = function ofOffset(prefix, offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(prefix, 'prefix');
        $2e6f1e48aadbcba7$var$requireNonNull(offset, 'offset');
        if (prefix.length === 0) return offset;
        if (prefix === 'GMT' || prefix === 'UTC' || prefix === 'UT') {
            if (offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(prefix, offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(prefix + offset.id(), offset.rules());
        }
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid prefix, must be GMT, UTC or UT: " + prefix);
    };
    ZoneIdFactory.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, 'temporal');
        var obj = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone());
        if (obj == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain ZoneId from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ''));
        return obj;
    };
    return ZoneIdFactory;
}();
var $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = null;
function $2e6f1e48aadbcba7$var$_init() {
    $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = new $2e6f1e48aadbcba7$var$SystemDefaultZoneId();
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault = $2e6f1e48aadbcba7$var$ZoneIdFactory.systemDefault;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.getAvailableZoneIds = $2e6f1e48aadbcba7$var$ZoneIdFactory.getAvailableZoneIds;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.of = $2e6f1e48aadbcba7$var$ZoneIdFactory.of;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset = $2e6f1e48aadbcba7$var$ZoneIdFactory.ofOffset;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.from = $2e6f1e48aadbcba7$var$ZoneIdFactory.from;
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from = $2e6f1e48aadbcba7$var$ZoneIdFactory.from;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.SYSTEM = $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.UTC = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$isInit = false;
function $2e6f1e48aadbcba7$var$init() {
    if ($2e6f1e48aadbcba7$var$isInit) return;
    $2e6f1e48aadbcba7$var$isInit = true;
    $2e6f1e48aadbcba7$var$_init$m();
    $2e6f1e48aadbcba7$var$_init$n();
    $2e6f1e48aadbcba7$var$_init$l();
    $2e6f1e48aadbcba7$var$_init$k();
    $2e6f1e48aadbcba7$var$_init$3();
    $2e6f1e48aadbcba7$var$_init$f();
    $2e6f1e48aadbcba7$var$_init$1();
    $2e6f1e48aadbcba7$var$_init$j();
    $2e6f1e48aadbcba7$var$_init$2();
    $2e6f1e48aadbcba7$var$_init$5();
    $2e6f1e48aadbcba7$var$_init$4();
    $2e6f1e48aadbcba7$var$_init$a();
    $2e6f1e48aadbcba7$var$_init$i();
    $2e6f1e48aadbcba7$var$_init$b();
    $2e6f1e48aadbcba7$var$_init$c();
    $2e6f1e48aadbcba7$var$_init$h();
    $2e6f1e48aadbcba7$var$_init$g();
    $2e6f1e48aadbcba7$var$_init$7();
    $2e6f1e48aadbcba7$var$_init();
    $2e6f1e48aadbcba7$var$_init$9();
    $2e6f1e48aadbcba7$var$_init$d();
    $2e6f1e48aadbcba7$var$_init$e();
    $2e6f1e48aadbcba7$var$_init$6();
    $2e6f1e48aadbcba7$var$_init$8();
}
$2e6f1e48aadbcba7$var$init();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ToNativeJsConverter = function() {
    function ToNativeJsConverter(temporal, zone) {
        var zonedDateTime;
        if (temporal instanceof $2e6f1e48aadbcba7$export$fecec53969739358) {
            this.instant = temporal;
            return;
        } else if (temporal instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) {
            zone = zone == null ? $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atStartOfDay(zone);
        } else if (temporal instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) {
            zone = zone == null ? $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atZone(zone);
        } else if (temporal instanceof $2e6f1e48aadbcba7$export$d3b7288e7994edea) {
            if (zone == null) zonedDateTime = temporal;
            else zonedDateTime = temporal.withZoneSameInstant(zone);
        } else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("unsupported instance for convert operation:" + temporal);
        this.instant = zonedDateTime.toInstant();
    }
    var _proto = ToNativeJsConverter.prototype;
    _proto.toDate = function toDate() {
        return new Date(this.instant.toEpochMilli());
    };
    _proto.toEpochMilli = function toEpochMilli() {
        return this.instant.toEpochMilli();
    };
    return ToNativeJsConverter;
}();
function $2e6f1e48aadbcba7$export$9c68d69a4c5bbcf9(temporal, zone) {
    return new $2e6f1e48aadbcba7$var$ToNativeJsConverter(temporal, zone);
}
/*
 * @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$export$1f878d3ea5c30765(date, zone) {
    if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
    $2e6f1e48aadbcba7$var$requireNonNull(date, 'date');
    $2e6f1e48aadbcba7$var$requireNonNull(zone, 'zone');
    if (date instanceof Date) return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(date.getTime()).atZone(zone);
    else if (typeof date.toDate === 'function' && date.toDate() instanceof Date) return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(date.toDate().getTime()).atZone(zone);
    throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('date must be a javascript Date or a moment instance');
}
function $2e6f1e48aadbcba7$var$bindUse(jsJoda) {
    var used = [];
    return function use(fn) {
        if (!~used.indexOf(fn)) {
            fn(jsJoda);
            used.push(fn);
        }
        return jsJoda;
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$71511d61b312f219 = {
    assert: $2e6f1e48aadbcba7$var$assert$1,
    DateTimeBuilder: $2e6f1e48aadbcba7$var$DateTimeBuilder,
    DateTimeParseContext: $2e6f1e48aadbcba7$var$DateTimeParseContext,
    DateTimePrintContext: $2e6f1e48aadbcba7$var$DateTimePrintContext,
    MathUtil: $2e6f1e48aadbcba7$var$MathUtil,
    StringUtil: $2e6f1e48aadbcba7$var$StringUtil,
    StringBuilder: $2e6f1e48aadbcba7$var$StringBuilder
};
var $2e6f1e48aadbcba7$var$jsJodaExports = {
    _: $2e6f1e48aadbcba7$export$71511d61b312f219,
    convert: $2e6f1e48aadbcba7$export$9c68d69a4c5bbcf9,
    nativeJs: $2e6f1e48aadbcba7$export$1f878d3ea5c30765,
    ArithmeticException: $2e6f1e48aadbcba7$export$5891bcae38b5fd67,
    DateTimeException: $2e6f1e48aadbcba7$export$6058f27c7f907fb,
    DateTimeParseException: $2e6f1e48aadbcba7$export$ce8a206818942248,
    IllegalArgumentException: $2e6f1e48aadbcba7$export$86eb44ed3377dd8f,
    IllegalStateException: $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e,
    UnsupportedTemporalTypeException: $2e6f1e48aadbcba7$export$8fe6dec993229f58,
    NullPointerException: $2e6f1e48aadbcba7$export$b6ad7a1de4697efd,
    Clock: $2e6f1e48aadbcba7$export$9735c82c4bae3302,
    DayOfWeek: $2e6f1e48aadbcba7$export$7ed5ca4f8b987938,
    Duration: $2e6f1e48aadbcba7$export$3b11bc38611c5941,
    Instant: $2e6f1e48aadbcba7$export$fecec53969739358,
    LocalDate: $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6,
    LocalTime: $2e6f1e48aadbcba7$export$bf1071e344bea1d,
    LocalDateTime: $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff,
    OffsetTime: $2e6f1e48aadbcba7$export$a362394fcc906a80,
    OffsetDateTime: $2e6f1e48aadbcba7$export$f351e12f7a164fb5,
    Month: $2e6f1e48aadbcba7$export$951c8378cdfec6e6,
    MonthDay: $2e6f1e48aadbcba7$export$30964d9b15071608,
    ParsePosition: $2e6f1e48aadbcba7$export$56251aea61478734,
    Period: $2e6f1e48aadbcba7$export$67186dcd8fa4f92f,
    Year: $2e6f1e48aadbcba7$export$6ce2f08d515512,
    YearConstants: $2e6f1e48aadbcba7$export$c04b60057299af61,
    YearMonth: $2e6f1e48aadbcba7$export$b707805e12671f51,
    ZonedDateTime: $2e6f1e48aadbcba7$export$d3b7288e7994edea,
    ZoneOffset: $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3,
    ZoneId: $2e6f1e48aadbcba7$export$a514a0be1f00ef62,
    ZoneRegion: $2e6f1e48aadbcba7$export$9caa52e4e516e67d,
    ZoneOffsetTransition: $2e6f1e48aadbcba7$export$993d982a5ca9c76d,
    ZoneRules: $2e6f1e48aadbcba7$export$cbd9bcf3fad97817,
    ZoneRulesProvider: $2e6f1e48aadbcba7$export$79d73e02cd645302,
    ChronoLocalDate: $2e6f1e48aadbcba7$export$2a07e3472bc98879,
    ChronoLocalDateTime: $2e6f1e48aadbcba7$export$94e985176fb19d17,
    ChronoZonedDateTime: $2e6f1e48aadbcba7$export$e69f60c5a83f5572,
    IsoChronology: $2e6f1e48aadbcba7$export$f47ae290cf4e4958,
    ChronoField: $2e6f1e48aadbcba7$export$7f55a40756153c3e,
    ChronoUnit: $2e6f1e48aadbcba7$export$e61e212a4109fb8a,
    IsoFields: $2e6f1e48aadbcba7$export$2091a0730eb3b2d2,
    Temporal: $2e6f1e48aadbcba7$export$336849d529cb05e5,
    TemporalAccessor: $2e6f1e48aadbcba7$export$e5100310ee9cc158,
    TemporalAdjuster: $2e6f1e48aadbcba7$export$841f8bd48996924f,
    TemporalAdjusters: $2e6f1e48aadbcba7$export$d922854d56f8a965,
    TemporalAmount: $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff,
    TemporalField: $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9,
    TemporalQueries: $2e6f1e48aadbcba7$export$d6cc568434dfd9dc,
    TemporalQuery: $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff,
    TemporalUnit: $2e6f1e48aadbcba7$export$5d412a4bb789788e,
    ValueRange: $2e6f1e48aadbcba7$export$177e5e64bab4dec5,
    DateTimeFormatter: $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c,
    DateTimeFormatterBuilder: $2e6f1e48aadbcba7$export$81529fd372517959,
    DecimalStyle: $2e6f1e48aadbcba7$export$c1929c59b9e7d355,
    ResolverStyle: $2e6f1e48aadbcba7$export$2a833e4d13229d66,
    SignStyle: $2e6f1e48aadbcba7$export$b2e3a42c433c0b35,
    TextStyle: $2e6f1e48aadbcba7$export$1df879243bf2e42d
};
var $2e6f1e48aadbcba7$export$1f96ae73734a86cc = $2e6f1e48aadbcba7$var$bindUse($2e6f1e48aadbcba7$var$jsJodaExports);
$2e6f1e48aadbcba7$var$jsJodaExports.use = $2e6f1e48aadbcba7$export$1f96ae73734a86cc;


const $50008134581f4ead$export$6b862160d295c8e = (date)=>{
    const localDate = (0, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6).parse(date);
    return new Date(localDate.year(), localDate.monthValue() - 1, localDate.dayOfMonth(), 12, 0, 0);
};
const $50008134581f4ead$export$6f2ea9a35ec59703 = (date)=>{
    return new Date(date.year(), date.monthValue() - 1, date.dayOfMonth(), 12, 0, 0);
};
const $50008134581f4ead$export$588937bcd60ade55 = (dateTime)=>{
    const localDate = (0, $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff).parse(dateTime);
    return new Date(localDate.year(), localDate.monthValue() - 1, localDate.dayOfMonth(), 12, 0, 0);
};


/* eslint-disable no-restricted-syntax */ // Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds.
// Code is from:
// https://www.matthewgerstman.com/tech/throttle-and-debounce/
// Usage:
// 1. Wrap to be debounced function and save it into a new Function
// const debouncedFunc = debounce((str) => console.log(str), 200)
// 2. Call the function
// debouncedFunc("Hello World")
function $f21400ae50a90441$export$2e2bcd8739ae039(func, timeoutMillis) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = $parcel$global.setTimeout(()=>{
            func(...args);
        }, timeoutMillis);
    };
}


const $117bb602da9323ac$var$contactEmail = "cooperation-lines@flixbus.com";
var $117bb602da9323ac$export$2e2bcd8739ae039 = $117bb602da9323ac$var$contactEmail;


const $730d905258f96f17$var$calculatePagerPageNumber = (totalItems, pageSize)=>{
    return Math.ceil(totalItems / pageSize);
};
var $730d905258f96f17$export$2e2bcd8739ae039 = $730d905258f96f17$var$calculatePagerPageNumber;


const $fb7d4045e1236b72$var$correctOutOfBoundsPageSelection = (currentPageSizeAsNumber, totalItems, pagination, setPagination)=>{
    const amountOfExistingPages = (0, $730d905258f96f17$export$2e2bcd8739ae039)(totalItems, currentPageSizeAsNumber);
    if (amountOfExistingPages > 0 && pagination.page >= amountOfExistingPages) setPagination({
        ...pagination,
        page: amountOfExistingPages - 1
    });
};
var $fb7d4045e1236b72$export$2e2bcd8739ae039 = $fb7d4045e1236b72$var$correctOutOfBoundsPageSelection;


var $b6c6330f9af3214a$export$2e2bcd8739ae039 = (errorMessage)=>{
    const errorMessageWithoutDotAtEnd = errorMessage.endsWith(".") ? errorMessage.slice(0, -1) : errorMessage;
    const splitedErrorMessage = errorMessageWithoutDotAtEnd.split(":").pop();
    return splitedErrorMessage ? splitedErrorMessage.trim() : errorMessageWithoutDotAtEnd;
};


/*   
  In cases where we dont want data to be undefined while we reload data with Apollo we use this function. That is for example 
  the case when using fetchMore

  So if: 
  - Query loads for the first time. newData and prevData are undefined -> Returns undefined
  - Query has finished loading and value is available in cache -> Returns newData
  - Query in currently loading and data form the previous succesfull query is existing -> Returns prevData
  */ const $0d791f91139aeb0d$var$getLatestDefinedData = (newData, prevData)=>{
    if (newData !== undefined) return newData;
    else if (prevData !== undefined) return prevData;
    return undefined;
};
var $0d791f91139aeb0d$export$2e2bcd8739ae039 = $0d791f91139aeb0d$var$getLatestDefinedData;


const $e92cae15439e0402$export$3cbf91f22e6153ff = (existing, { args: args }, getNumberForPageSize)=>{
    const { pageSize: pageSize, page: page } = args.pageRequest;
    const limit = getNumberForPageSize(pageSize);
    const offset = page * limit;
    const expectedPageSize = existing ? Math.min(limit, existing.total - offset) : limit;
    const requestedSlice = existing ? existing.items.slice(offset, offset + expectedPageSize) : [];
    if (Object.values(requestedSlice).length !== expectedPageSize) return undefined;
    return {
        total: existing.total,
        items: requestedSlice
    };
};
const $e92cae15439e0402$export$ef62e76dbf8b59d7 = (existing, incoming, { args: args }, getNumberForPageSize)=>{
    const { pageSize: pageSize, page: page } = args.pageRequest;
    const limit = getNumberForPageSize(pageSize);
    const offset = page * limit;
    const merged = existing ? [
        ...existing.items
    ] : [];
    incoming.items.forEach((item, i)=>{
        merged[offset + i] = item;
    });
    return {
        total: incoming.total,
        items: merged
    };
};


const $ba4d0afcc1e98abc$var$scrollToTopOfElement = (ref)=>{
    const element = ref.current;
    if (element !== null && element.scrollTop > 0) element.scrollTo(0, 0);
};
var $ba4d0afcc1e98abc$export$2e2bcd8739ae039 = $ba4d0afcc1e98abc$var$scrollToTopOfElement;


const $eff69fb1886d6e36$var$sortLocales = (a, b)=>a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
const $eff69fb1886d6e36$export$1c0c86175370e5f0 = [
    {
        locale: "en_US",
        name: "English",
        flagName: "us",
        bcp47Locale: "en-US",
        iso6391: "en",
        drupal: "en-us"
    },
    {
        locale: "de",
        name: "Deutsch",
        flagName: "de",
        bcp47Locale: "de",
        iso6391: "de",
        drupal: "de"
    },
    {
        locale: "hr",
        name: "Hrvatski",
        flagName: "hr",
        bcp47Locale: "hr",
        iso6391: "hr",
        drupal: "hr"
    },
    {
        locale: "fr",
        name: "Fran\xe7ais",
        flagName: "fr",
        bcp47Locale: "fr",
        iso6391: "fr",
        drupal: "fr"
    },
    {
        locale: "it",
        name: "Italiano",
        flagName: "it",
        bcp47Locale: "it",
        iso6391: "it",
        drupal: "it"
    },
    {
        locale: "lv_LV",
        name: "Latvie\u0161u",
        flagName: "lv",
        bcp47Locale: "lv",
        iso6391: "lv",
        drupal: "lv"
    },
    {
        locale: "pl",
        name: "Polski",
        flagName: "pl",
        bcp47Locale: "pl",
        iso6391: "pl",
        drupal: "pl"
    },
    {
        locale: "pt_PT",
        name: "Portugu\xeas",
        flagName: "pt",
        bcp47Locale: "pt",
        iso6391: "pt",
        drupal: "pt-pt"
    },
    {
        locale: "pt_BR",
        name: "Portugu\xeas (Brasil)",
        flagName: "br",
        bcp47Locale: "pt-BR",
        iso6391: "pt",
        drupal: "pt-br"
    },
    {
        locale: "es",
        name: "Espa\xf1ol",
        flagName: "es",
        bcp47Locale: "es",
        iso6391: "es",
        drupal: "es"
    },
    {
        locale: "uk",
        name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        flagName: "ua",
        bcp47Locale: "uk",
        iso6391: "uk",
        drupal: "uk"
    },
    {
        locale: "tr",
        name: "T\xfcrk",
        flagName: "tr",
        bcp47Locale: "tr",
        iso6391: "tr",
        drupal: "tr"
    }
];
const $eff69fb1886d6e36$export$10e0e2046491126b = {
    locale: "en",
    name: "English",
    flagName: "eu",
    bcp47Locale: "en",
    iso6391: "en",
    drupal: "en-gl"
};
const $eff69fb1886d6e36$export$54fe0cd6fd82862e = [
    $eff69fb1886d6e36$export$10e0e2046491126b,
    {
        locale: "at",
        name: "Deutsch",
        flagName: "at",
        bcp47Locale: "de-AT",
        iso6391: "de",
        drupal: "de-at"
    },
    {
        locale: "bg",
        name: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438",
        flagName: "bg",
        bcp47Locale: "bg",
        iso6391: "bg",
        drupal: "bg"
    },
    {
        locale: "bs",
        name: "Bosanski",
        flagName: "ba",
        bcp47Locale: "bs",
        iso6391: "bs",
        drupal: "bs"
    },
    {
        locale: "ca",
        name: "Catal\xe0",
        flagName: "es-ct",
        bcp47Locale: "ca",
        iso6391: "ca",
        drupal: "ca"
    },
    {
        locale: "cs",
        name: "\u010Ce\u0161tina",
        flagName: "cz",
        bcp47Locale: "cs",
        iso6391: "cs",
        drupal: "cs"
    },
    {
        locale: "da",
        name: "Dansk",
        flagName: "dk",
        bcp47Locale: "da",
        iso6391: "da",
        drupal: "da"
    },
    {
        locale: "de",
        name: "Deutsch",
        flagName: "de",
        bcp47Locale: "de",
        iso6391: "de",
        drupal: "de"
    },
    {
        locale: "de_CH",
        name: "Deutsch",
        flagName: "ch",
        bcp47Locale: "de-CH",
        iso6391: "de",
        drupal: "de-ch"
    },
    {
        locale: "el",
        name: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        flagName: "gr",
        bcp47Locale: "el-GR",
        iso6391: "el",
        drupal: "el"
    },
    {
        locale: "en_CA",
        name: "English",
        flagName: "ca",
        bcp47Locale: "en-CA",
        iso6391: "en",
        drupal: "en-ca"
    },
    {
        locale: "en_GB",
        name: "English",
        flagName: "gb",
        bcp47Locale: "en-GB",
        iso6391: "en",
        drupal: "en-gb"
    },
    {
        locale: "en_IE",
        name: "English",
        flagName: "ie",
        bcp47Locale: "en-IE",
        iso6391: "en",
        drupal: "en-ie"
    },
    {
        locale: "en_IN",
        name: "English",
        flagName: "in",
        bcp47Locale: "en-IN",
        iso6391: "en",
        drupal: "en-in"
    },
    {
        locale: "en_US",
        name: "English",
        flagName: "us",
        bcp47Locale: "en-US",
        iso6391: "en",
        drupal: "en-us"
    },
    {
        locale: "es",
        name: "Espa\xf1ol",
        flagName: "es",
        bcp47Locale: "es",
        iso6391: "es",
        drupal: "es"
    },
    {
        locale: "es_CL",
        name: "Espa\xf1ol",
        flagName: "cl",
        bcp47Locale: "es-CL",
        iso6391: "es",
        drupal: "es-cl"
    },
    {
        locale: "es_MX",
        name: "Espa\xf1ol",
        flagName: "mx",
        bcp47Locale: "es-MX",
        iso6391: "es",
        drupal: "es-mx"
    },
    {
        locale: "es_US",
        name: "Espa\xf1ol",
        flagName: "us",
        bcp47Locale: "es-US",
        iso6391: "es",
        drupal: "es-us"
    },
    {
        locale: "et_EE",
        name: "Estonian",
        flagName: "ee",
        bcp47Locale: "et",
        iso6391: "et",
        drupal: "et"
    },
    {
        locale: "fi",
        name: "Suomi",
        flagName: "fi",
        bcp47Locale: "fi-FI",
        iso6391: "fi",
        drupal: "fi"
    },
    {
        locale: "fr",
        name: "Fran\xe7ais",
        flagName: "fr",
        bcp47Locale: "fr",
        iso6391: "fr",
        drupal: "fr"
    },
    {
        locale: "fr_BE",
        name: "Fran\xe7ais",
        flagName: "be",
        bcp47Locale: "fr-BE",
        iso6391: "fr",
        drupal: "fr-be"
    },
    {
        locale: "fr_CA",
        name: "Fran\xe7ais",
        flagName: "ca",
        bcp47Locale: "fr-CA",
        iso6391: "fr",
        drupal: "fr-ca"
    },
    {
        locale: "fr_CH",
        name: "Fran\xe7ais",
        flagName: "ch",
        bcp47Locale: "fr-CH",
        iso6391: "fr",
        drupal: "fr-ch"
    },
    {
        locale: "hr",
        name: "Hrvatski",
        flagName: "hr",
        bcp47Locale: "hr",
        iso6391: "hr",
        drupal: "hr"
    },
    {
        locale: "hu",
        name: "Magyar",
        flagName: "hu",
        bcp47Locale: "hu",
        iso6391: "hu",
        drupal: "hu"
    },
    {
        locale: "it",
        name: "Italiano",
        flagName: "it",
        bcp47Locale: "it",
        iso6391: "it",
        drupal: "it"
    },
    {
        locale: "it_CH",
        name: "Italiano",
        flagName: "ch",
        bcp47Locale: "it-CH",
        iso6391: "it",
        drupal: "it-ch"
    },
    {
        locale: "lt_LT",
        name: "Lietuvi\u0173",
        flagName: "lt",
        bcp47Locale: "lt",
        iso6391: "lt",
        drupal: "lt"
    },
    {
        locale: "lv_LV",
        name: "Latvie\u0161u",
        flagName: "lv",
        bcp47Locale: "lv",
        iso6391: "lv",
        drupal: "lv"
    },
    {
        locale: "mk",
        name: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438",
        flagName: "mk",
        bcp47Locale: "mk",
        iso6391: "mk",
        drupal: "mk"
    },
    {
        locale: "nl",
        name: "Nederlands",
        flagName: "nl",
        bcp47Locale: "nl",
        iso6391: "nl",
        drupal: "nl"
    },
    {
        locale: "nl_BE",
        name: "Nederlands",
        flagName: "be",
        bcp47Locale: "nl-BE",
        iso6391: "nl",
        drupal: "nl-be"
    },
    {
        locale: "no",
        name: "Norsk (bokm\xe5l)",
        flagName: "no",
        bcp47Locale: "nb",
        iso6391: "nb",
        drupal: "nb"
    },
    {
        locale: "pl",
        name: "Polski",
        flagName: "pl",
        bcp47Locale: "pl",
        iso6391: "pl",
        drupal: "pl"
    },
    {
        locale: "pt",
        name: "Portugu\xeas",
        flagName: "pt",
        bcp47Locale: "pt",
        iso6391: "pt",
        drupal: "pt-pt"
    },
    {
        locale: "pt_BR",
        name: "Portugu\xeas",
        flagName: "br",
        bcp47Locale: "pt-BR",
        iso6391: "pt",
        drupal: "pt-br"
    },
    {
        locale: "ro",
        name: "Rom\xe2n\u0103",
        flagName: "ro",
        bcp47Locale: "ro",
        iso6391: "ro",
        drupal: "ro"
    },
    {
        locale: "sk",
        name: "Sloven\u010Dina",
        flagName: "sk",
        bcp47Locale: "sk",
        iso6391: "sk",
        drupal: "sk"
    },
    {
        locale: "sl",
        name: "Sloven\u0161\u010Dina",
        flagName: "si",
        bcp47Locale: "sl",
        iso6391: "sl",
        drupal: "sl"
    },
    {
        locale: "sq",
        name: "Shqip",
        flagName: "al",
        bcp47Locale: "sq",
        iso6391: "sq",
        drupal: "sq"
    },
    {
        locale: "sr_Latn_RS",
        name: "Srpski",
        flagName: "rs",
        bcp47Locale: "sr",
        iso6391: "sr",
        drupal: "sr"
    },
    {
        locale: "sv",
        name: "Svenska",
        flagName: "se",
        bcp47Locale: "sv",
        iso6391: "sv",
        drupal: "sv"
    },
    {
        locale: "tr",
        name: "T\xfcrk\xe7e",
        flagName: "tr",
        bcp47Locale: "tr",
        iso6391: "tr",
        drupal: "tr"
    },
    {
        locale: "uk",
        name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        flagName: "ua",
        bcp47Locale: "uk",
        iso6391: "uk",
        drupal: "uk"
    },
    {
        locale: "zh_US",
        name: "\u4E2D\u6587",
        flagName: "us",
        bcp47Locale: "zh",
        iso6391: "zh",
        drupal: "zh-us"
    }
].sort($eff69fb1886d6e36$var$sortLocales);
const $eff69fb1886d6e36$export$e24640604b11ca0 = (locale, isInternal)=>{
    let currentLanguage;
    if (isInternal) currentLanguage = $eff69fb1886d6e36$export$1c0c86175370e5f0.find((l)=>l.locale === locale);
    else {
        let localeMappedToPhrase = locale;
        if (locale === "pt_PT") localeMappedToPhrase = "pt";
        currentLanguage = $eff69fb1886d6e36$export$54fe0cd6fd82862e.find((l)=>l.locale === localeMappedToPhrase);
    }
    return currentLanguage || $eff69fb1886d6e36$export$10e0e2046491126b;
};


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $ccbd6968dbb36c3b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$ccbd6968dbb36c3b$export$2e2bcd8739ae039 = $ccbd6968dbb36c3b$export$871608497c498473;


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $77dc29417ac8d032$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$77dc29417ac8d032$export$2e2bcd8739ae039 = $77dc29417ac8d032$export$e67a095c620b86fe;


function $ae5dedc3e6bc7894$export$1ea939691cdc45b8(date) {
    if (!(0, $ccbd6968dbb36c3b$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$ae5dedc3e6bc7894$export$2e2bcd8739ae039 = $ae5dedc3e6bc7894$export$1ea939691cdc45b8;



const $e53a64e8b1fa0c80$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $e53a64e8b1fa0c80$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $e53a64e8b1fa0c80$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $82aa69c14702147f$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $6c77c8df84810c56$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $6c77c8df84810c56$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6c77c8df84810c56$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6c77c8df84810c56$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $1fab2cf05b8cccda$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $1fab2cf05b8cccda$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$1fab2cf05b8cccda$var$formatRelativeLocale[token];


/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $b12404f6dcad3401$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $54b33a47c5274498$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $54b33a47c5274498$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $54b33a47c5274498$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $54b33a47c5274498$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $54b33a47c5274498$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $54b33a47c5274498$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $54b33a47c5274498$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $54b33a47c5274498$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $54b33a47c5274498$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $54b33a47c5274498$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $89a828c41b7e1bc3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $89a828c41b7e1bc3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $89a828c41b7e1bc3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $89a828c41b7e1bc3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $89a828c41b7e1bc3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern = /\d+/i;
const $6a38ab3f2b32c4bb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $6a38ab3f2b32c4bb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $6a38ab3f2b32c4bb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $6a38ab3f2b32c4bb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $6a38ab3f2b32c4bb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6a38ab3f2b32c4bb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern,
        parsePattern: $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $f45f4bcf38c4ce94$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $e53a64e8b1fa0c80$export$2c14ff85d6318973),
    formatLong: (0, $6c77c8df84810c56$export$cbf60ecb96cbb82f),
    formatRelative: (0, $1fab2cf05b8cccda$export$8fbbfd65594f46a0),
    localize: (0, $54b33a47c5274498$export$b3bd0bc58e36cd63),
    match: (0, $6a38ab3f2b32c4bb$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$f45f4bcf38c4ce94$export$2e2bcd8739ae039 = $f45f4bcf38c4ce94$export$137380d9ce54f7f;


let $6525066f50a2904f$var$defaultOptions = {};
function $6525066f50a2904f$export$430a3269e24b912e() {
    return $6525066f50a2904f$var$defaultOptions;
}
function $6525066f50a2904f$export$95365be1b0704abc(newOptions) {
    $6525066f50a2904f$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;



function $08eadd31071dba99$export$63fa379ae8a9ba2(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$08eadd31071dba99$export$2e2bcd8739ae039 = $08eadd31071dba99$export$63fa379ae8a9ba2;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $39c386bf2b2d4be8$export$113002b5eff6e430(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


function $30481ff49751e85f$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = startOfDayLeft.getTime() - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = startOfDayRight.getTime() - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / (0, $e24aa25ccaa7cb1c$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$30481ff49751e85f$export$2e2bcd8739ae039 = $30481ff49751e85f$export$4a02e9c37dab4871;



/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $9e6f0c9ad494c17a$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$9e6f0c9ad494c17a$export$2e2bcd8739ae039 = $9e6f0c9ad494c17a$export$ead8a1812b171991;


function $acbc1d0003a51961$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const _date = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$acbc1d0003a51961$export$2e2bcd8739ae039 = $acbc1d0003a51961$export$f91e89d3d0406102;



function $4312ea6469709b9b$export$d3b42cd8452deec(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const diff = (0, $30481ff49751e85f$export$4a02e9c37dab4871)(_date, (0, $acbc1d0003a51961$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$4312ea6469709b9b$export$2e2bcd8739ae039 = $4312ea6469709b9b$export$d3b42cd8452deec;





function $a6b650558c0d274a$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$a6b650558c0d274a$export$2e2bcd8739ae039 = $a6b650558c0d274a$export$42c81a444fbfb5d4;


function $80ab7b76dc31fb87$export$6173213f95a4431e(date) {
    return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$80ab7b76dc31fb87$export$2e2bcd8739ae039 = $80ab7b76dc31fb87$export$6173213f95a4431e;





function $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a5b0ea7a35e081a3$export$2e2bcd8739ae039 = $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc;




function $00ea35cfe8164ea9$export$236bdfa374eb69a9(date) {
    const year = (0, $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$00ea35cfe8164ea9$export$2e2bcd8739ae039 = $00ea35cfe8164ea9$export$236bdfa374eb69a9;



function $7e3321a3fdd64965$export$7cabdc5698b63e2f(date) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const diff = (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(_date).getTime() - (0, $00ea35cfe8164ea9$export$236bdfa374eb69a9)(_date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / (0, $e24aa25ccaa7cb1c$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$7e3321a3fdd64965$export$2e2bcd8739ae039 = $7e3321a3fdd64965$export$7cabdc5698b63e2f;










function $2a4c9a3ae7bb29a5$export$12d572480ceb6e58(date, options) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$2a4c9a3ae7bb29a5$export$2e2bcd8739ae039 = $2a4c9a3ae7bb29a5$export$12d572480ceb6e58;




function $ef995389f8e20dbc$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $2a4c9a3ae7bb29a5$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ef995389f8e20dbc$export$2e2bcd8739ae039 = $ef995389f8e20dbc$export$bb7b45bb8e74da0f;



function $ea960e7aff37061d$export$efe19b760242b2fc(date, options) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const diff = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(_date, options).getTime() - (0, $ef995389f8e20dbc$export$bb7b45bb8e74da0f)(_date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / (0, $e24aa25ccaa7cb1c$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$ea960e7aff37061d$export$2e2bcd8739ae039 = $ea960e7aff37061d$export$efe19b760242b2fc;



function $3f6840376f7c8255$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $aed2876e10bb3b8a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $3f6840376f7c8255$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $2733e62ab452f32f$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $2733e62ab452f32f$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $2a4c9a3ae7bb29a5$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $ea960e7aff37061d$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $7e3321a3fdd64965$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $4312ea6469709b9b$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        const originalDate = options._originalDate || date;
        const timestamp = originalDate.getTime();
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $2733e62ab452f32f$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $3f6840376f7c8255$export$c8306e720e213c0f)(minutes, 2);
}
function $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $3f6840376f7c8255$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $2733e62ab452f32f$var$formatTimezone(offset, delimiter);
}
function $2733e62ab452f32f$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(Math.floor(absOffset / 60), 2);
    const minutes = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $3d9918f67aabe98a$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3d9918f67aabe98a$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3d9918f67aabe98a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3d9918f67aabe98a$var$timeLongFormatter(timePattern, formatLong));
};
const $3d9918f67aabe98a$export$70cc8fd02856fd58 = {
    p: $3d9918f67aabe98a$var$timeLongFormatter,
    P: $3d9918f67aabe98a$var$dateTimeLongFormatter
};


const $8680c08594a744bc$var$dayOfYearTokenRE = /^D+$/;
const $8680c08594a744bc$var$weekYearTokenRE = /^Y+$/;
const $8680c08594a744bc$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8680c08594a744bc$export$c6cc36aa33304772(token) {
    return $8680c08594a744bc$var$dayOfYearTokenRE.test(token);
}
function $8680c08594a744bc$export$c6b49d6dceb604a1(token) {
    return $8680c08594a744bc$var$weekYearTokenRE.test(token);
}
function $8680c08594a744bc$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8680c08594a744bc$var$message(token, format, input);
    console.warn(_message);
    if ($8680c08594a744bc$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8680c08594a744bc$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $4d82c4193dc87874$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $4d82c4193dc87874$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $4d82c4193dc87874$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $4d82c4193dc87874$var$doubleQuoteRegExp = /''/g;
const $4d82c4193dc87874$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4d82c4193dc87874$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $f45f4bcf38c4ce94$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    if (!(0, $ae5dedc3e6bc7894$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    const result = formatStr.match($4d82c4193dc87874$var$longFormattingTokensRegExp).map(function(substring) {
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $3d9918f67aabe98a$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4d82c4193dc87874$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $4d82c4193dc87874$var$cleanEscapedString(substring);
        const formatter = (0, $2733e62ab452f32f$export$fe98a034cfb96d55)[firstCharacter];
        if (formatter) {
            if (!options?.useAdditionalWeekYearTokens && (0, $8680c08594a744bc$export$c6b49d6dceb604a1)(substring)) (0, $8680c08594a744bc$export$f5f38f90ecaaf879)(substring, formatStr, String(date));
            if (!options?.useAdditionalDayOfYearTokens && (0, $8680c08594a744bc$export$c6cc36aa33304772)(substring)) (0, $8680c08594a744bc$export$f5f38f90ecaaf879)(substring, formatStr, String(date));
            return formatter(originalDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4d82c4193dc87874$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4d82c4193dc87874$var$cleanEscapedString(input) {
    const matched = input.match($4d82c4193dc87874$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4d82c4193dc87874$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$4d82c4193dc87874$export$2e2bcd8739ae039 = $4d82c4193dc87874$export$d9468344d3651243;


const $4e02a20ce078235a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "halbe Minute",
        withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
const $4e02a20ce078235a$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $4e02a20ce078235a$var$formatDistanceLocale[token].withPreposition : $4e02a20ce078235a$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};



// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $15e8006f3dc7f915$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $15e8006f3dc7f915$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $15e8006f3dc7f915$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $15e8006f3dc7f915$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $15e8006f3dc7f915$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $15e8006f3dc7f915$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $15e8006f3dc7f915$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $e83fafded8675bbb$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $e83fafded8675bbb$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$e83fafded8675bbb$var$formatRelativeLocale[token];



const $e4b5d38f8d0834f6$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $e4b5d38f8d0834f6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e4b5d38f8d0834f6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const $e4b5d38f8d0834f6$var$formattingMonthValues = {
    narrow: $e4b5d38f8d0834f6$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $e4b5d38f8d0834f6$var$monthValues.wide
};
const $e4b5d38f8d0834f6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $e4b5d38f8d0834f6$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $e4b5d38f8d0834f6$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $e4b5d38f8d0834f6$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $e4b5d38f8d0834f6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e4b5d38f8d0834f6$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e4b5d38f8d0834f6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e4b5d38f8d0834f6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e4b5d38f8d0834f6$var$monthValues,
        formattingValues: $e4b5d38f8d0834f6$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e4b5d38f8d0834f6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e4b5d38f8d0834f6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e4b5d38f8d0834f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $2b424aa96b5d868b$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $2b424aa96b5d868b$var$parseOrdinalNumberPattern = /\d+/i;
const $2b424aa96b5d868b$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
const $2b424aa96b5d868b$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $2b424aa96b5d868b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $2b424aa96b5d868b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2b424aa96b5d868b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
const $2b424aa96b5d868b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $2b424aa96b5d868b$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
const $2b424aa96b5d868b$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $2b424aa96b5d868b$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
const $2b424aa96b5d868b$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        evening: /abends/i,
        night: /nachts/i
    }
};
const $2b424aa96b5d868b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $2b424aa96b5d868b$var$matchOrdinalNumberPattern,
        parsePattern: $2b424aa96b5d868b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $2b424aa96b5d868b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b424aa96b5d868b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $2b424aa96b5d868b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b424aa96b5d868b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $2b424aa96b5d868b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b424aa96b5d868b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $2b424aa96b5d868b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b424aa96b5d868b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $2b424aa96b5d868b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b424aa96b5d868b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $71f01aa224b3e90a$export$2fa162a495d26869 = {
    code: "de",
    formatDistance: (0, $4e02a20ce078235a$export$2c14ff85d6318973),
    formatLong: (0, $15e8006f3dc7f915$export$cbf60ecb96cbb82f),
    formatRelative: (0, $e83fafded8675bbb$export$8fbbfd65594f46a0),
    localize: (0, $e4b5d38f8d0834f6$export$b3bd0bc58e36cd63),
    match: (0, $2b424aa96b5d868b$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$71f01aa224b3e90a$export$2e2bcd8739ae039 = $71f01aa224b3e90a$export$2fa162a495d26869;

const $5ba43632354e87e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
const $5ba43632354e87e6$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $5ba43632354e87e6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};



const $334db27b947814ac$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $334db27b947814ac$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $334db27b947814ac$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $334db27b947814ac$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $334db27b947814ac$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $334db27b947814ac$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $334db27b947814ac$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $ca4963119fdca634$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $ca4963119fdca634$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
const $ca4963119fdca634$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $ca4963119fdca634$var$formatRelativeLocalePlural[token];
    else return $ca4963119fdca634$var$formatRelativeLocale[token];
};



const $6088d42b50ba756f$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
const $6088d42b50ba756f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $6088d42b50ba756f$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
const $6088d42b50ba756f$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
const $6088d42b50ba756f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
const $6088d42b50ba756f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
const $6088d42b50ba756f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $6088d42b50ba756f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6088d42b50ba756f$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $6088d42b50ba756f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $6088d42b50ba756f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $6088d42b50ba756f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $6088d42b50ba756f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $6088d42b50ba756f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6088d42b50ba756f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $a1311f5f1c9085ee$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $a1311f5f1c9085ee$var$parseOrdinalNumberPattern = /\d+/i;
const $a1311f5f1c9085ee$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const $a1311f5f1c9085ee$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
const $a1311f5f1c9085ee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $a1311f5f1c9085ee$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a1311f5f1c9085ee$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const $a1311f5f1c9085ee$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
const $a1311f5f1c9085ee$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const $a1311f5f1c9085ee$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
const $a1311f5f1c9085ee$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const $a1311f5f1c9085ee$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
const $a1311f5f1c9085ee$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $a1311f5f1c9085ee$var$matchOrdinalNumberPattern,
        parsePattern: $a1311f5f1c9085ee$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $a1311f5f1c9085ee$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1311f5f1c9085ee$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $a1311f5f1c9085ee$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1311f5f1c9085ee$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $a1311f5f1c9085ee$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1311f5f1c9085ee$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $a1311f5f1c9085ee$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1311f5f1c9085ee$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $a1311f5f1c9085ee$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a1311f5f1c9085ee$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $a1984019572062f4$export$ca5e4045a55e76d2 = {
    code: "es",
    formatDistance: (0, $5ba43632354e87e6$export$2c14ff85d6318973),
    formatLong: (0, $334db27b947814ac$export$cbf60ecb96cbb82f),
    formatRelative: (0, $ca4963119fdca634$export$8fbbfd65594f46a0),
    localize: (0, $6088d42b50ba756f$export$b3bd0bc58e36cd63),
    match: (0, $a1311f5f1c9085ee$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$a1984019572062f4$export$2e2bcd8739ae039 = $a1984019572062f4$export$ca5e4045a55e76d2;

const $a8b9f5afaebed923$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $a8b9f5afaebed923$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const form = $a8b9f5afaebed923$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};



const $06b6cc6bd460c7ea$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $06b6cc6bd460c7ea$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $06b6cc6bd460c7ea$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $06b6cc6bd460c7ea$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $06b6cc6bd460c7ea$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $06b6cc6bd460c7ea$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $06b6cc6bd460c7ea$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $7acdc7f8ca1a798a$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $7acdc7f8ca1a798a$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$7acdc7f8ca1a798a$var$formatRelativeLocale[token];



const $872dd4782b292903$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $872dd4782b292903$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $872dd4782b292903$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $872dd4782b292903$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $872dd4782b292903$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $872dd4782b292903$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $872dd4782b292903$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $872dd4782b292903$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $872dd4782b292903$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $872dd4782b292903$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $872dd4782b292903$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $872dd4782b292903$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $872dd4782b292903$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};




const $44d7658ff2d485bf$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $44d7658ff2d485bf$var$parseOrdinalNumberPattern = /\d+/i;
const $44d7658ff2d485bf$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $44d7658ff2d485bf$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $44d7658ff2d485bf$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $44d7658ff2d485bf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $44d7658ff2d485bf$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $44d7658ff2d485bf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $44d7658ff2d485bf$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $44d7658ff2d485bf$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $44d7658ff2d485bf$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $44d7658ff2d485bf$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $44d7658ff2d485bf$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $44d7658ff2d485bf$var$matchOrdinalNumberPattern,
        parsePattern: $44d7658ff2d485bf$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $44d7658ff2d485bf$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $44d7658ff2d485bf$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $44d7658ff2d485bf$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $44d7658ff2d485bf$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $44d7658ff2d485bf$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $44d7658ff2d485bf$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $44d7658ff2d485bf$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $44d7658ff2d485bf$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $44d7658ff2d485bf$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $44d7658ff2d485bf$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $a48cd7632cfffdd2$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: (0, $a8b9f5afaebed923$export$2c14ff85d6318973),
    formatLong: (0, $06b6cc6bd460c7ea$export$cbf60ecb96cbb82f),
    formatRelative: (0, $7acdc7f8ca1a798a$export$8fbbfd65594f46a0),
    localize: (0, $872dd4782b292903$export$b3bd0bc58e36cd63),
    match: (0, $44d7658ff2d485bf$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$a48cd7632cfffdd2$export$2e2bcd8739ae039 = $a48cd7632cfffdd2$export$acb2a88f7d552ebf;

const $b1fe59cf7e282b85$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $b1fe59cf7e282b85$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $b1fe59cf7e282b85$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};



const $30cd8f8e62ae35b5$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
const $30cd8f8e62ae35b5$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $30cd8f8e62ae35b5$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $30cd8f8e62ae35b5$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $30cd8f8e62ae35b5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $30cd8f8e62ae35b5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $30cd8f8e62ae35b5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $8a36d56fe8939c2a$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: "P"
};
const $8a36d56fe8939c2a$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    const format = $8a36d56fe8939c2a$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};



const $c932dc8c3c3dab0a$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
const $c932dc8c3c3dab0a$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $c932dc8c3c3dab0a$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
const $c932dc8c3c3dab0a$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
const $c932dc8c3c3dab0a$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $c932dc8c3c3dab0a$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $c932dc8c3c3dab0a$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $c932dc8c3c3dab0a$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $c932dc8c3c3dab0a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c932dc8c3c3dab0a$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $c932dc8c3c3dab0a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $c932dc8c3c3dab0a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $c932dc8c3c3dab0a$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c932dc8c3c3dab0a$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $c932dc8c3c3dab0a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $c932dc8c3c3dab0a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c932dc8c3c3dab0a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $c45196b4b8e8cecc$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $c45196b4b8e8cecc$var$parseOrdinalNumberPattern = /\d+/i;
const $c45196b4b8e8cecc$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
const $c45196b4b8e8cecc$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $c45196b4b8e8cecc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $c45196b4b8e8cecc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c45196b4b8e8cecc$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
const $c45196b4b8e8cecc$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
const $c45196b4b8e8cecc$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $c45196b4b8e8cecc$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $c45196b4b8e8cecc$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
const $c45196b4b8e8cecc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
const $c45196b4b8e8cecc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $c45196b4b8e8cecc$var$matchOrdinalNumberPattern,
        parsePattern: $c45196b4b8e8cecc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $c45196b4b8e8cecc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c45196b4b8e8cecc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $c45196b4b8e8cecc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c45196b4b8e8cecc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $c45196b4b8e8cecc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c45196b4b8e8cecc$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $c45196b4b8e8cecc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c45196b4b8e8cecc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $c45196b4b8e8cecc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c45196b4b8e8cecc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $434f55b7bc169140$export$b4adb3f464574dcf = {
    code: "hr",
    formatDistance: (0, $b1fe59cf7e282b85$export$2c14ff85d6318973),
    formatLong: (0, $30cd8f8e62ae35b5$export$cbf60ecb96cbb82f),
    formatRelative: (0, $8a36d56fe8939c2a$export$8fbbfd65594f46a0),
    localize: (0, $c932dc8c3c3dab0a$export$b3bd0bc58e36cd63),
    match: (0, $c45196b4b8e8cecc$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$434f55b7bc169140$export$2e2bcd8739ae039 = $434f55b7bc169140$export$b4adb3f464574dcf;

const $d84f55bd4deb2cb0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
const $d84f55bd4deb2cb0$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $d84f55bd4deb2cb0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};



const $534572b92a74b8b3$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $534572b92a74b8b3$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $534572b92a74b8b3$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $534572b92a74b8b3$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $534572b92a74b8b3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $534572b92a74b8b3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $534572b92a74b8b3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};



function $67a7203abf91c820$export$6ea683876c36b8d2(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(dateLeft, options);
    const dateRightStartOfWeek = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}
var // Fallback for modularized imports:
$67a7203abf91c820$export$2e2bcd8739ae039 = $67a7203abf91c820$export$6ea683876c36b8d2;


const $b4724835e5092732$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $b4724835e5092732$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $b4724835e5092732$var$weekdays[day] + " scorso alle' p";
    }
}
function $b4724835e5092732$var$thisWeek(day) {
    return "'" + $b4724835e5092732$var$weekdays[day] + " alle' p";
}
function $b4724835e5092732$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $b4724835e5092732$var$weekdays[day] + " prossimo alle' p";
    }
}
const $b4724835e5092732$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return $b4724835e5092732$var$thisWeek(day);
        else return $b4724835e5092732$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return $b4724835e5092732$var$thisWeek(day);
        else return $b4724835e5092732$var$nextWeek(day);
    },
    other: "P"
};
const $b4724835e5092732$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $b4724835e5092732$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};



const $075f56d22ec5bd38$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
const $075f56d22ec5bd38$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $075f56d22ec5bd38$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
const $075f56d22ec5bd38$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
const $075f56d22ec5bd38$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
const $075f56d22ec5bd38$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
const $075f56d22ec5bd38$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number);
};
const $075f56d22ec5bd38$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $075f56d22ec5bd38$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $075f56d22ec5bd38$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $075f56d22ec5bd38$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $075f56d22ec5bd38$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $075f56d22ec5bd38$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $075f56d22ec5bd38$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $075f56d22ec5bd38$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $d633937e9b2cb5dd$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $d633937e9b2cb5dd$var$parseOrdinalNumberPattern = /\d+/i;
const $d633937e9b2cb5dd$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
const $d633937e9b2cb5dd$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
const $d633937e9b2cb5dd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $d633937e9b2cb5dd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d633937e9b2cb5dd$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
const $d633937e9b2cb5dd$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d633937e9b2cb5dd$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
const $d633937e9b2cb5dd$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
const $d633937e9b2cb5dd$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
const $d633937e9b2cb5dd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
const $d633937e9b2cb5dd$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $d633937e9b2cb5dd$var$matchOrdinalNumberPattern,
        parsePattern: $d633937e9b2cb5dd$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $d633937e9b2cb5dd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d633937e9b2cb5dd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $d633937e9b2cb5dd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d633937e9b2cb5dd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $d633937e9b2cb5dd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d633937e9b2cb5dd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $d633937e9b2cb5dd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d633937e9b2cb5dd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $d633937e9b2cb5dd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d633937e9b2cb5dd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $f400068414e1fac5$export$3486a10f30cf1ee4 = {
    code: "it",
    formatDistance: (0, $d84f55bd4deb2cb0$export$2c14ff85d6318973),
    formatLong: (0, $534572b92a74b8b3$export$cbf60ecb96cbb82f),
    formatRelative: (0, $b4724835e5092732$export$8fbbfd65594f46a0),
    localize: (0, $075f56d22ec5bd38$export$b3bd0bc58e36cd63),
    match: (0, $d633937e9b2cb5dd$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$f400068414e1fac5$export$2e2bcd8739ae039 = $f400068414e1fac5$export$3486a10f30cf1ee4;

function $332122cb6f86af54$var$buildLocalizeTokenFn(schema) {
    return (count, options)=>{
        if (count === 1) {
            if (options?.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            const rem = count % 10 === 1 && count % 100 !== 11;
            if (options?.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
const $332122cb6f86af54$var$formatDistanceLocale = {
    lessThanXSeconds: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    xSeconds: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            "{{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xHours: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xDays: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "{{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "{{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $332122cb6f86af54$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
const $332122cb6f86af54$export$2c14ff85d6318973 = (token, count, options)=>{
    const result = $332122cb6f86af54$var$formatDistanceLocale[token](count, options);
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return "pirms " + result;
    }
    return result;
};



const $148c0b4bdf4cee90$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
const $148c0b4bdf4cee90$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $148c0b4bdf4cee90$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $148c0b4bdf4cee90$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $148c0b4bdf4cee90$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $148c0b4bdf4cee90$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $148c0b4bdf4cee90$var$dateTimeFormats,
        defaultWidth: "full"
    })
};



const $d2f013c7ed84b191$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
const $d2f013c7ed84b191$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $d2f013c7ed84b191$var$weekdays[date.getDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: (date, baseDate, options)=>{
        if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $d2f013c7ed84b191$var$weekdays[date.getDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: "P"
};
const $d2f013c7ed84b191$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $d2f013c7ed84b191$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};



const $b0c2d67bceb28b53$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
const $b0c2d67bceb28b53$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "tre\u0161ais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
const $b0c2d67bceb28b53$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
const $b0c2d67bceb28b53$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        "marts",
        "apr\u012Blis",
        "maijs",
        "j\u016Bnijs",
        "j\u016Blijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
const $b0c2d67bceb28b53$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "mart\u0101",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
const $b0c2d67bceb28b53$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdiena",
        "pirmdiena",
        "otrdiena",
        "tre\u0161diena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
const $b0c2d67bceb28b53$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
const $b0c2d67bceb28b53$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
const $b0c2d67bceb28b53$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
const $b0c2d67bceb28b53$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $b0c2d67bceb28b53$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b0c2d67bceb28b53$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b0c2d67bceb28b53$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b0c2d67bceb28b53$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $b0c2d67bceb28b53$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b0c2d67bceb28b53$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b0c2d67bceb28b53$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b0c2d67bceb28b53$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $b0c2d67bceb28b53$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b0c2d67bceb28b53$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b0c2d67bceb28b53$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $0ef2754c10220617$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $0ef2754c10220617$var$parseOrdinalNumberPattern = /\d+/i;
const $0ef2754c10220617$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
const $0ef2754c10220617$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
const $0ef2754c10220617$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
const $0ef2754c10220617$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
const $0ef2754c10220617$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
const $0ef2754c10220617$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $0ef2754c10220617$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
const $0ef2754c10220617$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
const $0ef2754c10220617$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
const $0ef2754c10220617$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $0ef2754c10220617$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $0ef2754c10220617$var$matchOrdinalNumberPattern,
        parsePattern: $0ef2754c10220617$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $0ef2754c10220617$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ef2754c10220617$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $0ef2754c10220617$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ef2754c10220617$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $0ef2754c10220617$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ef2754c10220617$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $0ef2754c10220617$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ef2754c10220617$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $0ef2754c10220617$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ef2754c10220617$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $45467934372e4307$export$54ca4d1eb7926f1 = {
    code: "lv",
    formatDistance: (0, $332122cb6f86af54$export$2c14ff85d6318973),
    formatLong: (0, $148c0b4bdf4cee90$export$cbf60ecb96cbb82f),
    formatRelative: (0, $d2f013c7ed84b191$export$8fbbfd65594f46a0),
    localize: (0, $b0c2d67bceb28b53$export$b3bd0bc58e36cd63),
    match: (0, $0ef2754c10220617$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$45467934372e4307$export$2e2bcd8739ae039 = $45467934372e4307$export$54ca4d1eb7926f1;

const $222d9f5401f4f018$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $222d9f5401f4f018$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    const rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    const rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $222d9f5401f4f018$var$declension(scheme, count, time) {
    const group = $222d9f5401f4f018$var$declensionGroup(scheme, count);
    const finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
const $222d9f5401f4f018$export$2c14ff85d6318973 = (token, count, options)=>{
    const scheme = $222d9f5401f4f018$var$formatDistanceLocale[token];
    if (!options?.addSuffix) return $222d9f5401f4f018$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $222d9f5401f4f018$var$declension(scheme, count, "future");
    else return $222d9f5401f4f018$var$declension(scheme, count, "past") + " temu";
};



const $680aa18d836a7eee$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $680aa18d836a7eee$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $680aa18d836a7eee$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $680aa18d836a7eee$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $680aa18d836a7eee$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $680aa18d836a7eee$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $680aa18d836a7eee$var$dateTimeFormats,
        defaultWidth: "full"
    })
};



const $5d754d4fa54e3259$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
const $5d754d4fa54e3259$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
const $5d754d4fa54e3259$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
const $5d754d4fa54e3259$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $5d754d4fa54e3259$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) adjectives = $5d754d4fa54e3259$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $5d754d4fa54e3259$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $5d754d4fa54e3259$var$adjectivesNextWeek;
    else throw new Error(`Cannot determine adjectives for token ${token}`);
    const day = date.getDay();
    const grammaticalGender = $5d754d4fa54e3259$var$dayGrammaticalGender[day];
    const adjective = adjectives[grammaticalGender];
    return `'${adjective}' eeee 'o' p`;
}
const $5d754d4fa54e3259$var$formatRelativeLocale = {
    lastWeek: $5d754d4fa54e3259$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $5d754d4fa54e3259$var$dayAndTimeWithAdjective,
    other: "P"
};
const $5d754d4fa54e3259$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $5d754d4fa54e3259$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};



const $b7cc944b65b66354$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
const $b7cc944b65b66354$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
const $b7cc944b65b66354$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
const $b7cc944b65b66354$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
const $b7cc944b65b66354$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $b7cc944b65b66354$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $b7cc944b65b66354$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
const $b7cc944b65b66354$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
const $b7cc944b65b66354$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $b7cc944b65b66354$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b7cc944b65b66354$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b7cc944b65b66354$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b7cc944b65b66354$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b7cc944b65b66354$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b7cc944b65b66354$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b7cc944b65b66354$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $b7cc944b65b66354$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $b7cc944b65b66354$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b7cc944b65b66354$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};




const $676f48f72a8339c4$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $676f48f72a8339c4$var$parseOrdinalNumberPattern = /\d+/i;
const $676f48f72a8339c4$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
const $676f48f72a8339c4$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
const $676f48f72a8339c4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
const $676f48f72a8339c4$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
const $676f48f72a8339c4$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
const $676f48f72a8339c4$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
const $676f48f72a8339c4$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
const $676f48f72a8339c4$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
const $676f48f72a8339c4$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
const $676f48f72a8339c4$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
const $676f48f72a8339c4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $676f48f72a8339c4$var$matchOrdinalNumberPattern,
        parsePattern: $676f48f72a8339c4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $676f48f72a8339c4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $676f48f72a8339c4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $676f48f72a8339c4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $676f48f72a8339c4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $676f48f72a8339c4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $676f48f72a8339c4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $676f48f72a8339c4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $676f48f72a8339c4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $676f48f72a8339c4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $676f48f72a8339c4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $1a2df3957c65e787$export$6ea5311eda92944f = {
    code: "pl",
    formatDistance: (0, $222d9f5401f4f018$export$2c14ff85d6318973),
    formatLong: (0, $680aa18d836a7eee$export$cbf60ecb96cbb82f),
    formatRelative: (0, $5d754d4fa54e3259$export$8fbbfd65594f46a0),
    localize: (0, $b7cc944b65b66354$export$b3bd0bc58e36cd63),
    match: (0, $676f48f72a8339c4$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$1a2df3957c65e787$export$2e2bcd8739ae039 = $1a2df3957c65e787$export$6ea5311eda92944f;

const $26f1da0f120628dc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $26f1da0f120628dc$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $26f1da0f120628dc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};



const $e5f58cd4ff694fe7$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
const $e5f58cd4ff694fe7$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $e5f58cd4ff694fe7$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e5f58cd4ff694fe7$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $e5f58cd4ff694fe7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $e5f58cd4ff694fe7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $e5f58cd4ff694fe7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $aa622f7afaf6fb16$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $aa622f7afaf6fb16$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    const format = $aa622f7afaf6fb16$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};



const $e9259b8389bfd576$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
const $e9259b8389bfd576$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $e9259b8389bfd576$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $e9259b8389bfd576$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $e9259b8389bfd576$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
const $e9259b8389bfd576$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
const $e9259b8389bfd576$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $e9259b8389bfd576$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e9259b8389bfd576$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9259b8389bfd576$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9259b8389bfd576$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9259b8389bfd576$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9259b8389bfd576$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9259b8389bfd576$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e9259b8389bfd576$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $daf90eff97856362$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
const $daf90eff97856362$var$parseOrdinalNumberPattern = /\d+/i;
const $daf90eff97856362$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
const $daf90eff97856362$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
const $daf90eff97856362$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
const $daf90eff97856362$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $daf90eff97856362$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $daf90eff97856362$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $daf90eff97856362$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
const $daf90eff97856362$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
const $daf90eff97856362$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
const $daf90eff97856362$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
const $daf90eff97856362$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $daf90eff97856362$var$matchOrdinalNumberPattern,
        parsePattern: $daf90eff97856362$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $daf90eff97856362$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf90eff97856362$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $daf90eff97856362$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf90eff97856362$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $daf90eff97856362$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf90eff97856362$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $daf90eff97856362$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf90eff97856362$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $daf90eff97856362$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $daf90eff97856362$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $04fe8634ce0e36dd$export$84175d5f1cb4e39d = {
    code: "pt",
    formatDistance: (0, $26f1da0f120628dc$export$2c14ff85d6318973),
    formatLong: (0, $e5f58cd4ff694fe7$export$cbf60ecb96cbb82f),
    formatRelative: (0, $aa622f7afaf6fb16$export$8fbbfd65594f46a0),
    localize: (0, $e9259b8389bfd576$export$b3bd0bc58e36cd63),
    match: (0, $daf90eff97856362$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$04fe8634ce0e36dd$export$2e2bcd8739ae039 = $04fe8634ce0e36dd$export$84175d5f1cb4e39d;

const $c83878f3f5594e30$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $c83878f3f5594e30$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $c83878f3f5594e30$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};



const $76b267524b2ac362$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $76b267524b2ac362$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $76b267524b2ac362$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $76b267524b2ac362$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $76b267524b2ac362$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $76b267524b2ac362$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $76b267524b2ac362$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $26d5486f07eb1a5b$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $26d5486f07eb1a5b$export$8fbbfd65594f46a0 = (token, date, _baseDate, _options)=>{
    const format = $26d5486f07eb1a5b$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};



const $e00474e35acbab99$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
const $e00474e35acbab99$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $e00474e35acbab99$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $e00474e35acbab99$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $e00474e35acbab99$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
const $e00474e35acbab99$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
const $e00474e35acbab99$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "week") return number + "\xaa";
    return number + "\xba";
};
const $e00474e35acbab99$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e00474e35acbab99$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e00474e35acbab99$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e00474e35acbab99$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e00474e35acbab99$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e00474e35acbab99$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e00474e35acbab99$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e00474e35acbab99$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $9b1ca50fe0d00d49$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
const $9b1ca50fe0d00d49$var$parseOrdinalNumberPattern = /\d+/i;
const $9b1ca50fe0d00d49$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
const $9b1ca50fe0d00d49$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
const $9b1ca50fe0d00d49$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $9b1ca50fe0d00d49$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9b1ca50fe0d00d49$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $9b1ca50fe0d00d49$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
const $9b1ca50fe0d00d49$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
const $9b1ca50fe0d00d49$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
const $9b1ca50fe0d00d49$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
const $9b1ca50fe0d00d49$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
const $9b1ca50fe0d00d49$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $9b1ca50fe0d00d49$var$matchOrdinalNumberPattern,
        parsePattern: $9b1ca50fe0d00d49$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $9b1ca50fe0d00d49$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9b1ca50fe0d00d49$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $9b1ca50fe0d00d49$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9b1ca50fe0d00d49$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $9b1ca50fe0d00d49$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9b1ca50fe0d00d49$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $9b1ca50fe0d00d49$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9b1ca50fe0d00d49$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $9b1ca50fe0d00d49$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9b1ca50fe0d00d49$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $8e42ae5917476c09$export$93dd81123f5ddbcd = {
    code: "pt-BR",
    formatDistance: (0, $c83878f3f5594e30$export$2c14ff85d6318973),
    formatLong: (0, $76b267524b2ac362$export$cbf60ecb96cbb82f),
    formatRelative: (0, $26d5486f07eb1a5b$export$8fbbfd65594f46a0),
    localize: (0, $e00474e35acbab99$export$b3bd0bc58e36cd63),
    match: (0, $9b1ca50fe0d00d49$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$8e42ae5917476c09$export$2e2bcd8739ae039 = $8e42ae5917476c09$export$93dd81123f5ddbcd;

const $e5b93ece0626a778$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
const $e5b93ece0626a778$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $e5b93ece0626a778$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};



const $37a1f0099e1f7cae$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
const $37a1f0099e1f7cae$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $37a1f0099e1f7cae$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $37a1f0099e1f7cae$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $37a1f0099e1f7cae$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $37a1f0099e1f7cae$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $37a1f0099e1f7cae$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $62e6dbc4a2cbda4f$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
const $62e6dbc4a2cbda4f$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$62e6dbc4a2cbda4f$var$formatRelativeLocale[token];



const $12e67af72f846fca$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
const $12e67af72f846fca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
const $12e67af72f846fca$var$monthValues = {
    narrow: [
        "O",
        "\u015E",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "\u015Eub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "A\u011Fu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "\u015Eubat",
        "Mart",
        "Nisan",
        "May\u0131s",
        "Haziran",
        "Temmuz",
        "A\u011Fustos",
        "Eyl\xfcl",
        "Ekim",
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
const $12e67af72f846fca$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        "Cuma",
        "Cumartesi"
    ]
};
const $12e67af72f846fca$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    }
};
const $12e67af72f846fca$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    }
};
const $12e67af72f846fca$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $12e67af72f846fca$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $12e67af72f846fca$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $12e67af72f846fca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $12e67af72f846fca$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $12e67af72f846fca$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $12e67af72f846fca$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $12e67af72f846fca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $12e67af72f846fca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $771607c66e68afb1$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $771607c66e68afb1$var$parseOrdinalNumberPattern = /\d+/i;
const $771607c66e68afb1$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
const $771607c66e68afb1$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
const $771607c66e68afb1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
const $771607c66e68afb1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
const $771607c66e68afb1$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
const $771607c66e68afb1$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
const $771607c66e68afb1$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
const $771607c66e68afb1$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
const $771607c66e68afb1$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
const $771607c66e68afb1$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
const $771607c66e68afb1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $771607c66e68afb1$var$matchOrdinalNumberPattern,
        parsePattern: $771607c66e68afb1$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $771607c66e68afb1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $771607c66e68afb1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $771607c66e68afb1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $771607c66e68afb1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $771607c66e68afb1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $771607c66e68afb1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $771607c66e68afb1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $771607c66e68afb1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $771607c66e68afb1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $771607c66e68afb1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $6c5cc9e1d7c8b578$export$72451b88a72ad9c2 = {
    code: "tr",
    formatDistance: (0, $e5b93ece0626a778$export$2c14ff85d6318973),
    formatLong: (0, $37a1f0099e1f7cae$export$cbf60ecb96cbb82f),
    formatRelative: (0, $62e6dbc4a2cbda4f$export$8fbbfd65594f46a0),
    localize: (0, $12e67af72f846fca$export$b3bd0bc58e36cd63),
    match: (0, $771607c66e68afb1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$6c5cc9e1d7c8b578$export$2e2bcd8739ae039 = $6c5cc9e1d7c8b578$export$72451b88a72ad9c2;

function $c60abedf1b0a632d$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $c60abedf1b0a632d$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $c60abedf1b0a632d$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $c60abedf1b0a632d$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $c60abedf1b0a632d$var$declension(scheme.past, count);
                else return $c60abedf1b0a632d$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $c60abedf1b0a632d$var$declension(scheme.regular, count);
    };
}
const $c60abedf1b0a632d$var$halfAtMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
const $c60abedf1b0a632d$var$formatDistanceLocale = {
    lessThanXSeconds: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $c60abedf1b0a632d$var$halfAtMinute,
    lessThanXMinutes: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $c60abedf1b0a632d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
const $c60abedf1b0a632d$export$2c14ff85d6318973 = (token, count, options)=>{
    options = options || {};
    return $c60abedf1b0a632d$var$formatDistanceLocale[token](count, options);
};



const $2681cff7b9171b35$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
const $2681cff7b9171b35$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $2681cff7b9171b35$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2681cff7b9171b35$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $2681cff7b9171b35$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $2681cff7b9171b35$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $2681cff7b9171b35$var$dateTimeFormats,
        defaultWidth: "full"
    })
};




const $895c9609edec31d9$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $895c9609edec31d9$var$lastWeek(day) {
    const weekday = $895c9609edec31d9$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $895c9609edec31d9$var$thisWeek(day) {
    const weekday = $895c9609edec31d9$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $895c9609edec31d9$var$nextWeek(day) {
    const weekday = $895c9609edec31d9$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
const $895c9609edec31d9$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return $895c9609edec31d9$var$thisWeek(day);
    else return $895c9609edec31d9$var$lastWeek(day);
};
const $895c9609edec31d9$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $67a7203abf91c820$export$6ea683876c36b8d2)(date, baseDate, options)) return $895c9609edec31d9$var$thisWeek(day);
    else return $895c9609edec31d9$var$nextWeek(day);
};
const $895c9609edec31d9$var$formatRelativeLocale = {
    lastWeek: $895c9609edec31d9$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $895c9609edec31d9$var$nextWeekFormat,
    other: "P"
};
const $895c9609edec31d9$export$8fbbfd65594f46a0 = (token, date, baseDate, options)=>{
    const format = $895c9609edec31d9$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};



const $e9150878b2d23a24$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
const $e9150878b2d23a24$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $e9150878b2d23a24$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
const $e9150878b2d23a24$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
const $e9150878b2d23a24$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $e9150878b2d23a24$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
const $e9150878b2d23a24$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
const $e9150878b2d23a24$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
const $e9150878b2d23a24$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e9150878b2d23a24$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9150878b2d23a24$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9150878b2d23a24$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9150878b2d23a24$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $e9150878b2d23a24$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9150878b2d23a24$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e9150878b2d23a24$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $e9150878b2d23a24$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $3ddf4b99a0031280$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
const $3ddf4b99a0031280$var$parseOrdinalNumberPattern = /\d+/i;
const $3ddf4b99a0031280$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
const $3ddf4b99a0031280$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $3ddf4b99a0031280$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
const $3ddf4b99a0031280$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3ddf4b99a0031280$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
const $3ddf4b99a0031280$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
const $3ddf4b99a0031280$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
const $3ddf4b99a0031280$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
const $3ddf4b99a0031280$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
const $3ddf4b99a0031280$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $3ddf4b99a0031280$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $3ddf4b99a0031280$var$matchOrdinalNumberPattern,
        parsePattern: $3ddf4b99a0031280$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $3ddf4b99a0031280$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ddf4b99a0031280$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $3ddf4b99a0031280$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ddf4b99a0031280$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $3ddf4b99a0031280$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ddf4b99a0031280$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $3ddf4b99a0031280$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ddf4b99a0031280$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $3ddf4b99a0031280$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ddf4b99a0031280$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $5d6836eaa34032e0$export$312745a8a3013c00 = {
    code: "uk",
    formatDistance: (0, $c60abedf1b0a632d$export$2c14ff85d6318973),
    formatLong: (0, $2681cff7b9171b35$export$cbf60ecb96cbb82f),
    formatRelative: (0, $895c9609edec31d9$export$8fbbfd65594f46a0),
    localize: (0, $e9150878b2d23a24$export$b3bd0bc58e36cd63),
    match: (0, $3ddf4b99a0031280$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$5d6836eaa34032e0$export$2e2bcd8739ae039 = $5d6836eaa34032e0$export$312745a8a3013c00;



const $944e98c5c54289c1$var$getCookieDomain = ()=>{
    return ".cooperation.flixbus.com";
};
const $944e98c5c54289c1$export$110700823644f4a6 = (cname, cvalue, exdays)=>{
    const expires = exdays ? `expires=${new Date(Date.now() + exdays * 86400000).toUTCString()}` : "";
    document.cookie = `${cname}=${cvalue};${expires};path=/;domain=${$944e98c5c54289c1$var$getCookieDomain()}`;
};
const $944e98c5c54289c1$export$4be65e66cfa2648a = (cname)=>{
    const name = `${cname}=`;
    const ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
};


const $61d5299c8c0ea66c$export$dcb45bc85ae9cf43 = "marketplace-language";
const $61d5299c8c0ea66c$export$68274e25c3f28c82 = ()=>(0, $944e98c5c54289c1$export$4be65e66cfa2648a)($61d5299c8c0ea66c$export$dcb45bc85ae9cf43) || "en_US";
const $61d5299c8c0ea66c$export$68682645b7684355 = (locale)=>{
    (0, $944e98c5c54289c1$export$110700823644f4a6)($61d5299c8c0ea66c$export$dcb45bc85ae9cf43, locale.locale, 10000);
    window.location.reload();
};


const $1f54b005b1dbfc2e$export$180605366c04f0cd = ()=>{
    switch((0, $61d5299c8c0ea66c$export$68274e25c3f28c82)()){
        case "de":
            return 0, $71f01aa224b3e90a$export$2fa162a495d26869;
        case "en_US":
            return 0, $f45f4bcf38c4ce94$export$137380d9ce54f7f;
        case "es":
            return 0, $a1984019572062f4$export$ca5e4045a55e76d2;
        case "fr":
            return 0, $a48cd7632cfffdd2$export$acb2a88f7d552ebf;
        case "hr":
            return 0, $434f55b7bc169140$export$b4adb3f464574dcf;
        case "it":
            return 0, $f400068414e1fac5$export$3486a10f30cf1ee4;
        case "lv_LV":
            return 0, $45467934372e4307$export$54ca4d1eb7926f1;
        case "pl":
            return 0, $1a2df3957c65e787$export$6ea5311eda92944f;
        case "pt_PT":
            return 0, $04fe8634ce0e36dd$export$84175d5f1cb4e39d;
        case "pt_BR":
            return 0, $8e42ae5917476c09$export$93dd81123f5ddbcd;
        case "tr":
            return 0, $6c5cc9e1d7c8b578$export$72451b88a72ad9c2;
        case "uk":
            return 0, $5d6836eaa34032e0$export$312745a8a3013c00;
        default:
            return 0, $f45f4bcf38c4ce94$export$137380d9ce54f7f;
    }
};
const $1f54b005b1dbfc2e$export$ea26e1acb089409 = (date)=>{
    if (typeof date === "string") return (0, $4d82c4193dc87874$export$d9468344d3651243)((0, $50008134581f4ead$export$6b862160d295c8e)(date), "PP", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "PP", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$49d7e406c8c8de5b = (date)=>{
    if (typeof date === "string") return (0, $4d82c4193dc87874$export$d9468344d3651243)(new Date(date), "PPp", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "PPp", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$cab0efee452e38f7 = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "MMM", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$e7d21bbf4cde0abf = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "MMM d", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$a2f8112a3428e0ab = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "MMMM yyyy", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$6eafc686ed354076 = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "iii, PP", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$b14f51f013fa1a38 = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "iii", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};
const $1f54b005b1dbfc2e$export$d2261a91aba8995f = (date)=>{
    return (0, $4d82c4193dc87874$export$d9468344d3651243)(date, "d", {
        locale: $1f54b005b1dbfc2e$export$180605366c04f0cd()
    });
};


var $cbcea9a160c7d75b$export$2e2bcd8739ae039 = (text)=>text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();




var $138804ff4b365ce0$var$DataReportType = /*#__PURE__*/ function(DataReportType) {
    DataReportType["GrossRevenue"] = "gross-revenue";
    DataReportType["SegmentDistance"] = "segment-distance";
    return DataReportType;
}($138804ff4b365ce0$var$DataReportType || {});
var $138804ff4b365ce0$export$2e2bcd8739ae039 = $138804ff4b365ce0$var$DataReportType;



/**
 * @param ref React Reference to the Element which position should be measured
 *
 * @return [topIsInViewport, rightIsInViewport, bottomIsInViewport, leftIsInViewport]
 
 *          topIsInViewport is the top edge of the element within the viewport
 *          rightIsInViewport is the right edge of the element within the viewport
 *          bottomIsInViewport is the bottom edge of the element within the viewport
 *          leftIsInViewport is the left edge of the element within the viewport
 */ const $662fbf456dde6253$var$isElementInViewport = (ref)=>{
    const rect = ref.current.getBoundingClientRect();
    return [
        rect.top >= 0,
        rect.right <= (window.innerWidth || document.documentElement.clientWidth),
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
        rect.left >= 0
    ];
};
var $662fbf456dde6253$export$2e2bcd8739ae039 = $662fbf456dde6253$var$isElementInViewport;


var $173744dd3ec940db$export$2e2bcd8739ae039 = (enumSrc, value)=>{
    return Object.values(enumSrc).includes(value);
};



const $e1c511ceac8bc405$var$supportedGetParams = [
    // MPC
    "partner",
    "line",
    "schedule",
    "token",
    "id_token",
    "access_token",
    "forbidden_relations",
    "country",
    "status",
    "station_id",
    "station_name",
    // MPO
    "date",
    "returnTo",
    "lineId",
    "departureStationId",
    "departureTime",
    "startDate",
    "endDate",
    "departureDays",
    "tracking_channel",
    "report",
    "page",
    "pageSize",
    "sortBy",
    "sort"
];
const $e1c511ceac8bc405$export$37cfcd9117b95f2b = (query, isGetParams = true)=>{
    const delimiter = isGetParams ? "?" : "#";
    const params = {};
    const res = new URLSearchParams(query.split(delimiter)[1]);
    $e1c511ceac8bc405$var$supportedGetParams.forEach((key)=>{
        const value = res.get(key) || "";
        if (value.length > 0) params[key] = value;
    });
    return params;
};


const $52df5c4abbb4e89e$var$removeItemFormArray = (arr, value)=>{
    const newArr = [
        ...arr
    ];
    const index = arr.indexOf(value);
    if (index > -1) newArr.splice(index, 1);
    return newArr;
};
var $52df5c4abbb4e89e$export$2e2bcd8739ae039 = $52df5c4abbb4e89e$var$removeItemFormArray;



const $3148ac12565e8f12$var$serviceDesk = "https://flixtech.atlassian.net/servicedesk/customer/portal/38";
const $3148ac12565e8f12$var$serviceDeskPlatformBusiness = "https://flixtech.atlassian.net/servicedesk/customer/portal/1631";
const $3148ac12565e8f12$var$musLocation = `${"/myaccount"}`;
const $3148ac12565e8f12$export$b4aa7c009839d9f1 = {
    userHome: "/",
    // Links to MPP application
    mpp: "https://mpp.flixbus.com",
    serviceDesk: // Internal links to service desk
    $3148ac12565e8f12$var$serviceDesk,
    serviceDeskRequestLogin: `${$3148ac12565e8f12$var$serviceDesk}/group/77/create/363`,
    serviceDeskReportProblem: `${$3148ac12565e8f12$var$serviceDesk}/group/77/create/349`,
    serviceDeskPlatformBusiness: // Internal link to service desk of platform business
    $3148ac12565e8f12$var$serviceDeskPlatformBusiness,
    // Links to MUS application
    mus: $3148ac12565e8f12$var$musLocation
};
const $3148ac12565e8f12$var$mpcLocation = `${"/connect"}`;
const $3148ac12565e8f12$var$opsLocation = `${"/ops"}`;
const $3148ac12565e8f12$export$27b666feebe4ad6b = {
    userHome: $3148ac12565e8f12$var$mpcLocation,
    capacityManager: "/",
    bookingInfo: "/reports",
    dataReports: "/data-reports",
    faq: "/faq",
    faqArticle: "/faq/:articleId",
    bookingReportsDownload: "/reports/download",
    partnerOverview: "/partners",
    partnerOverviewWithReturnLocation: (pathname)=>`/partners?returnTo=${pathname}`,
    // Links to MPC application
    mpc: $3148ac12565e8f12$var$mpcLocation,
    showStations: `${$3148ac12565e8f12$var$mpcLocation}/stations`,
    paxList: "/checkin/:rideId"
};
const $3148ac12565e8f12$export$ef70d4ce339359f4 = {
    userHome: $3148ac12565e8f12$export$b4aa7c009839d9f1.userHome,
    createPartner: "/partner/new",
    showPartnerDetail: "/partner/:partnerId",
    createLine: "/line/new",
    showLineDetail: "/line/:lineId",
    createSchedule: "/schedule/new",
    showScheduleDetail: "/schedule/:scheduleId",
    showStations: "/stations",
    showCountries: "/countries",
    // Links to MPO application
    capacityManager: $3148ac12565e8f12$var$opsLocation,
    bookingInfo: `${$3148ac12565e8f12$var$opsLocation}/reports`,
    faq: `${$3148ac12565e8f12$var$opsLocation}/faq`,
    dataReports: `${$3148ac12565e8f12$var$opsLocation}/data-reports`,
    // Links to MPP application
    mpp: $3148ac12565e8f12$export$b4aa7c009839d9f1.mpp,
    // Internal links to service desk
    serviceDesk: $3148ac12565e8f12$export$b4aa7c009839d9f1.serviceDesk
};
const $3148ac12565e8f12$export$6ef3d755bebf7e79 = {
    userHome: $3148ac12565e8f12$var$mpcLocation,
    // Links to MPO application
    capacityManager: $3148ac12565e8f12$var$opsLocation,
    bookingInfo: `${$3148ac12565e8f12$var$opsLocation}/reports`,
    faq: `${$3148ac12565e8f12$var$opsLocation}/faq`,
    dataReports: `${$3148ac12565e8f12$var$opsLocation}/data-reports`,
    // Links to MPC application
    mpc: $3148ac12565e8f12$var$mpcLocation,
    showStations: `${$3148ac12565e8f12$var$mpcLocation}/stations`,
    // Links to MPP application
    mpp: $3148ac12565e8f12$export$b4aa7c009839d9f1.mpp
};


// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $02443dfd16cf74b4$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $02443dfd16cf74b4$var$forEach, slice: $02443dfd16cf74b4$var$slice } = Array.prototype;
const { hasOwnProperty: $02443dfd16cf74b4$var$hasOwnProperty } = Object.prototype;
class $02443dfd16cf74b4$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $02443dfd16cf74b4$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $02443dfd16cf74b4$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $02443dfd16cf74b4$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($02443dfd16cf74b4$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($02443dfd16cf74b4$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $02443dfd16cf74b4$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $02443dfd16cf74b4$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $02443dfd16cf74b4$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


function $557c26506c40b8f1$var$defaultDispose() {}
class $557c26506c40b8f1$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $557c26506c40b8f1$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $1b7dab7b0d0a41be$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $1b7dab7b0d0a41be$var$MISSING_VALUE = {};
let $1b7dab7b0d0a41be$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $1b7dab7b0d0a41be$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $1b7dab7b0d0a41be$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $1b7dab7b0d0a41be$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $1b7dab7b0d0a41be$var$MISSING_VALUE) break;
                if (context !== $1b7dab7b0d0a41be$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($1b7dab7b0d0a41be$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = $1b7dab7b0d0a41be$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $1b7dab7b0d0a41be$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $1b7dab7b0d0a41be$var$currentContext;
            $1b7dab7b0d0a41be$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $1b7dab7b0d0a41be$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $1b7dab7b0d0a41be$var$currentContext;
            return function() {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($1b7dab7b0d0a41be$var$currentContext) {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $1b7dab7b0d0a41be$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $1b7dab7b0d0a41be$var$globalKey = "@wry/context:Slot";
const $1b7dab7b0d0a41be$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$1b7dab7b0d0a41be$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$1b7dab7b0d0a41be$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $1b7dab7b0d0a41be$var$globalHost = $1b7dab7b0d0a41be$var$host;
const $1b7dab7b0d0a41be$export$8c6ed5c666ac1360 = $1b7dab7b0d0a41be$var$globalHost[$1b7dab7b0d0a41be$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$1b7dab7b0d0a41be$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($1b7dab7b0d0a41be$var$globalHost, $1b7dab7b0d0a41be$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($1b7dab7b0d0a41be$var$makeSlotClass());


const { bind: $1f2d3d2c6c19c650$export$2385a24977818dd0, noContext: $1f2d3d2c6c19c650$export$9fa6f2e300a97f8 } = (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360);
function $1f2d3d2c6c19c650$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($1f2d3d2c6c19c650$export$2385a24977818dd0(callback), delay);
}
function $1f2d3d2c6c19c650$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.next);
        const boundThrow = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($1f2d3d2c6c19c650$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $1f2d3d2c6c19c650$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $1f2d3d2c6c19c650$var$wrappedFibers = [];
function $1f2d3d2c6c19c650$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($1f2d3d2c6c19c650$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $1f2d3d2c6c19c650$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $1f2d3d2c6c19c650$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
function $ef3c9a5ce6618ec2$export$d906efd39458576(fn) {
    return $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $ad641868d96e626a$export$5a15a386532a5ea4 } = Object.prototype;
const $ad641868d96e626a$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $ad641868d96e626a$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $2a376116df8c597f$var$emptySetPool = [];
const $2a376116df8c597f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $2a376116df8c597f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $2a376116df8c597f$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $2a376116df8c597f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $2a376116df8c597f$var$valueCopy(value) {
    return value.slice(0);
}
class $2a376116df8c597f$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$2a376116df8c597f$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$2a376116df8c597f$var$mightBeDirty(this)) {
            $2a376116df8c597f$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $2a376116df8c597f$var$assert(!this.recomputing, "already recomputing");
        $2a376116df8c597f$var$rememberParent(this);
        return $2a376116df8c597f$var$mightBeDirty(this) ? $2a376116df8c597f$var$reallyRecompute(this, args) : $2a376116df8c597f$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $2a376116df8c597f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $ad641868d96e626a$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $2a376116df8c597f$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $2a376116df8c597f$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $2a376116df8c597f$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $2a376116df8c597f$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $2a376116df8c597f$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$2a376116df8c597f$export$3bb977b3ba9d3b59.count = 0;
function $2a376116df8c597f$var$rememberParent(child) {
    const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($2a376116df8c597f$var$mightBeDirty(child)) $2a376116df8c597f$var$reportDirtyChild(parent, child);
        else $2a376116df8c597f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $2a376116df8c597f$var$reallyRecompute(entry, args) {
    $2a376116df8c597f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).withValue(entry, $2a376116df8c597f$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($2a376116df8c597f$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $2a376116df8c597f$var$setClean(entry);
    return $2a376116df8c597f$var$valueGet(entry.value);
}
function $2a376116df8c597f$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $2a376116df8c597f$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$2a376116df8c597f$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $2a376116df8c597f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $2a376116df8c597f$var$setClean(entry) {
    entry.dirty = false;
    if ($2a376116df8c597f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $2a376116df8c597f$var$reportClean(entry);
}
function $2a376116df8c597f$var$reportDirty(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportDirtyChild);
}
function $2a376116df8c597f$var$reportClean(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportCleanChild);
}
function $2a376116df8c597f$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $ad641868d96e626a$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $2a376116df8c597f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert($2a376116df8c597f$var$mightBeDirty(child));
    const parentWasClean = !$2a376116df8c597f$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $2a376116df8c597f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $2a376116df8c597f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $2a376116df8c597f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert(!$2a376116df8c597f$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $2a376116df8c597f$var$valueCopy(child.value));
    else if (!$2a376116df8c597f$var$valueIs(childValue, child.value)) parent.setDirty();
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
    if ($2a376116df8c597f$var$mightBeDirty(parent)) return;
    $2a376116df8c597f$var$reportClean(parent);
}
function $2a376116df8c597f$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($2a376116df8c597f$var$emptySetPool.length < $2a376116df8c597f$var$POOL_TARGET_SIZE) $2a376116df8c597f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $2a376116df8c597f$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $2a376116df8c597f$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $2a376116df8c597f$var$assert(parent.dirtyChildren === null);
}
function $2a376116df8c597f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
}
function $2a376116df8c597f$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $ad641868d96e626a$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $f96bffcf733fdbbf$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $f96bffcf733fdbbf$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $ad641868d96e626a$export$5a15a386532a5ea4).call($f96bffcf733fdbbf$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $0fc5e093b69637b4$var$defaultKeyTrie;
function $0fc5e093b69637b4$export$cd3144f8dd136006(...args) {
    const trie = $0fc5e093b69637b4$var$defaultKeyTrie || ($0fc5e093b69637b4$var$defaultKeyTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $0fc5e093b69637b4$var$caches = new Set();
function $0fc5e093b69637b4$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $0fc5e093b69637b4$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $2a376116df8c597f$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $0fc5e093b69637b4$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).hasValue()) {
            $0fc5e093b69637b4$var$caches.forEach((cache)=>cache.clean());
            $0fc5e093b69637b4$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


var $0b37964519c908de$export$ac9723609f5c76c2 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
var $0b37964519c908de$var$cacheInfoMap = new WeakMap();
function $0b37964519c908de$var$getCacheInfo(cache) {
    var info = $0b37964519c908de$var$cacheInfoMap.get(cache);
    if (!info) $0b37964519c908de$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)()
    });
    return info;
}
function $0b37964519c908de$export$cbe12faed7725318(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $0b37964519c908de$export$f342bdd61b3e9412(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $0b37964519c908de$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $0b37964519c908de$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $0b37964519c908de$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $0b37964519c908de$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $0b37964519c908de$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $0b37964519c908de$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $0b37964519c908de$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}



const $0cba5a2b438c2f8b$export$eb80e1beaa8dacf8 = "marketplace-theme";
const $0cba5a2b438c2f8b$export$5a63ccfbe4d87ef0 = ()=>{
    const cookieValue = (0, $944e98c5c54289c1$export$4be65e66cfa2648a)($0cba5a2b438c2f8b$export$eb80e1beaa8dacf8);
    switch(cookieValue){
        case "light":
            return false;
        case "dark":
            return true;
        default:
            return window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)").matches : false;
    }
};
const $0cba5a2b438c2f8b$export$5039a765c4bdf70f = (newSetting)=>{
    (0, $944e98c5c54289c1$export$110700823644f4a6)($0cba5a2b438c2f8b$export$eb80e1beaa8dacf8, newSetting, 90);
};
const $0cba5a2b438c2f8b$export$9f25c19833cd15c8 = (0, $0b37964519c908de$export$5345c8ac69b4a9db)($0cba5a2b438c2f8b$export$5a63ccfbe4d87ef0());
const $0cba5a2b438c2f8b$export$93d4e7f90805808f = ()=>{
    const isDark = (0, $550d697bbc914bec$export$b10e3d92c03f6472)($0cba5a2b438c2f8b$export$9f25c19833cd15c8);
    const toggleTheme = ()=>{
        const newValue = !isDark;
        $0cba5a2b438c2f8b$export$9f25c19833cd15c8(newValue);
        $0cba5a2b438c2f8b$export$5039a765c4bdf70f(newValue ? "dark" : "light");
    };
    return [
        isDark,
        toggleTheme
    ];
};


var $6e7b8bb89b9ade82$var$Breakpoint = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["XXS"] = 0] = "XXS";
    Breakpoint[Breakpoint["XS"] = 390] = "XS";
    Breakpoint[Breakpoint["SM"] = 600] = "SM";
    Breakpoint[Breakpoint["MD"] = 768] = "MD";
    Breakpoint[Breakpoint["LG"] = 1024] = "LG";
    Breakpoint[Breakpoint["XL"] = 1200] = "XL";
    return Breakpoint;
}($6e7b8bb89b9ade82$var$Breakpoint || {});
var $6e7b8bb89b9ade82$export$2e2bcd8739ae039 = $6e7b8bb89b9ade82$var$Breakpoint;


const $da9185fabec4bff7$export$b521c1e8c94b7265 = (wrapper, expectedBreakpoint, expectedChildren, position = 0)=>{
    expectedChildren.forEach((child)=>{
        // @ts-ignore toContainMatchingElement is coming from jest-enzyme and all projects using
        // RTL complain about it. Thats why we need to ignore it.
        expect(wrapper.find("ResponsiveRenderer").at(position)).toContainMatchingElement(child);
    });
    expectedBreakpoint.forEach((breakpoint)=>{
        expect(wrapper.find("ResponsiveRenderer").at(position).prop("hidden")).toContain(breakpoint);
    });
};
const $da9185fabec4bff7$export$e3dc2574efb33e85 = (wrapper, expectedId, expectedValues, position = 0)=>{
    // @ts-ignore toContainMatchingElement is coming from jest-enzyme and all projects using
    // RTL complain about it. Thats why we need to ignore it.
    expect(wrapper).toContainMatchingElement("FormattedMessage");
    expect(wrapper.find("FormattedMessage").at(position).prop("id")).toBe(expectedId);
    if (expectedValues) expect(wrapper.find("FormattedMessage").at(position).prop("values")).toEqual(expectedValues);
};


const $fc1c75be27f34222$var$dlPush = (args)=>{
    window.dataLayer = window.dataLayer ? window.dataLayer : [];
    window.dataLayer.push(args);
};
var $fc1c75be27f34222$export$2e2bcd8739ae039 = $fc1c75be27f34222$var$dlPush;


var $bccbf5d1aa5ab54f$export$2e2bcd8739ae039 = (ref)=>{
    if (ref.current) {
        const elements = ref.current.children;
        return Array.from(elements).some((element)=>element.scrollWidth > element.clientWidth);
    }
    return false;
};



var $1bff4b63b9011559$export$8757f577d4b14917 = /*#__PURE__*/ function(TrackingChannel) {
    TrackingChannel[TrackingChannel["Mail"] = 0] = "Mail";
    return TrackingChannel;
}({});
const $1bff4b63b9011559$export$43a1c00151a29d78 = (url = window.location.href)=>{
    const uriParams = (0, $e1c511ceac8bc405$export$37cfcd9117b95f2b)(url);
    return {
        channel: uriParams.tracking_channel === "mail" ? 0 : undefined
    };
};



const $b10d2992255ab947$export$58eacdd7158b2a77 = "yyyy-MM-dd";
const $b10d2992255ab947$export$be046e18778dd817 = (date)=>{
    return (0, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6).of(date.getFullYear(), date.getMonth() + 1, date.getDate()).format((0, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c).ofPattern($b10d2992255ab947$export$58eacdd7158b2a77));
};
const $b10d2992255ab947$export$f30c6b279b3bcc10 = (date)=>{
    if (date) return (0, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6).parse(date).format((0, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c).ofPattern($b10d2992255ab947$export$58eacdd7158b2a77));
    return (0, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6).now().format((0, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c).ofPattern($b10d2992255ab947$export$58eacdd7158b2a77));
};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $32e8132807e4a3fa$export$18ce0697a983be9b = function() {
    $32e8132807e4a3fa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32e8132807e4a3fa$export$18ce0697a983be9b.apply(this, arguments);
};
function $32e8132807e4a3fa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $32e8132807e4a3fa$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");

var $6e0a0c7f0bf054d5$var$IconSize = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    'cover'
];
var $6e0a0c7f0bf054d5$export$f04a61298a47a40f = function Icon(_a) {
    var appearance = _a.appearance, extraClasses = _a.extraClasses, InlineIcon = _a.InlineIcon, size = _a.size, title = _a.title, fillCanvas = _a.fillCanvas, ariaHidden = _a["aria-hidden"], ariaLabel = _a["aria-label"], rest = (0, $32e8132807e4a3fa$export$3c9a16f847548506)(_a, [
        "appearance",
        "extraClasses",
        "InlineIcon",
        "size",
        "title",
        "fillCanvas",
        'aria-hidden',
        'aria-label'
    ]);
    var DEFAULT_SPACING_MULTIPLIER = 6;
    var customStyle = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, rest).style;
    // since the styles are minimal we can inline them minimizing 3rd party packages footprint and avoid CSS loading
    var styles = {
        display: 'inline-block',
        width: '1.5em',
        height: '1.5em',
        verticalAlign: 'middle',
        fill: 'currentColor'
    };
    // additional styles for the <svg> element
    var svgStyles = {
        display: 'block',
        maxWidth: '100%'
    };
    // additional styles for the svg <path> element
    var pathStyles = {};
    if (size) styles = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)((0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, styles), {
        width: size !== 'cover' ? "var(--hcr-spacing-".concat(size, ", ").concat(size * DEFAULT_SPACING_MULTIPLIER, "px)") : '100%',
        height: size !== 'cover' ? "var(--hcr-spacing-".concat(size, ", ").concat(size * DEFAULT_SPACING_MULTIPLIER, "px)") : '100%'
    });
    if (appearance === 'primary') styles = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)((0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, styles), {
        fill: "var(--hcr-icon-primary-color, var(--hcr-primary-icon-color, #8b8b8b))"
    });
    if (appearance === 'secondary') styles = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)((0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, styles), {
        fill: "var(--hcr-icon-secondary-color, var(--hcr-secondary-icon-color, #97d700))"
    });
    if (fillCanvas) pathStyles = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)((0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, pathStyles), {
        transform: 'scale(1.2)',
        transformOrigin: 'center'
    });
    // merging custom styles with component ones
    if (customStyle) styles = (0, $32e8132807e4a3fa$export$18ce0697a983be9b)((0, $32e8132807e4a3fa$export$18ce0697a983be9b)({}, styles), customStyle);
    // conditionally adds extra classes
    var classList = (0, $32e8132807e4a3fa$export$1216008129fb82ed)([
        'hci-icon'
    ], extraClasses ? [
        extraClasses
    ] : [], true);
    return /*#__PURE__*/ $acw62.createElement("span", (0, $32e8132807e4a3fa$export$18ce0697a983be9b)({
        className: classList.join(' ')
    }, rest, {
        style: styles
    }), InlineIcon && /*#__PURE__*/ $acw62.createElement(InlineIcon, {
        title: title,
        role: "img",
        "aria-hidden": ariaHidden,
        "aria-label": ariaLabel,
        style: svgStyles,
        pathRest: {
            style: pathStyles
        }
    }));
};
$6e0a0c7f0bf054d5$export$f04a61298a47a40f.displayName = 'Icon';
$6e0a0c7f0bf054d5$export$f04a61298a47a40f.propTypes = {
    /** Change icon color */ appearance: $8da5bfbbed271cd7$exports.oneOf([
        'primary',
        'secondary',
        null
    ]),
    /** Injection in className */ extraClasses: $8da5bfbbed271cd7$exports.string,
    /** An inline SVG icon from components/icons/inline */ InlineIcon: $8da5bfbbed271cd7$exports.func.isRequired,
    /** Size of the icon, 20px if none is provided, "cover" fills all available space */ size: $8da5bfbbed271cd7$exports.oneOf($6e0a0c7f0bf054d5$var$IconSize),
    /** Custom title for Icon */ title: $8da5bfbbed271cd7$exports.string,
    /** Aria-hidden attribute for Icon */ 'aria-hidden': $8da5bfbbed271cd7$exports.oneOfType([
        $8da5bfbbed271cd7$exports.bool,
        $8da5bfbbed271cd7$exports.oneOf([
            'true',
            'false'
        ])
    ]),
    /** Aria Label for Icon */ 'aria-label': $8da5bfbbed271cd7$exports.string
};

function $199945823a88ad35$export$e092ad3ec43b55ee() {
    $199945823a88ad35$export$e092ad3ec43b55ee = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $199945823a88ad35$export$e092ad3ec43b55ee.apply(this, arguments);
}
function $199945823a88ad35$export$81942a8f34b531c4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $199945823a88ad35$export$d8a2083381e8fcb(source, excluded) {
    if (source == null) return {};
    var target = $199945823a88ad35$export$81942a8f34b531c4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $acw62 = parcelRequire("acw62");

var $c84b9d283ebf7c4b$var$_excluded = [
    "title",
    "pathRest"
];
var $c84b9d283ebf7c4b$export$e04bcc6127e699bf = function IconClose(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $c84b9d283ebf7c4b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-close"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "m13.41 12 6.37-6.36a1 1 0 1 0-1.42-1.42L12 10.6 5.64 4.22a1 1 0 1 0-1.42 1.42L10.6 12l-6.37 6.36a1 1 0 1 0 1.42 1.42L12 13.4l6.36 6.37a1 1 0 1 0 1.42-1.42z"
    }, pathRest)));
};
$c84b9d283ebf7c4b$export$e04bcc6127e699bf.displayName = 'InlineIcon(IconClose)';
$c84b9d283ebf7c4b$export$e04bcc6127e699bf.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};


parcelRequire("acw62");
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';




function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, 'span') ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)) break;
        (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)();
    }
    return (0, $f4f4fca9115ed8bd$export$58adb3bec8346d0f)(begin, (0, $f4f4fca9115ed8bd$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $f4f4fca9115ed8bd$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $fc182b1f84212d3f$var$prefix((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$36776f635604f274)(value) - 3 - (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $4eee05ec22b53782$export$23f2a1d2818174ef = false;
var $4eee05ec22b53782$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4eee05ec22b53782$export$e7094788287c5e9b = $4eee05ec22b53782$var$EmotionCacheContext.Provider;
var $4eee05ec22b53782$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
};
var $4eee05ec22b53782$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $4eee05ec22b53782$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $4eee05ec22b53782$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
};
var $4eee05ec22b53782$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4eee05ec22b53782$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $4eee05ec22b53782$var$getTheme(outerTheme, theme);
    });
});
var $4eee05ec22b53782$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4eee05ec22b53782$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4eee05ec22b53782$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4eee05ec22b53782$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4eee05ec22b53782$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4eee05ec22b53782$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4eee05ec22b53782$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4eee05ec22b53782$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4eee05ec22b53782$var$Emotion = /* #__PURE__ */ $4eee05ec22b53782$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4eee05ec22b53782$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4eee05ec22b53782$var$typePropName && !$4eee05ec22b53782$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $4eee05ec22b53782$export$a9c23c6ac3fc3eca = $4eee05ec22b53782$var$Emotion;



var $acw62 = parcelRequire("acw62");







parcelRequire("9ORqK");
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4eee05ec22b53782$export$dda1d9f60106f0e9).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4eee05ec22b53782$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4eee05ec22b53782$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($63d46a01db878c10$export$c8a8987d4410bf2d || ($63d46a01db878c10$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
function $63d46a01db878c10$export$d25ddfdf17c3ad3e() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});


function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $204931a4986f463b$var$lrPlacement = [
    'left',
    'right'
];
const $204931a4986f463b$var$rlPlacement = [
    'right',
    'left'
];
const $204931a4986f463b$var$tbPlacement = [
    'top',
    'bottom'
];
const $204931a4986f463b$var$btPlacement = [
    'bottom',
    'top'
];
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $204931a4986f463b$var$rlPlacement : $204931a4986f463b$var$lrPlacement;
            return isStart ? $204931a4986f463b$var$lrPlacement : $204931a4986f463b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $204931a4986f463b$var$tbPlacement : $204931a4986f463b$var$btPlacement;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    const side = $204931a4986f463b$export$3c915306cb7fc97a(placement);
    return $204931a4986f463b$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $9dccb9a8753b0e86$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $9dccb9a8753b0e86$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $9dccb9a8753b0e86$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $204931a4986f463b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $204931a4986f463b$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9dccb9a8753b0e86$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9dccb9a8753b0e86$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9dccb9a8753b0e86$var$originSides.has((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $204931a4986f463b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $204931a4986f463b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    if (!$c51400d9a81fca36$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    if (!$c51400d9a81fca36$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $c51400d9a81fca36$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $c51400d9a81fca36$var$containRe = /paint|layout|strict|content/;
const $c51400d9a81fca36$var$isNotNone = (value)=>!!value && value !== 'none';
let $c51400d9a81fca36$var$isWebKitValue;
function $c51400d9a81fca36$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $c51400d9a81fca36$export$45a5e7f76e0caa8d(elementOrCss) ? $c51400d9a81fca36$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c51400d9a81fca36$var$isNotNone(css.transform) || $c51400d9a81fca36$var$isNotNone(css.translate) || $c51400d9a81fca36$var$isNotNone(css.scale) || $c51400d9a81fca36$var$isNotNone(css.rotate) || $c51400d9a81fca36$var$isNotNone(css.perspective) || !$c51400d9a81fca36$export$78551043582a6a98() && ($c51400d9a81fca36$var$isNotNone(css.backdropFilter) || $c51400d9a81fca36$var$isNotNone(css.filter)) || $c51400d9a81fca36$var$willChangeRe.test(css.willChange || '') || $c51400d9a81fca36$var$containRe.test(css.contain || '');
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c51400d9a81fca36$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if ($c51400d9a81fca36$var$isWebKitValue == null) $c51400d9a81fca36$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $c51400d9a81fca36$var$isWebKitValue;
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c51400d9a81fca36$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c51400d9a81fca36$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c51400d9a81fca36$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bede215d88ec3aee$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $bede215d88ec3aee$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $bede215d88ec3aee$var$SCROLLBAR_MAX = 25;
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $bede215d88ec3aee$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $bede215d88ec3aee$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $bede215d88ec3aee$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === 'fixed' || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c51400d9a81fca36$export$89e651af02346cd4)(element) ? [] : $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, top);
        right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== 'body' || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bede215d88ec3aee$var$getHTMLOffset(documentElement, scroll) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$isStaticPositioned(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'static';
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c51400d9a81fca36$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if ((0, $c51400d9a81fca36$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$bede215d88ec3aee$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent))offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(offsetParent) && $bede215d88ec3aee$var$isStaticPositioned(offsetParent) && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || win;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === 'rtl';
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
function $bede215d88ec3aee$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$bede215d88ec3aee$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && !$bede215d88ec3aee$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bede215d88ec3aee$export$37b6bde19b108ecc = (0, $9dccb9a8753b0e86$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bede215d88ec3aee$export$cc800923e997bb8 = (0, $9dccb9a8753b0e86$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);


var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $bede215d88ec3aee$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};


var $cc1bf8814393d86b$export$fa397790119a1408;
var $cc1bf8814393d86b$export$b426df703d3b34b8;
var $cc1bf8814393d86b$export$1ca1ec8b29a4ce27;
$cc1bf8814393d86b$export$fa397790119a1408 = `ClearIndicator-54SxxG-flix-theme-dark`;
$cc1bf8814393d86b$export$b426df703d3b34b8 = `ClearIndicator-54SxxG-flix-theme-flix`;
$cc1bf8814393d86b$export$1ca1ec8b29a4ce27 = `ClearIndicator-54SxxG-icon`;


const $15a95a4dbc72f529$var$ClearIndicator = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).ClearIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
            InlineIcon: (0, $c84b9d283ebf7c4b$export$e04bcc6127e699bf),
            extraClasses: $cc1bf8814393d86b$export$1ca1ec8b29a4ce27,
            size: 4
        })
    });
};
var $15a95a4dbc72f529$export$2e2bcd8739ae039 = $15a95a4dbc72f529$var$ClearIndicator;





var $acw62 = parcelRequire("acw62");

var $b271bcddec93d9b1$var$_excluded = [
    "title",
    "pathRest"
];
var $b271bcddec93d9b1$export$403194946ee83bdf = function IconArrowDown(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $b271bcddec93d9b1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-arrow-down"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M18.68 8.3a1 1 0 0 0-1.41 0l-5.28 5.28-5.26-5.27a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.41l5.96 5.99a1 1 0 0 0 1.41 0l5.98-6a1 1 0 0 0 0-1.42"
    }, pathRest)));
};
$b271bcddec93d9b1$export$403194946ee83bdf.displayName = 'InlineIcon(IconArrowDown)';
$b271bcddec93d9b1$export$403194946ee83bdf.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};


parcelRequire("acw62");

const $2b2850ccc654d05b$var$DropdownIndicator = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
            InlineIcon: (0, $b271bcddec93d9b1$export$403194946ee83bdf),
            size: 4
        })
    });
};
var $2b2850ccc654d05b$export$2e2bcd8739ae039 = $2b2850ccc654d05b$var$DropdownIndicator;





var $acw62 = parcelRequire("acw62");

var $81ceaf7546033655$var$_excluded = [
    "title",
    "pathRest"
];
var $81ceaf7546033655$export$3577c0003511ce2d = function IconArrowUp(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $81ceaf7546033655$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-arrow-up"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "m18.68 14.28-5.97-5.99a1 1 0 0 0-1.41 0l-5.98 6a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0l5.28-5.29 5.26 5.28a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42"
    }, pathRest)));
};
$81ceaf7546033655$export$3577c0003511ce2d.displayName = 'InlineIcon(IconArrowUp)';
$81ceaf7546033655$export$3577c0003511ce2d.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};


parcelRequire("acw62");

const $5a41aab8da0b5e84$var$DropupIndicator = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
            InlineIcon: (0, $81ceaf7546033655$export$3577c0003511ce2d),
            size: 4
        })
    });
};
var $5a41aab8da0b5e84$export$2e2bcd8739ae039 = $5a41aab8da0b5e84$var$DropupIndicator;




parcelRequire("acw62");

var $498d34d06ba6b76b$export$fa397790119a1408;
var $498d34d06ba6b76b$export$b426df703d3b34b8;
var $498d34d06ba6b76b$export$1ca1ec8b29a4ce27;
var $498d34d06ba6b76b$export$ace48e5eb78698e7;
var $498d34d06ba6b76b$export$e87b363dbd988a48;
var $498d34d06ba6b76b$export$fcb993fc76799bbc;
var $498d34d06ba6b76b$export$368579262afb2721;
var $498d34d06ba6b76b$export$245ad05b0468ea5e;
var $498d34d06ba6b76b$export$d06ace4049a15362;
var $498d34d06ba6b76b$export$9651f3c45da8432f;
var $498d34d06ba6b76b$export$7d46d1ead19e11ac;
var $498d34d06ba6b76b$export$5daa8974290cce67;
var $498d34d06ba6b76b$export$ff48a4fbbbe377ab;
$498d34d06ba6b76b$export$fa397790119a1408 = `styles-QYzr7G-flix-theme-dark`;
$498d34d06ba6b76b$export$b426df703d3b34b8 = `styles-QYzr7G-flix-theme-flix`;
$498d34d06ba6b76b$export$1ca1ec8b29a4ce27 = `styles-QYzr7G-icon`;
$498d34d06ba6b76b$export$ace48e5eb78698e7 = `styles-QYzr7G-multiIcon`;
$498d34d06ba6b76b$export$e87b363dbd988a48 = `styles-QYzr7G-multiIconsWrapper`;
$498d34d06ba6b76b$export$fcb993fc76799bbc = `styles-QYzr7G-multiInfoWrapper`;
$498d34d06ba6b76b$export$368579262afb2721 = `styles-QYzr7G-multiWrapper`;
$498d34d06ba6b76b$export$245ad05b0468ea5e = `styles-QYzr7G-optionLabel`;
$498d34d06ba6b76b$export$d06ace4049a15362 = `styles-QYzr7G-optionWithDescriptionWrapper`;
$498d34d06ba6b76b$export$9651f3c45da8432f = `styles-QYzr7G-optionWrapper`;
$498d34d06ba6b76b$export$7d46d1ead19e11ac = `styles-QYzr7G-singleValueLabel`;
$498d34d06ba6b76b$export$5daa8974290cce67 = `styles-QYzr7G-singleValueWithDescriptionWrapper`;
$498d34d06ba6b76b$export$ff48a4fbbbe377ab = `styles-QYzr7G-suffixElement`;


const $16f29cccac148065$var$SingleValue = (props)=>{
    if (props.data.description) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$5daa8974290cce67,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: props.data.label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: props.data.description
                })
            ]
        })
    });
    if (props.data.multiIconLabel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$368579262afb2721,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $498d34d06ba6b76b$export$e87b363dbd988a48,
                    children: props.data.multiIconLabel.map((element, i)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                    InlineIcon: element.icon,
                                    extraClasses: $498d34d06ba6b76b$export$ace48e5eb78698e7
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: element.label
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $498d34d06ba6b76b$export$fcb993fc76799bbc,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.data.label
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$9651f3c45da8432f,
            children: [
                props.data.icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: $498d34d06ba6b76b$export$1ca1ec8b29a4ce27,
                    children: props.data.icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: $498d34d06ba6b76b$export$7d46d1ead19e11ac,
                    children: props.data.label
                })
            ]
        })
    });
};
var $16f29cccac148065$export$2e2bcd8739ae039 = $16f29cccac148065$var$SingleValue;




var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


parcelRequire("acw62");

const $38de36f839ea911c$var$MultiIconLabel = ({ label: label, multiIconLabel: multiIconLabel, extraClasses: extraClasses })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($498d34d06ba6b76b$export$368579262afb2721, extraClasses),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $498d34d06ba6b76b$export$e87b363dbd988a48,
                children: multiIconLabel.map((element, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                InlineIcon: element.icon,
                                extraClasses: $498d34d06ba6b76b$export$ace48e5eb78698e7
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: element.label
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $498d34d06ba6b76b$export$fcb993fc76799bbc,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: label
                })
            })
        ]
    });
};
var $38de36f839ea911c$export$2e2bcd8739ae039 = $38de36f839ea911c$var$MultiIconLabel;



parcelRequire("acw62");



const $4b57c50dbfa9c188$var$Option = (props)=>{
    if (props.data.description) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$d06ace4049a15362,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: props.data.label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: props.data.description
                })
            ]
        })
    });
    if (props.data.multiIconLabel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38de36f839ea911c$export$2e2bcd8739ae039), {
            label: props.data.label,
            multiIconLabel: props.data.multiIconLabel
        })
    });
    if (props.data.suffixElement) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$9651f3c45da8432f,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $498d34d06ba6b76b$export$245ad05b0468ea5e,
                    children: props.data.label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $498d34d06ba6b76b$export$ff48a4fbbbe377ab,
                    children: props.data.suffixElement
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $498d34d06ba6b76b$export$9651f3c45da8432f,
            children: [
                props.data.icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: $498d34d06ba6b76b$export$1ca1ec8b29a4ce27,
                    children: props.data.icon
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: $498d34d06ba6b76b$export$245ad05b0468ea5e,
                    children: props.data.label
                })
            ]
        })
    });
};
var $4b57c50dbfa9c188$export$2e2bcd8739ae039 = $4b57c50dbfa9c188$var$Option;




const $433401918a64c671$var$removeSpacesAndSpecialCharacters = (text)=>{
    return text?.replace(/([^0-9a-z]|\s)/gi, "");
};
var $433401918a64c671$export$2e2bcd8739ae039 = $433401918a64c671$var$removeSpacesAndSpecialCharacters;


const $c58d3c29271911d8$export$4675491868a7cddb = [
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Addis_Ababa",
    "Africa/Algiers",
    "Africa/Asmara",
    "Africa/Bamako",
    "Africa/Bangui",
    "Africa/Banjul",
    "Africa/Bissau",
    "Africa/Blantyre",
    "Africa/Brazzaville",
    "Africa/Bujumbura",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/Conakry",
    "Africa/Dakar",
    "Africa/Dar_es_Salaam",
    "Africa/Djibouti",
    "Africa/Douala",
    "Africa/El_Aaiun",
    "Africa/Freetown",
    "Africa/Gaborone",
    "Africa/Harare",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Kampala",
    "Africa/Khartoum",
    "Africa/Kigali",
    "Africa/Kinshasa",
    "Africa/Lagos",
    "Africa/Libreville",
    "Africa/Lome",
    "Africa/Luanda",
    "Africa/Lubumbashi",
    "Africa/Lusaka",
    "Africa/Malabo",
    "Africa/Maputo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "Africa/Mogadishu",
    "Africa/Monrovia",
    "Africa/Nairobi",
    "Africa/Ndjamena",
    "Africa/Niamey",
    "Africa/Nouakchott",
    "Africa/Ouagadougou",
    "Africa/Porto-Novo",
    "Africa/Sao_Tome",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Ciudad_Juarez",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Fort_Nelson",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Kralendijk",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Port_of_Spain",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Antarctica/McMurdo",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Arctic/Longyearbyen",
    "Asia/Aden",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Baghdad",
    "Asia/Bahrain",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Colombo",
    "Asia/Damascus",
    "Asia/Dhaka",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Gaza",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Kathmandu",
    "Asia/Khandyga",
    "Asia/Kolkata",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Kuwait",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Muscat",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Phnom_Penh",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qatar",
    "Asia/Qyzylorda",
    "Asia/Rangoon",
    "Asia/Riyadh",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ulaanbaatar",
    "Asia/Urumqi",
    "Asia/Ust-Nera",
    "Asia/Vientiane",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faroe",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/St_Helena",
    "Atlantic/Stanley",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Busingen",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Guernsey",
    "Europe/Helsinki",
    "Europe/Isle_of_Man",
    "Europe/Istanbul",
    "Europe/Jersey",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kyiv",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/Ljubljana",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Mariehamn",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Podgorica",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Simferopol",
    "Europe/Skopje",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zaporozhye",
    "Europe/Zurich",
    "Indian/Antananarivo",
    "Indian/Chagos",
    "Indian/Christmas",
    "Indian/Cocos",
    "Indian/Comoro",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Mayotte",
    "Indian/Reunion",
    "Pacific/Apia",
    "Pacific/Auckland",
    "Pacific/Bougainville",
    "Pacific/Chatham",
    "Pacific/Chuuk",
    "Pacific/Easter",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Funafuti",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Johnston",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Kwajalein",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Midway",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pago_Pago",
    "Pacific/Palau",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Port_Moresby",
    "Pacific/Rarotonga",
    "Pacific/Saipan",
    "Pacific/Tahiti",
    "Pacific/Tarawa",
    "Pacific/Tongatapu",
    "Pacific/Wake",
    "Pacific/Wallis",
    "UTC"
];
const $c58d3c29271911d8$var$timezones = ()=>$c58d3c29271911d8$export$4675491868a7cddb.map((timezone)=>({
            value: timezone,
            label: timezone
        }));
var $c58d3c29271911d8$export$2e2bcd8739ae039 = $c58d3c29271911d8$var$timezones;














var $e130a2a39502831b$export$2e2bcd8739ae039 = async (locale)=>{
    const localeMap = {
        de: ()=>(parcelRequire("jTyJM")),
        en: ()=>(parcelRequire("2k0Ea")),
        es: ()=>(parcelRequire("3QaWb")),
        fr: ()=>(parcelRequire("2uW6Q")),
        hr: ()=>(parcelRequire("i8ZFc")),
        it: ()=>(parcelRequire("4pJ3W")),
        lv_LV: ()=>(parcelRequire("bH5M0")),
        pl: ()=>(parcelRequire("eHzNx")),
        pt_BR: ()=>(parcelRequire("6jFfq")),
        pt_PT: ()=>(parcelRequire("6IsRp")),
        tr: ()=>(parcelRequire("axXW0")),
        uk: ()=>(parcelRequire("7Dct0"))
    };
    const importFn = localeMap[locale] || localeMap.en;
    const module = await importFn();
    // Parcel bundles HTML differently in dev vs production
    const html = typeof module === "string" ? module : module.default || module[1] || module;
    const bodyContent = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    return bodyContent ? bodyContent[1] : html;
};


var $157bd0a03e794e8a$export$2e2bcd8739ae039 = (text)=>text.split(/\s+/).filter((word)=>word.length > 0).map((word)=>word.replace(/[^\w]/g, ""));







var $acw62 = parcelRequire("acw62");

var $b526a126f5cf24bd$export$2e2bcd8739ae039 = {
    raw: ".hcr-infobox-16-4-0{background-color:var(--hcr-box-bg-color);border:1px solid var(--hcr-line-primary-color);border-radius:var(--hcr-border-radius-1);padding:var(--hcr-spacing-4)}.hcr-infobox--small-16-4-0{padding:var(--hcr-spacing-2)}.hcr-infobox-16-4-0{border:0;box-shadow:var(--hcr-primary-box-shadow)}.hcr-infobox--strong-16-4-0{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-box-state-color),var(--hcr-box-state-color));border-color:var(--hcr-box-state-color);--hcr-box-state-color:var(--hcr-neutral-color)}.hcr-infobox--warning-16-4-0{--hcr-box-state-color:var(--hcr-warning-color)}.hcr-infobox--success-16-4-0{--hcr-box-state-color:var(--hcr-success-color)}.hcr-infobox--danger-16-4-0{--hcr-box-state-color:var(--hcr-danger-color)}.hcr-infobox-16-4-0{--hcr-infobox-icon-size-rem:3rem;--hcr-infobox-icon-size-px:var(--hcr-spacing-8);align-items:center;display:flex;gap:var(--hcr-spacing-2)}.hcr-infobox-16-4-0:where(:not(:last-child)){margin-bottom:var(--hcr-spacing-2)}.hcr-infobox--small-icon-16-4-0{--hcr-infobox-icon-size-rem:1.5rem;--hcr-infobox-icon-size-px:var(--hcr-spacing-4)}.hcr-infobox__content-16-4-0{flex-grow:1;min-width:0;overflow-wrap:anywhere}.hcr-infobox-16-4-0:before{align-self:flex-start;background-color:var(--hcr-neutral-color);content:\"\";flex-shrink:0;height:var(--hcr-infobox-icon-size-rem);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm1-8.5V17a1\\ 1\\ 0\\ 01-2\\ 0v-5.5a1\\ 1\\ 0\\ 112\\ 0zm.5-4a1.5\\ 1.5\\ 0\\ 11-3\\ 0\\ 1.5\\ 1.5\\ 0\\ 013\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm1-8.5V17a1\\ 1\\ 0\\ 01-2\\ 0v-5.5a1\\ 1\\ 0\\ 112\\ 0zm.5-4a1.5\\ 1.5\\ 0\\ 11-3\\ 0\\ 1.5\\ 1.5\\ 0\\ 013\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-infobox-icon-size-px)*2);max-width:calc(var(--hcr-infobox-icon-size-px)*2);min-height:var(--hcr-infobox-icon-size-px);min-width:var(--hcr-infobox-icon-size-px);width:var(--hcr-infobox-icon-size-rem)}@supports (min-height:max(var(--hcr-infobox-icon-size-px ),var(--hcr-line-height-primary ))){.hcr-infobox-16-4-0:before{min-height:max(var(--hcr-infobox-icon-size-px),var(--hcr-line-height-primary))}}.hcr-infobox--success-16-4-0:before{background-color:var(--hcr-success-color);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M16.89\\ 8.3a1\\ 1\\ 0\\ 010\\ 1.4l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 011.4\\ 0zM22\\ 12a10\\ 10\\ 0\\ 11-20\\ 0\\ 10\\ 10\\ 0\\ 0120\\ 0zm-2\\ 0a8\\ 8\\ 0\\ 00-16\\ 0\\ 8\\ 8\\ 0\\ 0016\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M16.89\\ 8.3a1\\ 1\\ 0\\ 010\\ 1.4l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 011.4\\ 0zM22\\ 12a10\\ 10\\ 0\\ 11-20\\ 0\\ 10\\ 10\\ 0\\ 0120\\ 0zm-2\\ 0a8\\ 8\\ 0\\ 00-16\\ 0\\ 8\\ 8\\ 0\\ 0016\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover}.hcr-infobox--success-16-4-0:before,.hcr-infobox--warning-16-4-0:before{height:var(--hcr-infobox-icon-size-rem);width:var(--hcr-infobox-icon-size-rem)}.hcr-infobox--warning-16-4-0:before{background-color:var(--hcr-warning-color);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm-1-7.5V7a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0zm2.5\\ 4a1.5\\ 1.5\\ 0\\ 11-3\\ 0\\ 1.5\\ 1.5\\ 0\\ 013\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm-1-7.5V7a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0zm2.5\\ 4a1.5\\ 1.5\\ 0\\ 11-3\\ 0\\ 1.5\\ 1.5\\ 0\\ 013\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover}.hcr-infobox--danger-16-4-0:before{background-color:var(--hcr-danger-color);height:var(--hcr-infobox-icon-size-rem);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm4.95-3.05a1\\ 1\\ 0\\ 01-1.41\\ 0L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54a1\\ 1\\ 0\\ 010\\ 1.41z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm4.95-3.05a1\\ 1\\ 0\\ 01-1.41\\ 0L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54a1\\ 1\\ 0\\ 010\\ 1.41z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-infobox-icon-size-rem)}",
    map: {
        "hcr-infobox": "hcr-infobox-16-4-0",
        "hcr-infobox--small": "hcr-infobox--small-16-4-0",
        "hcr-infobox--strong": "hcr-infobox--strong-16-4-0",
        "hcr-infobox--warning": "hcr-infobox--warning-16-4-0",
        "hcr-infobox--success": "hcr-infobox--success-16-4-0",
        "hcr-infobox--danger": "hcr-infobox--danger-16-4-0",
        "hcr-infobox--small-icon": "hcr-infobox--small-icon-16-4-0",
        "hcr-infobox__content": "hcr-infobox__content-16-4-0"
    }
};





const $702b9449be14ac4b$export$8ad3a7add6add4b3 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        regular: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    })
]);
const $702b9449be14ac4b$export$a18c65527e9c80e1 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
        ])
    })
]);
const $702b9449be14ac4b$export$50d0863e1c2a2c7f = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
]);


const $44c0b44978235916$export$abd0e75d71e10e1b = [
    'success',
    'warning',
    'danger'
];



const $e1ec6c9ab7046438$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('infobox', (0, $b526a126f5cf24bd$export$2e2bcd8739ae039));
function $e1ec6c9ab7046438$export$bbd2fb9c6f52fe5(_a) {
    var { appearance: appearance, children: children, extraClasses: extraClasses, innerRef: innerRef, small: small = false, smallIcon: smallIcon = false, strong: strong = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "appearance",
        "children",
        "extraClasses",
        "innerRef",
        "small",
        "smallIcon",
        "strong"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", Object.assign({
        ref: innerRef,
        className: $e1ec6c9ab7046438$var$bem.b([
            appearance,
            {
                small: small,
                'small-icon': smallIcon,
                strong: strong
            }
        ], extraClasses)
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $e1ec6c9ab7046438$var$bem.e('content')
    }, children));
}
$e1ec6c9ab7046438$export$bbd2fb9c6f52fe5.displayName = 'Infobox';
$e1ec6c9ab7046438$export$bbd2fb9c6f52fe5.propTypes = {
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $44c0b44978235916$export$abd0e75d71e10e1b)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    smallIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    strong: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $e1ec6c9ab7046438$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($e1ec6c9ab7046438$export$bbd2fb9c6f52fe5, (0, $b526a126f5cf24bd$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $ec4e01b7a51b1327$export$2e2bcd8739ae039 = {
    raw: "@property --hcr-spinner-progress-internal{syntax:\"<length-percentage>\";inherits:false;initial-value:0%}.hcr-spinner-16-4-0{--hcr-spinner-size:calc(var(--hcr-spacing-12) + var(--hcr-spacing-3));display:inline-grid;height:var(--hcr-spinner-size);place-content:center;position:relative;transition:--hcr-spinner-progress-internal .25s linear;width:var(--hcr-spinner-size);--hcr-spinner-progress-internal:25%;--hcr-spinner-color:var(--hcr-ui-primary-dark-color);--hcr-spinner-bg-color:var(--hcr-box-bg-color);--hcr-spinner-line-color:var(--hcr-ui-primary-light-color);animation:spinner-rotate 1s linear infinite;background-image:conic-gradient(var(--hcr-spinner-color) var(--hcr-spinner-progress-internal),var(--hcr-spinner-line-color)0);border-radius:50%}.hcr-spinner-16-4-0:before{background-color:var(--hcr-spinner-bg-color);border-radius:inherit;content:\"\";display:block;inset:var(--hcr-spacing-half);position:absolute;transition:background-color .25s ease}.hcr-spinner--danger-16-4-0{--hcr-spinner-color:var(--hcr-danger-color);--hcr-spinner-line-color:var(--hcr-line-primary-color)}@keyframes spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.hcr-spinner-16-4-0[aria-valuenow],.hcr-spinner-16-4-0[role=timer]{--hcr-spinner-progress-internal:calc(var(--hcr-spinner-progress) * 1%);animation:none}.hcr-spinner--show-value-16-4-0[aria-valuenow]:after{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));content:attr(aria-valuenow) attr(data-unit,\"%\");font-size:var(--hcr-font-size-h4);font-weight:var(--hcr-font-weight-bold);line-height:var(--hcr-line-height-h4);place-self:center;position:absolute}.hcr-spinner--show-value-16-4-0[aria-valuenow=\"100\"]{--hcr-spinner-bg-color:var(--hcr-spinner-line-color)}.hcr-spinner--show-value-16-4-0[aria-valuenow=\"100\"]:before{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-spinner-bg-color),var(--hcr-spinner-bg-color))}.hcr-spinner--show-value-16-4-0[aria-valuenow=\"100\"]:after{animation:spinner-checkmark-grow .25s;background-color:var(--hcr-spinner-color);content:\"\";display:block;height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-spinner--danger-16-4-0.hcr-spinner--show-value-16-4-0[aria-valuenow=\"100\"]{--hcr-spinner-bg-color:var(--hcr-spinner-color)}.hcr-spinner--danger-16-4-0.hcr-spinner--show-value-16-4-0[aria-valuenow=\"100\"]:after{background-color:var(--hcr-spinner-color);height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.95\\ 13.54a1\\ 1\\ 0\\ 11-1.41\\ 1.41L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.95\\ 13.54a1\\ 1\\ 0\\ 11-1.41\\ 1.41L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-spinner--md-16-4-0:after,.hcr-spinner--sm-16-4-0:after{display:none}.hcr-spinner--sm-16-4-0{--hcr-spinner-size:var(--hcr-spacing-4)}.hcr-spinner--md-16-4-0{--hcr-spinner-size:var(--hcr-spacing-6)}.hcr-spinner--lg-16-4-0{--hcr-spinner-size:var(--hcr-spacing-8)}.hcr-spinner--xl-16-4-0{--hcr-spinner-size:var(--hcr-spacing-12)}.hcr-spinner--xxl-16-4-0{--hcr-spinner-size:calc(var(--hcr-spacing-12) + var(--hcr-spacing-4))}@keyframes spinner-checkmark-grow{0%{-webkit-mask-size:0;mask-size:0;opacity:0}to{-webkit-mask-size:var(--hcr-spacing-4);mask-size:var(--hcr-spacing-4);opacity:1}}",
    map: {
        "hcr-spinner": "hcr-spinner-16-4-0",
        "hcr-spinner--danger": "hcr-spinner--danger-16-4-0",
        "hcr-spinner--show-value": "hcr-spinner--show-value-16-4-0",
        "hcr-spinner--sm": "hcr-spinner--sm-16-4-0",
        "hcr-spinner--md": "hcr-spinner--md-16-4-0",
        "hcr-spinner--lg": "hcr-spinner--lg-16-4-0",
        "hcr-spinner--xl": "hcr-spinner--xl-16-4-0",
        "hcr-spinner--xxl": "hcr-spinner--xxl-16-4-0"
    }
};





const $79c1e4299de9471c$export$6c67a8b9af9c2b16 = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $79c1e4299de9471c$export$819629f8c47a0926 = [
    'timer',
    'progressbar'
];



const $a448fa77989b51de$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('spinner', (0, $ec4e01b7a51b1327$export$2e2bcd8739ae039));
const $a448fa77989b51de$var$spinnerProgressVarName = `--hcr-spinner-progress`;
function $a448fa77989b51de$export$7f7cbe89f1eacd2(_a) {
    var { role: role, extraClasses: extraClasses, size: size = 'xxl', danger: danger, showValue: showValue, value: value, valueMax: valueMax = 100, valueMin: valueMin = 0, unit: unit = '%' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "role",
        "extraClasses",
        "size",
        "danger",
        "showValue",
        "value",
        "valueMax",
        "valueMin",
        "unit"
    ]);
    const className = $a448fa77989b51de$var$bem.b([
        size,
        {
            'show-value': showValue,
            danger: danger
        }
    ], extraClasses);
    const progressProps = rest;
    const progressValue = typeof value === 'number' && Math.floor(value / valueMax * 100);
    if (progressValue) progressProps['style'] = Object.assign({
        [$a448fa77989b51de$var$spinnerProgressVarName]: progressValue
    }, rest.style);
    // Timer returns early, it has no units nor value attributes
    if (role === 'timer') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: role,
        className: className
    }, progressProps));
    let progressRole;
    if (typeof value === 'number') {
        progressRole = 'progressbar';
        progressProps['aria-valuenow'] = value;
        if (valueMax !== 100) progressProps['aria-valuemax'] = valueMax;
        if (valueMin !== 0) progressProps['aria-valuemin'] = valueMin;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: progressRole,
        className: className
    }, unit && unit !== '%' ? {
        'data-unit': unit
    } : {}, progressProps));
}
$a448fa77989b51de$export$7f7cbe89f1eacd2.displayName = 'Spinner';
$a448fa77989b51de$export$7f7cbe89f1eacd2.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $79c1e4299de9471c$export$6c67a8b9af9c2b16)),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    danger: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $79c1e4299de9471c$export$819629f8c47a0926)),
    showValue: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    valueMax: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    valueMin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    unit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $a448fa77989b51de$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($a448fa77989b51de$export$7f7cbe89f1eacd2, (0, $ec4e01b7a51b1327$export$2e2bcd8739ae039));


parcelRequire("acw62");
var $11334dc6502e5500$export$3d6552a0ad5670c9;
var $11334dc6502e5500$export$641374ffb95bc399;
$11334dc6502e5500$export$3d6552a0ad5670c9 = `InfoAlert-ffQmSa-infobox`;
$11334dc6502e5500$export$641374ffb95bc399 = `InfoAlert-ffQmSa-spinner`;


const $a96afdb6fe86673c$var$InfoAlert = ({ type: type, loading: loading = false, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1ec6c9ab7046438$export$2e2bcd8739ae039), {
        appearance: type === "info" ? undefined : type,
        extraClasses: $11334dc6502e5500$export$3d6552a0ad5670c9,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                children,
                loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a448fa77989b51de$export$2e2bcd8739ae039), {
                    size: "sm",
                    extraClasses: $11334dc6502e5500$export$641374ffb95bc399
                })
            ]
        })
    });
};
var $a96afdb6fe86673c$export$2e2bcd8739ae039 = $a96afdb6fe86673c$var$InfoAlert;



parcelRequire("acw62");
const $a7858a988b34866c$var$HeaderStagingBackground = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: false
    });
};
var $a7858a988b34866c$export$2e2bcd8739ae039 = $a7858a988b34866c$var$HeaderStagingBackground;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

//
// Main
//
function $c2b6c798eecb7135$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c2b6c798eecb7135$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c2b6c798eecb7135$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c2b6c798eecb7135$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c2b6c798eecb7135$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c2b6c798eecb7135$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c2b6c798eecb7135$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c2b6c798eecb7135$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c2b6c798eecb7135$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c2b6c798eecb7135$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c2b6c798eecb7135$var$monadic : $c2b6c798eecb7135$var$variadic;
    return $c2b6c798eecb7135$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c2b6c798eecb7135$var$strategyVariadic(fn, options) {
    return $c2b6c798eecb7135$var$assemble(fn, this, $c2b6c798eecb7135$var$variadic, options.cache.create(), options.serializer);
}
function $c2b6c798eecb7135$var$strategyMonadic(fn, options) {
    return $c2b6c798eecb7135$var$assemble(fn, this, $c2b6c798eecb7135$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c2b6c798eecb7135$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c2b6c798eecb7135$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c2b6c798eecb7135$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c2b6c798eecb7135$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c2b6c798eecb7135$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c2b6c798eecb7135$var$ObjectWithoutPrototypeCache();
    }
};
var $c2b6c798eecb7135$export$c5491a8691a23b9e = {
    variadic: $c2b6c798eecb7135$var$strategyVariadic,
    monadic: $c2b6c798eecb7135$var$strategyMonadic
};


function $e5c7ec88ecc0f34d$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $e5c7ec88ecc0f34d$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $e5c7ec88ecc0f34d$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $e5c7ec88ecc0f34d$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $e5c7ec88ecc0f34d$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $e5c7ec88ecc0f34d$export$3fae2929ed23c202(map, pl, field) {
    return $e5c7ec88ecc0f34d$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $e5c7ec88ecc0f34d$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $e5c7ec88ecc0f34d$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $e5c7ec88ecc0f34d$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $e5c7ec88ecc0f34d$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $e5c7ec88ecc0f34d$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $e5c7ec88ecc0f34d$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $e5c7ec88ecc0f34d$export$a99e4aaac79eeead = (0, $c2b6c798eecb7135$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $c2b6c798eecb7135$export$c5491a8691a23b9e).variadic
});
var $e5c7ec88ecc0f34d$export$b479a1a2d8754359 = (0, $c2b6c798eecb7135$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $c2b6c798eecb7135$export$c5491a8691a23b9e).variadic
});
var $e5c7ec88ecc0f34d$export$569bb3095db8432e = (0, $c2b6c798eecb7135$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $c2b6c798eecb7135$export$c5491a8691a23b9e).variadic
});
var $e5c7ec88ecc0f34d$export$e124bc7d23dd0e5a = (0, $c2b6c798eecb7135$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $c2b6c798eecb7135$export$c5491a8691a23b9e).variadic
});
var $e5c7ec88ecc0f34d$export$a1209f8c6068edc3 = (0, $c2b6c798eecb7135$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $c2b6c798eecb7135$export$c5491a8691a23b9e).variadic
});



var $693d63d2fb891c85$exports = {};

$parcel$defineInteropFlag($693d63d2fb891c85$exports);
$parcel$export($693d63d2fb891c85$exports, "ErrorCode", () => $b2de32051be1701b$export$d4e71bc0b80dc0fb);
$parcel$export($693d63d2fb891c85$exports, "FormatError", () => $b2de32051be1701b$export$7369836851cc1329);
$parcel$export($693d63d2fb891c85$exports, "isFormatXMLElementFn", () => $a7bf6eec6df43b65$export$df0c12a2d414a163);

$parcel$export($693d63d2fb891c85$exports, "IntlMessageFormat", () => $65f19ee2190344e6$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
//
// Main
//
function $b236ccb710e31bc5$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $b236ccb710e31bc5$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $b236ccb710e31bc5$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $b236ccb710e31bc5$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $b236ccb710e31bc5$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $b236ccb710e31bc5$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $b236ccb710e31bc5$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b236ccb710e31bc5$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $b236ccb710e31bc5$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $b236ccb710e31bc5$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $b236ccb710e31bc5$var$monadic : $b236ccb710e31bc5$var$variadic;
    return $b236ccb710e31bc5$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $b236ccb710e31bc5$var$strategyVariadic(fn, options) {
    return $b236ccb710e31bc5$var$assemble(fn, this, $b236ccb710e31bc5$var$variadic, options.cache.create(), options.serializer);
}
function $b236ccb710e31bc5$var$strategyMonadic(fn, options) {
    return $b236ccb710e31bc5$var$assemble(fn, this, $b236ccb710e31bc5$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $b236ccb710e31bc5$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $b236ccb710e31bc5$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$b236ccb710e31bc5$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$b236ccb710e31bc5$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $b236ccb710e31bc5$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $b236ccb710e31bc5$var$ObjectWithoutPrototypeCache();
    }
};
var $b236ccb710e31bc5$export$c5491a8691a23b9e = {
    variadic: $b236ccb710e31bc5$var$strategyVariadic,
    monadic: $b236ccb710e31bc5$var$strategyMonadic
};



var $566ea7342c8aac00$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($566ea7342c8aac00$export$896afd8541959ee5 || ($566ea7342c8aac00$export$896afd8541959ee5 = {}));




var $6d93ce9b7508ba31$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($6d93ce9b7508ba31$export$b87f371cbc396fcf || ($6d93ce9b7508ba31$export$b87f371cbc396fcf = {}));
var $6d93ce9b7508ba31$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($6d93ce9b7508ba31$export$906452485466fa53 || ($6d93ce9b7508ba31$export$906452485466fa53 = {}));
function $6d93ce9b7508ba31$export$cfa10c5697238752(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.literal;
}
function $6d93ce9b7508ba31$export$4f55724281bdfaf9(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.argument;
}
function $6d93ce9b7508ba31$export$e11187b219e191e1(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.number;
}
function $6d93ce9b7508ba31$export$32d811605da75f40(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.date;
}
function $6d93ce9b7508ba31$export$34ec46f596b1702f(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.time;
}
function $6d93ce9b7508ba31$export$dcfe1c11d168b5a1(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.select;
}
function $6d93ce9b7508ba31$export$6c796d116f0a4fbc(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.plural;
}
function $6d93ce9b7508ba31$export$c0ece297bdd0c082(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.pound;
}
function $6d93ce9b7508ba31$export$5c83de34745812b(el) {
    return el.type === $6d93ce9b7508ba31$export$b87f371cbc396fcf.tag;
}
function $6d93ce9b7508ba31$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $6d93ce9b7508ba31$export$906452485466fa53.number);
}
function $6d93ce9b7508ba31$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $6d93ce9b7508ba31$export$906452485466fa53.dateTime);
}
function $6d93ce9b7508ba31$export$f0ac572c1121c662(value) {
    return {
        type: $6d93ce9b7508ba31$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $6d93ce9b7508ba31$export$425e864b0ba114f1(value, style) {
    return {
        type: $6d93ce9b7508ba31$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $56b959600434bfe0$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $56b959600434bfe0$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $68c188c5ce67ae9e$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $68c188c5ce67ae9e$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($68c188c5ce67ae9e$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $5da92d4f027b697b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $55abffaa7be2a294$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $5da92d4f027b697b$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $55abffaa7be2a294$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $55abffaa7be2a294$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $55abffaa7be2a294$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $55abffaa7be2a294$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $55abffaa7be2a294$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $55abffaa7be2a294$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($55abffaa7be2a294$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $55abffaa7be2a294$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $55abffaa7be2a294$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$55abffaa7be2a294$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $55abffaa7be2a294$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $55abffaa7be2a294$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $55abffaa7be2a294$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $55abffaa7be2a294$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, all), $55abffaa7be2a294$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, all), $55abffaa7be2a294$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($55abffaa7be2a294$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($55abffaa7be2a294$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($55abffaa7be2a294$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($55abffaa7be2a294$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), $55abffaa7be2a294$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($55abffaa7be2a294$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), $55abffaa7be2a294$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $55abffaa7be2a294$var$parseSign(token.stem);
        if (signOpts) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $55abffaa7be2a294$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $3ea3a646f6bf810c$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $bf5af2bd607f6563$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $bf5af2bd607f6563$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $bf5af2bd607f6563$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $3ea3a646f6bf810c$export$a8c9209db4084317)[regionTag || ''] || (0, $3ea3a646f6bf810c$export$a8c9209db4084317)[languageTag || ''] || (0, $3ea3a646f6bf810c$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $3ea3a646f6bf810c$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $40e0a547127cbfee$var$_a;
var $40e0a547127cbfee$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $56b959600434bfe0$export$523451f94304dd6c).source, "*"));
var $40e0a547127cbfee$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $56b959600434bfe0$export$523451f94304dd6c).source, "*$"));
function $40e0a547127cbfee$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $40e0a547127cbfee$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $40e0a547127cbfee$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $40e0a547127cbfee$var$hasNativeFromEntries = !!Object.fromEntries;
var $40e0a547127cbfee$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $40e0a547127cbfee$var$hasTrimStart = !!String.prototype.trimStart;
var $40e0a547127cbfee$var$hasTrimEnd = !!String.prototype.trimEnd;
var $40e0a547127cbfee$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $40e0a547127cbfee$var$isSafeInteger = $40e0a547127cbfee$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $40e0a547127cbfee$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $40e0a547127cbfee$var$re = $40e0a547127cbfee$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $40e0a547127cbfee$var$REGEX_SUPPORTS_U_AND_Y = (($40e0a547127cbfee$var$_a = $40e0a547127cbfee$var$re.exec('a')) === null || $40e0a547127cbfee$var$_a === void 0 ? void 0 : $40e0a547127cbfee$var$_a[0]) === 'a';
} catch (_) {
    $40e0a547127cbfee$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $40e0a547127cbfee$var$startsWith = $40e0a547127cbfee$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $40e0a547127cbfee$var$fromCodePoint = $40e0a547127cbfee$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $40e0a547127cbfee$var$fromEntries = // native
$40e0a547127cbfee$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $40e0a547127cbfee$var$codePointAt = $40e0a547127cbfee$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $40e0a547127cbfee$var$trimStart = $40e0a547127cbfee$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($40e0a547127cbfee$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $40e0a547127cbfee$var$trimEnd = $40e0a547127cbfee$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($40e0a547127cbfee$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $40e0a547127cbfee$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $40e0a547127cbfee$var$matchIdentifierAtIndex;
if ($40e0a547127cbfee$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $40e0a547127cbfee$var$IDENTIFIER_PREFIX_RE_1 = $40e0a547127cbfee$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $40e0a547127cbfee$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $40e0a547127cbfee$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $40e0a547127cbfee$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$40e0a547127cbfee$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $40e0a547127cbfee$var$codePointAt(s, index);
        if (c === undefined || $40e0a547127cbfee$var$_isWhiteSpace(c) || $40e0a547127cbfee$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $40e0a547127cbfee$var$fromCodePoint.apply(void 0, match);
};
var $40e0a547127cbfee$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).pound,
                    location: $40e0a547127cbfee$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $40e0a547127cbfee$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $40e0a547127cbfee$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$40e0a547127cbfee$var$_isAlpha(this.char())) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_TAG, $40e0a547127cbfee$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $40e0a547127cbfee$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_TAG, $40e0a547127cbfee$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $40e0a547127cbfee$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).UNCLOSED_TAG, $40e0a547127cbfee$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_TAG, $40e0a547127cbfee$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $40e0a547127cbfee$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $40e0a547127cbfee$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$40e0a547127cbfee$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $40e0a547127cbfee$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $40e0a547127cbfee$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EMPTY_ARGUMENT, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).MALFORMED_ARGUMENT, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).MALFORMED_ARGUMENT, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $40e0a547127cbfee$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $40e0a547127cbfee$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $40e0a547127cbfee$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $40e0a547127cbfee$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $40e0a547127cbfee$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $40e0a547127cbfee$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $40e0a547127cbfee$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $bf5af2bd607f6563$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $6d93ce9b7508ba31$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $68c188c5ce67ae9e$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).date : (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).date : (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $40e0a547127cbfee$var$createLocation(typeEndPosition_1, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $40e0a547127cbfee$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $6d93ce9b7508ba31$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $40e0a547127cbfee$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $40e0a547127cbfee$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $40e0a547127cbfee$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $55abffaa7be2a294$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $6d93ce9b7508ba31$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $55abffaa7be2a294$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $566ea7342c8aac00$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $40e0a547127cbfee$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $566ea7342c8aac00$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $566ea7342c8aac00$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $40e0a547127cbfee$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $566ea7342c8aac00$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $566ea7342c8aac00$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $40e0a547127cbfee$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $40e0a547127cbfee$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$40e0a547127cbfee$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $40e0a547127cbfee$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($40e0a547127cbfee$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $40e0a547127cbfee$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $40e0a547127cbfee$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $40e0a547127cbfee$var$_isAlphaOrSlash(codepoint) {
    return $40e0a547127cbfee$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $40e0a547127cbfee$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $40e0a547127cbfee$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $40e0a547127cbfee$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $c9a2d9a40bc639f4$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $6d93ce9b7508ba31$export$dcfe1c11d168b5a1)(el) || (0, $6d93ce9b7508ba31$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $c9a2d9a40bc639f4$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $6d93ce9b7508ba31$export$e11187b219e191e1)(el) && (0, $6d93ce9b7508ba31$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $6d93ce9b7508ba31$export$32d811605da75f40)(el) || (0, $6d93ce9b7508ba31$export$34ec46f596b1702f)(el)) && (0, $6d93ce9b7508ba31$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $6d93ce9b7508ba31$export$5c83de34745812b)(el)) $c9a2d9a40bc639f4$var$pruneLocation(el.children);
    });
}
function $c9a2d9a40bc639f4$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $40e0a547127cbfee$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $566ea7342c8aac00$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $c9a2d9a40bc639f4$var$pruneLocation(result.val);
    return result.val;
}
var $c9a2d9a40bc639f4$export$d3c1bfa0f7d806e9 = (0, $40e0a547127cbfee$export$7acfa6ed01010e37);




var $b2de32051be1701b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b2de32051be1701b$export$d4e71bc0b80dc0fb || ($b2de32051be1701b$export$d4e71bc0b80dc0fb = {}));
var $b2de32051be1701b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b2de32051be1701b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b2de32051be1701b$export$7369836851cc1329);


var $a7bf6eec6df43b65$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a7bf6eec6df43b65$export$49694c2877b44c57 || ($a7bf6eec6df43b65$export$49694c2877b44c57 = {}));
function $a7bf6eec6df43b65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal || part.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a7bf6eec6df43b65$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $a7bf6eec6df43b65$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $6d93ce9b7508ba31$export$cfa10c5697238752)(els[0])) return [
        {
            type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $6d93ce9b7508ba31$export$cfa10c5697238752)(el)) {
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $6d93ce9b7508ba31$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $b2de32051be1701b$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $6d93ce9b7508ba31$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $6d93ce9b7508ba31$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $6d93ce9b7508ba31$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $6d93ce9b7508ba31$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $6d93ce9b7508ba31$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $6d93ce9b7508ba31$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $6d93ce9b7508ba31$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $6d93ce9b7508ba31$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a7bf6eec6df43b65$export$df0c12a2d414a163(formatFn)) throw new (0, $b2de32051be1701b$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $a7bf6eec6df43b65$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $6d93ce9b7508ba31$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $6d93ce9b7508ba31$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $b2de32051be1701b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a7bf6eec6df43b65$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $65f19ee2190344e6$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $65f19ee2190344e6$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $65f19ee2190344e6$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, defaultConfig));
}
function $65f19ee2190344e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $65f19ee2190344e6$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $b236ccb710e31bc5$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.number),
            strategy: (0, $b236ccb710e31bc5$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $b236ccb710e31bc5$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $b236ccb710e31bc5$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $b236ccb710e31bc5$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $b236ccb710e31bc5$export$c5491a8691a23b9e).variadic
        })
    };
}
var $65f19ee2190344e6$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $a7bf6eec6df43b65$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $a7bf6eec6df43b65$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $65f19ee2190344e6$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $65f19ee2190344e6$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $c9a2d9a40bc639f4$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $693d63d2fb891c85$export$2e2bcd8739ae039 = (0, $65f19ee2190344e6$export$d342343268debc40);


//
// Main
//
function $4cd71bde5c6db5d4$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $4cd71bde5c6db5d4$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $4cd71bde5c6db5d4$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $4cd71bde5c6db5d4$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $4cd71bde5c6db5d4$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $4cd71bde5c6db5d4$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $4cd71bde5c6db5d4$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4cd71bde5c6db5d4$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $4cd71bde5c6db5d4$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $4cd71bde5c6db5d4$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $4cd71bde5c6db5d4$var$monadic : $4cd71bde5c6db5d4$var$variadic;
    return $4cd71bde5c6db5d4$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $4cd71bde5c6db5d4$var$strategyVariadic(fn, options) {
    return $4cd71bde5c6db5d4$var$assemble(fn, this, $4cd71bde5c6db5d4$var$variadic, options.cache.create(), options.serializer);
}
function $4cd71bde5c6db5d4$var$strategyMonadic(fn, options) {
    return $4cd71bde5c6db5d4$var$assemble(fn, this, $4cd71bde5c6db5d4$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $4cd71bde5c6db5d4$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $4cd71bde5c6db5d4$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$4cd71bde5c6db5d4$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$4cd71bde5c6db5d4$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $4cd71bde5c6db5d4$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $4cd71bde5c6db5d4$var$ObjectWithoutPrototypeCache();
    }
};
var $4cd71bde5c6db5d4$export$c5491a8691a23b9e = {
    variadic: $4cd71bde5c6db5d4$var$strategyVariadic,
    monadic: $4cd71bde5c6db5d4$var$strategyMonadic
};



var $68b242487880b508$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($68b242487880b508$export$557d6acb76e8a244 || ($68b242487880b508$export$557d6acb76e8a244 = {}));
var $68b242487880b508$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $68b242487880b508$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $68b242487880b508$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($68b242487880b508$export$e3b7eee1dbc44895);
var $68b242487880b508$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $68b242487880b508$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($68b242487880b508$export$c016d36112f6ddf8);


function $864ced6e9596b36d$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $864ced6e9596b36d$var$defaultErrorHandler = function(error) {};
var $864ced6e9596b36d$var$defaultWarnHandler = function(warning) {};
var $864ced6e9596b36d$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $864ced6e9596b36d$var$defaultErrorHandler,
    onWarn: $864ced6e9596b36d$var$defaultWarnHandler
};
function $864ced6e9596b36d$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $864ced6e9596b36d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $864ced6e9596b36d$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $864ced6e9596b36d$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.number),
        strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $65f19ee2190344e6$export$d342343268debc40)(message, locales, overrideFormats, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.message),
            strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.list),
            strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
        })
    };
}
function $864ced6e9596b36d$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $68b242487880b508$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $2911c18a2024d56a$export$45c4bbf6e55bba1f(intl) {
    (0, $e5c7ec88ecc0f34d$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $2911c18a2024d56a$export$b52f8d6fc0d47415 = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $864ced6e9596b36d$export$b52f8d6fc0d47415)), {
    textComponent: $acw62.Fragment
});
function $2911c18a2024d56a$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($acw62.Children.toArray(parts));
    };
}
function $2911c18a2024d56a$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}




var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

function $e0f39ec61dff1544$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $e0f39ec61dff1544$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $acw62.createContext(null)) : $acw62.createContext(null);
var $e0f39ec61dff1544$var$IntlConsumer = $e0f39ec61dff1544$var$IntlContext.Consumer, $e0f39ec61dff1544$var$IntlProvider = $e0f39ec61dff1544$var$IntlContext.Provider;
var $e0f39ec61dff1544$export$2881499e37b75b9a = $e0f39ec61dff1544$var$IntlProvider;
var $e0f39ec61dff1544$export$841858b892ce1f4c = $e0f39ec61dff1544$var$IntlContext;
function $e0f39ec61dff1544$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $acw62.createElement($e0f39ec61dff1544$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $2911c18a2024d56a$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $acw62.createElement(WrappedComponent, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($e0f39ec61dff1544$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(// @ts-expect-error
    $acw62.forwardRef(function(props, ref) {
        return $acw62.createElement(WithIntl, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WithIntl, WrappedComponent);
}


function $174d9ac429a8b478$export$2e2bcd8739ae039() {
    var intl = $acw62.useContext((0, $e0f39ec61dff1544$export$841858b892ce1f4c));
    (0, $2911c18a2024d56a$export$45c4bbf6e55bba1f)(intl);
    return intl;
}






var $acw62 = parcelRequire("acw62");

var $02bdb4ba7bdc281d$export$2e2bcd8739ae039 = {
    raw: ".hcr-link-16-4-0{background-color:initial;color:var(--hcr-link-color);font-weight:var(--hcr-font-weight-semibold);text-decoration:underline}.hcr-link-16-4-0:enabled:active,.hcr-link-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-link-16-4-0:enabled:hover,.hcr-link-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);border-radius:var(--hcr-border-radius-1);text-decoration:underline}.hcr-link-16-4-0:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}",
    map: {
        "hcr-link": "hcr-link-16-4-0"
    }
};






const $21ca9f2bc9d1bb2f$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('link', (0, $02bdb4ba7bdc281d$export$2e2bcd8739ae039));
function $21ca9f2bc9d1bb2f$export$a6c7ac8248d6e38a(_a) {
    var { children: children, extraClasses: extraClasses, innerRef: innerRef, RouterLink: RouterLink } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "innerRef",
        "RouterLink"
    ]);
    if (RouterLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RouterLink, Object.assign({
        className: $21ca9f2bc9d1bb2f$var$bem.b(false, extraClasses),
        to: rest.href || rest.to || ''
    }, innerRef ? {
        innerRef: innerRef
    } : {}, rest), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        ref: innerRef,
        className: $21ca9f2bc9d1bb2f$var$bem.b(false, extraClasses)
    }, rest), children);
}
$21ca9f2bc9d1bb2f$export$a6c7ac8248d6e38a.displayName = 'Link';
$21ca9f2bc9d1bb2f$export$a6c7ac8248d6e38a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    RouterLink: (0, $702b9449be14ac4b$export$50d0863e1c2a2c7f)
};
var $21ca9f2bc9d1bb2f$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($21ca9f2bc9d1bb2f$export$a6c7ac8248d6e38a, (0, $02bdb4ba7bdc281d$export$2e2bcd8739ae039));


parcelRequire("acw62");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $acw62 = parcelRequire("acw62");


function $5665a8818306a5ca$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $2911c18a2024d56a$export$d36bdfa510afb180)(nextValues, values) && (0, $2911c18a2024d56a$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $5665a8818306a5ca$var$FormattedMessage(props) {
    var intl = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $acw62.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $acw62.createElement(Component, null, $acw62.Children.toArray(nodes));
    return $acw62.createElement($acw62.Fragment, null, nodes);
}
$5665a8818306a5ca$var$FormattedMessage.displayName = 'FormattedMessage';
var $5665a8818306a5ca$var$MemoizedFormattedMessage = $acw62.memo($5665a8818306a5ca$var$FormattedMessage, $5665a8818306a5ca$var$areEqual);
$5665a8818306a5ca$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $5665a8818306a5ca$export$2e2bcd8739ae039 = $5665a8818306a5ca$var$MemoizedFormattedMessage;



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $722bc9eaf0c39f46$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};

/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7c375ae106b964be$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $7c375ae106b964be$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    GONE: 410,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $7c375ae106b964be$export$8343e6f32f5246de = {
    GET: "GET",
    POST: "POST"
};
const $7c375ae106b964be$export$893b1b5b686d84ef = [
    $7c375ae106b964be$export$a002182e51710d39.OPENID_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.PROFILE_SCOPE,
    $7c375ae106b964be$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $7c375ae106b964be$export$268e88275f5afab2 = [
    ...$7c375ae106b964be$export$893b1b5b686d84ef,
    $7c375ae106b964be$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $7c375ae106b964be$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $7c375ae106b964be$export$81ab9ba9bd28255c = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $7c375ae106b964be$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $7c375ae106b964be$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $7c375ae106b964be$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $7c375ae106b964be$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const $7c375ae106b964be$export$5ef2b2ebd3da3e04 = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for server response type
 * @deprecated Use ResponseMode instead
 */ const $7c375ae106b964be$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $7c375ae106b964be$export$f990a5bae1260b8c = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $7c375ae106b964be$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $7c375ae106b964be$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $7c375ae106b964be$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $7c375ae106b964be$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $7c375ae106b964be$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $7c375ae106b964be$export$7e1bea6dc1b6b32e = "appmetadata";
const $7c375ae106b964be$export$476989d62bcb4c85 = "client_info";
const $7c375ae106b964be$export$978fe7ab5e74b539 = "1";
const $7c375ae106b964be$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $7c375ae106b964be$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $7c375ae106b964be$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $7c375ae106b964be$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $7c375ae106b964be$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $7c375ae106b964be$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $7c375ae106b964be$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const $7c375ae106b964be$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $7c375ae106b964be$export$92a685f9218422bd = {
    CONFIGURED_NO_AUTO_DETECTION: "2",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $7c375ae106b964be$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $7c375ae106b964be$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $7c375ae106b964be$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $7c375ae106b964be$export$8d50f42618161d1a = 300;
const $7c375ae106b964be$export$6592cb873eed5846 = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $5ff55562d73e0e2b$export$a0a689e4294b9880 = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $5ff55562d73e0e2b$export$3ebdf53424883b5f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $5ff55562d73e0e2b$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $5ff55562d73e0e2b$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $5ff55562d73e0e2b$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
const $5ff55562d73e0e2b$export$dc1d3aa5f3837765 = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $5ff55562d73e0e2b$export$21d55bedf0d269fb = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const $5ff55562d73e0e2b$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 * 900-999 Miscellaneous
 */ const $5ff55562d73e0e2b$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
};
/**
 * API Names for Telemetry purposes.
 */ const $5ff55562d73e0e2b$export$7ee4637d1247e747 = {
    861: "acquireTokenRedirect",
    862: "acquireTokenPopup",
    863: "ssoSilent",
    864: "acquireTokenSilent_authCode",
    865: "handleRedirectPromise",
    866: "acquireTokenByCode",
    61: "acquireTokenSilent_silentFlow",
    961: "logout",
    962: "logoutPopup",
    963: "hydrateCache",
    964: "loadExternalTokens"
};
const $5ff55562d73e0e2b$export$970e8382081b483f = (id)=>{
    if (typeof id === "number" && id in $5ff55562d73e0e2b$export$7ee4637d1247e747) return $5ff55562d73e0e2b$export$7ee4637d1247e747[id];
    return "unknown";
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $5ff55562d73e0e2b$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($5ff55562d73e0e2b$export$4ec29255e7e7f68f || ($5ff55562d73e0e2b$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $5ff55562d73e0e2b$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $5ff55562d73e0e2b$export$7e12949cd6884193 = {
    scopes: (0, $7c375ae106b964be$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $5ff55562d73e0e2b$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $5ff55562d73e0e2b$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $5ff55562d73e0e2b$export$3c22ff8b64b8f565 = "msal.db";
const $5ff55562d73e0e2b$export$6a9022b4c5fcea02 = 1;
const $5ff55562d73e0e2b$export$9d785db034fb436f = `${$5ff55562d73e0e2b$export$3c22ff8b64b8f565}.keys`;
const $5ff55562d73e0e2b$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $5ff55562d73e0e2b$export$736180706fb122ee = [
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Default,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.Skip,
    $5ff55562d73e0e2b$export$4394baa7e922d42d.RefreshTokenAndNetwork
];


/*! @azure/msal-react v3.0.29 2026-03-18 */ /*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-common v15.17.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $0bf1d54ef751a29c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($0bf1d54ef751a29c$export$243e62d78d3b544d || ($0bf1d54ef751a29c$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $0bf1d54ef751a29c$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $0bf1d54ef751a29c$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $0bf1d54ef751a29c$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $0bf1d54ef751a29c$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$0bf1d54ef751a29c$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $0bf1d54ef751a29c$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}

/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 
var $1a08d0bb87f43eeb$exports = {};

$parcel$export($1a08d0bb87f43eeb$exports, "unexpectedError", () => $1a08d0bb87f43eeb$export$efbc88c27b0be04);
$parcel$export($1a08d0bb87f43eeb$exports, "postRequestFailed", () => $1a08d0bb87f43eeb$export$7a1e28a7b60ca602);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $1a08d0bb87f43eeb$export$efbc88c27b0be04 = "unexpected_error";
const $1a08d0bb87f43eeb$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0ff8310393c4d2db$export$cd5f04206718d3a5 = {
    [(0, $1a08d0bb87f43eeb$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $0ff8310393c4d2db$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $1a08d0bb87f43eeb$export$efbc88c27b0be04),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602),
        desc: $0ff8310393c4d2db$export$cd5f04206718d3a5[0, $1a08d0bb87f43eeb$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $0ff8310393c4d2db$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $0ff8310393c4d2db$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $0ff8310393c4d2db$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $0ff8310393c4d2db$export$145273558d58e0ac(code, additionalMessage ? `${$0ff8310393c4d2db$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $0ff8310393c4d2db$export$cd5f04206718d3a5[code]);
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b7c9daf3e548a083$export$41d7a3d4e14d6113 = "storage_not_supported";
const $b7c9daf3e548a083$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $b7c9daf3e548a083$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d12a658e6d92d79e$export$a14089932466e176 = {
    [(0, $b7c9daf3e548a083$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $b7c9daf3e548a083$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $d12a658e6d92d79e$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $b7c9daf3e548a083$export$41d7a3d4e14d6113),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $b7c9daf3e548a083$export$1377ea690fa0b6d8),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $b7c9daf3e548a083$export$37486e3b6bed61c6),
        desc: $d12a658e6d92d79e$export$a14089932466e176[0, $b7c9daf3e548a083$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $d12a658e6d92d79e$export$176bd5050947ba0c(errorCode) {
    return new $d12a658e6d92d79e$export$2eb7a1dfdc4c5fba(errorCode, $d12a658e6d92d79e$export$a14089932466e176[errorCode]);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d2a81b67c35e82cb$export$29650b96fd06034a = {
    initialize: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    getAccountByHomeId: ()=>{
        return null;
    },
    getAccountByUsername: ()=>{
        return null;
    },
    getAccountByLocalId: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    loginPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logout: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    enableAccountStorageEvents: ()=>{
        return;
    },
    disableAccountStorageEvents: ()=>{
        return;
    },
    getTokenCache: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    getLogger: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8));
    },
    hydrateCache: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    },
    clearCache: ()=>{
        return Promise.reject((0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$1377ea690fa0b6d8)));
    }
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $1dc604eb300e1131$var$defaultMsalContext = {
    instance: (0, $d2a81b67c35e82cb$export$29650b96fd06034a),
    inProgress: (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None,
    accounts: [],
    logger: new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)({})
};
const $1dc604eb300e1131$export$66324aeea97dd1e5 = $acw62.createContext($1dc604eb300e1131$var$defaultMsalContext);
const $1dc604eb300e1131$export$b74154d0810e24c1 = $1dc604eb300e1131$export$66324aeea97dd1e5.Consumer;


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c309956643209ca0$export$ba9166e03da6599c {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Login;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).SsoSilent;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup) return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START:
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Logout;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).SsoSilent) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Logout) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Login && currentStatus !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    }
}



/*! @azure/msal-react v3.0.29 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1f6f413f87363628$export$7a39d5906c5d6010(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $1f6f413f87363628$export$601fd69958c01c8c(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $1f6f413f87363628$export$fa581286d49c51db(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 'use strict';
/* eslint-disable header/header */ const $31c121d5e6ab4e5f$export$a8ff84c12d48cfa6 = "@azure/msal-react";
const $31c121d5e6ab4e5f$export$83d89fbfd8236492 = "3.0.29";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7b3e52a40af96eae$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $7b3e52a40af96eae$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $7b3e52a40af96eae$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'");
            }
            break;
        case $7b3e52a40af96eae$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $c309956643209ca0$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - ${message.eventType} results in setting inProgress from ${previousState.inProgress} to ${status}`);
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    if (newInProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) // Can't start checking accounts until initialization is complete
    return previousState;
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !(0, $1f6f413f87363628$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!(0, $1f6f413f87363628$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $7b3e52a40af96eae$export$25bac41dc3d78d47({ instance: instance, children: children }) {
    (0, $acw62.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $5ff55562d73e0e2b$export$8abb9de997bb4e44).React, (0, $31c121d5e6ab4e5f$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $acw62.useMemo)(()=>{
        return instance.getLogger().clone((0, $31c121d5e6ab4e5f$export$a8ff84c12d48cfa6), (0, $31c121d5e6ab4e5f$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    const [state, updateState] = (0, $acw62.useReducer)($7b3e52a40af96eae$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup,
            accounts: []
        };
    });
    (0, $acw62.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $7b3e52a40af96eae$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $7b3e52a40af96eae$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dc604eb300e1131$export$66324aeea97dd1e5).Provider, {
        value: contextValue
    }, children);
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");

/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $5ae49243d6498b42$export$f41558044a1dd55 = ()=>(0, $acw62.useContext)((0, $1dc604eb300e1131$export$66324aeea97dd1e5));


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $41a0d322aea9de82$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!(0, $1f6f413f87363628$export$fa581286d49c51db)(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $41a0d322aea9de82$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const isUserAuthenticated = (0, $acw62.useMemo)(()=>{
        if (inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) return false;
        return $41a0d322aea9de82$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $89a512f94435fcda$export$3f7734c901feade6({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $f0c0868d77661165$export$8285a35799c5812b({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-common v15.17.0 2026-03-18 */ 

var $84767569d86b0bc0$exports = {};

$parcel$export($84767569d86b0bc0$exports, "noTokensFound", () => $84767569d86b0bc0$export$e408b083cd212696);
$parcel$export($84767569d86b0bc0$exports, "nativeAccountUnavailable", () => $84767569d86b0bc0$export$3bf2eb3358f5f570);
$parcel$export($84767569d86b0bc0$exports, "refreshTokenExpired", () => $84767569d86b0bc0$export$a90e8b9c10991b49);
$parcel$export($84767569d86b0bc0$exports, "uxNotAllowed", () => $84767569d86b0bc0$export$a58b5e049da4f1a6);
$parcel$export($84767569d86b0bc0$exports, "interactionRequired", () => $84767569d86b0bc0$export$cdb77bf88e749c31);
$parcel$export($84767569d86b0bc0$exports, "consentRequired", () => $84767569d86b0bc0$export$ca4e8d96d12fe4c5);
$parcel$export($84767569d86b0bc0$exports, "loginRequired", () => $84767569d86b0bc0$export$402ebc0f96d7decb);
$parcel$export($84767569d86b0bc0$exports, "badToken", () => $84767569d86b0bc0$export$2e3666c77d45a4da);
$parcel$export($84767569d86b0bc0$exports, "interruptedUser", () => $84767569d86b0bc0$export$54dc2de0f2617e03);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * MSAL-defined interaction required error code indicating no tokens are found in cache.
 * @public
 */ const $84767569d86b0bc0$export$e408b083cd212696 = "no_tokens_found";
/**
 * MSAL-defined error code indicating a native account is unavailable on the platform.
 * @public
 */ const $84767569d86b0bc0$export$3bf2eb3358f5f570 = "native_account_unavailable";
/**
 * MSAL-defined error code indicating the refresh token has expired and user interaction is needed.
 * @public
 */ const $84767569d86b0bc0$export$a90e8b9c10991b49 = "refresh_token_expired";
/**
 * MSAL-defined error code indicating UI/UX is not allowed (e.g., blocked by policy), requiring alternate interaction.
 * @public
 */ const $84767569d86b0bc0$export$a58b5e049da4f1a6 = "ux_not_allowed";
/**
 * Server-originated error code indicating interaction is required to complete the request.
 * @public
 */ const $84767569d86b0bc0$export$cdb77bf88e749c31 = "interaction_required";
/**
 * Server-originated error code indicating user consent is required.
 * @public
 */ const $84767569d86b0bc0$export$ca4e8d96d12fe4c5 = "consent_required";
/**
 * Server-originated error code indicating user login is required.
 * @public
 */ const $84767569d86b0bc0$export$402ebc0f96d7decb = "login_required";
/**
 * Server-originated error code indicating the token is invalid or corrupted.
 * @public
 */ const $84767569d86b0bc0$export$2e3666c77d45a4da = "bad_token";
/**
 * Server-originated error code indicating the user was interrupted and must reattempt the flow.
 * @public
 */ const $84767569d86b0bc0$export$54dc2de0f2617e03 = "interrupted_user";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $18a94acc3dad87ad$export$e16d6a6c677acec5 = [
    (0, $84767569d86b0bc0$export$cdb77bf88e749c31),
    (0, $84767569d86b0bc0$export$ca4e8d96d12fe4c5),
    (0, $84767569d86b0bc0$export$402ebc0f96d7decb),
    (0, $84767569d86b0bc0$export$2e3666c77d45a4da),
    (0, $84767569d86b0bc0$export$a58b5e049da4f1a6),
    (0, $84767569d86b0bc0$export$54dc2de0f2617e03)
];
const $18a94acc3dad87ad$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token",
    "interrupted_user"
];
const $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages = {
    [(0, $84767569d86b0bc0$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $84767569d86b0bc0$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $84767569d86b0bc0$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $84767569d86b0bc0$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve.",
    [(0, $84767569d86b0bc0$export$a58b5e049da4f1a6)]: "`canShowUI` flag in Edge was set to false. User interaction required on web page. Please invoke an interactive API to resolve.",
    [(0, $84767569d86b0bc0$export$54dc2de0f2617e03)]: "The user could not be authenticated due to an interrupted state. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $18a94acc3dad87ad$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $84767569d86b0bc0$export$e408b083cd212696),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $84767569d86b0bc0$export$3bf2eb3358f5f570),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $84767569d86b0bc0$export$2e3666c77d45a4da),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$2e3666c77d45a4da]
    },
    interrupted_user: {
        code: (0, $84767569d86b0bc0$export$54dc2de0f2617e03),
        desc: $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[0, $84767569d86b0bc0$export$54dc2de0f2617e03]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $18a94acc3dad87ad$export$6ba3e818c6bc76ba extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $18a94acc3dad87ad$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $18a94acc3dad87ad$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $18a94acc3dad87ad$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $18a94acc3dad87ad$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $18a94acc3dad87ad$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $18a94acc3dad87ad$export$8f7a741750c16535(errorCode) {
    return new $18a94acc3dad87ad$export$6ba3e818c6bc76ba(errorCode, $18a94acc3dad87ad$var$InteractionRequiredAuthErrorMessages[errorCode]);
}




/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");
/*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 
var $6be88bbe69356b76$exports = {};

$parcel$export($6be88bbe69356b76$exports, "clientInfoDecodingError", () => $6be88bbe69356b76$export$ccdf48c387c47b82);
$parcel$export($6be88bbe69356b76$exports, "clientInfoEmptyError", () => $6be88bbe69356b76$export$12315251e24e0181);
$parcel$export($6be88bbe69356b76$exports, "tokenParsingError", () => $6be88bbe69356b76$export$ad362b2e3a260143);
$parcel$export($6be88bbe69356b76$exports, "nullOrEmptyToken", () => $6be88bbe69356b76$export$78d01e29cb494be2);
$parcel$export($6be88bbe69356b76$exports, "endpointResolutionError", () => $6be88bbe69356b76$export$c9fcc93738cc2bc3);
$parcel$export($6be88bbe69356b76$exports, "networkError", () => $6be88bbe69356b76$export$4358cbadf08aa73);
$parcel$export($6be88bbe69356b76$exports, "openIdConfigError", () => $6be88bbe69356b76$export$73566da29bc073eb);
$parcel$export($6be88bbe69356b76$exports, "hashNotDeserialized", () => $6be88bbe69356b76$export$14c4d54a8414667f);
$parcel$export($6be88bbe69356b76$exports, "invalidState", () => $6be88bbe69356b76$export$72a77317632c052b);
$parcel$export($6be88bbe69356b76$exports, "stateMismatch", () => $6be88bbe69356b76$export$6a56d8f882843cd8);
$parcel$export($6be88bbe69356b76$exports, "stateNotFound", () => $6be88bbe69356b76$export$ef9214cfa5960fc);
$parcel$export($6be88bbe69356b76$exports, "nonceMismatch", () => $6be88bbe69356b76$export$edd0491c2c280be7);
$parcel$export($6be88bbe69356b76$exports, "authTimeNotFound", () => $6be88bbe69356b76$export$43356944266c945e);
$parcel$export($6be88bbe69356b76$exports, "maxAgeTranspired", () => $6be88bbe69356b76$export$f95fb86904f89749);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingTokens", () => $6be88bbe69356b76$export$47c50a2451614107);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAccounts", () => $6be88bbe69356b76$export$2804a8b1b4c3be8b);
$parcel$export($6be88bbe69356b76$exports, "multipleMatchingAppMetadata", () => $6be88bbe69356b76$export$575bb2924bcd0084);
$parcel$export($6be88bbe69356b76$exports, "requestCannotBeMade", () => $6be88bbe69356b76$export$4ac9fb1f531eded7);
$parcel$export($6be88bbe69356b76$exports, "cannotRemoveEmptyScope", () => $6be88bbe69356b76$export$f7a276c01beb068a);
$parcel$export($6be88bbe69356b76$exports, "cannotAppendScopeSet", () => $6be88bbe69356b76$export$93883786cf4a4a27);
$parcel$export($6be88bbe69356b76$exports, "emptyInputScopeSet", () => $6be88bbe69356b76$export$41e2ce5958c42c83);
$parcel$export($6be88bbe69356b76$exports, "deviceCodePollingCancelled", () => $6be88bbe69356b76$export$e3af42f9856ab2a);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeExpired", () => $6be88bbe69356b76$export$c0ef55deeb5e30d5);
$parcel$export($6be88bbe69356b76$exports, "deviceCodeUnknownError", () => $6be88bbe69356b76$export$4a9e9cce395ba70c);
$parcel$export($6be88bbe69356b76$exports, "noAccountInSilentRequest", () => $6be88bbe69356b76$export$5a3c7d1c90ac9220);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheRecord", () => $6be88bbe69356b76$export$d396103576f879cc);
$parcel$export($6be88bbe69356b76$exports, "invalidCacheEnvironment", () => $6be88bbe69356b76$export$dedc648643245fa1);
$parcel$export($6be88bbe69356b76$exports, "noAccountFound", () => $6be88bbe69356b76$export$b98ebfe073f0162f);
$parcel$export($6be88bbe69356b76$exports, "noCryptoObject", () => $6be88bbe69356b76$export$c39e501a22cba395);
$parcel$export($6be88bbe69356b76$exports, "unexpectedCredentialType", () => $6be88bbe69356b76$export$21fdd1f95350cd6d);
$parcel$export($6be88bbe69356b76$exports, "invalidAssertion", () => $6be88bbe69356b76$export$e168896c692fb06b);
$parcel$export($6be88bbe69356b76$exports, "invalidClientCredential", () => $6be88bbe69356b76$export$c483ba88a47982b1);
$parcel$export($6be88bbe69356b76$exports, "tokenRefreshRequired", () => $6be88bbe69356b76$export$e23b692cce0c7779);
$parcel$export($6be88bbe69356b76$exports, "userTimeoutReached", () => $6be88bbe69356b76$export$afbb99ff17e87b86);
$parcel$export($6be88bbe69356b76$exports, "tokenClaimsCnfRequiredForSignedJwt", () => $6be88bbe69356b76$export$6f89b8a7d491b526);
$parcel$export($6be88bbe69356b76$exports, "authorizationCodeMissingFromServerResponse", () => $6be88bbe69356b76$export$93625fc864d26bba);
$parcel$export($6be88bbe69356b76$exports, "bindingKeyNotRemoved", () => $6be88bbe69356b76$export$5765db5d84418d29);
$parcel$export($6be88bbe69356b76$exports, "endSessionEndpointNotSupported", () => $6be88bbe69356b76$export$c3bd741c16a889f3);
$parcel$export($6be88bbe69356b76$exports, "keyIdMissing", () => $6be88bbe69356b76$export$3c9338a50e294d1);
$parcel$export($6be88bbe69356b76$exports, "noNetworkConnectivity", () => $6be88bbe69356b76$export$31ae862f18c3b2b7);
$parcel$export($6be88bbe69356b76$exports, "userCanceled", () => $6be88bbe69356b76$export$8ee329e65a880ec7);
$parcel$export($6be88bbe69356b76$exports, "missingTenantIdError", () => $6be88bbe69356b76$export$8c321d057617a458);
$parcel$export($6be88bbe69356b76$exports, "methodNotImplemented", () => $6be88bbe69356b76$export$24176fc1f15eea22);
$parcel$export($6be88bbe69356b76$exports, "nestedAppAuthBridgeDisabled", () => $6be88bbe69356b76$export$3078b0202fe7eea3);
$parcel$export($6be88bbe69356b76$exports, "platformBrokerError", () => $6be88bbe69356b76$export$3642667d172bf3ce);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6be88bbe69356b76$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $6be88bbe69356b76$export$12315251e24e0181 = "client_info_empty_error";
const $6be88bbe69356b76$export$ad362b2e3a260143 = "token_parsing_error";
const $6be88bbe69356b76$export$78d01e29cb494be2 = "null_or_empty_token";
const $6be88bbe69356b76$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $6be88bbe69356b76$export$4358cbadf08aa73 = "network_error";
const $6be88bbe69356b76$export$73566da29bc073eb = "openid_config_error";
const $6be88bbe69356b76$export$14c4d54a8414667f = "hash_not_deserialized";
const $6be88bbe69356b76$export$72a77317632c052b = "invalid_state";
const $6be88bbe69356b76$export$6a56d8f882843cd8 = "state_mismatch";
const $6be88bbe69356b76$export$ef9214cfa5960fc = "state_not_found";
const $6be88bbe69356b76$export$edd0491c2c280be7 = "nonce_mismatch";
const $6be88bbe69356b76$export$43356944266c945e = "auth_time_not_found";
const $6be88bbe69356b76$export$f95fb86904f89749 = "max_age_transpired";
const $6be88bbe69356b76$export$47c50a2451614107 = "multiple_matching_tokens";
const $6be88bbe69356b76$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $6be88bbe69356b76$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $6be88bbe69356b76$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $6be88bbe69356b76$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $6be88bbe69356b76$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $6be88bbe69356b76$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $6be88bbe69356b76$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $6be88bbe69356b76$export$c0ef55deeb5e30d5 = "device_code_expired";
const $6be88bbe69356b76$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $6be88bbe69356b76$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $6be88bbe69356b76$export$d396103576f879cc = "invalid_cache_record";
const $6be88bbe69356b76$export$dedc648643245fa1 = "invalid_cache_environment";
const $6be88bbe69356b76$export$b98ebfe073f0162f = "no_account_found";
const $6be88bbe69356b76$export$c39e501a22cba395 = "no_crypto_object";
const $6be88bbe69356b76$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $6be88bbe69356b76$export$e168896c692fb06b = "invalid_assertion";
const $6be88bbe69356b76$export$c483ba88a47982b1 = "invalid_client_credential";
const $6be88bbe69356b76$export$e23b692cce0c7779 = "token_refresh_required";
const $6be88bbe69356b76$export$afbb99ff17e87b86 = "user_timeout_reached";
const $6be88bbe69356b76$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $6be88bbe69356b76$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $6be88bbe69356b76$export$5765db5d84418d29 = "binding_key_not_removed";
const $6be88bbe69356b76$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $6be88bbe69356b76$export$3c9338a50e294d1 = "key_id_missing";
const $6be88bbe69356b76$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $6be88bbe69356b76$export$8ee329e65a880ec7 = "user_canceled";
const $6be88bbe69356b76$export$8c321d057617a458 = "missing_tenant_id_error";
const $6be88bbe69356b76$export$24176fc1f15eea22 = "method_not_implemented";
const $6be88bbe69356b76$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";
const $6be88bbe69356b76$export$3642667d172bf3ce = "platform_broker_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $eaea74bac26129fa$export$8190ec70cbf7ec08 = {
    [(0, $6be88bbe69356b76$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $6be88bbe69356b76$export$12315251e24e0181)]: "The client info was empty",
    [(0, $6be88bbe69356b76$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $6be88bbe69356b76$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $6be88bbe69356b76$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $6be88bbe69356b76$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $6be88bbe69356b76$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $6be88bbe69356b76$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $6be88bbe69356b76$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $6be88bbe69356b76$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $6be88bbe69356b76$export$ef9214cfa5960fc)]: "State not found",
    [(0, $6be88bbe69356b76$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $6be88bbe69356b76$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $6be88bbe69356b76$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $6be88bbe69356b76$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $6be88bbe69356b76$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $6be88bbe69356b76$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $6be88bbe69356b76$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $6be88bbe69356b76$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $6be88bbe69356b76$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $6be88bbe69356b76$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $6be88bbe69356b76$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $6be88bbe69356b76$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $6be88bbe69356b76$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $6be88bbe69356b76$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $6be88bbe69356b76$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $6be88bbe69356b76$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $6be88bbe69356b76$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $6be88bbe69356b76$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $6be88bbe69356b76$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $6be88bbe69356b76$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $6be88bbe69356b76$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $6be88bbe69356b76$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $6be88bbe69356b76$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $6be88bbe69356b76$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $6be88bbe69356b76$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $6be88bbe69356b76$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $6be88bbe69356b76$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $6be88bbe69356b76$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $6be88bbe69356b76$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $6be88bbe69356b76$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $6be88bbe69356b76$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $6be88bbe69356b76$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $6be88bbe69356b76$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled",
    [(0, $6be88bbe69356b76$export$3642667d172bf3ce)]: "An error occurred in the native broker. See the platformBrokerError property for details."
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $eaea74bac26129fa$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $6be88bbe69356b76$export$ccdf48c387c47b82),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $6be88bbe69356b76$export$12315251e24e0181),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $6be88bbe69356b76$export$ad362b2e3a260143),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $6be88bbe69356b76$export$78d01e29cb494be2),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $6be88bbe69356b76$export$c9fcc93738cc2bc3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $6be88bbe69356b76$export$4358cbadf08aa73),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $6be88bbe69356b76$export$73566da29bc073eb),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $6be88bbe69356b76$export$14c4d54a8414667f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $6be88bbe69356b76$export$72a77317632c052b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $6be88bbe69356b76$export$6a56d8f882843cd8),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $6be88bbe69356b76$export$ef9214cfa5960fc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $6be88bbe69356b76$export$edd0491c2c280be7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $6be88bbe69356b76$export$43356944266c945e),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $6be88bbe69356b76$export$f95fb86904f89749),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $6be88bbe69356b76$export$47c50a2451614107),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $6be88bbe69356b76$export$2804a8b1b4c3be8b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $6be88bbe69356b76$export$575bb2924bcd0084),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $6be88bbe69356b76$export$4ac9fb1f531eded7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $6be88bbe69356b76$export$f7a276c01beb068a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $6be88bbe69356b76$export$93883786cf4a4a27),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $6be88bbe69356b76$export$41e2ce5958c42c83),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $6be88bbe69356b76$export$e3af42f9856ab2a),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $6be88bbe69356b76$export$c0ef55deeb5e30d5),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $6be88bbe69356b76$export$4a9e9cce395ba70c),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $6be88bbe69356b76$export$5a3c7d1c90ac9220),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $6be88bbe69356b76$export$d396103576f879cc),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $6be88bbe69356b76$export$dedc648643245fa1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $6be88bbe69356b76$export$b98ebfe073f0162f),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $6be88bbe69356b76$export$c39e501a22cba395),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $6be88bbe69356b76$export$21fdd1f95350cd6d),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $6be88bbe69356b76$export$e168896c692fb06b),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $6be88bbe69356b76$export$c483ba88a47982b1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $6be88bbe69356b76$export$e23b692cce0c7779),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $6be88bbe69356b76$export$afbb99ff17e87b86),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $6be88bbe69356b76$export$6f89b8a7d491b526),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $6be88bbe69356b76$export$93625fc864d26bba),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $6be88bbe69356b76$export$5765db5d84418d29),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $6be88bbe69356b76$export$c3bd741c16a889f3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $6be88bbe69356b76$export$3c9338a50e294d1),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $6be88bbe69356b76$export$31ae862f18c3b2b7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $6be88bbe69356b76$export$8ee329e65a880ec7),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $6be88bbe69356b76$export$8c321d057617a458),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $6be88bbe69356b76$export$3078b0202fe7eea3),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3078b0202fe7eea3]
    },
    platformBrokerError: {
        code: (0, $6be88bbe69356b76$export$3642667d172bf3ce),
        desc: $eaea74bac26129fa$export$8190ec70cbf7ec08[0, $6be88bbe69356b76$export$3642667d172bf3ce]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $eaea74bac26129fa$export$a839ff85a7957561 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $eaea74bac26129fa$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $eaea74bac26129fa$export$a839ff85a7957561.prototype);
    }
}
function $eaea74bac26129fa$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $eaea74bac26129fa$export$a839ff85a7957561(errorCode, additionalMessage);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $7aacd5d6e6d7482c$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $7aacd5d6e6d7482c$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $54830df9a5d9a12c$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr, preferred_username: preferred_username, upn: upn, login_hint: login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        username: "",
        isHomeTenant: $54830df9a5d9a12c$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $54830df9a5d9a12c$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $54830df9a5d9a12c$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $70363054a03152f4$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $da8f9f8eb56c5a02$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $de576c4d1becc778$export$73a3e3dedd37150d = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $d6acc4a6126921e0$export$680160523e6bfa6a {
    /**
     * Returns the AccountInfo interface for this account.
     */ static getAccountInfo(accountEntity) {
        const tenantProfiles = accountEntity.tenantProfiles || [];
        // Ensure at least the home tenant profile exists
        if (tenantProfiles.length === 0 && accountEntity.realm && accountEntity.localAccountId) tenantProfiles.push((0, $54830df9a5d9a12c$export$924857724cb21ba4)(accountEntity.homeAccountId, accountEntity.localAccountId, accountEntity.realm));
        return {
            homeAccountId: accountEntity.homeAccountId,
            environment: accountEntity.environment,
            tenantId: accountEntity.realm,
            username: accountEntity.username,
            localAccountId: accountEntity.localAccountId,
            loginHint: accountEntity.loginHint,
            name: accountEntity.name,
            nativeAccountId: accountEntity.nativeAccountId,
            authorityType: accountEntity.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map(tenantProfiles.map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            })),
            dataBoundary: accountEntity.dataBoundary
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        else account.authorityType = (0, $7c375ae106b964be$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) {
            clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
            if (clientInfo.xms_tdbr) account.dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
        }
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.loginHint = accountDetails.idTokenClaims?.login_hint;
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $d6acc4a6126921e0$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $7c375ae106b964be$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.loginHint = accountInfo.loginHint;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        const tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        // Ensure at least the home tenant profile exists
        if (tenantProfiles.length === 0 && accountInfo.tenantId && accountInfo.localAccountId) tenantProfiles.push((0, $54830df9a5d9a12c$export$924857724cb21ba4)(accountInfo.homeAccountId, accountInfo.localAccountId, accountInfo.tenantId, accountInfo.idTokenClaims));
        account.tenantProfiles = tenantProfiles;
        account.dataBoundary = accountInfo.dataBoundary;
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || authType === (0, $70363054a03152f4$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.loginHint === accountB.loginHint && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return (0, $1f6f413f87363628$export$fa581286d49c51db)(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $e5e33773db31b6c0$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const [account, setAccount] = (0, $acw62.useState)(()=>{
        if (inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) return null;
        else return $e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers);
    });
    (0, $acw62.useEffect)(()=>{
        if (inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).Startup) setAccount((currentAccount)=>{
            const nextAccount = $e5e33773db31b6c0$var$getAccount(instance, accountIdentifiers);
            if (!(0, $d6acc4a6126921e0$export$680160523e6bfa6a).accountInfoIsEqual(currentAccount, nextAccount, true)) {
                logger.info("useAccount - Updating account");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        inProgress,
        accountIdentifiers,
        instance,
        logger
    ]);
    return account;
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c88e71052189f2fb$export$a77ea62d722c2a73 = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $c88e71052189f2fb$export$2aa0f0a55de712e6 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $c88e71052189f2fb$export$2aa0f0a55de712e6.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError() {
        return new $c88e71052189f2fb$export$2aa0f0a55de712e6($c88e71052189f2fb$export$a77ea62d722c2a73.invalidInteractionType.code, $c88e71052189f2fb$export$a77ea62d722c2a73.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError() {
        return new $c88e71052189f2fb$export$2aa0f0a55de712e6($c88e71052189f2fb$export$a77ea62d722c2a73.unableToFallbackToInteraction.code, $c88e71052189f2fb$export$a77ea62d722c2a73.unableToFallbackToInteraction.desc);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $90c0acaab831205e$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifiers);
    const account = (0, $e5e33773db31b6c0$export$83a8e409853da004)(accountIdentifiers);
    const [[result, error], setResponse] = (0, $acw62.useState)([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $acw62.useRef)(inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None);
    (0, $acw62.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $acw62.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        switch(loginType){
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup:
                logger.verbose("useMsalAuthentication - Calling loginPopup");
                return instance.loginPopup(loginRequest);
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect:
                // This promise is not expected to resolve due to full frame redirect
                logger.verbose("useMsalAuthentication - Calling loginRedirect");
                return instance.loginRedirect(loginRequest).then(null);
            case (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent:
                logger.verbose("useMsalAuthentication - Calling ssoSilent");
                return instance.ssoSilent(loginRequest);
            default:
                throw (0, $c88e71052189f2fb$export$2aa0f0a55de712e6).createInvalidInteractionTypeError();
        }
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $acw62.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.");
            tokenRequest = {
                scopes: (0, $7c375ae106b964be$export$893b1b5b686d84ef)
            };
        }
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request");
            tokenRequest.account = account;
        }
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling acquireTokenSilent");
            return instance.acquireTokenSilent(tokenRequest).catch(async (e)=>{
                if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                    if (!interactionInProgress.current) {
                        logger.error("useMsalAuthentication - Interaction required, falling back to interaction");
                        return login(fallbackInteractionType, tokenRequest);
                    } else {
                        logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.");
                        throw (0, $c88e71052189f2fb$export$2aa0f0a55de712e6).createUnableToFallbackToInteractionError();
                    }
                }
                throw e;
            });
        };
        return getToken().then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $acw62.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            switch(message.eventType){
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS:
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
                    if (message.payload) setResponse([
                        message.payload,
                        null
                    ]);
                    break;
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE:
                case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                    if (message.error) setResponse([
                        null,
                        message.error
                    ]);
                    break;
            }
        });
        logger.verbose(`useMsalAuthentication - Registered event callback with id: ${callbackId}`);
        return ()=>{
            if (callbackId) {
                logger.verbose(`useMsalAuthentication - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    (0, $acw62.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) {
            if (!isAuthenticated) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        }
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $8be22596aceaa726$export$c9cd7a02d4bd7707({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = (0, $acw62.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const msalAuthResult = (0, $90c0acaab831205e$export$d130d543558e611f)(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = (0, $41a0d322aea9de82$export$7e9c60d6d1836c84)(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1f6f413f87363628$export$7a39d5906c5d6010)(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingComponent, {
        ...context
    });
    return null;
}


/*! @azure/msal-react v3.0.29 2026-03-18 */ 
var $acw62 = parcelRequire("acw62");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $89d1927841dd723e$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};







'use strict';


parcelRequire("acw62");

parcelRequire("acw62");
var $4d4f04faa0dd2ff5$export$43a750ddd9f2303e = /*#__PURE__*/ function(ErrorTypes) {
    ErrorTypes["e401"] = "401";
    ErrorTypes["e403"] = "403";
    ErrorTypes["e404"] = "404";
    ErrorTypes["e500"] = "500";
    return ErrorTypes;
}({});
var $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20 = /*#__PURE__*/ function(ErrorMessages) {
    ErrorMessages["e403"] = "Application has thrown an Authorization Error";
    ErrorMessages["e404"] = "Application has thrown a Not Found Error";
    ErrorMessages["e500"] = "Application has thrown a Network Error";
    return ErrorMessages;
}({});





var $acw62 = parcelRequire("acw62");

var $f017e7c7dab69766$export$2e2bcd8739ae039 = {
    raw: ".hcr-btn-group-16-4-0:not([hidden]){display:flex}.hcr-btn-group--wrap-16-4-0{flex-wrap:wrap}.hcr-btn-group-16-4-0{align-items:flex-start;flex-direction:column;gap:var(--hcr-spacing-2);justify-content:flex-start}.hcr-btn-group-16-4-0:where(:not(:last-child)){margin-bottom:var(--hcr-spacing-2)}.hcr-btn-group--justify-center-16-4-0{justify-content:center}.hcr-btn-group--justify-end-16-4-0{justify-content:flex-end}.hcr-btn-group--justify-between-16-4-0{justify-content:space-between}.hcr-btn-group--justify-around-16-4-0{justify-content:space-around}.hcr-btn-group--justify-evenly-16-4-0{justify-content:space-evenly}.hcr-btn-group--align-center-16-4-0{align-items:center}.hcr-btn-group--align-end-16-4-0{align-items:flex-end}.hcr-btn-group--horizontal-16-4-0{flex-direction:row}.hcr-btn-group--vertical-16-4-0{flex-direction:column}@media (min-width:600px){.hcr-btn-group-16-4-0:not(.hcr-btn-group--vertical-16-4-0,.hcr-btn-group--horizontal-16-4-0){flex-direction:row}}.hcr-btn-group--gap-half-16-4-0{gap:var(--hcr-spacing-half)}.hcr-btn-group--gap-1-16-4-0{gap:var(--hcr-spacing-1)}.hcr-btn-group--half-gap-16-4-0{gap:var(--hcr-spacing-half)}.hcr-btn-group--1-gap-16-4-0{gap:var(--hcr-spacing-1)}.hcr-btn-group--align-center-16-4-0{justify-content:center}.hcr-btn-group--align-end-16-4-0{justify-content:flex-end}",
    map: {
        "hcr-btn-group": "hcr-btn-group-16-4-0",
        "hcr-btn-group--wrap": "hcr-btn-group--wrap-16-4-0",
        "hcr-btn-group--justify-center": "hcr-btn-group--justify-center-16-4-0",
        "hcr-btn-group--justify-end": "hcr-btn-group--justify-end-16-4-0",
        "hcr-btn-group--justify-between": "hcr-btn-group--justify-between-16-4-0",
        "hcr-btn-group--justify-around": "hcr-btn-group--justify-around-16-4-0",
        "hcr-btn-group--justify-evenly": "hcr-btn-group--justify-evenly-16-4-0",
        "hcr-btn-group--align-center": "hcr-btn-group--align-center-16-4-0",
        "hcr-btn-group--align-end": "hcr-btn-group--align-end-16-4-0",
        "hcr-btn-group--horizontal": "hcr-btn-group--horizontal-16-4-0",
        "hcr-btn-group--vertical": "hcr-btn-group--vertical-16-4-0",
        "hcr-btn-group--gap-half": "hcr-btn-group--gap-half-16-4-0",
        "hcr-btn-group--gap-1": "hcr-btn-group--gap-1-16-4-0",
        "hcr-btn-group--half-gap": "hcr-btn-group--half-gap-16-4-0",
        "hcr-btn-group--1-gap": "hcr-btn-group--1-gap-16-4-0"
    }
};





const $c7e28d5255151c0d$export$de55e4ad14d39638 = [
    'responsive',
    'horizontal',
    'vertical'
];
const $c7e28d5255151c0d$export$eea0c98c06c45472 = [
    'start',
    'center',
    'end'
];
const $c7e28d5255151c0d$export$c5a5eef093de9e94 = [
    'start',
    'center',
    'end',
    'between',
    'around',
    'evenly'
];
const $c7e28d5255151c0d$export$ad94ecaa3b6d5e33 = [
    'half',
    '1',
    '2'
];


const $864f56dba4ac147d$export$1209d7831fc2d3b5 = (propName, componentName, since, alternative)=>{
    console.warn(`\`${propName}\` prop in \`${componentName}\` component is deprecated since v${since}. ${alternative}`);
};
function $864f56dba4ac147d$export$b90c8e9d5dbcc8c3(since, alternative, callback) {
    return (props, propName, componentName)=>{
        if (props[propName] !== undefined) $864f56dba4ac147d$export$1209d7831fc2d3b5(String(propName), componentName, since, alternative);
        return callback ? callback(props, propName, componentName) : null;
    };
}



const $1e32dd16d4636999$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('btn-group', (0, $f017e7c7dab69766$export$2e2bcd8739ae039));
/** @since 6.0.0 */ function $1e32dd16d4636999$export$69b1032f2ecdf404(_a) {
    var { children: children, extraClasses: extraClasses, orientation: orientation = 'responsive', alignment: alignment, align: align = 'start', justify: justify = 'start', gap: gap = '2', wrap: wrap = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "orientation",
        "alignment",
        "align",
        "justify",
        "gap",
        "wrap"
    ]);
    let computedAlign = align;
    if (alignment) {
        (0, $864f56dba4ac147d$export$1209d7831fc2d3b5)('alignment', 'ButtonGroup', '16.4.0', 'Please use `align` instead.');
        computedAlign = alignment;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: $1e32dd16d4636999$var$bem.b({
            [orientation]: orientation !== 'responsive',
            [`align-${computedAlign}`]: computedAlign !== 'start',
            [`justify-${justify}`]: justify !== 'start',
            [`gap-${gap}`]: gap !== '2',
            wrap: wrap
        }, extraClasses)
    }, rest), children);
}
$1e32dd16d4636999$export$69b1032f2ecdf404.displayName = 'ButtonGroup';
$1e32dd16d4636999$export$69b1032f2ecdf404.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c7e28d5255151c0d$export$de55e4ad14d39638)),
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c7e28d5255151c0d$export$eea0c98c06c45472)),
    align: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c7e28d5255151c0d$export$eea0c98c06c45472)),
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c7e28d5255151c0d$export$c5a5eef093de9e94)),
    gap: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c7e28d5255151c0d$export$ad94ecaa3b6d5e33)),
    wrap: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $1e32dd16d4636999$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($1e32dd16d4636999$export$69b1032f2ecdf404, (0, $f017e7c7dab69766$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $6fff70164c82793f$export$2e2bcd8739ae039 = {
    raw: ".hcr-h1-16-4-0,.hcr-h2-16-4-0,.hcr-h3-16-4-0,.hcr-h4-16-4-0{margin:0 0 var(--hcr-spacing-2);padding:var(--hcr-spacing-2)0 0}.hcr-h1-16-4-0:is(strong),.hcr-h2-16-4-0:is(strong),.hcr-h3-16-4-0:is(strong),.hcr-h4-16-4-0:is(strong){display:block}.hcr-h1-16-4-0{font-size:var(--hcr-font-size-h1);line-height:var(--hcr-line-height-h1);margin:0 0 var(--hcr-spacing-4)}.hcr-h1-16-4-0,.hcr-h2-16-4-0{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-weight:var(--hcr-font-weight-bold)}.hcr-h2-16-4-0{font-size:var(--hcr-font-size-h2);line-height:var(--hcr-line-height-h2)}.hcr-h3-16-4-0{font-size:var(--hcr-font-size-h3);line-height:var(--hcr-line-height-h3)}.hcr-h3-16-4-0,.hcr-h4-16-4-0{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-weight:var(--hcr-font-weight-bold)}.hcr-h4-16-4-0{font-size:var(--hcr-font-size-h4);line-height:var(--hcr-line-height-h4)}.hcr-h1--section-header-16-4-0,.hcr-h1--space-flush-top-16-4-0,.hcr-h1-16-4-0,.hcr-h2--section-header-16-4-0,.hcr-h2--space-flush-top-16-4-0,.hcr-h3--section-header-16-4-0,.hcr-h3--space-flush-top-16-4-0,.hcr-h4--section-header-16-4-0,.hcr-h4--space-flush-top-16-4-0{padding-top:0}.hcr-h1--space-flush-bottom-16-4-0,.hcr-h2--space-flush-bottom-16-4-0,.hcr-h3--space-flush-bottom-16-4-0,.hcr-h4--space-flush-bottom-16-4-0{margin-bottom:0}.hcr-h1--space-flush-16-4-0,.hcr-h2--space-flush-16-4-0,.hcr-h3--space-flush-16-4-0,.hcr-h4--space-flush-16-4-0{margin-bottom:0;padding-top:0}",
    map: {
        "hcr-h1": "hcr-h1-16-4-0",
        "hcr-h2": "hcr-h2-16-4-0",
        "hcr-h3": "hcr-h3-16-4-0",
        "hcr-h4": "hcr-h4-16-4-0",
        "hcr-h1--section-header": "hcr-h1--section-header-16-4-0",
        "hcr-h1--space-flush-top": "hcr-h1--space-flush-top-16-4-0",
        "hcr-h2--section-header": "hcr-h2--section-header-16-4-0",
        "hcr-h2--space-flush-top": "hcr-h2--space-flush-top-16-4-0",
        "hcr-h3--section-header": "hcr-h3--section-header-16-4-0",
        "hcr-h3--space-flush-top": "hcr-h3--space-flush-top-16-4-0",
        "hcr-h4--section-header": "hcr-h4--section-header-16-4-0",
        "hcr-h4--space-flush-top": "hcr-h4--space-flush-top-16-4-0",
        "hcr-h1--space-flush-bottom": "hcr-h1--space-flush-bottom-16-4-0",
        "hcr-h2--space-flush-bottom": "hcr-h2--space-flush-bottom-16-4-0",
        "hcr-h3--space-flush-bottom": "hcr-h3--space-flush-bottom-16-4-0",
        "hcr-h4--space-flush-bottom": "hcr-h4--space-flush-bottom-16-4-0",
        "hcr-h1--space-flush": "hcr-h1--space-flush-16-4-0",
        "hcr-h2--space-flush": "hcr-h2--space-flush-16-4-0",
        "hcr-h3--space-flush": "hcr-h3--space-flush-16-4-0",
        "hcr-h4--space-flush": "hcr-h4--space-flush-16-4-0"
    }
};





const $e28358a9c33d1ee1$export$76587a699ba26c32 = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'strong',
    'span'
];



function $02cbb07845aa75e9$export$a8a3e93435678ff9(_a) {
    var { children: children, extraClasses: extraClasses, flushSpace: flushSpace = false, sectionHeader: sectionHeader = false, size: size, Elem: Elem } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "flushSpace",
        "sectionHeader",
        "size",
        "Elem"
    ]);
    // different heading type requires different HTML tags
    const Element = Elem || `h${size}`;
    // different Heading size has different block class name, e.g. `flix-h1`, `flix-h4`
    const headingBem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`h${size}`, (0, $6fff70164c82793f$export$2e2bcd8739ae039));
    const headingClassNames = headingBem.b({
        'section-header': sectionHeader,
        'space-flush': flushSpace
    }, extraClasses);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, Object.assign({
        className: headingClassNames
    }, rest), children);
}
$02cbb07845aa75e9$export$a8a3e93435678ff9.displayName = 'Heading';
$02cbb07845aa75e9$export$a8a3e93435678ff9.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array
    ]).isRequired,
    flushSpace: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    sectionHeader: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        1,
        2,
        3,
        4
    ]).isRequired,
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $e28358a9c33d1ee1$export$76587a699ba26c32))
};
var $02cbb07845aa75e9$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($02cbb07845aa75e9$export$a8a3e93435678ff9, (0, $6fff70164c82793f$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $c3f9fff6bf32aaf1$export$2e2bcd8739ae039 = {
    raw: ".hcr-blockquote-16-4-0,.hcr-text-16-4-0 blockquote{color:var(--hcr-content-primary-color);font-family:inherit;margin:0 0 var(--hcr-spacing-2);padding:var(--hcr-spacing-2)0 0 calc(var(--hcr-spacing-4) + var(--hcr-spacing-2));position:relative}@media (min-width:600px){.hcr-blockquote-16-4-0,.hcr-text-16-4-0 blockquote{padding:var(--hcr-spacing-2)0 0 calc(var(--hcr-spacing-8) + var(--hcr-spacing-2))}}.hcr-blockquote-16-4-0:before,.hcr-text-16-4-0 blockquote:before{background-color:var(--hcr-icon-primary-color);content:\"\";height:var(--hcr-spacing-2);left:0;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 159.8\\ 100\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M159.4,62.9A32.2,32.2,0,0,0,129,35.7c3.7-13.8,12.8-19.4,23.8-22.5a1.3,1.3,0,0,0,.9-1.4l-1.8-11s-0.2-.9-1.6-0.7c-38,4.3-63.7,33.2-58.9,68.3,4.4,24.3,23.4,33.7,41,31.2a32.4,32.4,0,0,0,27-36.7h0ZM38.1,35.7c3.6-13.8,13-19.4,23.8-22.5a1.3,1.3,0,0,0,.9-1.4l-1.6-11S61-.2,59.6,0C21.6,4.1-3.9,33,.5,68.2c4.6,24.5,23.8,33.9,41.2,31.4A32.1,32.1,0,0,0,68.5,62.9,31.7,31.7,0,0,0,38.1,35.7Z\\'\\ /%3E%3C/svg%3E)no-repeat left center/contain;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 159.8\\ 100\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M159.4,62.9A32.2,32.2,0,0,0,129,35.7c3.7-13.8,12.8-19.4,23.8-22.5a1.3,1.3,0,0,0,.9-1.4l-1.8-11s-0.2-.9-1.6-0.7c-38,4.3-63.7,33.2-58.9,68.3,4.4,24.3,23.4,33.7,41,31.2a32.4,32.4,0,0,0,27-36.7h0ZM38.1,35.7c3.6-13.8,13-19.4,23.8-22.5a1.3,1.3,0,0,0,.9-1.4l-1.6-11S61-.2,59.6,0C21.6,4.1-3.9,33,.5,68.2c4.6,24.5,23.8,33.9,41.2,31.4A32.1,32.1,0,0,0,68.5,62.9,31.7,31.7,0,0,0,38.1,35.7Z\\'\\ /%3E%3C/svg%3E)no-repeat left center/contain;position:absolute;top:0;width:var(--hcr-spacing-4)}@media (min-width:600px){.hcr-blockquote-16-4-0:before,.hcr-text-16-4-0 blockquote:before{height:var(--hcr-spacing-4);width:var(--hcr-spacing-8)}}.hcr-link-16-4-0,.hcr-text-16-4-0 a{background-color:initial;color:var(--hcr-link-color);font-weight:var(--hcr-font-weight-semibold);text-decoration:underline}.hcr-link-16-4-0:enabled:active,.hcr-link-16-4-0[href]:active,.hcr-text-16-4-0 a:enabled:active,.hcr-text-16-4-0 a[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-link-16-4-0:enabled:hover,.hcr-link-16-4-0[href]:hover,.hcr-text-16-4-0 a:enabled:hover,.hcr-text-16-4-0 a[href]:hover{background-image:var(--hcr-hover-layer-color);border-radius:var(--hcr-border-radius-1);text-decoration:underline}.hcr-link-16-4-0:focus-visible,.hcr-text-16-4-0 a:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-h1-16-4-0,.hcr-h2-16-4-0,.hcr-h3-16-4-0,.hcr-h4-16-4-0,.hcr-text-16-4-0 h1,.hcr-text-16-4-0 h2,.hcr-text-16-4-0 h3,.hcr-text-16-4-0 h4{margin:0 0 var(--hcr-spacing-2);padding:var(--hcr-spacing-2)0 0}.hcr-h1-16-4-0:is(strong),.hcr-h2-16-4-0:is(strong),.hcr-h3-16-4-0:is(strong),.hcr-h4-16-4-0:is(strong),.hcr-text-16-4-0 h1:is(strong),.hcr-text-16-4-0 h2:is(strong),.hcr-text-16-4-0 h3:is(strong),.hcr-text-16-4-0 h4:is(strong){display:block}.hcr-h1-16-4-0,.hcr-text-16-4-0 h1{font-size:var(--hcr-font-size-h1);line-height:var(--hcr-line-height-h1);margin:0 0 var(--hcr-spacing-4)}.hcr-h1-16-4-0,.hcr-h2-16-4-0,.hcr-text-16-4-0 h1,.hcr-text-16-4-0 h2{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-weight:var(--hcr-font-weight-bold)}.hcr-h2-16-4-0,.hcr-text-16-4-0 h2{font-size:var(--hcr-font-size-h2);line-height:var(--hcr-line-height-h2)}.hcr-h3-16-4-0,.hcr-text-16-4-0 h3{font-size:var(--hcr-font-size-h3);line-height:var(--hcr-line-height-h3)}.hcr-h3-16-4-0,.hcr-h4-16-4-0,.hcr-text-16-4-0 h3,.hcr-text-16-4-0 h4{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-weight:var(--hcr-font-weight-bold)}.hcr-h4-16-4-0,.hcr-text-16-4-0 h4{font-size:var(--hcr-font-size-h4);line-height:var(--hcr-line-height-h4)}.hcr-h1--section-header-16-4-0,.hcr-h1--space-flush-top-16-4-0,.hcr-h1-16-4-0,.hcr-h2--section-header-16-4-0,.hcr-h2--space-flush-top-16-4-0,.hcr-h3--section-header-16-4-0,.hcr-h3--space-flush-top-16-4-0,.hcr-h4--section-header-16-4-0,.hcr-h4--space-flush-top-16-4-0,.hcr-text-16-4-0 h1{padding-top:0}.hcr-h1--space-flush-bottom-16-4-0,.hcr-h2--space-flush-bottom-16-4-0,.hcr-h3--space-flush-bottom-16-4-0,.hcr-h4--space-flush-bottom-16-4-0{margin-bottom:0}.hcr-h1--space-flush-16-4-0,.hcr-h2--space-flush-16-4-0,.hcr-h3--space-flush-16-4-0,.hcr-h4--space-flush-16-4-0{margin-bottom:0;padding-top:0}.hcr-list-16-4-0,.hcr-text-16-4-0 ul{list-style-type:none;margin:0 0 var(--hcr-spacing-2);padding:0;padding-left:var(--hcr-spacing-2)}.hcr-list__item-16-4-0,.hcr-text-16-4-0 ul>li{color:var(--hcr-content-primary-color);line-height:var(--hcr-line-height-primary);padding-left:calc(var(--hcr-spacing-2) + var(--hcr-spacing-half));position:relative}.hcr-list__item-16-4-0:before,.hcr-text-16-4-0 ul>li:before{background:var(--hcr-content-primary-color);border-radius:50%;content:\"\";display:block;height:var(--hcr-spacing-half);left:0;margin-top:calc(-1*var(--hcr-spacing-half)/2);position:absolute;top:calc(var(--hcr-line-height-primary)/2);width:var(--hcr-spacing-half)}@supports (width:clamp(var(--hcr-spacing-half ),0.188rem,var(--hcr-spacing-2 ))){.hcr-list__item-16-4-0,.hcr-text-16-4-0 ul>li{padding-left:calc(var(--hcr-spacing-2) + clamp(var(--hcr-spacing-half),.188rem,var(--hcr-spacing-2)))}.hcr-list__item-16-4-0:before,.hcr-text-16-4-0 ul>li:before{height:clamp(var(--hcr-spacing-half),.188rem,var(--hcr-spacing-2));margin-top:calc(-1*clamp(var(--hcr-spacing-half),.188rem,var(--hcr-spacing-2))/2);width:clamp(var(--hcr-spacing-half),.188rem,var(--hcr-spacing-2))}}.hcr-list__item-16-4-0>.hcr-list-16-4-0,.hcr-text-16-4-0 .hcr-list__item-16-4-0>ul,.hcr-text-16-4-0 ul>li>.hcr-list-16-4-0,.hcr-text-16-4-0 ul>li>ul{margin:0;padding-left:0}.hcr-list-numbered-16-4-0,.hcr-text-16-4-0 ol{counter-reset:numbered-list-counter;list-style-type:none;margin:0 0 var(--hcr-spacing-2);padding:0;padding-left:var(--hcr-spacing-2)}.hcr-list-numbered__item-16-4-0,.hcr-text-16-4-0 ol>li{color:var(--hcr-content-primary-color);display:table;position:relative}.hcr-list-numbered__item-16-4-0:before,.hcr-text-16-4-0 ol>li:before{content:counters(numbered-list-counter,\".\")\".\";counter-increment:numbered-list-counter;display:table-cell;font-weight:var(--hcr-font-weight-bold);padding-right:var(--hcr-spacing-1)}.hcr-list-numbered__item-16-4-0>.hcr-list-numbered-16-4-0,.hcr-text-16-4-0 .hcr-list-numbered__item-16-4-0>ol,.hcr-text-16-4-0 ol>li>.hcr-list-numbered-16-4-0,.hcr-text-16-4-0 ol>li>ol{margin:0;padding-left:0;width:100%}.hcr-list-numbered__item-16-4-0>.hcr-list-numbered-16-4-0 .hcr-list-numbered__item-16-4-0:before,.hcr-list-numbered__item-16-4-0>.hcr-list-numbered-16-4-0 .hcr-text-16-4-0 ol>li:before,.hcr-text-16-4-0 .hcr-list-numbered__item-16-4-0>.hcr-list-numbered-16-4-0 ol>li:before,.hcr-text-16-4-0 .hcr-list-numbered__item-16-4-0>ol .hcr-list-numbered__item-16-4-0:before,.hcr-text-16-4-0 .hcr-list-numbered__item-16-4-0>ol>li:before,.hcr-text-16-4-0 ol>li>.hcr-list-numbered-16-4-0 .hcr-list-numbered__item-16-4-0:before,.hcr-text-16-4-0 ol>li>.hcr-list-numbered-16-4-0 ol>li:before,.hcr-text-16-4-0 ol>li>ol .hcr-list-numbered__item-16-4-0:before,.hcr-text-16-4-0 ol>li>ol>li:before{content:counters(numbered-list-counter,\".\");font-weight:var(--hcr-font-weight-normal)}.hcr-list-description__details-16-4-0,.hcr-text-16-4-0 dl>dd{margin-left:var(--hcr-spacing-4)}.hcr-list-description__details-16-4-0+.hcr-list-description__term-16-4-0,.hcr-text-16-4-0 dl>.hcr-list-description__details-16-4-0+dt,.hcr-text-16-4-0 dl>dd+.hcr-list-description__term-16-4-0,.hcr-text-16-4-0 dl>dd+dt{margin-top:var(--hcr-spacing-2)}.hcr-mark-16-4-0,.hcr-text-16-4-0 mark{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color)}.hcr-text-16-4-0,.hcr-text-16-4-0 p{color:var(--hcr-container-content-color,var(--hcr-content-primary-color));font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-primary);margin:0}.hcr-text-16-4-0 p:where(:not(:last-child)),.hcr-text-16-4-0:where(:not(:last-child)){margin-bottom:var(--hcr-spacing-2)}.hcr-text--small-16-4-0,.hcr-text--small-16-4-0 p{color:var(--hcr-container-content-color,var(--hcr-content-primary-color));font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin:0}.hcr-text--small-16-4-0 p:where(:not(:last-child)),.hcr-text--small-16-4-0:where(:not(:last-child)){margin-bottom:var(--hcr-spacing-2)}",
    map: {
        "hcr-blockquote": "hcr-blockquote-16-4-0",
        "hcr-text": "hcr-text-16-4-0",
        "hcr-link": "hcr-link-16-4-0",
        "hcr-h1": "hcr-h1-16-4-0",
        "hcr-h2": "hcr-h2-16-4-0",
        "hcr-h3": "hcr-h3-16-4-0",
        "hcr-h4": "hcr-h4-16-4-0",
        "hcr-h1--section-header": "hcr-h1--section-header-16-4-0",
        "hcr-h1--space-flush-top": "hcr-h1--space-flush-top-16-4-0",
        "hcr-h2--section-header": "hcr-h2--section-header-16-4-0",
        "hcr-h2--space-flush-top": "hcr-h2--space-flush-top-16-4-0",
        "hcr-h3--section-header": "hcr-h3--section-header-16-4-0",
        "hcr-h3--space-flush-top": "hcr-h3--space-flush-top-16-4-0",
        "hcr-h4--section-header": "hcr-h4--section-header-16-4-0",
        "hcr-h4--space-flush-top": "hcr-h4--space-flush-top-16-4-0",
        "hcr-h1--space-flush-bottom": "hcr-h1--space-flush-bottom-16-4-0",
        "hcr-h2--space-flush-bottom": "hcr-h2--space-flush-bottom-16-4-0",
        "hcr-h3--space-flush-bottom": "hcr-h3--space-flush-bottom-16-4-0",
        "hcr-h4--space-flush-bottom": "hcr-h4--space-flush-bottom-16-4-0",
        "hcr-h1--space-flush": "hcr-h1--space-flush-16-4-0",
        "hcr-h2--space-flush": "hcr-h2--space-flush-16-4-0",
        "hcr-h3--space-flush": "hcr-h3--space-flush-16-4-0",
        "hcr-h4--space-flush": "hcr-h4--space-flush-16-4-0",
        "hcr-list": "hcr-list-16-4-0",
        "hcr-list__item": "hcr-list__item-16-4-0",
        "hcr-list-numbered": "hcr-list-numbered-16-4-0",
        "hcr-list-numbered__item": "hcr-list-numbered__item-16-4-0",
        "hcr-list-description__details": "hcr-list-description__details-16-4-0",
        "hcr-list-description__term": "hcr-list-description__term-16-4-0",
        "hcr-mark": "hcr-mark-16-4-0",
        "hcr-text--small": "hcr-text--small-16-4-0"
    }
};





const $133b61de5db7b607$export$7c290091077ac56d = [
    'address',
    'article',
    'aside',
    'code',
    'div',
    'em',
    'p',
    'pre',
    'section',
    'small',
    'span',
    'strong'
];



const $c56b2edcbeb4ad55$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('text', (0, $c3f9fff6bf32aaf1$export$2e2bcd8739ae039));
function $c56b2edcbeb4ad55$export$5f1af8db9871e1d6(_a) {
    var { Elem: Elem = 'p', extraClasses: extraClasses, children: children, small: small } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "Elem",
        "extraClasses",
        "children",
        "small"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        className: $c56b2edcbeb4ad55$var$bem.b([
            {
                small: small
            }
        ], extraClasses)
    }, rest), children);
}
$c56b2edcbeb4ad55$export$5f1af8db9871e1d6.displayName = 'Text';
$c56b2edcbeb4ad55$export$5f1af8db9871e1d6.propTypes = {
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $133b61de5db7b607$export$7c290091077ac56d)),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $c56b2edcbeb4ad55$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($c56b2edcbeb4ad55$export$5f1af8db9871e1d6, (0, $c3f9fff6bf32aaf1$export$2e2bcd8739ae039));


parcelRequire("acw62");

var $25d1fb3875da6dd6$exports = {};
$25d1fb3875da6dd6$exports = import.meta.resolve("lxzqR");


var $d9ac503a6ffa6fd1$exports = {};
$d9ac503a6ffa6fd1$exports = import.meta.resolve("cI2Tm");


var $a4a6ad79151684d7$exports = {};
$a4a6ad79151684d7$exports = import.meta.resolve("faLLs");


/*
  This file is auto-generated. Do not edit it directly.
  To update this file, run `npm run codegen:common`.
*/ var $a19e0ad93a0122b0$var$Feature = /*#__PURE__*/ function(Feature) {
    Feature["USER_HAS_MARKETPLACE_ACCESS"] = "USER_HAS_MARKETPLACE_ACCESS";
    Feature["USER_HAS_SERVICEDESK_ACCESS"] = "USER_HAS_SERVICEDESK_ACCESS";
    Feature["USER_HAS_VIEW_ACCESS_TO_ALL_PAGES"] = "USER_HAS_VIEW_ACCESS_TO_ALL_PAGES";
    Feature["VIEW_PARTNER_LIST"] = "VIEW_PARTNER_LIST";
    Feature["VIEW_PARTNER"] = "VIEW_PARTNER";
    Feature["CREATE_PARTNER"] = "CREATE_PARTNER";
    Feature["DELETE_PARTNER_UNPUBLISHED"] = "DELETE_PARTNER_UNPUBLISHED";
    Feature["VIEW_DELETE_PARTNER"] = "VIEW_DELETE_PARTNER";
    Feature["EDIT_PARTNER_CURRENCY"] = "EDIT_PARTNER_CURRENCY";
    Feature["EDIT_PARTNER_NAME_UNPUBLISHED"] = "EDIT_PARTNER_NAME_UNPUBLISHED";
    Feature["EDIT_PARTNER_NAME_PUBLISHED"] = "EDIT_PARTNER_NAME_PUBLISHED";
    Feature["EDIT_PARTNER_CONCESSION_OWNER_UNPUBLISHED"] = "EDIT_PARTNER_CONCESSION_OWNER_UNPUBLISHED";
    Feature["VIEW_PARTNER_CONCESSION_OWNER"] = "VIEW_PARTNER_CONCESSION_OWNER";
    Feature["EDIT_PARTNER_BUSINESS_REGION_UNPUBLISHED"] = "EDIT_PARTNER_BUSINESS_REGION_UNPUBLISHED";
    Feature["VIEW_PARTNER_BUSINESS_REGION"] = "VIEW_PARTNER_BUSINESS_REGION";
    Feature["EDIT_PARTNER_BUSINESS_DEV_MANAGER"] = "EDIT_PARTNER_BUSINESS_DEV_MANAGER";
    Feature["EDIT_PARTNER_DEFAULT_ACCESS"] = "EDIT_PARTNER_DEFAULT_ACCESS";
    Feature["EDIT_PARTNER_DEFAULT_CAPACITY"] = "EDIT_PARTNER_DEFAULT_CAPACITY";
    Feature["EDIT_PARTNER_MEANS_OF_TRANSPORT"] = "EDIT_PARTNER_MEANS_OF_TRANSPORT";
    Feature["EDIT_PARTNER_INTEGRATION_INTERMEDIARY"] = "EDIT_PARTNER_INTEGRATION_INTERMEDIARY";
    Feature["EDIT_PARTNER_CAPACITY_DECREASE_RULE"] = "EDIT_PARTNER_CAPACITY_DECREASE_RULE";
    Feature["EDIT_PARTNER_PASSENGER_BOOKING_DATA_ACCESS_ALLOWED"] = "EDIT_PARTNER_PASSENGER_BOOKING_DATA_ACCESS_ALLOWED";
    Feature["EDIT_PARTNER_PASSENGER_BOOKING_INFORMATION"] = "EDIT_PARTNER_PASSENGER_BOOKING_INFORMATION";
    Feature["VIEW_ALL_PARTNER_PASSENGER_BOOKING_INFORMATION_FIELDS"] = "VIEW_ALL_PARTNER_PASSENGER_BOOKING_INFORMATION_FIELDS";
    Feature["EDIT_PARTNER_BRAND"] = "EDIT_PARTNER_BRAND";
    Feature["VIEW_AVAILABLE_BRANDS"] = "VIEW_AVAILABLE_BRANDS";
    Feature["VIEW_PARTNER_BRAND_POLICIES"] = "VIEW_PARTNER_BRAND_POLICIES";
    Feature["EDIT_PARTNER_BRAND_POLICIES"] = "EDIT_PARTNER_BRAND_POLICIES";
    Feature["EDIT_PARTNER_SETTINGS"] = "EDIT_PARTNER_SETTINGS";
    Feature["EDIT_PARTNER_API_SETTINGS"] = "EDIT_PARTNER_API_SETTINGS";
    Feature["EDIT_PARTNER_INVENTORY_RULES"] = "EDIT_PARTNER_INVENTORY_RULES";
    Feature["EDIT_PARTNER_AUTO_ON_SALE_CONFIG"] = "EDIT_PARTNER_AUTO_ON_SALE_CONFIG";
    Feature["EDIT_PARTNER_IC_PRICING_RULES"] = "EDIT_PARTNER_IC_PRICING_RULES";
    Feature["VIEW_PARTNER_IC_PRICING_RULES"] = "VIEW_PARTNER_IC_PRICING_RULES";
    Feature["EDIT_PARTNER_TEAMS"] = "EDIT_PARTNER_TEAMS";
    Feature["EDIT_PARTNER_PUBLISH_POLICIES"] = "EDIT_PARTNER_PUBLISH_POLICIES";
    Feature["VIEW_PARTNER_TAGS"] = "VIEW_PARTNER_TAGS";
    Feature["EDIT_PARTNER_TAGS"] = "EDIT_PARTNER_TAGS";
    Feature["VIEW_PARTNER_USERS"] = "VIEW_PARTNER_USERS";
    Feature["VIEW_PARTNER_TEST_USERS"] = "VIEW_PARTNER_TEST_USERS";
    Feature["VIEW_LINE"] = "VIEW_LINE";
    Feature["CREATE_LINE"] = "CREATE_LINE";
    Feature["EDIT_LINE_DESCRIPTION_UNPUBLISHED"] = "EDIT_LINE_DESCRIPTION_UNPUBLISHED";
    Feature["EDIT_LINE_CODE_UNPUBLISHED"] = "EDIT_LINE_CODE_UNPUBLISHED";
    Feature["EDIT_LINE_CONTRACT_MODEL_UNPUBLISHED"] = "EDIT_LINE_CONTRACT_MODEL_UNPUBLISHED";
    Feature["EDIT_LINE_BRAND"] = "EDIT_LINE_BRAND";
    Feature["EDIT_LINE_CUT_OFF_SALES"] = "EDIT_LINE_CUT_OFF_SALES";
    Feature["EDIT_LINE_AMENITIES"] = "EDIT_LINE_AMENITIES";
    Feature["EDIT_LINE_MINIMUM_SEAT_CAPACITY"] = "EDIT_LINE_MINIMUM_SEAT_CAPACITY";
    Feature["EDIT_LINE_DEFAULT_CIRCULATION"] = "EDIT_LINE_DEFAULT_CIRCULATION";
    Feature["EDIT_LINE_MEANS_OF_TRANSPORT_UNPUBLISHED"] = "EDIT_LINE_MEANS_OF_TRANSPORT_UNPUBLISHED";
    Feature["EDIT_LINE_FORBIDDEN_RELATIONS_ADD"] = "EDIT_LINE_FORBIDDEN_RELATIONS_ADD";
    Feature["EDIT_LINE_FORBIDDEN_RELATIONS_DELETE"] = "EDIT_LINE_FORBIDDEN_RELATIONS_DELETE";
    Feature["DELETE_LINE_UNPUBLISHED"] = "DELETE_LINE_UNPUBLISHED";
    Feature["UPLOAD_FORBIDDEN_RELATIONS"] = "UPLOAD_FORBIDDEN_RELATIONS";
    Feature["CREATE_SCHEDULE"] = "CREATE_SCHEDULE";
    Feature["VIEW_SCHEDULE"] = "VIEW_SCHEDULE";
    Feature["VIEW_SCHEDULE_VALIDATION"] = "VIEW_SCHEDULE_VALIDATION";
    Feature["CREATE_SCHEDULE_COPY"] = "CREATE_SCHEDULE_COPY";
    Feature["CREATE_SCHEDULE_CONCEPT_CHANGE"] = "CREATE_SCHEDULE_CONCEPT_CHANGE";
    Feature["DELETE_SCHEDULE"] = "DELETE_SCHEDULE";
    Feature["EDIT_SCHEDULE_NAME_UNPUBLISHED"] = "EDIT_SCHEDULE_NAME_UNPUBLISHED";
    Feature["EDIT_SCHEDULE_PERIOD_UNPUBLISHED"] = "EDIT_SCHEDULE_PERIOD_UNPUBLISHED";
    Feature["EDIT_SCHEDULE_INITIAL_CAPACITY_UNPUBLISHED"] = "EDIT_SCHEDULE_INITIAL_CAPACITY_UNPUBLISHED";
    Feature["EDIT_SCHEDULE_NON_OPERATIONAL_PERIOD_UNPUBLISHED"] = "EDIT_SCHEDULE_NON_OPERATIONAL_PERIOD_UNPUBLISHED";
    Feature["EDIT_SCHEDULE_TIMETABLE_UNPUBLISHED"] = "EDIT_SCHEDULE_TIMETABLE_UNPUBLISHED";
    Feature["EDIT_SCHEDULE_SUBMIT_TO_REVIEW"] = "EDIT_SCHEDULE_SUBMIT_TO_REVIEW";
    Feature["EDIT_SCHEDULE_APPROVE_REJECT"] = "EDIT_SCHEDULE_APPROVE_REJECT";
    Feature["EDIT_SCHEDULE_PUBLISH"] = "EDIT_SCHEDULE_PUBLISH";
    Feature["EDIT_SCHEDULE_ACTIVATE_ON_SALE"] = "EDIT_SCHEDULE_ACTIVATE_ON_SALE";
    Feature["EDIT_SCHEDULE_ARCHIVE"] = "EDIT_SCHEDULE_ARCHIVE";
    Feature["EDIT_SCHEDULE_PUT_ON_HIDDEN"] = "EDIT_SCHEDULE_PUT_ON_HIDDEN";
    Feature["VIEW_SCHEDULE_STATUS_HISTORY"] = "VIEW_SCHEDULE_STATUS_HISTORY";
    Feature["EDIT_SCHEDULE_STATUS"] = "EDIT_SCHEDULE_STATUS";
    Feature["VIEW_SCHEDULE_DETAILED_STATUS"] = "VIEW_SCHEDULE_DETAILED_STATUS";
    Feature["VIEW_HIDDEN_STATUS"] = "VIEW_HIDDEN_STATUS";
    Feature["EDIT_PRICING"] = "EDIT_PRICING";
    Feature["VIEW_ALL_OPS_PARTNER"] = "VIEW_ALL_OPS_PARTNER";
    Feature["VIEW_RIDES"] = "VIEW_RIDES";
    Feature["EDIT_CAPACITY_MANAGER_CAPACITY"] = "EDIT_CAPACITY_MANAGER_CAPACITY";
    Feature["EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES"] = "EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES";
    Feature["EDIT_CAPACITY_MANAGER_CANCEL_RIDE"] = "EDIT_CAPACITY_MANAGER_CANCEL_RIDE";
    Feature["VIEW_CAPACITY_MANAGER_RIDES_IN_PREVIEW"] = "VIEW_CAPACITY_MANAGER_RIDES_IN_PREVIEW";
    Feature["VIEW_BOOKINGS"] = "VIEW_BOOKINGS";
    Feature["VIEW_BOOKING_REPORTS_DOWNLOAD"] = "VIEW_BOOKING_REPORTS_DOWNLOAD";
    Feature["CREATE_STATION"] = "CREATE_STATION";
    Feature["VIEW_STATIONS"] = "VIEW_STATIONS";
    Feature["CREATE_CITY"] = "CREATE_CITY";
    Feature["VIEW_CITIES"] = "VIEW_CITIES";
    Feature["CREATE_STATION_IMPORT"] = "CREATE_STATION_IMPORT";
    Feature["CREATE_CITY_IMPORT"] = "CREATE_CITY_IMPORT";
    Feature["EDIT_STATION_INREVIEW"] = "EDIT_STATION_INREVIEW";
    Feature["EDIT_STATION_APPROVED"] = "EDIT_STATION_APPROVED";
    Feature["EDIT_STATION_PUBLISHED"] = "EDIT_STATION_PUBLISHED";
    Feature["EDIT_STATION_REJECTED"] = "EDIT_STATION_REJECTED";
    Feature["EDIT_STATION_APPROVE_REJECT"] = "EDIT_STATION_APPROVE_REJECT";
    Feature["EDIT_CITY_STATION_APPROVER"] = "EDIT_CITY_STATION_APPROVER";
    Feature["VIEW_POWER_BI_REPORT"] = "VIEW_POWER_BI_REPORT";
    Feature["VIEW_PAX_LIST"] = "VIEW_PAX_LIST";
    Feature["CHECK_IN_MANUAL"] = "CHECK_IN_MANUAL";
    Feature["CHECK_IN_QR"] = "CHECK_IN_QR";
    Feature["CHANGE_PARTNER"] = "CHANGE_PARTNER";
    Feature["USER_HAS_MUS_ACCESS"] = "USER_HAS_MUS_ACCESS";
    return Feature;
}($a19e0ad93a0122b0$var$Feature || {});
var $a19e0ad93a0122b0$export$2e2bcd8739ae039 = $a19e0ad93a0122b0$var$Feature;




let $3b643887ffa5d38c$var$r = !1, $3b643887ffa5d38c$var$o = !1;
const $3b643887ffa5d38c$var$e = [], $3b643887ffa5d38c$var$i = async (i)=>{
    if ($3b643887ffa5d38c$var$r) return void console.warn("\uD83E\uDDF1 Formbricks - Warning: Formbricks is already initializing.");
    const n = ((r)=>{
        const o = r[0], { appUrl: e, environmentId: i } = o;
        return e ? i ? {
            appUrl: e.endsWith("/") ? e.slice(0, -1) : e,
            environmentId: i
        } : (console.error("\uD83E\uDDF1 Formbricks - Error: environmentId is required"), null) : (console.error("\uD83E\uDDF1 Formbricks - Error: appUrl is required"), null);
    })(i);
    if (n) {
        $3b643887ffa5d38c$var$r = !0;
        try {
            const r = await (async (r)=>{
                if (!globalThis.formbricks) {
                    const e = document.createElement("script");
                    e.type = "text/javascript", e.src = `${r}/js/formbricks.umd.cjs`, e.async = !0;
                    const i = async ()=>new Promise((r, o)=>{
                            const i = setTimeout(()=>{
                                o(new Error("Formbricks SDK loading timed out"));
                            }, 1e4);
                            e.onload = ()=>{
                                clearTimeout(i), r();
                            }, e.onerror = ()=>{
                                clearTimeout(i), o(new Error("Failed to load Formbricks SDK"));
                            };
                        });
                    document.head.appendChild(e);
                    try {
                        return await i(), {
                            ok: !0,
                            data: void 0
                        };
                    } catch (o) {
                        return {
                            ok: !1,
                            error: new Error(o.message ?? "Failed to load Formbricks SDK")
                        };
                    }
                }
                return {
                    ok: !0,
                    data: void 0
                };
            })(n.appUrl), i = globalThis.formbricks;
            if (!r.ok || !i) return void console.error("\uD83E\uDDF1 Formbricks - Error: Failed to load Formbricks SDK");
            await i.setup({
                ...n
            }), $3b643887ffa5d38c$var$o = !0, ((r)=>{
                for (const { prop: o, args: i } of $3b643887ffa5d38c$var$e)"function" == typeof r[o] ? r[o](...i) : console.error(`\u{1F9F1} Formbricks - Error: Method ${o} does not exist on formbricks`);
            })(formbricks);
        } catch (t) {
            console.error("\uD83E\uDDF1 Formbricks - Error: setup failed", t);
        } finally{
            $3b643887ffa5d38c$var$r = !1;
        }
    }
}, $3b643887ffa5d38c$var$n = async (r, ...n)=>{
    $3b643887ffa5d38c$var$o ? await (async (r, o)=>{
        const e = globalThis.formbricks;
        e && await e[r](...o);
    })(r, n) : "setup" === r ? await $3b643887ffa5d38c$var$i(n) : (console.warn("\uD83E\uDDF1 Formbricks - Warning: Formbricks not initialized. This method will be queued and executed after initialization."), $3b643887ffa5d38c$var$e.push({
        prop: r,
        args: n
    }));
}, $3b643887ffa5d38c$export$2e2bcd8739ae039 = new Proxy({}, {
    get: (r, o, e)=>(...r)=>$3b643887ffa5d38c$var$n(o, ...r)
});



/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $399fa9610e7cb0fb$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

var $3a016e333d7347e3$exports = {};

$parcel$export($3a016e333d7347e3$exports, "redirectUriEmpty", () => $3a016e333d7347e3$export$7a02f9bdce79dd4e);
$parcel$export($3a016e333d7347e3$exports, "claimsRequestParsingError", () => $3a016e333d7347e3$export$561c97672a478709);
$parcel$export($3a016e333d7347e3$exports, "authorityUriInsecure", () => $3a016e333d7347e3$export$f77c6af656c8444b);
$parcel$export($3a016e333d7347e3$exports, "urlParseError", () => $3a016e333d7347e3$export$ee2a1a3389f75508);
$parcel$export($3a016e333d7347e3$exports, "urlEmptyError", () => $3a016e333d7347e3$export$859df485a5e0f239);
$parcel$export($3a016e333d7347e3$exports, "emptyInputScopesError", () => $3a016e333d7347e3$export$6ac27379c42383f);
$parcel$export($3a016e333d7347e3$exports, "invalidClaims", () => $3a016e333d7347e3$export$96e755c70e0d0e34);
$parcel$export($3a016e333d7347e3$exports, "tokenRequestEmpty", () => $3a016e333d7347e3$export$eca67ff7a91fed9d);
$parcel$export($3a016e333d7347e3$exports, "logoutRequestEmpty", () => $3a016e333d7347e3$export$9eb2eeb401492d88);
$parcel$export($3a016e333d7347e3$exports, "invalidCodeChallengeMethod", () => $3a016e333d7347e3$export$b8d8b332f17376dc);
$parcel$export($3a016e333d7347e3$exports, "pkceParamsMissing", () => $3a016e333d7347e3$export$2da3866b327f1753);
$parcel$export($3a016e333d7347e3$exports, "invalidCloudDiscoveryMetadata", () => $3a016e333d7347e3$export$92a2985751150ca5);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthorityMetadata", () => $3a016e333d7347e3$export$edb4d5942bc8ccff);
$parcel$export($3a016e333d7347e3$exports, "untrustedAuthority", () => $3a016e333d7347e3$export$50c3162fda5f57);
$parcel$export($3a016e333d7347e3$exports, "missingSshJwk", () => $3a016e333d7347e3$export$8fbed44b22d9136f);
$parcel$export($3a016e333d7347e3$exports, "missingSshKid", () => $3a016e333d7347e3$export$b728bd8a588956c);
$parcel$export($3a016e333d7347e3$exports, "missingNonceAuthenticationHeader", () => $3a016e333d7347e3$export$4f88b4462bcef15f);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthenticationHeader", () => $3a016e333d7347e3$export$bea58e1a2e503b59);
$parcel$export($3a016e333d7347e3$exports, "cannotSetOIDCOptions", () => $3a016e333d7347e3$export$a5c9fbb90473dca2);
$parcel$export($3a016e333d7347e3$exports, "cannotAllowPlatformBroker", () => $3a016e333d7347e3$export$9a3a7609ff879ac7);
$parcel$export($3a016e333d7347e3$exports, "authorityMismatch", () => $3a016e333d7347e3$export$91415fb6baea5d09);
$parcel$export($3a016e333d7347e3$exports, "invalidRequestMethodForEAR", () => $3a016e333d7347e3$export$370f4bd236cb2302);
$parcel$export($3a016e333d7347e3$exports, "invalidAuthorizePostBodyParameters", () => $3a016e333d7347e3$export$54c6a0c3921e0e0b);
$parcel$export($3a016e333d7347e3$exports, "invalidPlatformBrokerConfiguration", () => $3a016e333d7347e3$export$771e0d8e79da4143);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3a016e333d7347e3$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $3a016e333d7347e3$export$561c97672a478709 = "claims_request_parsing_error";
const $3a016e333d7347e3$export$f77c6af656c8444b = "authority_uri_insecure";
const $3a016e333d7347e3$export$ee2a1a3389f75508 = "url_parse_error";
const $3a016e333d7347e3$export$859df485a5e0f239 = "empty_url_error";
const $3a016e333d7347e3$export$6ac27379c42383f = "empty_input_scopes_error";
const $3a016e333d7347e3$export$96e755c70e0d0e34 = "invalid_claims";
const $3a016e333d7347e3$export$eca67ff7a91fed9d = "token_request_empty";
const $3a016e333d7347e3$export$9eb2eeb401492d88 = "logout_request_empty";
const $3a016e333d7347e3$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $3a016e333d7347e3$export$2da3866b327f1753 = "pkce_params_missing";
const $3a016e333d7347e3$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $3a016e333d7347e3$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $3a016e333d7347e3$export$50c3162fda5f57 = "untrusted_authority";
const $3a016e333d7347e3$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $3a016e333d7347e3$export$b728bd8a588956c = "missing_ssh_kid";
const $3a016e333d7347e3$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $3a016e333d7347e3$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $3a016e333d7347e3$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $3a016e333d7347e3$export$9a3a7609ff879ac7 = "cannot_allow_platform_broker";
const $3a016e333d7347e3$export$91415fb6baea5d09 = "authority_mismatch";
const $3a016e333d7347e3$export$370f4bd236cb2302 = "invalid_request_method_for_EAR";
const $3a016e333d7347e3$export$54c6a0c3921e0e0b = "invalid_authorize_post_body_parameters";
const $3a016e333d7347e3$export$771e0d8e79da4143 = "invalid_platform_broker_configuration";

/*! @azure/msal-common v15.17.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $350dc36ccc5c7715$export$45752b5111a13710 = {
    [(0, $3a016e333d7347e3$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $3a016e333d7347e3$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $3a016e333d7347e3$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $3a016e333d7347e3$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $3a016e333d7347e3$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $3a016e333d7347e3$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $3a016e333d7347e3$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $3a016e333d7347e3$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $3a016e333d7347e3$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $3a016e333d7347e3$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $3a016e333d7347e3$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $3a016e333d7347e3$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $3a016e333d7347e3$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $3a016e333d7347e3$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $3a016e333d7347e3$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $3a016e333d7347e3$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $3a016e333d7347e3$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $3a016e333d7347e3$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $3a016e333d7347e3$export$9a3a7609ff879ac7)]: "Cannot set allowPlatformBroker parameter to true when not in AAD protocol mode.",
    [(0, $3a016e333d7347e3$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority.",
    [(0, $3a016e333d7347e3$export$54c6a0c3921e0e0b)]: "Invalid authorize post body parameters provided. If you are using authorizePostBodyParameters, the request method must be POST. Please check the request method and parameters.",
    [(0, $3a016e333d7347e3$export$370f4bd236cb2302)]: "Invalid request method for EAR protocol mode. The request method cannot be GET when using EAR protocol mode. Please change the request method to POST.",
    [(0, $3a016e333d7347e3$export$771e0d8e79da4143)]: "Invalid platform broker configuration. `allowPlatformBrokerWithDOM` can only be enabled when `allowPlatformBroker` is enabled."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $350dc36ccc5c7715$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $3a016e333d7347e3$export$7a02f9bdce79dd4e),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $3a016e333d7347e3$export$561c97672a478709),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $3a016e333d7347e3$export$f77c6af656c8444b),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $3a016e333d7347e3$export$ee2a1a3389f75508),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $3a016e333d7347e3$export$859df485a5e0f239),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $3a016e333d7347e3$export$6ac27379c42383f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$6ac27379c42383f]
    },
    invalidClaimsRequest: {
        code: (0, $3a016e333d7347e3$export$96e755c70e0d0e34),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$eca67ff7a91fed9d),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $3a016e333d7347e3$export$9eb2eeb401492d88),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $3a016e333d7347e3$export$b8d8b332f17376dc),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $3a016e333d7347e3$export$2da3866b327f1753),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $3a016e333d7347e3$export$92a2985751150ca5),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $3a016e333d7347e3$export$edb4d5942bc8ccff),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $3a016e333d7347e3$export$50c3162fda5f57),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $3a016e333d7347e3$export$8fbed44b22d9136f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $3a016e333d7347e3$export$b728bd8a588956c),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$4f88b4462bcef15f),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $3a016e333d7347e3$export$bea58e1a2e503b59),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $3a016e333d7347e3$export$a5c9fbb90473dca2),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$a5c9fbb90473dca2]
    },
    cannotAllowPlatformBroker: {
        code: (0, $3a016e333d7347e3$export$9a3a7609ff879ac7),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$9a3a7609ff879ac7]
    },
    authorityMismatch: {
        code: (0, $3a016e333d7347e3$export$91415fb6baea5d09),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$91415fb6baea5d09]
    },
    invalidAuthorizePostBodyParameters: {
        code: (0, $3a016e333d7347e3$export$54c6a0c3921e0e0b),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$54c6a0c3921e0e0b]
    },
    invalidRequestMethodForEAR: {
        code: (0, $3a016e333d7347e3$export$370f4bd236cb2302),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$370f4bd236cb2302]
    },
    invalidPlatformBrokerConfiguration: {
        code: (0, $3a016e333d7347e3$export$771e0d8e79da4143),
        desc: $350dc36ccc5c7715$export$45752b5111a13710[0, $3a016e333d7347e3$export$771e0d8e79da4143]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $350dc36ccc5c7715$export$ac9d9d20c2327339 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $350dc36ccc5c7715$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $350dc36ccc5c7715$export$ac9d9d20c2327339.prototype);
    }
}
function $350dc36ccc5c7715$export$5d63d098f4f130a1(errorCode) {
    return new $350dc36ccc5c7715$export$ac9d9d20c2327339(errorCode);
}

/*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dd88ab1a0b4d3851$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/* eslint-disable header/header */ const $4c1e49235f95193e$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $4c1e49235f95193e$export$83d89fbfd8236492 = "15.17.0";



/*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $442eacaa0418a38d$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
    /**
     * Tests if a given string matches a given pattern using stricter, anchored matching semantics.
     *
     * Differences from `matchPattern` (legacy):
     * - All regex metacharacters (including `.`) in the pattern are treated as literals,
     *   so `example.com` matches only `example.com` and not `exampleXcom`.
     * - The generated regex is anchored with `^` and `$` so partial/substring matches
     *   are not allowed.
     * - `*` is the only supported wildcard. Its behaviour depends on the URL component:
     *   - `host` component: `*` matches any sequence of characters that does NOT include
     *     a dot (`.`), keeping wildcards within a single DNS label boundary.
     *   - All other components: `*` matches any sequence of characters (including `/`).
     *
     * @param pattern - The `protectedResourceMap` key pattern to match against. `*` is a
     *   multi-character wildcard; all other characters are treated as literals.
     * @param input - The URL component value (e.g. host, pathname) extracted from the
     *   outgoing request URL to test against the pattern.
     * @param options - Optional. Provide `component` to enable component-aware wildcard
     *   semantics. Accepted values: `"host"`, `"path"`, `"protocol"`, `"search"`,
     *   `"hash"`. Defaults to path-style (permissive) matching when omitted.
     * @returns `true` if the full input string matches the pattern; `false` otherwise.
     */ static matchPatternStrict(pattern, input, options) {
        const component = options?.component;
        // Step 1: Escape all regex special characters so literals are matched literally.
        let regexBody = pattern.replace(/[.+^${}()|[\]\\*?]/g, "\\$&");
        // Step 2: Replace the escaped '*' with its component-aware regex equivalent.
        if (component === "host") regexBody = regexBody.replace(/\\\*/g, "[^.]*");
        else // PATH, PROTOCOL, SEARCH, HASH, or unspecified: '*' matches any characters.
        regexBody = regexBody.replace(/\\\*/g, ".*");
        // Step 3: Anchor for full-string matching.
        // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(`^${regexBody}$`);
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $74ffed612cd8faee$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $442eacaa0418a38d$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $442eacaa0418a38d$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$6ac27379c42383f));
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $74ffed612cd8faee$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...(0, $7c375ae106b964be$export$893b1b5b686d84ef)
        ];
        const scopeSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(scopesToUse);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $74ffed612cd8faee$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $7c375ae106b964be$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}





var $b29e27fb146a7ddd$exports = {};

$parcel$export($b29e27fb146a7ddd$exports, "extractTokenClaims", () => $b29e27fb146a7ddd$export$8a59e6f35fb00518);
$parcel$export($b29e27fb146a7ddd$exports, "getJWSPayload", () => $b29e27fb146a7ddd$export$b9f318d6daf53c97);
$parcel$export($b29e27fb146a7ddd$exports, "isKmsi", () => $b29e27fb146a7ddd$export$9475d607926d7a45);
$parcel$export($b29e27fb146a7ddd$exports, "checkMaxAge", () => $b29e27fb146a7ddd$export$ee7a34ea7880144c);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $b29e27fb146a7ddd$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $b29e27fb146a7ddd$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function $b29e27fb146a7ddd$export$9475d607926d7a45(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    const kmsi = idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
    return kmsi;
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $b29e27fb146a7ddd$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $b29e27fb146a7ddd$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$f95fb86904f89749));
}



/*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 


var $0763983a1d35c4b8$exports = {};

$parcel$export($0763983a1d35c4b8$exports, "stripLeadingHashOrQuery", () => $0763983a1d35c4b8$export$fe89dd256736a6b3);
$parcel$export($0763983a1d35c4b8$exports, "getDeserializedResponse", () => $0763983a1d35c4b8$export$f98e0976781b1204);
$parcel$export($0763983a1d35c4b8$exports, "mapToQueryString", () => $0763983a1d35c4b8$export$44d4663acf79cde2);
$parcel$export($0763983a1d35c4b8$exports, "normalizeUrlForComparison", () => $0763983a1d35c4b8$export$d87ce1a4b7c183c8);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Canonicalizes a URL by making it lowercase and ensuring it ends with /
 * Inlined version of UrlString.canonicalizeUri to avoid circular dependency
 * @param url - URL to canonicalize
 * @returns Canonicalized URL
 */ function $0763983a1d35c4b8$var$canonicalizeUrl(url) {
    if (!url) return url;
    let lowerCaseUrl = url.toLowerCase();
    if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
    else if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
    if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
    return lowerCaseUrl;
}
/**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $0763983a1d35c4b8$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $0763983a1d35c4b8$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$14c4d54a8414667f));
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $0763983a1d35c4b8$export$44d4663acf79cde2(parameters, encodeExtraParams = true, extraQueryParameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        if (!encodeExtraParams && extraQueryParameters && key in extraQueryParameters) queryParameterArray.push(`${key}=${value}`);
        else queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison by removing hash, canonicalizing,
 * and ensuring consistent URL encoding in query parameters.
 * This fixes redirect loops when URLs contain encoded characters like apostrophes (%27).
 * @param url - URL to normalize
 * @returns Normalized URL string for comparison
 */ function $0763983a1d35c4b8$export$d87ce1a4b7c183c8(url) {
    if (!url) return url;
    // Remove hash first
    const urlWithoutHash = url.split("#")[0];
    try {
        // Parse the URL to handle encoding consistently
        const urlObj = new URL(urlWithoutHash);
        /*
         * Reconstruct the URL with properly decoded query parameters
         * This ensures that %27 and ' are treated as equivalent
         */ const normalizedUrl = urlObj.origin + urlObj.pathname + urlObj.search;
        // Apply canonicalization logic inline to avoid circular dependency
        return $0763983a1d35c4b8$var$canonicalizeUrl(normalizedUrl);
    } catch (e) {
        // Fallback to original logic if URL parsing fails
        return $0763983a1d35c4b8$var$canonicalizeUrl(urlWithoutHash);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $f7f911f196324278$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $f7f911f196324278$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $f7f911f196324278$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $f7f911f196324278$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $f7f911f196324278$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $0763983a1d35c4b8$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ff4bd32e3511744b$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        },
        "login.sovcloud-identity.fr": {
            token_endpoint: "https://login.sovcloud-identity.fr/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.sovcloud-identity.fr/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.sovcloud-identity.fr/{tenantid}/v2.0",
            authorization_endpoint: "https://login.sovcloud-identity.fr/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.sovcloud-identity.fr/{tenantid}/oauth2/v2.0/logout"
        },
        "login.sovcloud-identity.de": {
            token_endpoint: "https://login.sovcloud-identity.de/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.sovcloud-identity.de/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.sovcloud-identity.de/{tenantid}/v2.0",
            authorization_endpoint: "https://login.sovcloud-identity.de/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.sovcloud-identity.de/{tenantid}/oauth2/v2.0/logout"
        },
        "login.sovcloud-identity.sg": {
            token_endpoint: "https://login.sovcloud-identity.sg/common/oauth2/v2.0/token",
            jwks_uri: "https://login.sovcloud-identity.sg/common/discovery/v2.0/keys",
            issuer: "https://login.sovcloud-identity.sg/{tenantid}/v2.0",
            authorization_endpoint: "https://login.sovcloud-identity.sg/common/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.sovcloud-identity.sg/common/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.fr",
                preferred_cache: "login.sovcloud-identity.fr",
                aliases: [
                    "login.sovcloud-identity.fr"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.de",
                preferred_cache: "login.sovcloud-identity.de",
                aliases: [
                    "login.sovcloud-identity.de"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.sg",
                preferred_cache: "login.sovcloud-identity.sg",
                aliases: [
                    "login.sovcloud-identity.sg"
                ]
            }
        ]
    }
};
const $ff4bd32e3511744b$export$f612854287391207 = $ff4bd32e3511744b$export$223f43dfec89cb87.endpointMetadata;
const $ff4bd32e3511744b$export$a21acafc3b6f5582 = $ff4bd32e3511744b$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $ff4bd32e3511744b$export$7d026f079148cd31 = new Set();
$ff4bd32e3511744b$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $ff4bd32e3511744b$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $ff4bd32e3511744b$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG, logger) || $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, $ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $ff4bd32e3511744b$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $ff4bd32e3511744b$export$1b1433f93c9873f(authorityHost) {
    const metadata = $ff4bd32e3511744b$export$6e21098ea6e60dc($ff4bd32e3511744b$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $ff4bd32e3511744b$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 
var $d0300807e9c5c64e$exports = {};

$parcel$export($d0300807e9c5c64e$exports, "cacheQuotaExceeded", () => $d0300807e9c5c64e$export$e55c8be2f026d30a);
$parcel$export($d0300807e9c5c64e$exports, "cacheErrorUnknown", () => $d0300807e9c5c64e$export$6f650427f72a7890);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d0300807e9c5c64e$export$e55c8be2f026d30a = "cache_quota_exceeded";
const $d0300807e9c5c64e$export$6f650427f72a7890 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $531f2a6dee41cfa4$export$7ab11f0b2c87dadd = {
    [(0, $d0300807e9c5c64e$export$e55c8be2f026d30a)]: "Exceeded cache storage capacity.",
    [(0, $d0300807e9c5c64e$export$6f650427f72a7890)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $531f2a6dee41cfa4$export$78ff06e91c3de382 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] ? $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[errorCode] : $531f2a6dee41cfa4$export$7ab11f0b2c87dadd[0, $d0300807e9c5c64e$export$6f650427f72a7890]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $531f2a6dee41cfa4$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $531f2a6dee41cfa4$export$2056718aee1b1d88(e) {
    if (!(e instanceof Error)) return new $531f2a6dee41cfa4$export$78ff06e91c3de382((0, $d0300807e9c5c64e$export$6f650427f72a7890));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $531f2a6dee41cfa4$export$78ff06e91c3de382((0, $d0300807e9c5c64e$export$e55c8be2f026d30a));
    else return new $531f2a6dee41cfa4$export$78ff06e91c3de382(e.name, e.message);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $0c353f04031c78df$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>!value)) {
            this.commonLogger.warning("getAccountInfoFilteredBy: Account filter is empty or invalid, returning null");
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return (0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param correlationId {?string} correlation id
     * @param kmsi - Keep Me Signed In
     * @param apiId - API identifier for telemetry tracking
     * @param storeInCache {?StoreInCache}
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        if (!cacheRecord) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi, apiId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) throw e;
            else throw (0, $531f2a6dee41cfa4$export$2056718aee1b1d88)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId, kmsi) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(credential.target);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * Removes accessToken from the cache
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        if (!credential || credential.credentialType.toLowerCase() !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase() || credential.tokenType !== (0, $7c375ae106b964be$export$901491a717da2ba5).POP) // If the credential is not a PoP token, we can return
        return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        const kid = credential.keyId;
        if (kid) this.cryptoImpl.removeTokenBindingKey(kid).catch(()=>{
            this.commonLogger.error(`Failed to remove token binding key ${kid}`, correlationId);
            this.performanceClient?.incrementFields({
                removeTokenBindingKeyFailure: 1
            }, correlationId);
        });
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param correlationId {?string}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("CacheManager - getAccessToken called", correlationId);
        const scopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found", correlationId);
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them", correlationId);
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken(this.generateCredentialKey(accessToken), correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param correlationId {?string}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys, performanceClient) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $ff4bd32e3511744b$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $0c353f04031c78df$export$b7254d304b3004b6 extends $0c353f04031c78df$export$996e3ea69314b5c6 {
    async setAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    async setRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    generateCredentialKey() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
    generateAccountKey() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
}




/*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    InitializeCache: "initializeCache",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    GetStandardParams: "getStandardParams",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    HandleResponseEar: "handleResponseEar",
    HandleResponsePlatformBroker: "handleResponsePlatformBroker",
    HandleResponseCode: "handleResponseCode",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    ImportExistingCache: "importExistingCache",
    SetUserData: "setUserData",
    LocalStorageUpdated: "localStorageUpdated",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues",
    GenerateHKDF: "generateHKDF",
    GenerateBaseKey: "generateBaseKey",
    Base64Decode: "base64Decode",
    UrlEncodeArr: "urlEncodeArr",
    Encrypt: "encrypt",
    Decrypt: "decrypt",
    GenerateEarKey: "generateEarKey",
    DecryptEarResponse: "decryptEarResponse",
    LoadExternalTokens: "LoadExternalTokens",
    LoadAccount: "loadAccount",
    LoadIdToken: "loadIdToken",
    LoadAccessToken: "loadAccessToken",
    LoadRefreshToken: "loadRefreshToken",
    /**
     * SSO capability verification call (msal-browser).
     * Fire-and-forget SSO verification call made after interactive authentication completes.
     */ SsoCapable: "ssoCapable"
};
const $80a5304d92c187bf$export$8dc198b6eb7c4c72 = new Map([
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.InitializeCache,
        "InitCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.ImportExistingCache,
        "importCache"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SetUserData,
        "setUserData"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.LocalStorageUpdated,
        "localStorageUpdated"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponseEar,
        "HandleRespEar"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponseCode,
        "HandleRespCode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleResponsePlatformBroker,
        "HandleRespPlatBroker"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateHKDF,
        "genHKDF"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateBaseKey,
        "genBaseKey"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Base64Decode,
        "b64Decode"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.UrlEncodeArr,
        "urlEncArr"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Encrypt,
        "encrypt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.Decrypt,
        "decrypt"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.GenerateEarKey,
        "genEarKey"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.DecryptEarResponse,
        "decryptEarResp"
    ],
    [
        $80a5304d92c187bf$export$2f2811a3e1b21823.SsoCapable,
        "SsoCapable"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $80a5304d92c187bf$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $80a5304d92c187bf$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "expiredCacheRemovedCount",
    "upgradedCacheCount",
    "networkRtt",
    "iframePollIntervalMs",
    "iframeTimeoutMs",
    "iframeTickCount",
    "crossOriginTickCount"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c21b15fc7f6dcd1f$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $c21b15fc7f6dcd1f$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $80a5304d92c187bf$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $c21b15fc7f6dcd1f$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $c21b15fc7f6dcd1f$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d21eb39178ebb5ae$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $7c375ae106b964be$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
    correlationId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22));
    }
};
const $d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $7c375ae106b964be$export$a002182e51710d39).SKU,
    version: (0, $4c1e49235f95193e$export$83d89fbfd8236492),
    cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
};
const $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
    tenant: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $d21eb39178ebb5ae$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$d21eb39178ebb5ae$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $d21eb39178ebb5ae$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$d21eb39178ebb5ae$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$d21eb39178ebb5ae$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $0c353f04031c78df$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $dd88ab1a0b4d3851$export$865f57d401606752), new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions), new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)()),
        networkInterface: networkImplementation || $d21eb39178ebb5ae$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $dd88ab1a0b4d3851$export$865f57d401606752),
        clientCredentials: clientCredentials || $d21eb39178ebb5ae$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$d21eb39178ebb5ae$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$d21eb39178ebb5ae$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $d21eb39178ebb5ae$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $d21eb39178ebb5ae$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        encodeExtraQueryParams: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $d21eb39178ebb5ae$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v15.17.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $04922ae8364b32fe$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$24176fc1f15eea22)));
    }
};



/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0780bb28b98eb888$export$ee549107fa376fc1 = "pkce_not_created";
const $0780bb28b98eb888$export$2c031f99d3e081ff = "ear_jwk_empty";
const $0780bb28b98eb888$export$b9f7c47ac4054f3d = "ear_jwe_empty";
const $0780bb28b98eb888$export$6319761d10f0cc4c = "crypto_nonexistent";
const $0780bb28b98eb888$export$be9285c64f247822 = "empty_navigate_uri";
const $0780bb28b98eb888$export$a29c42a1dd414317 = "hash_empty_error";
const $0780bb28b98eb888$export$211c8e8843a8d278 = "no_state_in_hash";
const $0780bb28b98eb888$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $0780bb28b98eb888$export$237bdd0b913cb30c = "unable_to_parse_state";
const $0780bb28b98eb888$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $0780bb28b98eb888$export$2700dc1c133d227e = "interaction_in_progress";
const $0780bb28b98eb888$export$f1b7091ee48d0b3e = "popup_window_error";
const $0780bb28b98eb888$export$5e827e513523a576 = "empty_window_error";
const $0780bb28b98eb888$export$6bae303c5e922702 = "user_cancelled";
const $0780bb28b98eb888$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $0780bb28b98eb888$export$c8b6efb19551013d = "monitor_window_timeout";
const $0780bb28b98eb888$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $0780bb28b98eb888$export$71bafc2814e56c09 = "block_iframe_reload";
const $0780bb28b98eb888$export$c4a80c97d7b48f72 = "block_nested_popups";
const $0780bb28b98eb888$export$6a76760db525f402 = "iframe_closed_prematurely";
const $0780bb28b98eb888$export$78523a40be105a03 = "silent_logout_unsupported";
const $0780bb28b98eb888$export$87933d7d4116cb12 = "no_account_error";
const $0780bb28b98eb888$export$24dae796d0958d3 = "silent_prompt_value_error";
const $0780bb28b98eb888$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $0780bb28b98eb888$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $0780bb28b98eb888$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $0780bb28b98eb888$export$ff7164a2aeeff392 = "invalid_cache_type";
const $0780bb28b98eb888$export$932e0f52d657f7fb = "non_browser_environment";
const $0780bb28b98eb888$export$4752ced1a1a262f = "database_not_open";
const $0780bb28b98eb888$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $0780bb28b98eb888$export$7a1e28a7b60ca602 = "post_request_failed";
const $0780bb28b98eb888$export$45e7eaaecd19d31e = "get_request_failed";
const $0780bb28b98eb888$export$96735047beea85a0 = "failed_to_parse_response";
const $0780bb28b98eb888$export$6acf650331eb5f5f = "unable_to_load_token";
const $0780bb28b98eb888$export$a416b0eceb5c15df = "crypto_key_not_found";
const $0780bb28b98eb888$export$e502d98cd8d2da43 = "auth_code_required";
const $0780bb28b98eb888$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $0780bb28b98eb888$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $0780bb28b98eb888$export$c1110692d2978b8 = "database_unavailable";
const $0780bb28b98eb888$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $0780bb28b98eb888$export$4747c302ef0117fd = "native_handshake_timeout";
const $0780bb28b98eb888$export$59080ea2398ee306 = "native_extension_not_installed";
const $0780bb28b98eb888$export$7b7357e3538624aa = "native_connection_not_established";
const $0780bb28b98eb888$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $0780bb28b98eb888$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $0780bb28b98eb888$export$fcc6790b5d12da63 = "invalid_base64_string";
const $0780bb28b98eb888$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $0780bb28b98eb888$export$df9e6aae71bd84f = "failed_to_build_headers";
const $0780bb28b98eb888$export$487fe7232a90003c = "failed_to_parse_headers";
const $0780bb28b98eb888$export$6e3539c6f28cd91f = "failed_to_decrypt_ear_response";
const $0780bb28b98eb888$export$ce7eeda4eb1dd3c6 = "timed_out";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6e0b7bb04b1e6592$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $6e0b7bb04b1e6592$export$16ffff3fb076c606 = {
    [(0, $0780bb28b98eb888$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $0780bb28b98eb888$export$2c031f99d3e081ff)]: "No EAR encryption key provided. This is unexpected.",
    [(0, $0780bb28b98eb888$export$b9f7c47ac4054f3d)]: "Server response does not contain ear_jwe property. This is unexpected.",
    [(0, $0780bb28b98eb888$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $0780bb28b98eb888$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $0780bb28b98eb888$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $0780bb28b98eb888$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $0780bb28b98eb888$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $0780bb28b98eb888$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $0780bb28b98eb888$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $0780bb28b98eb888$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $0780bb28b98eb888$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $0780bb28b98eb888$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $0780bb28b98eb888$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $0780bb28b98eb888$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $0780bb28b98eb888$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $0780bb28b98eb888$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $0780bb28b98eb888$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $0780bb28b98eb888$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $0780bb28b98eb888$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $0780bb28b98eb888$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $0780bb28b98eb888$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $0780bb28b98eb888$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $0780bb28b98eb888$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $0780bb28b98eb888$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $0780bb28b98eb888$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $0780bb28b98eb888$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $0780bb28b98eb888$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $0780bb28b98eb888$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $0780bb28b98eb888$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $0780bb28b98eb888$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $0780bb28b98eb888$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $0780bb28b98eb888$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $0780bb28b98eb888$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $0780bb28b98eb888$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$6e0b7bb04b1e6592$var$ErrorLink}`,
    [(0, $0780bb28b98eb888$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $0780bb28b98eb888$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $0780bb28b98eb888$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $0780bb28b98eb888$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $0780bb28b98eb888$export$487fe7232a90003c)]: "Failed to parse response headers",
    [(0, $0780bb28b98eb888$export$6e3539c6f28cd91f)]: "Failed to decrypt ear response",
    [(0, $0780bb28b98eb888$export$ce7eeda4eb1dd3c6)]: "The request timed out."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $6e0b7bb04b1e6592$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $0780bb28b98eb888$export$ee549107fa376fc1),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $0780bb28b98eb888$export$6319761d10f0cc4c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $0780bb28b98eb888$export$be9285c64f247822),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $0780bb28b98eb888$export$a29c42a1dd414317),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $0780bb28b98eb888$export$211c8e8843a8d278),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $0780bb28b98eb888$export$5743873a5ba5d124),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $0780bb28b98eb888$export$237bdd0b913cb30c),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $0780bb28b98eb888$export$499b1b95c97a1c75),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $0780bb28b98eb888$export$2700dc1c133d227e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $0780bb28b98eb888$export$f1b7091ee48d0b3e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $0780bb28b98eb888$export$5e827e513523a576),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $0780bb28b98eb888$export$6bae303c5e922702),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $0780bb28b98eb888$export$e2e3374c08b8ef2a),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $0780bb28b98eb888$export$c8b6efb19551013d),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $0780bb28b98eb888$export$9cc12eb574ceee30),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $0780bb28b98eb888$export$71bafc2814e56c09),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $0780bb28b98eb888$export$c4a80c97d7b48f72),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $0780bb28b98eb888$export$6a76760db525f402),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $0780bb28b98eb888$export$78523a40be105a03),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $0780bb28b98eb888$export$87933d7d4116cb12),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $0780bb28b98eb888$export$24dae796d0958d3),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$8b51939fb2aab3d7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $0780bb28b98eb888$export$f3ae24cdfaab4488),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f3ae24cdfaab4488]
    },
    authRequestNotSet: {
        code: (0, $0780bb28b98eb888$export$c47649cf6408c7b2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $0780bb28b98eb888$export$ff7164a2aeeff392),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $0780bb28b98eb888$export$932e0f52d657f7fb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $0780bb28b98eb888$export$4752ced1a1a262f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $0780bb28b98eb888$export$31ae862f18c3b2b7),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $0780bb28b98eb888$export$7a1e28a7b60ca602),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $0780bb28b98eb888$export$45e7eaaecd19d31e),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $0780bb28b98eb888$export$96735047beea85a0),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $0780bb28b98eb888$export$6acf650331eb5f5f),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $0780bb28b98eb888$export$a416b0eceb5c15df),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $0780bb28b98eb888$export$e502d98cd8d2da43),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $0780bb28b98eb888$export$8bea68053103eaeb),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $0780bb28b98eb888$export$1efb009e9d75bbe4),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $0780bb28b98eb888$export$c1110692d2978b8),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $0780bb28b98eb888$export$b897bbe2c683def2),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $0780bb28b98eb888$export$4747c302ef0117fd),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $0780bb28b98eb888$export$59080ea2398ee306),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $0780bb28b98eb888$export$7b7357e3538624aa),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $0780bb28b98eb888$export$436657cdcd7fe2be),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $0780bb28b98eb888$export$62fdd8848aa75547),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $0780bb28b98eb888$export$fcc6790b5d12da63),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $0780bb28b98eb888$export$f6f43ae33ad04b91),
        desc: $6e0b7bb04b1e6592$export$16ffff3fb076c606[0, $0780bb28b98eb888$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $6e0b7bb04b1e6592$export$f8eb6760ca13876a extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $6e0b7bb04b1e6592$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $6e0b7bb04b1e6592$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $6e0b7bb04b1e6592$export$f8eb6760ca13876a(errorCode, subError);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cb0bb957d18a08cc$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $cb0bb957d18a08cc$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $01c2dbbf2115e471$export$bae979e68e4dc802 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $01c2dbbf2115e471$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $01c2dbbf2115e471$export$262c4a35fb53be19(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $01c2dbbf2115e471$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $f210e947e17010a2$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$45e7eaaecd19d31e) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $f210e947e17010a2$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $5ff55562d73e0e2b$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $0780bb28b98eb888$export$7a1e28a7b60ca602) : (0, $0780bb28b98eb888$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $f210e947e17010a2$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $f210e947e17010a2$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $01c2dbbf2115e471$export$262c4a35fb53be19)((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$df9e6aae71bd84f)), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $f210e947e17010a2$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ var $7d3a00eb36d325b3$exports = {};

$parcel$export($7d3a00eb36d325b3$exports, "instrumentBrokerParams", () => $7d3a00eb36d325b3$export$7153a1ee4346fa3b);
$parcel$export($7d3a00eb36d325b3$exports, "addResponseType", () => $7d3a00eb36d325b3$export$3e2fd8b32dd28470);
$parcel$export($7d3a00eb36d325b3$exports, "addResponseMode", () => $7d3a00eb36d325b3$export$f1c153626c2c2d91);
$parcel$export($7d3a00eb36d325b3$exports, "addNativeBroker", () => $7d3a00eb36d325b3$export$8c305b8d324c4edb);
$parcel$export($7d3a00eb36d325b3$exports, "addScopes", () => $7d3a00eb36d325b3$export$c213bf8f125826ba);
$parcel$export($7d3a00eb36d325b3$exports, "addClientId", () => $7d3a00eb36d325b3$export$8360c651f9cc692b);
$parcel$export($7d3a00eb36d325b3$exports, "addRedirectUri", () => $7d3a00eb36d325b3$export$6758d6264f4f06);
$parcel$export($7d3a00eb36d325b3$exports, "addPostLogoutRedirectUri", () => $7d3a00eb36d325b3$export$bb8081db67b059c0);
$parcel$export($7d3a00eb36d325b3$exports, "addIdTokenHint", () => $7d3a00eb36d325b3$export$c6f34f6f67740950);
$parcel$export($7d3a00eb36d325b3$exports, "addDomainHint", () => $7d3a00eb36d325b3$export$1bd007a9d7fec290);
$parcel$export($7d3a00eb36d325b3$exports, "addLoginHint", () => $7d3a00eb36d325b3$export$65f43fd4b28bba5f);
$parcel$export($7d3a00eb36d325b3$exports, "addCcsUpn", () => $7d3a00eb36d325b3$export$aa9cca16bcc29d2d);
$parcel$export($7d3a00eb36d325b3$exports, "addCcsOid", () => $7d3a00eb36d325b3$export$68a633ecf634a2ea);
$parcel$export($7d3a00eb36d325b3$exports, "addSid", () => $7d3a00eb36d325b3$export$9d8531b0fa366b30);
$parcel$export($7d3a00eb36d325b3$exports, "addClaims", () => $7d3a00eb36d325b3$export$b04c3bca9165ed02);
$parcel$export($7d3a00eb36d325b3$exports, "addClientCapabilitiesToClaims", () => $7d3a00eb36d325b3$export$f40e790983a9797e);
$parcel$export($7d3a00eb36d325b3$exports, "addCorrelationId", () => $7d3a00eb36d325b3$export$8a224ff809946e9c);
$parcel$export($7d3a00eb36d325b3$exports, "addLibraryInfo", () => $7d3a00eb36d325b3$export$3ecac3764b147c3f);
$parcel$export($7d3a00eb36d325b3$exports, "addApplicationTelemetry", () => $7d3a00eb36d325b3$export$37ec1b76d865654a);
$parcel$export($7d3a00eb36d325b3$exports, "addPrompt", () => $7d3a00eb36d325b3$export$e982ccd37a61cde6);
$parcel$export($7d3a00eb36d325b3$exports, "addState", () => $7d3a00eb36d325b3$export$4a8b8c14090dd065);
$parcel$export($7d3a00eb36d325b3$exports, "addNonce", () => $7d3a00eb36d325b3$export$87b1d5d886e84b11);
$parcel$export($7d3a00eb36d325b3$exports, "addCodeChallengeParams", () => $7d3a00eb36d325b3$export$57a984e7ed784e16);
$parcel$export($7d3a00eb36d325b3$exports, "addAuthorizationCode", () => $7d3a00eb36d325b3$export$ff027aab2d77a49c);
$parcel$export($7d3a00eb36d325b3$exports, "addDeviceCode", () => $7d3a00eb36d325b3$export$8999dc4307159304);
$parcel$export($7d3a00eb36d325b3$exports, "addRefreshToken", () => $7d3a00eb36d325b3$export$b9e8ccbb425b80a3);
$parcel$export($7d3a00eb36d325b3$exports, "addCodeVerifier", () => $7d3a00eb36d325b3$export$dceb49e3b4703cbb);
$parcel$export($7d3a00eb36d325b3$exports, "addClientSecret", () => $7d3a00eb36d325b3$export$8df84bbb0e2465bc);
$parcel$export($7d3a00eb36d325b3$exports, "addClientAssertion", () => $7d3a00eb36d325b3$export$2d3d772920e2496e);
$parcel$export($7d3a00eb36d325b3$exports, "addClientAssertionType", () => $7d3a00eb36d325b3$export$55ad911d12112f00);
$parcel$export($7d3a00eb36d325b3$exports, "addOboAssertion", () => $7d3a00eb36d325b3$export$34b131001eea36b1);
$parcel$export($7d3a00eb36d325b3$exports, "addRequestTokenUse", () => $7d3a00eb36d325b3$export$b6d65fd125460167);
$parcel$export($7d3a00eb36d325b3$exports, "addGrantType", () => $7d3a00eb36d325b3$export$e5f700fdeb4022b2);
$parcel$export($7d3a00eb36d325b3$exports, "addClientInfo", () => $7d3a00eb36d325b3$export$86b85a101d45e918);
$parcel$export($7d3a00eb36d325b3$exports, "addCliData", () => $7d3a00eb36d325b3$export$5a0058be0b2fe3ea);
$parcel$export($7d3a00eb36d325b3$exports, "addInstanceAware", () => $7d3a00eb36d325b3$export$50b40dfb1d11b77a);
$parcel$export($7d3a00eb36d325b3$exports, "addExtraQueryParameters", () => $7d3a00eb36d325b3$export$1a9f676bcc5d37da);
$parcel$export($7d3a00eb36d325b3$exports, "addUsername", () => $7d3a00eb36d325b3$export$d38c772efe03a690);
$parcel$export($7d3a00eb36d325b3$exports, "addPassword", () => $7d3a00eb36d325b3$export$bfe833e59aa823e8);
$parcel$export($7d3a00eb36d325b3$exports, "addPopToken", () => $7d3a00eb36d325b3$export$6dfc34809d8c4096);
$parcel$export($7d3a00eb36d325b3$exports, "addSshJwk", () => $7d3a00eb36d325b3$export$f004de9a266b8070);
$parcel$export($7d3a00eb36d325b3$exports, "addServerTelemetry", () => $7d3a00eb36d325b3$export$79fb524b159705e9);
$parcel$export($7d3a00eb36d325b3$exports, "addThrottling", () => $7d3a00eb36d325b3$export$26592ae2037df9de);
$parcel$export($7d3a00eb36d325b3$exports, "addLogoutHint", () => $7d3a00eb36d325b3$export$e0d4676d7288bded);
$parcel$export($7d3a00eb36d325b3$exports, "addBrokerParameters", () => $7d3a00eb36d325b3$export$5ea4577e2a518c27);
$parcel$export($7d3a00eb36d325b3$exports, "addEARParameters", () => $7d3a00eb36d325b3$export$ec0b476da4a9fb0);
$parcel$export($7d3a00eb36d325b3$exports, "addPostBodyParameters", () => $7d3a00eb36d325b3$export$c9658e697f771ac4);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 
var $b00a7f221d8fdf60$exports = {};

$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ID", () => $b00a7f221d8fdf60$export$c7b1b63f5b60f8e);
$parcel$export($b00a7f221d8fdf60$exports, "REDIRECT_URI", () => $b00a7f221d8fdf60$export$89711068e98820c5);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_TYPE", () => $b00a7f221d8fdf60$export$af70b7209f1c7f6e);
$parcel$export($b00a7f221d8fdf60$exports, "RESPONSE_MODE", () => $b00a7f221d8fdf60$export$2ae8b352eb8edff7);
$parcel$export($b00a7f221d8fdf60$exports, "GRANT_TYPE", () => $b00a7f221d8fdf60$export$47f09697d0642170);
$parcel$export($b00a7f221d8fdf60$exports, "CLAIMS", () => $b00a7f221d8fdf60$export$c9b29cc9615296dd);
$parcel$export($b00a7f221d8fdf60$exports, "SCOPE", () => $b00a7f221d8fdf60$export$1c5a554c78c0cd12);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR", () => $b00a7f221d8fdf60$export$103bedf43ba882db);
$parcel$export($b00a7f221d8fdf60$exports, "ERROR_DESCRIPTION", () => $b00a7f221d8fdf60$export$a9d2d02ea6b73527);
$parcel$export($b00a7f221d8fdf60$exports, "ACCESS_TOKEN", () => $b00a7f221d8fdf60$export$cdbdf26448f9da5b);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN", () => $b00a7f221d8fdf60$export$9e690c458f1b1eda);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN", () => $b00a7f221d8fdf60$export$2a2261c5a58ac0);
$parcel$export($b00a7f221d8fdf60$exports, "EXPIRES_IN", () => $b00a7f221d8fdf60$export$a9f2539254087dfb);
$parcel$export($b00a7f221d8fdf60$exports, "REFRESH_TOKEN_EXPIRES_IN", () => $b00a7f221d8fdf60$export$97e3ac17371277);
$parcel$export($b00a7f221d8fdf60$exports, "STATE", () => $b00a7f221d8fdf60$export$63b4527a2777036f);
$parcel$export($b00a7f221d8fdf60$exports, "NONCE", () => $b00a7f221d8fdf60$export$8646168ae3eb91e1);
$parcel$export($b00a7f221d8fdf60$exports, "PROMPT", () => $b00a7f221d8fdf60$export$19855bb42e55939d);
$parcel$export($b00a7f221d8fdf60$exports, "SESSION_STATE", () => $b00a7f221d8fdf60$export$3edd0f3d0bfcddba);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_INFO", () => $b00a7f221d8fdf60$export$476989d62bcb4c85);
$parcel$export($b00a7f221d8fdf60$exports, "CODE", () => $b00a7f221d8fdf60$export$ec5856072852bd7f);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE", () => $b00a7f221d8fdf60$export$58d2be3216991fee);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_CHALLENGE_METHOD", () => $b00a7f221d8fdf60$export$129e6f0601e36303);
$parcel$export($b00a7f221d8fdf60$exports, "CODE_VERIFIER", () => $b00a7f221d8fdf60$export$a5a34ec10c757281);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_REQUEST_ID", () => $b00a7f221d8fdf60$export$633c8d7cd18ad9a9);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_SKU", () => $b00a7f221d8fdf60$export$fe2f04d04881f19d);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_VER", () => $b00a7f221d8fdf60$export$d0d0201281a553c0);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_OS", () => $b00a7f221d8fdf60$export$35497983a44f9406);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CPU", () => $b00a7f221d8fdf60$export$d14a6ca469cd1d2b);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_CURR_TELEM", () => $b00a7f221d8fdf60$export$770dc090fda61e98);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_LAST_TELEM", () => $b00a7f221d8fdf60$export$99d6087ff3bfb0d3);
$parcel$export($b00a7f221d8fdf60$exports, "X_MS_LIB_CAPABILITY", () => $b00a7f221d8fdf60$export$c5cd103a582a276);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_NAME", () => $b00a7f221d8fdf60$export$6101af169595a2ae);
$parcel$export($b00a7f221d8fdf60$exports, "X_APP_VER", () => $b00a7f221d8fdf60$export$a8707209cc4254a);
$parcel$export($b00a7f221d8fdf60$exports, "POST_LOGOUT_URI", () => $b00a7f221d8fdf60$export$965624bb436bcb2);
$parcel$export($b00a7f221d8fdf60$exports, "ID_TOKEN_HINT", () => $b00a7f221d8fdf60$export$8d6737236a319b56);
$parcel$export($b00a7f221d8fdf60$exports, "DEVICE_CODE", () => $b00a7f221d8fdf60$export$a575303545717aec);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_SECRET", () => $b00a7f221d8fdf60$export$69f7aececf3ea5d7);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION", () => $b00a7f221d8fdf60$export$cddd1d85c78cca51);
$parcel$export($b00a7f221d8fdf60$exports, "CLIENT_ASSERTION_TYPE", () => $b00a7f221d8fdf60$export$21aecb34d0e7d9c0);
$parcel$export($b00a7f221d8fdf60$exports, "TOKEN_TYPE", () => $b00a7f221d8fdf60$export$5706a68daf4f000a);
$parcel$export($b00a7f221d8fdf60$exports, "REQ_CNF", () => $b00a7f221d8fdf60$export$427afb3f9eefe31e);
$parcel$export($b00a7f221d8fdf60$exports, "OBO_ASSERTION", () => $b00a7f221d8fdf60$export$3529b31b0ae94ae0);
$parcel$export($b00a7f221d8fdf60$exports, "REQUESTED_TOKEN_USE", () => $b00a7f221d8fdf60$export$97bc1bf63f077c4a);
$parcel$export($b00a7f221d8fdf60$exports, "ON_BEHALF_OF", () => $b00a7f221d8fdf60$export$4aca5741d44e318e);
$parcel$export($b00a7f221d8fdf60$exports, "FOCI", () => $b00a7f221d8fdf60$export$a03331b9d99609d6);
$parcel$export($b00a7f221d8fdf60$exports, "CCS_HEADER", () => $b00a7f221d8fdf60$export$773357fabf610b1f);
$parcel$export($b00a7f221d8fdf60$exports, "RETURN_SPA_CODE", () => $b00a7f221d8fdf60$export$f58b98a40c1faa68);
$parcel$export($b00a7f221d8fdf60$exports, "NATIVE_BROKER", () => $b00a7f221d8fdf60$export$830ff7e6cf071f86);
$parcel$export($b00a7f221d8fdf60$exports, "LOGOUT_HINT", () => $b00a7f221d8fdf60$export$a96ff88ff08babe2);
$parcel$export($b00a7f221d8fdf60$exports, "SID", () => $b00a7f221d8fdf60$export$e9405f9e95799b52);
$parcel$export($b00a7f221d8fdf60$exports, "LOGIN_HINT", () => $b00a7f221d8fdf60$export$defd6be6e02aaeb3);
$parcel$export($b00a7f221d8fdf60$exports, "DOMAIN_HINT", () => $b00a7f221d8fdf60$export$41459bac1e74ba19);
$parcel$export($b00a7f221d8fdf60$exports, "X_CLIENT_EXTRA_SKU", () => $b00a7f221d8fdf60$export$493429868d5ba9bc);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_CLIENT_ID", () => $b00a7f221d8fdf60$export$3f910906fd5fe047);
$parcel$export($b00a7f221d8fdf60$exports, "BROKER_REDIRECT_URI", () => $b00a7f221d8fdf60$export$c3ecf58e7e228261);
$parcel$export($b00a7f221d8fdf60$exports, "INSTANCE_AWARE", () => $b00a7f221d8fdf60$export$d72b25d13120919d);
$parcel$export($b00a7f221d8fdf60$exports, "EAR_JWK", () => $b00a7f221d8fdf60$export$1e9ebf38b05380ef);
$parcel$export($b00a7f221d8fdf60$exports, "EAR_JWE_CRYPTO", () => $b00a7f221d8fdf60$export$79d2fd0e357f5119);
$parcel$export($b00a7f221d8fdf60$exports, "CLI_DATA", () => $b00a7f221d8fdf60$export$d1fd943f3801b39a);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b00a7f221d8fdf60$export$c7b1b63f5b60f8e = "client_id";
const $b00a7f221d8fdf60$export$89711068e98820c5 = "redirect_uri";
const $b00a7f221d8fdf60$export$af70b7209f1c7f6e = "response_type";
const $b00a7f221d8fdf60$export$2ae8b352eb8edff7 = "response_mode";
const $b00a7f221d8fdf60$export$47f09697d0642170 = "grant_type";
const $b00a7f221d8fdf60$export$c9b29cc9615296dd = "claims";
const $b00a7f221d8fdf60$export$1c5a554c78c0cd12 = "scope";
const $b00a7f221d8fdf60$export$103bedf43ba882db = "error";
const $b00a7f221d8fdf60$export$a9d2d02ea6b73527 = "error_description";
const $b00a7f221d8fdf60$export$cdbdf26448f9da5b = "access_token";
const $b00a7f221d8fdf60$export$9e690c458f1b1eda = "id_token";
const $b00a7f221d8fdf60$export$2a2261c5a58ac0 = "refresh_token";
const $b00a7f221d8fdf60$export$a9f2539254087dfb = "expires_in";
const $b00a7f221d8fdf60$export$97e3ac17371277 = "refresh_token_expires_in";
const $b00a7f221d8fdf60$export$63b4527a2777036f = "state";
const $b00a7f221d8fdf60$export$8646168ae3eb91e1 = "nonce";
const $b00a7f221d8fdf60$export$19855bb42e55939d = "prompt";
const $b00a7f221d8fdf60$export$3edd0f3d0bfcddba = "session_state";
const $b00a7f221d8fdf60$export$476989d62bcb4c85 = "client_info";
const $b00a7f221d8fdf60$export$ec5856072852bd7f = "code";
const $b00a7f221d8fdf60$export$58d2be3216991fee = "code_challenge";
const $b00a7f221d8fdf60$export$129e6f0601e36303 = "code_challenge_method";
const $b00a7f221d8fdf60$export$a5a34ec10c757281 = "code_verifier";
const $b00a7f221d8fdf60$export$633c8d7cd18ad9a9 = "client-request-id";
const $b00a7f221d8fdf60$export$fe2f04d04881f19d = "x-client-SKU";
const $b00a7f221d8fdf60$export$d0d0201281a553c0 = "x-client-VER";
const $b00a7f221d8fdf60$export$35497983a44f9406 = "x-client-OS";
const $b00a7f221d8fdf60$export$d14a6ca469cd1d2b = "x-client-CPU";
const $b00a7f221d8fdf60$export$770dc090fda61e98 = "x-client-current-telemetry";
const $b00a7f221d8fdf60$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $b00a7f221d8fdf60$export$c5cd103a582a276 = "x-ms-lib-capability";
const $b00a7f221d8fdf60$export$6101af169595a2ae = "x-app-name";
const $b00a7f221d8fdf60$export$a8707209cc4254a = "x-app-ver";
const $b00a7f221d8fdf60$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $b00a7f221d8fdf60$export$8d6737236a319b56 = "id_token_hint";
const $b00a7f221d8fdf60$export$a575303545717aec = "device_code";
const $b00a7f221d8fdf60$export$69f7aececf3ea5d7 = "client_secret";
const $b00a7f221d8fdf60$export$cddd1d85c78cca51 = "client_assertion";
const $b00a7f221d8fdf60$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $b00a7f221d8fdf60$export$5706a68daf4f000a = "token_type";
const $b00a7f221d8fdf60$export$427afb3f9eefe31e = "req_cnf";
const $b00a7f221d8fdf60$export$3529b31b0ae94ae0 = "assertion";
const $b00a7f221d8fdf60$export$97bc1bf63f077c4a = "requested_token_use";
const $b00a7f221d8fdf60$export$4aca5741d44e318e = "on_behalf_of";
const $b00a7f221d8fdf60$export$a03331b9d99609d6 = "foci";
const $b00a7f221d8fdf60$export$773357fabf610b1f = "X-AnchorMailbox";
const $b00a7f221d8fdf60$export$f58b98a40c1faa68 = "return_spa_code";
const $b00a7f221d8fdf60$export$830ff7e6cf071f86 = "nativebroker";
const $b00a7f221d8fdf60$export$a96ff88ff08babe2 = "logout_hint";
const $b00a7f221d8fdf60$export$e9405f9e95799b52 = "sid";
const $b00a7f221d8fdf60$export$defd6be6e02aaeb3 = "login_hint";
const $b00a7f221d8fdf60$export$41459bac1e74ba19 = "domain_hint";
const $b00a7f221d8fdf60$export$493429868d5ba9bc = "x-client-xtra-sku";
const $b00a7f221d8fdf60$export$3f910906fd5fe047 = "brk_client_id";
const $b00a7f221d8fdf60$export$c3ecf58e7e228261 = "brk_redirect_uri";
const $b00a7f221d8fdf60$export$d72b25d13120919d = "instance_aware";
const $b00a7f221d8fdf60$export$1e9ebf38b05380ef = "ear_jwk";
const $b00a7f221d8fdf60$export$79d2fd0e357f5119 = "ear_jwe_crypto";
const $b00a7f221d8fdf60$export$d1fd943f3801b39a = "clidata";





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $7d3a00eb36d325b3$export$7153a1ee4346fa3b(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $b00a7f221d8fdf60$export$89711068e98820c5))
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $7d3a00eb36d325b3$export$3e2fd8b32dd28470(parameters, responseType) {
    parameters.set((0, $b00a7f221d8fdf60$export$af70b7209f1c7f6e), responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $7d3a00eb36d325b3$export$f1c153626c2c2d91(parameters, responseMode) {
    parameters.set((0, $b00a7f221d8fdf60$export$2ae8b352eb8edff7), responseMode ? responseMode : (0, $7c375ae106b964be$export$f990a5bae1260b8c).QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $7d3a00eb36d325b3$export$8c305b8d324c4edb(parameters) {
    parameters.set((0, $b00a7f221d8fdf60$export$830ff7e6cf071f86), "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $7d3a00eb36d325b3$export$c213bf8f125826ba(parameters, scopes, addOidcScopes = true, defaultScopes = (0, $7c375ae106b964be$export$893b1b5b686d84ef)) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(requestScopes);
    parameters.set((0, $b00a7f221d8fdf60$export$1c5a554c78c0cd12), scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $7d3a00eb36d325b3$export$8360c651f9cc692b(parameters, clientId) {
    parameters.set((0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e), clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $7d3a00eb36d325b3$export$6758d6264f4f06(parameters, redirectUri) {
    parameters.set((0, $b00a7f221d8fdf60$export$89711068e98820c5), redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $7d3a00eb36d325b3$export$bb8081db67b059c0(parameters, redirectUri) {
    parameters.set((0, $b00a7f221d8fdf60$export$965624bb436bcb2), redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $7d3a00eb36d325b3$export$c6f34f6f67740950(parameters, idTokenHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$8d6737236a319b56), idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $7d3a00eb36d325b3$export$1bd007a9d7fec290(parameters, domainHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$41459bac1e74ba19), domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$65f43fd4b28bba5f(parameters, loginHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$defd6be6e02aaeb3), loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$aa9cca16bcc29d2d(parameters, loginHint) {
    parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $7d3a00eb36d325b3$export$68a633ecf634a2ea(parameters, clientInfo) {
    parameters.set((0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $7d3a00eb36d325b3$export$9d8531b0fa366b30(parameters, sid) {
    parameters.set((0, $b00a7f221d8fdf60$export$e9405f9e95799b52), sid);
}
/**
 * add claims
 * @param claims
 */ function $7d3a00eb36d325b3$export$b04c3bca9165ed02(parameters, claims, clientCapabilities) {
    const mergedClaims = $7d3a00eb36d325b3$export$f40e790983a9797e(claims, clientCapabilities);
    try {
        JSON.parse(mergedClaims);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
    }
    parameters.set((0, $b00a7f221d8fdf60$export$c9b29cc9615296dd), mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $7d3a00eb36d325b3$export$8a224ff809946e9c(parameters, correlationId) {
    parameters.set((0, $b00a7f221d8fdf60$export$633c8d7cd18ad9a9), correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $7d3a00eb36d325b3$export$3ecac3764b147c3f(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set((0, $b00a7f221d8fdf60$export$fe2f04d04881f19d), libraryInfo.sku);
    parameters.set((0, $b00a7f221d8fdf60$export$d0d0201281a553c0), libraryInfo.version);
    if (libraryInfo.os) parameters.set((0, $b00a7f221d8fdf60$export$35497983a44f9406), libraryInfo.os);
    if (libraryInfo.cpu) parameters.set((0, $b00a7f221d8fdf60$export$d14a6ca469cd1d2b), libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $7d3a00eb36d325b3$export$37ec1b76d865654a(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set((0, $b00a7f221d8fdf60$export$6101af169595a2ae), appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set((0, $b00a7f221d8fdf60$export$a8707209cc4254a), appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $7d3a00eb36d325b3$export$e982ccd37a61cde6(parameters, prompt) {
    parameters.set((0, $b00a7f221d8fdf60$export$19855bb42e55939d), prompt);
}
/**
 * add state
 * @param state
 */ function $7d3a00eb36d325b3$export$4a8b8c14090dd065(parameters, state) {
    if (state) parameters.set((0, $b00a7f221d8fdf60$export$63b4527a2777036f), state);
}
/**
 * add nonce
 * @param nonce
 */ function $7d3a00eb36d325b3$export$87b1d5d886e84b11(parameters, nonce) {
    parameters.set((0, $b00a7f221d8fdf60$export$8646168ae3eb91e1), nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $7d3a00eb36d325b3$export$57a984e7ed784e16(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set((0, $b00a7f221d8fdf60$export$58d2be3216991fee), codeChallenge);
        parameters.set((0, $b00a7f221d8fdf60$export$129e6f0601e36303), codeChallengeMethod);
    } else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$2da3866b327f1753));
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $7d3a00eb36d325b3$export$ff027aab2d77a49c(parameters, code) {
    parameters.set((0, $b00a7f221d8fdf60$export$ec5856072852bd7f), code);
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $7d3a00eb36d325b3$export$8999dc4307159304(parameters, code) {
    parameters.set((0, $b00a7f221d8fdf60$export$a575303545717aec), code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $7d3a00eb36d325b3$export$b9e8ccbb425b80a3(parameters, refreshToken) {
    parameters.set((0, $b00a7f221d8fdf60$export$2a2261c5a58ac0), refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $7d3a00eb36d325b3$export$dceb49e3b4703cbb(parameters, codeVerifier) {
    parameters.set((0, $b00a7f221d8fdf60$export$a5a34ec10c757281), codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $7d3a00eb36d325b3$export$8df84bbb0e2465bc(parameters, clientSecret) {
    parameters.set((0, $b00a7f221d8fdf60$export$69f7aececf3ea5d7), clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $7d3a00eb36d325b3$export$2d3d772920e2496e(parameters, clientAssertion) {
    if (clientAssertion) parameters.set((0, $b00a7f221d8fdf60$export$cddd1d85c78cca51), clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $7d3a00eb36d325b3$export$55ad911d12112f00(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set((0, $b00a7f221d8fdf60$export$21aecb34d0e7d9c0), clientAssertionType);
}
/**
 * add OBO assertion for confidential client flows
 * @param clientAssertion
 */ function $7d3a00eb36d325b3$export$34b131001eea36b1(parameters, oboAssertion) {
    parameters.set((0, $b00a7f221d8fdf60$export$3529b31b0ae94ae0), oboAssertion);
}
/**
 * add grant type
 * @param grantType
 */ function $7d3a00eb36d325b3$export$b6d65fd125460167(parameters, tokenUse) {
    parameters.set((0, $b00a7f221d8fdf60$export$97bc1bf63f077c4a), tokenUse);
}
/**
 * add grant type
 * @param grantType
 */ function $7d3a00eb36d325b3$export$e5f700fdeb4022b2(parameters, grantType) {
    parameters.set((0, $b00a7f221d8fdf60$export$47f09697d0642170), grantType);
}
/**
 * add client info
 *
 */ function $7d3a00eb36d325b3$export$86b85a101d45e918(parameters) {
    parameters.set((0, $7c375ae106b964be$export$476989d62bcb4c85), "1");
}
/**
 * add clidata=1 to request to indicate client data support
 */ function $7d3a00eb36d325b3$export$5a0058be0b2fe3ea(parameters) {
    parameters.set((0, $b00a7f221d8fdf60$export$d1fd943f3801b39a), "1");
}
function $7d3a00eb36d325b3$export$50b40dfb1d11b77a(parameters) {
    if (!parameters.has((0, $b00a7f221d8fdf60$export$d72b25d13120919d))) parameters.set((0, $b00a7f221d8fdf60$export$d72b25d13120919d), "true");
}
/**
 * add extraQueryParams
 * @param eQParams
 */ function $7d3a00eb36d325b3$export$1a9f676bcc5d37da(parameters, eQParams) {
    Object.entries(eQParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
function $7d3a00eb36d325b3$export$f40e790983a9797e(claims, clientCapabilities) {
    let mergedClaims;
    // Parse provided claims into JSON object or initialize empty object
    if (!claims) mergedClaims = {};
    else try {
        mergedClaims = JSON.parse(claims);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$96e755c70e0d0e34));
    }
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!mergedClaims.hasOwnProperty((0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[(0, $7c375ae106b964be$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $7c375ae106b964be$export$c125cda26c71ef54).XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * adds `username` for Password Grant flow
 * @param username
 */ function $7d3a00eb36d325b3$export$d38c772efe03a690(parameters, username) {
    parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).username, username);
}
/**
 * adds `password` for Password Grant flow
 * @param password
 */ function $7d3a00eb36d325b3$export$bfe833e59aa823e8(parameters, password) {
    parameters.set((0, $7c375ae106b964be$export$fa8b29062cab1da).password, password);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $7d3a00eb36d325b3$export$6dfc34809d8c4096(parameters, cnfString) {
    if (cnfString) {
        parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).POP);
        parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $7d3a00eb36d325b3$export$f004de9a266b8070(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set((0, $b00a7f221d8fdf60$export$5706a68daf4f000a), (0, $7c375ae106b964be$export$901491a717da2ba5).SSH);
        parameters.set((0, $b00a7f221d8fdf60$export$427afb3f9eefe31e), sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 */ function $7d3a00eb36d325b3$export$79fb524b159705e9(parameters, serverTelemetryManager) {
    parameters.set((0, $b00a7f221d8fdf60$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set((0, $b00a7f221d8fdf60$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $7d3a00eb36d325b3$export$26592ae2037df9de(parameters) {
    parameters.set((0, $b00a7f221d8fdf60$export$c5cd103a582a276), (0, $7c375ae106b964be$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $7d3a00eb36d325b3$export$e0d4676d7288bded(parameters, logoutHint) {
    parameters.set((0, $b00a7f221d8fdf60$export$a96ff88ff08babe2), logoutHint);
}
function $7d3a00eb36d325b3$export$5ea4577e2a518c27(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047))) parameters.set((0, $b00a7f221d8fdf60$export$3f910906fd5fe047), brokerClientId);
    if (!parameters.has((0, $b00a7f221d8fdf60$export$c3ecf58e7e228261))) parameters.set((0, $b00a7f221d8fdf60$export$c3ecf58e7e228261), brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $7d3a00eb36d325b3$export$ec0b476da4a9fb0(parameters, jwk) {
    parameters.set((0, $b00a7f221d8fdf60$export$1e9ebf38b05380ef), encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set((0, $b00a7f221d8fdf60$export$79d2fd0e357f5119), jweCryptoB64Encoded);
}
/**
 * Adds authorize body parameters to the request parameters
 * @param parameters
 * @param bodyParameters
 */ function $7d3a00eb36d325b3$export$c9658e697f771ac4(parameters, bodyParameters) {
    Object.entries(bodyParameters).forEach(([key, value])=>{
        if (value) parameters.set(key, value);
    });
}




/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($6f6986007da7f422$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $6f6986007da7f422$export$84f5a428c7153a69(inputArr) {
    return $6f6986007da7f422$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $6f6986007da7f422$export$e510a73ee562749(input) {
    return $6f6986007da7f422$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $6f6986007da7f422$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $581fd3df606755c8$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($581fd3df606755c8$export$8f0c237d3e8188bc(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $581fd3df606755c8$export$8f0c237d3e8188bc(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $4e0948336b4ea4a7$var$AES_GCM = "AES-GCM";
const $4e0948336b4ea4a7$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $4e0948336b4ea4a7$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $4e0948336b4ea4a7$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $4e0948336b4ea4a7$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $4e0948336b4ea4a7$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $4e0948336b4ea4a7$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $4e0948336b4ea4a7$var$RAW = "raw";
// Key Usages
const $4e0948336b4ea4a7$var$ENCRYPT = "encrypt";
const $4e0948336b4ea4a7$var$DECRYPT = "decrypt";
const $4e0948336b4ea4a7$var$DERIVE_KEY = "deriveKey";
// Suberror
const $4e0948336b4ea4a7$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $4e0948336b4ea4a7$var$keygenAlgorithmOptions = {
    name: $4e0948336b4ea4a7$var$PKCS1_V15_KEYGEN_ALG,
    hash: $4e0948336b4ea4a7$var$S256_HASH_ALG,
    modulusLength: $4e0948336b4ea4a7$var$MODULUS_LENGTH,
    publicExponent: $4e0948336b4ea4a7$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $4e0948336b4ea4a7$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c));
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6319761d10f0cc4c), $4e0948336b4ea4a7$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $4e0948336b4ea4a7$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($4e0948336b4ea4a7$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $4e0948336b4ea4a7$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $4e0948336b4ea4a7$var$getRandomUint32() {
    window.crypto.getRandomValues($4e0948336b4ea4a7$var$UINT32_ARR);
    return $4e0948336b4ea4a7$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $4e0948336b4ea4a7$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $4e0948336b4ea4a7$var$getRandomUint32() * 0x400 + ($4e0948336b4ea4a7$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $4e0948336b4ea4a7$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $4e0948336b4ea4a7$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $4e0948336b4ea4a7$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $4e0948336b4ea4a7$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $5ff55562d73e0e2b$export$1294c3e3f84694cd), key, $4e0948336b4ea4a7$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $4e0948336b4ea4a7$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($4e0948336b4ea4a7$var$keygenAlgorithmOptions, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $4e0948336b4ea4a7$export$95528b8a314880d1() {
    const key = await $4e0948336b4ea4a7$export$1222fa1cada87c76();
    const keyStr = (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return (0, $6f6986007da7f422$export$e510a73ee562749)(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $4e0948336b4ea4a7$export$cf6da4e13ceceed(earJwk) {
    const b64DecodedJwk = (0, $581fd3df606755c8$export$c62426fdd000a97e)(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(rawKey);
    return window.crypto.subtle.importKey($4e0948336b4ea4a7$var$RAW, keyBuffer, $4e0948336b4ea4a7$var$AES_GCM, false, [
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $4e0948336b4ea4a7$export$13b9c776ab498ef3(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "jwe_length");
    const key = await $4e0948336b4ea4a7$export$cf6da4e13ceceed(earJwk).catch(()=>{
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[2]);
        const ciphertext = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[3]);
        const tag = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $4e0948336b4ea4a7$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6e3539c6f28cd91f), "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $4e0948336b4ea4a7$export$1222fa1cada87c76() {
    const key = await window.crypto.subtle.generateKey({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        length: 256
    }, true, [
        $4e0948336b4ea4a7$var$ENCRYPT,
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($4e0948336b4ea4a7$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $4e0948336b4ea4a7$export$5a71d4e3178f19c4(baseKey) {
    return window.crypto.subtle.importKey($4e0948336b4ea4a7$var$RAW, baseKey, $4e0948336b4ea4a7$var$HKDF, false, [
        $4e0948336b4ea4a7$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $4e0948336b4ea4a7$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $4e0948336b4ea4a7$var$HKDF,
        salt: nonce,
        hash: $4e0948336b4ea4a7$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $4e0948336b4ea4a7$var$AES_GCM,
        length: 256
    }, false, [
        $4e0948336b4ea4a7$var$ENCRYPT,
        $4e0948336b4ea4a7$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $4e0948336b4ea4a7$export$5b0f6292f11d1d18(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $4e0948336b4ea4a7$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(encryptedData)),
        nonce: (0, $6f6986007da7f422$export$84f5a428c7153a69)(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $4e0948336b4ea4a7$export$e85a0c9a1067c5d3(baseKey, nonce, context, encryptedData) {
    const encodedData = (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(encryptedData);
    const derivedKey = await $4e0948336b4ea4a7$var$deriveKey(baseKey, (0, $581fd3df606755c8$export$8f0c237d3e8188bc)(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $4e0948336b4ea4a7$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $4e0948336b4ea4a7$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $4e0948336b4ea4a7$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $6f6986007da7f422$export$84f5a428c7153a69)(hashBytes);
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $3003b661a087a867$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $3003b661a087a867$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $3003b661a087a867$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $3003b661a087a867$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $3003b661a087a867$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $3003b661a087a867$export$60785768478b4ffc() {
    const currentUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $3003b661a087a867$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $f7f911f196324278$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $3003b661a087a867$export$9f140ed41af5108c()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $3003b661a087a867$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($3003b661a087a867$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $3003b661a087a867$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($3003b661a087a867$export$722fdce8786cc28b()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $3003b661a087a867$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $3003b661a087a867$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $3003b661a087a867$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $3003b661a087a867$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $3003b661a087a867$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $3003b661a087a867$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $3003b661a087a867$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $3003b661a087a867$export$62c8f4fdca4df60f(initialized, config) {
    $3003b661a087a867$export$4dd091cbdc98b52e(initialized);
    $3003b661a087a867$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $3003b661a087a867$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $3003b661a087a867$export$7571c350ed9fec74() {
    return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
}
const $3003b661a087a867$export$f40e790983a9797e = (0, $7d3a00eb36d325b3$exports).addClientCapabilitiesToClaims;


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $68fb5a78014bcfe7$export$a5835ee54399d410 = 60000;
const $68fb5a78014bcfe7$export$f3ffe700be354b19 = 10000;
const $68fb5a78014bcfe7$export$293647e7865520c6 = 30000;
const $68fb5a78014bcfe7$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $68fb5a78014bcfe7$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $3003b661a087a867$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $de576c4d1becc778$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $7c375ae106b964be$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $7c375ae106b964be$export$a002182e51710d39).OPENID_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $7c375ae106b964be$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None,
            tenant: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false,
        encodeExtraQueryParams: false,
        verifySSO: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        cacheRetentionDays: 5,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $d21eb39178ebb5ae$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $f210e947e17010a2$export$4c206ef5be879972)() : (0, $04922ae8364b32fe$export$6d95060a8ed7155a),
        navigationClient: new (0, $cb0bb957d18a08cc$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $68fb5a78014bcfe7$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $68fb5a78014bcfe7$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowPlatformBroker: false,
        allowPlatformBrokerWithDOM: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $68fb5a78014bcfe7$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && providedSystemOptions?.allowPlatformBroker) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).cannotAllowPlatformBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/* eslint-disable header/header */ const $183cce12cb16965c$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $183cce12cb16965c$export$83d89fbfd8236492 = "4.30.0";



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6e97899b5d45c1c1$export$8a682ae47622dbb9 = "msal";
const $6e97899b5d45c1c1$var$BROWSER_PREFIX = "browser";
const $6e97899b5d45c1c1$export$9e9532f57bbb139e = "|";
const $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d = 2;
const $6e97899b5d45c1c1$export$4693794d1f911b27 = 2;
const $6e97899b5d45c1c1$export$b28668d53eb57e63 = `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${$6e97899b5d45c1c1$var$BROWSER_PREFIX}.log.level`;
const $6e97899b5d45c1c1$export$d9bc1c202a3825f1 = `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${$6e97899b5d45c1c1$var$BROWSER_PREFIX}.log.pii`;
const $6e97899b5d45c1c1$export$54408f0b0cf727d4 = `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${$6e97899b5d45c1c1$var$BROWSER_PREFIX}.performance.enabled`;
const $6e97899b5d45c1c1$export$6825ebfedde34998 = `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.version`;
const $6e97899b5d45c1c1$export$55a9047ed9cd2b03 = "account.keys";
const $6e97899b5d45c1c1$export$332974f1fffb359a = "token.keys";
function $6e97899b5d45c1c1$export$8cef587ddea5c5f6(schema = $6e97899b5d45c1c1$export$4693794d1f911b27) {
    if (schema < 1) return `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${$6e97899b5d45c1c1$export$55a9047ed9cd2b03}`;
    return `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${schema}.${$6e97899b5d45c1c1$export$55a9047ed9cd2b03}`;
}
function $6e97899b5d45c1c1$export$79944bbef1910535(clientId, schema = $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d) {
    if (schema < 1) return `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${$6e97899b5d45c1c1$export$332974f1fffb359a}.${clientId}`;
    return `${$6e97899b5d45c1c1$export$8a682ae47622dbb9}.${schema}.${$6e97899b5d45c1c1$export$332974f1fffb359a}.${clientId}`;
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $277b893ea3b41414$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $0bf1d54ef751a29c$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $68fb5a78014bcfe7$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $6e97899b5d45c1c1$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $6e97899b5d45c1c1$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $0bf1d54ef751a29c$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $0bf1d54ef751a29c$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $277b893ea3b41414$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions, (0, $183cce12cb16965c$export$a8ff84c12d48cfa6), (0, $183cce12cb16965c$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $067e966d84ac4206$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $ca5905c77ac1cd45$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.splice($ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $ca5905c77ac1cd45$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $ca5905c77ac1cd45$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $ca5905c77ac1cd45$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $ca5905c77ac1cd45$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$ca5905c77ac1cd45$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $769cd552162fdff8$export$a2170d4e3f010950 extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $769cd552162fdff8$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $ca5905c77ac1cd45$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $769cd552162fdff8$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $36cb4f619f94d121$export$f39c23bbfed89e6e extends (0, $277b893ea3b41414$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $36cb4f619f94d121$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $36cb4f619f94d121$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $449d8ba978713aa9$export$e2ac717a196f20ed = "missing_kid_error";
const $449d8ba978713aa9$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3953c3c36cc43bcf$export$ce96a12d056376ad = {
    [(0, $449d8ba978713aa9$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $449d8ba978713aa9$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $3953c3c36cc43bcf$export$980ad46b7a115fad extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $3953c3c36cc43bcf$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $3953c3c36cc43bcf$export$3ef463ea134172ed(code) {
    return new $3953c3c36cc43bcf$export$980ad46b7a115fad(code, $3953c3c36cc43bcf$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $3c3d586eea595f5f$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $3953c3c36cc43bcf$export$3ef463ea134172ed)((0, $449d8ba978713aa9$export$de67390d0a514010));
        const shrHeader = new $3c3d586eea595f5f$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $7c375ae106b964be$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}






/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $f0fb072e99d60057$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565);
        this.version = (0, $5ff55562d73e0e2b$export$6a9022b4c5fcea02);
        this.tableName = (0, $5ff55562d73e0e2b$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $5ff55562d73e0e2b$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6be83965311b144c$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $9f41ba1b3e22ed80$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $f0fb072e99d60057$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $4e0948336b4ea4a7$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $9f41ba1b3e22ed80$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $6f6986007da7f422$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $581fd3df606755c8$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $4e0948336b4ea4a7$export$a949d36eab55b41f)($e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $4e0948336b4ea4a7$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        if (keyFound) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).bindingKeyNotRemoved);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $4e0948336b4ea4a7$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $e72c2cdc5fe24d6f$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $3c3d586eea595f5f$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $6f6986007da7f422$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $4e0948336b4ea4a7$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(plainText);
    }
}
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$e72c2cdc5fe24d6f$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $e72c2cdc5fe24d6f$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $df7cbba4fa13e524$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f7e197739ae81767$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $0c23eec3b11a3e26$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 

/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5386add07ebe4b6d$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $43ad213520b7a7a8$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $7c375ae106b964be$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).SUCCESS) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).BAD_REQUEST) {
                    const currentIMDSVersion = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $7c375ae106b964be$export$2b71909294c66558).SUCCESS) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $7c375ae106b964be$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $7c375ae106b964be$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $7c375ae106b964be$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $7c375ae106b964be$export$2b71909294c66558).BAD_REQUEST && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$43ad213520b7a7a8$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};





var $9ab3d26df56b176d$exports = {};

$parcel$export($9ab3d26df56b176d$exports, "createIdTokenEntity", () => $9ab3d26df56b176d$export$d8a173a23f325769);
$parcel$export($9ab3d26df56b176d$exports, "createAccessTokenEntity", () => $9ab3d26df56b176d$export$fa005e75d915b6db);
$parcel$export($9ab3d26df56b176d$exports, "createRefreshTokenEntity", () => $9ab3d26df56b176d$export$9095b5885dfa55cc);
$parcel$export($9ab3d26df56b176d$exports, "isCredentialEntity", () => $9ab3d26df56b176d$export$b8fc93e8af17dc04);
$parcel$export($9ab3d26df56b176d$exports, "isAccessTokenEntity", () => $9ab3d26df56b176d$export$d7e6bcc84cf680df);
$parcel$export($9ab3d26df56b176d$exports, "isIdTokenEntity", () => $9ab3d26df56b176d$export$71eec93d11c94dfc);
$parcel$export($9ab3d26df56b176d$exports, "isRefreshTokenEntity", () => $9ab3d26df56b176d$export$f1bb3af43d5b8bc7);
$parcel$export($9ab3d26df56b176d$exports, "isServerTelemetryEntity", () => $9ab3d26df56b176d$export$7ad16989078344e5);
$parcel$export($9ab3d26df56b176d$exports, "isThrottlingEntity", () => $9ab3d26df56b176d$export$7e43cc7efaf4bec2);
$parcel$export($9ab3d26df56b176d$exports, "generateAppMetadataKey", () => $9ab3d26df56b176d$export$ddbc6773ab812685);
$parcel$export($9ab3d26df56b176d$exports, "isAppMetadataEntity", () => $9ab3d26df56b176d$export$bb2a01b66d0b3486);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataEntity", () => $9ab3d26df56b176d$export$6231cab310116b3c);
$parcel$export($9ab3d26df56b176d$exports, "generateAuthorityMetadataExpiresAt", () => $9ab3d26df56b176d$export$90f464c4238c27e5);
$parcel$export($9ab3d26df56b176d$exports, "updateAuthorityEndpointMetadata", () => $9ab3d26df56b176d$export$ef87e8fbd8af5f96);
$parcel$export($9ab3d26df56b176d$exports, "updateCloudDiscoveryMetadata", () => $9ab3d26df56b176d$export$6d4972e1d88c8518);
$parcel$export($9ab3d26df56b176d$exports, "isAuthorityMetadataExpired", () => $9ab3d26df56b176d$export$b96839cf63a15b0f);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 


var $0a4a8f22735f9ff5$exports = {};

$parcel$export($0a4a8f22735f9ff5$exports, "nowSeconds", () => $0a4a8f22735f9ff5$export$ae62599a119ac50a);
$parcel$export($0a4a8f22735f9ff5$exports, "toSecondsFromDate", () => $0a4a8f22735f9ff5$export$13bf6a15fb02e52d);
$parcel$export($0a4a8f22735f9ff5$exports, "toDateFromSeconds", () => $0a4a8f22735f9ff5$export$dcee164673849555);
$parcel$export($0a4a8f22735f9ff5$exports, "isTokenExpired", () => $0a4a8f22735f9ff5$export$b007d77a962aa175);
$parcel$export($0a4a8f22735f9ff5$exports, "isCacheExpired", () => $0a4a8f22735f9ff5$export$d812b641f1458de4);
$parcel$export($0a4a8f22735f9ff5$exports, "wasClockTurnedBack", () => $0a4a8f22735f9ff5$export$8961be72dcbc368e);
$parcel$export($0a4a8f22735f9ff5$exports, "delay", () => $0a4a8f22735f9ff5$export$1391212d75b2ee65);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $0a4a8f22735f9ff5$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $0a4a8f22735f9ff5$export$13bf6a15fb02e52d(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $0a4a8f22735f9ff5$export$dcee164673849555(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $0a4a8f22735f9ff5$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $0a4a8f22735f9ff5$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function $0a4a8f22735f9ff5$export$d812b641f1458de4(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $0a4a8f22735f9ff5$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $0a4a8f22735f9ff5$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $0a4a8f22735f9ff5$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $9ab3d26df56b176d$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $7c375ae106b964be$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ab3d26df56b176d$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $9ab3d26df56b176d$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $9ab3d26df56b176d$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $9ab3d26df56b176d$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $7c375ae106b964be$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ab3d26df56b176d$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $7c375ae106b964be$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $9ab3d26df56b176d$export$90f464c4238c27e5() {
    return (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)() + (0, $7c375ae106b964be$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $9ab3d26df56b176d$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $9ab3d26df56b176d$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $9ab3d26df56b176d$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $77bb430f4568f6e8$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $43ad213520b7a7a8$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $70363054a03152f4$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $7c375ae106b964be$export$a002182e51710d39).ADFS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Adfs;
            case (0, $7c375ae106b964be$export$a002182e51710d39).DSTS:
                return (0, $70363054a03152f4$export$cd82032b224a3839).Dsts;
        }
        return (0, $70363054a03152f4$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $70363054a03152f4$export$cd82032b224a3839).Default && this.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Adfs || this.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $9ab3d26df56b176d$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $9ab3d26df56b176d$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $9ab3d26df56b176d$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $df7cbba4fa13e524$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $ff4bd32e3511744b$export$f612854287391207)) return (0, $ff4bd32e3511744b$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $7c375ae106b964be$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $7c375ae106b964be$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $ff4bd32e3511744b$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $9ab3d26df56b176d$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $7c375ae106b964be$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $9ab3d26df56b176d$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $7c375ae106b964be$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $70363054a03152f4$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $f7e197739ae81767$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $0c23eec3b11a3e26$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $7c375ae106b964be$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $ff4bd32e3511744b$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $399fa9610e7cb0fb$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $7c375ae106b964be$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $ff4bd32e3511744b$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $7c375ae106b964be$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $7c375ae106b964be$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $f7f911f196324278$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $77bb430f4568f6e8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $7c375ae106b964be$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$77bb430f4568f6e8$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON,
    (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS,
    (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $77bb430f4568f6e8$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $7c375ae106b964be$export$e18ac120172ed505).COMMON:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $7c375ae106b964be$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $77bb430f4568f6e8$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $7c375ae106b964be$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $77bb430f4568f6e8$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $77bb430f4568f6e8$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $762faca86a0f7942$export$2daa8cfcf54c2b48(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.tokenBodyParameters?.clientId
    };
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 





/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $bccaa1af695c1c1d$export$b18f4dec3e412d34 = {
    Lax: "Lax",
    None: "None"
};
class $bccaa1af695c1c1d$export$dae7d845015939d5 {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = `${encodeURIComponent(key)}`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i];
            const [key, ...rest] = decodeURIComponent(cookie).trim().split("=");
            const value = rest.join("=");
            if (key === name) return value;
        }
        return "";
    }
    getUserData() {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).methodNotImplemented);
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $bccaa1af695c1c1d$export$b18f4dec3e412d34.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $bccaa1af695c1c1d$export$b18f4dec3e412d34.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData() {
        return Promise.reject((0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).methodNotImplemented));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const cookieParts = decodeURIComponent(cookie).trim().split("=");
            keys.push(cookieParts[0]);
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $bccaa1af695c1c1d$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $bccaa1af695c1c1d$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $2ca05ea7e59555fe$export$beb6809f8bbb3df6(storage, schemaVersion) {
    const accountKeys = storage.getItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $2ca05ea7e59555fe$export$ee837b3b857e6cf8(clientId, storage, schemaVersion) {
    const item = storage.getItem((0, $6e97899b5d45c1c1$export$79944bbef1910535)(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $4f742cf6a25ffee9$export$691b4523c5340423(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fc08fc8f06eda9dc$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $fc08fc8f06eda9dc$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.cache";
class $fc08fc8f06eda9dc$export$19fffca37ef3e106 {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
        this.memoryStorage = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($fc08fc8f06eda9dc$var$BROADCAST_CHANNEL_NAME);
    }
    async initialize(correlationId) {
        const cookies = new (0, $bccaa1af695c1c1d$export$dae7d845015939d5)();
        const cookieString = cookies.getItem($fc08fc8f06eda9dc$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $581fd3df606755c8$export$8f0c237d3e8188bc), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Base64Decode, this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5a71d4e3178f19c4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
            const baseKey = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$1222fa1cada87c76), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateBaseKey, this.logger, this.performanceClient, correlationId)();
            const keyStr = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $6f6986007da7f422$export$84f5a428c7153a69), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UrlEncodeArr, this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5a71d4e3178f19c4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($fc08fc8f06eda9dc$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, (0, $bccaa1af695c1c1d$export$b18f4dec3e412d34).None // SameSite must be None to support iframed apps
            );
        }
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.importExistingCache.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).ImportExistingCache, this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", this.updateCache.bind(this));
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$e85a0c9a1067c5d3), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$436657cdcd7fe2be));
        if (kmsi) this.setItem(key, value);
        else {
            const { data: data, nonce: nonce } = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$5b0f6292f11d1d18), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Encrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith((0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys));
        else this.removeItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)());
        const tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem((0, $6e97899b5d45c1c1$export$79944bbef1910535)(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem((0, $6e97899b5d45c1c1$export$79944bbef1910535)(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!(0, $4f742cf6a25ffee9$export$691b4523c5340423)(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$e85a0c9a1067c5d3), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event) {
        this.logger.trace("Updating internal cache from broadcast event");
        const perfMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).LocalStorageUpdated);
        perfMeasurement.add({
            isBackground: true
        });
        const { key: key, value: value, context: context } = event.data;
        if (!key) {
            this.logger.error("Broadcast event missing key");
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`Ignoring broadcast event from clientId: ${context}`);
            perfMeasurement.end({
                success: false,
                errorCode: "contextMismatch"
            });
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("Removed item from internal cache");
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("Updated item in internal cache");
        }
        perfMeasurement.end({
            success: true
        });
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $514a2dc2ad0988f3$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $d12a658e6d92d79e$export$176bd5050947ba0c)((0, $b7c9daf3e548a083$export$41d7a3d4e14d6113));
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}










/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function $5f053cdf68181154$export$f6b67b4ecd4149d9(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $d3981d5134d5331a$export$44d7291b5c8cc149 extends (0, $0c353f04031c78df$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $6be83965311b144c$export$d7392285c701ecf5)();
        this.browserStorage = $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheConfig.temporaryCacheLocation, logger, performanceClient);
        this.cookieStorage = new (0, $bccaa1af695c1c1d$export$dae7d845015939d5)();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage);
        let tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < (0, $6e97899b5d45c1c1$export$4693794d1f911b27); i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage);
        tokenKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return null;
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ((0, $0a4a8f22735f9ff5$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            this.performanceClient.incrementFields({
                expiredCacheRemovedCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = (0, $4f742cf6a25ffee9$export$691b4523c5340423)(parsedValue) ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData || !(0, $9ab3d26df56b176d$exports).isCredentialEntity(decryptedData)) {
            this.performanceClient.incrementFields({
                invalidCacheCount: 1
            }, correlationId);
            return null;
        }
        if (((0, $9ab3d26df56b176d$exports).isAccessTokenEntity(decryptedData) || (0, $9ab3d26df56b176d$exports).isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && (0, $0a4a8f22735f9ff5$exports).isTokenExpired(decryptedData.expiresOn, (0, $7c375ae106b964be$export$8d50f42618161d1a))) {
            this.browserStorage.removeItem(key);
            this.performanceClient.incrementFields({
                expiredCacheRemovedCount: 1
            }, correlationId);
            return null;
        }
        return decryptedData;
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ((0, $0a4a8f22735f9ff5$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = (0, $4f742cf6a25ffee9$export$691b4523c5340423)(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.performanceClient.incrementFields({
            expiredAcntRemovedCount: 1
        }, correlationId);
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(idToken.secret, (0, $581fd3df606755c8$export$c62426fdd000a97e));
                if (claims) kmsiMap[idToken.homeAccountId] = (0, $b29e27fb146a7ddd$exports).isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d));
        const currentAccountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage);
        const previousAccountKeys = (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(idTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && (0, $4f742cf6a25ffee9$export$691b4523c5340423)(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(oldSchemaData.secret, (0, $581fd3df606755c8$export$c62426fdd000a97e));
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys((0, $b29e27fb146a7ddd$exports).extractTokenClaims(currentIdToken.secret, (0, $581fd3df606755c8$export$c62426fdd000a97e)) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(account.homeAccountId, account.localAccountId, tenantId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey((0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(account));
                const kmsi = (0, $b29e27fb146a7ddd$exports).isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d));
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(accessTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!Object.keys(kmsiMap).includes(oldSchemaData.homeAccountId)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d));
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(refreshTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $5f053cdf68181154$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!Object.keys(kmsiMap).includes(oldSchemaData.homeAccountId)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem((0, $6e97899b5d45c1c1$export$6825ebfedde34998));
        if (previousVersion) {
            this.logger.info(`MSAL.js was last initialized by version: ${previousVersion}`);
            this.performanceClient.addFields({
                previousLibraryVersion: previousVersion
            }, correlationId);
        }
        if (previousVersion !== (0, $183cce12cb16965c$export$83d89fbfd8236492)) this.setItem((0, $6e97899b5d45c1c1$export$6825ebfedde34998), (0, $183cce12cb16965c$export$83d89fbfd8236492), correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array((0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $531f2a6dee41cfa4$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $d0300807e9c5c64e$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); i++)if (key === (0, $6e97899b5d45c1c1$export$79944bbef1910535)(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array((0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $531f2a6dee41cfa4$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $d0300807e9c5c64e$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d); i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $d6acc4a6126921e0$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) return null;
        this.performanceClient.addFields({
            accountCachedBy: (0, $5ff55562d73e0e2b$export$970e8382081b483f)(parsedAccount.cachedByApiId)
        }, correlationId);
        return (0, $0c353f04031c78df$export$996e3ea69314b5c6).toObject(new (0, $d6acc4a6126921e0$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi, apiId) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = this.generateAccountKey((0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        account.cachedByApiId = apiId;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        const wasAdded = this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGIN event
         */ if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage && wasAdded) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, (0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(account));
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return (0, $2ca05ea7e59555fe$export$beb6809f8bbb3df6)(this.browserStorage);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = (0, $6e97899b5d45c1c1$export$4693794d1f911b27)) {
        if (accountKeys.length === 0) this.removeItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)(schemaVersion));
        else this.setItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $6e97899b5d45c1c1$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
            return true;
        } else {
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGOUT event
         */ if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, account);
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("idToken removed from tokenKeys map");
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d)) {
        this.logger.trace("removeAccessTokenKey called");
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`removed ${keysRemoved} accessToken keys from tokenKeys map`);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("refreshToken removed from tokenKeys map");
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d)) {
        return (0, $2ca05ea7e59555fe$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Stores the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = (0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d)) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem((0, $6e97899b5d45c1c1$export$79944bbef1910535)(this.clientId, schemaVersion));
            return;
        } else this.setItem((0, $6e97899b5d45c1c1$export$79944bbef1910535)(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $9ab3d26df56b176d$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $9ab3d26df56b176d$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = this.generateCredentialKey(accessToken);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`access token ${index === -1 ? "added to" : "updated in"} map`);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $9ab3d26df56b176d$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $9ab3d26df56b176d$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $9ab3d26df56b176d$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $9ab3d26df56b176d$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $9ab3d26df56b176d$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $5ff55562d73e0e2b$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters found");
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, $7c375ae106b964be$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId,
                lastUpdatedAt: (0, $0a4a8f22735f9ff5$exports).nowSeconds().toString()
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $9ab3d26df56b176d$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.cookieStorage.getItem(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.cookieStorage.setItem(key, value, undefined, this.cacheConfig.secureCookies);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.cookieStorage.removeItem(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ clearTokensAndKeysWithClaims(correlationId) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        let removedAccessTokens = 0;
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key, correlationId);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) {
                this.removeAccessToken(key, correlationId);
                removedAccessTokens++;
            }
        });
        // warn if any access tokens are removed
        if (removedAccessTokens > 0) this.logger.warning(`${removedAccessTokens} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ((0, $442eacaa0418a38d$export$ecc754f99843e759).startsWith(key, (0, $6e97899b5d45c1c1$export$8a682ae47622dbb9))) return key;
        return `${0, $6e97899b5d45c1c1$export$8a682ae47622dbb9}.${this.clientId}.${key}`;
    }
    /**
     * Cache Key: msal.<schema_version>-<home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
     * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
     * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
     * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
     * @param credentialEntity
     * @returns
     */ generateCredentialKey(credential) {
        const familyId = credential.credentialType === (0, $7c375ae106b964be$export$eca2dc7e6e608a68).REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${(0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)}.${(0, $6e97899b5d45c1c1$export$ec2ec5cd3d01f05d)}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            credential.requestedClaimsHash || "",
            scheme
        ];
        return credentialKey.join((0, $6e97899b5d45c1c1$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${(0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)}.${(0, $6e97899b5d45c1c1$export$4693794d1f911b27)}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join((0, $6e97899b5d45c1c1$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache() {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    cacheAuthorizeRequest(authCodeRequest, codeVerifier) {
        this.logger.trace("BrowserCacheManager.cacheAuthorizeRequest called");
        const encodedValue = (0, $6f6986007da7f422$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = (0, $6f6986007da7f422$export$e510a73ee562749)(codeVerifier);
            this.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest() {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8b51939fb2aab3d7));
        const encodedVerifier = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).VERIFIER, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse((0, $581fd3df606755c8$export$c62426fdd000a97e)(encodedTokenRequest));
            if (encodedVerifier) verifier = (0, $581fd3df606755c8$export$c62426fdd000a97e)(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f3ae24cdfaab4488));
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error(`Cannot parse interaction status. Removing temporary cache items and clearing url hash. Retrying interaction should fix the error`);
            this.removeTemporaryItem(key);
            this.resetRequestCache();
            (0, $3003b661a087a867$export$a20c3032ba81d6aa)(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $6e97899b5d45c1c1$export$8a682ae47622dbb9)}.${(0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? (0, $0a4a8f22735f9ff5$exports).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, $0a4a8f22735f9ff5$exports).toSecondsFromDate(result.extExpiresOn) : 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi((0, $b29e27fb146a7ddd$exports).extractTokenClaims(result.idToken, (0, $581fd3df606755c8$export$c62426fdd000a97e))), (0, $5ff55562d73e0e2b$export$192d74ad69b40705).hydrateCache);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache);
        } catch (e) {
            if (e instanceof (0, $531f2a6dee41cfa4$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $d3981d5134d5331a$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage:
                return new (0, $fc08fc8f06eda9dc$export$19fffca37ef3e106)(clientId, logger, performanceClient);
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).SessionStorage:
                return new (0, $514a2dc2ad0988f3$export$2c4b17e1c2e0931)();
            case (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e);
    }
    return new (0, $6be83965311b144c$export$d7392285c701ecf5)();
}
const $d3981d5134d5331a$export$8e2d54002f8f6e5d = (clientId, logger, performanceClient, eventHandler)=>{
    const cacheOptions = {
        cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        cacheRetentionDays: 5,
        temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $d3981d5134d5331a$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $dd88ab1a0b4d3851$export$865f57d401606752), logger, performanceClient, eventHandler);
};


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $807e525bbe19e865$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter || {}, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $807e525bbe19e865$export$4f9234baf34abd0(accountFilter, logger, browserStorage, correlationId) {
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d915baf55d86927d(username, logger, browserStorage, correlationId) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $807e525bbe19e865$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $807e525bbe19e865$export$c55c3d25cf1bcd99(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $807e525bbe19e865$export$13dd2e33a23839ad(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}





/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9f61ab73b66f619a$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $9f61ab73b66f619a$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)({});
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($9f61ab73b66f619a$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $3003b661a087a867$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            timestamp: Date.now()
        };
        switch(eventType){
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_ADDED:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACCOUNT_REMOVED:
            case (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
                break;
            default:
                // Emit event to callbacks registered in this instance
                this.invokeCallbacks(message);
                break;
        }
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`Emitting event to callback ${callbackId}: ${message.eventType}`);
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 



/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $feda987e240ac148$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};





var $ef8a264971d8166d$exports = {};

$parcel$export($ef8a264971d8166d$exports, "createDiscoveredInstance", () => $ef8a264971d8166d$export$ab9db5e7e572e7da);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $ef8a264971d8166d$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $77bb430f4568f6e8$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c9fcc93738cc2bc3));
    }
}



/*! @azure/msal-common v15.17.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $016e46db2c2afa86$export$ea52035eac03daf0 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $016e46db2c2afa86$export$ea52035eac03daf0.prototype);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $38fc8bee021018e9$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $7c375ae106b964be$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($38fc8bee021018e9$export$c060a619741dd765.checkResponseStatus(response) || $38fc8bee021018e9$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $38fc8bee021018e9$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($38fc8bee021018e9$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $7c375ae106b964be$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $7c375ae106b964be$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $3b13384e79a725db$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $d21eb39178ebb5ae$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(this.config.loggerOptions, (0, $4c1e49235f95193e$export$a8ff84c12d48cfa6), (0, $4c1e49235f95193e$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $7c375ae106b964be$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                headers[(0, $7c375ae106b964be$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $38fc8bee021018e9$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint, correlationId);
        let response;
        try {
            response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $01c2dbbf2115e471$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $7c375ae106b964be$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) throw e;
            else throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4358cbadf08aa73));
        }
        (0, $38fc8bee021018e9$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response, correlationId);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $ef8a264971d8166d$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameters = new Map();
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenQueryParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenQueryParameters);
        (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, request.correlationId);
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
}







/*! @azure/msal-common v15.17.0 2026-03-18 */ 




/*! @azure/msal-common v15.17.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $18d0dfe50b7b79f1$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $18d0dfe50b7b79f1$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$c39e501a22cba395));
        if (!state) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $7c375ae106b964be$export$a002182e51710d39).RESOURCE_DELIM) : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b));
        }
    }
}



/*! @azure/msal-common v15.17.0 2026-03-18 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $942a44945e07e21d$var$KeyLocation = {
    SW: "sw"
};
/** @internal */ class $942a44945e07e21d$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $942a44945e07e21d$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $f7f911f196324278$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $a01edd09af59ca7b$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $4039fad97bcf28f6$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $7c375ae106b964be$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, apiId, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
                (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $a01edd09af59ca7b$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const cachedAccounts = this.cacheStorage.getAllAccounts({
                    homeAccountId: cacheRecord.account.homeAccountId,
                    environment: cacheRecord.account.environment
                }, request.correlationId);
                if (cachedAccounts.length < 1) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    this.performanceClient?.addFields({
                        acntLoggedOut: true
                    }, request.correlationId);
                    return await $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, (0, $b29e27fb146a7ddd$export$9475d607926d7a45)(idTokenClaims || {}), apiId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $4039fad97bcf28f6$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$dedc648643245fa1));
        const claimsTenantId = (0, $da8f9f8eb56c5a02$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $9ab3d26df56b176d$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $4039fad97bcf28f6$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $9ab3d26df56b176d$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
                this.performanceClient?.addFields({
                    ntwkRtExpiresOnSeconds: rtExpiresOn
                }, request.correlationId);
            }
            cachedRefreshToken = (0, $9ab3d26df56b176d$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = (0, $0a4a8f22735f9ff5$export$dcee164673849555)(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $7c375ae106b964be$export$978fe7ab5e74b539) ? (0, $7c375ae106b964be$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $54830df9a5d9a12c$export$452a054c78b83dad)((0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $4039fad97bcf28f6$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey, correlationId);
    const baseAccount = cachedAccount || (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}












/*! @azure/msal-common v15.17.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $e4969f34ccbe14ce$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $7e4376d17ecbf639$export$8538731fd397fb90 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     * @param apiId - API identifier for telemetry tracking
     */ async acquireToken(request, apiId, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$7a02f9bdce79dd4e));
        } else // Validate and include redirect uri
        (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        (0, $7d3a00eb36d325b3$export$ff027aab2d77a49c)(parameters, request.code);
        // Add library metadata
        (0, $7d3a00eb36d325b3$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $7d3a00eb36d325b3$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $7d3a00eb36d325b3$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) (0, $7d3a00eb36d325b3$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) (0, $7d3a00eb36d325b3$export$dceb49e3b4703cbb)(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) (0, $7d3a00eb36d325b3$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $7d3a00eb36d325b3$export$2d3d772920e2496e)(parameters, await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $7d3a00eb36d325b3$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        (0, $7d3a00eb36d325b3$export$e5f700fdeb4022b2)(parameters, (0, $7c375ae106b964be$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $7d3a00eb36d325b3$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $7d3a00eb36d325b3$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $7aacd5d6e6d7482c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $7c375ae106b964be$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $b00a7f221d8fdf60$export$f58b98a40c1faa68])) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, {
            [(0, $b00a7f221d8fdf60$export$f58b98a40c1faa68)]: "1"
        });
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047)) ? undefined : this.config.authOptions.clientCapabilities;
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || configClaims && configClaims.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, configClaims);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) (0, $7d3a00eb36d325b3$export$bb8081db67b059c0)(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, request.correlationId);
        if (request.idTokenHint) (0, $7d3a00eb36d325b3$export$c6f34f6f67740950)(parameters, request.idTokenHint);
        if (request.state) (0, $7d3a00eb36d325b3$export$4a8b8c14090dd065)(parameters, request.state);
        if (request.logoutHint) (0, $7d3a00eb36d325b3$export$e0d4676d7288bded)(parameters, request.logoutHint);
        if (request.extraQueryParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) (0, $7d3a00eb36d325b3$export$50b40dfb1d11b77a)(parameters);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters, this.config.authOptions.encodeExtraQueryParams, request.extraQueryParameters);
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ /*! @azure/msal-common v15.17.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9c3cb45936be6b04$var$skuGroupSeparator = ",";
const $9c3cb45936be6b04$var$skuValueSeparator = "|";
function $9c3cb45936be6b04$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($9c3cb45936be6b04$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$9c3cb45936be6b04$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $9c3cb45936be6b04$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($9c3cb45936be6b04$var$skuGroupSeparator);
}
function $9c3cb45936be6b04$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($9c3cb45936be6b04$var$skuValueSeparator);
}
/** @internal */ class $9c3cb45936be6b04$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $7c375ae106b964be$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $7c375ae106b964be$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $9c3cb45936be6b04$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $7c375ae106b964be$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $9c3cb45936be6b04$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cf81b85efeb3dcd5$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU, (0, $183cce12cb16965c$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(correlationId, account) {
        if (account) // Clear given account.
        try {
            this.browserStorage.removeAccount(account, correlationId);
            this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
        } catch (error) {
            this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
        }
        else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            this.browserStorage.clear(correlationId);
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $f7f911f196324278$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $ef8a264971d8166d$exports).createDiscoveredInstance, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).authorityMismatch);
        return discoveredAuthority;
    }
}






/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $550ae9dc1dae1add$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $4e0948336b4ea4a7$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $550ae9dc1dae1add$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($550ae9dc1dae1add$export$8e461fcf1fd6910b, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function $550ae9dc1dae1add$export$253b550f4555e4bf(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) {
        // Don't override httpMethod if it is already set, default to POST if not set
        httpMethod = requestMethod || (0, $7c375ae106b964be$export$8343e6f32f5246de).POST;
        // Validate that method is not GET if protocol mode is EAR
        if (httpMethod !== (0, $7c375ae106b964be$export$8343e6f32f5246de).POST) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).invalidRequestMethodForEAR);
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || (0, $7c375ae106b964be$export$8343e6f32f5246de).GET;
    // Regardless of protocolMode, if there are authorizePostBodyParameters, validate the request method is POST
    if (interactionRequest.authorizePostBodyParameters && httpMethod !== (0, $7c375ae106b964be$export$8343e6f32f5246de).POST) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).invalidAuthorizePostBodyParameters);
    return httpMethod;
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $5d00224fcf1f9e62$export$fa9179cade3eb05a extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl((0, $3003b661a087a867$export$1204531fbbf6ecde)(), (0, $3003b661a087a867$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $7e4376d17ecbf639$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = params.authority || await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $183cce12cb16965c$export$83d89fbfd8236492),
                cpu: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        if (new URL(redirectUri).origin !== new URL(window.location.href).origin) {
            this.logger.warning("The origin of the redirect URI does not match the origin of the current page. This is likely to cause issues with authentication.", this.correlationId);
            this.performanceClient.addFields({
                isRedirectUriCrossOrigin: true
            }, this.correlationId);
        }
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const interactionRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        const validatedRequest = {
            ...interactionRequest,
            httpMethod: (0, $550ae9dc1dae1add$export$253b550f4555e4bf)(interactionRequest, this.config.auth.protocolMode)
        };
        // Skip active account lookup if either login hint or session id is set
        if (request.loginHint || request.sid) return validatedRequest;
        const account = request.account || this.browserStorage.getActiveAccount(this.correlationId);
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        return validatedRequest;
    }
}






/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $6ec519bc7bf28780$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).invalidState);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c7efd3c039fd7d9$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $0763983a1d35c4b8$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $9c7efd3c039fd7d9$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
    const platformStateObj = (0, $6ec519bc7bf28780$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$499b1b95c97a1c75));
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ var $bfa307c523b8b81c$exports = {};

$parcel$export($bfa307c523b8b81c$exports, "getStandardAuthorizeRequestParameters", () => $bfa307c523b8b81c$export$61cf790f71e46219);
$parcel$export($bfa307c523b8b81c$exports, "getAuthorizeUrl", () => $bfa307c523b8b81c$export$e397eb426c115a0a);
$parcel$export($bfa307c523b8b81c$exports, "getAuthorizationCodePayload", () => $bfa307c523b8b81c$export$36c64a7d10cf377b);
$parcel$export($bfa307c523b8b81c$exports, "validateAuthorizationResponse", () => $bfa307c523b8b81c$export$9979de10627480c5);
/*! @azure/msal-common v15.17.0 2026-03-18 */ 









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ function $bfa307c523b8b81c$export$61cf790f71e46219(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraQueryParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, requestScopes, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
    (0, $7d3a00eb36d325b3$export$8a224ff809946e9c)(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    (0, $7d3a00eb36d325b3$export$f1c153626c2c2d91)(parameters, request.responseMode);
    // add client_info=1
    (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
    // add clidata=1
    (0, $7d3a00eb36d325b3$export$5a0058be0b2fe3ea)(parameters);
    if (request.prompt) {
        (0, $7d3a00eb36d325b3$export$e982ccd37a61cde6)(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        (0, $7d3a00eb36d325b3$export$1bd007a9d7fec290)(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
            // SessionID is only used in silent calls
            logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
            (0, $7d3a00eb36d325b3$export$9d8531b0fa366b30)(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $bfa307c523b8b81c$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $bfa307c523b8b81c$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (accountSid && request.prompt === (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                (0, $7d3a00eb36d325b3$export$9d8531b0fa366b30)(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (request.loginHint) {
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.loginHint);
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            }
        } else if (request.loginHint) {
            logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
            (0, $7d3a00eb36d325b3$export$65f43fd4b28bba5f)(parameters, request.loginHint);
            (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
    if (request.nonce) (0, $7d3a00eb36d325b3$export$87b1d5d886e84b11)(parameters, request.nonce);
    if (request.state) (0, $7d3a00eb36d325b3$export$4a8b8c14090dd065)(parameters, request.state);
    if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, authOptions.clientId, authOptions.redirectUri);
    // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
    const configClaims = request.skipBrokerClaims && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047)) ? undefined : authOptions.clientCapabilities;
    if (request.claims || configClaims && configClaims.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, configClaims);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes((0, $b00a7f221d8fdf60$export$d72b25d13120919d)))) (0, $7d3a00eb36d325b3$export$50b40dfb1d11b77a)(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 */ function $bfa307c523b8b81c$export$e397eb426c115a0a(authority, requestParameters, encodeParams, extraQueryParameters) {
    const queryString = (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(requestParameters, encodeParams, extraQueryParameters);
    return (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 */ function $bfa307c523b8b81c$export$36c64a7d10cf377b(serverParams, cachedState) {
    // Get code response
    $bfa307c523b8b81c$export$9979de10627480c5(serverParams, cachedState);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$93625fc864d26bba));
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 */ function $bfa307c523b8b81c$export$9979de10627480c5(serverResponse, requestState) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Cached State") : (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$ef9214cfa5960fc), "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$72a77317632c052b), serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$6a56d8f882843cd8));
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $bfa307c523b8b81c$var$parseServerErrorNo(serverResponse);
        if ((0, $18a94acc3dad87ad$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
        throw new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $bfa307c523b8b81c$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $bfa307c523b8b81c$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $bfa307c523b8b81c$var$extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}






/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $e330ed825f42f772$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request, apiId) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = (0, $bfa307c523b8b81c$exports).getAuthorizationCodePayload(response, request.state);
        } catch (e) {
            if (e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.subError === (0, $0780bb28b98eb888$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request, apiId);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, apiId, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, apiId, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 

/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ad0863ed8e4325cb$export$fbe5ac8608048ea9 = "ContentError";
const $ad0863ed8e4325cb$export$9da03c0dbf887a8 = "PageException";
const $ad0863ed8e4325cb$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $2f685d09a8b3d741$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $2f685d09a8b3d741$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $2f685d09a8b3d741$export$3c68b4973c91ba = "NO_NETWORK";
const $2f685d09a8b3d741$export$8cd212c10b4124d2 = "DISABLED";
const $2f685d09a8b3d741$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";
const $2f685d09a8b3d741$export$17f9d85d4c738bc7 = "UX_NOT_ALLOWED";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a5e5dee51df551c2$var$INVALID_METHOD_ERROR = -2147186943;
const $a5e5dee51df551c2$export$9a1233b0d52ed7cd = {
    [(0, $ad0863ed8e4325cb$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $a5e5dee51df551c2$export$4b8a4f6256e840ab extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $a5e5dee51df551c2$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $a5e5dee51df551c2$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && error.ext.status === (0, $2f685d09a8b3d741$export$8cd212c10b4124d2)) return true;
    if (error.ext && error.ext.error && error.ext.error === $a5e5dee51df551c2$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $ad0863ed8e4325cb$export$fbe5ac8608048ea9:
        case 0, $ad0863ed8e4325cb$export$9da03c0dbf887a8:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $a5e5dee51df551c2$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $2f685d09a8b3d741$export$f4c2bddc98c93ffc:
            return (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$exports).nativeAccountUnavailable);
        case 0, $2f685d09a8b3d741$export$e0aac30e542b316c:
            return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(code, description);
        case 0, $2f685d09a8b3d741$export$bec5e49cc27c5c10:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702));
        case 0, $2f685d09a8b3d741$export$3c68b4973c91ba:
            return (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$31ae862f18c3b2b7));
        case 0, $2f685d09a8b3d741$export$17f9d85d4c738bc7:
            return (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$exports).uxNotAllowed);
    }
    return new $a5e5dee51df551c2$export$4b8a4f6256e840ab(code, $a5e5dee51df551c2$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 










'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $da9f8d1ce5c4543c$export$e344f5b12c464597 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $77bb430f4568f6e8$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if ((0, $0a4a8f22735f9ff5$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $7c375ae106b964be$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $7c375ae106b964be$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId, this.performanceClient),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $7c375ae106b964be$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $b29e27fb146a7ddd$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$43356944266c945e));
            (0, $b29e27fb146a7ddd$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $4039fad97bcf28f6$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $5d2b86ff94a0079d$export$59d4f873ee62d01e extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $da9f8d1ce5c4543c$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $6e0b7bb04b1e6592$export$f8eb6760ca13876a) && error.errorCode === (0, $0780bb28b98eb888$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest.correlationId, validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e6f06a03b9c6516d$export$3f89612b3fd8831f extends (0, $cf81b85efeb3dcd5$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = (0, $9c3cb45936be6b04$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $183cce12cb16965c$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $b00a7f221d8fdf60$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) {
                    this.logger.info("MSAL internal Cache does not contain tokens, return error as per cache policy");
                    nativeATMeasurement.end({
                        success: false,
                        brokerErrorCode: "cache_request_failed"
                    });
                    throw e;
                }
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            });
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, this.correlationId);
        if (!account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab)) {
                const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp);
            const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            if (performanceClient && this.correlationId) this.performanceClient.addFields({
                isNativeBroker: true
            }, this.correlationId);
            return authResult;
        } catch (e) {
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("handleNativeServerResponse: Double broker flow detected, ignoring accountId mismatch");
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $a5e5dee51df551c2$export$9154414ec87d187b)((0, $ad0863ed8e4325cb$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $581fd3df606755c8$export$c62426fdd000a97e), this.correlationId, idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount, this.correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(idTokenClaims));
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING, (0, $70363054a03152f4$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(responseScopes) : (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(requestScopes);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $54830df9a5d9a12c$export$452a054c78b83dad)((0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$901491a717da2ba5).POP : (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, correlationId, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi, this.apiId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext((0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(accountEntity), correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const cachedAccessToken = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $581fd3df606755c8$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(idTokenClaims), this.apiId, request.storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === (0, $7c375ae106b964be$export$901491a717da2ba5).POP ? (0, $7c375ae106b964be$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, claims: claims, ...remainingProperties } = request;
        const scopeSet = new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $7c375ae106b964be$export$893b1b5b686d84ef));
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && !!request.embeddedClientId ? undefined : this.config.auth.clientCapabilities;
        const mergedClaims = configClaims && configClaims.length ? (0, $7d3a00eb36d325b3$exports).addClientCapabilitiesToClaims(claims, configClaims) : claims;
        const validatedRequest = {
            ...remainingProperties,
            claims: mergedClaims,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $f7f911f196324278$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent:
            case (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                return (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("initializeNativeRequest: prompt was not provided");
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).SELECT_ACCOUNT:
                this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                return prompt;
            default:
                this.logger.trace(`initializeNativeRequest: prompt = ${prompt} is not compatible with native flow`);
                throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$62fdd8848aa75547));
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $b00a7f221d8fdf60$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $b00a7f221d8fdf60$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $b00a7f221d8fdf60$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $2a64db28ce4fd109$var$clientDataAccountTypeMapping = new Map([
    [
        "e",
        "AAD"
    ],
    [
        "m",
        "MSA"
    ]
]);
/**
 * Parses the clientdata response parameter from the /authorize endpoint.
 *
 * The clientdata value is URL-encoded and pipe-delimited:
 *   urlencoded(account_type | error | sub_error | cloud_instance | caller_data_boundary)
 *
 * @param clientdata - The raw clientdata string from the authorize response
 * @returns Parsed ClientData object, or null if the input is empty/invalid
 */ function $2a64db28ce4fd109$export$a3b9de6fc1cadc0e(clientdata) {
    if (!clientdata) return null;
    try {
        const decoded = decodeURIComponent(clientdata);
        const parts = decoded.split("|");
        if (parts.length < 5) return null;
        return {
            accountType: $2a64db28ce4fd109$var$clientDataAccountTypeMapping.get(parts[0]?.trim() || "") || "",
            error: parts[1]?.trim() || "",
            subError: parts[2]?.trim() || "",
            cloudInstance: parts[3]?.trim() || "",
            callerDataBoundary: parts[4]?.trim() || ""
        };
    } catch  {
        return null;
    }
}
/**
 * Instruments account type, error, and suberror from clientdata
 */ function $2a64db28ce4fd109$var$instrumentClientData(response, correlationId, performanceClient) {
    const parsed = $2a64db28ce4fd109$export$a3b9de6fc1cadc0e(response.clientdata);
    parsed?.accountType && performanceClient.addFields({
        accountType: parsed.accountType
    }, correlationId);
    parsed?.error && performanceClient.addFields({
        serverErrorNo: parsed.error
    }, correlationId);
    parsed?.subError && performanceClient.addFields({
        serverSubErrorNo: parsed.subError
    }, correlationId);
}
/**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = (0, $bfa307c523b8b81c$exports).getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addLibraryInfo(parameters, {
        sku: (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).MSAL_SKU,
        version: (0, $183cce12cb16965c$export$83d89fbfd8236492),
        os: "",
        cpu: ""
    });
    if (config.auth.protocolMode !== (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) (0, $7d3a00eb36d325b3$exports).addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        (0, $7d3a00eb36d325b3$exports).addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const cryptoOps = new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient);
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(cryptoOps);
            // req_cnf is always sent as a string for SPAs
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = cryptoOps.encodeKid(request.popKid);
            (0, $7d3a00eb36d325b3$exports).addPopToken(parameters, reqCnfData);
        }
    }
    (0, $7d3a00eb36d325b3$exports).instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$export$a256231ce8625983(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).pkceParamsMissing);
    const parameters = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$var$getStandardParameters, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetStandardParams, logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addResponseType(parameters, (0, $7c375ae106b964be$export$5ef2b2ebd3da3e04).CODE);
    (0, $7d3a00eb36d325b3$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $7c375ae106b964be$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    (0, $7d3a00eb36d325b3$exports).addExtraQueryParameters(parameters, request.extraQueryParameters || {});
    return (0, $bfa307c523b8b81c$exports).getAuthorizeUrl(authority, parameters, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $2a64db28ce4fd109$export$3c140ef19fa8de34(frame, config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2c031f99d3e081ff));
    const parameters = await $2a64db28ce4fd109$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addResponseType(parameters, (0, $7c375ae106b964be$export$5ef2b2ebd3da3e04).IDTOKEN_TOKEN_REFRESHTOKEN);
    (0, $7d3a00eb36d325b3$exports).addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    (0, $7d3a00eb36d325b3$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $7c375ae106b964be$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    const queryParams = new Map();
    (0, $7d3a00eb36d325b3$exports).addExtraQueryParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, $7d3a00eb36d325b3$exports).addCorrelationId(queryParams, request.correlationId);
    const url = (0, $bfa307c523b8b81c$exports).getAuthorizeUrl(authority, queryParams, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
    return $2a64db28ce4fd109$var$createForm(frame, url, parameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function $2a64db28ce4fd109$export$a76e1509233f1aec(frame, config, authority, request, logger, performanceClient) {
    const parameters = await $2a64db28ce4fd109$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $7d3a00eb36d325b3$exports).addResponseType(parameters, (0, $7c375ae106b964be$export$5ef2b2ebd3da3e04).CODE);
    (0, $7d3a00eb36d325b3$exports).addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || (0, $7c375ae106b964be$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    (0, $7d3a00eb36d325b3$exports).addPostBodyParameters(parameters, request.authorizePostBodyParameters || {});
    const queryParams = new Map();
    (0, $7d3a00eb36d325b3$exports).addExtraQueryParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    (0, $7d3a00eb36d325b3$exports).addCorrelationId(queryParams, request.correlationId);
    const url = (0, $bfa307c523b8b81c$exports).getAuthorizeUrl(authority, queryParams, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
    return $2a64db28ce4fd109$var$createForm(frame, url, parameters);
}
/**
 * Creates form element in the provided document with auth parameters in the post body
 * @param frame
 * @param authorizeUrl
 * @param parameters
 * @returns
 */ function $2a64db28ce4fd109$var$createForm(frame, authorizeUrl, parameters) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = authorizeUrl;
    parameters.forEach((value, key)=>{
        const param = frame.createElement("input");
        param.hidden = true;
        param.name = key;
        param.value = value;
        form.appendChild(param);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $2a64db28ce4fd109$export$51c4d8201b4a42eb(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("Account id found, calling WAM for token");
    if (!platformAuthProvider) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
    const browserCrypto = new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient);
    const nativeInteractionClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = (0, $18d0dfe50b7b79f1$export$871e33217042c65e).parseRequestState(browserCrypto, request.state);
    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $2a64db28ce4fd109$export$907304a743d3578a(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $2a64db28ce4fd109$var$instrumentClientData(response, request.correlationId, performanceClient);
    if (response.accountId) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$export$51c4d8201b4a42eb, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponse, logger, performanceClient, request.correlationId)(response, request, apiId);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $2a64db28ce4fd109$export$21aeb02dac823516(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $38fc8bee021018e9$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $2a64db28ce4fd109$var$instrumentClientData(response, request.correlationId, performanceClient);
    // Validate state & check response for errors
    (0, $bfa307c523b8b81c$exports).validateAuthorizationResponse(response, request.state);
    if (!response.ear_jwe) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$b9f7c47ac4054f3d));
    if (!request.earJwk) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$2c031f99d3e081ff));
    const decryptedData = JSON.parse(await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$13b9c776ab498ef3), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DecryptEarResponse, logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($2a64db28ce4fd109$export$51c4d8201b4a42eb, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(config.auth.clientId, browserStorage, new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(logger, performanceClient), logger, null, null, performanceClient);
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, (0, $0a4a8f22735f9ff5$exports).nowSeconds(), request, apiId, additionalData, undefined, undefined, undefined, undefined);
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $cab7ad26b4a73b7b$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($cab7ad26b4a73b7b$var$generateCodeVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $cab7ad26b4a73b7b$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($cab7ad26b4a73b7b$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $4e0948336b4ea4a7$export$960b9ff25e7d4257), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $6f6986007da7f422$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $cab7ad26b4a73b7b$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$52caff7bddbaf316), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $6f6986007da7f422$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ee549107fa376fc1));
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $baeb759c53a00ffc$export$de4c158ddf8b89f6 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
        this.platformAuthType = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - sendMessage called.");
        // fall back to native calls
        const messageBody = {
            method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: messageBody
        };
        this.logger.trace(this.platformAuthType + " - Sending request to browser extension");
        this.logger.tracePii(this.platformAuthType + ` - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("PlatformAuthExtensionHandler - createProvider called.");
        try {
            const preferredProvider = new $baeb759c53a00ffc$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient, (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $baeb759c53a00ffc$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace(this.platformAuthType + " - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace(this.platformAuthType + " - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(this.platformAuthType + `.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace(this.platformAuthType + " - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(this.platformAuthType + " - Received response from browser extension");
                this.logger.tracePii(this.platformAuthType + ` - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $a5e5dee51df551c2$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $5ff55562d73e0e2b$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(this.platformAuthType + `.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(this.platformAuthType + ` - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $952fbef31257d8ea$export$aa8591dfbb8a4c65 {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("PlatformAuthDOMHandler: createProvider called");
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts((0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes((0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).PLATFORM_DOM_APIS)) {
                logger.trace("Platform auth api available in DOM");
                return new $952fbef31257d8ea$export$aa8591dfbb8a4c65(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return (0, $5ff55562d73e0e2b$export$3ebdf53424883b5f).DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - Sending request to browser DOM API");
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response);
        } catch (e) {
            this.logger.error(this.platformAuthType + " - executeGetToken DOM API error");
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(this.platformAuthType + " - initializeNativeDOMRequest called");
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, storeInCache: storeInCache, embeddedClientId: embeddedClientId, extraParameters: extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            storeInCache: storeInCache,
            embeddedClientId: embeddedClientId
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(this.platformAuthType + " - platform broker returned successful and valid response");
                return this.convertToPlatformBrokerResponse(response);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(this.platformAuthType + " - platform broker returned error response");
                    throw (0, $a5e5dee51df551c2$export$9154414ec87d187b)(errorResponse.error.code, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw (0, $0ff8310393c4d2db$export$eb157f7636c79bd2)((0, $1a08d0bb87f43eeb$exports).unexpectedError, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response) {
        this.logger.trace(this.platformAuthType + " - convertToNativeResponse called");
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters) {
        try {
            const stringifiedProperties = {};
            for (const [key, value] of Object.entries(extraParameters)){
                if (!value) continue;
                if (typeof value === "object") stringifiedProperties[key] = JSON.stringify(value);
                else stringifiedProperties[key] = String(value);
            }
            return stringifiedProperties;
        } catch (e) {
            this.logger.error(this.platformAuthType + " - Error stringifying extra parameters");
            this.logger.errorPii(this.platformAuthType + " - Error stringifying extra parameters: " + e);
            return {};
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param loggerOptions
 * @param perfClient
 * @returns
 */ async function $1ef3eb788d38d5ed$export$bce61db0d62ff8e2(loggerOptions, perfClient, correlationId, domConfig) {
    const logger = new (0, $0bf1d54ef751a29c$export$efa9a398d6368992)(loggerOptions || {}, (0, $183cce12cb16965c$export$a8ff84c12d48cfa6), (0, $183cce12cb16965c$export$83d89fbfd8236492));
    logger.trace("isPlatformBrokerAvailable called");
    const performanceClient = perfClient || new (0, $c21b15fc7f6dcd1f$export$c70f2989a65fda3e)();
    if (typeof window === "undefined") {
        logger.trace("Non-browser environment detected, returning false");
        return false;
    }
    return !!await $1ef3eb788d38d5ed$export$b2c9df3607dc771a(logger, performanceClient, correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)(), undefined, domConfig);
}
async function $1ef3eb788d38d5ed$export$b2c9df3607dc771a(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("getPlatformAuthProvider called", correlationId);
    logger.trace("Has client allowed platform auth via DOM API: " + enablePlatformBrokerDOMSupport);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await (0, $952fbef31257d8ea$export$aa8591dfbb8a4c65).createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("Platform auth via DOM API not available, checking for extension");
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await (0, $baeb759c53a00ffc$export$de4c158ddf8b89f6).createProvider(logger, nativeBrokerHandshakeTimeout || (0, $68fb5a78014bcfe7$export$73d1d87a8b7ddb57), performanceClient);
        }
    } catch (e) {
        logger.trace("Platform auth not available", e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use native broker
 * @param logger
 * @param config
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5(config, logger, platformAuthProvider, authenticationScheme) {
    logger.trace("isPlatformAuthAllowed called");
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.system.allowPlatformBrokerWithDOM) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$exports).invalidPlatformBrokerConfiguration);
    if (!config.system.allowPlatformBroker) {
        logger.trace("isPlatformAuthAllowed: allowPlatformBroker is not enabled, returning false");
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("isPlatformAuthAllowed: Platform auth provider is not initialized, returning false");
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER:
        case (0, $7c375ae106b964be$export$901491a717da2ba5).POP:
            logger.trace("isPlatformAuthAllowed: authenticationScheme is supported, returning true");
            return true;
        default:
            logger.trace("isPlatformAuthAllowed: authenticationScheme is not supported, returning false");
            return false;
    }
    return true;
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $674f66832275a4d9$export$43b0fce132d066f4 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: this.config.system.asyncPopups
            }, this.correlationId);
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: (0, $550ae9dc1dae1add$export$253b550f4555e4bf)(request, this.config.auth.protocolMode)
                };
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) (0, $3003b661a087a867$export$a0816fa17a9e79be)(validRequest.authority);
        const isPlatformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup);
        const pkce = pkceCodes || await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge
        };
        try {
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === (0, $7c375ae106b964be$export$8343e6f32f5246de).POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                    popupWindow: popupWindow
                }, null);
                // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
                const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
                const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
                return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkce.verifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge
        };
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(popupWindow.document, this.config, discoveredAuthority, popupRequest, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.monitorPopupForHash.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $2a64db28ce4fd109$export$a76e1509233f1aec)(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.monitorPopupForHash.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).POPUP_OPENED, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $5ff55562d73e0e2b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9c96cbdf0340174c$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $9c96cbdf0340174c$export$a368977effbc1ed6 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        validRequest.platformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.resetRequestCache();
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest, request.onRedirectNavigate);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) e.setCorrelationId(this.correlationId);
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request, onRedirectNavigate) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect);
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === (0, $7c375ae106b964be$export$8343e6f32f5246de).POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager: serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl, onRedirectNavigate);
            }
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, pkceCodes.verifier);
        const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        this.browserStorage.cacheAuthorizeRequest(request);
        const form = await (0, $2a64db28ce4fd109$export$a76e1509233f1aec)(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", request, pkceVerifier, parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise);
        try {
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.resetRequestCache();
                // Do not instrument "no_server_response" if user clicked back button
                if ($9c96cbdf0340174c$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $0763983a1d35c4b8$exports).normalizeUrlForComparison(loginRequestUrl);
            const currentUrlNormalized = (0, $0763983a1d35c4b8$exports).normalizeUrlForComparison(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $3003b661a087a867$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!(0, $3003b661a087a867$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $3003b661a087a867$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $9c7efd3c039fd7d9$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $3003b661a087a867$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $5ff55562d73e0e2b$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $0763983a1d35c4b8$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$211c8e8843a8d278));
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, request.correlationId)({
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, request.correlationId)(request, serverParams, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl, onRedirectNavigateRequest) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = onRedirectNavigateRequest || this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $5ff55562d73e0e2b$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGOUT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $f7f911f196324278$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $3003b661a087a867$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $b4d2944d1c7d2c68$export$b5cc8574c3c26d11(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)($b4d2944d1c7d2c68$var$loadFrame, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$loadFrameSync, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
async function $b4d2944d1c7d2c68$export$99ef719e5be9ef9(config, authority, request, logger, performanceClient) {
    const frame = $b4d2944d1c7d2c68$var$createHiddenIframe();
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $2a64db28ce4fd109$export$a76e1509233f1aec)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function $b4d2944d1c7d2c68$export$dfeea08a8aa03859(config, authority, request, logger, performanceClient) {
    const frame = $b4d2944d1c7d2c68$var$createHiddenIframe();
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $2a64db28ce4fd109$export$3c140ef19fa8de34)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $b4d2944d1c7d2c68$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    performanceClient.addFields({
        iframePollIntervalMs: pollIntervalMilliseconds,
        iframeTimeoutMs: timeout
    }, correlationId);
    let totalTickCount = 0;
    let crossOriginTickCount = 0;
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $68fb5a78014bcfe7$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $68fb5a78014bcfe7$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            totalTickCount++;
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {
                crossOriginTickCount++;
            }
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $7c375ae106b964be$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        performanceClient.addFields({
            iframeTickCount: totalTickCount,
            crossOriginTickCount: crossOriginTickCount
        }, correlationId);
        (0, $5386add07ebe4b6d$export$468cda29b159ee5d)($b4d2944d1c7d2c68$var$removeHiddenIframe, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $b4d2944d1c7d2c68$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $b4d2944d1c7d2c68$var$loadFrameSync(urlNavigate) {
    const frameHandle = $b4d2944d1c7d2c68$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $b4d2944d1c7d2c68$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $73772bb7ece2a11b$export$e81c7938bccef977 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $7c375ae106b964be$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        silentRequest.platformBroker = (0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme);
        (0, $3003b661a087a867$export$a0816fa17a9e79be)(silentRequest.authority);
        if (this.config.auth.protocolMode === (0, $de576c4d1becc778$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Initialize the client
            authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) || e.errorCode !== (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        const discoveredAuthority = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $4e0948336b4ea4a7$export$95528b8a314880d1), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        const msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$dfeea08a8aa03859), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: this.initializeServerTelemetryManager(this.apiId),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$21aeb02dac823516), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Verifies SSO capability by making an iframe request to /authorize without exchanging the code for tokens.
     * This is useful for verifying SSO capability in the background without the overhead of a full token exchange.
     * @param request - The SSO silent request
     * @returns true if SSO verification was successful with a valid authorization code, false otherwise
     */ async verifySso(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        const inputRequest = {
            ...request
        };
        if (!inputRequest.prompt) inputRequest.prompt = (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        const authClient = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
            serverTelemetryManager: this.initializeServerTelemetryManager(this.apiId),
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            requestExtraQueryParameters: silentRequest.extraQueryParameters,
            account: silentRequest.account
        });
        const correlationId = silentRequest.correlationId;
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const requestWithPkce = {
            ...silentRequest,
            codeChallenge: pkceCodes.challenge
        };
        // Create authorize request url
        const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, requestWithPkce, this.logger, this.performanceClient);
        // Get the frame handle for the silent request - this triggers the SSO verification
        const msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$b5cc8574c3c26d11), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the iframe for the response
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        // Deserialize the response
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        // Validate the response - this checks for errors and validates state
        (0, $bfa307c523b8b81c$exports).validateAuthorizationResponse(serverParams, silentRequest.state);
        // Verify a valid authorization code is present
        if (!serverParams.code) {
            this.logger.warning("SSO verification response did not contain an authorization code", correlationId);
            return false;
        }
        this.logger.verbose("SSO verification completed successfully with valid authorization code - skipped token exchange", correlationId);
        return true;
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const correlationId = request.correlationId;
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        const pkceCodes = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        let msalFrame;
        if (request.httpMethod === (0, $7c375ae106b964be$export$8343e6f32f5246de).POST) msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$99ef719e5be9ef9), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
        else {
            // Create authorize request url
            const navigateUrl = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$a256231ce8625983), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            // Get the frame handle for the silent request
            msalFrame = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$b5cc8574c3c26d11), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        }
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $b4d2944d1c7d2c68$export$9ee275d2f26db8a7), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)((0, $9c7efd3c039fd7d9$export$e64c1808ed72a7c), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $2a64db28ce4fd109$export$907304a743d3578a), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-common v15.17.0 2026-03-18 */ 























'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $bf3b67e227c05f73$export$9cb096b89b92d8a8 extends (0, $3b13384e79a725db$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request, apiId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0a4a8f22735f9ff5$export$ae62599a119ac50a)();
        const response = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $7c375ae106b964be$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $4039fad97bcf28f6$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request, apiId) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true, apiId);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && e.errorCode === (0, $84767569d86b0bc0$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $016e46db2c2afa86$export$ea52035eac03daf0) && e.errorCode === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $7c375ae106b964be$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci, apiId) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $5386add07ebe4b6d$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined, this.performanceClient);
        if (!refreshToken) throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$e408b083cd212696));
        if (refreshToken.expiresOn) {
            const offset = request.refreshTokenExpirationOffsetSeconds || $bf3b67e227c05f73$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS;
            this.performanceClient?.addFields({
                cacheRtExpiresOnSeconds: Number(refreshToken.expiresOn),
                rtOffsetSeconds: offset
            }, request.correlationId);
            if ((0, $0a4a8f22735f9ff5$export$b007d77a962aa175)(refreshToken.expiresOn, offset)) throw (0, $18a94acc3dad87ad$export$8f7a741750c16535)((0, $84767569d86b0bc0$export$a90e8b9c10991b49));
        }
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest, apiId);
        } catch (e) {
            if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                if (e.subError === (0, $84767569d86b0bc0$export$2e3666c77d45a4da)) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $f7f911f196324278$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $7d3a00eb36d325b3$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $b00a7f221d8fdf60$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) (0, $7d3a00eb36d325b3$export$6758d6264f4f06)(parameters, request.redirectUri);
        (0, $7d3a00eb36d325b3$export$c213bf8f125826ba)(parameters, request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        (0, $7d3a00eb36d325b3$export$e5f700fdeb4022b2)(parameters, (0, $7c375ae106b964be$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        (0, $7d3a00eb36d325b3$export$86b85a101d45e918)(parameters);
        (0, $7d3a00eb36d325b3$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $7d3a00eb36d325b3$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $7d3a00eb36d325b3$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $d21eb39178ebb5ae$export$25afa7198c2ed9b9)(this.config)) (0, $7d3a00eb36d325b3$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        (0, $7d3a00eb36d325b3$export$b9e8ccbb425b80a3)(parameters, request.refreshToken);
        if (this.config.clientCredentials.clientSecret) (0, $7d3a00eb36d325b3$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $7d3a00eb36d325b3$export$2d3d772920e2496e)(parameters, await (0, $e4969f34ccbe14ce$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $7d3a00eb36d325b3$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $942a44945e07e21d$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $7d3a00eb36d325b3$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $7c375ae106b964be$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $7d3a00eb36d325b3$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $350dc36ccc5c7715$export$5d63d098f4f130a1)((0, $3a016e333d7347e3$export$8fbed44b22d9136f));
        }
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $7aacd5d6e6d7482c$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    (0, $7d3a00eb36d325b3$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $feda987e240ac148$export$17b7b3ac1abef49f).UPN:
                (0, $7d3a00eb36d325b3$export$aa9cca16bcc29d2d)(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) (0, $7d3a00eb36d325b3$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $7d3a00eb36d325b3$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        (0, $7d3a00eb36d325b3$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && parameters.has((0, $b00a7f221d8fdf60$export$3f910906fd5fe047)) ? undefined : this.config.authOptions.clientCapabilities;
        if (!(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(request.claims) || configClaims && configClaims.length > 0) (0, $7d3a00eb36d325b3$export$b04c3bca9165ed02)(parameters, request.claims, configClaims);
        return (0, $0763983a1d35c4b8$export$44d4663acf79cde2)(parameters);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9a90898a8c83eb8c$export$b4a36596822a5d2 extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$8e461fcf1fd6910b), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $bf3b67e227c05f73$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $dc748a126de75897$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj, performanceClient){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
        this.performanceClient = performanceClient;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ async loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$932e0f52d657f7fb));
        const correlationId = request.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        const rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).LoadExternalTokens, correlationId);
        try {
            const idTokenClaims = response.id_token ? (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.id_token, (0, $581fd3df606755c8$export$c62426fdd000a97e)) : undefined;
            const kmsi = (0, $b29e27fb146a7ddd$exports).isKmsi(idTokenClaims || {});
            const authorityOptions = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata,
                skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
            };
            const authorityString = request.authority || this.config.auth.authority;
            const authority = await (0, $ef8a264971d8166d$exports).createDiscoveredInstance((0, $77bb430f4568f6e8$export$f1c6ec2e6d68c49c).generateAuthority(authorityString, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, correlationId, this.performanceClient);
            const cacheRecordAccount = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.loadAccount.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).LoadAccount, this.logger, this.performanceClient, correlationId)(request, options.clientInfo || response.client_info || "", correlationId, authority, idTokenClaims);
            const idToken = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.loadIdToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).LoadIdToken, this.logger, this.performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, correlationId, kmsi);
            const accessToken = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.loadAccessToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).LoadAccessToken, this.logger, this.performanceClient, correlationId)(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options, correlationId, kmsi);
            const refreshToken = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.loadRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).LoadRefreshToken, this.logger, this.performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, correlationId, kmsi);
            rootMeasurement.end({
                success: true
            }, undefined, (0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(cacheRecordAccount));
            return this.generateAuthenticationResult(request, {
                account: cacheRecordAccount,
                idToken: idToken,
                accessToken: accessToken,
                refreshToken: refreshToken
            }, authority, idTokenClaims);
        } catch (error) {
            rootMeasurement.end({
                success: false
            }, error);
            throw error;
        }
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ async loadAccount(request, clientInfo, correlationId, authority, idTokenClaims) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            await this.storage.setAccount(accountEntity, correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(idTokenClaims || {}), (0, $5ff55562d73e0e2b$export$192d74ad69b40705).loadExternalTokens);
            return accountEntity;
        } else if (!clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, clientInfo or idToken must be provided instead.");
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $4039fad97bcf28f6$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $581fd3df606755c8$export$c62426fdd000a97e), correlationId, idTokenClaims, clientInfo, authority.getPreferredCache(), claimsTenantId, undefined, undefined, this.logger);
        await this.storage.setAccount(cachedAccount, correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(idTokenClaims || {}), (0, $5ff55562d73e0e2b$export$192d74ad69b40705).loadExternalTokens);
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ async loadIdToken(response, homeAccountId, environment, tenantId, correlationId, kmsi) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $9ab3d26df56b176d$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        await this.storage.setIdTokenCredential(idTokenEntity, correlationId, kmsi);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ async loadAccessToken(request, response, homeAccountId, environment, tenantId, options, correlationId, kmsi) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + (0, $0a4a8f22735f9ff5$exports).nowSeconds();
        const accessTokenEntity = (0, $9ab3d26df56b176d$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $581fd3df606755c8$export$c62426fdd000a97e));
        await this.storage.setAccessTokenCredential(accessTokenEntity, correlationId, kmsi);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ async loadRefreshToken(response, homeAccountId, environment, correlationId, kmsi) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        const expiresOn = response.refresh_token_expires_in ? response.refresh_token_expires_in + (0, $0a4a8f22735f9ff5$exports).nowSeconds() : undefined;
        this.performanceClient.addFields({
            extRtExpiresOnSeconds: expiresOn
        }, correlationId);
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $9ab3d26df56b176d$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, expiresOn);
        await this.storage.setRefreshTokenCredential(refreshTokenEntity, correlationId, kmsi);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, authority, idTokenClaims) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $74ffed612cd8faee$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: (0, $d6acc4a6126921e0$export$680160523e6bfa6a).getAccountInfo(accountEntity),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}





/*! @azure/msal-browser v4.30.0 2026-03-18 */ 



/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542 extends (0, $7e4376d17ecbf639$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $74f7d1cf2fd01491$export$d7f5ef311b3e9fca extends (0, $5d00224fcf1f9e62$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $2c25b6e1fc2d7d09$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $e330ed825f42f772$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, this.apiId, false);
        } catch (e) {
            if (e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$78523a40be105a03)));
    }
}







/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */ function $ae095a3d7bff7e6f$export$79f13b4cfaaf0d09() {
    if (typeof window === "undefined" || !window.navigator) return {};
    const connection = "connection" in window.navigator ? window.navigator.connection : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
    };
}
function $ae095a3d7bff7e6f$export$fe0570c25bf19cec(currentClientId, performanceEvent, logger) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("There is already an instance of MSAL.js in the window with the same client id.");
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1d9f6519fe722240$var$preflightCheck(initialized, performanceEvent, account) {
    try {
        (0, $3003b661a087a867$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, account);
        throw e;
    }
}
class $1d9f6519fe722240$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            cacheRetentionDays: 5,
            temporaryCacheLocation: (0, $5ff55562d73e0e2b$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler);
        // Initialize the token cache
        this.tokenCache = new (0, $dc748a126de75897$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto, this.performanceClient);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $1d9f6519fe722240$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackStateChange(correlationId, event) {
        if (!correlationId) return;
        if (event.type === "visibilitychange") {
            this.logger.info("Perf: Visibility change detected");
            this.performanceClient.incrementFields({
                visibilityChangeCount: 1
            }, correlationId);
        } else if (event.type === "online") {
            this.logger.info("Perf: Online status change detected");
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        } else if (event.type === "offline") {
            this.logger.info("Perf: Offline status change detected");
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        }
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request, isBroker) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_START);
        // Broker applications are initialized twice, so we avoid double-counting it
        if (!isBroker) try {
            this.logMultipleInstances(initMeasurement);
        } catch  {}
        await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.browserStorage.initialize.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeCache, this.logger, this.performanceClient, initCorrelationId)(initCorrelationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await (0, $1ef3eb788d38d5ed$export$b2c9df3607dc771a)(this.logger, this.performanceClient, initCorrelationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.system.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            (0, $5386add07ebe4b6d$export$468cda29b159ee5d)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(initCorrelationId);
        }
        this.config.system.asyncPopups && await this.preGeneratePkceCodes(initCorrelationId);
        this.initialized = true;
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $3003b661a087a867$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT) {
            this.logger.verbose("handleRedirectPromise removing interaction_in_progress flag and returning null after sign-out");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && this.platformAuthProvider && !hash;
        let rootMeasurement;
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        try {
            if (useNative && this.platformAuthProvider) {
                rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, platformBrokerRequest?.correlationId || "");
                this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId);
                redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest();
                const correlationId = standardRequest.correlationId;
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
                this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, standardRequest, codeVerifier, rootMeasurement);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache();
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache();
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true
                }, undefined, result.account);
                // Fire-and-forget SSO capability verification in background
                this.verifySsoCapability(result.account, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            }, undefined);
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache();
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                atrMeasurement.add({
                    navigateCallbackResult: navigate !== false
                });
                atrMeasurement.event = atrMeasurement.end({
                    success: true
                }, undefined, request.account) || atrMeasurement.event;
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    atrMeasurement.add({
                        brokerErrorName: e.name,
                        brokerErrorCode: e.errorCode
                    });
                    if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache();
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $1d9f6519fe722240$var$preflightCheck(this.initialized, atPopupMeasurement, request.account);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNIN);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId: correlationId
            }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                atPopupMeasurement.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
                    this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            // SSO capability verification in background
            this.verifySsoCapability(result.account, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup);
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (this.config.system.asyncPopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackStateChangeWithMeasurement(event) {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        if (event.type === "visibilitychange") {
            this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
            measurement.increment({
                visibilityChangeCount: 1
            });
        } else if (event.type === "online") {
            this.logger.info("Perf: Online status change detected in ", measurement.event.name);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        } else if (event.type === "offline") {
            this.logger.info("Perf: Offline status change detected in ", measurement.event.name);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        }
    }
    addStateChangeListeners(listener) {
        document.addEventListener("visibilitychange", listener);
        window.addEventListener("online", listener);
        window.addEventListener("offline", listener);
    }
    removeStateChangeListeners(listener) {
        document.removeEventListener("visibilitychange", listener);
        window.removeEventListener("online", listener);
        window.removeEventListener("offline", listener);
    }
    /**
     * SSO capability verification in the background.
     * This method makes an iframe request to /authorize to verify SSO capability without calling /token.
     * This method does not block the caller and tracks telemetry for success/failure.
     * This method only executes if verifySSO is set to true in the auth configuration.
     * @param account - The account to use for the SSO verification
     * @param parentApi - The API ID of the parent operation for logging purposes
     */ verifySsoCapability(account, parentApi) {
        // Check if SSO capability verification is enabled
        if (!this.config.auth.verifySSO) return;
        const correlationId = this.browserCrypto.createNewGuid();
        const ssoCapableMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoCapable, correlationId);
        ssoCapableMeasurement.add({
            parentApi: parentApi
        });
        this.logger.verbose(`SSO capability verification initiated after ${parentApi}`, correlationId);
        /*
         * Use setTimeout to ensure this runs in a separate macrotask after the current call stack completes
         * This ensures the result is returned to the caller before the SSO verification starts and doesn't affect performance
         */ setTimeout(()=>{
            const ssoVerificationRequest = {
                account: account,
                correlationId: correlationId
            };
            const silentIframeClient = this.createSilentIframeClient(correlationId);
            silentIframeClient.verifySso(ssoVerificationRequest).then((success)=>{
                this.logger.verbose(`SSO capability verification completed after ${parentApi}, success: ${success}`, correlationId);
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: success
                }, undefined, account);
            }).catch((error)=>{
                this.logger.warning(`SSO capability verification failed after ${parentApi}: ${error.message}`, correlationId);
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: false
                }, error, account);
            });
        }, 0);
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, this.ssoSilentMeasurement, request.account);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent).catch((e)=>{
                this.ssoSilentMeasurement?.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        atbcMeasurement.add({
                            brokerErrorName: e.name,
                            brokerErrorCode: e.errorCode
                        });
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true
                    }, undefined, result.account);
                    return result;
                } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$b897bbe2c683def2));
            } else throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $3003b661a087a867$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $3003b661a087a867$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true, (0, $5ff55562d73e0e2b$export$dc1d3aa5f3837765).SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        const correlationId = this.getRequestCorrelationId();
        (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.getRequestCorrelationId();
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(result.idTokenClaims), (0, $5ff55562d73e0e2b$export$192d74ad69b40705).hydrateCache);
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        this.logger.trace("acquireTokenNative called");
        if (!this.platformAuthProvider) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$7b7357e3538624aa));
        const nativeClient = new (0, $e6f06a03b9c6516d$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        this.logger.trace("canUsePlatformBroker called");
        if (!this.platformAuthProvider) {
            this.logger.trace("canUsePlatformBroker: platform broker unavilable, returning false");
            return false;
        }
        if (!(0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("canUsePlatformBroker: isBrokerAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).NONE:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).CONSENT:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).LOGIN:
            case (0, $7c375ae106b964be$export$49a06cbda5acaa5).SELECT_ACCOUNT:
                this.logger.trace("canUsePlatformBroker: prompt is compatible with platform broker flow");
                break;
            default:
                this.logger.trace(`canUsePlatformBroker: prompt = ${request.prompt} is not compatible with platform broker flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUsePlatformBroker: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $674f66832275a4d9$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $9c96cbdf0340174c$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $73772bb7ece2a11b$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $5d2b86ff94a0079d$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $9a90898a8c83eb8c$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $74f7d1cf2fd01491$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $3003b661a087a867$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ enableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.subscribeCrossTab();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ disableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $5ff55562d73e0e2b$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.unsubscribeCrossTab();
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $7c375ae106b964be$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $1d9f6519fe722240$var$preflightCheck(this.initialized, atsMeasurement, request.account);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $6e0b7bb04b1e6592$export$72f7b48f3bc1d4cb)((0, $0780bb28b98eb888$export$87933d7d4116cb12));
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac)) // Ensures PWB scenarios can correctly match request to response
            error.setCorrelationId(correlationId);
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = (0, $762faca86a0f7942$export$2daa8cfcf54c2b48)(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority,
            correlationId: correlationId
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackStateChange = (event)=>this.trackStateChange(request.correlationId, event);
        this.performanceClient.addQueueMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        }, request.correlationId);
        this.addStateChangeListeners(trackStateChange);
        const silentRequest = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $550ae9dc1dae1add$export$4c8aa78c426811d4), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                const silentRefreshReason = `${refreshTokenError.errorCode}${refreshTokenError.subError ? `|${refreshTokenError.subError}` : ""}`;
                this.performanceClient.addFields({
                    silentRefreshReason: silentRefreshReason
                }, silentRequest.correlationId);
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, response);
            this.performanceClient.addFields({
                fromCache: response.fromCache
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(trackStateChange);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ((0, $1ef3eb788d38d5ed$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, (0, $5ff55562d73e0e2b$export$192d74ad69b40705).acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                this.performanceClient.addFields({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                }, silentRequest.correlationId);
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $a5e5dee51df551c2$export$4b8a4f6256e840ab) && (0, $a5e5dee51df551c2$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) this.logger.verbose("acquireTokenSilent - cache lookup policy set to AccessToken, attempting to acquire token from local cache");
            return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $5386add07ebe4b6d$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("Generating new PKCE codes");
        this.pkceCode = await (0, $5386add07ebe4b6d$export$e4feded94d9adb18)((0, $cab7ad26b4a73b7b$export$91d5e5a023803853), (0, $80a5304d92c187bf$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        this.logger.verbose("Attempting to pick up pre-generated PKCE codes");
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        this.logger.verbose(`${res ? "Found" : "Did not find"} pre-generated PKCE codes`);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("There is already an instance of MSAL.js in the window.");
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        (0, $ae095a3d7bff7e6f$export$fe0570c25bf19cec)(clientId, performanceEvent, this.logger);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $1d9f6519fe722240$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $84767569d86b0bc0$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $5ff55562d73e0e2b$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $6be88bbe69356b76$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).noTokensFound || refreshTokenError.errorCode === (0, $84767569d86b0bc0$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $5ff55562d73e0e2b$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
/*! @azure/msal-browser v4.30.0 2026-03-18 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $61425a9d4424b5fd$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $03968fc19372b2df$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = (0, $7d3a00eb36d325b3$exports).addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $7c375ae106b964be$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $442eacaa0418a38d$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $54830df9a5d9a12c$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            loginHint: loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $61425a9d4424b5fd$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserCancel:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).userCanceled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noNetworkConnectivity);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).noAccountFound);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).Disabled:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)((0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $eaea74bac26129fa$export$a839ff85a7957561)(error.code || (0, $6be88bbe69356b76$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).TransientError:
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).PersistentError:
                return new (0, $016e46db2c2afa86$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $067e966d84ac4206$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $0ff8310393c4d2db$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $eaea74bac26129fa$export$ea892ce48f5bb4f3)((0, $6be88bbe69356b76$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $b29e27fb146a7ddd$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: (0, $0a4a8f22735f9ff5$exports).toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || (0, $7c375ae106b964be$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v4.30.0 2026-03-18 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $f43fb4a2edb734fd$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $f43fb4a2edb734fd$export$7c79ceb488783308 extends (0, $0ff8310393c4d2db$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $f43fb4a2edb734fd$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $f43fb4a2edb734fd$export$7c79ceb488783308($f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.code, $f43fb4a2edb734fd$export$81a70490e660273a.unsupportedMethod.desc);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $8ac21447ebc7e19d$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $e72c2cdc5fe24d6f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $dd88ab1a0b4d3851$export$865f57d401606752);
        this.eventHandler = new (0, $9f61ab73b66f619a$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $d3981d5134d5331a$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $77bb430f4568f6e8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $d3981d5134d5331a$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        this.nestedAppAuthAdapter = new (0, $03968fc19372b2df$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $8ac21447ebc7e19d$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || (0, $4e0948336b4ea4a7$export$6ef0355fa80a5278)();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`Failed to hydrate cache. Error: ${error}`, validRequest.correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = (0, $0a4a8f22735f9ff5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`Failed to hydrate cache. Error: ${error}`, validRequest.correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $0ff8310393c4d2db$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $80a5304d92c187bf$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("forceRefresh is set to true, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default;
        switch(request.cacheLookupPolicy){
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).Default:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessToken:
            case (0, $5ff55562d73e0e2b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        let currentAccount = null;
        const correlationId = request.correlationId || this.browserCrypto.createNewGuid();
        if (accountContext) currentAccount = (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: request.correlationId || this.browserCrypto.createNewGuid(),
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $7c375ae106b964be$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $0a4a8f22735f9ff5$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $0a4a8f22735f9ff5$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId, this.performanceClient);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $807e525bbe19e865$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $5ff55562d73e0e2b$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $f43fb4a2edb734fd$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $d6acc4a6126921e0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $b29e27fb146a7ddd$exports).isKmsi(result.idTokenClaims), (0, $5ff55562d73e0e2b$export$192d74ad69b40705).hydrateCache);
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $54e1c8c64fb5e616$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $54e1c8c64fb5e616$export$6a1d744b364856f2(config) {
    const standard = new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $8ac21447ebc7e19d$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $1d9f6519fe722240$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $5579c29889b267e7$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $54e1c8c64fb5e616$export$414d5e42be8c56db)(configuration);
        const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.isBroker = false;
        this.controller = controller || new (0, $1d9f6519fe722240$export$e9d1ef1cb8705404)(new (0, $36cb4f619f94d121$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request, this.isBroker);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $769cd552162fdff8$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $8ac21447ebc7e19d$export$2319deb182e38ab3)(nestedAppAuth);
        const nestablePCA = new $5579c29889b267e7$export$89f4855ef88b7920(configuration, controller);
        await nestablePCA.initialize();
        return nestablePCA;
    }
    return $5579c29889b267e7$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $5579c29889b267e7$export$f28b97cfb2f3098(configuration) {
    const pca = new $5579c29889b267e7$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}


const $a2d10b2db6923a38$var$msalConfig = {
    auth: {
        clientId: "aadb7256-36f2-48c5-80f0-c50ea4ccc759",
        authority: "https://login.microsoftonline.com/d8d0ad3e-8bcf-48e9-9bb2-aee17c6c4fd5",
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
};
const $a2d10b2db6923a38$export$a59c2286a7150b12 = new (0, $5579c29889b267e7$export$89f4855ef88b7920)($a2d10b2db6923a38$var$msalConfig);
const $a2d10b2db6923a38$export$be6c432b2463c5eb = ()=>({
        scopes: [
            "openid",
            "profile"
        ],
        account: $a2d10b2db6923a38$export$a59c2286a7150b12.getActiveAccount() || undefined
    });


const $bc59a856a5e4c3e2$export$15445f8a01cc33a5 = ()=>{
    const account = (0, $e5e33773db31b6c0$export$83a8e409853da004)();
    return account?.name || "";
};
const $bc59a856a5e4c3e2$var$getRedirectUrl = ()=>{
    return "https://connect.cooperation.flixbus.com/";
};
const $bc59a856a5e4c3e2$export$a0973bcfe11b05c9 = ()=>{
    const redirectUrl = $bc59a856a5e4c3e2$var$getRedirectUrl();
    (0, $3b643887ffa5d38c$export$2e2bcd8739ae039).logout();
    window.localStorage.clear();
    (0, $a2d10b2db6923a38$export$a59c2286a7150b12).logoutRedirect({
        postLogoutRedirectUri: redirectUrl
    });
};
const $bc59a856a5e4c3e2$export$497311c211e584c0 = (token)=>{
    return {
        headers: {
            authorization: `Bearer ${token}`
        }
    };
};
const $bc59a856a5e4c3e2$export$ffd06224fc106bf3 = "auth-issuer-cypress";
const $bc59a856a5e4c3e2$export$99d52135fc6f2cd8 = ()=>false;
const $bc59a856a5e4c3e2$export$ca25862a9e6ee63c = ()=>{
    const cookieValue = (0, $944e98c5c54289c1$export$4be65e66cfa2648a)($bc59a856a5e4c3e2$export$ffd06224fc106bf3);
    return false;
};
const $bc59a856a5e4c3e2$export$57947cfd429801a2 = (exp)=>{
    return typeof exp !== "number" || exp * 1000 < Date.now();
};
const $bc59a856a5e4c3e2$export$257b2d10b709d8ef = async (inProgess = (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None, forceRefresh = false)=>{
    if (!forceRefresh) {
        // First, handle any pending redirect response
        const redirectResponse = await (0, $a2d10b2db6923a38$export$a59c2286a7150b12).handleRedirectPromise();
        if (redirectResponse) // If there's a redirect response, return the token, it is now in the msal cache
        return redirectResponse;
    }
    return (0, $a2d10b2db6923a38$export$a59c2286a7150b12).acquireTokenSilent({
        ...(0, $a2d10b2db6923a38$export$be6c432b2463c5eb)(),
        forceRefresh: forceRefresh
    }).then((resp)=>{
        return resp;
    }).catch((error)=>{
        // WE don't want that error to be spamming when we test the error case in jest
        if (!$bc59a856a5e4c3e2$export$ca25862a9e6ee63c()) console.warn(`acquireTokenSilent failed: ${error}`);
        if (error instanceof (0, $18a94acc3dad87ad$export$6ba3e818c6bc76ba)) {
            // fallback to interaction when silent call fails
            if (inProgess === (0, $5ff55562d73e0e2b$export$bec20eda0179362b).None) return (0, $a2d10b2db6923a38$export$a59c2286a7150b12).acquireTokenRedirect({
                ...(0, $a2d10b2db6923a38$export$be6c432b2463c5eb)()
            }).catch((err)=>{
                if (!$bc59a856a5e4c3e2$export$ca25862a9e6ee63c()) console.error(`acquireTokenRedirect failed: ${err}`);
            });
            else console.error("Interaction already in Progress");
        }
        return undefined;
    });
};
const $bc59a856a5e4c3e2$export$57690667ea6b189b = ()=>(0, $a2d10b2db6923a38$export$a59c2286a7150b12).getActiveAccount()?.idTokenClaims?.roles;


/*
  This file is auto-generated. Do not edit it directly.
  To update this file, run `npm run codegen:common`.
*/ var $7fa43330bc76951a$var$Role = /*#__PURE__*/ function(Role) {
    Role["DATA_WALL"] = "MP_DATA_WALL_GRANTED";
    Role["ROLE_ADMIN"] = "ROLE_ADMIN";
    Role["ROLE_OP"] = "ROLE_OP";
    Role["ROLE_BD"] = "ROLE_BD";
    Role["ROLE_USER_MANAGER"] = "ROLE_USER_MANAGER";
    Role["ROLE_CAPACITY_MANAGER"] = "ROLE_CAPACITY_MANAGER";
    Role["ROLE_GENERAL_SETTINGS"] = "ROLE_GENERAL_SETTINGS";
    Role["ROLE_PRICING"] = "ROLE_PRICING";
    Role["ROLE_SCHEDULE_MANAGER"] = "ROLE_SCHEDULE_MANAGER";
    Role["ROLE_REPORTING"] = "ROLE_REPORTING";
    Role["ROLE_PARTNER"] = "ROLE_PARTNER";
    Role["ROLE_STATION_MANAGER"] = "ROLE_STATION_MANAGER";
    Role["ROLE_POWER_BI"] = "ROLE_POWER_BI";
    Role["ROLE_DISPATCHER"] = "ROLE_DISPATCHER";
    Role["ROLE_DRIVER"] = "ROLE_DRIVER";
    return Role;
}($7fa43330bc76951a$var$Role || {});
var $7fa43330bc76951a$export$2e2bcd8739ae039 = $7fa43330bc76951a$var$Role;


var $71f9f16f8e7bf2d4$exports = {};
$71f9f16f8e7bf2d4$exports = {
    "USER_HAS_MARKETPLACE_ACCESS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER",
        "ROLE_STATION_MANAGER"
    ],
    "USER_HAS_SERVICEDESK_ACCESS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "USER_HAS_VIEW_ACCESS_TO_ALL_PAGES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "VIEW_PARTNER_LIST": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_PARTNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "CREATE_PARTNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "DELETE_PARTNER_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_DELETE_PARTNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_CURRENCY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_NAME_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_NAME_PUBLISHED": [
        "ROLE_ADMIN"
    ],
    "EDIT_PARTNER_CONCESSION_OWNER_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_PARTNER_CONCESSION_OWNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_BUSINESS_REGION_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_PARTNER_BUSINESS_REGION": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_BUSINESS_DEV_MANAGER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_DEFAULT_ACCESS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_DEFAULT_CAPACITY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_MEANS_OF_TRANSPORT": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_INTEGRATION_INTERMEDIARY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_CAPACITY_DECREASE_RULE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_PASSENGER_BOOKING_DATA_ACCESS_ALLOWED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_PASSENGER_BOOKING_INFORMATION": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_REPORTING",
        "ROLE_GENERAL_SETTINGS"
    ],
    "VIEW_ALL_PARTNER_PASSENGER_BOOKING_INFORMATION_FIELDS": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "EDIT_PARTNER_BRAND": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_AVAILABLE_BRANDS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_PARTNER_BRAND_POLICIES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "EDIT_PARTNER_BRAND_POLICIES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_PARTNER_SETTINGS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_API_SETTINGS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_INVENTORY_RULES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_AUTO_ON_SALE_CONFIG": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_IC_PRICING_RULES": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_PARTNER_IC_PRICING_RULES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_TEAMS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER"
    ],
    "EDIT_PARTNER_PUBLISH_POLICIES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_PARTNER_TAGS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PARTNER_TAGS": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_PARTNER_USERS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "VIEW_PARTNER_TEST_USERS": [
        "ROLE_ADMIN"
    ],
    "VIEW_LINE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "CREATE_LINE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_DESCRIPTION_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_CODE_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_CONTRACT_MODEL_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_LINE_BRAND": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_GENERAL_SETTINGS"
    ],
    "EDIT_LINE_CUT_OFF_SALES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_LINE_AMENITIES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_GENERAL_SETTINGS"
    ],
    "EDIT_LINE_MINIMUM_SEAT_CAPACITY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_LINE_DEFAULT_CIRCULATION": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_MEANS_OF_TRANSPORT_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_FORBIDDEN_RELATIONS_ADD": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_LINE_FORBIDDEN_RELATIONS_DELETE": [
        "ROLE_BD",
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "DELETE_LINE_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "UPLOAD_FORBIDDEN_RELATIONS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "CREATE_SCHEDULE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "VIEW_SCHEDULE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "VIEW_SCHEDULE_VALIDATION": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "CREATE_SCHEDULE_COPY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "CREATE_SCHEDULE_CONCEPT_CHANGE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "DELETE_SCHEDULE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_NAME_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_PERIOD_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_INITIAL_CAPACITY_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_NON_OPERATIONAL_PERIOD_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_TIMETABLE_UNPUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_SUBMIT_TO_REVIEW": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER"
    ],
    "EDIT_SCHEDULE_APPROVE_REJECT": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_SCHEDULE_PUBLISH": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "EDIT_SCHEDULE_ACTIVATE_ON_SALE": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "EDIT_SCHEDULE_ARCHIVE": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "EDIT_SCHEDULE_PUT_ON_HIDDEN": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_SCHEDULE_STATUS_HISTORY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_SCHEDULE_STATUS": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_SCHEDULE_DETAILED_STATUS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "VIEW_HIDDEN_STATUS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "EDIT_PRICING": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_PRICING"
    ],
    "VIEW_ALL_OPS_PARTNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "VIEW_RIDES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "EDIT_CAPACITY_MANAGER_CAPACITY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_CAPACITY_MANAGER"
    ],
    "EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_CAPACITY_MANAGER"
    ],
    "EDIT_CAPACITY_MANAGER_CANCEL_RIDE": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_CAPACITY_MANAGER"
    ],
    "VIEW_CAPACITY_MANAGER_RIDES_IN_PREVIEW": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_BOOKINGS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER"
    ],
    "VIEW_BOOKING_REPORTS_DOWNLOAD": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_REPORTING"
    ],
    "CREATE_STATION": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_STATION_MANAGER"
    ],
    "VIEW_STATIONS": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER",
        "ROLE_STATION_MANAGER"
    ],
    "CREATE_CITY": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_STATION_MANAGER"
    ],
    "VIEW_CITIES": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_USER_MANAGER",
        "ROLE_CAPACITY_MANAGER",
        "ROLE_GENERAL_SETTINGS",
        "ROLE_PRICING",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_REPORTING",
        "ROLE_PARTNER",
        "ROLE_STATION_MANAGER"
    ],
    "CREATE_STATION_IMPORT": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_STATION_MANAGER"
    ],
    "CREATE_CITY_IMPORT": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_STATION_INREVIEW": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_STATION_APPROVED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_STATION_PUBLISHED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_STATION_REJECTED": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_SCHEDULE_MANAGER",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_STATION_APPROVE_REJECT": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_STATION_MANAGER"
    ],
    "EDIT_CITY_STATION_APPROVER": [
        "ROLE_ADMIN",
        "ROLE_OP"
    ],
    "VIEW_POWER_BI_REPORT": [
        "ROLE_ADMIN",
        "ROLE_POWER_BI"
    ],
    "VIEW_PAX_LIST": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_DISPATCHER",
        "ROLE_DRIVER"
    ],
    "CHECK_IN_MANUAL": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_DISPATCHER"
    ],
    "CHECK_IN_QR": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD",
        "ROLE_DRIVER"
    ],
    "CHANGE_PARTNER": [
        "ROLE_ADMIN",
        "ROLE_OP",
        "ROLE_BD"
    ],
    "USER_HAS_MUS_ACCESS": [
        "ROLE_PARTNER"
    ]
};


const $abefdbda3c0e307b$export$7c4451767ad4ac38 = ()=>{
    if ((0, $bc59a856a5e4c3e2$export$ca25862a9e6ee63c)()) return true;
    const roles = (0, $bc59a856a5e4c3e2$export$57690667ea6b189b)();
    if (roles && roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_STATION_MANAGER)) return true;
    if (roles && roles.length) return roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).DATA_WALL);
    return false;
};
const $abefdbda3c0e307b$export$d38c79f7cb4d2f57 = (feature)=>{
    const permissionsObject = $71f9f16f8e7bf2d4$exports;
    const roles = (0, $bc59a856a5e4c3e2$export$57690667ea6b189b)();
    if ((0, $bc59a856a5e4c3e2$export$99d52135fc6f2cd8)()) return false;
    if ((0, $bc59a856a5e4c3e2$export$ca25862a9e6ee63c)()) return true;
    if (roles && roles.length) {
        if (permissionsObject[feature]) return permissionsObject[feature].some((role)=>roles.includes(role));
        return false;
    }
    return false;
};
const $abefdbda3c0e307b$export$e2110b7b2e6f4926 = (features)=>{
    return features.some((feature)=>$abefdbda3c0e307b$export$d38c79f7cb4d2f57(feature));
};



parcelRequire("acw62");
const $65aec11a7212da24$var$HideMainNav = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
        children: "header {display: none !important}"
    });
};
var $65aec11a7212da24$export$2e2bcd8739ae039 = $65aec11a7212da24$var$HideMainNav;





var $acw62 = parcelRequire("acw62");

var $7e1e4fc15c9e8e81$export$2e2bcd8739ae039 = {
    raw: ".hcr-btn-16-4-0{--hcr-button-bg-color:var(--hcr-box-bg-color);--hcr-button-border-color:var(--hcr-grayscale-50-color);--hcr-button-text-color:var(--hcr-content-primary-color);align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:var(--hcr-button-bg-color);border:1px solid var(--hcr-button-border-color);border-radius:var(--hcr-border-radius-1);color:var(--hcr-button-text-color);cursor:pointer;display:inline-flex;font-family:inherit;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-half);justify-content:center;line-height:var(--hcr-line-height-primary);max-width:100%;min-height:var(--hcr-input-height-mobile);min-width:142px;overflow-wrap:anywhere;padding:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half) - 1px) var(--hcr-spacing-2);position:relative;text-align:center;text-decoration:none;transition:background .25s ease}.hcr-btn-16-4-0:enabled:hover,.hcr-btn-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-btn-16-4-0:enabled:active,.hcr-btn-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-btn-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-btn--disabled-16-4-0,.hcr-btn-16-4-0:disabled,.hcr-btn-16-4-0[aria-disabled=true]{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}@media (min-width:0) and (max-width:599px){.hcr-btn-16-4-0{display:flex;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-btn--lg-16-4-0,.hcr-btn--link-16-4-0,.hcr-btn--md-16-4-0,.hcr-btn--sm-16-4-0,.hcr-btn--square-16-4-0,.hcr-btn--stacked-16-4-0{display:inline-flex;width:auto}}@media (min-width:1200px){.hcr-btn-16-4-0{min-height:var(--hcr-input-height-desktop);padding-bottom:calc(var(--hcr-spacing-1) - 1px);padding-top:calc(var(--hcr-spacing-1) - 1px)}}.hcr-btn--loading-16-4-0{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-btn--primary-16-4-0{--hcr-button-bg-color:var(--hcr-button-primary-color);--hcr-button-border-color:var(--hcr-button-primary-color);--hcr-button-text-color:var(--hcr-button-label-color)}.hcr-btn--secondary-16-4-0{--hcr-button-border-color:var(--hcr-button-primary-color)}.hcr-btn--danger-16-4-0{--hcr-button-bg-color:var(--hcr-danger-color);--hcr-button-border-color:var(--hcr-danger-color);--hcr-button-text-color:var(--hcr-grayscale-0-color)}.hcr-btn--link-16-4-0{--hcr-button-bg-color:#0000;--hcr-button-border-color:#0000;--hcr-button-text-color:var(--hcr-container-content-color,var(--hcr-content-primary-color));min-width:auto;padding:0 var(--hcr-spacing-half)}.hcr-btn--link-16-4-0.hcr-btn--loading-16-4-0:before{margin-left:0}.hcr-btn--sm-16-4-0{font-size:var(--hcr-font-size-small);line-height:var(--hcr-line-height-small);min-height:var(--hcr-spacing-4);min-width:auto;padding-bottom:0;padding-top:0}.hcr-btn--md-16-4-0{min-height:var(--hcr-input-height-desktop);padding-bottom:calc(var(--hcr-spacing-1) - 1px);padding-top:calc(var(--hcr-spacing-1) - 1px)}.hcr-btn--lg-16-4-0{min-height:var(--hcr-spacing-8);padding:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half)) var(--hcr-spacing-4)}.hcr-btn--loading-16-4-0:before{animation:btn-spinner-rotate 1s linear infinite,btn-spinner-grow .25s;border-left-color:#0003;border:var(--hcr-spacing-half) solid #0003;border-left:var(--hcr-spacing-half) solid var(--hcr-button-text-color);border-radius:50%;content:\"\";display:inline-block;flex-shrink:0;height:var(--hcr-spacing-4);width:var(--hcr-spacing-4)}.hcr-btn--loading-16-4-0:has(.hcr-btn__icon-16-4-0):before,.hcr-btn--loading-16-4-0:has([class^=hci-icon]):before{animation:btn-spinner-rotate 1s linear infinite}@keyframes btn-spinner-grow{0%{height:0;opacity:0;width:0}to{height:var(--hcr-spacing-4);opacity:1;width:var(--hcr-spacing-4)}}@keyframes btn-spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.hcr-btn--loading-16-4-0 .hcr-btn__icon-16-4-0,.hcr-btn--loading-16-4-0 [class^=hci-icon]{display:none!important}.hcr-btn--square-16-4-0{aspect-ratio:1;min-width:var(--hcr-input-height-mobile);padding-left:0;padding-right:0}@media (min-width:1200px){.hcr-btn--square-16-4-0{min-width:var(--hcr-input-height-desktop)}}.hcr-btn--square-16-4-0.hcr-btn--sm-16-4-0{min-width:var(--hcr-spacing-4)}.hcr-btn--square-16-4-0.hcr-btn--md-16-4-0{min-width:var(--hcr-spacing-6)}.hcr-btn--square-16-4-0.hcr-btn--lg-16-4-0{min-width:var(--hcr-spacing-8)}.hcr-btn--stacked-16-4-0{flex-direction:column;font-size:var(--hcr-font-size-small);line-height:var(--hcr-line-height-small);min-width:auto;padding-left:var(--hcr-spacing-1);padding-right:var(--hcr-spacing-1)}.hcr-btn--stacked-16-4-0.hcr-btn--lg-16-4-0{font-size:var(--hcr-font-size-primary);line-height:var(--hcr-line-height-primary);padding-left:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half));padding-right:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half))}.hcr-btn--block-16-4-0{display:flex;width:-webkit-fill-available;width:-moz-available;width:stretch}",
    map: {
        "hcr-btn": "hcr-btn-16-4-0",
        "hcr-btn--disabled": "hcr-btn--disabled-16-4-0",
        "hcr-btn--sm": "hcr-btn--sm-16-4-0",
        "hcr-btn--md": "hcr-btn--md-16-4-0",
        "hcr-btn--lg": "hcr-btn--lg-16-4-0",
        "hcr-btn--link": "hcr-btn--link-16-4-0",
        "hcr-btn--square": "hcr-btn--square-16-4-0",
        "hcr-btn--stacked": "hcr-btn--stacked-16-4-0",
        "hcr-btn--loading": "hcr-btn--loading-16-4-0",
        "hcr-btn--primary": "hcr-btn--primary-16-4-0",
        "hcr-btn--secondary": "hcr-btn--secondary-16-4-0",
        "hcr-btn--danger": "hcr-btn--danger-16-4-0",
        "hcr-btn__icon": "hcr-btn__icon-16-4-0",
        "hcr-btn--block": "hcr-btn--block-16-4-0"
    }
};





const $95ad0b73abcf4f9f$export$f3ae2b2681d6a2fd = [
    'primary',
    'secondary',
    'danger',
    'link'
];
const $95ad0b73abcf4f9f$export$6435cacfbaa60ff5 = [
    'button',
    'submit',
    'reset'
];
const $95ad0b73abcf4f9f$export$1b0853faebbc1e53 = [
    'button',
    'a',
    'span'
];
const $95ad0b73abcf4f9f$export$e1fbd9299acdd36 = [
    'block',
    'square',
    'stacked'
];
const $95ad0b73abcf4f9f$export$73e83bf2b7e02467 = [
    'sm',
    'md',
    'lg'
];



var $acw62 = parcelRequire("acw62");
var $175aa43345204302$exports = {};

$parcel$export($175aa43345204302$exports, "isFragment", () => $175aa43345204302$export$9522e17588c12572);
$parcel$export($175aa43345204302$exports, "getElementName", () => $175aa43345204302$export$cb26d1ee6764af05);
$parcel$export($175aa43345204302$exports, "isOfType", () => $175aa43345204302$export$2dabafa86f11ed64);
$parcel$export($175aa43345204302$exports, "mapRecursively", () => $175aa43345204302$export$413dd9fe11ad5ea7);
$parcel$export($175aa43345204302$exports, "getUninjectedCompName", () => $175aa43345204302$export$16588b807bbcb70);
$parcel$export($175aa43345204302$exports, "getChildrenByName", () => $175aa43345204302$export$348ae70a93bc9267);
$parcel$export($175aa43345204302$exports, "assignInnerRefWithComponentRef", () => $175aa43345204302$export$390003ad846c69eb);

var $acw62 = parcelRequire("acw62");
/**
 * Returns `true` if `child` is a `React.Fragment`.
 * @param {ReactNode | ExoticComponent} child
 * @returns boolean
 */ function $175aa43345204302$export$9522e17588c12572(child) {
    return Boolean(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
}
/**
 * Returns element's displayName, name or type depending on what is given.
 * @param {ReactNode} element
 * @returns {string} Element's displayName, name or type
 */ function $175aa43345204302$export$cb26d1ee6764af05(element) {
    if (element) {
        const typeCastE = element;
        if (typeCastE.displayName) return typeCastE.displayName;
        if (typeCastE.type) return typeof typeCastE.type === 'string' ? typeCastE.type : typeCastE.type.displayName || typeCastE.type.name;
    }
    return typeof element;
}
/**
 * Returns `true` if `element` is a valid component whose `displayName` matches
 * the given `displayName`.
 * @param {ReactNode} element
 * @param {string} displayName
 * @returns boolean
 */ function $175aa43345204302$export$2dabafa86f11ed64(element, displayName) {
    const elementName = $175aa43345204302$export$cb26d1ee6764af05(element);
    return Boolean(elementName) && elementName.includes(displayName);
}
/**
 * Applies a function `fn` to an array of children. If a `React.Fragment` is found,
 * recursively applies the same function to its `children`.
 * @param {array} children
 * @param {function} fn
 * @returns array
 */ function $175aa43345204302$export$413dd9fe11ad5ea7(children, fn) {
    return (0, $acw62.Children).map(children, (child, i)=>{
        if (child && $175aa43345204302$export$9522e17588c12572(child)) return (0, $acw62.Children).map(// @ts-expect-error assume there is a children prop
        child.props.children, (grandChild)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(grandChild) && fn(grandChild, i));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) ? fn(child, i) : child;
    });
}
/**
 * Strips down Injecss() HOC name from components
 * @param {string} compName
 * @returns string
 */ function $175aa43345204302$export$16588b807bbcb70(compName) {
    return compName.replace('Injecss(', '').replace(')', '');
}
/**
 * Filters children based on displayName. Also iterates through Fragments recursively.
 * @param {array} children
 * @param {string} displayName
 * @returns A collection of children that has the provided displayName
 */ function $175aa43345204302$export$348ae70a93bc9267(children, displayName) {
    let filteredChildren = [];
    (0, $acw62.Children).forEach(children, (child)=>{
        if ($175aa43345204302$export$9522e17588c12572(child)) {
            const nestedChildren = $175aa43345204302$export$348ae70a93bc9267(// @ts-expect-error assume there is a children prop
            child.props.children, displayName);
            filteredChildren = [
                ...filteredChildren,
                ...nestedChildren
            ];
        } else if (child && $175aa43345204302$export$16588b807bbcb70($175aa43345204302$export$cb26d1ee6764af05(child)) === displayName) filteredChildren.push(child);
    });
    return filteredChildren;
}
/**
 * Assigns ref to both innerRef and component internal ref variable.
 * Does nothing if null passed as node (preventing node callback double passes, see: https://react.dev/reference/react-dom/components/common#ref-callback)
 * @param node HTMl element
 * @param innerRef inner ref object
 * @param componentRef component ref object
 */ function $175aa43345204302$export$390003ad846c69eb(node, innerRef, componentRef) {
    if (node === null) return;
    componentRef.current = node;
    if (typeof innerRef === 'function') innerRef(node);
    else if (innerRef) // TODO resolve type assignment with `as`
    innerRef.current = node;
}




/**
 * Returns null if child is valid, returns child name if not.
 */ const $1ead597b5f273027$var$getInvalidChildName = (child, validChildName)=>{
    if (Array.isArray(validChildName)) {
        const a = validChildName.map((validName)=>$175aa43345204302$export$2dabafa86f11ed64(child, validName));
        if (a.find((result)=>result === true)) // Child is valid.
        return null;
    } else if ($175aa43345204302$export$2dabafa86f11ed64(child, validChildName)) // Child is valid.
    return null;
    // Child of invalid type, return child name.
    return $175aa43345204302$export$cb26d1ee6764af05(child);
};
/** Returns null if valid, returns error if not. */ const $1ead597b5f273027$var$validateChildrenTypes = (children, validChildName, propName, componentName)=>{
    let error = null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        // If the child is a React.Fragment, run this function again on its children
        if ($175aa43345204302$export$9522e17588c12572(child)) {
            const fragmentChild = child;
            error = $1ead597b5f273027$var$validateChildrenTypes(fragmentChild.props.children, validChildName, propName, componentName);
        } else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
            const invalidChildName = $1ead597b5f273027$var$getInvalidChildName(child, validChildName);
            if (invalidChildName !== null) error = new Error(`\`${componentName}\` only accepts \`${propName}\` of type \`${validChildName}\`, but \`${invalidChildName}\` is given.`);
        } else if (child !== null) // null check allows ternary expression to pass through
        error = new Error(`\`${componentName}\` only accepts React valid elements as children.`);
    });
    return error;
};
const $1ead597b5f273027$export$3fe9e1e5e8357d71 = (validChildName)=>(props, propName, componentName)=>{
        const prop = props[propName];
        if (prop === null || prop === undefined) // Prop wasn't specified. Throw an error.
        return new Error(`\`${propName}\` is required for \`${componentName}\`.`);
        // @ts-expect-error prop is not a component but still has children
        return $1ead597b5f273027$var$validateChildrenTypes(prop, validChildName, propName, componentName);
    };
const $1ead597b5f273027$export$9b76c83bbe136b6a = (validChildName)=>(props, propName, componentName)=>{
        const prop = props[propName];
        if (!prop) // Prop wasn't specified, this is valid, do nothing.
        return null;
        // @ts-expect-error prop is not a component but still has children
        return $1ead597b5f273027$var$validateChildrenTypes(prop, validChildName, propName, componentName);
    };
/**
 * Requires either aria-label or children to be present
 */ const $1ead597b5f273027$export$ff91b688641fa6db = (componentName)=>({ 'aria-label': ariaLabel, children: children })=>{
        // exclude null or empty arrays from valid children
        const hasChildren = children !== null && children !== undefined && !(Array.isArray(children) && children.length === 0);
        // redundant type check is for JS environments
        const hasAriaLabel = typeof ariaLabel === 'string' && ariaLabel.trim().length > 0;
        if (!hasChildren && !hasAriaLabel) return new Error(`"${componentName}" requires either children or a non-empty aria-label.`);
        return null;
    };



const $a932d1784dd52635$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('btn', (0, $7e1e4fc15c9e8e81$export$2e2bcd8739ae039));
function $a932d1784dd52635$export$353f5b6fc5456de1(_a) {
    var { appearance: appearance, RouterLink: RouterLink, extraClasses: extraClasses, innerRef: innerRef, display: display, children: children, size: size, href: href, loading: loading = false, type: type = 'button', Elem: Elem = 'button' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "appearance",
        "RouterLink",
        "extraClasses",
        "innerRef",
        "display",
        "children",
        "size",
        "href",
        "loading",
        "type",
        "Elem"
    ]);
    const buttonProps = Object.assign(Object.assign({
        className: $a932d1784dd52635$var$bem.b([
            appearance,
            display,
            size,
            {
                loading: loading
            }
        ], extraClasses)
    }, loading && {
        'aria-live': 'polite',
        'aria-busy': 'true'
    }), rest);
    if (RouterLink) {
        const routerLinkProps = Object.assign(Object.assign(Object.assign({}, innerRef ? {
            innerRef: innerRef
        } : {}), buttonProps), rest);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RouterLink, Object.assign({}, routerLinkProps), children);
    }
    if (Elem === 'span') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        ref: innerRef
    }, buttonProps), children);
    if (Elem === 'a') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        ref: innerRef,
        href: href
    }, buttonProps), children);
    return(/*#__PURE__*/ // @ts-expect-error @todo find out why TS thinks innerRef has LegacyRef<AnchorHTMLElement> type
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: innerRef,
        type: type
    }, buttonProps), children));
}
$a932d1784dd52635$export$353f5b6fc5456de1.displayName = 'Button';
$a932d1784dd52635$export$353f5b6fc5456de1.propTypes = {
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $95ad0b73abcf4f9f$export$f3ae2b2681d6a2fd)),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $95ad0b73abcf4f9f$export$73e83bf2b7e02467)),
    children: (0, $1ead597b5f273027$export$ff91b688641fa6db)('Button'),
    display: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $95ad0b73abcf4f9f$export$e1fbd9299acdd36)),
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $95ad0b73abcf4f9f$export$1b0853faebbc1e53)),
    RouterLink: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $95ad0b73abcf4f9f$export$6435cacfbaa60ff5))
};
var $a932d1784dd52635$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($a932d1784dd52635$export$353f5b6fc5456de1, (0, $7e1e4fc15c9e8e81$export$2e2bcd8739ae039));


parcelRequire("acw62");

const $a60eae65940e4f94$var$RetryButton = ({ primary: primary, persistLocalStorage: persistLocalStorage = false })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        "data-id": "retry-button",
        appearance: primary ? "primary" : undefined,
        onClick: ()=>{
            // Set expiry date of all cookies in the past (which basically removes all cookies)
            const Cookies = document.cookie.split(";");
            for(let i = 0; i < Cookies.length; i++)document.cookie = `${Cookies[i]}=; expires=${new Date(0).toUTCString()}`;
            if (!persistLocalStorage) window.localStorage.clear();
            window.location.reload();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "retry.button.text"
        })
    });
var $a60eae65940e4f94$export$2e2bcd8739ae039 = $a60eae65940e4f94$var$RetryButton;



var $e4eb122edd83e299$export$8ce1fd94bee2f412;
var $e4eb122edd83e299$export$5050f8adede8c46c;
var $e4eb122edd83e299$export$fa397790119a1408;
var $e4eb122edd83e299$export$b426df703d3b34b8;
var $e4eb122edd83e299$export$516dd90aeaaabcf0;
var $e4eb122edd83e299$export$63e82393dc8977bf;
var $e4eb122edd83e299$export$2cedfd664bb3bd01;
$e4eb122edd83e299$export$8ce1fd94bee2f412 = `ErrorPage-rg6PXW-background`;
$e4eb122edd83e299$export$5050f8adede8c46c = `ErrorPage-rg6PXW-descriptionText`;
$e4eb122edd83e299$export$fa397790119a1408 = `ErrorPage-rg6PXW-flix-theme-dark`;
$e4eb122edd83e299$export$b426df703d3b34b8 = `ErrorPage-rg6PXW-flix-theme-flix`;
$e4eb122edd83e299$export$516dd90aeaaabcf0 = `ErrorPage-rg6PXW-headline`;
$e4eb122edd83e299$export$63e82393dc8977bf = `ErrorPage-rg6PXW-imageContainer`;
$e4eb122edd83e299$export$2cedfd664bb3bd01 = `ErrorPage-rg6PXW-textContainer`;




parcelRequire("acw62");


const $6587c27c1522e65e$var$BackToMainPageButton = ({ primary: primary })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        "data-id": "back-button",
        appearance: primary ? "primary" : undefined,
        href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).userHome,
        Elem: "a",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "home.button.text"
        })
    });
var $6587c27c1522e65e$export$2e2bcd8739ae039 = $6587c27c1522e65e$var$BackToMainPageButton;




parcelRequire("acw62");


const $7ee245e49ba2e9e8$var$LogoutButton = ({ primary: primary })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        "data-id": "logout-button",
        appearance: primary ? "primary" : undefined,
        onClick: ()=>{
            (0, $bc59a856a5e4c3e2$export$a0973bcfe11b05c9)();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "navigation.logout"
        })
    });
var $7ee245e49ba2e9e8$export$2e2bcd8739ae039 = $7ee245e49ba2e9e8$var$LogoutButton;




parcelRequire("acw62");


const $8e50487a7bd8eac4$var$OpenTicketLoginButton = ({ primary: primary })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        "data-id": "ticket-login-button",
        appearance: primary ? "primary" : undefined,
        href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).serviceDeskRequestLogin,
        Elem: "a",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "serviceDesk.button.text"
        })
    });
var $8e50487a7bd8eac4$export$2e2bcd8739ae039 = $8e50487a7bd8eac4$var$OpenTicketLoginButton;




parcelRequire("acw62");


const $76f8f935b03dec69$var$OpenTicketProblemButton = ({ primary: primary })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        "data-id": "ticket-problem-button",
        appearance: primary ? "primary" : undefined,
        href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).serviceDeskReportProblem,
        Elem: "a",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "serviceDesk.button.text"
        })
    });
var $76f8f935b03dec69$export$2e2bcd8739ae039 = $76f8f935b03dec69$var$OpenTicketProblemButton;


const $2c45961a3b378f92$var$ErrorPage = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    let image;
    let headline;
    let text1;
    let text2;
    let button1;
    let button2;
    switch(type){
        case (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e401:
            image = (0, (/*@__PURE__*/$parcel$interopDefault($25d1fb3875da6dd6$exports)));
            headline = formatMessage({
                id: "error.401.secondHeadline"
            });
            text1 = formatMessage({
                id: "error.401403.description.top"
            });
            text2 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? formatMessage({
                id: "error.401403.description.bottom.bd"
            }) : formatMessage({
                id: "error.401403.description.bottom"
            });
            button1 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a60eae65940e4f94$export$2e2bcd8739ae039), {
                primary: false
            });
            button2 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e50487a7bd8eac4$export$2e2bcd8739ae039), {
                primary: true
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ee245e49ba2e9e8$export$2e2bcd8739ae039), {
                primary: true
            });
            break;
        case (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e403:
            image = (0, (/*@__PURE__*/$parcel$interopDefault($25d1fb3875da6dd6$exports)));
            headline = formatMessage({
                id: "error.403.secondHeadline"
            });
            text1 = formatMessage({
                id: "error.401403.description.top"
            });
            text2 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? formatMessage({
                id: "error.401403.description.bottom.bd"
            }) : formatMessage({
                id: "error.401403.description.bottom"
            });
            button1 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a60eae65940e4f94$export$2e2bcd8739ae039), {
                primary: false
            });
            button2 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e50487a7bd8eac4$export$2e2bcd8739ae039), {
                primary: true
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ee245e49ba2e9e8$export$2e2bcd8739ae039), {
                primary: true
            });
            break;
        case (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e404:
            image = (0, (/*@__PURE__*/$parcel$interopDefault($d9ac503a6ffa6fd1$exports)));
            headline = formatMessage({
                id: "error.404.secondHeadline"
            });
            text1 = formatMessage({
                id: "error.404.description"
            });
            text2 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                        id: "error.404.description.bottom"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                                    id: "error.404.list.item.top"
                                })
                            }, "one"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                                    id: "error.404.list.item.bottom"
                                })
                            }, "two")
                        ]
                    })
                ]
            });
            button1 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6587c27c1522e65e$export$2e2bcd8739ae039), {
                primary: true
            });
            button2 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
            break;
        case (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e500:
            image = (0, (/*@__PURE__*/$parcel$interopDefault($a4a6ad79151684d7$exports)));
            headline = formatMessage({
                id: "error.500.secondHeadline"
            });
            text1 = formatMessage({
                id: "error.500.description.top"
            });
            text2 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? formatMessage({
                id: "error.500.description.bottom"
            }) : "";
            button1 = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76f8f935b03dec69$export$2e2bcd8739ae039), {
                primary: false
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ee245e49ba2e9e8$export$2e2bcd8739ae039), {
                primary: false
            });
            button2 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a60eae65940e4f94$export$2e2bcd8739ae039), {
                primary: true
            });
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-status-code": type,
        className: $e4eb122edd83e299$export$8ce1fd94bee2f412,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $e4eb122edd83e299$export$63e82393dc8977bf,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: image,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $e4eb122edd83e299$export$2cedfd664bb3bd01,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02cbb07845aa75e9$export$2e2bcd8739ae039), {
                        extraClasses: $e4eb122edd83e299$export$516dd90aeaaabcf0,
                        size: 1,
                        children: type
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02cbb07845aa75e9$export$2e2bcd8739ae039), {
                        extraClasses: $e4eb122edd83e299$export$516dd90aeaaabcf0,
                        size: 1,
                        children: headline
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c56b2edcbeb4ad55$export$2e2bcd8739ae039), {
                        extraClasses: $e4eb122edd83e299$export$5050f8adede8c46c,
                        children: [
                            text1,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            text2
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1e32dd16d4636999$export$2e2bcd8739ae039), {
                        children: [
                            (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_MARKETPLACE_ACCESS) && button1,
                            button2
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65aec11a7212da24$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2c45961a3b378f92$export$2e2bcd8739ae039 = $2c45961a3b378f92$var$ErrorPage;


const $4986795f07a5ffe1$var$AuthErrorPage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c45961a3b378f92$export$2e2bcd8739ae039), {
        type: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e401
    });
};
var $4986795f07a5ffe1$export$2e2bcd8739ae039 = $4986795f07a5ffe1$var$AuthErrorPage;




parcelRequire("acw62");




const $4dd910a646f2cf52$var$PermissionTemplate = ({ children: children })=>{
    const activeAccount = (0, $e5e33773db31b6c0$export$83a8e409853da004)();
    const hasUserAccess = ()=>{
        let access = (0, $abefdbda3c0e307b$export$7c4451767ad4ac38)() && (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_MARKETPLACE_ACCESS);
        access = access && (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_MUS_ACCESS);
        return access;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: hasUserAccess() && activeAccount ? children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c45961a3b378f92$export$2e2bcd8739ae039), {
            type: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e403
        })
    });
};
var $4dd910a646f2cf52$export$2e2bcd8739ae039 = $4dd910a646f2cf52$var$PermissionTemplate;







var $3v7ey = parcelRequire("3v7ey");
parcelRequire("acw62");



const $fb4f81fbc5797ce9$var$UserTracking = ()=>{
    const activeAccount = (0, $e5e33773db31b6c0$export$83a8e409853da004)();
    const roles = (0, $bc59a856a5e4c3e2$export$57690667ea6b189b)();
    const userId = activeAccount ? (0, (/*@__PURE__*/$parcel$interopDefault($3v7ey)))(activeAccount.username).toString() : "unknown";
    // DATADOG
    (0, $95032d6edbc0e5a2$export$65cc181beb0d2632).setUser({
        id: userId,
        roles: (0, $bc59a856a5e4c3e2$export$57690667ea6b189b)(),
        language: (0, $61d5299c8c0ea66c$export$68274e25c3f28c82)()
    });
    window.dataLayer = window.dataLayer || [];
    // User Dimension for Roles
    if (roles) window.dataLayer.push({
        isAdmin: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_ADMIN)
    }, {
        isBd: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_BD)
    }, {
        isOp: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_OP)
    }, {
        isUserManager: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_USER_MANAGER)
    }, {
        isCapacityManager: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_CAPACITY_MANAGER)
    }, {
        isGeneralSettings: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_GENERAL_SETTINGS)
    }, {
        isPricing: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_PRICING)
    }, {
        isScheduleManager: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_SCHEDULE_MANAGER)
    }, {
        isReporting: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_REPORTING)
    }, {
        isPartner: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_PARTNER)
    }, {
        isStationManager: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_STATION_MANAGER)
    }, {
        isPowerBi: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_POWER_BI)
    }, {
        isDispatcher: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_DISPATCHER)
    }, {
        isDriver: roles.includes((0, $7fa43330bc76951a$export$2e2bcd8739ae039).ROLE_DRIVER)
    });
    // Formbricks
    if (typeof window !== "undefined" && !(0, $bc59a856a5e4c3e2$export$ca25862a9e6ee63c)()) {
        (0, $3b643887ffa5d38c$export$2e2bcd8739ae039).setup({
            environmentId: "cmgqim9gf034xkm01ehg9llac",
            appUrl: "https://surveys.cro.flix.tech"
        });
        // User is not registered yet
        if (localStorage.getItem("formbricks-js") == null) {
            (0, $3b643887ffa5d38c$export$2e2bcd8739ae039).setLanguage((0, $eff69fb1886d6e36$export$e24640604b11ca0)((0, $61d5299c8c0ea66c$export$68274e25c3f28c82)(), true).iso6391);
            (0, $3b643887ffa5d38c$export$2e2bcd8739ae039).setUserId(userId);
            (0, $3b643887ffa5d38c$export$2e2bcd8739ae039).setAttributes({
                Roles: roles ? roles.join(";") : ""
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};
var $fb4f81fbc5797ce9$export$2e2bcd8739ae039 = $fb4f81fbc5797ce9$var$UserTracking;



const $c813f840a1b0ee31$var$loginCallback = (event)=>{
    if ([
        (0, $722bc9eaf0c39f46$export$3d7865934588d77e).LOGIN_SUCCESS,
        (0, $722bc9eaf0c39f46$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS,
        (0, $722bc9eaf0c39f46$export$3d7865934588d77e).SSO_SILENT_SUCCESS
    ].includes(event.eventType) && event.payload) {
        const { account: account } = event.payload;
        (0, $a2d10b2db6923a38$export$a59c2286a7150b12).setActiveAccount(account);
    }
};
const $c813f840a1b0ee31$var$AuthProvider = ({ children: children })=>{
    (0, $a2d10b2db6923a38$export$a59c2286a7150b12).addEventCallback($c813f840a1b0ee31$var$loginCallback);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b3e52a40af96eae$export$25bac41dc3d78d47), {
        instance: (0, $a2d10b2db6923a38$export$a59c2286a7150b12),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8be22596aceaa726$export$c9cd7a02d4bd7707), {
            errorComponent: (0, $4986795f07a5ffe1$export$2e2bcd8739ae039),
            interactionType: (0, $5ff55562d73e0e2b$export$4ec29255e7e7f68f).Redirect,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb4f81fbc5797ce9$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4dd910a646f2cf52$export$2e2bcd8739ae039), {
                    children: children
                })
            ]
        })
    });
};
var $c813f840a1b0ee31$export$2e2bcd8739ae039 = $c813f840a1b0ee31$var$AuthProvider;










const $42e40739c8000d7b$var$ContactUsLink = ()=>{
    const contactLink = (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS) ? (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).serviceDeskReportProblem : `mailto:${0, $117bb602da9323ac$export$2e2bcd8739ae039}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21ca9f2bc9d1bb2f$export$2e2bcd8739ae039), {
        href: contactLink,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "general.contactUs"
        })
    });
};
var $42e40739c8000d7b$export$2e2bcd8739ae039 = $42e40739c8000d7b$var$ContactUsLink;



const $65a88248e998e932$var$DefaultInfoAlert = ({ message: message, type: type = "danger" })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a96afdb6fe86673c$export$2e2bcd8739ae039), {
        type: type,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                `${(0, $b6c6330f9af3214a$export$2e2bcd8739ae039)(message)}. ${formatMessage({
                    id: "general.info.tryAgain"
                })} `,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42e40739c8000d7b$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $65a88248e998e932$export$2e2bcd8739ae039 = $65a88248e998e932$var$DefaultInfoAlert;







var $acw62 = parcelRequire("acw62");

var $437e4c7283d6186a$export$2e2bcd8739ae039 = {
    raw: ".hcr-notification-16-4-0{align-items:center;background:var(--hcr-box-bg-color);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);color:var(--hcr-content-primary-color);display:flex;font-family:inherit;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-bold);gap:var(--hcr-spacing-2);padding:var(--hcr-spacing-2);position:relative;width:100%}.hcr-notification-16-4-0:where(:not(:last-child)){margin-bottom:var(--hcr-spacing-2)}.hcr-notification-16-4-0:before,.hcr-notification__close-16-4-0{align-self:flex-start;flex-shrink:0}.hcr-notification-16-4-0:before{background-color:var(--hcr-neutral-color);content:\"\";height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm1\\ 15a1\\ 1\\ 0\\ 01-2\\ 0v-5.5a1\\ 1\\ 0\\ 112\\ 0V17zm-1-8a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm1\\ 15a1\\ 1\\ 0\\ 01-2\\ 0v-5.5a1\\ 1\\ 0\\ 112\\ 0V17zm-1-8a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}@supports (min-height:max(var(--hcr-spacing-4 ),var(--hcr-line-height-primary ))){.hcr-notification-16-4-0:before{min-height:max(var(--hcr-spacing-4),var(--hcr-line-height-primary))}}.hcr-notification--success-16-4-0:before{background-color:var(--hcr-success-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-notification--warning-16-4-0:before{background-color:var(--hcr-warning-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-notification--danger-16-4-0:before{background-color:var(--hcr-danger-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.95\\ 13.54a1\\ 1\\ 0\\ 11-1.41\\ 1.41L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.95\\ 13.54a1\\ 1\\ 0\\ 11-1.41\\ 1.41L12\\ 13.41l-3.54\\ 3.54a1\\ 1\\ 0\\ 11-1.41-1.41L10.59\\ 12\\ 7.05\\ 8.46a1\\ 1\\ 0\\ 111.41-1.41L12\\ 10.59l3.54-3.54a1\\ 1\\ 0\\ 111.41\\ 1.41L13.41\\ 12l3.54\\ 3.54z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-notification--toast-16-4-0{--hcr-notification-toast-fade-time:300ms;--hcr-notification-toast-stay-time:4s;animation:var(--hcr-notification-toast-fade-time) fade-in-notification-top,var(--hcr-notification-toast-stay-time) var(--hcr-notification-toast-fade-time) stay-notification,var(--hcr-notification-toast-fade-time) calc(var(--hcr-notification-toast-fade-time) + var(--hcr-notification-toast-stay-time)) fade-out-notification-top;background:var(--hcr-grayscale-100-color);opacity:0;z-index:1}.hcr-notification--toast-16-4-0,.hcr-notification--toast-16-4-0 .hcr-notification__content-16-4-0 *{color:var(--hcr-grayscale-0-color)}.hcr-notification--toast-16-4-0 .hcr-notification__close-16-4-0:before{background-color:var(--hcr-grayscale-0-color)}.hcr-notification-container--bottom-left-16-4-0 .hcr-notification--toast-16-4-0,.hcr-notification-container--bottom-right-16-4-0 .hcr-notification--toast-16-4-0{animation:var(--hcr-notification-toast-fade-time) fade-in-notification-bottom,var(--hcr-notification-toast-stay-time) var(--hcr-notification-toast-fade-time) stay-notification,var(--hcr-notification-toast-fade-time) calc(var(--hcr-notification-toast-fade-time) + var(--hcr-notification-toast-stay-time)) fade-out-notification-bottom}.hcr-notification--toast-delayed-16-4-0{--hcr-notification-toast-stay-time:8s}.hcr-notification--toast-dismiss-16-4-0{animation:var(--hcr-notification-toast-fade-time) fade-in-notification-top;opacity:1}.hcr-notification-container--bottom-left-16-4-0 .hcr-notification--toast-dismiss-16-4-0,.hcr-notification-container--bottom-right-16-4-0 .hcr-notification--toast-dismiss-16-4-0{animation:var(--hcr-notification-toast-fade-time) fade-in-notification-bottom}.hcr-notification__content-16-4-0{flex-grow:1;min-width:0;overflow-wrap:anywhere}.hcr-notification__close-16-4-0{margin:calc(-1*var(--hcr-spacing-1)) calc(-1*var(--hcr-spacing-1)) calc(-1*var(--hcr-spacing-1))0}.hcr-notification__close-16-4-0:before{background-color:var(--hcr-grayscale-100-color);content:\"\";height:1.125rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-3)*2);max-width:calc(var(--hcr-spacing-3)*2);min-height:var(--hcr-spacing-3);min-width:var(--hcr-spacing-3);width:1.125rem}.hcr-notification-container-16-4-0{position:fixed;width:100%;z-index:1209}.hcr-notification-container-16-4-0:not(:empty){padding:var(--hcr-spacing-2)}@media (min-width:600px){.hcr-notification-container-16-4-0{width:auto}.hcr-notification-container-16-4-0:not(:empty){padding:var(--hcr-spacing-6)}}.hcr-notification-container--top-right-16-4-0,.hcr-notification-container-16-4-0{right:0;top:0}.hcr-notification-container--top-left-16-4-0{left:0;right:auto;top:0}.hcr-notification-container--bottom-left-16-4-0{bottom:0;left:0;right:auto;top:auto}.hcr-notification-container--bottom-right-16-4-0{bottom:0;right:0;top:auto}@keyframes fade-in-notification-top{0%{opacity:0;transform:translateY(calc(-1*var(--hcr-spacing-4)))}to{opacity:1;transform:translateY(0)}}@keyframes fade-in-notification-bottom{0%{opacity:1;transform:translateY(var(--hcr-spacing-4))}to{opacity:1;transform:translateY(0)}}@keyframes stay-notification{0%{opacity:1}to{opacity:1}}@keyframes fade-out-notification-top{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(calc(-1*var(--hcr-spacing-4)))}}@keyframes fade-out-notification-bottom{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(var(--hcr-spacing-4))}}",
    map: {
        "hcr-notification": "hcr-notification-16-4-0",
        "hcr-notification__close": "hcr-notification__close-16-4-0",
        "hcr-notification--success": "hcr-notification--success-16-4-0",
        "hcr-notification--warning": "hcr-notification--warning-16-4-0",
        "hcr-notification--danger": "hcr-notification--danger-16-4-0",
        "hcr-notification--toast": "hcr-notification--toast-16-4-0",
        "hcr-notification__content": "hcr-notification__content-16-4-0",
        "hcr-notification-container--bottom-left": "hcr-notification-container--bottom-left-16-4-0",
        "hcr-notification-container--bottom-right": "hcr-notification-container--bottom-right-16-4-0",
        "hcr-notification--toast-delayed": "hcr-notification--toast-delayed-16-4-0",
        "hcr-notification--toast-dismiss": "hcr-notification--toast-dismiss-16-4-0",
        "hcr-notification-container": "hcr-notification-container-16-4-0",
        "hcr-notification-container--top-right": "hcr-notification-container--top-right-16-4-0",
        "hcr-notification-container--top-left": "hcr-notification-container--top-left-16-4-0"
    }
};






const $9116502358b7f78a$export$da9eede32b29a2e8 = [
    'danger',
    'warning',
    'success'
];




const $f4c815c3962a486f$var$TOAST_COUNTDOWN = 4000; // 4s is the toast animation length
const $f4c815c3962a486f$var$TOAST_DELAYED_COUNTDOWN = 8000; // 8s is the delayed toast animation length
const $f4c815c3962a486f$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('notification', (0, $437e4c7283d6186a$export$2e2bcd8739ae039));
function $f4c815c3962a486f$export$14834abbfce3b8cd(_a) {
    var { appearance: appearance, children: children, closeProps: closeProps, extraClasses: extraClasses, dismissCallback: dismissCallback, innerRef: innerRef, toast: toast = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "appearance",
        "children",
        "closeProps",
        "extraClasses",
        "dismissCallback",
        "innerRef",
        "toast"
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (toast && toast !== 'dismiss' && typeof dismissCallback === 'function') {
            const dismissCallbackCountdown = toast === 'delayed' ? $f4c815c3962a486f$var$TOAST_DELAYED_COUNTDOWN : $f4c815c3962a486f$var$TOAST_COUNTDOWN;
            window.setTimeout(()=>{
                if (ref.current) dismissCallback(ref.current);
            }, dismissCallbackCountdown);
        }
    }, [
        toast
    ]);
    const handleCloseOnClick = (event)=>{
        closeProps === null || closeProps === void 0 || closeProps.onClick(event, ref.current);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", Object.assign({
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, ref);
        },
        className: $f4c815c3962a486f$var$bem.b([
            appearance,
            {
                toast: toast,
                'toast-delayed': toast === 'delayed',
                'toast-dismiss': toast === 'dismiss'
            }
        ], extraClasses),
        role: "alert",
        "aria-live": appearance === 'danger' ? 'assertive' : 'polite'
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $f4c815c3962a486f$var$bem.e('content')
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), Object.assign({
        appearance: "link",
        display: "square",
        size: "md",
        extraClasses: $f4c815c3962a486f$var$bem.e('close')
    }, closeProps, {
        onClick: handleCloseOnClick
    })));
}
$f4c815c3962a486f$export$14834abbfce3b8cd.displayName = 'Notification';
$f4c815c3962a486f$export$14834abbfce3b8cd.propTypes = {
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $9116502358b7f78a$export$da9eede32b29a2e8)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    closeProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
    }),
    dismissCallback: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
            ])
        })
    ]),
    toast: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'delayed',
            'dismiss'
        ])
    ])
};
var $f4c815c3962a486f$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($f4c815c3962a486f$export$14834abbfce3b8cd, (0, $437e4c7283d6186a$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");






const $3351c4355a508754$export$afa03a2d827c06f7 = [
    'top-right',
    'top-left',
    'bottom-left',
    'bottom-right'
];



const $eecab1b4733edcf7$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('notification-container', (0, $437e4c7283d6186a$export$2e2bcd8739ae039));
function $eecab1b4733edcf7$export$aef1c47d6b127917(_a) {
    var { children: children, extraClasses: extraClasses, innerRef: innerRef, position: position = 'top-right' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "innerRef",
        "position"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: $eecab1b4733edcf7$var$bem.b([
            position
        ], extraClasses)
    }, rest), children);
}
$eecab1b4733edcf7$export$aef1c47d6b127917.displayName = 'NotificationContainer';
$eecab1b4733edcf7$export$aef1c47d6b127917.propTypes = {
    children: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('Notification'),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
            ])
        })
    ]),
    position: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $3351c4355a508754$export$afa03a2d827c06f7))
};
var $eecab1b4733edcf7$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($eecab1b4733edcf7$export$aef1c47d6b127917, (0, $437e4c7283d6186a$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
const $97239caf4718583a$var$usePrevious = (value)=>{
    const ref = $acw62.useRef();
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $97239caf4718583a$export$2e2bcd8739ae039 = $97239caf4718583a$var$usePrevious;


var $c1dc12bb9459c036$export$fa397790119a1408;
var $c1dc12bb9459c036$export$b426df703d3b34b8;
var $c1dc12bb9459c036$export$89904e92e034c0f5;
$c1dc12bb9459c036$export$fa397790119a1408 = `Notification-MACsLW-flix-theme-dark`;
$c1dc12bb9459c036$export$b426df703d3b34b8 = `Notification-MACsLW-flix-theme-flix`;
$c1dc12bb9459c036$export$89904e92e034c0f5 = `Notification-MACsLW-notificationContainer`;


var $e34e0d66636b867f$export$2e2bcd8739ae039 = (oldArray, newArray)=>newArray.filter((newNotification)=>!oldArray.some((oldNotification)=>oldNotification?.id === newNotification?.id));



const $46eede1f4ee6ca47$var$notificationsVar = (0, $0b37964519c908de$export$5345c8ac69b4a9db)([]);
var $46eede1f4ee6ca47$export$2e2bcd8739ae039 = $46eede1f4ee6ca47$var$notificationsVar;


const $a25d5bfa152eee5b$export$921a032020d7fa9d = (notificationId)=>{
    const notifications = (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)();
    const notificationsArr = [
        ...notifications
    ];
    const findNotificationById = (id)=>notificationsArr.findIndex((ele)=>ele.id === id);
    const removeItemFromNotifications = (index)=>{
        notificationsArr.splice(index, 1);
    };
    removeItemFromNotifications(findNotificationById(notificationId));
    (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)(notificationsArr);
};
const $a25d5bfa152eee5b$export$c832f5d77d2ac427 = ()=>{
    const notifications = (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)();
    if (notifications.length) (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)([]);
};



const $ea526ae3f61bb245$var$Notification = ()=>{
    const notifications = (0, $550d697bbc914bec$export$b10e3d92c03f6472)((0, $46eede1f4ee6ca47$export$2e2bcd8739ae039));
    const prevNotifications = (0, $97239caf4718583a$export$2e2bcd8739ae039)(notifications);
    $acw62.useEffect(()=>{
        let newItems;
        if (!prevNotifications) newItems = [
            ...notifications
        ];
        else newItems = (0, $e34e0d66636b867f$export$2e2bcd8739ae039)(prevNotifications, notifications);
        newItems.forEach((item)=>{
            if (!item.isPermanent) setTimeout(()=>(0, $a25d5bfa152eee5b$export$921a032020d7fa9d)(item.id), 4000);
        });
    }, [
        notifications
    ]);
    if (notifications.length > 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eecab1b4733edcf7$export$2e2bcd8739ae039), {
        position: "bottom-right",
        extraClasses: $c1dc12bb9459c036$export$89904e92e034c0f5,
        children: notifications.map((notification)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4c815c3962a486f$export$2e2bcd8739ae039), {
                "data-id": notification.id,
                appearance: notification.type,
                toast: !notification.isPermanent,
                closeProps: {
                    onClick: ()=>(0, $a25d5bfa152eee5b$export$921a032020d7fa9d)(notification.id),
                    "aria-label": "close notification"
                },
                children: notification.message
            }, notification.id);
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};
var $ea526ae3f61bb245$export$2e2bcd8739ae039 = $ea526ae3f61bb245$var$Notification;


const $75a6d1d5d86ebb3c$var$generateNotificationId = ()=>{
    // https://gist.github.com/gordonbrander/2230317#gistcomment-1713405
    return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
};
var $75a6d1d5d86ebb3c$export$2e2bcd8739ae039 = $75a6d1d5d86ebb3c$var$generateNotificationId;



const $6d4b5f61eb7ea5e7$var$addNotification = (variables)=>{
    const notifications = (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)();
    const newNotification = {
        id: (0, $75a6d1d5d86ebb3c$export$2e2bcd8739ae039)(),
        type: variables.type,
        message: variables.message,
        age: Date.now(),
        isPermanent: variables.isPermanent
    };
    (0, $46eede1f4ee6ca47$export$2e2bcd8739ae039)([
        ...notifications,
        newNotification
    ]);
};
var $6d4b5f61eb7ea5e7$export$2e2bcd8739ae039 = $6d4b5f61eb7ea5e7$var$addNotification;






var $acw62 = parcelRequire("acw62");

var $9d6cb387b04a6cff$export$2e2bcd8739ae039 = {
    raw: ".hcr-popup-16-4-0{bottom:0;display:flex;left:0;opacity:0;place-content:center;place-items:center;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:1100}.hcr-popup-16-4-0[hidden]{display:none}.hcr-popup--active-16-4-0{opacity:1}.hcr-popup__body-16-4-0{background:var(--hcr-box-bg-color);border-radius:var(--hcr-border-radius-1);display:flex;flex-direction:column;max-height:80vh;max-width:600px;overflow:hidden;padding:0 var(--hcr-spacing-4) var(--hcr-spacing-4);scale:.95;text-align:center;transition:scale .25s ease;width:95%;z-index:1101}@media (min-width:390px){.hcr-popup__body-16-4-0{width:80%}}.hcr-popup--active-16-4-0 .hcr-popup__body-16-4-0{scale:1}.hcr-popup__title-16-4-0{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-size:var(--hcr-font-size-h1);font-weight:var(--hcr-font-weight-bold);line-height:var(--hcr-line-height-h1)}.hcr-popup__content-16-4-0,.hcr-popup__icon-16-4-0,.hcr-popup__title-16-4-0{margin:0 0 var(--hcr-spacing-2)}.hcr-popup__content-16-4-0:first-child,.hcr-popup__icon-16-4-0:first-child,.hcr-popup__title-16-4-0:first-child{padding-top:var(--hcr-spacing-4)}.hcr-popup__content-16-4-0 .hcr-popup__icon-16-4-0:first-child,.hcr-popup__content-16-4-0 .hcr-popup__title-16-4-0:first-child{padding-top:0}.hcr-popup__content-16-4-0{background:linear-gradient(var(--hcr-box-bg-color),#fff0),linear-gradient(#fff0,var(--hcr-box-bg-color)),linear-gradient(var(--hcr-box-shadow-subtle-color),#fff0),linear-gradient(#fff0,var(--hcr-box-shadow-subtle-color));background-attachment:local,local,scroll,scroll;background-position:0 0,0 100%,0 0,0 100%;background-repeat:no-repeat;background-size:100% var(--hcr-spacing-4),100% var(--hcr-spacing-4),100% var(--hcr-spacing-1),100% var(--hcr-spacing-1);color:var(--hcr-container-content-color,var(--hcr-content-primary-color));font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-primary);margin-left:calc(var(--hcr-spacing-4)*-1);margin-right:calc(var(--hcr-spacing-4)*-1);overflow-y:auto;padding-left:var(--hcr-spacing-4);padding-right:var(--hcr-spacing-4)}.hcr-popup__content-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) - 2px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:-2px}.hcr-popup__actions-16-4-0{display:flex;flex-flow:row wrap;gap:var(--hcr-spacing-2);justify-content:center}",
    map: {
        "hcr-popup": "hcr-popup-16-4-0",
        "hcr-popup--active": "hcr-popup--active-16-4-0",
        "hcr-popup__body": "hcr-popup__body-16-4-0",
        "hcr-popup__title": "hcr-popup__title-16-4-0",
        "hcr-popup__icon": "hcr-popup__icon-16-4-0",
        "hcr-popup__content": "hcr-popup__content-16-4-0",
        "hcr-popup__actions": "hcr-popup__actions-16-4-0"
    }
};








var $acw62 = parcelRequire("acw62");
/*
https://github.com/KittyGiraudel/focusable-selectors

The MIT License (MIT)
Copyright (c) 2021 Kitty Giraudel

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
associated documentation files (the "Software"), to deal in the Software without restriction,
including without limitation the rights to use, copy, modify, merge, publish, distribute,
sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial
portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ const $eb7fb8287ea3dabf$var$not = {
    inert: ':not([inert])',
    negTabIndex: ':not([tabindex^="-"])',
    disabled: ':not(:disabled)'
};
var $eb7fb8287ea3dabf$export$2e2bcd8739ae039 = [
    `a[href]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `area[href]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `input:not([type="hidden"]):not([type="radio"])${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}${$eb7fb8287ea3dabf$var$not.disabled}`,
    `input[type="radio"]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}${$eb7fb8287ea3dabf$var$not.disabled}`,
    `select${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}${$eb7fb8287ea3dabf$var$not.disabled}`,
    `textarea${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}${$eb7fb8287ea3dabf$var$not.disabled}`,
    `button${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}${$eb7fb8287ea3dabf$var$not.disabled}`,
    `details${$eb7fb8287ea3dabf$var$not.inert} > summary:first-of-type${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    // Discard until Firefox supports `:has()`
    // See: https://github.com/KittyGiraudel/focusable-selectors/issues/12
    // `details:not(:has(> summary))${not.inert}${not.negTabIndex}`,
    `iframe${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `audio[controls]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `video[controls]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `[contenteditable]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`,
    `[tabindex]${$eb7fb8287ea3dabf$var$not.inert}${$eb7fb8287ea3dabf$var$not.negTabIndex}`
];



var $acw62 = parcelRequire("acw62");
/**
 * A hook that returns true on the first render of a component and false on all subsequent renders.
 *
 * @since 12.2.0
 */ function $e78f42959ed806ba$export$5964c316e853650f() {
    const isFirstRender = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
}


/** Handles the tab key when focus trap is set on a given container element.
 *
 * @since 8.8.0
 * @param {boolean} active - Whether the container is active/visible or not.
 * @param {HTMLElement | null} container - The container element to set the focus trap on.
 * @param {HTMLElement | null} target - The target element to return focus to when the container is
 * closed.
 * @param {boolean} skipInitialFocus - Whether to skip setting the initial focus when container is
 * opened. E.g.: if the component handles it on its own, like the SubMenu that can set the initial
 * focus on the last element.
 * @since 13.6.0
 * @param skipAfterFocus - Whether to skip setting the after focus when container is
 * closed. E.g.: if the component handles it on its own,
 * like the SubMenu that doesn't require setting the focus when it's closed with the mouse click
 * @private This hook is private because it is very specific to our internal use cases and its API
 * is not stable enough for public use.
 */ function $0da343143cf6cd49$export$bf0846d1a7c2b80(active, container, target, skipInitialFocus, skipAfterFocus) {
    const isFirstRender = (0, $e78f42959ed806ba$export$5964c316e853650f)();
    const [firstInteractiveElement, setFirstInteractiveElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const [lastInteractiveElement, setLastInteractiveElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    /* Set focus to target element when popup is closed, but is not the first render. */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active && !skipAfterFocus && isFirstRender === false) target === null || target === void 0 || target.focus();
    }, [
        active
    ]);
    /* Set focus to first interactive element when popup is opened and finishes loading. */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active && firstInteractiveElement && !skipInitialFocus) firstInteractiveElement.focus();
    }, [
        active,
        firstInteractiveElement,
        skipInitialFocus
    ]);
    /* When component is active and no longer loading,
   * find the first and last interactive elements and store them. */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active && container) {
            const allInteractiveElements = container.querySelectorAll((0, $eb7fb8287ea3dabf$export$2e2bcd8739ae039).join(','));
            const firstElement = allInteractiveElements === null || allInteractiveElements === void 0 ? void 0 : allInteractiveElements.item(0);
            const lastElement = allInteractiveElements === null || allInteractiveElements === void 0 ? void 0 : allInteractiveElements.item(allInteractiveElements.length - 1);
            setFirstInteractiveElement(firstElement);
            setLastInteractiveElement(lastElement);
        }
    }, [
        active,
        container
    ]);
    const handleTabKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>{
        const { target: eventTarget } = event;
        if (event.key !== 'Tab' || eventTarget !== firstInteractiveElement && eventTarget !== lastInteractiveElement) return;
        if (eventTarget === firstInteractiveElement && event.shiftKey) {
            event.preventDefault();
            lastInteractiveElement === null || lastInteractiveElement === void 0 || lastInteractiveElement.focus();
        }
        if (eventTarget === lastInteractiveElement && !event.shiftKey) {
            event.preventDefault();
            firstInteractiveElement === null || firstInteractiveElement === void 0 || firstInteractiveElement.focus();
        }
    }, [
        firstInteractiveElement,
        lastInteractiveElement
    ]);
    return {
        handleTabKeyDown: handleTabKeyDown,
        firstInteractiveElement: firstInteractiveElement,
        lastInteractiveElement: lastInteractiveElement
    };
}



var $acw62 = parcelRequire("acw62");
const $d0edf3fbeebd7107$export$2f66101556f91cda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    active: false
});
const $d0edf3fbeebd7107$export$6b0a8531a102393f = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($d0edf3fbeebd7107$export$2f66101556f91cda);




var $acw62 = parcelRequire("acw62");

var $a44d6a4665af43ad$export$2e2bcd8739ae039 = {
    raw: ".hcr-overlay-16-4-0{background:var(--hcr-overlay-bg-color);height:100%;left:0;position:fixed;top:0;width:100%;z-index:1100}",
    map: {
        "hcr-overlay": "hcr-overlay-16-4-0"
    }
};






const $c3a9b3faf56c39c9$var$bemOverlay = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('overlay', (0, $a44d6a4665af43ad$export$2e2bcd8739ae039));
function $c3a9b3faf56c39c9$export$c6fdb837b070b4ff(_a) {
    var { extraClasses: extraClasses, innerRef: innerRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: $c3a9b3faf56c39c9$var$bemOverlay.b(false, extraClasses)
    }, rest));
}
$c3a9b3faf56c39c9$export$c6fdb837b070b4ff.displayName = 'Overlay';
$c3a9b3faf56c39c9$export$c6fdb837b070b4ff.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
            ])
        })
    ])
};
var $c3a9b3faf56c39c9$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($c3a9b3faf56c39c9$export$c6fdb837b070b4ff, (0, $a44d6a4665af43ad$export$2e2bcd8739ae039));




var $acw62 = parcelRequire("acw62");
function $cc75eba7bd5380d9$var$createRootElement(id) {
    const rootElement = document.createElement('div');
    rootElement.setAttribute('id', id);
    return rootElement;
}
/**
 * @link https://react.dev/reference/react-dom/createPortal
 * @since 2.4.0
 *
 * Returns an existing or newly created Element with the given id, to be used as the container
 * for the createPortal API.
 */ function $cc75eba7bd5380d9$export$b1072f43c67b540c(id) {
    const containerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const existingParent = document.getElementById(id);
        const parentElement = existingParent || $cc75eba7bd5380d9$var$createRootElement(id);
        if (!existingParent) document.body.appendChild(parentElement);
        containerRef.current && parentElement.appendChild(containerRef.current);
        return ()=>{
            var _a;
            (_a = containerRef.current) === null || _a === void 0 || _a.remove();
            // only remove if the element was created with the hook
            if (!existingParent && !parentElement.childElementCount) parentElement.remove();
        };
    }, [
        id
    ]);
    const getContainerElem = ()=>{
        if (!containerRef.current) containerRef.current = document.createElement('div');
        return containerRef.current;
    };
    return getContainerElem();
}



var $acw62 = parcelRequire("acw62");

/**
 * @since 9.4.0
 *
 * Adds a delay between toggling the `hidden` attribute and the `--active` modifier.
 * 250ms is the default transition time for honeycomb animations.
 * If the two props are set at the same time, the CSS transition doesn't happen.
 *
 * @param {boolean} active - indicates if the component is active
 * @return `[boolean, boolean]` respective values for `hidden` attribute and `--active` modifier
 */ function $67561704b17d0e15$export$a8eea371d4bdec47(active) {
    const [win] = (0, $a2044d38a0bc3f8e$export$f0dc76b03756ac7e)();
    const [hiddenAttr, setHiddenAttr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!active);
    const [activeModifier, setActiveModifier] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(active);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active) {
            setHiddenAttr(false);
            win === null || win === void 0 || win.setTimeout(()=>{
                setActiveModifier(true);
            }, 50);
        }
        if (!active) {
            win === null || win === void 0 || win.setTimeout(()=>{
                setHiddenAttr(true);
            }, 250);
            setActiveModifier(false);
        }
    }, [
        active
    ]);
    return [
        hiddenAttr,
        activeModifier
    ];
}



var $acw62 = parcelRequire("acw62");

/**
 * @since 12.5.0 as `useLockBodyScroll`
 * @since 10.0.0 as `useBodyStyleModifications`
 *
 * A hook that blocks the document body from scrolling when active.
 */ function $2281ea219ab01c59$export$bd4ec12442706c3d(active) {
    const [, doc] = (0, $a2044d38a0bc3f8e$export$f0dc76b03756ac7e)();
    /**
   * When the modal is opened should block users from scrolling the document body.
   * This does not happen when is not modal (hasOverlay = false) or if customer has disabled it.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (doc !== null) {
            const scrollbarWidth = Math.abs(doc.defaultView.innerWidth - doc.documentElement.clientWidth);
            const scrollBarInPix = `${scrollbarWidth}px`;
            if (active) {
                doc.body.style.overflow = 'hidden';
                doc.body.style.paddingRight = scrollBarInPix;
            } else {
                doc.body.style.removeProperty('overflow');
                doc.body.style.removeProperty('padding-right');
            }
        }
        // removing overflow when component is unmounted
        return ()=>{
            if (doc !== null) {
                const scrollbarWidth = Math.abs(doc.defaultView.innerWidth - doc.documentElement.clientWidth);
                const scrollBarInPix = `${scrollbarWidth}px`;
                if (doc.body.style.overflow === 'hidden') doc.body.style.removeProperty('overflow');
                if (doc.body.style.paddingRight === scrollBarInPix) doc.body.style.removeProperty('padding-right');
            }
        };
    }, [
        doc,
        active
    ]);
}


const $b171853a489870c3$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('popup', (0, $9d6cb387b04a6cff$export$2e2bcd8739ae039));
function $b171853a489870c3$export$129a32eedafa97c5(_a) {
    var { id: id, active: active = false, children: children, extraClasses: extraClasses = '', portalId: portalId, onOverlayClick: onOverlayClick, innerRef: innerRef, targetRef: targetRef, loading: loading, disableBodyStyleModifications: disableBodyStyleModifications = false, disableFocusManagement: disableFocusManagement = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "active",
        "children",
        "extraClasses",
        "portalId",
        "onOverlayClick",
        "innerRef",
        "targetRef",
        "loading",
        "disableBodyStyleModifications",
        "disableFocusManagement"
    ]);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const container = portalId && (0, $cc75eba7bd5380d9$export$b1072f43c67b540c)(portalId);
    const [hiddenAttr, activeModifier] = (0, $67561704b17d0e15$export$a8eea371d4bdec47)(active);
    // Tab trap activates with the `activeModifier`, to be sure the `hidden` attribute is gone before
    // querying for the focusable elements
    const activeAndLoaded = activeModifier && !loading;
    const tabTrap = !disableFocusManagement ? (0, $0da343143cf6cd49$export$bf0846d1a7c2b80)(activeAndLoaded, popupRef.current, targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) : null;
    if (!disableBodyStyleModifications) (0, $2281ea219ab01c59$export$bd4ec12442706c3d)(active);
    const handleKeyDown = (event)=>{
        var _a, _b;
        // Listen to Escape button press to close Popup with keyboard
        if (event.key === 'Escape' || event.key === 'Esc') {
            onOverlayClick === null || onOverlayClick === void 0 || onOverlayClick(event);
            event.stopPropagation();
        }
        (_a = tabTrap === null || tabTrap === void 0 ? void 0 : tabTrap.handleTabKeyDown) === null || _a === void 0 || _a.call(tabTrap, event);
        (_b = rest.onKeyDown) === null || _b === void 0 || _b.call(rest, event);
    };
    const popupState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            active: !hiddenAttr,
            loading: loading
        }), [
        hiddenAttr,
        loading
    ]);
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ const popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, popupRef);
        },
        id: id,
        role: "alertdialog",
        "aria-modal": "true",
        className: $b171853a489870c3$var$bem.b({
            active: activeModifier
        }, extraClasses),
        hidden: hiddenAttr
    }, loading !== undefined ? {
        'aria-live': 'polite',
        'aria-busy': loading
    } : {}, rest, {
        onKeyDown: handleKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d0edf3fbeebd7107$export$2f66101556f91cda).Provider, {
        value: popupState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $b171853a489870c3$var$bem.e('body')
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3a9b3faf56c39c9$export$2e2bcd8739ae039), {
        onClick: onOverlayClick
    })));
    // wrapping this in a fragment to satisfy babel `remove-prop-types` plugin,
    // so it recognizes this as a valid react component (the plugin needs to see React.createElement (or JSX) returned)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, container ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(popup, container) : popup);
}
$b171853a489870c3$export$129a32eedafa97c5.displayName = 'Popup';
$b171853a489870c3$export$129a32eedafa97c5.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    onOverlayClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    portalId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    targetRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    disableBodyStyleModifications: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    disableFocusManagement: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $b171853a489870c3$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($b171853a489870c3$export$129a32eedafa97c5, (0, $9d6cb387b04a6cff$export$2e2bcd8739ae039));



parcelRequire("acw62");
var $039ba91dcf79e1aa$export$e75aed950cf2f092;
var $039ba91dcf79e1aa$export$5b5b70a4d6ca0c4f;
var $039ba91dcf79e1aa$export$5aa96c65591d2b44;
var $039ba91dcf79e1aa$export$63b4813c5280c707;
$039ba91dcf79e1aa$export$e75aed950cf2f092 = `Popup-EzJaOW-allowOverflow`;
$039ba91dcf79e1aa$export$5b5b70a4d6ca0c4f = `Popup-EzJaOW-contentLeft`;
$039ba91dcf79e1aa$export$5aa96c65591d2b44 = `Popup-EzJaOW-isWide`;
$039ba91dcf79e1aa$export$63b4813c5280c707 = `Popup-EzJaOW-popup`;


const $8d17a23dd82c8412$var$Popup = ({ active: active, onClose: onClose, isLeft: isLeft, allowOverflow: allowOverflow, isWide: isWide, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b171853a489870c3$export$2e2bcd8739ae039), {
            "data-id": active ? "active-popup" : "inactive-popup",
            active: active,
            extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($039ba91dcf79e1aa$export$63b4813c5280c707, isLeft && $039ba91dcf79e1aa$export$5b5b70a4d6ca0c4f, allowOverflow && $039ba91dcf79e1aa$export$e75aed950cf2f092, isWide && $039ba91dcf79e1aa$export$5aa96c65591d2b44),
            onOverlayClick: onClose,
            children: children
        })
    });
};
var $8d17a23dd82c8412$export$2e2bcd8739ae039 = $8d17a23dd82c8412$var$Popup;



parcelRequire("acw62");
const $ea7698691ea46cd5$var$DisableBodyScroll = ({ active: active })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
            children: "body { overflow: hidden}"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
    });
};
var $ea7698691ea46cd5$export$2e2bcd8739ae039 = $ea7698691ea46cd5$var$DisableBodyScroll;


const $d201893169ea3ce2$var$LANGUAGE_SWITCHER_PORTAL_ID = "language-switcher-portal";
var $d201893169ea3ce2$export$2e2bcd8739ae039 = $d201893169ea3ce2$var$LANGUAGE_SWITCHER_PORTAL_ID;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $f4713e20c85afaf3$export$ada278d15ed54cfa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $f4713e20c85afaf3$export$159d014d924da02({ bem: bem, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f4713e20c85afaf3$export$ada278d15ed54cfa.Provider, {
        value: bem
    }, children);
}
const $f4713e20c85afaf3$export$420afa8e158527b1 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f4713e20c85afaf3$export$ada278d15ed54cfa);





const $aba69dbc69cc1344$export$e9e5a7d9e5571844 = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    'none'
];


const $cbf6628f25c8cc8f$var$bemFlag = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('flag');
const $cbf6628f25c8cc8f$var$HC_FLAGS_VERSION = '2.0.0';
const $cbf6628f25c8cc8f$var$DEFAULT_SPACING_MULTIPLIER = 6;
/** @since 5.2.0 */ function $cbf6628f25c8cc8f$export$48ea269755562084(_a) {
    var { countryCode: countryCode, countryName: countryName, extraClasses: extraClasses, modifier: modifier, size: size = 4, version: version = $cbf6628f25c8cc8f$var$HC_FLAGS_VERSION } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "countryCode",
        "countryName",
        "extraClasses",
        "modifier",
        "size",
        "version"
    ]);
    const bemContext = (0, $f4713e20c85afaf3$export$420afa8e158527b1)();
    const bem = bemContext ? bemContext.e('flag', modifier, extraClasses) : $cbf6628f25c8cc8f$var$bemFlag.b(modifier, extraClasses);
    let width;
    let height;
    if (size !== 'none') {
        const sizeValue = size * $cbf6628f25c8cc8f$var$DEFAULT_SPACING_MULTIPLIER;
        width = sizeValue;
        height = sizeValue;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", Object.assign({
        className: bem,
        src: `https://honeycomb-assets.hive.flixbus.com/honeycomb-flags-static/${version}/svg/${countryCode}.svg`,
        alt: countryName,
        width: width,
        height: height
    }, rest));
}
$cbf6628f25c8cc8f$export$48ea269755562084.displayName = 'Flag';
$cbf6628f25c8cc8f$export$48ea269755562084.propTypes = {
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    countryName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    modifier: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $aba69dbc69cc1344$export$e9e5a7d9e5571844))
};



var $acw62 = parcelRequire("acw62");


var $9fbcddfadd621cef$export$2e2bcd8739ae039 = {
    raw: ".hcr-language-switcher-16-4-0{align-items:center;display:flex;height:100%}.hcr-language-switcher__toggle-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:inherit;display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-1);text-decoration:none}.hcr-language-switcher__toggle-16-4-0 .hcr-icon-16-4-0,.hcr-language-switcher__toggle-16-4-0 [class^=hci-icon]{line-height:1}.hcr-language-switcher__toggle-16-4-0 .hcr-icon-16-4-0:before,.hcr-language-switcher__toggle-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-language-switcher__toggle-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);text-align:inherit}.hcr-language-switcher__toggle-16-4-0[aria-expanded]:after{background-color:var(--hcr-header-color);content:\"\";height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-language-switcher__toggle-16-4-0[aria-expanded=true]:after{transform:rotate(180deg)}.hcr-language-switcher__toggle-16-4-0[aria-expanded=true]+.hcr-header-burger-menu-subnav-16-4-0:not([hidden]),.hcr-language-switcher__toggle-16-4-0[aria-expanded=true]+.hcr-header-nav-subnav-16-4-0:not([hidden]){display:block}.hcr-language-switcher__toggle-16-4-0:enabled:hover,.hcr-language-switcher__toggle-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-language-switcher__toggle-16-4-0:enabled:active,.hcr-language-switcher__toggle-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-language-switcher__toggle-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-header-burger-menu__widgets-16-4-0 .hcr-language-switcher__toggle-16-4-0{padding:var(--hcr-spacing-1);width:100%}.hcr-language-switcher__flag-16-4-0{border-radius:100%;display:inline-block;height:var(--hcr-spacing-4);width:var(--hcr-spacing-4)}.hcr-language-switcher-popup-16-4-0{bottom:0;display:none;left:0;margin:0 auto;max-width:var(--hcr-page-max-width);min-width:var(--hcr-page-min-width);padding:0 var(--hcr-spacing-2);position:fixed;right:0;top:0;z-index:1100}.hcr-language-switcher-popup-16-4-0:not([hidden]){align-items:center;column-gap:var(--hcr-spacing-2);display:grid;grid-template-columns:repeat(4,1fr);grid-template-rows:100vh auto}@media (min-width:1024px){.hcr-language-switcher-popup-16-4-0:not([hidden]){grid-template-columns:repeat(12,1fr)}}.hcr-language-switcher-popup__body-16-4-0{background:var(--hcr-box-bg-color);border-radius:var(--hcr-border-radius-1);display:grid;grid-column:1/span 4;grid-template-columns:auto min-content;height:-moz-fit-content;height:fit-content;max-height:80vh;overflow-y:auto;padding:var(--hcr-spacing-4);position:relative;z-index:1101}@media (min-width:1024px){.hcr-language-switcher-popup__body-16-4-0{grid-column:2/span 10}}.hcr-language-switcher-popup__region-16-4-0{grid-column:1}.hcr-language-switcher-popup__region-16-4-0:not(:last-child){border-bottom:1px solid var(--hcr-line-primary-color);margin-bottom:var(--hcr-spacing-2);padding-bottom:var(--hcr-spacing-2)}.hcr-language-switcher-popup__list-16-4-0{column-gap:var(--hcr-spacing-1);display:grid;grid-template-columns:repeat(2,1fr);list-style-type:none;margin:0;padding:0}.hcr-language-switcher-popup__list-16-4-0:not(:last-child){margin-bottom:var(--hcr-spacing-2)}@media (min-width:768px){.hcr-language-switcher-popup__list-16-4-0{grid-template-columns:repeat(4,1fr)}}.hcr-language-switcher-popup__region--columns-16-4-0 .hcr-language-switcher-popup__list-16-4-0{column-count:2;display:block}@media (min-width:768px){.hcr-language-switcher-popup__region--columns-16-4-0 .hcr-language-switcher-popup__list-16-4-0{column-count:4}}.hcr-language-switcher-popup__region--columns-16-4-0 .hcr-language-switcher-popup__item-16-4-0{break-inside:avoid;display:flex}.hcr-language-switcher-popup__link-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);text-align:inherit}.hcr-language-switcher-popup__link-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-secondary-color);cursor:pointer;display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);margin:var(--hcr-spacing-half)0;padding:var(--hcr-spacing-1) var(--hcr-spacing-half);position:relative;text-decoration:none;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-language-switcher-popup__link-16-4-0 .hcr-icon-16-4-0,.hcr-language-switcher-popup__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-language-switcher-popup__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-language-switcher-popup__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-language-switcher-popup__link-16-4-0:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-language-switcher-popup__link-16-4-0:enabled:active,.hcr-language-switcher-popup__link-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-language-switcher-popup__link-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 0) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:0}.hcr-language-switcher-popup__link-16-4-0[aria-current]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);padding-left:var(--hcr-spacing-2);position:relative}.hcr-language-switcher-popup__link-16-4-0[aria-current]:before{background:var(--hcr-brand-primary-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;content:\"\";height:var(--hcr-spacing-4);left:0;position:absolute;top:calc(50% - var(--hcr-spacing-4)/2);width:var(--hcr-spacing-half)}.hcr-language-switcher-popup__close-16-4-0{align-self:start;grid-column:2;grid-row:1;right:0;top:0}.hcr-language-switcher-popup__close-16-4-0.hcr-language-switcher-popup__close-16-4-0{position:-webkit-sticky;position:sticky}.hcr-language-switcher-popup__close-16-4-0:before{background-color:var(--hcr-icon-primary-color);content:\"\";height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}",
    map: {
        "hcr-language-switcher": "hcr-language-switcher-16-4-0",
        "hcr-language-switcher__toggle": "hcr-language-switcher__toggle-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-header-burger-menu-subnav": "hcr-header-burger-menu-subnav-16-4-0",
        "hcr-header-nav-subnav": "hcr-header-nav-subnav-16-4-0",
        "hcr-header-burger-menu__widgets": "hcr-header-burger-menu__widgets-16-4-0",
        "hcr-language-switcher__flag": "hcr-language-switcher__flag-16-4-0",
        "hcr-language-switcher-popup": "hcr-language-switcher-popup-16-4-0",
        "hcr-language-switcher-popup__body": "hcr-language-switcher-popup__body-16-4-0",
        "hcr-language-switcher-popup__region": "hcr-language-switcher-popup__region-16-4-0",
        "hcr-language-switcher-popup__list": "hcr-language-switcher-popup__list-16-4-0",
        "hcr-language-switcher-popup__region--columns": "hcr-language-switcher-popup__region--columns-16-4-0",
        "hcr-language-switcher-popup__item": "hcr-language-switcher-popup__item-16-4-0",
        "hcr-language-switcher-popup__link": "hcr-language-switcher-popup__link-16-4-0",
        "hcr-language-switcher-popup__close": "hcr-language-switcher-popup__close-16-4-0"
    }
};









var $acw62 = parcelRequire("acw62");
const $57b0d10ee5b20928$export$1db1adf15a404bf6 = /*#__PURE__*/ (0, $acw62.createContext)({
    toggleRef: {
        current: null
    },
    openPopup: ()=>null,
    closePopup: ()=>null,
    active: false
});



const $e2b2f4565ba6b823$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
function $e2b2f4565ba6b823$export$57776a505fcc1846(_a) {
    var { extraClasses: extraClasses, children: children, onPopupOpen: onPopupOpen = ()=>null, onPopupClose: onPopupClose = ()=>null, portalId: portalId } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "onPopupOpen",
        "onPopupClose",
        "portalId"
    ]);
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const toggleRef = (0, $acw62.useRef)(null);
    const toggleChild = $175aa43345204302$export$348ae70a93bc9267(children, 'LanguageSwitcherToggle')[0];
    const popupChild = $175aa43345204302$export$348ae70a93bc9267(children, 'LanguageSwitcherPopup')[0];
    const popupPortal = portalId && (0, $cc75eba7bd5380d9$export$b1072f43c67b540c)(portalId);
    const handlePopupOpen = (0, $acw62.useCallback)(()=>{
        setActive(true);
        onPopupOpen();
    }, [
        onPopupOpen
    ]);
    const handlePopupClose = (0, $acw62.useCallback)(()=>{
        var _a;
        setActive(false);
        (_a = toggleRef.current) === null || _a === void 0 || _a.focus();
        onPopupClose();
    }, [
        onPopupClose,
        toggleRef
    ]);
    const lsState = (0, $acw62.useMemo)(()=>({
            toggleRef: toggleRef,
            openPopup: handlePopupOpen,
            closePopup: handlePopupClose,
            active: active
        }), [
        toggleRef,
        handlePopupOpen,
        handlePopupClose,
        active
    ]);
    return popupPortal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57b0d10ee5b20928$export$1db1adf15a404bf6).Provider, {
        value: lsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: $e2b2f4565ba6b823$var$bem.b([], extraClasses)
    }, rest), toggleChild), /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(popupChild, popupPortal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57b0d10ee5b20928$export$1db1adf15a404bf6).Provider, {
        value: lsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: $e2b2f4565ba6b823$var$bem.b([], extraClasses)
    }, rest), toggleChild, popupChild));
}
$e2b2f4565ba6b823$export$57776a505fcc1846.displayName = 'LanguageSwitcher';
$e2b2f4565ba6b823$export$57776a505fcc1846.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)([
        'LanguageSwitcherToggle',
        'LanguageSwitcherPopup'
    ]),
    onPopupOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onPopupClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    portalId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $e2b2f4565ba6b823$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($e2b2f4565ba6b823$export$57776a505fcc1846, (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");










const $80274574461ffb6f$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher-popup', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
function $80274574461ffb6f$export$6ed7b60090d1205f(_a) {
    var { extraClasses: extraClasses, 'aria-label': ariaLabel, closeLabel: closeLabel, children: children } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        'aria-label',
        "closeLabel",
        "children"
    ]);
    const popupBody = (0, $acw62.useRef)(null);
    const closeBtn = (0, $acw62.useRef)(null);
    const { active: active, closePopup: closePopup } = (0, $acw62.useContext)((0, $57b0d10ee5b20928$export$1db1adf15a404bf6));
    // run this only once when component mounts
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        const allLinks = (_a = popupBody === null || popupBody === void 0 ? void 0 : popupBody.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(`.${$80274574461ffb6f$var$bem.e('link')}`);
        const lastLink = allLinks === null || allLinks === void 0 ? void 0 : allLinks.item(allLinks.length - 1);
        (_b = closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.current) === null || _b === void 0 || _b.addEventListener('keydown', (event)=>{
            if (event.shiftKey && event.key === 'Tab') {
                event.preventDefault();
                lastLink === null || lastLink === void 0 || lastLink.focus();
            }
        });
        lastLink.addEventListener('keydown', (event)=>{
            var _a;
            if (!event.shiftKey && event.key === 'Tab') {
                event.preventDefault();
                (_a = closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.current) === null || _a === void 0 || _a.focus();
            }
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (active) (_a = closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.current) === null || _a === void 0 || _a.focus();
    }, [
        active
    ]);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: "dialog",
        "aria-modal": "true",
        className: $80274574461ffb6f$var$bem.b([], extraClasses),
        "aria-label": ariaLabel,
        onKeyDown: (event)=>{
            if (event.key === 'Escape') closePopup();
        }
    }, !active && {
        hidden: true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popupBody,
        className: $80274574461ffb6f$var$bem.e('body')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
        innerRef: closeBtn,
        extraClasses: $80274574461ffb6f$var$bem.e('close'),
        appearance: "link",
        display: "square",
        size: "md",
        "aria-label": closeLabel,
        onClick: closePopup
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3a9b3faf56c39c9$export$2e2bcd8739ae039), {
        onClick: closePopup
    })));
}
$80274574461ffb6f$export$6ed7b60090d1205f.displayName = 'LanguageSwitcherPopup';
$80274574461ffb6f$export$6ed7b60090d1205f.propTypes = {
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('LanguageSwitcherPopupRegion'),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    closeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
};
var $80274574461ffb6f$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($80274574461ffb6f$export$6ed7b60090d1205f, (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");





const $6073de108c1c4df9$export$3e7aa63b4cd1dcad = [
    'button',
    'a'
];





var $acw62 = parcelRequire("acw62");

const $ea5137d009687ef5$export$a439dc2f01176e60 = [
    'span',
    'div',
    'button',
    'a'
];





function $9dfbfe5c004aa051$export$73df57962b7f9000(_a) {
    var { Elem: Elem, children: children, href: href, RouterLink: RouterLink, innerRef: innerRef, active: active = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "Elem",
        "children",
        "href",
        "RouterLink",
        "innerRef",
        "active"
    ]);
    if (RouterLink) {
        const routerLinkRest = Object.assign(Object.assign(Object.assign(Object.assign({}, active ? {
            'aria-current': 'page'
        } : {}), innerRef ? {
            innerRef: innerRef
        } : {}), href ? {
            href: href
        } : {}), rest);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RouterLink, Object.assign({}, routerLinkRest), children);
    }
    switch(Elem){
        case 'button':
            {
                const buttonRest = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
                    ref: innerRef,
                    type: "button",
                    "aria-current": active ? 'page' : undefined
                }, buttonRest), children);
            }
        case 'a':
            {
                const anchorRest = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
                    ref: innerRef,
                    "aria-current": active ? 'page' : undefined
                }, anchorRest, {
                    href: href
                }), children);
            }
        case 'div':
            {
                const divRest = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
                    ref: innerRef,
                    "aria-current": active ? 'page' : undefined
                }, divRest), children);
            }
        default:
            {
                const spanRest = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
                    ref: innerRef,
                    "aria-current": active ? 'page' : undefined
                }, spanRest), children);
            }
    }
}
$9dfbfe5c004aa051$export$73df57962b7f9000.displayName = 'NavElem';
$9dfbfe5c004aa051$export$73df57962b7f9000.propTypes = {
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $ea5137d009687ef5$export$a439dc2f01176e60)),
    children: (0, $1ead597b5f273027$export$ff91b688641fa6db)('NavElem'),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    RouterLink: (0, $702b9449be14ac4b$export$50d0863e1c2a2c7f),
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};




const $325b118076073bdb$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher-popup', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
const $325b118076073bdb$var$lsBem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
function $325b118076073bdb$export$7f0aee89b3e617be(_a) {
    var { children: children, flag: flag, href: href, RouterLink: RouterLink, active: active = false, Elem: Elem = 'a', extraClasses: extraClasses, innerRef: innerRef, shouldCloseDialog: shouldCloseDialog } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "flag",
        "href",
        "RouterLink",
        "active",
        "Elem",
        "extraClasses",
        "innerRef",
        "shouldCloseDialog"
    ]);
    const { closePopup: closePopup } = (0, $acw62.useContext)((0, $57b0d10ee5b20928$export$1db1adf15a404bf6));
    const handleClick = (event)=>{
        var _a;
        (_a = rest.onClick) === null || _a === void 0 || _a.call(rest, event);
        if (shouldCloseDialog) closePopup();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: $325b118076073bdb$var$bem.e('item', {}, extraClasses)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dfbfe5c004aa051$export$73df57962b7f9000), Object.assign({
        RouterLink: RouterLink,
        innerRef: innerRef,
        Elem: Elem,
        href: href,
        className: $325b118076073bdb$var$bem.e('link')
    }, active && {
        'aria-current': 'true'
    }, rest, {
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$ada278d15ed54cfa).Provider, {
        value: $325b118076073bdb$var$lsBem
    }, flag), children));
}
$325b118076073bdb$export$7f0aee89b3e617be.displayName = 'LanguageSwitcherPopupItem';
$325b118076073bdb$export$7f0aee89b3e617be.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    flag: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('Flag'),
    lang: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $6073de108c1c4df9$export$3e7aa63b4cd1dcad)),
    RouterLink: (0, $702b9449be14ac4b$export$50d0863e1c2a2c7f),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    shouldCloseDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
/**
 * Generates a unique id prefixed for components aria attributes.
 *
 * Will use React 18 `useId` if available, otherwise generate a randomized number based on
 * the timestamp.
 *
 * Automatic id generation can be overwritten by consumers that provide a component id.
 *
 * @param prefix The id prefix
 * @param suffix Optionally replace the automatically generated id
 * @returns `{prefix}-{random-id|manual-suffix}`
 *
 * @since 2.4.0
 * @private This hook is private, users should use `useId` from React 18 or provide their own ids.
 */ function $c3eee7b1359b34f4$export$9cb3c4fd0f7c7bd9(prefix, suffix) {
    // If consumer uses React < 18 they don't have `useId`. So we want to explicitly walk around TS.
    // @ts-ignore
    const { useId: reactUseId } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
    // if useId exists, use it, otherwise generate a timestamp and randomize it
    const componentId = typeof reactUseId === 'function' ? reactUseId() : Math.floor(Date.now() * Math.random());
    const [suffixVal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(suffix !== null && suffix !== void 0 ? suffix : componentId);
    return `${prefix}-${suffixVal}`;
}



const $66bc8fee13189d1c$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher-popup', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
function $66bc8fee13189d1c$export$690d4bc103d00596(_a) {
    var { id: id, children: children, title: title, extraClasses: extraClasses, order: order = 'rows' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "children",
        "title",
        "extraClasses",
        "order"
    ]);
    const headingId = (0, $c3eee7b1359b34f4$export$9cb3c4fd0f7c7bd9)(`hcr-${title.replace(/ /g, '-').toLowerCase()}-heading`, id);
    const freeChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>!$175aa43345204302$export$9522e17588c12572(child) && child);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", Object.assign({
        id: id,
        "aria-labelledby": headingId,
        className: $66bc8fee13189d1c$var$bem.e('region', {
            columns: order === 'columns'
        }, extraClasses)
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02cbb07845aa75e9$export$2e2bcd8739ae039), {
        id: headingId,
        size: 4,
        Elem: "h2",
        sectionHeader: true
    }, title), freeChildren ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: $66bc8fee13189d1c$var$bem.e('list')
    }, freeChildren) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        var _a;
        if ($175aa43345204302$export$9522e17588c12572(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            className: $66bc8fee13189d1c$var$bem.e('list')
        }, (_a = child.props) === null || _a === void 0 ? void 0 : _a.children);
        return null;
    }));
}
$66bc8fee13189d1c$export$690d4bc103d00596.displayName = 'LanguageSwitcherPopupRegion';
$66bc8fee13189d1c$export$690d4bc103d00596.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('LanguageSwitcherPopupItem'),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    order: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'rows',
        'columns'
    ])
};



var $acw62 = parcelRequire("acw62");









const $d7b9c023872f63eb$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('language-switcher', (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));
function $d7b9c023872f63eb$export$9bd092c56dd74842(_a) {
    var { extraClasses: extraClasses, children: children, flag: flag } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "flag"
    ]);
    const { toggleRef: toggleRef, openPopup: openPopup } = (0, $acw62.useContext)((0, $57b0d10ee5b20928$export$1db1adf15a404bf6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: toggleRef,
        type: "button",
        className: $d7b9c023872f63eb$var$bem.e('toggle', {}, extraClasses),
        onClick: openPopup
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$ada278d15ed54cfa).Provider, {
        value: $d7b9c023872f63eb$var$bem
    }, flag), children);
}
$d7b9c023872f63eb$export$9bd092c56dd74842.displayName = 'LanguageSwitcherToggle';
$d7b9c023872f63eb$export$9bd092c56dd74842.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    flag: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('Flag'),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
            ])
        })
    ])
};
var $d7b9c023872f63eb$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($d7b9c023872f63eb$export$9bd092c56dd74842, (0, $9fbcddfadd621cef$export$2e2bcd8739ae039));


parcelRequire("acw62");
var $a68fac07380ebb8b$export$e03c1c3201ee8bb7;
$a68fac07380ebb8b$export$e03c1c3201ee8bb7 = `LanguageSwitcher-4o_STq-toggle`;



const $1cea3b3f250ab4ad$var$LanguageSwitcher = ({ onLanguageSelected: onLanguageSelected, languages: languages, currentLanguage: currentLanguage, toggleIcon: toggleIcon })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e2b2f4565ba6b823$export$2e2bcd8739ae039), {
        portalId: (0, $d201893169ea3ce2$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7b9c023872f63eb$export$2e2bcd8739ae039), {
                lang: currentLanguage.bcp47Locale,
                extraClasses: $a68fac07380ebb8b$export$e03c1c3201ee8bb7,
                flag: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbf6628f25c8cc8f$export$48ea269755562084), {
                    countryCode: currentLanguage.flagName,
                    countryName: currentLanguage.name
                }),
                children: [
                    currentLanguage.name,
                    toggleIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                        InlineIcon: (0, $b271bcddec93d9b1$export$403194946ee83bdf)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80274574461ffb6f$export$2e2bcd8739ae039), {
                "aria-label": "Language selector.",
                closeLabel: "Close language selector.",
                children: languages.map((region)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66bc8fee13189d1c$export$690d4bc103d00596), {
                        title: region.region,
                        children: region.locales.map((lang)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $325b118076073bdb$export$7f0aee89b3e617be), {
                                active: lang.locale === currentLanguage.locale,
                                lang: lang.bcp47Locale,
                                flag: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbf6628f25c8cc8f$export$48ea269755562084), {
                                    countryCode: lang.flagName,
                                    countryName: lang.name
                                }),
                                onClick: ()=>{
                                    onLanguageSelected(lang);
                                },
                                children: lang.name
                            }, lang.locale))
                    }, region.region))
            })
        ]
    });
};
var $1cea3b3f250ab4ad$export$2e2bcd8739ae039 = $1cea3b3f250ab4ad$var$LanguageSwitcher;



/* eslint-disable no-restricted-syntax */ /*
We are using getDerivedStateFromError here which is not yet implemented
as hooks. That's why we need a class based component
https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes
*/ 


var $acw62 = parcelRequire("acw62");


class $c788d42036daec36$var$ErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            errorType: undefined,
            isUnloading: false
        };
        this.setIsUnloading = this.setIsUnloading.bind(this);
    }
    static getDerivedStateFromError(error) {
        if (error.message === (0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e500) return {
            errorType: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e500
        };
        if (error.message === (0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e403) return {
            errorType: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e403
        };
        if (error.message === (0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e404) return {
            errorType: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e404
        };
        return {
            errorType: undefined
        };
    }
    componentDidMount() {
        window.addEventListener("beforeunload", this.setIsUnloading);
    }
    componentDidCatch(error) {
        const { errorType: errorType, isUnloading: isUnloading } = this.state;
        if (errorType && !isUnloading) (0, $95032d6edbc0e5a2$export$65cc181beb0d2632).addError(error, {
            type: errorType
        });
    }
    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.setIsUnloading);
    }
    setIsUnloading() {
        this.setState({
            isUnloading: true
        });
    }
    render() {
        const { errorType: errorType, isUnloading: isUnloading } = this.state;
        const { children: children } = this.props;
        if (errorType && !isUnloading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c45961a3b378f92$export$2e2bcd8739ae039), {
            type: errorType
        });
        return children;
    }
}
var $c788d42036daec36$export$2e2bcd8739ae039 = $c788d42036daec36$var$ErrorBoundary;





var $acw62 = parcelRequire("acw62");

var $f0f4553d8923ab9e$var$_excluded = [
    "title",
    "pathRest"
];
var $f0f4553d8923ab9e$export$ee0a9968ab5cedc8 = function IconProfile(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $f0f4553d8923ab9e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-profile"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 0 1-4.5-1.39 3 3 0 0 1 1.82-2.68 6.3 6.3 0 0 0 5.36 0 3 3 0 0 1 1.82 2.68A8 8 0 0 1 12 20m6.22-2.97a5 5 0 0 0-3.8-3.24q-1.07.72-2.42.74-1.34-.02-2.42-.74a5 5 0 0 0-3.8 3.24A8 8 0 1 1 20 12c0 1.9-.67 3.65-1.78 5.03M12 6c-1.68 0-3.05 1.55-3.05 3.45s1.37 3.46 3.05 3.46 3.05-1.55 3.05-3.46C15.05 7.55 13.68 6 12 6m0 4.9c-.56 0-1.05-.67-1.05-1.45S11.45 8 12 8c.56 0 1.05.68 1.05 1.45 0 .78-.5 1.46-1.05 1.46"
    }, pathRest)));
};
$f0f4553d8923ab9e$export$ee0a9968ab5cedc8.displayName = 'InlineIcon(IconProfile)';
$f0f4553d8923ab9e$export$ee0a9968ab5cedc8.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $c40261c34536a43d$var$_excluded = [
    "title",
    "pathRest"
];
var $c40261c34536a43d$export$65daaa3bbd433e83 = function IconQuestion(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $c40261c34536a43d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-question"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 0 1 0-16 8 8 0 0 1 0 16m3.14-10.86c0 1.3-1.1 2.32-1.63 2.81l-.15.14c-.3.3-.47.53-.47.8v.12a1 1 0 0 1-1.99 0v-.11c0-1.16.75-1.91 1.07-2.23l.18-.17q1-.93 1-1.36c0-.69-.46-1.15-1.13-1.15-.5 0-.97.3-1.13.76l-.05.19a1 1 0 0 1-1.96-.36q.05-.27.14-.52a3.2 3.2 0 0 1 3-2.06 3.06 3.06 0 0 1 3.12 3.14M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    }, pathRest)));
};
$c40261c34536a43d$export$65daaa3bbd433e83.displayName = 'InlineIcon(IconQuestion)';
$c40261c34536a43d$export$65daaa3bbd433e83.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};




var $acw62 = parcelRequire("acw62");


var $553b646fecb98fdf$export$2e2bcd8739ae039 = {
    raw: ".hcr-avatar-16-4-0{color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;flex-shrink:0;height:var(--hcr-spacing-4);width:var(--hcr-spacing-4)}.hcr-avatar__image-16-4-0{border-radius:100%;display:block;height:100%;width:100%}.hcr-avatar__image-16-4-0 svg{height:100%;width:100%}.hcr-avatar-16-4-0:is(a,button):focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-avatar--size-6-16-4-0{height:var(--hcr-spacing-6);width:var(--hcr-spacing-6)}.hcr-avatar--size-8-16-4-0{height:var(--hcr-spacing-8);width:var(--hcr-spacing-8)}.hcr-avatar--size-16-16-4-0{height:calc(var(--hcr-spacing-8)*2);width:calc(var(--hcr-spacing-8)*2)}",
    map: {
        "hcr-avatar": "hcr-avatar-16-4-0",
        "hcr-avatar__image": "hcr-avatar__image-16-4-0",
        "hcr-avatar--size-6": "hcr-avatar--size-6-16-4-0",
        "hcr-avatar--size-8": "hcr-avatar--size-8-16-4-0",
        "hcr-avatar--size-16": "hcr-avatar--size-16-16-4-0"
    }
};




const $0f9d571abde02163$export$9a270941bcff7e77 = [
    6,
    8,
    16
];



const $2a3cda011510100a$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('avatar', (0, $553b646fecb98fdf$export$2e2bcd8739ae039));
function $2a3cda011510100a$export$e2255cf6045e8d47(_a) {
    var { alt: alt, as: as = 'div', children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
        InlineIcon: (0, $f0f4553d8923ab9e$export$ee0a9968ab5cedc8),
        size: "cover"
    }), extraClasses: extraClasses, innerRef: innerRef, size: size, src: src, url: url } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "alt",
        "as",
        "children",
        "extraClasses",
        "innerRef",
        "size",
        "src",
        "url"
    ]);
    const avatarClassNames = $2a3cda011510100a$var$bem.b(size ? [
        `size-${size}`
    ] : [], extraClasses);
    // if no url passed render as div (default element type) or custom element provided via "as"
    const WrapperElement = url ? 'a' : as;
    // do not set "href" if no url is given, prevents setting href on a div
    const wrapperProps = Object.assign({}, url ? Object.assign({
        className: avatarClassNames,
        href: url
    }, rest) : Object.assign({
        className: avatarClassNames
    }, rest));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperElement, Object.assign({
        ref: innerRef
    }, wrapperProps), src && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: $2a3cda011510100a$var$bem.e('image'),
        src: src,
        alt: alt
    }), !src && children);
}
$2a3cda011510100a$export$e2255cf6045e8d47.displayName = 'Avatar';
$2a3cda011510100a$export$e2255cf6045e8d47.propTypes = {
    alt ({ alt: alt, src: src }) {
        if (src && !(alt === null || alt === void 0 ? void 0 : alt.trim())) return new Error('The "alt" text is required if a source is provided to Avatar.');
        return null;
    },
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $0f9d571abde02163$export$9a270941bcff7e77)),
    src: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $2a3cda011510100a$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($2a3cda011510100a$export$e2255cf6045e8d47, (0, $553b646fecb98fdf$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $73395dc44dfca54e$export$2e2bcd8739ae039 = {
    raw: ".hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0,.hcr-dropdown__items-container-16-4-0{--hcr-balloon-width:15.75rem;--hcr-balloon-height:44px;--hcr-balloon-background:var(--hcr-box-bg-color);--hcr-balloon-color:var(--hcr-content-primary-color);--hcr-balloon-close-color:var(--hcr-icon-primary-color);--hcr-balloon-content-margin:0;--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) var(--hcr-spacing-2);color:var(--hcr-balloon-color);font-family:inherit;font-size:var(--hcr-font-size-primary);justify-content:space-between;min-height:var(--hcr-balloon-height);min-width:var(--hcr-balloon-width);position:relative;text-decoration:none;width:-moz-fit-content;width:fit-content;z-index:10}.hcr-dropdown--active-16-4-0 .hcr-dropdown__items-container-16-4-0:not([hidden]),.hcr-dropdown--active-16-4-0>.hcr-dropdown__items-16-4-0:not([hidden]){display:flex}.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0:before,.hcr-dropdown__items-container-16-4-0:before{background:var(--hcr-balloon-background);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);content:\"\";position:absolute;top:0;z-index:-1}.hcr-dropdown--top-16-4-0 .hcr-dropdown__items-container-16-4-0,.hcr-dropdown--top-16-4-0>.hcr-dropdown__items-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-dropdown--top-16-4-0 .hcr-dropdown__items-container-16-4-0:before,.hcr-dropdown--top-16-4-0>.hcr-dropdown__items-16-4-0:before{bottom:var(--hcr-spacing-2);left:0;right:0;top:0}.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0,.hcr-dropdown__items-container-16-4-0{padding:var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0:before,.hcr-dropdown__items-container-16-4-0:before{bottom:0;left:0;right:0;top:var(--hcr-spacing-2)}.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0:after,.hcr-dropdown__items-container-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-left:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-right:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-top:0;content:\"\";height:0;inset:var(--hcr-spacing-1) auto auto;position:absolute;width:0;z-index:0}.hcr-dropdown--top-16-4-0 .hcr-dropdown__items-container-16-4-0:after,.hcr-dropdown--top-16-4-0>.hcr-dropdown__items-16-4-0:after{border-bottom:0;border-left:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-right:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-top:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);inset:auto auto var(--hcr-spacing-1)}.hcr-dropdown--top-16-4-0 .hcr-dropdown__items-container-16-4-0:after,.hcr-dropdown--top-16-4-0>.hcr-dropdown__items-16-4-0:after,.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0:after,.hcr-dropdown__items-container-16-4-0:after{left:50%;right:auto;transform:translateX(-50%)}.hcr-dropdown--right-16-4-0 .hcr-dropdown__items-container-16-4-0:after,.hcr-dropdown--right-16-4-0>.hcr-dropdown__items-16-4-0:after{left:min(25%,var(--hcr-spacing-3));transform:none}.hcr-dropdown--left-16-4-0 .hcr-dropdown__items-container-16-4-0:after,.hcr-dropdown--left-16-4-0>.hcr-dropdown__items-16-4-0:after{left:auto;right:min(25%,var(--hcr-spacing-3));transform:none}.hcr-dropdown-16-4-0{display:inline-block;position:relative}.hcr-dropdown-16-4-0>.hcr-dropdown__items-16-4-0,.hcr-dropdown__items-container-16-4-0{bottom:auto;display:none;flex-direction:column;left:50%;margin:calc(-1*var(--hcr-spacing-1))0 0;padding:var(--hcr-spacing-4)0 var(--hcr-spacing-2);position:absolute;top:100%;transform:translateX(-50%)}.hcr-dropdown__items-container-16-4-0 .hcr-dropdown__items-16-4-0{background:linear-gradient(var(--hcr-balloon-background),#fff0),linear-gradient(#fff0,var(--hcr-balloon-background)),linear-gradient(var(--hcr-box-shadow-subtle-color),#fff0),linear-gradient(#fff0,var(--hcr-box-shadow-subtle-color));background-attachment:local,local,scroll,scroll;background-position:0 0,0 100%,0 0,0 100%;background-repeat:no-repeat;background-size:100% var(--hcr-spacing-4),100% var(--hcr-spacing-4),100% var(--hcr-spacing-1),100% var(--hcr-spacing-1);max-height:315px;overflow-y:auto}.hcr-dropdown__item-16-4-0{list-style:none;text-align:left}.hcr-dropdown__item-16-4-0:not(:last-of-type){margin-bottom:var(--hcr-spacing-1)}.hcr-dropdown__link-16-4-0{align-items:center;color:var(--hcr-content-secondary-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-1) var(--hcr-spacing-4);position:relative;text-decoration:none;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-dropdown__link-16-4-0 .hcr-icon-16-4-0,.hcr-dropdown__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-dropdown__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-dropdown__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-dropdown__link-16-4-0[aria-current],.hcr-dropdown__link-16-4-0[aria-selected=true]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);position:relative}.hcr-dropdown__link-16-4-0[aria-current]:before,.hcr-dropdown__link-16-4-0[aria-selected=true]:before{background:var(--hcr-brand-primary-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;content:\"\";height:var(--hcr-spacing-4);left:0;position:absolute;top:calc(50% - var(--hcr-spacing-4)/2);width:var(--hcr-spacing-half)}.hcr-dropdown__link-16-4-0:is(a,button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-weight:var(--hcr-font-weight-semibold);text-align:inherit}.hcr-dropdown__link-16-4-0:is(a,button):enabled:hover,.hcr-dropdown__link-16-4-0:is(a,button)[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-dropdown__link-16-4-0:is(a,button):enabled:active,.hcr-dropdown__link-16-4-0:is(a,button)[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-dropdown__link-16-4-0:is(a,button):focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) - 2px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:-2px}.hcr-dropdown__link-16-4-0:is(a,button):focus-visible:before{opacity:0}.hcr-dropdown--top-16-4-0 .hcr-dropdown__items-container-16-4-0,.hcr-dropdown--top-16-4-0>.hcr-dropdown__items-16-4-0{bottom:100%;margin:0 0 calc(-1*var(--hcr-spacing-1));padding:var(--hcr-spacing-2)0 var(--hcr-spacing-4);top:auto}.hcr-dropdown--left-16-4-0 .hcr-dropdown__items-container-16-4-0,.hcr-dropdown--left-16-4-0>.hcr-dropdown__items-16-4-0{transform:translateX(calc(-100% + min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-dropdown--right-16-4-0 .hcr-dropdown__items-container-16-4-0,.hcr-dropdown--right-16-4-0>.hcr-dropdown__items-16-4-0{transform:translateX(calc(-1*min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}",
    map: {
        "hcr-dropdown__items-container": "hcr-dropdown__items-container-16-4-0",
        "hcr-dropdown": "hcr-dropdown-16-4-0",
        "hcr-dropdown__items": "hcr-dropdown__items-16-4-0",
        "hcr-dropdown--active": "hcr-dropdown--active-16-4-0",
        "hcr-dropdown--top": "hcr-dropdown--top-16-4-0",
        "hcr-dropdown--right": "hcr-dropdown--right-16-4-0",
        "hcr-dropdown--left": "hcr-dropdown--left-16-4-0",
        "hcr-dropdown__item": "hcr-dropdown__item-16-4-0",
        "hcr-dropdown__link": "hcr-dropdown__link-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0"
    }
};







var $acw62 = parcelRequire("acw62");
const $881605b223889743$export$e7d6e469a6eed078 = 300;
/**
 * custom visibility toggling hook,
 * triggers active state with click, hover and arrow keys
 * @param options { initialActive, onToggle, content, hoverEvents, arrowEvents, delay }
 * @private This hook is currently private because its API is highly specific for our internal use
 * cases and has not been prepared for public use yet.
 */ const $881605b223889743$export$6c3f529066e77cfe = ({ initialActive: initialActive = false, onToggle: onToggle, content: content, hoverEvents: hoverEvents = false, arrowEvents: arrowEvents = false, delay: delay = $881605b223889743$export$e7d6e469a6eed078 })=>{
    let currentTimeOut;
    const [isActive, setIsActive] = (0, $acw62.useState)(initialActive);
    (0, $acw62.useEffect)(()=>{
        setIsActive(initialActive);
    }, [
        initialActive
    ]);
    const activate = (event)=>{
        setIsActive(true);
        if (onToggle) {
            event === null || event === void 0 || event.persist();
            onToggle(true, event);
        }
    };
    const deactivate = (event)=>{
        setIsActive(false);
        if (onToggle) {
            event === null || event === void 0 || event.persist();
            onToggle(false, event);
        }
    };
    const handleClick = (event)=>{
        setIsActive(!isActive);
        if (onToggle) {
            event.persist();
            onToggle(!isActive, event);
        }
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            // avoids unwanted page scrolls and double call of pointers events on space and enter
            event.preventDefault();
            handleClick(event);
        }
        if (event.key === 'Escape') deactivate(event);
        if (arrowEvents && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
            // avoids unwanted page scrolls
            event.preventDefault();
            activate(event);
        }
    };
    const handleMouseEnter = (event)=>{
        event.persist();
        clearTimeout(currentTimeOut);
        currentTimeOut = setTimeout(()=>activate(event), delay);
    };
    const handleMouseOut = (event)=>{
        event.persist();
        const targetElement = event.relatedTarget && event.relatedTarget.nodeType ? event.relatedTarget : null;
        clearTimeout(currentTimeOut);
        if (!(content === null || content === void 0 ? void 0 : content.contains(targetElement))) currentTimeOut = setTimeout(()=>deactivate(event), delay);
    };
    const BASIC_EVENTS = {
        onKeyDown: handleKeyDown,
        onClick: handleClick
    };
    const HOVER_EVENTS = {
        onMouseEnter: handleMouseEnter,
        // @todo this won't work with submenus if placed outside of the target link, rethink it
        // the mouse leaves the target when moving towards a sub menu
        onMouseLeave: handleMouseOut
    };
    const getHandlers = hoverEvents ? Object.assign(Object.assign({}, BASIC_EVENTS), HOVER_EVENTS) : BASIC_EVENTS;
    return [
        isActive,
        getHandlers,
        deactivate
    ];
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $24ad9cd18b9a061c$export$317b1c34aa6349ea;
(function(SubMenuInitialFocus) {
    SubMenuInitialFocus["First"] = "first";
    SubMenuInitialFocus["Last"] = "last";
    SubMenuInitialFocus["Target"] = "target";
    SubMenuInitialFocus["None"] = "none";
})($24ad9cd18b9a061c$export$317b1c34aa6349ea || ($24ad9cd18b9a061c$export$317b1c34aa6349ea = {}));
const $24ad9cd18b9a061c$var$SubMenuContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    hidden: false,
    setInitialFocus: $24ad9cd18b9a061c$export$317b1c34aa6349ea.None,
    closeSubMenu: ()=>{}
});
function $24ad9cd18b9a061c$export$d2d35f354bcdebf4(props) {
    const { children: children } = props, contextProps = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(props, [
        "children"
    ]);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>contextProps, Object.values(contextProps));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($24ad9cd18b9a061c$var$SubMenuContext.Provider, {
        value: value
    }, children);
}
const $24ad9cd18b9a061c$export$a2873e323c026b38 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($24ad9cd18b9a061c$var$SubMenuContext);


/**
 * @private This hook is private.
 * @since 7.3.0
 */ function $0745dc474f408795$export$21134cfa9af8e42e({ isExpanded: isExpanded, lastEvent: lastEvent }) {
    const [focusAt, setFocusAt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).None);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if ((lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent.nativeEvent) instanceof KeyboardEvent) {
            const lastKeyboardEvent = lastEvent;
            if (isExpanded) {
                if (lastKeyboardEvent.key === 'ArrowDown') setFocusAt((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).First);
                else if (lastKeyboardEvent.key === 'ArrowUp') setFocusAt((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).Last);
                else setFocusAt((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).None);
            } else {
                if (lastKeyboardEvent.key === 'Escape') {
                    setFocusAt((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).Target);
                    return;
                }
                setFocusAt((0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).None);
            }
        }
    }, [
        isExpanded,
        lastEvent
    ]);
    return focusAt;
}




var $acw62 = parcelRequire("acw62");







const $fab663585318a761$export$a9c522a6d7beb830 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { className: className, children: children } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "className",
        "children"
    ]);
    const subMenuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { setInitialFocus: setInitialFocus, hidden: hidden, closeSubMenu: closeSubMenu, target: target } = (0, $24ad9cd18b9a061c$export$a2873e323c026b38)();
    const { handleTabKeyDown: handleTabKeyDown, firstInteractiveElement: firstInteractiveElement, lastInteractiveElement: lastInteractiveElement } = (0, $0da343143cf6cd49$export$bf0846d1a7c2b80)(!hidden, subMenuRef.current, target, true, true);
    const handleMenuKeyDown = (event)=>{
        var _a, _b, _c, _d;
        if (event.key === 'Escape' && closeSubMenu) closeSubMenu(event);
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            // cycles back to first item when is the last
            if (event.target === lastInteractiveElement) firstInteractiveElement === null || firstInteractiveElement === void 0 || firstInteractiveElement.focus();
            else {
                // or sets focus to next menu item
                const eventTargetElem = event.target;
                const nextLink = (_b = (_a = eventTargetElem.parentElement) === null || _a === void 0 ? void 0 : _a.nextSibling) === null || _b === void 0 ? void 0 : _b.firstChild;
                nextLink === null || nextLink === void 0 || nextLink.focus();
            }
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            // cycles back to last link when is the first
            if (event.target === firstInteractiveElement) lastInteractiveElement === null || lastInteractiveElement === void 0 || lastInteractiveElement.focus();
            else {
                // or sets focus to previous menu item
                const eventTargetElem = event.target;
                const prevLink = (_d = (_c = eventTargetElem.parentElement) === null || _c === void 0 ? void 0 : _c.previousSibling) === null || _d === void 0 ? void 0 : _d.firstChild;
                prevLink === null || prevLink === void 0 || prevLink.focus();
            }
        }
        handleTabKeyDown(event);
        if (rest.onKeyDown) rest.onKeyDown(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        switch(setInitialFocus){
            case (0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).Target:
                target === null || target === void 0 || target.focus();
                break;
            case (0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).First:
                firstInteractiveElement === null || firstInteractiveElement === void 0 || firstInteractiveElement.focus();
                break;
            case (0, $24ad9cd18b9a061c$export$317b1c34aa6349ea).Last:
                lastInteractiveElement === null || lastInteractiveElement === void 0 || lastInteractiveElement.focus();
                break;
        }
    }, [
        hidden,
        setInitialFocus,
        target,
        firstInteractiveElement,
        lastInteractiveElement
    ]);
    // @todo [HIVE-2597] & [HIVE-3055] Remove cloneElement and props injection
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
    const enhancedItems = childrenArray.map((child)=>{
        if ($175aa43345204302$export$2dabafa86f11ed64(child, 'NavItem')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            role: 'presentation',
            linkRole: 'menuitem'
        });
        return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({
        role: "menu",
        className: className,
        hidden: hidden,
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, ref, subMenuRef);
        }
    }, rest, {
        onKeyDown: handleMenuKeyDown
    }), enhancedItems);
});
$fab663585318a761$export$a9c522a6d7beb830.displayName = 'SubMenu';
$fab663585318a761$export$a9c522a6d7beb830.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)([
        'NavItem',
        'DropdownItem'
    ])
};



const $a95fcfeaada0acb8$export$4925db1b340f2751 = [
    'center',
    'start',
    'left',
    'end',
    'right'
];
const $a95fcfeaada0acb8$export$84bcd335419cb14e = [
    'top',
    'bottom'
];




const $2f60807b922cb821$var$bemDropdown = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('dropdown', (0, $73395dc44dfca54e$export$2e2bcd8739ae039));
/** @since 1.4.0 */ function $2f60807b922cb821$export$931cbfb6bfb85fc(_a) {
    var _b;
    var { id: id, children: children, links: links, extraClasses: extraClasses = '', innerRef: innerRef, menuRef: menuRef, active: activeProp, onToggle: onToggle = ()=>null, xPosition: xPosition = 'center', yPosition: yPosition = 'bottom', openOnHover: openOnHover = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "children",
        "links",
        "extraClasses",
        "innerRef",
        "menuRef",
        "active",
        "onToggle",
        "xPosition",
        "yPosition",
        "openOnHover"
    ]);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const menuPrivateRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [lastEvent, setLastEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const handleToggle = (isActive, event)=>{
        setLastEvent(event);
        if (onToggle) onToggle(isActive, event);
    };
    const [activeHook, targetEvents, closeDropdown] = (0, $881605b223889743$export$6c3f529066e77cfe)({
        initialActive: Boolean(activeProp),
        onToggle: handleToggle,
        content: containerRef.current,
        hoverEvents: openOnHover,
        arrowEvents: true
    });
    const isActive = activeProp === undefined ? activeHook : activeProp;
    const focusAt = (0, $0745dc474f408795$export$21134cfa9af8e42e)({
        isExpanded: isActive,
        lastEvent: lastEvent
    });
    const handleBlur = (event)=>{
        const origin = event.relatedTarget;
        if (origin && containerRef.current && containerRef.current.contains(origin)) return;
        closeDropdown(event);
    };
    /**
   * Generates a dynamic prefix for the component ID using the links keys or
   * index if keys are not provided
   */ const idPrefix = links.map(({ key: key }, index)=>key || index.toString(16)).join('');
    const dropdownListId = `dropdown-list-${(0, $c3eee7b1359b34f4$export$9cb3c4fd0f7c7bd9)(idPrefix, id)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        id: id,
        className: $2f60807b922cb821$var$bemDropdown.b({
            active: isActive,
            left: xPosition === 'left' || xPosition === 'end',
            right: xPosition === 'right' || xPosition === 'start',
            top: yPosition === 'top'
        }, extraClasses),
        onBlur: handleBlur,
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, containerRef);
        },
        // this magically makes onBlur work in Safari with its known button focus and event.relatedTarget tricks (see: https://bugs.webkit.org/show_bug.cgi?id=22261)
        tabIndex: -1
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, Object.assign(Object.assign({}, targetEvents), {
        // overriding onClick and onKeyDown events to execute custom handlers if present
        onClick: (event)=>{
            var _a, _b;
            targetEvents.onClick(event);
            (_b = (_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, event);
        },
        onKeyDown: (event)=>{
            var _a, _b;
            targetEvents.onKeyDown(event);
            (_b = (_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.onKeyDown) === null || _b === void 0 || _b.call(_a, event);
        },
        'aria-haspopup': 'menu',
        'aria-controls': dropdownListId,
        'aria-expanded': Boolean(isActive)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24ad9cd18b9a061c$export$d2d35f354bcdebf4), {
        setInitialFocus: focusAt,
        hidden: !isActive,
        closeSubMenu: closeDropdown,
        target: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.firstElementChild
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2f60807b922cb821$var$bemDropdown.e('items-container'),
        hidden: !isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fab663585318a761$export$a9c522a6d7beb830), {
        id: dropdownListId,
        className: $2f60807b922cb821$var$bemDropdown.e('items'),
        onMouseLeave: (event)=>openOnHover && closeDropdown(event),
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, menuRef, menuPrivateRef);
        }
    }, links))));
}
$2f60807b922cb821$export$931cbfb6bfb85fc.displayName = 'Dropdown';
$2f60807b922cb821$export$931cbfb6bfb85fc.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    menuRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    links: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('DropdownItem'),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    xPosition: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $a95fcfeaada0acb8$export$4925db1b340f2751)),
    yPosition: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $a95fcfeaada0acb8$export$84bcd335419cb14e)),
    openOnHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $2f60807b922cb821$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($2f60807b922cb821$export$931cbfb6bfb85fc, (0, $73395dc44dfca54e$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $4702524f7bf99409$export$2e2bcd8739ae039 = {
    raw: ".hcr-grid-container-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5)}.hcr-grid-container--gutter-4-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5)}.hcr-grid-16-4-0{display:flex;flex-wrap:wrap;margin-left:calc(-1*var(--hcr-grid-gutter-2)*.5);margin-right:calc(-1*var(--hcr-grid-gutter-2)*.5);width:calc(100% + var(--hcr-grid-gutter-2))}.hcr-grid--align-bottom-16-4-0{align-items:flex-end}.hcr-grid--align-top-16-4-0{align-items:flex-start}.hcr-grid--align-center-16-4-0{align-items:center}.hcr-grid--justify-center-16-4-0{justify-content:center}.hcr-grid--justify-left-16-4-0{justify-content:flex-start}.hcr-grid--justify-right-16-4-0{justify-content:flex-end}.hcr-grid--justify-space-between-16-4-0{justify-content:space-between}.hcr-grid--gutter-4-16-4-0{display:flex;flex-wrap:wrap;margin-left:calc(-1*var(--hcr-grid-gutter-4)*.5);margin-right:calc(-1*var(--hcr-grid-gutter-4)*.5);width:calc(100% + var(--hcr-grid-gutter-4))}.hcr-col-1-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-16-4-0{margin-left:8.3333333333%}.hcr-col-2-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-16-4-0{margin-left:16.6666666667%}.hcr-col-3-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-16-4-0{margin-left:25%}.hcr-col-4-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-16-4-0{margin-left:33.3333333333%}.hcr-col-5-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-16-4-0{margin-left:41.6666666667%}.hcr-col-6-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-16-4-0{margin-left:50%}.hcr-col-7-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-16-4-0{margin-left:58.3333333333%}.hcr-col-8-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-16-4-0{margin-left:66.6666666667%}.hcr-col-9-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-16-4-0{margin-left:75%}.hcr-col-10-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-16-4-0{margin-left:83.3333333333%}.hcr-col-11-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-16-4-0{margin-left:91.6666666667%}.hcr-col-12-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-16-4-0{margin-left:100%}@media (min-width:390px){.hcr-col-1-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-xs-16-4-0{margin-left:8.3333333333%}.hcr-col-2-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-xs-16-4-0{margin-left:16.6666666667%}.hcr-col-3-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-xs-16-4-0{margin-left:25%}.hcr-col-4-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-xs-16-4-0{margin-left:33.3333333333%}.hcr-col-5-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-xs-16-4-0{margin-left:41.6666666667%}.hcr-col-6-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-xs-16-4-0{margin-left:50%}.hcr-col-7-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-xs-16-4-0{margin-left:58.3333333333%}.hcr-col-8-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-xs-16-4-0{margin-left:66.6666666667%}.hcr-col-9-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-xs-16-4-0{margin-left:75%}.hcr-col-10-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-xs-16-4-0{margin-left:83.3333333333%}.hcr-col-11-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-xs-16-4-0{margin-left:91.6666666667%}.hcr-col-12-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-xs-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-xs-16-4-0{margin-left:100%}}@media (min-width:600px){.hcr-col-1-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-sm-16-4-0{margin-left:8.3333333333%}.hcr-col-2-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-sm-16-4-0{margin-left:16.6666666667%}.hcr-col-3-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-sm-16-4-0{margin-left:25%}.hcr-col-4-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-sm-16-4-0{margin-left:33.3333333333%}.hcr-col-5-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-sm-16-4-0{margin-left:41.6666666667%}.hcr-col-6-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-sm-16-4-0{margin-left:50%}.hcr-col-7-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-sm-16-4-0{margin-left:58.3333333333%}.hcr-col-8-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-sm-16-4-0{margin-left:66.6666666667%}.hcr-col-9-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-sm-16-4-0{margin-left:75%}.hcr-col-10-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-sm-16-4-0{margin-left:83.3333333333%}.hcr-col-11-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-sm-16-4-0{margin-left:91.6666666667%}.hcr-col-12-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-sm-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-sm-16-4-0{margin-left:100%}}@media (min-width:768px){.hcr-col-1-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-md-16-4-0{margin-left:8.3333333333%}.hcr-col-2-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-md-16-4-0{margin-left:16.6666666667%}.hcr-col-3-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-md-16-4-0{margin-left:25%}.hcr-col-4-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-md-16-4-0{margin-left:33.3333333333%}.hcr-col-5-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-md-16-4-0{margin-left:41.6666666667%}.hcr-col-6-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-md-16-4-0{margin-left:50%}.hcr-col-7-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-md-16-4-0{margin-left:58.3333333333%}.hcr-col-8-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-md-16-4-0{margin-left:66.6666666667%}.hcr-col-9-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-md-16-4-0{margin-left:75%}.hcr-col-10-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-md-16-4-0{margin-left:83.3333333333%}.hcr-col-11-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-md-16-4-0{margin-left:91.6666666667%}.hcr-col-12-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-md-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-md-16-4-0{margin-left:100%}}@media (min-width:1024px){.hcr-col-1-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-lg-16-4-0{margin-left:8.3333333333%}.hcr-col-2-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-lg-16-4-0{margin-left:16.6666666667%}.hcr-col-3-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-lg-16-4-0{margin-left:25%}.hcr-col-4-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-lg-16-4-0{margin-left:33.3333333333%}.hcr-col-5-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-lg-16-4-0{margin-left:41.6666666667%}.hcr-col-6-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-lg-16-4-0{margin-left:50%}.hcr-col-7-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-lg-16-4-0{margin-left:58.3333333333%}.hcr-col-8-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-lg-16-4-0{margin-left:66.6666666667%}.hcr-col-9-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-lg-16-4-0{margin-left:75%}.hcr-col-10-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-lg-16-4-0{margin-left:83.3333333333%}.hcr-col-11-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-lg-16-4-0{margin-left:91.6666666667%}.hcr-col-12-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-lg-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-lg-16-4-0{margin-left:100%}}@media (min-width:1200px){.hcr-col-1-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:8.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-1-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:8.3333333333%}.hcr-push-1-xl-16-4-0{margin-left:8.3333333333%}.hcr-col-2-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:16.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-2-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:16.6666666667%}.hcr-push-2-xl-16-4-0{margin-left:16.6666666667%}.hcr-col-3-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:25%}.hcr-grid--gutter-4-16-4-0 .hcr-col-3-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:25%}.hcr-push-3-xl-16-4-0{margin-left:25%}.hcr-col-4-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:33.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-4-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:33.3333333333%}.hcr-push-4-xl-16-4-0{margin-left:33.3333333333%}.hcr-col-5-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:41.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-5-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:41.6666666667%}.hcr-push-5-xl-16-4-0{margin-left:41.6666666667%}.hcr-col-6-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:50%}.hcr-grid--gutter-4-16-4-0 .hcr-col-6-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:50%}.hcr-push-6-xl-16-4-0{margin-left:50%}.hcr-col-7-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:58.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-7-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:58.3333333333%}.hcr-push-7-xl-16-4-0{margin-left:58.3333333333%}.hcr-col-8-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:66.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-8-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:66.6666666667%}.hcr-push-8-xl-16-4-0{margin-left:66.6666666667%}.hcr-col-9-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:75%}.hcr-grid--gutter-4-16-4-0 .hcr-col-9-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:75%}.hcr-push-9-xl-16-4-0{margin-left:75%}.hcr-col-10-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:83.3333333333%}.hcr-grid--gutter-4-16-4-0 .hcr-col-10-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:83.3333333333%}.hcr-push-10-xl-16-4-0{margin-left:83.3333333333%}.hcr-col-11-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:91.6666666667%}.hcr-grid--gutter-4-16-4-0 .hcr-col-11-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:91.6666666667%}.hcr-push-11-xl-16-4-0{margin-left:91.6666666667%}.hcr-col-12-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-2)*.5);padding-right:calc(var(--hcr-grid-gutter-2)*.5);width:100%}.hcr-grid--gutter-4-16-4-0 .hcr-col-12-xl-16-4-0{padding-left:calc(var(--hcr-grid-gutter-4)*.5);padding-right:calc(var(--hcr-grid-gutter-4)*.5);width:100%}.hcr-push-12-xl-16-4-0{margin-left:100%}}.hcr-col-16-4-0{flex:1;margin:0 calc(var(--hcr-grid-gutter-2)*.5)}.hcr-col--inline-16-4-0{flex-basis:auto;flex-grow:0}.hcr-grid--gutter-4-16-4-0 .hcr-col-16-4-0{margin:0 calc(var(--hcr-grid-gutter-4)*.5)}",
    map: {
        "hcr-grid-container": "hcr-grid-container-16-4-0",
        "hcr-grid-container--gutter-4": "hcr-grid-container--gutter-4-16-4-0",
        "hcr-grid": "hcr-grid-16-4-0",
        "hcr-grid--align-bottom": "hcr-grid--align-bottom-16-4-0",
        "hcr-grid--align-top": "hcr-grid--align-top-16-4-0",
        "hcr-grid--align-center": "hcr-grid--align-center-16-4-0",
        "hcr-grid--justify-center": "hcr-grid--justify-center-16-4-0",
        "hcr-grid--justify-left": "hcr-grid--justify-left-16-4-0",
        "hcr-grid--justify-right": "hcr-grid--justify-right-16-4-0",
        "hcr-grid--justify-space-between": "hcr-grid--justify-space-between-16-4-0",
        "hcr-grid--gutter-4": "hcr-grid--gutter-4-16-4-0",
        "hcr-col-1": "hcr-col-1-16-4-0",
        "hcr-push-1": "hcr-push-1-16-4-0",
        "hcr-col-2": "hcr-col-2-16-4-0",
        "hcr-push-2": "hcr-push-2-16-4-0",
        "hcr-col-3": "hcr-col-3-16-4-0",
        "hcr-push-3": "hcr-push-3-16-4-0",
        "hcr-col-4": "hcr-col-4-16-4-0",
        "hcr-push-4": "hcr-push-4-16-4-0",
        "hcr-col-5": "hcr-col-5-16-4-0",
        "hcr-push-5": "hcr-push-5-16-4-0",
        "hcr-col-6": "hcr-col-6-16-4-0",
        "hcr-push-6": "hcr-push-6-16-4-0",
        "hcr-col-7": "hcr-col-7-16-4-0",
        "hcr-push-7": "hcr-push-7-16-4-0",
        "hcr-col-8": "hcr-col-8-16-4-0",
        "hcr-push-8": "hcr-push-8-16-4-0",
        "hcr-col-9": "hcr-col-9-16-4-0",
        "hcr-push-9": "hcr-push-9-16-4-0",
        "hcr-col-10": "hcr-col-10-16-4-0",
        "hcr-push-10": "hcr-push-10-16-4-0",
        "hcr-col-11": "hcr-col-11-16-4-0",
        "hcr-push-11": "hcr-push-11-16-4-0",
        "hcr-col-12": "hcr-col-12-16-4-0",
        "hcr-push-12": "hcr-push-12-16-4-0",
        "hcr-col-1-xs": "hcr-col-1-xs-16-4-0",
        "hcr-push-1-xs": "hcr-push-1-xs-16-4-0",
        "hcr-col-2-xs": "hcr-col-2-xs-16-4-0",
        "hcr-push-2-xs": "hcr-push-2-xs-16-4-0",
        "hcr-col-3-xs": "hcr-col-3-xs-16-4-0",
        "hcr-push-3-xs": "hcr-push-3-xs-16-4-0",
        "hcr-col-4-xs": "hcr-col-4-xs-16-4-0",
        "hcr-push-4-xs": "hcr-push-4-xs-16-4-0",
        "hcr-col-5-xs": "hcr-col-5-xs-16-4-0",
        "hcr-push-5-xs": "hcr-push-5-xs-16-4-0",
        "hcr-col-6-xs": "hcr-col-6-xs-16-4-0",
        "hcr-push-6-xs": "hcr-push-6-xs-16-4-0",
        "hcr-col-7-xs": "hcr-col-7-xs-16-4-0",
        "hcr-push-7-xs": "hcr-push-7-xs-16-4-0",
        "hcr-col-8-xs": "hcr-col-8-xs-16-4-0",
        "hcr-push-8-xs": "hcr-push-8-xs-16-4-0",
        "hcr-col-9-xs": "hcr-col-9-xs-16-4-0",
        "hcr-push-9-xs": "hcr-push-9-xs-16-4-0",
        "hcr-col-10-xs": "hcr-col-10-xs-16-4-0",
        "hcr-push-10-xs": "hcr-push-10-xs-16-4-0",
        "hcr-col-11-xs": "hcr-col-11-xs-16-4-0",
        "hcr-push-11-xs": "hcr-push-11-xs-16-4-0",
        "hcr-col-12-xs": "hcr-col-12-xs-16-4-0",
        "hcr-push-12-xs": "hcr-push-12-xs-16-4-0",
        "hcr-col-1-sm": "hcr-col-1-sm-16-4-0",
        "hcr-push-1-sm": "hcr-push-1-sm-16-4-0",
        "hcr-col-2-sm": "hcr-col-2-sm-16-4-0",
        "hcr-push-2-sm": "hcr-push-2-sm-16-4-0",
        "hcr-col-3-sm": "hcr-col-3-sm-16-4-0",
        "hcr-push-3-sm": "hcr-push-3-sm-16-4-0",
        "hcr-col-4-sm": "hcr-col-4-sm-16-4-0",
        "hcr-push-4-sm": "hcr-push-4-sm-16-4-0",
        "hcr-col-5-sm": "hcr-col-5-sm-16-4-0",
        "hcr-push-5-sm": "hcr-push-5-sm-16-4-0",
        "hcr-col-6-sm": "hcr-col-6-sm-16-4-0",
        "hcr-push-6-sm": "hcr-push-6-sm-16-4-0",
        "hcr-col-7-sm": "hcr-col-7-sm-16-4-0",
        "hcr-push-7-sm": "hcr-push-7-sm-16-4-0",
        "hcr-col-8-sm": "hcr-col-8-sm-16-4-0",
        "hcr-push-8-sm": "hcr-push-8-sm-16-4-0",
        "hcr-col-9-sm": "hcr-col-9-sm-16-4-0",
        "hcr-push-9-sm": "hcr-push-9-sm-16-4-0",
        "hcr-col-10-sm": "hcr-col-10-sm-16-4-0",
        "hcr-push-10-sm": "hcr-push-10-sm-16-4-0",
        "hcr-col-11-sm": "hcr-col-11-sm-16-4-0",
        "hcr-push-11-sm": "hcr-push-11-sm-16-4-0",
        "hcr-col-12-sm": "hcr-col-12-sm-16-4-0",
        "hcr-push-12-sm": "hcr-push-12-sm-16-4-0",
        "hcr-col-1-md": "hcr-col-1-md-16-4-0",
        "hcr-push-1-md": "hcr-push-1-md-16-4-0",
        "hcr-col-2-md": "hcr-col-2-md-16-4-0",
        "hcr-push-2-md": "hcr-push-2-md-16-4-0",
        "hcr-col-3-md": "hcr-col-3-md-16-4-0",
        "hcr-push-3-md": "hcr-push-3-md-16-4-0",
        "hcr-col-4-md": "hcr-col-4-md-16-4-0",
        "hcr-push-4-md": "hcr-push-4-md-16-4-0",
        "hcr-col-5-md": "hcr-col-5-md-16-4-0",
        "hcr-push-5-md": "hcr-push-5-md-16-4-0",
        "hcr-col-6-md": "hcr-col-6-md-16-4-0",
        "hcr-push-6-md": "hcr-push-6-md-16-4-0",
        "hcr-col-7-md": "hcr-col-7-md-16-4-0",
        "hcr-push-7-md": "hcr-push-7-md-16-4-0",
        "hcr-col-8-md": "hcr-col-8-md-16-4-0",
        "hcr-push-8-md": "hcr-push-8-md-16-4-0",
        "hcr-col-9-md": "hcr-col-9-md-16-4-0",
        "hcr-push-9-md": "hcr-push-9-md-16-4-0",
        "hcr-col-10-md": "hcr-col-10-md-16-4-0",
        "hcr-push-10-md": "hcr-push-10-md-16-4-0",
        "hcr-col-11-md": "hcr-col-11-md-16-4-0",
        "hcr-push-11-md": "hcr-push-11-md-16-4-0",
        "hcr-col-12-md": "hcr-col-12-md-16-4-0",
        "hcr-push-12-md": "hcr-push-12-md-16-4-0",
        "hcr-col-1-lg": "hcr-col-1-lg-16-4-0",
        "hcr-push-1-lg": "hcr-push-1-lg-16-4-0",
        "hcr-col-2-lg": "hcr-col-2-lg-16-4-0",
        "hcr-push-2-lg": "hcr-push-2-lg-16-4-0",
        "hcr-col-3-lg": "hcr-col-3-lg-16-4-0",
        "hcr-push-3-lg": "hcr-push-3-lg-16-4-0",
        "hcr-col-4-lg": "hcr-col-4-lg-16-4-0",
        "hcr-push-4-lg": "hcr-push-4-lg-16-4-0",
        "hcr-col-5-lg": "hcr-col-5-lg-16-4-0",
        "hcr-push-5-lg": "hcr-push-5-lg-16-4-0",
        "hcr-col-6-lg": "hcr-col-6-lg-16-4-0",
        "hcr-push-6-lg": "hcr-push-6-lg-16-4-0",
        "hcr-col-7-lg": "hcr-col-7-lg-16-4-0",
        "hcr-push-7-lg": "hcr-push-7-lg-16-4-0",
        "hcr-col-8-lg": "hcr-col-8-lg-16-4-0",
        "hcr-push-8-lg": "hcr-push-8-lg-16-4-0",
        "hcr-col-9-lg": "hcr-col-9-lg-16-4-0",
        "hcr-push-9-lg": "hcr-push-9-lg-16-4-0",
        "hcr-col-10-lg": "hcr-col-10-lg-16-4-0",
        "hcr-push-10-lg": "hcr-push-10-lg-16-4-0",
        "hcr-col-11-lg": "hcr-col-11-lg-16-4-0",
        "hcr-push-11-lg": "hcr-push-11-lg-16-4-0",
        "hcr-col-12-lg": "hcr-col-12-lg-16-4-0",
        "hcr-push-12-lg": "hcr-push-12-lg-16-4-0",
        "hcr-col-1-xl": "hcr-col-1-xl-16-4-0",
        "hcr-push-1-xl": "hcr-push-1-xl-16-4-0",
        "hcr-col-2-xl": "hcr-col-2-xl-16-4-0",
        "hcr-push-2-xl": "hcr-push-2-xl-16-4-0",
        "hcr-col-3-xl": "hcr-col-3-xl-16-4-0",
        "hcr-push-3-xl": "hcr-push-3-xl-16-4-0",
        "hcr-col-4-xl": "hcr-col-4-xl-16-4-0",
        "hcr-push-4-xl": "hcr-push-4-xl-16-4-0",
        "hcr-col-5-xl": "hcr-col-5-xl-16-4-0",
        "hcr-push-5-xl": "hcr-push-5-xl-16-4-0",
        "hcr-col-6-xl": "hcr-col-6-xl-16-4-0",
        "hcr-push-6-xl": "hcr-push-6-xl-16-4-0",
        "hcr-col-7-xl": "hcr-col-7-xl-16-4-0",
        "hcr-push-7-xl": "hcr-push-7-xl-16-4-0",
        "hcr-col-8-xl": "hcr-col-8-xl-16-4-0",
        "hcr-push-8-xl": "hcr-push-8-xl-16-4-0",
        "hcr-col-9-xl": "hcr-col-9-xl-16-4-0",
        "hcr-push-9-xl": "hcr-push-9-xl-16-4-0",
        "hcr-col-10-xl": "hcr-col-10-xl-16-4-0",
        "hcr-push-10-xl": "hcr-push-10-xl-16-4-0",
        "hcr-col-11-xl": "hcr-col-11-xl-16-4-0",
        "hcr-push-11-xl": "hcr-push-11-xl-16-4-0",
        "hcr-col-12-xl": "hcr-col-12-xl-16-4-0",
        "hcr-push-12-xl": "hcr-push-12-xl-16-4-0",
        "hcr-col": "hcr-col-16-4-0",
        "hcr-col--inline": "hcr-col--inline-16-4-0"
    }
};







var $acw62 = parcelRequire("acw62");





function $f7294196a699ec48$export$2e2bcd8739ae039({ children: children }) {
    const bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('grid-container', (0, $4702524f7bf99409$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: bem.b()
    }, children);
}
$f7294196a699ec48$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired
};


const $fa735e4ef47d48a3$export$2f51907f9d92360d = [
    'top',
    'bottom',
    'center'
];
const $fa735e4ef47d48a3$export$7a4b931763354ad0 = [
    'left',
    'right',
    'center',
    'space-between'
];
const $fa735e4ef47d48a3$export$82cc40b257ba9fe7 = [
    '2',
    '4'
];



function $a56a5249bf41155e$export$ef2184bd89960b14(_a) {
    var { extraClasses: extraClasses, children: children, applyContainer: applyContainer = false, align: align, justify: justify, gutterSize: gutterSize = '2', innerRef: innerRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "applyContainer",
        "align",
        "justify",
        "gutterSize",
        "innerRef"
    ]);
    const bemGrid = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('grid', (0, $4702524f7bf99409$export$2e2bcd8739ae039));
    const bemGridClassNames = bemGrid.b({
        [`align-${align}`]: align,
        [`justify-${justify}`]: justify,
        [`gutter-${gutterSize}`]: gutterSize
    }, extraClasses);
    const gridRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: bemGridClassNames
    }, rest), children);
    return applyContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7294196a699ec48$export$2e2bcd8739ae039), null, gridRow) : gridRow;
}
$a56a5249bf41155e$export$ef2184bd89960b14.displayName = 'Grid';
$a56a5249bf41155e$export$ef2184bd89960b14.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('GridCol'),
    applyContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    align: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $fa735e4ef47d48a3$export$2f51907f9d92360d)),
    justify: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $fa735e4ef47d48a3$export$7a4b931763354ad0)),
    gutterSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $fa735e4ef47d48a3$export$82cc40b257ba9fe7)),
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};
var $a56a5249bf41155e$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($a56a5249bf41155e$export$ef2184bd89960b14, (0, $4702524f7bf99409$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");





const $08f80c36a1823783$export$c347fe6707b6a630 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];


function $e07bc6cc49523b41$export$1b5689fc8adf2f5e(_a) {
    var { extraClasses: extraClasses = '', children: children, inline: inline = false, size: size, sm: sm, md: md, lg: lg, xl: xl, push: push, pushSm: pushSm, pushMd: pushMd, pushLg: pushLg, pushXl: pushXl, innerRef: innerRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "inline",
        "size",
        "sm",
        "md",
        "lg",
        "xl",
        "push",
        "pushSm",
        "pushMd",
        "pushLg",
        "pushXl",
        "innerRef"
    ]);
    const gridColBem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('col', (0, $4702524f7bf99409$export$2e2bcd8739ae039));
    // `flix-col-` and `flix-push-` grid classes doesn't follow the BEM syntax,
    // using BEM mixes in order to assemble the resulting class string
    // @todo consider refactoring to use BEM syntax consistently
    const colClassNames = gridColBem.mix({
        [extraClasses]: extraClasses,
        [gridColBem.b({
            inline: inline
        })]: !size,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`col-${size}`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: size,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`col-${sm}-sm`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: sm,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`col-${md}-md`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: md,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`col-${lg}-lg`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: lg,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`col-${xl}-xl`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: xl,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`push-${push}`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: push,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`push-${pushSm}-sm`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: pushSm,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`push-${pushMd}-md`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: pushMd,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`push-${pushLg}-lg`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: pushLg,
        [new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`push-${pushXl}-xl`, (0, $4702524f7bf99409$export$2e2bcd8739ae039)).b()]: pushXl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: colClassNames
    }, rest), children);
}
$e07bc6cc49523b41$export$1b5689fc8adf2f5e.displayName = 'GridCol';
$e07bc6cc49523b41$export$1b5689fc8adf2f5e.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    sm: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    md: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    lg: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    xl: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    pushSm: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    pushMd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    pushLg: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    pushXl: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $08f80c36a1823783$export$c347fe6707b6a630)),
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};



var $acw62 = parcelRequire("acw62");

var $53029cf23931f89b$export$2e2bcd8739ae039 = {
    raw: ".hcr-header-16-4-0{--hcr-container-content-color:var(--hcr-header-color);background:var(--hcr-header-bg-color);color:var(--hcr-header-color);left:0;padding:0 var(--hcr-spacing-2);position:fixed;right:0;top:0;z-index:1000}.hcr-header__inner-16-4-0{column-gap:var(--hcr-spacing-2);display:grid;grid-template-areas:\"burger burger brand brand brand brand brand brand brand widget widget widget\";grid-template-columns:repeat(12,1fr);margin:0 auto;min-height:var(--hcr-spacing-10);position:relative}@media (min-width:768px){.hcr-header__inner-16-4-0{grid-template-areas:\"brand brand brand brand brand brand brand brand widget widget widget widget\"\"nav nav nav nav nav nav                             nav nav nav nav nav nav\"}}@media (min-width:1200px){.hcr-header__inner-16-4-0{grid-template-areas:\"brand brand nav nav nav nav nav nav nav nav widget widget\";max-width:calc(var(--hcr-page-max-width) - 2*var(--hcr-spacing-2));min-width:calc(var(--hcr-page-min-width) - 2*var(--hcr-spacing-2))}.hcr-header--widget-m-16-4-0 .hcr-header__inner-16-4-0{grid-template-areas:\"brand brand nav nav nav nav nav nav nav widget widget widget\"}.hcr-header--widget-l-16-4-0 .hcr-header__inner-16-4-0{grid-template-areas:\"brand brand nav nav nav nav nav nav widget widget widget widget\"}}.hcr-header--fullwidth-16-4-0 .hcr-header__inner-16-4-0{max-width:none}.hcr-header--unfixed-16-4-0{position:static}.hcr-header-nav-16-4-0{display:none}.hcr-header-burger-menu-16-4-0{display:block}@media (min-width:768px){.hcr-header-nav-16-4-0{display:block}.hcr-header-burger-menu-16-4-0{display:none}}",
    map: {
        "hcr-header": "hcr-header-16-4-0",
        "hcr-header__inner": "hcr-header__inner-16-4-0",
        "hcr-header--widget-m": "hcr-header--widget-m-16-4-0",
        "hcr-header--widget-l": "hcr-header--widget-l-16-4-0",
        "hcr-header--fullwidth": "hcr-header--fullwidth-16-4-0",
        "hcr-header--unfixed": "hcr-header--unfixed-16-4-0",
        "hcr-header-nav": "hcr-header-nav-16-4-0",
        "hcr-header-burger-menu": "hcr-header-burger-menu-16-4-0"
    }
};





const $d66ca8a210ec5162$export$dcddda83585522a9 = [
    'm',
    'l'
];




const $f95fd1159f86112d$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header', (0, $53029cf23931f89b$export$2e2bcd8739ae039));
function $f95fd1159f86112d$export$8b251419efc915eb(_a) {
    var { extraClasses: extraClasses, fullwidth: fullwidth = false, fixed: fixed = false, innerRef: innerRef, skipLinks: skipLinks, brand: brand, navigation: navigation, burgerMenu: burgerMenu, widgets: widgets, widgetSize: widgetSize } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "fullwidth",
        "fixed",
        "innerRef",
        "skipLinks",
        "brand",
        "navigation",
        "burgerMenu",
        "widgets",
        "widgetSize"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", Object.assign({
        ref: innerRef,
        className: $f95fd1159f86112d$var$bem.b({
            fullwidth: fullwidth,
            unfixed: !fixed,
            [`widget-${widgetSize}`]: Boolean(widgetSize)
        }, extraClasses)
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $f95fd1159f86112d$var$bem.e('inner')
    }, skipLinks, brand, navigation, burgerMenu, widgets));
}
$f95fd1159f86112d$export$8b251419efc915eb.displayName = 'Header';
$f95fd1159f86112d$export$8b251419efc915eb.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    fullwidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    fixed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    skipLinks: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('HeaderSkipLinks'),
    brand: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('HeaderBrand'),
    navigation: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('HeaderNavigation'),
    burgerMenu: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('HeaderBurgerMenu'),
    widgets: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('HeaderWidgets'),
    widgetSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $d66ca8a210ec5162$export$dcddda83585522a9))
};
var $f95fd1159f86112d$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($f95fd1159f86112d$export$8b251419efc915eb, (0, $53029cf23931f89b$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $3037fe3bb5213181$export$2e2bcd8739ae039 = {
    raw: ".hcr-header-brand-16-4-0{align-items:center;align-self:center;display:flex;grid-area:brand;grid-column:1/-1;height:var(--hcr-spacing-10);justify-content:center}@media (min-width:1200px){.hcr-header-brand-16-4-0{grid-column:brand-start/brand-end;justify-content:flex-start}}.hcr-header-brand__link-16-4-0{display:block;margin:0 calc(-1*var(--hcr-spacing-1));padding:var(--hcr-spacing-1);width:-moz-fit-content;width:fit-content}.hcr-header-brand__link-16-4-0:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-header-brand__img-16-4-0{display:block;height:var(--hcr-spacing-4);width:auto}.hcr-header-brand--tall-16-4-0 .hcr-header-brand__img-16-4-0{height:var(--hcr-spacing-6)}.hcr-header-brand--square-16-4-0 .hcr-header-brand__img-16-4-0{height:var(--hcr-spacing-6);width:var(--hcr-spacing-6)}",
    map: {
        "hcr-header-brand": "hcr-header-brand-16-4-0",
        "hcr-header-brand__link": "hcr-header-brand__link-16-4-0",
        "hcr-header-brand__img": "hcr-header-brand__img-16-4-0",
        "hcr-header-brand--tall": "hcr-header-brand--tall-16-4-0",
        "hcr-header-brand--square": "hcr-header-brand--square-16-4-0"
    }
};





const $2f17fe0740fb384d$export$6705bbf058e515e9 = [
    'square',
    'tall'
];



const $5f19e397f3651e2e$var$bemBrand = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header-brand', (0, $3037fe3bb5213181$export$2e2bcd8739ae039));
function $5f19e397f3651e2e$export$7eeca4f9565066a1(_a) {
    var { alt: alt, appearance: appearance, extraClasses: extraClasses, height: height, href: href, innerRef: innerRef, RouterLink: RouterLink, src: src, width: width, theme: theme = 'flix' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "alt",
        "appearance",
        "extraClasses",
        "height",
        "href",
        "innerRef",
        "RouterLink",
        "src",
        "width",
        "theme"
    ]);
    const themedSrc = Array.isArray(src) ? src.filter((item)=>item.theme === theme)[0].src : src;
    const themedAppearance = Array.isArray(src) && src.filter((item)=>item.theme === theme)[0].appearance || appearance;
    const image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: $5f19e397f3651e2e$var$bemBrand.e('img'),
        src: themedSrc,
        alt: alt,
        width: width,
        height: height
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $5f19e397f3651e2e$var$bemBrand.b([
            themedAppearance
        ], extraClasses)
    }, RouterLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RouterLink, Object.assign({
        className: $5f19e397f3651e2e$var$bemBrand.e('link'),
        to: href
    }, innerRef ? {
        innerRef: innerRef
    } : {}, rest), image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        ref: innerRef,
        className: $5f19e397f3651e2e$var$bemBrand.e('link'),
        href: href
    }, rest), image));
}
$5f19e397f3651e2e$export$7eeca4f9565066a1.displayName = 'HeaderBrand';
$5f19e397f3651e2e$export$7eeca4f9565066a1.propTypes = {
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            theme: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
            appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $2f17fe0740fb384d$export$6705bbf058e515e9))
        }))
    ]).isRequired,
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $2f17fe0740fb384d$export$6705bbf058e515e9)),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    RouterLink: (0, $702b9449be14ac4b$export$50d0863e1c2a2c7f),
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $5f19e397f3651e2e$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($5f19e397f3651e2e$export$7eeca4f9565066a1, (0, $3037fe3bb5213181$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $7caffcf97c2c9c2e$export$2e2bcd8739ae039 = {
    raw: ".hcr-header-burger-menu-16-4-0{align-self:center;grid-area:burger}@media (min-width:1200px){.hcr-header-burger-menu-16-4-0{left:var(--hcr-spacing-2);position:absolute}}.hcr-header-burger-menu__overlay-16-4-0{display:none}.hcr-header-burger-menu-16-4-0>.hcr-header-burger-menu__toggle-16-4-0:after{background-color:var(--hcr-header-color);content:\"\";height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M2\\ 5a1\\ 1\\ 0\\ 011-1h18a1\\ 1\\ 0\\ 010\\ 2H3a1\\ 1\\ 0\\ 01-1-1zm19\\ 6H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2zm0\\ 7H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M2\\ 5a1\\ 1\\ 0\\ 011-1h18a1\\ 1\\ 0\\ 010\\ 2H3a1\\ 1\\ 0\\ 01-1-1zm19\\ 6H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2zm0\\ 7H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-header-burger-menu__panel-16-4-0{background:var(--hcr-box-bg-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;color:var(--hcr-content-secondary-color);left:-23.75em;max-width:23.75em;overflow-y:auto;padding-bottom:env(safe-area-inset-bottom);padding-top:env(safe-area-inset-top);position:fixed;top:0;width:85%;z-index:1000;-webkit-overflow-scrolling:touch;transition:left .25s ease}.hcr-header-burger-menu__panel-16-4-0>.hcr-header-burger-menu__toggle-16-4-0{margin:var(--hcr-spacing-2)}.hcr-header-burger-menu__panel-16-4-0>.hcr-header-burger-menu__toggle-16-4-0:before{background-color:var(--hcr-icon-primary-color);content:\"\";height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}.hcr-header-burger-menu__toggle-16-4-0[aria-expanded=true]+.hcr-header-burger-menu__panel-16-4-0:not([hidden]){left:0}.hcr-header-burger-menu__toggle-16-4-0[aria-expanded=true]~.hcr-header-burger-menu__overlay-16-4-0{display:block;z-index:999}.hcr-header-burger-menu__nav-16-4-0{position:static;width:100%}.hcr-header-burger-menu__list-16-4-0{list-style-type:none;margin:0;padding:0}.hcr-header-burger-menu__item-16-4-0{border-top:1px solid var(--hcr-line-primary-color)}.hcr-header-burger-menu__link-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);text-align:inherit}.hcr-header-burger-menu__link-16-4-0{align-items:center;color:var(--hcr-content-secondary-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-3) var(--hcr-spacing-4);text-align:left;text-decoration:none;width:100%}.hcr-header-burger-menu__link-16-4-0 .hcr-icon-16-4-0,.hcr-header-burger-menu__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-header-burger-menu__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-header-burger-menu__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-header-burger-menu__link-16-4-0[aria-expanded]:after{background-color:var(--hcr-header-color);content:\"\";height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-header-burger-menu__link-16-4-0[aria-expanded=true]:after{transform:rotate(180deg)}.hcr-header-burger-menu__link-16-4-0[aria-expanded=true]+.hcr-header-burger-menu-subnav-16-4-0:not([hidden]),.hcr-header-burger-menu__link-16-4-0[aria-expanded=true]+.hcr-header-nav-subnav-16-4-0:not([hidden]){display:block}.hcr-header-burger-menu__link-16-4-0[aria-expanded]:after{background-color:var(--hcr-icon-primary-color)}.hcr-header-burger-menu__link-16-4-0[aria-current],.hcr-header-burger-menu__link-16-4-0[aria-selected=true]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);position:relative}.hcr-header-burger-menu__link-16-4-0[aria-current]:before,.hcr-header-burger-menu__link-16-4-0[aria-selected=true]:before{background:var(--hcr-brand-primary-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;content:\"\";height:var(--hcr-spacing-4);left:0;position:absolute;top:calc(50% - var(--hcr-spacing-4)/2);width:var(--hcr-spacing-half)}.hcr-header-burger-menu__link-16-4-0:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-header-burger-menu__link-16-4-0:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-header-burger-menu__link-16-4-0:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) - 2px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:-2px}.hcr-header-burger-menu__link-16-4-0:focus-visible:before{opacity:0}.hcr-header-burger-menu__text-16-4-0{display:block;width:100%}.hcr-header-burger-menu__widgets--has-container-16-4-0{border-top:1px solid var(--hcr-line-primary-color);padding:var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-header-burger-menu-subnav-16-4-0{display:none;padding:0 var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-7)}.hcr-header-burger-menu-subnav__item-16-4-0{display:block}.hcr-header-burger-menu-subnav__link-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);text-align:inherit}.hcr-header-burger-menu-subnav__link-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-secondary-color);cursor:pointer;display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);margin:var(--hcr-spacing-half)0;padding:var(--hcr-spacing-1) var(--hcr-spacing-half);position:relative;text-decoration:none;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-header-burger-menu-subnav__link-16-4-0 .hcr-icon-16-4-0,.hcr-header-burger-menu-subnav__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-header-burger-menu-subnav__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-header-burger-menu-subnav__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-header-burger-menu-subnav__link-16-4-0:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-header-burger-menu-subnav__link-16-4-0:enabled:active,.hcr-header-burger-menu-subnav__link-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-header-burger-menu-subnav__link-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 0) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:0}.hcr-header-burger-menu-subnav__link-16-4-0[aria-current]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);padding-left:var(--hcr-spacing-2);position:relative}.hcr-header-burger-menu-subnav__link-16-4-0[aria-current]:before{background:var(--hcr-brand-primary-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;content:\"\";height:var(--hcr-spacing-4);left:0;position:absolute;top:calc(50% - var(--hcr-spacing-4)/2);width:var(--hcr-spacing-half)}.hcr-header-burger-menu__link-16-4-0 [class^=hci-icon]{align-self:baseline;flex-shrink:0}",
    map: {
        "hcr-header-burger-menu": "hcr-header-burger-menu-16-4-0",
        "hcr-header-burger-menu__overlay": "hcr-header-burger-menu__overlay-16-4-0",
        "hcr-header-burger-menu__toggle": "hcr-header-burger-menu__toggle-16-4-0",
        "hcr-header-burger-menu__panel": "hcr-header-burger-menu__panel-16-4-0",
        "hcr-header-burger-menu__nav": "hcr-header-burger-menu__nav-16-4-0",
        "hcr-header-burger-menu__list": "hcr-header-burger-menu__list-16-4-0",
        "hcr-header-burger-menu__item": "hcr-header-burger-menu__item-16-4-0",
        "hcr-header-burger-menu__link": "hcr-header-burger-menu__link-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-header-burger-menu-subnav": "hcr-header-burger-menu-subnav-16-4-0",
        "hcr-header-nav-subnav": "hcr-header-nav-subnav-16-4-0",
        "hcr-header-burger-menu__text": "hcr-header-burger-menu__text-16-4-0",
        "hcr-header-burger-menu__widgets--has-container": "hcr-header-burger-menu__widgets--has-container-16-4-0",
        "hcr-header-burger-menu-subnav__item": "hcr-header-burger-menu-subnav__item-16-4-0",
        "hcr-header-burger-menu-subnav__link": "hcr-header-burger-menu-subnav__link-16-4-0"
    }
};








var $acw62 = parcelRequire("acw62");
const $0ec55452460ccd57$var$HeaderBurgerMenuContext = /*#__PURE__*/ (0, $acw62.createContext)({
    closeBurgerMenu: ()=>{}
});
function $0ec55452460ccd57$export$e81581b67b002bf5(props) {
    const { children: children, closeBurgerMenu: closeBurgerMenu } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0ec55452460ccd57$var$HeaderBurgerMenuContext.Provider, {
        value: {
            closeBurgerMenu: closeBurgerMenu
        }
    }, children);
}
/** Allows access to `HeaderBurgerMenuContext` when used as a burger menu item or widget component. */ const $0ec55452460ccd57$export$3820cb12ec3eed43 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0ec55452460ccd57$var$HeaderBurgerMenuContext);








var $acw62 = parcelRequire("acw62");
/**
 * @since 7.6.0
 *
 * Creates a controllable state. E.g: components that have internal state management that could be
 * overwritten by external props.
 *
 * @returns `[value, setValue]` an array with value and value setter function.
 */ function $d003d9005214b083$export$6f32135080cb4c3({ state: state, defaultState: defaultState }) {
    const [controlledState, setControlledState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultState);
    const isControlled = state !== undefined;
    const value = isControlled ? state : controlledState;
    const setValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((nextValue)=>{
        if (!isControlled) setControlledState(nextValue);
    }, []);
    return [
        value,
        setValue
    ];
}


const $d2599f6bb9ec513a$var$componentName = 'header-burger-menu';
const $d2599f6bb9ec513a$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)($d2599f6bb9ec513a$var$componentName, (0, $7caffcf97c2c9c2e$export$2e2bcd8739ae039));
function $d2599f6bb9ec513a$export$d8e5b4bce9d362b0(_a) {
    var { children: children, extraClasses: extraClasses, panelId: panelId, openPanelLabel: openPanelLabel, closePanelLabel: closePanelLabel, widgets: widgets, applyWidgetContainer: applyWidgetContainer = false, innerRef: innerRef, onToggle: onToggle, open: openProp, disableBodyStyleModifications: disableBodyStyleModifications = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "panelId",
        "openPanelLabel",
        "closePanelLabel",
        "widgets",
        "applyWidgetContainer",
        "innerRef",
        "onToggle",
        "open",
        "disableBodyStyleModifications"
    ]);
    const [open, setOpen] = (0, $d003d9005214b083$export$6f32135080cb4c3)({
        state: openProp,
        defaultState: false
    });
    const isOpen = Boolean(open);
    const [hiddenAttr, ariaExpandedProp] = (0, $67561704b17d0e15$export$a8eea371d4bdec47)(isOpen);
    const openMenu = ()=>setOpen(true);
    const closeMenu = ()=>setOpen(false);
    if (!disableBodyStyleModifications) (0, $2281ea219ab01c59$export$bd4ec12442706c3d)(!hiddenAttr);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onToggle === null || onToggle === void 0 || onToggle(isOpen);
    }, [
        isOpen
    ]);
    const toggleButton = (label, action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
            extraClasses: $d2599f6bb9ec513a$var$bem.e('toggle'),
            appearance: "link",
            display: "square",
            size: "md",
            "aria-label": label,
            "aria-controls": panelId,
            "aria-expanded": ariaExpandedProp,
            onClick: action
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$ada278d15ed54cfa).Provider, {
        value: $d2599f6bb9ec513a$var$bem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0ec55452460ccd57$export$e81581b67b002bf5), {
        closeBurgerMenu: closeMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: $d2599f6bb9ec513a$var$bem.b(false, extraClasses)
    }, rest), toggleButton(openPanelLabel, openMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $d2599f6bb9ec513a$var$bem.e('panel'),
        id: panelId,
        role: "dialog",
        "aria-modal": "true",
        hidden: hiddenAttr
    }, toggleButton(closePanelLabel, closeMenu), children, widgets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $d2599f6bb9ec513a$var$bem.e('widgets', {
            'has-container': applyWidgetContainer
        })
    }, widgets)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c3a9b3faf56c39c9$export$2e2bcd8739ae039), {
        extraClasses: $d2599f6bb9ec513a$var$bem.e('overlay'),
        onClick: closeMenu
    }))));
}
$d2599f6bb9ec513a$export$d8e5b4bce9d362b0.displayName = 'HeaderBurgerMenu';
$d2599f6bb9ec513a$export$d8e5b4bce9d362b0.propTypes = {
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('HeaderNavigation'),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    panelId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    openPanelLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    closePanelLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    widgets: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    applyWidgetContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};
var $d2599f6bb9ec513a$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($d2599f6bb9ec513a$export$d8e5b4bce9d362b0, (0, $7caffcf97c2c9c2e$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $408d7e64dc7c867c$export$2e2bcd8739ae039 = {
    raw: ".hcr-header-nav-subnav-16-4-0{--hcr-balloon-width:15.75rem;--hcr-balloon-height:44px;--hcr-balloon-background:var(--hcr-box-bg-color);--hcr-balloon-color:var(--hcr-content-primary-color);--hcr-balloon-close-color:var(--hcr-icon-primary-color);--hcr-balloon-content-margin:0;--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) var(--hcr-spacing-2);color:var(--hcr-balloon-color);font-family:inherit;font-size:var(--hcr-font-size-primary);justify-content:space-between;min-height:var(--hcr-balloon-height);min-width:var(--hcr-balloon-width);position:relative;text-decoration:none;width:-moz-fit-content;width:fit-content;z-index:10}.hcr-header-nav-subnav-16-4-0:before{background:var(--hcr-balloon-background);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);content:\"\";position:absolute;top:0;z-index:-1}.hcr-header-nav-subnav-16-4-0{padding:var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-header-nav-subnav-16-4-0:before{bottom:0;left:0;right:0;top:var(--hcr-spacing-2)}.hcr-header-nav-subnav-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-left:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-right:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-top:0;content:\"\";height:0;inset:var(--hcr-spacing-1) auto auto;left:50%;position:absolute;right:auto;transform:translateX(-50%);width:0;z-index:0}.hcr-header-nav-subnav--right-16-4-0:after{left:min(25%,var(--hcr-spacing-3));transform:none}.hcr-header-nav-subnav--left-16-4-0:after{left:auto;right:min(25%,var(--hcr-spacing-3));transform:none}.hcr-header-nav-16-4-0{background:var(--hcr-header-nav-bg-color-tablet);grid-area:nav;grid-column:nav-start/-1;margin:0 calc(var(--hcr-spacing-2)*-1)}@media (min-width:1200px){.hcr-header-nav-16-4-0{background:none;margin:0}.hcr-header__inner-16-4-0:has(>.hcr-header-widgets-16-4-0) .hcr-header-nav-16-4-0{grid-column:nav-start/nav-end}}.hcr-header-nav__list-16-4-0{display:flex;flex-wrap:wrap;justify-content:center;list-style-type:none;margin:0 auto;padding:0}@media (min-width:1200px){.hcr-header-nav__list-16-4-0{justify-content:flex-start;margin:0;max-width:none}}.hcr-header-nav__item-16-4-0{position:relative}.hcr-header-nav__link-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-header-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);min-height:var(--hcr-spacing-8);padding:var(--hcr-spacing-2);text-decoration:none}.hcr-header-nav__link-16-4-0 .hcr-icon-16-4-0,.hcr-header-nav__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-header-nav__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-header-nav__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-header-nav__link-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);text-align:inherit}.hcr-header-nav__link-16-4-0[aria-expanded]:after{background-color:var(--hcr-header-color);content:\"\";height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-header-nav__link-16-4-0[aria-expanded=true]:after{transform:rotate(180deg)}.hcr-header-nav__link-16-4-0[aria-expanded=true]+.hcr-header-burger-menu-subnav-16-4-0:not([hidden]),.hcr-header-nav__link-16-4-0[aria-expanded=true]+.hcr-header-nav-subnav-16-4-0:not([hidden]){display:block}.hcr-header-nav__link-16-4-0:enabled:hover,.hcr-header-nav__link-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-header-nav__link-16-4-0:enabled:active,.hcr-header-nav__link-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-header-nav__link-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}@media (min-width:1200px){.hcr-header-nav__link-16-4-0{min-height:var(--hcr-spacing-10);padding:var(--hcr-spacing-3) var(--hcr-spacing-2)}}.hcr-header-nav__link-16-4-0[aria-current],.hcr-header-nav__link-16-4-0[aria-selected=true]{color:var(--hcr-header-color);position:relative}.hcr-header-nav__link-16-4-0[aria-current]:before,.hcr-header-nav__link-16-4-0[aria-selected=true]:before{background:var(--hcr-header-color);border-radius:var(--hcr-border-radius-1) var(--hcr-border-radius-1)0 0;bottom:0;content:\"\";height:var(--hcr-spacing-half);left:0;position:absolute;right:0}.hcr-header-nav__link-16-4-0[aria-expanded]:after{align-self:stretch;height:auto}.hcr-header-nav-subnav-16-4-0{bottom:auto;display:none;flex-direction:column;left:50%;margin:calc(-1*var(--hcr-spacing-1))0 0;padding:var(--hcr-spacing-4)0 var(--hcr-spacing-2);position:absolute;top:75%;transform:translateX(-50%)}.hcr-header-nav-subnav--left-16-4-0{transform:translateX(calc(-100% + min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-header-nav-subnav--right-16-4-0{transform:translateX(calc(-1*min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-header-nav-subnav__item-16-4-0{list-style:none;text-align:left}.hcr-header-nav-subnav__item-16-4-0:not(:last-of-type){margin-bottom:var(--hcr-spacing-1)}.hcr-header-nav-subnav__link-16-4-0{align-items:center;color:var(--hcr-content-secondary-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-1) var(--hcr-spacing-4);position:relative;text-align:left;text-decoration:none;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-header-nav-subnav__link-16-4-0 .hcr-icon-16-4-0,.hcr-header-nav-subnav__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-header-nav-subnav__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-header-nav-subnav__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-header-nav-subnav__link-16-4-0[aria-current],.hcr-header-nav-subnav__link-16-4-0[aria-selected=true]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);position:relative}.hcr-header-nav-subnav__link-16-4-0[aria-current]:before,.hcr-header-nav-subnav__link-16-4-0[aria-selected=true]:before{background:var(--hcr-brand-primary-color);border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;bottom:0;content:\"\";height:var(--hcr-spacing-4);left:0;position:absolute;top:calc(50% - var(--hcr-spacing-4)/2);width:var(--hcr-spacing-half)}.hcr-header-nav-subnav__link-16-4-0:is(a,button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-weight:var(--hcr-font-weight-semibold);text-align:inherit}.hcr-header-nav-subnav__link-16-4-0:is(a,button):enabled:hover,.hcr-header-nav-subnav__link-16-4-0:is(a,button)[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-header-nav-subnav__link-16-4-0:is(a,button):enabled:active,.hcr-header-nav-subnav__link-16-4-0:is(a,button)[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-header-nav-subnav__link-16-4-0:is(a,button):focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) - 2px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:-2px}.hcr-header-nav-subnav__link-16-4-0:is(a,button):focus-visible:before{opacity:0}",
    map: {
        "hcr-header-nav-subnav": "hcr-header-nav-subnav-16-4-0",
        "hcr-header-nav-subnav--right": "hcr-header-nav-subnav--right-16-4-0",
        "hcr-header-nav-subnav--left": "hcr-header-nav-subnav--left-16-4-0",
        "hcr-header-nav": "hcr-header-nav-16-4-0",
        "hcr-header__inner": "hcr-header__inner-16-4-0",
        "hcr-header-widgets": "hcr-header-widgets-16-4-0",
        "hcr-header-nav__list": "hcr-header-nav__list-16-4-0",
        "hcr-header-nav__item": "hcr-header-nav__item-16-4-0",
        "hcr-header-nav__link": "hcr-header-nav__link-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-header-burger-menu-subnav": "hcr-header-burger-menu-subnav-16-4-0",
        "hcr-header-nav-subnav__item": "hcr-header-nav-subnav__item-16-4-0",
        "hcr-header-nav-subnav__link": "hcr-header-nav-subnav__link-16-4-0"
    }
};








function $a8372fc2863001da$export$30c8227d86cbe2f5(_a) {
    var { children: children, 'aria-label': ariaLabel, extraClasses: extraClasses, innerRef: innerRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        'aria-label',
        "extraClasses",
        "innerRef"
    ]);
    const parentBem = (0, $acw62.useContext)((0, $f4713e20c85afaf3$export$ada278d15ed54cfa));
    const bem = (0, $acw62.useMemo)(()=>parentBem || new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header-nav', (0, $408d7e64dc7c867c$export$2e2bcd8739ae039)), [
        parentBem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$ada278d15ed54cfa).Provider, {
        value: bem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", Object.assign({
        ref: innerRef,
        "aria-label": ariaLabel,
        className: bem.b(false, [
            extraClasses,
            bem.e('nav')
        ])
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: bem.e('list')
    }, children)));
}
$a8372fc2863001da$export$30c8227d86cbe2f5.displayName = 'HeaderNavigation';
$a8372fc2863001da$export$30c8227d86cbe2f5.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('NavItem'),
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};
var $a8372fc2863001da$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($a8372fc2863001da$export$30c8227d86cbe2f5, (0, $408d7e64dc7c867c$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");






const $43250af9d6e2f543$export$92708714045597e7 = [
    'left',
    'right'
];





/** @visibleName HeaderSubNavigation */ function $1384d326eb4d180d$export$b1f66cf2ca09f3c3(_a) {
    var { id: id, children: children, extraClasses: extraClasses, alignment: alignment, innerRef: innerRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "children",
        "extraClasses",
        "alignment",
        "innerRef"
    ]);
    const parentBem = (0, $acw62.useContext)((0, $f4713e20c85afaf3$export$ada278d15ed54cfa));
    const bem = (0, $acw62.useMemo)(()=>parentBem ? new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)(`${parentBem.block.replace('hcr-', '')}-subnav`, parentBem.module) : new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header-nav-subnav', (0, $408d7e64dc7c867c$export$2e2bcd8739ae039)), [
        parentBem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$ada278d15ed54cfa).Provider, {
        value: bem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fab663585318a761$export$a9c522a6d7beb830), Object.assign({
        id: id,
        ref: innerRef,
        // allowing for proper click element detection in the submenu, so onBlur works as expected
        tabIndex: -1
    }, rest, {
        className: bem.b(alignment, extraClasses)
    }), children));
}
$1384d326eb4d180d$export$b1f66cf2ca09f3c3.displayName = 'HeaderSubNavigation(SubMenu)';
$1384d326eb4d180d$export$b1f66cf2ca09f3c3.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('NavItem'),
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $43250af9d6e2f543$export$92708714045597e7)),
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};
var $1384d326eb4d180d$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($1384d326eb4d180d$export$b1f66cf2ca09f3c3, (0, $408d7e64dc7c867c$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");

var $d81e2d3add027f3a$export$2e2bcd8739ae039 = {
    raw: ".hcr-header-widgets-16-4-0{align-self:center;grid-area:widget;justify-self:end}.hcr-header-widgets-16-4-0:not(.hcr-header-widgets--no-responsive-rendering-16-4-0){display:none}@media (min-width:768px){.hcr-header-widgets-16-4-0:not(.hcr-header-widgets--no-responsive-rendering-16-4-0){display:block}}.hcr-header-user-widget-16-4-0{align-items:center;display:flex;gap:var(--hcr-spacing-1);position:relative}.hcr-header-user-widget__toggle-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-header-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-1);line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-1);text-decoration:none}.hcr-header-user-widget__toggle-16-4-0 .hcr-icon-16-4-0,.hcr-header-user-widget__toggle-16-4-0 [class^=hci-icon]{line-height:1}.hcr-header-user-widget__toggle-16-4-0 .hcr-icon-16-4-0:before,.hcr-header-user-widget__toggle-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-header-user-widget__toggle-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);text-align:inherit}.hcr-header-user-widget__toggle-16-4-0[aria-expanded]:after{background-color:var(--hcr-header-color);content:\"\";height:var(--hcr-spacing-4);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-4)}.hcr-header-user-widget__toggle-16-4-0[aria-expanded=true]:after{transform:rotate(180deg)}.hcr-header-user-widget__toggle-16-4-0[aria-expanded=true]+.hcr-header-burger-menu-subnav-16-4-0:not([hidden]),.hcr-header-user-widget__toggle-16-4-0[aria-expanded=true]+.hcr-header-nav-subnav-16-4-0:not([hidden]){display:block}.hcr-header-user-widget__toggle-16-4-0:enabled:hover,.hcr-header-user-widget__toggle-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-header-user-widget__toggle-16-4-0:enabled:active,.hcr-header-user-widget__toggle-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-header-user-widget__toggle-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}",
    map: {
        "hcr-header-widgets": "hcr-header-widgets-16-4-0",
        "hcr-header-widgets--no-responsive-rendering": "hcr-header-widgets--no-responsive-rendering-16-4-0",
        "hcr-header-user-widget": "hcr-header-user-widget-16-4-0",
        "hcr-header-user-widget__toggle": "hcr-header-user-widget__toggle-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-header-burger-menu-subnav": "hcr-header-burger-menu-subnav-16-4-0",
        "hcr-header-nav-subnav": "hcr-header-nav-subnav-16-4-0"
    }
};









parcelRequire("acw62");


const $c1e1b3e8de3f8d60$export$9d8e73ca108a638d = ()=>({ children: children, subMenu: subMenu })=>{
        if (subMenu) {
            const emptyStringChildren = typeof children === 'string' && !children.trim();
            const emptyObjectChildren = children && typeof children === 'object' && Object.keys(children).length === 0;
            if (!children || emptyStringChildren || emptyObjectChildren) return new Error('A \'children\' text is required when a subMenu is present at \'HeaderUserWidget\' component.');
            if (!$175aa43345204302$export$2dabafa86f11ed64(subMenu, 'HeaderSubNavigation')) return new Error(`The 'subMenu' prop at 'HeaderUserWidget' only accepts a
        'HeaderSubNavigation' component but received '${$175aa43345204302$export$cb26d1ee6764af05(subMenu)}'.`);
        }
        return null;
    };






const $d0237b414dabc697$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header-user-widget', (0, $d81e2d3add027f3a$export$2e2bcd8739ae039));
function $d0237b414dabc697$export$4b8805e3d3556bf9(_a) {
    var { extraClasses: extraClasses, children: children, subMenu: subMenu, href: href, innerRef: innerRef, RouterLink: RouterLink, avatar: avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a3cda011510100a$export$2e2bcd8739ae039), {
        "aria-hidden": "true"
    }), buttonRest: buttonRest } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "subMenu",
        "href",
        "innerRef",
        "RouterLink",
        "avatar",
        "buttonRest"
    ]);
    const dropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [lastEvent, setLastEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const handleToggle = (_isActive, event)=>setLastEvent(event);
    const [isExpanded, buttonEvents, closeDropdown] = (0, $881605b223889743$export$6c3f529066e77cfe)({
        initialActive: false,
        content: dropdownRef.current,
        onToggle: handleToggle,
        arrowEvents: true
    });
    const focusAt = (0, $0745dc474f408795$export$21134cfa9af8e42e)({
        isExpanded: isExpanded,
        lastEvent: lastEvent
    });
    const handleBlur = (event)=>{
        const origin = event.relatedTarget;
        if (origin && dropdownRef.current && dropdownRef.current.contains(origin)) return;
        closeDropdown(event);
    };
    if (subMenu) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", Object.assign({
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, dropdownRef);
        },
        "aria-labelledby": `${subMenu.props.id}-toggle-btn`,
        className: $d0237b414dabc697$var$bem.b(false, extraClasses),
        onBlur: handleBlur
    }, rest), avatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: targetRef,
        id: `${subMenu.props.id}-toggle-btn`,
        className: $d0237b414dabc697$var$bem.e('toggle'),
        type: "button",
        "aria-haspopup": "menu",
        "aria-expanded": isExpanded,
        "aria-controls": subMenu.props.id
    }, buttonRest, buttonEvents), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24ad9cd18b9a061c$export$d2d35f354bcdebf4), {
        setInitialFocus: focusAt,
        hidden: !isExpanded,
        closeSubMenu: closeDropdown,
        target: targetRef.current
    }, subMenu));
    const linkChildren = RouterLink && href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RouterLink, Object.assign({
        className: $d0237b414dabc697$var$bem.e('toggle'),
        to: href
    }, buttonRest), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        className: $d0237b414dabc697$var$bem.e('toggle'),
        href: href
    }, buttonRest), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: $d0237b414dabc697$var$bem.b(false, extraClasses)
    }, rest), avatar, href ? linkChildren : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $d0237b414dabc697$var$bem.e('toggle')
    }, children));
}
$d0237b414dabc697$export$4b8805e3d3556bf9.displayName = 'HeaderUserWidget';
$d0237b414dabc697$export$4b8805e3d3556bf9.propTypes = {
    avatar: (0, $1ead597b5f273027$export$9b76c83bbe136b6a)('Avatar'),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    RouterLink: (0, $702b9449be14ac4b$export$50d0863e1c2a2c7f),
    subMenu: (0, $c1e1b3e8de3f8d60$export$9d8e73ca108a638d)(),
    buttonRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({})
};
var $d0237b414dabc697$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($d0237b414dabc697$export$4b8805e3d3556bf9, (0, $d81e2d3add027f3a$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");






const $94a12033d0107a35$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('header-widgets', (0, $d81e2d3add027f3a$export$2e2bcd8739ae039));
function $94a12033d0107a35$export$29d193b8703fd484(_a) {
    var { children: children, extraClasses: extraClasses, innerRef: innerRef, noResponsiveRendering: noResponsiveRendering = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "innerRef",
        "noResponsiveRendering"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: $94a12033d0107a35$var$bem.b({
            'no-responsive-rendering': noResponsiveRendering
        }, extraClasses)
    }, rest), children);
}
$94a12033d0107a35$export$29d193b8703fd484.displayName = 'HeaderWidgets';
$94a12033d0107a35$export$29d193b8703fd484.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    noResponsiveRendering: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1)
};
var $94a12033d0107a35$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($94a12033d0107a35$export$29d193b8703fd484, (0, $d81e2d3add027f3a$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $049bb4124b9ba78a$export$2e2bcd8739ae039 = {
    raw: ".hcr-label-16-4-0{background:var(--hcr-bg-primary-color);border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-secondary-color);display:block;font-family:inherit;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);left:var(--hcr-spacing-1);line-height:var(--hcr-font-size-primary);max-width:calc(100% - var(--hcr-spacing-2));padding:1px var(--hcr-spacing-1);position:absolute;text-align:left;top:calc(var(--hcr-font-size-primary)/2 + 2px);transform:translateY(-100%);z-index:1}@media (min-width:1200px){.hcr-label-16-4-0{background:#0000;font-size:var(--hcr-font-size-primary);left:auto;line-height:var(--hcr-line-height-primary);max-width:none;padding:0 0 var(--hcr-spacing-half);position:static;top:auto;transform:none}}",
    map: {
        "hcr-label": "hcr-label-16-4-0"
    }
};




const $39f5a98ae6c430ce$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('label', (0, $049bb4124b9ba78a$export$2e2bcd8739ae039));
function $39f5a98ae6c430ce$export$b04be29aa201d4f5({ id: id, text: text, labelFor: labelFor, extraClasses: extraClasses = '', requiredText: requiredText, Elem: Elem = 'label' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, {
        id: id,
        className: $39f5a98ae6c430ce$var$bem.b(false, extraClasses),
        htmlFor: labelFor
    }, text, requiredText && ` (${requiredText})`);
}
$39f5a98ae6c430ce$export$b04be29aa201d4f5.displayName = 'Label';
$39f5a98ae6c430ce$export$b04be29aa201d4f5.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    labelFor ({ labelFor: labelFor, Elem: Elem }) {
        if (Elem === 'legend') return null;
        if (typeof labelFor !== 'string' || labelFor.trim() === '') return new Error('Label component as default `label` element requires a non-empty `labelFor` prop of type string.');
        return null;
    },
    requiredText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'label',
        'legend'
    ])
};
var $39f5a98ae6c430ce$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($39f5a98ae6c430ce$export$b04be29aa201d4f5, (0, $049bb4124b9ba78a$export$2e2bcd8739ae039));


/**
 * Concatenates original component extraClasses prop (when available) with new classes to inject.
 * Use case: when cloning children to preserve user given extraClasses.
 * @param {ReactElement} component
 * @param {string} injectedExtraClasses
 * @returns 'original-component-extraClasses' + 'injected-extra-classes'
 */ function $fc332675fdeb2380$export$8f628de5a2ade1fd(component, injectedExtraClasses) {
    const compExtraClasses = component.props.extraClasses ? `${component.props.extraClasses} ` : '';
    return `${compExtraClasses}${injectedExtraClasses}`;
}
/**
 * Creates prioritized description ids by pushing all possible descriptions in order:
 * 1st: the left inline label (if present);
 * 2nd: the right inline label (if present);
 * 3rd: the inputInfo id (if `info` is present));
 * 4th: any user added aria-describedby coming from component handler prop or the component itself;
 */ function $fc332675fdeb2380$export$db93d21cb888fc59(id, { inlineLabel: inlineLabel, inlineLabelLeft: inlineLabelLeft, inlineLabelRight: inlineLabelRight, info: info, srOnlyInfo: srOnlyInfo, ariaDescribedBy: ariaDescribedBy, component: component }) {
    const describedByIds = [];
    if (inlineLabel) describedByIds.push(`inline-label-${id}`);
    if (inlineLabelLeft) describedByIds.push(`inline-label-left-${id}`);
    if (inlineLabelRight) describedByIds.push(`inline-label-right-${id}`);
    if (info) describedByIds.push(`info-${id}`);
    if (srOnlyInfo) describedByIds.push(`info-srOnly-${id}`);
    if (ariaDescribedBy) describedByIds.push(ariaDescribedBy.trim());
    if (component && component.props['aria-describedby']) describedByIds.push(component.props['aria-describedby'].trim());
    return describedByIds.length ? describedByIds.join(' ').trim() : undefined;
}
/**
 * Returns the error message id depending on order of priority messages:
 * 1. If the user provided their own aria-errormessage id, use it;
 * 2. If the component has its own infoError configured to true, use it;
 * 3. `undefined` if nothing is set;
 */ function $fc332675fdeb2380$export$cb36ad43b7a7e4d6(id, { ariaErrorMessage: ariaErrorMessage, infoError: infoError }) {
    if (ariaErrorMessage) return ariaErrorMessage.trim();
    if (infoError) return `infoError-${id}`;
    return;
}
/**
 * Creates a Label component for an input with a given node as text and respective for={id} and
 * component extraClasses.
 *
 * Or clones a given Label component adding the input specific props.
 *
 * Used by input components to handle their given label props.
 *
 * @param {LabelComp | ReactNode} label Label component or a ReactNode
 * @param {string} inputId The input id used on the label `for` attribute
 * @param {HoneyBemInstance} bem The parent bem instance
 * @param {string=} id id for the label
 * @param {string=} requiredText Deprecated: "required" text for generated Label
 * @returns A Label component for the input.
 */ function $fc332675fdeb2380$export$cfe90020b316e423({ label: label, inputId: inputId, bem: bem, id: id, requiredText: requiredText }) {
    if ($175aa43345204302$export$2dabafa86f11ed64(label, 'Label')) {
        const labelComponent = label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(labelComponent, {
            extraClasses: $fc332675fdeb2380$export$8f628de5a2ade1fd(labelComponent, bem.e('label')),
            labelFor: inputId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39f5a98ae6c430ce$export$2e2bcd8739ae039), {
        id: id,
        text: label,
        labelFor: inputId,
        requiredText: requiredText,
        extraClasses: bem.e('label')
    });
}
/**
 * Creates an Icon using the provided InlineIcon according to active state.
 * @param InlineIcon
 * @param {boolean} active the active flag to choose an icon.
 * @param iconRest rest props passed to icon component
 * @returns {JSXElement} The DOM node to use as the Portal target.
 */ function $fc332675fdeb2380$export$17c57e5c0b09dc86(InlineIcon, active, iconRest) {
    var _a;
    if (!InlineIcon) return null;
    const iconComp = InlineIcon;
    if ((_a = iconComp.displayName) === null || _a === void 0 ? void 0 : _a.includes('InlineIcon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), Object.assign({}, iconRest, {
        InlineIcon: iconComp,
        "aria-hidden": "true"
    }));
    const inlineIconAsObj = InlineIcon;
    const computedIcon = active ? inlineIconAsObj.active : inlineIconAsObj.regular;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), Object.assign({}, iconRest, {
        InlineIcon: computedIcon,
        "aria-hidden": "true"
    }));
}
function $fc332675fdeb2380$export$da832e62129270c0(ariaExpanded) {
    if (ariaExpanded === 'false') return false;
    return Boolean(ariaExpanded);
}





var $8ad3791e8171d8c1$export$2e2bcd8739ae039 = {
    raw: ".hcr-sr-only-16-4-0,.hcr-sr-only-focusable-16-4-0:not(:focus){border-width:0!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;margin:-1px!important;opacity:0!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:1px!important}.hcr-sr-only-focusable-16-4-0{opacity:1!important;transition:opacity .25s ease}",
    map: {
        "hcr-sr-only": "hcr-sr-only-16-4-0",
        "hcr-sr-only-focusable": "hcr-sr-only-focusable-16-4-0"
    }
};




var $acw62 = parcelRequire("acw62");


function $16e49d1e8b84061f$export$972517f59c4cc955(helpersName, styles) {
    const InjecssContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $8004033f3b6e4cea$export$b293f36bde7e07ad));
    const helperId = `${helpersName}Helpers__${(0, $f5d0d8e5a6972273$export$36b7d774d231bf3c)}${(0, $f5d0d8e5a6972273$export$5dc5db8b895b3c69)}`;
    if (!(0, $f5d0d8e5a6972273$export$e44ffb50cc242ec5)) (0, $8004033f3b6e4cea$export$fb348d80caab4249)(InjecssContextValue, styles.raw, helperId);
    (0, $8004033f3b6e4cea$export$c9fb2b964712e20e)(helperId, styles.raw);
}


const $836900889b75b6a5$var$srOnlyBem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('sr-only', (0, $8ad3791e8171d8c1$export$2e2bcd8739ae039));
const $836900889b75b6a5$var$srOnlyFocusableBem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('sr-only-focusable', (0, $8ad3791e8171d8c1$export$2e2bcd8739ae039));
function $836900889b75b6a5$export$2e2bcd8739ae039() {
    (0, $16e49d1e8b84061f$export$972517f59c4cc955)('A11y', (0, $8ad3791e8171d8c1$export$2e2bcd8739ae039));
    return {
        srOnly: $836900889b75b6a5$var$srOnlyBem.b(),
        srOnlyFocusable: $836900889b75b6a5$var$srOnlyFocusableBem.b()
    };
}


function $6aadfdf7a0ab017b$export$2e2bcd8739ae039(_a) {
    var _b;
    var { extraClasses: extraClasses, modifier: modifier, role: role, linkRole: linkRole, href: href, RouterLink: RouterLink, subMenu: subMenu, children: children, Elem: Elem, innerRef: innerRef, open: openProp, InlineIcon: InlineIconProp, active: active = false, openOnHover: openOnHover = false, shouldCloseDialog: shouldCloseDialog, srOnly: srOnly } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "modifier",
        "role",
        "linkRole",
        "href",
        "RouterLink",
        "subMenu",
        "children",
        "Elem",
        "innerRef",
        "open",
        "InlineIcon",
        "active",
        "openOnHover",
        "shouldCloseDialog",
        "srOnly"
    ]);
    const bem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $f4713e20c85afaf3$export$ada278d15ed54cfa));
    const liRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [lastEvent, setLastEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const handleToggle = (_isActive, event)=>setLastEvent(event);
    const [openHook, events, closeMenu] = (0, $881605b223889743$export$6c3f529066e77cfe)({
        initialActive: Boolean(openProp),
        content: liRef.current,
        hoverEvents: openOnHover,
        onToggle: handleToggle,
        arrowEvents: true
    });
    const isOpen = openProp === undefined ? openHook : openProp;
    const focusAt = (0, $0745dc474f408795$export$21134cfa9af8e42e)({
        isExpanded: isOpen,
        lastEvent: lastEvent
    });
    const handleBlur = (event)=>{
        const origin = event.relatedTarget;
        if (origin && liRef.current && liRef.current.contains(origin)) return;
        // This adds an imperceptible delay before closing the menu on blur, which allows the onClick event on another item
        // to register before the menu is closed.
        // Without this, the menu closes immediately on blur and the onClick on the other item doesn't work.
        setTimeout(closeMenu, 1);
    };
    const handleMouseLeave = ()=>openOnHover && setTimeout(closeMenu, (0, $881605b223889743$export$e7d6e469a6eed078));
    const anchorElem = href ? 'a' : 'span';
    const subMenuElem = subMenu ? 'button' : undefined;
    const itemElem = Elem || subMenuElem || anchorElem;
    const { closeSubMenu: closeSubMenu } = (0, $24ad9cd18b9a061c$export$a2873e323c026b38)();
    const { closeBurgerMenu: closeBurgerMenu } = (0, $0ec55452460ccd57$export$3820cb12ec3eed43)();
    const restProps = subMenu ? Object.assign(Object.assign(Object.assign({
        'aria-haspopup': 'menu',
        'aria-expanded': isOpen
    }, events), rest), {
        onClick: (event)=>{
            var _a;
            (_a = rest.onClick) === null || _a === void 0 || _a.call(rest, event);
            events.onClick(event);
        }
    }) : Object.assign(Object.assign({}, rest), {
        onClick: (event)=>{
            var _a;
            (_a = rest.onClick) === null || _a === void 0 || _a.call(rest, event);
            if (shouldCloseDialog) {
                closeSubMenu(event);
                closeBurgerMenu();
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: role,
        ref: liRef,
        className: bem === null || bem === void 0 ? void 0 : bem.e('item', modifier, extraClasses),
        onBlur: handleBlur,
        onMouseLeave: handleMouseLeave,
        // this magically makes onBlur work in Safari with its known button focus and event.relatedTarget tricks (see: https://bugs.webkit.org/show_bug.cgi?id=22261)
        tabIndex: subMenu ? -1 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dfbfe5c004aa051$export$73df57962b7f9000), Object.assign({
        Elem: itemElem,
        className: bem === null || bem === void 0 ? void 0 : bem.e('link', {
            active: active,
            'has-subnav': subMenu,
            'has-subnav-open': isOpen
        }),
        innerRef: innerRef,
        href: href,
        active: active,
        RouterLink: RouterLink,
        role: linkRole
    }, restProps), $fc332675fdeb2380$export$17c57e5c0b09dc86(InlineIconProp, Boolean(active)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: bem === null || bem === void 0 ? void 0 : bem.e('text')
    }, children), srOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $836900889b75b6a5$export$2e2bcd8739ae039)().srOnly
    }, " ", srOnly)), subMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24ad9cd18b9a061c$export$d2d35f354bcdebf4), {
        setInitialFocus: focusAt,
        hidden: !isOpen,
        closeSubMenu: closeMenu,
        target: (_b = liRef === null || liRef === void 0 ? void 0 : liRef.current) === null || _b === void 0 ? void 0 : _b.firstElementChild
    }, subMenu));
}
$6aadfdf7a0ab017b$export$2e2bcd8739ae039.displayName = 'NavItem';
$6aadfdf7a0ab017b$export$2e2bcd8739ae039.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    modifier: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkRole: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    RouterLink: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    subMenu: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    openOnHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    children: (0, $1ead597b5f273027$export$ff91b688641fa6db)('NavItem'),
    InlineIcon: (0, $702b9449be14ac4b$export$8ad3a7add6add4b3),
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $ea5137d009687ef5$export$a439dc2f01176e60)),
    shouldCloseDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    srOnly: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};


parcelRequire("acw62");





var $f5524f6b44d868fb$export$fa397790119a1408;
var $f5524f6b44d868fb$export$b426df703d3b34b8;
var $f5524f6b44d868fb$export$38e42c68cf43b5d4;
var $f5524f6b44d868fb$export$1ffaa3fd26b67b20;
var $f5524f6b44d868fb$export$1ca1ec8b29a4ce27;
var $f5524f6b44d868fb$export$a0973bcfe11b05c9;
var $f5524f6b44d868fb$export$8ea057179197726a;
var $f5524f6b44d868fb$export$c86d3ca66f38ed60;
var $f5524f6b44d868fb$export$df8352d9cc927c03;
$f5524f6b44d868fb$export$fa397790119a1408 = `Navigation-VMrtIW-flix-theme-dark`;
$f5524f6b44d868fb$export$b426df703d3b34b8 = `Navigation-VMrtIW-flix-theme-flix`;
$f5524f6b44d868fb$export$38e42c68cf43b5d4 = `Navigation-VMrtIW-header`;
$f5524f6b44d868fb$export$1ffaa3fd26b67b20 = `Navigation-VMrtIW-helpMenuIcon`;
$f5524f6b44d868fb$export$1ca1ec8b29a4ce27 = `Navigation-VMrtIW-icon`;
$f5524f6b44d868fb$export$a0973bcfe11b05c9 = `Navigation-VMrtIW-logout`;
$f5524f6b44d868fb$export$8ea057179197726a = `Navigation-VMrtIW-subMenuHeaderMobile`;
$f5524f6b44d868fb$export$c86d3ca66f38ed60 = `Navigation-VMrtIW-userName`;
$f5524f6b44d868fb$export$df8352d9cc927c03 = `Navigation-VMrtIW-widgetMobileMenu`;





var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");

var $a1a6cdd762f6d4ec$export$2e2bcd8739ae039 = {
    raw: ".hcr-divider-16-4-0{background-color:var(--hcr-line-primary-color);border-style:none;height:1px;position:relative}",
    map: {
        "hcr-divider": "hcr-divider-16-4-0"
    }
};






const $929c01dd4f184c67$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('divider', (0, $a1a6cdd762f6d4ec$export$2e2bcd8739ae039));
function $929c01dd4f184c67$export$2e0a83ec2e27ecbb(_a) {
    var { extraClasses: extraClasses } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", Object.assign({
        className: $929c01dd4f184c67$var$bem.b({}, extraClasses)
    }, rest));
}
$929c01dd4f184c67$export$2e0a83ec2e27ecbb.displayName = 'Divider';
$929c01dd4f184c67$export$2e0a83ec2e27ecbb.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $929c01dd4f184c67$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($929c01dd4f184c67$export$2e0a83ec2e27ecbb, (0, $a1a6cdd762f6d4ec$export$2e2bcd8739ae039));



const $71ec78dacd50a138$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('dropdown', (0, $73395dc44dfca54e$export$2e2bcd8739ae039));
function $71ec78dacd50a138$export$6648d5fa18559e7f(_a) {
    var { extraClasses: extraClasses, children: children, RouterLink: RouterLink, active: active = false, divider: divider = false, InlineIcon: InlineIcon, Elem: Elem, href: href, shouldCloseDialog: shouldCloseDialog, onClick: onClick } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "RouterLink",
        "active",
        "divider",
        "InlineIcon",
        "Elem",
        "href",
        "shouldCloseDialog",
        "onClick"
    ]);
    const itemElem = href ? 'a' : Elem;
    const role = RouterLink || itemElem === 'a' || itemElem === 'button' ? 'menuitem' : undefined;
    const { closeSubMenu: closeSubMenu } = (0, $24ad9cd18b9a061c$export$a2873e323c026b38)();
    const { closeBurgerMenu: closeBurgerMenu } = (0, $0ec55452460ccd57$export$3820cb12ec3eed43)();
    const handleOnClick = (event)=>{
        onClick === null || onClick === void 0 || onClick(event);
        if (shouldCloseDialog) {
            closeSubMenu(event);
            closeBurgerMenu();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        className: $71ec78dacd50a138$var$bem.e('item', {}, extraClasses)
    }, divider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $929c01dd4f184c67$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dfbfe5c004aa051$export$73df57962b7f9000), Object.assign({
        RouterLink: RouterLink,
        className: $71ec78dacd50a138$var$bem.e('link'),
        role: role,
        active: active,
        Elem: itemElem,
        href: href,
        onClick: handleOnClick
    }, rest), $fc332675fdeb2380$export$17c57e5c0b09dc86(InlineIcon, active), children));
}
$71ec78dacd50a138$export$6648d5fa18559e7f.displayName = 'DropdownItem';
$71ec78dacd50a138$export$6648d5fa18559e7f.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    divider: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    InlineIcon: (0, $702b9449be14ac4b$export$8ad3a7add6add4b3),
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $ea5137d009687ef5$export$a439dc2f01176e60)),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    RouterLink: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    shouldCloseDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $71ec78dacd50a138$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($71ec78dacd50a138$export$6648d5fa18559e7f, (0, $73395dc44dfca54e$export$2e2bcd8739ae039));


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $1b558ceaff25e22a$var$_excluded = [
    "title",
    "pathRest"
];
var $1b558ceaff25e22a$export$385133bba56e7cda = function IconNewTab(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $1b558ceaff25e22a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-new-tab"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M14.35 3a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1v5.66a1 1 0 1 1-2 0V5.42l-6.77 6.77a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.41L18.6 4h-3.24a1 1 0 0 1-1-1M21 12a1 1 0 0 0-1 1v6c0 .54-.46 1-1 1H5c-.54 0-1-.46-1-1V5c0-.54.46-1 1-1h6a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1"
    }, pathRest)));
};
$1b558ceaff25e22a$export$385133bba56e7cda.displayName = 'InlineIcon(IconNewTab)';
$1b558ceaff25e22a$export$385133bba56e7cda.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $4b0a79e980bf9ecb$var$_excluded = [
    "title",
    "pathRest"
];
var $4b0a79e980bf9ecb$export$bde6bdb251992fa0 = function IconQAndA(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $4b0a79e980bf9ecb$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-q-and-a"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M22 11.2v5.6c0 1.15-.63 2.1-1.4 2.1h-1.4v1.43c0 .44-.25.67-.63.67q-.47 0-1.1-.42L15 18.9h-4.9A2.1 2.1 0 0 1 8 16.8v-.03l2-1.37v1.4q.01.09.1.1h5.52l.5.34 1.08.74V16.9H20v-5.7q-.01-.09-.1-.1H19v-2h.9c1.16 0 2.1.94 2.1 2.1m-12 3-2.82 1.92q-.73.48-1.26.48c-.44 0-.72-.26-.72-.77V14.2H3.6c-.88 0-1.6-1.07-1.6-2.4V5.4A2.4 2.4 0 0 1 4.4 3h11.2A2.4 2.4 0 0 1 18 5.4v6.4a2.4 2.4 0 0 1-2.4 2.4zm0-.38a2 2 0 0 0 1.96-1.62h3.64a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.4-.4h-2.65a3.4 3.4 0 0 0-2.93-1.68c-1.24 0-2.36.66-2.98 1.68H4.4a.4.4 0 0 0-.4.4v6.4q.01.24.05.4H7.2v1.48l1.13-.77a2 2 0 0 0 1.67.9M9.88 7.4l-.13.13c-.22.22-.8.8-.8 1.78 0 .54.43.99.98.99.54 0 .99-.45.99-1.06q0-.09.21-.3l.1-.1c.39-.36 1.19-1.1 1.19-2.1a2.36 2.36 0 0 0-2.4-2.43 2.46 2.46 0 0 0-2.42 2 1 1 0 0 0 .81 1.14c.54.08 1.04-.26 1.15-.86.07-.18.25-.3.45-.3q.43.01.43.44s-.03.18-.56.67M11 11.8a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
    }, pathRest)));
};
$4b0a79e980bf9ecb$export$bde6bdb251992fa0.displayName = 'InlineIcon(IconQAndA)';
$4b0a79e980bf9ecb$export$bde6bdb251992fa0.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $bb451804f19bf827$var$_excluded = [
    "title",
    "pathRest"
];
var $bb451804f19bf827$export$220c5cf58b075480 = function IconQAndASolid(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $bb451804f19bf827$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-q-and-a-solid"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M15.6 14.2a2.4 2.4 0 0 0 2.4-2.4V5.4A2.4 2.4 0 0 0 15.6 3H4.4A2.4 2.4 0 0 0 2 5.4v6.4c0 1.32.72 2.4 1.6 2.4h1.6v1.63c0 .5.28.77.72.77q.53 0 1.26-.48L10 14.19zm-5.59-7.9c-.2 0-.38.11-.45.29-.11.6-.61.95-1.15.87A1 1 0 0 1 7.6 6.3q.03-.2.1-.4a2.5 2.5 0 0 1 2.32-1.58c1.37 0 2.4 1.04 2.4 2.42 0 1-.8 1.75-1.19 2.1l-.1.1q-.22.21-.21.3c0 .62-.45 1.06-.99 1.06a1 1 0 0 1-.99-.99c0-.97.59-1.56.8-1.78l.14-.13c.53-.49.56-.66.56-.67q0-.42-.42-.44M9 11.81a1 1 0 1 1 2 0 1 1 0 0 1-2 0m.9-2.51.02-.15v.08zM22 11.2v5.6c0 1.15-.63 2.1-1.4 2.1h-1.4v1.43c0 .44-.25.67-.63.67q-.47 0-1.1-.42L15 18.9h-4.9A2.1 2.1 0 0 1 8 16.8v-.03l2.3-1.57h5.3a3.4 3.4 0 0 0 3.4-3.4V9.1h.9c1.16 0 2.1.94 2.1 2.1"
    }, pathRest)));
};
$bb451804f19bf827$export$220c5cf58b075480.displayName = 'InlineIcon(IconQAndASolid)';
$bb451804f19bf827$export$220c5cf58b075480.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 





var $fb36046a05d8490c$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $fb36046a05d8490c$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $864ced6e9596b36d$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $fb36046a05d8490c$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $fb36046a05d8490c$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fb36046a05d8490c$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $fb36046a05d8490c$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fb36046a05d8490c$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $49c5e80e1e37b1ef$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $49c5e80e1e37b1ef$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $864ced6e9596b36d$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $49c5e80e1e37b1ef$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $49c5e80e1e37b1ef$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $49c5e80e1e37b1ef$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





var $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $017098cf53bbcffc$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $864ced6e9596b36d$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $017098cf53bbcffc$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $017098cf53bbcffc$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $017098cf53bbcffc$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $017098cf53bbcffc$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $017098cf53bbcffc$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $30978dc1b9a7c40c$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $30978dc1b9a7c40c$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $30978dc1b9a7c40c$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}





function $ce9ae9e93dd5fa99$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $ce9ae9e93dd5fa99$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $ce9ae9e93dd5fa99$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $ce9ae9e93dd5fa99$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $ce9ae9e93dd5fa99$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $ce9ae9e93dd5fa99$export$3fae2929ed23c202(map, pl, field) {
    return $ce9ae9e93dd5fa99$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $ce9ae9e93dd5fa99$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $ce9ae9e93dd5fa99$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $ce9ae9e93dd5fa99$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $ce9ae9e93dd5fa99$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $ce9ae9e93dd5fa99$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $ce9ae9e93dd5fa99$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $ce9ae9e93dd5fa99$export$a99e4aaac79eeead = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
});
var $ce9ae9e93dd5fa99$export$b479a1a2d8754359 = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
});
var $ce9ae9e93dd5fa99$export$569bb3095db8432e = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
});
var $ce9ae9e93dd5fa99$export$e124bc7d23dd0e5a = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
});
var $ce9ae9e93dd5fa99$export$a1209f8c6068edc3 = (0, $4cd71bde5c6db5d4$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $4cd71bde5c6db5d4$export$c5491a8691a23b9e).variadic
});





var $0c895559c4f6f03d$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($0c895559c4f6f03d$export$896afd8541959ee5 || ($0c895559c4f6f03d$export$896afd8541959ee5 = {}));




var $8285d117ce28dbd1$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($8285d117ce28dbd1$export$b87f371cbc396fcf || ($8285d117ce28dbd1$export$b87f371cbc396fcf = {}));
var $8285d117ce28dbd1$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($8285d117ce28dbd1$export$906452485466fa53 || ($8285d117ce28dbd1$export$906452485466fa53 = {}));
function $8285d117ce28dbd1$export$cfa10c5697238752(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.literal;
}
function $8285d117ce28dbd1$export$4f55724281bdfaf9(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.argument;
}
function $8285d117ce28dbd1$export$e11187b219e191e1(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.number;
}
function $8285d117ce28dbd1$export$32d811605da75f40(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.date;
}
function $8285d117ce28dbd1$export$34ec46f596b1702f(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.time;
}
function $8285d117ce28dbd1$export$dcfe1c11d168b5a1(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.select;
}
function $8285d117ce28dbd1$export$6c796d116f0a4fbc(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.plural;
}
function $8285d117ce28dbd1$export$c0ece297bdd0c082(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.pound;
}
function $8285d117ce28dbd1$export$5c83de34745812b(el) {
    return el.type === $8285d117ce28dbd1$export$b87f371cbc396fcf.tag;
}
function $8285d117ce28dbd1$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $8285d117ce28dbd1$export$906452485466fa53.number);
}
function $8285d117ce28dbd1$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $8285d117ce28dbd1$export$906452485466fa53.dateTime);
}
function $8285d117ce28dbd1$export$f0ac572c1121c662(value) {
    return {
        type: $8285d117ce28dbd1$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $8285d117ce28dbd1$export$425e864b0ba114f1(value, style) {
    return {
        type: $8285d117ce28dbd1$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $f26a03b396735968$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $f26a03b396735968$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $78f746aabce6eac6$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $78f746aabce6eac6$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($78f746aabce6eac6$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $18caf27b52ed454f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $241a65cd315dbd7b$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $18caf27b52ed454f$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $241a65cd315dbd7b$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $241a65cd315dbd7b$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $241a65cd315dbd7b$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $241a65cd315dbd7b$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $241a65cd315dbd7b$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $241a65cd315dbd7b$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($241a65cd315dbd7b$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $241a65cd315dbd7b$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $241a65cd315dbd7b$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$241a65cd315dbd7b$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $241a65cd315dbd7b$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $241a65cd315dbd7b$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $241a65cd315dbd7b$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $241a65cd315dbd7b$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, all), $241a65cd315dbd7b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, all), $241a65cd315dbd7b$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($241a65cd315dbd7b$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($241a65cd315dbd7b$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($241a65cd315dbd7b$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($241a65cd315dbd7b$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), $241a65cd315dbd7b$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($241a65cd315dbd7b$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), $241a65cd315dbd7b$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $241a65cd315dbd7b$var$parseSign(token.stem);
        if (signOpts) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $241a65cd315dbd7b$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $a1abaf8ae714d954$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $d5a44048631657bb$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $d5a44048631657bb$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $d5a44048631657bb$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $a1abaf8ae714d954$export$a8c9209db4084317)[regionTag || ''] || (0, $a1abaf8ae714d954$export$a8c9209db4084317)[languageTag || ''] || (0, $a1abaf8ae714d954$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $a1abaf8ae714d954$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $4e2e529d708d721d$var$_a;
var $4e2e529d708d721d$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $f26a03b396735968$export$523451f94304dd6c).source, "*"));
var $4e2e529d708d721d$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $f26a03b396735968$export$523451f94304dd6c).source, "*$"));
function $4e2e529d708d721d$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $4e2e529d708d721d$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $4e2e529d708d721d$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $4e2e529d708d721d$var$hasNativeFromEntries = !!Object.fromEntries;
var $4e2e529d708d721d$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $4e2e529d708d721d$var$hasTrimStart = !!String.prototype.trimStart;
var $4e2e529d708d721d$var$hasTrimEnd = !!String.prototype.trimEnd;
var $4e2e529d708d721d$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $4e2e529d708d721d$var$isSafeInteger = $4e2e529d708d721d$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $4e2e529d708d721d$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $4e2e529d708d721d$var$re = $4e2e529d708d721d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $4e2e529d708d721d$var$REGEX_SUPPORTS_U_AND_Y = (($4e2e529d708d721d$var$_a = $4e2e529d708d721d$var$re.exec('a')) === null || $4e2e529d708d721d$var$_a === void 0 ? void 0 : $4e2e529d708d721d$var$_a[0]) === 'a';
} catch (_) {
    $4e2e529d708d721d$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $4e2e529d708d721d$var$startsWith = $4e2e529d708d721d$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $4e2e529d708d721d$var$fromCodePoint = $4e2e529d708d721d$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $4e2e529d708d721d$var$fromEntries = // native
$4e2e529d708d721d$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $4e2e529d708d721d$var$codePointAt = $4e2e529d708d721d$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $4e2e529d708d721d$var$trimStart = $4e2e529d708d721d$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($4e2e529d708d721d$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $4e2e529d708d721d$var$trimEnd = $4e2e529d708d721d$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($4e2e529d708d721d$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $4e2e529d708d721d$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $4e2e529d708d721d$var$matchIdentifierAtIndex;
if ($4e2e529d708d721d$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $4e2e529d708d721d$var$IDENTIFIER_PREFIX_RE_1 = $4e2e529d708d721d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $4e2e529d708d721d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $4e2e529d708d721d$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $4e2e529d708d721d$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$4e2e529d708d721d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $4e2e529d708d721d$var$codePointAt(s, index);
        if (c === undefined || $4e2e529d708d721d$var$_isWhiteSpace(c) || $4e2e529d708d721d$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $4e2e529d708d721d$var$fromCodePoint.apply(void 0, match);
};
var $4e2e529d708d721d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).pound,
                    location: $4e2e529d708d721d$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $4e2e529d708d721d$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $4e2e529d708d721d$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$4e2e529d708d721d$var$_isAlpha(this.char())) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_TAG, $4e2e529d708d721d$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $4e2e529d708d721d$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_TAG, $4e2e529d708d721d$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $4e2e529d708d721d$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).UNCLOSED_TAG, $4e2e529d708d721d$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_TAG, $4e2e529d708d721d$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $4e2e529d708d721d$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $4e2e529d708d721d$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$4e2e529d708d721d$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $4e2e529d708d721d$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $4e2e529d708d721d$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EMPTY_ARGUMENT, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).MALFORMED_ARGUMENT, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).MALFORMED_ARGUMENT, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $4e2e529d708d721d$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $4e2e529d708d721d$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $4e2e529d708d721d$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $4e2e529d708d721d$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $4e2e529d708d721d$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $4e2e529d708d721d$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $4e2e529d708d721d$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $d5a44048631657bb$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $8285d117ce28dbd1$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $78f746aabce6eac6$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).date : (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).date : (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $4e2e529d708d721d$var$createLocation(typeEndPosition_1, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $4e2e529d708d721d$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $4e2e529d708d721d$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $4e2e529d708d721d$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $4e2e529d708d721d$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $241a65cd315dbd7b$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $8285d117ce28dbd1$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $241a65cd315dbd7b$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $0c895559c4f6f03d$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $4e2e529d708d721d$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $0c895559c4f6f03d$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $0c895559c4f6f03d$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $4e2e529d708d721d$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $0c895559c4f6f03d$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $0c895559c4f6f03d$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $4e2e529d708d721d$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $4e2e529d708d721d$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$4e2e529d708d721d$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $4e2e529d708d721d$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($4e2e529d708d721d$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $4e2e529d708d721d$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $4e2e529d708d721d$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $4e2e529d708d721d$var$_isAlphaOrSlash(codepoint) {
    return $4e2e529d708d721d$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $4e2e529d708d721d$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4e2e529d708d721d$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $4e2e529d708d721d$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $47d7ceaa5cf7518a$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $8285d117ce28dbd1$export$dcfe1c11d168b5a1)(el) || (0, $8285d117ce28dbd1$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $47d7ceaa5cf7518a$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $8285d117ce28dbd1$export$e11187b219e191e1)(el) && (0, $8285d117ce28dbd1$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $8285d117ce28dbd1$export$32d811605da75f40)(el) || (0, $8285d117ce28dbd1$export$34ec46f596b1702f)(el)) && (0, $8285d117ce28dbd1$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $8285d117ce28dbd1$export$5c83de34745812b)(el)) $47d7ceaa5cf7518a$var$pruneLocation(el.children);
    });
}
function $47d7ceaa5cf7518a$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $4e2e529d708d721d$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $0c895559c4f6f03d$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $47d7ceaa5cf7518a$var$pruneLocation(result.val);
    return result.val;
}
var $47d7ceaa5cf7518a$export$d3c1bfa0f7d806e9 = (0, $4e2e529d708d721d$export$7acfa6ed01010e37);


function $f26b5fe94260a5e5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $f26b5fe94260a5e5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $65f19ee2190344e6$export$d342343268debc40).formats;
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $f26b5fe94260a5e5$var$deepMergeOptions($f26b5fe94260a5e5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $f26b5fe94260a5e5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $f26b5fe94260a5e5$var$deepMergeOptions($f26b5fe94260a5e5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $f26b5fe94260a5e5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $f26b5fe94260a5e5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $ce9ae9e93dd5fa99$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $8285d117ce28dbd1$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $68b242487880b508$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $68b242487880b508$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $68b242487880b508$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $68b242487880b508$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};






var $75e8ae8ff5953bf1$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $75e8ae8ff5953bf1$var$now = Date.now();
function $75e8ae8ff5953bf1$var$generateToken(i) {
    return "".concat($75e8ae8ff5953bf1$var$now, "_").concat(i, "_").concat($75e8ae8ff5953bf1$var$now);
}
function $75e8ae8ff5953bf1$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $75e8ae8ff5953bf1$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $75e8ae8ff5953bf1$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $75e8ae8ff5953bf1$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $75e8ae8ff5953bf1$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}





var $7d76ab7739f3ed5e$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $7d76ab7739f3ed5e$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $b2de32051be1701b$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $b2de32051be1701b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $864ced6e9596b36d$export$d697c39a2985a4c)(options, $7d76ab7739f3ed5e$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $68b242487880b508$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}


function $d840350b98d505a5$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $d840350b98d505a5$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $d840350b98d505a5$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $d840350b98d505a5$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $864ced6e9596b36d$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $864ced6e9596b36d$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $68b242487880b508$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $68b242487880b508$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $68b242487880b508$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $d840350b98d505a5$var$verifyConfigMessages(resolvedConfig);
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $fb36046a05d8490c$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $fb36046a05d8490c$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $49c5e80e1e37b1ef$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $017098cf53bbcffc$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $017098cf53bbcffc$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $017098cf53bbcffc$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $017098cf53bbcffc$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $017098cf53bbcffc$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $30978dc1b9a7c40c$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $f26b5fe94260a5e5$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $f26b5fe94260a5e5$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $75e8ae8ff5953bf1$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $75e8ae8ff5953bf1$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $7d76ab7739f3ed5e$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



var $acw62 = parcelRequire("acw62");


function $799bd4e991c1f0e6$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $a7bf6eec6df43b65$export$df0c12a2d414a163)(v) ? (0, $2911c18a2024d56a$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $799bd4e991c1f0e6$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $799bd4e991c1f0e6$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $f26b5fe94260a5e5$export$25868d1e8e76735f).apply(void 0, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $acw62.Children.toArray(chunks);
    return chunks;
};
var $799bd4e991c1f0e6$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $799bd4e991c1f0e6$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $d840350b98d505a5$export$7e4cbedfdd7b4c0d)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $2911c18a2024d56a$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, coreIntl), {
        formatMessage: $799bd4e991c1f0e6$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $799bd4e991c1f0e6$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};




var /*
 * Function to Format Messages outside of React Components
 * Works only if selected languages is stored as cookie and only returnst translations
 * for internal langs
 */ $fefa4e2c18d9f2ab$export$2e2bcd8739ae039 = (id, values)=>{
    const { messages: messages } = window;
    const locale = (0, $eff69fb1886d6e36$export$e24640604b11ca0)((0, $61d5299c8c0ea66c$export$68274e25c3f28c82)(), false);
    if (messages && Object.keys(messages).length) {
        const cache = (0, $864ced6e9596b36d$export$51c4f4e973f2dc00)();
        const intl = (0, $799bd4e991c1f0e6$export$7e4cbedfdd7b4c0d)({
            locale: locale.bcp47Locale,
            messages: messages || {}
        }, cache);
        return intl.formatMessage({
            id: id
        }, values);
    }
    return JSON.stringify({
        id: id,
        ...values
    });
};


var $72a7cae42bbdbca4$var$NavigationApp = /*#__PURE__*/ function(NavigationApp) {
    NavigationApp["MPC"] = "MPC";
    NavigationApp["MPO"] = "MPO";
    NavigationApp["MUS"] = "MUS";
    NavigationApp["MTC"] = "MTC";
    return NavigationApp;
}($72a7cae42bbdbca4$var$NavigationApp || {});
var $72a7cae42bbdbca4$export$2e2bcd8739ae039 = $72a7cae42bbdbca4$var$NavigationApp;


const $86d6f48353187cb7$var$getHelpMenuItems = (app, isUsedInDropdown)=>{
    const pathnames = app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? (0, $3148ac12565e8f12$export$ef70d4ce339359f4) : app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $3148ac12565e8f12$export$27b666feebe4ad6b) : (0, $3148ac12565e8f12$export$6ef3d755bebf7e79);
    const items = [
        {
            key: "faq",
            InlineIcon: isUsedInDropdown ? {
                regular: (0, $4b0a79e980bf9ecb$export$bde6bdb251992fa0),
                active: (0, $bb451804f19bf827$export$220c5cf58b075480)
            } : (0, $4b0a79e980bf9ecb$export$bde6bdb251992fa0),
            href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? undefined : pathnames.faq,
            to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? pathnames.faq : undefined,
            RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
            target: "_blank",
            shouldCloseDialog: isUsedInDropdown ? undefined : true,
            text: "FAQ"
        }
    ];
    if ((0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_SERVICEDESK_ACCESS)) items.push({
        key: "service-desk",
        InlineIcon: (0, $1b558ceaff25e22a$export$385133bba56e7cda),
        href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).serviceDeskReportProblem,
        target: "_blank",
        shouldCloseDialog: isUsedInDropdown ? undefined : true,
        text: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("navigation.reportProblem")
    }, {
        key: "service-desk-business",
        InlineIcon: (0, $1b558ceaff25e22a$export$385133bba56e7cda),
        href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).serviceDeskPlatformBusiness,
        target: "_blank",
        shouldCloseDialog: isUsedInDropdown ? undefined : true,
        text: "Contact Business Team"
    });
    return items;
};
var $86d6f48353187cb7$export$2e2bcd8739ae039 = $86d6f48353187cb7$var$getHelpMenuItems;


const $790626a2e649e497$var$getDropdownHelpMenuItems = (app)=>{
    const items = (0, $86d6f48353187cb7$export$2e2bcd8739ae039)(app, true);
    const dropdownItems = items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71ec78dacd50a138$export$2e2bcd8739ae039), {
            InlineIcon: item.InlineIcon,
            href: item.href,
            to: item.to,
            target: item.target,
            RouterLink: item.RouterLink,
            children: item.text
        }, item.key));
    if (dropdownItems.length > 1) return [
        ...dropdownItems.slice(0, 1),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71ec78dacd50a138$export$2e2bcd8739ae039), {
            divider: true
        }, "divider"),
        ...dropdownItems.slice(1)
    ];
    return dropdownItems;
};
var $790626a2e649e497$export$2e2bcd8739ae039 = $790626a2e649e497$var$getDropdownHelpMenuItems;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $0425f190c7032ce6$var$_excluded = [
    "title",
    "pathRest"
];
var $0425f190c7032ce6$export$8cce8755ba9f81c4 = function IconHomeSolid(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $0425f190c7032ce6$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-home-solid"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "m21.53 9.49-9.06-7.33A.7.7 0 0 0 12 2a.7.7 0 0 0-.47.16L2.47 9.49c-.26.2-.47.65-.47.98V21.4c0 .33.27.6.6.6h7.05a.6.6 0 0 0 .6-.6v-4.87c0-.33.27-.6.6-.6h2.3c.33 0 .6.27.6.6v4.87c0 .33.27.6.6.6h7.05a.6.6 0 0 0 .6-.6V10.47c0-.33-.21-.77-.47-.98"
    }, pathRest)));
};
$0425f190c7032ce6$export$8cce8755ba9f81c4.displayName = 'InlineIcon(IconHomeSolid)';
$0425f190c7032ce6$export$8cce8755ba9f81c4.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};









const $6fc87e87e9c8af93$var$getNavigationItems = (app)=>{
    const pathnames = app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? (0, $3148ac12565e8f12$export$ef70d4ce339359f4) : app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $3148ac12565e8f12$export$27b666feebe4ad6b) : (0, $3148ac12565e8f12$export$6ef3d755bebf7e79);
    const navItems = [];
    navItems.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
        href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? undefined : pathnames.userHome,
        to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? pathnames.userHome : undefined,
        RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
        InlineIcon: (0, $0425f190c7032ce6$export$8cce8755ba9f81c4),
        shouldCloseDialog: true,
        // TODO: remove the inline css when this is done: https://flixtech.atlassian.net/servicedesk/customer/portal/115/HNY-320
        style: {
            gap: "0"
        },
        children: " "
    }, "home"), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
        href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? undefined : pathnames.capacityManager,
        to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? pathnames.capacityManager : undefined,
        RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
        shouldCloseDialog: true,
        children: "Capacity Manager"
    }, "capacity-manager"), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
        href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? undefined : pathnames.bookingInfo,
        to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? pathnames.bookingInfo : undefined,
        RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
        shouldCloseDialog: true,
        children: "Booking Reports"
    }, "booking-info"));
    if ((0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).VIEW_POWER_BI_REPORT)) navItems.push(/*#__PURE__*/ (0, $acw62.createElement)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
        ...(0, $7939e29d663dd3ed$export$6c330e8992e8a295)(`${pathnames.dataReports}/*`) ? {
            "aria-current": "page"
        } : {},
        key: "data-reports",
        subMenu: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1384d326eb4d180d$export$2e2bcd8739ae039), {
            id: "data-reports-sub-navigation",
            children: Object.values((0, $138804ff4b365ce0$export$2e2bcd8739ae039)).map((value)=>{
                const path = `${pathnames.dataReports}/${value}`;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                    href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? undefined : path,
                    to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? path : undefined,
                    RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPO ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
                    shouldCloseDialog: true,
                    children: value === (0, $138804ff4b365ce0$export$2e2bcd8739ae039).GrossRevenue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                        id: "navigation.dataReports.grossRevenue"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                        id: "navigation.dataReports.segmentDistance"
                    })
                }, path);
            })
        })
    }, "Data Reports"));
    navItems.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
        href: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? undefined : pathnames.showStations,
        to: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? pathnames.showStations : undefined,
        RouterLink: app === (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MPC ? (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d) : undefined,
        shouldCloseDialog: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
            id: "navigation.citiesAndStations"
        })
    }, "show-stations"));
    return navItems;
};
var $6fc87e87e9c8af93$export$2e2bcd8739ae039 = $6fc87e87e9c8af93$var$getNavigationItems;





var $acw62 = parcelRequire("acw62");

var $242c5d46dd3e26d5$var$_excluded = [
    "title",
    "pathRest"
];
var $242c5d46dd3e26d5$export$a54041d71da972bf = function IconNight(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $242c5d46dd3e26d5$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-night"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M20.63 18.45a.7.7 0 0 0-.68-.46h-.34q-1.72 0-3.35-.59a9.72 9.72 0 0 1-4.91-14.27.7.7 0 0 0-.05-.84.7.7 0 0 0-.8-.26 10.2 10.2 0 0 0-7 7.74c-.98 4.8 2.11 10.15 6.74 11.7a10.3 10.3 0 0 0 10.21-2.2c.23-.21.3-.54.18-.82M13.5 20q-1.35 0-2.62-.43c-3.66-1.22-6.2-5.61-5.43-9.4A8.2 8.2 0 0 1 8.2 5.52l-.15.74a11.8 11.8 0 0 0 8.24 13.26q-1.34.47-2.8.48"
    }, pathRest)));
};
$242c5d46dd3e26d5$export$a54041d71da972bf.displayName = 'InlineIcon(IconNight)';
$242c5d46dd3e26d5$export$a54041d71da972bf.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $5761bcdeb7c2df84$var$_excluded = [
    "title",
    "pathRest"
];
var $5761bcdeb7c2df84$export$f8295d9ceeb6d2d6 = function IconSettings(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $5761bcdeb7c2df84$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-settings"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "m21.4 9.35-3.03-.24q-.29-.63-.68-1.18l1.3-2.75a.66.66 0 0 0-.25-.84l-3.48-2a.66.66 0 0 0-.86.2l-1.72 2.5a7 7 0 0 0-1.36 0L9.6 2.54a.66.66 0 0 0-.86-.2l-3.48 2a.66.66 0 0 0-.26.84l1.31 2.75q-.4.55-.68 1.18l-3.03.24a.66.66 0 0 0-.6.64v4.02c0 .33.27.62.6.64l3.03.24q.3.63.68 1.18l-1.3 2.75c-.15.3-.03.67.25.84l3.48 2q.14.09.32.09c.2 0 .42-.1.54-.28l1.72-2.5a7 7 0 0 0 1.36 0l1.72 2.5a.66.66 0 0 0 .86.2l3.48-2.01c.28-.17.4-.55.26-.84l-1.31-2.75q.4-.55.68-1.18l3.03-.24c.33-.02.6-.31.6-.64V9.99a.66.66 0 0 0-.6-.64m-1.4 3.4-1.79.15-1.17.1-.5 1.06q-.19.45-.48.84l-.68.96.5 1.07.78 1.62-1.32.76-1.01-1.48-.67-.97-1.17.12a5 5 0 0 1-.98 0l-1.17-.12-.67.97-1.02 1.48-1.3-.76.76-1.62.51-1.07-.69-.96a5 5 0 0 1-.48-.84L6.96 13l-1.17-.1-1.8-.13v-1.52l1.8-.14 1.17-.1.49-1.06q.2-.45.48-.84l.7-.96-.52-1.07-.77-1.62 1.31-.76 1.02 1.48.67.97 1.17-.12a5 5 0 0 1 .98 0l1.17.12.67-.97 1.01-1.48 1.32.76-.78 1.62-.5 1.07.68.96q.3.39.49.84l.49 1.07 1.17.1 1.79.13zM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    }, pathRest)));
};
$5761bcdeb7c2df84$export$f8295d9ceeb6d2d6.displayName = 'InlineIcon(IconSettings)';
$5761bcdeb7c2df84$export$f8295d9ceeb6d2d6.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $1c55412cb5dc7a1f$var$_excluded = [
    "title",
    "pathRest"
];
var $1c55412cb5dc7a1f$export$c60900947260205a = function IconSun(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $1c55412cb5dc7a1f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-sun"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8M11 4V3a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0m2 16v1a1 1 0 1 1-2 0v-1a1 1 0 1 1 2 0m9-8a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1M4 13H3a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2m12.95-5.95a1 1 0 0 1 0-1.41l.7-.71a1 1 0 1 1 1.42 1.41l-.7.71a1 1 0 0 1-1.42 0m-9.9 9.9a1 1 0 0 1 0 1.41l-.7.71a1 1 0 1 1-1.42-1.41l.7-.71a1 1 0 0 1 1.42 0m12.02.7a1 1 0 1 1-1.41 1.42l-.71-.7a1 1 0 1 1 1.41-1.42zM4.93 6.36a1 1 0 1 1 1.41-1.42l.71.7a1 1 0 1 1-1.41 1.42z"
    }, pathRest)));
};
$1c55412cb5dc7a1f$export$c60900947260205a.displayName = 'InlineIcon(IconSun)';
$1c55412cb5dc7a1f$export$c60900947260205a.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



parcelRequire("acw62");






const $dbfba77f68568ddb$var$getWidgetNavigation = (isDarkTheme, toggleTheme, isMobile = false)=>{
    const selected = (0, $61d5299c8c0ea66c$export$68274e25c3f28c82)();
    const locale = (0, $eff69fb1886d6e36$export$1c0c86175370e5f0).find((lang)=>lang.locale === selected);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1384d326eb4d180d$export$2e2bcd8739ae039), {
        id: "user-sub-menu",
        children: [
            (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_MUS_ACCESS) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).mus,
                InlineIcon: (0, $5761bcdeb7c2df84$export$f8295d9ceeb6d2d6),
                extraClasses: $f5524f6b44d868fb$export$1ca1ec8b29a4ce27,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    id: "navigation.personalSettings"
                })
            }, "PersonalSettings") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                onClick: toggleTheme,
                Elem: "button",
                InlineIcon: isDarkTheme ? (0, $242c5d46dd3e26d5$export$a54041d71da972bf) : (0, $1c55412cb5dc7a1f$export$c60900947260205a),
                extraClasses: $f5524f6b44d868fb$export$1ca1ec8b29a4ce27,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    id: "navigation.toggleTheme"
                })
            }, "toggleTheme"),
            locale ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                Elem: "div",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cea3b3f250ab4ad$export$2e2bcd8739ae039), {
                    currentLanguage: locale,
                    languages: [
                        {
                            region: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("navigation.switchLanguage"),
                            locales: (0, $eff69fb1886d6e36$export$1c0c86175370e5f0)
                        }
                    ],
                    onLanguageSelected: (0, $61d5299c8c0ea66c$export$68682645b7684355)
                })
            }, "switchLanguage") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).mpp,
                Elem: "a",
                InlineIcon: (0, $1b558ceaff25e22a$export$385133bba56e7cda),
                target: "_blank",
                extraClasses: $f5524f6b44d868fb$export$1ca1ec8b29a4ce27,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    id: "navigation.MobilityPartnerPortal"
                })
            }, "MobilityPartnerPortal"),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                onClick: (0, $bc59a856a5e4c3e2$export$a0973bcfe11b05c9),
                Elem: "button",
                extraClasses: isMobile ? undefined : $f5524f6b44d868fb$export$a0973bcfe11b05c9,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    id: "navigation.logout"
                })
            }, "logout")
        ]
    });
};
var $dbfba77f68568ddb$export$2e2bcd8739ae039 = $dbfba77f68568ddb$var$getWidgetNavigation;


const $a4964bc9f1cb5508$var$LOGO_FLIX_URL = "https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/2.0.0/svg/flix-white.svg";
const $a4964bc9f1cb5508$var$LOGO_COOPERATION_URL = "https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/2.0.0/svg/flixcoop-white.svg";
const $a4964bc9f1cb5508$var$Navigation = ({ app: app, widget: widget, isUsedInternal: isUsedInternal, RouterLink: RouterLink })=>{
    const userName = (0, $bc59a856a5e4c3e2$export$15445f8a01cc33a5)();
    const navigation = (0, $6fc87e87e9c8af93$export$2e2bcd8739ae039)(app);
    const [isDarkTheme, toggleTheme] = (0, $0cba5a2b438c2f8b$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f95fd1159f86112d$export$2e2bcd8739ae039), {
                brand: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f19e397f3651e2e$export$2e2bcd8739ae039), {
                    src: isUsedInternal ? $a4964bc9f1cb5508$var$LOGO_COOPERATION_URL : $a4964bc9f1cb5508$var$LOGO_FLIX_URL,
                    alt: isUsedInternal ? "Flix Cooperation" : "Flix",
                    RouterLink: RouterLink,
                    href: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).userHome,
                    height: "20px",
                    width: "auto"
                }),
                navigation: (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_VIEW_ACCESS_TO_ALL_PAGES) && isUsedInternal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8372fc2863001da$export$2e2bcd8739ae039), {
                    "data-id": "desktop",
                    "aria-label": "Main",
                    children: navigation
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                burgerMenu: (0, $abefdbda3c0e307b$export$d38c79f7cb4d2f57)((0, $a19e0ad93a0122b0$export$2e2bcd8739ae039).USER_HAS_VIEW_ACCESS_TO_ALL_PAGES) && isUsedInternal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2599f6bb9ec513a$export$2e2bcd8739ae039), {
                    openPanelLabel: "Open main menu",
                    closePanelLabel: "Close main menu",
                    panelId: "burger-panel",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8372fc2863001da$export$2e2bcd8739ae039), {
                        "data-id": "mobile",
                        "aria-label": "Main",
                        children: [
                            ...navigation,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                                "data-id": "help-widget-mobile-menu",
                                subMenu: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1384d326eb4d180d$export$2e2bcd8739ae039), {
                                    id: "help-mobile-menu",
                                    children: (0, $86d6f48353187cb7$export$2e2bcd8739ae039)(app, false).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                                            InlineIcon: item.InlineIcon,
                                            href: item.href,
                                            to: item.to,
                                            target: item.target,
                                            RouterLink: item.RouterLink,
                                            shouldCloseDialog: item.shouldCloseDialog,
                                            children: item.text
                                        }, item.key))
                                }),
                                extraClasses: $f5524f6b44d868fb$export$df8352d9cc927c03,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $f5524f6b44d868fb$export$8ea057179197726a,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                            InlineIcon: (0, $c40261c34536a43d$export$65daaa3bbd433e83),
                                            size: 5
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Help Center"
                                        })
                                    ]
                                })
                            }, "helpMenu"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                                "data-id": "user-widget-mobile-menu",
                                subMenu: (0, $dbfba77f68568ddb$export$2e2bcd8739ae039)(isDarkTheme, toggleTheme, true),
                                extraClasses: $f5524f6b44d868fb$export$df8352d9cc927c03,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: $f5524f6b44d868fb$export$8ea057179197726a,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                            InlineIcon: (0, $f0f4553d8923ab9e$export$ee0a9968ab5cedc8),
                                            size: 5
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: userName
                                        })
                                    ]
                                })
                            }, "userMenu")
                        ]
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                widgetSize: "m",
                widgets: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a12033d0107a35$export$2e2bcd8739ae039), {
                    children: isUsedInternal ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a56a5249bf41155e$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e07bc6cc49523b41$export$1b5689fc8adf2f5e), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f60807b922cb821$export$2e2bcd8739ae039), {
                                    id: "help-menu-dropdown",
                                    links: (0, $790626a2e649e497$export$2e2bcd8739ae039)(app),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                        size: 6,
                                        InlineIcon: (0, $c40261c34536a43d$export$65daaa3bbd433e83),
                                        extraClasses: $f5524f6b44d868fb$export$1ffaa3fd26b67b20
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e07bc6cc49523b41$export$1b5689fc8adf2f5e), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0237b414dabc697$export$2e2bcd8739ae039), {
                                    avatar: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a3cda011510100a$export$2e2bcd8739ae039), {
                                        size: 6
                                    }),
                                    subMenu: (0, $dbfba77f68568ddb$export$2e2bcd8739ae039)(isDarkTheme, toggleTheme),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: $f5524f6b44d868fb$export$c86d3ca66f38ed60,
                                        children: userName === "Julia Jormakka" ? "Julia Eva Aili Maria Alvariina Jormakka" : userName
                                    })
                                })
                            })
                        ]
                    }) : widget
                }),
                extraClasses: $f5524f6b44d868fb$export$38e42c68cf43b5d4,
                fixed: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7858a988b34866c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: (0, $d201893169ea3ce2$export$2e2bcd8739ae039)
            })
        ]
    });
};
var $a4964bc9f1cb5508$export$2e2bcd8739ae039 = $a4964bc9f1cb5508$var$Navigation;





var $acw62 = parcelRequire("acw62");

var $fab4635eae535bc7$export$34e0f9847d4c02dd;
var $fab4635eae535bc7$export$d55486916beefd15;
var $fab4635eae535bc7$export$fa397790119a1408;
var $fab4635eae535bc7$export$b426df703d3b34b8;
var $fab4635eae535bc7$export$b50df5c21d22a4eb;
var $fab4635eae535bc7$export$6f093cfa640b7166;
$fab4635eae535bc7$export$34e0f9847d4c02dd = `Footer-yd8sDq-container`;
$fab4635eae535bc7$export$d55486916beefd15 = `Footer-yd8sDq-flexContainer`;
$fab4635eae535bc7$export$fa397790119a1408 = `Footer-yd8sDq-flix-theme-dark`;
$fab4635eae535bc7$export$b426df703d3b34b8 = `Footer-yd8sDq-flix-theme-flix`;
$fab4635eae535bc7$export$b50df5c21d22a4eb = `Footer-yd8sDq-linkFlexContainer`;
$fab4635eae535bc7$export$6f093cfa640b7166 = `Footer-yd8sDq-text`;


const $e986d6583a1af7f8$export$12f72d415d17df92 = async (langCode)=>{
    // For more info on this endpoint see: https://wiki.flix.tech/display/D8/Navigation+Menus
    const res = await fetch("https://api.cms.flixbus.com/gql", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            query: `
      query {
        menu(name: "footer-legal-react-fe") {
          items (language: "${langCode}") {
            title
            url {
              path
            }
          }
        }
        domains(language: "${langCode}", project: "${langCode === "es-mx" ? "greyhound" : "flixbus"}") {
          name
        }
      }`
        })
    });
    if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
    }
    const items = await res.json();
    return items;
};


const $9a69e10efae4b4dd$var$CURRENT_YEAR = new Date().getFullYear();
const $9a69e10efae4b4dd$var$Footer = ({ locale: locale, isInternal: isInternal })=>{
    const [menuItems, setMenuItems] = $acw62.useState([]);
    const [domain, setDomain] = $acw62.useState("");
    const languageObject = (0, $eff69fb1886d6e36$export$e24640604b11ca0)(locale, isInternal);
    $acw62.useEffect(()=>{
        let isMounted = true;
        const { drupal: drupal } = (0, $eff69fb1886d6e36$export$e24640604b11ca0)(locale, isInternal);
        (0, $e986d6583a1af7f8$export$12f72d415d17df92)(drupal).then((res)=>{
            if (isMounted) {
                setDomain(res.data.domains[0].name);
                setMenuItems(res.data.menu.items);
            }
        }).catch((e)=>{
            console.error(e.message);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        locale,
        isInternal
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $fab4635eae535bc7$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $929c01dd4f184c67$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $fab4635eae535bc7$export$d55486916beefd15,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $fab4635eae535bc7$export$b50df5c21d22a4eb,
                        children: menuItems.map((item)=>{
                            if (item.url.path === "/manage-consent-settings") return(// eslint-disable-next-line jsx-a11y/anchor-is-valid
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "#",
                                onClick: ()=>{
                                    if (window.UC_UI) {
                                        window.UC_UI.updateLanguage(languageObject.iso6391);
                                        window.UC_UI.showSecondLayer();
                                    }
                                },
                                className: $fab4635eae535bc7$export$6f093cfa640b7166,
                                children: item.title
                            }, item.url.path));
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                rel: "noreferrer",
                                target: "_blank",
                                href: item.url.path.startsWith("/") ? `https://${domain}${item.url.path}` : item.url.path,
                                className: $fab4635eae535bc7$export$6f093cfa640b7166,
                                children: item.title
                            }, item.url.path);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $fab4635eae535bc7$export$6f093cfa640b7166,
                        children: [
                            "\xa9 ",
                            $9a69e10efae4b4dd$var$CURRENT_YEAR,
                            " Flix SE"
                        ]
                    })
                ]
            })
        ]
    });
};
var $9a69e10efae4b4dd$export$2e2bcd8739ae039 = $9a69e10efae4b4dd$var$Footer;




var $acw62 = parcelRequire("acw62");

const $22d960a4870b8182$export$f667990dc5aadd30 = /*#__PURE__*/ $acw62.createContext(undefined);
const $22d960a4870b8182$export$5daa7e4a3ac6a853 = ()=>$acw62.useContext($22d960a4870b8182$export$f667990dc5aadd30);
const $22d960a4870b8182$var$ViewportProvider = ({ children: children })=>{
    const [width, setWidth] = $acw62.useState(window.innerWidth);
    const handleWindowResize = (0, $f21400ae50a90441$export$2e2bcd8739ae039)(()=>setWidth(window.innerWidth), 200);
    $acw62.useEffect(()=>{
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($22d960a4870b8182$export$f667990dc5aadd30.Provider, {
        value: width,
        children: children
    });
};
var $22d960a4870b8182$export$2e2bcd8739ae039 = $22d960a4870b8182$var$ViewportProvider;



parcelRequire("acw62");


const $92cf915b05495aa8$var$useIsInRange = (range)=>{
    const width = (0, $22d960a4870b8182$export$5daa7e4a3ac6a853)();
    const getCurrentRange = ()=>{
        if (width !== undefined) {
            if (width < (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).XS) return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).XXS;
            if (width < (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).SM) return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).XS;
            if (width < (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).MD) return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).SM;
            if (width < (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).LG) return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).MD;
            if (width < (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).XL) return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).LG;
            return (0, $6e7b8bb89b9ade82$export$2e2bcd8739ae039).XL;
        }
        return undefined;
    };
    const currentRange = getCurrentRange();
    if (currentRange !== undefined) return range.includes(currentRange);
    return false;
};
var $92cf915b05495aa8$export$2e2bcd8739ae039 = $92cf915b05495aa8$var$useIsInRange;


const $7acf22c424d1ef55$var$ResponsiveRenderer = ({ hidden: hidden, children: children })=>{
    const isInRangeToBeHidden = (0, $92cf915b05495aa8$export$2e2bcd8739ae039)(hidden);
    if (isInRangeToBeHidden) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
var $7acf22c424d1ef55$export$2e2bcd8739ae039 = $7acf22c424d1ef55$var$ResponsiveRenderer;





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");


var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $70f61dd951fba0f0$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $70f61dd951fba0f0$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $70f61dd951fba0f0$var$_ref
    }, props));
};
var $70f61dd951fba0f0$var$A11yText$1 = $70f61dd951fba0f0$var$A11yText;
var $70f61dd951fba0f0$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $70f61dd951fba0f0$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $70f61dd951fba0f0$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($70f61dd951fba0f0$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($70f61dd951fba0f0$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $70f61dd951fba0f0$var$LiveRegion$1 = $70f61dd951fba0f0$var$LiveRegion;
var $70f61dd951fba0f0$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $70f61dd951fba0f0$var$anyDiacritic = new RegExp('[' + $70f61dd951fba0f0$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $70f61dd951fba0f0$var$diacriticToBase = {};
for(var $70f61dd951fba0f0$var$i = 0; $70f61dd951fba0f0$var$i < $70f61dd951fba0f0$var$diacritics.length; $70f61dd951fba0f0$var$i++){
    var $70f61dd951fba0f0$var$diacritic = $70f61dd951fba0f0$var$diacritics[$70f61dd951fba0f0$var$i];
    for(var $70f61dd951fba0f0$var$j = 0; $70f61dd951fba0f0$var$j < $70f61dd951fba0f0$var$diacritic.letters.length; $70f61dd951fba0f0$var$j++)$70f61dd951fba0f0$var$diacriticToBase[$70f61dd951fba0f0$var$diacritic.letters[$70f61dd951fba0f0$var$j]] = $70f61dd951fba0f0$var$diacritic.base;
}
var $70f61dd951fba0f0$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($70f61dd951fba0f0$var$anyDiacritic, function(match) {
        return $70f61dd951fba0f0$var$diacriticToBase[match];
    });
};
var $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($70f61dd951fba0f0$var$stripDiacritics);
var $70f61dd951fba0f0$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $70f61dd951fba0f0$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $70f61dd951fba0f0$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $70f61dd951fba0f0$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $70f61dd951fba0f0$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $70f61dd951fba0f0$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $70f61dd951fba0f0$var$memoizedStripDiacriticsForInput(input);
            candidate = $70f61dd951fba0f0$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $70f61dd951fba0f0$var$_excluded = [
    "innerRef"
];
function $70f61dd951fba0f0$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $70f61dd951fba0f0$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $e5db4f66b3bbccc3$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $70f61dd951fba0f0$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $70f61dd951fba0f0$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $70f61dd951fba0f0$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $e5db4f66b3bbccc3$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $70f61dd951fba0f0$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $70f61dd951fba0f0$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $70f61dd951fba0f0$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $70f61dd951fba0f0$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $70f61dd951fba0f0$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $70f61dd951fba0f0$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $70f61dd951fba0f0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $70f61dd951fba0f0$var$activeScrollLocks = 0;
var $70f61dd951fba0f0$var$listenerOptions = {
    capture: false,
    passive: false
};
function $70f61dd951fba0f0$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($70f61dd951fba0f0$var$LOCK_STYLES).forEach(function(key) {
                var val = $70f61dd951fba0f0$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$70f61dd951fba0f0$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $70f61dd951fba0f0$var$activeScrollLocks = Math.max($70f61dd951fba0f0$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $70f61dd951fba0f0$var$activeScrollLocks < 1) $70f61dd951fba0f0$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $70f61dd951fba0f0$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $70f61dd951fba0f0$var$preventTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $70f61dd951fba0f0$var$preventInertiaScroll, $70f61dd951fba0f0$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $70f61dd951fba0f0$var$allowTouchMove, $70f61dd951fba0f0$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $70f61dd951fba0f0$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $70f61dd951fba0f0$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $70f61dd951fba0f0$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $70f61dd951fba0f0$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $70f61dd951fba0f0$var$blurSelectInput,
        css: $70f61dd951fba0f0$var$_ref2$1
    }), children(targetRef));
}
function $70f61dd951fba0f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $70f61dd951fba0f0$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $70f61dd951fba0f0$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $70f61dd951fba0f0$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $70f61dd951fba0f0$var$RequiredInput$1 = $70f61dd951fba0f0$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $70f61dd951fba0f0$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $70f61dd951fba0f0$var$isIPhone() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPhone/i);
}
function $70f61dd951fba0f0$var$isMac() {
    return $70f61dd951fba0f0$var$testPlatform(/^Mac/i);
}
function $70f61dd951fba0f0$var$isIPad() {
    return $70f61dd951fba0f0$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $70f61dd951fba0f0$var$isMac() && navigator.maxTouchPoints > 1;
}
function $70f61dd951fba0f0$var$isIOS() {
    return $70f61dd951fba0f0$var$isIPhone() || $70f61dd951fba0f0$var$isIPad();
}
function $70f61dd951fba0f0$var$isAppleDevice() {
    return $70f61dd951fba0f0$var$isMac() || $70f61dd951fba0f0$var$isIOS();
}
var $70f61dd951fba0f0$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $70f61dd951fba0f0$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $70f61dd951fba0f0$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $70f61dd951fba0f0$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $70f61dd951fba0f0$var$defaultStyles = {
    clearIndicator: (0, $e5db4f66b3bbccc3$export$407448d2b89b1813),
    container: (0, $e5db4f66b3bbccc3$export$8b22cf2602fb60ce),
    control: (0, $e5db4f66b3bbccc3$export$4368d992c4eafac0),
    dropdownIndicator: (0, $e5db4f66b3bbccc3$export$f1e1789686576879),
    group: (0, $e5db4f66b3bbccc3$export$39b482c5e57630a8),
    groupHeading: (0, $e5db4f66b3bbccc3$export$2d1720544b23b823),
    indicatorsContainer: (0, $e5db4f66b3bbccc3$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $e5db4f66b3bbccc3$export$dda1d9f60106f0e9),
    input: (0, $e5db4f66b3bbccc3$export$35e795649ee09318),
    loadingIndicator: (0, $e5db4f66b3bbccc3$export$882b5998b3b9117c),
    loadingMessage: (0, $e5db4f66b3bbccc3$export$342063e11d6c3cad),
    menu: (0, $e5db4f66b3bbccc3$export$953cecd6e717a553),
    menuList: (0, $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $e5db4f66b3bbccc3$export$ae1af26003f05816),
    multiValue: (0, $e5db4f66b3bbccc3$export$ffb5f4729a158638),
    multiValueLabel: (0, $e5db4f66b3bbccc3$export$9e5f44173e64f162),
    multiValueRemove: (0, $e5db4f66b3bbccc3$export$625550452a3fa3ec),
    noOptionsMessage: (0, $e5db4f66b3bbccc3$export$3b14a55fb2447963),
    option: (0, $e5db4f66b3bbccc3$export$90a7f3efeed30595),
    placeholder: (0, $e5db4f66b3bbccc3$export$efccba1c4a2ef57b),
    singleValue: (0, $e5db4f66b3bbccc3$export$d141bba7fdc215a3),
    valueContainer: (0, $e5db4f66b3bbccc3$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $70f61dd951fba0f0$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $70f61dd951fba0f0$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $70f61dd951fba0f0$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $70f61dd951fba0f0$var$baseUnit = 4;
// The minimum height of the control
var $70f61dd951fba0f0$var$controlHeight = 38;
// The amount of space between the control and menu */
var $70f61dd951fba0f0$var$menuGutter = $70f61dd951fba0f0$var$baseUnit * 2;
var $70f61dd951fba0f0$var$spacing = {
    baseUnit: $70f61dd951fba0f0$var$baseUnit,
    controlHeight: $70f61dd951fba0f0$var$controlHeight,
    menuGutter: $70f61dd951fba0f0$var$menuGutter
};
var $70f61dd951fba0f0$export$4368d992c4eafac0 = {
    borderRadius: $70f61dd951fba0f0$var$borderRadius,
    colors: $70f61dd951fba0f0$var$colors,
    spacing: $70f61dd951fba0f0$var$spacing
};
var $70f61dd951fba0f0$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $70f61dd951fba0f0$export$db3b6bfb95261072(),
    formatGroupLabel: $70f61dd951fba0f0$var$formatGroupLabel,
    getOptionLabel: $70f61dd951fba0f0$export$8b22cf2602fb60ce,
    getOptionValue: $70f61dd951fba0f0$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $70f61dd951fba0f0$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $e5db4f66b3bbccc3$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue);
    var label = $70f61dd951fba0f0$var$getOptionLabel(props, option);
    var value = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $70f61dd951fba0f0$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $70f61dd951fba0f0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $e5db4f66b3bbccc3$export$3466f893ebf79586));
}
function $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) {
    return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue));
}
function $70f61dd951fba0f0$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$70f61dd951fba0f0$var$shouldHideSelectedOptions(props) || !isSelected) && $70f61dd951fba0f0$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $70f61dd951fba0f0$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $70f61dd951fba0f0$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $70f61dd951fba0f0$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $70f61dd951fba0f0$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $70f61dd951fba0f0$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $70f61dd951fba0f0$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $70f61dd951fba0f0$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $70f61dd951fba0f0$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $70f61dd951fba0f0$var$getOptionValue(props, i) === candidate;
    });
}
function $70f61dd951fba0f0$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $70f61dd951fba0f0$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $70f61dd951fba0f0$var$instanceId = 1;
var $70f61dd951fba0f0$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $70f61dd951fba0f0$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $70f61dd951fba0f0$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $70f61dd951fba0f0$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $70f61dd951fba0f0$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $e5db4f66b3bbccc3$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $70f61dd951fba0f0$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $70f61dd951fba0f0$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $e5db4f66b3bbccc3$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $70f61dd951fba0f0$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$70f61dd951fba0f0$var$instanceId);
        _this.state.selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                if ($70f61dd951fba0f0$var$isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $70f61dd951fba0f0$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($70f61dd951fba0f0$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $70f61dd951fba0f0$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $70f61dd951fba0f0$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $70f61dd951fba0f0$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $e5db4f66b3bbccc3$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($70f61dd951fba0f0$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $70f61dd951fba0f0$var$buildFocusableOptionsWithIds($70f61dd951fba0f0$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $70f61dd951fba0f0$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $70f61dd951fba0f0$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $70f61dd951fba0f0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$70f61dd951fba0f0$export$25ce5a424b770e84.defaultProps = $70f61dd951fba0f0$export$407448d2b89b1813;




















var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $70f61dd951fba0f0$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $4eee05ec22b53782$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};









var $2554e7af892e99f0$export$a3bc9b8ed74fc;
var $2554e7af892e99f0$export$fa397790119a1408;
var $2554e7af892e99f0$export$b426df703d3b34b8;
var $2554e7af892e99f0$export$1ca1ec8b29a4ce27;
var $2554e7af892e99f0$export$a80b3bd66acc52ff;
var $2554e7af892e99f0$export$b76af709b52e7487;
$2554e7af892e99f0$export$a3bc9b8ed74fc = `Select-rceqqa-error`;
$2554e7af892e99f0$export$fa397790119a1408 = `Select-rceqqa-flix-theme-dark`;
$2554e7af892e99f0$export$b426df703d3b34b8 = `Select-rceqqa-flix-theme-flix`;
$2554e7af892e99f0$export$1ca1ec8b29a4ce27 = `Select-rceqqa-icon`;
$2554e7af892e99f0$export$a80b3bd66acc52ff = `Select-rceqqa-info`;
$2554e7af892e99f0$export$b76af709b52e7487 = `Select-rceqqa-inputLabel`;


const $0efec8145fdf3b01$var$Select = ({ id: id, label: label, placeholder: placeholder, initialValue: initialValue, options: options, onSelect: onSelect, onClear: onClear, onBlur: onBlur, errorText: errorText, isDisabled: isDisabled, isDropUp: isDropUp = false, infoText: infoText })=>{
    const [value, setValue] = $acw62.useState(initialValue);
    $acw62.useEffect(()=>{
        setValue(initialValue);
    }, [
        initialValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: $2554e7af892e99f0$export$b76af709b52e7487,
                htmlFor: `select-${label}`,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                id: id ? id : `select-${(0, $433401918a64c671$export$2e2bcd8739ae039)(label) || Math.random()}`,
                "data-id": "select",
                placeholder: placeholder,
                styles: (0, $63c2c06b53ba964b$export$2e2bcd8739ae039)(!!errorText, true, isDropUp, onClear !== undefined, !!label),
                value: value,
                options: options,
                components: {
                    ClearIndicator: $15a95a4dbc72f529$export$2e2bcd8739ae039,
                    DropdownIndicator: isDropUp ? (0, $5a41aab8da0b5e84$export$2e2bcd8739ae039) : (0, $2b2850ccc654d05b$export$2e2bcd8739ae039),
                    Option: $4b57c50dbfa9c188$export$2e2bcd8739ae039,
                    SingleValue: $16f29cccac148065$export$2e2bcd8739ae039
                },
                onChange: (selectedValue)=>{
                    setValue(selectedValue);
                    if (selectedValue) onSelect(selectedValue);
                    else if (onClear) onClear();
                },
                onBlur: onBlur,
                isDisabled: isDisabled,
                menuPlacement: isDropUp ? "top" : "bottom",
                isClearable: onClear !== undefined,
                isSearchable: false
            }),
            infoText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "data-id": "info-message",
                className: $2554e7af892e99f0$export$a80b3bd66acc52ff,
                children: infoText
            }),
            errorText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "data-id": "error-message",
                className: `${$2554e7af892e99f0$export$a80b3bd66acc52ff} ${$2554e7af892e99f0$export$a3bc9b8ed74fc}`,
                children: errorText
            })
        ]
    });
};
var $0efec8145fdf3b01$export$2e2bcd8739ae039 = $0efec8145fdf3b01$var$Select;






function $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6d99a9de69717ea6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d99a9de69717ea6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
}
function $6d99a9de69717ea6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d99a9de69717ea6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6d99a9de69717ea6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d99a9de69717ea6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d99a9de69717ea6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $6d99a9de69717ea6$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $6d99a9de69717ea6$var$hasSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbols() && Boolean(Symbol[name]);
};
var $6d99a9de69717ea6$var$getSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($6d99a9de69717ea6$var$hasSymbols() && !$6d99a9de69717ea6$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $6d99a9de69717ea6$var$SymbolIterator = $6d99a9de69717ea6$var$getSymbol('iterator');
var $6d99a9de69717ea6$var$SymbolObservable = $6d99a9de69717ea6$var$getSymbol('observable');
var $6d99a9de69717ea6$var$SymbolSpecies = $6d99a9de69717ea6$var$getSymbol('species'); // === Abstract Operations ===
function $6d99a9de69717ea6$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $6d99a9de69717ea6$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$6d99a9de69717ea6$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $6d99a9de69717ea6$export$77cea355fa80b5f4;
}
function $6d99a9de69717ea6$var$isObservable(x) {
    return x instanceof $6d99a9de69717ea6$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $6d99a9de69717ea6$var$hostReportError(e) {
    if ($6d99a9de69717ea6$var$hostReportError.log) $6d99a9de69717ea6$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $6d99a9de69717ea6$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $6d99a9de69717ea6$var$hostReportError(e);
        }
    });
}
function $6d99a9de69717ea6$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $6d99a9de69717ea6$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
}
function $6d99a9de69717ea6$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $6d99a9de69717ea6$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $6d99a9de69717ea6$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $6d99a9de69717ea6$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $6d99a9de69717ea6$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $6d99a9de69717ea6$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $6d99a9de69717ea6$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $6d99a9de69717ea6$var$enqueue(function() {
            return $6d99a9de69717ea6$var$flushSubscription(subscription);
        });
        return;
    }
    $6d99a9de69717ea6$var$notifySubscription(subscription, type, value);
}
var $6d99a9de69717ea6$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $6d99a9de69717ea6$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $6d99a9de69717ea6$var$closeSubscription(this);
            $6d99a9de69717ea6$var$cleanupSubscription(this);
        }
    };
    $6d99a9de69717ea6$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $6d99a9de69717ea6$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'complete');
    };
    $6d99a9de69717ea6$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $6d99a9de69717ea6$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $6d99a9de69717ea6$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$6d99a9de69717ea6$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($6d99a9de69717ea6$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($6d99a9de69717ea6$var$hasSymbol('iterator')) {
            method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $6d99a9de69717ea6$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $6d99a9de69717ea6$var$_createClass(Observable, null, [
        {
            key: $6d99a9de69717ea6$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($6d99a9de69717ea6$var$hasSymbols()) Object.defineProperty($6d99a9de69717ea6$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $6d99a9de69717ea6$var$SymbolObservable,
        hostReportError: $6d99a9de69717ea6$var$hostReportError
    },
    configurable: true
});


parcelRequire("6Z7su");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $58650dd67955ab9d$var$prototype = (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).prototype;
var $58650dd67955ab9d$var$fakeObsSymbol = "@@observable";
if (!$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol]) // @ts-expect-error
$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol] = function() {
    return this;
};



function $159d5dc79a8added$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $3a16601e2096f4cd$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $3a16601e2096f4cd$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}




function $8beb5260c793fc92$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
const $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$9dec5d1b3b6a130d(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9541a54af6a37409$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $9541a54af6a37409$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[' + $9541a54af6a37409$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $9541a54af6a37409$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $9541a54af6a37409$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $11b06753ce50693f$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $11b06753ce50693f$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $11b06753ce50693f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $11b06753ce50693f$var$kindValues = new Set(Object.keys($11b06753ce50693f$export$4fcd777a40ccf407));
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $11b06753ce50693f$var$kindValues.has(maybeKind);
}
/** Name */ var $11b06753ce50693f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($11b06753ce50693f$export$f58c50edb4aef9d4 || ($11b06753ce50693f$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($b7b8db97a7d116fe$export$a84bdc57c5122798 || ($b7b8db97a7d116fe$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $11b06753ce50693f$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $78b48476e314521e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(node) || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $78b48476e314521e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $7f688c9754699513$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(85, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragments.length === 1, 86, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $7f688c9754699513$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $7f688c9754699513$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 87, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $7f688c9754699513$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}


function $947797cdb9e55a2d$var$noop() {}
const $947797cdb9e55a2d$var$defaultDispose = $947797cdb9e55a2d$var$noop;
const $947797cdb9e55a2d$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $947797cdb9e55a2d$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $947797cdb9e55a2d$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $947797cdb9e55a2d$var$noop,
        unregister: $947797cdb9e55a2d$var$noop
    };
};
const $947797cdb9e55a2d$var$finalizationBatchSize = 10024;
class $947797cdb9e55a2d$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $947797cdb9e55a2d$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $947797cdb9e55a2d$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $947797cdb9e55a2d$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $947797cdb9e55a2d$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $947797cdb9e55a2d$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $b3ac5bdec858bda0$var$scheduledCleanup = new WeakSet();
function $b3ac5bdec858bda0$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$b3ac5bdec858bda0$var$scheduledCleanup.has(cache)) {
        $b3ac5bdec858bda0$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b3ac5bdec858bda0$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b3ac5bdec858bda0$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $947797cdb9e55a2d$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $947797cdb9e55a2d$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};
var $b3ac5bdec858bda0$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $557c26506c40b8f1$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};



var $c506be9be1a65610$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $c506be9be1a65610$export$f29926b23b28936b = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$c506be9be1a65610$var$cacheSizeSymbol]);




var $1da01699264b6e1e$var$globalCaches = {};
function $1da01699264b6e1e$export$a8fcd406d9e37621(name, getSize) {
    $1da01699264b6e1e$var$globalCaches[name] = getSize;
}
var $1da01699264b6e1e$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloClientMemoryInternals : undefined;
var $1da01699264b6e1e$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals : undefined;
var $1da01699264b6e1e$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloCacheMemoryInternals : undefined;
function $1da01699264b6e1e$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $c506be9be1a65610$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $1da01699264b6e1e$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $1da01699264b6e1e$var$getCurrentCacheSizes(),
        sizes: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            print: (_a = $1da01699264b6e1e$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($1da01699264b6e1e$var$globalCaches),
            parser: (_b = $1da01699264b6e1e$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($1da01699264b6e1e$var$globalCaches),
            canonicalStringify: (_c = $1da01699264b6e1e$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($1da01699264b6e1e$var$globalCaches),
            links: $1da01699264b6e1e$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $1da01699264b6e1e$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $1da01699264b6e1e$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $1da01699264b6e1e$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, $1da01699264b6e1e$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $1da01699264b6e1e$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $1da01699264b6e1e$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $1da01699264b6e1e$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $1da01699264b6e1e$var$getWrapperInformation(f) {
    return $1da01699264b6e1e$var$isWrapper(f) ? f.size : undefined;
}
function $1da01699264b6e1e$var$isDefined(value) {
    return value != null;
}
function $1da01699264b6e1e$var$transformInfo(transform) {
    return $1da01699264b6e1e$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $1da01699264b6e1e$var$recurseTransformInfo(transform) {
    return transform ? (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        $1da01699264b6e1e$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($1da01699264b6e1e$var$isDefined) : [];
}
function $1da01699264b6e1e$var$linkInfo(link) {
    var _a;
    return link ? (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($1da01699264b6e1e$var$isDefined) : [];
}


var $0bef48da5254bd54$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $0bef48da5254bd54$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $0bef48da5254bd54$var$sortingMap = new (0, $b3ac5bdec858bda0$export$5b4f745137d91413)((0, $c506be9be1a65610$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $0bef48da5254bd54$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $0bef48da5254bd54$var$sortingMap;
$0bef48da5254bd54$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $0bef48da5254bd54$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($0bef48da5254bd54$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $0bef48da5254bd54$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $0bef48da5254bd54$var$sortingMap.get(sortedKey) || keys;
                $0bef48da5254bd54$var$sortingMap.set(unsortedKey, sortedKeys);
                $0bef48da5254bd54$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $0bef48da5254bd54$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $9d830e5028848843$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $9d830e5028848843$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $9d830e5028848843$export$540432d49fcec6c9(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $9d830e5028848843$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $9d830e5028848843$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $9d830e5028848843$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $9d830e5028848843$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $9d830e5028848843$var$isVariable(value) {
    return value.kind === "Variable";
}
function $9d830e5028848843$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $9d830e5028848843$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $9d830e5028848843$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $9d830e5028848843$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($9d830e5028848843$var$isIntValue(value) || $9d830e5028848843$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($9d830e5028848843$var$isBooleanValue(value) || $9d830e5028848843$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $9d830e5028848843$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($9d830e5028848843$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($9d830e5028848843$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $9d830e5028848843$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($9d830e5028848843$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $28d90d877eb1e517$export$3991762405098ea)(96, name.value, value.kind);
}
function $9d830e5028848843$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $9d830e5028848843$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $9d830e5028848843$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $9d830e5028848843$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $9d830e5028848843$var$storeKeyNameStringify = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51);
var $9d830e5028848843$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($9d830e5028848843$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $9d830e5028848843$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($9d830e5028848843$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($9d830e5028848843$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $9d830e5028848843$var$storeKeyNameStringify;
        $9d830e5028848843$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $9d830e5028848843$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $9d830e5028848843$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $9d830e5028848843$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($9d830e5028848843$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$9d830e5028848843$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $9d830e5028848843$export$cf7bf7e4f289cc26(result, (0, $7f688c9754699513$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $9d830e5028848843$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $9d830e5028848843$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $818d93327cb72c29$export$a7d0d8111d2386df(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc && doc.kind === "Document", 88);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(89, definition.kind);
        return definition;
    });
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operations.length <= 1, 90, operations.length);
    return doc;
}
function $818d93327cb72c29$export$7a5b1fa979d2c158(doc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $818d93327cb72c29$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $818d93327cb72c29$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $818d93327cb72c29$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $818d93327cb72c29$export$7a5b1fa979d2c158(doc);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 91);
    return queryDef;
}
function $818d93327cb72c29$export$772111caef41b3f5(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.kind === "Document", 92);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.definitions.length <= 1, 93);
    var fragmentDef = doc.definitions[0];
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 94);
    return fragmentDef;
}
function $818d93327cb72c29$export$f431198736b7f96d(queryDoc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $28d90d877eb1e517$export$3991762405098ea)(95);
}
function $818d93327cb72c29$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $9d830e5028848843$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $6a49a3d7d64e95e4$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $f3beb697e0729913$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $28d90d877eb1e517$export$3991762405098ea)(46, key);
    }
    return operation;
}


function $60c07ffd02e3617d$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
}
function $60c07ffd02e3617d$var$toLink(handler) {
    return typeof handler === "function" ? new $60c07ffd02e3617d$export$2fed3d61f740bc7f(handler) : handler;
}
function $60c07ffd02e3617d$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $60c07ffd02e3617d$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($60c07ffd02e3617d$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $60c07ffd02e3617d$var$toLink(left);
        var rightLink = $60c07ffd02e3617d$var$toLink(right || new ApolloLink($60c07ffd02e3617d$var$passthrough));
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(leftLink) && $60c07ffd02e3617d$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $159d5dc79a8added$export$f29bedd62f56fcb2)(operation.context, (0, $6a49a3d7d64e95e4$export$4f3f7df1b558c729)((0, $f3beb697e0729913$export$a92a48117d546c9)(operation)))) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $60c07ffd02e3617d$var$toLink(first);
        if ($60c07ffd02e3617d$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(38, firstLink);
            return firstLink;
        }
        var nextLink = $60c07ffd02e3617d$var$toLink(second);
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($60c07ffd02e3617d$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $28d90d877eb1e517$export$3991762405098ea)(39);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $88c17748fb93d3ed$export$51396ec711da548b = (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).execute;










function $89c1eec09879e1ca$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(evaledValue !== void 0, 78, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $89c1eec09879e1ca$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $89c1eec09879e1ca$export$528b5e7d8ba07fbf = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, false);
};
var $89c1eec09879e1ca$export$ad1b63b26c1a9b76 = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, true);
};
function $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a(document) {
    return document && $89c1eec09879e1ca$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $89c1eec09879e1ca$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$89c1eec09879e1ca$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 79, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 80, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 81, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $89c1eec09879e1ca$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(82);
            else if (modeArg.value.kind !== (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(83);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(84, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}







// A version of Array.isArray that works better with readonly arrays.
var $e6aaa0e65613edd7$export$43bee75e5e14138e = Array.isArray;
function $e6aaa0e65613edd7$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $202b8a19e6086c64$var$TYPENAME_FIELD = {
    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $202b8a19e6086c64$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD && $202b8a19e6086c64$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $202b8a19e6086c64$var$nullIfDocIsEmpty(doc) {
    return $202b8a19e6086c64$var$isEmpty((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(doc) || (0, $818d93327cb72c29$export$772111caef41b3f5)(doc), (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $202b8a19e6086c64$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $202b8a19e6086c64$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $202b8a19e6086c64$export$e5ae0530da5fe96c(directives, doc) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(97);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $202b8a19e6086c64$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $202b8a19e6086c64$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $9d830e5028848843$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([], selections, true), [
                        $202b8a19e6086c64$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $202b8a19e6086c64$var$TYPENAME_FIELD;
    }
});
var $202b8a19e6086c64$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(98);
        }
        return willRemove;
    }
};
function $202b8a19e6086c64$export$74985f3324559867(doc) {
    return $202b8a19e6086c64$export$e5ae0530da5fe96c([
        $202b8a19e6086c64$var$connectionRemoveConfig
    ], (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc));
}
function $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($202b8a19e6086c64$var$getDirectiveMatcher(directives)) || nestedCheck && $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $202b8a19e6086c64$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $202b8a19e6086c64$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $202b8a19e6086c64$var$getArgumentMatcher(config);
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $202b8a19e6086c64$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $202b8a19e6086c64$export$57c368c23873f32b(document) {
    var definition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $202b8a19e6086c64$export$8eae69e876ee321e(document) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $202b8a19e6086c64$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $202b8a19e6086c64$export$b6125cad5877ac5e(document) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, node), {
                directives: (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([], node.directives || [], true), [
                    {
                        kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}



var $c32b8dc3cfa701c7$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $28d90d877eb1e517$export$3991762405098ea)(42, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $5a02450356081318$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $1601b71e849a21db$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $4a4ee00566e93faf$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $5fd38885ae4d12e0$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $fd4188fd4ad08084$var$isNodeResponse(value) {
    return !!value.body;
}
function $fd4188fd4ad08084$var$isReadableStream(value) {
    return !!value.getReader;
}
function $fd4188fd4ad08084$var$isAsyncIterableIterator(value) {
    return !!((0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $fd4188fd4ad08084$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $fd4188fd4ad08084$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $fd4188fd4ad08084$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $fd4188fd4ad08084$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($fd4188fd4ad08084$var$isNodeResponse(response)) body = response.body;
    if ($fd4188fd4ad08084$var$isAsyncIterableIterator(body)) return (0, $1601b71e849a21db$export$2e2bcd8739ae039)(body);
    if ($fd4188fd4ad08084$var$isReadableStream(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($fd4188fd4ad08084$var$isStreamableBlob(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($fd4188fd4ad08084$var$isBlob(body)) return (0, $4a4ee00566e93faf$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($fd4188fd4ad08084$var$isNodeReadableStream(body)) return (0, $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $844103e0eea42137$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $456cf4c370166a0f$export$4995664c1b49842e = Symbol();
function $456cf4c370166a0f$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$456cf4c370166a0f$export$4995664c1b49842e]);
    return false;
}
function $456cf4c370166a0f$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $456cf4c370166a0f$var$generateErrorMessage = function(err) {
    var errors = (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $456cf4c370166a0f$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $456cf4c370166a0f$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)((0, $a0acfd416da73b8a$export$1216008129fb82ed)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);






var $0217b27a7999d1ae$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0217b27a7999d1ae$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $0217b27a7999d1ae$export$160070228be94b08(sources);
}
function $0217b27a7999d1ae$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $0217b27a7999d1ae$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $0217b27a7999d1ae$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $0217b27a7999d1ae$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $0217b27a7999d1ae$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $3a16601e2096f4cd$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(source) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($0217b27a7999d1ae$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $4753a78f97af1d82$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $4753a78f97af1d82$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $4753a78f97af1d82$export$f90dc0a3531b8b83(value) {
    return $4753a78f97af1d82$export$879767c5cdf33cb3(value) || $4753a78f97af1d82$export$6c17a45d8c64ff02(value);
}
function $4753a78f97af1d82$export$3f32b6369f408f33(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && "payload" in value;
}
function $4753a78f97af1d82$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    if ($4753a78f97af1d82$export$879767c5cdf33cb3(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $6ba89ebc2766b493$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6ba89ebc2766b493$export$ccb60864026baf09(response, nextValue) {
    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $fd4188fd4ad08084$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $6ba89ebc2766b493$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $4753a78f97af1d82$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $456cf4c370166a0f$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6ba89ebc2766b493$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $6ba89ebc2766b493$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $6ba89ebc2766b493$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "data") && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $fc846bb2ae15ec15$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $28d90d877eb1e517$export$3991762405098ea)(40);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $876b79dde797933a$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $876b79dde797933a$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $876b79dde797933a$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $876b79dde797933a$export$45a677ea7cb6d5c8(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $876b79dde797933a$export$d3f406ff46035894(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || $876b79dde797933a$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $a51b3e37e1f6e888$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a51b3e37e1f6e888$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a51b3e37e1f6e888$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $876b79dde797933a$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $a51b3e37e1f6e888$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $876b79dde797933a$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $876b79dde797933a$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $670ab209adef6fbd$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($670ab209adef6fbd$var$escapedRegExp, $670ab209adef6fbd$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $670ab209adef6fbd$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $670ab209adef6fbd$var$escapedReplacer(str) {
    return $670ab209adef6fbd$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $670ab209adef6fbd$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(ast, $e6602c9cee6df4a2$var$printDocASTReducer);
}
const $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80;
const $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e6602c9cee6df4a2$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e6602c9cee6df4a2$var$hasMultilineItems(node.variableDefinitions) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$join(node.variableDefinitions, '\n'), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $e6602c9cee6df4a2$var$wrap('', node.description, '\n') + $e6602c9cee6df4a2$var$join([
                node.operation,
                $e6602c9cee6df4a2$var$join([
                    node.name,
                    varDefs
                ]),
                $e6602c9cee6df4a2$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + variable + ': ' + type + $e6602c9cee6df4a2$var$wrap(' = ', defaultValue) + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e6602c9cee6df4a2$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e6602c9cee6df4a2$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')');
            if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)');
            return $e6602c9cee6df4a2$var$join([
                argsLine,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e6602c9cee6df4a2$var$join([
                '...',
                $e6602c9cee6df4a2$var$wrap('on ', typeCondition),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$e6602c9cee6df4a2$var$wrap('', $e6602c9cee6df4a2$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $a51b3e37e1f6e888$export$adb6ca997eeb1f45)(value) : (0, $670ab209adef6fbd$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $e6602c9cee6df4a2$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $e6602c9cee6df4a2$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + ': ' + type + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name + ': ' + type,
                $e6602c9cee6df4a2$var$wrap('= ', defaultValue),
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + 'directive @' + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $e6602c9cee6df4a2$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$join([
                'extend schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e6602c9cee6df4a2$var$join([
                'extend scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$join([
                'extend union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$join([
                'extend enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$wrap('.', fieldName),
                $e6602c9cee6df4a2$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$e6602c9cee6df4a2$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$e6602c9cee6df4a2$var$join([
                '@',
                name,
                $e6602c9cee6df4a2$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap('{\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $722312be2835bfdf$var$printCache;
var $722312be2835bfdf$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $722312be2835bfdf$var$printCache.get(ast);
    if (!result) {
        result = (0, $e6602c9cee6df4a2$export$c2d084dc44961371)(ast);
        $722312be2835bfdf$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $722312be2835bfdf$var$printCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$722312be2835bfdf$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("print", function() {
    return $722312be2835bfdf$var$printCache ? $722312be2835bfdf$var$printCache.size : 0;
});


var $9778f37d6aa7b324$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $9778f37d6aa7b324$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $9778f37d6aa7b324$var$defaultOptions = {
    method: "POST"
};
var $9778f37d6aa7b324$export$dd86f00dc866e75d = {
    http: $9778f37d6aa7b324$var$defaultHttpOptions,
    headers: $9778f37d6aa7b324$var$defaultHeaders,
    options: $9778f37d6aa7b324$var$defaultOptions
};
var $9778f37d6aa7b324$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $9778f37d6aa7b324$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $9778f37d6aa7b324$export$12d90ccf75844275.apply(void 0, (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        operation,
        $9778f37d6aa7b324$export$e88934976ca4fd65
    ], configs, false));
}
function $9778f37d6aa7b324$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $9778f37d6aa7b324$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $722312be2835bfdf$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $9778f37d6aa7b324$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $d07bf4cf2912bc0e$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $c8ea6bc4a603e6d1$export$de246493ae27fe3f(variables, query) {
    var result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $045bb098515a5bfc$export$4fd972edbe7450d3(errorValue) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $0c8dd0eb947866f7$var$backupFetch = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $0c8dd0eb947866f7$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $9778f37d6aa7b324$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $fc846bb2ae15ec15$export$8423f0cd3773115e)(preferredFetch || $0c8dd0eb947866f7$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $5a02450356081318$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $202b8a19e6086c64$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $9778f37d6aa7b324$export$12d90ccf75844275)(operation, print, (0, $9778f37d6aa7b324$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $c8ea6bc4a603e6d1$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $818d93327cb72c29$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(41);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $d07bf4cf2912bc0e$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $0c8dd0eb947866f7$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $6ba89ebc2766b493$export$ccb60864026baf09)(response, observerNext);
                else return (0, $6ba89ebc2766b493$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $6ba89ebc2766b493$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $4c2d109245a5920b$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $0c8dd0eb947866f7$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $60c07ffd02e3617d$export$2fed3d61f740bc7f));




const { toString: $a2b6f433e732b502$var$toString, hasOwnProperty: $a2b6f433e732b502$var$hasOwnProperty } = Object.prototype;
const $a2b6f433e732b502$var$fnToStr = Function.prototype.toString;
const $a2b6f433e732b502$var$previousComparisons = new Map();
function $a2b6f433e732b502$export$411ce8e5a71e3069(a, b) {
    try {
        return $a2b6f433e732b502$var$check(a, b);
    } finally{
        $a2b6f433e732b502$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$a2b6f433e732b502$export$2e2bcd8739ae039 = $a2b6f433e732b502$export$411ce8e5a71e3069;
function $a2b6f433e732b502$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $a2b6f433e732b502$var$toString.call(a);
    const bTag = $a2b6f433e732b502$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aKeys = $a2b6f433e732b502$var$definedKeys(a);
                const bKeys = $a2b6f433e732b502$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$a2b6f433e732b502$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$a2b6f433e732b502$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$a2b6f433e732b502$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $a2b6f433e732b502$var$fnToStr.call(a);
                if (aCode !== $a2b6f433e732b502$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$a2b6f433e732b502$var$endsWith(aCode, $a2b6f433e732b502$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $a2b6f433e732b502$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($a2b6f433e732b502$var$isDefinedKey, obj);
}
function $a2b6f433e732b502$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $a2b6f433e732b502$var$nativeCodeSuffix = "{ [native code] }";
function $a2b6f433e732b502$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $a2b6f433e732b502$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $a2b6f433e732b502$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $a2b6f433e732b502$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}




function $558b9f91eb7bf726$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $de072e4be1d4d57a$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $af26a5afbde47a9e$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)
        });
    }
    if ((0, $5d0a073f980bb2a3$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $5bb23690c12ed9a4$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($5bb23690c12ed9a4$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(sources)
        ];
        if ($5bb23690c12ed9a4$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e);








function $2e04132f91cc06f1$var$identity(document) {
    return document;
}
var $2e04132f91cc06f1$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($2e04132f91cc06f1$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            this.performWork = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(Array.isArray(cacheKeys), 77);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $c506be9be1a65610$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $5333c7f04e9cca43$export$b4df399e879e53ab(result) {
    var errors = $5333c7f04e9cca43$export$a163557155188b6e(result);
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(errors);
}
function $5333c7f04e9cca43$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}








/**
 * The current status of a query’s execution in our system.
 */ var $72c5140a632c7fa1$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($72c5140a632c7fa1$export$bd096ddbd246c79c || ($72c5140a632c7fa1$export$bd096ddbd246c79c = {}));
function $72c5140a632c7fa1$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $72c5140a632c7fa1$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $e398dba65b0b4cec$var$toString = Object.prototype.toString;
function $e398dba65b0b4cec$export$629a2bd3f5a49ecc(value) {
    return $e398dba65b0b4cec$var$cloneDeepHelper(value);
}
function $e398dba65b0b4cec$var$cloneDeepHelper(val, seen) {
    switch($e398dba65b0b4cec$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e398dba65b0b4cec$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e398dba65b0b4cec$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $2f3cebf1a05c1b38$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

function $a52ba2117a948b92$export$7ff41c6e01127226(promise) {
    promise.catch(function() {});
    return promise;
}






function $3703278c0cb633ee$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aRest, bRest) && $3703278c0cb633ee$var$equalBySelectionSet((0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $3703278c0cb633ee$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $3703278c0cb633ee$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($3703278c0cb633ee$var$directiveIsNonreactive);
}
function $3703278c0cb633ee$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}



var $3118fa29bcf9f4b2$var$assign = Object.assign, $3118fa29bcf9f4b2$var$hasOwnProperty = Object.hasOwnProperty;
var $3118fa29bcf9f4b2$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = this;
        var startedInactive = ObservableQuery.inactiveOnCreation.getValue();
        _this = _super.call(this, function(observer) {
            _this._getOrCreateQuery();
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(_this.maskResult(last.result));
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.dirty = false;
        _this._getOrCreateQuery = function() {
            if (startedInactive) {
                queryManager["queries"].set(_this.queryId, queryInfo);
                startedInactive = false;
            }
            return _this.queryManager.getOrCreateQuery(_this.queryId);
        };
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        _this.maskResult = _this.maskResult.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentFullResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
        var result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            // We need to check for both both `error` and `errors` field because there
            // are cases where sometimes `error` is set, but not `errors` and
            // vice-versa. This will be updated in the next major version when
            // `errors` is deprecated in favor of `error`.
            if (result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready && (result.error || result.errors)) result.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        return this.maskResult(this.getCurrentFullResult(saveAsLastResult));
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var documentInfo = this.queryManager.getDocumentInfo(this.query);
        var dataMasking = this.queryManager.dataMasking;
        var query = dataMasking ? documentInfo.nonReactiveQuery : this.query;
        var resultIsDifferent = dataMasking || documentInfo.hasNonreactiveDirective ? !(0, $3703278c0cb633ee$export$5e40714c5ad44445)(query, this.last.result, newResult, this.variables) : !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $3118fa29bcf9f4b2$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(21, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $28d90d877eb1e517$export$f5708dca728d7177)(updateQuery, 22);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, lastResult), {
                    networkStatus: originalNetworkStatus,
                    loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(originalNetworkStatus),
                    data: data
                }), _this.variables);
            }
            return _this.maskResult(fetchMoreResult);
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) _this.reobserveCacheFirst();
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, updateOptions) {
                    return updateQuery(previous, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
                        subscriptionData: subscriptionData
                    }, updateOptions));
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(23, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }), result = _a.result, complete = _a.complete;
        var newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        var queryInfo = this._getOrCreateQuery();
        queryInfo.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](queryInfo, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(pollInterval, 24);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $72c5140a632c7fa1$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(error)) error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return (0, $a52ba2117a948b92$export$7ff41c6e01127226)(this.reobserveAsConcast(newOptions, newNetworkStatus).promise.then(this.maskResult));
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "next", this.maskResult(result));
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    ObservableQuery.prototype.maskResult = function(result) {
        return result && "data" in result ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
            data: this.queryManager.maskOperation({
                document: this.query,
                data: result.data,
                fetchPolicy: this.options.fetchPolicy,
                id: this.queryId
            })
        }) : result;
    };
    /** @internal */ ObservableQuery.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout();
        this.dirty = false;
    };
    ObservableQuery.prototype.cancelNotifyTimeout = function() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
    };
    /** @internal */ ObservableQuery.prototype.scheduleNotify = function() {
        var _this = this;
        if (this.dirty) return;
        this.dirty = true;
        if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
            return _this.notify();
        }, 0);
    };
    /** @internal */ ObservableQuery.prototype.notify = function() {
        this.cancelNotifyTimeout();
        if (this.dirty) {
            if (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !(0, $72c5140a632c7fa1$export$37509604341a3464)(this.queryInfo.networkStatus)) {
                var diff = this.queryInfo.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                this.observe();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                this.reobserveCacheFirst();
            }
        }
        this.dirty = false;
    };
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    ObservableQuery.prototype.reobserveCacheFirst = function() {
        var _a = this.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return this.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function(currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            }
        });
        return this.reobserve();
    };
    /**
     * @internal
     * A slot used by the `useQuery` hook to indicate that `client.watchQuery`
     * should not register the query immediately, but instead wait for the query to
     * be started registered with the `QueryManager` when `useSyncExternalStore`
     * actively subscribes to it.
     */ ObservableQuery.inactiveOnCreation = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
    return ObservableQuery;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($3118fa29bcf9f4b2$export$6c1b56eac59c9584);
function $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(25, error.message, error.stack);
}
function $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(26, missing);
}
function $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}







var $f8e7d4b4bf21978e$var$destructiveMethodCounts = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($f8e7d4b4bf21978e$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $f8e7d4b4bf21978e$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$f8e7d4b4bf21978e$var$destructiveMethodCounts.has(cache)) {
            $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, 0);
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "evict");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "modify");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
        if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(query.variables, this.variables)) {
            this.lastDiff = void 0;
            // Ensure we don't continue to receive cache updates for old variables
            this.cancel();
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _a, _b;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && ((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError())) return;
        this.updateLastDiff(diff);
        if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) (_b = this.observableQuery) === null || _b === void 0 || _b["scheduleNotify"]();
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        if (oq === this.observableQuery) return;
        this.observableQuery = oq;
        if (oq) oq["queryInfo"] = this;
    };
    QueryInfo.prototype.stop = function() {
        var _a;
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
            this.cancel();
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {
        var _a;
        (_a = this.cancelWatch) === null || _a === void 0 || _a.call(this);
        this.cancelWatch = void 0;
    };
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancelWatch = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(this.cache) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var _a;
        var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if ("incremental" in result && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        var _a;
        this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}







var $6e5089e13e4c0db0$export$dadc3b13206cb3ad = (0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map;
var $6e5089e13e4c0db0$export$de8324a23c9fae9a = (0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? WeakSet : Set;
var $6e5089e13e4c0db0$export$2ddf8815a8abe8b = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
var $6e5089e13e4c0db0$var$issuedWarning = false;
function $6e5089e13e4c0db0$export$f21dbf49e2bec78b() {
    if (!$6e5089e13e4c0db0$var$issuedWarning) {
        $6e5089e13e4c0db0$var$issuedWarning = true;
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(52);
    }
}






function $310a6ebe531ba02b$export$7e32b29e1cb162e1(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj) && $310a6ebe531ba02b$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $310a6ebe531ba02b$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $310a6ebe531ba02b$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $310a6ebe531ba02b$export$7e32b29e1cb162e1(obj);
    return obj;
}




function $9502062b2d53558f$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).withValue(true, function() {
        var masked = $9502062b2d53558f$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $310a6ebe531ba02b$export$7f9c177735b71f18)(masked);
        return masked;
    });
}
function $9502062b2d53558f$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    var mutableTarget = Array.isArray(data) ? [] : Object.create(null);
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $9502062b2d53558f$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    var _a;
    var knownChanged = context.knownChanged;
    var memo = $9502062b2d53558f$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for(var _i = 0, _b = Array.from(data.entries()); _i < _b.length; _i++){
            var _c = _b[_i], index = _c[0], item = _c[1];
            if (item === null) {
                memo[index] = null;
                continue;
            }
            var masked = $9502062b2d53558f$var$maskSelectionSet(item, selectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", "[").concat(index, "]") : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for(var _d = 0, _e = selectionSet.selections; _d < _e.length; _d++){
        var selection = _e[_d];
        var value = void 0;
        // we later want to add acessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD) {
            var keyName = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
            var childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                var masked = $9502062b2d53558f$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", ".").concat(keyName) : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(globalThis.__DEV__ !== false)) memo[keyName] = value;
            if (globalThis.__DEV__ !== false) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !((_a = Object.getOwnPropertyDescriptor(memo, keyName)) === null || _a === void 0 ? void 0 : _a.value)) Object.defineProperty(memo, keyName, $9502062b2d53558f$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $9502062b2d53558f$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) {
            var fragmentName = selection.name.value;
            var fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 47, fragmentName);
            var mode = (0, $89c1eec09879e1ca$export$d6913ace4214003)(selection);
            if (mode !== "mask") value = $9502062b2d53558f$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $9502062b2d53558f$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    var getValue = function() {
        if ((0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).getValue()) return value;
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(48, operationName ? "".concat(operationType, " '").concat(operationName, "'") : "anonymous ".concat(operationType), "".concat(path, ".").concat(fieldName).replace(/^\./, ""));
        getValue = function() {
            return value;
        };
        return value;
    };
    return {
        get: function() {
            return getValue();
        },
        set: function(newValue) {
            getValue = function() {
                return newValue;
            };
        },
        enumerable: true,
        configurable: true
    };
}



function $553b831e0c7e9b12$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $6e5089e13e4c0db0$export$f21dbf49e2bec78b)();
        return data;
    }
    var fragments = document.definitions.filter(function(node) {
        return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
    });
    if (typeof fragmentName === "undefined") {
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragments.length === 1, 49, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    var fragment = fragments.find(function(fragment) {
        return fragment.name.value === fragmentName;
    });
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!fragment, 50, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $a2b6f433e732b502$export$2e2bcd8739ae039)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $9502062b2d53558f$export$d4ee6fea56447c82)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $6e5089e13e4c0db0$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $6e5089e13e4c0db0$export$de8324a23c9fae9a)()
    });
}





function $c0327452fa319b31$export$74a61e4252a4a2ef(data, document, cache) {
    var _a;
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $6e5089e13e4c0db0$export$f21dbf49e2bec78b)();
        return data;
    }
    var definition = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(definition, 51);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $9502062b2d53558f$export$d4ee6fea56447c82)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: (_a = definition.name) === null || _a === void 0 ? void 0 : _a.value,
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $6e5089e13e4c0db0$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $6e5089e13e4c0db0$export$de8324a23c9fae9a)()
    });
}


var $957978b378afd274$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $957978b378afd274$var$IGNORE = Object.create(null);
var $957978b378afd274$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false);
        this.noCacheWarningsByQueryId = new Set();
        var defaultDocumentTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(27));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(mutation, 28);
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 29);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $5333c7f04e9cca43$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, storeResult), {
                                            data: self.maskOperation({
                                                document: mutation,
                                                data: storeResult.data,
                                                fetchPolicy: fetchPolicy,
                                                id: mutationId
                                            })
                                        }));
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $456cf4c370166a0f$export$26a337512320b8c6) ? err : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$957978b378afd274$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $4753a78f97af1d82$export$f90dc0a3531b8b83)(result) || (0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $957978b378afd274$var$IGNORE
        }) : optimisticResponse;
        if (data === $957978b378afd274$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(queryId), options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                nonReactiveQuery: (0, $202b8a19e6086c64$export$b6125cad5877ac5e)(document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $202b8a19e6086c64$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                defaultVars: (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this);
        var observable = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        if (!(0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)["inactiveOnCreation"].getValue()) this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query, 30);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query.kind === "Document", 31);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.returnPartialData, 32);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.pollInterval, 33);
        var query = this.transform(options.query);
        return this.fetchQuery(queryId, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            query: query
        })).then(function(result) {
            return result && (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                data: _this.maskOperation({
                    document: query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: queryId
                })
            });
        }).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(34));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNames = new Map();
        var queryNamesAndQueryStrings = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $9d830e5028848843$export$540432d49fcec6c9)(desc)) {
                var queryString = (0, $722312be2835bfdf$export$c2d084dc44961371)(_this.transform(desc));
                queryNames.set(queryString, (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has((0, $722312be2835bfdf$export$c2d084dc44961371)(document))) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                    if (document) queryNamesAndQueryStrings.set((0, $722312be2835bfdf$export$c2d084dc44961371)(document), true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getOrCreateQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach(function(included, nameOrQueryString) {
            if (!included) {
                var queryName = queryNames.get(nameOrQueryString);
                if (queryName) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(35, queryName);
                else globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(36);
            }
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            (_this.queries.get(queryId) || observableQuery["queryInfo"]).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startGraphQLSubscription = function(options) {
        var _this = this;
        var query = options.query, variables = options.variables;
        var fetchPolicy = options.fetchPolicy, _a = options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a, _b = options.context, context = _b === void 0 ? {} : _b, _c = options.extensions, extensions = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $456cf4c370166a0f$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $456cf4c370166a0f$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        var _a;
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            (_a = this.queries.get(queryId)) === null || _a === void 0 || _a.stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            var _a;
            return (_a = info.observableQuery) === null || _a === void 0 ? void 0 : _a["notify"]();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $722312be2835bfdf$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast_1 = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                        (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast_1;
                    concast_1.beforeNext(function cb(method, arg) {
                        if (method === "next" && "hasNext" in arg && arg.hasNext) concast_1.beforeNext(cb);
                        else inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $5333c7f04e9cca43$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryInfo, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryInfo.queryId);
        };
        this.fetchCancelFns.set(queryInfo.queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: (_this.queries.get(queryId) || oq["queryInfo"]).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) diff = _this.cache.diff(oq["queryInfo"]["getDiffOptions"]());
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.maskOperation = function(options) {
        var _a, _b, _c;
        var document = options.document, data = options.data;
        if (globalThis.__DEV__ !== false) {
            var fetchPolicy = options.fetchPolicy, id = options.id;
            var operationType = (_a = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document)) === null || _a === void 0 ? void 0 : _a.operation;
            var operationId = ((_b = operationType === null || operationType === void 0 ? void 0 : operationType[0]) !== null && _b !== void 0 ? _b : "o") + id;
            if (this.dataMasking && fetchPolicy === "no-cache" && !(0, $7f688c9754699513$export$5b84f3d7865d4e49)(document) && !this.noCacheWarningsByQueryId.has(operationId)) {
                this.noCacheWarningsByQueryId.add(operationId);
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(37, (_c = (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(document)) !== null && _c !== void 0 ? _c : "Unnamed ".concat(operationType !== null && operationType !== void 0 ? operationType : "operation"));
            }
        }
        return this.dataMasking ? (0, $c0327452fa319b31$export$74a61e4252a4a2ef)(data, document, this.cache) : data;
    };
    QueryManager.prototype.maskFragment = function(options) {
        var data = options.data, fragment = options.fragment, fragmentName = options.fragmentName;
        return this.dataMasking ? (0, $553b831e0c7e9b12$export$adbebb59d1aeea97)(data, fragment, this.cache, fragmentName) : data;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(data, {})) (0, $3118fa29bcf9f4b2$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getOrCreateQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $6320ab015e2889cc$export$e7ecd7c16613ccfd(node) {
    return $6320ab015e2889cc$export$4cedd8740794bd78(node) || $6320ab015e2889cc$export$b05c7141ec7770ba(node) || $6320ab015e2889cc$export$fbc18e88163d676d(node);
}
function $6320ab015e2889cc$export$4cedd8740794bd78(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $6320ab015e2889cc$export$65772b71e1d017ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT;
}
function $6320ab015e2889cc$export$f95bfad9e6aea45f(node) {
    return $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST ? node.values.some($6320ab015e2889cc$export$f95bfad9e6aea45f) : node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$6320ab015e2889cc$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE);
}
function $6320ab015e2889cc$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $6320ab015e2889cc$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION || $6320ab015e2889cc$export$a3584bba04f5bfe0(node) || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $6320ab015e2889cc$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6320ab015e2889cc$export$fbc18e88163d676d(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION || $6320ab015e2889cc$export$d7907721b241e11f(node);
}
function $6320ab015e2889cc$export$d7907721b241e11f(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}
function $6320ab015e2889cc$export$9c93c002c59dc2d6(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).TYPE_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).MEMBER_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_COORDINATE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE;
}




var $99c0c2fd8aedf706$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $202b8a19e6086c64$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $202b8a19e6086c64$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
                fragments = (0, $818d93327cb72c29$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $9d830e5028848843$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $9d830e5028848843$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 19, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $0217b27a7999d1ae$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $a0acfd416da73b8a$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $a0acfd416da73b8a$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $78b48476e314521e$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 20, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();




function $1a9f9b47c9ebef70$export$235b7fc70b9fc359(defaults, options) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}



var $9cf0de8518e6cdc4$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $28d90d877eb1e517$export$3991762405098ea)(16);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _b = options.ssrMode, ssrMode = _b === void 0 ? false : _b, _c = options.ssrForceFetchDelay, ssrForceFetchDelay = _c === void 0 ? 0 : _c, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools, dataMasking = options.dataMasking;
        var link = options.link;
        if (!link) link = uri ? new (0, $4c2d109245a5920b$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492);
        this.localState = new (0, $99c0c2fd8aedf706$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $957978b378afd274$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$9cf0de8518e6cdc4$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $9cf0de8518e6cdc4$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 17);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        var _this = this;
        var id = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(options).map(function(result) {
            return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
                data: _this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: id
                })
            });
        });
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        var _a;
        return this.cache.watchFragment((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), (_a = {}, _a[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, _a)));
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $88c17748fb93d3ed$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(18, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$dfdba94ce46d2ea5);







// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $14505e8b7f660318$var$contextKey = (0, $5d0a073f980bb2a3$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $14505e8b7f660318$export$a47505d961ee3a1() {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)("createContext" in $69607e38bd2400f2$exports, 54);
    var context = $69607e38bd2400f2$exports.createContext[$14505e8b7f660318$var$contextKey];
    if (!context) {
        Object.defineProperty($69607e38bd2400f2$exports.createContext, $14505e8b7f660318$var$contextKey, {
            value: context = $69607e38bd2400f2$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $14505e8b7f660318$export$c2ee824bcc89ca6a = $14505e8b7f660318$export$a47505d961ee3a1;


var $93ef3346b14b7851$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $14505e8b7f660318$export$a47505d961ee3a1)();
    var parentContext = $69607e38bd2400f2$exports.useContext(ApolloContext);
    var context = $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(context.client, 55);
    return $69607e38bd2400f2$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};














var $3b55b3aff583fbaf$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)((0, $7f688c9754699513$export$abbf37c7cf644e41), {
            max: (0, $c506be9be1a65610$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
        });
    }
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    ApolloCache.prototype.lookupFragment = function(fragmentName) {
        return null;
    };
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        var id = typeof from === "undefined" || typeof from === "string" ? from : this.identify(from);
        var dataMasking = !!options[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== false) {
            var actualFragmentName = fragmentName || (0, $818d93327cb72c29$export$772111caef41b3f5)(fragment).name.value;
            if (!id) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(1, actualFragmentName);
        }
        var diffOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, otherOptions), {
            returnPartialData: true,
            id: id,
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            return _this.watch((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    var data = dataMasking ? (0, $553b831e0c7e9b12$export$adbebb59d1aeea97)(diff.result, fragment, _this, fragmentName) : diff.result;
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $3703278c0cb633ee$export$5e40714c5ad44445)(query, {
                        data: latestDiff.result
                    }, {
                        data: data
                    }, // TODO: Fix the type on WatchFragmentOptions so that TVars
                    // extends OperationVariables
                    options.variables)) return;
                    var result = {
                        data: data,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $0217b27a7999d1ae$export$160070228be94b08)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, diff), {
                        result: data
                    });
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $3b55b3aff583fbaf$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e7ed438e82606689);



var $5b6ca74647771eb2$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);















var $3f1d3403edb822de$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $3f1d3403edb822de$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $3f1d3403edb822de$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$3f1d3403edb822de$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$3f1d3403edb822de$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($3f1d3403edb822de$export$b931b78cbb3caf86(id) && !$3f1d3403edb822de$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$3f1d3403edb822de$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $3f1d3403edb822de$var$defaultConfig = {
    dataIdFromObject: $3f1d3403edb822de$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $3f1d3403edb822de$export$fa542f9ee3f7f4e2(config) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)($3f1d3403edb822de$var$defaultConfig, config);
}
function $3f1d3403edb822de$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $3f1d3403edb822de$var$defaultConfig.canonizeResults : value;
}
function $3f1d3403edb822de$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $3f1d3403edb822de$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $3f1d3403edb822de$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($3f1d3403edb822de$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(result)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && (0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            return $3f1d3403edb822de$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $3f1d3403edb822de$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $3f1d3403edb822de$export$4f39afca21bd938e(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(value) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value);
}
function $3f1d3403edb822de$export$b874a818f7a2fa6d() {
    return new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
}
function $3f1d3403edb822de$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $0268d457c22a2684$var$DELETE = Object.create(null);
var $0268d457c22a2684$var$delModifier = function() {
    return $0268d457c22a2684$var$DELETE;
};
var $0268d457c22a2684$var$INVALIDATE = Object.create(null);
var $0268d457c22a2684$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $310a6ebe531ba02b$export$7f9c177735b71f18)((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $9d830e5028848843$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $9d830e5028848843$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(typeof dataId === "string", 2);
        var merged = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)($0268d457c22a2684$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $0268d457c22a2684$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $0268d457c22a2684$var$DELETE,
                INVALIDATE: $0268d457c22a2684$var$INVALIDATE,
                isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $0268d457c22a2684$var$delModifier ? $0268d457c22a2684$var$DELETE : modify((0, $310a6ebe531ba02b$export$7f9c177735b71f18)(fieldValue), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $0268d457c22a2684$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $0268d457c22a2684$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(3, ref);
                                        return true;
                                    }
                                };
                                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(4, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $0268d457c22a2684$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $0268d457c22a2684$var$delModifier, _a) : $0268d457c22a2684$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $0268d457c22a2684$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $0268d457c22a2684$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $0268d457c22a2684$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $0268d457c22a2684$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($0268d457c22a2684$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $0268d457c22a2684$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $0268d457c22a2684$export$f8068a30967ddc18(store, entityId) {
    if ($0268d457c22a2684$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $0268d457c22a2684$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $0268d457c22a2684$var$Stump(_this);
            _this.storageTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($0268d457c22a2684$export$cb507f57054c7321 || ($0268d457c22a2684$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $0268d457c22a2684$var$Layer = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($0268d457c22a2684$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $0268d457c22a2684$var$Stump = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $0268d457c22a2684$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($0268d457c22a2684$var$Layer);
function $0268d457c22a2684$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $0268d457c22a2684$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $0268d457c22a2684$export$cb507f57054c7321 && store.group.caching);
}








function $4a344505b0ae796e$var$shallowCopy(value) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $4a344505b0ae796e$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var copy = $4a344505b0ae796e$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $145a33e3a7865af6$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $145a33e3a7865af6$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $145a33e3a7865af6$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $145a33e3a7865af6$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $9d830e5028848843$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $5b6ca74647771eb2$export$257c68286583b0f9)($145a33e3a7865af6$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $202b8a19e6086c64$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(10, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $0217b27a7999d1ae$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $310a6ebe531ba02b$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $145a33e3a7865af6$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $145a33e3a7865af6$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $145a33e3a7865af6$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
                (0, $28d90d877eb1e517$export$f5708dca728d7177)(!(0, $9d830e5028848843$export$fa99cac1c0883c47)(value), 11, (0, $3f1d3403edb822de$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $113f43d0843b9450$var$specifierInfoCache = Object.create(null);
function $113f43d0843b9450$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $113f43d0843b9450$var$specifierInfoCache[cacheKey] || ($113f43d0843b9450$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $113f43d0843b9450$export$f1953a0407594d2c(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $113f43d0843b9450$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $113f43d0843b9450$export$e8f64f7a025887d3(object, schemaKeyPath, $113f43d0843b9450$var$extractKey);
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(extracted !== void 0, 5, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $113f43d0843b9450$export$550737ee0cc371ac(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $113f43d0843b9450$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $113f43d0843b9450$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $113f43d0843b9450$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $113f43d0843b9450$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    return $113f43d0843b9450$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $113f43d0843b9450$export$eca459f173e85801(spec) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(s)) {
                $113f43d0843b9450$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $113f43d0843b9450$var$extractKey(object, key) {
    return object[key];
}
function $113f43d0843b9450$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $113f43d0843b9450$var$extractKey;
    return $113f43d0843b9450$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $113f43d0843b9450$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map($113f43d0843b9450$var$normalize);
        return $113f43d0843b9450$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $113f43d0843b9450$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}



function $8557ced3c8197c32$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $8557ced3c8197c32$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $8557ced3c8197c32$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $8557ced3c8197c32$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $8557ced3c8197c32$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $8557ced3c8197c32$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $3f1d3403edb822de$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $6e5089e13e4c0db0$export$2ddf8815a8abe8b).withValue(true, function() {
            while(keyFn){
                var specifierOrId = keyFn((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, object), storeObject), context);
                if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $113f43d0843b9450$export$f1953a0407594d2c)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $8557ced3c8197c32$var$mergeTrueFn : merge === false ? $8557ced3c8197c32$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $8557ced3c8197c32$var$nullKeyFieldsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyFields) ? (0, $113f43d0843b9450$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $8557ced3c8197c32$var$simpleKeyArgsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyArgs) ? (0, $113f43d0843b9450$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $8557ced3c8197c32$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(!old || old === which, 6, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $3f1d3403edb822de$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(7, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $3f1d3403edb822de$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $113f43d0843b9450$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $9d830e5028848843$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $9d830e5028848843$export$3cdb6c178b88cabe)(fieldName, $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $8557ced3c8197c32$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $8557ced3c8197c32$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $8557ced3c8197c32$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $8557ced3c8197c32$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $8557ced3c8197c32$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)
    };
}
function $8557ced3c8197c32$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(8, (0, $29a424226342d3ac$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $8557ced3c8197c32$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) || (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(9);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(existing) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $e28f51741d388e97$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(query);
        var merger = (0, $3f1d3403edb822de$export$b874a818f7a2fa6d)();
        variables = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables)
        }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $9d830e5028848843$export$fa99cac1c0883c47)(ref)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(12, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $e28f51741d388e97$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $8557ced3c8197c32$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $e28f51741d388e97$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $e28f51741d388e97$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $9d830e5028848843$export$fa99cac1c0883c47)(incomingValue) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $202b8a19e6086c64$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(13, (0, $9d830e5028848843$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $e28f51741d388e97$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $e28f51741d388e97$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $e28f51741d388e97$var$getChildMergeTree(mergeTree, i));
            $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(14, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $9d830e5028848843$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $28d90d877eb1e517$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $e28f51741d388e97$var$emptyMergeTreePool = [];
function $e28f51741d388e97$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $e28f51741d388e97$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $e28f51741d388e97$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $e28f51741d388e97$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $e28f51741d388e97$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $e28f51741d388e97$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $e28f51741d388e97$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $e28f51741d388e97$var$mergeTreeIsEmpty(childTree)) {
        $e28f51741d388e97$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $e28f51741d388e97$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $e28f51741d388e97$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($e28f51741d388e97$var$warnings.has(typeDotName)) return;
    $e28f51741d388e97$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(15, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, existing), (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, incoming));
}







var $49c8996098641f51$export$467265324939f47f = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)((0, $202b8a19e6086c64$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $0b37964519c908de$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $3f1d3403edb822de$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $8557ced3c8197c32$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $0268d457c22a2684$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $e28f51741d388e97$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $145a33e3a7865af6$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $5b6ca74647771eb2$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $0b37964519c908de$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $0b37964519c908de$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        (0, $722312be2835bfdf$export$c2d084dc44961371).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $0b37964519c908de$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.fragmentMatches = function(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    };
    InMemoryCache.prototype.lookupFragment = function(fragmentName) {
        var _a;
        return ((_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.lookup(fragmentName)) || null;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $3b55b3aff583fbaf$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $49c8996098641f51$export$467265324939f47f.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e95a5a2210e62466);





function $2fbc3945f137d753$export$2f04de43fe27971a(setter) {
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)(function(operation, forward) {
        var request = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(operation, []);
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}






function $e1a11cec7a0d88c4$export$2288787135a8f66e(errorHandler) {
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) retriedResult = errorHandler({
                            graphQLErrors: result.errors,
                            response: result,
                            operation: operation,
                            forward: forward
                        });
                        else if ((0, $456cf4c370166a0f$export$345f95cc6b6b9b0b)(result)) retriedResult = errorHandler({
                            protocolErrors: result.extensions[0, $456cf4c370166a0f$export$4995664c1b49842e],
                            response: result,
                            operation: operation,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError && networkError.result && networkError.result.errors || void 0,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $e1a11cec7a0d88c4$export$d2c8415987899609 = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $e1a11cec7a0d88c4$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $60c07ffd02e3617d$export$2fed3d61f740bc7f));




var $acw62 = parcelRequire("acw62");





const $1928e593f4b3d7a8$var$promiseToObservable = (promise)=>new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)((subscriber)=>{
        promise.then((value)=>{
            if (subscriber.closed) return;
            subscriber.next(value);
            subscriber.complete();
        }, (err)=>subscriber.error(err));
    });
var $1928e593f4b3d7a8$export$2e2bcd8739ae039 = $1928e593f4b3d7a8$var$promiseToObservable;


const $953d60e84fc6ba8d$var$StateProvider = ({ fetchPolicy: fetchPolicy, typePolicies: typePolicies, children: children })=>{
    const [hasNetworkError, setHasNetworkError] = $acw62.useState(false);
    const [hasNotFoundError, setHasNotFoundError] = $acw62.useState(false);
    const [hasAuthError, setHasAuthError] = $acw62.useState(false);
    const { inProgress: inProgress } = (0, $5ae49243d6498b42$export$f41558044a1dd55)();
    const language = (0, $61d5299c8c0ea66c$export$68274e25c3f28c82)();
    const authLink = (0, $2fbc3945f137d753$export$2f04de43fe27971a)(async ()=>{
        if ((0, $bc59a856a5e4c3e2$export$ca25862a9e6ee63c)()) // authToken is only set for e2e tests (Basic auth)
        // Otherwise get the id token from the authProvider
        return {
            headers: {
                authorization: (0, $944e98c5c54289c1$export$4be65e66cfa2648a)((0, $bc59a856a5e4c3e2$export$ffd06224fc106bf3)),
                language: language
            }
        };
        const token = await (0, $bc59a856a5e4c3e2$export$257b2d10b709d8ef)(inProgress, false);
        return {
            headers: {
                ...(0, $bc59a856a5e4c3e2$export$497311c211e584c0)(token ? token.idToken : "").headers,
                language: language
            }
        };
    });
    const authErrorLink = (0, $e1a11cec7a0d88c4$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors, operation: operation, forward: forward })=>{
        const has401 = graphQLErrors?.some(({ extensions: extensions })=>{
            return extensions?.errorCode === 401;
        });
        if (has401) // @ts-ignore
        return (0, $1928e593f4b3d7a8$export$2e2bcd8739ae039)((0, $bc59a856a5e4c3e2$export$257b2d10b709d8ef)(undefined, true)).flatMap((token)=>{
            operation.setContext({
                headers: {
                    // @ts-ignore
                    ...(0, $bc59a856a5e4c3e2$export$497311c211e584c0)(token.idToken).headers,
                    language: language
                },
                isRetry: true
            });
            return forward(operation);
        });
    });
    const errorLink = (0, $e1a11cec7a0d88c4$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors, networkError: networkError })=>{
        if (graphQLErrors) graphQLErrors.forEach(async ({ message: message, locations: locations, path: path, extensions: extensions })=>{
            if (extensions?.errorCode === 404) setHasNotFoundError(true);
            if (extensions?.errorCode === 401) setHasAuthError(true);
            if (extensions?.errorCode === 403) setHasAuthError(true);
            console.warn(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        });
        if (networkError) {
            console.warn(`[Network error]: ${networkError}`);
            setHasNetworkError(true);
        }
    });
    const httpLink = new (0, $4c2d109245a5920b$export$f4bbf1aec241cc1)({
        uri: "/graphql",
        credentials: "same-origin"
    });
    const client = new (0, $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88)({
        link: (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).from([
            authLink,
            authErrorLink,
            errorLink,
            httpLink
        ]),
        cache: new (0, $49c8996098641f51$export$467265324939f47f)({
            typePolicies: {
                ...typePolicies
            }
        }),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: fetchPolicy
            }
        }
    });
    if (hasNetworkError) throw new Error((0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e500);
    if (hasNotFoundError) throw new Error((0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e404);
    if (hasAuthError) throw new Error((0, $4d4f04faa0dd2ff5$export$6586c12bbf6d0c20).e403);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93ef3346b14b7851$export$c16b04c8a9956446), {
        client: client,
        children: children
    });
};
var $953d60e84fc6ba8d$export$2e2bcd8739ae039 = $953d60e84fc6ba8d$var$StateProvider;





var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 


var $acw62 = parcelRequire("acw62");



function $a9cfbe53a9cbd404$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $a9cfbe53a9cbd404$var$IntlProvider = /** @class */ function(_super) {
    (0, $a0acfd416da73b8a$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $864ced6e9596b36d$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $799bd4e991c1f0e6$export$7e4cbedfdd7b4c0d)($a9cfbe53a9cbd404$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $a9cfbe53a9cbd404$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $a9cfbe53a9cbd404$var$processIntlConfig(props);
        if (!(0, $2911c18a2024d56a$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $799bd4e991c1f0e6$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $2911c18a2024d56a$export$45c4bbf6e55bba1f)(this.state.intl);
        return $acw62.createElement((0, $e0f39ec61dff1544$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $2911c18a2024d56a$export$b52f8d6fc0d47415);
    return IntlProvider;
}($acw62.PureComponent);
var $a9cfbe53a9cbd404$export$2e2bcd8739ae039 = $a9cfbe53a9cbd404$var$IntlProvider;






const $6d6d27de55d618ae$export$d7814c438e2e70a2 = "lang";
const $6d6d27de55d618ae$export$70c064fcbd73031c = (param)=>{
    return (0, $eff69fb1886d6e36$export$54fe0cd6fd82862e).find((lang)=>lang.locale === param);
};
const $6d6d27de55d618ae$export$5246e63a9ae7fe34 = ()=>{
    const browserLocale = (0, $eff69fb1886d6e36$export$54fe0cd6fd82862e).find((lang)=>lang.bcp47Locale === navigator.language);
    if (browserLocale) return browserLocale;
    return (0, $eff69fb1886d6e36$export$54fe0cd6fd82862e).find((lang)=>lang.bcp47Locale === navigator.language.split("-")[0]);
};
const $6d6d27de55d618ae$var$useCurrentLocale = ()=>{
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const setLocale = (lang)=>{
        setSearchParams(`${$6d6d27de55d618ae$export$d7814c438e2e70a2}=${lang.locale}`);
    };
    const localeFromSearchParam = $6d6d27de55d618ae$export$70c064fcbd73031c(searchParams.get($6d6d27de55d618ae$export$d7814c438e2e70a2));
    const localeFromBrowser = $6d6d27de55d618ae$export$5246e63a9ae7fe34();
    if (localeFromSearchParam) return [
        localeFromSearchParam,
        setLocale
    ];
    if (localeFromBrowser) {
        setLocale(localeFromBrowser);
        return [
            localeFromBrowser,
            setLocale
        ];
    }
    setLocale((0, $eff69fb1886d6e36$export$10e0e2046491126b));
    return [
        (0, $eff69fb1886d6e36$export$10e0e2046491126b),
        setLocale
    ];
};
var $6d6d27de55d618ae$export$2e2bcd8739ae039 = $6d6d27de55d618ae$var$useCurrentLocale;






























































var $8e61e31d20dfb092$export$2e2bcd8739ae039 = async (locale, isUsedInternal)=>{
    if (isUsedInternal) switch(locale){
        case "de":
            return (parcelRequire("lDMx5"));
        case "en":
            return (parcelRequire("aomWg"));
        case "es":
            return (parcelRequire("hMDjA"));
        case "fr":
            return (parcelRequire("2Hiyr"));
        case "hr":
            return (parcelRequire("4iiq5"));
        case "it":
            return (parcelRequire("bfr93"));
        case "lv_LV":
            return (parcelRequire("g38qb"));
        case "pl":
            return (parcelRequire("gIRbv"));
        case "pt_BR":
            return (parcelRequire("bvWpg"));
        case "pt":
            return (parcelRequire("lXJRU"));
        case "tr":
            return (parcelRequire("lKvWu"));
        case "uk":
            return (parcelRequire("7lvqF"));
        default:
            return (parcelRequire("aomWg"));
    }
    else switch(locale){
        case "at":
            return (parcelRequire("gwS4i"));
        case "bg":
            return (parcelRequire("l4Foc"));
        case "bs":
            return (parcelRequire("2mtiv"));
        case "ca":
            return (parcelRequire("dxDer"));
        case "cs":
            return (parcelRequire("aKMJr"));
        case "da":
            return (parcelRequire("sK9Fu"));
        case "de":
            return (parcelRequire("4tx5w"));
        case "de_CH":
            return (parcelRequire("jEOdQ"));
        case "el":
            return (parcelRequire("3zvpK"));
        case "en_CA":
            return (parcelRequire("1hXIw"));
        case "en_GB":
            return (parcelRequire("893KM"));
        case "en_US":
            return (parcelRequire("7Rq0e"));
        case "en_IE":
            return (parcelRequire("7RStm"));
        case "en_IN":
            return (parcelRequire("eA3Fe"));
        case "es":
            return (parcelRequire("1UWDV"));
        case "es_CL":
            return (parcelRequire("av2rP"));
        case "es_MX":
            return (parcelRequire("gaHbE"));
        case "es_US":
            return (parcelRequire("7x782"));
        case "et_EE":
            return (parcelRequire("iF2Nm"));
        case "fi":
            return (parcelRequire("1HAk0"));
        case "fr":
            return (parcelRequire("6yVp9"));
        case "fr_BE":
            return (parcelRequire("aKKkr"));
        case "fr_CA":
            return (parcelRequire("34nyo"));
        case "fr_CH":
            return (parcelRequire("8qava"));
        case "hr":
            return (parcelRequire("g7KJJ"));
        case "hu":
            return (parcelRequire("1kPzM"));
        case "it":
            return (parcelRequire("jBSim"));
        case "it_CH":
            return (parcelRequire("6UkSI"));
        case "lt_LT":
            return (parcelRequire("bOBxi"));
        case "lv_LV":
            return (parcelRequire("VRwTE"));
        case "mk":
            return (parcelRequire("iZpJl"));
        case "nl":
            return (parcelRequire("7Il5I"));
        case "nl_BE":
            return (parcelRequire("6CCah"));
        case "no":
            return (parcelRequire("jmbqU"));
        case "pl":
            return (parcelRequire("8jsDo"));
        case "pt":
            return (parcelRequire("cZAQu"));
        case "pt_BR":
            return (parcelRequire("4jEze"));
        case "ro":
            return (parcelRequire("38E8E"));
        case "sk":
            return (parcelRequire("2BUQH"));
        case "sl":
            return (parcelRequire("36jau"));
        case "sq":
            return (parcelRequire("ebdry"));
        case "sr_Latn_RS":
            return (parcelRequire("hP22W"));
        case "sv":
            return (parcelRequire("ckH97"));
        case "tr":
            return (parcelRequire("j8CYa"));
        case "uk":
            return (parcelRequire("aMtwO"));
        case "zh_US":
            return (parcelRequire("3DOwE"));
        default:
            return (parcelRequire("dTBj8"));
    }
};


const $bf22335153625c86$var$TranslationProvider = ({ usesCookies: usesCookies, isUsedInternal: isUsedInternal, children: children })=>{
    const [messages, setMessages] = $acw62.useState({});
    let locale;
    if (usesCookies) {
        const lang = (0, $61d5299c8c0ea66c$export$68274e25c3f28c82)();
        locale = (0, $eff69fb1886d6e36$export$e24640604b11ca0)(lang, false);
    } else // eslint-disable-next-line react-hooks/rules-of-hooks
    [locale] = (0, $6d6d27de55d618ae$export$2e2bcd8739ae039)();
    const setTranslations = async ()=>{
        setMessages(await (0, $8e61e31d20dfb092$export$2e2bcd8739ae039)(locale.locale, isUsedInternal));
    };
    $acw62.useEffect(()=>{
        setTranslations();
    }, [
        locale
    ]);
    if (Object.keys(messages).length) {
        // We need to expose the messages to the window object to be able to use them in the
        // formatMessage function outside of React components
        window.messages = messages;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9cfbe53a9cbd404$export$2e2bcd8739ae039), {
            locale: locale.bcp47Locale,
            defaultLocale: (0, $eff69fb1886d6e36$export$10e0e2046491126b).locale,
            messages: messages || {},
            children: children
        }, locale.bcp47Locale);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};
var $bf22335153625c86$export$2e2bcd8739ae039 = $bf22335153625c86$var$TranslationProvider;






var $acw62 = parcelRequire("acw62");

var $5f66f0db6cf3ea69$export$2e2bcd8739ae039 = {
    raw: ".hcr-tooltip-16-4-0{--hcr-balloon-width:15.75rem;--hcr-balloon-height:44px;--hcr-balloon-background:var(--hcr-box-bg-color);--hcr-balloon-color:var(--hcr-content-primary-color);--hcr-balloon-close-color:var(--hcr-icon-primary-color);--hcr-balloon-content-margin:0;--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) var(--hcr-spacing-2);color:var(--hcr-balloon-color);font-family:inherit;font-size:var(--hcr-font-size-primary);justify-content:space-between;min-height:var(--hcr-balloon-height);min-width:var(--hcr-balloon-width);position:relative;text-decoration:none;width:-moz-fit-content;width:fit-content}.hcr-tooltip--active-16-4-0:not([hidden]){display:flex}.hcr-tooltip-16-4-0:before{background:var(--hcr-balloon-background);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);content:\"\";left:0;position:absolute;z-index:-1}.hcr-tooltip__content-16-4-0{flex:auto;margin:var(--hcr-balloon-content-margin);position:relative;text-align:left;z-index:1}.hcr-tooltip__close-16-4-0{align-self:flex-start;margin:var(--hcr-balloon-close-margin);position:relative;z-index:1}.hcr-tooltip__close-16-4-0:before{background-color:var(--hcr-balloon-close-color);content:\"\";height:var(--hcr-spacing-3);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-3)}.hcr-tooltip--danger-16-4-0{--hcr-balloon-background:var(--hcr-danger-color);--hcr-balloon-color:var(--hcr-grayscale-0-color);--hcr-balloon-close-color:var(--hcr-grayscale-0-color)}.hcr-tooltip--content-fit-16-4-0{--hcr-balloon-width:auto;--hcr-balloon-height:auto;--hcr-balloon-content-margin:calc(-1 * var(--hcr-spacing-1));--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-2)) calc(-1 * var(--hcr-spacing-2)) calc(-1 * var(--hcr-spacing-2)) var(--hcr-spacing-2);white-space:nowrap}.hcr-tooltip--medium-16-4-0{--hcr-balloon-width:23.25rem}.hcr-tooltip--large-16-4-0{--hcr-balloon-width:30.75rem}.hcr-tooltip-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-tooltip-16-4-0:before{bottom:0;left:var(--hcr-spacing-2);right:0;top:0}.hcr-tooltip--left-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-tooltip--left-16-4-0:before{bottom:0;left:0;right:var(--hcr-spacing-2);top:0}.hcr-tooltip--top-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-tooltip--top-16-4-0:before{bottom:var(--hcr-spacing-2);left:0;right:0;top:0}.hcr-tooltip--bottom-16-4-0{padding:var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-tooltip--bottom-16-4-0:before{bottom:0;left:0;right:0;top:var(--hcr-spacing-2)}.hcr-tooltip-16-4-0:after{border-left:0;border-right:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);content:\"\";height:0;inset:auto auto auto var(--hcr-spacing-1);position:absolute;width:0;z-index:0}.hcr-tooltip--left-16-4-0:after,.hcr-tooltip-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-top:calc(var(--hcr-spacing-1) + 2px) solid #0000}.hcr-tooltip--left-16-4-0:after{border-left:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-right:0;inset:auto var(--hcr-spacing-1) auto auto}.hcr-tooltip-16-4-0:after{top:50%;transform:translateY(-50%)}.hcr-tooltip--start-16-4-0:after{top:min(25%,var(--hcr-spacing-3));transform:none}.hcr-tooltip--end-16-4-0:after{bottom:min(25%,var(--hcr-spacing-3));top:auto;transform:none}.hcr-tooltip--bottom-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-top:0;inset:var(--hcr-spacing-1) auto auto}.hcr-tooltip--bottom-16-4-0:after,.hcr-tooltip--top-16-4-0:after{border-left:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-right:calc(var(--hcr-spacing-1) + 2px) solid #0000}.hcr-tooltip--top-16-4-0:after{border-bottom:0;border-top:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);inset:auto auto var(--hcr-spacing-1)}.hcr-tooltip--bottom-16-4-0:after,.hcr-tooltip--top-16-4-0:after{left:50%;right:auto;transform:translateX(-50%)}.hcr-tooltip--bottom-16-4-0.hcr-tooltip--start-16-4-0:after,.hcr-tooltip--top-16-4-0.hcr-tooltip--start-16-4-0:after{left:min(25%,var(--hcr-spacing-3));transform:none}.hcr-tooltip--bottom-16-4-0.hcr-tooltip--end-16-4-0:after,.hcr-tooltip--top-16-4-0.hcr-tooltip--end-16-4-0:after{left:auto;right:min(25%,var(--hcr-spacing-3));transform:none}@supports (anchor-name:var(--hcr-tooltip-anchor )){[data-tooltip-fixed]{anchor-name:var(--hcr-tooltip-anchor)}}.hcr-tooltip-16-4-0{bottom:auto;display:none;left:100%;opacity:0;position:absolute;top:50%;transform:translateY(-50%);transition:opacity .25s ease;z-index:10}.hcr-tooltip--active-16-4-0:not([hidden]){opacity:1}.hcr-tooltip--fixed-16-4-0{inset:auto;position:fixed}.hcr-tooltip--fixed-16-4-0.hcr-tooltip--bottom-16-4-0,.hcr-tooltip--fixed-16-4-0.hcr-tooltip--left-16-4-0,.hcr-tooltip--fixed-16-4-0.hcr-tooltip--top-16-4-0{inset:auto}@supports (position-anchor:var(--hcr-tooltip-anchor )){.hcr-tooltip--fixed-16-4-0{position-anchor:var(--hcr-tooltip-anchor);left:anchor(right);top:anchor(center)}.hcr-tooltip--fixed-16-4-0.hcr-tooltip--top-16-4-0{bottom:anchor(top);left:anchor(center)}.hcr-tooltip--fixed-16-4-0.hcr-tooltip--bottom-16-4-0{left:anchor(center);top:anchor(bottom)}.hcr-tooltip--fixed-16-4-0.hcr-tooltip--left-16-4-0{right:anchor(left);top:anchor(center)}}.hcr-tooltip--start-16-4-0{transform:translateY(calc(-1*(calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip--end-16-4-0{transform:translateY(calc(-100% + calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3)))}.hcr-tooltip--left-16-4-0{bottom:auto;left:auto;right:100%;top:50%;transform:translateY(-50%)}.hcr-tooltip--left-16-4-0.hcr-tooltip--start-16-4-0{transform:translateY(calc(-1*(calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip--left-16-4-0.hcr-tooltip--end-16-4-0{transform:translateY(calc(-100% + calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3)))}.hcr-tooltip--top-16-4-0{bottom:100%;left:50%;top:auto;transform:translateX(-50%)}.hcr-tooltip--top-16-4-0.hcr-tooltip--start-16-4-0{transform:translateX(calc(-1*min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip--top-16-4-0.hcr-tooltip--end-16-4-0{transform:translateX(calc(-100% + min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip--bottom-16-4-0{bottom:auto;left:50%;top:100%;transform:translateX(-50%)}.hcr-tooltip--bottom-16-4-0.hcr-tooltip--start-16-4-0{transform:translateX(calc(-1*min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip--bottom-16-4-0.hcr-tooltip--end-16-4-0{transform:translateX(calc(-100% + min(50%,calc(var(--hcr-spacing-1) + 2px) + var(--hcr-spacing-3))))}.hcr-tooltip-target-16-4-0{position:relative}.hcr-tooltip-target--inline-16-4-0{display:inline-block}.hcr-tooltip-target__button-16-4-0{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);padding:0;text-align:inherit}",
    map: {
        "hcr-tooltip": "hcr-tooltip-16-4-0",
        "hcr-tooltip--active": "hcr-tooltip--active-16-4-0",
        "hcr-tooltip__content": "hcr-tooltip__content-16-4-0",
        "hcr-tooltip__close": "hcr-tooltip__close-16-4-0",
        "hcr-tooltip--danger": "hcr-tooltip--danger-16-4-0",
        "hcr-tooltip--content-fit": "hcr-tooltip--content-fit-16-4-0",
        "hcr-tooltip--medium": "hcr-tooltip--medium-16-4-0",
        "hcr-tooltip--large": "hcr-tooltip--large-16-4-0",
        "hcr-tooltip--left": "hcr-tooltip--left-16-4-0",
        "hcr-tooltip--top": "hcr-tooltip--top-16-4-0",
        "hcr-tooltip--bottom": "hcr-tooltip--bottom-16-4-0",
        "hcr-tooltip--start": "hcr-tooltip--start-16-4-0",
        "hcr-tooltip--end": "hcr-tooltip--end-16-4-0",
        "hcr-tooltip--fixed": "hcr-tooltip--fixed-16-4-0",
        "hcr-tooltip-target": "hcr-tooltip-target-16-4-0",
        "hcr-tooltip-target--inline": "hcr-tooltip-target--inline-16-4-0",
        "hcr-tooltip-target__button": "hcr-tooltip-target__button-16-4-0"
    }
};








const $7ea51213ab9a36c1$export$967ffdc41d7c5622 = [
    'top',
    'bottom',
    'left',
    'right'
];
const $7ea51213ab9a36c1$export$7256c2531cd031e9 = [
    'start',
    'end'
];
const $7ea51213ab9a36c1$export$1ab6aaa0dfe30d1 = [
    'inline',
    'block'
];
const $7ea51213ab9a36c1$export$aaba7e8b56a28dc6 = [
    'content-fit',
    'medium',
    'large'
];



var $acw62 = parcelRequire("acw62");



/** @since 8.8.5 */ function $43d755d35c112323$export$2e2bcd8739ae039({ children: children, className: className, openOnHover: openOnHover, isExpanded: isExpanded, hookEvents: hookEvents, id: id, style: style, btnRef: btnRef }) {
    const { getElementName: getElementName } = $175aa43345204302$exports;
    const targetEvents = (target)=>{
        const handleClick = (event)=>{
            if (target === null || target === void 0 ? void 0 : target.props.onClick) target.props.onClick(event);
            if (hookEvents && hookEvents.onClick) hookEvents.onClick(event);
        };
        const handleKeyDown = (event)=>{
            if (target === null || target === void 0 ? void 0 : target.props.onKeyDown) target.props.onKeyDown(event);
            if (hookEvents && hookEvents.onKeyDown) hookEvents.onKeyDown(event);
        };
        return Object.assign(Object.assign({}, hookEvents), {
            onKeyDown: handleKeyDown,
            onClick: handleClick
        });
    };
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) {
        const ariaDescribedBy = $fc332675fdeb2380$export$db93d21cb888fc59(id, {
            ariaDescribedBy: id,
            component: children
        });
        const isButton = getElementName(children) === 'button' || getElementName(children).includes('Button') && children.props.Elem === undefined || getElementName(children) === 'Injecss(Tag)' && children.props.Elem === 'button';
        // clone it and attach required events and attributes
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, Object.assign(Object.assign(Object.assign({}, openOnHover ? {
            'aria-describedby': ariaDescribedBy
        } : Object.assign({
            'aria-controls': id
        }, isButton ? {
            'aria-expanded': isExpanded
        } : {})), targetEvents(children)), {
            style: style
        }));
    }
    // wrap plain text with a button
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        type: "button",
        className: className,
        ref: btnRef
    }, openOnHover ? {
        'aria-describedby': id
    } : {
        'aria-controls': id,
        'aria-expanded': isExpanded
    }, targetEvents(), {
        style: style
    }), children);
}


/**
 * Calculates tooltips fixed position based on the target position
 * and tooltip desired position class names
 * @param {Element} target
 * @param position
 */ function $b76ee494cd281082$export$8c05723064717d0d(target, position) {
    let tooltipStyles = '';
    // Calculate position based on target element
    const targetPosition = target.getBoundingClientRect();
    switch(position){
        case 'top':
            tooltipStyles = `bottom: ${window.innerHeight - targetPosition.top}px; left: ${targetPosition.right - targetPosition.width / 2}px;`;
            break;
        case 'bottom':
            tooltipStyles = `top: ${targetPosition.bottom}px; left: ${targetPosition.right - targetPosition.width / 2}px;`;
            break;
        case 'left':
            tooltipStyles = `top: ${targetPosition.top + targetPosition.height / 2}px; right: ${window.innerWidth - targetPosition.left}px;`;
            break;
        default:
            tooltipStyles = `top: ${targetPosition.top + targetPosition.height / 2}px; left: ${targetPosition.right}px;`;
    }
    return tooltipStyles;
}
/**
 * Applies fixed position coordinates to the tooltip
 * based on the given target and position preference
 * @param target
 * @param tooltip
 * @param position
 */ function $b76ee494cd281082$export$6b9df8958dd7322f(target, tooltip, position) {
    if (target && tooltip) {
        const positionStyles = $b76ee494cd281082$export$8c05723064717d0d(target, position);
        // updating styles like this in a non-React way as it happens faster
        // and doesn't rerender the component every time
        // It might make sense here as this position intended to act as polyfill and be here temporary
        // without embedding it too deep into react component logic
        tooltip.setAttribute('style', positionStyles);
    }
}




var $acw62 = parcelRequire("acw62");

var $ab2b5373e6da71b0$export$2e2bcd8739ae039 = {
    raw: ".hcr-balloon-16-4-0{--hcr-balloon-width:15.75rem;--hcr-balloon-height:44px;--hcr-balloon-background:var(--hcr-box-bg-color);--hcr-balloon-color:var(--hcr-content-primary-color);--hcr-balloon-close-color:var(--hcr-icon-primary-color);--hcr-balloon-content-margin:0;--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) calc(-1 * var(--hcr-spacing-1)) var(--hcr-spacing-2);color:var(--hcr-balloon-color);font-family:inherit;font-size:var(--hcr-font-size-primary);justify-content:space-between;min-height:var(--hcr-balloon-height);min-width:var(--hcr-balloon-width);position:relative;text-decoration:none;width:-moz-fit-content;width:fit-content;z-index:10}.hcr-balloon-16-4-0:not([hidden]){display:flex}.hcr-balloon-16-4-0:before{background:var(--hcr-balloon-background);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);content:\"\";left:0;position:absolute;z-index:-1}.hcr-balloon__content-16-4-0{flex:auto;margin:var(--hcr-balloon-content-margin);position:relative;text-align:left;z-index:1}.hcr-balloon__close-16-4-0{align-self:flex-start;margin:var(--hcr-balloon-close-margin);position:relative;z-index:1}.hcr-balloon__close-16-4-0:before{background-color:var(--hcr-balloon-close-color);content:\"\";height:var(--hcr-spacing-3);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:var(--hcr-spacing-3)}.hcr-balloon--danger-16-4-0{--hcr-balloon-background:var(--hcr-danger-color);--hcr-balloon-color:var(--hcr-grayscale-0-color);--hcr-balloon-close-color:var(--hcr-grayscale-0-color)}.hcr-balloon--content-fit-16-4-0{--hcr-balloon-width:auto;--hcr-balloon-height:auto;--hcr-balloon-content-margin:calc(-1 * var(--hcr-spacing-1));--hcr-balloon-close-margin:calc(-1 * var(--hcr-spacing-2)) calc(-1 * var(--hcr-spacing-2)) calc(-1 * var(--hcr-spacing-2)) var(--hcr-spacing-2);white-space:nowrap}.hcr-balloon--medium-16-4-0{--hcr-balloon-width:23.25rem}.hcr-balloon--large-16-4-0{--hcr-balloon-width:30.75rem}.hcr-balloon-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-balloon-16-4-0:before{bottom:0;left:var(--hcr-spacing-2);right:0;top:0}.hcr-balloon--left-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-balloon--left-16-4-0:before{bottom:0;left:0;right:var(--hcr-spacing-2);top:0}.hcr-balloon--top-16-4-0{padding:var(--hcr-spacing-2) var(--hcr-spacing-2) var(--hcr-spacing-4)}.hcr-balloon--top-16-4-0:before{bottom:var(--hcr-spacing-2);left:0;right:0;top:0}.hcr-balloon--bottom-16-4-0{padding:var(--hcr-spacing-4) var(--hcr-spacing-2) var(--hcr-spacing-2)}.hcr-balloon--bottom-16-4-0:before{bottom:0;left:0;right:0;top:var(--hcr-spacing-2)}.hcr-balloon-16-4-0:after{border-left:0;border-right:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);content:\"\";height:0;inset:auto auto auto var(--hcr-spacing-1);position:absolute;width:0;z-index:0}.hcr-balloon--left-16-4-0:after,.hcr-balloon-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-top:calc(var(--hcr-spacing-1) + 2px) solid #0000}.hcr-balloon--left-16-4-0:after{border-left:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-right:0;inset:auto var(--hcr-spacing-1) auto auto}.hcr-balloon-16-4-0:after{top:50%;transform:translateY(-50%)}.hcr-balloon--start-16-4-0:after{top:min(25%,var(--hcr-spacing-3));transform:none}.hcr-balloon--end-16-4-0:after{bottom:min(25%,var(--hcr-spacing-3));top:auto;transform:none}.hcr-balloon--bottom-16-4-0:after{border-bottom:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);border-top:0;inset:var(--hcr-spacing-1) auto auto}.hcr-balloon--bottom-16-4-0:after,.hcr-balloon--top-16-4-0:after{border-left:calc(var(--hcr-spacing-1) + 2px) solid #0000;border-right:calc(var(--hcr-spacing-1) + 2px) solid #0000}.hcr-balloon--top-16-4-0:after{border-bottom:0;border-top:calc(var(--hcr-spacing-1) + 2px) solid var(--hcr-balloon-background);inset:auto auto var(--hcr-spacing-1)}.hcr-balloon--bottom-16-4-0:after,.hcr-balloon--top-16-4-0:after{left:50%;right:auto;transform:translateX(-50%)}.hcr-balloon--start-16-4-0.hcr-balloon--bottom-16-4-0:after,.hcr-balloon--start-16-4-0.hcr-balloon--top-16-4-0:after{left:min(25%,var(--hcr-spacing-3));transform:none}.hcr-balloon--end-16-4-0.hcr-balloon--bottom-16-4-0:after,.hcr-balloon--end-16-4-0.hcr-balloon--top-16-4-0:after{left:auto;right:min(25%,var(--hcr-spacing-3));transform:none}.hcr-balloon--top-16-4-0:after{top:auto}",
    map: {
        "hcr-balloon": "hcr-balloon-16-4-0",
        "hcr-balloon__content": "hcr-balloon__content-16-4-0",
        "hcr-balloon__close": "hcr-balloon__close-16-4-0",
        "hcr-balloon--danger": "hcr-balloon--danger-16-4-0",
        "hcr-balloon--content-fit": "hcr-balloon--content-fit-16-4-0",
        "hcr-balloon--medium": "hcr-balloon--medium-16-4-0",
        "hcr-balloon--large": "hcr-balloon--large-16-4-0",
        "hcr-balloon--left": "hcr-balloon--left-16-4-0",
        "hcr-balloon--top": "hcr-balloon--top-16-4-0",
        "hcr-balloon--bottom": "hcr-balloon--bottom-16-4-0",
        "hcr-balloon--start": "hcr-balloon--start-16-4-0",
        "hcr-balloon--end": "hcr-balloon--end-16-4-0"
    }
};





const $c2c1d359f5b34dfc$export$6308e1a16f4ef787 = [
    'top',
    'bottom',
    'left',
    'right'
];
const $c2c1d359f5b34dfc$export$41082b867d4856ca = [
    'start',
    'end'
];
const $c2c1d359f5b34dfc$export$cea1dba590f1dce0 = [
    'content-fit',
    'medium',
    'large'
];




const $c50ace7393aa17b4$var$bemBalloon = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('balloon', (0, $ab2b5373e6da71b0$export$2e2bcd8739ae039));
function $c50ace7393aa17b4$export$3016537a1ffc38d5(_a) {
    var { innerRef: innerRef, children: children, closeProps: closeProps, extraClasses: extraClasses, customBem: customBem, position: position = 'right', alignment: alignment, danger: danger = false, size: size } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "innerRef",
        "children",
        "closeProps",
        "extraClasses",
        "customBem",
        "position",
        "alignment",
        "danger",
        "size"
    ]);
    const bemObj = customBem || $c50ace7393aa17b4$var$bemBalloon;
    const balloonClassNames = bemObj.b([
        {
            active: !rest.hidden,
            danger: danger,
            top: position === 'top',
            left: position === 'left',
            bottom: position === 'bottom',
            start: alignment === 'start',
            end: alignment === 'end'
        },
        size
    ], extraClasses);
    // preventing closeProps destructor to override Button className property
    const _b = Object.assign({}, closeProps), { extraClasses: closeBtnExtraClasses } = _b, closePropsRest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_b, [
        "extraClasses"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: innerRef,
        className: balloonClassNames
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: bemObj.e('content')
    }, children), closeProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), Object.assign({
        appearance: "link",
        display: "square",
        size: "sm",
        extraClasses: bemObj.e('close', false, closeBtnExtraClasses)
    }, closePropsRest)));
}
$c50ace7393aa17b4$export$3016537a1ffc38d5.displayName = 'Balloon';
$c50ace7393aa17b4$export$3016537a1ffc38d5.propTypes = {
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    closeProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    }),
    danger: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    customBem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf((0, $4ada79c183cfad4b$export$2e2bcd8739ae039)),
    position: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c2c1d359f5b34dfc$export$6308e1a16f4ef787)),
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c2c1d359f5b34dfc$export$41082b867d4856ca)),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c2c1d359f5b34dfc$export$cea1dba590f1dce0))
};
var $c50ace7393aa17b4$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($c50ace7393aa17b4$export$3016537a1ffc38d5, (0, $ab2b5373e6da71b0$export$2e2bcd8739ae039));



// defines base class names for tooltip's target trigger element
const $7c719ed1689be3d8$var$bemTarget = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('tooltip-target', (0, $5f66f0db6cf3ea69$export$2e2bcd8739ae039));
const $7c719ed1689be3d8$var$bemTooltip = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('tooltip', (0, $5f66f0db6cf3ea69$export$2e2bcd8739ae039));
const $7c719ed1689be3d8$var$TOOLTIP_ANCHOR_CSS_VAR = `--hcr-tooltip-anchor`;
// checks if browser supports anchor positioning (only in browser environment)
const $7c719ed1689be3d8$var$BROWSER_SUPPORTS_ANCHOR_POS = typeof CSS !== 'undefined' && CSS.supports ? CSS.supports('anchor-name', `var(${$7c719ed1689be3d8$var$TOOLTIP_ANCHOR_CSS_VAR})`) : false;
/** @since 0.2.0 */ function $7c719ed1689be3d8$export$28c660c63b792dea(_a) {
    var { id: id, active: activeProp, fixed: fixed = false, children: children, closeBtn: closeBtn, content: content, extraClasses: extraClasses, hasClose: hasClose = false, onToggle: onToggle = ()=>null, openOnHover: openOnHover = false, position: position, alignment: alignment, danger: danger = false, size: size, wrapAround: wrapAround = 'inline', disableInternalHandlers: disableInternalHandlers = false, innerRef: innerRef, balloonRef: balloonRef, targetRef: targetRef } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "active",
        "fixed",
        "children",
        "closeBtn",
        "content",
        "extraClasses",
        "hasClose",
        "onToggle",
        "openOnHover",
        "position",
        "alignment",
        "danger",
        "size",
        "wrapAround",
        "disableInternalHandlers",
        "innerRef",
        "balloonRef",
        "targetRef"
    ]);
    // Initializing all the needed refs and elements for focus control and positioning
    const tooltipContainerRef = (0, $acw62.useRef)(null);
    const tooltipBalloonRef = (0, $acw62.useRef)(null);
    // Ref populated with a button wrapper in TooltipTarget component
    const btnTargetRef = (0, $acw62.useRef)(null);
    // Either use provided targetRef or try to bind to the wrapping target button
    const unifiedTargetRef = targetRef || btnTargetRef;
    // Fallback to tooltipContainerRef if no target or btnRefs available
    const tooltipTargetElement = unifiedTargetRef && typeof unifiedTargetRef !== 'function' && unifiedTargetRef.current ? unifiedTargetRef.current : tooltipContainerRef.current;
    const [activeHook, hookEvents, deactivateTooltip] = (0, $881605b223889743$export$6c3f529066e77cfe)({
        initialActive: activeProp,
        onToggle: onToggle,
        content: tooltipBalloonRef.current,
        hoverEvents: openOnHover
    });
    const [win, doc] = (0, $a2044d38a0bc3f8e$export$f0dc76b03756ac7e)();
    // Checks if modern browser anchor based positioning possible
    const isPortalAnchorPositioning = fixed && $7c719ed1689be3d8$var$BROWSER_SUPPORTS_ANCHOR_POS;
    // Checks if polyfill approach with fixed positioning is needed
    const isPortalFixedPositioning = fixed && !$7c719ed1689be3d8$var$BROWSER_SUPPORTS_ANCHOR_POS;
    // Dynamic style objects to wire anchor positioning in modern browsers
    // Adjust to support anchorName style property and our CSS var
    const anchorTargetStyles = {
        [`${$7c719ed1689be3d8$var$TOOLTIP_ANCHOR_CSS_VAR}`]: `--tooltip-${id}`,
        ['anchorName']: `var(${$7c719ed1689be3d8$var$TOOLTIP_ANCHOR_CSS_VAR})`
    };
    const anchorTooltipStyles = {
        [`${$7c719ed1689be3d8$var$TOOLTIP_ANCHOR_CSS_VAR}`]: `--tooltip-${id}`
    };
    // @todo this is questionable so can be removed if a cleaner way is found
    const isInline = wrapAround === 'inline';
    const Elem = isInline ? 'span' : 'div';
    // Unified active state
    const isActive = activeProp === undefined ? activeHook : activeProp;
    // Initially position tooltip on screen in unsupported browsers
    if (isActive && isPortalFixedPositioning) (0, $b76ee494cd281082$export$6b9df8958dd7322f)(tooltipTargetElement, tooltipBalloonRef.current, position);
    /**
   * Attaches repositioning event listeners for browsers that do not support anchor positioning
   * aka "Polyfill" mode
   */ (0, $acw62.useEffect)(()=>{
        // init signal to control the event listeners
        const scrollResizeAbortController = new AbortController();
        let scrollThrottle = false;
        /**
     * Runs tooltip positioning on every animation frame
     */ const repositionTooltip = ()=>{
            // reposition on every frame, this achieves the smoothest animation
            // we can try dropping FPS with timers for performance reasons if needed
            if (!scrollThrottle) {
                scrollThrottle = true;
                requestAnimationFrame(function() {
                    (0, $b76ee494cd281082$export$6b9df8958dd7322f)(tooltipTargetElement, tooltipBalloonRef.current, position);
                    scrollThrottle = false;
                });
            }
        };
        // attaching reposition when scroll or resize happens
        // @todo this DOES NOT include dynamic target size changes,
        // if this happens reposition happens either on scroll or during a rerender
        if (isPortalFixedPositioning && doc && win) {
            doc.addEventListener('scroll', repositionTooltip, {
                capture: true,
                passive: true,
                signal: scrollResizeAbortController.signal
            });
            win.addEventListener('resize', repositionTooltip, {
                passive: true,
                signal: scrollResizeAbortController.signal
            });
        }
        // aborting event listeners for non-active tooltips
        if (!isActive) scrollResizeAbortController.abort();
        return ()=>{
            scrollResizeAbortController.abort(); // clean up when unmounting
        };
    }, [
        isActive,
        isPortalFixedPositioning,
        position,
        doc,
        win
    ]);
    /**
   * Adds a click listener to the document;
   * when a click on any element that does not contain the tooltip occurs,
   * calls the visibilityToggler `deactivateTooltip` function
   */ (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (tooltipContainerRef.current && !tooltipContainerRef.current.contains(event.target) && typeof deactivateTooltip === 'function') deactivateTooltip();
        };
        if (!openOnHover && doc) doc.addEventListener('click', handleClickOutside, true);
        // remove document listener when tooltip unmounts
        return ()=>{
            if (!openOnHover && doc) doc.removeEventListener('click', handleClickOutside, true);
        };
    }, [
        deactivateTooltip,
        openOnHover
    ]);
    const handleClose = (event)=>{
        var _a;
        (_a = closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.onClick) === null || _a === void 0 || _a.call(closeBtn, event);
        deactivateTooltip();
    };
    // generate close button props
    const closeProps = hasClose ? Object.assign(Object.assign({}, closeBtn), {
        onClick: handleClose
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, tooltipContainerRef);
        }
    }, rest, {
        className: $7c719ed1689be3d8$var$bemTarget.b({
            inline: isInline
        }, rest.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $43d755d35c112323$export$2e2bcd8739ae039), Object.assign({
        id: id,
        className: $7c719ed1689be3d8$var$bemTarget.e('button'),
        hookEvents: !disableInternalHandlers ? hookEvents : {},
        openOnHover: openOnHover,
        isExpanded: isActive
    }, isPortalAnchorPositioning ? {
        style: anchorTargetStyles
    } : {}, {
        btnRef: btnTargetRef
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c50ace7393aa17b4$export$2e2bcd8739ae039), Object.assign({
        role: "tooltip",
        id: id,
        innerRef: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, balloonRef, tooltipBalloonRef);
        },
        alignment: alignment,
        hidden: !isActive,
        position: position,
        onMouseLeave: ()=>openOnHover && deactivateTooltip(),
        onKeyDown: (event)=>event.key === 'Escape' && deactivateTooltip(),
        closeProps: closeProps,
        customBem: $7c719ed1689be3d8$var$bemTooltip,
        extraClasses: $7c719ed1689be3d8$var$bemTooltip.mix(Object.assign(Object.assign({}, extraClasses ? {
            [extraClasses]: extraClasses
        } : {}), {
            [$7c719ed1689be3d8$var$bemTooltip.m({
                fixed: fixed
            })]: fixed
        })),
        danger: danger,
        size: size
    }, isPortalAnchorPositioning ? {
        style: anchorTooltipStyles
    } : {}), content));
}
$7c719ed1689be3d8$export$28c660c63b792dea.displayName = 'Tooltip';
$7c719ed1689be3d8$export$28c660c63b792dea.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    closeBtn: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({}),
    content: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    hasClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    danger: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $7ea51213ab9a36c1$export$aaba7e8b56a28dc6)),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    openOnHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $7ea51213ab9a36c1$export$967ffdc41d7c5622)),
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $7ea51213ab9a36c1$export$7256c2531cd031e9)),
    wrapAround: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $7ea51213ab9a36c1$export$1ab6aaa0dfe30d1)),
    disableInternalHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    balloonRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    targetRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    fixed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $7c719ed1689be3d8$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($7c719ed1689be3d8$export$28c660c63b792dea, (0, $5f66f0db6cf3ea69$export$2e2bcd8739ae039));


var $acw62 = parcelRequire("acw62");

const $e60137afc73fc6ac$export$4465485c874b39ad = (0, $7ea51213ab9a36c1$export$967ffdc41d7c5622);


/**
 * Returns the dimensions of the target container to calculate smart position against
 * @param window
 * @param container
 * @return {height: number, width: number}
 */ function $380f2c0fd8fe3e9e$export$91e38f747eaa9c43(window, container) {
    if (!container) return {
        height: window.innerHeight,
        width: window.innerWidth
    };
    const containerBoundingRect = container.getBoundingClientRect();
    return {
        height: containerBoundingRect.height,
        width: containerBoundingRect.width
    };
}
/**
 * returns BoundingClientRect position like object,
 * if container ref is given this is calculated against it
 * otherwise browser window is used
 * @param target {RefObject}
 * @param container {RefObject}
 */ function $380f2c0fd8fe3e9e$export$e9278e8fd80c0c90(target, container) {
    if (container && target) {
        const targetRect = target.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        return {
            top: targetRect.top - containerRect.top,
            bottom: targetRect.bottom - containerRect.top,
            left: targetRect.left - containerRect.left,
            right: targetRect.right - containerRect.left,
            width: targetRect.width,
            height: targetRect.height,
            y: targetRect.top - containerRect.top,
            x: targetRect.left - containerRect.left
        };
    }
    return target === null || target === void 0 ? void 0 : target.getBoundingClientRect();
}
/**
 * calculates the size of the zones on each side from the tooltip target element
 * returns zones with their sizes ordered from the biggest to the smallest
 * @param targetPosition
 * @param containerRect
 * @param smartPositionOffset
 */ function $380f2c0fd8fe3e9e$export$5e21c17c75d76fd0(targetPosition, containerRect, smartPositionOffset) {
    // tooltip target divides screen into 4 squares
    // checking which square is bigger,
    // meaning which direction from target has more space available
    const { top: offsetTop = 0, bottom: offsetBottom = 0, left: offsetLeft = 0, right: offsetRight = 0 } = smartPositionOffset;
    const tooltipZonesSizes = {
        // top direction square
        top: (targetPosition.top - offsetTop) * containerRect.width,
        // bottom direction square
        bottom: (containerRect.height - targetPosition.bottom - offsetBottom) * containerRect.width,
        // left direction square
        left: (targetPosition.left + offsetLeft) * containerRect.height,
        // right direction square
        right: (containerRect.width - targetPosition.right - offsetRight) * containerRect.height
    };
    const zonesSorted = Object.entries(tooltipZonesSizes).sort((a, b)=>{
        if (a[1] > b[1]) return -1;
        if (a[1] < b[1]) return 1;
        return 0;
    });
    return zonesSorted;
}
/**
 * Gets the biggest zone from the list provided, that is more likely to fit the tooltip
 * Accepts allowed zones if it's needed to restrict positioning options
 * @param zonesSorted
 * @param smartPositionAllowedPositions
 */ function $380f2c0fd8fe3e9e$export$3492d02690f90f2f(zonesSorted, smartPositionAllowedPositions) {
    const zonesSortedAndAllowed = zonesSorted.filter((value)=>smartPositionAllowedPositions.indexOf(value[0]) > -1);
    // getting the zone with max space available,
    // while also checking of it's in the list of allowed smart positioning zones
    const [maxZoneDirection] = zonesSortedAndAllowed[0];
    return maxZoneDirection;
}
/**
 * Gets zones that a relevant for tooltip alignment,
 * this mostly narrows down to returning vertical zones for horizontal max zone,
 * and horizontal if the biggest zone is vertical
 * */ function $380f2c0fd8fe3e9e$export$7fb5307b1b3be5e9(zonesSorted, currentZoneDirection) {
    const isVerticalMaxZone = currentZoneDirection === 'top' || currentZoneDirection === 'bottom';
    return zonesSorted.filter((zone)=>isVerticalMaxZone && (zone[0] === 'left' || zone[0] === 'right') || !isVerticalMaxZone && (zone[0] === 'top' || zone[0] === 'bottom'));
}
/**
 * Calculates additional smart alignment based on received zone sizes
 * @param zonesSorted
 * @param smartPositionAllowedPositions
 */ function $380f2c0fd8fe3e9e$export$c70c8955932466e8(zonesSorted, smartPositionAllowedPositions) {
    const maxZoneDirection = $380f2c0fd8fe3e9e$export$3492d02690f90f2f(zonesSorted, smartPositionAllowedPositions);
    const [secondLargestZone, thirdLargestZone] = $380f2c0fd8fe3e9e$export$7fb5307b1b3be5e9(zonesSorted, maxZoneDirection);
    // fine-tuning tooltip position by adjusting the alignment
    let calculatedAlignment = null;
    // smart alignment needs to take 2nd largest zone in consideration, to align towards that
    const secondLargestZoneName = secondLargestZone[0];
    const secondLargestZoneSize = secondLargestZone[1];
    // 3rd largest zone is needed to calculate the threshold to decide if alignment is needed,
    // we only need its size
    const thirdLargestZoneSize = thirdLargestZone[1];
    // smart alignment only takes place of alignment zones differ for more than specified number
    // this is a magic number we need, as tooltips never appear centered without this threshold
    const alignmentThreshold = 0.25;
    if (maxZoneDirection === 'left' || maxZoneDirection === 'right') {
        if (secondLargestZoneName === 'top') calculatedAlignment = 'end';
        if (secondLargestZoneName === 'bottom') calculatedAlignment = 'start';
        if (secondLargestZoneSize - thirdLargestZoneSize <= secondLargestZoneSize * alignmentThreshold) calculatedAlignment = null;
    }
    if (maxZoneDirection === 'top' || maxZoneDirection === 'bottom') {
        if (secondLargestZoneName === 'right') calculatedAlignment = 'start';
        if (secondLargestZoneName === 'left') calculatedAlignment = 'end';
        if (secondLargestZoneSize - thirdLargestZoneSize <= secondLargestZoneSize * alignmentThreshold) calculatedAlignment = null;
    }
    return calculatedAlignment;
}


/**
 * @since 10.9.0
 *
 * Calculates smart position for tooltips based on position of the target element on the screen or
 * within a certain DOM element.
 *
 * @see [Tooltip](https://honeycomb-react.hive.flix.tech/#/Components/Tooltip)
 * @see [Dropdown](https://honeycomb-react.hive.flix.tech/#/Components/Dropdown)
 */ function $56344d10e995bdc7$export$4305a51ef540d017({ active: active, alignment: alignment, position: position, smartPositionRef: smartPositionRef, smartPositionOffset: smartPositionOffset = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
}, smartPositionAllowedPositions: smartPositionAllowedPositions = (0, $e60137afc73fc6ac$export$4465485c874b39ad) }) {
    const [target, setTarget] = (0, $acw62.useState)(null);
    const [element, setElement] = (0, $acw62.useState)(null);
    // @todo figure why defaults only work until the smart position is applied,
    // once set only smart values are used (tried different things, none worked properly).
    const [smartPositionValue, setSmartPositionValue] = (0, $acw62.useState)(position);
    const [smartAlignmentValue, setSmartAlignmentValue] = (0, $acw62.useState)(alignment);
    const [isOutsideOfBoundaries, setIsOutsideOfBoundaries] = (0, $acw62.useState)();
    // Reassigning refs every time elements are mounted/changed
    const targetRef = (0, $acw62.useCallback)((node)=>{
        if (node !== null) setTarget(node);
    }, []);
    const elementRef = (0, $acw62.useCallback)((node)=>{
        if (node !== null) setElement(node);
    }, []);
    /**
   * Using IntersectionObserver API to calculate
   * if tooltip goes outside the specified container edges
   * and smart position mechanism is needed
   */ const intersectionObserverOptions = {
        root: smartPositionRef && smartPositionRef.current ? smartPositionRef.current : null,
        rootMargin: '0px',
        threshold: 1.0
    };
    /**
   * Re-calculates tooltip position value for smart positioning.
   * Runs every time element gets outside the defined container edges.
   */ (0, $acw62.useLayoutEffect)(()=>{
        // preventing things breaking if SSR is happening
        // additionally we want smart positioning only happen if the refs are passed and not null
        if (target && element && typeof window !== 'undefined' && typeof window.document.createElement !== 'undefined') {
            const observer = new IntersectionObserver((entries)=>{
                const [entry] = entries;
                setIsOutsideOfBoundaries(!entry.isIntersecting);
            }, intersectionObserverOptions);
            if (element) observer.observe(element);
            // only apply "smart" positioning mechanism if tooltip goes outside of container bounds
            if (isOutsideOfBoundaries === true) {
                const containerRect = (0, $380f2c0fd8fe3e9e$export$91e38f747eaa9c43)(window, smartPositionRef === null || smartPositionRef === void 0 ? void 0 : smartPositionRef.current);
                const targetPosition = (0, $380f2c0fd8fe3e9e$export$e9278e8fd80c0c90)(target, smartPositionRef === null || smartPositionRef === void 0 ? void 0 : smartPositionRef.current);
                const zonesSorted = (0, $380f2c0fd8fe3e9e$export$5e21c17c75d76fd0)(targetPosition, containerRect, smartPositionOffset);
                // getting a zone with the max space available,
                // while also checking if it's in the list of allowed smart positioning zones
                const maxZoneDirection = (0, $380f2c0fd8fe3e9e$export$3492d02690f90f2f)(zonesSorted, smartPositionAllowedPositions);
                // showing "smart" tooltip in the direction with max space available
                setSmartPositionValue(maxZoneDirection);
                // only align when needed, when the difference between the zones is big enough
                const calculatedAlignment = (0, $380f2c0fd8fe3e9e$export$c70c8955932466e8)(zonesSorted, smartPositionAllowedPositions);
                if (calculatedAlignment !== null) setSmartAlignmentValue(calculatedAlignment);
            }
            return ()=>{
                if (element) observer.unobserve(element);
            };
        }
        return ()=>{};
    }, [
        active,
        target,
        element
    ]);
    return [
        smartPositionValue,
        smartAlignmentValue,
        targetRef,
        elementRef
    ];
}




var $acw62 = parcelRequire("acw62");

var $241216f1c79b68fc$export$2cedfd664bb3bd01;
var $241216f1c79b68fc$export$4e6f96734dfe12f4;
var $241216f1c79b68fc$export$cc74dcc53cfce4eb;
$241216f1c79b68fc$export$2cedfd664bb3bd01 = `OverflownText-lILybG-textContainer`;
$241216f1c79b68fc$export$4e6f96734dfe12f4 = `OverflownText-lILybG-tooltip`;
$241216f1c79b68fc$export$cc74dcc53cfce4eb = `OverflownText-lILybG-wrapper`;


const $ad71d0cf041d1339$var$OverflownText = ({ tooltipContent: tooltipContent, isTooltipShownDefault: isTooltipShownDefault, extraClasses: extraClasses, children: children })=>{
    const [isActive, setIsActive] = $acw62.useState(false);
    const [smartPosition, smartAlignment, targetInnerRef, balloonInnerRef] = (0, $56344d10e995bdc7$export$4305a51ef540d017)({
        active: isActive
    });
    const [isTextOverFlown, setIsTextOverFlown] = $acw62.useState(true);
    const elementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        setIsTextOverFlown((0, $bccbf5d1aa5ab54f$export$2e2bcd8739ae039)(elementRef));
    }, [
        elementRef
    ]);
    const showTooltip = isTooltipShownDefault || isTextOverFlown;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $241216f1c79b68fc$export$cc74dcc53cfce4eb,
        children: [
            showTooltip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c719ed1689be3d8$export$2e2bcd8739ae039), {
                innerRef: targetInnerRef,
                balloonRef: balloonInnerRef,
                id: "overflown-text",
                content: tooltipContent,
                openOnHover: true,
                size: "content-fit",
                position: smartPosition,
                alignment: smartAlignment,
                onToggle: setIsActive,
                extraClasses: $241216f1c79b68fc$export$4e6f96734dfe12f4,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($241216f1c79b68fc$export$2cedfd664bb3bd01, extraClasses),
                    ref: elementRef,
                    "data-id": "overflown-text",
                    children: children
                })
            }),
            !showTooltip && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($241216f1c79b68fc$export$2cedfd664bb3bd01, extraClasses),
                ref: elementRef,
                "data-id": "overflown-text",
                children: children
            })
        ]
    });
};
var $ad71d0cf041d1339$export$2e2bcd8739ae039 = $ad71d0cf041d1339$var$OverflownText;





var $acw62 = parcelRequire("acw62");

var $0084abf155b67209$var$_excluded = [
    "title",
    "pathRest"
];
var $0084abf155b67209$export$60b42ba963c1b0af = function IconArrowLeft(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $0084abf155b67209$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-arrow-left"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "m15.7 17.27-5.28-5.28 5.27-5.26a1 1 0 0 0 0-1.41 1 1 0 0 0-1.41 0l-5.99 5.97a1 1 0 0 0 0 1.41l6 5.98a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.41"
    }, pathRest)));
};
$0084abf155b67209$export$60b42ba963c1b0af.displayName = 'InlineIcon(IconArrowLeft)';
$0084abf155b67209$export$60b42ba963c1b0af.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



var $acw62 = parcelRequire("acw62");

var $5b3ef7dcc370811e$var$_excluded = [
    "title",
    "pathRest"
];
var $5b3ef7dcc370811e$export$e2df95fe2abd6d02 = function IconArrowRight(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $5b3ef7dcc370811e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-arrow-right"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M15.7 11.3 9.72 5.32a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.42L13.58 12 8.3 17.27a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l5.99-5.97a1 1 0 0 0 0-1.41"
    }, pathRest)));
};
$5b3ef7dcc370811e$export$e2df95fe2abd6d02.displayName = 'InlineIcon(IconArrowRight)';
$5b3ef7dcc370811e$export$e2df95fe2abd6d02.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $6c972fcf9f090ffb$export$2e2bcd8739ae039 = {
    raw: ".hcr-skeleton-16-4-0{animation:skeleton-blink 1.6s linear infinite;background:var(--hcr-grayscale-30-color);border-radius:var(--hcr-border-radius-1);content:\"\";display:block;height:var(--hcr-line-height-primary);margin-bottom:var(--hcr-spacing-2);width:100%}.hcr-skeleton--w-xs-16-4-0{width:25%}.hcr-skeleton--w-sm-16-4-0{width:33%}.hcr-skeleton--w-md-16-4-0{width:50%}.hcr-skeleton--w-lg-16-4-0{width:75%}.hcr-skeleton--h-xs-16-4-0{height:1px;margin-bottom:var(--hcr-spacing-2)}.hcr-skeleton--h-md-16-4-0{height:calc(var(--hcr-line-height-primary) + var(--hcr-spacing-1));margin-bottom:var(--hcr-spacing-2)}.hcr-skeleton--h-lg-16-4-0{height:calc(var(--hcr-line-height-primary) + var(--hcr-spacing-3) + 2px);margin-bottom:var(--hcr-spacing-2)}@media (min-width:1200px){.hcr-skeleton--h-lg-16-4-0{height:calc(var(--hcr-line-height-primary) + var(--hcr-spacing-2))}}.hcr-skeleton--inline-16-4-0{display:inline-flex;vertical-align:middle}.hcr-skeleton--round-16-4-0{border-radius:var(--hcr-spacing-5)}.hcr-skeleton--flush-bottom-16-4-0{margin-bottom:0}@keyframes skeleton-blink{0%{opacity:1}50%{opacity:.5}to{opacity:1}}",
    map: {
        "hcr-skeleton": "hcr-skeleton-16-4-0",
        "hcr-skeleton--w-xs": "hcr-skeleton--w-xs-16-4-0",
        "hcr-skeleton--w-sm": "hcr-skeleton--w-sm-16-4-0",
        "hcr-skeleton--w-md": "hcr-skeleton--w-md-16-4-0",
        "hcr-skeleton--w-lg": "hcr-skeleton--w-lg-16-4-0",
        "hcr-skeleton--h-xs": "hcr-skeleton--h-xs-16-4-0",
        "hcr-skeleton--h-md": "hcr-skeleton--h-md-16-4-0",
        "hcr-skeleton--h-lg": "hcr-skeleton--h-lg-16-4-0",
        "hcr-skeleton--inline": "hcr-skeleton--inline-16-4-0",
        "hcr-skeleton--round": "hcr-skeleton--round-16-4-0",
        "hcr-skeleton--flush-bottom": "hcr-skeleton--flush-bottom-16-4-0"
    }
};





const $c9e17862934b3e96$export$a83fe240e85dc689 = [
    'xs',
    'sm',
    'md',
    'lg'
];



const $18e3b9edfaaee1b3$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('skeleton', (0, $6c972fcf9f090ffb$export$2e2bcd8739ae039));
function $18e3b9edfaaee1b3$export$8f31e4c4a37b8e9c(_a) {
    var { width: width, height: height, flushBottom: flushBottom = false, inline: inline = false, round: round = false, extraClasses: extraClasses, Elem: Elem = 'span' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "width",
        "height",
        "flushBottom",
        "inline",
        "round",
        "extraClasses",
        "Elem"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        className: $18e3b9edfaaee1b3$var$bem.b({
            [`w-${width}`]: Boolean(width),
            [`h-${height}`]: Boolean(height),
            'flush-bottom': flushBottom,
            inline: inline,
            round: round
        }, extraClasses)
    }, rest));
}
$18e3b9edfaaee1b3$export$8f31e4c4a37b8e9c.displayName = 'Skeleton';
$18e3b9edfaaee1b3$export$8f31e4c4a37b8e9c.propTypes = {
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    flushBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c9e17862934b3e96$export$a83fe240e85dc689)),
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    round: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $c9e17862934b3e96$export$a83fe240e85dc689))
};
var $18e3b9edfaaee1b3$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($18e3b9edfaaee1b3$export$8f31e4c4a37b8e9c, (0, $6c972fcf9f090ffb$export$2e2bcd8739ae039));


parcelRequire("acw62");
var $29dcb3db5e2ec910$export$fa397790119a1408;
var $29dcb3db5e2ec910$export$b426df703d3b34b8;
var $29dcb3db5e2ec910$export$a049c3b5e4400589;
$29dcb3db5e2ec910$export$fa397790119a1408 = `PagerSkeleton-lAE6bq-flix-theme-dark`;
$29dcb3db5e2ec910$export$b426df703d3b34b8 = `PagerSkeleton-lAE6bq-flix-theme-flix`;
$29dcb3db5e2ec910$export$a049c3b5e4400589 = `PagerSkeleton-lAE6bq-skeletonWrapper`;


const $996184e1e571f333$var$PagerSkeleton = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $29dcb3db5e2ec910$export$a049c3b5e4400589,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18e3b9edfaaee1b3$export$2e2bcd8739ae039), {
                flushBottom: true,
                height: "lg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18e3b9edfaaee1b3$export$2e2bcd8739ae039), {
                flushBottom: true,
                height: "lg"
            })
        ]
    });
};
var $996184e1e571f333$export$2e2bcd8739ae039 = $996184e1e571f333$var$PagerSkeleton;



var $83991081a067aa64$export$3c0700692b42d99d;
var $83991081a067aa64$export$fa397790119a1408;
var $83991081a067aa64$export$b426df703d3b34b8;
var $83991081a067aa64$export$2e6c959c16ff56b8;
var $83991081a067aa64$export$cc74dcc53cfce4eb;
$83991081a067aa64$export$3c0700692b42d99d = `Pager-BszHiq-dropdownLabel`;
$83991081a067aa64$export$fa397790119a1408 = `Pager-BszHiq-flix-theme-dark`;
$83991081a067aa64$export$b426df703d3b34b8 = `Pager-BszHiq-flix-theme-flix`;
$83991081a067aa64$export$2e6c959c16ff56b8 = `Pager-BszHiq-select`;
$83991081a067aa64$export$cc74dcc53cfce4eb = `Pager-BszHiq-wrapper`;


const $a6b894d0c33f00a5$var$filterOptions = (options, totalItems)=>{
    return options.filter((_, i, arr)=>{
        if (i === 0) return true;
        else return parseInt(arr[i].label, 10) <= totalItems || parseInt(arr[i - 1].label) < totalItems;
    });
};
var $a6b894d0c33f00a5$export$2e2bcd8739ae039 = $a6b894d0c33f00a5$var$filterOptions;


const $0184f9f253e41f93$var$Pager = ({ loading: loading, onChange: onChange = ()=>{}, pageSizeOptions: pageSizeOptions, isDropUp: isDropUp, currentPage: currentPage, totalItems: totalItems = 0, pageSize: pageSize })=>{
    const avialableOptions = (0, $a6b894d0c33f00a5$export$2e2bcd8739ae039)(pageSizeOptions, totalItems);
    const totalPages = totalItems ? (0, $730d905258f96f17$export$2e2bcd8739ae039)(totalItems, pageSize.value) : undefined;
    const disableNext = currentPage !== undefined && totalPages !== undefined ? currentPage + 1 >= totalPages : true;
    const disablePrevious = currentPage !== undefined ? currentPage <= 0 : true;
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $996184e1e571f333$export$2e2bcd8739ae039), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $83991081a067aa64$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $83991081a067aa64$export$2e6c959c16ff56b8,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0efec8145fdf3b01$export$2e2bcd8739ae039), {
                    options: avialableOptions,
                    initialValue: pageSizeOptions.find((option)=>option.value === pageSize.name),
                    onSelect: ({ value: value })=>onChange(0, value),
                    isDisabled: avialableOptions.length <= 1,
                    isDropUp: isDropUp
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $83991081a067aa64$export$3c0700692b42d99d,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    id: "pager.dropdown.label",
                    values: {
                        totalItems: totalItems
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
                display: "square",
                "aria-label": "Go Back",
                disabled: disablePrevious,
                onClick: ()=>onChange(currentPage - 1, pageSize.name),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                    InlineIcon: (0, $0084abf155b67209$export$60b42ba963c1b0af),
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                    "data-id": "page-label",
                    id: "pager.page.label",
                    values: {
                        b: (msg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: msg
                            }),
                        currentPage: currentPage + 1,
                        totalPages: totalPages
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a932d1784dd52635$export$2e2bcd8739ae039), {
                display: "square",
                "aria-label": "Go Forward",
                disabled: disableNext,
                onClick: ()=>onChange(currentPage + 1, pageSize.name),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                    InlineIcon: (0, $5b3ef7dcc370811e$export$e2df95fe2abd6d02),
                    "aria-hidden": "true"
                })
            })
        ]
    });
};
var $0184f9f253e41f93$export$2e2bcd8739ae039 = $0184f9f253e41f93$var$Pager;






var $acw62 = parcelRequire("acw62");
const $3894e71b4d79c9a1$var$HandleOutsideClick = ({ onClickOutside: onClickOutside, children: children })=>{
    const ref = $acw62.useRef(null);
    const handleClickOutside = (event)=>{
        if (ref.current && !ref.current.contains(event.target)) onClickOutside();
    };
    $acw62.useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        children: children
    });
};
var $3894e71b4d79c9a1$export$2e2bcd8739ae039 = $3894e71b4d79c9a1$var$HandleOutsideClick;





var $acw62 = parcelRequire("acw62");

var $d2427dd7a97ede3b$export$2e2bcd8739ae039 = {
    raw: ".hcr-calendar-16-4-0{background-color:var(--hcr-box-bg-color);border-radius:var(--hcr-border-radius-1);box-shadow:var(--hcr-primary-box-shadow);display:flex;flex-direction:column;gap:var(--hcr-spacing-2);min-width:calc(var(--hcr-spacing-1)*46);padding:var(--hcr-spacing-2);z-index:10}.hcr-calendar-16-4-0[hidden]{display:none}.hcr-calendar--flat-16-4-0{border-radius:0;box-shadow:none}.hcr-calendar__table-16-4-0{border-spacing:0 var(--hcr-spacing-half);width:100%}.hcr-calendar__caption-16-4-0{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-size:var(--hcr-font-size-h3);font-weight:var(--hcr-font-weight-bold);line-height:var(--hcr-line-height-h3);margin-bottom:var(--hcr-spacing-2)}.hcr-calendar__btn-16-4-0,.hcr-calendar__cell-16-4-0{font-family:var(--hcr-font-family-primary);line-height:2.25rem;position:relative;text-align:center}.hcr-calendar__cell--range-16-4-0:not(:empty){background-color:var(--hcr-highlight-color)}.hcr-calendar__cell--end-16-4-0 .hcr-calendar__btn-16-4-0,.hcr-calendar__cell--selected-16-4-0 .hcr-calendar__btn-16-4-0,.hcr-calendar__cell--start-16-4-0 .hcr-calendar__btn-16-4-0{background-color:var(--hcr-button-primary-color);color:var(--hcr-button-label-color)}.hcr-calendar__cell--end-16-4-0 .hcr-calendar__btn-16-4-0:before,.hcr-calendar__cell--start-16-4-0 .hcr-calendar__btn-16-4-0:before{background-color:var(--hcr-button-primary-color);content:\" \";height:var(--hcr-spacing-2);margin-top:calc(-1*var(--hcr-spacing-1));pointer-events:none;position:absolute;top:50%;transform:rotate(45deg);width:var(--hcr-spacing-2)}.hcr-calendar__cell--start-16-4-0:not(:empty){background-image:linear-gradient(to right,#fff0 0,var(--hcr-highlight-color) 50%)}.hcr-calendar__cell--start-16-4-0 .hcr-calendar__btn-16-4-0:before{left:100%;margin-left:calc(-1*var(--hcr-spacing-1))}.hcr-calendar__cell--end-16-4-0:not(:empty){background-image:linear-gradient(to right,var(--hcr-highlight-color) 50%,#fff0 50%)}.hcr-calendar__cell--end-16-4-0 .hcr-calendar__btn-16-4-0:before{margin-right:calc(-1*var(--hcr-spacing-1));right:100%}.hcr-calendar__cell--start-16-4-0.hcr-calendar__cell--end-16-4-0{background-image:none}.hcr-calendar__cell--start-16-4-0.hcr-calendar__cell--end-16-4-0 .hcr-calendar__btn-16-4-0:before{display:none}.hcr-calendar__cell--start-16-4-0 .hcr-calendar__btn-16-4-0{z-index:1}.hcr-calendar__cell--current-16-4-0 .hcr-calendar__btn-16-4-0:after{background-color:var(--hcr-content-primary-color);border-radius:var(--hcr-border-radius-1);bottom:var(--hcr-spacing-half);content:\"\";display:block;height:.1875rem;left:50%;position:absolute;transform:translateX(calc(-1*1.125rem/2));width:1.125rem}.hcr-calendar__cell--end-16-4-0.hcr-calendar__cell--current-16-4-0 .hcr-calendar__btn-16-4-0:after,.hcr-calendar__cell--selected-16-4-0.hcr-calendar__cell--current-16-4-0 .hcr-calendar__btn-16-4-0:after,.hcr-calendar__cell--start-16-4-0.hcr-calendar__cell--current-16-4-0 .hcr-calendar__btn-16-4-0:after{background-color:var(--hcr-button-label-color)}.hcr-calendar__btn-16-4-0{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-primary-color);cursor:pointer;display:block;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);line-height:var(--hcr-line-height-primary);min-height:var(--hcr-spacing-6);min-width:var(--hcr-spacing-6);padding:var(--hcr-spacing-1)0;text-align:inherit;width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-calendar__btn-16-4-0:focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px;z-index:1}.hcr-calendar__btn-16-4-0:enabled:hover,.hcr-calendar__btn-16-4-0:enabled:hover:before{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-calendar__btn-16-4-0:enabled:active,.hcr-calendar__btn-16-4-0:enabled:active:before{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-calendar__btn--disabled-16-4-0,.hcr-calendar__btn--disabled-16-4-0:before,.hcr-calendar__btn-16-4-0:disabled,.hcr-calendar__btn-16-4-0:disabled:before,.hcr-calendar__btn-16-4-0[aria-disabled=true],.hcr-calendar__btn-16-4-0[aria-disabled=true]:before{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}.hcr-calendar__cell--hover-16-4-0 .hcr-calendar__btn-16-4-0,.hcr-calendar__cell--hover-16-4-0 .hcr-calendar__btn-16-4-0:before{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-calendar__months-16-4-0{display:flex;flex-direction:column;flex-grow:1;gap:var(--hcr-spacing-2)}.hcr-calendar__controls-16-4-0{display:flex;flex-wrap:wrap;gap:var(--hcr-spacing-1)}.hcr-calendar--horizontal-16-4-0,.hcr-calendar--horizontal-16-4-0 .hcr-calendar__months-16-4-0{flex-direction:row;gap:var(--hcr-spacing-4)}.hcr-calendar--horizontal-16-4-0 .hcr-calendar__month-16-4-0{flex-grow:1}.hcr-calendar--horizontal-16-4-0 .hcr-calendar__controls-16-4-0{align-items:flex-end;flex-direction:column}.hcr-calendar--horizontal-16-4-0 .hcr-calendar__controls-16-4-0:last-child{align-items:flex-start}.hcr-calendar-header-16-4-0{align-items:center;display:grid;gap:var(--hcr-spacing-2);grid-template:\"prev content next\"var(--hcr-input-height-mobile)/var(--hcr-input-height-mobile) auto var(--hcr-input-height-mobile);margin-bottom:var(--hcr-spacing-2)}@media (min-width:1200px){.hcr-calendar-header-16-4-0{grid-template-columns:var(--hcr-input-height-desktop) auto var(--hcr-input-height-desktop);grid-template-rows:var(--hcr-input-height-desktop)}}.hcr-calendar-header-16-4-0 .hcr-btn-16-4-0:first-child{grid-area:prev}.hcr-calendar-header-16-4-0 .hcr-btn-16-4-0:last-child{grid-area:next}.hcr-calendar-header__title-16-4-0{color:var(--hcr-container-content-color,var(--hcr-heading-font-color));font-size:var(--hcr-font-size-h3);font-weight:var(--hcr-font-weight-bold);grid-area:content;line-height:var(--hcr-line-height-h3);text-align:center}.hcr-calendar-header--birthday-16-4-0{grid-template:auto/auto auto}",
    map: {
        "hcr-calendar": "hcr-calendar-16-4-0",
        "hcr-calendar--flat": "hcr-calendar--flat-16-4-0",
        "hcr-calendar__table": "hcr-calendar__table-16-4-0",
        "hcr-calendar__caption": "hcr-calendar__caption-16-4-0",
        "hcr-calendar__btn": "hcr-calendar__btn-16-4-0",
        "hcr-calendar__cell": "hcr-calendar__cell-16-4-0",
        "hcr-calendar__cell--range": "hcr-calendar__cell--range-16-4-0",
        "hcr-calendar__cell--start": "hcr-calendar__cell--start-16-4-0",
        "hcr-calendar__cell--end": "hcr-calendar__cell--end-16-4-0",
        "hcr-calendar__cell--selected": "hcr-calendar__cell--selected-16-4-0",
        "hcr-calendar__cell--current": "hcr-calendar__cell--current-16-4-0",
        "hcr-calendar__btn--disabled": "hcr-calendar__btn--disabled-16-4-0",
        "hcr-calendar__cell--hover": "hcr-calendar__cell--hover-16-4-0",
        "hcr-calendar__months": "hcr-calendar__months-16-4-0",
        "hcr-calendar__controls": "hcr-calendar__controls-16-4-0",
        "hcr-calendar--horizontal": "hcr-calendar--horizontal-16-4-0",
        "hcr-calendar__month": "hcr-calendar__month-16-4-0",
        "hcr-calendar-header": "hcr-calendar-header-16-4-0",
        "hcr-btn": "hcr-btn-16-4-0",
        "hcr-calendar-header__title": "hcr-calendar-header__title-16-4-0",
        "hcr-calendar-header--birthday": "hcr-calendar-header--birthday-16-4-0"
    }
};


/** Checks if two dates are in the same month and year. */ function $53f5b6dc22264c79$export$a18c89cbd24170ff(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}
/** Checks if a month is between a start and end date, including start and end date. */ function $53f5b6dc22264c79$export$9ae2fcb84de26ead(date, startDate, endDate) {
    const startOfStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const endOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
    return date.getTime() >= startOfStartDate.getTime() && date.getTime() <= endOfEndDate.getTime();
}
/** Checks if two dates are the same day, month, and year. */ function $53f5b6dc22264c79$export$a8b2a21161763694(a, b) {
    return $53f5b6dc22264c79$export$a18c89cbd24170ff(a, b) && a.getDate() === b.getDate();
}
/** Normalizes time for date given to be a default 00:00:00 */ function $53f5b6dc22264c79$export$f3417f4d288609d9(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
/** Checks if a date is in between a start and end date (excluding start and end dates) */ function $53f5b6dc22264c79$export$2b3dc83407dc1cd5(date, startDate, endDate) {
    return date.getTime() < endDate.getTime() && date.getTime() > startDate.getTime();
}




/** Creates a 'day' object for the calendar based on a given Date class instance. */ function $a060cac931c9e211$export$ef7ba876172a4e70(_a) {
    var { date: date, disabled: disabled, prev: prev, next: next } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "date",
        "disabled",
        "prev",
        "next"
    ]);
    return Object.assign({
        weekday: date.getDay(),
        number: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
        date: date,
        disabled: disabled,
        prev: prev,
        next: next
    }, rest);
}
(0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
    weekday: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    number: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    month: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    year: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date).isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    prev: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    next: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
});


/**
 * Calculates how many days from the previous month are needed so the calendar matches the layout.
 * Then returns an array with padding days from the previous month in the correct order.
 */ function $60abc6e452f39f85$export$ea0e2983ba38c85e(year, month, options) {
    // first day of week of this month
    const firstWeekDay = new Date(year, month, 1).getDay();
    let startPadLength = 0;
    if (options.offset > firstWeekDay) startPadLength = 7 - firstWeekDay - options.offset;
    if (options.offset < firstWeekDay) startPadLength = firstWeekDay - options.offset;
    return startPadLength > 0 ? new Array(startPadLength).fill(null).map((_, i)=>{
        // Time travel in JS. Where `days <=0` go back in time.
        // e.g.:
        //  - new Date(2020, 5, 0)  -> new Date(2019, 4, 31)
        //  - new Date(2020, 5, -1) -> new Date(2019, 4, 30)
        const date = new Date(year, month, 0 - i);
        return (0, $a060cac931c9e211$export$ef7ba876172a4e70)({
            date: date,
            disabled: options.disableDayFn(date),
            prev: true // adds prev flag
        });
    }).reverse() : [];
}
/** Returns an array of days from the current month. */ function $60abc6e452f39f85$export$148d277a82d0f987(year, month, options) {
    // Another prime example of time traveling.
    // Advancing 1 month to get day 0 = last day of current month.
    return new Array(new Date(year, month + 1, 0).getDate()).fill(null).map((_, i)=>{
        const date = new Date(year, month, i + 1);
        return (0, $a060cac931c9e211$export$ef7ba876172a4e70)({
            date: date,
            disabled: options.disableDayFn(date)
        });
    });
}
/**
 * Calculates how many days from the next month are needed so the calendar matches the layout.
 * Then returns an array with padding days from the next month.
 */ function $60abc6e452f39f85$export$dee4e20cbb4c4b12(totalCalendarDays, year, month, options) {
    const daysInLastWeek = totalCalendarDays % 7;
    // if the last week is full, no padding is needed
    const padEndLength = daysInLastWeek === 0 || daysInLastWeek === 7 ? 0 : 7 - daysInLastWeek;
    return padEndLength ? new Array(Math.abs(padEndLength)).fill(null).map((_, i)=>{
        // ensure correct next month/year depending on current month
        const nextOrCurrentMonth = month <= 10 ? month + 1 : 0;
        const nextOrCurrentYear = month <= 10 ? year : year + 1;
        const date = new Date(nextOrCurrentYear, nextOrCurrentMonth, 1 + i);
        return (0, $a060cac931c9e211$export$ef7ba876172a4e70)({
            date: date,
            disabled: options.disableDayFn(date),
            next: true
        });
    }) : [];
}
/**
 * Creates an array of arrays of length 7 representing the smallest required amount of full weeks to
 * display a month.
 */ function $60abc6e452f39f85$export$bc3d4e224292e926(year, month, options) {
    const startPad = $60abc6e452f39f85$export$ea0e2983ba38c85e(year, month, options);
    const days = $60abc6e452f39f85$export$148d277a82d0f987(year, month, options);
    const endPad = $60abc6e452f39f85$export$dee4e20cbb4c4b12(startPad.length + days.length, year, month, options);
    const mergedDays = [
        ...startPad,
        ...days,
        ...endPad
    ];
    // splits days in weeks
    const weeks = [];
    for(let i = 0; i < mergedDays.length; i += 7)weeks.push(mergedDays.slice(i, i + 7));
    return weeks;
}


/**
 * Creates an object which keys 'months' and 'years' containing all months required by the
 * calendar component.
 */ function $6cdd5f1a31dcdcdb$export$153a29385a91d598(start, end, options) {
    var _a, _b;
    // passing `new Date()` as prop value in here adds current time that breaks date comparisons,
    // making sure all the received dates from props have default time 00:00:00
    const startDate = (0, $53f5b6dc22264c79$export$f3417f4d288609d9)(start);
    const endDate = (0, $53f5b6dc22264c79$export$f3417f4d288609d9)(end);
    // default function to disable dates outside of calendar range
    const defaultDisableDayFn = (date)=>date < startDate || date > endDate;
    // initialize years
    const months = [];
    const years = new Set([]);
    // maximum amount of required months by provided years
    const monthsLength = (end.getFullYear() - start.getFullYear() + 1) * 12;
    // for each month
    for(let i = 0; i < monthsLength; i += 1){
        // skip irrelevant months unless it's birthday appearance,
        // there we need to have all months till the end of the year,
        // as with 2 selects the user can end up seeing the month outside of range
        if (!(options === null || options === void 0 ? void 0 : options.padFullYear) && (i % 12 < start.getMonth() && i < 11 || i % 12 > end.getMonth() && i >= monthsLength - 11)) continue;
        // current year
        const year = start.getFullYear() + Math.floor(i / 12);
        years.add(year);
        // for each month add an entry
        months.push({
            year: year,
            month: i % 12,
            // weeks are generated by month factory
            weeks: (0, $60abc6e452f39f85$export$bc3d4e224292e926)(year, i % 12, {
                disableDayFn: (_a = options === null || options === void 0 ? void 0 : options.disableDayFn) !== null && _a !== void 0 ? _a : defaultDisableDayFn,
                offset: (_b = options === null || options === void 0 ? void 0 : options.offset) !== null && _b !== void 0 ? _b : 1
            })
        });
    }
    return {
        months: months,
        years: years
    };
}







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
function $f0f60f3eb710c4fa$export$2e2bcd8739ae039(contextName, defaultContextValue) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContextValue);
    function Provider(props) {
        const { children: children } = props, otherProps = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(props, [
            "children"
        ]);
        const value = (0, $acw62.useMemo)(()=>otherProps, Object.values(otherProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: value
        }, children);
    }
    const useContext = ()=>{
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext(Context);
        if (!context) throw new Error(`You forgot to wrap your component with ${contextName}`);
        return context;
    };
    return [
        Provider,
        useContext
    ];
}


const $f7ea18031d1b00f0$var$defaultCalendarMonthContextValue = {
    monthId: '',
    month: 0,
    year: 0,
    weeks: []
};
const [$f7ea18031d1b00f0$export$1f2026fa7f08db1, $f7ea18031d1b00f0$export$18133a67a641ec27] = (0, $f0f60f3eb710c4fa$export$2e2bcd8739ae039)('CalendarMonthContext', $f7ea18031d1b00f0$var$defaultCalendarMonthContextValue);



const $7ddddebd8b39f22d$var$defaultCalendarContextValue = {
    id: '',
    calendar: undefined,
    setMonthsAtATime: ()=>{},
    setPadFullYear: ()=>{},
    setDisplayedMonth: ()=>{},
    onPrev: ()=>{},
    onNext: ()=>{},
    months: [],
    displayedMonth: new Date(),
    startDate: new Date(),
    endDate: new Date()
};
const [$7ddddebd8b39f22d$export$9f35886c694dc2ec, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968] = (0, $f0f60f3eb710c4fa$export$2e2bcd8739ae039)('CalendarContext', $7ddddebd8b39f22d$var$defaultCalendarContextValue);


const $a0c9c7ccd61c53c0$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
function $a0c9c7ccd61c53c0$export$6f8f90ab54e7702e({ startSelected: startSelected, endSelected: endSelected, selected: selected, hoveredDate: hoveredDate, setHoveredDate: setHoveredDate, handleSelect: handleSelect, dayLabel: dayLabel = (d, m, y)=>`${new Date(y, m, d).toLocaleDateString()}`, dayProps: dayProps = ()=>({}), currentDate: currentDate, hoverDayCondition: hoverDayCondition = ()=>false }) {
    const { setDisplayedMonth: setDisplayedMonth } = (0, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968)();
    const { month: month, year: year, weeks: weeks } = (0, $f7ea18031d1b00f0$export$18133a67a641ec27)();
    // mouse over events to update range highlight
    const handleDateEnter = (date)=>{
        setHoveredDate(date);
    };
    const handleDateLeave = ()=>{
        setHoveredDate(endSelected);
    };
    const isRangeHighlight = (date)=>{
        if (startSelected && endSelected) return (0, $53f5b6dc22264c79$export$2b3dc83407dc1cd5)(date, startSelected, endSelected);
        if (startSelected && hoveredDate) return (0, $53f5b6dc22264c79$export$2b3dc83407dc1cd5)(date, startSelected, hoveredDate);
        if (endSelected && hoveredDate) return (0, $53f5b6dc22264c79$export$2b3dc83407dc1cd5)(date, hoveredDate, endSelected);
        return false;
    };
    const isSelected = (date)=>selected && (0, $53f5b6dc22264c79$export$a8b2a21161763694)(date, selected);
    const isStartDate = (date)=>startSelected && (0, $53f5b6dc22264c79$export$a8b2a21161763694)(date, startSelected);
    const isEndDate = (date)=>endSelected && (0, $53f5b6dc22264c79$export$a8b2a21161763694)(date, endSelected);
    const isCurrentDate = (date)=>currentDate && (0, $53f5b6dc22264c79$export$a8b2a21161763694)(date, currentDate);
    const cellClassNames = (date)=>$a0c9c7ccd61c53c0$var$bem.e('cell', {
            selected: isSelected(date),
            start: isStartDate(date),
            end: isEndDate(date),
            range: isRangeHighlight(date),
            current: isCurrentDate(date),
            hover: hoverDayCondition(date)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, weeks.map((days)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: `w-${days[0].date.getFullYear()}-${days[0].date.getMonth()}-${days[0].number}`
        }, days.map(({ number: number, date: date, disabled: disabled, prev: prev, next: next })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`,
                className: cellClassNames(date),
                "aria-disabled": disabled,
                "aria-selected": isSelected(date) || isStartDate(date) || isEndDate(date) ? 'true' : undefined,
                "aria-current": isCurrentDate(date) ? 'date' : undefined
            }, !prev && !next && disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $a0c9c7ccd61c53c0$var$bem.e('btn', 'disabled')
            }, number), !prev && !next && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
                className: $a0c9c7ccd61c53c0$var$bem.e('btn'),
                onClick: (event)=>{
                    setDisplayedMonth(date);
                    handleSelect === null || handleSelect === void 0 || handleSelect(date, event);
                },
                onMouseEnter: ()=>handleDateEnter(date),
                onFocus: ()=>handleDateEnter(date),
                onMouseLeave: handleDateLeave,
                onBlur: handleDateLeave,
                type: "button",
                disabled: disabled,
                "aria-pressed": isSelected(date) || isStartDate(date) || isEndDate(date) ? 'true' : false,
                "aria-label": dayLabel(number, month, year)
            }, dayProps(date)), number))))));
}
$a0c9c7ccd61c53c0$export$6f8f90ab54e7702e.displayName = 'CalendarBody';
$a0c9c7ccd61c53c0$export$6f8f90ab54e7702e.propTypes = {
    startSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    endSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    currentDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    handleSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    dayLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    dayProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    hoverDayCondition: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};





var $acw62 = parcelRequire("acw62");


const $d1b353d7a53630fc$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
function $d1b353d7a53630fc$export$88304641f1478298({ controls: controls }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $d1b353d7a53630fc$var$bem.e('controls')
    }, controls);
}



var $acw62 = parcelRequire("acw62");





const $10e5d83e029520a1$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
function $10e5d83e029520a1$export$77af08ed164baa7({ days: days }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, days.map(({ short: short, long: long })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            scope: "col",
            key: short,
            className: $10e5d83e029520a1$var$bem.e('cell'),
            "aria-label": long
        }, short))));
}
$10e5d83e029520a1$export$77af08ed164baa7.propTypes = {
    days: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        short: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        long: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
    })).isRequired
};


const $95dd7968da83368a$export$2dfff351587a389 = [
    'list',
    'compact',
    'birthday'
];



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




function $5a4300f688a2506e$export$991e93d9fd1eeb83(props) {
    const { id: id, onPrev: onPrev } = (0, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968)();
    const { monthId: monthId } = (0, $f7ea18031d1b00f0$export$18133a67a641ec27)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), Object.assign({
        appearance: "link",
        display: "square",
        id: `${id}-calendar-prev-button`,
        onClick: onPrev,
        "aria-controls": monthId
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
        InlineIcon: (0, $0084abf155b67209$export$60b42ba963c1b0af),
        "aria-hidden": "true"
    }));
}
function $5a4300f688a2506e$export$38c53968fead39bb(props) {
    const { id: id, onNext: onNext } = (0, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968)();
    const { monthId: monthId } = (0, $f7ea18031d1b00f0$export$18133a67a641ec27)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), Object.assign({
        appearance: "link",
        display: "square",
        id: `${id}-calendar-next-button`,
        onClick: onNext,
        "aria-controls": monthId
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
        InlineIcon: (0, $5b3ef7dcc370811e$export$e2df95fe2abd6d02),
        "aria-hidden": "true"
    }));
}







var $acw62 = parcelRequire("acw62");

var $d25eac0ff23d3e88$export$2e2bcd8739ae039 = {
    raw: ".hcr-select-16-4-0{position:relative}.hcr-select__info-16-4-0:not(:empty){color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin-top:var(--hcr-spacing-1)}.hcr-select__info-16-4-0:not(:empty)~.hcr-select__info-16-4-0{margin-top:var(--hcr-spacing-half)}.hcr-select--error-16-4-0 .hcr-select__info-16-4-0{color:var(--hcr-danger-dark-color)}.hcr-select__info-16-4-0~.hcr-select__info-16-4-0{color:var(--hcr-content-primary-color)}.hcr-select-16-4-0:after,.hcr-select-16-4-0:before{pointer-events:none;right:var(--hcr-spacing-2);top:calc(calc(var(--hcr-line-height-primary)/2 + var(--hcr-spacing-2) - var(--hcr-spacing-half)) - min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))/2)}@media (min-width:1200px){.hcr-select-16-4-0:after,.hcr-select-16-4-0:before{top:calc(calc(var(--hcr-line-height-primary) + var(--hcr-spacing-half)) + calc(var(--hcr-line-height-primary)/2 + var(--hcr-spacing-1) - 1px) - min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))/2)}}.hcr-select-16-4-0:after{background-color:var(--hcr-content-primary-color);content:\"\";height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M18.68\\ 8.3a1\\ 1\\ 0\\ 00-1.41\\ 0l-5.28\\ 5.28-5.26-5.27a1\\ 1\\ 0\\ 00-1.4\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.41l5.96\\ 5.99a1\\ 1\\ 0\\ 001.41\\ 0l5.98-6a1\\ 1\\ 0\\ 000-1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);position:absolute;width:1.5rem}.hcr-select--error-16-4-0:after,.hcr-select--valid-16-4-0:after{right:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4))}.hcr-select--no-label-16-4-0:after,.hcr-select--no-label-16-4-0:before{top:calc(calc(var(--hcr-line-height-primary)/2 + var(--hcr-spacing-2) - var(--hcr-spacing-half)) - min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))/2)}@media (min-width:1200px){.hcr-select--no-label-16-4-0:after,.hcr-select--no-label-16-4-0:before{top:calc(calc(var(--hcr-line-height-primary)/2 + var(--hcr-spacing-1) - 1px) - min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))/2)}}.hcr-select__container-16-4-0{align-items:center;background-color:var(--hcr-box-bg-color);border:1px solid var(--hcr-input-border-color);border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-primary-color);display:grid;grid-template-areas:\"left-inline-label left-icon text-input controllers right-icon feedback-icon right-inline-label\";grid-template-columns:repeat(2,max-content) 1fr repeat(4,max-content);min-height:var(--hcr-input-height-mobile);overflow:hidden;position:relative;z-index:0}@media (min-width:1200px){.hcr-select__container-16-4-0{min-height:var(--hcr-input-height-desktop)}}.hcr-select--error-16-4-0 .hcr-select__container-16-4-0{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color));border-color:var(--hcr-danger-color)}.hcr-select--active-16-4-0 .hcr-select__container-16-4-0,.hcr-select__container-16-4-0:has(:focus-visible){box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-select__icon-16-4-0,.hcr-select__icon-16-4-0.hcr-icon-16-4-0{flex-shrink:0;font-size:1.5rem;grid-area:left-icon;height:1.5rem;line-height:1.5rem;margin-left:var(--hcr-spacing-2);margin-right:var(--hcr-spacing-2);max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);pointer-events:none;position:relative;width:1.5rem;z-index:1}@supports (font-size:min(1.5rem,var(--hcr-spacing-4 ))){.hcr-select__icon-16-4-0,.hcr-select__icon-16-4-0.hcr-icon-16-4-0{font-size:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4));line-height:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))}}.hcr-select__icon-16-4-0.hcr-icon-16-4-0:before,.hcr-select__icon-16-4-0:before{height:1.5rem;margin-left:0;margin-right:0;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}.hcr-select__inline-label-16-4-0{align-items:center;align-self:stretch;border-right:1px solid var(--hcr-input-border-color);display:flex;grid-area:left-inline-label;padding:0 var(--hcr-spacing-2);z-index:1}.hcr-select__field-16-4-0,.hcr-select__inline-label-16-4-0{line-height:var(--hcr-line-height-primary);position:relative}.hcr-select__field-16-4-0{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;color:var(--hcr-content-primary-color);font-family:inherit;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);grid-column:left-icon-start/feedback-icon-end;grid-row:1;min-height:100%;padding:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half) - 1px) var(--hcr-spacing-2);padding-right:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4));text-overflow:ellipsis;width:100%}@media (min-width:1200px){.hcr-select__field-16-4-0{padding-bottom:calc(var(--hcr-spacing-1) - 1px);padding-top:calc(var(--hcr-spacing-1) - 1px)}}.hcr-select__field-16-4-0::placeholder{color:var(--hcr-content-secondary-color);font-style:italic;opacity:1}.hcr-select__field-16-4-0:enabled:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-select__field-16-4-0:enabled:focus{outline:none}.hcr-select__field-16-4-0::-ms-expand{display:none}.hcr-select__field-16-4-0[disabled]{cursor:not-allowed}.hcr-select__field-16-4-0:not([multiple]) optgroup,.hcr-select__field-16-4-0:not([multiple]) option{background:var(--hcr-box-bg-color);color:var(--hcr-content-primary-color)}.hcr-select__icon-16-4-0~.hcr-select__field-16-4-0{padding-left:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4))}.hcr-select--error-16-4-0 .hcr-select__field-16-4-0,.hcr-select--valid-16-4-0 .hcr-select__field-16-4-0{padding-right:calc(2*min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-6))}.hcr-select--error-16-4-0:before,.hcr-select--valid-16-4-0:before{content:\"\";max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);position:absolute;z-index:1}.hcr-select--error-16-4-0:before{background-color:var(--hcr-danger-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-select--valid-16-4-0:before{background-color:var(--hcr-success-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-select--error-16-4-0 .hcr-select__field-16-4-0{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-select--error-16-4-0 .hcr-select__field-16-4-0:enabled:hover{background-image:var(--hcr-hover-layer-color),linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-select--disabled-16-4-0{opacity:var(--hcr-disabled-element-opacity)}.hcr-select--disabled-16-4-0 .hcr-select__field-16-4-0{cursor:not-allowed}.hcr-select--multiple-16-4-0.hcr-select-16-4-0:after{display:none}.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0{height:auto;padding-right:var(--hcr-spacing-2)}.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0 option{border-radius:var(--hcr-border-radius-1);margin:var(--hcr-spacing-1)0;padding:var(--hcr-spacing-half)}.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0:enabled option:enabled:hover,.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0:enabled option[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0:enabled option:enabled:active,.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0:enabled option[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-select--multiple-16-4-0.hcr-select-16-4-0 .hcr-select__field-16-4-0:disabled{overflow:hidden}.hcr-select--multiple-16-4-0.hcr-select--error-16-4-0 .hcr-select__field-16-4-0,.hcr-select--multiple-16-4-0.hcr-select--valid-16-4-0 .hcr-select__field-16-4-0{padding-right:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-6))}.hcr-select--multiple-16-4-0.hcr-select--error-16-4-0:before,.hcr-select--multiple-16-4-0.hcr-select--valid-16-4-0:before{right:var(--hcr-spacing-4)}",
    map: {
        "hcr-select": "hcr-select-16-4-0",
        "hcr-select__info": "hcr-select__info-16-4-0",
        "hcr-select--error": "hcr-select--error-16-4-0",
        "hcr-select--valid": "hcr-select--valid-16-4-0",
        "hcr-select--no-label": "hcr-select--no-label-16-4-0",
        "hcr-select__container": "hcr-select__container-16-4-0",
        "hcr-select--active": "hcr-select--active-16-4-0",
        "hcr-select__icon": "hcr-select__icon-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-select__inline-label": "hcr-select__inline-label-16-4-0",
        "hcr-select__field": "hcr-select__field-16-4-0",
        "hcr-select--disabled": "hcr-select--disabled-16-4-0",
        "hcr-select--multiple": "hcr-select--multiple-16-4-0"
    }
};







var $acw62 = parcelRequire("acw62");

function $7506893090a2c069$export$2e2bcd8739ae039(_a) {
    var { placeholder: placeholder, value: value, children: children } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "placeholder",
        "value",
        "children"
    ]);
    if (placeholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        key: "placeholder",
        value: value,
        style: {
            display: 'none'
        }
    }, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", Object.assign({
        value: value
    }, rest), children || value);
}
$7506893090a2c069$export$2e2bcd8739ae039.displayName = 'SelectOption';
$7506893090a2c069$export$2e2bcd8739ae039.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]).isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};





var $acw62 = parcelRequire("acw62");


function $facdcf0d3636fc4c$export$141b3f6b946c04dd(_a) {
    var { id: id, className: className, children: children = '', error: error = false, srOnly: srOnly = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "className",
        "children",
        "error",
        "srOnly"
    ]);
    const srOnlyHelper = srOnly ? (0, $836900889b75b6a5$export$2e2bcd8739ae039)().srOnly : '';
    const idPrefix = error ? 'infoError-' : 'info-';
    const srOnlyPrefix = srOnly ? 'srOnly-' : '';
    const ariaLive = error ? {
        'aria-live': 'assertive',
        role: 'alert'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        id: `${idPrefix}${srOnlyPrefix}${id}`,
        className: `${className} ${srOnlyHelper}`.trim()
    }, ariaLive, rest), children);
}
$facdcf0d3636fc4c$export$141b3f6b946c04dd.displayName = 'InputInfo';
const $facdcf0d3636fc4c$export$52637b497a650311 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node;
$facdcf0d3636fc4c$export$141b3f6b946c04dd.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    children: $facdcf0d3636fc4c$export$52637b497a650311,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    srOnly: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};




var $acw62 = parcelRequire("acw62");

function $dfb8fccc2d2e5ffe$export$30a783b2c1753d17(_a) {
    var { id: id, className: className, children: children } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        id: `inline-label-${id}`,
        className: className
    }, rest), children);
}
$dfb8fccc2d2e5ffe$export$30a783b2c1753d17.displayName = 'InlineLabel';
$dfb8fccc2d2e5ffe$export$30a783b2c1753d17.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired
};





var $acw62 = parcelRequire("acw62");



/**
 * Validates label props based on acceptable Label text prop.
 */ const $1d03adf1ac923b0d$export$a274f689f170c939 = (componentName = 'Input')=>({ 'aria-label': ariaLabel, label: label })=>{
        if (!ariaLabel && !label) return new Error(`${componentName} component requires either a label or aria-label.`);
        if (label && typeof label !== 'string' && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(label)) return new Error(`${componentName} component only accepts a "Label" component or a valid ReactElement as label, but received ${$175aa43345204302$export$cb26d1ee6764af05(label)}.`);
        return null;
    };



var $acw62 = parcelRequire("acw62");



/**
 * Enhances Icon or Button with Input class names depending on the component type.
 * @param icon Icon or Button component
 * @param extraClasses classNames to inject on the icon
 * @returns Enhanced Icon or Button component for Input component
 */ function $489b871d42960a96$export$7a16b93ab59a9b28(icon, extraClasses) {
    if ($175aa43345204302$export$2dabafa86f11ed64(icon, 'Button')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
        display: 'square',
        appearance: 'link',
        size: 'sm',
        extraClasses: $fc332675fdeb2380$export$8f628de5a2ade1fd(icon, extraClasses)
    });
    if ($175aa43345204302$export$2dabafa86f11ed64(icon, 'Icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(icon, {
        extraClasses: $fc332675fdeb2380$export$8f628de5a2ade1fd(icon, extraClasses),
        size: 4
    });
    return icon;
}
function $489b871d42960a96$export$a5365f35436fab43() {
    return ({ iconLeft: iconLeft, iconRight: iconRight })=>{
        if (iconLeft && !$175aa43345204302$export$2dabafa86f11ed64(iconLeft, 'Icon') && !$175aa43345204302$export$2dabafa86f11ed64(iconLeft, 'Button')) return new Error(`Input component only accepts "Icon" or "Button" component as iconLeft, but received ${$175aa43345204302$export$cb26d1ee6764af05(iconLeft)}.`);
        if (iconRight && !$175aa43345204302$export$2dabafa86f11ed64(iconRight, 'Icon') && !$175aa43345204302$export$2dabafa86f11ed64(iconRight, 'Button')) return new Error(`Input component only accepts "Icon" or "Button" component as iconRight, but received ${$175aa43345204302$export$cb26d1ee6764af05(iconRight)}.`);
        return null;
    };
}



const $6ea345f069896cae$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('select', (0, $d25eac0ff23d3e88$export$2e2bcd8739ae039));
function $6ea345f069896cae$export$ef9b1a59e592288f(_a) {
    var { active: active = false, disabled: disabled = false, multiple: multiple = false, extraClasses: extraClasses, id: id, label: label, valid: valid, requiredText: requiredText, icon: icon, info: info, infoError: infoError, inlineLabel: inlineLabel, innerRef: innerRef, placeholder: placeholder, children: children, required: required, 'aria-describedby': ariaDescribedBy } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "active",
        "disabled",
        "multiple",
        "extraClasses",
        "id",
        "label",
        "valid",
        "requiredText",
        "icon",
        "info",
        "infoError",
        "inlineLabel",
        "innerRef",
        "placeholder",
        "children",
        "required",
        'aria-describedby'
    ]);
    const describedByIds = $fc332675fdeb2380$export$db93d21cb888fc59(id, {
        inlineLabel: inlineLabel,
        info: info,
        ariaDescribedBy: ariaDescribedBy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $6ea345f069896cae$var$bem.b({
            valid: valid === true,
            error: valid === false,
            disabled: disabled,
            multiple: multiple,
            active: active,
            'no-label': !label
        }, extraClasses)
    }, label && $fc332675fdeb2380$export$cfe90020b316e423({
        label: label,
        inputId: id,
        bem: $6ea345f069896cae$var$bem,
        requiredText: requiredText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $6ea345f069896cae$var$bem.e('container')
    }, inlineLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfb8fccc2d2e5ffe$export$30a783b2c1753d17), {
        id: id,
        className: $6ea345f069896cae$var$bem.e('inline-label')
    }, inlineLabel), icon && (0, $489b871d42960a96$export$7a16b93ab59a9b28)(icon, $6ea345f069896cae$var$bem.e('icon')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", Object.assign({
        ref: innerRef,
        id: id,
        className: $6ea345f069896cae$var$bem.e('field'),
        required: required,
        disabled: disabled,
        multiple: multiple,
        "aria-errormessage": `infoError-${id}`,
        "aria-describedby": describedByIds
    }, valid === false && {
        'aria-invalid': true
    }, rest), placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7506893090a2c069$export$2e2bcd8739ae039), {
        value: "",
        placeholder: placeholder
    }), children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        error: true,
        id: id,
        className: $6ea345f069896cae$var$bem.e('info')
    }, infoError), info && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: id,
        className: $6ea345f069896cae$var$bem.e('info')
    }, info));
}
$6ea345f069896cae$export$ef9b1a59e592288f.displayName = 'Select';
$6ea345f069896cae$export$ef9b1a59e592288f.propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    label: (0, $1d03adf1ac923b0d$export$a274f689f170c939)('Select'),
    children (props) {
        const isSelectOptionErr = (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('SelectOption')(props, 'children', 'Select');
        const isSelectOptGroupErr = (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('SelectOptGroup')(props, 'children', 'Select');
        if (isSelectOptionErr === null || isSelectOptGroupErr === null) return null;
        return new Error('"Select" requires "children" of types "SelectOption" or "SelectOptGroup".');
    },
    requiredText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    icon: (0, $489b871d42960a96$export$a5365f35436fab43)(),
    info: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    infoError: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    inlineLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $6ea345f069896cae$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($6ea345f069896cae$export$ef9b1a59e592288f, (0, $d25eac0ff23d3e88$export$2e2bcd8739ae039));



const $56ae55986a96eff0$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar-header', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
/** @since 16.0.0 */ function $56ae55986a96eff0$export$6a017b168bebd4da({ prevButtonProps: prevButtonProps = {
    'aria-label': 'Previous month'
}, nextButtonProps: nextButtonProps = {
    'aria-label': 'Next month'
}, selectProps: selectProps = {
    'aria-label': 'Select month and year'
} }) {
    const { calendar: calendar, months: months, displayedMonth: displayedMonth, setDisplayedMonth: setDisplayedMonth, startDate: startDate, endDate: endDate } = (0, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968)();
    const { monthId: monthId } = (0, $f7ea18031d1b00f0$export$18133a67a641ec27)();
    const onChangeHandler = (e)=>{
        setDisplayedMonth(new Date(e.target.value));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $56ae55986a96eff0$var$bem.b('compact')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5a4300f688a2506e$export$991e93d9fd1eeb83), Object.assign({
        disabled: (0, $53f5b6dc22264c79$export$a18c89cbd24170ff)(displayedMonth, startDate)
    }, prevButtonProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ea345f069896cae$export$2e2bcd8739ae039), Object.assign({
        extraClasses: $56ae55986a96eff0$var$bem.e('select'),
        id: `${monthId}-month-year-select`,
        value: new Date(displayedMonth.getFullYear(), displayedMonth.getMonth(), 1).toDateString(),
        onChange: onChangeHandler,
        "aria-controls": monthId
    }, selectProps), calendar === null || calendar === void 0 ? void 0 : calendar.months.map(({ month: month, year: year })=>{
        const dateString = new Date(year, month, 1).toDateString();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7506893090a2c069$export$2e2bcd8739ae039), {
            key: dateString,
            value: dateString
        }, `${months[month]} ${year}`);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5a4300f688a2506e$export$38c53968fead39bb), Object.assign({
        disabled: (0, $53f5b6dc22264c79$export$a18c89cbd24170ff)(displayedMonth, endDate)
    }, nextButtonProps)));
}
$56ae55986a96eff0$export$6a017b168bebd4da.propTypes = {
    prevButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({}),
    nextButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({}),
    selectProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({})
};



var $acw62 = parcelRequire("acw62");








const $10a36b3404443171$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar-header', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
/** @since 16.0.0 */ function $10a36b3404443171$export$d3cb071a5e86b3dc({ selectMonthProps: selectMonthProps = {
    'aria-label': 'Select month'
}, selectYearProps: selectYearProps = {
    'aria-label': 'Select year'
} }) {
    const { calendar: calendar, months: months, displayedMonth: displayedMonth, setDisplayedMonth: setDisplayedMonth, startDate: startDate, endDate: endDate, setPadFullYear: setPadFullYear } = (0, $7ddddebd8b39f22d$export$a4e6a44ee6f2e968)();
    const { monthId: monthId } = (0, $f7ea18031d1b00f0$export$18133a67a641ec27)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPadFullYear(true);
    }, []);
    const onMonthChange = (e)=>{
        setDisplayedMonth(new Date(displayedMonth.getFullYear(), months.findIndex((month)=>month === e.target.value), 1));
    };
    const onYearChange = (e)=>{
        setDisplayedMonth(new Date(parseInt(e.target.value, 10), displayedMonth.getMonth(), 1));
    };
    const yearsArray = calendar && Array.from(calendar.years);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $10a36b3404443171$var$bem.b('birthday')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ea345f069896cae$export$2e2bcd8739ae039), Object.assign({
        extraClasses: $10a36b3404443171$var$bem.e('select'),
        id: `${monthId}-month-select`,
        onChange: onMonthChange,
        value: months[displayedMonth.getMonth()],
        "aria-controls": monthId
    }, selectMonthProps), months.map((month, index)=>{
        const optionDate = new Date(displayedMonth.getFullYear(), index, 1);
        // disable month options that are outside the start/end range
        const isOptionEnabled = (0, $53f5b6dc22264c79$export$2b3dc83407dc1cd5)(optionDate, startDate, endDate) || (0, $53f5b6dc22264c79$export$a18c89cbd24170ff)(optionDate, startDate) || (0, $53f5b6dc22264c79$export$a18c89cbd24170ff)(optionDate, endDate);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7506893090a2c069$export$2e2bcd8739ae039), {
            key: month,
            value: month,
            disabled: !isOptionEnabled
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ea345f069896cae$export$2e2bcd8739ae039), Object.assign({
        extraClasses: $10a36b3404443171$var$bem.e('select'),
        id: `${monthId}-year-select`,
        onChange: onYearChange,
        value: displayedMonth.getFullYear(),
        "aria-controls": monthId
    }, selectYearProps), yearsArray === null || yearsArray === void 0 ? void 0 : yearsArray.map((year)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7506893090a2c069$export$2e2bcd8739ae039), {
            key: year,
            value: year
        }))));
}
$10a36b3404443171$export$d3cb071a5e86b3dc.propTypes = {
    selectMonthProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({}),
    selectYearProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({})
};




const $b22922e93429e0c9$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('calendar', (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));
/** @since 1.3.0 */ function $b22922e93429e0c9$export$e1aef45b828286de(_a) {
    var { months: months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ], days: days = [
        {
            short: 'Mo',
            long: 'Monday'
        },
        {
            short: 'Tu',
            long: 'Tuesday'
        },
        {
            short: 'We',
            long: 'Wednesday'
        },
        {
            short: 'Th',
            long: 'Thursday'
        },
        {
            short: 'Fr',
            long: 'Friday'
        },
        {
            short: 'Sa',
            long: 'Saturday'
        },
        {
            short: 'Su',
            long: 'Sunday'
        }
    ], firstDayOfWeek: firstDayOfWeek = 1, selected: selected, showCurrentDate: showCurrentDate = false, startSelected: startSelected, defaultMonth: defaultMonthProp, endSelected: endSelected, startDate: startDate = new Date(), endDate: endDateProp, handleSelect: handleSelect = ()=>null, flat: flat = false, horizontal: horizontal = false, appearance: appearance = 'list', calendarHeader: calendarHeader, hidden: hidden = false, compactPrevButton: compactPrevButton = {
        'aria-label': 'Previous month'
    }, compactNextButton: compactNextButton = {
        'aria-label': 'Next month'
    }, compactSelect: compactSelect = {
        'aria-label': 'Select month and year'
    }, birthdaySelectMonth: birthdaySelectMonth = {
        'aria-label': 'Select month'
    }, birthdaySelectYear: birthdaySelectYear = {
        'aria-label': 'Select year'
    }, dayLabel: dayLabel = (day, month, year)=>`${new Date(year, month, day).toLocaleDateString()}`, dayProps: dayProps = ()=>({}), disableDayCondition: disableDayCondition, controls: controls, hoverDayCondition: hoverDayCondition, testCalendar: testCalendar, id: id, extraClasses: extraClasses, multiSelectable: multiSelectable = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "months",
        "days",
        "firstDayOfWeek",
        "selected",
        "showCurrentDate",
        "startSelected",
        "defaultMonth",
        "endSelected",
        "startDate",
        "endDate",
        "handleSelect",
        "flat",
        "horizontal",
        "appearance",
        "calendarHeader",
        "hidden",
        "compactPrevButton",
        "compactNextButton",
        "compactSelect",
        "birthdaySelectMonth",
        "birthdaySelectYear",
        "dayLabel",
        "dayProps",
        "disableDayCondition",
        "controls",
        "hoverDayCondition",
        "testCalendar",
        "id",
        "extraClasses",
        "multiSelectable"
    ]);
    // default values
    const defaultMonth = defaultMonthProp || new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const endDate = endDateProp || new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    /**
   * This variable is here while we keep the deprecated appearance to handle both cases.
   * When appearance is gone this should be:
   *
   * shouldRenderCaption = !calendarHeader; -> Just render the caption if calendarHeader is undefined.
   **/ const shouldRenderCaption = appearance === 'list' && !calendarHeader;
    const [calendar, setCalendar] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(testCalendar);
    const [displayedMonth, setDisplayedMonth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultMonth);
    const [displayedCalendar, setDisplayedCalendar] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(testCalendar);
    const [hoveredDate, setHoveredDate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(endSelected);
    /**
   * monthsAtATime: limits the amount of months displayed at one time.
   *   - if monthsAtATime == 0: renders all months in a sequence, no limitation.
   *
   * setMonthsAtATime: Specific headers can set this (e.g.: simple header).
   *
   * Initial value is set by the calendarHeader. If no calendarHeader is rendered then is 0 if appearance is list.
   */ const [monthsAtATime, setMonthsAtATime] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(shouldRenderCaption ? 0 : 1);
    const [padFullYear, setPadFullYear] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // if calendar changes recompute displayedCalendar
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let displayedCalendar = calendar;
        if (calendar && displayedMonth && monthsAtATime > 0) {
            const lastDisplayedMonth = new Date(displayedMonth.getFullYear(), displayedMonth.getMonth() + monthsAtATime, 0);
            const displayedMonths = calendar.months.filter(({ year: year, month: month })=>{
                return (0, $53f5b6dc22264c79$export$9ae2fcb84de26ead)(new Date(year, month, 1), displayedMonth, lastDisplayedMonth);
            });
            displayedCalendar = Object.assign(Object.assign({}, calendar), {
                months: displayedMonths.length > 0 ? displayedMonths : [
                    calendar.months[0]
                ]
            });
        }
        setDisplayedCalendar(displayedCalendar);
    }, [
        calendar,
        monthsAtATime,
        displayedMonth
    ]);
    // updating the calendar when changing the defaultMonth
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // we won't set month if the value provided is outside of start/end date range
        if (defaultMonth > startDate && defaultMonth < endDate) setDisplayedMonth(defaultMonth);
    }, [
        // we only need to recalculate this once the day changes
        defaultMonth.getDate(),
        defaultMonth.getMonth(),
        defaultMonth.getFullYear(),
        startDate.getDate(),
        startDate.getMonth(),
        startDate.getFullYear(),
        endDate.getDate(),
        endDate.getMonth(),
        endDate.getFullYear()
    ]);
    // is start/end/weekStart change, recalculate calendar
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setCalendar((0, $6cdd5f1a31dcdcdb$export$153a29385a91d598)(startDate, endDate, {
            offset: firstDayOfWeek,
            disableDayFn: disableDayCondition,
            padFullYear: padFullYear
        }));
    }, [
        startDate.getDate(),
        startDate.getMonth(),
        startDate.getFullYear(),
        endDate.getDate(),
        endDate.getMonth(),
        endDate.getFullYear(),
        firstDayOfWeek,
        disableDayCondition,
        padFullYear
    ]);
    const onPrev = ()=>{
        setDisplayedMonth(new Date(displayedMonth.getFullYear(), displayedMonth.getMonth() - 1, 1));
    };
    const onNext = ()=>{
        setDisplayedMonth(new Date(displayedMonth.getFullYear(), displayedMonth.getMonth() + 1, 1));
    };
    // Handles deprecated `appearance` prop to render the calendar header.
    const deprecatedCalendarHeader = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (appearance === 'compact') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ae55986a96eff0$export$6a017b168bebd4da), {
            prevButtonProps: compactPrevButton,
            nextButtonProps: compactNextButton,
            selectProps: compactSelect
        });
        if (appearance === 'birthday') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $10a36b3404443171$export$d3cb071a5e86b3dc), {
            selectMonthProps: birthdaySelectMonth,
            selectYearProps: birthdaySelectYear
        });
        return null;
    }, [
        appearance,
        compactPrevButton,
        compactNextButton,
        compactSelect,
        birthdaySelectMonth,
        birthdaySelectYear
    ]);
    const isMultiSelectable = multiSelectable || startSelected !== undefined || endSelected !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ddddebd8b39f22d$export$9f35886c694dc2ec), {
        id: id,
        months: months,
        calendar: calendar,
        displayedMonth: displayedMonth,
        startDate: startDate,
        endDate: endDate,
        setMonthsAtATime: setMonthsAtATime,
        setPadFullYear: setPadFullYear,
        setDisplayedMonth: setDisplayedMonth,
        onPrev: onPrev,
        onNext: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        id: id,
        className: $b22922e93429e0c9$var$bem.b({
            flat: flat,
            horizontal: horizontal
        }, extraClasses),
        hidden: hidden
    }, rest), controls && horizontal === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1b353d7a53630fc$export$88304641f1478298), {
        controls: controls
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $b22922e93429e0c9$var$bem.e('months')
    }, displayedCalendar === null || displayedCalendar === void 0 ? void 0 : displayedCalendar.months.map(({ month: month, year: year, weeks: weeks })=>{
        const monthId = `${id}-${year}-${month}-grid`;
        const monthTitle = `${months[month]} ${year}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7ea18031d1b00f0$export$1f2026fa7f08db1), {
            key: monthId,
            monthId: monthId,
            month: month,
            year: year,
            weeks: weeks
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $b22922e93429e0c9$var$bem.e('month')
        }, calendarHeader ? calendarHeader : deprecatedCalendarHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
            id: monthId,
            role: "grid",
            className: $b22922e93429e0c9$var$bem.e('table'),
            "aria-multiselectable": isMultiSelectable,
            "aria-label": monthTitle
        }, shouldRenderCaption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
            className: $b22922e93429e0c9$var$bem.e('caption')
        }, monthTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $10e5d83e029520a1$export$77af08ed164baa7), {
            days: days
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0c9c7ccd61c53c0$export$6f8f90ab54e7702e), {
            startSelected: startSelected,
            endSelected: endSelected,
            selected: selected,
            hoveredDate: hoveredDate,
            setHoveredDate: setHoveredDate,
            handleSelect: handleSelect,
            dayLabel: dayLabel,
            dayProps: dayProps,
            currentDate: showCurrentDate ? new Date() : undefined,
            hoverDayCondition: hoverDayCondition
        }))));
    })), controls && horizontal === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d1b353d7a53630fc$export$88304641f1478298), {
        controls: controls
    })));
}
$b22922e93429e0c9$export$e1aef45b828286de.displayName = 'Calendar';
$b22922e93429e0c9$export$e1aef45b828286de.propTypes = {
    months: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string),
    days: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        short: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        long: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
    })),
    firstDayOfWeek: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    startDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    endDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    startSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    endSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    handleSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    flat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    defaultMonth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Date),
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    dayProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    testCalendar: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({}),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    showCurrentDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    disableDayCondition: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    controls: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    hoverDayCondition: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    multiSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    calendarHeader: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    // deprecated props
    appearance: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead.', (props)=>{
        const { appearance: appearance } = props;
        if (appearance && !(0, $95dd7968da83368a$export$2dfff351587a389).includes(appearance)) return new Error(`Invalid value for \`appearance\` prop in \`Calendar\` component. Expected one of ${(0, $95dd7968da83368a$export$2dfff351587a389).join(', ')}.`);
        return null;
    }),
    dayLabel: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `dayProps` prop instead to set `aria-label` on day buttons.', (props)=>{
        const { dayLabel: dayLabel } = props;
        if (dayLabel && typeof dayLabel !== 'function') return new Error('`dayLabel` prop in `Calendar` component must be a function.');
        return null;
    }),
    compactPrevButton: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead."'),
    compactNextButton: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead."'),
    compactSelect: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead."'),
    birthdaySelectMonth: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead."'),
    birthdaySelectYear: (0, $864f56dba4ac147d$export$b90c8e9d5dbcc8c3)('16.0.0', 'Please use `calendarHeader` prop instead."')
};
var $b22922e93429e0c9$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($b22922e93429e0c9$export$e1aef45b828286de, (0, $d2427dd7a97ede3b$export$2e2bcd8739ae039));



function $16b6b9a14647dbb1$export$5c007e10c6929c95(date, dateToCompare) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}
var // Fallback for modularized imports:
$16b6b9a14647dbb1$export$2e2bcd8739ae039 = $16b6b9a14647dbb1$export$5c007e10c6929c95;



var $acw62 = parcelRequire("acw62");

var $02b04304aa1f0dc2$export$56bbcdb8aca31149;
$02b04304aa1f0dc2$export$56bbcdb8aca31149 = `PeriodPicker-zFyDAa-calendar`;




function $43c6d634ecd98fac$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$43c6d634ecd98fac$export$2e2bcd8739ae039 = $43c6d634ecd98fac$export$dd412b56f1e4d8aa;




function $99f40034f45b9aea$export$17c93e242b2d3a22(date, amount) {
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$99f40034f45b9aea$export$2e2bcd8739ae039 = $99f40034f45b9aea$export$17c93e242b2d3a22;




function $e3ff25af357d41d7$export$e16d8520af44a096(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $77dc29417ac8d032$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $99f40034f45b9aea$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $43c6d634ecd98fac$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $9e6f0c9ad494c17a$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
var // Fallback for modularized imports:
$e3ff25af357d41d7$export$2e2bcd8739ae039 = $e3ff25af357d41d7$export$e16d8520af44a096;


function $fc0b49ce51db4bd5$export$ea39ec197993aef0(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateLeft);
    const dateRightStartOfDay = (0, $08eadd31071dba99$export$63fa379ae8a9ba2)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}
var // Fallback for modularized imports:
$fc0b49ce51db4bd5$export$2e2bcd8739ae039 = $fc0b49ce51db4bd5$export$ea39ec197993aef0;




const $b3141db263bb6e26$export$5f84d4e06c0693c4 = ()=>[
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.monday"),
            long: "Monday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.tuesday"),
            long: "Tuesday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.wednesday"),
            long: "Wednesday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.thursday"),
            long: "Thursday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.friday"),
            long: "Friday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.saturday"),
            long: "Saturday"
        },
        {
            short: (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.sunday"),
            long: "Sunday"
        }
    ];
const $b3141db263bb6e26$export$ab152e6ff2cc840e = ()=>[
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.january"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.february"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.march"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.april"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.may"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.june"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.july"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.august"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.september"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.october"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.november"),
        (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.december")
    ];
const $b3141db263bb6e26$export$3ee8fbdbeceaef0e = (earliestStart, start, end)=>{
    if (start && end === undefined) return start;
    return earliestStart;
};
const $b3141db263bb6e26$export$7874fb380758be78 = (latestEnd, start, maxLength)=>{
    if (start && maxLength) return (0, $e3ff25af357d41d7$export$e16d8520af44a096)(start, {
        days: maxLength
    });
    return latestEnd;
};
const $b3141db263bb6e26$export$1862b5e1c8c0d0a = (start, end)=>{
    if (start && end) {
        if ((0, $16b6b9a14647dbb1$export$5c007e10c6929c95)(end, start)) return (0, $1f54b005b1dbfc2e$export$ea26e1acb089409)(start);
        if ((0, $fc0b49ce51db4bd5$export$ea39ec197993aef0)(start, end)) return (0, $1f54b005b1dbfc2e$export$ea26e1acb089409)(start);
        return `${(0, $1f54b005b1dbfc2e$export$ea26e1acb089409)(start)} - ${(0, $1f54b005b1dbfc2e$export$ea26e1acb089409)(end)}`;
    }
    return "";
};






var $acw62 = parcelRequire("acw62");

var $a0ab4994765488fb$export$2e2bcd8739ae039 = {
    raw: ".hcr-input-16-4-0{position:relative}.hcr-input__info-16-4-0:not(:empty){color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin-top:var(--hcr-spacing-1)}.hcr-input__info-16-4-0:not(:empty)~.hcr-input__info-16-4-0{margin-top:var(--hcr-spacing-half)}.hcr-input--error-16-4-0 .hcr-input__info-16-4-0{color:var(--hcr-danger-dark-color)}.hcr-input__info-16-4-0~.hcr-input__info-16-4-0{color:var(--hcr-content-primary-color)}.hcr-input--error-16-4-0 .hcr-input__field-16-4-0,.hcr-input--loading-16-4-0 .hcr-input__field-16-4-0,.hcr-input--valid-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4))}.hcr-input--error-16-4-0 .hcr-input__feedback-icon-16-4-0,.hcr-input--loading-16-4-0 .hcr-input__feedback-icon-16-4-0,.hcr-input--valid-16-4-0 .hcr-input__feedback-icon-16-4-0{max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4)}.hcr-input--loading-16-4-0 .hcr-input__feedback-icon-16-4-0{height:1.5rem;width:1.5rem;--hcr-spinner-progress-internal:25%;--hcr-spinner-color:var(--hcr-ui-primary-dark-color);--hcr-spinner-bg-color:var(--hcr-box-bg-color);--hcr-spinner-line-color:var(--hcr-ui-primary-light-color);animation:spinner-rotate 1s linear infinite;background-image:conic-gradient(var(--hcr-spinner-color) var(--hcr-spinner-progress-internal),var(--hcr-spinner-line-color)0);border-radius:50%}.hcr-input--loading-16-4-0 .hcr-input__feedback-icon-16-4-0:before{background-color:var(--hcr-spinner-bg-color);border-radius:inherit;content:\"\";display:block;inset:var(--hcr-spacing-half);position:absolute;transition:background-color .25s ease}.hcr-input--loading-16-4-0 .hcr-input__feedback-icon--danger-16-4-0{--hcr-spinner-color:var(--hcr-danger-color);--hcr-spinner-line-color:var(--hcr-line-primary-color)}@keyframes spinner-rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.hcr-input--loading-16-4-0:has(.hcr-input__field-16-4-0:enabled:hover) .hcr-input__feedback-icon-16-4-0:before{background-image:var(--hcr-hover-layer-color)}.hcr-input--error-16-4-0 .hcr-input__feedback-icon-16-4-0{background-color:var(--hcr-danger-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm-1\\ 5a1\\ 1\\ 0\\ 012\\ 0v5.5a1\\ 1\\ 0\\ 11-2\\ 0V7zm1\\ 11a1.5\\ 1.5\\ 0\\ 110-3\\ 1.5\\ 1.5\\ 0\\ 010\\ 3z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-input--valid-16-4-0 .hcr-input__feedback-icon-16-4-0{background-color:var(--hcr-success-color);height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-input--error-16-4-0 .hcr-input__field-16-4-0{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-input--error-16-4-0 .hcr-input__field-16-4-0:enabled:hover{background-image:var(--hcr-hover-layer-color),linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-input--disabled-16-4-0{opacity:var(--hcr-disabled-element-opacity)}.hcr-input__container-16-4-0{align-items:center;background-color:var(--hcr-box-bg-color);border:1px solid var(--hcr-input-border-color);border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-primary-color);display:grid;grid-template-areas:\"left-inline-label left-icon text-input controllers right-icon feedback-icon right-inline-label\";grid-template-columns:repeat(2,max-content) 1fr repeat(4,max-content);min-height:var(--hcr-input-height-mobile);overflow:hidden;position:relative;z-index:0}@media (min-width:1200px){.hcr-input__container-16-4-0{min-height:var(--hcr-input-height-desktop)}}.hcr-input--error-16-4-0 .hcr-input__container-16-4-0{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color));border-color:var(--hcr-danger-color)}.hcr-input--active-16-4-0 .hcr-input__container-16-4-0,.hcr-input__container-16-4-0:has(:focus-visible){box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-input__field-16-4-0{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;color:var(--hcr-content-primary-color);font-family:inherit;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);grid-column:left-icon-start/feedback-icon-end;grid-row:1;line-height:var(--hcr-line-height-primary);min-height:100%;padding:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half) - 1px) var(--hcr-spacing-2);position:relative;text-overflow:ellipsis;width:100%}@media (min-width:1200px){.hcr-input__field-16-4-0{padding-bottom:calc(var(--hcr-spacing-1) - 1px);padding-top:calc(var(--hcr-spacing-1) - 1px)}}.hcr-input__field-16-4-0::placeholder{color:var(--hcr-content-secondary-color);font-style:italic;opacity:1}.hcr-input__field-16-4-0[type=date],.hcr-input__field-16-4-0[type=datetime-local],.hcr-input__field-16-4-0[type=month],.hcr-input__field-16-4-0[type=time],.hcr-input__field-16-4-0[type=week]{padding-bottom:calc(var(--hcr-spacing-2) - 4px);padding-top:calc(var(--hcr-spacing-2) - 4px)}@media (min-width:1200px){.hcr-input__field-16-4-0[type=date],.hcr-input__field-16-4-0[type=datetime-local],.hcr-input__field-16-4-0[type=month],.hcr-input__field-16-4-0[type=time],.hcr-input__field-16-4-0[type=week]{padding-bottom:calc(var(--hcr-spacing-1) - 2px);padding-top:calc(var(--hcr-spacing-1) - 2px)}}.hcr-input__field-16-4-0[type=date]::-webkit-inner-spin-button,.hcr-input__field-16-4-0[type=datetime-local]::-webkit-inner-spin-button,.hcr-input__field-16-4-0[type=month]::-webkit-inner-spin-button,.hcr-input__field-16-4-0[type=time]::-webkit-inner-spin-button,.hcr-input__field-16-4-0[type=week]::-webkit-inner-spin-button{-webkit-appearance:none;appearance:none}.hcr-input__field-16-4-0[type=date]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=datetime-local]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=month]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=time]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=week]::-webkit-calendar-picker-indicator{color:#0000;display:block!important;height:var(--hcr-spacing-4);margin-left:0;margin-right:var(--hcr-spacing-2);max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);opacity:1;order:-1;padding:0;width:var(--hcr-spacing-4)}.hcr-input__field-16-4-0[type=date]::-webkit-clear-button,.hcr-input__field-16-4-0[type=datetime-local]::-webkit-clear-button,.hcr-input__field-16-4-0[type=month]::-webkit-clear-button,.hcr-input__field-16-4-0[type=time]::-webkit-clear-button,.hcr-input__field-16-4-0[type=week]::-webkit-clear-button{-webkit-appearance:none;appearance:none;background-color:var(--hcr-content-primary-color);background-image:none;height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0[type=date]::-webkit-calendar-picker-indicator,.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0[type=datetime-local]::-webkit-calendar-picker-indicator,.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0[type=month]::-webkit-calendar-picker-indicator,.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0[type=time]::-webkit-calendar-picker-indicator,.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0[type=week]::-webkit-calendar-picker-indicator{margin-left:calc(-1*(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-2)));opacity:0}.hcr-input__field-16-4-0[type=date]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=datetime-local]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=month]::-webkit-calendar-picker-indicator,.hcr-input__field-16-4-0[type=week]::-webkit-calendar-picker-indicator{background-color:var(--hcr-content-primary-color);background-image:none;height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M19\\ 5h-1V4a1\\ 1\\ 0\\ 00-2\\ 0v1H8V4a1\\ 1\\ 0\\ 00-2\\ 0v1H5a3\\ 3\\ 0\\ 00-3\\ 3v10a3\\ 3\\ 0\\ 003\\ 3h14a3\\ 3\\ 0\\ 003-3V8a3\\ 3\\ 0\\ 00-3-3zm1\\ 13c0\\ .54-.46\\ 1-1\\ 1H5c-.54\\ 0-1-.46-1-1v-7h16v7zM4\\ 9V8c0-.54.46-1\\ 1-1h14c.54\\ 0\\ 1\\ .46\\ 1\\ 1v1H4zm2\\ 4.5a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm-10\\ 3a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M19\\ 5h-1V4a1\\ 1\\ 0\\ 00-2\\ 0v1H8V4a1\\ 1\\ 0\\ 00-2\\ 0v1H5a3\\ 3\\ 0\\ 00-3\\ 3v10a3\\ 3\\ 0\\ 003\\ 3h14a3\\ 3\\ 0\\ 003-3V8a3\\ 3\\ 0\\ 00-3-3zm1\\ 13c0\\ .54-.46\\ 1-1\\ 1H5c-.54\\ 0-1-.46-1-1v-7h16v7zM4\\ 9V8c0-.54.46-1\\ 1-1h14c.54\\ 0\\ 1\\ .46\\ 1\\ 1v1H4zm2\\ 4.5a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm-10\\ 3a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0zm5\\ 0a1\\ 1\\ 0\\ 112\\ 0\\ 1\\ 1\\ 0\\ 01-2\\ 0z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-input__field-16-4-0[type=time]::-webkit-calendar-picker-indicator{background-color:var(--hcr-content-primary-color);background-image:none;height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm3.2-6.2a1\\ 1\\ 0\\ 11-1.4\\ 1.4l-2.5-2.5a1\\ 1\\ 0\\ 01-.3-.7V7a1\\ 1\\ 0\\ 012\\ 0v4.59l2.2\\ 2.2z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm0\\ 18a8\\ 8\\ 0\\ 010-16\\ 8\\ 8\\ 0\\ 010\\ 16zm3.2-6.2a1\\ 1\\ 0\\ 11-1.4\\ 1.4l-2.5-2.5a1\\ 1\\ 0\\ 01-.3-.7V7a1\\ 1\\ 0\\ 012\\ 0v4.59l2.2\\ 2.2z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;width:1.5rem}.hcr-input__field-16-4-0[type=search]::-webkit-search-cancel-button{-webkit-appearance:none;appearance:none;background-color:var(--hcr-content-primary-color);cursor:pointer;height:1.5rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);opacity:1;width:1.5rem}.hcr-input__field-16-4-0:enabled:hover,.hcr-input__field-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-input__field-16-4-0:focus{outline:none}.hcr-input--disabled-16-4-0 .hcr-input__field-16-4-0{cursor:not-allowed}.hcr-input__icon-16-4-0~.hcr-input__field-16-4-0{padding-left:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4))}.hcr-input--has-icon-right-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-4))}.hcr-input--error-16-4-0.hcr-input--has-icon-right-16-4-0 .hcr-input__field-16-4-0,.hcr-input--loading-16-4-0.hcr-input--has-icon-right-16-4-0 .hcr-input__field-16-4-0,.hcr-input--valid-16-4-0.hcr-input--has-icon-right-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(2*min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4)) + var(--hcr-spacing-6))}.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(var(--hcr-spacing-4)*2 + var(--hcr-spacing-4) + var(--hcr-spacing-1))}.hcr-input--error-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0,.hcr-input--has-icon-right-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0,.hcr-input--loading-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0,.hcr-input--valid-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(var(--hcr-spacing-4)*3 + var(--hcr-spacing-6) + var(--hcr-spacing-1))}.hcr-input--error-16-4-0.hcr-input--has-icon-right-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0,.hcr-input--loading-16-4-0.hcr-input--has-icon-right-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0,.hcr-input--valid-16-4-0.hcr-input--has-icon-right-16-4-0.hcr-input--has-controllers-16-4-0 .hcr-input__field-16-4-0{padding-right:calc(var(--hcr-spacing-4)*4 + var(--hcr-spacing-8) + var(--hcr-spacing-1))}.hcr-input__feedback-icon-16-4-0{flex-shrink:0;grid-area:feedback-icon;margin-right:var(--hcr-spacing-2);pointer-events:none;z-index:0}.hcr-input-16-4-0:not(.hcr-input--loading-16-4-0,.hcr-input--error-16-4-0,.hcr-input--valid-16-4-0) .hcr-input__feedback-icon-16-4-0{display:none}.hcr-input__inline-label-16-4-0{align-items:center;align-self:stretch;border-right:1px solid var(--hcr-input-border-color);display:flex;grid-area:left-inline-label;line-height:var(--hcr-line-height-primary);padding:0 var(--hcr-spacing-2);position:relative;z-index:1}.hcr-input__field-16-4-0~.hcr-input__inline-label-16-4-0{border-left:1px solid var(--hcr-input-border-color);border-right:0;grid-area:right-inline-label}.hcr-input__controllers-16-4-0{display:flex;gap:var(--hcr-spacing-1);grid-area:controllers;margin-right:var(--hcr-spacing-2)}.hcr-input__controllers-16-4-0 .hcr-input__icon-16-4-0{margin:0}.hcr-input__icon-16-4-0,.hcr-input__icon-16-4-0[class^=hci-icon]{flex-shrink:0;font-size:1.5rem;grid-area:left-icon;height:1.5rem;line-height:1.5rem;margin-left:var(--hcr-spacing-2);margin-right:var(--hcr-spacing-2);max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);pointer-events:none;position:relative;width:1.5rem;z-index:1}@supports (font-size:min(1.5rem,var(--hcr-spacing-4 ))){.hcr-input__icon-16-4-0,.hcr-input__icon-16-4-0[class^=hci-icon]{font-size:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4));line-height:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))}}.hcr-input__icon-16-4-0:before,.hcr-input__icon-16-4-0[class^=hci-icon]:before{height:1.5rem;margin-left:0;margin-right:0;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}.hcr-input__field-16-4-0~.hcr-input__icon-16-4-0,.hcr-input__field-16-4-0~.hcr-input__icon-16-4-0[class^=hci-icon]{grid-area:right-icon;margin-left:0;margin-right:var(--hcr-spacing-2)}.hcr-input-16-4-0 button.hcr-input__icon-16-4-0{pointer-events:auto}.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 .hcr-icon-16-4-0,.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 [class^=hci-icon],.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 flix-icon{height:1.5rem;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 [class^=hci-icon]{font-size:var(--hcr-font-size-small);line-height:var(--hcr-line-height-small)}.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 .hcr-icon-16-4-0{font-size:var(--hcr-spacing-4);line-height:var(--hcr-spacing-4)}.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 .hcr-icon-16-4-0:before{font-size:1.5rem;height:1.5rem;line-height:1.5rem;margin-left:0;margin-right:0;max-height:calc(var(--hcr-spacing-4)*2);max-width:calc(var(--hcr-spacing-4)*2);min-height:var(--hcr-spacing-4);min-width:var(--hcr-spacing-4);width:1.5rem}@supports (font-size:min(1.5rem,var(--hcr-spacing-4 ))){.hcr-input-16-4-0 button.hcr-input__icon-16-4-0 .hcr-icon-16-4-0:before{font-size:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4));line-height:min(max(var(--hcr-spacing-4),1.5rem),2*var(--hcr-spacing-4))}}",
    map: {
        "hcr-input": "hcr-input-16-4-0",
        "hcr-input__info": "hcr-input__info-16-4-0",
        "hcr-input--error": "hcr-input--error-16-4-0",
        "hcr-input--loading": "hcr-input--loading-16-4-0",
        "hcr-input__field": "hcr-input__field-16-4-0",
        "hcr-input--valid": "hcr-input--valid-16-4-0",
        "hcr-input__feedback-icon": "hcr-input__feedback-icon-16-4-0",
        "hcr-input__feedback-icon--danger": "hcr-input__feedback-icon--danger-16-4-0",
        "hcr-input--disabled": "hcr-input--disabled-16-4-0",
        "hcr-input__container": "hcr-input__container-16-4-0",
        "hcr-input--active": "hcr-input--active-16-4-0",
        "hcr-input__icon": "hcr-input__icon-16-4-0",
        "hcr-input--has-icon-right": "hcr-input--has-icon-right-16-4-0",
        "hcr-input--has-controllers": "hcr-input--has-controllers-16-4-0",
        "hcr-input__inline-label": "hcr-input__inline-label-16-4-0",
        "hcr-input__controllers": "hcr-input__controllers-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0"
    }
};








var $acw62 = parcelRequire("acw62");

const $baeadf941cf41030$export$2c1b53cd56a64039 = [
    'checkbox',
    'date',
    'datetime-local',
    'email',
    'month',
    'number',
    'password',
    'radio',
    'range',
    'search',
    'tel',
    'text',
    'time',
    'url',
    'week'
];


const $7194b19900b29637$export$dd2171e2b7d3bc5b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { id: id, className: className, valid: valid, busy: busy = false, type: type = 'text' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "className",
        "valid",
        "busy",
        "type"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        ref: ref,
        id: id,
        type: type,
        className: className
    }, valid !== undefined && type !== 'radio' && {
        'aria-invalid': !valid
    }, busy && {
        'aria-busy': true
    }, rest));
});
$7194b19900b29637$export$dd2171e2b7d3bc5b.displayName = 'InputField';
$7194b19900b29637$export$dd2171e2b7d3bc5b.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    busy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $baeadf941cf41030$export$2c1b53cd56a64039))
};





const $e1e63ae07ac94f02$export$a201b52747cee7e = [
    'date',
    'datetime-local',
    'email',
    'month',
    'number',
    'password',
    'search',
    'tel',
    'text',
    'time',
    'url',
    'week'
];




const $e0df4954ae6776a3$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('input', (0, $a0ab4994765488fb$export$2e2bcd8739ae039));
function $e0df4954ae6776a3$export$f5b8910cec6cf069(_a) {
    var { extraClasses: extraClasses, label: label, id: id, disabled: disabled = false, valid: valid, loading: loading = false, type: type = 'text', info: info, infoError: infoError, iconLeft: iconLeft, iconRight: iconRight, inlineLabelLeft: inlineLabelLeft, inlineLabelRight: inlineLabelRight, controllers: controllers, 'aria-describedby': ariaDescribedBy, 'aria-errormessage': ariaErrorMessage, innerRef: innerRef, hasInlineLabelAddon: hasInlineLabelAddon = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "label",
        "id",
        "disabled",
        "valid",
        "loading",
        "type",
        "info",
        "infoError",
        "iconLeft",
        "iconRight",
        "inlineLabelLeft",
        "inlineLabelRight",
        "controllers",
        'aria-describedby',
        'aria-errormessage',
        "innerRef",
        "hasInlineLabelAddon"
    ]);
    const classNames = $e0df4954ae6776a3$var$bem.b({
        disabled: disabled,
        'has-icon-right': iconRight,
        'has-controllers': controllers,
        error: !loading && valid === false,
        valid: !loading && valid === true,
        loading: loading
    }, extraClasses);
    /**
   * Creates prioritized description id value by pushing all possible descriptions in order;
   * 1st: the left inline label (if present);
   * 2nd: the right inline label (if present);
   * 3rd: the inputInfo id (if `info` is present));
   */ const describedByIds = $fc332675fdeb2380$export$db93d21cb888fc59(id, {
        inlineLabelLeft: inlineLabelLeft && !hasInlineLabelAddon,
        inlineLabelRight: inlineLabelRight,
        info: info,
        ariaDescribedBy: ariaDescribedBy
    });
    const errorMessageIds = $fc332675fdeb2380$export$cb36ad43b7a7e4d6(id, {
        ariaErrorMessage: ariaErrorMessage,
        infoError: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames
    }, label && $fc332675fdeb2380$export$cfe90020b316e423({
        label: label,
        inputId: id,
        bem: $e0df4954ae6776a3$var$bem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $e0df4954ae6776a3$var$bem.e('container')
    }, inlineLabelLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfb8fccc2d2e5ffe$export$30a783b2c1753d17), {
        id: `left-${id}`,
        className: $e0df4954ae6776a3$var$bem.e('inline-label')
    }, inlineLabelLeft), iconLeft && (0, $489b871d42960a96$export$7a16b93ab59a9b28)(iconLeft, $e0df4954ae6776a3$var$bem.e('icon')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7194b19900b29637$export$dd2171e2b7d3bc5b), Object.assign({
        ref: innerRef,
        id: id,
        className: $e0df4954ae6776a3$var$bem.e('field'),
        type: type,
        disabled: disabled,
        valid: valid,
        "aria-describedby": describedByIds,
        "aria-errormessage": errorMessageIds,
        busy: loading
    }, rest)), controllers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $e0df4954ae6776a3$var$bem.e('controllers')
    }, controllers.map((controller)=>(0, $489b871d42960a96$export$7a16b93ab59a9b28)(controller, $e0df4954ae6776a3$var$bem.e('icon')))), iconRight && (0, $489b871d42960a96$export$7a16b93ab59a9b28)(iconRight, $e0df4954ae6776a3$var$bem.e('icon')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $e0df4954ae6776a3$var$bem.e('feedback-icon'),
        "aria-hidden": "true"
    }), inlineLabelRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dfb8fccc2d2e5ffe$export$30a783b2c1753d17), {
        id: `right-${id}`,
        className: $e0df4954ae6776a3$var$bem.e('inline-label')
    }, inlineLabelRight)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: id,
        error: true,
        className: $e0df4954ae6776a3$var$bem.e('info')
    }, valid === false ? infoError : ''), info && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: id,
        className: $e0df4954ae6776a3$var$bem.e('info')
    }, info));
}
$e0df4954ae6776a3$export$f5b8910cec6cf069.displayName = 'Input';
$e0df4954ae6776a3$export$f5b8910cec6cf069.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    label: (0, $1d03adf1ac923b0d$export$a274f689f170c939)(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $e1e63ae07ac94f02$export$a201b52747cee7e)),
    info: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    infoError: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    iconLeft: (0, $489b871d42960a96$export$a5365f35436fab43)(),
    iconRight: (0, $489b871d42960a96$export$a5365f35436fab43)(),
    inlineLabelLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    inlineLabelRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    hasInlineLabelAddon: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $e0df4954ae6776a3$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($e0df4954ae6776a3$export$f5b8910cec6cf069, (0, $a0ab4994765488fb$export$2e2bcd8739ae039));


parcelRequire("acw62");

const $889b6312d81178d0$var$CalendarInput = ({ label: label, required: required, preventAutoFocus: preventAutoFocus = false, placeholder: placeholder, errorMessage: errorMessage, value: value, onFocus: onFocus })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0df4954ae6776a3$export$2e2bcd8739ae039), {
        label: label + (required ? " *" : ""),
        id: "period-input",
        value: value,
        readOnly: true,
        onFocus: onFocus,
        tabIndex: preventAutoFocus ? -1 : undefined,
        placeholder: placeholder || formatMessage({
            id: "general.select"
        }),
        iconRight: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
            InlineIcon: (0, $b271bcddec93d9b1$export$403194946ee83bdf)
        }),
        valid: errorMessage ? false : undefined,
        infoError: errorMessage || undefined
    });
};
var $889b6312d81178d0$export$2e2bcd8739ae039 = $889b6312d81178d0$var$CalendarInput;





var $acw62 = parcelRequire("acw62");

var $7d921d227d67dd88$var$_excluded = [
    "title",
    "pathRest"
];
var $7d921d227d67dd88$export$7b7ad8f03d93a9da = function IconPlus(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $7d921d227d67dd88$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-plus"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M21 11h-8V3a1 1 0 0 0-2 0v8H3a1 1 0 0 0 0 2h8v8a1 1 0 0 0 2 0v-8h8a1 1 0 0 0 0-2"
    }, pathRest)));
};
$7d921d227d67dd88$export$7b7ad8f03d93a9da.displayName = 'InlineIcon(IconPlus)';
$7d921d227d67dd88$export$7b7ad8f03d93a9da.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};




var $acw62 = parcelRequire("acw62");

var $563f264b69239c0e$export$2e2bcd8739ae039 = {
    raw: ".hcr-tag-16-4-0{--hcr-tag-color:var(--hcr-grayscale-50-color);--hcr-tag-background-color:var(--hcr-tag-color);--hcr-tag-border-color:var(--hcr-tag-color);--hcr-tag-text-color:var(--hcr-grayscale-100-color);color:var(--hcr-tag-text-color);font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);line-height:var(--hcr-line-height-primary)}.hcr-tag-16-4-0:not([hidden]){display:inline-flex}.hcr-tag-16-4-0{align-items:center;background-color:var(--hcr-tag-background-color);border:1px solid var(--hcr-tag-border-color);border-radius:var(--hcr-spacing-5);column-gap:var(--hcr-spacing-half);font-family:inherit;max-width:100%;padding:calc(var(--hcr-spacing-half) - 1px) var(--hcr-spacing-2);text-decoration:none;text-overflow:ellipsis;vertical-align:middle;white-space:nowrap}.hcr-tag__icon-16-4-0{color:inherit}.hcr-tag--outlined-16-4-0{--hcr-tag-background-color:var(--hcr-grayscale-0-color)}.hcr-tag--subtle-16-4-0{--hcr-tag-background-color:color-mix(var(--hcr-tag-color),var(--hcr-grayscale-0-color) 88%)}.hcr-tag--ai-16-4-0,.hcr-tag--danger-16-4-0,.hcr-tag--neutral-16-4-0,.hcr-tag--success-16-4-0,.hcr-tag--warning-16-4-0{--hcr-tag-text-color:var(--hcr-grayscale-0-color)}.hcr-tag--ai-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--ai-16-4-0.hcr-tag--subtle-16-4-0,.hcr-tag--danger-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--danger-16-4-0.hcr-tag--subtle-16-4-0,.hcr-tag--neutral-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--neutral-16-4-0.hcr-tag--subtle-16-4-0,.hcr-tag--success-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--success-16-4-0.hcr-tag--subtle-16-4-0,.hcr-tag--warning-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--warning-16-4-0.hcr-tag--subtle-16-4-0{--hcr-tag-text-color:var(--hcr-tag-color)}.hcr-tag--neutral-16-4-0{--hcr-tag-color:var(--hcr-neutral-dark-color)}.hcr-tag--success-16-4-0{--hcr-tag-color:var(--hcr-success-dark-color)}.hcr-tag--warning-16-4-0{--hcr-tag-color:var(--hcr-warning-dark-color)}.hcr-tag--warning-16-4-0.hcr-tag--subtle-16-4-0{--hcr-tag-background-color:color-mix(var(--hcr-warning-color),var(--hcr-grayscale-0-color) 88%)}.hcr-tag--danger-16-4-0{--hcr-tag-color:var(--hcr-danger-dark-color)}.hcr-tag--ai-16-4-0{--hcr-tag-color:var(--hcr-ai-dark-color);background-image:linear-gradient(100deg,color-mix(var(--hcr-tag-color),var(--hcr-grayscale-0-color) 32%),var(--hcr-tag-color))}.hcr-tag--ai-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--ai-16-4-0.hcr-tag--subtle-16-4-0{--hcr-tag-border-color:var(--hcr-ai-color)}.hcr-tag--ai-16-4-0.hcr-tag--subtle-16-4-0{--hcr-tag-background-color:color-mix(var(--hcr-ai-color),var(--hcr-grayscale-0-color) 88%);background-image:linear-gradient(100deg,color-mix(var(--hcr-ai-color),var(--hcr-grayscale-0-color) 95%),color-mix(var(--hcr-ai-color),var(--hcr-grayscale-0-color) 78%))}.hcr-tag--ai-16-4-0.hcr-tag--outlined-16-4-0{background-image:none}.hcr-tag--selected-16-4-0{--hcr-tag-color:var(--hcr-button-primary-color);--hcr-tag-text-color:var(--hcr-button-label-color)}.hcr-tag--selected-16-4-0.hcr-tag--outlined-16-4-0,.hcr-tag--selected-16-4-0.hcr-tag--subtle-16-4-0{--hcr-tag-text-color:var(--hcr-grayscale-100-color)}.hcr-tag__close-16-4-0{position:relative;z-index:1}.hcr-tag__close-16-4-0:before{background-color:var(--hcr-tag-text-color);content:\"\";height:1.125rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M13.41\\ 12l6.37-6.36a1\\ 1\\ 0\\ 10-1.42-1.42L12\\ 10.6\\ 5.64\\ 4.22a1\\ 1\\ 0\\ 10-1.42\\ 1.42L10.6\\ 12l-6.37\\ 6.36a1\\ 1\\ 0\\ 101.42\\ 1.42L12\\ 13.4l6.36\\ 6.37a1\\ 1\\ 0\\ 101.42-1.42L13.4\\ 12z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-3)*2);max-width:calc(var(--hcr-spacing-3)*2);min-height:var(--hcr-spacing-3);min-width:var(--hcr-spacing-3);width:1.125rem}.hcr-tag--small-16-4-0{font-size:var(--hcr-font-size-small);line-height:var(--hcr-line-height-small);padding:calc(var(--hcr-spacing-half) - 1px) var(--hcr-spacing-1)}.hcr-tag--small-16-4-0 .hcr-tag__icon-16-4-0{font-size:.75rem}.hcr-tag--small-16-4-0 .hcr-tag__icon-16-4-0:is([class*=flix-icon-]){font-size:1.125rem}.hcr-tag--small-16-4-0 .hcr-tag__close-16-4-0{height:1.125rem;margin:calc(-1*var(--hcr-spacing-half) - 1px)0;max-height:calc(var(--hcr-spacing-3)*2);max-width:calc(var(--hcr-spacing-3)*2);min-height:var(--hcr-spacing-3);min-width:var(--hcr-spacing-3);width:1.125rem}.hcr-tag-16-4-0:is(a,button){cursor:pointer}.hcr-tag-16-4-0:is(a,button):enabled:hover,.hcr-tag-16-4-0:is(a,button)[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-tag-16-4-0:is(a,button):enabled:active,.hcr-tag-16-4-0:is(a,button)[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-tag-16-4-0:is(a,button):focus-visible{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-tag--disabled-16-4-0,.hcr-tag-16-4-0:disabled,.hcr-tag-16-4-0[aria-disabled=true]{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}",
    map: {
        "hcr-tag": "hcr-tag-16-4-0",
        "hcr-tag__icon": "hcr-tag__icon-16-4-0",
        "hcr-tag--outlined": "hcr-tag--outlined-16-4-0",
        "hcr-tag--subtle": "hcr-tag--subtle-16-4-0",
        "hcr-tag--neutral": "hcr-tag--neutral-16-4-0",
        "hcr-tag--success": "hcr-tag--success-16-4-0",
        "hcr-tag--warning": "hcr-tag--warning-16-4-0",
        "hcr-tag--danger": "hcr-tag--danger-16-4-0",
        "hcr-tag--ai": "hcr-tag--ai-16-4-0",
        "hcr-tag--selected": "hcr-tag--selected-16-4-0",
        "hcr-tag__close": "hcr-tag__close-16-4-0",
        "hcr-tag--small": "hcr-tag--small-16-4-0",
        "hcr-tag--disabled": "hcr-tag--disabled-16-4-0"
    }
};






const $50cb57b4be79fe61$export$5e786b15b3c7a0c2 = [
    'neutral',
    'success',
    'warning',
    'danger',
    'selected',
    'ai'
];
const $50cb57b4be79fe61$export$d7d389197815b6ba = [
    'outlined',
    'subtle'
];
const $50cb57b4be79fe61$export$1d7032c01b60b667 = [
    'button',
    'a',
    'div',
    'span'
];




const $b9865f8d491b84ae$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('tag', (0, $563f264b69239c0e$export$2e2bcd8739ae039));
/** @since 0.2.0 */ function $b9865f8d491b84ae$export$3288d34c523a1192(_a) {
    var { appearance: appearance, children: children, closeProps: closeProps, disabled: disabled = false, display: display, Elem: /** @todo deprecate Elem="div" for tags, since they always behave as inline elements. Default to "span". */ Elem = 'div', extraClasses: extraClasses, innerRef: innerRef, small: small = false, tagColor: tagColor, tagTextColor: tagTextColor, style: style } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "appearance",
        "children",
        "closeProps",
        "disabled",
        "display",
        "Elem",
        "extraClasses",
        "innerRef",
        "small",
        "tagColor",
        "tagTextColor",
        "style"
    ]);
    const computedDisable = Elem === 'button' ? {
        disabled: disabled
    } : null;
    const ariaDisabled = disabled ? {
        'aria-disabled': disabled
    } : {};
    /* @ts-expect-error ReactNode expected in second parameter */ const tagChildren = $175aa43345204302$export$413dd9fe11ad5ea7(children, (child)=>{
        if ($175aa43345204302$export$2dabafa86f11ed64(child, 'Icon')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            extraClasses: $fc332675fdeb2380$export$8f628de5a2ade1fd(child, $b9865f8d491b84ae$var$bem.e('icon'))
        });
        return child;
    });
    const tagStyle = Object.assign(Object.assign(Object.assign({}, tagColor ? {
        '--hcr-tag-color': tagColor
    } : {}), tagTextColor ? {
        '--hcr-tag-text-color': tagTextColor
    } : {}), style);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        ref: innerRef,
        className: $b9865f8d491b84ae$var$bem.b([
            appearance,
            display,
            {
                disabled: disabled,
                small: small
            }
        ], extraClasses),
        style: tagStyle
    }, computedDisable, ariaDisabled, rest), tagChildren, closeProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a932d1784dd52635$export$2e2bcd8739ae039), Object.assign({
        extraClasses: $b9865f8d491b84ae$var$bem.e('close'),
        "aria-label": closeProps.label,
        appearance: "link",
        display: "square",
        size: "sm"
    }, closeProps)));
}
$b9865f8d491b84ae$export$3288d34c523a1192.displayName = 'Tag';
$b9865f8d491b84ae$export$3288d34c523a1192.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $50cb57b4be79fe61$export$5e786b15b3c7a0c2)),
    display: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $50cb57b4be79fe61$export$d7d389197815b6ba)),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $50cb57b4be79fe61$export$1d7032c01b60b667)),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    closeProps: ({ closeProps: closeProps })=>{
        // if has closeProps then must have label and onclick
        if (closeProps) {
            if (!closeProps.label) return new Error('`closeProps.label` is required if you provide `closeProps`');
            if (!closeProps.onClick) return new Error('`closeProps.onClick` is required if you provide `closeProps`');
        }
        return null;
    },
    tagColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    tagTextColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $b9865f8d491b84ae$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($b9865f8d491b84ae$export$3288d34c523a1192, (0, $563f264b69239c0e$export$2e2bcd8739ae039));


parcelRequire("acw62");

var $de851ad941cc2b08$export$2b067c6666111485;
$de851ad941cc2b08$export$2b067c6666111485 = `CalendarTag-Waq8uq-tag`;


const $66a18c1565f21ba8$var$CalendarTag = ({ value: value, onClick: onClick, onDelete: onDelete })=>{
    if (value) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b9865f8d491b84ae$export$2e2bcd8739ae039), {
        display: "subtle",
        extraClasses: $de851ad941cc2b08$export$2b067c6666111485,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onClick: onClick,
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                InlineIcon: (0, $c84b9d283ebf7c4b$export$e04bcc6127e699bf),
                onClick: onDelete
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b9865f8d491b84ae$export$2e2bcd8739ae039), {
        display: "subtle",
        onClick: onClick,
        extraClasses: $de851ad941cc2b08$export$2b067c6666111485,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                InlineIcon: (0, $7d921d227d67dd88$export$7b7ad8f03d93a9da)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                id: "scheduleDetail.NonOperationalDays.tag.label"
            })
        ]
    });
};
var $66a18c1565f21ba8$export$2e2bcd8739ae039 = $66a18c1565f21ba8$var$CalendarTag;


const $800843b0c4426ad9$export$f4b7ae87dc5fdd5d = (0, $b3141db263bb6e26$export$1862b5e1c8c0d0a);
const $800843b0c4426ad9$var$PeriodPicker = ({ inputElement: inputElement, earliestStartDate: earliestStartDate, latestEndDate: latestEndDate, periodStart: periodStart, periodEnd: periodEnd, onChange: onChange, onDelete: onDelete, onFocus: onFocus, label: label, preventAutoFocus: preventAutoFocus = false, errorMessage: errorMessage, placeholder: placeholder, required: required = false, longestSelectablePeriodInDays: longestSelectablePeriodInDays, defaultMonthShown: defaultMonthShown = "start" })=>{
    const [startDate, setStartDate] = $acw62.useState();
    const [endDate, setEndDate] = $acw62.useState();
    const [showCalendar, setShowCalendar] = $acw62.useState(false);
    const closeCalendarAndSubmitSelection = ()=>{
        setShowCalendar(false);
        if (onFocus) onFocus();
        if (startDate && endDate === undefined) onChange(startDate, periodEnd && (0, $16b6b9a14647dbb1$export$5c007e10c6929c95)(startDate, periodEnd) ? periodEnd : startDate);
        else if (startDate && endDate) onChange(startDate, endDate);
        else return;
        setStartDate(undefined);
        setEndDate(undefined);
    };
    $acw62.useEffect(()=>{
        if (startDate && endDate) closeCalendarAndSubmitSelection();
    }, [
        startDate,
        endDate
    ]);
    const handleDateSelect = (selected)=>{
        if (startDate === undefined) {
            setStartDate(selected);
            return;
        }
        if (endDate === undefined) {
            setEndDate(selected);
            return;
        }
        setStartDate(selected);
        setEndDate(undefined);
    };
    const selectedStartDate = startDate || periodStart;
    const selectedEndDate = endDate || periodEnd;
    const defaultMonth = selectedStartDate || (defaultMonthShown === "start" ? earliestStartDate : new Date());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3894e71b4d79c9a1$export$2e2bcd8739ae039), {
        onClickOutside: ()=>{
            if (showCalendar) closeCalendarAndSubmitSelection();
        },
        children: [
            inputElement === "input" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $889b6312d81178d0$export$2e2bcd8739ae039), {
                label: label,
                required: required,
                preventAutoFocus: preventAutoFocus,
                placeholder: placeholder,
                errorMessage: errorMessage,
                value: (0, $b3141db263bb6e26$export$1862b5e1c8c0d0a)(selectedStartDate, selectedEndDate),
                onFocus: ()=>setShowCalendar(true)
            }),
            inputElement === "tag" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66a18c1565f21ba8$export$2e2bcd8739ae039), {
                "aria-label": label,
                onClick: ()=>setShowCalendar(true),
                value: (0, $b3141db263bb6e26$export$1862b5e1c8c0d0a)(selectedStartDate, selectedEndDate),
                onDelete: ()=>{
                    setStartDate(undefined);
                    setEndDate(undefined);
                    if (onDelete) onDelete();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b22922e93429e0c9$export$2e2bcd8739ae039), {
                hidden: !showCalendar,
                id: "period-calendar",
                startDate: (0, $b3141db263bb6e26$export$3ee8fbdbeceaef0e)(earliestStartDate, startDate, endDate),
                endDate: (0, $b3141db263bb6e26$export$7874fb380758be78)(latestEndDate, startDate, longestSelectablePeriodInDays),
                startSelected: selectedStartDate,
                endSelected: selectedEndDate,
                defaultMonth: defaultMonth,
                handleSelect: handleDateSelect,
                days: (0, $b3141db263bb6e26$export$5f84d4e06c0693c4)(),
                months: (0, $b3141db263bb6e26$export$ab152e6ff2cc840e)(),
                extraClasses: $02b04304aa1f0dc2$export$56bbcdb8aca31149,
                calendarHeader: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56ae55986a96eff0$export$6a017b168bebd4da), {})
            })
        ]
    });
};
var $800843b0c4426ad9$export$2e2bcd8739ae039 = $800843b0c4426ad9$var$PeriodPicker;





var $acw62 = parcelRequire("acw62");







var $6686418702cbcf7d$export$34e0f9847d4c02dd;
var $6686418702cbcf7d$export$fa397790119a1408;
var $6686418702cbcf7d$export$b426df703d3b34b8;
var $6686418702cbcf7d$export$a80b3bd66acc52ff;
var $6686418702cbcf7d$export$e56455097d2b5b3a;
var $6686418702cbcf7d$export$1237798dc640739a;
var $6686418702cbcf7d$export$9505dd00e7230e13;
var $6686418702cbcf7d$export$61bb151bc9360b59;
var $6686418702cbcf7d$export$ec67f55c222e1546;
$6686418702cbcf7d$export$34e0f9847d4c02dd = `Autocomplete-FJPlAq-container`;
$6686418702cbcf7d$export$fa397790119a1408 = `Autocomplete-FJPlAq-flix-theme-dark`;
$6686418702cbcf7d$export$b426df703d3b34b8 = `Autocomplete-FJPlAq-flix-theme-flix`;
$6686418702cbcf7d$export$a80b3bd66acc52ff = `Autocomplete-FJPlAq-info`;
$6686418702cbcf7d$export$e56455097d2b5b3a = `Autocomplete-FJPlAq-inputSkeleton`;
$6686418702cbcf7d$export$1237798dc640739a = `Autocomplete-FJPlAq-label`;
$6686418702cbcf7d$export$9505dd00e7230e13 = `Autocomplete-FJPlAq-labelSkeleton`;
$6686418702cbcf7d$export$61bb151bc9360b59 = `Autocomplete-FJPlAq-labelWrapper`;
$6686418702cbcf7d$export$ec67f55c222e1546 = `Autocomplete-FJPlAq-narrow`;





parcelRequire("acw62");
var $736287a135180736$export$fa397790119a1408;
var $736287a135180736$export$b426df703d3b34b8;
var $736287a135180736$export$1ca1ec8b29a4ce27;
var $736287a135180736$export$46c1c92549715335;
var $736287a135180736$export$a072400278b5cc22;
$736287a135180736$export$fa397790119a1408 = `NoOptionsMessage-1Z_sra-flix-theme-dark`;
$736287a135180736$export$b426df703d3b34b8 = `NoOptionsMessage-1Z_sra-flix-theme-flix`;
$736287a135180736$export$1ca1ec8b29a4ce27 = `NoOptionsMessage-1Z_sra-icon`;
$736287a135180736$export$46c1c92549715335 = `NoOptionsMessage-1Z_sra-loading`;
$736287a135180736$export$a072400278b5cc22 = `NoOptionsMessage-1Z_sra-noOption`;


const $89ff5dba4ca98b74$var$NoOptionsMessage = ({ noOptionsAction: noOptionsAction, noOptionsInfo: noOptionsInfo, show: show, loading: loading })=>{
    if (show) {
        if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: $736287a135180736$export$46c1c92549715335,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a448fa77989b51de$export$2e2bcd8739ae039), {
                size: "sm"
            })
        });
        if (noOptionsAction) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-id": "no-options-action-info",
            className: $736287a135180736$export$a072400278b5cc22,
            onClick: noOptionsAction.action,
            children: [
                noOptionsAction.message,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                    extraClasses: $736287a135180736$export$1ca1ec8b29a4ce27,
                    InlineIcon: (0, $7d921d227d67dd88$export$7b7ad8f03d93a9da)
                })
            ]
        });
        if (noOptionsInfo) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-id": "no-options-info",
            children: noOptionsInfo
        });
        return null;
    }
    return null;
};
var $89ff5dba4ca98b74$export$2e2bcd8739ae039 = $89ff5dba4ca98b74$var$NoOptionsMessage;


const $fde2397fa9c66531$var$Autocomplete = ({ label: label, placeholder: placeholder = null, options: options, onValueSelected: onValueSelected, onFocus: onFocus = ()=>{}, startsOnInputValueLength: startsOnInputValueLength = 3, noOptionsAction: noOptionsAction, noOptionsInfo: noOptionsInfo, optionsLoading: optionsLoading, error: error = false, errorMessage: errorMessage, isNarrow: isNarrow = false, initialValue: initialValue = null, disabled: disabled = false, onInputChange: onInputChange, filterOption: filterOption, onBlur: onBlur, blurInputOnSelect: blurInputOnSelect = false, isClearable: isClearable = false, showValueOnly: showValueOnly = false, menuIsOpen: menuIsOpen = false, clearsOnChange: clearsOnChange = false, clearInputOnFocus: clearInputOnFocus = false, clearsOnSelect: clearsOnSelect = false, isLoading: isLoading = false, isSearchable: isSearchable = true })=>{
    const [showOptions, setShowOptions] = $acw62.useState(false);
    const [value, setValue] = $acw62.useState(initialValue);
    $acw62.useEffect(()=>{
        if (initialValue && !showValueOnly || clearsOnChange) setValue(initialValue);
        if (initialValue && showValueOnly) setValue({
            value: initialValue.value,
            label: initialValue.value
        });
    }, [
        initialValue
    ]);
    $acw62.useEffect(()=>{
        setShowOptions(menuIsOpen);
    }, [
        menuIsOpen
    ]);
    const handleOnInputChange = (inputValue)=>{
        setShowOptions(inputValue.length >= startsOnInputValueLength);
        if (onInputChange) onInputChange(inputValue);
    };
    const getNoOptionsElement = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89ff5dba4ca98b74$export$2e2bcd8739ae039), {
            show: showOptions,
            loading: optionsLoading,
            noOptionsAction: noOptionsAction ? {
                ...noOptionsAction,
                action: ()=>{
                    noOptionsAction.action();
                    setShowOptions(false);
                }
            } : undefined,
            noOptionsInfo: noOptionsInfo
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18e3b9edfaaee1b3$export$2e2bcd8739ae039), {
                extraClasses: $6686418702cbcf7d$export$9505dd00e7230e13,
                Elem: "div",
                width: "sm"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18e3b9edfaaee1b3$export$2e2bcd8739ae039), {
                extraClasses: $6686418702cbcf7d$export$e56455097d2b5b3a,
                Elem: "div"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $6686418702cbcf7d$export$34e0f9847d4c02dd,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $6686418702cbcf7d$export$61bb151bc9360b59,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    className: $6686418702cbcf7d$export$1237798dc640739a,
                    htmlFor: `autocomplete-${label}`,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                id: `autocomplete-${(0, $433401918a64c671$export$2e2bcd8739ae039)(label) || Math.random()}`,
                placeholder: placeholder,
                styles: (0, $63c2c06b53ba964b$export$2e2bcd8739ae039)(error, undefined, undefined, isClearable, !!label),
                options: showOptions || startsOnInputValueLength === 0 ? options : undefined,
                onChange: (selectedValue)=>{
                    if (selectedValue && selectedValue instanceof Array === false) {
                        onValueSelected(selectedValue);
                        if (showValueOnly) setValue({
                            value: selectedValue.value,
                            label: selectedValue.value
                        });
                        else setValue(selectedValue);
                        if (clearsOnSelect) setValue(null);
                    }
                    if (isClearable && selectedValue === null) {
                        onValueSelected(selectedValue);
                        setValue(selectedValue);
                    }
                },
                onInputChange: handleOnInputChange,
                value: value,
                components: {
                    ClearIndicator: $15a95a4dbc72f529$export$2e2bcd8739ae039,
                    DropdownIndicator: $2b2850ccc654d05b$export$2e2bcd8739ae039,
                    NoOptionsMessage: getNoOptionsElement,
                    Option: $4b57c50dbfa9c188$export$2e2bcd8739ae039,
                    SingleValue: $16f29cccac148065$export$2e2bcd8739ae039
                },
                inputId: `${(0, $433401918a64c671$export$2e2bcd8739ae039)(label) || Math.random()}-autocomplete`,
                "data-id": "autocomplete-select",
                onFocus: ()=>{
                    if (clearInputOnFocus) setValue(null);
                    onFocus();
                },
                className: isNarrow ? $6686418702cbcf7d$export$ec67f55c222e1546 : "",
                isDisabled: disabled,
                filterOption: filterOption,
                onBlur: onBlur,
                blurInputOnSelect: blurInputOnSelect,
                isClearable: isClearable,
                menuIsOpen: menuIsOpen ? true : undefined,
                isSearchable: isSearchable
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "data-id": "error-message",
                className: $6686418702cbcf7d$export$a80b3bd66acc52ff,
                children: errorMessage
            })
        ]
    });
};
var $fde2397fa9c66531$export$2e2bcd8739ae039 = $fde2397fa9c66531$var$Autocomplete;




var $7YFi7 = parcelRequire("7YFi7");
parcelRequire("acw62");


parcelRequire("acw62");
var $ec6811f7c37448f1$export$fa397790119a1408;
var $ec6811f7c37448f1$export$b426df703d3b34b8;
var $ec6811f7c37448f1$export$1237798dc640739a;
var $ec6811f7c37448f1$export$2ab9a8f9f1186f14;
var $ec6811f7c37448f1$export$cc74dcc53cfce4eb;
$ec6811f7c37448f1$export$fa397790119a1408 = `ReadOnlyFormField-my_ymG-flix-theme-dark`;
$ec6811f7c37448f1$export$b426df703d3b34b8 = `ReadOnlyFormField-my_ymG-flix-theme-flix`;
$ec6811f7c37448f1$export$1237798dc640739a = `ReadOnlyFormField-my_ymG-label`;
$ec6811f7c37448f1$export$2ab9a8f9f1186f14 = `ReadOnlyFormField-my_ymG-value`;
$ec6811f7c37448f1$export$cc74dcc53cfce4eb = `ReadOnlyFormField-my_ymG-wrapper`;


const $91df22877452df03$var$ReadOnlyFormField = ({ label: label, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $ec6811f7c37448f1$export$cc74dcc53cfce4eb,
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $ec6811f7c37448f1$export$1237798dc640739a,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $ec6811f7c37448f1$export$2ab9a8f9f1186f14,
                children: children
            })
        ]
    });
};
var $91df22877452df03$export$2e2bcd8739ae039 = $91df22877452df03$var$ReadOnlyFormField;



var $f7eff82bed8331d6$export$2e2bcd8739ae039 = (value, options)=>{
    const option = options.find((opt)=>opt.value === value);
    if (option) return option.label;
    return (0, $fefa4e2c18d9f2ab$export$2e2bcd8739ae039)("general.notAvailable");
};


const $b7e478ad0f1a9202$var$FormikAutocomplete = ({ name: name, label: label, placeholder: placeholder, options: options, noOptionsAction: noOptionsAction, onValueSelected: onValueSelected, initialValue: initialValue, readOnly: readOnly, filterOption: filterOption, startsOnInputValueLength: startsOnInputValueLength, required: required, onInputChange: onInputChange })=>{
    const [, meta, helper] = (0, $7YFi7.useField)(name);
    if (readOnly) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91df22877452df03$export$2e2bcd8739ae039), {
        label: label,
        children: (0, $f7eff82bed8331d6$export$2e2bcd8739ae039)(meta.value, options)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fde2397fa9c66531$export$2e2bcd8739ae039), {
        label: `${label}${required ? " *" : ""}`,
        placeholder: placeholder,
        options: options,
        onValueSelected: (selectedOption)=>{
            if (onValueSelected) onValueSelected(selectedOption.value);
            helper.setValue(selectedOption.value);
        },
        noOptionsAction: noOptionsAction,
        initialValue: initialValue || options.find((option)=>option.value === meta.value),
        onBlur: ()=>helper.setTouched(true),
        error: !!(meta.error && meta.touched),
        errorMessage: meta.error,
        filterOption: filterOption,
        startsOnInputValueLength: startsOnInputValueLength,
        onInputChange: onInputChange
    });
};
var $b7e478ad0f1a9202$export$2e2bcd8739ae039 = $b7e478ad0f1a9202$var$FormikAutocomplete;






var $acw62 = parcelRequire("acw62");

var $af74c4ab8df7ce34$export$2e2bcd8739ae039 = {
    raw: ".hcr-select-group-16-4-0{border:0;position:relative}.hcr-select-group__info-16-4-0:not(:empty){color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin-top:var(--hcr-spacing-1)}.hcr-select-group__info-16-4-0:not(:empty)~.hcr-select-group__info-16-4-0{margin-top:var(--hcr-spacing-half)}.hcr-select-group--error-16-4-0 .hcr-select-group__info-16-4-0{color:var(--hcr-danger-dark-color)}.hcr-select-group__info-16-4-0~.hcr-select-group__info-16-4-0{color:var(--hcr-content-primary-color)}.hcr-select-group--error-16-4-0 .hcr-select-group__item-16-4-0{border-color:var(--hcr-danger-color)}.hcr-select-group--error-16-4-0 .hcr-select-group__item-16-4-0 label{background-image:linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-select-group--error-16-4-0 .hcr-select-group__item-16-4-0 label:hover{background-image:var(--hcr-hover-layer-color),linear-gradient(var(--hcr-bg-primary-transparent-color),var(--hcr-bg-primary-transparent-color)),linear-gradient(var(--hcr-danger-color),var(--hcr-danger-color))}.hcr-select-group--disabled-16-4-0{opacity:var(--hcr-disabled-element-opacity)}.hcr-select-group--disabled-16-4-0 .hcr-select-group__item-16-4-0 input,.hcr-select-group--disabled-16-4-0 .hcr-select-group__item-16-4-0 label{cursor:not-allowed}.hcr-select-group__items-16-4-0{display:inline-flex;flex-wrap:wrap;list-style-type:none;padding-top:1px;position:relative}.hcr-select-group__label-16-4-0{z-index:2}.hcr-select-group__item-16-4-0{border:1px solid var(--hcr-input-border-color);margin-left:-1px;margin-top:-1px;min-width:var(--hcr-input-height-mobile);text-align:center}@media (min-width:1200px){.hcr-select-group__item-16-4-0{min-width:var(--hcr-input-height-desktop)}}.hcr-select-group__item-16-4-0:first-of-type,.hcr-select-group__item-16-4-0:first-of-type label{border-radius:var(--hcr-border-radius-1)0 0 var(--hcr-border-radius-1)}.hcr-select-group__item-16-4-0:last-of-type,.hcr-select-group__item-16-4-0:last-of-type label{border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0}.hcr-select-group__item-16-4-0 input{cursor:pointer;height:0;margin:0;opacity:0;position:absolute;width:0}.hcr-select-group__item-16-4-0 input:enabled:hover+label{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-select-group__item-16-4-0 input:enabled:active+label{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-select-group__item-16-4-0 input:focus-visible+label{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px;z-index:1}.hcr-select-group__item-16-4-0 input:checked+label{background-color:var(--hcr-highlight-color);padding-left:var(--hcr-spacing-2);padding-right:var(--hcr-spacing-2)}.hcr-select-group__item-16-4-0 input:checked+label:before{background-color:var(--hcr-content-primary-color);content:\"\";height:1.125rem;-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21.7\\ 6.2l-13\\ 13a1\\ 1\\ 0\\ 01-1.4\\ 0l-5-5a1\\ 1\\ 0\\ 111.4-1.4L8\\ 17.08l12.3-12.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21.7\\ 6.2l-13\\ 13a1\\ 1\\ 0\\ 01-1.4\\ 0l-5-5a1\\ 1\\ 0\\ 111.4-1.4L8\\ 17.08l12.3-12.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;max-height:calc(var(--hcr-spacing-3)*2);max-width:calc(var(--hcr-spacing-3)*2);min-height:var(--hcr-spacing-3);min-width:var(--hcr-spacing-3);width:1.125rem}.hcr-select-group__item-16-4-0 label{align-items:center;background:var(--hcr-box-bg-color);color:var(--hcr-content-primary-color);column-gap:var(--hcr-spacing-half);cursor:pointer;display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);line-height:var(--hcr-line-height-primary);padding:calc(var(--hcr-spacing-2) - var(--hcr-spacing-half)) var(--hcr-spacing-3);position:relative}@media (min-width:1200px){.hcr-select-group__item-16-4-0 label{min-width:var(--hcr-input-height-desktop);padding-bottom:calc(var(--hcr-spacing-1) - 1px);padding-top:calc(var(--hcr-spacing-1) - 1px)}}.hcr-select-group__item--disabled-16-4-0{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}.hcr-select-group__item--disabled-16-4-0 input,.hcr-select-group__item--disabled-16-4-0 label{cursor:not-allowed}",
    map: {
        "hcr-select-group": "hcr-select-group-16-4-0",
        "hcr-select-group__info": "hcr-select-group__info-16-4-0",
        "hcr-select-group--error": "hcr-select-group--error-16-4-0",
        "hcr-select-group__item": "hcr-select-group__item-16-4-0",
        "hcr-select-group--disabled": "hcr-select-group--disabled-16-4-0",
        "hcr-select-group__items": "hcr-select-group__items-16-4-0",
        "hcr-select-group__label": "hcr-select-group__label-16-4-0",
        "hcr-select-group__item--disabled": "hcr-select-group__item--disabled-16-4-0"
    }
};









const $a1ab8573c1f90592$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('select-group', (0, $af74c4ab8df7ce34$export$2e2bcd8739ae039));
function $a1ab8573c1f90592$export$ee25a334c55de1f4(_a) {
    var { id: id, disabled: disabled = false, error: error = false, multi: multi = false, label: label, info: info, infoError: infoError, options: options, extraClasses: extraClasses } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "disabled",
        "error",
        "multi",
        "label",
        "info",
        "infoError",
        "options",
        "extraClasses"
    ]);
    /**
   * Generates a dynamic prefix for the component ID in the following format:
   * N * option.id[first-letter]+[last-letter]
   */ const idPrefix = options.map((option)=>option.id && `${option.id.toString().charAt(0)}${option.id.toString().charAt(option.id.toString().length - 1)}`).join('');
    const componentId = (0, $c3eee7b1359b34f4$export$9cb3c4fd0f7c7bd9)(idPrefix, id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", Object.assign({
        id: id,
        className: $a1ab8573c1f90592$var$bem.b({
            error: error,
            disabled: disabled
        }, extraClasses)
    }, rest), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39f5a98ae6c430ce$export$2e2bcd8739ae039), {
        Elem: "legend",
        extraClasses: $a1ab8573c1f90592$var$bem.e('label'),
        text: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: $a1ab8573c1f90592$var$bem.e('items')
    }, options && options.map((_a)=>{
        var { id: subId, name: name, value: value, label: subLabel, disabled: subDisabled, innerRef: innerRef } = _a, restInOption = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
            "id",
            "name",
            "value",
            "label",
            "disabled",
            "innerRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: $a1ab8573c1f90592$var$bem.e('item', {
                disabled: subDisabled
            }),
            key: subId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, innerRef && {
            ref: innerRef
        }, {
            disabled: disabled || subDisabled,
            type: multi ? 'checkbox' : 'radio',
            value: value,
            name: name,
            id: subId,
            "aria-errormessage": `infoError-${componentId}`
        }, error && {
            'aria-invalid': true
        }, info && {
            'aria-describedby': `info-${componentId}`
        }, restInOption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            htmlFor: subId
        }, subLabel));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        error: true,
        id: componentId,
        className: $a1ab8573c1f90592$var$bem.e('info')
    }, error ? infoError : ''), info && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: componentId,
        className: $a1ab8573c1f90592$var$bem.e('info')
    }, info));
}
$a1ab8573c1f90592$export$ee25a334c55de1f4.displayName = 'SelectGroup';
$a1ab8573c1f90592$export$ee25a334c55de1f4.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    label ({ 'aria-label': ariaLabel, label: label }) {
        // if no aria label nor label throw validation error
        return !ariaLabel && !label ? new Error('Either a label or aria-label are required for SelectGroup') : null;
    },
    info: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    infoError: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    multi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
        ]).isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        /** Ref forwarded to the input element */ innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
                current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element,
                    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
                ])
            })
        ])
    })).isRequired
};
var $a1ab8573c1f90592$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($a1ab8573c1f90592$export$ee25a334c55de1f4, (0, $af74c4ab8df7ce34$export$2e2bcd8739ae039));


parcelRequire("acw62");

var $bd785c3334cab6bb$export$7ed5ca4f8b987938 = /*#__PURE__*/ function(DayOfWeek) {
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
    return DayOfWeek;
}({});


var $091c3f4c2f88e9e7$export$fa397790119a1408;
var $091c3f4c2f88e9e7$export$b426df703d3b34b8;
var $091c3f4c2f88e9e7$export$86410c4345f8840e;
$091c3f4c2f88e9e7$export$fa397790119a1408 = `DayPicker-PzRy1W-flix-theme-dark`;
$091c3f4c2f88e9e7$export$b426df703d3b34b8 = `DayPicker-PzRy1W-flix-theme-flix`;
$091c3f4c2f88e9e7$export$86410c4345f8840e = `DayPicker-PzRy1W-picker`;


const $20ae91deb431f2f3$var$DayPicker = ({ value: value, disabled: disabled = [], onValueChanged: onValueChanged, id: id, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    const allOptions = [
        {
            id: id ? `${id}-monday` : "monday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Monday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Monday,
            label: formatMessage({
                id: "general.monday"
            })
        },
        {
            id: id ? `${id}-tuesday` : "tuesday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Tuesday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Tuesday,
            label: formatMessage({
                id: "general.tuesday"
            })
        },
        {
            id: id ? `${id}-wednesday` : "wednesday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Wednesday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Wednesday,
            label: formatMessage({
                id: "general.wednesday"
            })
        },
        {
            id: id ? `${id}-thursday` : "thursday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Thursday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Thursday,
            label: formatMessage({
                id: "general.thursday"
            })
        },
        {
            id: id ? `${id}-friday` : "friday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Friday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Friday,
            label: formatMessage({
                id: "general.friday"
            })
        },
        {
            id: id ? `${id}-saturday` : "saturday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Saturday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Saturday,
            label: formatMessage({
                id: "general.saturday"
            })
        },
        {
            id: id ? `${id}-sunday` : "sunday",
            value: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Sunday,
            name: (0, $bd785c3334cab6bb$export$7ed5ca4f8b987938).Sunday,
            label: formatMessage({
                id: "general.sunday"
            })
        }
    ];
    const onChange = (e)=>{
        const newValue = [
            ...value
        ];
        if (e.target.checked) {
            if (!value.includes(e.target.value)) {
                newValue.push(e.target.value);
                onValueChanged(newValue);
            }
        } else {
            const index = value.indexOf(e.target.value);
            if (index !== -1) {
                newValue.splice(index, 1);
                onValueChanged(newValue);
            }
        }
    };
    const options = allOptions.map((option)=>{
        return {
            ...option,
            disabled: disabled.includes(option.value),
            checked: value.includes(option.value),
            onChange: onChange
        };
    });
    const label = isRequired ? `${formatMessage({
        id: "bookingInfo.filter.departureDay.label"
    })} *` : formatMessage({
        id: "bookingInfo.filter.departureDay.label"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1ab8573c1f90592$export$2e2bcd8739ae039), {
        label: label,
        options: options,
        extraClasses: $091c3f4c2f88e9e7$export$86410c4345f8840e,
        multi: true
    });
};
var $20ae91deb431f2f3$export$2e2bcd8739ae039 = $20ae91deb431f2f3$var$DayPicker;



parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

var $a3b08ebbdb8e3f9a$export$2e2bcd8739ae039 = {
    raw: ".hcr-checkbox-16-4-0{position:relative}.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0{min-height:var(--hcr-spacing-3)}.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:after{-webkit-mask-size:calc(var(--hcr-spacing-3) - var(--hcr-spacing-1));mask-size:calc(var(--hcr-spacing-3) - var(--hcr-spacing-1))}.hcr-checkbox--sm-16-4-0 .hcr-checkbox__input-16-4-0,.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:after,.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:before{height:var(--hcr-spacing-3);margin-top:calc((var(--hcr-line-height-primary) - var(--hcr-spacing-3))/2);width:var(--hcr-spacing-3)}@supports (margin-top:max(0px,calc((var(--hcr-line-height-primary ) - var(--hcr-spacing-3 ))/2))){.hcr-checkbox--sm-16-4-0 .hcr-checkbox__input-16-4-0,.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:after,.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:before{margin-top:max(0px,(var(--hcr-line-height-primary) - var(--hcr-spacing-3))/2)}}.hcr-checkbox__label-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-primary-color);cursor:pointer;display:inline-flex;font-family:inherit;gap:var(--hcr-spacing-2);margin:calc(-1*var(--hcr-spacing-half));min-height:var(--hcr-spacing-5);padding:var(--hcr-spacing-half);position:relative;vertical-align:middle}.hcr-checkbox__label-16-4-0:after,.hcr-checkbox__label-16-4-0:before{align-self:flex-start;content:\"\";display:block;flex-shrink:0}.hcr-checkbox__label-16-4-0:before{border:2px solid var(--hcr-input-border-color);border-radius:var(--hcr-border-radius-1);height:var(--hcr-spacing-5);margin-top:calc((var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2);transition:border-color .25s ease;width:var(--hcr-spacing-5)}@supports (margin-top:max(0px,calc((var(--hcr-line-height-primary ) - var(--hcr-spacing-5 ))/2))){.hcr-checkbox__label-16-4-0:before{margin-top:max(0px,(var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2)}}.hcr-checkbox__label-16-4-0:after{background-color:var(--hcr-input-border-color);height:var(--hcr-spacing-5);left:var(--hcr-spacing-half);margin-top:calc((var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21.7\\ 6.2l-13\\ 13a1\\ 1\\ 0\\ 01-1.4\\ 0l-5-5a1\\ 1\\ 0\\ 111.4-1.4L8\\ 17.08l12.3-12.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/calc(var(--hcr-spacing-5) - var(--hcr-spacing-1));mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21.7\\ 6.2l-13\\ 13a1\\ 1\\ 0\\ 01-1.4\\ 0l-5-5a1\\ 1\\ 0\\ 111.4-1.4L8\\ 17.08l12.3-12.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/calc(var(--hcr-spacing-5) - var(--hcr-spacing-1));pointer-events:none;position:absolute;top:var(--hcr-spacing-half);transform:scale(0);transition:transform .25s ease,background-color .25s ease;width:var(--hcr-spacing-5)}@supports (margin-top:max(0px,calc((var(--hcr-line-height-primary ) - var(--hcr-spacing-5 ))/2))){.hcr-checkbox__label-16-4-0:after{margin-top:max(0px,(var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2)}}.hcr-checkbox__input-16-4-0{height:var(--hcr-spacing-5);margin-top:calc((var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2);width:var(--hcr-spacing-5)}@supports (margin-top:max(0px,calc((var(--hcr-line-height-primary ) - var(--hcr-spacing-5 ))/2))){.hcr-checkbox__input-16-4-0{margin-top:max(0px,(var(--hcr-line-height-primary) - var(--hcr-spacing-5))/2)}}.hcr-checkbox__input-16-4-0:checked+.hcr-checkbox__label-16-4-0:after{transform:scale(1)}.hcr-checkbox__input-16-4-0{cursor:pointer;opacity:0;position:absolute}.hcr-checkbox__input-16-4-0:focus-visible+.hcr-checkbox__label-16-4-0:before{box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-checkbox__input-16-4-0:enabled+.hcr-checkbox__label-16-4-0:hover,.hcr-checkbox__input-16-4-0:enabled:hover+.hcr-checkbox__label-16-4-0{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-checkbox__input-16-4-0:checked+.hcr-checkbox__label-16-4-0:before{border-color:var(--hcr-content-primary-color)}.hcr-checkbox__input-16-4-0:checked+.hcr-checkbox__label-16-4-0:after{background-color:var(--hcr-content-primary-color)}.hcr-checkbox--disabled-16-4-0 .hcr-checkbox__label-16-4-0{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}.hcr-checkbox--error-16-4-0 .hcr-checkbox__label-16-4-0:before{border-color:var(--hcr-danger-color)}.hcr-checkbox--error-16-4-0 .hcr-checkbox__input-16-4-0:not(:checked)+.hcr-checkbox__label-16-4-0:before{box-shadow:inset 0 0 0 100vh var(--hcr-bg-primary-transparent-color),inset 0 0 0 100vh var(--hcr-danger-color);transition:box-shadow .25s ease}.hcr-checkbox--error-16-4-0 .hcr-checkbox__input-16-4-0:focus-visible:not(:checked)+.hcr-checkbox__label-16-4-0:before{box-shadow:inset 0 0 0 100vh var(--hcr-bg-primary-transparent-color),inset 0 0 0 100vh var(--hcr-danger-color),0 0 0 4px var(--hcr-grayscale-0-color)}.hcr-checkbox__info-16-4-0:not(:empty){color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin-top:var(--hcr-spacing-1)}.hcr-checkbox__info-16-4-0:not(:empty)~.hcr-checkbox__info-16-4-0{margin-top:var(--hcr-spacing-half)}.hcr-checkbox--error-16-4-0 .hcr-checkbox__info-16-4-0{color:var(--hcr-danger-dark-color)}.hcr-checkbox__info-16-4-0~.hcr-checkbox__info-16-4-0{color:var(--hcr-content-primary-color)}.hcr-checkbox--indeterminate-16-4-0>.hcr-checkbox__label-16-4-0:before,.hcr-checkbox__input-16-4-0:indeterminate+.hcr-checkbox__label-16-4-0:before{border-color:var(--hcr-content-primary-color)}.hcr-checkbox--indeterminate-16-4-0>.hcr-checkbox__label-16-4-0:after,.hcr-checkbox__input-16-4-0:indeterminate+.hcr-checkbox__label-16-4-0:after{background-color:var(--hcr-content-primary-color);-webkit-mask-image:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21\\ 11H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2z\\'\\ /%3E%3C/svg%3E);mask-image:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M21\\ 11H3a1\\ 1\\ 0\\ 000\\ 2h18a1\\ 1\\ 0\\ 000-2z\\'\\ /%3E%3C/svg%3E);transform:scale(1)}.hcr-checkbox--sm-16-4-0 .hcr-checkbox__label-16-4-0:before{border-radius:var(--hcr-border-radius-half)}.hcr-checkbox--no-label-16-4-0 .hcr-checkbox__label-16-4-0:after,.hcr-checkbox--no-label-16-4-0 .hcr-checkbox__label-16-4-0:before{margin-top:0}",
    map: {
        "hcr-checkbox": "hcr-checkbox-16-4-0",
        "hcr-checkbox--sm": "hcr-checkbox--sm-16-4-0",
        "hcr-checkbox__label": "hcr-checkbox__label-16-4-0",
        "hcr-checkbox__input": "hcr-checkbox__input-16-4-0",
        "hcr-checkbox--disabled": "hcr-checkbox--disabled-16-4-0",
        "hcr-checkbox--error": "hcr-checkbox--error-16-4-0",
        "hcr-checkbox__info": "hcr-checkbox__info-16-4-0",
        "hcr-checkbox--indeterminate": "hcr-checkbox--indeterminate-16-4-0",
        "hcr-checkbox--no-label": "hcr-checkbox--no-label-16-4-0"
    }
};












const $52917a9e4d29fd2f$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('checkbox', (0, $a3b08ebbdb8e3f9a$export$2e2bcd8739ae039));
function $52917a9e4d29fd2f$export$48513f6b9f8ce62d(_a) {
    var { id: id, extraClasses: extraClasses, label: label, value: value, disabled: disabled, valid: valid, innerRef: innerRef, info: info, infoError: infoError, small: small = false, indeterminate: indeterminate = false, 'aria-describedby': ariaDescribedBy } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "id",
        "extraClasses",
        "label",
        "value",
        "disabled",
        "valid",
        "innerRef",
        "info",
        "infoError",
        "small",
        "indeterminate",
        'aria-describedby'
    ]);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = indeterminate;
    }, []);
    const className = $52917a9e4d29fd2f$var$bem.b({
        disabled: disabled,
        error: valid === false,
        sm: small,
        indeterminate: indeterminate,
        'no-label': !label
    }, extraClasses);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7194b19900b29637$export$dd2171e2b7d3bc5b), Object.assign({
        ref: (node)=>{
            $175aa43345204302$export$390003ad846c69eb(node, innerRef, inputRef);
        },
        id: id,
        type: "checkbox",
        value: value,
        disabled: disabled,
        className: $52917a9e4d29fd2f$var$bem.e('input'),
        valid: valid,
        "aria-errormessage": `infoError-${id}`,
        "aria-describedby": $fc332675fdeb2380$export$db93d21cb888fc59(id, {
            info: info,
            ariaDescribedBy: ariaDescribedBy
        })
    }, rest)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: id,
        className: $52917a9e4d29fd2f$var$bem.e('label')
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        error: true,
        id: id,
        className: $52917a9e4d29fd2f$var$bem.e('info')
    }, valid === false ? infoError : ''), info && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: id,
        className: $52917a9e4d29fd2f$var$bem.e('info')
    }, info));
}
$52917a9e4d29fd2f$export$48513f6b9f8ce62d.displayName = 'Checkbox';
$52917a9e4d29fd2f$export$48513f6b9f8ce62d.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    label: (0, $1d03adf1ac923b0d$export$a274f689f170c939)('Checkbox'),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]).isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    innerRef: (0, $702b9449be14ac4b$export$a18c65527e9c80e1),
    info: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    infoError: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $52917a9e4d29fd2f$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($52917a9e4d29fd2f$export$48513f6b9f8ce62d, (0, $a3b08ebbdb8e3f9a$export$2e2bcd8739ae039));


parcelRequire("acw62");

var $96afac83ebe01425$export$b07e517d22efa1ca;
var $96afac83ebe01425$export$34e0f9847d4c02dd;
var $96afac83ebe01425$export$fa397790119a1408;
var $96afac83ebe01425$export$b426df703d3b34b8;
var $96afac83ebe01425$export$ff48a4fbbbe377ab;
$96afac83ebe01425$export$b07e517d22efa1ca = `MultiSelectOption-5pq8Ja-checkbox`;
$96afac83ebe01425$export$34e0f9847d4c02dd = `MultiSelectOption-5pq8Ja-container`;
$96afac83ebe01425$export$fa397790119a1408 = `MultiSelectOption-5pq8Ja-flix-theme-dark`;
$96afac83ebe01425$export$b426df703d3b34b8 = `MultiSelectOption-5pq8Ja-flix-theme-flix`;
$96afac83ebe01425$export$ff48a4fbbbe377ab = `MultiSelectOption-5pq8Ja-suffixElement`;


const $3f974a705a6cd313$var$MultiSelectOption = (props)=>{
    const { data: { value: value, label: label }, isSelected: isSelected } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
        ...props,
        className: $96afac83ebe01425$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52917a9e4d29fd2f$export$2e2bcd8739ae039), {
                id: value,
                value: value,
                label: label,
                defaultChecked: isSelected,
                small: true,
                extraClasses: $96afac83ebe01425$export$b07e517d22efa1ca
            }),
            props.data.suffixElement && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $96afac83ebe01425$export$ff48a4fbbbe377ab,
                children: props.data.suffixElement
            })
        ]
    });
};
var $3f974a705a6cd313$export$2e2bcd8739ae039 = $3f974a705a6cd313$var$MultiSelectOption;


var $1286641fd157733b$export$fa397790119a1408;
var $1286641fd157733b$export$b426df703d3b34b8;
var $1286641fd157733b$export$1237798dc640739a;
var $1286641fd157733b$export$e7125f2b24a423a5;
$1286641fd157733b$export$fa397790119a1408 = `MultiSelectAutocomplete-Gd-5da-flix-theme-dark`;
$1286641fd157733b$export$b426df703d3b34b8 = `MultiSelectAutocomplete-Gd-5da-flix-theme-flix`;
$1286641fd157733b$export$1237798dc640739a = `MultiSelectAutocomplete-Gd-5da-label`;
$1286641fd157733b$export$e7125f2b24a423a5 = `MultiSelectAutocomplete-Gd-5da-noOptionInfo`;


const $b1632bfb5f783054$var$MultiSelectAutocomplete = ({ inputValue: inputValue, options: options, selectedOptions: selectedOptions, onSelect: onSelect, label: label, onBlur: onBlur, onInputChange: onInputChange, optionsLoading: optionsLoading = false, placeholder: placeholder, noOptionsMessage: noOptionsMessage })=>{
    const renderOption = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f974a705a6cd313$export$2e2bcd8739ae039), {
            ...props
        });
    const getNoOptionsElement = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89ff5dba4ca98b74$export$2e2bcd8739ae039), {
            show: true,
            loading: optionsLoading,
            noOptionsInfo: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $1286641fd157733b$export$e7125f2b24a423a5,
                children: noOptionsMessage
            })
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    className: $1286641fd157733b$export$1237798dc640739a,
                    htmlFor: `select-${label}`,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                isMulti: true,
                id: `select-${(0, $433401918a64c671$export$2e2bcd8739ae039)(label) || Math.random()}`,
                "data-id": "multi-select",
                components: {
                    NoOptionsMessage: getNoOptionsElement,
                    ClearIndicator: $15a95a4dbc72f529$export$2e2bcd8739ae039,
                    DropdownIndicator: $2b2850ccc654d05b$export$2e2bcd8739ae039,
                    Option: renderOption
                },
                styles: {
                    ...(0, $63c2c06b53ba964b$export$2e2bcd8739ae039)(false, true, undefined, undefined, !!label),
                    ...(0, $949a2a3b3edb254a$export$2e2bcd8739ae039)()
                },
                options: options,
                onChange: (opts)=>{
                    const newSelectedOptions = opts || [];
                    onSelect(newSelectedOptions);
                },
                onBlur: onBlur,
                onInputChange: (value, action)=>{
                    if (action.action === "input-change" && onInputChange) onInputChange(value);
                },
                value: selectedOptions,
                inputValue: inputValue,
                isSearchable: true,
                isClearable: true,
                hideSelectedOptions: false,
                backspaceRemovesValue: false,
                closeMenuOnSelect: false,
                controlShouldRenderValue: false,
                placeholder: placeholder
            })
        ]
    });
};
var $b1632bfb5f783054$export$2e2bcd8739ae039 = $b1632bfb5f783054$var$MultiSelectAutocomplete;






var $acw62 = parcelRequire("acw62");

var $a27295f8e5779687$export$2e2bcd8739ae039 = {
    raw: ".hcr-nav-horizontal-16-4-0{margin:0 0 var(--hcr-spacing-4)}.hcr-nav-horizontal__items-16-4-0{align-items:flex-end;display:inline-flex}.hcr-nav-horizontal--stretch-16-4-0 .hcr-nav-horizontal__items-16-4-0{display:flex}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__items-16-4-0{border:1px solid var(--hcr-line-primary-color);border-radius:var(--hcr-border-radius-1)}.hcr-nav-horizontal__item-16-4-0{list-style-type:none;position:relative;white-space:nowrap}.hcr-nav-horizontal--stretch-16-4-0 .hcr-nav-horizontal__item-16-4-0{flex:1 1 0}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__item-16-4-0{padding:0}.hcr-nav-horizontal__link-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-content-secondary-color);display:flex;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-semibold);gap:var(--hcr-spacing-half);justify-content:center;line-height:var(--hcr-line-height-primary);padding:var(--hcr-spacing-1) var(--hcr-spacing-2);text-decoration:none}.hcr-nav-horizontal__link-16-4-0 .hcr-icon-16-4-0,.hcr-nav-horizontal__link-16-4-0 [class^=hci-icon]{line-height:1}.hcr-nav-horizontal__link-16-4-0 .hcr-icon-16-4-0:before,.hcr-nav-horizontal__link-16-4-0 [class^=hci-icon]:before{margin:0}.hcr-nav-horizontal__link-16-4-0:is(button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);text-align:inherit}.hcr-nav-horizontal__link-16-4-0:enabled:hover,.hcr-nav-horizontal__link-16-4-0[href]:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-nav-horizontal__link-16-4-0:enabled:active,.hcr-nav-horizontal__link-16-4-0[href]:active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-nav-horizontal__link--disabled-16-4-0,.hcr-nav-horizontal__link-16-4-0:disabled,.hcr-nav-horizontal__link-16-4-0[aria-disabled=true]{cursor:not-allowed;opacity:var(--hcr-disabled-element-opacity)}.hcr-nav-horizontal__link-16-4-0:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 0) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:0;position:relative;z-index:1}.hcr-nav-horizontal__link-16-4-0[aria-current],.hcr-nav-horizontal__link-16-4-0[aria-selected=true]{background-color:var(--hcr-highlight-color);color:var(--hcr-content-primary-color);position:relative}.hcr-nav-horizontal__link-16-4-0[aria-current]:before,.hcr-nav-horizontal__link-16-4-0[aria-selected=true]:before{background:var(--hcr-brand-primary-color);border-radius:var(--hcr-border-radius-1) var(--hcr-border-radius-1)0 0;bottom:0;content:\"\";height:var(--hcr-spacing-half);left:0;position:absolute;right:0}.hcr-nav-horizontal--stretch-16-4-0 .hcr-nav-horizontal__link-16-4-0{width:-webkit-fill-available;width:-moz-available;width:stretch}.hcr-nav-horizontal-16-4-0:not(.hcr-nav-horizontal--wrapper-16-4-0) .hcr-nav-horizontal__link-16-4-0:before{border-radius:0 0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__link-16-4-0{border-radius:0;border-right:1px solid var(--hcr-line-primary-color);padding-block:calc(var(--hcr-spacing-1) - 1px)}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__link-16-4-0[aria-current],.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__link-16-4-0[aria-selected=true]{background-color:var(--hcr-highlight-color)}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__item-16-4-0:first-child .hcr-nav-horizontal__link-16-4-0{border-radius:var(--hcr-border-radius-1)0 0 var(--hcr-border-radius-1)}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__item-16-4-0:first-child .hcr-nav-horizontal__link-16-4-0:before{border-radius:0 var(--hcr-border-radius-1)}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__item-16-4-0:last-child .hcr-nav-horizontal__link-16-4-0{border-radius:0 var(--hcr-border-radius-1) var(--hcr-border-radius-1)0;border-right:0}.hcr-nav-horizontal--wrapper-16-4-0 .hcr-nav-horizontal__item-16-4-0:last-child .hcr-nav-horizontal__link-16-4-0:before{border-radius:var(--hcr-border-radius-1)0}.hcr-nav-horizontal__panel-16-4-0:focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}",
    map: {
        "hcr-nav-horizontal": "hcr-nav-horizontal-16-4-0",
        "hcr-nav-horizontal__items": "hcr-nav-horizontal__items-16-4-0",
        "hcr-nav-horizontal--stretch": "hcr-nav-horizontal--stretch-16-4-0",
        "hcr-nav-horizontal--wrapper": "hcr-nav-horizontal--wrapper-16-4-0",
        "hcr-nav-horizontal__item": "hcr-nav-horizontal__item-16-4-0",
        "hcr-nav-horizontal__link": "hcr-nav-horizontal__link-16-4-0",
        "hcr-icon": "hcr-icon-16-4-0",
        "hcr-nav-horizontal__link--disabled": "hcr-nav-horizontal__link--disabled-16-4-0",
        "hcr-nav-horizontal__panel": "hcr-nav-horizontal__panel-16-4-0"
    }
};






const $064e8376ed41e262$export$405a4598562f3588 = [
    'nav',
    'div',
    'section'
];




const $88b5985a4460d911$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('nav-horizontal', (0, $a27295f8e5779687$export$2e2bcd8739ae039));
function $88b5985a4460d911$export$1b9f4bc1be160562(_a) {
    var { children: children, extraClasses: extraClasses, listRole: listRole, 'aria-label': ariaLabel, stretch: stretch = false, wrapper: wrapper = false, Elem: Elem = 'nav' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "extraClasses",
        "listRole",
        'aria-label',
        "stretch",
        "wrapper",
        "Elem"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4713e20c85afaf3$export$159d014d924da02), {
        bem: $88b5985a4460d911$var$bem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        "aria-label": ariaLabel,
        className: $88b5985a4460d911$var$bem.b({
            stretch: stretch,
            wrapper: wrapper
        }, extraClasses)
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        role: listRole,
        className: $88b5985a4460d911$var$bem.e('items')
    }, children)));
}
$88b5985a4460d911$export$1b9f4bc1be160562.displayName = 'NavHorizontal';
$88b5985a4460d911$export$1b9f4bc1be160562.propTypes = {
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('NavItem'),
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    listRole: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    'aria-label': ({ 'aria-label': ariaLabel, Elem: Elem })=>{
        // if Elem is 'div', aria-label is optional
        if (Elem === 'div') return null;
        return !ariaLabel || ariaLabel.trim() === '' ? new Error('When NavHorizontal Element is "nav" or "section" then "aria-label" is required.') : null;
    },
    stretch: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $064e8376ed41e262$export$405a4598562f3588))
};
var $88b5985a4460d911$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($88b5985a4460d911$export$1b9f4bc1be160562, (0, $a27295f8e5779687$export$2e2bcd8739ae039));



parcelRequire("acw62");
var $939cf5ee2fc3f5d2$export$837bd02682cd3db9;
var $939cf5ee2fc3f5d2$export$fa397790119a1408;
var $939cf5ee2fc3f5d2$export$b426df703d3b34b8;
var $939cf5ee2fc3f5d2$export$80e4b313e5e6b30d;
$939cf5ee2fc3f5d2$export$837bd02682cd3db9 = `HorizontalNavigation-CBF1Hq-block`;
$939cf5ee2fc3f5d2$export$fa397790119a1408 = `HorizontalNavigation-CBF1Hq-flix-theme-dark`;
$939cf5ee2fc3f5d2$export$b426df703d3b34b8 = `HorizontalNavigation-CBF1Hq-flix-theme-flix`;
$939cf5ee2fc3f5d2$export$80e4b313e5e6b30d = `HorizontalNavigation-CBF1Hq-nav`;


const $3c146de96c38ca2f$var$HorizontalNavigation = ({ displayedTab: displayedTab, onTabClicked: onTabClicked, labels: labels, blockDisplay: blockDisplay })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88b5985a4460d911$export$2e2bcd8739ae039), {
        extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(blockDisplay ? $939cf5ee2fc3f5d2$export$837bd02682cd3db9 : "", $939cf5ee2fc3f5d2$export$80e4b313e5e6b30d),
        "aria-label": `switch between ${labels.map((label)=>label.text)}`,
        children: labels.map((label)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aadfdf7a0ab017b$export$2e2bcd8739ae039), {
                Elem: displayedTab === label.key ? "span" : "button",
                active: displayedTab === label.key,
                onClick: ()=>onTabClicked(label.key),
                children: label.text
            }, label.key);
        })
    });
};
var $3c146de96c38ca2f$export$2e2bcd8739ae039 = $3c146de96c38ca2f$var$HorizontalNavigation;





var $a0a11a6f0b684203$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["Danger"] = "danger";
    NotificationType["Warning"] = "warning";
    NotificationType["Success"] = "success";
    return NotificationType;
}({});





/*
 * useEffect which runs on every rerender except the fist one
 * https://stackoverflow.com/a/73856816
 */ 
var $acw62 = parcelRequire("acw62");
const $95938a2617746cab$var$useEffectAfterMount = (cb, dependencies)=>{
    const mounted = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!mounted.current) return cb();
        mounted.current = false;
    }, dependencies);
};
var $95938a2617746cab$export$2e2bcd8739ae039 = $95938a2617746cab$var$useEffectAfterMount;







parcelRequire("acw62");



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $981db609414215bf$var$_excluded = [
    "title",
    "pathRest"
];
var $981db609414215bf$export$8b14014029ddbbd9 = function IconNewsletter(_ref) {
    var title = _ref.title, pathRest = _ref.pathRest, rest = (0, $199945823a88ad35$export$d8a2083381e8fcb)(_ref, $981db609414215bf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hci-svg-newsletter"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", (0, $199945823a88ad35$export$e092ad3ec43b55ee)({
        d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-.41 2-5.28 5.28h-.01l-1.3 1.3-1.3-1.3L5.4 6zM20 17c0 .54-.46 1-1 1H5c-.54 0-1-.46-1-1V7.41L8.58 12l-2.3 2.31a1 1 0 0 0 .02 1.4 1 1 0 0 0 1.42 0L10 13.4l1.3 1.3a1 1 0 0 0 1.42 0l1.3-1.3 2.27 2.3a1 1 0 0 0 1.42 0c.4-.37.4-1 .01-1.4L15.41 12 20 7.4z"
    }, pathRest)));
};
$981db609414215bf$export$8b14014029ddbbd9.displayName = 'InlineIcon(IconNewsletter)';
$981db609414215bf$export$8b14014029ddbbd9.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    pathRest: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
};




var $acw62 = parcelRequire("acw62");

var $f6650092eb2d58be$export$2e2bcd8739ae039 = {
    raw: ".hcr-list-wrapper-16-4-0{--hcr-list-wrapper-min-height:var(--hcr-spacing-8);--hcr-list-wrapper-content-padding:var(--hcr-spacing-2);--hcr-list-wrapper-interactive-content-padding:var(--hcr-spacing-2) var(--hcr-spacing-8) var(--hcr-spacing-2) var(--hcr-spacing-2);--hcr-list-wrapper-font-weight:var(--hcr-font-weight-semibold);list-style-type:none;margin:0;padding:0}.hcr-list-wrapper__item-16-4-0{align-items:stretch;background-color:var(--hcr-box-bg-color);border:solid var(--hcr-line-primary-color);border-width:0 1px 1px;color:var(--hcr-content-primary-color);display:flex;font-size:var(--hcr-font-size-primary);line-height:var(--hcr-line-height-primary);min-height:var(--hcr-list-wrapper-min-height);position:relative}.hcr-list-wrapper__item-16-4-0:first-of-type{border-top-width:1px}.hcr-list-wrapper__item-16-4-0:first-of-type,.hcr-list-wrapper__item-16-4-0:first-of-type .hcr-list-wrapper__content-16-4-0{border-top-left-radius:var(--hcr-border-radius-1);border-top-right-radius:var(--hcr-border-radius-1)}.hcr-list-wrapper__item-16-4-0:last-of-type,.hcr-list-wrapper__item-16-4-0:last-of-type .hcr-list-wrapper__content-16-4-0{border-bottom-left-radius:var(--hcr-border-radius-1);border-bottom-right-radius:var(--hcr-border-radius-1)}.hcr-list-wrapper__item--error-16-4-0{border-color:var(--hcr-danger-color);border-width:1px}.hcr-list-wrapper__item--error-16-4-0+.hcr-list-wrapper__item--error-16-4-0{border-width:0 1px 1px}.hcr-list-wrapper__item--disabled-16-4-0{opacity:var(--hcr-disabled-element-opacity)}.hcr-list-wrapper__item--disabled-16-4-0 .hcr-list-wrapper__content-16-4-0{cursor:not-allowed}.hcr-list-wrapper__item-16-4-0:not(.hcr-list-wrapper__item--disabled-16-4-0) .hcr-list-wrapper__content-16-4-0:is(a,button):hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-list-wrapper__item-16-4-0:not(.hcr-list-wrapper__item--disabled-16-4-0) .hcr-list-wrapper__content-16-4-0:is(a,button):active{background-image:var(--hcr-pressed-layer-color);text-decoration:none}.hcr-list-wrapper__item-16-4-0:not(.hcr-list-wrapper__item--disabled-16-4-0) .hcr-list-wrapper__content-16-4-0:is(a,button):focus-visible{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px;text-decoration:none;z-index:1}.hcr-list-wrapper__content-16-4-0{color:var(--hcr-content-primary-color);display:block;font-weight:var(--hcr-list-wrapper-font-weight);padding:var(--hcr-list-wrapper-content-padding);width:100%}.hcr-list-wrapper__content-16-4-0:is(a,button){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#0000;border:0;cursor:pointer;font-family:var(--hcr-font-family-primary);font-size:var(--hcr-font-size-primary);padding:0;padding:var(--hcr-list-wrapper-interactive-content-padding);text-align:inherit;text-align:left;text-decoration:none}.hcr-list-wrapper__content-16-4-0:is(a,button):after{background-color:var(--hcr-icon-primary-color);content:\"\";height:var(--hcr-spacing-4);margin-top:calc(-1*var(--hcr-spacing-2));-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M15.7\\ 11.3L9.72\\ 5.32a1\\ 1\\ 0\\ 00-1.42\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.42L13.58\\ 12\\ 8.3\\ 17.27a1\\ 1\\ 0\\ 000\\ 1.41\\ 1\\ 1\\ 0\\ 001.41\\ 0l5.99-5.97a1\\ 1\\ 0\\ 000-1.41z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M15.7\\ 11.3L9.72\\ 5.32a1\\ 1\\ 0\\ 00-1.42\\ 0\\ 1\\ 1\\ 0\\ 000\\ 1.42L13.58\\ 12\\ 8.3\\ 17.27a1\\ 1\\ 0\\ 000\\ 1.41\\ 1\\ 1\\ 0\\ 001.41\\ 0l5.99-5.97a1\\ 1\\ 0\\ 000-1.41z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;position:absolute;right:var(--hcr-spacing-2);top:50%;width:var(--hcr-spacing-4)}.hcr-list-wrapper--small-16-4-0{--hcr-list-wrapper-min-height:var(--hcr-spacing-6);--hcr-list-wrapper-content-padding:var(--hcr-spacing-1);--hcr-list-wrapper-interactive-content-padding:var(--hcr-spacing-1) var(--hcr-spacing-6) var(--hcr-spacing-1) var(--hcr-spacing-1);--hcr-list-wrapper-font-weight:var(--hcr-font-weight-normal)}",
    map: {
        "hcr-list-wrapper": "hcr-list-wrapper-16-4-0",
        "hcr-list-wrapper__item": "hcr-list-wrapper__item-16-4-0",
        "hcr-list-wrapper__content": "hcr-list-wrapper__content-16-4-0",
        "hcr-list-wrapper__item--error": "hcr-list-wrapper__item--error-16-4-0",
        "hcr-list-wrapper__item--disabled": "hcr-list-wrapper__item--disabled-16-4-0",
        "hcr-list-wrapper--small": "hcr-list-wrapper--small-16-4-0"
    }
};






const $e6458bc843893617$export$282e8197cbcdd610 = [
    'ul',
    'ol'
];



const $b8e2a2667fcf68a9$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('list-wrapper', (0, $f6650092eb2d58be$export$2e2bcd8739ae039));
function $b8e2a2667fcf68a9$export$a1d70406c7c51a07(_a) {
    var { extraClasses: extraClasses, children: children, small: small = false, Elem: Elem = 'ul' } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "extraClasses",
        "children",
        "small",
        "Elem"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        className: $b8e2a2667fcf68a9$var$bem.b({
            small: small
        }, extraClasses)
    }, rest), children);
}
$b8e2a2667fcf68a9$export$a1d70406c7c51a07.displayName = 'ListWrapper';
$b8e2a2667fcf68a9$export$a1d70406c7c51a07.propTypes = {
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    children: (0, $1ead597b5f273027$export$3fe9e1e5e8357d71)('ListWrapperItem'),
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $e6458bc843893617$export$282e8197cbcdd610))
};
var $b8e2a2667fcf68a9$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($b8e2a2667fcf68a9$export$a1d70406c7c51a07, (0, $f6650092eb2d58be$export$2e2bcd8739ae039));



var $acw62 = parcelRequire("acw62");







const $618739c48ea6dedf$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('list-wrapper', (0, $f6650092eb2d58be$export$2e2bcd8739ae039));
function $618739c48ea6dedf$export$43c7d73d15fbb67d(_a) {
    var { children: children, href: href, RouterLink: RouterLink, error: error = false, disabled: disabled = false, Elem: Elem = 'span', extraClasses: extraClasses } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "children",
        "href",
        "RouterLink",
        "error",
        "disabled",
        "Elem",
        "extraClasses"
    ]);
    const itemElem = href ? 'a' : Elem;
    const itemClassName = $618739c48ea6dedf$var$bem.e('item', {
        error: error,
        disabled: disabled
    }, extraClasses);
    const contClassName = $618739c48ea6dedf$var$bem.e('content');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: itemClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9dfbfe5c004aa051$export$73df57962b7f9000), Object.assign({
        RouterLink: RouterLink,
        Elem: itemElem,
        href: href
    }, rest, {
        className: contClassName
    }), children));
}
$618739c48ea6dedf$export$43c7d73d15fbb67d.displayName = 'ListWrapperItem';
$618739c48ea6dedf$export$43c7d73d15fbb67d.propTypes = {
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $ea5137d009687ef5$export$a439dc2f01176e60)),
    href: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    RouterLink: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};



parcelRequire("acw62");

var $a24f4bda873092f2$export$fa397790119a1408;
var $a24f4bda873092f2$export$b426df703d3b34b8;
var $a24f4bda873092f2$export$af5dcc21c8ae7acc;
var $a24f4bda873092f2$export$fa74c5ef354ef29c;
var $a24f4bda873092f2$export$d043ff22bb17d686;
$a24f4bda873092f2$export$fa397790119a1408 = `Settings-khISgW-flix-theme-dark`;
$a24f4bda873092f2$export$b426df703d3b34b8 = `Settings-khISgW-flix-theme-flix`;
$a24f4bda873092f2$export$af5dcc21c8ae7acc = `Settings-khISgW-headerIcon`;
$a24f4bda873092f2$export$fa74c5ef354ef29c = `Settings-khISgW-listWrapperItem`;
$a24f4bda873092f2$export$d043ff22bb17d686 = `Settings-khISgW-spinnerWrapper`;


// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// This file was automatically generated using npm run codegen
// If you want to alter this file please do so via the above mentioned command
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $f419306d4be7fb23$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $0989dd6156f69013$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $151337c9f32f7005$var$LineRegExp = /\r\n|[\n\r]/g;
function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($151337c9f32f7005$var$LineRegExp)){
        typeof match.index === 'number' || (0, $0989dd6156f69013$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $52f13d37c0305dc6$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $52f13d37c0305dc6$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $52f13d37c0305dc6$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $f419306d4be7fb23$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $52f13d37c0305dc6$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $a45c53fbf464b798$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $a45c53fbf464b798$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $52f13d37c0305dc6$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $52f13d37c0305dc6$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}



/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($289bf729a82494c6$export$b45ffd2948484c41 || ($289bf729a82494c6$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 






/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['DOT'] = '.';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($ac240aaa94caf15d$export$8b9d26ab11394711 || ($ac240aaa94caf15d$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $971bc50063303b32$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $971bc50063303b32$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOT || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $971bc50063303b32$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $971bc50063303b32$var$isSupplementaryCodePoint(body, location) {
    return $971bc50063303b32$var$isLeadingSurrogate(body.charCodeAt(location)) && $971bc50063303b32$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $971bc50063303b32$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $971bc50063303b32$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
function $971bc50063303b32$export$4b99857da92744e4(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
function $971bc50063303b32$export$c255480b061bd6aa(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $971bc50063303b32$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $971bc50063303b32$var$readBlockString(lexer, position);
                return $971bc50063303b32$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $971bc50063303b32$var$readNumber(lexer, position, code);
         // Name
        if ((0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) return $971bc50063303b32$export$ccff49e992952c96(lexer, position);
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $971bc50063303b32$var$isUnicodeScalarValue(code) || $971bc50063303b32$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.` : `Invalid character: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.`);
    }
    return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $971bc50063303b32$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $971bc50063303b32$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.`);
    } else {
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.`);
    return $971bc50063303b32$export$c255480b061bd6aa(lexer, isFloat ? (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT : (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $971bc50063303b32$var$readDigits(lexer, start, firstCode) {
    if (!(0, $876b79dde797933a$export$727d9dbc4fbb948f)(firstCode)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$971bc50063303b32$export$4b99857da92744e4(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $876b79dde797933a$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $971bc50063303b32$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) : $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) : $971bc50063303b32$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$971bc50063303b32$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $971bc50063303b32$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $971bc50063303b32$var$read16BitHexCode(body, position + 2);
    if ($971bc50063303b32$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($971bc50063303b32$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $971bc50063303b32$var$read16BitHexCode(body, position + 8);
            if ($971bc50063303b32$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $971bc50063303b32$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $971bc50063303b32$var$readHexDigit(body.charCodeAt(position)) << 12 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $971bc50063303b32$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $971bc50063303b32$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $971bc50063303b32$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $a51b3e37e1f6e888$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
function $971bc50063303b32$export$ccff49e992952c96(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $876b79dde797933a$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $971bc50063303b32$export$c255480b061bd6aa(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}







class $48f845de67894441$export$1b46278b6a12726b {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   * Since a schema coordinate may not contain newline, this value is always 1.
   */ line = 1;
    /**
   * The character offset at which the current line begins.
   * Since a schema coordinate may not contain newline, this value is always 0.
   */ lineStart = 0;
    constructor(source){
        const startOfFileToken = new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
    }
    get [Symbol.toStringTag]() {
        return 'SchemaCoordinateLexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the current Lexer token.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            // Read the next token and form a link in the token linked-list.
            const nextToken = $48f845de67894441$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
            token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
            nextToken.prev = token;
            token = nextToken;
        }
        return token;
    }
}
/**
 * Gets the next token from the source starting at the given position.
 */ function $48f845de67894441$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    const position = start;
    if (position < bodyLength) {
        const code = body.charCodeAt(position);
        switch(code){
            case 0x002e:
                // .
                return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOT, position, position + 1);
            case 0x0028:
                // (
                return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x003a:
                // :
                return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x0040:
                // @
                return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT, position, position + 1);
        } // Name
        if ((0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) return (0, $971bc50063303b32$export$ccff49e992952c96)(lexer, position);
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character: ${(0, $971bc50063303b32$export$4b99857da92744e4)(lexer, position)}.`);
    }
    return (0, $971bc50063303b32$export$c255480b061bd6aa)(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}





/* c8 ignore next 3 */ const $c44107310810d751$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $c44107310810d751$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$c44107310810d751$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $1ff584847d3a412c$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $c44107310810d751$export$ca03416d6c9e029e)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}



function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$e14c466bd0916f7a(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return type;
}
function $0013c7ab45cf197d$export$87ea0c241caf7f8f(source) {
    const sourceObj = (0, $1ff584847d3a412c$export$75135ee9ed6e435b)(source) ? source : new (0, $1ff584847d3a412c$export$1d2df86270c81ecb)(source);
    const lexer = new (0, $48f845de67894441$export$1b46278b6a12726b)(sourceObj);
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, {
        lexer: lexer
    });
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const coordinate = parser.parseSchemaCoordinate();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return coordinate;
}
class $0013c7ab45cf197d$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const { lexer: lexer, ..._options } = options;
        if (lexer) this._lexer = lexer;
        else {
            const sourceObj = (0, $1ff584847d3a412c$export$75135ee9ed6e435b)(source) ? source : new (0, $1ff584847d3a412c$export$1d2df86270c81ecb)(source);
            this._lexer = new (0, $971bc50063303b32$export$6168dc8908a6c652)(sourceObj);
        }
        this._options = _options;
        this._tokenCounter = 0;
    }
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (hasDescription && keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are not supported on shorthand queries.');
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
            }
            if (hasDescription) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, only GraphQL definitions support descriptions.');
            switch(keywordToken.value){
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY,
            description: undefined,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const description = this.parseDescription();
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            description: description,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            description: this.parseDescription(),
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING:
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST,
            values: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING) || this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$0013c7ab45cf197d$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $289bf729a82494c6$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */ parseSchemaCoordinate() {
        const start = this._lexer.token;
        const ofDirective = this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        let memberName;
        if (!ofDirective && this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOT)) memberName = this.parseName();
        let argumentName;
        if ((ofDirective || memberName) && this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L)) {
            argumentName = this.parseName();
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
        }
        if (ofDirective) {
            if (argumentName) return this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE,
                name: name,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_COORDINATE,
                name: name
            });
        } else if (memberName) {
            if (argumentName) return this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT_COORDINATE,
                name: name,
                fieldName: memberName,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).MEMBER_COORDINATE,
                name: name,
                memberName: memberName
            });
        }
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).TYPE_COORDINATE,
            name: name
        });
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $11b06753ce50693f$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$0013c7ab45cf197d$var$getTokenKindDesc(kind)}, found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    const value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $971bc50063303b32$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $4f5dcc0184f23a66$var$docCache = new Map();
var $4f5dcc0184f23a66$var$fragmentSourceMap = new Map();
var $4f5dcc0184f23a66$var$printFragmentWarnings = true;
var $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
function $4f5dcc0184f23a66$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $4f5dcc0184f23a66$var$cacheKeyFromLoc(loc) {
    return $4f5dcc0184f23a66$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $4f5dcc0184f23a66$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $4f5dcc0184f23a66$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $4f5dcc0184f23a66$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($4f5dcc0184f23a66$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $4f5dcc0184f23a66$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $4f5dcc0184f23a66$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $4f5dcc0184f23a66$var$parseDocument(source) {
    var cacheKey = $4f5dcc0184f23a66$var$normalize(source);
    if (!$4f5dcc0184f23a66$var$docCache.has(cacheKey)) {
        var parsed = (0, $0013c7ab45cf197d$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $4f5dcc0184f23a66$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $4f5dcc0184f23a66$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $4f5dcc0184f23a66$var$docCache.set(cacheKey, $4f5dcc0184f23a66$var$stripLoc($4f5dcc0184f23a66$var$processFragments(parsed)));
    }
    return $4f5dcc0184f23a66$var$docCache.get(cacheKey);
}
function $4f5dcc0184f23a66$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $4f5dcc0184f23a66$var$parseDocument(result);
}
function $4f5dcc0184f23a66$export$657554ef4dc7ac2d() {
    $4f5dcc0184f23a66$var$docCache.clear();
    $4f5dcc0184f23a66$var$fragmentSourceMap.clear();
}
function $4f5dcc0184f23a66$export$e4294e638636c6ab() {
    $4f5dcc0184f23a66$var$printFragmentWarnings = false;
}
function $4f5dcc0184f23a66$export$78cf889af350c840() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = true;
}
function $4f5dcc0184f23a66$export$5290df9bbbd3cfa() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
}
var $4f5dcc0184f23a66$var$extras = {
    gql: $4f5dcc0184f23a66$export$72e4926bf8358653,
    resetCaches: $4f5dcc0184f23a66$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $4f5dcc0184f23a66$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $4f5dcc0184f23a66$var$extras.gql, gql_1.resetCaches = $4f5dcc0184f23a66$var$extras.resetCaches, gql_1.disableFragmentWarnings = $4f5dcc0184f23a66$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.disableExperimentalFragmentVariables;
})($4f5dcc0184f23a66$export$72e4926bf8358653 || ($4f5dcc0184f23a66$export$72e4926bf8358653 = {}));
$4f5dcc0184f23a66$export$72e4926bf8358653["default"] = $4f5dcc0184f23a66$export$72e4926bf8358653;
var $4f5dcc0184f23a66$export$2e2bcd8739ae039 = $4f5dcc0184f23a66$export$72e4926bf8358653;

var $80214a2a1ebe2fb0$export$1aa5a89531b7670d = Symbol.for("apollo.skipToken");
















var $0feb9bd81dd1c3b8$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($0feb9bd81dd1c3b8$export$d1d99cf900472499 || ($0feb9bd81dd1c3b8$export$d1d99cf900472499 = {}));
var $0feb9bd81dd1c3b8$var$cache;
function $0feb9bd81dd1c3b8$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $0feb9bd81dd1c3b8$export$8f49e4af10703ce3(document) {
    if (!$0feb9bd81dd1c3b8$var$cache) $0feb9bd81dd1c3b8$var$cache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $0feb9bd81dd1c3b8$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!document && !!document.kind, 70, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 71);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 72, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query : $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(definitions.length === 1, 73, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $0feb9bd81dd1c3b8$var$cache.set(document, payload);
    return payload;
}
$0feb9bd81dd1c3b8$export$8f49e4af10703ce3.resetCache = function() {
    $0feb9bd81dd1c3b8$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("parser", function() {
    return $0feb9bd81dd1c3b8$var$cache ? $0feb9bd81dd1c3b8$var$cache.size : 0;
});
function $0feb9bd81dd1c3b8$export$6dfb8732f737404c(document, type) {
    var operation = $0feb9bd81dd1c3b8$export$8f49e4af10703ce3(document);
    var requiredOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(type);
    var usedOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(operation.type);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operation.type === type, 74, requiredOperationName, requiredOperationName, usedOperationName);
}





function $0868e36814f766fc$export$eb9a56e7a29e494(override) {
    var context = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!client, 58);
    return client;
}


var $966349df9047bbed$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $966349df9047bbed$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$966349df9047bbed$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}


var $0ad8e3d9f4959055$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ad8e3d9f4959055$var$noop() {}
var $0ad8e3d9f4959055$var$lastWatchOptions = Symbol();
function $0ad8e3d9f4959055$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $966349df9047bbed$export$7f12579c79e39619)("useQuery", // eslint-disable-next-line react-compiler/react-compiler
    $0ad8e3d9f4959055$var$useQuery_, (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $0ad8e3d9f4959055$var$useQuery_(query, options) {
    var _a = $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options), result = _a.result, obsQueryFields = _a.obsQueryFields;
    return $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), obsQueryFields);
    }, [
        result,
        obsQueryFields
    ]);
}
function $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions) {
    function createInternalState(previous) {
        var _a;
        (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(query, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Query);
        var internalState = {
            client: client,
            query: query,
            observable: // See if there is an existing observable that was used to fetch the same
            // data and if so, use it instead since it will contain the proper queryId
            // to fetch the result set. This is used during SSR.
            renderPromises && renderPromises.getSSRObservable(makeWatchQueryOptions()) || (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)["inactiveOnCreation"].withValue(!renderPromises, function() {
                return client.watchQuery($0ad8e3d9f4959055$export$2167b7db3cd527f2(void 0, client, options, makeWatchQueryOptions()));
            }),
            resultData: {
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: (_a = previous === null || previous === void 0 ? void 0 : previous.resultData.current) === null || _a === void 0 ? void 0 : _a.data
            }
        };
        return internalState;
    }
    var _a = $69607e38bd2400f2$exports.useState(createInternalState), internalState = _a[0], updateInternalState = _a[1];
    /**
     * Used by `useLazyQuery` when a new query is executed.
     * We keep this logic here since it needs to update things in unsafe
     * ways and here we at least can keep track of that in a single place.
     */ function onQueryExecuted(watchQueryOptions) {
        var _a;
        var _b;
        // this needs to be set to prevent an immediate `resubscribe` in the
        // next rerender of the `useQuery` internals
        Object.assign(internalState.observable, (_a = {}, _a[$0ad8e3d9f4959055$var$lastWatchOptions] = watchQueryOptions, _a));
        var resultData = internalState.resultData;
        updateInternalState((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, internalState), {
            // might be a different query
            query: watchQueryOptions.query,
            resultData: Object.assign(resultData, {
                // We need to modify the previous `resultData` object as we rely on the
                // object reference in other places
                previousData: ((_b = resultData.current) === null || _b === void 0 ? void 0 : _b.data) || resultData.previousData,
                current: undefined
            })
        }));
    }
    if (client !== internalState.client || query !== internalState.query) {
        // If the client or query have changed, we need to create a new InternalState.
        // This will trigger a re-render with the new state, but it will also continue
        // to run the current render function to completion.
        // Since we sometimes trigger some side-effects in the render function, we
        // re-assign `state` to the new state to ensure that those side-effects are
        // triggered with the new state.
        var newInternalState = createInternalState(internalState);
        updateInternalState(newInternalState);
        return [
            newInternalState,
            onQueryExecuted
        ];
    }
    return [
        internalState,
        onQueryExecuted
    ];
}
function $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options) {
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options.client);
    var renderPromises = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)()).renderPromises;
    var isSyncSSR = !!renderPromises;
    var disableNetworkFetches = client.disableNetworkFetches;
    var ssrAllowed = options.ssr !== false && !options.skip;
    var partialRefetch = options.partialRefetch;
    var makeWatchQueryOptions = $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, options, isSyncSSR);
    var _a = $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions), _b = _a[0], observable = _b.observable, resultData = _b.resultData, onQueryExecuted = _a[1];
    var watchQueryOptions = makeWatchQueryOptions(observable);
    $0ad8e3d9f4959055$var$useResubscribeIfNecessary(resultData, observable, client, options, watchQueryOptions);
    var obsQueryFields = $69607e38bd2400f2$exports.useMemo(function() {
        return $0ad8e3d9f4959055$var$bindObservableMethods(observable);
    }, [
        observable
    ]);
    $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed);
    var result = $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, {
        onCompleted: options.onCompleted || $0ad8e3d9f4959055$var$noop,
        onError: options.onError || $0ad8e3d9f4959055$var$noop
    });
    return {
        result: result,
        obsQueryFields: obsQueryFields,
        observable: observable,
        resultData: resultData,
        client: client,
        onQueryExecuted: onQueryExecuted
    };
}
function $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, callbacks) {
    var callbackRef = $69607e38bd2400f2$exports.useRef(callbacks);
    $69607e38bd2400f2$exports.useEffect(function() {
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        // eslint-disable-next-line react-compiler/react-compiler
        callbackRef.current = callbacks;
    });
    var resultOverride = (isSyncSSR || disableNetworkFetches) && options.ssr === false && !options.skip ? // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    $0ad8e3d9f4959055$var$ssrDisabledResult : options.skip || watchQueryOptions.fetchPolicy === "standby" ? // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    $0ad8e3d9f4959055$var$skipStandbyResult : void 0;
    var previousData = resultData.previousData;
    var currentResultOverride = $69607e38bd2400f2$exports.useMemo(function() {
        return resultOverride && $0ad8e3d9f4959055$export$de3acc9431f1695e(resultOverride, previousData, observable, client);
    }, [
        client,
        observable,
        resultOverride,
        previousData
    ]);
    return (0, $4653928bf51922ba$export$306c0aa65ff9ec16)($69607e38bd2400f2$exports.useCallback(function(handleStoreChange) {
        // reference `disableNetworkFetches` here to ensure that the rules of hooks
        // keep it as a dependency of this effect, even though it's not used
        disableNetworkFetches;
        if (isSyncSSR) return function() {};
        var onNext = function() {
            var previousResult = resultData.current;
            // We use `getCurrentResult()` instead of the onNext argument because
            // the values differ slightly. Specifically, loading results will have
            // an empty object for data instead of `undefined` for some reason.
            var result = observable.getCurrentResult();
            // Make sure we're not attempting to re-render similar results
            if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
            $0ad8e3d9f4959055$var$setResult(result, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        var onError = function(error) {
            subscription.current.unsubscribe();
            subscription.current = observable.resubscribeAfterError(onNext, onError);
            if (!$0ad8e3d9f4959055$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
            throw error;
            var previousResult = resultData.current;
            if (!previousResult || previousResult && previousResult.loading || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(error, previousResult.error)) $0ad8e3d9f4959055$var$setResult({
                data: previousResult && previousResult.data,
                error: error,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error
            }, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        // TODO evaluate if we keep this in
        // React Compiler cannot handle scoped `let` access, but a mutable object
        // like this is fine.
        // was:
        // let subscription = observable.subscribe(onNext, onError);
        var subscription = {
            current: observable.subscribe(onNext, onError)
        };
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return function() {
            setTimeout(function() {
                return subscription.current.unsubscribe();
            });
        };
    }, [
        disableNetworkFetches,
        isSyncSSR,
        observable,
        resultData,
        partialRefetch,
        client
    ]), function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    }, function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    });
}
function $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed) {
    if (renderPromises && ssrAllowed) {
        renderPromises.registerSSRObservable(observable);
        if (observable.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
        renderPromises.addObservableQueryPromise(observable);
    }
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $0ad8e3d9f4959055$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, client, options, watchQueryOptions) {
    var _a;
    if (observable[$0ad8e3d9f4959055$var$lastWatchOptions] && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(observable[$0ad8e3d9f4959055$var$lastWatchOptions], watchQueryOptions)) {
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        observable.reobserve($0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, options, watchQueryOptions));
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        resultData.previousData = ((_a = resultData.current) === null || _a === void 0 ? void 0 : _a.data) || resultData.previousData;
        resultData.current = void 0;
    }
    observable[$0ad8e3d9f4959055$var$lastWatchOptions] = watchQueryOptions;
}
function $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, _a, isSyncSSR) {
    if (_a === void 0) _a = {};
    var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
    // makes otherOptions almost a WatchQueryOptions object, except for the
    // query property that we add below.
    otherOptions = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(_a, [
        "skip",
        "ssr",
        "onCompleted",
        "onError",
        "defaultOptions"
    ]);
    return function(observable) {
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: query
        });
        if (isSyncSSR && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            watchQueryOptions.initialFetchPolicy = watchQueryOptions.initialFetchPolicy || watchQueryOptions.fetchPolicy || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
            watchQueryOptions.fetchPolicy = "standby";
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = (observable === null || observable === void 0 ? void 0 : observable.options.initialFetchPolicy) || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
        return watchQueryOptions;
    };
}
function $0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, queryHookOptions, watchQueryOptions) {
    var toMerge = [];
    var globalDefaults = client.defaultOptions.watchQuery;
    if (globalDefaults) toMerge.push(globalDefaults);
    if (queryHookOptions.defaultOptions) toMerge.push(queryHookOptions.defaultOptions);
    // We use compact rather than mergeOptions for this part of the merge,
    // because we want watchQueryOptions.variables (if defined) to replace
    // this.observable.options.variables whole. This replacement allows
    // removing variables by removing them from the variables input to
    // useQuery. If the variables were always merged together (rather than
    // replaced), there would be no way to remove existing variables.
    // However, the variables from options.defaultOptions and globalDefaults
    // (if provided) should be merged, to ensure individual defaulted
    // variables always have values, if not otherwise defined in
    // observable.options or watchQueryOptions.
    toMerge.push((0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(observable && observable.options, watchQueryOptions));
    return toMerge.reduce((0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359));
}
function $0ad8e3d9f4959055$var$setResult(nextResult, resultData, observable, client, partialRefetch, forceUpdate, callbacks) {
    var previousResult = resultData.current;
    if (previousResult && previousResult.data) resultData.previousData = previousResult.data;
    if (!nextResult.error && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nextResult.errors)) // Until a set naming convention for networkError and graphQLErrors is
    // decided upon, we map errors (graphQLErrors) to the error options.
    // TODO: Is it possible for both result.error and result.errors to be
    // defined here?
    nextResult.error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: nextResult.errors
    });
    resultData.current = $0ad8e3d9f4959055$export$de3acc9431f1695e($0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(nextResult, observable, partialRefetch), resultData.previousData, observable, client);
    // Calling state.setResult always triggers an update, though some call sites
    // perform additional equality checks before committing to an update.
    forceUpdate();
    $0ad8e3d9f4959055$var$handleErrorOrCompleted(nextResult, previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus, callbacks);
}
function $0ad8e3d9f4959055$var$handleErrorOrCompleted(result, previousNetworkStatus, callbacks) {
    if (!result.loading) {
        var error_1 = $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result);
        // wait a tick in case we are in the middle of rendering a component
        Promise.resolve().then(function() {
            if (error_1) callbacks.onError(error_1);
            else if (result.data && previousNetworkStatus !== result.networkStatus && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready) callbacks.onCompleted(result.data);
        }).catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(error);
        });
    }
}
function $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbacks, partialRefetch, client) {
    // Using this.result as a cache ensures getCurrentResult continues returning
    // the same (===) result object, unless state.setResult has been called, or
    // we're doing server rendering and therefore override the result below.
    if (!resultData.current) // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
    // this could call unsafeHandlePartialRefetch
    $0ad8e3d9f4959055$var$setResult(observable.getCurrentResult(), resultData, observable, client, partialRefetch, function() {}, callbacks);
    return resultData.current;
}
function $0ad8e3d9f4959055$export$e700754533d2c94f(queryHookDefaultOptions, clientDefaultOptions) {
    var _a;
    return (queryHookDefaultOptions === null || queryHookDefaultOptions === void 0 ? void 0 : queryHookDefaultOptions.fetchPolicy) || ((_a = clientDefaultOptions === null || clientDefaultOptions === void 0 ? void 0 : clientDefaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
}
function $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result) {
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $0ad8e3d9f4959055$export$de3acc9431f1695e(result, previousData, observable, client) {
    var data = result.data, partial = result.partial, resultWithoutPartial = (0, $a0acfd416da73b8a$export$3c9a16f847548506)(result, [
        "data",
        "partial"
    ]);
    var queryResult = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
        data: data
    }, resultWithoutPartial), {
        client: client,
        observable: observable,
        variables: observable.variables,
        called: result !== $0ad8e3d9f4959055$var$ssrDisabledResult && result !== $0ad8e3d9f4959055$var$skipStandbyResult,
        previousData: previousData
    });
    return queryResult;
}
function $0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(result, observable, partialRefetch) {
    // TODO: This code should be removed when the partialRefetch option is
    // removed. I was unable to get this hook to behave reasonably in certain
    // edge cases when this block was put in an effect.
    if (result.partial && partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && observable.options.fetchPolicy !== "cache-only") {
        observable.refetch();
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, result), {
            loading: true,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch
        });
    }
    return result;
}
var $0ad8e3d9f4959055$var$ssrDisabledResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading
});
var $0ad8e3d9f4959055$var$skipStandbyResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: false,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
});
function $0ad8e3d9f4959055$var$bindObservableMethods(observable) {
    return {
        refetch: observable.refetch.bind(observable),
        reobserve: observable.reobserve.bind(observable),
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable)
    };
}




var $5a2b96547ab615e1$export$700979bc83e7db82 = (0, $5d0a073f980bb2a3$export$71594e8a50f746f4) ? $69607e38bd2400f2$exports.useLayoutEffect : $69607e38bd2400f2$exports.useEffect;


// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $cea895d27273d5ec$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
];
function $cea895d27273d5ec$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    var execOptionsRef = $69607e38bd2400f2$exports.useRef(void 0);
    var optionsRef = $69607e38bd2400f2$exports.useRef(void 0);
    var queryRef = $69607e38bd2400f2$exports.useRef(void 0);
    var merged = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var queryHookOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, merged), {
        skip: !execOptionsRef.current
    });
    var _b = (0, $0ad8e3d9f4959055$export$5c23c59ff7f655a8)(document, queryHookOptions), obsQueryFields = _b.obsQueryFields, useQueryResult = _b.result, client = _b.client, resultData = _b.resultData, observable = _b.observable, onQueryExecuted = _b.onQueryExecuted;
    var initialFetchPolicy = observable.options.initialFetchPolicy || (0, $0ad8e3d9f4959055$export$e700754533d2c94f)(queryHookOptions.defaultOptions, client.defaultOptions);
    var forceUpdateState = $69607e38bd2400f2$exports.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $69607e38bd2400f2$exports.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = obsQueryFields[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $cea895d27273d5ec$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, [
        forceUpdateState,
        obsQueryFields
    ]);
    var called = !!execOptionsRef.current;
    var result = $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, useQueryResult), eagerMethods), {
            called: called
        });
    }, [
        useQueryResult,
        eagerMethods,
        called
    ]);
    var execute = $69607e38bd2400f2$exports.useCallback(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(optionsRef.current, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = $cea895d27273d5ec$var$executeQuery(resultData, observable, client, document, (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            skip: false
        }), onQueryExecuted).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, [
        client,
        document,
        eagerMethods,
        initialFetchPolicy,
        observable,
        resultData,
        onQueryExecuted
    ]);
    var executeRef = $69607e38bd2400f2$exports.useRef(execute);
    (0, $5a2b96547ab615e1$export$700979bc83e7db82)(function() {
        executeRef.current = execute;
    });
    var stableExecute = $69607e38bd2400f2$exports.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return executeRef.current.apply(executeRef, args);
    }, []);
    return [
        stableExecute,
        result
    ];
}
function $cea895d27273d5ec$var$executeQuery(resultData, observable, client, currentQuery, options, onQueryExecuted) {
    var query = options.query || currentQuery;
    var watchQueryOptions = (0, $0ad8e3d9f4959055$export$63539d93836ebf9c)(client, query, options, false)(observable);
    var concast = observable.reobserveAsConcast((0, $0ad8e3d9f4959055$export$2167b7db3cd527f2)(observable, client, options, watchQueryOptions));
    onQueryExecuted(watchQueryOptions);
    return new Promise(function(resolve) {
        var result;
        // Subscribe to the concast independently of the ObservableQuery in case
        // the component gets unmounted before the promise resolves. This prevents
        // the concast from terminating early and resolving with `undefined` when
        // there are no more subscribers for the concast.
        concast.subscribe({
            next: function(value) {
                result = value;
            },
            error: function() {
                resolve((0, $0ad8e3d9f4959055$export$de3acc9431f1695e)(observable.getCurrentResult(), resultData.previousData, observable, client));
            },
            complete: function() {
                resolve((0, $0ad8e3d9f4959055$export$de3acc9431f1695e)(observable["maskResult"](result), resultData.previousData, observable, client));
            }
        });
    });
}









function $6ce4d937b84048d1$export$609860bf8b0084c(mutation, options) {
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(mutation, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Mutation);
    var _a = $69607e38bd2400f2$exports.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $69607e38bd2400f2$exports.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    (0, $5a2b96547ab615e1$export$700979bc83e7db82)(function() {
        Object.assign(ref.current, {
            client: client,
            options: options,
            mutation: mutation
        });
    });
    var execute = $69607e38bd2400f2$exports.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }, function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $69607e38bd2400f2$exports.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: ref.current.client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $69607e38bd2400f2$exports.useEffect(function() {
        var current = ref.current;
        // eslint-disable-next-line react-compiler/react-compiler
        current.isMounted = true;
        return function() {
            current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $a0acfd416da73b8a$export$18ce0697a983be9b)({
            reset: reset
        }, result)
    ];
}








function $99c3602150b5e682$export$2ce622d4a52d9584(value) {
    var promise = Promise.resolve(value);
    promise.status = "fulfilled";
    promise.value = value;
    return promise;
}
function $99c3602150b5e682$export$d22877ef6074ba31(reason) {
    var promise = Promise.reject(reason);
    // prevent potential edge cases leaking unhandled error rejections
    promise.catch(function() {});
    promise.status = "rejected";
    promise.reason = reason;
    return promise;
}
function $99c3602150b5e682$export$eb00ffac1f7b439a(promise) {
    return "status" in promise;
}
function $99c3602150b5e682$export$954ba518324b0e0f(promise) {
    if ($99c3602150b5e682$export$eb00ffac1f7b439a(promise)) return promise;
    var pendingPromise = promise;
    pendingPromise.status = "pending";
    pendingPromise.then(function(value) {
        if (pendingPromise.status === "pending") {
            var fulfilledPromise = pendingPromise;
            fulfilledPromise.status = "fulfilled";
            fulfilledPromise.value = value;
        }
    }, function(reason) {
        if (pendingPromise.status === "pending") {
            var rejectedPromise = pendingPromise;
            rejectedPromise.status = "rejected";
            rejectedPromise.reason = reason;
        }
    });
    return promise;
}



// Prevent webpack from complaining about our feature detection of the
// use property of the React namespace, which is expected not
// to exist when using current stable versions, and that's fine.
var $8ed67bd4d94ce2d4$var$useKey = "use";
var $8ed67bd4d94ce2d4$var$realHook = $69607e38bd2400f2$exports[$8ed67bd4d94ce2d4$var$useKey];
var $8ed67bd4d94ce2d4$export$92629c20d6a56587 = $8ed67bd4d94ce2d4$var$realHook || function __use(promise) {
    var statefulPromise = (0, $99c3602150b5e682$export$954ba518324b0e0f)(promise);
    switch(statefulPromise.status){
        case "pending":
            throw statefulPromise;
        case "rejected":
            throw statefulPromise.reason;
        case "fulfilled":
            return statefulPromise.value;
    }
};



function $76629976780e9cfc$export$722debc0e56fea39(memoFn, deps) {
    var ref = $69607e38bd2400f2$exports.useRef(void 0);
    if (!ref.current || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ref.current.deps, deps)) // eslint-disable-next-line react-compiler/react-compiler
    ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
}








var $14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL = Symbol.for("apollo.internal.queryRef");
var $14e82582f58c487a$var$PROMISE_SYMBOL = Symbol.for("apollo.internal.refPromise");
function $14e82582f58c487a$export$d596989234857a70(internalQueryRef) {
    var _a;
    var ref = (_a = {
        toPromise: function() {
            // We avoid resolving this promise with the query data because we want to
            // discourage using the server data directly from the queryRef. Instead,
            // the data should be accessed through `useReadQuery`. When the server
            // data is needed, its better to use `client.query()` directly.
            //
            // Here we resolve with the ref itself to make using this in React Router
            // or TanStack Router `loader` functions a bit more ergonomic e.g.
            //
            // function loader() {
            //   return { queryRef: await preloadQuery(query).toPromise() }
            // }
            return $14e82582f58c487a$export$c9c310289852f904(ref).then(function() {
                return ref;
            });
        }
    }, _a[$14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL] = internalQueryRef, _a[$14e82582f58c487a$var$PROMISE_SYMBOL] = internalQueryRef.promise, _a);
    return ref;
}
function $14e82582f58c487a$export$212d896173921d75(queryRef) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!queryRef || $14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL in queryRef, 69);
}
function $14e82582f58c487a$export$c9c310289852f904(queryRef) {
    var internalQueryRef = $14e82582f58c487a$export$39359b12e11a00e3(queryRef);
    return internalQueryRef.promise.status === "fulfilled" ? internalQueryRef.promise : queryRef[$14e82582f58c487a$var$PROMISE_SYMBOL];
}
function $14e82582f58c487a$export$39359b12e11a00e3(queryRef) {
    return queryRef[$14e82582f58c487a$var$QUERY_REFERENCE_SYMBOL];
}
function $14e82582f58c487a$export$24cbda35be00f1a(queryRef, promise) {
    queryRef[$14e82582f58c487a$var$PROMISE_SYMBOL] = promise;
}
var $14e82582f58c487a$var$OBSERVED_CHANGED_OPTIONS = [
    "canonizeResults",
    "context",
    "errorPolicy",
    "fetchPolicy",
    "refetchWritePolicy",
    "returnPartialData"
];
var $14e82582f58c487a$export$d72b52f31231b813 = /** @class */ function() {
    function InternalQueryReference(observable, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.softReferences = 0;
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dispose = this.dispose.bind(this);
        this.observable = observable;
        if (options.onDispose) this.onDispose = options.onDispose;
        this.setResult();
        this.subscribeToQuery();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this queryRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function() {
            var _a;
            if (!_this.references) _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
        };
        // We wait until the request has settled to ensure we don't dispose of the
        // query ref before the request finishes, otherwise we would leave the
        // promise in a pending state rendering the suspense boundary indefinitely.
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    Object.defineProperty(InternalQueryReference.prototype, "disposed", {
        get: function() {
            return this.subscription.closed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalQueryReference.prototype, "watchQueryOptions", {
        get: function() {
            return this.observable.options;
        },
        enumerable: false,
        configurable: true
    });
    InternalQueryReference.prototype.reinitialize = function() {
        var observable = this.observable;
        var originalFetchPolicy = this.watchQueryOptions.fetchPolicy;
        var avoidNetworkRequests = originalFetchPolicy === "no-cache" || originalFetchPolicy === "standby";
        try {
            if (avoidNetworkRequests) observable.silentSetOptions({
                fetchPolicy: "standby"
            });
            else {
                observable.resetLastResults();
                observable.silentSetOptions({
                    fetchPolicy: "cache-first"
                });
            }
            this.subscribeToQuery();
            if (avoidNetworkRequests) return;
            observable.resetDiff();
            this.setResult();
        } finally{
            observable.silentSetOptions({
                fetchPolicy: originalFetchPolicy
            });
        }
    };
    InternalQueryReference.prototype.retain = function() {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function() {
            if (disposed) return;
            disposed = true;
            _this.references--;
            setTimeout(function() {
                if (!_this.references) _this.dispose();
            });
        };
    };
    InternalQueryReference.prototype.softRetain = function() {
        var _this = this;
        this.softReferences++;
        var disposed = false;
        return function() {
            // Tracking if this has already been called helps ensure that
            // multiple calls to this function won't decrement the reference
            // counter more than it should. Subsequent calls just result in a noop.
            if (disposed) return;
            disposed = true;
            _this.softReferences--;
            setTimeout(function() {
                if (!_this.softReferences && !_this.references) _this.dispose();
            });
        };
    };
    InternalQueryReference.prototype.didChangeOptions = function(watchQueryOptions) {
        var _this = this;
        return $14e82582f58c487a$var$OBSERVED_CHANGED_OPTIONS.some(function(option) {
            return option in watchQueryOptions && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.watchQueryOptions[option], watchQueryOptions[option]);
        });
    };
    InternalQueryReference.prototype.applyOptions = function(watchQueryOptions) {
        var _a = this.watchQueryOptions, currentFetchPolicy = _a.fetchPolicy, currentCanonizeResults = _a.canonizeResults;
        // "standby" is used when `skip` is set to `true`. Detect when we've
        // enabled the query (i.e. `skip` is `false`) to execute a network request.
        if (currentFetchPolicy === "standby" && currentFetchPolicy !== watchQueryOptions.fetchPolicy) this.initiateFetch(this.observable.reobserve(watchQueryOptions));
        else {
            this.observable.silentSetOptions(watchQueryOptions);
            if (currentCanonizeResults !== watchQueryOptions.canonizeResults) {
                this.result = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, this.result), this.observable.getCurrentResult());
                this.promise = (0, $99c3602150b5e682$export$2ce622d4a52d9584)(this.result);
            }
        }
        return this.promise;
    };
    InternalQueryReference.prototype.listen = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    InternalQueryReference.prototype.refetch = function(variables) {
        return this.initiateFetch(this.observable.refetch(variables));
    };
    InternalQueryReference.prototype.fetchMore = function(options) {
        return this.initiateFetch(this.observable.fetchMore(options));
    };
    InternalQueryReference.prototype.dispose = function() {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    InternalQueryReference.prototype.onDispose = function() {
    // noop. overridable by options
    };
    InternalQueryReference.prototype.handleNext = function(result) {
        var _a;
        switch(this.promise.status){
            case "pending":
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, result);
                break;
            default:
                // This occurs when switching to a result that is fully cached when this
                // class is instantiated. ObservableQuery will run reobserve when
                // subscribing, which delivers a result from the cache.
                if (result.data === this.result.data && result.networkStatus === this.result.networkStatus) return;
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                this.promise = (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result);
                this.deliver(this.promise);
                break;
        }
    };
    InternalQueryReference.prototype.handleError = function(error) {
        var _a;
        this.subscription.unsubscribe();
        this.subscription = this.observable.resubscribeAfterError(this.handleNext, this.handleError);
        switch(this.promise.status){
            case "pending":
                (_a = this.reject) === null || _a === void 0 || _a.call(this, error);
                break;
            default:
                this.promise = (0, $99c3602150b5e682$export$d22877ef6074ba31)(error);
                this.deliver(this.promise);
        }
    };
    InternalQueryReference.prototype.deliver = function(promise) {
        this.listeners.forEach(function(listener) {
            return listener(promise);
        });
    };
    InternalQueryReference.prototype.initiateFetch = function(returnedPromise) {
        var _this = this;
        this.promise = this.createPendingPromise();
        this.promise.catch(function() {});
        // If the data returned from the fetch is deeply equal to the data already
        // in the cache, `handleNext` will not be triggered leaving the promise we
        // created in a pending state forever. To avoid this situtation, we attempt
        // to resolve the promise if `handleNext` hasn't been run to ensure the
        // promise is resolved correctly.
        returnedPromise.then(function() {
            // In the case of `fetchMore`, this promise is resolved before a cache
            // result is emitted due to the fact that `fetchMore` sets a `no-cache`
            // fetch policy and runs `cache.batch` in its `.then` handler. Because
            // the timing is different, we accidentally run this update twice
            // causing an additional re-render with the `fetchMore` result by
            // itself. By wrapping in `setTimeout`, this should provide a short
            // delay to allow the `QueryInfo.notify` handler to run before this
            // promise is checked.
            // See https://github.com/apollographql/apollo-client/issues/11315 for
            // more information
            setTimeout(function() {
                var _a;
                if (_this.promise.status === "pending") {
                    // Use the current result from the observable instead of the value
                    // resolved from the promise. This avoids issues in some cases where
                    // the raw resolved value should not be the emitted value, such as
                    // when a `fetchMore` call returns an empty array after it has
                    // reached the end of the list.
                    //
                    // See the following for more information:
                    // https://github.com/apollographql/apollo-client/issues/11642
                    _this.result = _this.observable.getCurrentResult();
                    (_a = _this.resolve) === null || _a === void 0 || _a.call(_this, _this.result);
                }
            });
        }).catch(function(error) {
            var _a;
            return (_a = _this.reject) === null || _a === void 0 ? void 0 : _a.call(_this, error);
        });
        return returnedPromise;
    };
    InternalQueryReference.prototype.subscribeToQuery = function() {
        var _this = this;
        this.subscription = this.observable.filter(function(result) {
            return !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, {}) && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result, _this.result);
        }).subscribe(this.handleNext, this.handleError);
    };
    InternalQueryReference.prototype.setResult = function() {
        // Don't save this result as last result to prevent delivery of last result
        // when first subscribing
        var result = this.observable.getCurrentResult(false);
        if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result, this.result)) return;
        this.result = result;
        this.promise = result.data && (!result.partial || this.watchQueryOptions.returnPartialData) ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result) : this.createPendingPromise();
    };
    InternalQueryReference.prototype.createPendingPromise = function() {
        var _this = this;
        return (0, $99c3602150b5e682$export$954ba518324b0e0f)(new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    return InternalQueryReference;
}();





var $929004aa3455ca92$export$5ad20f9b6f32cad2 = /** @class */ function() {
    function FragmentReference(client, watchFragmentOptions, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.dispose = this.dispose.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.observable = client.watchFragment(watchFragmentOptions);
        if (options.onDispose) this.onDispose = options.onDispose;
        var diff = this.getDiff(client, watchFragmentOptions);
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this fragmentRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function() {
            var _a;
            if (!_this.references) _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
        };
        this.promise = diff.complete ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(diff.result) : this.createPendingPromise();
        this.subscribeToFragment();
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    FragmentReference.prototype.listen = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    FragmentReference.prototype.retain = function() {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function() {
            if (disposed) return;
            disposed = true;
            _this.references--;
            setTimeout(function() {
                if (!_this.references) _this.dispose();
            });
        };
    };
    FragmentReference.prototype.dispose = function() {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    FragmentReference.prototype.onDispose = function() {
    // noop. overridable by options
    };
    FragmentReference.prototype.subscribeToFragment = function() {
        this.subscription = this.observable.subscribe(this.handleNext.bind(this), this.handleError.bind(this));
    };
    FragmentReference.prototype.handleNext = function(result) {
        var _a;
        switch(this.promise.status){
            case "pending":
                if (result.complete) return (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, result.data);
                this.deliver(this.promise);
                break;
            case "fulfilled":
                // This can occur when we already have a result written to the cache and
                // we subscribe for the first time. We create a fulfilled promise in the
                // constructor with a value that is the same as the first emitted value
                // so we want to skip delivering it.
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.promise.value, result.data)) return;
                this.promise = result.complete ? (0, $99c3602150b5e682$export$2ce622d4a52d9584)(result.data) : this.createPendingPromise();
                this.deliver(this.promise);
        }
    };
    FragmentReference.prototype.handleError = function(error) {
        var _a;
        (_a = this.reject) === null || _a === void 0 || _a.call(this, error);
    };
    FragmentReference.prototype.deliver = function(promise) {
        this.listeners.forEach(function(listener) {
            return listener(promise);
        });
    };
    FragmentReference.prototype.createPendingPromise = function() {
        var _this = this;
        return (0, $99c3602150b5e682$export$954ba518324b0e0f)(new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    FragmentReference.prototype.getDiff = function(client, options) {
        var cache = client.cache;
        var from = options.from, fragment = options.fragment, fragmentName = options.fragmentName;
        var diff = cache.diff((0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            query: cache["getFragmentDoc"](fragment, fragmentName),
            returnPartialData: true,
            id: from,
            optimistic: true
        }));
        return (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, diff), {
            result: client["queryManager"].maskFragment({
                fragment: fragment,
                fragmentName: fragmentName,
                data: diff.result
            })
        });
    };
    return FragmentReference;
}();


var $f5a0c48552257915$export$7a8323d1591be59f = /** @class */ function() {
    function SuspenseCache(options) {
        if (options === void 0) options = Object.create(null);
        this.queryRefs = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        this.fragmentRefs = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        this.options = options;
    }
    SuspenseCache.prototype.getQueryRef = function(cacheKey, createObservable) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $14e82582f58c487a$export$d72b52f31231b813)(createObservable(), {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: function() {
                delete ref.current;
            }
        });
        return ref.current;
    };
    SuspenseCache.prototype.getFragmentRef = function(cacheKey, client, options) {
        var ref = this.fragmentRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, $929004aa3455ca92$export$5ad20f9b6f32cad2)(client, options, {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: function() {
                delete ref.current;
            }
        });
        return ref.current;
    };
    SuspenseCache.prototype.add = function(cacheKey, queryRef) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        ref.current = queryRef;
    };
    return SuspenseCache;
}();


var $d9329d606ac77d7c$var$suspenseCacheSymbol = Symbol.for("apollo.suspenseCache");
function $d9329d606ac77d7c$export$d841506be5d0acb2(client) {
    var _a;
    if (!client[$d9329d606ac77d7c$var$suspenseCacheSymbol]) client[$d9329d606ac77d7c$var$suspenseCacheSymbol] = new (0, $f5a0c48552257915$export$7a8323d1591be59f)((_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense);
    return client[$d9329d606ac77d7c$var$suspenseCacheSymbol];
}




function $b6b5458965dbc84d$export$5bf2755c0a009e74(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $966349df9047bbed$export$7f12579c79e39619)("useSuspenseQuery", // eslint-disable-next-line react-compiler/react-compiler
    $b6b5458965dbc84d$var$useSuspenseQuery_, (0, $0868e36814f766fc$export$eb9a56e7a29e494)(typeof options === "object" ? options.client : undefined))(query, options);
}
function $b6b5458965dbc84d$var$useSuspenseQuery_(query, options) {
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options.client);
    var suspenseCache = (0, $d9329d606ac77d7c$export$d841506be5d0acb2)(client);
    var watchQueryOptions = $b6b5458965dbc84d$export$85ae642579670efb({
        client: client,
        query: query,
        options: options
    });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var cacheKey = (0, $a0acfd416da73b8a$export$1216008129fb82ed)([
        query,
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables)
    ], [].concat(queryKey), true);
    var queryRef = suspenseCache.getQueryRef(cacheKey, function() {
        return client.watchQuery(watchQueryOptions);
    });
    var _b = $69607e38bd2400f2$exports.useState([
        queryRef.key,
        queryRef.promise
    ]), current = _b[0], setPromise = _b[1];
    // This saves us a re-execution of the render function when a variable changed.
    if (current[0] !== queryRef.key) {
        // eslint-disable-next-line react-compiler/react-compiler
        current[0] = queryRef.key;
        current[1] = queryRef.promise;
    }
    var promise = current[1];
    if (queryRef.didChangeOptions(watchQueryOptions)) current[1] = promise = queryRef.applyOptions(watchQueryOptions);
    $69607e38bd2400f2$exports.useEffect(function() {
        var dispose = queryRef.retain();
        var removeListener = queryRef.listen(function(promise) {
            setPromise([
                queryRef.key,
                promise
            ]);
        });
        return function() {
            removeListener();
            dispose();
        };
    }, [
        queryRef
    ]);
    var skipResult = $69607e38bd2400f2$exports.useMemo(function() {
        var error = $b6b5458965dbc84d$export$b2c90f1874ba96bf(queryRef.result);
        return {
            loading: false,
            data: queryRef.result.data,
            networkStatus: error ? (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error : (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready,
            error: error
        };
    }, [
        queryRef.result
    ]);
    var result = fetchPolicy === "standby" ? skipResult : (0, $8ed67bd4d94ce2d4$export$92629c20d6a56587)(promise);
    var fetchMore = $69607e38bd2400f2$exports.useCallback(function(options) {
        var promise = queryRef.fetchMore(options);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    var refetch = $69607e38bd2400f2$exports.useCallback(function(variables) {
        var promise = queryRef.refetch(variables);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    // TODO: The internalQueryRef doesn't have TVariables' type information so we have to cast it here
    var subscribeToMore = queryRef.observable.subscribeToMore;
    return $69607e38bd2400f2$exports.useMemo(function() {
        return {
            client: client,
            data: result.data,
            error: $b6b5458965dbc84d$export$b2c90f1874ba96bf(result),
            networkStatus: result.networkStatus,
            fetchMore: fetchMore,
            refetch: refetch,
            subscribeToMore: subscribeToMore
        };
    }, [
        client,
        fetchMore,
        refetch,
        result,
        subscribeToMore
    ]);
}
function $b6b5458965dbc84d$var$validateOptions(options) {
    var query = options.query, fetchPolicy = options.fetchPolicy, returnPartialData = options.returnPartialData;
    (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(query, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Query);
    $b6b5458965dbc84d$var$validateFetchPolicy(fetchPolicy);
    $b6b5458965dbc84d$var$validatePartialDataReturn(fetchPolicy, returnPartialData);
}
function $b6b5458965dbc84d$var$validateFetchPolicy(fetchPolicy) {
    if (fetchPolicy === void 0) fetchPolicy = "cache-first";
    var supportedFetchPolicies = [
        "cache-first",
        "network-only",
        "no-cache",
        "cache-and-network"
    ];
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(supportedFetchPolicies.includes(fetchPolicy), 66, fetchPolicy);
}
function $b6b5458965dbc84d$var$validatePartialDataReturn(fetchPolicy, returnPartialData) {
    if (fetchPolicy === "no-cache" && returnPartialData) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(67);
}
function $b6b5458965dbc84d$export$b2c90f1874ba96bf(result) {
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $b6b5458965dbc84d$export$85ae642579670efb(_a) {
    var client = _a.client, query = _a.query, options = _a.options;
    return (0, $76629976780e9cfc$export$722debc0e56fea39)(function() {
        var _a;
        if (options === (0, $80214a2a1ebe2fb0$export$1aa5a89531b7670d)) return {
            query: query,
            fetchPolicy: "standby"
        };
        var fetchPolicy = options.fetchPolicy || ((_a = client.defaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
        var watchQueryOptions = (0, $a0acfd416da73b8a$export$18ce0697a983be9b)((0, $a0acfd416da73b8a$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: fetchPolicy,
            query: query,
            notifyOnNetworkStatusChange: false,
            nextFetchPolicy: void 0
        });
        if (globalThis.__DEV__ !== false) $b6b5458965dbc84d$var$validateOptions(watchQueryOptions);
        // Assign the updated fetch policy after our validation since `standby` is
        // not a supported fetch policy on its own without the use of `skip`.
        if (options.skip) watchQueryOptions.fetchPolicy = "standby";
        return watchQueryOptions;
    }, [
        client,
        options,
        query
    ]);
}


const $808edefb2e1fceb5$var$defaultOptions = {};
const $808edefb2e1fceb5$export$9b155b059188a949 = (0, $4f5dcc0184f23a66$export$72e4926bf8358653)`
  fragment Preference on Preference {
    ridesFullyBooked {
      active
      utilization
    }
    scheduleExpiryReminder {
      active
    }
    productNews {
      active
    }
    bookingReports {
      active
      time
      timezone
    }
  }
`;
const $808edefb2e1fceb5$export$7000cd62712c9956 = (0, $4f5dcc0184f23a66$export$72e4926bf8358653)`
  query GetUser {
    getUser {
      id
      displayName
      mail
      language
      preference {
        ...Preference
      }
    }
  }
  ${$808edefb2e1fceb5$export$9b155b059188a949}
`;
function $808edefb2e1fceb5$export$9beb97f355b95ab9(baseOptions) {
    const options = {
        ...$808edefb2e1fceb5$var$defaultOptions,
        ...baseOptions
    };
    return $0ad8e3d9f4959055$export$dd0a697e1782aedd($808edefb2e1fceb5$export$7000cd62712c9956, options);
}
function $808edefb2e1fceb5$export$7df562623c42db5(baseOptions) {
    const options = {
        ...$808edefb2e1fceb5$var$defaultOptions,
        ...baseOptions
    };
    return $cea895d27273d5ec$export$fd83eea6ecd2d8fa($808edefb2e1fceb5$export$7000cd62712c9956, options);
}
function $808edefb2e1fceb5$export$a632e7fe35eb6f5d(baseOptions) {
    const options = baseOptions === $80214a2a1ebe2fb0$export$1aa5a89531b7670d ? baseOptions : {
        ...$808edefb2e1fceb5$var$defaultOptions,
        ...baseOptions
    };
    return $b6b5458965dbc84d$export$5bf2755c0a009e74($808edefb2e1fceb5$export$7000cd62712c9956, options);
}
const $808edefb2e1fceb5$export$9678a9827deb7b30 = (0, $4f5dcc0184f23a66$export$72e4926bf8358653)`
  mutation UpdateUserPreference($language: Language!, $preference: PreferenceInput!) {
    updateUserPreference(language: $language, preference: $preference) {
      id
      language
      preference {
        ...Preference
      }
    }
  }
  ${$808edefb2e1fceb5$export$9b155b059188a949}
`;
function $808edefb2e1fceb5$export$f933a6ccf2714c6f(baseOptions) {
    const options = {
        ...$808edefb2e1fceb5$var$defaultOptions,
        ...baseOptions
    };
    return $6ce4d937b84048d1$export$609860bf8b0084c($808edefb2e1fceb5$export$9678a9827deb7b30, options);
}





var $acw62 = parcelRequire("acw62");

var $b0c6f7113c8a4417$export$2e2bcd8739ae039 = {
    raw: ".hcr-switch-16-4-0{display:block;line-height:var(--hcr-spacing-5)}.hcr-switch__info-16-4-0:not(:empty){color:var(--hcr-container-content-color,var(--hcr-content-primary-color));display:block;font-size:var(--hcr-font-size-small);font-weight:var(--hcr-font-weight-normal);line-height:var(--hcr-line-height-small);margin-top:var(--hcr-spacing-1)}.hcr-switch__info-16-4-0:not(:empty)~.hcr-switch__info-16-4-0{margin-top:var(--hcr-spacing-half)}.hcr-switch--error-16-4-0 .hcr-switch__info-16-4-0{color:var(--hcr-danger-dark-color)}.hcr-switch__info-16-4-0~.hcr-switch__info-16-4-0{color:var(--hcr-content-primary-color)}@media (min-width:600px){.hcr-switch-16-4-0{display:inline-block}}.hcr-switch__input-16-4-0{height:0;opacity:0;position:absolute;width:0}.hcr-switch__input-16-4-0:enabled+.hcr-switch__label-16-4-0:hover{background-image:var(--hcr-hover-layer-color);text-decoration:none}.hcr-switch__label-16-4-0{align-items:center;border-radius:var(--hcr-border-radius-1);color:var(--hcr-container-content-color,var(--hcr-content-primary-color));column-gap:var(--hcr-spacing-2);cursor:pointer;display:grid;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);grid-template-columns:auto var(--hcr-spacing-8);line-height:var(--hcr-line-height-primary);margin:calc(-1*var(--hcr-spacing-half));min-height:calc(var(--hcr-spacing-5) + var(--hcr-spacing-half)*2);min-width:100%;padding:var(--hcr-spacing-half)}@media (min-width:600px){.hcr-switch__label-16-4-0{grid-template-columns:var(--hcr-spacing-8) auto}}.hcr-switch__label-16-4-0:after,.hcr-switch__label-16-4-0:before{align-self:center;content:\"\";grid-column:2;grid-row:1;justify-self:end}@media (min-width:600px){.hcr-switch__label-16-4-0:after,.hcr-switch__label-16-4-0:before{grid-column:1}}.hcr-switch__label-16-4-0:before{background-color:var(--hcr-input-border-color);border-radius:var(--hcr-spacing-5);height:var(--hcr-spacing-5);transition:background-color .25s ease;width:var(--hcr-spacing-8)}.hcr-switch__label-16-4-0:after{background-color:var(--hcr-grayscale-0-color);height:var(--hcr-spacing-5);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10.01\\ 10.01\\ 0\\ 000\\ 20\\ 10.01\\ 10.01\\ 0\\ 000-20z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10.01\\ 10.01\\ 0\\ 000\\ 20\\ 10.01\\ 10.01\\ 0\\ 000-20z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;transform:translateX(calc((var(--hcr-spacing-8) - var(--hcr-spacing-5))*-1));transition:transform .25s ease,-webkit-mask-image .25s ease;transition:transform .25s ease,mask-image .25s ease;transition:transform .25s ease,mask-image .25s ease,-webkit-mask-image .25s ease;width:var(--hcr-spacing-5)}.hcr-switch__input-16-4-0:focus-visible+.hcr-switch__label-16-4-0{border-radius:var(--hcr-border-radius-1);box-shadow:0 0 0 calc(var(--hcr-spacing-half) + 1px) var(--hcr-grayscale-0-color);outline:2px solid var(--hcr-focus-outline-color);outline-offset:1px}.hcr-switch__input-16-4-0:checked+.hcr-switch__label-16-4-0:after{background-color:var(--hcr-grayscale-0-color);height:var(--hcr-spacing-5);-webkit-mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;mask:url(data:image/svg+xml,%3Csvg\\ viewBox=\\'0\\ 0\\ 24\\ 24\\'\\ xmlns=\\'http://www.w3.org/2000/svg\\'\\ %3E%3Cpath\\ d=\\'M12\\ 2a10\\ 10\\ 0\\ 100\\ 20\\ 10\\ 10\\ 0\\ 000-20zm4.89\\ 7.7l-6\\ 6a1\\ 1\\ 0\\ 01-1.42\\ 0l-2.36-2.35a1\\ 1\\ 0\\ 111.42-1.41l1.65\\ 1.65\\ 5.3-5.3a1\\ 1\\ 0\\ 111.4\\ 1.42z\\'\\ /%3E%3C/svg%3E)no-repeat center/cover;transform:translateX(0);width:var(--hcr-spacing-5)}.hcr-switch__input-16-4-0:checked+.hcr-switch__label-16-4-0:before{background-color:var(--hcr-content-primary-color)}.hcr-switch--sm-16-4-0{line-height:var(--hcr-spacing-3);min-height:var(--hcr-spacing-3)}@media (min-width:600px){.hcr-switch--sm-16-4-0 .hcr-switch__label-16-4-0{grid-template-columns:var(--hcr-spacing-5) auto}}.hcr-switch--sm-16-4-0 .hcr-switch__label-16-4-0:before{border-radius:var(--hcr-spacing-3);height:var(--hcr-spacing-3);width:var(--hcr-spacing-5)}.hcr-switch--sm-16-4-0 .hcr-switch__label-16-4-0:after{height:var(--hcr-spacing-3);transform:translateX(calc((var(--hcr-spacing-5) - var(--hcr-spacing-3))*-1));width:var(--hcr-spacing-3)}.hcr-switch--sm-16-4-0 .hcr-switch__input-16-4-0:checked+.hcr-switch__label-16-4-0:after{height:var(--hcr-spacing-3);width:var(--hcr-spacing-3)}.hcr-switch--stacked-16-4-0 .hcr-switch__label-16-4-0{grid-template-columns:auto}.hcr-switch--stacked-16-4-0 .hcr-switch__label-16-4-0:after,.hcr-switch--stacked-16-4-0 .hcr-switch__label-16-4-0:before{grid-column:1;grid-row:2;justify-self:start}.hcr-switch--stacked-16-4-0 .hcr-switch__label-16-4-0:after{transform:translateX(0)}.hcr-switch--stacked-16-4-0 .hcr-switch__input-16-4-0:checked+.hcr-switch__label-16-4-0:after{transform:translateX(calc(var(--hcr-spacing-8) - var(--hcr-spacing-5)))}@media (min-width:1200px){.hcr-switch--stacked-16-4-0{color:var(--hcr-content-secondary-color)}}.hcr-switch--disabled-16-4-0{opacity:var(--hcr-disabled-element-opacity)}.hcr-switch--disabled-16-4-0 .hcr-switch__label-16-4-0{cursor:not-allowed}",
    map: {
        "hcr-switch": "hcr-switch-16-4-0",
        "hcr-switch__info": "hcr-switch__info-16-4-0",
        "hcr-switch--error": "hcr-switch--error-16-4-0",
        "hcr-switch__input": "hcr-switch__input-16-4-0",
        "hcr-switch__label": "hcr-switch__label-16-4-0",
        "hcr-switch--sm": "hcr-switch--sm-16-4-0",
        "hcr-switch--stacked": "hcr-switch--stacked-16-4-0",
        "hcr-switch--disabled": "hcr-switch--disabled-16-4-0"
    }
};







const $6e0c6ddba99cd38e$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('switch', (0, $b0c6f7113c8a4417$export$2e2bcd8739ae039));
function $6e0c6ddba99cd38e$export$b5d5cf8927ab7262(_a) {
    var { disabled: disabled, extraClasses: extraClasses, id: id, info: info, infoError: infoError, label: label, stacked: stacked = false, small: small = false, 'aria-describedby': ariaDescribedBy } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "disabled",
        "extraClasses",
        "id",
        "info",
        "infoError",
        "label",
        "stacked",
        "small",
        'aria-describedby'
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $6e0c6ddba99cd38e$var$bem.b({
            disabled: disabled,
            stacked: stacked,
            error: infoError,
            sm: small
        }, extraClasses)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        id: id,
        className: $6e0c6ddba99cd38e$var$bem.e('input'),
        type: "checkbox",
        disabled: disabled,
        "aria-errormessage": `infoError-${id}`,
        "aria-describedby": $fc332675fdeb2380$export$db93d21cb888fc59(id, {
            info: info,
            ariaDescribedBy: ariaDescribedBy
        })
    }, infoError && {
        'aria-invalid': true
    }, rest)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: id,
        className: $6e0c6ddba99cd38e$var$bem.e('label')
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        error: true,
        id: id,
        className: $6e0c6ddba99cd38e$var$bem.e('info')
    }, infoError), info && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $facdcf0d3636fc4c$export$141b3f6b946c04dd), {
        id: id,
        className: $6e0c6ddba99cd38e$var$bem.e('info')
    }, info));
}
$6e0c6ddba99cd38e$export$b5d5cf8927ab7262.displayName = 'Switch';
$6e0c6ddba99cd38e$export$b5d5cf8927ab7262.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    info: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    infoError: (0, $facdcf0d3636fc4c$export$52637b497a650311),
    label ({ 'aria-label': ariaLabel, label: label }) {
        // if no aria label nor label throw validation error
        return !ariaLabel && !label ? new Error('Either label or aria-label are required for Switch component.') : null;
    },
    stacked: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
var $6e0c6ddba99cd38e$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($6e0c6ddba99cd38e$export$b5d5cf8927ab7262, (0, $b0c6f7113c8a4417$export$2e2bcd8739ae039));



parcelRequire("acw62");

var $967bdd8205cc5d12$export$fa397790119a1408;
var $967bdd8205cc5d12$export$b426df703d3b34b8;
var $967bdd8205cc5d12$export$a80b3bd66acc52ff;
var $967bdd8205cc5d12$export$76c7e83ecc9cdf05;
var $967bdd8205cc5d12$export$67870427684edf46;
var $967bdd8205cc5d12$export$52002a3975269b5d;
var $967bdd8205cc5d12$export$58485ece88f64aa8;
var $967bdd8205cc5d12$export$b60afe7011bdf071;
$967bdd8205cc5d12$export$fa397790119a1408 = `BookingReportItem-Rxii0G-flix-theme-dark`;
$967bdd8205cc5d12$export$b426df703d3b34b8 = `BookingReportItem-Rxii0G-flix-theme-flix`;
$967bdd8205cc5d12$export$a80b3bd66acc52ff = `BookingReportItem-Rxii0G-info`;
$967bdd8205cc5d12$export$76c7e83ecc9cdf05 = `BookingReportItem-Rxii0G-listItem`;
$967bdd8205cc5d12$export$67870427684edf46 = `BookingReportItem-Rxii0G-setupWrapper`;
$967bdd8205cc5d12$export$52002a3975269b5d = `BookingReportItem-Rxii0G-switch`;
$967bdd8205cc5d12$export$58485ece88f64aa8 = `BookingReportItem-Rxii0G-switchWrapper`;
$967bdd8205cc5d12$export$b60afe7011bdf071 = `BookingReportItem-Rxii0G-timezoneWrapper`;


const $a7fdc30add12756f$var$BookingReportItem = ({ preference: preference, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    const handleTimeInputChange = (0, $f21400ae50a90441$export$2e2bcd8739ae039)((value)=>onChange({
            active: preference.active,
            time: value,
            timezone: preference.timezone
        }), 500);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $967bdd8205cc5d12$export$76c7e83ecc9cdf05,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.dailyBookingReportNotification.header"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: $967bdd8205cc5d12$export$a80b3bd66acc52ff,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.dailyBookingReportNotification.subheader"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-testid": "select-wrapper",
                        className: $967bdd8205cc5d12$export$67870427684edf46,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0df4954ae6776a3$export$2e2bcd8739ae039), {
                                id: "booking-report-time-input",
                                "aria-label": "booking-report-time-input",
                                "data-testid": "booking-report-time-input",
                                type: "time",
                                label: formatMessage({
                                    id: "time.input.label"
                                }),
                                info: formatMessage({
                                    id: "time.input.info"
                                }),
                                defaultValue: preference.time,
                                onChange: (event)=>{
                                    handleTimeInputChange(event.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: $967bdd8205cc5d12$export$b60afe7011bdf071,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fde2397fa9c66531$export$2e2bcd8739ae039), {
                                    label: formatMessage({
                                        id: "timezone.select.label"
                                    }),
                                    options: (0, $c58d3c29271911d8$export$2e2bcd8739ae039)(),
                                    startsOnInputValueLength: 0,
                                    initialValue: {
                                        value: preference.timezone,
                                        label: preference.timezone
                                    },
                                    onValueSelected: (selectedValue)=>{
                                        onChange({
                                            active: preference.active,
                                            time: preference.time,
                                            timezone: selectedValue.value
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $967bdd8205cc5d12$export$58485ece88f64aa8,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0c6ddba99cd38e$export$2e2bcd8739ae039), {
                    id: "booking-report-switch",
                    "aria-label": "booking-report",
                    defaultChecked: preference.active,
                    onChange: ({ currentTarget: currentTarget })=>{
                        onChange({
                            active: currentTarget.checked,
                            time: preference.time,
                            timezone: preference.timezone
                        });
                    },
                    extraClasses: $967bdd8205cc5d12$export$52002a3975269b5d
                })
            })
        ]
    });
};
var $a7fdc30add12756f$export$2e2bcd8739ae039 = $a7fdc30add12756f$var$BookingReportItem;





parcelRequire("acw62");

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// This file was automatically generated using npm run codegen
// If you want to alter this file please do so via the above mentioned command
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
var $31a4b012c88a3eb5$export$ce4fe1c9e6520c1a = /*#__PURE__*/ function(Language) {
    /** Azerbaijani */ Language["Az"] = "AZ";
    /** Belarusian */ Language["Be"] = "BE";
    /** Bulgarian */ Language["Bg"] = "BG";
    /** Bosnian */ Language["Bs"] = "BS";
    /** Czech */ Language["Cs"] = "CS";
    /** Danish */ Language["Da"] = "DA";
    /** German */ Language["De"] = "DE";
    /** Greek */ Language["El"] = "EL";
    /** English */ Language["En"] = "EN";
    /** Spanish */ Language["Es"] = "ES";
    /** Estonian */ Language["Et"] = "ET";
    /** Finnish */ Language["Fi"] = "FI";
    /** French */ Language["Fr"] = "FR";
    /** Irish */ Language["Ga"] = "GA";
    /** Croatian */ Language["Hr"] = "HR";
    /** Hungarian */ Language["Hu"] = "HU";
    /** Armenian */ Language["Hy"] = "HY";
    /** Icelandic */ Language["Is"] = "IS";
    /** Italian */ Language["It"] = "IT";
    /** Georgian */ Language["Ka"] = "KA";
    /** Kazakh */ Language["Kk"] = "KK";
    /** Luxembourgish */ Language["Lb"] = "LB";
    /** Lithuanian */ Language["Lt"] = "LT";
    /** Latvian */ Language["Lv"] = "LV";
    /** Macedonian */ Language["Mk"] = "MK";
    /** Maltese */ Language["Mt"] = "MT";
    /** Dutch */ Language["Nl"] = "NL";
    /** Norwegian */ Language["No"] = "NO";
    /** Polish */ Language["Pl"] = "PL";
    /** Portuguese */ Language["Pt"] = "PT";
    /** Romanian */ Language["Ro"] = "RO";
    /** Russian */ Language["Ru"] = "RU";
    /** Northern Sami */ Language["Se"] = "SE";
    /** Slovak */ Language["Sk"] = "SK";
    /** Slovene */ Language["Sl"] = "SL";
    /** Albanian */ Language["Sq"] = "SQ";
    /** Serbian */ Language["Sr"] = "SR";
    /** Swedish */ Language["Sv"] = "SV";
    /** Turkish */ Language["Tr"] = "TR";
    /** Ukrainian */ Language["Uk"] = "UK";
    return Language;
}({});


const $c52959ab49698796$export$68f2bb91674b52b = [
    {
        locale: "en_US",
        name: "English",
        flagName: "us",
        bcp47Locale: "en-US",
        iso6391: "en",
        drupal: "en-us"
    },
    {
        locale: "de",
        name: "Deutsch",
        flagName: "de",
        bcp47Locale: "de",
        iso6391: "de",
        drupal: "de"
    },
    {
        locale: "hr",
        name: "Hrvatski",
        flagName: "hr",
        bcp47Locale: "hr",
        iso6391: "hr",
        drupal: "hr"
    },
    {
        locale: "fr",
        name: "Fran\xe7ais",
        flagName: "fr",
        bcp47Locale: "fr",
        iso6391: "fr",
        drupal: "fr"
    },
    {
        locale: "it",
        name: "Italiano",
        flagName: "it",
        bcp47Locale: "it",
        iso6391: "it",
        drupal: "it"
    },
    {
        locale: "pl",
        name: "Polski",
        flagName: "pl",
        bcp47Locale: "pl",
        iso6391: "pl",
        drupal: "pl"
    },
    {
        locale: "pt_PT",
        name: "Portugu\xeas",
        flagName: "pt",
        bcp47Locale: "pt",
        iso6391: "pt",
        drupal: "pt-pt"
    },
    {
        locale: "es",
        name: "Espa\xf1ol",
        flagName: "es",
        bcp47Locale: "es",
        iso6391: "es",
        drupal: "es"
    },
    {
        locale: "uk",
        name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        flagName: "ua",
        bcp47Locale: "uk",
        iso6391: "uk",
        drupal: "uk"
    },
    {
        locale: "tr",
        name: "T\xfcrk",
        flagName: "tr",
        bcp47Locale: "tr",
        iso6391: "tr",
        drupal: "tr"
    }
];
const $c52959ab49698796$export$50b1fc38daf11e85 = (locale)=>{
    const language = Object.values((0, $31a4b012c88a3eb5$export$ce4fe1c9e6520c1a)).find((lang)=>lang.toLowerCase() === locale.iso6391);
    if (language === undefined) throw new Error(`Language not found for locale: ${locale.iso6391}`);
    return language;
};
const $c52959ab49698796$export$a73865999604d89 = (language)=>{
    const locale = Object.values($c52959ab49698796$export$68f2bb91674b52b).find((locales)=>locales.iso6391 === language.toLowerCase());
    if (locale === undefined) throw new Error(`Locale not found for language: ${language}`);
    return locale;
};


var $a748abb5ee7b9dc9$export$fa397790119a1408;
var $a748abb5ee7b9dc9$export$b426df703d3b34b8;
var $a748abb5ee7b9dc9$export$a80b3bd66acc52ff;
var $a748abb5ee7b9dc9$export$76c7e83ecc9cdf05;
var $a748abb5ee7b9dc9$export$52002a3975269b5d;
var $a748abb5ee7b9dc9$export$58485ece88f64aa8;
$a748abb5ee7b9dc9$export$fa397790119a1408 = `ListItemStyles-Q5nAqG-flix-theme-dark`;
$a748abb5ee7b9dc9$export$b426df703d3b34b8 = `ListItemStyles-Q5nAqG-flix-theme-flix`;
$a748abb5ee7b9dc9$export$a80b3bd66acc52ff = `ListItemStyles-Q5nAqG-info`;
$a748abb5ee7b9dc9$export$76c7e83ecc9cdf05 = `ListItemStyles-Q5nAqG-listItem`;
$a748abb5ee7b9dc9$export$52002a3975269b5d = `ListItemStyles-Q5nAqG-switch`;
$a748abb5ee7b9dc9$export$58485ece88f64aa8 = `ListItemStyles-Q5nAqG-switchWrapper`;


const $554024e2ba99f1e3$var$ProductNewsItem = ({ language: language, preference: preference, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $a748abb5ee7b9dc9$export$76c7e83ecc9cdf05,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.productNewsNotification.header"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: $a748abb5ee7b9dc9$export$a80b3bd66acc52ff,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.productNewsNotification.subheader"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cea3b3f250ab4ad$export$2e2bcd8739ae039), {
                            currentLanguage: (0, $c52959ab49698796$export$a73865999604d89)(language),
                            languages: [
                                {
                                    region: formatMessage({
                                        id: "navigation.switchLanguage"
                                    }),
                                    locales: (0, $c52959ab49698796$export$68f2bb91674b52b)
                                }
                            ],
                            onLanguageSelected: (locale)=>{
                                onChange((0, $c52959ab49698796$export$50b1fc38daf11e85)(locale), {
                                    active: preference.active
                                });
                            },
                            toggleIcon: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $a748abb5ee7b9dc9$export$58485ece88f64aa8,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0c6ddba99cd38e$export$2e2bcd8739ae039), {
                    id: "product-news-switch",
                    "aria-label": "product-news",
                    defaultChecked: preference.active,
                    onChange: ({ currentTarget: currentTarget })=>{
                        onChange(language, {
                            active: currentTarget.checked
                        });
                    },
                    extraClasses: $a748abb5ee7b9dc9$export$52002a3975269b5d
                })
            })
        ]
    });
};
var $554024e2ba99f1e3$export$2e2bcd8739ae039 = $554024e2ba99f1e3$var$ProductNewsItem;





parcelRequire("acw62");


const $32cfa2d879d94977$export$686f881ababcf2a2 = [
    {
        value: 80,
        label: "80%"
    },
    {
        value: 70,
        label: "70%"
    },
    {
        value: 60,
        label: "60%"
    },
    {
        value: 50,
        label: "50%"
    }
];
const $32cfa2d879d94977$export$ab8e91f7535378c3 = (utilization)=>{
    switch(utilization){
        case 80:
            return $32cfa2d879d94977$export$686f881ababcf2a2[0];
        case 70:
            return $32cfa2d879d94977$export$686f881ababcf2a2[1];
        case 60:
            return $32cfa2d879d94977$export$686f881ababcf2a2[2];
        case 50:
            return $32cfa2d879d94977$export$686f881ababcf2a2[3];
        default:
            return $32cfa2d879d94977$export$686f881ababcf2a2[3];
    }
};


var $69bc59ecb35b6eba$export$fa397790119a1408;
var $69bc59ecb35b6eba$export$b426df703d3b34b8;
var $69bc59ecb35b6eba$export$a80b3bd66acc52ff;
var $69bc59ecb35b6eba$export$76c7e83ecc9cdf05;
var $69bc59ecb35b6eba$export$9fb37dd3c0ee904e;
var $69bc59ecb35b6eba$export$52002a3975269b5d;
var $69bc59ecb35b6eba$export$58485ece88f64aa8;
$69bc59ecb35b6eba$export$fa397790119a1408 = `RideFullyBookedItem-k1qYhG-flix-theme-dark`;
$69bc59ecb35b6eba$export$b426df703d3b34b8 = `RideFullyBookedItem-k1qYhG-flix-theme-flix`;
$69bc59ecb35b6eba$export$a80b3bd66acc52ff = `RideFullyBookedItem-k1qYhG-info`;
$69bc59ecb35b6eba$export$76c7e83ecc9cdf05 = `RideFullyBookedItem-k1qYhG-listItem`;
$69bc59ecb35b6eba$export$9fb37dd3c0ee904e = `RideFullyBookedItem-k1qYhG-selectWrapper`;
$69bc59ecb35b6eba$export$52002a3975269b5d = `RideFullyBookedItem-k1qYhG-switch`;
$69bc59ecb35b6eba$export$58485ece88f64aa8 = `RideFullyBookedItem-k1qYhG-switchWrapper`;


const $5ff6465a51182a64$var$RideFullyBookedItem = ({ preference: preference, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $69bc59ecb35b6eba$export$76c7e83ecc9cdf05,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.fullyBookedRidesNotification.header"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: $69bc59ecb35b6eba$export$a80b3bd66acc52ff,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.fullyBookedRidesNotification.subheader"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "select-wrapper",
                        className: $69bc59ecb35b6eba$export$9fb37dd3c0ee904e,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                            id: "fully-booked-rides-select",
                            "data-testid": "fully-booked-rides-select",
                            defaultValue: (0, $32cfa2d879d94977$export$ab8e91f7535378c3)(preference.utilization),
                            options: (0, $32cfa2d879d94977$export$686f881ababcf2a2),
                            styles: (0, $63c2c06b53ba964b$export$2e2bcd8739ae039)(false, true),
                            onChange: (selectedValue)=>{
                                onChange({
                                    active: preference.active,
                                    utilization: selectedValue.value
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $69bc59ecb35b6eba$export$58485ece88f64aa8,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0c6ddba99cd38e$export$2e2bcd8739ae039), {
                    id: "fully-booked-rides-switch",
                    "aria-label": "fully-booked-rides",
                    defaultChecked: preference.active,
                    onChange: ({ currentTarget: currentTarget })=>{
                        onChange({
                            active: currentTarget.checked,
                            utilization: preference.utilization
                        });
                    },
                    extraClasses: $69bc59ecb35b6eba$export$52002a3975269b5d
                })
            })
        ]
    });
};
var $5ff6465a51182a64$export$2e2bcd8739ae039 = $5ff6465a51182a64$var$RideFullyBookedItem;




parcelRequire("acw62");


const $851805f4e3b5fb7e$var$ScheduleExpiryItem = ({ preference: preference, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $a748abb5ee7b9dc9$export$76c7e83ecc9cdf05,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.scheduleExpiryNotification.header"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: $a748abb5ee7b9dc9$export$a80b3bd66acc52ff,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                            id: "settings.scheduleExpiryNotification.subheader"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $a748abb5ee7b9dc9$export$58485ece88f64aa8,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0c6ddba99cd38e$export$2e2bcd8739ae039), {
                    id: "schedule-expiry-switch",
                    "aria-label": "schedule-expiry",
                    defaultChecked: preference.active,
                    onChange: ({ currentTarget: currentTarget })=>{
                        onChange({
                            active: currentTarget.checked
                        });
                    },
                    extraClasses: $a748abb5ee7b9dc9$export$52002a3975269b5d
                })
            })
        ]
    });
};
var $851805f4e3b5fb7e$export$2e2bcd8739ae039 = $851805f4e3b5fb7e$var$ScheduleExpiryItem;




parcelRequire("acw62");
var $24c4436aa4a95862$export$fa397790119a1408;
var $24c4436aa4a95862$export$b426df703d3b34b8;
var $24c4436aa4a95862$export$46e4a324ac90507f;
var $24c4436aa4a95862$export$a80b3bd66acc52ff;
var $24c4436aa4a95862$export$76c7e83ecc9cdf05;
var $24c4436aa4a95862$export$52002a3975269b5d;
var $24c4436aa4a95862$export$58485ece88f64aa8;
var $24c4436aa4a95862$export$cc74dcc53cfce4eb;
$24c4436aa4a95862$export$fa397790119a1408 = `SettingsHeader-WKQrDa-flix-theme-dark`;
$24c4436aa4a95862$export$b426df703d3b34b8 = `SettingsHeader-WKQrDa-flix-theme-flix`;
$24c4436aa4a95862$export$46e4a324ac90507f = `SettingsHeader-WKQrDa-heading`;
$24c4436aa4a95862$export$a80b3bd66acc52ff = `SettingsHeader-WKQrDa-info`;
$24c4436aa4a95862$export$76c7e83ecc9cdf05 = `SettingsHeader-WKQrDa-listItem`;
$24c4436aa4a95862$export$52002a3975269b5d = `SettingsHeader-WKQrDa-switch`;
$24c4436aa4a95862$export$58485ece88f64aa8 = `SettingsHeader-WKQrDa-switchWrapper`;
$24c4436aa4a95862$export$cc74dcc53cfce4eb = `SettingsHeader-WKQrDa-wrapper`;


const $e216595a82c25779$var$SettingsHeader = ({ name: name, mail: mail })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $24c4436aa4a95862$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02cbb07845aa75e9$export$2e2bcd8739ae039), {
                size: 1,
                extraClasses: $24c4436aa4a95862$export$46e4a324ac90507f,
                sectionHeader: true,
                children: name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: $24c4436aa4a95862$export$a80b3bd66acc52ff,
                children: mail
            })
        ]
    });
};
var $e216595a82c25779$export$2e2bcd8739ae039 = $e216595a82c25779$var$SettingsHeader;


const $3ed2fa0944688fa3$var$Settings = ()=>{
    const intl = (0, $174d9ac429a8b478$export$2e2bcd8739ae039)();
    const { data: userData, loading: loading, error: error } = (0, $808edefb2e1fceb5$export$9beb97f355b95ab9)();
    const [updateUserPreference] = (0, $808edefb2e1fceb5$export$f933a6ccf2714c6f)({
        onError: (err)=>(0, $6d4b5f61eb7ea5e7$export$2e2bcd8739ae039)({
                message: `User settings update failed: ${(0, $b6c6330f9af3214a$export$2e2bcd8739ae039)(err.message)}`,
                type: (0, $a0a11a6f0b684203$export$9130146a86a85749).Danger
            }),
        onCompleted: ()=>{
            (0, $6d4b5f61eb7ea5e7$export$2e2bcd8739ae039)({
                message: intl.formatMessage({
                    id: "settings.update.success"
                })
            });
        }
    });
    const handleUpdatePreference = (id, lang, values)=>{
        updateUserPreference({
            variables: {
                language: lang,
                preference: {
                    ...values
                }
            },
            optimisticResponse: {
                updateUserPreference: {
                    id: id,
                    language: lang,
                    preference: {
                        ridesFullyBooked: {
                            ...values.ridesFullyBooked,
                            __typename: "RidesFullyBookedPreference"
                        },
                        scheduleExpiryReminder: {
                            ...values.scheduleExpiryReminder,
                            __typename: "ScheduleExpiryReminderPreference"
                        },
                        productNews: {
                            ...values.productNews,
                            __typename: "ProductNewsPreference"
                        },
                        bookingReports: {
                            ...values.bookingReports,
                            __typename: "BookingReportsPreference"
                        },
                        __typename: "Preference"
                    },
                    __typename: "User"
                }
            }
        });
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $a24f4bda873092f2$export$d043ff22bb17d686,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a448fa77989b51de$export$2e2bcd8739ae039), {
            "data-testid": "spinner"
        })
    });
    if (userData?.getUser) {
        const { id: id, displayName: displayName, mail: mail, language: language, preference: preference } = userData.getUser;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e216595a82c25779$export$2e2bcd8739ae039), {
                    name: displayName,
                    mail: mail || ""
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    "data-testid": "notification-section",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $02cbb07845aa75e9$export$2e2bcd8739ae039), {
                            "data-testid": "notification-header-wrapper",
                            size: 3,
                            sectionHeader: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e0a0c7f0bf054d5$export$f04a61298a47a40f), {
                                    InlineIcon: (0, $981db609414215bf$export$8b14014029ddbbd9),
                                    extraClasses: $a24f4bda873092f2$export$af5dcc21c8ae7acc
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5665a8818306a5ca$export$2e2bcd8739ae039), {
                                    id: "settings.notificationSection.header"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b8e2a2667fcf68a9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618739c48ea6dedf$export$43c7d73d15fbb67d), {
                                    "data-testid": "daily-booking-report",
                                    extraClasses: $a24f4bda873092f2$export$fa74c5ef354ef29c,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7fdc30add12756f$export$2e2bcd8739ae039), {
                                        preference: preference.bookingReports,
                                        onChange: (values)=>handleUpdatePreference(id, language, {
                                                ridesFullyBooked: {
                                                    active: preference.ridesFullyBooked.active,
                                                    utilization: preference.ridesFullyBooked.utilization
                                                },
                                                scheduleExpiryReminder: {
                                                    active: preference.scheduleExpiryReminder.active
                                                },
                                                productNews: {
                                                    active: preference.productNews.active
                                                },
                                                bookingReports: values
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618739c48ea6dedf$export$43c7d73d15fbb67d), {
                                    "data-testid": "fully-booked-rides-item",
                                    extraClasses: $a24f4bda873092f2$export$fa74c5ef354ef29c,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ff6465a51182a64$export$2e2bcd8739ae039), {
                                        preference: preference.ridesFullyBooked,
                                        onChange: (values)=>handleUpdatePreference(id, language, {
                                                ridesFullyBooked: values,
                                                scheduleExpiryReminder: {
                                                    active: preference.scheduleExpiryReminder.active
                                                },
                                                productNews: {
                                                    active: preference.productNews.active
                                                },
                                                bookingReports: {
                                                    active: preference.bookingReports.active,
                                                    time: preference.bookingReports.time,
                                                    timezone: preference.bookingReports.timezone
                                                }
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618739c48ea6dedf$export$43c7d73d15fbb67d), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $851805f4e3b5fb7e$export$2e2bcd8739ae039), {
                                        preference: preference.scheduleExpiryReminder,
                                        onChange: (values)=>handleUpdatePreference(id, language, {
                                                ridesFullyBooked: {
                                                    active: preference.ridesFullyBooked.active,
                                                    utilization: preference.ridesFullyBooked.utilization
                                                },
                                                scheduleExpiryReminder: values,
                                                productNews: {
                                                    active: preference.productNews.active
                                                },
                                                bookingReports: {
                                                    active: preference.bookingReports.active,
                                                    time: preference.bookingReports.time,
                                                    timezone: preference.bookingReports.timezone
                                                }
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618739c48ea6dedf$export$43c7d73d15fbb67d), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $554024e2ba99f1e3$export$2e2bcd8739ae039), {
                                        language: language,
                                        preference: preference.productNews,
                                        onChange: (lang, values)=>handleUpdatePreference(id, lang, {
                                                ridesFullyBooked: {
                                                    active: preference.ridesFullyBooked.active,
                                                    utilization: preference.ridesFullyBooked.utilization
                                                },
                                                scheduleExpiryReminder: {
                                                    active: preference.scheduleExpiryReminder.active
                                                },
                                                productNews: values,
                                                bookingReports: {
                                                    active: preference.bookingReports.active,
                                                    time: preference.bookingReports.time,
                                                    timezone: preference.bookingReports.timezone
                                                }
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (error) {
        const errorType = error.graphQLErrors?.some((graphqlError)=>graphqlError.extensions?.classification === "NOT_FOUND") ? (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e403 : (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e500;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c45961a3b378f92$export$2e2bcd8739ae039), {
            type: errorType
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};
var $3ed2fa0944688fa3$export$2e2bcd8739ae039 = $3ed2fa0944688fa3$var$Settings;


const $ec887f9d6e3817d2$export$3cb69218ff952ef8 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c45961a3b378f92$export$2e2bcd8739ae039), {
        type: (0, $4d4f04faa0dd2ff5$export$43a750ddd9f2303e).e404
    });
const $ec887f9d6e3817d2$var$Router = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: (0, $3148ac12565e8f12$export$b4aa7c009839d9f1).userHome,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ed2fa0944688fa3$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/myaccount",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                    to: "/",
                    replace: true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec887f9d6e3817d2$export$3cb69218ff952ef8, {})
            })
        ]
    });
};
var $ec887f9d6e3817d2$export$2e2bcd8739ae039 = $ec887f9d6e3817d2$var$Router;





var $acw62 = parcelRequire("acw62");

var $2c63710e520228dc$export$2e2bcd8739ae039 = {
    raw: ".hcr-page-container-16-4-0{margin:0 auto;max-width:var(--hcr-page-max-width);min-width:var(--hcr-page-min-width);padding:0 var(--hcr-spacing-2)}.hcr-page-container--has-fixed-header-16-4-0,.hcr-page-container--has-fixed-header-no-nav-16-4-0{padding-top:var(--hcr-spacing-10)}@media (min-width:768px) and (max-width:1199px){.hcr-page-container--has-fixed-header-16-4-0{padding-top:calc(var(--hcr-spacing-10) + var(--hcr-spacing-8))}}",
    map: {
        "hcr-page-container": "hcr-page-container-16-4-0",
        "hcr-page-container--has-fixed-header": "hcr-page-container--has-fixed-header-16-4-0",
        "hcr-page-container--has-fixed-header-no-nav": "hcr-page-container--has-fixed-header-no-nav-16-4-0"
    }
};





const $3ec2c5feccddf392$export$1a1be407fba9bd1f = [
    'div',
    'main',
    'section'
];
const $3ec2c5feccddf392$export$f246a0a31c54a56b = [
    true,
    false,
    'no-nav'
];



const $08d850b5d4f14418$var$bem = new (0, $4ada79c183cfad4b$export$2e2bcd8739ae039)('page-container', (0, $2c63710e520228dc$export$2e2bcd8739ae039));
function $08d850b5d4f14418$export$5f86df0ee0a255b5(_a) {
    var { Elem: Elem = 'div', children: children, extraClasses: extraClasses, hasFixedHeader: hasFixedHeader = false } = _a, rest = (0, $9abc92afe9cf7102$export$3c9a16f847548506)(_a, [
        "Elem",
        "children",
        "extraClasses",
        "hasFixedHeader"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Elem, Object.assign({
        className: $08d850b5d4f14418$var$bem.b({
            'has-fixed-header': hasFixedHeader === true,
            'has-fixed-header-no-nav': hasFixedHeader === 'no-nav'
        }, extraClasses)
    }, rest), children);
}
$08d850b5d4f14418$export$5f86df0ee0a255b5.displayName = 'PageContainer';
$08d850b5d4f14418$export$5f86df0ee0a255b5.propTypes = {
    Elem: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $3ec2c5feccddf392$export$1a1be407fba9bd1f)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node.isRequired,
    extraClasses: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    hasFixedHeader: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf((0, $3ec2c5feccddf392$export$f246a0a31c54a56b))
};
var $08d850b5d4f14418$export$2e2bcd8739ae039 = (0, $8004033f3b6e4cea$export$59edeac1b7126870)($08d850b5d4f14418$export$5f86df0ee0a255b5, (0, $2c63710e520228dc$export$2e2bcd8739ae039));


parcelRequire("acw62");
var $93a5b789aae9fbce$export$d6a8c36fa3fa30b5;
var $93a5b789aae9fbce$export$fa397790119a1408;
var $93a5b789aae9fbce$export$b426df703d3b34b8;
$93a5b789aae9fbce$export$d6a8c36fa3fa30b5 = `Layout-7N-Fwq-defaultContainer`;
$93a5b789aae9fbce$export$fa397790119a1408 = `Layout-7N-Fwq-flix-theme-dark`;
$93a5b789aae9fbce$export$b426df703d3b34b8 = `Layout-7N-Fwq-flix-theme-flix`;


const $00dff1ec8d83154a$var$Layout = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08d850b5d4f14418$export$2e2bcd8739ae039), {
        "data-testid": "layout",
        extraClasses: $93a5b789aae9fbce$export$d6a8c36fa3fa30b5,
        children: children
    });
var $00dff1ec8d83154a$export$2e2bcd8739ae039 = $00dff1ec8d83154a$var$Layout;



const $eb45f5eedb31dde1$export$299f460e950e4145 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c788d42036daec36$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $953d60e84fc6ba8d$export$2e2bcd8739ae039), {
                fetchPolicy: "cache-and-network",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $aeb73c5367733af6$export$2e2bcd8739ae039), {
                        full: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4964bc9f1cb5508$export$2e2bcd8739ae039), {
                                app: (0, $72a7cae42bbdbca4$export$2e2bcd8739ae039).MUS,
                                isUsedInternal: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00dff1ec8d83154a$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec887f9d6e3817d2$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea526ae3f61bb245$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $eb45f5eedb31dde1$var$App = ()=>{
    const isDarkTheme = (0, $550d697bbc914bec$export$b10e3d92c03f6472)((0, $0cba5a2b438c2f8b$export$9f25c19833cd15c8));
    // User is Cypress
    (0, $bc59a856a5e4c3e2$export$ca25862a9e6ee63c)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa9bfcb1867fae64$export$cf6495336e7980c8), {
        id: "theme-wrapper",
        dark: isDarkTheme,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf22335153625c86$export$2e2bcd8739ae039), {
            usesCookies: true,
            isUsedInternal: true,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c813f840a1b0ee31$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eb45f5eedb31dde1$export$299f460e950e4145, {})
            })
        })
    });
};
var $eb45f5eedb31dde1$export$2e2bcd8739ae039 = $eb45f5eedb31dde1$var$App;


(0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb45f5eedb31dde1$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=app.bd6bd2cb.js.map
